webpackJsonp([1],Array(48).concat([
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_performance_payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_performance_payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_pages_performance_payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_http_common__ = __webpack_require__(400);







var _this = this;

/* eslint-disable */




// import { GraphHTTP } from "../utils/http-common";

var WAIT = 60000 * 5;
var login = function login(_ref) {
  var commit = _ref.commit;
  return commit("setLogin", true);
};
var logout = function logout(_ref2) {
  var commit = _ref2.commit;
  return commit("setLogin", false);
};
var timeAgo = function timeAgo(date, timeRN) {
  // console.log({ date, timeRN, ago: moment(date).from(timeRN) });
  // let ta=undefined==
  return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).from(timeRN);
};

var statusCalc = function statusCalc(date) {
  // console.log( moment(date).diff(this.timeRightNow));
  var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_7_moment___default()(date).diff(_this.timeRightNow));
  if (difference / 60000 > 90) {
    return true;
  } else {
    return false;
  }
};

var transformMapData = function transformMapData(MapData) {
  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
    var oldKey = __WEBPACK_IMPORTED_MODULE_9__components_pages_performance_payload_dictionary_json___default.a.find(function (x) {
      return x.new_key == key;
    });
    if (oldKey && oldKey["old_key"] != "") {
      cummData[oldKey["old_key"]] = MapData[key];
    } else {
      cummData[key] = MapData[key];
    }
    return cummData;
  }, {});
};
var transformListData = function transformListData(ListData) {
  if (ListData !== null) {
    return ListData.map(function (x) {
      return x.length ? transformListData(x) : transformMapData(x);
    });
  }
  return [];
};

var flagsDict = {
  errors: {
    InverterFault: "Inverter Fault",
    BusOver: "Bus Overload",
    BusUnder: "Bus Underload",
    BusSoftFail: "Bus Failed",
    InverterVoltageTooLow: "Inverter Voltage Too Low",
    InverterVoltageTooHigh: "Inverter Voltage Too High",
    InverterOverCurrent: "Inverter Overcurrent",
    InverterSoftFail: "Inverter failed (soft)",
    SelfTestFail: "Self test failed",
    OPDCVoltageOpen: "",
    BatteryOpen: "Battery Open",
    BatteryLowAlarm: "Battery Low",
    CurrentSensorFail: "Current Sensor failed"
  },

  warnings: {
    lineFail: "Line Failed",
    LineFail: "Line Failed",
    OPVShort: "Pv Output Short Circuit",
    BatteryUnderShutdown: "Battery Under Shortdown",
    EepromFault: "EEPROM Fault",

    PVLoss: "No supply from PV",
    BatteryDerating: "Battery Derating",
    Overload: "System Overload"
  }
};
var errorCalc = function errorCalc(Payload) {
  var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
  var alarmFlags = {};
  for (var property in Payload) {
    if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
      if (Payload[property] > 0) {
        if (flagsDict.warnings[property]) {
          alarmFlags["warning"] ? alarmFlags["warning"]++ : alarmFlags["warning"] = 1;
        } else if (flagsDict.errors[property]) {
          alarmFlags["error"] ? alarmFlags["error"]++ : alarmFlags["error"] = 1;
        }
      }
    }
  }

  return {
    count: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(alarmFlags).reduce(function (all, x) {
      return all += alarmFlags[x];
    }, 0),
    flags: alarmFlags
  };
};

var loginNetwork = function loginNetwork(_ref3) {
  var commit = _ref3.commit;

  commit("setLoading", true);
  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    setTimeout(function () {
      commit("setLogin", true);
      commit("setLoading", false);
      resolve();
    }, 3000);
  });
};

var setUserSession = function setUserSession(_ref4, user) {
  var commit = _ref4.commit;

  commit("setUser", user);
};

var setAccess = function setAccess(_ref5, access) {
  var commit = _ref5.commit;

  commit("setAccess", access);
};
var setGlobalTableOptions = function setGlobalTableOptions(_ref6, globalTableOptions) {
  var commit = _ref6.commit;

  commit("setGlobalTableOptions", globalTableOptions);
};
var setPerformanceFilter = function setPerformanceFilter(_ref7, performanceFilter) {
  var commit = _ref7.commit;

  console.log({ performanceFilter: performanceFilter });
  commit("setPerformanceFilter", performanceFilter);
};
var setHome = function setHome(_ref8, status) {
  var commit = _ref8.commit;

  commit("setHome", status);
};
var setDrawerMode = function setDrawerMode(_ref9, status) {
  var commit = _ref9.commit;

  commit("setDrawerMode", status);
};
var setRole = function setRole(_ref10, roles) {
  var commit = _ref10.commit;

  commit("setRole", roles);
};

var toggleSidebar = function toggleSidebar(_ref11, status) {
  var commit = _ref11.commit;

  commit("toggleSidebar", status);
};

var setTheme = function setTheme(_ref12) {
  var commit = _ref12.commit;
  var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  commit("setTheme", theme);
};

var fillDeviceList = function fillDeviceList(_ref13, list) {
  var commit = _ref13.commit;

  HTTP.get("/online-devices", {
    params: {
      // $limit: 20
    }
  }).then(function (response) {
    commit("fillDeviceList", response.data);
  }).catch(function (error) {
    console.log(error);
  });
  HTTP.get("/devices", {
    params: {
      // $limit: 20
    }
  }).then(function (response) {
    commit("fillOffDeviceList", response.data);
  }).catch(function (error) {
    console.log(error);
  });
};

var HTTP = __WEBPACK_IMPORTED_MODULE_6_axios___default.a.create({
  // baseURL: 'http://localhost:3030',
  baseURL: "https://iot-solarbase.arnergy.com",
  headers: {
    // Authorization: 'Bearer {token}'
  }
});
var handleFilters = function handleFilters(_ref14) {
  var commit = _ref14.commit,
      getters = _ref14.getters;

  filters({ commit: commit, getters: getters });
};
var filters = function filters(_ref15) {
  var commit = _ref15.commit,
      getters = _ref15.getters;

  var filterFirmWarVersion = getters.filterFirmWarVersion;
  var filterSectorVal = getters.filterSectorVal;
  var filterPaymentModel = getters.filterPaymentModel;
  // console.log({ filterFirmWarVersion, filterSectorVal, filterPaymentModel });

  if (filterSectorVal.length === 0 && filterFirmWarVersion.length === 0 && filterPaymentModel.length === 0) {
    clearFilters({ commit: commit, getters: getters });
    return;
  }
  var all = getters.graphDeviceDetails;
  var online = getters.onLineDevices;
  var alarm = getters.alarmDevices;
  var offline = getters.offLineDeviceList;

  var allDeviceFilter = all.filter(function (item) {
    return item.sector === filterSectorVal || item.FV === filterFirmWarVersion || item.paymentModel === filterPaymentModel;
  });
  var onlineDeviceFilter = online.filter(function (item) {
    return item.sector === filterSectorVal || item.FV === filterFirmWarVersion || item.paymentModel === filterPaymentModel;
  });
  var offLineDeviceFilter = offline.filter(function (item) {
    return item.sector === filterSectorVal || item.FV === filterFirmWarVersion || item.paymentModel === filterPaymentModel;
  });
  var alarmDeviceFilter = alarm.filter(function (item) {
    return item.sector === filterSectorVal || item.FV === filterFirmWarVersion || item.paymentModel === filterPaymentModel;
  });
  setFilteredResponse({ commit: commit, getters: getters }, allDeviceFilter, onlineDeviceFilter, offLineDeviceFilter, alarmDeviceFilter);
};

var setFilteredResponse = function setFilteredResponse(_ref16, filteredAllDevices, filteredOnlineDevices, filteredOffLineDevices, filteredAlarmDevices) {
  var commit = _ref16.commit,
      getters = _ref16.getters;

  commit("filteredAllDevices", filteredAllDevices);
  commit("filteredOnlineDevices", filteredOnlineDevices);
  commit("filteredOffLineDevices", filteredOffLineDevices);
  commit("filteredAlarmDevices", filteredAlarmDevices);
};

var setCriticalSystems = function setCriticalSystems(_ref17, list) {
  var commit = _ref17.commit,
      getters = _ref17.getters;

  commit("setCriticalSystems", list);
};

var clearFilters = function clearFilters(_ref18) {
  var commit = _ref18.commit,
      getters = _ref18.getters;

  commit("filteredAllDevices", getters.graphDeviceDetails);
  commit("filteredOnlineDevices", getters.onLineDevices);
  commit("filteredOffLineDevices", getters.offLineDeviceList);
  commit("filteredAlarmDevices", getters.alarmDevices);
};
var clearFVFilter = function clearFVFilter(_ref19, payload) {
  var commit = _ref19.commit,
      getters = _ref19.getters;

  if (payload.length === 0) {
    commit("filteredAllDevices", getters.graphDeviceDetails);
    commit("filteredOnlineDevices", getters.onLineDevices);
    commit("filteredOffLineDevices", getters.offLineDeviceList);
  }
};
var refreshList = function refreshList(_ref20, list) {
  var commit = _ref20.commit;

  return HTTP.get("/online-devices").then(function (response) {
    return response.data.Items;
  }).then(function (devices) {
    return HTTP.get("/devicemode").then(function (modes) {
      return {
        devices: devices,
        modes: modes.data.Items
      };
    });
  }).then(function (tempData) {
    return HTTP.get("/device-expiry").then(function (expiries) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, tempData, {
        expiries: expiries.data.Items
      });
    });
  }).then(function (data) {
    commit("fillDeviceList", data);
    // console.log(data);
    return data;
  }).then(function (transformedData) {
    transformedData["devices"].map(function (item) {
      // console.log(item);
      var inverterId = item.DeviceID;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      return HTTP.post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        if (DevData[0]) {
          // aggr[inverterId]=DevData[0]["payload"];
          commit("updateWarning", DevData[0]);
        }
      }).catch();
    });
  }).catch(function (error) {
    console.log(error);
  });
};
var findDeviceData = function findDeviceData(dataset, key, value) {
  var res = dataset.filter(function (x) {
    return x[key] == value;
  });
  return res.length > 0 ? res : undefined;
};
var batteryMode = function batteryMode(mode, version) {
  if (version == "v4") {
    var resp = "--";
    var formattedMode = mode.split("").length > 1 ? mode.split("")[1] : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
      case "00":
        resp = "Power On";
        break;
      case "S":
      case "SB":
      case "01":
        resp = "On Standby";
        break;
      case "L":
      case "E":
      case "05":
        resp = "On Grid";
        break;
      case "Y":
      case "02":
        resp = "Bypass Mode";
        break;
      case "B":
      case "03":
        resp = "On Battery";
        break;
      case "F":
      case "04":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
      case "06":
        resp = "Charging";
        break;
      default:
        resp = formattedMode;
    }
    // console.log(resp);
    return resp;
  } else if (version == "v3") {
    var resp = "--";
    var formattedMode = mode.split("").length > 1 ? mode.split("")[1] : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "E":
        resp = "On Grid";
        break;
      case "Y":
        resp = "Bypass Mode";
        break;
      case "B":
        resp = "On Battery";
        break;
      case "F":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
        resp = formattedMode;
    }
    // console.log(resp);
    return resp;
  } else {
    var _resp = "--";
    /***
     * v6 mode data
     * @constant
     * SB -- Standby
     * FL --  Failure
     * SC --  Self check
     * NM -- Normal
     * AL --- Alarm
     * * */

    var formattedMode = mode.split("").length > 1 ? mode.split("")[1] : mode || "inv not detected";
    switch (formattedMode) {
      case "P":
        _resp = "Power On";
        break;
      case "S":
      case "SB":
        _resp = "On Standby";
        break;
      case "L":
        _resp = "On Grid";
        break;
      case "B":
      case "NM":
        _resp = "On Battery";
        break;
      case "F":
      case "FL":
        _resp = "Fault";
        break;
      case "H":
        _resp = "Power saving mode";
        break;
      case "C":
        _resp = "Charging";
        break;
      default:
        _resp = formattedMode;
    }
    return _resp;
  }
};
var currentTime = function () {
  var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
    var response, tmpDate;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

          case 2:
            response = _context.sent;

            if (!response) {
              _context.next = 10;
              break;
            }

            if (!response.data.datetime) {
              _context.next = 9;
              break;
            }

            tmpDate = response.data.datetime.split(".")[0];
            return _context.abrupt("return", tmpDate);

          case 9:
            return _context.abrupt("return", null);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function currentTime() {
    return _ref21.apply(this, arguments);
  };
}();
var performanceGraphCall = function () {
  var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(_ref23, payload) {
    var commit = _ref23.commit,
        getters = _ref23.getters;
    var timeRN, arrayOfIds;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            timeRN = payload.timeRN || payload; //for other user type aside customer...

            arrayOfIds = payload.arrayOfIds;
            // console.log('>>>>>>>>>>>>>>>>>>>', timeRN, payload)

            poll({ commit: commit, getters: getters }, timeRN, arrayOfIds);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, _this);
  }));

  return function performanceGraphCall(_x2, _x3) {
    return _ref22.apply(this, arguments);
  };
}();

var poller = function () {
  var _ref24 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(_ref25, timeRN, arrayOfIds) {
    var commit = _ref25.commit,
        getters = _ref25.getters;
    var timeRightNow;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return currentTime();

          case 2:
            timeRightNow = _context3.sent;

            // console.log({timeRightNow});
            poll({ commit: commit, getters: getters }, timeRightNow || timeRN, arrayOfIds);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this);
  }));

  return function poller(_x4, _x5, _x6) {
    return _ref24.apply(this, arguments);
  };
}();

var performanceGraphCall2 = function () {
  var _ref26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(_ref27, payload) {
    var commit = _ref27.commit,
        getters = _ref27.getters;
    var timeRN, arrayOfIds;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            timeRN = payload.timeRN || payload; //for other user type aside customer...

            arrayOfIds = payload.arrayOfIds;

            poll2({ commit: commit, getters: getters }, timeRN, arrayOfIds, payload.limit, payload.page, payload);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this);
  }));

  return function performanceGraphCall2(_x7, _x8) {
    return _ref26.apply(this, arguments);
  };
}();

var poller2 = function () {
  var _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(_ref29, timeRN, arrayOfIds, payload) {
    var commit = _ref29.commit,
        getters = _ref29.getters;
    var timeRightNow;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return currentTime();

          case 2:
            timeRightNow = _context5.sent;

            poll2.apply(undefined, [{ commit: commit, getters: getters }, timeRightNow || timeRN, arrayOfIds].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(payload)));

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, _this);
  }));

  return function poller2(_x9, _x10, _x11, _x12) {
    return _ref28.apply(this, arguments);
  };
}();

var poll = function () {
  var _ref30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(_ref31, timeRN, arrayOfIds) {
    var commit = _ref31.commit,
        getters = _ref31.getters;
    var hasArrayOfIds, url;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            hasArrayOfIds = arrayOfIds ? true : false;
            url = "/graphql";
            return _context6.abrupt("return", cachedPollCall(url, arrayOfIds, timeRN, { commit: commit, getters: getters }));

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, _this);
  }));

  return function poll(_x13, _x14, _x15) {
    return _ref30.apply(this, arguments);
  };
}();

var poll2 = function () {
  var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(_ref33, timeRN, arrayOfIds) {
    var commit = _ref33.commit,
        getters = _ref33.getters;
    var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 20;
    var page = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var payload = arguments[5];
    var devicePath, hasArrayOfIds, url;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            devicePath = "";


            if (payload && payload.search) {
              devicePath = "&search=" + payload.search;
            }

            if (payload && payload.filter) {
              devicePath += "&filter=" + payload.filter;
            }

            if (payload && payload.sortField) {
              devicePath += "&sortField=" + payload.sortField + "&sortOrder=" + payload.sortOrder;
            }

            hasArrayOfIds = arrayOfIds ? true : false;
            url = "/devices?limit=" + limit + "&page=" + page + devicePath;


            if (hasArrayOfIds) {
              url = "/devices?limit=" + limit + "&page=" + page + devicePath + "&deviceIds=" + arrayOfIds.join(",");
            }
            return _context7.abrupt("return", cachedPollCall2(url, arrayOfIds, timeRN, { commit: commit, getters: getters }));

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, _this);
  }));

  return function poll2(_x16, _x17, _x18) {
    return _ref32.apply(this, arguments);
  };
}();

var cachedPollCall = function cachedPollCall(url, arrayOfIds, timeRN, _ref34) {
  var commit = _ref34.commit,
      getters = _ref34.getters;

  var query = "\n  {\n    devices {\n      DeviceID\n      mode\n      payload\n      expiry\n      owner {\n        CID\n        name\n        user\n        locations\n        deviceType\n        email\n        sector\n      }\n      request {\n        paymentmodel\n      }\n    }\n  }\n\n";

  return __WEBPACK_IMPORTED_MODULE_10__utils_http_common__["a" /* default */].GraphHTTP.post(url, { query: query }).then(function (res) {
    var devices = res.data.data.devices;
    handleSuccess(devices, timeRN, arrayOfIds, { commit: commit, getters: getters });
  }).catch(function (err) {
    console.log(err);
    sleep(WAIT).then(function () {
      poller({ commit: commit, getters: getters }, timeRN, arrayOfIds);
    });
  });
};

var cachedPollCall2 = function cachedPollCall2(url, arrayOfIds, timeRN, _ref35) {
  var commit = _ref35.commit,
      getters = _ref35.getters;

  commit("loadingState", true);
  return __WEBPACK_IMPORTED_MODULE_10__utils_http_common__["a" /* default */].FastAPIHTTP.get(url).then(function (res) {
    commit("loadingState", false);
    var devices = res.data.data.devices;
    console.log("running this", res);
    handleSuccess2(devices, timeRN, arrayOfIds, res.data.data, {
      commit: commit,
      getters: getters
    });
  }).catch(function (err) {
    console.log(err);
    sleep(WAIT).then(function () {
      poller2({ commit: commit, getters: getters }, timeRN, arrayOfIds);
    });
  });
};

var handleSuccess2 = function handleSuccess2(devices, timeRN, arrayOfIds, data, _ref36) {
  var commit = _ref36.commit,
      getters = _ref36.getters;

  var pagination = {
    currentPage: data.currentPage,
    limit: data.limit,
    totalPages: data.totalPages,
    totalRecords: data.totalRecords,
    deviceAnalytics: data.deviceAnalytics
  };

  commit("fillDeviceList", devices);
  commit("devicePayload", pagination);
  var arr = construct(devices, timeRN);

  var offLines = arr.filter(function (x) {
    var type = true;
    return x && type ? statusCalc(x.TimeStamp) == true : false;
  });
  var sysAlarms = arr.filter(function (x) {
    var type = true;
    return x && x.Alarms ? true : false;
  });

  var onLines = arr.filter(function (x) {
    var type = true;

    return x && type ? statusCalc(x.TimeStamp) == false : true;
  });

  commit("graphDeviceDetails", arr || []);
  commit("offLineDevices", offLines || []);
  commit("alarmDevices", sysAlarms || []);
  commit("onLineDevices", onLines || []);

  var filterFirmWarVersion = getters.filterFirmWarVersion;
  var filterSectorVal = getters.filterSectorVal;
  var filterPaymentModel = getters.filterPaymentModel;
  if (filterFirmWarVersion === "" && filterSectorVal === "" && filterPaymentModel === "") {
    commit("filteredAllDevices", arr || []);
    commit("filteredOnlineDevices", onLines || []);
    commit("filteredAlarmDevices", sysAlarms || []);
    commit("filteredOffLineDevices", offLines || []);
  } else {
    handleFilters({ commit: commit, getters: getters });
  }
  var uniqueFV = uniqueFilter(arr);
  var uniqueSectors = uniqueSectorsFilter(arr);
  var uniquePaymentModel = uniquePaymentModelFilter(arr);

  uniqueSectors.unshift({ sector: "clear", id: 0 });
  uniquePaymentModel.unshift({ paymentModel: "clear", id: 0 });
  uniqueFV.unshift({ FV: "clear", id: 0 });
  commit("uniqueFV", uniqueFV || []);
  commit("uniqueSectors", uniqueSectors || []);
  commit("uniquePaymentModel", uniquePaymentModel || []);

  sleep(WAIT).then(function () {
    poller2({ commit: commit, getters: getters }, timeRN, arrayOfIds);
  });
  // setTimeout(poller({ commit }, timeRN), 60000);
};

var handleSuccess = function handleSuccess(devices, timeRN, arrayOfIds, _ref37) {
  var commit = _ref37.commit,
      getters = _ref37.getters;

  commit("fillDeviceList", devices);
  var arr = construct(devices, timeRN);

  var offLines = arr.filter(function (x) {
    var type = true;
    return x && type ? statusCalc(x.TimeStamp) == true : false;
  });
  var sysAlarms = arr.filter(function (x) {
    var type = true;
    return x && x.Alarms ? true : false;
  });

  var onLines = arr.filter(function (x) {
    var type = true;

    return x && type ? statusCalc(x.TimeStamp) == false : true;
  });

  commit("graphDeviceDetails", arr || []);
  commit("offLineDevices", offLines || []);
  commit("alarmDevices", sysAlarms || []);
  commit("onLineDevices", onLines || []);

  var filterFirmWarVersion = getters.filterFirmWarVersion;
  var filterSectorVal = getters.filterSectorVal;
  var filterPaymentModel = getters.filterPaymentModel;
  if (filterFirmWarVersion === "" && filterSectorVal === "" && filterPaymentModel === "") {
    commit("filteredAllDevices", arr || []);
    commit("filteredOnlineDevices", onLines || []);
    commit("filteredAlarmDevices", sysAlarms || []);
    commit("filteredOffLineDevices", offLines || []);
  } else {
    handleFilters({ commit: commit, getters: getters });
  }
  var uniqueFV = uniqueFilter(arr);
  var uniqueSectors = uniqueSectorsFilter(arr);
  var uniquePaymentModel = uniquePaymentModelFilter(arr);
  // console.log({ uniquePaymentModel });

  uniqueSectors.unshift({ sector: "clear", id: 0 });
  uniquePaymentModel.unshift({ paymentModel: "clear", id: 0 });
  uniqueFV.unshift({ FV: "clear", id: 0 });
  commit("uniqueFV", uniqueFV || []);
  commit("uniqueSectors", uniqueSectors || []);
  commit("uniquePaymentModel", uniquePaymentModel || []);

  sleep(WAIT).then(function () {
    poller({ commit: commit, getters: getters }, timeRN, arrayOfIds);
  });
  // setTimeout(poller({ commit }, timeRN), 60000);
};

var roundUp = function roundUp(num) {
  return Math.round(num * 100) / 100;
};
var uniqueFilter = function uniqueFilter(arr) {
  var resArr = [];
  arr.filter(function (item) {
    var i = resArr.findIndex(function (x) {
      return x.FV == item.FV;
    });
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};

var uniqueSectorsFilter = function uniqueSectorsFilter(arr) {
  var resArr = [];
  arr.filter(function (item) {
    var i = resArr.findIndex(function (x) {
      return x.sector == item.sector;
    });
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};
var uniquePaymentModelFilter = function uniquePaymentModelFilter(arr) {
  var resArr = [];
  arr.filter(function (item) {
    var i = resArr.findIndex(function (x) {
      return x.paymentModel == item.paymentModel;
    });
    if (i <= -1) {
      resArr.push(item);
    }
    return null;
  });
  return resArr;
};
var sleep = function sleep() {
  var ms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : WAIT;

  // console.log(ms + "here");

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    return setTimeout(resolve, ms);
  });
};
var panelPowerReduce = function panelPowerReduce(InverterData) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

  var power = InverterData ? InverterData.reduce(function (acc, parameter) {
    var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
    return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
  }, 0) : "";
  if (version == "v5") {
    console.log({ power: power });
  }
  return power / 1000 + "kW";
};

var panelPowerReduceRaw = function panelPowerReduceRaw(InverterData) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

  var power = InverterData ? InverterData.reduce(function (acc, parameter) {
    var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
    return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
  }, 0) : "";
  return power;
};
var panelPower = function panelPower(PVChargingPower) {
  var power = roundUp(PVChargingPower * 1 / 1000);
  return power + "kW";
};

var panelPowerRaw = function panelPowerRaw(PVChargingPower) {
  var power = roundUp(PVChargingPower * 1);
  return power;
};

var roundDown = function roundDown(num) {
  return parseInt(num) > 100 ? 100 : num;
};

var installedCapacity = function installedCapacity(device) {
  var _device$payload = device.payload,
      MiscData = _device$payload.MiscData,
      InstPV = _device$payload.InstPV;

  if (MiscData) {
    return Number(MiscData.InstallSize) + "kVA";
  } else if (device.deviceType) {
    return device.deviceType.indexOf("3000") > -1 ? 3 : device.deviceType.indexOf("2000") > -1 ? 2 : 5 + "kVA";
  } else return 0 + "kVA";
};
var installedPv = function installedPv(device) {
  var InstPV = device.payload.InstPV;

  return InstPV;
};

var contractualLoad = function contractualLoad(device) {
  var InstPV = device.payload.InstPV;

  return InstPV;
};

var getExtraSourceWhileOnBattery = function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
  if (batteryMode === "On Battery") {
    if (solarPower > OutputLoadNotPercent) {
      return "On Solar";
    } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
      return "On Solar & Battery";
    } else return batteryMode;
  } else return batteryMode;
};
var construct = function construct(devices, timeRN) {
  try {
    var arr = [];

    devices && devices.filter(function (x) {
      // let inverterFlag =
      //   x.payload &&
      //   x.payload.InverterDetected &&
      //   x.payload.InverterDetected == "NO"
      //     ? true
      //     : false;
      return x.payload &&
      // !inverterFlag &&
      x.DeviceID != null && x.request != null;
    }).map(function (device) {
      try {
        var d = {};
        var MiscData = {};
        // let Alarms = {};
        var did = device.owner[0] ? device.owner[0]["CID"] : "None";
        var name = device.owner[0] ? device.owner[0]["name"] : "Arnergy Solar";
        var InverterData = device.payload.InverterData || [];
        var streetRoute = device.owner[0] ? device.owner[0]["streetRoute"] : "None";
        // console.log('=========', device.payload.Version)
        // Transformation Begins
        d.version = device.payload.Version || "v2";
        d.paymentModel = device.request.length > 0 ? device.request[0].paymentmodel : "--";

        d.sector = typeof device.owner[0] === "undefined" ? "--" : device.owner[0]["sector"] === null ? "--" : device.owner[0]["sector"];

        if (typeof device.payload["WarningsData"] !== "undefined") {
          // console.log({
          //   id: device.DeviceID,
          //   type: device.payload["WarningsData"].length ? "array" : "object",
          //   data: Object.values(device.payload["WarningsData"])
          // });
          d.Alarms = transformListData(device.payload["WarningsData"])[0];

          var _errorCalc = errorCalc(d.Alarms),
              count = _errorCalc.count,
              flags = _errorCalc.flags;

          d.flags = flags;
          if (count < 1) {
            delete d.Alarms;
          }
        }

        d.MiscData = typeof device.payload["MiscData"] === "undefined" ? MiscData.FV = "" : device.payload["MiscData"];
        d.FV = typeof device.payload["MiscData"] === "undefined" ? "-" : typeof device.payload["MiscData"]["FV"] === "undefined" ? "-" : device.payload["MiscData"]["FV"] || "-";
        d.InverterId = d.version == "v4" || d.version == "v3" ? device.DeviceID : device.DeviceID;
        d.TimeStamp = device.payload.Timestamp || device.payload.TimeStamp;
        d.id = device.DeviceID;
        d.panelpower = d.version == "v4" ? panelPowerReduce(device.payload.PowerData, "v4") : d.version == "v3" || d.version == "v5" || d.version == "v6" ? panelPowerReduce(InverterData) : panelPower(device.payload.PVChargingPower);
        var tempBattery = device.payload.BatteryData && device.payload.BatteryData.SOC ? device.payload.BatteryData.SOC.replace("%", "") : device.payload.BatteryCapacity;
        d.BatteryCapacity = roundDown(tempBattery || 0);
        d.deviceType = device.owner[0] ? device.owner[0]["deviceType"]["name"] : "Arnergy5000";
        d.installedCapacity = installedCapacity(device);
        // console.log({ capacity: device.payload.MiscData.InstallSize });
        // panelPowerReduceRaw
        // device.owner[0]
        //   ? device.owner[0]["deviceType"]["name"]
        //   : "Arnergy 5000";
        d.ownerName = name;
        d.ownerId = did;
        d.address = streetRoute;
        d.batteryMode = batteryMode(device.mode || "", d.version);

        d.expiry = __WEBPACK_IMPORTED_MODULE_7_moment___default()(device.expiry).format("MMMM Do YYYY, h:mm:ss a") == "Invalid date" ? device.expiry : __WEBPACK_IMPORTED_MODULE_7_moment___default()(device.expiry).format("MMMM Do YYYY, h:mm:ss a");
        d.lastseen = d.version == "v4" || d.version == "v3" ? timeAgo(device.payload.Timestamp, timeRN) : timeAgo(device.payload.TimeStamp, timeRN);

        var timestamp = device.payload.Timestamp || device.payload.TimeStamp;

        if (Number(timestamp.split(":")[timestamp.split(":").length - 1]) > 59) {
          timestamp = timestamp.slice(0, timestamp.length - 2) + "59";
          console.log(timestamp, "real");
        }

        d.Time = timestamp ? "" + Object(__WEBPACK_IMPORTED_MODULE_8_date_fns_format__["a" /* default */])(new Date(timestamp), "yyyy-MM-dd'T'HH:mm:ss") : "Invalid Date";
        // console.log({expiry: device.payload.Timestamp?device.payload.Timestamp:device.payload.TimeStamp, deviceId: device.DeviceID});
        // roundDown
        var tempLoad = d.version == "v4" ? roundUp(device.payload.PowerData ? device.payload.PowerData.reduce(function (acc, obj) {
          return acc += Number(obj["OL%"] || 0);
        }, 0) / device.payload.PowerData.length : "") : d.version == "v3" ? roundUp(InverterData.reduce(function (acc, obj) {
          return acc += Number(obj["OL%"] || 0);
        }, 0) / InverterData.length) : d.version == "v5" || d.version == "v6" ? device.payload.InvAggrData && device.payload.InvAggrData["AOL%"] || 0 : device.payload.OutputLoadPercent * 1;
        d.OutputLoadPercent = roundDown(tempLoad || 0) + "";

        var tempPanelPower = d.version == "v4" ? panelPowerReduceRaw(device.payload.PowerData, "v4") : d.version == "v3" ? panelPowerReduceRaw(InverterData) : panelPowerRaw(device.payload.PVChargingPower);

        var tempLoadSum = d.version == "v4" ? roundUp(device.payload.PowerData ? device.payload.PowerData.reduce(function (acc, obj) {
          return acc += Number(obj["OL%"] || 0);
        }, 0) : "") : d.version == "v3" ? roundUp(InverterData.reduce(function (acc, obj) {
          return acc += Number(obj["ACOAP"]);
        }, 0)) : device.payload.OutputLoadPercent * 1;

        d.batteryMode = getExtraSourceWhileOnBattery(d.batteryMode, tempLoadSum, tempPanelPower);
        d.contractualLoad = (device.payload.CLoad ? device.payload.CLoad / 1000 : 0) + "kW";
        d.installedPV = (device.payload.InstPV ? device.payload.InstPV / 1000 : 0) + "kW";

        // if ( d.version == "v5") {
        //   console.log({bm:d.batteryMode});
        // }

        arr.push(d);
      } catch (error) {
        console.log("map =>", error);
      }
    });
    return arr;
  } catch (error) {
    console.error(error);
  }
};

var saveOsCustomer = function saveOsCustomer(_ref38, customer) {
  var commit = _ref38.commit;

  commit("saveOsCustomer", customer);
};

var saveCustomerProductOptions = function saveCustomerProductOptions(_ref39, options) {
  var commit = _ref39.commit;

  commit("saveCustomerProductOptions", options);
};

// const saveCustomerProductOptions = ({ commit }, options) => {
//   commit("saveCustomerProductOptions", options);
// };

var saveUserNotifications = function () {
  var _ref40 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(_ref41, data) {
    var commit = _ref41.commit;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit("saveUserNotifications", data);

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, _this);
  }));

  return function saveUserNotifications(_x24, _x25) {
    return _ref40.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["b"] = ({
  fillDeviceList: fillDeviceList,
  refreshList: refreshList,
  login: login,
  logout: logout,
  loginNetwork: loginNetwork,
  setUserSession: setUserSession,
  setAccess: setAccess,
  setHome: setHome,
  setDrawerMode: setDrawerMode,
  setRole: setRole,
  setTheme: setTheme,
  toggleSidebar: toggleSidebar,
  performanceGraphCall: performanceGraphCall,
  performanceGraphCall2: performanceGraphCall2,
  handleFilters: handleFilters,
  clearFilters: clearFilters,
  setGlobalTableOptions: setGlobalTableOptions,
  setPerformanceFilter: setPerformanceFilter,
  setCriticalSystems: setCriticalSystems,
  saveOsCustomer: saveOsCustomer,
  saveUserNotifications: saveUserNotifications,
  saveCustomerProductOptions: saveCustomerProductOptions
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_battery_vue__ = __webpack_require__(951);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbe4bee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_battery_vue__ = __webpack_require__(2235);
function injectStyle (ssrContext) {
  __webpack_require__(2234)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bbe4bee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_battery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bbe4bee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_battery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyInput_vue__ = __webpack_require__(1133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f1eeff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyInput_vue__ = __webpack_require__(2792);
function injectStyle (ssrContext) {
  __webpack_require__(2791)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18f1eeff"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f1eeff_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(875);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a85c0150_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(2062);
function injectStyle (ssrContext) {
  __webpack_require__(2059)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a85c0150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a85c0150_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergySelect_vue__ = __webpack_require__(1134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383bc194_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergySelect_vue__ = __webpack_require__(2794);
function injectStyle (ssrContext) {
  __webpack_require__(2793)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-383bc194"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergySelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_383bc194_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergySelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__ = __webpack_require__(869);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b29f7a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__ = __webpack_require__(2049);
function injectStyle (ssrContext) {
  __webpack_require__(2048)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b29f7a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wallet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b29f7a0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wallet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = {"DeviceID":"43450001","payload":{"version":"v3","DeviceID":"43450001","Timestamp":"2000-01-01T00:00:29","InverterData":[{"InverterId":"92931905108756","ACOV":"230.1","ACOAP":"0046","ACOAT":"0000","OL%":"000"}],"BatteryData":{"BatteryID":"92931905108756","FmA":"000.0","FmD":"00.0","FmE":"230.1","FmF":"50.0","BtSN":"0046","BtSOC":"0000","BtA":"000","FtFmA":"339","FtFmB":"49.00"},"EnergyData":{"GnT":"0","GnW":"0","GnM":"0","GnY":"0","ConTOGd":"0","ConWOGd":"0","ConMOGd":"0","ConYOGd":"0","ConTfGd":"0","ConWfGd":"0","ConMfGd":"0","ConYfGd":"0","PkT":"00","PkW":"0000","PkM":"000.0","PkY":"00.00"},"MiscData":{"ChgCycle":"5","ExptdChgCyl":"6000","BatteryPercentage":"0%"},"ExpiryDate":"of","ModeData":[{"InverterId":"92931905108756","Mode":"B"}],"WarningsData":[{"InverterId":"92931905108756","PVLs":"1","IvFlt":"0","BusOv":"0","BusU":"0","BusStFail":"0","LnFail":"1","OPVSht":"0","IvLwV":"0","IvHgV":"0","OvT":"0","FaLk":"0","BtHgV":"0","BtLwAlm":"0","Rsv01":"0","BtUShtDw":"0","BtDer":"0","Ovld":"0","EpromFlt":"0","IvOvA":"0","IvSfFl":"0","SfTestFl":"0","OPDCVOp":"0","BtOp":"0","ASenFl":"0","Rsv02":"0","Rsv03":"0","Rsv04":"0","Rsv05":"0","Rsv06":"0","Rsv07":"0","Rsv08":"0","Rsv09":"0"}]}}

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnergySelectDynamic_vue__ = __webpack_require__(1137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5919c225_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnergySelectDynamic_vue__ = __webpack_require__(2801);
function injectStyle (ssrContext) {
  __webpack_require__(2800)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5919c225"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnergySelectDynamic_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5919c225_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnergySelectDynamic_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports) {

module.exports = [{"old_key":"InverterId","new_key":"InverterId","label":"Inverter Id","description":"Serial number of the inverter","datatype":"Integer","unit":""},{"old_key":"GridVoltage","new_key":"GdV","label":"Grid Voltage","description":"Voltage of the electricity supplied from distribution company (DISCO) or generator","datatype":"Float","unit":"V"},{"old_key":"GridFrequency","new_key":"GdF","label":"Grid Frequency","description":"Frequency of the electricity supplied from distribution company (DISCO) or generator","datatype":"Float","unit":"Hz"},{"old_key":"ACOutputVoltage","new_key":"ACOV","label":"AC Output Voltage","description":"Voltage of the AC output from the inverter","datatype":"Float","unit":"V"},{"old_key":"ACOutputFrequency","new_key":"ACOF","label":"AC Output Frequency","description":"Frequency of the AC output from the inverter","datatype":"Float","unit":"Hz"},{"old_key":"ACOutputApparentPower","new_key":"ACOAP","label":"AC Output Apparent Power","description":"Apparent power of the AC output from the inverter","datatype":"Integer","unit":"VA"},{"old_key":"ACOutputActivePower","new_key":"ACOAT","label":"AC Output Active Power","description":"Active power of the AC output from the inverter","datatype":"Integer","unit":"W"},{"old_key":"OutputLoadPercent","new_key":"OL%","label":"Output Load Percent","description":"Ratio of the current output load to the load carrying capacity of the inverter","datatype":"Integer","unit":"%"},{"old_key":"BusVoltage","new_key":"BusV","label":"Bus Voltage","description":"Voltage level of the busbar in the inverter","datatype":"Integer","unit":"V"},{"old_key":"BatteryVoltage","new_key":"BtV","label":"Battery Voltage","description":"Voltage across the battery's terminals","datatype":"Float","unit":"V"},{"old_key":"BatteryChargingCurrent","new_key":"BtCgA","label":"Battery Charging Current","description":"Current being supplied to the battery","datatype":"Integer","unit":"A"},{"old_key":"BatteryCapacity","new_key":"BtCp","label":"Battery Capacity","description":"Capacity of the battery","datatype":"Integer","unit":"%"},{"old_key":"InverterHeatSinkTemp","new_key":"IvHST","label":"Inverter Heat Sink Temperature","description":"Temperature of the heat sink component found in inverters","datatype":"Integer","unit":"°C"},{"old_key":"PVInputCurrent","new_key":"PVInA","label":"PV Input Current","description":"Input current generated from solar PV array","datatype":"Integer","unit":"A"},{"old_key":"PVInputVoltage","new_key":"PVInV","label":"PV Input Voltage","description":"Input voltage from the solar PV array","datatype":"Float","unit":"V"},{"old_key":"BatteryVoltageFromSCC","new_key":"BtVSCC","label":"Battery Voltage From SCC","description":"","datatype":"Float","unit":""},{"old_key":"BatteryDischargeCurrent","new_key":"BtDsA","label":"Battery Discharge Current","description":"Current being drawn from the battery","datatype":"Integer","unit":"A"},{"old_key":"DeviceStatus1","new_key":"DvS1","label":"Device Status 1","description":"Shows the current operating status of the inverter","datatype":"Binary","unit":""},{"old_key":"BatteryVoltageOffsetForFan","new_key":"BtVFa","label":"Battery Voltage Offset For Fan","description":"Offset voltage of battery when inverter fan is on","datatype":"Integer","unit":"mV"},{"old_key":"EEPROMVersion","new_key":"EEPROM","label":"EEPROM Version","description":"Shows the version number of the inverter's EEPROM","datatype":"Integer","unit":""},{"old_key":"PVChargingPower","new_key":"PVCgP","label":"PV Charging Power","description":"Power generated from solar PV array charging the battery","datatype":"Integer","unit":"W"},{"old_key":"DeviceStatus2","new_key":"DvS2","label":"Device Status 2","description":"Shows the current operating status of the inverter","datatype":"Binary","unit":""},{"old_key":"GridCurrent","new_key":"GdA","label":"Grid Current","description":"Current of the electricity supplied from distribution company (DISCO) or generator","datatype":"Float","unit":"A"},{"old_key":"ACOutputCurrent","new_key":"ACOA","label":"AC Output Current","description":"Current of the AC output from the inverter","datatype":"Float","unit":"A"},{"old_key":"BatteryRechargeVoltage","new_key":"BtRgV","label":"Battery Recharge Voltage","description":"Battery Recharge Voltage","datatype":"Float","unit":"V"},{"old_key":"BatteryUnderVoltage","new_key":"BtUV","label":"Battery Under Voltage","description":"Battery Under voltage","datatype":"Float","unit":"V"},{"old_key":"BatteryBulkVoltage","new_key":"BtBkV","label":"Battery Bulk Voltage","description":"Battery Bulk Voltage","datatype":"Float","unit":"V"},{"old_key":"BatteryFloatVoltage","new_key":"BtFlV","label":"Battery Float Voltage","description":"Battery Float Voltage","datatype":"","unit":""},{"old_key":"BatteryType","new_key":"BtTp","label":"Battery Type","description":"Battery Type(0: AGM, 1:Flooded, 2:User defined)","datatype":"option","unit":""},{"old_key":"MaxACChargingCurrent","new_key":"MxACCgA","label":"Maximum AC Charging Current","description":"Maximum AC charging current","datatype":"Integer","unit":"A"},{"old_key":"MaxChargingCurrent","new_key":"MxCgA","label":"Maximum Charging Current","description":"Current maximum charging current","datatype":"Integer","unit":"A"},{"old_key":"InputVoltage","new_key":"IvV","label":"Input Voltage","description":"Input voltage range(0: Appliance, 1:UPS","datatype":"option","unit":""},{"old_key":"OutputSourcePriority","new_key":"OScPt","label":"Output Source Priority","description":"Output Source Priority(0: USB, 1: SUB, 2:SBU","datatype":"option","unit":""},{"old_key":"Chargersourcepriority","new_key":"CgscPt","label":"Charge Source Priority","description":"Charge Source Priority","datatype":"option","unit":""},{"old_key":"Reserved1","new_key":"Rsv1","label":"Reserved 1","description":"Maximum Parallel Number","datatype":"","unit":""},{"old_key":"MachineType","new_key":"MnTp","label":"Machine Type","description":"Machine type(00: Grid tie, 01: Off Grid, 10: Hybrid","datatype":"option","unit":""},{"old_key":"Topology","new_key":"Topo","label":"Topology","description":"Topology(0: Transformerless, 1: Transformer)","datatype":"option","unit":""},{"old_key":"OutputMode","new_key":"OMo","label":"Output Mode","description":"Output mode(00: Single machine, 01: Parallel output, 02: Phase 1 of 3, 03: phase 2 of 3, 04: phase 3 of 3)","datatype":"option","unit":""},{"old_key":"Batteryre-dischargeVoltage","new_key":"BtRedcgV","label":"Battery Re-discharge Voltage","description":"","datatype":"Float","unit":"V"},{"old_key":"Reserved2","new_key":"Rsv2","label":"Reserved 2","description":"PV OK condition for parallel","datatype":"","unit":""},{"old_key":"Reserved3","new_key":"Rsv3","label":"Reserved 3","description":"PV power balance","datatype":"","unit":""},{"old_key":"Unknown","new_key":"Unknw","label":"Unknown","description":"","datatype":"","unit":""},{"old_key":"PVLoss","new_key":"PVLs","label":"PV Loss","description":"","datatype":"","unit":""},{"old_key":"InverterFault","new_key":"IvFlt","label":"Inverter Fault","description":"","datatype":"","unit":""},{"old_key":"BusOver","new_key":"BusOv","label":"Bus Overvoltage","description":"","datatype":"","unit":""},{"old_key":"BusUnder","new_key":"BusU","label":"Bus Undervoltage","description":"","datatype":"","unit":""},{"old_key":"BusSoftFail","new_key":"BusStFail","label":"Bus Soft Fail","description":"","datatype":"","unit":""},{"old_key":"LineFail","new_key":"LnFail","label":"Line Fail","description":"","datatype":"","unit":""},{"old_key":"OPVShort","new_key":"OPVSht","label":"Open PV Short Fault","description":"","datatype":"","unit":""},{"old_key":"InverterVoltageTooLow","new_key":"IvLwV","label":"Inverter Voltage Too Low","description":"","datatype":"","unit":""},{"old_key":"InverterVoltageTooHigh","new_key":"IvHgV","label":"Inverter Voltage Too High","description":"","datatype":"","unit":""},{"old_key":"OverTemperature","new_key":"OvT","label":"Over Temperature","description":"","datatype":"","unit":""},{"old_key":"FanLocked","new_key":"FaLk","label":"Fan Locked","description":"","datatype":"","unit":""},{"old_key":"BatteryVoltageHigh","new_key":"BtHgV","label":"Battery Voltage High","description":"","datatype":"","unit":""},{"old_key":"BatteryLowAlarm","new_key":"BtLwAlm","label":"Battery Low Alarm","description":"","datatype":"","unit":""},{"old_key":"Reserved01","new_key":"Rsv01","label":"Reserved01","description":"","datatype":"","unit":""},{"old_key":"BatteryUnderShutdown","new_key":"BtUShtDw","label":"Battery Undervoltaage Shutdown","description":"","datatype":"","unit":""},{"old_key":"BatteryDerating","new_key":"BtDer","label":"Battery Derating","description":"","datatype":"","unit":""},{"old_key":"Overload","new_key":"OvLd","label":"Overload","description":"","datatype":"","unit":""},{"old_key":"EepromFault","new_key":"EpromFlt","label":"EEPROM Fault","description":"","datatype":"","unit":""},{"old_key":"InverterOverCurrent","new_key":"IvOvA","label":"Inverter Overcurrent","description":"","datatype":"","unit":""},{"old_key":"InverterSoftFail","new_key":"IvStFl","label":"Inverter Soft Fail","description":"","datatype":"","unit":""},{"old_key":"SelfTestFail","new_key":"SfTestFl","label":"Self Test Fail","description":"","datatype":"","unit":""},{"old_key":"OPDCVoltageOpen","new_key":"OPDCVOp","label":"OPDC Voltage Open","description":"","datatype":"","unit":""},{"old_key":"BatteryOpen","new_key":"BtOp","label":"Battery Open","description":"","datatype":"","unit":""},{"old_key":"CurrentSensorFail","new_key":"ASenFl","label":"Current Sensor Fail","description":"","datatype":"","unit":""},{"old_key":"Reserved02","new_key":"Rsv02","label":"Reserved02","description":"","datatype":"","unit":""},{"old_key":"Reserved03","new_key":"Rsv03","label":"Reserved03","description":"","datatype":"","unit":""},{"old_key":"Reserved04","new_key":"Rsv04","label":"Reserved04","description":"","datatype":"","unit":""},{"old_key":"Reserved05","new_key":"Rsv05","label":"Reserved05","description":"","datatype":"","unit":""},{"old_key":"Reserved06","new_key":"Rsv06","label":"Reserved06","description":"","datatype":"","unit":""},{"old_key":"Reserved07","new_key":"Rsv07","label":"Reserved07","description":"","datatype":"","unit":""},{"old_key":"Reserved08","new_key":"Rsv08","label":"Reserved08","description":"","datatype":"","unit":""},{"old_key":"Reserved09","new_key":"Rsv09","label":"Reserved09","description":"","datatype":"","unit":""},{"old_key":"GeneratedToday","new_key":"GnT","label":"Generated Today","description":"Total energy generated today","datatype":"Integer","unit":"Wh"},{"old_key":"GeneratedWeek","new_key":"GnW","label":"Generated Week","description":"Total energy generated in the week","datatype":"Integer","unit":"Wh"},{"old_key":"GeneratedMonth","new_key":"GnM","label":"Generated Month","description":"Total energy generated in the month","datatype":"Integer","unit":"Wh"},{"old_key":"GeneratedYear","new_key":"GnY","label":"Generated Year","description":"Total energy generated in the year","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedTodayOffGrid","new_key":"ConTfGd","label":"Consumed Today Off Grid","description":"Total energy consumed off grid in today","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedWeekOffGrid","new_key":"ConWfGd","label":"Consumed Week Off Grid","description":"Total energy consumed off grid in the week","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedMonthOffGrid","new_key":"ConMfGd","label":"Consumed Month Off Grid","description":"Total energy consumed off grid in the month","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedYearOffGrid","new_key":"ConYfGd","label":"Consumed Year Off Grid","description":"Total energy consumed off grid in the year","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedTodayOnGrid","new_key":"ConTOGd","label":"Consumed Today On Grid","description":"Total energy consumed on grid today","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedWeekOnGrid","new_key":"ConWOGd","label":"Consumed Week On Grid","description":"Total energy consumed on grid in the week","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedMonthOnGrid","new_key":"ConMOGd","label":"Consumed Month On Grid","description":"Total energy consumed on grid in the month","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedYearOnGrid","new_key":"ConYOGd","label":"Consumed Year On Grid","description":"Total energy consumed on grid in the year","datatype":"Integer","unit":"Wh"},{"old_key":"PeakToday","new_key":"PkT","label":"Peak Today","description":"Peak energy generated today","datatype":"Integer","unit":"Wh"},{"old_key":"PeakWeek","new_key":"PkW","label":"Peak Week","description":"Peak energy generated in the week","datatype":"Integer","unit":"Wh"},{"old_key":"PeakMonth","new_key":"PkM","label":"Peak Month","description":"Peak energy generated in the month","datatype":"Integer","unit":"Wh"},{"old_key":"PeakYear","new_key":"PkY","label":"Peak Year","description":"Peak energy generated in the year","datatype":"Integer","unit":"Wh"},{"old_key":"OutputLoadPercent (ACOutputPowerPercentage)","new_key":"OL%","label":"Output Load Percentage","description":"Ratio of the current output load to the load carrying capacity of the inverter","datatype":"Integer","unit":"%"},{"old_key":"PVChargingPower (SolarInputPower)","new_key":"PVCgP","label":"PV Input Power","description":"Power generated from solar PV array charging the battery","datatype":"Integer","unit":"W"},{"old_key":"BatteryLowAlarm (BatteryLow)","new_key":"BtLwAlm","label":"Battery Low Alarm","description":"","datatype":"","unit":""},{"old_key":"PVVoltageHigh","new_key":"PVHgV","label":"PV Voltage High","description":"","datatype":"","unit":""},{"old_key":"BatteryLowHybridMode","new_key":"BtLwHy","label":"Battery Low Hybrid Mode","description":"","datatype":"","unit":""},{"old_key":"GridVoltageHighLoss","new_key":"GdHgV","label":"Grid Voltage High Loss","description":"","datatype":"Float","unit":"V"},{"old_key":"GridVoltageLowLoss","new_key":"GdLwV","label":"Grid Voltage Low Loss","description":"","datatype":"Float","unit":"V"},{"old_key":"GridFrequencyHighLoss","new_key":"GdHgF","label":"Grid Frequency High Loss","description":"","datatype":"","unit":""},{"old_key":"GridFrequencyLowLoss","new_key":"GdLwF","label":"Grid Frequency Low Loss","description":"","datatype":"","unit":""},{"old_key":"ACInputVoltageLoss","new_key":"GdLsV","label":"AC Input Voltage Loss","description":"","datatype":"option","unit":""},{"old_key":"ACInputFrequencyLoss","new_key":"GdLsF","label":"AC Input Frequency Loss","description":"","datatype":"","unit":""},{"old_key":"ACInputPhaseDislocation","new_key":"GdPd","label":"AC Input Phase Dislocation","description":"","datatype":"","unit":""},{"old_key":"EPOactive","new_key":"EPO","label":"EPO Active","description":"","datatype":"","unit":""},{"old_key":"ACInputWaveLoss","new_key":"GdLsW","label":"AC Input Wave Loss","description":"","datatype":"","unit":""},{"old_key":"Reseved","new_key":"Rsv","label":"Reseved","description":"","datatype":"","unit":""},{"old_key":"MaximumBatteryDischargeCurrentInHybridMode","new_key":"MxBtDsHyA","label":"Maximum Battery Discharge Current In Hybrid Mode","description":"","datatype":"","unit":""},{"old_key":"ACInputRatedVoltage","new_key":"rGdV","label":"AC InputRated Voltage","description":"Voltage of the AC input recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"V"},{"old_key":"ACInputRatedFrequency","new_key":"rGdF","label":"AC Input Rated Frequency","description":"Frequency of the AC input recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"Hz"},{"old_key":"ACInputRatedCurrent","new_key":"rGdA","label":"AC Input Rated Current","description":"Current of the AC input recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"A"},{"old_key":"ACOutputRatedVoltage","new_key":"rACOV","label":"AC Output Rated Voltage","description":"Voltage of the AC output recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"V"},{"old_key":"ACOutputRatedFrequency","new_key":"rACOF","label":"AC Output Rated Frequency","description":"Frequency of the AC output recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"Hz"},{"old_key":"ACOutputRatedCurrent","new_key":"rACOA","label":"AC Output Rated Current","description":"Current of the AC output recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"A"},{"old_key":"MPPTRatedCurrentPerString","new_key":"rMPPTA","label":"MPPT Rated Current Per String","description":"Maximum current per string of PV modules recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"A"},{"old_key":"RatedBatteryVoltage","new_key":"rBtV","label":"Rated Battery Voltage","description":"Voltage of the battery recommended by manufacturer of the inverter for nominal use","datatype":"Integer","unit":"V"},{"old_key":"BatteryCurrent","new_key":"BtA","label":"Battery Current","description":"The charging or discharging current of the inverter","datatype":"Integer","unit":"A"},{"old_key":"ACInputVoltageR","new_key":"GdV1","label":"AC Input Voltage R","description":"Voltage of the first phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"V"},{"old_key":"ACInputVoltageS","new_key":"GdV2","label":"AC Input Voltage S","description":"Voltage of the second phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"V"},{"old_key":"ACInputVoltageT","new_key":"GdV3","label":"AC Input Voltage T","description":"Voltage of the third phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"V"},{"old_key":"ACInputCurrentR","new_key":"GdA1","label":"AC Input Current R","description":"Current of the first phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"A"},{"old_key":"ACInputCurrentS","new_key":"GdA2","label":"AC Input Current S","description":"Current of the second phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"A"},{"old_key":"ACInputCurrentT","new_key":"GdA3","label":"AC Input Current T","description":"Current of the third phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"A"},{"old_key":"ACOutputVoltageR","new_key":"ACOV1","label":"AC Output Voltage R","description":"Voltage of the first phase of AC output from the inverter","datatype":"Integer","unit":"V"},{"old_key":"ACOutputVoltageS","new_key":"ACOV2","label":"AC Output Voltage S","description":"Voltage of the second phase of AC output from the inverter","datatype":"Integer","unit":"V"},{"old_key":"ACOutputVoltageT","new_key":"ACOV3","label":"AC Output Voltage T","description":"Voltage of the third phase of AC output from the inverter","datatype":"Integer","unit":"V"},{"old_key":"ACOutputCurrentR","new_key":"ACOA1","label":"AC Output Current R","description":"Current of the first phase of AC output from the inverter","datatype":"Integer","unit":"A"},{"old_key":"ACOutputCurrentS","new_key":"ACOA2","label":"AC Output Current S","description":"Current of the second phase of AC output from the inverter","datatype":"Integer","unit":"A"},{"old_key":"ACOutputCurrentT","new_key":"ACOA3","label":"AC Output Current T","description":"Current of the third phase of AC output from the inverter","datatype":"Integer","unit":"A"},{"old_key":"InnerTemperature","new_key":"InT","label":"Inner Temperature","description":"The internal temperature of the inverter","datatype":"Integer","unit":"°C"},{"old_key":"ComponentMaxTemperature","new_key":"CoMxT","label":"Component Maximum Temperature","description":"The maximum temperature of the component in the inverter","datatype":"Integer","unit":"°C"},{"old_key":"ExternalBatteryTemperature","new_key":"ExBaT","label":"External Battery Temperature","description":"The external temperature of the battery","datatype":"Integer","unit":"°C"},{"old_key":"BatteryPower","new_key":"BtP","label":"Battery Power","description":"","datatype":"","unit":""},{"old_key":"ACInputActivePowerR","new_key":"GdAT1","label":"AC Input Active Power R","description":"Active power of the first phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"W"},{"old_key":"ACInputActivePowerS","new_key":"GdAT2","label":"AC Input Active Power S","description":"Active power of the second phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"W"},{"old_key":"ACInputActivePowerT","new_key":"GdAT3","label":"AC Input Active Power T","description":"Active power of the third phase of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"W"},{"old_key":"ACInputTotalActivePower","new_key":"GdATt","label":"AC Input Total Active Power","description":"Total active power of electrcity supplied from distribution company (DISCO) or generator","datatype":"Integer","unit":"W"},{"old_key":"ACOutputActivePowerR","new_key":"ACOAT1","label":"AC Output Active Power R","description":"Active power of the first phase of AC output from the inverter","datatype":"Integer","unit":"W"},{"old_key":"ACOutputActivePowerS","new_key":"ACOAT2","label":"AC Output Active Power S","description":"Active power of the second phase of AC output from the inverter","datatype":"Integer","unit":"W"},{"old_key":"ACOutputActivePowerT","new_key":"ACOAT3","label":"AC Output Active Power T","description":"Active power of the third phase of AC output from the inverter","datatype":"Integer","unit":"W"},{"old_key":"ACOutputTotalActivePower","new_key":"ACOATt","label":"AC Output Total Active Power","description":"Total active power of the AC output from the inverter","datatype":"Integer","unit":"W"},{"old_key":"ACOutputApparentPowerR","new_key":"ACOAP1","label":"AC Output Apparent Power R","description":"Apparent power of the first phase of AC output from the inverter","datatype":"Integer","unit":"VA"},{"old_key":"ACOutputApparentPowerS","new_key":"ACOAP2","label":"AC Output Apparent Power S","description":"Apparent power of the second phase of AC output from the inverter","datatype":"Integer","unit":"VA"},{"old_key":"ACOutputApparentPowerT","new_key":"ACOAP3","label":"AC Output Apparent Power T","description":"Apparent power of the third phase of AC output from the inverter","datatype":"Integer","unit":"VA"},{"old_key":"ACOutputTotalApparentPower","new_key":"ACOAPt","label":"AC Output Total Apparent Power","description":"Total active power of the AC output from the inverter","datatype":"Integer","unit":"VA"},{"old_key":"","new_key":"PAT","label":"Power Availabilty Time","description":"The number of minutes the system has been available since the day began","datatype":"Integer","unit":""},{"old_key":"","new_key":"PAP","label":"Power Availabilty Percentage","description":"The perentage of the number of minutes the system has been available since the day began","datatype":"Integer","unit":"%"},{"old_key":"","new_key":"ChgCycle","label":"Charge Cycle","description":"","datatype":"","unit":""},{"old_key":"","new_key":"Critical","label":"Battery Critical","description":"","datatype":"Boolean","unit":""},{"old_key":"","new_key":"ExptdChgCyl","label":"Expected Charge Cycle","description":"","datatype":"","unit":""},{"old_key":"","new_key":"FV","label":"Firmware Version","description":"","datatype":"","unit":""},{"old_key":"","new_key":"InstallSize","label":"Installed Capacity","description":"","datatype":"Integer","unit":"kVA"},{"old_key":"","new_key":"InvOffBy","label":"Inverter Off Message","description":"","datatype":"","unit":""},{"old_key":"","new_key":"InvState","label":"Inverter State","description":"","datatype":"Switch","unit":""},{"old_key":"","new_key":"PowCon","label":"Power Control","description":"","datatype":"","unit":""},{"old_key":"","new_key":"PowConF","label":"Power Control Fault","description":"","datatype":"","unit":""},{"old_key":"","new_key":"MaxChgAlwd","label":"Maximum Charging Allowed","description":"","datatype":"","unit":"A"},{"old_key":"","new_key":"BatChg","label":"Battery Charging","description":"","datatype":"String","unit":""},{"old_key":"","new_key":"NumOfBat","label":"Number of Batteries","description":"","datatype":"Integer","unit":""},{"old_key":"","new_key":"BatDisChg","label":"Battery Discharge","description":"","datatype":"String","unit":""},{"old_key":"","new_key":"TotalBatVolt","label":"Battery Voltage","description":"","datatype":"String","unit":"V"},{"old_key":"","new_key":"TotalBatCur","label":"Battery Current","description":"","datatype":"String","unit":"A"},{"old_key":"","new_key":"BatMaxTemp","label":"Battery Maximum Temperature","description":"","datatype":"","unit":"C"},{"old_key":"","new_key":"BatMode","label":"Battery Mode","description":"","datatype":"","unit":""},{"old_key":"","new_key":"MaxDisChgAlwd","label":"Maximum Discharge Allowed","description":"","datatype":"","unit":""},{"old_key":"","new_key":"BatMinTemp","label":"Battery Minimum Temperature","description":"","datatype":"","unit":""},{"old_key":"","new_key":"CellMinV","label":"Minimum Cell Voltage","description":"","datatype":"","unit":"V"},{"old_key":"ConsumedToday","new_key":"ConT","label":"Consumed Today ","description":"Total energy consumed today","datatype":"","unit":"Wh"},{"old_key":"ConsumedMonth","new_key":"ConM","label":"Consumed Month","description":"Total energy consumed  in the month","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedYear","new_key":"ConY","label":"Consumed Year","description":"Total energy consumed on grid in the year","datatype":"Integer","unit":"Wh"},{"old_key":"ConsumedAllTime","new_key":"ConAT","label":"Consumed All TIme","description":"Total energy consumed All time","datatype":"Integer","unit":"Wh"},{"old_key":"PeekAllTime","new_key":"PkAT","label":"Peak All time","description":"Peak energy generated All Time","datatype":"Integer","unit":"Wh"},{"old_key":"GeneratedAllTime","new_key":"GnAT","label":"Generated All time","description":"Total energy generated All Time","datatype":"Integer","unit":"Wh"},{"old_key":"Overload","new_key":"Ovld","label":"Overload","description":"Fault/Warning indicator when the load on the system is too much","datatype":"Integer","unit":""},{"old_key":"InverterSoftFail","new_key":"IvStFl","label":"InverterSoftFail","description":"Fault indicator for soft fail conditions of the inverter","datatype":"Integer","unit":""},{"old_key":"InverterSoftFail","new_key":"IvSfFl","label":"InverterSoftFail","description":"Fault indicator for soft fail conditions of the inverter","datatype":"Integer","unit":""},{"old_key":"DCOutputVoltage","new_key":"DCOV","label":"DC output voltage","description":"DC output voltage","datatype":"Integer","unit":"V"},{"old_key":"DCOutputPower","new_key":"DCOP","label":"DC output power","description":"DC output power","datatype":"Integer","unit":"W"},{"old_key":"PVInputVoltage","new_key":"PVIV","label":"PV input voltage","description":"PV input voltage","datatype":"PV input voltage","unit":"V"},{"old_key":"PVInputCurrent","new_key":"PVIA","label":"PV input current","description":"PV input current","datatype":"PV input current","unit":"V"},{"old_key":"DCOutputVoltage","new_key":"LV","label":"Load Voltage","description":"Load Voltage","datatype":"Load Voltage","unit":"V"},{"old_key":"LoadCurrent","new_key":"LA","label":"Load current","description":"Load current","datatype":"Integer","unit":"A"},{"old_key":"DCOutputPower","new_key":"LP","label":"Load Power","description":"Load Power","datatype":"Integer","unit":"W"},{"old_key":"BatteryTemperature","new_key":"BtTemp","label":"Battery Temperature","description":"Battery Temperature","datatype":"Integer","unit":"C"},{"old_key":"SOC","new_key":"BtSOC","label":"Percentage of battery remaining capacity","description":"Percentage of battery remaining capacity","datatype":"Integer","unit":"%"},{"old_key":"PercentageOfBatteryRemainingCapacity","new_key":"BtSOC","label":"Percentage of battery remaining capacity","description":"Percentage of battery remaining capacity","datatype":"Float","unit":"%"},{"old_key":"BatteryRealRatedVoltage","new_key":"BtRRV","label":"Battery real rated voltage","description":"Battery real rated voltage","datatype":"Integer","unit":"V"},{"old_key":"BatteryStatus","new_key":"BtStat","label":"Battery status","description":"Battery status","datatype":"String","unit":""},{"old_key":"MaximumBatteryVoltageToday","new_key":"MaxBtVT","label":"Maximum Battery Voltage Today","description":"Maximum Battery Voltage Today","datatype":"String","unit":"V"},{"old_key":"MinmumBatteryVoltageToday","new_key":"MinBtVT","label":"Minmum Battery Voltage Today","description":"Minmum Battery Voltage Today","datatype":"String","unit":"V"},{"old_key":"BatteryVoltage","new_key":"BtV","label":"Battery Voltage","description":"Battery Voltage","datatype":"String","unit":"V"},{"old_key":"BatteryCurrent","new_key":"BtA","label":"Battery Current","description":"Battery Current","datatype":"String","unit":"V"},{"old_key":"OutputLoadPercent","new_key":"AOL%","label":"Output LoadP ercent","description":"Output LoadP ercent","datatype":"String","unit":"V"},{"old_key":"PVInputShortCircuit","new_key":"PVISC","label":"PV input short circuit","description":"PV input short circuit","datatype":"Binary","unit":""},{"old_key":"LoadMOSFETShortCircuit","new_key":"LMosSC","label":"Load  MOSFET short circuit","description":"Load  MOSFET short circuit","datatype":"Binary","unit":""},{"old_key":"LoadShortCircuit","new_key":"LSC","label":"Load  short circuit","description":"Load  short circuit","datatype":"Binary","unit":""}]

/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allow_vue__ = __webpack_require__(899);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1564d2b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allow_vue__ = __webpack_require__(2105);
function injectStyle (ssrContext) {
  __webpack_require__(2104)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1564d2b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1564d2b8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_chart_vue__ = __webpack_require__(947);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f5589a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_chart_vue__ = __webpack_require__(2229);
function injectStyle (ssrContext) {
  __webpack_require__(2226)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18f5589a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f5589a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_installationStat_vue__ = __webpack_require__(949);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de3e9e64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_installationStat_vue__ = __webpack_require__(2231);
function injectStyle (ssrContext) {
  __webpack_require__(2230)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-de3e9e64"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_installationStat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_de3e9e64_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_installationStat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 88 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_animated_icons_vue__ = __webpack_require__(954);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f40bd7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_icons_vue__ = __webpack_require__(2564);
function injectStyle (ssrContext) {
  __webpack_require__(2247)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-61f40bd7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_animated_icons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61f40bd7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_animated_icons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__ = __webpack_require__(952);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74771512_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__ = __webpack_require__(2244);
function injectStyle (ssrContext) {
  __webpack_require__(2243)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_controls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74771512_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_controls_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e170df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charts_vue__ = __webpack_require__(2246);
function injectStyle (ssrContext) {
  __webpack_require__(2245)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_charts_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e170df0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_charts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rightBar_vue__ = __webpack_require__(1061);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452241b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rightBar_vue__ = __webpack_require__(2600);
function injectStyle (ssrContext) {
  __webpack_require__(2599)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-452241b3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_rightBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452241b3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_rightBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Register__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Login__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Error__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_NewPassword__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_ForgotPassword__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_EmailConfirmed__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_shs_GenerateToken__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_shs_TokenHistory__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_shs_TransactionResponse__ = __webpack_require__(2050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_shs_ravepay__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_devices_New__ = __webpack_require__(2055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_devices_Devices__ = __webpack_require__(2063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_pages_devices_Request__ = __webpack_require__(2066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_pages_devices_ManageRequests__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_devices_deviceRequestStatus__ = __webpack_require__(2072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_pages_devices_View__ = __webpack_require__(2075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_pages_kitchen_index__ = __webpack_require__(2084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_users_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_pages_users_new_user__ = __webpack_require__(2088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_pages_users_new_billing__ = __webpack_require__(2091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_users_BillingUpdate__ = __webpack_require__(2098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_users_new_customer__ = __webpack_require__(2101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_pages_users_edit_user__ = __webpack_require__(2106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_pages_users_edit_profile__ = __webpack_require__(2109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pages_users_details__ = __webpack_require__(2112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_pages_kitchen_Onboarding_FinishTab__ = __webpack_require__(2115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_pages_billing_Billing__ = __webpack_require__(2119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pages_billing_TransactionHistory__ = __webpack_require__(2141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pages_onboardingTracker_OnboardingTracker__ = __webpack_require__(2144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pages_adminBilling_AdminBilling__ = __webpack_require__(2147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_pages_luxOnboarding_LuxOnboarding__ = __webpack_require__(2153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_pages_luxOnboarding_LuxDeviceUpdate__ = __webpack_require__(2165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_pages_luxOnboarding_ListLuxUsers__ = __webpack_require__(2168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_pages_adminBilling_AdminTransactionHistory__ = __webpack_require__(2171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_pages_dashboard_index__ = __webpack_require__(2176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_pages_inventory_index__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_pages_inventory_packages__ = __webpack_require__(2181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_pages_inventory_components__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_pages_roles_index__ = __webpack_require__(2194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_pages_report_config__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_pages_alarm_alarmConfig__ = __webpack_require__(2199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_pages_enquiries_index__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_pages_enquiries_view__ = __webpack_require__(2205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_pages_instalation_addInstalation__ = __webpack_require__(2208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_pages_instalation_instalationList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_pages_instalation_instalationSchedule__ = __webpack_require__(2213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_pages_instalation_ongoingInstalation__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_pages_instalation_inventoryRequest__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_pages_instalation_installationCommission__ = __webpack_require__(2220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_pages_performance_details__ = __webpack_require__(2224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_pages_performance_detailsV2__ = __webpack_require__(2602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_pages_performance_geoDistro__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_pages_performance_index3_vue__ = __webpack_require__(2668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_pages_rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_pages_reports_index__ = __webpack_require__(2684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_pages_invoices_index__ = __webpack_require__(2710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_pages_invoices_single__ = __webpack_require__(2715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_pages_subsmanager_index__ = __webpack_require__(2721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_pages_proforma_index__ = __webpack_require__(2733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_pages_dashboard_new__ = __webpack_require__(2736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_pages_dashboard_pie__ = __webpack_require__(2749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_pages_dashboard_summary__ = __webpack_require__(2752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_pages_customerDashboard_index__ = __webpack_require__(2755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_pages_notifications_index__ = __webpack_require__(2764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_pages_dashboard_animated_icons__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_pages_warnings_index__ = __webpack_require__(2767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_pages_warnings_Index2__ = __webpack_require__(2773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_pages_customerWarning_index__ = __webpack_require__(2779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_pages_onboarding__ = __webpack_require__(2785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_pages_submodules_payments__ = __webpack_require__(2831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_pages_submodules_performance__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_pages_submodules_devices__ = __webpack_require__(2834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_pages_submodules_support__ = __webpack_require__(2839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_pages_submodules_reports__ = __webpack_require__(2842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_pages_submodules_feedback__ = __webpack_require__(2845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_pages_submodules_inventory__ = __webpack_require__(2848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_pages_submodules_users__ = __webpack_require__(2851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_pages_submodules_customers__ = __webpack_require__(2854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_pages_submodules_auditTrail__ = __webpack_require__(2866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__components_pages_submodules_user_mgt_vue__ = __webpack_require__(2869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__components_pages_submodules_customer_admin_vue__ = __webpack_require__(2916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__components_pages_submodules_payment_vue__ = __webpack_require__(2936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__components_pages_payment_paymentProcess__ = __webpack_require__(2945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__components_pages_payment_Feedback__ = __webpack_require__(2952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__components_pages_onboarding_outrightSale__ = __webpack_require__(2955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__components_pages_onboarding_outrightSale_OSAgreement_vue__ = __webpack_require__(2960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__components_pages_onboarding_outrightSale_OSSummary_vue__ = __webpack_require__(2963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__components_pages_onboarding_outrightSale_OSFinish_vue__ = __webpack_require__(2966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__components_pages_onboarding_leaseToOwn__ = __webpack_require__(2969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__components_pages_onboarding_leaseToOwn_LOSummary_vue__ = __webpack_require__(2972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__components_pages_onboarding_leaseToOwn_JobInformation_vue__ = __webpack_require__(2976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__components_pages_onboarding_leaseToOwn_LOAgreement_vue__ = __webpack_require__(2981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__components_pages_onboarding_leaseToOwn_BankStatement_vue__ = __webpack_require__(2984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__components_pages_onboarding_leaseToOwn_CreditCheck_vue__ = __webpack_require__(3005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_pages_onboarding_leaseToOwn_KYC_vue__ = __webpack_require__(3008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__components_pages_onboarding_leaseToOwn_PayDeposit_vue__ = __webpack_require__(3013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__components_pages_onboarding_leaseToOwn_LOFinish_vue__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_pages_EmailVerified_vue__ = __webpack_require__(3025);
/* eslint-disable */




































































// /home/aio/Documents/_repos/Arnergy/arnergy-core-vue/src/components/pages/customerDashboard/index.vue








// SubModules
















// test build

// Onboarding














// import OnboardingLO from "@/components/pages/onboarding/LO";
// import OnboardingOS from "@/components/pages/onboarding/OS";

// import VueGoodTablePlugin from 'vue-good-table';

// // import the styles
// import 'vue-good-table/dist/vue-good-table.css'

// Vue.use(VueGoodTablePlugin);


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;else return { x: 0, y: 500 };
  },

  routes: [{
    path: "/auth/register",
    name: "Register",
    component: __WEBPACK_IMPORTED_MODULE_2__components_pages_Register__["a" /* default */],
    meta: {
      bodyClass: "p-front p-signup-helper",
      permission: "anon"
    }
  }, {
    path: "/auth/email-verification",
    name: "EmailVerified",
    component: __WEBPACK_IMPORTED_MODULE_102__components_pages_EmailVerified_vue__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/onboarding/finish-tab",
    name: "FinishTab",
    component: __WEBPACK_IMPORTED_MODULE_30__components_pages_kitchen_Onboarding_FinishTab__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/customer_payment/:activetab",
    name: "customer_payment",
    component: __WEBPACK_IMPORTED_MODULE_86__components_pages_submodules_payment_vue__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/onboarding",
    name: "Onboarding",
    component: __WEBPACK_IMPORTED_MODULE_73__components_pages_onboarding__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/auth/processPayment",
    name: "Register",
    component: __WEBPACK_IMPORTED_MODULE_87__components_pages_payment_paymentProcess__["a" /* default */],
    meta: {
      permission: "anon"
    },
    alias: "/processPayment"
  }, {
    path: "/auth/paymentFeedback",
    name: "Register",
    component: __WEBPACK_IMPORTED_MODULE_88__components_pages_payment_Feedback__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/customer_payment/:activetab",
    name: "customer_payment",
    component: __WEBPACK_IMPORTED_MODULE_86__components_pages_submodules_payment_vue__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/customer_admin/:activetab",
    name: "customer_admin",
    component: __WEBPACK_IMPORTED_MODULE_85__components_pages_submodules_customer_admin_vue__["a" /* default */],
    meta: {
      permission: "anon"
    }
  }, {
    path: "/user_management/:activetab",
    name: "user_management",
    component: __WEBPACK_IMPORTED_MODULE_84__components_pages_submodules_user_mgt_vue__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/auth/login",
    name: "Login",
    component: __WEBPACK_IMPORTED_MODULE_3__components_pages_Login__["a" /* default */],
    meta: {
      permission: "anon",
      bodyClass: "p-front"
    },
    alias: "/login"
  }, {
    path: "/auth/forgot-password",
    name: "ForgotPassword",
    component: __WEBPACK_IMPORTED_MODULE_6__components_pages_ForgotPassword__["a" /* default */],
    meta: {
      permission: "anon",
      bodyClass: "p-front"
    }
  }, {
    path: "/auth/new-password/:uid/:token",
    name: "Password",
    component: __WEBPACK_IMPORTED_MODULE_5__components_pages_NewPassword__["a" /* default */],
    meta: {
      permission: "anon",
      bodyClass: "p-front"
    }
  }, {
    path: "/auth/email-confirm/:uid/:token",
    name: "EmailConfirmed",
    component: __WEBPACK_IMPORTED_MODULE_7__components_pages_EmailConfirmed__["a" /* default */],
    meta: {
      permission: "anon",
      bodyClass: "p-front"
    }
  }, {
    path: "/onboarding/os",
    name: "OutrightSale",
    component: __WEBPACK_IMPORTED_MODULE_89__components_pages_onboarding_outrightSale__["a" /* default */],
    children: [{
      path: "agreement",
      name: "OSAgreement",
      component: __WEBPACK_IMPORTED_MODULE_90__components_pages_onboarding_outrightSale_OSAgreement_vue__["a" /* default */]
    }, {
      path: "summary",
      name: "OSSummary",
      component: __WEBPACK_IMPORTED_MODULE_91__components_pages_onboarding_outrightSale_OSSummary_vue__["a" /* default */]
    }, {
      path: "finish",
      name: "OSFinish",
      component: __WEBPACK_IMPORTED_MODULE_92__components_pages_onboarding_outrightSale_OSFinish_vue__["a" /* default */]
    }]
  }, {
    path: "/onboarding/lo",
    name: "LeaseToOwn",
    component: __WEBPACK_IMPORTED_MODULE_93__components_pages_onboarding_leaseToOwn__["a" /* default */],
    children: [{
      path: "summary",
      name: "LOSummary",
      component: __WEBPACK_IMPORTED_MODULE_94__components_pages_onboarding_leaseToOwn_LOSummary_vue__["a" /* default */]
    },
    // {
    //   path: "job-info",
    //   name: "JobInformation",
    //   component: JobInformation
    // },
    {
      path: "agreement",
      name: "LOAgreement",
      component: __WEBPACK_IMPORTED_MODULE_96__components_pages_onboarding_leaseToOwn_LOAgreement_vue__["a" /* default */]
    },
    // {
    //   path: "bank-statement",
    //   name: "BankStatement",
    //   component: BankStatement
    // },
    {
      path: "credit-check",
      name: "CreditCheck",
      component: __WEBPACK_IMPORTED_MODULE_98__components_pages_onboarding_leaseToOwn_CreditCheck_vue__["a" /* default */]
    }, {
      path: "kyc",
      name: "KYC",
      component: __WEBPACK_IMPORTED_MODULE_99__components_pages_onboarding_leaseToOwn_KYC_vue__["a" /* default */]
    }, {
      path: "deposit",
      name: "PayDeposit",
      component: __WEBPACK_IMPORTED_MODULE_100__components_pages_onboarding_leaseToOwn_PayDeposit_vue__["a" /* default */]
    }, {
      path: "finish",
      name: "LOFinish",
      component: __WEBPACK_IMPORTED_MODULE_101__components_pages_onboarding_leaseToOwn_LOFinish_vue__["a" /* default */]
    }]
  }, {
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_57__components_pages_performance_index3_vue__["a" /* default */],
    meta: {
      permission: "CUSTOMER",
      fail: "/error"
    },
    alias: "/home"
  }, {
    path: "/shs/generate-token",
    name: "GenerateToken",
    component: __WEBPACK_IMPORTED_MODULE_8__components_pages_shs_GenerateToken__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/shs/token-history",
    name: "TokenHistory",
    component: __WEBPACK_IMPORTED_MODULE_9__components_pages_shs_TokenHistory__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/wallet",
    name: "WalletMgmt",
    component: __WEBPACK_IMPORTED_MODULE_10__components_pages_shs_Wallet__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/transaction/response/*",
    name: "TransactionResponse",
    component: __WEBPACK_IMPORTED_MODULE_11__components_pages_shs_TransactionResponse__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/request",
    name: "deviceRequest",
    component: __WEBPACK_IMPORTED_MODULE_16__components_pages_devices_Request__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/requests/manage",
    name: "manageRequests",
    component: __WEBPACK_IMPORTED_MODULE_17__components_pages_devices_ManageRequests__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/devices/new",
    name: "New",
    component: __WEBPACK_IMPORTED_MODULE_13__components_pages_devices_New__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/devices/list",
    name: "List",
    component: __WEBPACK_IMPORTED_MODULE_14__components_pages_devices_List__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/device/:deviceId/:activetab?",
    name: "viewDevices",
    component: __WEBPACK_IMPORTED_MODULE_19__components_pages_devices_View__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/device/performance/:deviceId/:version",
    name: "devicePerformance",
    component: __WEBPACK_IMPORTED_MODULE_54__components_pages_performance_details__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/device/performance-v2/:deviceId/:version",
    name: "devicePerformanceV2",
    component: __WEBPACK_IMPORTED_MODULE_55__components_pages_performance_detailsV2__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/dashboard/performance/:deviceId",
    name: "newDashboard",
    component: __WEBPACK_IMPORTED_MODULE_64__components_pages_dashboard_new__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/dashboard/performance/pie/:deviceId/:version",
    name: "pieChart",
    component: __WEBPACK_IMPORTED_MODULE_65__components_pages_dashboard_pie__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/dashboard/summary",
    name: "dashboardSummary",
    component: __WEBPACK_IMPORTED_MODULE_66__components_pages_dashboard_summary__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/dashboard/animated-icons",
    name: "DashboardAnimatedIcons",
    component: __WEBPACK_IMPORTED_MODULE_69__components_pages_dashboard_animated_icons__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/customers",
    name: "customers",
    component: __WEBPACK_IMPORTED_MODULE_82__components_pages_submodules_customers__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/subsmanager",
    name: "subsmanager",
    component: __WEBPACK_IMPORTED_MODULE_62__components_pages_subsmanager_index__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/proforma",
    name: "proforma",
    component: __WEBPACK_IMPORTED_MODULE_63__components_pages_proforma_index__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/devices-status",
    name: "devices-status",
    component: __WEBPACK_IMPORTED_MODULE_15__components_pages_devices_Devices__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/onboarding-tracker",
    name: "onboarding-tracker",
    component: __WEBPACK_IMPORTED_MODULE_33__components_pages_onboardingTracker_OnboardingTracker__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/admin-billing",
    name: "admin-billing",
    component: __WEBPACK_IMPORTED_MODULE_34__components_pages_adminBilling_AdminBilling__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/lux-onboarding",
    name: "lux-onboarding",
    component: __WEBPACK_IMPORTED_MODULE_37__components_pages_luxOnboarding_ListLuxUsers__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/lux-onboarding/create",
    name: "lux-onboarding-create",
    component: __WEBPACK_IMPORTED_MODULE_35__components_pages_luxOnboarding_LuxOnboarding__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/lux-onboarding/update",
    name: "LuxDeviceUpdate",
    component: __WEBPACK_IMPORTED_MODULE_36__components_pages_luxOnboarding_LuxDeviceUpdate__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/admin-transaction-history",
    name: "admin-transaction-history",
    component: __WEBPACK_IMPORTED_MODULE_38__components_pages_adminBilling_AdminTransactionHistory__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/users/list",
    name: "Users",
    component: __WEBPACK_IMPORTED_MODULE_21__components_pages_users_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/billing",
    name: "billing",
    component: __WEBPACK_IMPORTED_MODULE_31__components_pages_billing_Billing__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/billing/transactionHistory",
    name: "transactionHistory",
    component: __WEBPACK_IMPORTED_MODULE_32__components_pages_billing_TransactionHistory__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/user/new",
    name: "UserCreate",
    component: __WEBPACK_IMPORTED_MODULE_22__components_pages_users_new_user__["a" /* default */]
  }, {
    path: "/user/billing",
    name: "BillingCreate",
    component: __WEBPACK_IMPORTED_MODULE_23__components_pages_users_new_billing__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/user/billing-update",
    name: "BillingUpdate",
    component: __WEBPACK_IMPORTED_MODULE_24__components_pages_users_BillingUpdate__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/customer/new",
    name: "CustomerCreate",
    component: __WEBPACK_IMPORTED_MODULE_25__components_pages_users_new_customer__["a" /* default */]
  }, {
    path: "/users/priviledges/:userId",
    name: "allowUser",
    component: __WEBPACK_IMPORTED_MODULE_26__components_pages_users_allow__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/users/edit/:userId",
    name: "editUser",
    component: __WEBPACK_IMPORTED_MODULE_27__components_pages_users_edit_user__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/profile/edit/:userId",
    name: "editUser",
    component: __WEBPACK_IMPORTED_MODULE_28__components_pages_users_edit_profile__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/error",
    name: "Error",
    component: __WEBPACK_IMPORTED_MODULE_4__components_pages_Error__["a" /* default */],
    meta: {
      permission: "anon|CUSTOMER",
      bodyClass: "p-front"
    }
  }, {
    path: "/dashboard/CustomerDashboard",
    name: "customerDashboard",
    component: __WEBPACK_IMPORTED_MODULE_67__components_pages_customerDashboard_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/dashboard/notifications",
    name: "notifications",
    component: __WEBPACK_IMPORTED_MODULE_68__components_pages_notifications_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/users/:userId",
    name: "UserDetails",
    component: __WEBPACK_IMPORTED_MODULE_29__components_pages_users_details__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/kitchen",
    name: "uiKitchen",
    component: __WEBPACK_IMPORTED_MODULE_20__components_pages_kitchen_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/inventory/index",
    name: "inventoryIndex",
    component: __WEBPACK_IMPORTED_MODULE_40__components_pages_inventory_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/inventory/components",
    name: "inventoryComponents",
    component: __WEBPACK_IMPORTED_MODULE_42__components_pages_inventory_components__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/roles",
    name: "roles",
    component: __WEBPACK_IMPORTED_MODULE_43__components_pages_roles_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/report",
    name: "report",
    component: __WEBPACK_IMPORTED_MODULE_44__components_pages_report_config__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/alarm/config",
    name: "alarmConfig",
    component: __WEBPACK_IMPORTED_MODULE_45__components_pages_alarm_alarmConfig__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/enquiries",
    name: "enquiries",
    component: __WEBPACK_IMPORTED_MODULE_46__components_pages_enquiries_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/enquiries/:enqId",
    name: "viewEnquiry",
    component: __WEBPACK_IMPORTED_MODULE_47__components_pages_enquiries_view__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/device-request/:id",
    name: "deviceRequestStatus",
    component: __WEBPACK_IMPORTED_MODULE_18__components_pages_devices_deviceRequestStatus__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/instalations/approved",
    name: "instalationList",
    component: __WEBPACK_IMPORTED_MODULE_49__components_pages_instalation_instalationList__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/instalations/ongoing",
    name: "ongoingInstalation",
    component: __WEBPACK_IMPORTED_MODULE_51__components_pages_instalation_ongoingInstalation__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/instalations/inventory-request/:Installation",
    name: "inventoryRequest",
    component: __WEBPACK_IMPORTED_MODULE_52__components_pages_instalation_inventoryRequest__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/installation/commission/:Installation",
    name: "instalationCommission",
    component: __WEBPACK_IMPORTED_MODULE_53__components_pages_instalation_installationCommission__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/instalation/schedule/:Installation",
    name: "instalationSchedule",
    component: __WEBPACK_IMPORTED_MODULE_50__components_pages_instalation_instalationSchedule__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/shs/pay",
    name: "ravepay",
    component: __WEBPACK_IMPORTED_MODULE_12__components_pages_shs_ravepay__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  },
  // SubModules
  {
    path: "/payments",
    name: "payments",
    component: __WEBPACK_IMPORTED_MODULE_74__components_pages_submodules_payments__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/performance/:live",
    name: "performance",
    component: __WEBPACK_IMPORTED_MODULE_57__components_pages_performance_index3_vue__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/performance-v2/:live",
    name: "performance",
    component: __WEBPACK_IMPORTED_MODULE_57__components_pages_performance_index3_vue__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/geo-distribution",
    name: "geoDistribution",
    component: __WEBPACK_IMPORTED_MODULE_56__components_pages_performance_geoDistro__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/devices/:activetab",
    name: "devices",
    component: __WEBPACK_IMPORTED_MODULE_76__components_pages_submodules_devices__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/support",
    name: "support",
    component: __WEBPACK_IMPORTED_MODULE_77__components_pages_submodules_support__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/report/config",
    name: "reportConfig",
    component: __WEBPACK_IMPORTED_MODULE_78__components_pages_submodules_reports__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/feedback",
    name: "feedback",
    component: __WEBPACK_IMPORTED_MODULE_79__components_pages_submodules_feedback__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/packages",
    name: "packages",
    component: __WEBPACK_IMPORTED_MODULE_41__components_pages_inventory_packages__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/inventory",
    name: "inventory",
    component: __WEBPACK_IMPORTED_MODULE_80__components_pages_submodules_inventory__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/usersmanage",
    name: "usersmanage",
    component: __WEBPACK_IMPORTED_MODULE_81__components_pages_submodules_users__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/audittrail",
    name: "audittrail",
    component: __WEBPACK_IMPORTED_MODULE_83__components_pages_submodules_auditTrail__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/rightbar",
    name: "rightBar",
    component: __WEBPACK_IMPORTED_MODULE_58__components_pages_rightBar__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }, {
    path: "/reports",
    name: "reports",
    component: __WEBPACK_IMPORTED_MODULE_59__components_pages_reports_index__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/invoices",
    name: "invoices",
    component: __WEBPACK_IMPORTED_MODULE_60__components_pages_invoices_index__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/invoices/:single",
    name: "singleinvoice",
    component: __WEBPACK_IMPORTED_MODULE_61__components_pages_invoices_single__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/warnings",
    name: "warnings",
    component: __WEBPACK_IMPORTED_MODULE_70__components_pages_warnings_index__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  },
  // Warning_Index2
  {
    path: "/warnings2",
    name: "Index2",
    component: __WEBPACK_IMPORTED_MODULE_71__components_pages_warnings_Index2__["a" /* default */],
    meta: {
      permission: "ADMIN"
    }
  }, {
    path: "/customerWarning",
    name: "customerWarnings",
    component: __WEBPACK_IMPORTED_MODULE_72__components_pages_customerWarning_index__["a" /* default */],
    meta: {
      permission: "CUSTOMER"
    }
  }]
}));

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__ = __webpack_require__(874);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35152aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__ = __webpack_require__(2057);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35152aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agreement_vue__ = __webpack_require__(1135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e02814_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agreement_vue__ = __webpack_require__(2796);
function injectStyle (ssrContext) {
  __webpack_require__(2795)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-97e02814"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97e02814_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMain_vue__ = __webpack_require__(1143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169c7c30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMain_vue__ = __webpack_require__(2823);
function injectStyle (ssrContext) {
  __webpack_require__(2822)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-169c7c30"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalMain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169c7c30_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalMain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    $_createCsvLabelsConf: function $_createCsvLabelsConf(arr) {
      var conf = {};

      arr.map(function (m, i) {
        conf[m] = { title: m };
      });

      return conf;
    },
    $_createCsvLabels: function $_createCsvLabels(labels, separator) {
      var row = "";
      var c = "";

      try {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(labels).map(function (m, i) {
          row += '"' + labels[m] + '"' + separator;
        });

        row = row.slice(0, -1);

        c += row + "\r\n";
      } catch (err) {
        c = "error";
      } finally {
        return c;
      }
    },
    $_createCsvContent: function $_createCsvContent(arr, labels, separator) {
      var row = "";
      var c = "";
      var type = "";

      try {
        arr.map(function (m, i) {
          row = "";

          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(labels).map(function (k, s) {
            var item = m[k];
            //   const item = Object.values(m)[0]
            //   console.log('kkkkkkkkkkkkkkkk', m[k])
            type = typeof item === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(item);
            if (type === "number" || type === "float") {
              row += item + separator;
            } else {
              row += '"' + item + '"' + separator;
            }
          });

          row = row.slice(0, -1);

          c += row + "\r\n";
        });
      } catch (err) {
        c = "error";
      } finally {
        return c;
      }
    },
    $_downloadCsv: function $_downloadCsv(uid, csv, title) {
      try {
        var uri = "data:text/csv;charset=utf-8," + "\uFEFF" + encodeURIComponent(csv);

        var link = document.createElement("a");

        link.id = "csv-" + uid;
        link.href = uri;

        document.body.appendChild(link);

        document.getElementById(link.id).style.visibility = "hidden";
        document.getElementById(link.id).download = title + ".csv";

        document.body.appendChild(link);
        document.getElementById(link.id).click();

        setTimeout(function () {
          document.body.removeChild(link);
        });
        return true;
      } catch (err) {
        return false;
      }
    }
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_indicator_vue__ = __webpack_require__(1086);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72db82da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_indicator_vue__ = __webpack_require__(2653);
function injectStyle (ssrContext) {
  __webpack_require__(2652)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-72db82da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_status_indicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72db82da_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_status_indicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDciIGhlaWdodD0iNDUiIHZpZXdCb3g9IjAgMCA0NyA0NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zNy4xOTUyIDQ0LjA3NjJMMC44MzAzNjEgNC45NDM2Mkw0Ni40OTg2IDAuMjcxNzU2TDM3LjE5NTIgNDQuMDc2MloiIGZpbGw9IiNFNkY2RkYiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSuccess_vue__ = __webpack_require__(1189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1034d78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSuccess_vue__ = __webpack_require__(2950);
function injectStyle (ssrContext) {
  __webpack_require__(2949)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a1034d78"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalSuccess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1034d78_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalSuccess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.34e79a9.png";

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(893);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4702c30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2087);
function injectStyle (ssrContext) {
  __webpack_require__(2086)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4702c30a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4702c30a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instalationList_vue__ = __webpack_require__(940);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdcb670_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instalationList_vue__ = __webpack_require__(2212);
function injectStyle (ssrContext) {
  __webpack_require__(2211)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instalationList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cdcb670_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instalationList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ongoingInstalation_vue__ = __webpack_require__(943);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a2a421_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ongoingInstalation_vue__ = __webpack_require__(2217);
function injectStyle (ssrContext) {
  __webpack_require__(2216)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ongoingInstalation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62a2a421_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ongoingInstalation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inventoryRequest_vue__ = __webpack_require__(944);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4425e82a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inventoryRequest_vue__ = __webpack_require__(2219);
function injectStyle (ssrContext) {
  __webpack_require__(2218)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inventoryRequest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4425e82a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inventoryRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/inverter.d47c928.png";

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customPieChart_vue__ = __webpack_require__(957);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c88df0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customPieChart_vue__ = __webpack_require__(2563);
function injectStyle (ssrContext) {
  __webpack_require__(2254)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55c88df0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customPieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55c88df0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customPieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports) {

module.exports = [{"value":"Industry "},{"value":"Accounting "},{"value":"Airlines/Aviation"},{"value":"Alternative Dispute Resolution"},{"value":"Alternative Medicine"},{"value":"Animation"},{"value":"Apparel/Fashion"},{"value":"Architecture/Planning"},{"value":"Arts/Crafts"},{"value":"Automotive"},{"value":"Aviation/Aerospace"},{"value":"Banking/Mortgage"},{"value":"Biotechnology/Greentech"},{"value":"Broadcast Media"},{"value":"Building Materials"},{"value":"Business Supplies/Equipment"},{"value":"Capital Markets/Hedge Fund/Private Equity"},{"value":"Chemicals"},{"value":"Civic/Social Organization"},{"value":"Civil Engineering"},{"value":"Commercial Real Estate"},{"value":"Computer Games"},{"value":"Computer Hardware"},{"value":"Computer Networking"},{"value":"Computer Software/Engineering"},{"value":"Computer/Network Security"},{"value":"Construction"},{"value":"Consumer Electronics"},{"value":"Consumer Goods"},{"value":"Consumer Services"},{"value":"Cosmetics"},{"value":"Dairy"},{"value":"Defense/Space"},{"value":"Design"},{"value":"E-Learning"},{"value":"Education Management"},{"value":"Electrical/Electronic Manufacturing"},{"value":"Entertainment/Movie Production"},{"value":"Environmental Services"},{"value":"Events Services"},{"value":"Executive Office"},{"value":"Facilities Services"},{"value":"Farming"},{"value":"Financial Services"},{"value":"Fine Art"},{"value":"Fishery"},{"value":"Food Production"},{"value":"Food/Beverages"},{"value":"Fundraising"},{"value":"Furniture"},{"value":"Gambling/Casinos"},{"value":"Glass/Ceramics/Concrete"},{"value":"Government Administration"},{"value":"Government Relations"},{"value":"Graphic Design/Web Design"},{"value":"Health/Fitness"},{"value":"Higher Education/Acadamia"},{"value":"Hospital/Health Care"},{"value":"Hospitality"},{"value":"Human Resources/HR"},{"value":"Import/Export"},{"value":"Individual/Family Services"},{"value":"Industrial Automation"},{"value":"Information Services"},{"value":"Information Technology/IT"},{"value":"Insurance"},{"value":"International Affairs"},{"value":"International Trade/Development"},{"value":"Internet"},{"value":"Investment Banking/Venture"},{"value":"Investment Management/Hedge Fund/Private Equity"},{"value":"Judiciary"},{"value":"Law Enforcement"},{"value":"Law Practice/Law Firms"},{"value":"Legal Services"},{"value":"Legislative Office"},{"value":"Leisure/Travel"},{"value":"Library"},{"value":"Logistics/Procurement"},{"value":"Luxury Goods/Jewelry"},{"value":"Machinery"},{"value":"Management Consulting"},{"value":"Maritime"},{"value":"Market Research"},{"value":"Marketing/Advertising/Sales"},{"value":"Mechanical or Industrial Engineering"},{"value":"Media Production"},{"value":"Medical Equipment"},{"value":"Medical Practice"},{"value":"Mental Health Care"},{"value":"Military Industry"},{"value":"Mining/Metals"},{"value":"Motion Pictures/Film"},{"value":"Museums/Institutions"},{"value":"Music"},{"value":"Nanotechnology"},{"value":"Newspapers/Journalism"},{"value":"Non-Profit/Volunteering"},{"value":"Oil/Energy/Solar/Greentech"},{"value":"Online Publishing"},{"value":"Other Industry"},{"value":"Outsourcing/Offshoring"},{"value":"Package/Freight Delivery"},{"value":"Packaging/Containers"},{"value":"Paper/Forest Products"},{"value":"Performing Arts"},{"value":"Pharmaceuticals"},{"value":"Philanthropy"},{"value":"Photography"},{"value":"Plastics"},{"value":"Political Organization"},{"value":"Primary/Secondary Education"},{"value":"Printing"},{"value":"Professional Training"},{"value":"Program Development"},{"value":"Public Relations/PR"},{"value":"Public Safety"},{"value":"Publishing Industry"},{"value":"Railroad Manufacture"},{"value":"Ranching"},{"value":"Real Estate/Mortgage"},{"value":"Recreational Facilities/Services"},{"value":"Religious Institutions"},{"value":"Renewables/Environment"},{"value":"Research Industry"},{"value":"Restaurants"},{"value":"Retail Industry"},{"value":"Security/Investigations"},{"value":"Semiconductors"},{"value":"Shipbuilding"},{"value":"Sporting Goods"},{"value":"Sports"},{"value":"Staffing/Recruiting"},{"value":"Supermarkets"},{"value":"Telecommunications"},{"value":"Textiles"},{"value":"Think Tanks"},{"value":"Tobacco"},{"value":"Translation/Localization"},{"value":"Transportation"},{"value":"Utilities"},{"value":"Venture Capital/VC"},{"value":"Veterinary"},{"value":"Warehousing"},{"value":"Wholesale"},{"value":"Wine/Spirits"},{"value":"Wireless"},{"value":"Writing/Editing"}]

/***/ }),
/* 242 */,
/* 243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyRequests_vue__ = __webpack_require__(1149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1009ad70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyRequests_vue__ = __webpack_require__(2837);
function injectStyle (ssrContext) {
  __webpack_require__(2836)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1009ad70_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1903ded6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(2921);
function injectStyle (ssrContext) {
  __webpack_require__(2920)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1903ded6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1903ded6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/female-wave.efb4abb.gif";

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputField_vue__ = __webpack_require__(1206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c30edae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputField_vue__ = __webpack_require__(2990);
function injectStyle (ssrContext) {
  __webpack_require__(2989)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c30edae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c30edae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputField_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeAgoUtil", function() { return timeAgoUtil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ant_design_vue__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue_dist_antd_css__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ant_design_vue_dist_antd_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_ant_design_vue_dist_antd_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_body_class__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_body_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_body_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_good_table__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuebar__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_masonry_css__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ability__ = __webpack_require__(1853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__casl_vue__ = __webpack_require__(1906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_notifications__ = __webpack_require__(1907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_router_back_button__ = __webpack_require__(1908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_router_back_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_router_back_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_google_maps__ = __webpack_require__(1909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_noty__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_noty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_noty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vee_validate__ = __webpack_require__(1933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_drawer_layout__ = __webpack_require__(1934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_drawer_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_drawer_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ckeditor_ckeditor5_vue__ = __webpack_require__(1935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ckeditor_ckeditor5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ckeditor_ckeditor5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__vuikit_icons__ = __webpack_require__(1936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__bachdgvn_vue_otp_input__ = __webpack_require__(1937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__bachdgvn_vue_otp_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__bachdgvn_vue_otp_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_modal__ = __webpack_require__(1938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_js_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en__ = __webpack_require__(1939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__App__ = __webpack_require__(1943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils_http_common__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__utils_constants__ = __webpack_require__(3043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__utils_localstorage_common__ = __webpack_require__(3044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__store__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vuikit_theme__ = __webpack_require__(3045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__vuikit_theme___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__vuikit_theme__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__node_modules_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(3046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__node_modules_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__node_modules_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__node_modules_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(3047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__node_modules_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__node_modules_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(3048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__node_modules_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__node_modules_noty_lib_noty_css__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__node_modules_noty_lib_noty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__node_modules_noty_lib_noty_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__node_modules_noty_lib_themes_bootstrap_v3_css__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__node_modules_noty_lib_themes_bootstrap_v3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__node_modules_noty_lib_themes_bootstrap_v3_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_good_table_dist_vue_good_table_css__ = __webpack_require__(3049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_good_table_dist_vue_good_table_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_good_table_dist_vue_good_table_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_pages_kitchen_grey_table_header__ = __webpack_require__(3050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_pages_kitchen_center__ = __webpack_require__(3054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_pages_kitchen_arnergy_table__ = __webpack_require__(3057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_pages_kitchen_grey_pagination_vue__ = __webpack_require__(3060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vue_infinite_loading__ = __webpack_require__(3064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vue_infinite_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_vue_infinite_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_pages_customerDashboard_LineChart_vue__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_moment__);


/* eslint-disable */










// import DatePicker from "vue-md-date-picker";


// import Datetime from 'vue-datetime'








// import VueNativeSock from "vue-native-websocket";
// import VueWebsocket from "vue-websocket";




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21__vuikit_icons__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_ant_design_vue__["a" /* Spin */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue_js_modal___default.a, { dynamic: true, injectModalsContainer: true });

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__ckeditor_ckeditor5_vue___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue2_google_maps__, {
  load: {
    key: "AIzaSyAbz4NWK8NfeybeMGfBqQyablVMv2Xm0Lw",

    libraries: "places, drawing" // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',


    //// If you intend to programmatically custom event listener code
    //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
    //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
    //// you might need to turn this on.
    // autobindAllEvents: false,

    //// If you want to manually install components, e.g.
    //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
    //// Vue.component('GmapMarker', GmapMarker)
    //// then disable the following:
    // installComponents: true,
  } });



// configure language
__WEBPACK_IMPORTED_MODULE_25_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_24_element_ui_lib_locale_lang_en___default.a);

function toast(_ref) {
  var title = _ref.title,
      message = _ref.message,
      type = _ref.type,
      timeout = _ref.timeout,
      cb = _ref.cb;

  if (type === __WEBPACK_IMPORTED_MODULE_14_vue_notifications___default.a.types.warn) type = "warning";
  return new __WEBPACK_IMPORTED_MODULE_17_noty___default.a({
    theme: "bootstrap-v3",
    text: message,
    timeout: timeout,
    type: type
  }).show();
}

var mercId = "09554"; //09554
var currCode = "566";

var options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};








// import "./utils/richmarker.js";
// import "flatpickr/dist/themes/material_blue.css";







// import 'vue-datetime/dist/vue-datetime.css'







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_body_class___default.a, __WEBPACK_IMPORTED_MODULE_27__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_good_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_form_wizard___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11_vue_masonry_css__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_notifications___default.a, options); //Notifications
// Vue.use(Notifications); //
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuebar___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_drawer_layout___default.a);

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_router_back_button___default.a, { router: __WEBPACK_IMPORTED_MODULE_27__router__["a" /* default */] });



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter("formatDate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_45_moment___default()(String(value)).format("YYYY-MM-DD");
  }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter("formatDate", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_45_moment___default()(String(value)).format("YYYY-MM-DD");
  }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter("formatDateTime", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_45_moment___default()(String(value)).format("YYYY-MM-DD  hh:mm:ss");
  }
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("arnergy-table", __WEBPACK_IMPORTED_MODULE_41__components_pages_kitchen_arnergy_table__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("grey-pagination", __WEBPACK_IMPORTED_MODULE_42__components_pages_kitchen_grey_pagination_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("v-select", __WEBPACK_IMPORTED_MODULE_10_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("Can", __WEBPACK_IMPORTED_MODULE_13__casl_vue__["a" /* Can */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("table-header", __WEBPACK_IMPORTED_MODULE_39__components_pages_kitchen_grey_table_header__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("Center", __WEBPACK_IMPORTED_MODULE_40__components_pages_kitchen_center__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("line-chart", __WEBPACK_IMPORTED_MODULE_44__components_pages_customerDashboard_LineChart_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component("v-otp-input", __WEBPACK_IMPORTED_MODULE_22__bachdgvn_vue_otp_input___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_43_vue_infinite_loading___default.a, {
  /* options */
});

__WEBPACK_IMPORTED_MODULE_27__router__["a" /* default */].beforeEach(function (to, from, next) {
  var fetchUserData = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var userResponse, userData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return HTTP1.get("/users/" + __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].getters.getUserSession.id + "/?filter[include][role_mappings]/?" + Date.now());

            case 3:
              userResponse = _context.sent;

              if (userResponse.status === 200) {
                userData = userResponse.data;

                userData.token = token;
                userData.roleType = [{ subject: userData.roleType, actions: "all" }];
                setAccessLocal(userData);
                HTTP1.defaults.headers.common["Authorization"] = token;
              }
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              _context.next = 11;
              return refreshUserToken();

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[0, 7]]);
    }));

    return function fetchUserData() {
      return _ref2.apply(this, arguments);
    };
  }();

  var refreshUserToken = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var userResponse, userData;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return HTTP.get("/auth/user");

            case 3:
              userResponse = _context2.sent;

              if (userResponse.status === 200) {
                userData = userResponse.data;

                userData.token = token;
                userData.roleType = [{ subject: userData.roleType, actions: "all" }];
                setAccessLocal(userData);
                HTTP.defaults.headers.common["Authorization"] = "Bearer " + token;
              } else {
                logout();
              }
              _context2.next = 11;
              break;

            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](0);

              console.error("Failed to refresh user token:", _context2.t0);
              logout();

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this, [[0, 7]]);
    }));

    return function refreshUserToken() {
      return _ref3.apply(this, arguments);
    };
  }();

  // console.log(from.path)
  // localStorage.setItem('PATHMONITOR',from.name||"Home");
  // localStorage.setItem('PATHPARAMS',JSON.stringify(from.params));
  var isReload = false;
  if (window.performance) {}
  // console.info(window.performance.navigation.type);


  // do something based on the navigation type...
  switch (window.performance.navigation.type) {
    case 0:
      // console.info("TYPE_NAVIGATE");
      break;
    case 1:
      // console.info("TYPE_RELOAD");
      isReload = true;
      // if(from.name !== null){
      //   // next(from.name)
      //   console.log(from.fullPath)
      // }
      // next(from.path)
      //  next({ name: from.name||"Home", params: from.params });
      break;
    case 2:
      // console.info("TYPE_BACK_FORWARD");
      break;
    case 255:
      // console.info("255");
      break;
  }

  var HTTP = __WEBPACK_IMPORTED_MODULE_28__utils_http_common__["a" /* default */].FASTHTTP;
  var HTTP1 = __WEBPACK_IMPORTED_MODULE_28__utils_http_common__["a" /* default */].instance;
  var token = __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].getters.getUserSession !== null ? __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].getters.getUserSession.token : null;

  if (token !== null) {
    fetchUserData();
  } else {
    console.error("Token is null.");
  }

  function setAccessLocal(userSession) {
    __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].commit("setUser", userSession);
    //ability.update(userSession.roleType);
  }

  var acl = __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].getters.getUserSession !== null ? __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].getters.getUserSession.roleType : null;
  //  token = (store.getters.getUserSession !== null) ?
  //   store.getters.getUserSession.token :
  //   null;
  if (to.path === "/home" || to.path === "/") {
    // console.log(to.path)
    __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].commit("setHome", true);
  } else {
    __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */].commit("setHome", false);
  }

  if (token) {
    // let a = ability;
    next();
    // console.log(from.path);
    if (from.name !== null && isReload) {
      // next(from.fullPath)
    } else {}
      // next();

      // console.log(from, isReload)
  } else {
    if (to.path.indexOf("/auth") > -1) {
      next();
    } else {
      next("/auth/login");
    }
  }
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__casl_vue__["b" /* abilitiesPlugin */], __WEBPACK_IMPORTED_MODULE_12__ability__["a" /* default */]);
});

var timeAgoUtil = function timeAgoUtil(time) {
  var templates = {
    prefix: "",
    suffix: " ago",
    seconds: "few seconds",
    minute: "about a minute",
    minutes: "%d minutes",
    hour: "about an hour",
    hours: "about %d hours",
    day: "a day",
    days: "%d days",
    month: "about a month",
    months: "%d months",
    year: "about a year",
    years: "%d years"
  };
  var template = function template(t, n) {
    return templates[t] && templates[t].replace(/%d/i, Math.abs(Math.round(n)));
  };

  var timer = function timer(time) {
    if (!time) return;
    // time = time.replace(/\.\d+/, ""); // remove milliseconds
    // time = time.replace(/-/, "/").replace(/-/, "/");
    // time = time.replace(/T/, " ").replace(/Z/, " UTC");
    // time = time.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"); // -04:00 -> -0400
    // time = new Date(time * 1000 || time);

    var now = new Date();
    var seconds = time * 0.001 >> 0;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    var years = days / 365;

    // console.log({
    //   seconds,
    //   minutes,
    //   hours,
    //   days,
    //   years
    // })

    return templates.prefix + (seconds < 45 && template("seconds", seconds) || seconds < 90 && template("minute", 1) || minutes < 45 && template("minutes", minutes) || minutes < 90 && template("hour", 1) || hours < 24 && template("hours", hours) || hours < 42 && template("day", 1) || days < 30 && template("days", days) || days < 45 && template("month", 1) || days < 365 && template("months", days / 30) || years < 1.5 && template("year", 1) || template("years", years)) + templates.suffix;
  };

  return timer(time);
};

// To Disable logs
// console.log = function() {};
// console.log = function() {};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$httpUtils = __WEBPACK_IMPORTED_MODULE_28__utils_http_common__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$utilConstants = __WEBPACK_IMPORTED_MODULE_29__utils_constants__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$customLocalStorage = __WEBPACK_IMPORTED_MODULE_30__utils_localstorage_common__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$log = console.log.bind(console);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: "#app",
  store: __WEBPACK_IMPORTED_MODULE_31__store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_27__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_26__App__["a" /* default */]);
  }
});

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_noty__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_noty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_noty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_noty_lib_noty_css__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_noty_lib_noty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_noty_lib_noty_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_noty_lib_themes_bootstrap_v3_css__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_noty_lib_themes_bootstrap_v3_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_noty_lib_themes_bootstrap_v3_css__);



/* eslint-disable */






var BASEURL = "";
var NOTIFICATION_URL = "";
var IOT_URL = "";
var GRAPH_URL = "";
var FastAPI_URL = "";
var isLocalDev = true;
switch (window.location.host) {
  case "uat.arnergy.com":
    BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL = "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    break;
  case "solarbase-staging.arnergy.com":
    BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL = "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    break;
  case "dev1.arnergy.com":
    BASEURL = "https://solarbase-temp-env-3.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL = "https://2h3ip9wikd.execute-api.eu-west-2.amazonaws.com/dev/api/v1/configuration";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://uc34sin7hjr47dvoufi34qph2u0qbskd.lambda-url.us-east-1.on.aws/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    break;
  case "localhost:3001":
    // case "localhost:8080":
    BASEURL = "https://api-solarbase.arnergy.com";
    // BASEURL = "http://localhost:3000";
    // BASEURL = "https://solarbase-temp-env-3.us-west-2.elasticbeanstalk.com";
    NOTIFICATION_URL = "https://2h3ip9wikd.execute-api.eu-west-2.amazonaws.com/dev/api/v1/configuration";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://9cwdo1u2ih.execute-api.us-east-1.amazonaws.com/dev";
    // FastAPI_URL = "http://127.0.0.1:8000";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    break;
  // BASEURL = "https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com";
  // https://uat.arnergy.com
  default:
    BASEURL = "https://api-solarbase.arnergy.com";
    NOTIFICATION_URL = "https://ii4470x4p8.execute-api.us-west-2.amazonaws.com/prod";
    IOT_URL = "http://ec2-35-89-99-65.us-west-2.compute.amazonaws.com:8081";
    GRAPH_URL = "https://9cwdo1u2ih.execute-api.us-east-1.amazonaws.com/dev";
    FastAPI_URL = "https://api2.arnergy.com/prod/iot-handler/";
    break;
}

var instance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: BASEURL + "/api/v1/",
  timeout: 0,
  headers: {
    "Content-Type": "application/json"
  }
});
var explorerHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: BASEURL + "/explorer/swagger.json",
  timeout: 0,
  headers: {
    "Content-Type": "application/json"
  }
});

var ZOHOTHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: BASEURL + "/api/v1/zohos/"
});

var FASTHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  // baseURL: `https://api2.arnergy.com/prod/customer-onboarding/api`,
  baseURL: "https://api2.arnergy.com/dev/customer-onboarding/api",
  headers: {
    "Content-Type": "application/json",
    accept: "application/json"
  }
});

var NotificationHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "" + NOTIFICATION_URL
});

var GraphHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "" + GRAPH_URL
});

var AlarmHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  // Staging
  baseURL: "https://api2.arnergy.com/dev/alarms"
  // Production
  // baseURL: `https://api2.arnergy.com/prod/alarms`
});

var FastAPIHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "" + FastAPI_URL
});

var IOTHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: IOT_URL + "/api/v1/"
});

var LUXHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "https://api2.arnergy.com/lux/dev/api/v1"
});

var CacheHTTP = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  // baseURL: "http://localhost:5000"
  baseURL: "https://api2.arnergy.com/cache"
});

instance.interceptors.request.use(function (config) {
  var token = localStorage.getItem("appUserToken");
  config.headers.Authorization = token;

  return config;
});

instance.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response && error.response.data && error.response.data.error && error.response.data.error.code == "AUTHORIZATION_REQUIRED") {
    if (!window.location.pathname.includes("onboarding")) {
      new __WEBPACK_IMPORTED_MODULE_5_noty___default.a({
        theme: "bootstrap-v3",
        text: "Unauthorized access, please login",
        type: "error"
      }).show();
      logout();
    }
    if (!window.location.pathname.includes("onboarding")) {
      new __WEBPACK_IMPORTED_MODULE_5_noty___default.a({
        theme: "bootstrap-v3",
        text: "Unauthorized access, please login",
        type: "error"
      }).show();
      logout();
    }
  } else {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
  }
});

var logout = function logout() {
  localStorage.clear();
  // @todo: clear store data
  setTimeout(function () {
    window.location.href = "/auth/login";
    // this.$router.replace({ path: "/auth/login" });
  }, 100);
};

var addHeaders = function addHeaders(Obj) {
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(Obj).forEach(function (key) {
    switch (key.toLowerCase()) {
      case "content-type":
        instance.defaults.headers.post[key] = Obj[key];
        break;
      default:
        instance.defaults.headers.common[key] = Obj[key];
    }
  });
};
// This object is included to exposes custom transforms
// and flatten nested objects for specific requests.
var flatten = {
  // this function flattens and transforms the /devices/list request
  deviceList: function deviceList(datum) {
    return datum.map(function (data) {
      var user = data.user.data;
      var fullName = user.first_name + " " + user.last_name;
      var others = data;
      delete others.user;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, others, user, {
        fullName: fullName
      });
    });
  }
};

var queryStrings = function queryStrings(params) {
  return __WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(params);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  addHeaders: addHeaders,
  queryStrings: queryStrings,
  instance: instance,
  explorerHTTP: explorerHTTP,
  ZOHOTHTTP: ZOHOTHTTP,
  flatten: flatten,
  NotificationHTTP: NotificationHTTP,
  IOTHTTP: IOTHTTP,
  LUXHTTP: LUXHTTP,
  AlarmHTTP: AlarmHTTP,
  GraphHTTP: GraphHTTP,
  FastAPIHTTP: FastAPIHTTP,
  CacheHTTP: CacheHTTP,
  FASTHTTP: FASTHTTP
});

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyLoader_vue__ = __webpack_require__(855);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e52953_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyLoader_vue__ = __webpack_require__(2015);
function injectStyle (ssrContext) {
  __webpack_require__(2014)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29e52953"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29e52953_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ("<!doctype html>\r\n<html>\r\n  <head>\r\n    <meta name=\"viewport\" content=\"width=device-width\">\r\n    <meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\">\r\n    <title>      <%=  user['firstName'] %>   <%=  user['lastName'] %>  -      <%= packageType['name'] %> (<%= order['paymentModel'] %>)</title>\r\n    <style>\r\n    /* -------------------------------------\r\n        INLINED WITH htmlemail.io/inline\r\n    ------------------------------------- */\r\n    /* -------------------------------------\r\n        RESPONSIVE AND MOBILE FRIENDLY STYLES\r\n    ------------------------------------- */\r\n    @media only screen and (max-width: 620px) {\r\n      table[class=body] h1 {\r\n        font-size: 28px !important;\r\n        margin-bottom: 10px !important;\r\n      }\r\n      table[class=body] p,\r\n            table[class=body] ul,\r\n            table[class=body] ol,\r\n            table[class=body] td,\r\n            table[class=body] span,\r\n            table[class=body] a {\r\n        font-size: 16px !important;\r\n      }\r\n      table[class=body] .wrapper,\r\n            table[class=body] .article {\r\n        padding: 10px !important;\r\n      }\r\n      table[class=body] .content {\r\n        padding: 0 !important;\r\n      }\r\n      table[class=body] .container {\r\n        padding: 0 !important;\r\n        width: 100% !important;\r\n      }\r\n      table[class=body] .main {\r\n        border-left-width: 0 !important;\r\n        border-radius: 0 !important;\r\n        border-right-width: 0 !important;\r\n      }\r\n      table[class=body] .btn table {\r\n        width: 100% !important;\r\n      }\r\n      table[class=body] .btn a {\r\n        width: 100% !important;\r\n      }\r\n      table[class=body] .img-responsive {\r\n        height: auto !important;\r\n        max-width: 100% !important;\r\n        width: auto !important;\r\n      }\r\n    }\r\n\r\n    /* -------------------------------------\r\n        PRESERVE THESE STYLES IN THE HEAD\r\n    ------------------------------------- */\r\n    @media all {\r\n      .ExternalClass {\r\n        width: 100%;\r\n      }\r\n      .ExternalClass,\r\n            .ExternalClass p,\r\n            .ExternalClass span,\r\n            .ExternalClass font,\r\n            .ExternalClass td,\r\n            .ExternalClass div {\r\n        line-height: 100%;\r\n      }\r\n      .apple-link a {\r\n        color: inherit !important;\r\n        font-family: inherit !important;\r\n        font-size: inherit !important;\r\n        font-weight: inherit !important;\r\n        line-height: inherit !important;\r\n        text-decoration: none !important;\r\n      }\r\n      #MessageViewBody a {\r\n        color: inherit;\r\n        text-decoration: none;\r\n        font-size: inherit;\r\n        font-family: inherit;\r\n        font-weight: inherit;\r\n        line-height: inherit;\r\n      }\r\n      .btn-primary table td:hover {\r\n        background-color: #34495e !important;\r\n      }\r\n      .btn-primary a:hover {\r\n        background-color: #34495e !important;\r\n        border-color: #34495e !important;\r\n      }\r\n    }\r\n    </style>\r\n  </head>\r\n  <body class=\"\" style=\"background-color: #f6f6f6; font-family: sans-serif; -webkit-font-smoothing: antialiased; font-size: 14px; line-height: 1.4; margin: 0; padding: 0; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%;\">\r\n    <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"body\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; background-color: #f6f6f6;\">\r\n      <tr>\r\n        <td style=\"font-family: sans-serif; font-size: 14px; vertical-align: top;\"></td>\r\n        <td class=\"container\" style=\"font-family: sans-serif; font-size: 14px; vertical-align: top; display: block; Margin: 0 auto; max-width: 768px; padding: 10px; width: 768px;\">\r\n          <div class=\"content\" style=\"box-sizing: border-box; display: block; Margin: 0 auto; max-width: 768px; padding: 10px;\">\r\n\r\n            <!-- START CENTERED WHITE CONTAINER -->\r\n            <span class=\"preheader\" style=\"color: transparent; display: none; height: 0; max-height: 0; max-width: 0; opacity: 0; overflow: hidden; mso-hide: all; visibility: hidden; width: 0;\">Invoice from Arnergy, Kindly follow the instruction to make payment</span>\r\n            <table class=\"main\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; background: #ffffff; border-radius: 3px;\">\r\n\r\n              <!-- START MAIN CONTENT AREA -->\r\n              <tr>\r\n                <td class=\"wrapper\" style=\"font-family: sans-serif; font-size: 14px; vertical-align: top; box-sizing: border-box; padding: 20px;\">\r\n                        <p style=\"font-family: sans-serif; font-size: 14px; font-weight: normal; margin: 0; margin-top: 20px; margin-bottom: 20px;\">\r\n\r\n                            <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;\">\r\n                                <tr>\r\n                                  <td style=\"font-family: sans-serif; font-size: 14px; vertical-align: top;\">\r\n                                    <!-- Head ROW -->\r\n                                     <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\r\n                                        <tr>\r\n                                            <td valign=\"top\" style=\"padding: 0;\" class=\"mobile-wrapper\">\r\n                                                <!-- LEFT COLUMN -->\r\n                                                <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"47%\" style=\"width: 47%;\" align=\"left\">\r\n                                                    <tr>\r\n                                                        <td style=\"padding: 0 0 10px 0;\">\r\n                                                            <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"100%\">\r\n                                                                <tr>\r\n                                                                    <td align=\"left\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 16px;\">\r\n                                                                        <img src=\"https://arnergy.com/logo.png\" alt=\"Arnergy Logo\" width=\"177px\"/>\r\n                                                                    </td>\r\n                                                                </tr>\r\n                                                            </table>\r\n                                                        </td>\r\n                                                    </tr>\r\n                                                </table>\r\n                                                <!-- RIGHT COLUMN -->\r\n                                                <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"38%\" style=\"width: 30%;\" align=\"right\">\r\n                                                    <tr>\r\n                                                        <td style=\"padding: 0 0 10px 0;\">\r\n                                                            <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"100%\">\r\n                                                                <tr style=\"width: 100%;\">\r\n                                                                    <td align=\"left\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 12px; font-weight: bold; width: 50%;\">\r\n                                                                    Invoiced To: \r\n                                                                    </td>\r\n                                                                    <td align=\"right\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 10px;\">\r\n                                                                            <%=  user['firstName'] %>   <%=  user['lastName'] %> \r\n                                                                    </td>\r\n                                                                </tr>\r\n                                                                <tr style=\"width: 100%;\">\r\n                                                                    <td align=\"left\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 12px;  font-weight: bold;  width: 50%;\">\r\n                                                                     Date: \r\n                                                                    </td>\r\n                                                                    <td align=\"right\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 10px;\">\r\n                                                                            <%=  new Date(user['createdAt']).toLocaleString()  %> \r\n                                                                    </td>\r\n                                                                </tr>\r\n                                                                 \r\n                                                            </table>\r\n                                                        </td>\r\n                                                    </tr>\r\n                                                </table>\r\n                                            </td>\r\n                                        </tr>\r\n                                    </table>\r\n                        </p>\r\n                        <p class=\"office-address\" style=\"font-size: 12px;\">\r\n                            <b style=\"margin-bottom: 20px; color: #1a93ca;\"> Arnergy Solar</b>\r\n                            <br> \r\n                            <span>\r\n                                22A, Adeleke Adedoyin Str.<br>\r\n                                Victoria Island, Lagos.\r\n                            </span>\r\n                        </p>\r\n\r\n                        <table cellspacing=\"0\" cellpadding=\"0\" border=\"0\" width=\"100%\">\r\n                                <tr>\r\n                                    <td valign=\"top\" style=\"padding: 0;\" class=\"mobile-wrapper\">\r\n                                        <!-- LEFT COLUMN -->\r\n                                        <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"47%\" style=\"width: 47%;\" align=\"left\">\r\n                                            <tr>\r\n                                                <td style=\"padding: 0 0 10px 0;\">\r\n                                                    <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"100%\">\r\n                                                        <tr>\r\n                                                            <td align=\"left\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 16px;\">\r\n                                                                   <p class=\"office-address\" style=\"font-size: 12px;\">\r\n                                                                        <b style=\"margin-bottom: 20px; color: #1a93ca;\">Payment Details</b>\r\n                                                                        <br> \r\n                                                                        <span style=\"font-size: 10px;\">\r\n                                                                            Bank Name: Arnergy Solar <br>\r\n                                                                            Account Number: 0035478525 <br>\r\n                                                                            Bank: GTBank\r\n                                                                        </span>\r\n                                                                        <br>\r\n                                                                        <br>\r\n                                                                        <span  style=\"font-size: 10px;\">\r\n                                                                            Bank Name: Arnergy Solar<br>\r\n                                                                            Account Number: 0035478525<br>\r\n                                                                            Bank: Zenith Bank\r\n                                                                        </span>\r\n                                                                    </p>\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </table>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </table>\r\n                                        <!-- RIGHT COLUMN -->\r\n                                        <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"38%\" style=\"width: 30%;\" align=\"right\">\r\n                                            <tr>\r\n                                                <td style=\"padding: 0 0 10px 0;\">\r\n                                                    <table cellpadding=\"0\" cellspacing=\"0\" border=\"0\" width=\"100%\">\r\n                                                        <tr style=\"width: 100%;\">\r\n                                                            <td align=\"right\" style=\"font-family: Arial, sans-serif; color: #333333; font-size: 12px; font-weight: bold; width: 50%;\">\r\n                                                                <div \r\n                                                                style=\"\r\n                                                                    width: 147px;\r\n                                                                    height: 40px;\r\n                                                                    background-color: #ff7b0f;\r\n                                                                    text-align: center;\r\n                                                                    line-height: 40px;\r\n                                                                    color: #fff;\r\n                                                                    \">\r\n                                                                Total: \r\n                                                                <span style=\"color: #ffffff; font-size: 18px; \" >\r\n                                                                        ₦<%=  packageType['price'] %> \r\n                                                                </span>\r\n                                                                </div>\r\n                                                                \r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </table>\r\n                                                </td>\r\n                                            </tr>\r\n                                        </table>\r\n                                    </td>\r\n                                </tr>\r\n                            </table>\r\n\r\n                            <table style=\"margin-left: auto; margin-right: auto; margin-bottom: 10px; \" class=\"responsive-table\" width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\">\r\n                                   <thead style=\"background: rgba(218, 218, 218, 0.47);\">\r\n                                       <th align=\"left\" style=\" padding: 10px;\">\r\n                                           Description\r\n                                       </th>\r\n                                       <th align=\"right\" style=\" padding: 10px;\">\r\n                                           Price\r\n                                       </th>\r\n                                   </thead>\r\n                                \r\n                                <tbody>\r\n                                    <tr style=\"border-bottom: 1px solid #eeeeee;\">\r\n                                        <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"border-bottom: 1px solid #919191; margin-bottom: 10px;\">\r\n                                                <tbody>\r\n                                                    <tr>\r\n                                                        <td class=\"mobile-wrapper\" valign=\"top\">\r\n                                                            <!-- LEFT COLUMN -->\r\n                                                            <table style=\"width: 65%;\" width=\"65%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"left\">\r\n                                                                <tbody>\r\n                                                                    <tr>\r\n                                                                        <td style=\"padding:0px 30px;\">\r\n                                                                            <h4>\r\n                                                                                <i>\r\n                                                                                        Package Details\r\n                                                                                </i>\r\n                                                                            </h4>\r\n                                                                            <p>\r\n                                                                                <%= packageType['name'] %>\r\n                                                                            </p>\r\n                                                                            <ul>\r\n                                                                                <% packageType.packageComponents.forEach(function(singleComponent){\r\n                                                                                    %>\r\n                                                                                    <li style=\"text-transform: capitalize;\">\r\n                                                                                        <b><%= singleComponent['componentType']['name'] %>:</b>                         <%= singleComponent['quantity'] %>\r\n                                                                                    </li>\r\n                                                                                <% }); %>\r\n                                                                            </ul>\r\n                                                                        </td>\r\n                                                                    </tr>\r\n                                                                </tbody>\r\n                                                            </table>\r\n                                                            <!-- RIGHT COLUMN -->\r\n                                                            <table style=\"width: 30%;\" width=\"30%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"right\">\r\n                                                                <tbody>\r\n                                                                    <tr>\r\n                                                                        <td style=\"padding: 0 0 10px 0;\">\r\n                                                                            <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\">\r\n                                                                                <tbody><tr>\r\n                                                                                    <td style=\"font-family: Arial, sans-serif; color: #333333; font-size: 16px; padding:0px 30px;\" align=\"right\">\r\n                                                                                            ₦<%= packageType['price'] %>\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                            </tbody></table>\r\n                                                                        </td>\r\n                                                                    </tr>\r\n                                                                </tbody>\r\n                                                            </table>\r\n                                                        </td>\r\n                                                    </tr>\r\n                                                </tbody>\r\n                                            </table>\r\n                                    </tr>\r\n                                    <!-- BreakDown row -->\r\n                                    <tr style=\"border-bottom: 1px solid #eeeeee;\">\r\n                                            <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"border-bottom: 1px solid #919191; margin-bottom: 10px;\">\r\n                                                    <tbody>\r\n                                                        <tr>\r\n                                                            <td class=\"mobile-wrapper\" valign=\"top\">\r\n                                                                <!-- LEFT COLUMN -->\r\n                                                                <table style=\"width: 65%;\" width=\"65%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"left\">\r\n                                                                    <tbody>\r\n                                                                            <h4>\r\n                                                                                    <i>\r\n                                                                                            Cost Breakdown\r\n                                                                                    </i>\r\n                                                                                </h4>\r\n                                                                        <tr>\r\n                                                                            <td style=\"padding:0px 8px;\">\r\n                                                                                <p>\r\n                                                                                       VAT \r\n                                                                                </p>\r\n                                                                            </td>\r\n                                                                            <td style=\"padding:0px 8px;\">\r\n                                                                                <p> \r\n                                                                                        <span>\r\n                                                                                                (<%= order['orderVat'] %>%)\r\n                                                                                        </span>\r\n                                                                                </p>html\r\n                                                                            </td>\r\n                                                                        </tr>\r\n                                                                        <tr>\r\n                                                                            <td stylhtmling:0px 8px;\">\r\n                                                                                <p>\r\n                                                                                    htmlount \r\n                                                                                </p>html\r\n                                                                            </td>\r\n                                                                            <td stylhtmling:0px 8px;\">\r\n                                                                                <p> html\r\n                                                                                        <span>\r\n                                                                                                (<%= order['orderDiscount'] %>%)\r\n                                                                                        </span>\r\n                                                                                </p>\r\n                                                                            </td>\r\n                                                                        </tr>\r\n                                                                        <!-- <%= order['paymentModel'] %> -->\r\n                                                                        <% if(order['paymentModel'] != 'OS'){ %>\r\n                                                                            <tr>\r\n                                                                                    <td style=\"padding:0px 8px;\">\r\n                                                                                        <p>\r\n                                                                                               Setup fee \r\n                                                                                        </p>\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                            <tr>\r\n                                                                                    <td style=\"padding:0px 8px;\">\r\n                                                                                        <p>\r\n                                                                                              Refundable caution fee \r\n                                                                                        </p>\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                            <tr>\r\n                                                                                    <td style=\"padding:0px 8px;\">\r\n                                                                                        <p>\r\n                                                                                             Subscription fee\r\n                                                                                        </p>\r\n                                                                                    </td>\r\n                                                                                </tr>\r\n                                                                          <% } %>\r\n                                                                    </tbody>\r\n                                                                </table>\r\n                                                                <!-- RIGHT COLUMN -->\r\n                                                                <table style=\"width: 30%;\" width=\"30%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" align=\"right\">\r\n                                                                    <tbody>\r\n                                                                        <tr>\r\n                                                                            <td style=\"padding: 0 0 10px 0;\">\r\n                                                                                <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\">\r\n                                                                                    <tbody>\r\n                                                                                        <tr>\r\n                                                                                            <td style=\"padding:0px 8px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                                    <p>   \r\n                                                                                                      ₦<%= Number(Number(packageType['price']) * (Number(order['orderVat'])/100)).toFixed(2) %>\r\n                                                                                                    </p>\r\n                                                                                            </td>\r\n                                                                                        </tr>\r\n                                                                                        <tr>\r\n                                                                                            <td style=\"padding:0px 8px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                                <p>       \r\n                                                                                                    ₦<%= Number(Number(packageType['price']) * (Number(order['orderDiscount'])/100)).toFixed(2) %>\r\n                                                                                                </p>\r\n                                                                                            </td>\r\n                                                                                        </tr>\r\n                                                                                        <% if(order['paymentModel'] != 'OS'){ %>\r\n                                                                                            <tr>\r\n                                                                                                <td style=\"padding:0px 8px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                                    <p>\r\n                                                                                                            ₦<%= Number(Number(packageType['price']) * (Number(packageConfig['Setup'])/100)).toFixed(2) %> \r\n                                                                                                    </p>\r\n                                                                                                </td>\r\n                                                                                            </tr>\r\n                                                                                            <tr>\r\n                                                                                                <td style=\"padding:0px 8px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                                    <p>\r\n                                                                                                            ₦<%= Number(Number(Number(packageType['price']) * (Number(packageConfig['Subscription'])/100)) * (Number(packageConfig['Caution']))).toFixed(2) %> \r\n                                                                                                    </p>\r\n                                                                                                </td>\r\n                                                                                            </tr>\r\n                                                                                            <tr>\r\n                                                                                                <td style=\"padding:0px 8px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                                    <p>\r\n                                                                                                            ₦<%= Number(Number(packageType['price']) * (Number(packageConfig['Subscription'])/100)).toFixed(2) %> \r\n                                                                                                    </p>\r\n                                                                                                </td>\r\n                                                                                            </tr>\r\n                                                                                            <% } %>\r\n                                                                                </tbody></table>\r\n                                                                            </td>\r\n                                                                        </tr>\r\n                                                                    </tbody>\r\n                                                                </table>\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </tbody>\r\n                                                </table>\r\n                                        </tr>\r\n\r\n                                        <tr style=\"border-bottom: 1px solid #eeeeee; \">\r\n                                               <!-- Total Table -->\r\n                                               <table width=\"100%\" cellspacing=\"0\" cellpadding=\"0\" border=\"0\" style=\"background: #ffffff; border-bottom: 1px solid #919191; margin-bottom: 10px;\">\r\n                                                    <tbody>\r\n                                                        <tr>\r\n                                                            <td align=\"right\" style=\"font-family: sans-serif; font-size: 14px; vertical-align: top; padding-bottom: 15px;\">\r\n                                                                <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: auto;\">\r\n                                                                    <tbody>\r\n                                                                        <tr>\r\n                                                                            <td style=\"padding:0px 30px; font-family: Arial, sans-serif; color: #333333;\" align=\"right\">\r\n                                                                                <p style=\"font-weight: bolder;\">       \r\n                                                                                    Total:  \r\n                                                                                    <span style=\"font-size: 30px; \" > \r\n                                                                                        ₦<%= Number(Number(packageType['price']) + (Number(order['orderDiscount'])/100) + Number(Number(packageType['price']) * (Number(order['orderVat'])/100))).toFixed(2) %>\r\n                                                                                    </span>\r\n                                                                                </p>\r\n                                                                            </td>\r\n                                                                        </tr>\r\n                                                                    </tbody>\r\n                                                                </table>\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </tbody>\r\n                                                </table>\r\n                                                <% if(setupURL != false){ %>\r\n                                                <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" class=\"btn btn-primary\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%; box-sizing: border-box; text-align: center;\">\r\n                                                    <tbody>\r\n                                                        <tr>\r\n                                                            <td align=\"center\" style=\"font-family: sans-serif; font-size: 14px; vertical-align: top; padding-bottom: 15px;\">\r\n                                                                <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: auto;\">\r\n                                                                    <tbody>\r\n                                                                        <tr>\r\n                                                                        <td style=\"font-family: sans-serif; font-size: 14px; vertical-align: top; background-color: #3498db; border-radius: 5px; text-align: center;\"> <a href=\"<%= setupURL %>\" target=\"_blank\" style=\"display: inline-block; color: #ffffff; background-color: #3498db; border: solid 1px #3498db; border-radius: 5px; box-sizing: border-box; cursor: pointer; text-decoration: none; font-size: 14px; font-weight: bold; margin: 0; padding: 12px 25px; text-transform: capitalize; border-color: #3498db;\">Make Payment</a> </td>\r\n                                                                        </tr>\r\n                                                                    </tbody>\r\n                                                                </table>\r\n                                                            </td>\r\n                                                        </tr>\r\n                                                    </tbody>\r\n                                                </table>\r\n                                                <% }%>\r\n                                        </tr>\r\n\r\n                                    </tbody>\r\n                            </table>\r\n                    </td>\r\n                    </tr>\r\n                  </table>\r\n                </td>\r\n              </tr>\r\n\r\n            <!-- END MAIN CONTENT AREA -->\r\n            </table>\r\n\r\n            <!-- START FOOTER -->\r\n            <div class=\"footer\" style=\"clear: both; Margin-top: 10px; text-align: center; width: 100%;\">\r\n              <table border=\"0\" cellpadding=\"0\" cellspacing=\"0\" style=\"border-collapse: separate; mso-table-lspace: 0pt; mso-table-rspace: 0pt; width: 100%;\">\r\n                <tr>\r\n                  <td class=\"content-block\" style=\"font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;\">\r\n                    <span class=\"apple-link\" style=\"color: #999999; font-size: 12px; text-align: center;\">22A, Adeleke Adedoyin Street, Victoria Island. Lagos.</span>\r\n                  </td>\r\n                </tr>\r\n                <tr>\r\n                  <td class=\"content-block powered-by\" style=\"font-family: sans-serif; vertical-align: top; padding-bottom: 10px; padding-top: 10px; font-size: 12px; color: #999999; text-align: center;\">\r\n                    Issued by <a href=\"http://solarbase.surge.sh\" style=\"color: #999999; font-size: 12px; text-align: center; text-decoration: none;\">Arnergy Solarbase&trade;</a>\r\n                  </td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n            <!-- END FOOTER -->\r\n\r\n          <!-- END CENTERED WHITE CONTAINER -->\r\n          </div>\r\n        </td>\r\n        <td style=\"font-family: sans-serif; font-size: 14px; vertical-align: top;\">&nbsp;</td>\r\n      </tr>\r\n    </table>\r\n  </body>\r\n</html>\r\n");

/***/ }),
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo-white.f546173.svg";

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_powerStat_vue__ = __webpack_require__(1081);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_926b3b90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_powerStat_vue__ = __webpack_require__(2645);
function injectStyle (ssrContext) {
  __webpack_require__(2644)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-926b3b90"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_powerStat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_926b3b90_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_powerStat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customBox_vue__ = __webpack_require__(1113);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ee41ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customBox_vue__ = __webpack_require__(2739);
function injectStyle (ssrContext) {
  __webpack_require__(2738)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14ee41ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14ee41ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customGridBox_vue__ = __webpack_require__(1114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea23698_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customGridBox_vue__ = __webpack_require__(2741);
function injectStyle (ssrContext) {
  __webpack_require__(2740)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8ea23698"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customGridBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8ea23698_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customGridBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customGeoBox_vue__ = __webpack_require__(1115);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659f2428_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customGeoBox_vue__ = __webpack_require__(2743);
function injectStyle (ssrContext) {
  __webpack_require__(2742)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-659f2428"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customGeoBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_659f2428_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customGeoBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customChart_vue__ = __webpack_require__(1116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bab0de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customChart_vue__ = __webpack_require__(2745);
function injectStyle (ssrContext) {
  __webpack_require__(2744)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bab0de4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bab0de4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customDatePicker_vue__ = __webpack_require__(1117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f9fc46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customDatePicker_vue__ = __webpack_require__(2747);
function injectStyle (ssrContext) {
  __webpack_require__(2746)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5f9fc46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customDatePicker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5f9fc46_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customDatePicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */,
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arnergy-5000.5c8e7de.png";

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingTopBar_vue__ = __webpack_require__(1144);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b6704c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingTopBar_vue__ = __webpack_require__(2826);
function injectStyle (ssrContext) {
  __webpack_require__(2825)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47b6704c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingTopBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47b6704c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingTopBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingButton_vue__ = __webpack_require__(1145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059eba06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingButton_vue__ = __webpack_require__(2829);
function injectStyle (ssrContext) {
  __webpack_require__(2828)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-059eba06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_059eba06_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRequestsuser_vue__ = __webpack_require__(1160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bdc1e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRequestsuser_vue__ = __webpack_require__(2896);
function injectStyle (ssrContext) {
  __webpack_require__(2871)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRequestsuser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58bdc1e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRequestsuser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__ = __webpack_require__(1170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f46d4a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__ = __webpack_require__(2910);
function injectStyle (ssrContext) {
  __webpack_require__(2897)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f46d4a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(1175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376eb59e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(2912);
function injectStyle (ssrContext) {
  __webpack_require__(2911)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-376eb59e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_376eb59e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerGroup_vue__ = __webpack_require__(1176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dfe9b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerGroup_vue__ = __webpack_require__(2914);
function injectStyle (ssrContext) {
  __webpack_require__(2913)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_22dfe9b0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_verify_vue__ = __webpack_require__(1188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1072ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_verify_vue__ = __webpack_require__(2948);
function injectStyle (ssrContext) {
  __webpack_require__(2947)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a1072ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_verify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a1072ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_verify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_error_vue__ = __webpack_require__(1211);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1479fa48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_error_vue__ = __webpack_require__(3000);
function injectStyle (ssrContext) {
  __webpack_require__(2999)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1479fa48"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1479fa48_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(1782);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(1789);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 801 */,
/* 802 */,
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(1806);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(1828);
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 809 */,
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(1833);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 811 */,
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(1855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mutations__ = __webpack_require__(1856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persist__ = __webpack_require__(1903);
/* eslint-disable */








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var vuexLocalStorage = new __WEBPACK_IMPORTED_MODULE_6_vuex_persist__["a" /* default */]({
  key: 'arnergy_persist_key', // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_4__mutations__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_5__actions__["b" /* default */],
  plugins: [vuexLocalStorage.plugin]
}));

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _userList$userListAdm;

/* eslint-disable */
var defaultTheme = {
  "theme-name": "light-solarbase",
  "$background-color": "#3B83B3",
  "$active-background-color": "#1a93ca",
  "$text-color": "#ffffff",
  "$active-text-color": "#ffffff"
};
var darkTheme = {
  "theme-name": "dark-solarbase",
  "$background-color": "#202831",
  "$active-background-color": "#191e24",
  "$text-color": "#7f8b94",
  "$active-text-color": "#40acfc"
};

/* harmony default export */ __webpack_exports__["a"] = (_userList$userListAdm = {
  userList: [],
  userListAdmin: [],
  groupList: [],
  subgroupList: [],
  groupUsers: [],
  groupitemList: [],
  userAmount: null,
  emailList: [],
  installs: [],
  installss: [],
  smsList: [],
  deviceList: []
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "deviceList", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "dummy", "Dummy Data"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "loggedInUser", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "userAccess", "CUSTOMER"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "isHome", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "isSidebarCollapsed", true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "drawerMode", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "allDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "allGraphDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "allOffDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "devicesWarning", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "roles", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "rolesAdmin", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "graphDeviceDetails", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "offLineDeviceList", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "alarmDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "criticalSystems", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "onLineDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "uniqueFV", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filteredAllDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filteredOnlineDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filteredAlarmDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filteredOffLineDevices", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "uniqueSectors", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filterFirmWarVersion", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filterPaymentModel", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "deviceCurrentSettings", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "filterSectorVal", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "performanceFilter", 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "loggedinUserRole", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "loggedinUserInstallationCount", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "globalTableOptions", {
  performance: {
    pagination: {
      currentPage: 1,
      prevPage: 1,
      currentPerPage: 50,
      total: 50
    }
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "defaultTheme", {
  "theme-name": "light-solarbase",
  "$background-color": "#3B83B3",
  "$active-background-color": "#1a93ca",
  "$text-color": "#ffffff",
  "$active-text-color": "#ffffff"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "darkTheme", {
  "theme-name": "dark-solarbase",
  "$background-color": "#202831",
  "$active-background-color": "#191e24",
  "$text-color": "#7f8b94",
  "$active-text-color": "#40acfc"
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "activeTheme", defaultTheme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "osCustomer", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "customerProductOptions", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "onboanrdingState", 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "onboardingPackageType", {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "userNotifications", []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "assignedDevices", null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "onboardingCustomerState", { id: 0, packageType: "", stateid: 0 }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "activeDeviceDaysToExpire", 100), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "luxOnboardingStatus", {
  deviceId: "",
  serialNumbers: []
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "luxPaymentStatus", {
  paymentType: "",
  cLoadValue: "",
  deviceVersion: ""
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_userList$userListAdm, "luxCount", 1), _userList$userListAdm);

/***/ }),
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */,
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1918)));

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1922)));

/***/ }),
/* 832 */,
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1926)));

/***/ }),
/* 834 */,
/* 835 */,
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(1931)));

/***/ }),
/* 837 */,
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slideout__ = __webpack_require__(1945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_slideout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_slideout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Sidebar__ = __webpack_require__(1949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_MainHeader__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_MainFooter__ = __webpack_require__(3030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_kitchen_Notifications_NotifyBox_vue__ = __webpack_require__(3033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_kitchen_Notifications_DaysLeft_vue__ = __webpack_require__(3036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_UsersWithoutDevice_vue__ = __webpack_require__(3039);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* eslint-disable */









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_5__components_Sidebar__["a" /* default */],
    MainFooter: __WEBPACK_IMPORTED_MODULE_7__components_MainFooter__["a" /* default */],
    MainHeader: __WEBPACK_IMPORTED_MODULE_6__components_MainHeader__["a" /* default */],
    "vk-offcanvas-content": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__["c" /* OffcanvasContent */],
    "days-left": __WEBPACK_IMPORTED_MODULE_10__components_pages_kitchen_Notifications_DaysLeft_vue__["a" /* default */],
    NotifyBox: __WEBPACK_IMPORTED_MODULE_9__components_pages_kitchen_Notifications_NotifyBox_vue__["a" /* default */],
    UsersWithoutDevice: __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_UsersWithoutDevice_vue__["a" /* default */]
  },
  data: function data() {
    return {
      sideBarCollapse: true,
      goback: true,
      isDefaultLayout: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDevices", "getUserSession", "isHome", "getDrawerMode", "getTheme", "getDeviceByUserId", "getAssignedDevices", "isSidebarCollapsed", "getUserNotifications"])),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapActions */])(["setAccess", "setUserSession", "setDrawerMode", "setTheme", "toggleSidebar", "saveUserNotifications"]), {
    // fetchUsers() {
    //   const HTTP = this.$httpUtils.instance;
    //   // console.log(JSON.stringify(this.getUserSession))
    //   const url = "/users";
    //   HTTP.get(url)
    //     .then(response => {
    //       const usersList = response.data;
    //       // this.$store.commit("saveUsers", usersList);
    //       // console.log(this.getUserById(1))
    //     })
    //     .catch(error => {
    //       console.log("error", error);
    //     });
    // },
    fetchDevices: function fetchDevices() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/devices";
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit("saveDevices", usersList);
        // console.log(this.getDevices)
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    handleSlideStart: function handleSlideStart() {
      // console.info("slide-start");
    },
    handleSlideMove: function handleSlideMove(position) {
      // console.info("slide-move", position);
    },
    handleSlideEnd: function handleSlideEnd(visible) {
      console.info("slide-end", visible);
      if (visible) {
        document.getElementsByClassName("content-wrap")[0].style.overflow = "hidden !important;";

        // console.log(wrapper);
      }
    },
    handleMaskClick: function handleMaskClick() {
      // console.info("mask-click");
      // this.setDrawerMode(false);
      // this.$refs.drawerLayout.toggle(false);
    },
    getUserAssignedDevices: function getUserAssignedDevices() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userId, url, result, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.getUserSession) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                userId = _this2.getUserSession.id;
                url = "/installations?filter={\"where\":{\"and\": [{\"userId\":" + userId + "}, {\"or\":[{ \"status\": \"requested\"},{ \"status\": \"commissioned\"},{ \"status\": \"completed\"}]}]}}";
                _context.next = 6;
                return _this2.$httpUtils.instance.get(url);

              case 6:
                result = _context.sent;
                res = result.data.map(function (item) {
                  return item.CID;
                });

                _this2.$store.state.loggedinUserInstallationCount = result.data.length;
                _this2.$store.commit("setAssignedDevices", res);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchUserNotifications: function fetchUserNotifications() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, devices;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this3.$httpUtils.NotificationHTTP;
                devices = _this3.getAssignedDevices;

                if (!(!devices || devices.length < 1)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                devices = devices.join(",");
                HTTP.get("notification/" + devices).then(function (res) {
                  _this3.$store.commit("saveUserNotifications", res.data.response.items);
                }).catch(function (error) {
                  console.log("error", error);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setLayout: function setLayout() {
      var _this4 = this;

      var exemptedRoutes = ["OutrightSale", "OSAgreement", "OSSummary", "OSFinish", "Onboarding", "LeaseToOwn", "LOSummary", "JobInformation", "LOAgreement", "BankStatement", "CreditCheck", "KYC", "PayDeposit", "LOFinish"];
      var value = exemptedRoutes.find(function (x) {
        return x == _this4.$route.name;
      });
      if (value) {
        this.isDefaultLayout = false;
      }
    }
  }),
  mounted: function mounted() {
    var page = localStorage["PATHMONITOR"] || "/";
    var path_params = JSON.parse(localStorage["PATHPARAMS"] || "{}") || "/";
    this.setTheme();
    this.getUserAssignedDevices();
    this.fetchUserNotifications();
    this.setLayout();
  },
  beforeUpdate: function beforeUpdate() {
    try {
      var lastHistory = this.$routerHistory.previous().path || "";
      if (lastHistory.includes("login") || lastHistory.includes("register") || lastHistory == "dashboard") this.goback = false;
    } catch (error) {}
  }
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_click_outside__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Menu"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["Submenu"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["MenuItem"]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_element_ui__["MenuItemGroup"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "sidebar",
  props: ["collapse"],
  data: function data() {
    return {
      logoWhite: "",
      isCollapse: false,
      onboardingState: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["setUserSession"]), {
    handleOpen: function handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose: function handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    navToPath: function navToPath(page) {
      this.$router.replace({
        path: page,
        params: {}
      });
      // document.getElementById("menu_pin").click();
      // console.log(user);
    },
    navTo: function navTo(page) {
      if (page == "devices") {
        this.$router.push({
          name: page,
          params: {
            activetab: this.$can("manage", "mine") ? "device_request" : this.$can("am", "manager") || this.$can("am", "engineer") ? "all_devices" : "manage_requests"
          }
        });
      } else if (page == "user_management") {
        this.$router.push({
          name: page,
          params: {
            activetab: this.$can("manage", "mine") ? "device_request" : this.$can("am", "manager") || this.$can("am", "engineer") ? "users" : "customer_group"
          }
        });
      } else {
        this.$router.push({
          name: page,
          params: {}
        });
        // document.getElementById("menu_pin").click();
        // console.log(user);
      }
    },
    shutDoor: function shutDoor() {
      // console.log(this.slideout);
    },
    logout: function logout() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.post("/users/logout", {}).then(function (response) {
        _this.$store.state.loggedinUserRole = null;
        container.setUserSession(null);
        localStorage.userToken = null;
        setTimeout(function () {
          // container.$router.push({ path: "/auth/login" });
          window.location.reload();
        }, 300);
      }).catch(function (e) {
        container.setUserSession(null);
        setTimeout(function () {
          window.location.reload();
        }, 300);
      });
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserSession", "getTheme", "isSidebarCollapsed"]), {
    isOnboardingLoacation: {
      get: function get() {
        return window.location.pathname == "/onboarding";
      }
    }
  }),
  mounted: function mounted() {
    if (!this.$can("all", "anon")) {
      // this.$router.push({ path: "/" });
      // return
    }
    if (localStorage.customerId) this.onboardingState = true;else this.onboardingState = false;
  },

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_1_vue_click_outside___default.a
  }
});

/***/ }),
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAwCAYAAABE1blzAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACISURBVHgB7dfBCYAwEAXRjViYrViZrdiZbgXJYQk6Yd41isxByG9R9KTeeUsx0ej7WyzOQDoD6QykM5DOQDoD6fb4WI6Bq3eeY+SMgvKUqc6l2e/7D9IZSGcgnYF0BtIZSLfnXfXoPZB33TvA2t/XgGtiwEA6A+kMpDOQzkA6A+kMpDOQbvnAFy5bLFaTETdLAAAAAElFTkSuQmCC"

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA6CAYAAADlTpoVAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHuSURBVHgB7ZrvbcIwEMVfUAfoBqQbsAFsULoBG5QNOkLVCUongE5AOgF0gqQTwAbXs+xK/eAzSXD+GN1Peop0CbFfbJ+NE0BJmwwdQET3fFiw5qycNWPdOxnOrModj6wvVpFl2Rljho0tWXtqz561wtjgSj2zThSPchRGuRILV5muKE0ZGAIu+JX64wUtaZxkyCaQLWwSqUMFm0hMAvlxsSls8vlTHQrWU6eJyJhjHWo88T1rzcpr3DNnraheVz+4BzyYuT1dMWao3pjuxiSFx5zJoGtEgmzrh3hHTMhOAxIla4bIkO26ZaDcOA/UFXQKmMvRERdMnqKUbbrDEOb+lR96wFtcg7u5xAo9QXYJKLFAWwKtF3eQ16vLJmpdLrRejp4hO035uqqJidPGJHDPhRDf8GqiQs+4FcyH55Qxt5R+FzL4KMTfMBw7IT5HU8ifnksMjFCvk3T9RLiJafbcc6rA8Hx6YmZ8Tn0XS11UWpl8Y3gqIf7gC0oGpax0xPBUQjz3BZsaHAON/g9OcOOowdRRg6mjBlNHDaaOGkwdNZg6ajB11GDqqMHUyYS9/Rz+ne0C8qZPX0g72QU8dTMGCTeMjsHUUYOKoihKgKjfbJP9pGuJ69hlWRbtPeQd4mIMtv541VEh4otWnehT5xcklUnYmJ5DsgAAAABJRU5ErkJggg=="

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAyCAYAAAAJHRh4AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD/SURBVHgB7dnRDYJAEATQxVgAHUgHUoIdaAfSgbEDSrAD6EDsADvQCrQEOjiH+KXhkvNDwhzzks2Zy304ibcuwUxk0hLnXIr1jMpRqcWjRh37gBU+FBantg/oLF5d7AFtYZFbevZvqItx2dq7UX5ywyojg+9cDwWJ/ieqgOwUkJ0CslNAdr5RLcMQUBiX1dCmnibYKSC72XbRK6o0LgfU7nvTF/CRJElrRHx/a7qD7BSQnQKyU0B2sx3VRoUpZINlH3j8jinrFHh2GgEhs/CXsC0qOKDuIDs1mZF0qOcPZ4NNIiC6YoOlsT/QHWSngOx8TSbH+FQal/XQpt5NsHsBLOZljaXkxScAAAAASUVORK5CYII="

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(122);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Dropdown"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["DropdownMenu"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["DropdownItem"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Switch"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "main-header",
  data: function data() {
    return {
      activeModel: false,
      activeIndex: "2",
      notifications: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["isHome", "getTheme", "getUserSession", "themeList", "getUserNotifications"])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setAccess", "setUserSession", "setDrawerMode", "setTheme"]), {
    toggleTheme: function toggleTheme(status) {
      // console.log(this.themeList[status?'dark':'light']);
      this.setTheme(this.themeList[status ? "dark" : "light"]);
    },
    logout: function logout() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.post("/users/logout", {}).then(function (response) {
        container.setUserSession(null);
        setTimeout(function () {
          // container.$router.push({ path: "/auth/login" });\
          window.location.reload();
        }, 300);
      }).catch(function (e) {
        container.setUserSession(null);
        setTimeout(function () {
          window.location.reload();
        }, 300);
      });
    },
    login: function login() {
      this.$router.push({
        path: "/auth/login"
      });
    },
    navigateToNotifications: function navigateToNotifications() {
      __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({ name: "notifications" });
    },
    getNotificationsCount: function getNotificationsCount() {
      if (!this.getUserNotifications) return 0;
      return this.getUserNotifications.filter(function (item) {
        return item.read != true;
      }).length;
    }
  }),
  mounted: function mounted() {
    // this.setUserSession(null)
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyLoader__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyFormInput__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(122);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import axios from "axios";





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "register",
  components: {
    ArnergyLoader: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyLoader__["a" /* default */],
    ArnergyFormInput: __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyFormInput__["a" /* default */]
  },
  data: function data() {
    return {
      bgColor: "../../assets/img/bg-image.jpg",
      regParams: {
        firstname: null,
        lastname: null,
        phonenumber: null,
        username: null,
        email: null,
        password: null,
        cpassword: null
      },
      customerEmail: "",
      slider: "slider1",
      sliderCount: 1,
      mailSent: false,
      formErrors: [],
      loader: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["setUserSession", "setAccess"]), {
    validateReg: function validateReg() {
      var formErrors = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "firstname":
              if (value === "null" || value === "") {
                formErrors[field] = "firstname cannot be empty.";
              }
              break;
            case "lastname":
              if (value === "null" || value === "") {
                formErrors[field] = "lastname cannot be empty.";
              }
              break;
            case "email":
              if (value === "null" || value === "") {
                formErrors[field] = "Email cannot be empty.";
              } else if (!this.isEmail(value)) {
                formErrors[field] = "Not a valid email.";
              }
              break;
            case "cemail":
              if (value !== "null" || value !== "") {
                if (value !== this.regParams.email) {
                  formErrors[field] = "Emails did not match.";
                }
              }
              break;
            case "password":
              if (value === "null" || value === "") {
                formErrors[field] = "Password cannot be empty.";
              }
              break;
            case "cpassword":
              if (value !== "null" || value !== "") {
                if (value !== this.regParams.password) {
                  formErrors[field] = "Password did not match.";
                }
              }
              break;
            case "phonenumber":
              if (value === "null" || value === "") {
                formErrors[field] = "Phone cannot be empty.";
              }
              break;
            case "customerType":
              if (value === "null" || value === "") {
                formErrors[field] = "Please select a Customer type.";
              }
              break;
            case "businessAddress":
              if (this.regParams.customerType == "Corporate" && (value === "null" || value === "")) {
                formErrors[field] = "Business Address cannot be empty.";
              }
              break;
            case "businessName":
              if (this.regParams.customerType == "Corporate" && (value === "null" || value === "")) {
                formErrors[field] = "Business Name cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    submitForm: function submitForm(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, str, tempReg, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                _this.formErrors = _this.validateReg();

                if (!(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(_this.formErrors).length > 0)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                data = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, _this.regParams, {
                  roletype: _this.regParams.customerType,
                  dateofbirth: new Date(),
                  wallet: 0,
                  realm: "",
                  username: _this.regParams.email,
                  ccemails: _this.regParams.email
                });
                str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(data);
                tempReg = JSON.parse(str);


                console.log(tempReg);

                HTTP = _this.$httpUtils.FASTHTTP;
                _context.prev = 9;

                _this.loader = true;
                _context.next = 13;
                return HTTP.post("/auth/register-otp", tempReg).then(function (res) {
                  console.log(res);
                  if (res.data) {
                    _this.loader = false;
                    _this.mailSent = true;
                    _this.customerEmail = _this.regParams.email;
                    _this.regParams = {};
                    _this.$router.push({ name: "EmailVerified", params: res.data });
                  }
                }).catch(function (error) {
                  // let { response } = error;
                  var message = error.response.data.detail;
                  _this.showErrorMsg({ message: message });
                  _this.loader = false;
                });

              case 13:
                res = _context.sent;
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](9);

                _this.errorMessage = "Something went wrong, please try again.";
                _this.showErrorMsg({ message: _this.errorMessage });
                _this.loader = false;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[9, 16]]);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    setInterval(function () {
      _this2.slider = "slider" + _this2.sliderCount;
      if (_this2.sliderCount === 3) _this2.sliderCount = 1;else _this2.sliderCount++;
    }, 3000);
  }
});

/***/ }),
/* 854 */,
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergyLoader"
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyFormInput_vue__ = __webpack_require__(857);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483219c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyFormInput_vue__ = __webpack_require__(2017);
function injectStyle (ssrContext) {
  __webpack_require__(2016)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-483219c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArnergyFormInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_483219c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArnergyFormInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergyFormInput",
  computed: {
    computedErrors: function computedErrors() {
      return typeof this.errorMessages === "string" ? [this.errorMessages] : this.errorMessages;
    },
    computedClasses: function computedClasses() {
      return {
        "material--active": this.focus,
        "material--disabled": this.disabled,
        "material--has-errors": Boolean(!this.valid || this.errorMessages && this.errorMessages.length),
        "material--raised": Boolean(this.focus || this.valueCopy || // has value
        this.placeholder && !this.valueCopy) // has placeholder
      };
    }
  },
  data: function data() {
    return {
      valueCopy: null,
      focus: false,
      valid: true
    };
  },
  beforeMount: function beforeMount() {
    // Here we are following the Vue2 convention on custom v-model:
    // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
    this.copyValue(this.value);
  },

  methods: {
    handleModelInput: function handleModelInput(event) {
      this.$emit("input", event.target.value, event);
      this.handleValidation();
    },
    handleFocus: function handleFocus(focused) {
      this.focus = focused;
    },
    handleValidation: function handleValidation() {
      this.valid = this.$el ? this.$el.querySelector(".material-input").validity.valid : this.valid;
    },
    copyValue: function copyValue(value) {
      this.valueCopy = value;
      this.handleValidation();
    }
  },
  watch: {
    value: function value(newValue) {
      // This watch works from the code side of the 2-way-binding:
      this.copyValue(newValue);
    }
  },
  props: {
    id: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    step: {
      type: Number,
      default: null
    },
    minlength: {
      type: Number,
      default: null
    },
    maxlength: {
      type: Number,
      default: null
    },
    required: {
      type: Boolean,
      default: true
    },
    autocomplete: {
      type: String,
      default: null
    },
    errorMessages: {
      type: [Array, String],
      default: null
    }
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyLoader__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyFormInput__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(122);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import axios from "axios";





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "login",
  components: {
    ArnergyLoader: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyLoader__["a" /* default */],
    ArnergyFormInput: __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyFormInput__["a" /* default */]
  },
  data: function data() {
    return {
      bgColor: "../../assets/img/bg-image.jpg",
      loginParams: {
        email: null,
        password: null
      },
      slider: "slider1",
      sliderCount: 1,
      errors: {},
      loader: false,
      loginErrors: {},
      displayError: false,
      errorMessage: ""
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["setUserSession", "setAccess"]), {
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    setCurrent: function setCurrent(user) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var payloadData, HTTP, response, str, tempLogin, _HTTP, container, _response, _tempLogin, _HTTP2, _container;

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("This is something else", user);
                payloadData = {
                  customerid: user.id,
                  stateid: 0,
                  iscompleted: false
                };
                HTTP = _this.$httpUtils.FASTHTTP;
                _context3.prev = 3;
                _context3.next = 6;
                return HTTP.get("/onboardingstate/state");

              case 6:
                response = _context3.sent;

                if (!(response.data.iscompleted || response.data.value && user.roletype !== "customer")) {
                  _context3.next = 15;
                  break;
                }

                str = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(_this.loginParams);
                tempLogin = JSON.parse(str);
                _HTTP = _this.$httpUtils.instance;
                container = _this;

                if (tempLogin) {
                  _this.loader = true;

                  // ==================================
                  _HTTP.post("/users/login", tempLogin).then(function (response) {
                    var tkn = response.data.id;
                    _this.loader = false;

                    _HTTP.defaults.headers.common["Authorization"] = tkn;
                    localStorage.setItem("appUserToken", tkn);

                    _HTTP.get("/users/" + response.data.userId + ("/?filter[include][role_mappings]/?" + Date.now()), {}).then(function () {
                      var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee(userResponse) {
                        var saveRole;
                        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                          while (1) {
                            switch (_context.prev = _context.next) {
                              case 0:
                                _this.loader = false;
                                localStorage.firstName = userResponse.data.firstName;
                                localStorage.lastName = userResponse.data.lastName;
                                localStorage.customerId = userResponse.data.id;
                                localStorage.phoneNumber = userResponse.data.phoneNumber;
                                localStorage.email = userResponse.data.email;
                                localStorage.roleType = userResponse.data.roleType;
                                localStorage.userToken = userResponse.data.id;
                                _this.$store.state.loggedinUserRole = userResponse.data.roleType;

                                saveRole = [{
                                  subject: userResponse.data.roleType,
                                  actions: "all"
                                }];

                                userResponse.data.token = tkn;
                                userResponse.data.roleType = saveRole;
                                _this.setAccessLocal(userResponse.data);

                              case 13:
                              case "end":
                                return _context.stop();
                            }
                          }
                        }, _callee, _this);
                      }));

                      return function (_x) {
                        return _ref.apply(this, arguments);
                      };
                    }());
                  }).catch(function (error) {
                    console.log("error", error);
                    _this.loader = false;
                    _this.showErrorMsg({
                      message: error.response.data.error.message
                    });
                  });
                } else {
                  _this.loader = false;
                }
                // this.setAccessLocal(user);
                _context3.next = 47;
                break;

              case 15:
                if (!(response.data.stateid == 0 || user.roletype === "customer")) {
                  _context3.next = 30;
                  break;
                }

                if (!response.data.value) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 19;
                return HTTP.post("/onboardingstate/state", payloadData);

              case 19:
                _response = _context3.sent;
                _context3.next = 22;
                return _this.setAccessLocalOnboarding(_response.data, user);

              case 22:
                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/onboarding");
                _context3.next = 28;
                break;

              case 25:
                _context3.next = 27;
                return _this.setAccessLocalOnboarding(response.data, user);

              case 27:
                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/onboarding");

              case 28:
                _context3.next = 47;
                break;

              case 30:
                if (!(response.data.packagetype == "LO")) {
                  _context3.next = 36;
                  break;
                }

                _context3.next = 33;
                return _this.setAccessLocalOnboarding(response.data, user);

              case 33:
                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/onboarding/lo");
                _context3.next = 47;
                break;

              case 36:
                if (!(response.data.packagetype == "OS")) {
                  _context3.next = 42;
                  break;
                }

                _context3.next = 39;
                return _this.setAccessLocalOnboarding(response.data, user);

              case 39:
                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/onboarding/os");
                _context3.next = 47;
                break;

              case 42:
                str = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(_this.loginParams);
                _tempLogin = JSON.parse(str);
                _HTTP2 = _this.$httpUtils.instance;
                _container = _this;

                if (_tempLogin) {
                  _this.loader = true;

                  // ==================================
                  _HTTP2.post("/users/login", _tempLogin).then(function (response) {
                    var tkn = response.data.id;
                    _this.loader = false;

                    _HTTP2.defaults.headers.common["Authorization"] = tkn;
                    localStorage.setItem("appUserToken", tkn);

                    _HTTP2.get("/users/" + response.data.userId + ("/?filter[include][role_mappings]/?" + Date.now()), {}).then(function () {
                      var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2(userResponse) {
                        var saveRole;
                        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                _this.loader = false;
                                localStorage.firstName = userResponse.data.firstName;
                                localStorage.lastName = userResponse.data.lastName;
                                localStorage.customerId = userResponse.data.id;
                                localStorage.phoneNumber = userResponse.data.phoneNumber;
                                localStorage.email = userResponse.data.email;
                                localStorage.roleType = userResponse.data.roleType;
                                localStorage.userToken = userResponse.data.id;
                                _this.$store.state.loggedinUserRole = userResponse.data.roleType;

                                saveRole = [{
                                  subject: userResponse.data.roleType,
                                  actions: "all"
                                }];

                                userResponse.data.token = tkn;
                                userResponse.data.roleType = saveRole;
                                _this.setAccessLocal(userResponse.data);

                              case 13:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2, _this);
                      }));

                      return function (_x2) {
                        return _ref2.apply(this, arguments);
                      };
                    }());
                  }).catch(function (error) {
                    console.log("error", error);
                    _this.loader = false;
                    _this.showErrorMsg({
                      message: error.response.data.error.message
                    });
                  });
                } else {
                  _this.loader = false;
                }

                // this.setAccessLocal(user);

              case 47:
                _context3.next = 53;
                break;

              case 49:
                _context3.prev = 49;
                _context3.t0 = _context3["catch"](3);

                console.log({ error: _context3.t0 });
                _this.setAccessLocalCaseState(user);

              case 53:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[3, 49]]);
      }))();
    },
    validateLogin: function validateLogin() {
      var err = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.loginParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref3 = _step.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var field = _ref4[0];
          var value = _ref4[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "email":
              if (value === "null" || value === "") {
                err[field] = "Email cannot be empty.";
              }
              break;
            case "password":
              if (value === "null" || value === "") {
                err[field] = "Password cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
    },
    submitLogin: function submitLogin(e) {
      var _this2 = this;

      e.preventDefault();
      this.validateLogin();
      var errorLength = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.errors).length;

      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this2.displayError = false;
        }, 3000);
        this.showErrorMsg({
          message: this.errorMessage
        });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(this.loginParams);
        var tempLogin = JSON.parse(str);
        var HTTP = this.$httpUtils.FASTHTTP;
        var container = this;
        if (tempLogin) {
          this.loader = true;

          // ==================================
          HTTP.post("/auth/login", tempLogin).then(function (response) {
            console.log(response);
            var tkn = response.data.access_token;
            console.log(tkn);
            _this2.loader = false;

            HTTP.defaults.headers.common["Authorization"] = "Bearer " + tkn;
            localStorage.setItem("appUserToken", tkn);

            // localStorage.firstName = response.data.User.firstname;
            // localStorage.lastName = response.data.User.lastname;
            // localStorage.customerId = response.data.User.id;
            // localStorage.phoneNumber = response.data.User.phonenumber;
            // localStorage.email = response.data.User.email;
            // localStorage.roleType = response.data.User.roletype;
            // localStorage.userToken = response.data.access_token;
            // this.$store.state.loggedinUserRole =
            //       userResponse.data.roleType;

            // var saveRole = [
            //   {
            //     subject: response.data.roletype,
            //     actions: "all"
            //   }
            // ];
            // response.data.User.token = tkn;
            // response.data.User.roleType = saveRole;
            // const fullUsr = response.data.User;
            // this.setCurrent(fullUsr);

            HTTP.get("/auth/user").then(function () {
              var _ref5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4(userResponse) {
                var saveRole;
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        console.log("User Response..", userResponse);
                        _this2.loader = false;
                        localStorage.firstName = userResponse.data.firstname;
                        localStorage.lastName = userResponse.data.lastname;
                        localStorage.customerId = userResponse.data.id;
                        localStorage.phoneNumber = userResponse.data.phonenumber;
                        localStorage.email = userResponse.data.email;
                        localStorage.roleType = userResponse.data.roletype;
                        localStorage.userToken = userResponse.data.access_token;
                        _this2.$store.state.loggedinUserRole = userResponse.data.roletype;

                        saveRole = [{
                          subject: userResponse.data.roletype,
                          actions: "all"
                        }];

                        userResponse.data.token = tkn;
                        userResponse.data.roleType = saveRole;
                        _context4.next = 15;
                        return _this2.setCurrent(userResponse.data);

                      case 15:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, _this2);
              }));

              return function (_x3) {
                return _ref5.apply(this, arguments);
              };
            }());
          }).catch(function (error) {
            console.log("error", error);
            _this2.loader = false;
            if (error.response && error.response.data && error.response.data.detail) {
              var errorMessage = error.response.data.detail;
              _this2.showErrorMsg({
                message: errorMessage
              });
            } else {
              _this2.showErrorMsg({
                message: "An error occurred."
              });
            }
          });
        } else {
          this.loader = false;
        }
        // =========================
      }
    },
    setAccessLocal: function setAccessLocal(userSession) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this3.setUserSession(userSession);

              case 2:
                _context5.next = 4;
                return _this3.$ability.update(userSession.roleType);

              case 4:
                __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/");

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this3);
      }))();
    },
    setAccessLocalOnboarding: function setAccessLocalOnboarding(onboardingLastState, userSession) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this4.setUserSession(userSession);

              case 2:
                // await this.$ability.update(userSession.roleType);
                // window.location.href = "/onboarding";
                // router.push("/onboarding");
                // router.push("/os/agreement");
                //await this.$ability.update(userSession.roleType);
                _this4.$store.commit("saveOnboardingCustomerState", onboardingLastState);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this4);
      }))();
    },
    setAccessLocalCaseState: function setAccessLocalCaseState(userSession) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this5.setUserSession(userSession);

              case 2:
                _context7.next = 4;
                return _this5.$ability.update(userSession.roleType);

              case 4:
                _context7.next = 6;
                return __WEBPACK_IMPORTED_MODULE_12__router__["a" /* default */].push("/");

              case 6:
                window.location.reload();

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this5);
      }))();
    }
  }),
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserSession"])),
  mounted: function mounted() {
    var _this6 = this;

    setInterval(function () {
      _this6.slider = "slider" + _this6.sliderCount;
      if (_this6.sliderCount === 3) _this6.sliderCount = 1;else _this6.sliderCount++;
    }, 3000);
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "error_page",
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setAccess"]), {
    logout: function logout() {
      var _this = this;

      this.setAccess("anon");
      this.access = "anon";
      setTimeout(function () {
        _this.$router.push({ path: "/auth/login" });
      }, 700);
    },
    login: function login() {
      this.$router.push({ path: "/auth/login" });
    }
  })
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "register",
  data: function data() {
    return {
      regSuccess: false,
      cpassword: null,
      regParams: {
        newPassword: null,
        accessToken: null,
        userId: null
      },
      errors: {},
      displayError: false,
      errorMessage: ""
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "newPassword":
              if (value === "null" || value === "") {
                errors[field] = "Password cannot be empty.";
              } else if (value !== this.cpassword) {
                errors[field] = "Password did not match.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
    },
    submitRequest: function submitRequest() {
      var _this = this;

      this.validateReg();
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({ message: errorMsg });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var url = "/users/update-password-from-token";
        HTTP.post(url + "?access_token=" + this.$route.params.token, tempReg).then(function (response) {
          container.regSuccess = true;
        }).catch(function (error) {
          var errorMsg = error.response.data.error.message;
          _this.showErrorMsg({ message: errorMsg });
        });
      }
    }
  },
  mounted: function mounted() {
    this.regParams.userId = this.$route.params.uid;
    // this.regParams.accessToken = this.$route.params.token;
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__router__ = __webpack_require__(122);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "forgot-password",
  data: function data() {
    return {
      bgColor: '../../assets/img/bg-image.jpg',
      regSuccess: false,
      regParams: {
        email: null,
        base_url: window.location.origin + "/auth/new-password"
      },
      slider: 'slider1',
      sliderCount: 1,
      errors: {},
      loader: false,
      displayError: false,
      errorMessage: ""
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          switch (field) {
            case "email":
              if (value === "null" || value === "") {
                errors[field] = "Email cannot be empty.";
              } else if (!this.isEmail(value)) {
                errors[field] = "Not a valid email.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
    },
    submitRequest: function submitRequest(e) {
      var _this = this;

      e.preventDefault();
      var errorLength = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.errors).length;
      var container = this;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");

        this.showErrorMsg({ message: errorMsg });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var url = "/users/reset";
        HTTP.post(url, tempReg).then(function (response) {
          container.regSuccess = true;
        }).catch(function (error) {
          var errorMsg = error.response.data.error.message;
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
          _this.showErrorMsg({ message: errorMsg });
        });
      }
    },
    goToLogin: function goToLogin(e) {
      e.preventDefault();
      __WEBPACK_IMPORTED_MODULE_6__router__["a" /* default */].push("/auth/login");
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "register",
  data: function data() {
    return {
      regSuccess: false,
      shouldNotBeHere: false,
      cpassword: null,
      regParams: {
        accessToken: null,
        userId: null
      },
      errors: {},
      displayError: false,
      errorMessage: ""
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "newPassword":
              if (value === "null" || value === "") {
                errors[field] = "Password cannot be empty.";
              } else if (value !== this.cpassword) {
                errors[field] = "Password did not match.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
    },
    submitRequest: function submitRequest(userId, token) {
      var _this = this;

      this.validateReg();
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({ message: errorMsg });
      } else {
        this.regParams.userId = userId;
        this.regParams.accessToken = token;
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var url = "/users/confirm-email-from-token";
        HTTP.post(url + "?access_token=" + token, tempReg).then(function (response) {
          container.regSuccess = true;
        }).catch(function (error) {
          container.regSuccess;
          var errorMsg = error.response.data.error.message;
          _this.showErrorMsg({ message: errorMsg });
        });
      }
    }
  },
  mounted: function mounted() {
    console.log(this.$route.params.uid);
    console.log(this.$route.params.token);

    if (!this.$route.params.uid || !this.$route.params.token) {
      this.shouldNotBeHere = true;
      console.log(this.shouldNotBeHere);
    } else {
      // if(window.location.search != ""){
      //   let src = new URLSearchParams(window.location.search).get(src);
      //   if()
      // }
      this.submitRequest(this.$route.params.uid, this.$route.params.token);
    }
    // this.regParams.accessToken = this.$route.params.token;
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_autocomplete__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ItemTemplate_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_payform__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_payform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_payform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(7);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_autocomplete___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "generate-token",
  components: {},
  data: function data() {
    return {
      deviceVerified: false,
      tokenGenerated: false,
      carddetail: false,
      initAmt: 0.0,
      reciever: {
        name: null,
        phone: null,
        email: null
      },
      formData: {
        item: null,
        duration: 0,
        cardno: null,
        cvv: null,
        expiry: null,
        expirymonth: "00",
        expiryyear: "00",
        pin: null,
        email: null,
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 0.0,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      otp: "",
      transactionReference: null,
      currentDevice: null,
      subscriptionPlan: null,
      myResponse: { token: null, expiry: null },
      options: [{ value: null, text: "Please select an option", disabled: true }, { value: 3, text: "3 days" }, { value: 7, text: "7 days" }, { value: 15, text: "15 days" }, { value: 30, text: "30 days" }],
      countries: [{ value: null, text: "Please select an option", disabled: true }, { value: "NG", text: "Nigeria" }],
      currency: [{ value: null, text: "Please select an option", disabled: true }, { value: "NGN", text: "Naria" }],
      items: [],
      errors: null,
      template: __WEBPACK_IMPORTED_MODULE_10__utils_ItemTemplate_vue__["a" /* default */]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    // validateFormData() {
    //   confirm
    //   if(this.tokenGenerated==true){
    //     console.log('me 1')
    //     return true;
    //   }else if (
    //     this.formData.duration == null ||
    //     this.formData.item.solarKitIds === null
    //   ) {
    //     let errTemp = "Please fill all required fields.";
    //     this.showErrorMsg({ message: errTemp });
    //      console.log('me 2')
    //     return false;
    //   } else if (
    //     this.formData.duration * this.initAmt <=
    //     this.getUserSession.wallet
    //   ) {
    //      console.log('me 3')
    //     return this.generateToken(this.formData);
    //   } else if (this.carddetail === true) {
    //     this.concludeTransaction();
    //   } else {
    //      console.log('me 4')
    //     if (
    //       this.formData.duration * this.initAmt >
    //       this.getUserSession.wallet
    //     ) {
    //        console.log('me 5')
    //       this.confirmPayment();
    //     }
    //   }
    // },
    generateToken: function generateToken(data) {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var param = { solarKitId: data.item.solarKitIds, value: data.duration };
      var str = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(param);
      var tempReg = JSON.parse(str);
      var url = "/tokens/webAPI/";
      var element = document.getElementsByClassName("wizard-nav-pills");
      HTTP.post(url, tempReg).then(function (response) {
        _this.tokenGenerated = true;
        var d = new Date();
        var expiry = new Date(d.setDate(d.getDate() + data.duration)).toDateString();
        _this.myResponse = response.data.solarKitId !== undefined ? response.data : { solarKitId: data.item.solarKitIds, token: null, expiry: expiry };
        // element.classList.add('set-disabled')
        return true;
      }).catch(function (error) {
        console.log("error", error);
        _this.showErrorMsg({
          message: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(error.response.data.error.message)
        });
        _this.tokenGenerated = false;
        return false;
      });
      // element.classList.add('set-disabled')
      return true;
    },
    concludeTransaction: function concludeTransaction() {
      var _this2 = this;

      var b = this.getUserSession.wallet - this.initAmt * this.formData.duration;
      if (b >= 0) {
        return this.generateToken(this.formData);
      }

      var formParam = {
        transactionReference: this.transactionReference,
        otp: this.otp
      };
      var data = true;
      if (this.carddetail == false) {
        this.confirmPayment();
        return false;
      }
      this.validateReg(formParam);
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this2.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        this.showErrorMsg({ message: errorMsg });
        return false;
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(formParam);
        var tempReg = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var url = "/payments/raveCardValidate/";
        HTTP.post(url, tempReg).then(function (response) {
          data = _this2.generateToken(_this2.formData);
        }).catch(function (error) {
          console.log(error);
          // var errorMsg = error.response.message;
          _this2.showErrorMsg({ message: "Transaction not successful" });
          return false;
        });
      }
      return data;
    },
    confirmPayment: function confirmPayment() {
      var _this3 = this;

      this.validateReg(this.formData);
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this3.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        this.showErrorMsg({ message: errorMsg });
      } else {
        var _container$formData$e = container.formData.expiry.split(" / ");

        var _container$formData$e2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_container$formData$e, 2);

        container.formData.expirymonth = _container$formData$e2[0];
        container.formData.expiryyear = _container$formData$e2[1];

        var _container$formData$n = container.formData.name.split(" ");

        var _container$formData$n2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_container$formData$n, 2);

        container.formData.firstname = _container$formData$n2[0];
        container.formData.lastname = _container$formData$n2[1];

        container.formData.deviceFingerprint = container.formData.device_fingerprint.result;
        container.formData.cardno = container.formData.cardno.replace(new RegExp(" ", "g"), "");
        container.formData.amount = "" + (container.initAmt * container.formData.duration - this.getUserSession.wallet);
        var str = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(container.formData);
        var tempReg = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var url = "/payments/raveCardCharge/";
        HTTP.post(url, tempReg).then(function (response) {
          _this3.transactionReference = response.data;
          _this3.carddetail = true;
        }).catch(function (error) {
          var messages = error.message;
          _this3.showErrorMsg({ message: messages });
        });
      }
    },
    finishGeneration: function finishGeneration() {
      this.$router.push({ path: "/home" });
    },
    checkValidation: function checkValidation() {
      var _this4 = this;

      if (this.deviceVerified === false) {
        alert("Please verify device.");
        return false;
      } else {
        this.updateSubType();
        var fp = __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2___default()();
        fp.get(function (result, components) {
          _this4.formData.device_fingerprint.result = result; // a hash, representing your device fingerprint
          _this4.formData.device_fingerprint.components = components; // an array of FP components
          console.log(_this4.formData.device_fingerprint);
        });
        this.deviceVerified == true;
        return true;
      }
    },
    updateSubType: function updateSubType() {
      var _this5 = this;

      console.log(this.formData.item.deviceType.id);
      var name = this.subscriptionPlan.filter(function (x) {
        return x.deviceTypeId == _this5.formData.item.deviceType.id;
      });
      this.initAmt = name[0].amount / name[0].value;
    },
    validateReg: function validateReg(data) {
      var err = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          if (value === "null" || value === "") {
            err[field] = "Please select a " + field + ".";
          } else if (field == "email" && !this.isEmail(value)) {
            err[field] = "Not a valid email.";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
      // console.log(this.errors);
    },
    cardValidate: function cardValidate() {
      var cardNumber = document.getElementById("ccnum");
      var cardNumberField = document.getElementById("cardno-field");
      var mastercard = document.getElementById("mastercard");
      var visa = document.getElementById("visa");
      var amex = document.getElementById("amex");

      amex.classList.add("transparent");
      visa.classList.add("transparent");
      mastercard.classList.add("transparent");

      if (__WEBPACK_IMPORTED_MODULE_12_payform___default.a.validateCardNumber(cardNumber.value) == false) {
        cardNumberField.classList.add("has-error");
      } else {
        cardNumberField.classList.remove("has-error");
        cardNumberField.classList.add("has-success");
      }
      var b = __WEBPACK_IMPORTED_MODULE_12_payform___default.a.parseCardType(cardNumber.value);
      document.getElementById(b).classList.remove("transparent");
    },
    getLabel: function getLabel(item) {
      this.deviceVerified = true;
      return item.solarKitIds;
    },
    returnData: function returnData(data) {
      var int = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var rData = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(this.currentDevice), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var value = _step2.value;

          if ((value.name.toLowerCase().indexOf(data.toLowerCase()) > -1 || value.solarKitIds.indexOf(data) > -1 || value.userId === data) && int == 0) {
            rData.push(value);
          } else if (value.userId == data && int == 1) {
            document.getElementsByClassName("v-autocomplete-input").value = value.solarKitIds;
            rData.push(value);
          }
        }
        // this.formData.amount=this.subscriptionPlan
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return rData;
    },
    find_prop: function find_prop(obj, key) {
      var _this6 = this;

      return function () {
        var keyNest = key.split(".");
        if (_this6.currentDevice === null || obj === undefined) {
          return "-";
        } else if (keyNest.length > 1) {
          return _this6.find_prop(obj[keyNest.shift()], keyNest.join("."));
        } else {
          return obj[key];
        }
      }();
    },
    device_prop: function device_prop(key) {
      return this.find_prop(this.currentDevice, key);
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    updateItems: function updateItems(text, int) {
      this.items = this.returnData(text, int);
    },
    loader: function loader() {
      var _this7 = this;

      var int = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      var context = this;
      var HTTP = this.$httpUtils.instance;
      var inverterId = this.formData.inverter_number;
      var url = "/installations/?filter={\"where\":{\"status\":\"completed\"},\"include\":[\"deviceType\",\"user\"]}";
      if (this.$can("manage", "mine")) {
        url = "/installations/?filter={\"where\":{\"status\":\"completed\",\"userId\":" + this.getUserSession.id + "},\"include\":[\"deviceType\",\"user\"]}";
      }

      HTTP.get(url).then(function (response) {
        _this7.currentDevice = response.data;
        _this7.updateItems("" + _this7.getUserSession.id, int);
      });
      this.formData.name = this.getUserSession.firstName + " " + this.getUserSession.lastName;
      this.formData.phonenumber = "" + this.getUserSession.phoneNumber;
      this.formData.email = "" + this.getUserSession.email;

      __WEBPACK_IMPORTED_MODULE_12_payform___default.a.cardNumberInput(document.getElementById("ccnum"));
      __WEBPACK_IMPORTED_MODULE_12_payform___default.a.expiryInput(document.getElementById("expiry"));
      __WEBPACK_IMPORTED_MODULE_12_payform___default.a.cvcInput(document.getElementById("cvc"));
      __WEBPACK_IMPORTED_MODULE_12_payform___default.a.numericInput(document.getElementById("mobile"));
      __WEBPACK_IMPORTED_MODULE_12_payform___default.a.numericInput(document.getElementById("pin"));
    },
    getSubscriptionPlan: function getSubscriptionPlan() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/subscription_plans/";
      HTTP.get(url).then(function (response) {
        _this8.subscriptionPlan = response.data;
      });
      this.loader(1);
    },
    numberWithSpaces: function numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{4})+(?!\d))/g, " ");
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    }
  },
  mounted: function mounted() {
    if (!this.$can("create", "token")) {
      this.$router.push({ path: "/" });
      return;
    }
    this.getSubscriptionPlan();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])(["getUserSession"]))
});

/***/ }),
/* 864 */,
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemTemplate_vue__ = __webpack_require__(866);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822e60b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemTemplate_vue__ = __webpack_require__(2039);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_822e60b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: { required: true },
    searchText: { required: true }
  }
});

/***/ }),
/* 867 */,
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'generate-token',
  data: function data() {
    return {
      responseData: '',
      errors: '',
      componentName: '',
      columns: [{
        label: 'User',
        field: 'user',
        filterable: true
      }, {
        label: 'Token',
        field: 'token',
        filterable: true
      }, {
        label: 'Date',
        field: 'date',
        filterable: true
      }],
      rows: [{ user: "", token: '', date: '' }]
    };
  },

  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    }
  },
  computed: {},
  mounted: function mounted() {}
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_4_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   Inventory
  // },
  data: function data() {
    return {
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{ field: "id", label: "ID", sortable: "true" }, {
        field: "actualAmount",
        label: "Transaction Amount",
        sortable: "true"
      }, { field: "status", label: "Status", sortable: "true" }, {
        field: "transactionType",
        label: "Transaction Type",
        sortable: "true"
      }, { field: "createdAt", label: "Transaction Time", sortable: "true" }],
      usersLists: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: { title: "", content: "" }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["getUserById", "getDevices", "getUserSession"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  }),
  methods: {
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(row).join('<%>').toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(user) {
      this.$router.push({ name: this.details, params: { userId: user } });
      console.log(user);
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getHistory: function getHistory() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/transactionHistories?filter[where][userId]=" + this.getUserSession.id;
      if (this.$can("read", "all")) {
        url = "/transactionHistories";
        if (this.$route.params.userId) {
          url = "/transactionHistories?filter[where][userId]=" + this.$route.params.userId;
        }
      }
      var container = this;
      HTTP.get(url).then(function (response) {
        // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
        _this.usersLists = response.data;
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    this.getHistory();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-wallet",
  data: function data() {
    return {
      TranscResp: {},
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "User",
        field: "user",
        filterable: true
      }, {
        label: "Reference",
        field: "ref",
        filterable: true
      }, {
        label: "Date",
        field: "date",
        filterable: true
      }],
      rows: [{ user: "300283377", ref: "2012020321", date: "12/12/2015" }, { user: "305383177", ref: "2012020321", date: "12/01/1991" }]
    };
  },

  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    processResponse: function processResponse() {
      var RESPONSE = window.location.href;
      var splited = RESPONSE.split("/");
      var splited = splited[splited.length - 1];
      // console.log(splited);
      var respData = JSON.parse('{"' + decodeURI(splited.split("?")[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      respData.UserID = this.getUserSession.id;
      respData.status = splited.split("?")[0];
      var tempResult = {
        status: splited.split("?")[0],
        data: respData,
        UserID: this.getUserSession.id
      };
      this.TranscResp = tempResult;
      var transactionPayload = {
        transactionReference: tempResult.data.TransactionReference,
        orderId: tempResult.data.OrderID,
        status: tempResult.data.status
      };
      this.pushTransaction(transactionPayload);
    },
    pushTransaction: function pushTransaction(data) {
      var HTTP = this.$httpUtils.instance;
      var url = "/payments/fidelityPayGate";
      var container = this;
      HTTP.post(url, data).then(function (response) {
        // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession"])),
  mounted: function mounted() {
    this.processResponse();
    // console.log(window.location.href);
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ravepay_vue__ = __webpack_require__(872);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c678974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ravepay_vue__ = __webpack_require__(2054);
function injectStyle (ssrContext) {
  __webpack_require__(2053)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ravepay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c678974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ravepay_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_autocomplete__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_v_autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_v_autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ItemTemplate_vue__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_payform__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_payform___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_payform__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_querystring__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_querystring__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_v_autocomplete___default.a);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "generate-token",
  components: {
    Rave: __WEBPACK_IMPORTED_MODULE_13_vue_ravepayment___default.a
  },
  data: function data() {
    return {
      transComplete: false,
      transDone: false,
      cardno: null,
      cvv: null,
      expiry: null,
      pin: null,
      // raveKey: "FLWPUBK-1e55a9d76566528730de3cadb478beb9-X",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      raveBtnText: "Make Payment",
      formData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 10000,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      otp: "",
      currentDevice: null,
      myResponse: null,
      countries: [{
        value: null,
        text: "Please select an option",
        disabled: true
      }, {
        value: "NG",
        text: "Nigeria"
      }],
      currency: [{
        value: null,
        text: "Please select an option",
        disabled: true
      }, {
        value: "NGN",
        text: "Naria"
      }],
      items: [],
      errors: null,
      template: __WEBPACK_IMPORTED_MODULE_10__utils_ItemTemplate_vue__["a" /* default */]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    callback: function callback(response) {
      var trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      if (trRef.data.status === "successful") {
        this.transDone = true;
      } else this.showErrorMsg({
        message: "Transaction fails"
      });
      this.transComplete = this.concludeTransaction(trRef.data.txRef);
      this.close;
    },
    close: function close() {
      console.log("Payment closed");
    },
    concludeTransaction: function concludeTransaction(txRef) {
      var _this = this;

      var data = true;
      var str = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()({
        txref: txRef
      });
      var tempReg = JSON.parse(str);
      var HTTP = this.$httpUtils.instance;
      var url = "/payments/flutterwave/";
      HTTP.post(url, tempReg).then(function (response) {
        _this.myResponse = response.data.data[0];
        console.log(response.data.data[0]);
        data = true;
      }).catch(function (error) {
        console.log(error);
        var errorMsg = error.response.data.message;
        _this.showErrorMsg({
          message: errorMsg
        });
        data = false;
      });
      return data;
    },
    confirmPayment: function confirmPayment() {
      var _this2 = this;

      this.validateReg(this.formData);
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this2.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var fp = __WEBPACK_IMPORTED_MODULE_11_fingerprintjs2___default()();
        fp.get(function (result, components) {
          container.formData.deviceFingerprint = result; // a hash, representing your device fingerprint
          container.formData.device_fingerprint.components = components; // an array of FP components
        });

        var _container$formData$n = container.formData.name.split(" ");

        var _container$formData$n2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_container$formData$n, 2);

        container.formData.firstname = _container$formData$n2[0];
        container.formData.lastname = _container$formData$n2[1];

        document.getElementById("paymentbtn").click();
      }
    },
    finishGeneration: function finishGeneration() {
      this.$router.push({
        path: "/home"
      });
    },
    validateReg: function validateReg(data) {
      var err = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          if (value === "null" || value === "") {
            err[field] = "Please select a " + field + ".";
          } else if (field == "email" && !this.isEmail(value)) {
            err[field] = "Not a valid email.";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
      // console.log(this.errors);
    },
    loader: function loader() {
      this.formData.name = this.getUserSession.firstName + " " + this.getUserSession.lastName;
      this.formData.phonenumber = "" + this.getUserSession.phoneNumber;
      this.formData.email = "" + this.getUserSession.email;
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    updateItems: function updateItems(text) {
      this.items = this.returnData(text);
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    }
  },
  mounted: function mounted() {
    this.loader();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    reference: function reference() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  })
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_2__utils_Autocomplete__["a" /* default */]
  },
  data: function data() {
    return {
      searchKey: ['first_name', 'last_name'],
      displayKey: ['first_name', 'last_name'],
      currentUser: null,
      selectedName: '',
      selection: '',
      form: {
        email: '',
        name: '',
        food: null,
        checked: []
      },
      deviceParam: {
        battery_rating: null,
        inverter_capacity: null,
        inverter_number: null,
        kit_capacity: null,
        lga_id: null,
        number_of_batteries: null,
        number_of_panels: null,
        panel_rating: null,
        state_id: null,
        system_type_id: null,
        user_id: null
      },
      foods: [{
        text: 'Select One',
        value: null
      }, 'Monthly', 'Outright', 'Lease2Own'],
      type: [{
        text: 'Select One',
        value: null
      }, 'Arnergy 300', 'Arnergy 1000', 'Arnergy 2000', 'Arnergy 5000'],
      show: true,
      selectedState: null,
      selectedLga: null,
      stateOptions: [{ value: null, disabled: true, text: "Please select a state" }],
      lgaOptions: [{ value: null, disabled: true, text: "Please select LGA" }],
      systemTypeOptions: [{ value: null, disabled: true, text: "Please select a system type" }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getDummy', 'getDevices'])),
  methods: {
    onSubmit: function onSubmit() {
      this.deviceParam.kit_capacity = this.deviceParam.inverter_capacity;
      // console.log(JSON.stringify(this.deviceParam));
      var HTTP = this.$httpUtils.instance;
      var url = "/devices";
      var container = this;
      HTTP.post(url, this.deviceParam).then(function (response) {
        // console.log(response.data.data.);
        container.$router.push({ path: '/device/' + response.data.data.inverter_number });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    onSelected: function onSelected(obj) {
      this.currentUser = obj;
      this.deviceParam.user_id = obj.id;
      this.selectedName = this.currentUser.full_name + ' ' + this.currentUser.last_name;
      // console.log(JSON.stringify(obj));
    },
    onReset: function onReset(evt) {
      var _this = this;

      evt.preventDefault();
      /* Reset our form values */
      this.form.email = '';
      this.form.name = '';
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(function () {
        _this.show = true;
      });
    },
    beforeDeviceDetails: function beforeDeviceDetails() {
      if (this.deviceParam.user_id === null) {
        alert("Please select a user.");
        return false;
      } else {
        return true;
      }
    },
    fetchStates: function fetchStates() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this2.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/system-types";
      HTTP.get(url).then(function (response) {

        var systemTypes = response.data;
        systemTypes.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });

        systemTypes.unshift({
          value: null,
          disabled: true,
          text: "Please select a system type"
        });
        _this3.systemTypeOptions = systemTypes;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = '/states/' + state + '/lga';
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    }
  },
  mounted: function mounted() {
    this.fetchStates();
    this.fetchSysTypes();
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String
    },
    suggestions: {
      type: Array,
      required: true
    },
    keys: {
      type: Array,
      required: true
    },
    display: {
      type: Array,
      required: true
    },
    subtitle: {
      type: String
    },
    onSelected: {
      type: Function,
      required: true
    }
  },

  data: function data() {
    return {
      open: false,
      // valueComp: '',
      current: 0
    };
  },


  computed: {
    // valueComp() {
    //   return this.value;
    // },
    matches: function matches() {
      var _this = this;

      return this.suggestions.filter(function (obj) {
        return function () {
          var tempStat = false;
          var arrLen = _this.keys.length;
          for (var i = 0; i < arrLen; i++) {
            var haystack = obj[_this.keys[i]].toLowerCase();
            var needle = _this.value.toLowerCase();
            tempStat = haystack.indexOf(needle) >= 0;
            if (tempStat) {
              break;
            }
          }
          return tempStat;
        }();
      });
    },
    openSuggestion: function openSuggestion() {
      return this.selection !== "" && this.matches.length !== 0 && this.open === true;
    }
  },
  methods: {
    updateValue: function updateValue(value) {
      if (this.open === false) {
        this.open = true;
        this.current = 0;
      }
      this.$emit("input", value);
    },

    // When enter pressed on the input
    enter: function enter() {
      // this.$emit("input", .city);
      this.onSelected(this.matches[this.current]);
      this.valueComp = this.displayText(this.matches[this.current]);
      // this.$emit("input", );
      // this.displayText(this.current);
      this.open = false;
    },
    displayText: function displayText(suggestion) {
      var finalDisplay = '';
      this.display.map(function (key) {
        return finalDisplay += " " + suggestion[key];
      });
      return finalDisplay;
    },

    // When up pressed while suggestions are open
    up: function up() {
      if (this.current > 0) {
        this.current--;
      }
    },

    // When up pressed while suggestions are open
    down: function down() {
      if (this.current < this.matches.length - 1) {
        this.current++;
      }
    },

    // For highlighting element
    isActive: function isActive(index) {
      return index === this.current;
    },


    // When one of the suggestion is clicked
    suggestionClick: function suggestionClick(index) {
      // this.$emit("input", this.matches[index].city);
      // this.onSelected(this.matches[this.current])
      this.onSelected(this.matches[index]);
      this.valueComp = this.displayText(this.matches[index]);
      // this.$emit("input", this.displayText(this.current));
      this.open = false;
    }
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_9_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    //   Inventory
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_8_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_8_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_8_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_8_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_8_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_8_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      plans: ["OS", "LO", "ES"],
      deviceTypes: [],
      searchTerm: "",
      isLoadingVGT: true,
      editOffCanvas: false,
      openCompletionCanvas: false,
      isLoading: false,
      regDataParams: {
        name: name
      },
      completionDate: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [
      // {
      //   field: "id",
      //   label: "ID",
      //   sortable: "true"
      // },
      {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "devicetype",
        label: "Device Type",
        sortable: "true"
      }, {
        field: "cid",
        label: "Customer ID",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // {
      //   field: "email",
      //   label: "E-mail",
      //   sortable: "true"
      // },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "createdAt",
        label: "Date Created",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      getUsers: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      users: [],
      currentUserId: 0,
      systemTypeOptions: [],
      period: [],
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    fetchUser: function fetchUser(query) {
      if (query) {
        var ctx = this;
        var HTTP = this.$httpUtils.instance;
        var _name = query.toLowerCase();

        setTimeout(function () {
          HTTP.get("/users?filter={\"where\":{\"or\":[{ \"firstName\": {\"regexp\":\"/" + _name + "/i\"}},{ \"lastName\": {\"regexp\":\"/" + _name + "/i\"}}]}}").then(function (response) {
            ctx.users = response.data.filter(function (item) {
              if (item.firstName.toLowerCase().includes(query.toLowerCase())) {
                return item;
              }
              if (item.lastName.toLowerCase().includes(query.toLowerCase())) {
                return item;
              }
              if (item.email.toLowerCase().includes(query.toLowerCase())) {
                return item;
              }
            });
          }).catch(function (error) {
            console.log("error", error);
          });
        }, 200);
      } else {
        // return ctx.users;
      }
    },
    fetchSysTypes: function fetchSysTypes(query) {
      var _this = this;

      if (query) {
        setTimeout(function () {
          var HTTP = _this.$httpUtils.instance;
          var url = "/device_types";
          HTTP.get(url).then(function (response) {
            var systemTypes = response.data;
            systemTypes.filter(function (x) {
              x.value = x.id;
              x.text = x.name;
            });

            _this.systemTypeOptions = systemTypes.filter(function (item) {
              return item.name.toLowerCase().includes(query.toLowerCase());
            });
            console.log("hello", _this.systemTypeOptions);
          }).catch(function (error) {
            console.log("error", error);
          });
        });
      } else {
        return this.systemTypeOptions;
      }
    },
    onUpdateCompletion: function onUpdateCompletion() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      var _container$regDataPar = container.regDataParams,
          id = _container$regDataPar.id,
          completion_date = _container$regDataPar.completion_date,
          purchase_price = _container$regDataPar.purchase_price;


      if (!completion_date || !purchase_price) {
        this.showErrorMsg({
          message: "Please fill in all fields"
        });
        return;
      }
      var tempReg = {
        completion_date: completion_date,
        purchase_price: purchase_price
      };
      this.toggleIsLoading();
      var url = "/installations/" + id;

      HTTP.patch(url, tempReg).then(function (response) {
        _this2.toggleIsLoading();
        container.regSuccess = true;
        _this2.showSuccessMsg({
          message: "Completion details Updated!"
        });
        _this2.init();
        _this2.openCompletionCanvas = false;

        _this2.regDataParams = {
          name: ""
        };
        _this2.$router.push({ path: "/devices/all_devices" });
      }).catch(function (error) {
        _this2.toggleIsLoading();
        // console.log(error.response.data.error);
        if (error.response.data.error.details) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
            // console.log(index);
          });
          // console.log("error", errTemp);
          errTemp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          _this2.showErrorMsg({
            message: errTemp
          });
        } else {
          _this2.showErrorMsg({
            message: error.response.data.error.message
          });
        }
      });
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      var _container$regDataPar2 = container.regDataParams,
          name = _container$regDataPar2.name,
          id = _container$regDataPar2.id,
          deviceType = _container$regDataPar2.deviceType,
          userId = _container$regDataPar2.userId,
          deviceTypeId = _container$regDataPar2.deviceTypeId;


      var from = this.period[0] !== undefined ? this.period[0] : false;
      var to = this.period[1] !== undefined ? this.period[1] : false;

      if (name == "") {
        this.showErrorMsg({
          message: "Name Is required"
        });

        return;
      }
      var tempReg = {
        name: name,
        userId: userId,
        from: from,
        to: to,
        deviceTypeId: deviceTypeId
      };

      tempReg.userId = this.currentUserId;

      if (typeof tempReg.deviceTypeId === "string") {
        delete tempReg.deviceTypeId;
      }

      this.toggleIsLoading();
      var url = "/installations/" + id;
      var deviceRequestUrl = "/device_requests/" + deviceTypeId;

      HTTP.patch(deviceRequestUrl, { paymentModel: deviceType }).then(function (response) {
        _this3.editOffCanvas = false;
      }).catch(function (error) {});

      HTTP.patch(url, tempReg).then(function (response) {
        _this3.toggleIsLoading();
        container.regSuccess = true;
        _this3.showSuccessMsg({
          message: "Installation Updated!"
        });
        _this3.init();
        _this3.editOffCanvas = false;

        _this3.regDataParams = {
          name: ""
        };
        _this3.$router.push({ path: "/devices/all_devices" });
      }).catch(function (error) {
        _this3.toggleIsLoading();
        // console.log(error.response.data.error);
        if (error.response.data.error.details) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
            // console.log(index);
          });
          // console.log("error", errTemp);
          errTemp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          _this3.showErrorMsg({
            message: errTemp
          });
        } else {
          _this3.showErrorMsg({
            message: error.response.data.error.message
          });
        }
      });
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    toggleEditCanvas: function toggleEditCanvas(data) {
      this.currentUserId = data.user.id;
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, data, {
        userId: data.user.firstName + " " + data.user.lastName + " - (" + data.user.id + ")",
        deviceTypeId: data.deviceType.name,
        plans: data.plan || this.plans[0]
      });
      this.editOffCanvas = !this.editOffCanvas;
      this.period = [data.from, data.to];
      // console.log({ data });
    },
    toggleUpdateCanvas: function toggleUpdateCanvas(data) {
      this.regDataParams = data;
      this.openCompletionCanvas = !this.openCompletionCanvas;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "maintenance"
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init: function init() {
      var _this4 = this;

      var httpUtils = this.$httpUtils;
      var userId = this.getUserSession.id;
      var realm = this.getUserSession.realm;

      var url = "/installations?filter={\"where\":{\"and\": [{\"userId\":" + userId + "}, {\"or\":[{ \"status\": \"commissioned\"},{ \"status\": \"completed\"}]}]},\"include\":[\"deviceType\",\"user\",\"operationsEngineer\"]}";
      if (this.$can("manage", "customer")) url = "/installations?filter={\"where\":{\"realm\":{\"$regex\" :\"^" + realm + "\"}},\"include\":[\"deviceType\",\"user\",\"operationsEngineer\"]}";
      if (this.$can("read", "all")) url = "/installations?filter={\"include\":[\"deviceType\",\"user\",\"operationsEngineer\"]}";

      httpUtils.instance.get(url).then(function (response) {
        _this4.getUsers = response.data;
        _this4.isLoadingVGT = false;
      }).catch(function (error) {
        console.log(error);
        _this4.errors = "Error occured at our end!";
        _this4.getUsers = "";
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this5.init();

              // console.log(this.getDummy)

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }
});

/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_10_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_9_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      editOffCanvas: false,
      isLoading: false,
      regDataParams: {
        name: name
      },
      selectOption: {
        enabled: false
      },
      items: items,
      fields: [{
        field: "customerName",
        label: "Customer Name",
        sortable: "true",
        tdClass: 'text-center'
      }, {
        field: "deviceId",
        label: "Device Id",
        sortable: "true"
      }, {
        field: "expiryDate",
        label: "Local Expiry Date",
        sortable: "true"
      }, {
        field: "remoteExpiryDate",
        label: "Remote Expiry Date",
        sortable: "true"
      }, {
        field: "lastSyncTime",
        label: "Last Sync Time",
        sortable: "true"
      }, {
        field: "isShutdown",
        label: "Admin Power",
        sortable: "true",
        tdClass: 'text-center'
      }, {
        field: "syncStatus",
        label: "Sync Status",
        sortable: "true",
        tdClass: 'text-center'
      }, {
        field: "adminPower",
        label: "Device Status",
        sortable: "true",
        tdClass: 'text-center'
      }],
      getDevices: "",
      currentPage: 0,
      details: "UserDetails",
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [{
          field: '',
          type: ''
        }],
        perPage: 200,
        page: 1
      },
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    onSubmit: function onSubmit() {
      var _this = this;

      var ConfigurationHTTP = this.$httpUtils.NotificationHTTP;
      var container = this;
      var _container$regDataPar = container.regDataParams,
          deviceId = _container$regDataPar.deviceId,
          invoiceNumber = _container$regDataPar.invoiceNumber,
          newExpiryDate = _container$regDataPar.newExpiryDate;


      if (!invoiceNumber || !newExpiryDate) {
        this.showErrorMsg({
          message: "Fill in all fields"
        });

        return;
      };
      this.toggleIsLoading();
      var url = "/" + deviceId;
      ConfigurationHTTP.patch(url, { expiryDate: newExpiryDate }).then(function (_) {
        _this.toggleIsLoading();
        container.regSuccess = true;
        _this.showSuccessMsg({
          message: "Expiry Date Updated!"
        });
        _this.loadItems();
        _this.editOffCanvas = false;

        _this.regDataParams = {
          name: ""
        };
      }).catch(function (error) {
        _this.toggleIsLoading();
        if (error.response.data.error.details) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          _this.showErrorMsg({
            message: errTemp
          });
        } else {
          _this.showErrorMsg({
            message: error.response.data.error.message
          });
        }
      });
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    toggleEditCanvas: function toggleEditCanvas(data) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, data, { oldExpiryDate: data.expiryDate, newExpiryDate: __WEBPACK_IMPORTED_MODULE_10_moment___default()(data.expiryDate).add(1, 'month').format('YYYY-MM-DD') });
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "maintenance"
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init: function init() {
      var httpUtils = this.$httpUtils;
      var userId = this.getUserSession.id;
      var realm = this.getUserSession.realm;
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    loadItems: function loadItems() {
      var _this2 = this;

      var httpUtils = this.$httpUtils;
      httpUtils.NotificationHTTP.get("?pageIndex=" + this.serverParams.page + "&pageSize=" + this.serverParams.perPage).then(function (response) {
        _this2.getDevices = response.data.response.items;
        _this2.rows = response.data.response.items;
        _this2.totalRecords = response.data.response.count;
      }).catch(function (error) {
        _this2.errors = "Error occured at our end!";
        _this2.getDevices = "";
      });
    },
    adminPowerCast: function adminPowerCast(data) {
      if (typeof data === 'undefined' || data === null) {
        return "--";
      } else if (data.includes("1111")) {
        return "Device Online";
      } else if (data.includes("A")) {
        return "Admin Shut-Down";
      } else if (data.includes("B")) {
        return "Battery Low";
      } else if (data.includes("E")) {
        return "Expiry Date Shut-Down";
      } else if (data.includes("U")) {
        return "User Shut-Down";
      } else {
        return "--";
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.init();
              _this3.loadItems();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_7__utils_Autocomplete__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchKey: ["first_name", "last_name"],
      displayKey: ["first_name", "last_name"],
      currentUser: null,
      selectedName: "",
      selectedType: null,
      houseInstalation: "",
      selection: "",
      tncstatus: "",
      requestForm: {
        customerregtype: null,
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        roofComment: null,
        deviceTypeId: null,
        comment: null,
        customertnc: null
      },
      reqSuccess: false,
      binaryOptions: [{
        text: "Yes",
        value: "yes"
      }, {
        text: "No",
        value: "no"
      }],
      form: {
        email: "",
        name: "",
        food: null,
        checked: []
      },
      foods: [{
        text: "Select One",
        value: null
      }, "Monthly", "Outright", "Lease2Own"],
      type: [{
        text: "Desired Bundle Service",
        value: null,
        disabled: true
      }, {
        value: "Arnergy 300",
        text: "Arnergy 300"
      }, {
        value: "Arnergy 1000",
        text: "Arnergy 1000"
      }, {
        value: "Arnergy 2000",
        text: "Arnergy 2000"
      }, {
        value: "Arnergy 5000",
        text: "Arnergy 5000"
      }],
      show: true,
      selectedState: null,
      selectedLga: null,
      stateOptions: [{
        value: null,
        disabled: true,
        text: "Please select a state"
      }],
      lgaOptions: [{
        value: null,
        disabled: true,
        text: "Please select LGA"
      }],
      systemTypeOptions: [{
        value: null,
        disabled: true,
        text: "Desired Bundle Service"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    submitRequest: function submitRequest() {
      var _this = this;

      if (this.validateRequestForm() === true) {
        delete this.requestForm.customerregtype;
        delete this.requestForm.customertnc;
        this.requestForm.userId = this.getUserSession.id;
        var container = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/device_requests";
        HTTP.post(url, this.requestForm).then(function (response) {
          // console.log(JSON.stringify(response));
          container.reqSuccess = true;
        }).catch(function (error) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          _this.showErrorMsg({
            message: errTemp
          });
        });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    },
    onSelected: function onSelected(obj) {
      this.currentUser = obj;
      this.deviceParam.user_id = obj.id;
      this.selectedName = this.currentUser.full_name + " " + this.currentUser.last_name;
      // console.log(JSON.stringify(obj));
    },
    onReset: function onReset(evt) {
      var _this2 = this;

      evt.preventDefault();
      /* Reset our form values */
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(function () {
        _this2.show = true;
      });
    },
    beforeDeviceDetails: function beforeDeviceDetails() {
      if (this.deviceParam.user_id === null) {
        alert("Please select a user.");
        return false;
      } else {
        return true;
      }
    },
    fetchStates: function fetchStates() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this3.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types";
      HTTP.get(url).then(function (response) {
        var systemTypes = response.data;
        systemTypes.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });

        systemTypes.unshift({
          value: null,
          disabled: true,
          text: "Desired Bundle Service"
        });
        _this4.systemTypeOptions = systemTypes;
        // console.log(JSON.stringify(systemTypes));
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/states/" + state + "/lga";
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    }
  },
  mounted: function mounted() {
    // this.fetchStates();
    if (!this.$can('create', 'device')) {
      this.$router.push({ path: "/" });
      return;
    }
    this.fetchSysTypes();
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRequests_vue__ = __webpack_require__(884);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cfe4e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRequests_vue__ = __webpack_require__(2071);
function injectStyle (ssrContext) {
  __webpack_require__(2069)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageRequests_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25cfe4e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageRequests_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fs_web__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_fs_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_fs_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_raw_loader_templates_invoice_ejs__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import ejs from "ejs";





var dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [{
      quantity: 1,
      createdAt: "2019-07-02T12:28:34.267Z",
      updatedAt: "2019-07-02T12:28:34.267Z",
      id: 12,
      deviceTypeId: 3,
      componentId: 2,
      componentTypeId: null,
      componentType: {
        name: "inverter",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 2
      }
    }, {
      quantity: 2,
      createdAt: "2019-07-02T12:28:47.102Z",
      updatedAt: "2019-07-02T12:28:47.102Z",
      id: 13,
      deviceTypeId: 3,
      componentId: 1,
      componentTypeId: null,
      componentType: {
        name: "battery",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 1
      }
    }, {
      quantity: 15,
      createdAt: "2019-07-02T14:16:33.398Z",
      updatedAt: "2019-07-02T14:16:33.398Z",
      id: 16,
      deviceTypeId: 3,
      componentId: 3,
      componentTypeId: null,
      componentType: {
        name: "solar panels",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 3
      }
    }]
  },
  selectedRequest: null
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-requests",
  data: function data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "System Capacity",
        field: "system.capacity",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }],
      deviceRequests: [],
      rows: []
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_7_element_ui__["Dialog"]
  },
  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo: function navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    fetchInvoice: function fetchInvoice(rowData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, user, packageConfig, packageType, html, el, options;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log({ rowData, templateLocation });
                _this.showInvoice = true;
                order = dataParam.order, user = dataParam.user, packageConfig = dataParam.packageConfig, packageType = dataParam.packageType;
                // readString(templateLocation).then(console.log);

                html = ejs.render(__WEBPACK_IMPORTED_MODULE_5_raw_loader_templates_invoice_ejs__["a" /* default */], {
                  order: order,
                  user: user,
                  packageConfig: packageConfig,
                  packageType: packageType,
                  setupURL: false
                });
                el = _this.$refs.invoiceSection;
                options = {
                  type: "dataURL"
                };

                _this.receiptData = html;
                // this.finalData = await this.$html2canvas(el, options);
                // console.log({ finalData });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    deleteRequest: function deleteRequest(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete("/device_requests/" + id).then(function (response) {
        _this2.centerDialogVisible = false;
        window.location.reload(true);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    var HTTP = this.$httpUtils.instance;
    var container = this;

    // {"status": 1}
    HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"transactionHistories\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}], \n      \"where\": {\n        \"or\":[\n          {\"status\": 0},\n          {\"status\": 1}\n        ]\n        } }", {}).then(function (response) {
      // console.log(JSON.stringify(rolesdata.data))
      console.log({ response: response });

      container.deviceRequests = response.data.filter(function (x) {
        return x.user;
      });
    });
  }
});

/***/ }),
/* 885 */,
/* 886 */,
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Timeline"]);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["TimelineItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__["a" /* default */]
    // 'el-timeline': Timeline,
    // 'el-timeline-item': TimelineItem,
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      instalationPackageConfig: [],
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        qty: 1
      },
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      installationData: null,
      columns: [
      /*    {
        label: "SN",
        field: "sn",
        type: "date"
      }, */
      {
        label: "Component",
        field: "componentType.name",
        filterable: true
      }, {
        label: "Qty",
        field: "quantity",
        filterable: true
      }],
      rows: [],
      reqSuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          componentList.unshift({
            value: null,
            disabled: true,
            text: "Please component type"
          });

          context.componentTypeOptions = componentList;
          context.componentTypeId = null;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    removeData: function removeData(index) {
      var name = this.rows.filter(function (x) {
        return x.componentId == index.componentId;
      });
      this.rows.splice(index.originalIndex, 1);
      this.componentOptions.splice(1, 0, {
        id: index.componentId,
        value: index.componentId,
        text: index.component,
        name: index.component
      });
    },
    fetchComponents: function fetchComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        var componentFetch = components.data;
        componentFetch.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });
        componentFetch.unshift({
          value: null,
          disabled: true,
          text: "Select Component"
        });
        container.componentOptions = componentFetch;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    submitRequest: function submitRequest() {
      var _this = this;

      var requestId = this.$route.params.id * 1;
      var pcConfig = this.instalationPackageConfig.map(function (x) {
        return {
          quantity: x.quantity,
          componentTypeId: x.componentId,
          deviceRequestId: requestId
        };
      });
      var HTTP = this.$httpUtils.instance;
      var container = this;

      HTTP.post("/installation_components", pcConfig).then(function (response) {
        var componentsResponse = response.data;
        if (componentsResponse) {
          HTTP.post("/device_requests/approve", { id: requestId }).then(function (response) {
            _this.showSuccessMsg({ message: "Installation Approved" });
            _this.$router.push({
              name: "devices",
              params: {
                activetab: "approved_installations"
              }
            });
            // setTimeout(() => {
            //   container.$router.push({
            //     name: "instalationList"
            //   });
            // }, 500);
          });
        }
      });
    },
    addInventory: function addInventory() {
      var conName = this.getComponentName(document.getElementById("componentName").value);
      var conType = this.getComponentTypeName(document.getElementById("componentType").value);
      var itemqty = document.getElementById("item-qty").value;
      itemqty = itemqty == "" ? 1 : itemqty;
      this.rows.push({
        deviceRequestId: this.$route.params.id,
        componentTypeId: document.getElementById("componentType").value,
        componentId: document.getElementById("componentName").value,
        component: conName,
        spec: conType,
        qty: itemqty,
        quantity: itemqty
      });
      this.componentOptions.splice(document.getElementById("componentName").selectedIndex, 1);
      this.componentTypeOptions.splice(document.getElementById("componentType").selectedIndex, 1);
      document.getElementById("componentName").selectedIndex = 0;
      document.getElementById("componentType").selectedIndex = 0;
    },
    getComponentName: function getComponentName(param) {
      return this.componentOptions.filter(function (x) {
        return x.value == param;
      })[0].name;
    },
    getComponentTypeName: function getComponentTypeName(param) {
      return this.componentTypeOptions.filter(function (x) {
        return x.value == param;
      })[0].name;
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate();
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    fetchData: function fetchData(d) {
      var _this2 = this;

      var requestId = this.$route.params.id;
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/device_requests/" + d + "?filter={\"include\": [\"user\",\"transactionHistories\", \"installations\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}]}", {}).then(function (components) {
        var componentFetch = components.data;
        _this2.installationData = componentFetch;
        return {
          systemCapacity: componentFetch.systemCapacity,
          packageComponents: _this2.installationData.deviceType.packageComponents
        };
      }).then(function (_ref3) {
        var packageComponents = _ref3.packageComponents,
            systemCapacity = _ref3.systemCapacity;

        // let x = systemCapacity /
        _this2.instalationPackageConfig = packageComponents.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            quantity: x.quantity,
            componentTypeId: x.componentId,
            deviceRequestId: requestId
          }, x);
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
  }
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_utils_GoogleAddressSuggest_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Dialog"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Button"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["b" /* ModalClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_7_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_7_element_ui__["FormItem"],
    Autocomplete: __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__["a" /* default */],
    AddressInput: __WEBPACK_IMPORTED_MODULE_6__components_utils_GoogleAddressSuggest_vue__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      showForm: false,
      addressParam: {},
      dialogVisible: false,
      currentDevice: {
        insComp: [],
        inst: null,
        rating: 0
      },
      form: {
        label: null,
        field: null,
        condition: true,
        value: null
      },
      // activeTab:"maintenance",
      activeTab: this.$route.params.activetab ? this.$route.params.activetab : "maintenance",
      maintenanceColumns: [{
        label: "Issue",
        field: "issue",
        filterable: true
      }, {
        label: "Engineer in charge",
        field: "operator",
        filterable: true
      }],
      alarmRows: "",
      alarmColumns: [{
        label: "Label",
        field: "label",
        filterable: true
      }, {
        label: "Field Name",
        field: "fieldName",
        filterable: true
      }, {
        label: "Field Property",
        field: "fieldProperty",
        filterable: true
      }, {
        label: "Condition",
        field: "condition",
        filterable: true
      }, {
        label: "Value",
        field: "value",
        filterable: true
      }],
      columns: [
      // {
      //   label: "SN",
      //   field: "sn",
      //   type: "number",
      //   filterable: true
      // },
      {
        label: "Component Name",
        field: "componentItems.name",
        filterable: true
      }, {
        label: "Quantity",
        type: "number",
        field: "quantity"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    triggerEditLocation: function triggerEditLocation() {
      if (this.$can("manage", "mine")) {
        return;
      } else {
        this.dialogVisible = true;
      }
    },
    getAlarm: function getAlarm() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var installationId = this.$route.params.deviceId;
      HTTP.get("/alarmConfigs?filter={\"where\":{\"installationId\":" + installationId + "}}").then(function (alarm) {
        container.alarmRows = alarm.data;
      });
    },
    showAlarmForm: function showAlarmForm() {
      this.showForm = true;
    },
    find_prop: function find_prop(obj, key) {
      var _this = this;

      return function () {
        var keyNest = key.split(".");
        if (_this.currentDevice === null || obj === undefined) {
          return "-";
        } else if (keyNest.length > 1) {
          return _this.find_prop(obj[keyNest.shift()], keyNest.join("."));
        } else {
          return obj[key];
        }
      }();
    },
    deviceParse: function deviceParse(string) {
      return string.split(" ");
    },
    device_prop: function device_prop(key) {
      // console.log(this.currentDevice)
      // return (this.currentDevice !== null) ? this.currentDevice.key : '-';
      return this.find_prop(this.currentDevice, key);
    },
    getDevice: function getDevice() {
      var _this2 = this;

      var context = this;
      var HTTP = this.$httpUtils.instance;
      var inverterId = this.$route.params.deviceId;
      var filter = {
        include: ["user", "deviceType", {
          deviceRequest: ["user", "deviceType", { installationComponents: ["componentItems"] }]
        }, "locations", { maintenanceHistory: "operationsEngineer" }]
      };

      // {
      //   include: {
      //     user,
      //     deviceType,
      //     deviceRequest: [
      //       "user",
      //       "deviceType",
      //       { installationComponents: ["componentItems"] }
      //     ],
      //     locations,
      //     maintenanceHistory: "operationsEngineer"
      //   }
      // };
      console.log(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter));

      // const url = `/installations/${inverterId}?filter={"include": ["user","deviceType","deviceRequest","locations",{"maintenanceHistory":"operationsEngineer"}]}`;
      var url = "/installations/" + inverterId + "?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter);
      // ?filter[include]=user&filter[include]=deviceType&filter[include]=deviceRequest&filter[include]=locations&filter[include]=maintenanceHistory`;
      var comId = [];
      var deviceRequestId = deviceRequestId;
      HTTP.get(url).then(function (response) {
        _this2.currentDevice.inst = response.data;
        var solarKit = _this2.currentDevice.inst.solarKitIds.replace(" ", ",");
        // let deviceRequestId = this.currentDevice.inst.deviceRequestId;
        // const url2 = `/installation_components/?filter={"where":{"deviceRequestId":${deviceRequestId}},"include":{"componentType":"component"}}`;
        // HTTP.get(url2).then(insComp => {
        //   this.currentDevice.insComp = insComp.data;
        //   for (var value of this.currentDevice.insComp) {
        //     if (
        //       value.componentType.name.toLowerCase().indexOf("inverter") >
        //         -1 ||
        //       value.componentType.name.toLowerCase().indexOf("kva") > -1
        //     ) {
        //       this.currentDevice.rating =
        //         value.componentType.rating * value.quantity;
        //       break;
        //     }
        //   }
        // });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    submitAddressUpdate: function submitAddressUpdate() {
      var _this3 = this;

      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/locations";
      HTTP.post(url, this.addressParam).then(function (response) {
        container.dialogVisible = false;
        _this3.showSuccessMsg({
          message: "Address Updated!"
        });
      }).catch(function (error) {
        var errorMsg = error.response.data.error.details.messages;
        var errTemp = [];
        var keyHooks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errorMsg);
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
          errTemp[index] = keyHooks[index] + " " + x[0];
        });
        errTemp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
        _this3.showErrorMsg({
          message: errTemp
        });
      });
    },
    initSearch: function initSearch() {
      // var input = document.getElementById('pac-input');
      var input = this.$refs.pacInput;
      var autocomplete = new google.maps.places.Autocomplete(input);
      autocomplete.addListener("place_changed", function () {
        document.getElementById("location-error").style.display = "none";
        var place = autocomplete.getPlace();
        if (!place.geometry) {
          document.getElementById("location-error").style.display = "inline-block";
          document.getElementById("location-error").innerHTML = "Cannot Locate '" + input.value + "' on map";
          return;
        }
      });
    },

    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.addressParam = {
        position: {
          lat: addressData.latitude,
          lng: addressData.longitude
        },
        streetNumber: addressData.street_number,
        streetRoute: (addressData.route ? addressData.route : "") + " - " + (addressData.locality ? addressData.locality : "") + ", " + (addressData.country ? addressData.country : ""),
        userId: this.currentDevice.inst.userId,
        installationId: this.currentDevice.inst.id,
        deviceRequestId: this.currentDevice.inst.deviceRequestId,
        stateId: 0,
        countryId: 0,
        locationId: 0,
        lgaId: 0
      };
      console.log(this.addressParam);
    }
  },
  mounted: function mounted() {
    if (!this.$can("read", "device")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    this.getDevice();
    this.getAlarm();
  }
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAddressSuggest_vue__ = __webpack_require__(890);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b56537_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAddressSuggest_vue__ = __webpack_require__(2082);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAddressSuggest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61b56537_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAddressSuggest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete__ = __webpack_require__(2080);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueGoogleAutocomplete: __WEBPACK_IMPORTED_MODULE_0_vue_google_autocomplete__["a" /* default */] },
  props: ['changeHandler'],
  data: function data() {
    return {
      address: ''
    };
  },

  mounted: function mounted() {
    // To demonstrate functionality of exposed component functions
    // Here we make focus on the user input
    this.$refs.address.focus();
  },


  methods: {
    /**
    * When the location found
    * @param {Object} addressData Data of the found location
    * @param {Object} placeResultData PlaceResult object
    * @param {String} id Input container ID
    */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.address = addressData;
    }
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ADDRESS_COMPONENTS = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};

var CITIES_TYPE = ['locality', 'administrative_area_level_3'];
var REGIONS_TYPE = ['locality', 'sublocality', 'postal_code', 'country', 'administrative_area_level_1', 'administrative_area_level_2'];

/*
  By default, we're only including basic place data because requesting these 
  fields place data is not additionally charged by Google. Please refer to:
   https://developers.google.com/maps/billing/understanding-cost-of-use#basic-data
*/
var BASIC_DATA_FIELDS = ['address_components', 'adr_address', 'alt_id', 'formatted_address', 'geometry', 'icon', 'id', 'name', 'business_status', 'photo', 'place_id', 'scope', 'type', 'url', 'utc_offset_minutes', 'vicinity'];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'VueGoogleAutocomplete',

    props: {
        id: {
            type: String,
            required: true
        },

        classname: String,

        placeholder: {
            type: String,
            default: 'Start typing'
        },

        disabled: {
            type: Boolean,
            default: false
        },

        types: {
            type: String,
            default: 'address'
        },

        fields: {
            type: Array,
            default: function _default() {
                return BASIC_DATA_FIELDS;
            }
        },

        country: {
            type: [String, Array],
            default: null
        },

        enableGeolocation: {
            type: Boolean,
            default: false
        },

        geolocationOptions: {
            type: Object,
            default: null
        }
    },

    data: function data() {
        return {
            /**
             * The Autocomplete object.
             *
             * @type {Autocomplete}
             * @link https://developers.google.com/maps/documentation/javascript/reference#Autocomplete
             */
            autocomplete: null,

            /**
             * Autocomplete input text
             * @type {String}
             */
            autocompleteText: '',

            geolocation: {
                /**
                 * Google Geocoder Objet
                 * @type {Geocoder}
                 * @link https://developers.google.com/maps/documentation/javascript/reference#Geocoder
                 */
                geocoder: null,

                /**
                 * Filled after geolocate result
                 * @type {Coordinates}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Coordinates
                 */
                loc: null,

                /**
                 * Filled after geolocate result
                 * @type {Position}
                 * @link https://developer.mozilla.org/en-US/docs/Web/API/Position
                 */
                position: null
            }
        };
    },


    watch: {
        autocompleteText: function autocompleteText(newVal, oldVal) {
            this.$emit('inputChange', { newVal: newVal, oldVal: oldVal }, this.id);
        },
        country: function country(newVal, oldVal) {
            this.autocomplete.setComponentRestrictions({
                country: this.country === null ? [] : this.country
            });
        }
    },

    mounted: function mounted() {
        var options = {};

        if (this.types) {
            options.types = [this.types];
        }

        if (this.country) {
            options.componentRestrictions = {
                country: this.country
            };
        }

        this.autocomplete = new google.maps.places.Autocomplete(document.getElementById(this.id), options);

        this.autocomplete.setFields(this.fields);

        this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },

    methods: {
        /**
         * When a place changed
         */
        onPlaceChanged: function onPlaceChanged() {
            var place = this.autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                this.$emit('no-results-found', place, this.id);
                return;
            }

            if (place.address_components !== undefined) {
                // return returnData object and PlaceResult object
                this.$emit('placechanged', this.formatResult(place), place, this.id);

                // update autocompleteText then emit change event
                this.autocompleteText = document.getElementById(this.id).value;
                this.onChange();
            }
        },


        /**
         * When the input gets focus
         */
        onFocus: function onFocus() {
            this.biasAutocompleteLocation();
            this.$emit('focus');
        },


        /**
         * When the input loses focus
         */
        onBlur: function onBlur() {
            this.$emit('blur');
        },


        /**
         * When the input got changed
         */
        onChange: function onChange() {
            this.$emit('change', this.autocompleteText);
        },


        /**
         * When a key gets pressed
         * @param  {Event} event A keypress event
         */
        onKeyPress: function onKeyPress(event) {
            this.$emit('keypress', event);
        },


        /**
         * When a keyup occurs
         * @param  {Event} event A keyup event
         */
        onKeyUp: function onKeyUp(event) {
            this.$emit('keyup', event);
        },


        /**
         * Clear the input
         */
        clear: function clear() {
            this.autocompleteText = '';
        },


        /**
         * Focus the input
         */
        focus: function focus() {
            this.$refs.autocomplete.focus();
        },


        /**
         * Blur the input
         */
        blur: function blur() {
            this.$refs.autocomplete.blur();
        },


        /**
         * Update the value of the input
         * @param  {String} value
         */
        update: function update(value) {
            this.autocompleteText = value;
        },


        /**
         * Update the coordinates of the input
         * @param  {Coordinates} value
         */
        updateCoordinates: function updateCoordinates(value) {
            var _this = this;

            if (!value && !(value.lat || value.lng)) return;
            if (!this.geolocation.geocoder) this.geolocation.geocoder = new google.maps.Geocoder();
            this.geolocation.geocoder.geocode({ 'location': value }, function (results, status) {
                if (status === 'OK') {
                    results = _this.filterGeocodeResultTypes(results);
                    if (results[0]) {
                        _this.$emit('placechanged', _this.formatResult(results[0]), results[0], _this.id);
                        _this.update(results[0].formatted_address);
                    } else {
                        _this.$emit('error', 'no result for provided coordinates');
                    }
                } else {
                    _this.$emit('error', 'error getting address from coords');
                }
            });
        },


        /**
         * Update location based on navigator geolocation
         */
        geolocate: function geolocate() {
            var _this2 = this;

            this.updateGeolocation(function (geolocation, position) {
                _this2.updateCoordinates(geolocation);
            });
        },


        /**
         * Update internal location from navigator geolocation
         * @param  {Function} (geolocation, position)
         */
        updateGeolocation: function updateGeolocation() {
            var _this3 = this;

            var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            if (navigator.geolocation) {
                var options = {};
                if (this.geolocationOptions) __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(options, this.geolocationOptions);
                navigator.geolocation.getCurrentPosition(function (position) {
                    var geolocation = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                    _this3.geolocation.loc = geolocation;
                    _this3.geolocation.position = position;

                    if (callback) callback(geolocation, position);
                }, function (err) {
                    _this3.$emit('error', 'Cannot get Coordinates from navigator', err);
                }, options);
            }
        },


        // Bias the autocomplete object to the user's geographical location,
        // as supplied by the browser's 'navigator.geolocation' object.
        biasAutocompleteLocation: function biasAutocompleteLocation() {
            var _this4 = this;

            if (this.enableGeolocation) {
                this.updateGeolocation(function (geolocation, position) {
                    var circle = new google.maps.Circle({
                        center: geolocation,
                        radius: position.coords.accuracy
                    });
                    _this4.autocomplete.setBounds(circle.getBounds());
                });
            }
        },


        /**
         * Format result from Geo google APIs
         * @param place
         * @returns {{formatted output}}
         */
        formatResult: function formatResult(place) {
            var returnData = {};
            for (var i = 0; i < place.address_components.length; i++) {
                var addressType = place.address_components[i].types[0];

                if (ADDRESS_COMPONENTS[addressType]) {
                    var val = place.address_components[i][ADDRESS_COMPONENTS[addressType]];
                    returnData[addressType] = val;
                }
            }

            returnData['latitude'] = place.geometry.location.lat();
            returnData['longitude'] = place.geometry.location.lng();
            return returnData;
        },


        /**
         * Extract configured types out of raw result as
         * Geocode API does not allow to do it
         * @param results
         * @returns {GeocoderResult}
         * @link https://developers.google.com/maps/documentation/javascript/reference#GeocoderResult
         */
        filterGeocodeResultTypes: function filterGeocodeResultTypes(results) {
            if (!results || !this.types) return results;
            var output = [];
            var types = [this.types];
            if (types.includes('(cities)')) types = types.concat(CITIES_TYPE);
            if (types.includes('(regions)')) types = types.concat(REGIONS_TYPE);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(results), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var r = _step.value;
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(r.types), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var t = _step2.value;

                            if (types.includes(t)) {
                                output.push(r);
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                _iterator2.return();
                            }
                        } finally {
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return output;
        }
    }
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




// import "vue-good-table/dist/vue-good-table.css";
// import { VueGoodTable } from "vue-good-table";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      form: {
        name: "",
        region: "",
        inputValue: this.dynamicTags
      },
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      results: []

      // columns: [
      //   {
      //     label: "Full Name",
      //     field: "fullname"
      //   },
      //   {
      //     label: "Email",
      //     field: "email"
      //   },
      //   {
      //     label: "Phone Number",
      //     field: "phonenumber",
      //     type: "number"
      //   },
      //   {
      //     label: "Customer Type",
      //     field: "customertype"
      //   },
      //   {
      //     label: "Last Seen",
      //     field: "lastseen"
      //   }
      // ],
      // rows: [
      //   {
      //     id: 1,
      //     fullname: "John Wick",
      //     email: "johnwick@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "Agent",
      //     lastseen: "Dec 9, 2017 "
      //   },
      //   {
      //     id: 2,
      //     fullname: "Jane Aniston",
      //     email: "janeaniston@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "CEO",
      //     lastseen: "14 minutes ago"
      //   },
      //   {
      //     id: 3,
      //     fullname: "Susan Hall",
      //     email: "susanhall@gmail.com",
      //     phonenumber: "2011-10-30",
      //     lastseen: "6 Hours ago"
      //   },
      //   {
      //     id: 4,
      //     fullname: "Chris Pratt",
      //     email: "chrispratt@gmail.com",
      //     phonenumber: "2011-10-11",
      //     customertype: "Manager",
      //     lastseen: "20 Minutes ago"
      //   },
      //   {
      //     id: 5,
      //     fullname: "Dan Schwarz",
      //     email: "danschwarz@gmail.com",
      //     phonenumber: "2011-10-21",
      //     customertype: "Engineer",
      //     lastseen: "5 Minutes ago"
      //   },
      //   {
      //     id: 6,
      //     fullname: "Jax Briggs",
      //     email: "jaxbriggs@gmail.com",
      //     phonenumber: "2011-10-31",
      //     customertype: "Security",
      //     lastseen: "2 Minutes ago"
      //   }
      // ]
    };
  },

  // props: {
  //   pageChanged: {
  //     type: Function
  //   },
  //   perPageChanged: {
  //     type: Function
  //   }
  // },
  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    onSubmit: function onSubmit() {
      console.log(this.form);
    },

    // selectAll(selected, selectedRows) {
    //   // do what you want here
    //   console.log(selected, selectedRows);
    // },
    // toggleSelectRow(params) {
    //   // row that was clicked
    //   console.log(params.row);
    //   // index of page
    //   console.log(params.pageIndex);
    //   // whether the row was selected or unselected
    //   console.log(params.selected);
    // },
    // customPageChange(customCurrentPage) {
    //   this.pageChanged({
    //     currentPage: customCurrentPage.push()
    //   });
    // },
    // customPerPageChange(customPerPage) {
    //   this.perPageChanged({
    //     currentPerPage: customPerPage
    //   });
    // },
    init: function init() {
      var _this2 = this;

      var token = "eyJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwiYWxnIjoiZGlyIn0..2T4HzSyG2yRal7qRrH46QQ.76im4yKWQUw3rm5RM6KGuQAEDo6Ll-MtfHoLQwhAexJBdJOQqMNPmWwn4X-DYtMxd5FuyZZlRt8XhXc1fvE6smRDH-yD1k5yBXHXP1Da5Oey4Z6udLOMWZalV8ipWijAvxaxFPrmzfxee3tbdYHZtZH7ExsoGtNdiu4q4SyNbOPTxGg7NasW5hb6gJTb116gmPk93ZA_TLc9HewrzsFfMaiQQwsn0DvM6pzTxGbr72RgaYff2vmGomey9io19mBCdxkFWKdn1uMv5Dzb5c3eGt9PfIBfA9WLO06cuQWx-4SXP6EL6a4d83IbA6E0RxmiSzpPFXiXHs8FTr2Qz-vnFigsZqQirmpF8DczFjgm1KhPyxSt5OanMfyC4JoKVXzFexuaLVgQ-001_YxeTAb5EqGly5Xdxhtl2B9b8GaXNveZkWaYqr8gJFxEvZn_RUYmywUnMk8oulFBURPOWphybjnPPdI_2my0Yh940T-1ymmk8-lI14otFkWIl4-wHFNw00bhxu-bav5yFE8c6Ddo9g63MupUGDyTQ5JGef4-rTVqZOQEyLgQWd42hXR6SN1pgXgD6DGMbQ6IJncv1DjFJLsNpyLAkB_YtbemCKGBYMa0vJGdBf2T_KMI37YCkvu23ELB4VPlpIIH2eIVYFFG6fUsmQvzqDQ-5XcriXiWazLfJCdXiA8flizyRltgWGFabLiLkrSnSiJfBgXmC-ZLmVasNBLAxgf-WU_2hBbslq4nJ_HJ_ADiNyhLutBX13EO41w46OdI5IaS5fAGrgBfZ1ZBIkv5aX664yRO4McPIOEqTIJ0feNlkN9elCVPkWNK4KWw8K2P0QLHhYRDNX31aKmoKMmj49WULUeUDwtie-MEtiXv9yPDOZHe4sytTjaJ.k4HxEMIKbZnYGzMHozuFgg";
      var resFormat = "application/json;charset=utf-8";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get("https://sandbox-quickbooks.api.intuit.com/v3/company/4620816365001689780/query?query=select * from Item &minorversion=38", {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "" + resFormat
        }
      })

      // axios
      //   .post(
      //     "https://sandbox-quickbooks.api.intuit.com/v3/company/4620816365001689780/item?minorversion=38",
      //     {
      //       header: {
      //         Authorization:
      //           `Bearer ${token}`,
      //         "Content-type": `${resFormat}`,
      //         // "Accept": `${resFormat}`
      //       },
      //       data:
      //       {
      //         "TrackQtyOnHand": true,
      //         "Name": "Modems",
      //         "QtyOnHand": 60,
      //         "IncomeAccountRef": {
      //           "name": "Sales of Product Income",
      //           "value": "79"
      //         },
      //         "AssetAccountRef": {
      //           "name": "Inventory Asset",
      //           "value": "81"
      //         },
      //         "InvStartDate": "2019-07-10",
      //         "Type": "Inventory",
      //         "ExpenseAccountRef": {
      //           "name": "Cost of Goods Sold",
      //           "value": "80"
      //         }
      //       }
      //     }
      //   )

      .then(function (res) {
        _this2.results = res.data.QueryResponse.Item;
        // this.results = res.data
        // console.log(res.data);
      }).catch(function (error) {
        // console.log(error.config);
        console.log(error);
      });
    },
    test: function test() {
      var items = this.results;
      console.log(items);
    }
  },
  mounted: function mounted() {
    this.results = this.init();
  },

  computed: {}
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_3_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   Inventory
  // },
  data: function data() {
    return {
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      users: [],
      items: items,
      fields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }],
      cxTeamFields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getDummy", "getDevices"]), {
    isACxTeam: {
      get: function get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      console.log("wetin dey xup naw", user, url);
      this.$router.push({
        path: url,
        query: {
          user: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.users = response.data;
        console.log('hello word +++++++++++++++++++++++++++++++++', container.users);
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';

// import VueNotifications from 'vue-notifications';


var getSearchParams = function getSearchParams(k) {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "new-user",
  components: {
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_9_element_ui__["FormItem"]
  },
  data: function data() {
    return {
      roleData: [],
      installations: [],
      regSuccess: false,
      isSectionManager: false,
      regParams: {
        firstName: "",
        roleType: "".toLowerCase(),
        assignedDevices: [],
        lastName: "",
        dateOfBirth: new Date(),
        noMail: false,
        gender: "",
        phoneNumber: "",
        realm: "",
        username: "",
        email: "",
        street_route: "",
        password: "<%%>",
        cpassword: "<%%>",
        stateId: "",
        countryId: 1,
        lgaId: "null"
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [{
        value: null,
        disabled: true,
        text: "Please select a state"
      }],
      lgaOptions: [{
        value: null,
        disabled: true,
        text: "Please select LGA"
      }],
      genderData: [{
        id: 1,
        name: "Male"
      }, {
        id: 0,
        name: "Female"
      }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    // lgaOptions() {
    //   const state = this.selectedState;
    //   return state;
    // },
  },
  methods: {
    logTHis: function logTHis() {
      var ctx = this;
      ctx.$log({ assisgned: ctx.regParams.assignedDevices });
    },
    checkSelRole: function checkSelRole(role) {
      this.regParams.roleType = role.name;
      // ctx.isSectionManager = role === "section manager" ? true : false;
      if (role.name != "section manager") {
        this.regParams.assignedDevices = [];
      } else {
        this.isSectionManager = true;
      }
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      console.log(this.regParams);
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            //   case "stateId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a state.";
            //     }
            //     break;
            //   case "lgaId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a local government.";
            //     }
            //     break;
            //   case "countryId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a country.";
            //     }
            //     break;
            // case "gender":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Gender cannot be empty.";
            //   }
            //   break;
            case "firstName":
              if (value === "null" || value === "") {
                errors[field] = "Firstname cannot be empty.";
                // console.log(this.errors)
              }
              break;
            case "lastName":
              if (value === "null" || value === "") {
                errors[field] = "Lastname cannot be empty.";
              }
              break;
            // case "username":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Username cannot be empty.";
            //   }
            //   break;
            case "email":
              if (value === "null" || value === "") {
                errors[field] = "Email cannot be empty.";
              } else if (!this.isEmail(value)) {
                errors[field] = "Not a valid email.";
              }
              break;
            case "street_route":
              if (value === "null" || value === "") {
                errors[field] = "Address cannot be empty.";
              }
              break;
            case "phoneNumber":
              if (value === "null" || value === "") {
                errors[field] = "Phone cannot be empty.";
              }
              break;
            case "gender":
              if (value === "null" || value === "") {
                errors[field] = "Gender cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
      // console.log(this.errors);
    },
    submitReg: function submitReg(e) {
      var _this = this;

      e.preventDefault();
      this.validateReg();
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (container.regParams.roleType === "section manager") {
        if (container.regParams.assignedDevices.length < 1) {
          this.displayError = true;
          setTimeout(function () {
            _this.displayError = false;
          }, 3000);
          var errorMsg = "Assign Device(s) is required";
          this.errorMessage = "Assign Device(s) is required";
          // console.log()
          this.showErrorMsg({
            message: errorMsg
          });
          return;
        }
      }
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        delete tempReg["cpassword"];
        tempReg["username"] = tempReg["email"];
        tempReg["assignedDevices"] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tempReg["assignedDevices"]);
        tempReg["adminVerifyEmail"] = true; //add email verified
        // console.log({ tempReg });
        // return;
        var HTTP = this.$httpUtils.instance;
        var url = "/users";
        // console.log({ params: tempReg });
        // return;
        HTTP.post(url, tempReg).then(function (response) {
          container.regSuccess = true;
          _this.showSuccessMsg({
            message: "User Created!"
          });
          _this.$router.push({ path: "/user_management/users" });
        }).catch(function (error) {
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(errorMsg);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
              errTemp[index] = keyHooks[index] + " " + x[0];
              // console.log(index);
            });
            // console.log("error", errTemp);
            errTemp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
            _this.showErrorMsg({
              message: errTemp
            });
          } else {
            _this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
      }
    },
    fetchStates: function fetchStates() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        // console.log(JSON.stringify(response))
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState = tempState.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
            text: x.text[0].toUpperCase() + x.text.substring(1)
          });
        });
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this2.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/states/" + state + "/lgas";
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga = tempLga.map(function (x) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
              text: x.text[0].toUpperCase() + x.text.substring(1)
            });
          });
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchInsatallations: function fetchInsatallations() {
      var ctx = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/installations/";
      var filter = "?filter[where][CID][neq]=null";
      HTTP.get(url + filter).then(function (response) {
        ctx.installations = response.data;
        ctx.$log({ installations: ctx.installations });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    searchRole: function searchRole(queryString, cb) {
      var arrayItem = this.roleData;
      var results = queryString ? arrayItem.filter(function (item) {
        return ("" + item.name.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      }) : arrayItem;

      cb(results);
    },
    fetchUserRoles: function fetchUserRoles() {
      //    fetchPreviledges() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var url = "/roles/";
      HTTP.get(url).then(function (response) {
        container.roleData = response.data;
      }).catch(function (error) {
        console.log("error", error);
      });
      // },
    }
  },
  mounted: function mounted() {
    var ctx = this;
    // (getSearchParams('q') !== undefined)? getSearchParams('q') :
    // (getSearchParams('v') !== undefined)? getSearchParams('v')
    this.fetchStates();
    this.fetchUserRoles();
    ctx.fetchInsatallations();
    // const user_type_token = (getSearchParams('s') !== undefined)? getSearchParams('s') : 'CUSTOMER';
    // const user_type_token = this.$route.query.s ||  this.$route.query.q ||  this.$route.query.v || 'CUSTOMER';
    // console.log("===================")
    // var LocationAddr =window.location.toString().split('?')[1];
    // console.log(user_type_token)
    // console.log(getSearchParams('s'));
  }
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_datepicker__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__ = __webpack_require__(219);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







var getSearchParams = function getSearchParams(k) {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "billing-schedule",
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_10_vue2_datepicker__["a" /* default */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Autocomplete"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_offcanvas__["b" /* OffcanvasClose */]
  },
  data: function data() {
    return {
      billingSuccess: false,
      regParams: {
        installationId: "",
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        price: "",
        monthlyCharge: ""
      },
      errorsResult: {},
      installationList: []
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    updateMonthlyCharge: function updateMonthlyCharge() {
      var calc = this.monthlyCharge;
      calc = this.regParams.price / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
    },
    getContacts: function getContacts() {
      var HTTP = this.$httpUtils.instance;
      var ctx = this;
      var filter = {
        where: {
          and: [{ CID: { neq: null } }, {
            or: [{ status: "requested" }, { status: "scheduled" }, { status: "commissioned" }, { status: "completed" }]
          }]
        },
        include: ["deviceRequest", "locations", "user"]
      };
      var url = "/installations?filter=" + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_json_stringify___default()(filter);
      HTTP.get(url).then(function (response) {
        ctx.installationList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, x, {
            value: x && x.deviceRequest ? x.name + " (" + (x.CID ? x.CID : x.solarKitIds) + ") " : null
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    disabledBeforeTodayAndAfterAWeek: function disabledBeforeTodayAndAfterAWeek(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "installationId":
              if (value === "null" || value === "NaN" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Customer's installation ID cannot be empty.";
              }
              break;
            case "duration":
              if (value === "null" || value === "NaN" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Duration cannot be empty.";
              }
              break;
            case "numberOfTimesPaymentIsMade":
              if (value === "null" || value === "NaN" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Number of payment made cannot be empty.";
              }
              break;
            case "monthlyRecurringChargeDate":
              if (value === "null" || value === "" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value) || value === "Invalid date") {
                errors[field] = "Charge date cannot be empty.";
              }
              break;
            case "price":
              if (value === "null" || value === "NaN" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Amount cannot be empty.";
              }
              break;
            case "monthlyCharge":
              if (value === "null" || value === "NaN" || Object(__WEBPACK_IMPORTED_MODULE_13_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Monthly charge cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errorsResult = errors;
    },
    createBilling: function createBilling(e) {
      var _this = this;

      e.preventDefault();
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.regParams);
      this.regParams.monthlyRecurringChargeDate = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this.regParams.monthlyRecurringChargeDate).format();

      this.validateReg();
      var errorLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      keys.forEach(function (key, index) {
        if (!["installation", "monthlyRecurringChargeDate"].includes(key)) {
          _this.regParams[key] = parseInt(_this.regParams[key]);
        }
      });
      var HTTP = this.$httpUtils.instance;
      var url = "/billings/setup-schedule";
      HTTP.post(url, this.regParams).then(function (res) {
        console.log("response", res);
        _this.showSuccessMsg({ message: "Device setup successfully!" });
        window.history.back();
      }).catch(function (error) {
        console.log("setup error", error.response);
        _this.showErrorMsg({ message: error.response.data.error.message });
      });
    },
    installationSearch: function installationSearch(queryString, cb) {
      var _this2 = this;

      var installationList = this.installationList;
      var results = queryString ? installationList.filter(function (installation) {
        return _this2.createFilter(queryString, installation);
      }) : installationList;
      cb(results);
    },
    createFilter: function createFilter(queryString, installation) {
      // console.log({ name: installation });
      return (installation.name + " - " + installation.CID).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(installation) {
      var ctx = this;
      var form = ctx.form;
      var deviceRequest = installation.deviceRequest,
          user = installation.user,
          locations = installation.locations;

      var paymentModel = deviceRequest.paymentModel;
      this.regParams.installationId = installation.id;
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getContacts();
  }
});

/***/ }),
/* 896 */,
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(419);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




var getSearchParams = function getSearchParams(k) {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "billing-update",
  components: {
    DatePicker: __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      billingSuccess: false,
      errorsResult: {},
      regParams: {
        duration: "",
        numberOfTimesPaymentIsMade: "",
        monthlyRecurringChargeDate: "",
        monthlyCharge: "",
        id: ""
      },
      parameters: {
        installationId: "",
        monthCharges: "",
        numbOfPayments: "",
        durationss: "",
        chargingDate: "",
        price: NaN
      },

      durationMonths: [{
        id: 6,
        name: "6 months"
      }, {
        id: 12,
        name: "12 months"
      }, {
        id: 24,
        name: "24 months"
      }, {
        id: 36,
        name: "36 months"
      }, {
        id: 60,
        name: "60 months"
      }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    updateMonthlyCharge: function updateMonthlyCharge() {
      var calc = this.monthlyCharge;
      calc = this.parameters.price / this.regParams.duration;
      this.regParams.monthlyCharge = Math.ceil(calc).toFixed(2);
    },
    disabledBeforeTodayAndAfterAWeek: function disabledBeforeTodayAndAfterAWeek(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today;
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "duration":
              if (value === "null" || value === "NaN") {
                errors[field] = "Duration cannot be empty.";
              }
              break;
            case "monthlyRecurringChargeDate":
              if (value === "null" || value === "") {
                errors[field] = "Monthly recurring charge date cannot be empty.";
              }
              break;
            case "numberOfTimesPaymentIsMade":
              if (value === "null" || value === "NaN") {
                errors[field] = "Payment Installment cannot be empty.";
              }
              break;
            case "monthlyCharge":
              if (value === "null" || value === "NaN") {
                errors[field] = "Monthly charge cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errorsResult = errors;
    },
    submitReg: function submitReg(e) {
      var _this = this;

      e.preventDefault();
      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.regParams);
      keys.forEach(function (key, index) {
        if (key !== "monthlyRecurringChargeDate") {
          _this.regParams[key] = parseInt(_this.regParams[key]);
        } else {
          _this.regParams[monthlyRecurringChargeDate] = _this.regParams[monthlyRecurringChargeDate.toString()];
        }
      });

      this.validateReg();
      var errorLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }

      var HTTP = this.$httpUtils.instance;
      var url = "/billings/" + this.regParams.id;
      HTTP.patch(url, this.regParams).then(function (res) {
        console.log("response", res);
        _this.showSuccessMsg({ message: "Device Updated!" });
        window.history.back();
      }).catch(function (error) {
        _this.showErrorMsg({ message: error.response.data.error.message });
      });
    }
  },
  mounted: function mounted() {
    this.parameters.installationId = this.$route.params.installationCID;
    this.parameters.monthCharges = this.$route.params.monthlyCharge;
    this.parameters.numbOfPayments = this.$route.params.numbOfpayment;
    this.parameters.durationss = this.$route.params.pDuration;
    this.parameters.chargingDate = this.$route.params.chargeDate;
    this.parameters.price = this.$route.params.amounts;
    this.regParams.id = this.$route.params.id;
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';

// import VueNotifications from 'vue-notifications';

var getSearchParams = function getSearchParams(k) {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "new-user",
  components: {
    "el-form": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_6_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioButton"],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Autocomplete"]
  },
  data: function data() {
    return {
      ZcontactList: [],
      formContact: "",
      roleData: [],
      regSuccess: false,
      regDataParams: {
        noMail: true,
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [{
        value: null,
        disabled: true,
        text: "Please select a state"
      }],
      lgaOptions: [{
        value: null,
        disabled: true,
        text: "Please select LGA"
      }]
      // genderOptions: [
      //   {
      //     text: "Male",
      //     value: 1
      //   },
      //   {
      //     text: "Female",
      //     value: 0
      //   }
      // ]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    // lgaOptions() {
    //   const state = this.selectedState;
    //   return state;
    // },
  },
  methods: {
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this.createFilter(queryString, contact);
      }) : contacts;
      cb(results);
    },
    loadAll: function loadAll() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      console.log("++++++++++++++++++++++++++");
      console.log(page);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this2.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    submitReg: function submitReg(e) {
      var _this3 = this;

      e.preventDefault();
      var container = this;
      if (this.formContact.length < 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this3.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var tempReg = this.regDataParams;
        console.log(tempReg);
        var HTTP = this.$httpUtils.instance;
        var url = "/users";
        HTTP.post(url, tempReg).then(function (response) {
          container.regSuccess = true;
          _this3.showSuccessMsg({
            message: "User Created!"
          });
          _this3.$router.push({ path: "/customers" });
        }).catch(function (error) {
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errorMsg);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
              errTemp[index] = keyHooks[index] + " " + x[0];
            });
            errTemp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
            _this3.showErrorMsg({
              message: errTemp
            });
          } else {
            if (tempReg.email == null) {
              _this3.showErrorMsg({
                message: "Please select a contact"
              });
            } else {
              _this3.showErrorMsg({
                message: error.response.data.error.message
              });
            }
          }
        });
      }
    },
    fetchStates: function fetchStates() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        // console.log(JSON.stringify(response))
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState = tempState.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            text: x.text[0].toUpperCase() + x.text.substring(1)
          });
        });
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this4.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/states/" + state + "/lgas";
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga = tempLga.map(function (x) {
            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
              text: x.text[0].toUpperCase() + x.text.substring(1)
            });
          });
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchUserRoles: function fetchUserRoles() {
      //    fetchPreviledges() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var url = "/roles/";
      HTTP.get(url).then(function (response) {
        container.roleData = response.data;
        //  this.$store.commit("setRole", self.roleData);
        //this.setRole(self.roleData);
      }).catch(function (error) {
        console.log("error", error);
      });
      // },
    }
  },
  mounted: function mounted() {
    this.loadAll();
    // (getSearchParams('q') !== undefined)? getSearchParams('q') :
    // (getSearchParams('v') !== undefined)? getSearchParams('v')
    // this.fetchStates();
    // this.fetchUserRoles();
    // const user_type_token = (getSearchParams('s') !== undefined)? getSearchParams('s') : 'CUSTOMER';
    // const user_type_token = this.$route.query.s ||  this.$route.query.q ||  this.$route.query.v || 'CUSTOMER';
    // console.log("===================")
    // var LocationAddr =window.location.toString().split('?')[1];
    // console.log(user_type_token)
    // console.log(getSearchParams('s'));
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_1__utils_Autocomplete__["a" /* default */]
  },
  data: function data() {
    return {
      searchKey: ["first_name", "last_name"],
      displayKey: ["first_name", "last_name"],
      selectedName: "",
      selection: "",
      userId: 0,
      roles: [],
      User: {
        first_name: "",
        last_name: ""
      },
      selectedUser: null,
      roleData: "",
      userRole: []
    };
  },

  computed: {
    userDevices: function userDevices() {
      var devices = this.getDeviceByUserId(this.userId);
      return devices;
    },
    fullname: function fullname() {
      firstname = this.User.first_name === undefined ? this.User.first_name : "";
      lastname = this.User.last_name === undefined ? this.User.last_name : "";
      return firstname + " " + lastname;
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  },
  methods: {
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/users/findOne?filter[where][id][eq]=" + this.userId;
      HTTP.get(url).then(function (response) {
        _this.selectedUser = response.data;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchPrivileges: function fetchPrivileges() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var self = this;
      var url = "/roles/";
      HTTP.get(url).then(function (response) {
        self.roleData = response.data;
        _this2.$store.commit("setRole", self.roleData);
        _this2.roles = response.data;
        console.log("roles", response.data);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchRowMap: function fetchRowMap() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var self = this;
      var url = "/role_mappings/?filter[where][principalId]=" + this.userId + "&filter[include][role]";
      HTTP.get(url).then(function (response) {
        self.userRole = response.data;
        _this3.fetchUsers();
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    alterMap: function alterMap(type, roleId, roleName, userId) {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var self = this;
      var url = "/role_mappings";
      if (type) {
        HTTP.post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          roleId: roleId,
          principalId: userId,
          principalType: roleName
        })).then(function (response) {
          console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          _this4.fetchRowMap();
        }).catch(function (error) {
          console.log("error", error);
        });
      } else {
        HTTP.get(url + "?filter[where][principalId]=" + userId + "&filter[where][roleId]=" + roleId).then(function (response) {
          HTTP.delete(url + "/" + response.data[0].id).then(function (res) {
            _this4.fetchRowMap();
          });
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    }
  },
  mounted: function mounted() {
    this.userId = this.$route.params.userId * 1;
    this.fetchRowMap();
    this.fetchPrivileges();
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';
// import VueNotifications from 'vue-notifications';


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "new-user",
  data: function data() {
    return {
      roleData: [],
      installations: [],
      regSuccess: false,
      isLoading: false,
      isSectionManager: false,
      regParams: {
        firstName: "",
        roleType: "".toLowerCase(),
        assignedDevices: [],
        lastName: "",
        dateOfBirth: new Date(),
        noMail: false,
        gender: null,
        phoneNumber: "",
        realm: "",
        username: "",
        email: "",
        street_route: "",
        password: "<%%>",
        cpassword: "<%%>",
        ccEmails: "",
        stateId: "",
        countryId: 1,
        lgaId: "null"
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [{
        value: null,
        disabled: true,
        text: "Please select a state"
      }],
      lgaOptions: [{
        value: null,
        disabled: true,
        text: "Please select LGA"
      }],
      genderData: [{
        id: 1,
        name: "Male"
      }, {
        id: 0,
        name: "Female"
      }]
      // genderOptions: [
      //   {
      //     text: "Male",
      //     value: 1
      //   },
      //   {
      //     text: "Female",
      //     value: 0
      //   }
      // ]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {
    // lgaOptions() {
    //   const state = this.selectedState;
    //   return state;
    // },
  },
  methods: {
    // updGender(val) {
    //   console.log(val);
    // },
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    checkSelRole: function checkSelRole() {
      var ctx = this;
      var role = ctx.regParams.roleType;
      console.log(ctx.regParams.assignedDevices);
      ctx.isSectionManager = role === "section manager";
      if (ctx.isSectionManager === false) {
        ctx.regParams.assignedDevices = [];
      } else {
        ctx.regParams.assignedDevices = ctx.regParams.assignedDevices.split(",");
      }
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            //   case "stateId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a state.";
            //     }
            //     break;
            //   case "lgaId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a local government.";
            //     }
            //     break;
            //   case "countryId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a country.";
            //     }
            //     break;
            // case "gender":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Gender cannot be empty.";
            //   }
            //   break;
            case "firstName":
              if (value === "null" || value === "") {
                errors[field] = "Firstname cannot be empty.";
                // console.log(this.errors)
              }
              break;
            case "lastName":
              if (value === "null" || value === "") {
                errors[field] = "Lastname cannot be empty.";
              }
              break;
            // case "username":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Username cannot be empty.";
            //   }
            //   break;
            case "email":
              if (value === "null" || value === "") {
                errors[field] = "Email cannot be empty.";
              } else if (!this.isEmail(value)) {
                errors[field] = "Not a valid email.";
              }
              break;
            case "street_route":
              if (value === "null" || value === "") {
                errors[field] = "Address cannot be empty.";
              }
              break;
            case "phoneNumber":
              if (value === "null" || value === "") {
                errors[field] = "Phone cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
      // console.log(this.errors);
    },
    submitReg: function submitReg(e) {
      var _this = this;

      e.preventDefault();
      this.validateReg();
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (container.regParams.roleType === "section manager") {
        if (container.regParams.assignedDevices.length < 1) {
          this.displayError = true;
          setTimeout(function () {
            _this.displayError = false;
          }, 3000);
          var errorMsg = "Assign Device(s) is required";
          this.errorMessage = "Assign Device(s) is required";
          // console.log()
          this.showErrorMsg({
            message: errorMsg
          });
          return;
        }
      }
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        delete tempReg["cpassword"];
        // tempReg["username"] = tempReg["email"];
        // tempReg["assignedDevices"] = JSON.stringify(tempReg["assignedDevices"]);
        // console.log({ tempReg });
        // return;

        this.toggleIsLoading();
        var HTTP = this.$httpUtils.instance;
        var url = "/users/" + this.userId;
        HTTP.patch(url, tempReg).then(function (response) {
          _this.toggleIsLoading();
          container.regSuccess = true;
          _this.showSuccessMsg({
            message: "User Updated!"
          });
          _this.$router.push({ path: "/users/list" });
        }).catch(function (error) {
          _this.toggleIsLoading();
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(errorMsg);
            __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
              errTemp[index] = keyHooks[index] + " " + x[0];
              // console.log(index);
            });
            // console.log("error", errTemp);
            errTemp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
            _this.showErrorMsg({
              message: errTemp
            });
          } else {
            _this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
      }
    },
    fetchStates: function fetchStates() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        // console.log(JSON.stringify(response))
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState = tempState.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
            text: x.text[0].toUpperCase() + x.text.substring(1)
          });
        });
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this2.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/states/" + state + "/lgas";
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga = tempLga.map(function (x) {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
              text: x.text[0].toUpperCase() + x.text.substring(1)
            });
          });
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchInstallations: function fetchInstallations() {
      var ctx = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/installations/";
      var filter = "?filter[where][CID][neq]=null";
      HTTP.get(url + filter).then(function (response) {
        ctx.installations = response.data;
        //  this.$store.commit("setRole", self.roleData);
        //this.setRole(self.roleData);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchUserRoles: function fetchUserRoles() {
      //    fetchPreviledges() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var url = "/users";
      HTTP.get(url).then(function (response) {
        container.roleData = response.data;
        //  this.$store.commit("setRole", self.roleData);
        //this.setRole(self.roleData);
      }).catch(function (error) {
        console.log("error", error);
      });
      // },
    }
  },
  mounted: function mounted() {
    var ctx = this;
    ctx.userId = ctx.$route.params.userId * 1;

    var user = ctx.$route.query.user;
    this.regParams = user;
    this.fetchStates();
    this.fetchUserRoles();
    ctx.fetchInstallations();
    this.checkSelRole();
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(7);










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { VueNotifications } from '../../main';

// import VueNotifications from 'vue-notifications';

var getSearchParams = function getSearchParams(k) {
  var p = {};
  var LocationAddr = window.location.toString().split("?")[1];
  LocationAddr.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
    p[k] = v;
  });
  return k ? p[k] : p;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "new-user",
  data: function data() {
    return {
      roleData: [],
      installations: [],
      regSuccess: false,
      isLoading: false,
      isSectionManager: false,
      regParams: {
        firstName: "",
        roleType: "".toLowerCase(),
        assignedDevices: [],
        lastName: "",
        dateOfBirth: new Date(),
        noMail: false,
        gender: null,
        phoneNumber: "",
        realm: "",
        username: "",
        email: "",
        street_route: "",
        password: "<%%>",
        cpassword: "<%%>",
        ccEmails: "",
        stateId: "",
        countryId: 1,
        lgaId: "null"
      },
      errors: {},
      displayError: false,
      errorMessage: "",
      selectedState: null,
      selectedLga: null,
      stateOptions: [{
        value: null,
        disabled: true,
        text: "Please select a state"
      }],
      lgaOptions: [{
        value: null,
        disabled: true,
        text: "Please select LGA"
      }],
      genderData: [{
        id: 1,
        name: "Male"
      }, {
        id: 0,
        name: "Female"
      }]
      // genderOptions: [
      //   {
      //     text: "Male",
      //     value: 1
      //   },
      //   {
      //     text: "Female",
      //     value: 0
      //   }
      // ]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])(["getUserById"])),
  methods: {
    // updGender(val) {
    //   console.log(val);
    // },
    formatDate: function formatDate(dateString) {
      return new Date().toDateString(dateString);
    },
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    logTHis: function logTHis() {
      var ctx = this;
      ctx.$log({ assisgned: ctx.regParams.assignedDevices });
    },
    checkSelRole: function checkSelRole() {
      var ctx = this;
      var role = ctx.regParams.roleType;
      console.log(ctx.regParams.assignedDevices);
      ctx.isSectionManager = role === "section manager";
      if (ctx.isSectionManager === false) {
        ctx.regParams.assignedDevices = [];
      } else {
        ctx.regParams.assignedDevices = ctx.regParams.assignedDevices.split(",");
      }
    },
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_entries___default()(this.regParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            //   case "stateId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a state.";
            //     }
            //     break;
            //   case "lgaId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a local government.";
            //     }
            //     break;
            //   case "countryId":
            //     if (value === "null" || value === "") {
            //       errors[field] = "Please select a country.";
            //     }
            //     break;
            // case "gender":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Gender cannot be empty.";
            //   }
            //   break;
            case "firstName":
              if (value === "null" || value === "") {
                errors[field] = "Firstname cannot be empty.";
                // console.log(this.errors)
              }
              break;
            case "lastName":
              if (value === "null" || value === "") {
                errors[field] = "Lastname cannot be empty.";
              }
              break;
            // case "username":
            //   if (value === "null" || value === "") {
            //     errors[field] = "Username cannot be empty.";
            //   }
            //   break;
            case "email":
              if (value === "null" || value === "") {
                errors[field] = "Email cannot be empty.";
              } else if (!this.isEmail(value)) {
                errors[field] = "Not a valid email.";
              }
              break;
            case "street_route":
              if (value === "null" || value === "") {
                errors[field] = "Address cannot be empty.";
              }
              break;
            case "phoneNumber":
              if (value === "null" || value === "") {
                errors[field] = "Phone cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = errors;
      // console.log(this.errors);
    },
    submitReg: function submitReg(e) {
      var _this = this;

      e.preventDefault();
      this.validateReg();
      var container = this;
      var errorLength = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (container.regParams.roleType === "section manager") {
        if (container.regParams.assignedDevices.length < 1) {
          this.displayError = true;
          setTimeout(function () {
            _this.displayError = false;
          }, 3000);
          var errorMsg = "Assign Device(s) is required";
          this.errorMessage = "Assign Device(s) is required";
          // console.log()
          this.showErrorMsg({
            message: errorMsg
          });
          return;
        }
      }
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
        // console.log()
        this.showErrorMsg({
          message: errorMsg
        });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.regParams);
        var tempReg = JSON.parse(str);
        delete tempReg["cpassword"];
        // tempReg["username"] = tempReg["email"];
        // tempReg["assignedDevices"] = JSON.stringify(tempReg["assignedDevices"]);
        // console.log({ tempReg });
        // return;

        this.toggleIsLoading();
        var HTTP = this.$httpUtils.instance;
        var url = "/users/" + this.userId;
        // console.log(tempReg);
        container.$log({ params: tempReg });
        // return;
        HTTP.patch(url, tempReg).then(function (response) {
          _this.toggleIsLoading();
          container.regSuccess = true;
          _this.showSuccessMsg({
            message: "User Updated!"
          });
          _this.$router.push({ path: "/users/list" });
        }).catch(function (error) {
          _this.toggleIsLoading();
          // console.log(error.response.data.error);
          if (error.response.data.error.details) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errorMsg);
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
              errTemp[index] = keyHooks[index] + " " + x[0];
              // console.log(index);
            });
            // console.log("error", errTemp);
            errTemp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
            _this.showErrorMsg({
              message: errTemp
            });
          } else {
            _this.showErrorMsg({
              message: error.response.data.error.message
            });
          }
        });
      }
    },
    fetchStates: function fetchStates() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/states";
      HTTP.get(url).then(function (response) {
        // console.log(JSON.stringify(response))
        var statesList = response.data;
        var str = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(statesList);
        str = str.replace(/id/g, "value");
        str = str.replace(/name/g, "text");
        var tempState = JSON.parse(str);
        tempState = tempState.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, x, {
            text: x.text[0].toUpperCase() + x.text.substring(1)
          });
        });
        tempState.unshift({
          value: null,
          disabled: true,
          text: "Please select a state"
        });
        _this2.stateOptions = tempState;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchLgas: function fetchLgas(state) {
      if (state !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/states/" + state + "/lgas";
        HTTP.get(url).then(function (response) {
          var statesList = response.data;
          var str = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(statesList);
          str = str.replace(/id/g, "value");
          str = str.replace(/name/g, "text");
          var tempLga = JSON.parse(str);
          tempLga = tempLga.map(function (x) {
            return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, x, {
              text: x.text[0].toUpperCase() + x.text.substring(1)
            });
          });
          tempLga.unshift({
            value: null,
            disabled: true,
            text: "Please select LGA"
          });
          context.lgaOptions = tempLga;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchInsatallations: function fetchInsatallations() {
      var ctx = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/installations/";
      var filter = "?filter[where][CID][neq]=null";
      HTTP.get(url + filter).then(function (response) {
        ctx.installations = response.data;
        // ctx.$log({ installations: ctx.installations });
        //  this.$store.commit("setRole", self.roleData);
        //this.setRole(self.roleData);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchUserRoles: function fetchUserRoles() {
      var _this3 = this;

      //    fetchPreviledges() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var url = "/users/" + container.userId;
      HTTP.get(url).then(function (response) {
        container.roleData = response.data;
        _this3.regParams = response.data;
        //  this.$store.commit("setRole", self.roleData);
        // this.setRole(self.roleData);
      }).catch(function (error) {
        console.log("error", error);
      });
      // },
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var ctx, user;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              ctx = _this4;

              ctx.$log({ Here: "Hurray" });
              ctx.userId = ctx.$route.params.userId * 1;
              // console.log(ctx)
              // console.log(ctx.$route.params.userId)
              // console.log(ctx.userId)

              _context.next = 5;
              return _this4.getUserById(ctx.userId);

            case 5:
              user = _context.sent;

              // ctx.$log({ user });
              _this4.regParams = user;
              // console.log(this.regParams)
              // (getSearchParams('q') !== undefined)? getSearchParams('q') :
              // (getSearchParams('v') !== undefined)? getSearchParams('v')

              _this4.fetchStates();
              _this4.fetchUserRoles();
              ctx.fetchInsatallations();
              _this4.checkSelRole();

              // const user_type_token = (getSearchParams('s') !== undefined)? getSearchParams('s') : 'CUSTOMER';
              // const user_type_token = this.$route.query.s ||  this.$route.query.q ||  this.$route.query.v || 'CUSTOMER';
              // console.log("===================")
              // var LocationAddr =window.location.toString().split('?')[1];
              // console.log(user_type_token)
              // console.log(getSearchParams('s'));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shs_Wallet__ = __webpack_require__(69);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Card: __WEBPACK_IMPORTED_MODULE_1_element_ui__["Card"],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_3__shs_Wallet__["a" /* default */]
  },
  data: function data() {
    return {
      currentUser: {},
      userId: 0,
      User: {
        firstName: "",
        lastName: ""
      },
      rows: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getDeviceByUserId", "getUserSession"]), {
    // currentUser() {
    //   let user = this.getUserById(this.userId);
    //   this.User = user;
    //   return user;
    // },
    userDevices: function userDevices() {
      var devices = this.getDeviceByUserId(this.userId);
      return devices;
    },
    fullname: function fullname() {
      firstname = this.User.firstName === undefined ? this.User.firstName : "";
      lastname = this.User.lastName === undefined ? this.User.lastName : "";
      return firstname + " " + lastname;
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  }),
  methods: {
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$utils.instance;
      var url = "/users";
      HTTP.get(url).then(function (response) {
        _this.items = usersList;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    navTo: function navTo(deviceId) {
      this.$router.push({ path: "/device/" + deviceId });
    }
  },
  mounted: function mounted() {
    this.userId = this.$route.params.userId * 1;
    this.currentUser = this.getUserById(this.userId);
    // console.log(this.getUsers);
    // console.log(this.getUserById(this.userId));
    // this.fetchUsers();
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {},
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    updateStateFunc: function updateStateFunc() {
      var _this = this;

      console.log("presssed");
      var HTTP = this.$httpUtils.instance;
      HTTP.patch("/onboardingStates", {
        customerid: localStorage.customerId,
        stateid: 6,
        id: localStorage.customerState
      }).then(function (res) {
        _this.$store.commit("saveOnboanrdingState", 6);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    },
    goToDash: function goToDash() {
      var _this2 = this;

      console.log("test");
      var HTTP = this.$httpUtils.instance;
      HTTP.post("/onboardingNotifications/sendAccountRegistrationEmail", {
        firstName: localStorage.firstName,
        lastName: localStorage.lastName,
        email: localStorage.email,
        isCompleted: true
      }).then(function (res) {
        _this2.updateStateFunc();
        if (res.data) {
          console.log(res.data);
          window.location.href = "/";
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(2121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_paystack__ = __webpack_require__(2136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_paystack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_paystack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SpinnerLoader_vue__ = __webpack_require__(2137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);








var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






__WEBPACK_IMPORTED_MODULE_12_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()({
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_11_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioButton"],
    SpinnerLoader: __WEBPACK_IMPORTED_MODULE_8__SpinnerLoader_vue__["a" /* default */]
  }, "SpinnerLoader", __WEBPACK_IMPORTED_MODULE_8__SpinnerLoader_vue__["a" /* default */]),
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      paystackkey: 'pk_test_ef115d721c8b6c98c010166c69eb4b8f57d0dd9a',
      paystackInitialized: false,

      searchTerm: "",
      cardData1: "",
      custData1: "",
      editOffCanvas: false,
      isLoading: false,
      defaultCardSet: false,
      defaultCardID: "",
      custLast4DigitNumber: "",
      amountDue: "",
      totalPrice: "0.00",
      dueDate: "",
      isDue: false,
      notDue: false,
      activeDevice: null,
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      regDataParams: {
        name: name
      },
      selectOption: {
        enabled: false
      },
      items: items,
      debitCards: [],
      getUsersDetails: [],
      checkedUser: [],
      currentID: [],
      selectedDevices: [],
      transactionHistory: [],
      processCard: false,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      },
      fields: [{
        field: "transactionReference",
        label: "Transaction Ref",
        sortable: "true"
      }, {
        field: "fullName",
        label: "Name",
        sortable: "true"
      }, {
        field: "amountPaid",
        label: "Amount",
        sortable: "true"
      }, {
        field: "paymentStatus",
        label: "Transaction Status",
        sortable: "true"
      }, {
        field: "paymentTime",
        label: "Date & Time",
        sortable: "true"
      }]
    }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "transactionHistory", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "total", ""), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "serverParams", {
      perPage: 10,
      page: 1
    }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "devices", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "tempDevicesList", []), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_ref, "newDeviceList", []), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession", "getAssignedDevices"]), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  methods: (_methods = {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("Do MMMM, YYYY");
    },
    formatTime: function formatTime(date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("hh:mm a");
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.init();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.init();
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var url = "/transactionHistories/user";

      httpUtils.instance.get(url + ("?skip=" + (this.serverParams.page - 1) * this.serverParams.perPage + "&limit=" + this.serverParams.perPage)).then(function (response) {
        _this.transactionHistory = response.data[0];
        _this.total = response.data[1].total;
      }).catch(function (error) {
        console.log("transactionUrl error", error);
        _this.showErrorMsg({ message: "Error occured at our end!" });
      });
    },
    changeActiveDevice: function changeActiveDevice(id) {
      this.activeDevice = id;
    },
    show: function show() {
      this.$modal.show("my-first-modal");
    },
    hide: function hide() {
      this.$modal.hide("my-first-modal");
    },
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    fetchDebitCards: function fetchDebitCards(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;

      HTTP.get("/billings/cards").then(function (res) {
        _this2.debitCards = res.data.data;
        console.log(_this2.debitCards);
        if (_this2.debitCards.length === 1 && !_this2.debitCards[0].isDefaultCard) {
          var card = _this2.debitCards[0];
          _this2.setDefaultCard(card.id, card.customerid);
          _this2.fetchDebitCards(_this2.getUserSession.id);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setDefaultCard: function setDefaultCard(cardid, custid) {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var data = { cardId: cardid, customerId: custid };

      HTTP.post("/recurringPaymentSetups/setDefaultCard", data).then(function (res) {
        _this3.processCard = true;
        _this3.defaultCardSet = true;
        _this3.defaultCardID = cardid;
        _this3.fetchDebitCards(_this3.getUserSession.id);
        _this3.showSuccessMsg({ message: "Default card set successfully!" });
      }).catch(function (error) {
        _this3.loader = false;
        console.log({ error: error.response.data.error.message });
        _this3.showErrorMsg({
          message: error.response.data.error.message
        });
      });
    },
    deleteModalCard: function deleteModalCard(cardid, custid, custlastDig) {
      this.cardData1 = cardid;
      this.custData1 = custid;
      this.custLast4DigitNumber = custlastDig;
      this.appear();
    },
    appear: function appear() {
      this.$modal.show("my-second-modal");
    },
    disappear: function disappear() {
      this.$modal.hide("my-second-modal");
    },
    cancelModalCard: function cancelModalCard() {
      this.cardData1 = "";
      this.custData1 = "";
      this.custLast4DigitNumber = "";
      this.disappear();
    },
    deleteCard: function deleteCard(e) {
      var _this4 = this;

      e.preventDefault();

      var HTTP = this.$httpUtils.instance;
      var url = "/recurringPaymentSetups/" + this.cardData1;
      HTTP.delete(url, this.cardData1).then(function (res) {
        _this4.showSuccessMsg({ message: "Card Deleted!" });
      }).catch(function (error) {
        _this4.showErrorMsg({ message: error.response.data.error.message });
      });
      this.disappear();
    },
    makePayment: function makePayment(data) {
      var _this5 = this;

      var httpUtils = this.$httpUtils;
      var url = "/billings/pay";

      this.show();

      httpUtils.instance.post(url, { paymentIds: data }).then(function (response) {
        _this5.hide();
        if (response.data.status == true) {
          //check to be sure the response is an array that has length
          var resData = response.data.data.length ? response.data.data.length : [response.data.data].length;
          for (var i = 0; i < resData; i++) {
            //multi data type response from endpoint so this check is to make sure the code reads the data appropriately
            if (response.data.data.status == "success" || response.data.data[i] && response.data.data[i].value.status == "success") {
              //render success message appropriately
              _this5.showSuccessMsg({
                message: response.data.data[i] ? "Installation ID - " + response.data.data[i].value.installationId + "\n " + response.data.data[i].value.message : response.data.data.message
              });
              _this5.checkedUser = [];
              _this5.totalPrice = "0.00";
              setTimeout(_this5.init(), 3000);
            } else {
              _this5.showErrorMsg({
                message: "Installation ID - " + response.data.data[i].value.installationId + "\n " + response.data.data[i].value.message
              });
              setTimeout(_this5.init(), 3000);
            }
          }
        } else {
          _this5.showErrorMsg({
            message: response.data.data && response.data.data.message ? response.data.data.message : response.data.message
          });
          setTimeout(_this5.init(), 3000);
        }
      }).catch(function (error) {
        _this5.hide();
        console.log("payment error", error);
        _this5.showErrorMsg({ message: "Payment error. Kindly try again!" });
      });
    },
    setCurrentAfterPayment: function setCurrentAfterPayment() {
      var _this6 = this;

      var urlSearchParams = new URLSearchParams(window.location.search);
      var params = Object.fromEntries(urlSearchParams.entries());
      var txref = params["tx_ref"];

      console.log("txref", txref);

      if (!txref) {
        return;
      }
      var data = {
        txref: txref
      };

      var HTTP = this.$httpUtils.instance;
      HTTP.post("/billings/add-card", data).then(function (res) {
        console.log("testing", res.data);
        if (res.data) {
          _this6.showSuccessMsg({ message: "Card successfully added!" });
          _this6.fetchDebitCards(_this6.getUserSession.id);
        } else {
          console.log("Nothing to show here");
        }
        window.history.back();
      }).catch(function (error) {
        _this6.showErrorMsg({
          message: error.response.data.error.message.message
        });
        console.log("testing error", error.response);
      });
    },
    flutterwavePaygate: function flutterwavePaygate(amount) {
      if (amount === "10") this.processCard = true;
      var finalAmount = this.processCard ? amount : this.amountDue;

      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: finalAmount,
        // amount: amount === "10" ? amount : this.firstPaymentAmt ? "10" : "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/billing",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phoneNumber,
          name: this.getUserSession.firstName + " " + this.getUserSession.lastName
        },
        callback: function callback(data) {
          console.log("flutterwaveCheckout", data);
        },
        onclose: function onclose(data) {
          // close modal
          console.log("on close", data);
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
        }
      });
    },
    payMultiple: function payMultiple() {
      var sum = 0;
      var selectedDevices = [];

      for (var i = 0; i < this.checkedUser.length; i++) {
        selectedDevices.push(parseInt(this.checkedUser[i].id));
        sum += parseInt(this.checkedUser[i].monthlyCharge);
      }

      this.selectedDevices = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(selectedDevices)));
      this.totalPrice = sum.toFixed(2).toString();
    }
  }, __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_methods, "formatDate", function formatDate(date) {
    var date1 = new Date();
    var date2 = new Date(__WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("YYYY/MM/DD"));
    var daysleft = Math.ceil((date2.getTime() - date1.getTime()) / (1000 * 3600 * 24));

    if (daysleft > 15) {
      this.notDue = true;
    } else if (daysleft < 1) {
      this.isDue = true;
    }
    if (date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("Do MMMM, YYYY");
    } else {
      return "- - - -";
    }
  }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_methods, "historyDate", function historyDate(date) {
    if (date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).format("Do MMMM, YYYY");
    } else {
      return "- - - -";
    }
  }), __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_defineProperty___default()(_methods, "init", function init() {
    var _this7 = this;

    var httpUtils = this.$httpUtils;
    var dashboardUrl = "/billings/dashboard";
    var transactionUrl = "/transactionHistories/user";

    httpUtils.instance.get(dashboardUrl).then(function (response) {
      console.log(response.data);
      _this7.amountDue = response.data.data.summary.monthlyCharge;
      _this7.currentID[0] = parseInt(response.data.data.summary.id);
      _this7.dueDate = response.data.data.summary.monthlyrecurringchargedate;
      _this7.getUsersDetails = response.data.data.schedule;
    }).catch(function (error) {
      console.log("tracker error", error);
    });

    httpUtils.instance.get(transactionUrl).then(function (response) {
      _this7.transactionHistory = response.data[0].slice(0, 5);
      console.log("t response", _this7.transactionHistory);
    }).catch(function (error) {
      console.log("transactionUrl error", error);
      _this7.showErrorMsg({ message: "Error occured at our end!" });
    });
  }), _methods),
  mounted: function mounted() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this8.init();
              _this8.fetchDebitCards(_this8.getUserSession.id);
              _this8.setCurrentAfterPayment();
              if (_this8.$can("am", "sm")) {
                _this8.devices = JSON.parse(_this8.getUserSession.assignedDevices);
                // JSON.parse(this.getUserSession.assignedDevices).map((dev, ind) => {
                //   this.getUsersDetails.map(single => {
                //     console.log('user session', single)
                //     if (single.cid === dev) this.devices.splice(ind, 1)
                //   })
                // })
              } else {
                _this8.devices = _this8.getAssignedDevices;
                // this.getAssignedDevices.map((dev, ind) => {
                //   this.getUsersDetails.map('assigned session', single => {
                //     if (single.cid === dev) this.devices.splice(ind, 1)
                //   })
                // })
              }
              _this8.changeActiveDevice(_this8.devices[0]);
              console.log(_this8.devices);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this8);
    }))();
  }
});

/***/ }),
/* 905 */,
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SpinnerLoader"
});

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/visa-logo.404e9f1.png";

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

/* harmony default export */ __webpack_exports__["a"] = ({
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      fields: [{
        field: "transactionReference",
        label: "Transaction Ref",
        sortable: "true"
      }, {
        field: "fullName",
        label: "Name",
        sortable: "true"
      }, {
        field: "amountPaid",
        label: "Amount",
        sortable: "true"
      }, {
        field: "paymentStatus",
        label: "Transaction Status",
        sortable: "true"
      }, {
        field: "paymentTime",
        label: "Date & Time",
        sortable: "true"
      }],
      transactionHistory: "",
      total: "",
      serverParams: {
        perPage: 10,
        page: 1
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"])),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("Do MMMM, YYYY");
    },
    formatTime: function formatTime(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("hh:mm a");
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.init();
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.init();
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var url = "/transactionHistories/user";

      httpUtils.instance.get(url + ("?skip=" + (this.serverParams.page - 1) * this.serverParams.perPage + "&limit=" + this.serverParams.perPage)).then(function (response) {
        _this.transactionHistory = response.data[0];
        _this.total = response.data[1].total;
      }).catch(function (error) {
        console.log("transactionUrl error", error);
        _this.showErrorMsg({ message: "Error occured at our end!" });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_6_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      editOffCanvas: false,
      isLoading: false,
      isLoadingVGT: true,
      regDataParams: {
        name: name
      },
      selectOption: {
        enabled: false
      },
      items: items,
      fields: [{
        field: "fullName",
        label: "Customer Name",
        sortable: "true"
      }, {
        field: "startDate",
        label: "Onboarding Start Date",
        sortable: "true"
      }, {
        field: "completionDate",
        label: "Completion Date",
        sortable: "true"
      }, {
        field: "paymentType",
        label: "Chosen Payment Type",
        sortable: "true"
      }, {
        field: "productType",
        label: "Product Type",
        sortable: "true"
      }, {
        field: "signedAgreement",
        label: "Signed Agreement",
        sortable: "true"
      }, {
        field: "paymentTenure",
        label: "Payment Tenure",
        sortable: "true"
      }, {
        field: "statementPassed",
        label: "Statement Passed",
        sortable: "true"
      }, {
        field: "kycUploadComplete",
        label: "KYC Upload",
        sortable: "true"
      }, {
        field: "depositSuccessful",
        label: "Deposit Successful?",
        sortable: "true"
      }, {
        field: "installationStatus",
        label: "Installation Status",
        sortable: "true"
      }, {
        field: "installationDate",
        label: "Installation Date",
        sortable: "true"
      }],
      getUsers: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    tickOrCross: function tickOrCross(e) {
      if (e == "Y") {
        return __webpack_require__(911);
      } else {
        return __webpack_require__(912);
      }
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    toggleEditCanvas: function toggleEditCanvas(data) {
      this.regDataParams = data;
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("Do MMM YYYY");
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var url = "/onboardingStates/getUsersDataWithStatus";

      httpUtils.instance.get(url).then(function (response) {
        console.log("onboard-tracker", response.data);
        _this.getUsers = response.data;
        _this.isLoadingVGT = false;
      }).catch(function (error) {
        console.log("tracker error", error);
        _this.showErrorMsg({ message: "Error occured at our end!" });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAvVBMVEUAAABmxFVpwllpwllqwllqwllqwlpqwVhoxlVrwVhqwllqwllrwllov1hpwllqwllqwllpwVhqwVprw1htv1tsxFhqwVlqwllpwllqw1lqv1VpwllqwllpwVhqwllqwllqwllqwlhpwlhqwllqwllmv1lqwVpqwllqwllowlprwVlqwllqwllpw1prwlpqw1hqwllqw1lqwllqwllmwlxpxFdqw1lrw1ttwlVqwVppwlpqwVpqw1lqwlkAAACZv1C6AAAAPXRSTlMAHm242PRsHRuZ/P2qIFDz8k5vbhwaneub1xh+w2u3ibXbhdHUFFvZ8DZW++4zaZzvmPjxGUlNTBWRorZq85SzYAAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjBxAQIjVTGmlwAAAA6klEQVQoz2WS63qCMAyGI6BocWvRzokbG1N3UOZhgocdev+3tYSitDU/0jxvvjQlAUBby/ODdjvwOyGY1u0xVVvUv2n4LVeGifjMB5GyLBrWeodjpqqRXF2ZuMPEyIH35Mb4TmbzZPKAnknwXA7wiGcKT1f8mYIMXkweYNOpjkDQMUuZpcd3VYn5K7wxi2PiHf3HAmCZN/dQsW7+ucIBGHpq3qlOqjH0Sq0h1B9INY1e5RJgo8PtwtCrL1qS0PHO4EVJN++daeHYD3ohQ3dR3nmFsTB5cWyWfvrOL/Kf0vpPZPqbcJ5kf7IG/8nTWZM+aiDXAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE5LTA3LTE2VDE0OjM0OjUzKzAyOjAwVKWlCgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOS0wNy0xNlQxNDozNDo1MyswMjowMCX4HbYAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAnFBMVEUAAAD3a1r4aFr3aVv3aFz3aFv4Z1v3Zl72alj3Z1z3aFv3aFv4aFz4aVr4Z1r3aFv3aFv1aVz4Z1z4aVv3aFv4aVz3aFv3aFv2ZFv3aFv3aFv3Z1r3aFr4Z1v3aVz4aFz3aFz3aFv3aVv3alr2aFv3Z1v3aFv3aVn4aVv2Z1v/cVX3aFr2aF74Z1z4aFv3aFv3aFj3Z1r3aFsAAAC5Ug7IAAAAMnRSTlMAH2633PVtHh2Z+/2qIkrw81BvSfxO8vEcnZo+W4o9bLXa9EE7tP4/a+8JmxtITKIg2ZAu0vAAAAABYktHRACIBR1IAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4wcQEQI3KVJGyQAAANVJREFUKM91UukagjAMqxyOQyd4IAoConJ4s/d/OMcKTgTyA2iyj6bNABATRdV0XVOnBH5hmBZrYM/mkqcL9gPHbfmlzTqwFeRXa/YHe1PzxGM9bH0u7NgA9twn+gmoIxqHB1FaBBQ8QiHiihNBiHUMauMx4op4YJ2AxqQieXaEtO2nnwDOX4fOmOCN/2qk+QWm4p3lrV2KQgFEDFhecxyQBjigAXATX2XWWYlZhzS0xHu93kd/7U8MRBkJikfVidZzZei+vAzW6925JyROqjStksJoiA9ouUmKNI12dAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAxOS0wNy0xNlQxNTowMjo1NSswMjowMH4fX/MAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMTktMDctMTZUMTU6MDI6NTUrMDI6MDAPQudPAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAABJRU5ErkJggg=="

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_adminBilling_BillingListing_vue__ = __webpack_require__(2149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AdminBilling",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_1_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_1_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_1_element_ui__["RadioButton"],
    BillingListing: __WEBPACK_IMPORTED_MODULE_0__components_pages_adminBilling_BillingListing_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      usertype: localStorage.roleType
    };
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BillingListing",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_6_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      isLoadingVGT: true,
      editOffCanvas: false,
      isLoading: false,
      deleteReason: "",
      idSelected: "",
      disableButton: "",
      userID: "",
      regParams: {},
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [{
        field: "firstName",
        label: "First Name",
        sortable: "true"
      }, {
        field: "lastName",
        label: "Last Name",
        sortable: "true"
      }, {
        field: "deviceId",
        label: "Device ID",
        sortable: "true"
      }, {
        field: "totalPrice",
        label: "Total Price (NGN)",
        sortable: "true"
      }, {
        field: "monthlyCharge",
        label: "Monthly Charge (NGN)",
        sortable: "true"
      }, {
        field: "amountPaid",
        label: "Amount Paid (NGN)",
        sortable: "true"
      }, {
        field: "remainingPayment",
        label: "Amount Remaining (NGN)"
      }, {
        field: "numberOfTimesPaymentIsMade",
        label: "Number of payment made",
        sortable: "true"
      }, {
        field: "remainingDuration",
        label: "no. of payment remaining"
      }, {
        field: "monthlyRecurringChargeDate",
        label: "Recurring Date",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      getUsers: "",
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      showModal: true,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUsers"]), {
    sortOptions: function sortOptions() {
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    show: function show() {
      this.$modal.show("my-first-modal");
    },
    hide: function hide() {
      this.$modal.hide("my-first-modal");
    },
    toggleIsLoading: function toggleIsLoading() {
      this.isLoading = !this.isLoading;
    },
    deleteModal: function deleteModal(data1, data2) {
      this.idSelected = data1;
      this.userID = data2;
      this.show();
    },
    cancel: function cancel() {
      this.idSelected = "";
      this.userID = "";
      this.hide();
    },
    deleteDevice: function deleteDevice(userIds) {
      var _this = this;

      console.log(userIds);
      var HTTP = this.$httpUtils.instance;
      var url = "/billings/" + userIds;
      HTTP.delete(url, this.userID).then(function (res) {
        _this.showSuccessMsg({ message: "Device Deleted!" });
        _this.init();
        _this.hide();
        console.log("DELETED");
      }).catch(function (error) {
        _this.showErrorMsg({ message: error.response.data.error.message });
      });
    },
    validateInput: function validateInput() {
      this.deleteReason = document.forms["myForm"]["fname"].value;
      if (this.deleteReason == "") {
        alert("Name must be filled out");
        return false;
      }
      return true;
      // if (
      //   this.deleteReason.value === "null" ||
      //   this.deleteReason.value === "NaN"
      // ) {
      //   console.log(`field is empty`);
      // } else {
      //   console.log("field is filled");
      // }
    },
    deletionDetails: function deletionDetails(callback) {
      var _this2 = this;

      if (!this.validateInput()) return;

      var httpUtils = this.$httpUtils;
      // let url = `/billings/getAllUserSchedules?filter={"where":{"id":${this.userID}}}`;
      // httpUtils.instance
      //   .get(url)
      //  log({ okay });
      // }) .then(response => {
      // console.log(url, this.userID);
      // let pass = response.data.data[0];
      // let okay = pass.find(obj => (obj.id = this.userID));
      // console.
      // .catch(error => {
      //   this.showErrorMsg({ message: "Error occured at our end!" });
      // });
      console.log("Hello world");
      console.log(this.deleteReason);

      // what to delete
      // return
      var userIds = this.userID;
      callback(userIds);

      var HTTP = this.$httpUtils.instance;
      HTTP.post("/CustomerDeletedBillings", { billingId: this.userID, deleteReason: this.deleteReason }).then(function (res) {
        console.log("customer deleted");
      }).catch(function (error) {
        _this2.showErrorMsg({
          message: error.response.data.error.message.message
        });
        _this2.showErrorMsg({ message: showInfoMsg });
      });
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    toggleEditCanvas: function toggleEditCanvas(data) {
      this.regParams = data;
      this.editOffCanvas = !this.editOffCanvas;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("DD MMMM, YYYY");
    },
    init: function init() {
      var _this3 = this;

      var httpUtils = this.$httpUtils;
      var url = "/billings/getAllUserSchedules";

      httpUtils.instance.get(url).then(function (response) {
        _this3.getUsers = response.data.data[0];
        _this3.isLoadingVGT = false;
      }).catch(function (error) {
        _this3.showErrorMsg({ message: "Error occured at our end!" });
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this4.init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DeviceSerial_vue__ = __webpack_require__(2155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LuxPayment_vue__ = __webpack_require__(2158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LuxMisc_vue__ = __webpack_require__(2161);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LuxOnboarding",
  data: function data() {
    return {};
  },

  components: {
    DeviceSerial: __WEBPACK_IMPORTED_MODULE_0__DeviceSerial_vue__["a" /* default */],
    LuxPayment: __WEBPACK_IMPORTED_MODULE_1__LuxPayment_vue__["a" /* default */],
    LuxMisc: __WEBPACK_IMPORTED_MODULE_2__LuxMisc_vue__["a" /* default */]
  },
  methods: {}
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui_src_utils_util__ = __webpack_require__(219);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DeviceSerial",
  data: function data() {
    return {
      regparams: {
        deviceId: "",
        serialNumbers: []
      },
      errorsResult: {},
      validateError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg: function validateReg() {
      var _this = this;

      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regparams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== null && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "deviceId":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_8_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "DeviceID cannot be empty.";
              }
              break;
            case "serialNumbers":
              if (value === [] || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_8_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Serial Number cannot be empty.";
              }
              break;
            default:
              break;
          }
          this.errorsResult = errors;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var errorLength = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(function () {
          _this.displayError == false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    dataPassage: function dataPassage() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    submit: function submit() {
      this.validateReg();
      var LuxOnboardingStatus = this.$store.state.luxOnboardingStatus;
      if (this.validateError === false) {
        LuxOnboardingStatus.deviceId = this.regparams.deviceId;
        LuxOnboardingStatus.serialNumbers = this.regparams.serialNumbers;
        this.$store.state.luxCount = 2;
      } else {
        console.log("Validate data first");
      }
    },
    back: function back() {
      window.history.back();
    }
  }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__ = __webpack_require__(219);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LuxPayment",
  components: {},
  data: function data() {
    return {
      StoreLuxOnboardingStatus: this.$store.state.luxOnboardingStatus,
      StateLuxPaymentStatus: this.$store.state.luxPaymentStatus,
      GetLuxOnboardingStates: this.$store.getters.getLuxOnboardingStates,
      luxPayment: {
        paymentType: "",
        cLoadValue: "",
        deviceVersion: "",
        CID: "",
        Charge: "",
        ExptdCharge: ""
      },
      validateError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg: function validateReg() {
      var _this = this;

      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.luxPayment)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== null && value !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "paymentType":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "paymentType cannot be empty.";
              }
              break;
            case "cLoadValue":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "cLoadValue cannot be empty.";
              }
              break;
            case "deviceVersion":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "deviceVersion cannot be empty.";
              }
              break;
            case "CID":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "CID cannot be empty.";
              }
              break;
            case "ChgCycle":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Charge cannot be empty.";
              }
              break;
            case "ExptdChgCyl":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "ExptdCharge cannot be empty.";
              }
              break;
            default:
              break;
          }
          this.errorsResult = errors;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var errorLength = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.validateReg();
      if (this.validateError === false) {
        var MiscData = {
          CID: this.luxPayment.CID,
          ChgCycle: this.luxPayment.Charge,
          ExptdChgCyl: this.luxPayment.ExptdCharge
        };
        var allParams = {
          deviceId: this.StoreLuxOnboardingStatus.deviceId,
          serialNumbers: this.StoreLuxOnboardingStatus.serialNumbers,
          paymentType: this.luxPayment.paymentType,
          CLoad: this.luxPayment.cLoadValue,
          Version: this.luxPayment.deviceVersion,
          MiscData: MiscData
        };

        var LuxHTTP = this.$httpUtils.LUXHTTP;
        var url = "/devices";
        LuxHTTP.post(url, allParams).then(function (response) {
          _this2.showSuccessMsg({ message: "Device setup successfully!" });
          window.history.back();
          _this2.$store.state.luxCount = 1;
        }).catch(function (error) {
          _this2.showErrorMsg({ message: "Error occured at our end!" });
        });
      } else {
        console.log("Validate data first");
      }
    },
    back: function back() {
      this.$store.state.luxCount = 1;
      this.GetLuxOnboardingStates.serialNumbers = [];
      this.GetLuxOnboardingStates.deviceId = "";
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__ = __webpack_require__(219);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LuxMisc",
  components: {},
  data: function data() {
    return {
      GetLuxOnboardingStates: this.$store.getters.getLuxOnboardingStates,
      GetLuxPaymentStates: this.$store.getters.getLuxPaymentStates,
      StoreLuxOnboardingStatus: this.$store.state.luxOnboardingStatus,
      StoreLuxPaymentStatus: this.$store.state.luxPaymentStatus,
      regparams: {
        CID: "",
        Charge: "",
        ExptdCharge: "",
        LAC: "",
        MCC: "",
        MNC: "",
        PAP: "",
        PAT: "",
        PSC: "",
        Radio: "",
        SIM: ""
      },
      validateError: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg: function validateReg() {
      var _this = this;

      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.regparams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== null && value !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "CID":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "CID cannot be empty.";
              }
              break;
            case "Charge":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Charge cannot be empty.";
              }
              break;
            case "ExptdCharge":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "ExptdCharge cannot be empty.";
              }
              break;
            case "LAC":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "LAC cannot be empty.";
              }
              break;
            case "MCC":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "MCC cannot be empty.";
              }
              break;
            case "MNC":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "MNC cannot be empty.";
              }
              break;
            case "PAP":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "PAP cannot be empty.";
              }
              break;
            case "PAT":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "PAT cannot be empty.";
              }
              break;
            case "PSC":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "PSC cannot be empty.";
              }
              break;
            case "Radio":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Radio cannot be empty.";
              }
              break;
            case "SIM":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "SIM cannot be empty.";
              }
              break;
            default:
              break;
          }
          this.errorsResult = errors;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var errorLength = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        this.validateError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      } else {
        this.validateError = false;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.validateReg();
      if (this.validateError === false) {
        var MiscData = {
          PSC: this.regparams.PSC,
          PAT: this.regparams.PAT,
          MNC: this.regparams.MNC,
          ChgCycle: this.regparams.Charge,
          ExptdChgCyl: this.regparams.ExptdCharge,
          SIM: this.regparams.SIM,
          Radio: this.regparams.Radio,
          MCC: this.regparams.MCC,
          PAP: this.regparams.PAP,
          CID: this.regparams.CID,
          LAC: this.regparams.LAC
        };
        var allParams = {
          deviceId: this.StoreLuxOnboardingStatus.deviceId,
          serialNumbers: this.StoreLuxOnboardingStatus.serialNumbers,
          paymentType: this.StoreLuxPaymentStatus.paymentType,
          Version: this.StoreLuxPaymentStatus.deviceVersion,
          CLoad: this.StoreLuxPaymentStatus.cLoadValue,
          MiscData: MiscData
        };
        console.log("Here are your data:", allParams);

        var LuxHTTP = this.$httpUtils.LUXHTTP;
        var url = "/devices";

        LuxHTTP.post(url, allParams).then(function (response) {
          console.log("response", response);
          _this2.showSuccessMsg({ message: "Device setup successfully!" });
          window.history.back();
          _this2.$store.state.luxCount = 1;
        }).catch(function (error) {
          _this2.showErrorMsg({ message: "Error occured at our end!" });
        });
      } else {
        console.log("Validate data first");
      }
    },
    back: function back() {
      this.$store.state.luxCount = 2;
      this.GetLuxOnboardingStates.serialNumbers = [];
      this.GetLuxOnboardingStates.deviceId = "";
      this.GetLuxPaymentStates.paymentType = "";
      this.GetLuxPaymentStates.cLoadValue = "";
      this.GetLuxPaymentStates.deviceVersion = "";
    }
  }
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__ = __webpack_require__(219);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LuxDeviceUpdate",
  data: function data() {
    return {
      regparams: {
        serialNumbers: [],
        paymentType: "",
        CLoad: "",
        Version: "",
        MiscData: {
          CID: "",
          ChgCycle: "",
          ExptdChgCyl: "",
          LAC: "",
          MCC: "",
          MNC: "",
          PAP: "",
          PAT: "",
          PSC: "",
          Radio: "",
          SIM: ""
        }
      },
      errorsResult: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    validateReg: function validateReg() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regparams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== null && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "serialNumbers":
              if (value === [] || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Serial Number cannot be empty.";
              }
              break;
            case "paymentType":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Payment type cannot be empty.";
              }
              break;
            case "CLoad":
              if (value === "" || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Contractual Load cannot be empty.";
              }
              break;
            case "Version":
              if (value === null || value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(value)) {
                errors[field] = "Device version cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.regparams.MiscData)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref3 = _step2.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var _field = _ref4[0];
          var _value = _ref4[1];

          _value = _value + "";
          if (_value !== null && _value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(_value)) {
            _value = _value.trim();
          }
          switch (_field) {
            case "CID":
              if (_value === "" || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "CID cannot be empty.";
              }
              break;
            case "ChgCycle":
              if (_value === [] || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "Charge Cycle cannot be empty.";
              }
              break;
            case "ExptdChgCyl":
              if (_value === "" || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "Expected Charge cycle cannot be empty.";
              }
              break;
            case "LAC":
              if (_value === "" || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "LAC cannot be empty.";
              }
              break;
            case "MCC":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "MCC cannot be empty.";
              }
              break;
            case "PAP":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "PAP cannot be empty.";
              }
              break;
            case "PAT":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "PAT cannot be empty.";
              }
              break;
            case "PSC":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "PSC cannot be empty.";
              }
              break;
            case "Radio":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "RADIO cannot be empty.";
              }
              break;
            case "SIM":
              if (_value === null || _value === NaN || Object(__WEBPACK_IMPORTED_MODULE_6_element_ui_src_utils_util__["a" /* isEmpty */])(_value)) {
                errors[_field] = "SIM cannot be empty.";
              }
              break;
            default:
              break;
          }
          this.errorsResult = errors;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    submit: function submit() {
      var _this = this;

      this.validateReg();
      var errorLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errorsResult).length;
      if (errorLength > 0) {
        this.errorMessage = "Fill All FIelds!!!";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 3000);
        var errorMsg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.errorsResult).join("<br>");
        this.showErrorMsg({
          message: errorMsg
        });

        return;
      }
      var LuxHTTP = this.$httpUtils.LUXHTTP;
      var url = "/devices/" + this.$route.params.exportDeviceid;
      LuxHTTP.patch(url, this.regparams).then(function (res) {
        console.log("response", res);
        _this.showSuccessMsg({
          message: "Your LUX onboarding update was successful"
        });
        window.history.back();
      }).catch(function (error) {
        console.log("setup error", error.response);
        _this.showErrorMsg({ message: error.response.data.detail.message });
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale("en", {
  monthsShort: "Jan_Feb_Mar_Apr_May_June_July_Aug_Sept_Oct_Nov_Dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ListLuxUsers",
  components: {},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      luxTotalEnergy: "",
      editOffCanvas: false,
      isLoading: false,
      idSelected: "",
      DeviceID: "",
      regParams: {},
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },
      items: items,

      fields: [{
        field: "deviceId",
        label: "Device ID",
        sortable: "true"
      }, {
        field: "serialNumbers",
        label: "Serial Number(s)",
        sortable: "true"
      }, {
        field: "Version",
        label: "System Version",
        sortable: "true"
      }, {
        field: "paymentType",
        label: "Payment Type",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      getUsers: "",
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15]
    };
  },

  computed: {
    // ...mapGetters(["getUsers"])
  },
  methods: {
    show: function show() {
      this.$modal.show("my-first-modal");
    },
    hide: function hide() {
      this.$modal.hide("my-first-modal");
    },
    deleteModal: function deleteModal(deviceIDdata) {
      this.DeviceID = deviceIDdata;
      this.show();
    },
    cancel: function cancel() {
      this.hide();
      this.DeviceID = "";
    },
    deleteDevice: function deleteDevice(e) {
      var _this = this;

      e.preventDefault();

      var LuxHTTP = this.$httpUtils.LUXHTTP;
      var url = "devices/" + this.DeviceID;
      LuxHTTP.delete(url, this.DeviceID).then(function (res) {
        _this.showSuccessMsg({ message: "Device Deleted!" });
        _this.init();
        _this.hide();
      }).catch(function (error) {
        _this.showErrorMsg({ message: error.response.data.error.message });
      });
    },
    totalEnergy: function totalEnergy() {
      var _this2 = this;

      var LuxHTTP = this.$httpUtils.LUXHTTP;
      var url = "/inverters/total-energy-generated";

      LuxHTTP.get(url).then(function (response) {
        _this2.luxTotalEnergy = response.data.data;
      }).catch(function (error) {
        _this2.showErrorMsg({ message: "Error occured at our end!" });
      });
    },
    init: function init() {
      var _this3 = this;

      var LuxHTTP = this.$httpUtils.LUXHTTP;
      var url = "/devices";

      LuxHTTP.get(url).then(function (response) {
        _this3.getUsers = response.data.data;
      }).catch(function (error) {
        _this3.showErrorMsg({ message: "Error occured at our end!" });
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this4.init();
              _this4.totalEnergy();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_transaction_history_vue__ = __webpack_require__(922);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

/* harmony default export */ __webpack_exports__["a"] = ({
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      period: "",
      fields: [{
        field: "transactionReference",
        label: "Transaction Ref",
        sortable: "true"
      }, {
        field: "fullName",
        label: "Name",
        sortable: "true"
      }, {
        field: "amountPaid",
        label: "Amount",
        sortable: "true"
      }, {
        field: "paymentStatus",
        label: "Transaction Status",
        sortable: "true"
      }, {
        field: "transactionType",
        label: "Transaction Type",
        sortable: "true"
      }, {
        field: "paymentTime",
        label: "Date & Time",
        sortable: "true"
      }],
      transactionHistories: "",
      serverParams: {
        perPage: 10,
        page: 1
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["transactionHistories"])),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("Do MMMM, YYYY");
    },
    formatTime: function formatTime(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format("hh:mm a");
    },
    updateParams: function updateParams(newProps) {
      this.serverParams = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.serverParams, newProps);
    },
    onPageChange: function onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.init();
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      var term = searchTerm.toLowerCase();

      var startDate = this.period[0] !== undefined ? this.period[0] : false;
      var endDate = this.period[1] !== undefined ? this.period[1] : false;

      var transCheck = row.transactionReference.indexOf(term) > -1;
      var userCheck = row.detail && row.detail.customer && row.detail.customer.name && row.detail.customer.name.toLowerCase().indexOf(term) > -1;
      var dateCheck = startDate == false ? true : __WEBPACK_IMPORTED_MODULE_5_moment___default()(row.createdAt).isBetween(startDate, endDate, "days") ? true : false;

      if ((transCheck || userCheck) && dateCheck) {
        return true;
      }
      return false;
    },
    onPerPageChange: function onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage });
      this.init();
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var url = "/transactionHistories";

      httpUtils.instance.get(url + '/?filter[order]=id%20DESC').then(function (response) {
        console.log(response.data);
        _this.transactionHistories = response.data;
      }).catch(function (error) {
        console.log("transactionUrl error", error);
        _this.showErrorMsg({ message: "Error occured at our end!" });
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transaction_history_vue__ = __webpack_require__(923);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3888662e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transaction_history_vue__ = __webpack_require__(2174);
function injectStyle (ssrContext) {
  __webpack_require__(2173)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3888662e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transaction_history_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3888662e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transaction_history_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_3_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   Inventory
  // },
  data: function data() {
    return {
      searchTerm: "",
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      cxTeamFields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roletype",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phonenumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedat",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      cxTeamFieldsAdmin: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getUsersAdmin", "getDummy", "getDevices"]), {
    isACxTeam: {
      get: function get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    pressFunc: function pressFunc() {
      console.log('i was presseed');
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit("saveUsers", usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchUsersAdmin: function fetchUsersAdmin() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var data = new FormData();
      var id = localStorage.customerId;
      data.append("customerAdminUserId", id);
      //  filter={"include": ["installations"]}
      var url = "/groupUsers/getUsersByCustomerAdmin";
      HTTP.post(url, data).then(function (response) {
        var usersList = response.data;
        _this2.$store.commit("saveUsersAdmin", usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsersAdmin();
    this.fetchUsers();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions__ = __webpack_require__(48);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Card"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["OptionGroup"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["Input"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_element_ui__["InputNumber"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchTerm: "",
      value: null,
      searchOption: {},
      options: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      selectOption: {
        enabled: true
      },
      columns: [{
        label: "Full Name",
        field: "fullname"
      }, {
        label: "Email",
        field: "email"
      }, {
        label: "Phone Number",
        field: "phonenumber",
        type: "number"
      }, {
        label: "Customer Type",
        field: "customertype"
      }, {
        label: "Last Seen",
        field: "lastseen"
      }],
      rows: [{
        id: 1,
        fullname: "John Wick",
        email: "johnwick@gmail.com",
        phonenumber: "2011-10-31",
        customertype: "Agent",
        lastseen: "Dec 9, 2017 "
      }, {
        id: 2,
        fullname: "Jane Aniston",
        email: "janeaniston@gmail.com",
        phonenumber: "2011-10-31",
        customertype: "CEO",
        lastseen: "14 minutes ago"
      }, {
        id: 3,
        fullname: "Susan Hall",
        email: "susanhall@gmail.com",
        phonenumber: "2011-10-30",
        customertype: "Manager",
        lastseen: "6 Hours ago"
      }, {
        id: 4,
        fullname: "Chris Pratt",
        email: "chrispratt@gmail.com",
        phonenumber: "2011-10-11",
        customertype: "Manager",
        lastseen: "20 Minutes ago"
      }, {
        id: 5,
        fullname: "Dan Schwarz",
        email: "danschwarz@gmail.com",
        phonenumber: "2011-10-21",
        customertype: "Engineer",
        lastseen: "5 Minutes ago"
      }, {
        id: 6,
        fullname: "Jax Briggs",
        email: "jaxbriggs@gmail.com",
        phonenumber: "2011-10-31",
        customertype: "Security",
        lastseen: "2 Minutes ago"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  components: {
    // GreyPagination
  },
  methods: {
    navTo: function navTo(page) {
      this.$router.push({
        name: page,
        params: {}
      });
      // console.log(user);
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getStatData: function getStatData() {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "06-12-2019";

      console.log('>>>>>>>>>>>>>>>>>>>>>>>');
      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "EnergyData",
        KeyConditionExpression: "Date = :key",
        ExpressionAttributeValues: {
          ":key": date
        }
        // Limit: limit,
        // ScanIndexForward: false
      };
      // console.log(data)
      __WEBPACK_IMPORTED_MODULE_4__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        console.log('>>>>>>>>>>>>>>>>>>>>>>>');
        console.log(DevData);
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  mounted: function mounted() {
    // this.getStatData();
    if (!this.$can("read", "dashboard")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    //console.log(JSON.stringify(this.getUserSession));
    // this.$ability.update([{ subject: 'CUSTOMER', actions: 'all' }]);
    // console.log(this.$ability);
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(926);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9959f88a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2180);
function injectStyle (ssrContext) {
  __webpack_require__(2179)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9959f88a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(7);











var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      multiple: true,
      responseData: '',
      rows: [],
      fields: [{
        label: "Name",
        key: "name",
        field: "name",
        sortable: "true"
        // {
        //   label: "Description",
        //   key: "description",
        //   field: "description",
        //   sortable: "true"
        // }
      }],
      inventoryCount: {},
      componentName: [],
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null,
        type: 'component',
        userId: 0
      },
      serialForm: {
        min: null,
        max: null
      },
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"]), {
    b: function b() {
      // `this` points to the vm instance
      return this.inventoryCount;
    },
    inventoryCounter: {
      // getter
      get: function get() {
        return this.inventoryCount;
      },
      // setter
      set: function set(newValue) {
        this.inventoryCount = newValue;
      }
    }
  }),
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: (_methods = {
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      console.log(selectedCompId);
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          context.componentTypeOptions = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(context.componentTypeOptions), __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(componentList));
        });
      }
    },
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.componentForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return 'Please fill all fields!';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    addInventory: function addInventory() {
      var url = "/inventories";
      if (this.multiple) {
        this.componentForm.serialNumber = this.serialForm.min + "->" + this.serialForm.max;
        url = "/inventories/multiple";
      }
      if (this.validateRequestForm() === true) {
        this.componentForm.userId = this.getUserSession.id;
        var container = this;
        var HTTP = this.$httpUtils.instance;
        HTTP.post(url, this.componentForm).then(function (response) {
          container.showSuccessMsg({ message: response.data + '\nComponent(s) Added' });
          container.hideModal();
          container.getComponents();
        }).catch(function (error) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + ' ' + x[0];
          });
          errTemp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errTemp).join('<br>');
          container.showErrorMsg({
            message: errTemp
          });
        });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    },

    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    getComponentName: function getComponentName(param) {
      try {
        return this.componentOptions.filter(function (x) {
          return x.value == param;
        })[0].name;
      } catch (error) {
        return '';
      }
    },
    getComponents: function getComponents() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/component_types/?filter={\"include\": [\"component\"]}", {}).then(function (components) {
        container.rows = components.data;
        components.data.forEach(function (element) {
          _this.componentName[element.id] = element.component.name;
          container.getComponentCount(element.id);
        });
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "random_num", function random_num(dumm) {
    return Math.floor(Math.random(9999) * 9999);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showModal", function showModal() {
    this.$refs.myModalRef.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "hideModal", function hideModal() {
    this.$refs.myModalRef.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getComponentCount", function getComponentCount(compType) {
    var HTTP = this.$httpUtils.instance;
    var self = this;

    HTTP.get("/inventories/count/?where=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ "componentTypeId": compType, "status": 0 })).then(function (count) {
      self.inventoryCount[compType] = count.data.count;
      var temp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.inventoryCount);
      temp[compType] = count.data.count;
      self.inventoryCounter = temp;
      console.log(self.inventoryCounter);
    });
    // self.setAccessLocal(saveRole.join);
  }), _methods),
  mounted: function mounted() {
    if (!this.$can("read", "inventory")) {
      this.$router.push({ path: "/" });
      return;
    }

    // const HTTP = this.$httpUtils.instance;
    // const container = this;
    // HTTP.get("/components/", {}).then(components => {
    //   const componentFetch = components.data;
    //   componentFetch.filter(x => {
    //     x.value = x.id;
    //     x.text = x.name;
    //   });
    //   componentFetch.unshift({
    //     value: null,
    //     disabled: true,
    //     text: "Select Component"
    //   });
    //   container.componentOptions = componentFetch;
    //   // container.setAccessLocal(saveRole.join);
    // }).then(this.getComponents());

    // HTTP.get("/component_types/", {}).then(components => {
    //   container.rows = components.data;
    // });
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__ = __webpack_require__(84);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["b" /* ModalClose */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_4_element_ui__["FormItem"]
  },
  data: function data() {
    return {
      priceChangeDisabled: true,
      packageDefaultPrice: null,
      componentId: "",
      showAddModal: false,
      selectedPackage: null,
      componentData: [],
      packageForm: {
        componentId: null,
        deviceTypeId: null,
        quantity: null
      },
      fields_: [{
        key: "name",
        label: "NAME",
        sortable: "true",
        field: "name",
        filterable: true
      }, {
        key: "description",
        label: "DESCRIPTION",
        sortable: "true",
        field: "description",
        filterable: true
      }],
      systemTypes: [],
      searchTerm: "",
      activeTab: "user_list",
      showOffCanvas: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: {},
  methods: {
    handleSelect: function handleSelect(item) {
      // console.log(item.id);
      this.packageForm.componentId = item.id;
    },
    querySearch: function querySearch(queryString, cb) {
      var _this = this;

      var _data = this.componentData;
      var results = queryString ? _data.filter(function (single) {
        return _this.createFilter(queryString, single);
      }) : _data;
      cb(results);
    },
    createFilter: function createFilter(queryString, single_item) {
      // console.log(single_item.name);
      return single_item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    tableRowClicked: function tableRowClicked(params) {
      // console.log(params);
      this.selectedPackage = params.row;
      this.packageForm.deviceTypeId = params.row.id;
      this.packageDefaultPrice = this.selectedPackage.price;
      this.showOffCanvas = true;
    },
    updatePackagePrice: function updatePackagePrice() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types/" + this.packageForm.deviceTypeId;
      console.log({
        package: this.packageDefaultPrice,
        before: this.selectedPackage.price
      });
      var updateParam = {
        price: this.packageDefaultPrice
      };
      return HTTP.patch(url, updateParam).then(function (response) {
        console.log({ response: response });
        var _tmp = _this2.fetchSysTypes();
        _this2.showInfoMsg({
          message: "Package price updated!"
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this3.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    deleteComponentConfig: function deleteComponentConfig(_row_id) {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/package_components/" + _row_id;
      HTTP.delete(url).then(function (response) {
        _this4.fetchSysTypes();
        _this4.showErrorMsg({
          message: "Deleted!"
        });
        _this4.selectedPackage = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this4.selectedPackage, {
          packageComponents: _this4.selectedPackage["packageComponents"].filter(function (x) {
            return x.id !== _row_id;
          })
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                url = "/package_components";

                HTTP.post(url, _this5.packageForm).then(function (response) {
                  var _tmp = _this5.fetchSysTypes();
                  _this5.showInfoMsg({
                    message: "Component Added!"
                  });
                  _this5.showAddModal = false;
                  // console.log(this.selectedPackage["packageComponents"]);
                  var packageAdded = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this5.packageForm, {
                    componentType: _this5.componentData.find(function (x) {
                      return x.id == _this5.packageForm.componentId;
                    })
                  });
                  // this.selectedPackage = this.systemTypes.find(x=>x.id == this.packageForm.deviceTypeId)
                  _this5.selectedPackage = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this5.selectedPackage, {
                    packageComponents: [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this5.selectedPackage["packageComponents"]), [packageAdded])
                  });
                  _this5.packageForm = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, _this5.packageForm, {
                    componentId: null,
                    quantity: null
                  });
                }).catch(function (error) {
                  console.log("error", error);
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    getComponents: function getComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        //console.log(JSON.stringify(components.data))
        container.componentData = components.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, x, {
            value: x.name
          });
        });
        // container.setAccessLocal(saveRole.join);
      });
    }
  },
  mounted: function mounted() {
    this.fetchSysTypes();
    this.getComponents();
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_components_vue__ = __webpack_require__(929);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ca6771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_components_vue__ = __webpack_require__(2193);
function injectStyle (ssrContext) {
  __webpack_require__(2184)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-45ca6771"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_components_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_45ca6771_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_components_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_papaparse__ = __webpack_require__(2185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_papaparse___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_papaparse__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__kitchen_ArnergyInventoryComponents_index__ = __webpack_require__(2186);












var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_16_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_modal__["b" /* ModalClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_11_element_ui__["FormItem"],
    "el-table": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Table"],
    "el-table-column": __WEBPACK_IMPORTED_MODULE_11_element_ui__["TableColumn"],
    "el-input": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Input"],
    EditReorderLevelComponent: __WEBPACK_IMPORTED_MODULE_17__kitchen_ArnergyInventoryComponents_index__["a" /* EditReorderLevelComponent */],
    ReorderLevelAlert: __WEBPACK_IMPORTED_MODULE_17__kitchen_ArnergyInventoryComponents_index__["b" /* ReorderLevelAlert */],
    "el-upload": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Upload"]
  },
  data: function data() {
    return {
      uploadStatus: "",
      uploadPercentage: 0,
      gettingPackage: false,
      showReorderEditModal: false,
      reorderItemRow: {
        reorderItemRow: 0
      },
      currentInventories: {},
      offCanvasType: "",
      search: "",
      searchTerm: "",
      responseData: "",
      componentName: "",
      selectedPackage: null,
      showAddModal: false,
      showOffCanvas: false,
      itemData: [],
      showAddInventoryModal: false,
      multiple: true,
      inventoryForm: {
        batchNumber: "",
        componentId: null,
        componentTypeId: null,
        serialNumber: "",
        type: "component",
        userId: 0
      },
      csvData: [],
      serialForm: {
        min: null,
        max: null
      },
      componentForm: {
        componentId: null,
        name: null,
        description: null,
        rating: null,
        unit: null,
        inStock: true
      },
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      itemComponentData: [],
      items: items,
      inventoryFields: [{
        label: "Name",
        key: "name",
        field: "name",
        sortable: "true"
      }, {
        label: "Serial Number",
        key: "serialNumber",
        field: "serialNumber",
        sortable: "true"
      }, {
        label: "Batch Number",
        key: "batchNumber",
        field: "batchNumber",
        sortable: "true"
      }, {
        label: "Actions",
        field: "actions"
      }],
      componentFields: [{
        label: "Name",
        key: "name",
        field: "name",
        sortable: "true"
      }, {
        label: "Description",
        key: "description",
        field: "description",
        sortable: "true"
      }, {
        label: "Reorder Level",
        key: "reorderLevel",
        field: "reorderLevel",
        sortable: "true"
      }, {
        label: "Actions",
        field: "actions"
      }],
      tableFields: [{
        label: "Name",
        key: "name",
        field: "name",
        sortable: "true"
      }, {
        label: "Number",
        key: "number",
        field: "number",
        sortable: "true"
      }, {
        label: "Actions",
        field: "actions"
      }],
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: { title: "", content: "" },
      componentData: [],
      componentTypeData: []
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.tableFields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return { text: f.label, value: f.key };
      });
    }
  }),
  methods: (_methods = {
    readFile: function readFile() {
      var vm = this;
      var file = vm.$refs.input.files[0];
      // console.log(file);
      if (file.type === "text/csv") {
        var reader = new FileReader();
        var result = [];
        this.csvData = result;
        reader.readAsText(file);
        var csvToArray = function csvToArray(csv) {
          var lines = csv.split("\n");
          // console.log(lines);
          var headers = lines[0].split(",");
          // console.log(headers);
          for (var i = 1; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(",");
            for (var j = 0; j < headers.length; j++) {
              obj[headers[j]] = currentline[j];
            }
            result.push(obj);
          }
          // console.log(result);
        };
        // console.log(result);
        this.csvData = result;
        console.log(this.csvData);
        reader.onload = function () {
          // console.log(reader.result);
          var data = reader.result;
          csvToArray(data);
        };
        reader.onerror = function () {
          console.log(reader.error);
        };
      } else {
        this.showErrorMsg({
          message: "Please upload a CSV file!"
        });
      }
    },

    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    // },
    generateSample: function generateSample() {
      // Papa
      var fields = ["serialNumber", "componentId", "componentTypeId", "userId"];
      var data = [["", this.inventoryForm.componentId, this.inventoryForm.componentTypeId, 0]];
      var CSV = __WEBPACK_IMPORTED_MODULE_15_papaparse___default.a.unparse({
        fields: fields,
        data: data
      });
      // console.log(csv)

      var fileName = "sample";

      var uri = "data:text/csv;charset=utf-8," + escape(CSV);

      var link = document.createElement("a");

      link.href = uri;

      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      document.body.appendChild(link);

      link.click();
      document.body.removeChild(link);
    },
    fetchComponentTypes: function fetchComponentTypes(selectedRowId) {
      // console.log(selectedRowId);
      this.componentTypeOptions = [];
      var context = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/components/" + selectedRowId + "/componentTypes";
      HTTP.get(url).then(function (response) {
        var componentList = response.data;
        componentList.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });
        context.componentTypeOptions = [].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(context.componentTypeOptions), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(componentList));
        // console.log(context.componentTypeOptions);
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).format("Do MMM YYYY");
    },
    handleComponentTypeDelete: function handleComponentTypeDelete(index, row) {
      var _this = this;

      // console.log(index, row);
      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/component_types/" + row.id;
      HTTP.delete(url).then(function (response) {
        container.showSuccessMsg({
          message: "1 component type deleted"
        });
        _this.getPackage(row.componentId);
      }).catch(function (error) {
        container.showErrorMsg({
          message: "Error occured!"
        });
      });
    },
    handleInventoryDelete: function handleInventoryDelete(index, row) {
      var _this2 = this;

      //console.log(index, row);
      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/inventories/" + row.id;
      HTTP.delete(url).then(function (response) {
        container.showSuccessMsg({
          message: "1 inventory deleted"
        });
        _this2.getComponentInventory(row.componentId);
      }).catch(function (error) {
        container.showErrorMsg({
          message: "Error occured!"
        });
      });
    },
    getPackage: function getPackage(id) {
      var _this3 = this;

      this.gettingPackage = true;
      this.itemData = [];
      var HTTP = this.$httpUtils.instance;
      //const url = `/components/${id}/inventories?filter={"where":{"status": "0"},"include": ["component","componentType"]}`;
      var url = "/components/" + id + "/componentTypes";
      return HTTP.get(url).then(function (response) {
        _this3.itemData = response.data;
        // console.log({ itemData: this.itemData });
        _this3.gettingPackage = false;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    getComponentInventory: function getComponentInventory(id) {
      var _this4 = this;

      this.gettingPackage = true;
      this.itemData = [];
      var HTTP = this.$httpUtils.instance;
      var url = "/components/" + id + "/inventories?filter={\"where\":{\"status\": \"0\"},\"include\": [\"component\",\"componentType\"]}";
      return HTTP.get(url).then(function (response) {
        _this4.itemData = response.data;
        _this4.gettingPackage = false;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    onSubmit: function onSubmit() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    viewComponentType: function viewComponentType(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.offCanvasType = "component_type";
      this.showOffCanvas = true;
      this.componentForm.componentId = row.id;
      this.currentInventories = row.inventories;
      this.getPackage(row.id);
    },
    viewInventory: function viewInventory(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.showOffCanvas = true;
      this.offCanvasType = "inventory_data";
      this.componentForm.componentId = row.id;
      this.getComponentInventory(row.id);
    },
    addBtnInventory: function addBtnInventory(row) {
      // console.log(row);
      this.selectedPackage = row;
      this.showAddInventoryModal = true;
      this.inventoryForm.componentId = this.selectedPackage.id;
      this.fetchComponentTypes(row.id);
    },
    navTo: function navTo(user) {
      this.$router.push({ name: this.details, params: { userId: user } });
      // console.log(user);
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editReorderButton: function editReorderButton(item) {
      this.showReorderEditModal = true;
      this.reorderItemRow = item;
    },
    closeEditReorderLevelModal: function closeEditReorderLevelModal() {
      this.showReorderEditModal = false;
      this.reorderItemRow = null;
    },
    reorderLevelUpdateResponse: function reorderLevelUpdateResponse(success) {
      if (success) {
        this.showInfoMsg({
          message: "Reorder Level Updated"
        });
        this.getComponents();
        this.getPackage(this.componentForm.componentId);
      } else {
        this.showErrorMsg({
          message: "something went wrong! please try again"
        });
      }
      this.closeEditReorderLevelModal();
    },

    // fetchUsers() {
    //   const HTTP = this.$httpUtils.instance;
    //   //  filter={"include": ["installations"]}
    //   const url = `/users?filter[include][installations]=deviceType`;
    //   HTTP.get(url)
    //     .then(response => {
    //       const usersList = response.data;
    //       this.$store.commit("saveUsers", usersList);
    //       // console.log(this.getUserById(1))
    //     })
    //     .catch(error => {
    //       console.log("error", error);
    //     });
    // },
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.componentForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },

    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "showModal", function showModal() {
    this.$refs.myModalRef.show();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getComponentName", function getComponentName(param) {
    return this.componentOptions.filter(function (x) {
      return x.value == param;
    })[0].name;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "hideModal", function hideModal() {
    this.$refs.myModalRef.hide();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "validateInventoryRequestForm", function validateInventoryRequestForm() {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.inventoryForm)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var _ref3 = _step2.value;

        var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

        var field = _ref4[0];
        var value = _ref4[1];

        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    return true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "addInventory", function addInventory() {
    var _this6 = this;

    var url = "/inventories";
    // let url = "";
    if (this.multiple) {
      this.inventoryForm = this.csvData.reduce(function (acc, current) {
        var _tmpPayload = __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_extends___default()({}, _this6.inventoryForm, {
          serialNumber: current["serialNumberFrom"] + "->" + current["serialNumberTo"],
          batchNumber: current["packingListNumber"]
        });
        return [].concat(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_toConsumableArray___default()(acc), [_tmpPayload]);
      }, []);
      // this.inventoryForm.serialNumber = `${this.serialForm.min}->${this.serialForm.max}`;
      url = "/inventories/multiple";
      // url = "";
    }
    console.log({ inventoryForm: this.inventoryForm });
    // this.inventoryForm.map(data => console.log(data));
    if (this.validateInventoryRequestForm() === true) {
      this.inventoryForm.userId = this.getUserSession.id;
      var container = this;
      var HTTP = this.$httpUtils.instance;
      //   console.log({ Form: this.inventoryForm });
      this.inventoryForm.map(function (data) {
        HTTP.post(url, data, {
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(Math.round(progressEvent.loaded / progressEvent.total * 100));
            if (this.uploadPercentage > 0 && this.uploadPercentage <= 60) {
              this.uploadStatus = "Uploading...";
            } else if (this.uploadPercentage > 60 && this.uploadPercentage <= 90) {
              this.uploadStatus = "Almost done!...";
            } else if (this.uploadPercentage === 100) {
              this.uploadStatus = "Upload Complete!";
            } else {
              this.uploadStatus = "Upload failed!";
            }
          }.bind(_this6)
        }).then(function (response) {
          console.log(response);

          // container.showSuccessMsg({
          //   message: container.multiple
          //     ? response.data.length + "\nComponent(s) Added"
          //     : "Item added!"
          // });
          container.showAddInventoryModal = false;
          container.getComponents();
        }).catch(function (error) {
          if (error.response) {
            var errorMsg = error.response.data.error.details.messages;
            var errTemp = [];
            var keyHooks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errorMsg);
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
              errTemp[index] = keyHooks[index] + " " + x[0];
            });
            errTemp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
            container.showErrorMsg({
              message: errTemp
            });
          } else {
            container.showErrorMsg({
              message: "Error occured!"
            });
          }
        });
      });

      //   HTTP.post(url, this.inventoryForm)
      //     .then(response => {
      //       container.showSuccessMsg({
      //         message: container.multiple
      //           ? response.data.length + "\nComponent(s) Added"
      //           : "Item added!"
      //       });
      //       container.showAddInventoryModal = false;
      //       container.getComponents();
      //     })
      //     .catch(error => {
      //       if (error.response) {
      //         var errorMsg = error.response.data.error.details.messages;
      //         var errTemp = [];
      //         var keyHooks = Object.keys(errorMsg);
      //         Object.values(errorMsg).map((x, index) => {
      //           errTemp[index] = keyHooks[index] + " " + x[0];
      //         });
      //         errTemp = Object.values(errTemp).join("<br>");
      //         container.showErrorMsg({
      //           message: errTemp
      //         });
      //       } else {
      //         container.showErrorMsg({
      //           message: "Error occured!"
      //         });
      //       }
      //     });
    } else {
      this.showErrorMsg({
        message: this.validateInventoryRequestForm()
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "submitComponentForm", function submitComponentForm() {
    var _this7 = this;

    if (this.validateRequestForm() === true) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/component_types";
      HTTP.post(url, this.componentForm).then(function (response) {
        //console.log(JSON.stringify(response));
        container.showInfoMsg({
          message: "Component Type Added"
        });
        container.showAddModal = false;
        container.getComponents();
        container.getPackage(_this7.componentForm.componentId);
        // window.reload();
        // container.reqSuccess = true;
      }).catch(function (error) {
        console.log(error);
        if (error.response) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          _this7.showErrorMsg({
            message: errTemp
          });
          _this7.inventoryForm = {
            batchNumber: "",
            componentId: null,
            componentTypeId: null,
            serialNumber: "",
            type: "component",
            userId: 0
          };
          _this7.serialForm = {
            min: null,
            max: null
          };
        } else {
          var errorMsg = error.Error;
          _this7.showErrorMsg({
            message: errorMsg
          });
        }
      });
    } else {
      this.showErrorMsg({
        message: this.validateRequestForm()
      });
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getComponents", function getComponents() {
    var HTTP = this.$httpUtils.instance;
    var container = this;
    HTTP.get("/components?filter={\"include\": [\"inventories\"]}", {}).then(function (components) {
      //console.log(JSON.stringify(components.data))
      // container.rows = components.data;
      container.componentData = components.data;

      //${id}/inventories?filter={"where":{"status": "0"}
      container.componentData.filter(function (x) {
        x.value = x.id;
        x.text = x.name;
        x.inventories = x.inventories.filter(function (y) {
          return y.status == 0;
        });
      });
      //var ComponentNo=[];
      // for (i of container.componentData){
      //   HTTP.get(`/components/${i.id}/inventories?filter={"where":{"status": "0"}}`, {}).then(componentNo => {
      //     i = componentNo.data.length;
      //   })
      // }

      // componentFetch.unshift({
      //   value: null,
      //   disabled: true,
      //   text: "Select Component"
      // });
      // container.componentOptions = componentFetch;
      //container.setAccessLocal(saveRole.join);
    });
  }), _methods),
  mounted: function mounted() {
    this.getComponents();
    //this.getPackage(params.id);
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_modal__ = __webpack_require__(84);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditReorderLevelComponent",
  props: {
    showReorderEditModal: false,
    defaultValue: 0,
    reorderItemRow: {}
  },
  components: {
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_modal__["b" /* ModalClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_1_element_ui__["FormItem"],
    "el-input": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Input"]
  },
  data: function data() {
    return {
      modalValue: 0
    };
  },

  watch: {
    defaultValue: {
      handler: function handler(after) {
        this.modalValue = after;
      },

      immediate: true
    }
  },
  methods: {
    updateInput: function updateInput() {
      this.$emit('modalValue', this.modalValue);
    },
    closeModal: function closeModal() {
      this.$emit("closeModal");
    },
    updateReorderLevel: function updateReorderLevel() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/component_types";
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.reorderItemRow, {
        reorderLevel: this.modalValue
      });

      HTTP.patch(url, values).then(function (response) {
        // console.log(response)
        _this.$emit("updateCallback", true);
      }).catch(function (error) {
        // console.log(error);
        _this.$emit("updateCallback", false);
      });
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_modal__ = __webpack_require__(84);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReorderLevelAlarm",
  props: ["itemRow", "inventories"],
  components: {
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_modal__["b" /* ModalClose */]
  },
  data: function data() {
    return {
      show: false,
      openModal: false,
      hover: false,
      reorderLevel: "",
      availableInventories: "",
      ids: []
    };
  },

  methods: {
    collateComponentTypeIds: function collateComponentTypeIds(items) {
      // @todo: if there's a problem, it's definitely here...
      if (items.length > 0 && this.itemRow.id != items[0].componentTypeId) return;
      var componentIds = items.map(function (item) {
        return item.componentTypeId;
      }).reduce(function (total, single) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, total, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, single, total[single] ? total[single] + 1 : 1));
      }, {});
      this.ids = componentIds;
    },
    showWarningElement: function showWarningElement(rowItem, ids) {
      var _this = this;

      // console.log(rowItem.reorderLevel, ids)
      // if(parseInt(rowItem.reorderLevel) > )
      var values = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(ids);
      values.forEach(function (item) {
        if (parseInt(item) <= rowItem.reorderLevel) {
          // yes, show warning
          _this.show = true;
          _this.availableInventories = item;
          _this.reorderLevel = rowItem.reorderLevel;
        }
      });
    }
  },
  mounted: function mounted() {
    this.collateComponentTypeIds(this.inventories);
    this.showWarningElement(this.itemRow, this.ids);
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_dialog__ = __webpack_require__(2196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuejs_dialog__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vuejs_dialog___default.a);
/**
new Vue({
  
})**/

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      data: {
        name: null,
        description: null
      },
      responseData: "",
      errors: {},
      errorMessage: "",
      displayError: false,
      componentName: "",
      columns: [
      // {
      //   label: "SN",
      //   field: "counter",
      //   originalIndex: 0
      // },
      {
        label: "Role",
        field: "name",
        filterable: true
      }, {
        label: "Description",
        field: "description",
        filterable: true
      }],
      rows: [{ name: null, description: null }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    isEmail: function isEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },
    validateData: function validateData() {
      var err = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          if (value === "null" || value === "") {
            err[field] = field + " cannot be empty.";
          }
          if (field.toLowerCase == "email") if (!this.isEmail(value)) {
            err[field] = "Not a valid email.";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
    },
    addRole: function addRole(e) {
      var _this = this;

      e.preventDefault();
      this.validateData();
      var errorLength = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.errors).length;
      if (errorLength > 0) {
        console.log(this.errors);
        this.errorMessage = "Require Fields cannot be empty.";
        this.displayError = true;
        setTimeout(function () {
          _this.displayError = false;
        }, 1000);
        this.showErrorMsg({ message: this.errorMessage });
      } else {
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data);
        var tempData = JSON.parse(str);
        var HTTP = this.$httpUtils.instance;
        var container = this;

        HTTP.post("/roles", tempData).then(function (response) {
          _this.fetchData();
          _this.$refs.myModalRef.hide();
        }).catch(function (error) {
          console.log("error", error);
          _this.showErrorMsg({ message: "Error occur while saving!" });
        });
        // =========================
      }
    },
    deleteData: function deleteData(e) {
      // e.preventDefault();
      //console.log(e);

      // return;
      // var roleId = e.srcElement.childNodes[0].innerHTML;

      var container = this;
      container.$dialog.confirm("Please confirm to continue").then(function () {
        console.log("Clicked on proceed");
        console.log(e);

        var HTTP = container.$httpUtils.instance;
        HTTP.delete("/roles/" + e, {}).then(function (response) {
          container.fetchData();
        }).catch(function (error) {
          console.log("error", error);
          container.showErrorMsg({
            message: "Error occur while Deleting!"
          });
        });
      }).catch(function (error) {
        console.log("error", error);
        console.log("Clicked on cancel");
      });

      // =========================
    },
    doNothing: function doNothing() {
      return false;
    },


    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    fetchData: function fetchData() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/roles";
      HTTP.get(url, {}).then(function (dataResponse) {
        var dataList = dataResponse.data;
        var str = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataList);
        var tempData = JSON.parse(str);
        _this2.rows = tempData;
      }).catch(function (error) {
        console.log("error", error);
        _this2.showErrorMsg({ message: "Error occur while saving!" });
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_config_vue__ = __webpack_require__(934);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01817dc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_config_vue__ = __webpack_require__(2198);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_config_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01817dc8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_config_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__ = __webpack_require__(84);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ReportConfig",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_modal__["b" /* ModalClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_4_element_ui__["FormItem"],
    "el-tag": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Tag"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      parameterConfig: [],
      formNames: {},
      formWhere: "",
      formOptions: {},
      searchTerm: "",
      operationType: "and",
      pathList: [],
      showOffCanvas: false,
      reportData: null,
      confirmDeleteModal: false,
      rowData: null,
      form: {
        title: "",
        endpoint: "",
        config: {
          where: "",
          parameters: {},
          include: ""
        },
        field: "",
        operation: "",
        inputValue: "",
        dynamicTags: [],
        inputVisible: false
      },
      formResults: [],
      rows: [],
      columns: [{
        label: "Title",
        field: "title"
      }, {
        label: "Endpoint",
        field: "endpoint",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }]
    };
  },

  computed: {
    computedWhere: {
      get: function get() {
        var _this = this;

        var regx = /((\$\S+))\b/gi;
        var tmpParam = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form.config.parameters);
        this.form.config.parameters = {};
        var foundMatch = this.form.config.where.match(regx);
        if (foundMatch) {
          foundMatch.map(function (x) {
            if (!tmpParam[x]) {
              _this.form.config.parameters[x] = {
                key: x,
                type: "freetext"
              };
              _this.formOptions[x] = {
                name: x.replace("$", ""),
                options: ""
              };
            } else {
              _this.form.config.parameters[x] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, tmpParam[x]);
            }
          });
          this.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form, {
            config: this.form.config
          });
          return foundMatch;
        }
      },
      set: function set(newVal, oldVal) {
        console.log({ newVal: newVal, oldVal: oldVal });
      }
    }
  },
  watch: {
    formWhere: function formWhere(newVal, oldVal) {
      var _this2 = this;

      console.log({ newVal: newVal, oldVal: oldVal });
      var regx = /((\$\S+))\b/gi;
      var foundMatch = newVal.match(regx);
      if (foundMatch) {
        foundMatch.map(function (x) {
          var entryFound = _this2.parameterConfig.find(function (v) {
            return v.key == x;
          });
          if (!entryFound) {
            _this2.parameterConfig = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.parameterConfig), [{
              key: x,
              type: "freetext",
              name: x.replace("$", ""),
              options: ""
            }]);
          }
          // else {
          //   this.form.config.parameters[x] = {
          //     ...tmpParam[x]
          //   };
          // }
        });
        // this.form = {
        //   ...this.form,
        //   config: this.form.config
        // };
        // return foundMatch;
      }
    },
    formOptions: function formOptions(newVal, oldVal) {
      // console.log("i am newVal",newVal)
      // console.log("i am oldVal",oldVal)
      // console.log({ newVal, oldVal });
      // if (this.map) {
      //   this.map.setOptions({
      //     styles:
      //       this.getTheme["theme-name"] == "dark-solarbase" ? darkStyle : {}
      //   });
      // }
    }
  },
  methods: {
    // updateVal(parnt,chld){
    //   console.log({parnt,chld})
    // },
    addOperation: function addOperation() {
      console.log({
        operation: this.form.operation,
        field: this.form.field,
        operands: this.form.operands
      });
    },
    changeParameterType: function changeParameterType(key, type) {
      console.log("i am key", key);
      console.log("i am key", type);
      // this.form = {
      //   ...this.form,
      //   config: {
      //     ...this.form.config,
      //     parameters: {
      //       ...this.form.config.parameters,
      //       [key]: { ...this.form.config.parameters[key], type }
      //     }
      //   }
      // };
      // console.log("this is form", this.form);
    },
    changeParameterOptions: function changeParameterOptions(key, options) {
      // console.log("i am key", key);
      // console.log("i am key", options);
      this.form = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form, {
        config: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form.config, {
          parameters: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form.config.parameters, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form.config.parameters[key], { options: options })))
        })
      });
      // console.log("this is form", this.form);
    },
    getReports: function getReports() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/reporting").then(function (reports) {
        //console.log(JSON.stringify(components.data))
        // container.rows = components.data;
        container.reportData = reports.data;
        // container.reportData.filter(x => {
        //   x.value = x.id;
        //   x.text = x.name;
        // });
      });
    },
    confirmDeleteReport: function confirmDeleteReport() {
      var _this3 = this;

      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/reporting/" + this.rowData.id;
      HTTP.delete(url).then(function (response) {
        container.showSuccessMsg({
          message: "1 report config Deleted"
        });
        _this3.confirmDeleteModal = false;
        _this3.getReports();
      }).catch(function (error) {
        container.showErrorMsg({
          message: "Error occured!"
        });
      });
    },
    deleteReport: function deleteReport(row) {
      this.confirmDeleteModal = true;
      this.rowData = row;
      confirmDeleteReport();
      //console.log(row.id);
      // const container = this;
      // const HTTP = this.$httpUtils.instance;
      // const url = `/reporting/${row.id}`;
      // HTTP.delete(url)
      // .then(response => {
      //   container.showSuccessMsg({
      //     message: "1 report config Deleted"
      //   });
      //   this.getReports();
      // })
      // .catch(error=> {
      //   container.showErrorMsg({
      //     message: "Error occured!"
      //   });
      // })
    },
    updateForm: function updateForm(value) {
      console.log("=======================");
      console.log(value);
      console.log(this.formOptions);
      console.log(this.formNames);
    },
    onSubmit: function onSubmit() {
      var _this4 = this;

      //console.log("form",this.computedWhere);
      // console.log(this.parameterConfig);
      // console.log(this.formNames);
      var data = {
        title: "" + this.form.title,
        endpoint: "" + this.form.endpoint,
        config: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.form.config, {
          where: this.formWhere,
          parameters: this.parameterConfig
        })
      };

      // console.log({ data });
      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/reporting";
      HTTP.post(url, data).then(function (response) {
        container.showSuccessMsg({
          message: "Report config added"
        });
        _this4.showOffCanvas = false;
        _this4.getReports();
      }).catch(function (error) {
        container.showErrorMsg({
          message: "Error occured!"
        });
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.getReports();
    this.$httpUtils.explorerHTTP.get("").then(function (x) {
      return x.data;
    }).then(function (apiData) {
      // console.log(apiData);
      _this5.pathList = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(apiData.paths).map(function (x) {
        // console.log(apiData.paths[x]);
        return apiData.paths[x].hasOwnProperty("get") ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, apiData.paths[x], {
          path: x
        }) : false;
      }).filter(function (x) {
        return x;
      });
      console.log(_this5.pathList);
    });
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__ = __webpack_require__(84);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "alarmConfig",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_3_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_modal__["b" /* ModalClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_2_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_2_element_ui__["FormItem"],
    "el-tag": __WEBPACK_IMPORTED_MODULE_2_element_ui__["Tag"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      activeTab: "alarm_config",
      searchTerm: "",
      showOffCanvas: false,
      installationList: [],
      getUsers: "",
      selectOption: {
        enabled: true
      },
      fields: [{
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "devicetype",
        label: "Device Type",
        sortable: "true"
      }, {
        field: "cid",
        label: "Customer ID",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      }, {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      form: {
        label: null,
        fieldName: null,
        fieldProperty: null,
        condition: "Greater than",
        value: null
      }
    };
  },

  methods: {
    navTo: function navTo(deviceId) {
      this.$router.push({
        // path: `/device/${deviceId}`,
        name: "viewDevices",
        params: {
          deviceId: deviceId,
          activetab: "alarm"
        }
      });
    },
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    getInstallations: function getInstallations() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/installations").then(function (installations) {
        container.installationList = installations.data;
      });
    },
    getUserList: function getUserList() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/installations?filter={\"include\":[\"deviceType\",\"alarmConfig\",\"user\",\"operationsEngineer\"]}").then(function (installations) {
        container.getUsers = installations.data.filter(function (x) {
          return x.alarmConfig.length != 0;
        });
      });
    },
    createAlarm: function createAlarm() {
      //this.form.condition==true ? this.form.condition="Greater than" : this.form.condition="Less than"
      console.log(this.form);
      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/alarmConfigs";
      HTTP.post(url, this.form).then(function (response) {
        container.showOffCanvas = false;
        container.getUserList();
        container.showSuccessMsg({
          message: "Alarm Created!"
        });
      }).catch(function (error) {
        container.showErrorMsg({
          message: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error.response.data.error.details.messages)
        });
      });
    }
  },
  mounted: function mounted() {
    this.getInstallations();
    this.getUserList();
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(937);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94c5157c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2204);
function injectStyle (ssrContext) {
  __webpack_require__(2201)
  __webpack_require__(2202)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94c5157c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94c5157c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_build_classic__ = __webpack_require__(2203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_build_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__ = __webpack_require__(84);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// eslint-disable-next-line






__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   Inventory
  // },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      editor: __WEBPACK_IMPORTED_MODULE_8__ckeditor_ckeditor5_build_classic___default.a,
      showOffCanvas: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      statusValue: null,
      statusOption: [{
        value: 1,
        name: "open"
      }, {
        value: 2,
        name: "close"
      }, {
        value: 3,
        name: "completed"
      }],
      fields: [{
        field: "installation.name",
        label: "installation",
        sortable: "true"
      }, {
        field: "customerId",
        label: "CID",
        sortable: "true"
      }, {
        field: "issue",
        label: "Issue/Enquiry",
        sortable: "true"
      }, {
        field: "operationsEngineer.name",
        label: "Engineer",
        sortable: "true"
      }, {
        field: "start",
        label: "Timeline Begins",
        sortable: "true"
      }, {
        field: "end",
        label: "Timeline End",
        sortable: "true"
      }, {
        field: "status",
        label: "Status",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],

      commentForm: {
        content: null,
        maintenanceId: null,
        userId: null
      },
      showStatusModal: false,
      showCommentModal: false,
      maintenanceList: "",
      selectedMaintenance: {},
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  components: {
    "el-carousel": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Carousel"],
    "el-carousel-item": __WEBPACK_IMPORTED_MODULE_9_element_ui__["CarouselItem"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["b" /* ModalClose */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    reloadPage: function reloadPage() {
      this.showOffCanvas = false;
      window.location.reload();
    },
    submitStatus: function submitStatus() {
      var maintenance = this.selectedMaintenance;
      var httpUtils = this.$httpUtils;
      //console.log(maintenance);
      var data = {
        status: this.statusValue
      };
      //console.log(data);
      var url = "/maintenance/" + maintenance.id;
      var container = this;
      httpUtils.instance.patch(url, data).then(function (response) {
        //console.log(response.data);
        container.showInfoMsg({
          message: "Status updated"
        });
        container.showStatusModal = false;
      }).catch(function (error) {
        console.log(error);
        container.showErrorMsg({
          message: error
        });
      });
    },
    submitComment: function submitComment() {
      var maintenance = this.selectedMaintenance;
      var httpUtils = this.$httpUtils;
      //console.log(maintenance);
      this.commentForm = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.commentForm, {
        userId: this.getUserSession.id,
        maintenanceId: maintenance["id"]
      });
      //console.log(this.commentForm);
      var url = "/maintenance_comments";
      var container = this;
      httpUtils.instance.post(url, this.commentForm).then(function (response) {
        //console.log(response.data);
        container.showInfoMsg({
          message: "Comment Added"
        });
        container.showCommentModal = false;
        var _tmpData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, response.data, {
          user: container.getUserSession
        });
        //maintenance = maintenance.push(response.data);
        //container.selectedMaintenance = container.selectedMaintenance['comments'].push(response.data);
        //console.log(container.selectedMaintenance["comments"]);
        container.selectedMaintenance = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, container.selectedMaintenance, {
          comments: [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(container.selectedMaintenance.comments), [_tmpData])
        });
        //console.log(this.selectedMaintenance);
        // console.log(updated);
        // container.viewMaintenance(updated);
      }).catch(function (error) {
        console.log(error);
        container.showErrorMsg({
          message: error
        });
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("Do MMM YYYY");
    },
    viewMaintenance: function viewMaintenance(maintenance) {
      this.selectedMaintenance = maintenance;
      console.log(this.selectedMaintenance);
      this.showOffCanvas = true;
      // this.$router.push({
      //   path: `/device/${deviceId}`
      // });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var userId = this.getUserSession.id;
      var realm = this.getUserSession.realm;
      // {"include": ["installation","operationsEngineer"]}
      var url = "/maintenance?filter={\"where\":{\"assignedTo\":" + userId + "},\"include\": [{\"installation\":\"deviceType\"},\"operationsEngineer\",{\"comments\":\"user\"}]}";
      if (this.$can("am", "engineer")) {
        url = "/maintenance?filter={\"include\": [{\"installation\":\"deviceType\"},\"operationsEngineer\",{\"comments\":\"user\"}]}";
      } else if (this.$can("manage", "customer")) {
        url = "/maintenance?filter={\"where\":{\"realm\":{\"$regex\" :\"^" + realm + "\"}},\"include\": [{\"installation\":\"deviceType\"},\"operationsEngineer\",{\"comments\":\"user\"}]}";
      } else if (this.$can("read", "all")) {
        url = "/maintenance?filter={\"where\":{\"status\":\"open\"},\"include\": [{\"installation\":\"deviceType\"},\"operationsEngineer\",{\"comments\":\"user\"}]}";
      }
      httpUtils.instance.get(url).then(function (response) {
        _this.maintenanceList = response.data;
      }).catch(function (error) {
        _this.errors = "Error occured at our end!";
        _this.maintenanceList = "";
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();

              // console.log(this.getDummy)

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      responseData: '',
      errors: '',
      componentName: ''
    };
  },

  methods: {},
  computed: {},
  mounted: function mounted() {}
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_4__utils_Autocomplete__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      instalationPackageConfig: [],
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        qty: 1
      },
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      installationData: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [
      /*    {
        label: "SN",
        field: "sn",
        type: "date"
      }, */
      {
        label: "Component",
        field: "componentType.name",
        filterable: true
      }, {
        label: "Qty",
        field: "quantity",
        filterable: true
      }],
      rows: [],
      reqSuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          componentList.unshift({
            value: null,
            disabled: true,
            text: "Please component type"
          });

          context.componentTypeOptions = componentList;
          context.componentTypeId = null;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    removeData: function removeData(index) {
      var name = this.rows.filter(function (x) {
        return x.componentId == index.componentId;
      });
      this.rows.splice(index.originalIndex, 1);
      this.componentOptions.splice(1, 0, {
        id: index.componentId,
        value: index.componentId,
        text: index.component,
        name: index.component
      });
    },
    fetchComponents: function fetchComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        var componentFetch = components.data;
        componentFetch.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });
        componentFetch.unshift({
          value: null,
          disabled: true,
          text: "Select Component"
        });
        container.componentOptions = componentFetch;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    submitRequest: function submitRequest() {
      var _this = this;

      var requestId = this.$route.params.id * 1;
      var pcConfig = this.instalationPackageConfig.map(function (x) {
        return {
          quantity: x.quantity,
          componentTypeId: x.componentId,
          deviceRequestId: requestId
        };
      });
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.post("/installation_components", pcConfig).then(function (response) {
        var componentsResponse = response.data;
        if (componentsResponse) {
          HTTP.patch("/device_requests/" + requestId, {
            status: 2
          }).then(function (data) {
            _this.showSuccessMsg({ message: "Installation Approved" });
            setTimeout(function () {
              container.$router.push({
                name: "instalationList"
              });
            }, 500);
          });
        }
      });
    },
    addInventory: function addInventory() {
      var conName = this.getComponentName(document.getElementById("componentName").value);
      var conType = this.getComponentTypeName(document.getElementById("componentType").value);
      var itemqty = document.getElementById("item-qty").value;
      itemqty = itemqty == "" ? 1 : itemqty;
      this.rows.push({
        deviceRequestId: this.$route.params.id,
        componentTypeId: document.getElementById("componentType").value,
        componentId: document.getElementById("componentName").value,
        component: conName,
        spec: conType,
        qty: itemqty,
        quantity: itemqty
      });
      this.componentOptions.splice(document.getElementById("componentName").selectedIndex, 1);
      this.componentTypeOptions.splice(document.getElementById("componentType").selectedIndex, 1);
      document.getElementById("componentName").selectedIndex = 0;
      document.getElementById("componentType").selectedIndex = 0;
    },
    getComponentName: function getComponentName(param) {
      return this.componentOptions.filter(function (x) {
        return x.value == param;
      })[0].name;
    },
    getComponentTypeName: function getComponentTypeName(param) {
      return this.componentTypeOptions.filter(function (x) {
        return x.value == param;
      })[0].name;
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate();
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    fetchData: function fetchData(d) {
      var _this2 = this;

      var requestId = this.$route.params.id;
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/device_requests/" + d + "?filter={\"include\": [\"user\",\"transactionHistories\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}]}", {}).then(function (components) {
        var componentFetch = components.data;
        _this2.installationData = componentFetch;
        return _this2.installationData.deviceType.packageComponents;
      }).then(function (packageComponents) {
        _this2.instalationPackageConfig = packageComponents.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({
            quantity: x.quantity,
            componentTypeId: x.componentId,
            deviceRequestId: requestId
          }, x);
        });
      });
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
  }
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_4__utils_Autocomplete__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null
      },
      deviceRequests: [],
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      dataParams: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },

      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }],
      rows: [],
      reqSuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    scheduleInstalation: function scheduleInstalation(installationObj) {
      this.$router.push({
        name: "instalationSchedule",
        params: {
          Installation: installationObj
        }
      });
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          componentList.unshift({
            value: null,
            disabled: true,
            text: "Please component type"
          });

          context.componentTypeOptions = componentList;
          context.componentTypeId = null;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchComponents: function fetchComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        var componentFetch = components.data;
        componentFetch.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });

        componentFetch.unshift({
          value: null,
          disabled: true,
          text: "Select Component"
        });
        container.componentOptions = componentFetch;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate();
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    fetchData: function fetchData(d) {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"deviceType\"]}", {}).then(function (components) {
        var componentFetch = components.data;
        _this.dataParams = componentFetch;
      });
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
    var HTTP = this.$httpUtils.instance;
    var container = this;
    HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"deviceType\",\"installationComponents\"], \"where\": {\"status\": 2}, \"order\": \"id DESC\" }", {}).then(function (rolesdata) {
      // console.log(JSON.stringify(rolesdata.data))
      container.deviceRequests = rolesdata.data;
    });
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_hotel_datepicker__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_hotel_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_hotel_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);











var _components$notificat;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

// import Autocomplete from "../../utils/Autocomplete";




// import { Datetime } from "vue-datetime";
// import "vue-datetime/dist/vue-datetime.css";

/* harmony default export */ __webpack_exports__["a"] = (_components$notificat = {
  components: {
    // Autocomplete,
    HotelDatePicker: __WEBPACK_IMPORTED_MODULE_13_vue_hotel_datepicker___default.a,
    "el-card": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Card"],
    "el-form": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_10_element_ui__["FormItem"],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Autocomplete"],
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_11_vuikit_lib_modal__["b" /* ModalClose */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      componentData: [],
      packageData: [],
      BOQ: [],
      // displayData: [],
      componentId: "",
      showAddModal: false,
      description: " ",
      deviceName: [],
      packageForm: {
        componentId: null,

        // componentName: null,
        // deviceTypeId: null,
        quantity: null
      },
      customFormat: {
        night: "Day",
        nights: "Days",
        "day-names": ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
        "month-names": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "check-in": "Installation starts",
        "check-out": "Installation ends"
      },
      requestId: this.$route.params.Installation,
      InstallationData: {},
      componentsToUse_public: {},
      availableComponentsList: [],
      tmp: [],
      rows: [],
      results: {},
      inventories: null,
      periods: {
        from: null,
        to: null
      },
      tempData: ""
    };
  }
}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components$notificat, "notifications", {
  showSuccessMsg: {
    type: "success",
    title: "Success",
    message: "Success Msg!"
  },
  showInfoMsg: {
    type: "info",
    title: "Information",
    message: "Info. Msg!"
  },
  showWarnMsg: {
    type: "warning",
    title: "Warning",
    message: "Warning Msg!"
  },
  showErrorMsg: {
    type: "error",
    title: "Error",
    message: "Error Msg!"
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components$notificat, "computed", __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_12_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"]), {
  componentsToUse: {
    // getter
    get: function get() {
      return this.componentsToUse_public;
    },
    // setter
    set: function set(newValue) {
      this.componentsToUse_public = newValue;
    }
  }
})), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components$notificat, "methods", {
  handleSelect: function handleSelect(item) {
    // console.log(item.id);
    this.packageForm.componentId = item.id;
  },
  querySearch: function querySearch(queryString, cb) {
    var _this = this;

    var _data = this.componentData;
    var results = queryString ? _data.filter(function (single) {
      return _this.createFilter(queryString, single);
    }) : _data;
    cb(results);
  },
  createFilter: function createFilter(queryString, single_item) {
    // console.log(single_item.name);
    return single_item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
  },
  getComponents: function getComponents() {
    var _this2 = this;

    var HTTP = this.$httpUtils.instance;
    var container = this;
    HTTP.get("/components/", {}).then(function (components) {
      //console.log(JSON.stringify(components.data))
      container.componentData = components.data.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_extends___default()({}, x, {
          value: x.name
        });
      });
      console.log(container.componentData);
      var data = [];
      for (var i = 0; i < container.componentData.length; i++) {
        // text += cars[i] + "<br>";
        _this2.deviceName.push({
          id: container.componentData[i].id,
          name: container.componentData[i].name
        });
        // return data
      }
      console.log(_this2.deviceName);

      // container.setAccessLocal(saveRole.join);
    });
  },
  onSubmit: function onSubmit() {
    var _this3 = this;

    // console.log(this.packageForm)
    var addedDevice = this.packageData.filter(function (x) {
      return x.componentTypeId === _this3.packageForm.componentId;
    });
    // addedDevice[0].componentItems.description = this.description;
    // console.log(addedDevice);
    // console.log(addedDevice.length);
    if (addedDevice.length > 0) {
      this.packageData.forEach(function (x) {
        // Snippet in IF statement checks for repeated component type
        if (x.componentTypeId === _this3.packageForm.componentId) {
          x.componentItems.name.replace(addedDevice[0].name);
          x.quantity = addedDevice[0].quantity;
          addedDevice[0].componentItems.description = _this3.description;
          // this.showInfoMsg({
          //   message: "Component Added!"
          // });
          _this3.showAddModal = false;
          console.log(x.componentItems.name.replace(addedDevice[0].name));
          console.log(x.quantity = _this3.packageForm.quantity);
          // } else {
          //     this.deviceName.forEach(y => {
          //       addedDevice[0].name = y.name;
          //       console.log(this.packageData.push(addedDevice));

          //     })
        }
      });
    } else {
      var test = this.deviceName.filter(function (x) {
        return x.id === _this3.packageForm.componentId;
      });
      // console.log("test");
      // addedDevice[0].componentItems.description = this.description;
      console.log(test);
      // console.log(this.$route.params);
      if (test.length > 0) {
        var otherComponents = {
          quantity: this.packageForm.quantity,
          createdAt: "2020-01-06T10:44:45.528Z",
          updatedAt: "2020-01-06T10:44:45.528Z",
          componentTypeId: this.packageForm.componentId,
          deviceRequestId: this.$route.params.Installation,
          componentItems: {
            name: test[0].name,
            description: this.description,
            createdAt: "2020-01-06T10:44:45.528Z",
            updatedAt: "2020-01-06T10:44:45.528Z",
            id: this.packageForm.componentId
          }
        };
        var tmp = [];
        // this.packageData.push(otherComponents);
        tmp = [].concat(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_toConsumableArray___default()(this.packageData), [otherComponents]);

        // Snippet in IF statement checks for repeated component type
        if (test.id === this.packageForm.componentId) {
          tmp.forEach(function (x) {
            tmp.componentItems.name = test[0].name;
            tmp.quantity = _this3.packageForm.quantity;
          });
        } else {
          // Code below pushes in new component into the BOQ
          console.log(tmp);
          this.packageData = tmp;

          this.BOQ = tmp;

          // console.log(this.packageData);
          // console.log(this.BOQ); // Bill of Quantity Data
          // console.log(otherComponents);
        }
        // tmp.forEach(x => {
        //   if(x.componentTypeId === this.packageForm.componentId){
        //     tmp.componentItems.name = test[0].name;
        //     tmp.quantity = this.packageForm.quantity;
        //   }
        // })
      }
      this.showAddModal = false;
    }
  },
  setCheckin: function setCheckin(chkInDate) {
    this.periods.from = chkInDate;
    console.log(this.periods.from);
  },
  setCheckOut: function setCheckOut(chkOutnDate) {
    this.periods.to = chkOutnDate;
    console.log(this.periods.to);
  },
  filterList: function filterList(arrayVal, component) {
    // console.log(arrayVal);
    var dat = arrayVal.filter(function (x) {
      return x.componentId === component.componentTypeId;
    });
    dat.unshift({
      value: null,
      disabled: true,
      text: "Please Select " + component.componentItems.name
    });
    return dat;
  },
  validateRequestForm: function validateRequestForm(entries) {
    var qty = 0;
    this.InstallationData.installationComponents.forEach(function (a) {
      qty += a.quantity;
    });
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.periods)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var field = _ref2[0];
        var value = _ref2[1];

        if (value === null || value === "") {
          return "Please fill all fields!";
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return qty > __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(entries).length ? "Please fill all entries !!!" : false;
  },
  duplicateEntries: function duplicateEntries(param) {
    var names = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(param);
    var count = function count(names) {
      return names.reduce(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(a, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, b, (a[b] || 0) + 1));
      }, {});
    };
    var duplicates = function duplicates(dict) {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_keys___default()(dict).filter(function (a) {
        return dict[a] > 1;
      });
    };
    var c = count(names);
    var d = duplicates(count(names));
    return d.length > 0 ? d : false;
  },
  compareDate: function compareDate(date1, date2) {
    if (date1 == null || date2 == null) {
      return "Please select date";
    }
    var now = __WEBPACK_IMPORTED_MODULE_14_moment___default()().startOf("day");
    var myDate = date1.getTime();
    var myDate2 = date2.getTime();

    console.log({
      now: now,
      myDate: myDate,
      myDate2: myDate2
    });

    return now > myDate ? "Invalid/Past Date" : myDate > myDate2 ? "Invalid Date supplied" : false;
  },
  submitRequest: function submitRequest(event) {
    var _this4 = this;

    event.preventDefault();
    var HTTP = this.$httpUtils.instance;
    var container = this;
    var inverters = "";
    var chk = this.compareDate(this.periods.from, this.periods.to);
    if (chk !== false) {
      this.showErrorMsg({
        message: chk.toString()
      });
      return;
    } else {
      var scope = {
        solarKitIds: "--",
        name: this.InstallationData["installationName"] ? this.InstallationData["installationName"] + " " : this.InstallationData.user["firstName"] + " " + this.InstallationData.user["lastName"],
        // `${this.InstallationData.user.firstName}  ${this.InstallationData.user.lastName}`,
        status: "requested",
        CID: this.InstallationData.CID,
        userId: this.InstallationData.user.id,
        deviceTypeId: this.InstallationData.deviceType.id,
        sector: this.InstallationData.sector ? this.InstallationData.sector : null,
        to: this.periods.to,
        from: this.periods.from,
        deviceRequestId: this.requestId * 1,
        BOQ: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.BOQ)
      };
      console.log({ scope: scope });
      console.log({ InstallationData: this.InstallationData });
      var drq = this.InstallationData;
      delete drq.user;
      delete drq.deviceType;
      delete drq.installationComponents;
      drq.status = 3;

      HTTP.put("/device_requests/" + this.requestId, drq).then(function (response) {
        HTTP.post("/installations", scope).then(function (response) {
          var Response = response.data;
          if (Response) {
            container.showSuccessMsg({
              message: "Installation successfully scheduled & inventory requested"
            });
            container.$router.push({
              name: "devices",
              params: {
                activetab: "inventory_request"
              }
            });
          }
        });
      }).catch(function (error) {
        console.log({ error: error });
        _this4.showErrorMsg({
          message: "error occured"
        });
      });
    }

    // chk = this.validateRequestForm(this.rows);
    // if (chk !== false) {
    //   this.showErrorMsg({
    //     message: chk
    //   });
    //   return;
    // }
    // chk = this.duplicateEntries(this.rows);
    // if (chk !== false) {
    //   this.showErrorMsg({
    //     message: "Duplicate entries for " + chk.toString()
    //   });
    //   return;
    // }

    // for (var key in this.rows) {
    //   if (key.toLowerCase().indexOf("inverter") > -1)
    //     inverters += `${this.rows[key]} `;
    // }
  },
  availableComponents: function availableComponents() {
    var HTTP = this.$httpUtils.instance;
    var context = this;
    var url = "/inventories/?filter={\"limit\": \"1000\", \"where\": {\"status\": \"0\"}}";
    HTTP.get(url).then(function (response) {
      null;
      var componentList = response.data;
      console.log(componentList);
      componentList.filter(function (x) {
        x.value = x.serialNumber;
        x.text = x.serialNumber;
      });
      context.availableComponentsList = componentList;
    }).catch(function (error) {
      console.log("error", error);
    });
  },
  formatTime: function formatTime(date) {
    var date = new Date(date); //or your date here
    return date.getHours() + " : " + date.getMinutes() + " :  " + date.getSeconds();
  },
  formatDate: function formatDate(date) {
    var date = new Date(date); //or your date here
    return date.getFullYear() + " / " + (date.getMonth() + 1) + "  /  " + date.getDate();
  },
  componentName: function componentName(id) {
    console.log(this.componentsToUse);
    // this.tempData = this.componentsToUse.find(x => x.id == id)[
    //   "component"
    // ]["name"];
    // return this.tempData;
  },
  componentTypeNames: function componentTypeNames() {
    var HTTP = this.$httpUtils.instance;
    var container = this;
    HTTP.get("/component_types/?filter={\"include\": {\"relation\": \"component\",\"scope\": {\"where\": {\"id\": \"componentId\" }}}}", {}).then(function (rolesdata) {
      container.componentsToUse = rolesdata.data;
      // console.log(container.componentsToUse);
    });
  },
  getInstallationData: function getInstallationData() {
    var _this5 = this;

    var HTTP = this.$httpUtils.instance;
    HTTP.get("/device_requests/" + this.requestId + "?filter={\"include\": [\"user\",\"deviceType\",{\"installationComponents\":[\"componentItems\"]}]}").then(function (resp) {
      // console.log(resp.data.installationComponents);
      _this5.InstallationData = resp.data;
      _this5.packageData = resp.data.installationComponents.map(function (x) {
        x.description = x.componentItems.description;
        return x;
      });
      _this5.tmp = resp.data.installationComponents;
      _this5.packageQuantity = _this5.packageData.quantity;
      _this5.BOQ = _this5.packageData;
      console.log({ po: _this5.packageData });
    });
  }
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_components$notificat, "mounted", function mounted() {
  this.componentTypeNames();
  this.availableComponents();
  this.getInstallationData();
  // this.fetchSysTypes();
  this.getComponents();
}), _components$notificat);

/***/ }),
/* 942 */,
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ongoingInstalation",
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_5__utils_Autocomplete__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      componentId: null,
      componentTypeId: null,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null
      },
      deviceRequests: [],
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      dataParams: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [{
        label: "Customer Name",
        field: "full_name",
        sortable: "true"
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true,
        sortable: "true"
      }, {
        label: 'Customer ID',
        field: 'cid',
        filterable: true,
        sortable: "true"
      }, {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true,
        sortable: "true"
      }, {
        label: "Actions",
        field: "actions",
        sortable: "true"
      }],
      rows: [],
      reqSuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    scheduleInstalation: function scheduleInstalation(installationObj) {
      this.$router.push({
        name: "instalationSchedule",
        params: {
          Installation: installationObj
        }
      });
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          componentList.unshift({
            value: null,
            disabled: true,
            text: "Please component type"
          });

          context.componentTypeOptions = componentList;
          context.componentTypeId = null;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchComponents: function fetchComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        var componentFetch = components.data;
        componentFetch.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });

        componentFetch.unshift({
          value: null,
          disabled: true,
          text: "Select Component"
        });
        container.componentOptions = componentFetch;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate();
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    fetchData: function fetchData(d) {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"deviceType\"]}", {}).then(function (components) {
        var componentFetch = components.data;
        _this.dataParams = componentFetch;
      });
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
    var HTTP = this.$httpUtils.instance;
    var container = this;
    var filter = {
      order: "id DESC",
      where: { status: "scheduled" },
      include: {
        deviceRequest: ["user", "deviceType", { installationComponents: ["componentItems"] }]
      }
    };
    // console.log(JSON.stringify(filter));
    HTTP.get(
    // `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 3}, "order": "id DESC" }`,
    "/installations/?filter=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filter), {}).then(function (rolesdata) {
      // console.log(JSON.stringify(rolesdata.data))
      container.deviceRequests = rolesdata.data;
    });
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Autocomplete__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ongoingInstalation",
  components: {
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["b" /* ModalClose */],
    Autocomplete: __WEBPACK_IMPORTED_MODULE_8__utils_Autocomplete__["a" /* default */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchTerm: "",
      currentDeviceRequest: {},
      showInventoryApprove: false,
      componentId: null,
      componentTypeId: null,
      BOQ: [],
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null
      },
      inventoryCount: {
        // 1: 0,
        // 2: 0,
        // ...
      },
      deviceRequests: [],
      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }],
      dataParams: {
        typeOfBuilding: null,
        roofType: null,
        roofCondition: null,
        roofReadiness: null,
        roofAge: null,
        comment: null,
        createAt: null,
        deviceType: null,
        user: null
      },
      columns: [{
        label: "Customer Name",
        field: "full_name",
        sortable: "true"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true,
        sortable: "true"
      }, {
        label: "Customer ID",
        field: "CID",
        sortable: "true"
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true,
        sortable: "true"
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true,
        sortable: "true"
      }, {
        label: "Actions",
        field: "actions",
        sortable: "true"
      }],
      rows: [],
      reqSuccess: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  methods: {
    submitRequest: function submitRequest(event) {
      var _this = this;

      event.preventDefault();
      //console.log(this.currentDeviceRequest)
      var scope = {
        status: "scheduled",
        approvedAt: new Date(),
        approvedById: this.getUserSession.id
      };
      //console.log(scope)
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.patch("/device_requests/" + this.currentDeviceRequest.deviceRequestId, { status: 4 }).then(function (response) {
        HTTP.patch("/installations/" + _this.currentDeviceRequest.id, scope).then(function (response) {
          var Response = response.data;
          console.log(response.data);
          if (Response) {
            container.showSuccessMsg({
              message: "Inventory request approved"
            });
            container.showInventoryApprove = false;
            // container.fetchDeviceRequests();
            container.$router.push({
              name: "devices",
              params: {
                activetab: "inventory_request"
              }
            });
            container.$router.go();
          }
        });
      }).catch(function (error) {
        console.log(error);
        _this.showErrorMsg({
          message: "error occured"
        });
      });
    },
    validateRequestForm: function validateRequestForm() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.requestForm)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          if (value === null || value === "") {
            return "Please fill all fields!";
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },
    showApprovalModal: function showApprovalModal(row) {
      console.log(row);
      this.currentDeviceRequest = row;
      if (row.BOQ) {
        this.BOQ = JSON.parse(row["BOQ"]);
      } else {
        this.BOQ = row.deviceRequest.installationComponents;
      }
      this.showInventoryApprove = true;

      // console.log(this.currentDeviceRequest);
      // console.log(this.BOQ);
      // this.BOQ = JSON.parse(this.currentDeviceRequest['BOQ']
      // let boq=JSON.parse(this.currentDeviceRequest['BOQ']);

      // this.currentDeviceRequest["BOQ"] = boq;
      // if (this.currentDeviceRequest['BOQ'] == null){
      //   this.currentDeviceRequest =
      // }
      // console.log(this.curre);

      // console.log(this.getUserSession.id)
    },
    scheduleInstalation: function scheduleInstalation(installationObj) {
      this.$router.push({
        name: "instalationSchedule",
        params: {
          Installation: installationObj
        }
      });
    },
    fetchInventoryCounts: function fetchInventoryCounts(array) {
      // this accepts an array
      var HTTP = this.$httpUtils.instance;
      var context = this;
      var componentIds = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this._formatArrayInput(array));
      HTTP.get("/inventories/?filter={\"where\": {\"status\": \"0\", \"componentId\": {\"inq\" : " + componentIds + "}}}").then(function (response) {
        // @todo: this should be extrated to its function
        var totalItems = response.data.reduce(function (result, item) {
          var itemComponentId = item.componentId;
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, result, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, itemComponentId, result[itemComponentId] ? result[itemComponentId] + 1 : 1));
        }, {});

        context.inventoryCount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, totalItems);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    _formatArrayInput: function _formatArrayInput(arrayInput) {
      // my input looks like "[solar_panel_2, battery_1]"
      // output should return => JSON.stringify(["1","2","3"])
      if (arrayInput.length < 1) {
        console.log("nothing in array");
        return;
      }

      return arrayInput.map(function (item) {
        var splitedResult = item.split("_");
        // select last item in array
        return splitedResult[splitedResult.length - 1];
      });
    },
    _convertIntKeyToNamedValues: function _convertIntKeyToNamedValues(value) {
      switch (value) {
        case 1:
          return "batteries";
        case 2:
          return "inverters";
        case 3:
          return "solar_panels";
        default:
          return "undefined_0";
      }
    },
    _countOrReturnZero: function _countOrReturnZero(value) {
      if (!value) {
        return 0;
      }
      return value;
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          componentList.unshift({
            value: null,
            disabled: true,
            text: "Please component type"
          });

          context.componentTypeOptions = componentList;
          context.componentTypeId = null;
        }).catch(function (error) {
          console.log("error", error);
        });
      }
    },
    fetchComponents: function fetchComponents() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/components/", {}).then(function (components) {
        var componentFetch = components.data;
        componentFetch.filter(function (x) {
          x.value = x.id;
          x.text = x.name;
        });

        componentFetch.unshift({
          value: null,
          disabled: true,
          text: "Select Component"
        });
        container.componentOptions = componentFetch;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + "/" + date.getMonth() + 1 + "/" + date.getDate();
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    },
    fetchData: function fetchData(d) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"deviceType\"]}", {}).then(function (components) {
        var componentFetch = components.data;
        _this2.dataParams = componentFetch;
      });
    },
    fetchDeviceRequests: function fetchDeviceRequests() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var container = this;
      var filter = {
        order: "id DESC",
        where: { status: "requested" },
        include: {
          deviceRequest: ["user", "deviceType", { installationComponents: ["componentItems"] }]
        }
      };
      // console.log(JSON.stringify(filter));
      HTTP.get(
      // `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 3}, "order": "id DESC" }`,
      "/installations/?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter), {}).then(function (rolesdata) {
        // console.log(JSON.stringify(rolesdata.data))

        container.deviceRequests = rolesdata.data.filter(function (x) {
          if (x.deviceRequest) {
            return true;
          } else {
            console.log(x);
          }
        });
        console.log(container.deviceRequests);
        _this3._fetchAndParseInventoryItems(container.deviceRequests);
      });
    },
    _fetchAndParseInventoryItems: function _fetchAndParseInventoryItems(items) {
      var _this4 = this;

      var result = items.reduce(function (total, item) {
        var _inventoryNames = _this4._compileInventoryComponentNameOnEachInstallation(item);
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(total), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_inventoryNames));
      }, []);
      var _inventoryItems = this._removeArrayDuplicates(result);
      var _inventoryCounts = this.fetchInventoryCounts(_inventoryItems);
    },
    _removeArrayDuplicates: function _removeArrayDuplicates(array) {
      if (array.length > 0) {
        return array.reduce(function (total, single) {
          return total.includes(single) ? total : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(total), [single]);
        }, []);
      }
    },
    _printTotalAvailableComponents: function _printTotalAvailableComponents(selectedComponent, recognizedInventories) {
      // (selectedComponent.componentTypeId in recognizedInventories) ==> nice but not readable
      var selected = selectedComponent.componentTypeId;
      var quantity = selectedComponent.quantity;
      var total = recognizedInventories[selected];
      if (recognizedInventories.hasOwnProperty(selected)) {
        if (total < quantity) {
          return total + " - FIX: limited quantity in stock";
        }
        return total;
      }
      return 0 + " - FIX: limited quantity in stock";
    },
    _shouldDisableApproveButton: function _shouldDisableApproveButton(selectedComponent, recognizedInventories) {
      // return false;
      try {
        var result = false;
        var components = selectedComponent.installationComponents;
        components.forEach(function (item) {
          var quantity = item.quantity;
          var componentId = item.componentTypeId;
          if (recognizedInventories.hasOwnProperty(componentId)) {
            var total = recognizedInventories[componentId];
            if (total < quantity) {
              result = true; // if total is less than quantity, yes, shouldDisableApproveButton;
            }
          } else {
            // if an item doesn't exist in inventory count
            // that's an automatic 0 total
            result = true;
          }
        });
        return result; //if all goes well, return false (i.e don't disable approve button)
      } catch (error) {}

      return true;
    },
    _compileInventoryComponentNameOnEachInstallation: function _compileInventoryComponentNameOnEachInstallation(installations) {
      var inputs = installations.deviceRequest.installationComponents;
      if (inputs) {
        return inputs.reduce(function (total, item) {
          var jointName = item.componentItems.name + "_" + item.componentTypeId;
          return total.includes(jointName) ? total : [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(total), [jointName]);
        }, []);
      }
    }
  },
  mounted: function mounted() {
    this.fetchData(this.$route.params.id);
    this.fetchComponents();
    this.fetchDeviceRequests();
  }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_GoogleAddressSuggest_vue__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_hotel_datepicker__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_hotel_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_hotel_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
//import Autocomplete from "../../utils/Autocomplete";





// import { Datetime } from "vue-datetime";
// import "vue-datetime/dist/vue-datetime.css";
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "instalationCommission",
  components: {
    Autocomplete: __WEBPACK_IMPORTED_MODULE_10_element_ui__["Autocomplete"],
    AddressInput: __WEBPACK_IMPORTED_MODULE_7__components_utils_GoogleAddressSuggest_vue__["a" /* default */],
    HotelDatePicker: __WEBPACK_IMPORTED_MODULE_9_vue_hotel_datepicker___default.a,
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Autocomplete"],
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Form"],
    "el-card": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Card"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      assignedTo: null,
      addressParam: {},
      maintenanceOptions: [{
        value: 60,
        label: "Bi-Monthly (Two Months)"
      }, {
        value: 90,
        label: "Quarter (Three Months)"
      }],
      assignList: [],
      maintenanceValue: "",
      Address: "",
      expiryDate: "",
      requestId: this.$route.params.Installation,
      InstallationData: {
        deviceRequest: {
          user: {},
          deviceType: {}
        }
      },
      formData: {
        warranty: null,
        maintenance: null,
        address: null,
        assignedTo: null
      },
      componentsToUse_public: {},
      availableComponentsList: [],
      rows: {},
      results: {},
      inventories: null,
      periods: {
        from: null,
        to: null
      },
      tempData: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"]), {
    componentsToUse: {
      // getter
      get: function get() {
        return this.componentsToUse_public;
      },
      // setter
      set: function set(newValue) {
        this.componentsToUse_public = newValue;
      }
    }
  }),
  methods: {
    userSearch: function userSearch(queryString, cb) {
      var _this = this;

      var users = this.assignList;
      var results = queryString ? users.filter(function (user) {
        return _this.createFilter(queryString, user);
      }) : users;
      cb(results);
    },
    fetchAssignList: function fetchAssignList() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType]=customer operations engineer" + "&filter[order]=id DESC";
      HTTP.get(url)
      // .then(response => {
      //   const usersList = response.data;
      //   console.log(usersList)
      //   this.$store.commit("saveUsers", usersList);
      //   // console.log(this.getUserById(1))
      // })
      .then(function (response) {
        return response.data;
      }).then(function (tempList) {
        // console.log(tempList);

        _this2.assignList = tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    showSolarValues: function showSolarValues(value, index) {
      // console.log(value, index)
      if (value[index]) {
        console.log("you", value.value);
        return value[index].value;
      }
      return "---";
    },
    showSolarInputs: function showSolarInputs(values, quantity) {
      var output = "";

      for (var i = 0; i < quantity; i++) {
        var itemValue = values[i] && values[i].value || "---";
        output += "\n          <input\n            type=\"text\"\n            value=\"" + itemValue + "\"\n            disabled=\"true\"\n            class=\"componentType form-control\"\n            style=\"text-transform: capitalize !important; margin-bottom: 10px\"\n          />\n        ";
      }

      return output;
    },
    userSelected: function userSelected(user) {
      this.formData = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.formData, {
        assignedTo: user["id"]
      });
      //  console.log({
      //   form: this.form
      // });
    },
    setCheckin: function setCheckin(chkInDate) {
      this.periods.from = chkInDate;
      console.log(this.periods.from);
    },
    setCheckOut: function setCheckOut(chkOutnDate) {
      this.periods.to = chkOutnDate;
      // console.log(this.periods.to);
    },
    filterList: function filterList(arrayVal, component) {
      var dat = arrayVal.filter(function (x) {
        return x.componentId === component.componentTypeId;
      });
      dat.unshift({
        value: null,
        disabled: true,
        text: "Please Select " + component.componentItems.name
      });
      return dat;
    },
    validateRequestForm: function validateRequestForm(entries) {
      console.log("}}}}}}}}}}}}}}}}}}}}}}}}");

      console.log(entries);

      var qty = 0;
      this.InstallationData.deviceRequest.installationComponents.forEach(function (a) {
        if (a.componentTypeId === 1 || a.componentTypeId === 2) {
          qty += a.quantity;
        }
      });
      var _formData = this.formData;
      // if (
      //   !_formData.warranty ||
      //   !_formData.maintenance ||
      //   !this.formData.address
      // ) {
      //   return "Please installation details!";
      // }

      // for (let [field, value] of Object.entries(this.periods)) {
      //   if (value === null || value === "") {
      //     return "Please fill all fields!";
      //   }
      // }
      // console.log(qty, Object.keys(entries).length);
      return qty > __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(entries).length ? "Please fill all entries !!!" : false;
    },
    duplicateEntries: function duplicateEntries(param) {
      var names = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(param);
      var count = function count(names) {
        return names.reduce(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(a, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, b, (a[b] || 0) + 1));
        }, {});
      };
      var duplicates = function duplicates(dict) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(dict).filter(function (a) {
          return dict[a] > 1;
        });
      };
      var c = count(names);
      var d = duplicates(count(names));
      return d.length > 0 ? d : false;
    },
    compareDate: function compareDate(date1, date2) {
      var now = new Date();
      var myDate = new Date(date1);
      var myDate2 = new Date(date2);

      // console.log({
      //   now,
      //   myDate,
      //   date2
      // });
      return now > myDate ? "Past Date" : myDate > myDate2 ? "Invalid Date supplied" : false;
    },

    /**
     * When the location found
     * @param {Object} addressData Data of the found location
     * @param {Object} placeResultData PlaceResult object
     * @param {String} id Input container ID
     */
    getAddressData: function getAddressData(addressData, placeResultData, id) {
      this.addressParam = {
        position: {
          lat: addressData.latitude,
          lng: addressData.longitude
        },
        streetNumber: addressData.street_number,
        streetRoute: (addressData.route ? addressData.route : "") + " - " + (addressData.locality ? addressData.locality : "") + ", " + (addressData.country ? addressData.country : ""),
        stateId: 0,
        countryId: 0,
        locationId: 0,
        lgaId: 0,
        userId: this.InstallationData.userId,
        installationId: this.InstallationData.id,
        deviceRequestId: this.InstallationData.deviceRequestId
      };
      // console.log(this.addressParam);
    },
    submitAddressUpdate: function submitAddressUpdate() {
      var _this3 = this;

      var container = this;
      var HTTP = this.$httpUtils.instance;
      var url = "/locations";
      HTTP.post(url, this.addressParam).then(function (response) {
        container.dialogVisible = false;
        _this3.showSuccessMsg({
          message: "Installation successfully commissioned!"
        });
        setTimeout(function () {
          container.$router.push({
            path: "/device/" + container.addressParam.installationId
          });
        }, 500);
      }).catch(function (error) {
        var errorMsg = error.response.data.error.details.messages;
        var errTemp = [];
        var keyHooks = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(errorMsg);
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
          errTemp[index] = keyHooks[index] + " " + x[0];
        });
        errTemp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
        _this3.showErrorMsg({
          message: errTemp
        });
      });
    },
    submitRequest: function submitRequest(event) {
      var _this4 = this;

      event.preventDefault();

      var HTTP = this.$httpUtils.instance;
      var container = this;
      var inverters = "";
      var chk = this.duplicateEntries(this.rows);
      console.log(this.rows);

      console.log(chk);

      if (chk !== false) {
        this.showErrorMsg({
          message: "Duplicate entries for " + chk.toString()
        });
        return;
      }
      // this.rows.__inverter__5 = 8585858;
      // this.rows.__inverter__6 = 8585855;
      for (var key in this.rows) {
        if (key.toLowerCase().indexOf("inverter") > -1) {
          inverters += this.rows[key] + " ";
        }
      }

      console.log(this.rows);
      console.log(this.formData);
      console.log("---=========------");

      var scope = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({
        solarKitIds: inverters.trim(),
        status: "commissioned",
        commissioned: new Date().toLocaleDateString()
      }, this.formData);
      chk = this.validateRequestForm(this.rows);
      if (chk !== false) {
        this.showErrorMsg({
          message: chk
        });
        return;
      }
      // console.log({ scope });
      HTTP.patch("/installations/" + this.InstallationData.id, scope).then(function (response) {
        var Response = response.data;
        if (Response) {
          var kitId = Response.id;
          scope = [];
          var a = [];
          for (var key in _this4.rows) {
            scope.push({
              serialNumber: _this4.rows[key],
              installationId: kitId
            });
            a.push(_this4.rows[key]);
          }
          HTTP.post("/installation_trackers", scope).then(function (data) {
            HTTP.patch("/device_requests/" + _this4.InstallationData.deviceRequest.id, {
              status: 4
            }).then(function (data) {
              HTTP.post("/inventories/update?where={\"serialNumber\":{\"inq\":[" + a + "]}}", {
                status: "1"
              }).then(function (data) {
                container.submitAddressUpdate();
              });
            });
          });
        }
      }).catch(function (error) {
        console.log(error);

        _this4.showErrorMsg({
          message: "error occured"
        });
      });
    },
    availableComponents: function availableComponents(typeIds) {
      var HTTP = this.$httpUtils.instance;
      var context = this;
      var url = "/inventories/?filter={\"limit\": \"1000\",  \"order\": \"serialNumber ASC\", \"where\": {\"status\": \"0\", \"componentId\": { \"inq\": " + typeIds + "}}}";
      HTTP.get(url).then(function (response) {
        var componentList = response.data;
        // console.log(componentList);
        componentList.filter(function (x) {
          x.value = x.serialNumber;
          x.text = x.serialNumber;
        });
        context.availableComponentsList = componentList;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    formatTime: function formatTime(date) {
      var date = new Date(date); //or your date here
      return date.getHours() + " : " + date.getMinutes() + " :  " + date.getSeconds();
    },
    formatDate: function formatDate(date) {
      var date = new Date(date); //or your date here
      return date.getFullYear() + " / " + (date.getMonth() + 1) + "  /  " + date.getDate();
    },
    componentName: function componentName(id) {
      // console.log(this.componentsToUse);
      // this.tempData = this.componentsToUse.find(x => x.id == id)[
      //   "component"
      // ]["name"];
      // return this.tempData;
    },
    isSolarPanels: function isSolarPanels(name, arrayVal) {
      if (name == "solar panels") {
        // this too is hardcodded...
        var dat = arrayVal.filter(function (x) {
          return x.componentId === 3; //this is hardcodded...
        });
        return dat;
      }
      return false;
    },
    componentTypeNames: function componentTypeNames() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      HTTP.get("/component_types/?filter={\"include\": {\"relation\": \"component\",\"scope\": {\"where\": {\"id\": \"componentId\" }}}}", {}).then(function (rolesdata) {
        container.componentsToUse = rolesdata.data;
        // console.log(container.componentsToUse);
      });
    },
    getInstallationData: function getInstallationData() {
      var _this5 = this;

      var HTTP = this.$httpUtils.instance;
      var filter = {
        order: "id DESC",
        where: { status: "scheduled" },
        include: {
          deviceRequest: ["user", "deviceType", { installationComponents: ["componentItems"] }]
        }
      };

      // HTTP.get(
      //   `/device_requests/${this.requestId}?filter={"include": ["user","deviceType",{"installationComponents":["componentItems"]}]}`
      // )
      // console.log(JSON.stringify(filter));
      HTTP.get(
      // `/device_requests/?filter={"include": ["user","deviceType","installationComponents"], "where": {"status": 3}, "order": "id DESC" }`,
      "/installations/" + this.requestId + "?filter=" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(filter), {}).then(function (resp) {
        // console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>");
        // console.log(resp.data.deviceRequest.installationComponents);
        var requiredComponents = resp.data.deviceRequest.installationComponents.map(function (x) {
          return x.componentItems.id;
        });
        _this5.availableComponents(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(requiredComponents));
        _this5.InstallationData = resp.data;
      });
    }
  },
  mounted: function mounted() {
    // this.componentTypeNames();
    this.getInstallationData();
    this.assignList = this.fetchAssignList();
  }
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__details_v2_vue__ = __webpack_require__(2232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__details_v3_vue__ = __webpack_require__(2570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_index_vue__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__details_v4_vue__ = __webpack_require__(2590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__details_v5_vue__ = __webpack_require__(2593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__details_v6_vue__ = __webpack_require__(2596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */















// import flatPickr from "vue-flatpickr-component";

// import "flatpickr/dist/flatpickr.css";

// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
var endies = "https://iot-solarbase.arnergy.com/event/publish";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["CollapseItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_9__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_8__kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_17__kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "v2-dash": __WEBPACK_IMPORTED_MODULE_11__details_v2_vue__["a" /* default */],
    "v3-dash": __WEBPACK_IMPORTED_MODULE_12__details_v3_vue__["a" /* default */],
    "v4-dash": __WEBPACK_IMPORTED_MODULE_14__details_v4_vue__["a" /* default */],
    "v5-dash": __WEBPACK_IMPORTED_MODULE_15__details_v5_vue__["a" /* default */],
    "v6-dash": __WEBPACK_IMPORTED_MODULE_16__details_v6_vue__["a" /* default */],
    "control-settings": __WEBPACK_IMPORTED_MODULE_13__controls_index_vue__["a" /* default */],

    // powerStat,
    // flatPickr,
    RightBar: __WEBPACK_IMPORTED_MODULE_20__rightBar__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["c" /* mapGetters */])(["DeviceList", "getUserSession"]), {
    // Device: {}
    isShow: {
      get: function get() {
        if (this.$can("am", "sm") || this.$can("manage", "user")) {
          return true;
        } else return false;
      }
    }
  }),
  data: function data() {
    return {
      initError: true,
      installationData: { name: "Arnergy Solar (Unassigned)" },
      deviceWarning: {},
      powerState: {},
      screenView: {
        code: 0,
        codeName: "System Overview"
      },
      chargerPriority: "01",
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_18_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_18_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      timeRightNow: "",
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      Device: {},
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapActions */])(["refreshList"]), {
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    getDevice: function getDevice() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var inverterId, context, HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                inverterId = _this.$route.params.deviceId;
                context = _this;
                HTTP = _this.$httpUtils.instance;
                //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;

                url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
                _context.next = 6;
                return HTTP.get(url).then(function (response) {
                  if (response.data.length > 0) context.installationData = response.data[0];
                  //console.log(response.data);
                }).catch(function (error) {
                  return "not assign";
                  //console.log("error", error);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openBlank: function openBlank() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var installationData, uuid, name, CID, URL;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                installationData = _this2.installationData;
                uuid = installationData.user.uuid;
                name = installationData.name, CID = installationData.CID;


                console.log(installationData);

                URL = "https://oss.arnergy.com/d/_fUnhhknk/grid-metrics?orgId=1&var-uuid=" + uuid + "&var-name=" + name + "%20&var-deviceId=" + CID;
                // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&kiosk`;
                // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&var-deviceId=${this.$route.params.deviceId}`;

                window.open(URL, "_blank").focus();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleSplitValue: function handleSplitValue(param) {
      this.screenView = param;
      // console.log(this.screenView);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    renderChart: function renderChart() {},
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_18_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(parameters) {
      var power = this.roundUp(parameters.ACOutputActivePower * 1 / 1000);
      return power + "kW";
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.$route.params.deviceId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = endies;
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this3.hideControl();
      }).catch(function (e) {
        console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.$route.params.deviceId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_18_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    initFetch: function initFetch() {
      var inverterId = this.$route.params.deviceId;
      // console.log(this.refreshList);
      this.Device = {
        parameters: this.findDeviceData(this.DeviceList.devices, "DeviceID", inverterId)[0],
        mode: this.findDeviceData(this.DeviceList.modes, "DeviceID", inverterId)[0],
        expiry: this.findDeviceData(this.DeviceList.expiries, "DeviceID", inverterId)[0]
      };
      // console.log(this.DeviceList);
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.$route.params.deviceId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    transformData: function transformData(data, keys) {
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["payload"][key] * 1]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_18_moment___default()(c_item["payload"]["TimeStamp"]).add(1, "hour").format("h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "PVChargingPower"]);
      this.solarchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Output Active Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["ACOutputActivePower"]
        }, {
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#ffb946",
          // backgroundColor: "rgba(0,0,0,0.3)",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart: function batteryChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["BatteryCapacity", "OutputLoadPercent"]);
      this.chartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Battery Percent",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["BatteryCapacity"]
        }, {
          pointRadius: 0,
          label: "Load Percent",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["OutputLoadPercent"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

      var container = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Parameters",
        KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": "" + inverterId,
          ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_18_moment___default()("2019/6/20").startOf("day").toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        // console.log(DevData);
        // console.log(this.getTimeLabel(DevData));
        _this4.batteryChart(DevData, _this4.getTimeLabel(DevData));
        _this4.solarDataChart(DevData, _this4.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var app = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_18_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        return console.log(err);
      });
    }
    // getDevice() {
    //   var inverterId = this.$route.params.deviceId;
    //   const context = this;
    //   const HTTP = this.$httpUtils.instance;
    //   //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    //   const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][solarKitIds]=${inverterId}`;
    //   HTTP.get(url)
    //     .then((response) => {
    //       if (response.data.length > 0)
    //         context.installationData = response.data[0];
    //     })
    //     .catch((error) => {
    //       return "not assign";
    //       //console.log("error", error);
    //     });
    // },

  }),
  created: function created() {},
  mounted: function mounted() {
    this.initError = false;
    // try {
    //   this.currentTime();
    // this.refreshList();
    //   this.initFetch();
    this.getDevice();
    //   this.getDeviceState();
    //   this.getDeviceData();
    //   this.getDeviceWarnings();
    // } catch (error) {
    //   this.initError = true;
    //   console.log("Init Error", error);
    // }

    // this.fetchAllDeviceData();
    // this.fetchHealth("today");
    // this.statusBorder = "4px solid #000";
    // setInterval(this.fetchAllDeviceData, 60000);
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_zoom__ = __webpack_require__(2227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_zoom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_zoom__);

//
//
//
//
//
//

/* eslint-disable */

// var myChart = {};
// var ctx = {};
var DEFAULT_OPTIONS = {
  legend: {
    labels: {}
  },
  responsive: true,
  maintainAspectRatio: false,
  pan: {
    enabled: true,
    mode: "x" // is panning about the y axis neccessary for bar charts?
  },
  zoom: {
    enabled: true,
    mode: "x"
  },
  major: {
    ticks: {}
  },
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true
      }
    }],
    xAxes: [{
      ticks: {
        // maxTicksLimit: 5
      }
    }]
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "grey-chart",
  props: ["options", "data", "type", "id", "short"],
  data: function data() {
    return {};
  },
  components: {},
  methods: {
    reload: function reload(newData, newType) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.drawChart(newData, newType, options);
      // alert("reloading");
    },
    drawChart: function drawChart(data, type) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var ctx = document.getElementById("myChart" + this.id).getContext("2d");
      var myChart = new Chart(ctx, {
        plugins: [__WEBPACK_IMPORTED_MODULE_1_chartjs_plugin_zoom___default.a],
        type: type,
        data: data,
        options: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, DEFAULT_OPTIONS, options)
      });
    }
  },
  mounted: function mounted() {
    var ctx = document.getElementById("myChart" + this.id).getContext("2d");
    // console.log(this.id)
    this.drawChart(this.data, this.type, this.options);
  },
  updated: function updated() {}
});

/***/ }),
/* 948 */,
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard-info-widgets",
  components: {},

  mounted: function mounted() {
    this.$refs.circleProgress.$data.value = 70;
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_timers__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_dashboard_animated_icons__ = __webpack_require__(97);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";

// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);
// var converter = require("json-2-csv");



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Loading"]);

var liveTimeout = null;



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  props: {
    inverterId: {
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_9__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_8__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_16_vue_datetime__["Datetime"],
    "device-control": __WEBPACK_IMPORTED_MODULE_19__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_20__widgets_charts__["default"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_21__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },

    statusBorder: {
      get: function get() {
        return "4px solid #e34a4a;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  beforeDestroy: function beforeDestroy() {
    // console.log("teardown shii", liveTimeout);
    // clearTimeout(liveTimeout);
    this.liveTimeout.destroy();
  },
  data: function data() {
    return {
      activeNames: ["1"],
      loading: true,
      filterDate: null,
      pickerOptions: {
        shortcuts: [{
          text: "Last week",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last month",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 3 months",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      liveTimeout: null,
      initError: false,
      installationData: {
        name: "Loding..."
      },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      perPage: 10,
      currentPage: 1,
      exportDataToTableValues: [],
      exportDataTableoptions: [],
      exportDataToTableValuesFields: ["payload.TimeStamp", "payload.PVInputVoltage", "payload.InverterId", "payload.EnergyData.ConsumedYearOffGrid"],
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_12_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_12_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      timeRightNow: __WEBPACK_IMPORTED_MODULE_12_moment___default()(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])(["refreshList", "performanceGraphCall"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    filterChart: function filterChart() {
      console.log(this.filterDate);
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    showWAlarm: function showWAlarm(type) {
      var _this2 = this;

      var resp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        return _tmp += _this2.deviceWarning[_curr] == 1 ? "<li>" + _this2.flags[type][_curr] + "</li>" : "";
      }, "");
      __WEBPACK_IMPORTED_MODULE_6_element_ui__["Notification"].warning({
        title: "" + type[0].toUpperCase() + type.slice(1),
        dangerouslyUseHTMLString: true,
        message: resp
      });
      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              return "warning";
            } else if (this.flags.faults[property]) {
              return "error";
            }
          }
        }
      }
      return;
    },
    exportData: function exportData() {
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    exportDataToTable: function exportDataToTable() {
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.currentTime();

              case 2:
                _this3.timeRightNow = _context.sent;
                container = _this3;
                inverterId = _this3.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this3.showTableOffCanvas = true;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    console.log(temp);

                    _this3.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }
                  _this3.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.currentTime();

              case 2:
                _this4.timeRightNow = _context2.sent;
                container = _this4;
                inverterId = _this4.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });

                  _this4.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    currentTime: function currentTime() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var me, HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = _this5;
                HTTP = _this5.$httpUtils.instance;
                _context3.next = 4;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 4:
                response = _context3.sent;
                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen() {
      // console.log(this.Device);
      return this.Device.parameters ? new Date(this.Device.parameters.TimeStamp).toDateString() + " " + new Date(this.Device.parameters.TimeStamp).toLocaleTimeString() : "--";
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_12_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    renderChart: function renderChart() {},
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(parameters) {
      var power = this.roundUp(parameters.ACOutputActivePower * 1 / 1000);
      return power + "kW";
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.PVChargingPower * 1 / 1000);
      return power + " kW";
      // var power = this.roundUp(
      //   (parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1)) / 1000
      // );
      // return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    confirmEnergy: function confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (cid) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", true);

              case 2:
                GraphHTTP = _this6.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context4.next = 6;
                return GraphHTTP.post("/graphql", data).then(function (res) {
                  console.log("---> V2 <----");

                  console.log(res);
                  console.log("++++++++>=1", _this6.Device);
                  if (res.data.data.device["Items"]) {
                    _this6.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this6.Device, {
                      parameters: res.data.data.device["Items"][0]["payload"]
                    });
                    console.log("++++++++>=2", _this6.Device);
                  }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, headers, payLoad, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.currentTime();

              case 2:
                _this7.timeRightNow = _context5.sent;
                container = _this7;
                headers = {
                  "Content-Type": "application/plain"
                };
                payLoad = {
                  ":key": Number(_this7.inverterId)
                };
                data = {
                  TableName: "ConnectedDevices",
                  FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
                  ExpressionAttributeValues: payLoad
                  // Limit: limit,
                  // ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
                  headers: headers
                }).then(function (resp) {
                  if (resp.data["Items"]) {
                    _this7.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this7.Device, {
                      parameters: resp.data["Items"][0]
                    });
                    console.log("++++++++>=", _this7.Device);
                  }
                  // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
                  // console.log("++++++++>=",  resp.data['Items']);
                }).catch(function (err) {
                  //  console.log("=++++++++>", err);
                  // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_12_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";
        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    initFetch: function initFetch() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var deviceId, inverterId, data_tmp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                deviceId = _this8.$route.params.deviceId;
                // let timeRightNow = await this.currentTime();
                // this.performanceGraphCall(timeRightNow);

                inverterId = _this8.inverterId * 1;
                // console.log(
                //   "============================",

                // );

                _this8.graphDetailsCall(parseInt(deviceId));
                data_tmp = _this8.DeviceList.find(function (x) {
                  return x.DeviceID == inverterId;
                });

                console.log("===========", data_tmp.payload);
                _this8.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, data_tmp, {
                  parameters: data_tmp.payload
                  //   mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
                  //   expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
                });
                // console.log(",,,,,", this.Device);
                if (_this8.Device.parameters == null) {
                  _this8.initError = true;
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["payload"][key] * 1]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_12_moment___default()(c_item["payload"]["TimeStamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "PVChargingPower"]);
      this.solarchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Output Active Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["ACOutputActivePower"]
        }, {
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#ffb946",
          // backgroundColor: "rgba(0,0,0,0.3)",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.charttype = "line";
      this.loading = false;
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart: function batteryChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["BatteryCapacity", "OutputLoadPercent"]);
      this.chartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Battery Percent",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["BatteryCapacity"]
        }, {
          pointRadius: 0,
          label: "Load Percent",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["OutputLoadPercent"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this9 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

      var container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Parameters",
        KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": "" + inverterId,
          ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        //  console.log(DevData);
        // console.log(this.getTimeLabel(DevData));
        _this9.batteryChart(DevData, _this9.getTimeLabel(DevData));
        _this9.solarDataChart(DevData, _this9.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //  console.log(err)
      });
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_12_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        //  console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {});
    },
    getDevice: function getDevice() {
      //  console.log(err)

      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][or][0][CID]=" + inverterId + "&filter[where][or][1][solarKitIds]=" + inverterId;
      HTTP.get(url).then(function (response) {
        //  console.log({ response });
        if (response.data.length > 0) context.installationData = response.data[0];
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this10.initError = false;
              try {
                // await this.currentTime();
                _this10.initFetch().then(function (x) {
                  // console.log(this.DeviceList);
                  // this.initFetch();
                  _this10.getDevice();
                  _this10.getDeviceState();
                  _this10.getDeviceWarnings();
                  // this.fetchAllDeviceData();

                  var deviceId = _this10.$route.params.deviceId;

                  console.log(deviceId);
                  _this10.graphDetailsCall(parseInt(deviceId));
                });
              } catch (error) {
                _this10.initError = true;
                //  console.log("Init Error", error);
              }

              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              //

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this10);
    }))();
  }
});

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "grey-battery",
  props: ["height", "width", "direction", "level", "mini"],
  data: function data() {
    return {
      boltDisplay: false,
      // batteryLevel: 0,
      battery_meter: {
        background: "green",
        width: this.level + "%" || "100%",
        height: "100%"
      },
      holderStyle: {
        width: this.width || "100px",
        height: this.height || "30px",
        background: "#eee"
      },
      parentStyle: {
        transform: this.direction == "y" ? "rotate(-90deg)" : ""
      },
      boltStyle: {
        display: 'none',
        transform: this.direction == "y" ? "rotate(90deg)" : ""
      }
    };
  },
  watch: {
    level: function level(newVal, old) {
      // console.log(old, newVal);
      this.batteryLevel = newVal;
      this.batUpdate(newVal);
      // this.boltDisplay = 
    }
  },
  components: {},
  methods: {
    batUpdate: function batUpdate(charge) {
      this.$refs.battery_level.style.width = charge + "%";
      var bg;
      this.$refs.bolt_display.style.display = 'none';
      if (charge <= 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        this.$refs.bolt_display.style.display = 'block';
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {

        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      // if(charge <80){

      // }
      // console.log(this.$refs.battery_level);
      this.battery_meter.background = bg;
      this.$refs.battery_level.style.background = bg;
    }
  },
  mounted: function mounted() {
    this.batUpdate(this.level);
  },
  updated: function updated() {}
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui_lib_theme_chalk_index_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Alert"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "device-control",
  components: {
    datetime: __WEBPACK_IMPORTED_MODULE_2_vue_datetime__["Datetime"]
  },
  data: function data() {
    return {
      endpointsMap: {
        "11-power": "power",

        "00-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "11-admin": "admin",

        "00-admin": "admin"
      },
      powerMap: {
        11: "ON",
        "00": "OFF"
      },
      chargerPriority: "01",
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      subExpiry: null,
      showWarning: false,
      powerState: null,
      adminPower: null,
      currentCommand: "",
      controlModal: false,
      deviceShadow: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  props: {
    inverterId: {
      default: null
    },
    identifier: {
      default: "EMS"
    },
    inverterNum: {
      default: ""
    }
  },
  methods: {
    getDeviceState: function getDeviceState() {
      var _this = this;

      var container = this;
      var inverterId = this.inverterId;
      if (this.identifier == "LUX") {
        var LuxHTTP = this.$httpUtils.LUXHTTP;
        var url = "/inverters/system_state?serialNumber=" + this.inverterNum;
        LuxHTTP.get(url).then(function (response) {
          if (response.data == true) {
            container.powerState = "ON";
            container.adminPower = "ON";
          }
          if (response.data == false) {
            container.powerState = "OFF";
            container.adminPower = "OFF";
          }
        }).catch(function (err) {
          _this.showErrorMsg({ message: "Error occured at our end!" });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId + "?" + Date.now()).then(function (resp) {
          container.deviceShadow = resp.data.state;

          if (resp.data.state.reported.userPower) {
            container.powerState = container.powerMap[resp.data.state.reported.userPower];
          }
          if (resp.data.state.reported.adminPower) {
            container.adminPower = container.powerMap[resp.data.state.reported.adminPower];
          }
          if (resp.data.state.reported.setExpiry) {
            container.subExpiry = new Date(resp.data.state.reported.setExpiry).toString();
          }
        }).catch(function (err) {
          //console.log(err)
        });
      }
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.controlModal = true;
      //   this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      //   this.$refs.controlModal.hide();
      this.controlModal = false;
    },
    control: function control() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      console.log(param + "-" + command + " => " + inverterId);
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      switch (this.identifier) {
        case "LUX":
          var LuxHTTP = this.$httpUtils.LUXHTTP;
          var url_turn_off = "/inverters/turn_off/" + this.inverterNum;
          var url_turn_on = "/inverters/turn_on/" + this.inverterNum;

          if (this.powerState == "ON") {
            LuxHTTP.post(url_turn_off, this.inverterNum).then(function (res) {
              _this2.showSuccessMsg({ message: "System turned off" });
              _this2.hideControl();
            }).catch(function (error) {
              _this2.showErrorMsg({ message: "Failed to turn system Off" });
            });
          } else if (this.powerState == "OFF") {
            LuxHTTP.post(url_turn_on, this.inverterNum).then(function (res) {
              _this2.showSuccessMsg({ message: "System turned On" });
              _this2.hideControl();
            }).catch(function (error) {
              _this2.showErrorMsg({ message: "Failed to turn system On" });
            });
          } else {
            console.log("Error with LUX endpoint");
          }
          break;
        case "EMS":
          HTTP.post(requestLink, requestParam).then(function (response) {
            alert("Sent!!!");
            _this2.hideControl();
            _this2.getDeviceState();
          }).catch(function (e) {
            console.log(e);
          });
          break;
        default:
          this.showErrorMsg({ message: "System cannot be identified" });
      }
    }
  },
  mounted: function mounted() {
    this.getDeviceState();
  }
});

/***/ }),
/* 953 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from "vue";
// import {
//   Carousel,
//   CarouselItem,
//   Breadcrumb,
//   Loading,
//   DatePicker,
//   BreadcrumbItem,
//   Notification
// } from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
// import moment from "moment";
// import GreyChart from "@/components/pages/kitchen/grey-chart";
// import payloadDictionary from "../payload_dictionary.json";
// import { Offcanvas, OffcanvasClose } from "vuikit/lib/offcanvas";
// import { Datetime } from "vue-datetime";
// import dummyData from "../dummy.json";
// import Battery from "@/components/pages/kitchen/grey-battery";
// import { HTTP as IOTHTTP } from "@/store/actions";
// import helpers from "@/components/utils/helpers.js";

// // utils/http-common.js
// var flatten = require("flat");
// // var converter = require("json-2-csv");
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
// Vue.use(DatePicker);
// Vue.use(Loading);
// export default {
//   name: "device-chart",
//   mixins: [helpers],
//   components: {
//     GreyChart,
//     datetime: Datetime,
//     "vk-offcanvas": Offcanvas,
//     "vk-offcanvas-close": OffcanvasClose
//     // Battery
//   },
//   compute: {
//     canSeeHistory: {
//       get() {
//         return true;
//         // if (this.$can("am", "manager") || this.$can("am", "sm")) {
//         //   return true;
//         // } else return false;
//       }
//     }
//   },
//   data: function() {
//     return {
//       labelMap: {
//         3: ["ddd D - h:m:s A", "LT"],
//         4: ["ddd D - h:m:s A", "LT"]
//       },
//       LastEvaluatedKey: null,
//       fullData: [],
//       datasetInterval: "hours",
//       charttype: "line",
//       loading: true,
//       filterDate: [moment().startOf("day"), moment()],
//       warningDataLoading: false,
//       viewDataLoading: false,
//       LoadMoreLoading: false,
//       exportDataLoading: false,
//       exportDataToTableLoading: false,
//       showTableOffCanvas: false,
//       warningsOffCanvas: false,
//       warningsData: [],
//       perPage: 10,
//       warningRows: 0,
//       currentPage: 1,
//       warningCurrentPage: 1,
//       exportDataToTableValues: [],
//       exportDataToTableValuesFields: [
//         "payload.InverterDetected",
//         "payload.Version",
//         "payload.DeviceID",
//         "payload.BatteryData.SOC",
//         "payload.Timestamp"
//       ],
//       warningsDataTableoptions: [],
//       warningsDataValuesFields: [
//         { key: "Fault", sortable: true },
//         { key: "StartTime", sortable: true },
//         { key: "EndTime", sortable: true },
//         { key: "Severity", sortable: true },
//         { key: "Status", sortable: true }
//       ],
//       exportDataTableoptions: [
//         {
//           value: "Option1",
//           label: "Option1"
//         },
//         {
//           value: "Option2",
//           label: "Option2"
//         },
//         {
//           value: "Option3",
//           label: "Option3"
//         },
//         {
//           value: "Option4",
//           label: "Option4"
//         },
//         {
//           value: "Option5",
//           label: "Option5"
//         }
//       ],
//       value1: [],
//       pickerOptions: {
//         shortcuts: [
//           {
//             text: "Today",
//             onClick(picker) {
//               const start = moment().startOf("day");
//               const end = moment();
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "This week",
//             onClick(picker) {
//               const start = moment().startOf("week");
//               const end = moment();
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "This month",
//             onClick(picker) {
//               const start = moment().startOf("month");
//               const end = moment();
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "This year",
//             onClick(picker) {
//               const start = moment().startOf("year");
//               const end = moment();
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "Last 7 days",
//             onClick(picker) {
//               const end = new Date();
//               const start = new Date();
//               start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "Last 30 days",
//             onClick(picker) {
//               const end = new Date();
//               const start = new Date();
//               start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
//               picker.$emit("pick", [start, end]);
//             }
//           },
//           {
//             text: "Last 3 months",
//             onClick(picker) {
//               const end = new Date();
//               const start = new Date();
//               start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
//               picker.$emit("pick", [start, end]);
//             }
//           }
//         ]
//       },
//       chartdata: {
//         labels: ["Please", "wait", ".", ".", ".", "."],
//         datasets: [
//           {
//             label: "Loading",
//             data: [],
//             backgroundColor: "rgba(255, 99, 132, 0.3)",
//             borderWidth: 1
//           }
//         ]
//       },
//       solarchartdata: {
//         labels: ["Please", "wait", ".", ".", "."],
//         datasets: [
//           {
//             label: "Loading",
//             data: [],
//             backgroundColor: "rgba(255, 99, 132, 0.3)",
//             borderWidth: 1
//           }
//         ]
//       }
//     };
//   },
//   props: {
//     inverterId: {
//       default: null
//     }
//   },
//   methods: {
//     filterChanged() {
//       this.viewDataLoading = true;
//       this.filterChart();
//     },
//     exportData() {
//       this.viewDataLoading = true;
//       this.exportDataLoading = true;
//       this.filterDate
//         ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000)
//         : this.DataToExport();
//     },
//     exportDataToTable() {
//       this.viewDataLoading = true;
//       this.exportDataToTableLoading = true;
//       this.filterDate
//         ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000)
//         : this.DataToExportToTable();
//     },
//     getDevice() {
//       var inverterId = this.inverterId;
//       const context = this;
//       const HTTP = this.$httpUtils.instance;
//       //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
//       const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=${inverterId}`;
//       HTTP.get(url)
//         .then(response => {
//           if (response.data.length > 0)
//             context.installationData = response.data[0];
//           //console.log(response.data);
//         })
//         .catch(error => {
//           return "not assign";
//           //console.log("error", error);
//         });
//     },
//     async DataToExportToTable(
//       upperLimit = null,
//       lowerLimit = null,
//       limit = 100
//     ) {
//       this.timeRightNow = await this.currentTime();
//       let container = this;
//       var inverterId = this.inverterId;
//       var headers = {
//         "Content-Type": "application/plain"
//       };
//       let data = {
//         TableName: "Parameters",
//         KeyConditionExpression:
//           "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
//         ExpressionAttributeValues: {
//           ":key": `${inverterId}`,
//           ":up":
//             upperLimit ||
//             moment("2019/6/20")
//               .startOf("day")
//               .toDate(),
//           ":down": lowerLimit || new Date().toISOString()
//         },
//         Limit: limit,
//         ScanIndexForward: false
//       };
//       // console.log(data);
//       IOTHTTP.post(`/devicedata`, data, {
//         headers
//       }).then(resp => {
//         this.exportDataToTableLoading = false;
//         this.viewDataLoading = false;
//         this.showTableOffCanvas = true;
//         var exportedData = resp.data.Items.map(data => {
//           return flatten(data);
//         });
//         console.log(exportedData);
//         if (exportedData.length > 0) {
//           let temp = Object.keys(exportedData[0]);
//           console.log(temp);

//           this.exportDataTableoptions = Object.keys(exportedData[0]);
//         }
//         this.exportDataToTableValues = exportedData;
//         let json2csvCallback = function(err, csv) {
//           if (err) throw err;
//           //return csv;
//           var hiddenElement = document.createElement("a");
//           hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
//           hiddenElement.target = "_blank";
//           hiddenElement.download = this.installationData.name + "_reports.csv";
//           hiddenElement.click();
//         };
//         // converter.json2csv(exportedData, json2csvCallback);
//       });
//     },
//     async currentTime() {
//       const me = this;
//       const HTTP = this.$httpUtils.instance;
//       let response = await HTTP.get(
//         "https://arnergy.com/weather-api/time/?" + Date.now()
//       );
//       let tmpDate = response.data.datetime.split(".")[0];
//       return tmpDate;
//     },
//     async DataToExport(upperLimit = null, lowerLimit = null, limit = 100) {
//       this.timeRightNow = await this.currentTime();
//       let container = this;
//       var inverterId = this.inverterId;
//       var headers = {
//         "Content-Type": "application/plain"
//       };
//       let data = {
//         TableName: "Parameters",
//         KeyConditionExpression:
//           "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
//         ExpressionAttributeValues: {
//           ":key": `${inverterId}`,
//           ":up":
//             upperLimit ||
//             moment("2019/6/20")
//               .startOf("day")
//               .toDate(),
//           ":down": lowerLimit || new Date().toISOString()
//         },
//         Limit: limit,
//         ScanIndexForward: false
//       };

//       IOTHTTP.post(`/devicedata`, data, {
//         headers
//       }).then(resp => {
//         this.viewDataLoading = false;
//         this.exportDataLoading = false;
//         var exportedData = resp.data.Items.map(data => {
//           return flatten(data);
//         });
//         this.exportDataToTableValues = exportedData;
//         this._convertJsonToCsvAndDownload(exportedData);
//       });
//     },
//     _convertJsonToCsvAndDownload(arrJson) {
//       let labels = Object.getOwnPropertyNames({ ...arrJson[0] });
//       let labelsConf = labels || this.$_createCsvLabelsConf(labels);

//       // @note: this.$_xxx is obtained from helpers mixin
//       const csvLabels = this.$_createCsvLabels(labelsConf, ",");
//       const csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
//       const content = csvLabels + csvData;

//       if (csvLabels == "error" || csvData === "error") {
//         console.error(`Error: An error occured while parsing the data.`);
//         return;
//       }

//       let f = this.$_downloadCsv(`csv-export`, content, "CSV Export Data");
//       if (!f) console.error(`An error has occured`, hasErrorEvent);
//     },
//     filterChart() {
//       console.log(this.filterDate);
//       this.loading = true;
//       this.filterDate
//         ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000)
//         : this.getDeviceData();
//     },
//     transformData(data, keys) {
//       return data.reduce(
//         (aggr, c_item) => {
//           keys.map(key => {
//             aggr[key] = [
//               ...aggr[key],
//               c_item["payload"] ? c_item["payload"][key] * 1 : c_item[key] * 1
//             ];
//           });
//           return aggr;
//         },
//         keys.reduce((ret, crr) => {
//           ret[crr] = [];
//           return ret;
//         }, {})
//       );
//     },
//     getTimeLabel(data) {
//       // console.log({ "data times": data[0] });
//       // console.log(data[0]);
//       data.reverse();
//       // console.log();

//       // console.log({ "data times reversed ": data[0] });
//       let formatLabel = moment(this.filterDate[1]).diff(
//         this.filterDate[0],
//         "days"
//       );
//       let labelConfig = this.labelMap[formatLabel <= 3 ? 3 : 4];
//       // console.log({ formatLabel, labelConfig });
//       let lastSOD = moment(data[0]).startOf("day");

//       return data.reduce((aggr, c_item, index) => {
//         // console.log({ index,c_item });
//         let currentTStamp = moment(c_item);
//         let currentSOD = currentTStamp.startOf("day");

//         let formatStr = labelConfig[0];
//         if (
//           lastSOD.valueOf() != currentSOD.valueOf() ||
//           index == 0 ||
//           index == data.length - 1
//         ) {
//           // console.log("Changes");
//           lastSOD = currentSOD;
//           //   lastSOD = moment(c_item["payload"]["TimeStamp"]).startOf("day");
//           formatStr = labelConfig[0];
//         }

//         aggr = [...aggr, moment(c_item).format(formatStr)];
//         return aggr;
//       }, []);
//     },
//     solarDataChart(displayData, labels) {
//       try {
//         // console.log({ displayData });
//         let Chartdata = this.transformData(displayData, [
//           "ACOutputActivePower",
//           "PVChargingPower",
//           "DCOutputPower"
//         ]);

//         // console.log({ Chartdata });
//         this.solarchartdata = {
//           labels: labels,
//           datasets: [
//             {
//               pointRadius: 0,
//               label: "Output Active Power",
//               borderColor: "#109cf1",
//               backgroundColor: "rgba(16, 156, 241,0.4)",
//               data:
//                 Chartdata["ACOutputActivePower"] &&
//                 Chartdata["ACOutputActivePower"][0]
//                   ? Chartdata["ACOutputActivePower"].reverse()
//                   : Chartdata["DCOutputPower"].reverse()
//             },
//             {
//               pointRadius: 0,
//               label: "PV Charging Power",
//               borderColor: "#ffb946",
//               // backgroundColor: "rgba(0,0,0,0.3)",
//               backgroundColor: "rgba(255, 185, 70,0.8)",
//               data: Chartdata["PVChargingPower"].reverse()
//             }
//           ]
//         };
//         this.charttype = "line";
//         this.loading = false;
//         // this.renderChart();
//         this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
//       } catch (error) {
//         console.log("solarDataChart => ", error);
//       }
//     },
//     batteryChart(displayData, labels) {
//       // console.log({ displayData, labels });
//       let Chartdata = this.transformData(displayData, [
//         "SOC",
//         "BatteryCapacity",
//         "OutputLoadPercent"
//       ]);
//       // console.log(labels);
//       this.chartdata = {
//         labels: labels,
//         datasets: [
//           {
//             pointRadius: 1,
//             label: "Battery Percent",
//             borderColor: "#109cf1",
//             backgroundColor: "rgba(16, 156, 241,0.4)",
//             data: Chartdata["SOC"].reverse()
//           },
//           {
//             pointRadius: 0,
//             label: "Load Percent",
//             borderColor: "#ffb946",
//             backgroundColor: "rgba(255, 185, 70,0.8)",
//             data: Chartdata["OutputLoadPercent"].reverse()
//           }
//         ]
//       };
//       this.charttype = "line";
//       this.$refs.healthchart.reload(this.chartdata, this.charttype);
//     },
//     exportWarnings() {
//       console.log(
//         JSON.stringify(this.filterDate[0]),
//         JSON.stringify(this.filterDate[1])
//       );

//       let upperLimit = JSON.stringify(this.filterDate[0]);
//       let lowerLimit = JSON.stringify(this.filterDate[1]);
//       JSON.stringify(this.filterDate[1]);
//       let filter = JSON.stringify({
//         where: {
//           and: [
//             { DeviceID: this.inverterId },
//             { StartTime: { lte: lowerLimit || new Date().toISOString() } },
//             { StartTime: { gte: upperLimit || moment("2019/6/20") } }
//           ]
//         },
//         order: "StartTime DESC"
//       });
//       let _exportedData = this.warningsData.map(data => {
//         return flatten(data);
//       });

//       let json2csvCallback = function(err, csv) {
//         if (err) throw err;
//         //return csv;
//         var hiddenElement = document.createElement("a");
//         hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
//         hiddenElement.target = "_blank";
//         hiddenElement.download = "_warning_reports.csv";
//         hiddenElement.click();
//       };
//       converter.json2csv(_exportedData, json2csvCallback);
//     },
//     getDeviceWarningsMapper() {
//       this.warningDataLoading = true;
//       this.viewDataLoading = true;
//       this.filterDate
//         ? this.getDeviceWarningsObject(
//             this.filterDate[0],
//             this.filterDate[1],
//             1000
//           )
//         : this.getDeviceWarningsObject();
//     },
//     async getDeviceWarningsObject(
//       upperLimit = null,
//       lowerLimit = null,
//       limit = 100
//     ) {
//       const HTTP = this.$httpUtils.instance;
//       let app = this;
//       var inverterId = this.inverterId;
//       var headers = {
//         "Content-Type": "application/plain"
//       };
//       let data = {
//         TableName: "Warnings",
//         KeyConditionExpression:
//           "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
//         ExpressionAttributeValues: {
//           ":key": inverterId * 1,
//           ":up":
//             upperLimit ||
//             moment("2019/6/20")
//               .startOf("day")
//               .toDate(),
//           ":down": lowerLimit || new Date().toISOString()
//         },
//         Limit: limit,
//         ScanIndexForward: false
//       };
//       let filter = JSON.stringify({
//         where: {
//           and: [
//             { DeviceID: this.inverterId },
//             { StartTime: { lte: lowerLimit || new Date().toISOString() } },
//             { StartTime: { gte: upperLimit || moment("2019/6/20") } }
//           ]
//         },
//         include: ["installation"],
//         order: "StartTime DESC"
//       });
//       HTTP.get(`warning_reports?filter=${filter}`)
//         .then(resp => {
//           this.warningDataLoading = false;
//           this.viewDataLoading = false;
//           this.warningsOffCanvas = true;
//           console.log({ resp });
//           this.warningsData = resp.data.map(d => ({
//             ...d
//           }));
//           this.warningRows = this.warningsData.length;
//           console.log(this.warningsData);
//         })
//         .catch(err => {
//           console.log(JSON.stringify(err));
//           this.warningDataLoading = false;
//           this.viewDataLoading = false;
//           this.warningsOffCanvas = true;
//           alert("An error occured, please try again");
//         });
//     },
//     LoadMore() {
//       this.LoadMoreLoading = true;
//       this.viewDataLoading = true;
//       if (this.filterDate) {
//         this.getDeviceData(
//           this.filterDate[0],
//           this.filterDate[1],
//           1000,
//           this.LastEvaluatedKey
//         );
//       }
//     },
//     getDeviceData(
//       upperLimit = null,
//       lowerLimit = null,
//       limit = 500,
//       LastEvaluatedKey = null
//     ) {
//       let container = this;
//       var inverterId = this.inverterId;
//       var headers = {
//         "Content-Type": "application/plain"
//       };
//       let data = {
//         TableName: "Parameters",
//         KeyConditionExpression:
//           "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
//         ExpressionAttributeValues: {
//           ":key": `${inverterId}`,
//           ":up":
//             upperLimit ||
//             moment("2019/6/20")
//               .startOf("day")
//               .toDate(),
//           ":down": lowerLimit || new Date().toISOString()
//         },
//         Limit: limit,
//         ScanIndexForward: false
//       };
//       if (LastEvaluatedKey) {
//         data["ExclusiveStartKey"] = LastEvaluatedKey;
//         // let tempQuery = ;
//         data["FilterExpression"] = data["KeyConditionExpression"];
//       }
//       // console.log(data);
//       IOTHTTP.post(`/devicedata/${LastEvaluatedKey ? "scan" : ""}`, data, {
//         headers
//       })
//         .then(resp => {
//           this.LoadMoreLoading = false;
//           this.viewDataLoading = false;
//           let { LastEvaluatedKey, Items } = resp.data;
//           let parsed = [];
//           this.fullData = [...this.fullData, ...Items];
//           this.LastEvaluatedKey = LastEvaluatedKey;

//           // console.log(this.fullData);
//           // console.log({
//           //   fullCount: this.fullData.length,
//           //   LastEvaluatedKey
//           // });
//           let {
//             Version,
//             EnergyData,
//             ModeData,
//             MiscData
//           } = this.fullData[0].payload;
//           console.log({
//             Version,
//             ModeData,
//             EnergyData,
//             MiscData,
//             lengh: this.fullData
//           });
//           // console.log({ fullData: this.fullData });
//           // console.log({ LastEvaluatedKey, Items, fullData: this.fullData });

//           switch (Version) {
//             case "v3":
//               // console.log("->", this.fullData);
//               parsed = this.fullData.map(x => {
//                 // console.log({ x });
//                 // console.log({ EnergyData: x.payload["EnergyData"] });
//                 // console.log({ InverterData: x.payload["InverterData"] });
//                 // console.log({ BatteryData: x.payload["BatteryData"] });
//                 return {
//                   TimeStamp: x.payload["Timestamp"],
//                   EnergyData: this.transformChartData(
//                     (MiscData && MiscData.FV >= 1.76) || MiscData.FV == 1.11
//                       ? x.payload["EnergyData"]["Data"]
//                       : x.payload["EnergyData"]
//                   ),
//                   ...this.transformChartData(x.payload["InverterData"]),
//                   ...this.transformMapData(x.payload["BatteryData"])
//                 };
//               });

//               // console.log({ parsed });
//               break;
//             case "v4":
//               parsed = this.fullData.map(x => {
//                 // console.log(x.payload["InverterData"]);
//                 return {
//                   TimeStamp: x.payload["Timestamp"],
//                   EnergyData: this.transformChartData(
//                     x.payload["EnergyData"] ? x.payload["EnergyData"] : []
//                   ),
//                   ...this.transformChartData(
//                     x.payload["InverterData"] ? x.payload["InverterData"] : []
//                   ),
//                   ...this.transformChartData(
//                     x.payload["InverterData"] ? x.payload["InverterData"] : []
//                   ),
//                   ...this.transformMapData(x.payload["BatteryData"])
//                 };
//               });
//               break;
//             case "v5":
//               const payload = this.fullData;
//               parsed = payload.map(x => {
//                 const toa = obj => {
//                   if (obj.length) return obj;
//                   if (obj.Data && obj.Data.length) return obj.Data;
//                   return [];
//                 };
//                 return {
//                   TimeStamp: x.payload["Timestamp"],
//                   EnergyData: this.transformChartData(
//                     x.payload["EnergyData"] ? toa(x.payload["EnergyData"]) : []
//                   ),
//                   ...this.transformChartData(
//                     x.payload["InverterData"]
//                       ? toa(x.payload["InverterData"])
//                       : []
//                   ),
//                   ...this.transformChartData(
//                     x.payload["InverterData"]
//                       ? toa(x.payload["InverterData"])
//                       : []
//                   ),
//                   ...this.transformMapData(x.payload["BatteryData"])
//                 };
//               });
//               // console.log({ parsed: this.fullData });

//               break;
//             case undefined:
//               parsed = this.fullData;
//               break;
//             default:
//               parsed = this.fullData;
//               break;
//           }

//           let timeArr = parsed.reduce(
//             (acc, { TimeStamp }) => [...acc, TimeStamp],
//             []
//           );
//           let chartLabels = this.getTimeLabel(timeArr);
//           this.batteryChart(parsed, chartLabels);
//           this.solarDataChart(parsed, chartLabels);
//         })
//         .catch(err => {
//           console.log(err);
//         });
//     },
//     getDevice() {
//       var inverterId = this.inverterId;
//       const context = this;
//       const HTTP = this.$httpUtils.instance;
//       //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
//       const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=${inverterId}`;
//       HTTP.get(url)
//         .then(response => {
//           if (response.data.length > 0)
//             context.installationData = response.data[0];
//           //console.log(response.data);
//         })
//         .catch(error => {
//           return "not assign";
//           //console.log("error", error);
//         });
//     },
//     transformDashData(_tmpDevice) {
//       let { EnergyData } = _tmpDevice.payload;
//       EnergyData = undefined === EnergyData ? [] : EnergyData;
//       this.EnergyData = this.transformMapData(
//         EnergyData[0] ? EnergyData[0] : EnergyData
//       );

//       Object.keys(this.EnergyData).map(x => {
//         this.EnergyData[x] = this.EnergyData[x] / 1000;
//         return this.EnergyData[x];
//       });
//       console.log(_tmpDevice.payload, "PAYLOAD");

//       let tmp_data = {
//         InstallType: _tmpDevice.payload.InstallType,
//         Timestamp: _tmpDevice.payload.Timestamp,
//         // Mode: _tmpDevice.payload.ModeData[0]["Mode"],
//         InverterData: this.transformListData(_tmpDevice.payload.InverterData),
//         // ModeData: this.transformListData(_tmpDevice.payload.ModeData || []),
//         Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
//         WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
//         BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
//         MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
//         EnergyData: this.EnergyData
//       };
//       // console.log("+++++DEBUG 02 +++>=", tmp_data);
//       //this.inverter=_tmpDevice.payload.InverterData;
//       this.Device = {
//         ...tmp_data
//         // EnergyData,
//         // Timestamp: _tmpDevice.payload.Timestamp,
//         // Mode: _tmpDevice.payload.ModeData[0]["Mode"],
//         // InverterData: this.transformListData(_tmpDevice.payload.InverterData),
//         // ModeData: this.transformListData(_tmpDevice.payload.ModeData),
//         // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
//         // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
//         // BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
//         // MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
//       };
//       this.errorCalc(this.Device.Warnings);
//       // console.log("+++++DEBUG +++>=", tmp_data);
//       return tmp_data;
//     },
//     transformChartData(InverterDataList) {
//       // console.log({ InverterDataList });

//       // if (InverterDataList) {
//       return InverterDataList.reduce((aggr, c_item) => {
//         let tmpCurr = this.transformMapData(c_item);
//         Object.keys(tmpCurr).map(singleKey => {
//           aggr[singleKey] = aggr[singleKey]
//             ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey])
//             : Number(tmpCurr[singleKey]);
//           // aggr[singleKey] =
//           //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
//         });
//         return aggr;
//         // console.log(aggr);
//       }, {});
//       // }
//     },
//     transformListData(ListData) {
//       // console.log({ ListData });
//       return ListData.map(x => {
//         // Object.keys(x).map(key => {
//         //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
//         //   delete x[key];
//         // });
//         return x.length ? this.transformListData(x) : this.transformMapData(x);
//       });
//     },

//     transformMapData(MapData) {
//       return Object.keys(MapData).reduce((cummData, key) => {
//         let oldKey = payloadDictionary.find(x => x.new_key == key);
//         // console.log(oldKey);
//         if (oldKey && oldKey !== "") {
//           cummData[oldKey["old_key"]] = MapData[key];
//           //   delete cummData[key];
//         } else {
//           cummData[key] = MapData[key];
//         }
//         return cummData;
//       }, {});
//     }
//   },

//   mounted() {
//     console.log("Loaded!");
//     this.getDevice();
//     this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000);
//     // this.getDevice();
//   }
// };
//

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__ = __webpack_require__(2248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_customAnimatedIcon__ = __webpack_require__(2251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_customPieChart__ = __webpack_require__(224);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







// import { HTTP as IOTHTTP } from "../../../store/actions";
// import moment from "moment";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loadingChartData: false,
      chargeState: "Charging",
      acoap: 0,
      gdv: 0,
      pvp: 0,
      pieChart: {}
    };
  },

  props: {
    device: {
      type: Object,
      default: null
    }
  },
  computed: {
    isSmartController: {
      get: function get() {
        try {
          var InverterData = this.device.InverterData;

          var dcop = InverterData && InverterData.length > 0 && InverterData[0]["DCOutputPower"];
          if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_nan___default()(dcop) || dcop == undefined) {
            return false;
          } else return true;
        } catch (error) {
          console.log("error => ", error);
          // return false
        }
      }
    },
    getGridStatus: {
      get: function get() {
        var modeData = this.device["ModeData"];
        modeData = modeData && modeData[0]["Mode"] ? modeData[0]["Mode"] : "";

        return this.gridCalc(modeData);
      }
    },
    loadEnergySource: {
      get: function get() {
        var chartDataNode = {
          InverterData: this.mergeInverterPower(this.device)
        };

        return this.processLoadEnergySourceVisualization(chartDataNode["InverterData"], this.device["ModeData"], this.device["MiscData"]);
      }
    }
  },
  components: {
    "custom-animated-icon": __WEBPACK_IMPORTED_MODULE_4__components_customAnimatedIcon__["a" /* default */],
    "custom-pie-chart": __WEBPACK_IMPORTED_MODULE_6__components_customPieChart__["a" /* default */]
  },
  methods: {
    getBatteryWattage: function getBatteryWattage() {
      var wattage = (this.device.BatteryData && this.device.BatteryData.TotalBatVolt || 0) * (this.device.BatteryData && this.device.BatteryData.TotalBatCur || 0) / 1000;
      // alert(wattage);
      wattage = wattage < 0 ? wattage * -1 : wattage;
      return Math.abs(wattage).toFixed(3);
    },
    handleOnChartReady: function handleOnChartReady() {
      this.pieChart = {
        title: "Energy Source(kW)",
        data: this.pieChartData(this.loadEnergySource)
      };
    },
    pieChartData: function pieChartData(displayData) {
      var result = [{
        value: this.computePieChartData(displayData || 9, "pvSource"),
        name: "PV",
        itemStyle: {
          color: "rgba(16, 156, 241,0.4)" // blue
        }
      }, {
        value: this.computePieChartData(displayData, "gridSource"),
        name: "Grid",
        itemStyle: {
          color: "rgba(255, 185, 70,0.47)" // yellow
        }
      }, {
        value: this.computePieChartData(displayData, "batterySource"),
        name: "Battery",
        itemStyle: {
          color: "rgba(250, 113, 111, 0.46)" // red
        }
      }];
      return result;
    },
    computePieChartData: function computePieChartData(loadEnergySource, key) {
      if (loadEnergySource == null || loadEnergySource[key] == null) return;
      return loadEnergySource[key] / 1000;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return 1;
      } else {
        return 0;
      }
    },
    getValue: function getValue(wattValue) {
      return "" + wattValue / 1000;
    },
    transformChartData: function transformChartData(InverterDataList) {
      return InverterDataList.reduce(function (aggr, tmpCurr) {
        // let tmpCurr = transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
      }, {});
    },
    mergeInverterPower: function mergeInverterPower(eventPayload) {
      var inverterTrans = this.transformChartData(eventPayload["InverterData"] ? eventPayload["InverterData"] : []);
      var powerTrans = this.transformChartData(eventPayload["PowerData"] ? eventPayload["PowerData"] : []);
      console.log({ inverterTrans: inverterTrans, powerTrans: powerTrans });

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, powerTrans, inverterTrans);
    },
    processLoadEnergySourceVisualization: function processLoadEnergySourceVisualization(data, modeData, miscData) {
      var loadEnergySource = {
        pvSource: 0,
        gridSource: 0,
        batterySource: 0
      };

      var pvp = this.pvp = data && data["PVChargingPower"] ? parseInt(data["PVChargingPower"]) : data && data["PVCgP1"] ? parseInt(data["PVCgP1"]) : parseInt(data["PVCgP "]) || 0;
      console.log({
        data: data,
        modeData: modeData,
        pvp1: data.PVCgP,
        pvp: pvp
      });

      var gdv = this.gdv = miscData && miscData["GridPower"] ? parseInt(miscData["GridPower"]) : 0;

      var acoap = this.acoap = data && data["ACOutputApparentPower"] ? parseInt(data["ACOutputApparentPower"]) : data && data["ACOutputTotalApparentPower"] ? parseInt(data["ACOutputTotalApparentPower"]) : data && data["DCOutputPower"] ? parseInt(data["DCOutputPower"]) : 0;
      var mode = modeData && modeData[0]["Mode"] ? modeData[0]["Mode"] : "";
      if (pvp >= acoap) {
        return loadEnergySource = {
          pvSource: acoap,
          gridSource: 0,
          batterySource: 0
        };
      }

      if (pvp < acoap) {
        if (pvp > 0 && (mode === "L" || mode === "E" || mode === "Y")) {
          return loadEnergySource = {
            pvSource: pvp,
            gridSource: gdv,
            batterySource: 0
          };
        }

        if (pvp > 0 && (mode !== "L" || mode !== "E" || mode !== "Y")) {
          return loadEnergySource = {
            pvSource: pvp,
            gridSource: 0,
            batterySource: acoap - pvp
          };
        }

        if (pvp === 0 && (mode === "L" || mode === "E" || mode === "Y")) {
          return loadEnergySource = {
            pvSource: 0,
            gridSource: gdv,
            batterySource: 0
          };
        }

        if (pvp === 0 && (mode !== "L" || mode !== "E" || mode !== "Y")) {
          loadEnergySource = {
            pvSource: 0,
            gridSource: 0,
            batterySource: acoap
          };

          return loadEnergySource;
        }
      }

      return loadEnergySource;
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-animated-icon",
  props: ["title", "value", "unit", "color", "image", "isCenterItem", "line", "lines", "dataValue"],
  components: {}
});

/***/ }),
/* 956 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-chart",
  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full_js__["a" /* default */]
  },
  props: ["data", "loading", "orient"],
  watch: {
    // watch it
    data: function data(newVal, oldVal) {
      this.chartOptions.series[0].data = newVal.data;
      this.chartOptions.series[0].name = "";
      this.chartOptions.title.text = newVal.title ? newVal.title : "no title";
      this.chartOptions.legend.orient = newVal.orient ? newVal.orient : "vertical";
      this.chartOptions.legend.data = this.computeLegendValues(newVal.data);
    }
  },
  data: function data() {
    return {
      // initOpts: {
      //   renderer: 'svg'
      // },
      chartOptions: {
        title: {
          text: "",
          bottom: "center",
          left: "center",
          fontSize: 15
        },
        tooltip: {
          trigger: "item",
          axisPointer: {
            type: "shadow"
          },
          formatter: "{a} <br/>{b}: {c}kW ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: 10,
          data: []
        },
        series: [{
          name: null,
          type: "pie",
          radius: ["50%", "70%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: "center"
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "20",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: []
        }]
      }
    };
  },
  methods: {
    onClick: function onClick(event, instance, ECharts) {
      console.log(arguments);
    },
    onReady: function onReady(instance, ECharts) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit("onReady");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    computeLegendValues: function computeLegendValues(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map(function (item) {
        return item.name;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__ = __webpack_require__(97);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    identifier: {
      type: String,
      default: null
    },
    inverterNum: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_25__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData.SOC);
          var dcop = parseInt(InverterData[0]["DCOutputPower"]);
          console.log({ dcop: dcop });
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        // console.log({ powerKey }, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }

      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataLoading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      device.payload.InverterData.reduce(function (acc, obj) {
        return acc += Number(obj["OL%"]);
      }, 0);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }

      var outputLoad = this.Device.InverterData.reduce(function (acc, obj) {
        // console.log({ obj });

        return acc += Number(obj["ACOutputApparentPower"]);
      }, 0);
      outputLoad = this.roundUpHandler(outputLoad);
      var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
      resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

      // console.log({ resp, outputLoad, solarPower, mode });

      return resp || "Battery Mode";
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      // console.log({ InverterData });
      var InvAggrData = this.Device.InvAggrData;

      try {
        if (InvAggrData) {
          return InvAggrData.AACOAP * 1 / 1000;
        }

        var power = InverterData.reduce(function (acc, parameter) {
          var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
          return acc + lw * 1;
        }, 0);
        var ac = power / 1000;

        return ac || 0;
      } catch (error) {
        return 0;
      }
    },
    activePercent: function activePercent(InverterData) {
      try {
        var InvAggrData = this.Device.InvAggrData;

        if (InvAggrData) {
          return InvAggrData["AOL%"];
        }

        var power = InverterData.reduce(function (acc, parameter) {
          return acc + parameter["OutputLoadPercent"] * 1;
        }, 0);
        console.log({ power: power });
        var ap = power / InverterData.length;
        return this.roundUp(ap || 0);
      } catch (error) {
        console.log();
      }
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                GraphHTTP = _this6.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context2.next = 6;
                return GraphHTTP.post("/graphql", data).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;
        // console.log({ energyData });

        var edResp = energyData ? energyData.map(function (e) {
          // console.log({ e });
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = ["1.12", "1.11"].includes("" + parseFloat(MiscData.FV)) || parseFloat(MiscData.FV) >= 1.76 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData ? true : false,EnergyData,test:  ['1.12','1.11'].includes(`${parseFloat(MiscData.FV)}`)|| parseFloat(MiscData.FV) >= 1.76
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this13.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this13.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = container.installationData.name + "_reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;
                container = _this14;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this15 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this15.currentTime();

              case 2:
                _this15.timeRightNow = _context6.sent;
                container = _this15;
                inverterId = _this15.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log("+++++=",resp.data.Items[0]);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  _this15.inverter = DevData[0].InverterData;
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  // console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this15);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this16 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this16.transformListData(resp.data.Items);
        console.log({ DevData: DevData });
        // if (DevData[0]) {
        //   app.deviceWarning = DevData[0]["payload"];
        // }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1048);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f837318_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2589);
function injectStyle (ssrContext) {
  __webpack_require__(2575)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f837318"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f837318_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__element_control_new__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__element_control_radio__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__element_pending_info__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__current_settings__ = __webpack_require__(2582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__element_control_input_vue__ = __webpack_require__(2585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_performance_payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_performance_payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_performance_payload_dictionary_json__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


// import { HTTP as IOTHTTP } from "@/store/actions";










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "controlSettings",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "element-control-new": __WEBPACK_IMPORTED_MODULE_8__element_control_new__["a" /* default */],
    "element-control-radio": __WEBPACK_IMPORTED_MODULE_9__element_control_radio__["a" /* default */],
    "element-pending-info": __WEBPACK_IMPORTED_MODULE_10__element_pending_info__["a" /* default */],
    "element-current-settings": __WEBPACK_IMPORTED_MODULE_11__current_settings__["a" /* default */],
    "element-current-input": __WEBPACK_IMPORTED_MODULE_12__element_control_input_vue__["a" /* default */]
  },
  computed: {
    // ...mapGetters(["DeviceList", "graphDeviceDetails"])
  },
  data: function data() {
    return {
      showCanvas: false,
      pendingChanges: null,
      currentSettings: {}
    };
  },
  methods: {
    getPendingChanges: function getPendingChanges() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var deviceId, HTTP, endpoint, res;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deviceId = _this.$route.params.deviceId;
                HTTP = _this.$httpUtils.instance;
                endpoint = _this.$utilConstants.IOT_BASE_URL + "/devicestate/";
                _context.next = 5;
                return HTTP.get("" + endpoint + deviceId);

              case 5:
                res = _context.sent;

                if (!(res && res.data && res.data.state && res.data.state.delta && res.data.state.delta)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", res.data.state.delta);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    graphDetailsCall: function graphDetailsCall() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var cid, GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                cid = _this2.$route.params.deviceId;

                _this2.deviceId = cid;

                if (cid) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt("return", true);

              case 4:
                GraphHTTP = _this2.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context3.next = 8;
                return GraphHTTP.post("/graphql", data).then(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(res) {
                    var _tmpDevice, parsed, tParsed;

                    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            console.log("---> response V3 <----");
                            _tmpDevice = res.data.data.device["Items"][0];
                            _context2.next = 4;
                            return _this2.transformDashData(_tmpDevice, res.data.data.device);

                          case 4:
                            parsed = _context2.sent;
                            _context2.next = 7;
                            return _this2.transformListData(parsed);

                          case 7:
                            tParsed = _context2.sent;
                            return _context2.abrupt("return", tParsed);

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this2);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()).catch(function (err) {
                  console.log(err);
                  return [{ DeviceID: _this2.deviceId }];
                });

              case 8:
                return _context3.abrupt("return", _context3.sent);

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }))();
    },
    transformMapData: function transformMapData(MapData) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_13__pages_performance_payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
        } else {
          cummData[key] = MapData[key];
        }
        return cummData;
      }, {});
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this3 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var currentSettings = _completePayload.currentSettings;
      // return currentSettings;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this3.deviceId
        });
      });
      return currentSettingsAndDeviceId;
    },
    transformListData: function transformListData(ListData) {
      var _this4 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this4.transformListData(x) : _this4.transformMapData(x);
      });
    },
    refresh: function refresh() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.getPendingChanges();

              case 2:
                _this5.pendingChanges = _context4.sent;
                _context4.next = 5;
                return _this5.graphDetailsCall();

              case 5:
                response = _context4.sent;

                _this5.currentSettings = response.length > 0 ? response[0] : {};

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var response;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.getPendingChanges();

            case 2:
              _this6.pendingChanges = _context5.sent;
              _context5.next = 5;
              return _this6.graphDetailsCall();

            case 5:
              response = _context5.sent;

              _this6.currentSettings = response.length > 0 ? response[0] : {};

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_new_vue__ = __webpack_require__(1050);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e11b56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_new_vue__ = __webpack_require__(2577);
function injectStyle (ssrContext) {
  __webpack_require__(2576)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-42e11b56"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42e11b56_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ElementControlNew", //name should change to ElementControlSwitch
  props: {
    name: "",
    enableAction: null,
    disableAction: null,
    desc: ""
  },
  components: {},
  data: function data() {
    return {
      isLoading: false
    };
  },

  watch: {
    defaultValue: {}
  },
  methods: {
    enableSetting: function enableSetting() {
      if (!this.showConfirm("ON")) return;
      this.sendRequest(this.enableAction);
    },
    disableSetting: function disableSetting() {
      if (!this.showConfirm("OFF")) return;
      this.sendRequest(this.disableAction);
    },
    sendRequest: function sendRequest(action) {
      var _this = this;

      var requestParam = {
        topic: this.$route.params.deviceId,
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          invConfig: action
        })
      };

      var HTTP = this.$httpUtils.instance;

      this.showLoading(true);
      HTTP.options(this.$utilConstants.IOT_BASE_URL + "/event/publish/", requestParam).then(function (response) {
        _this.$emit("refresh");
        _this.showAlarm({ type: "success", message: "Success, sent!" });
        _this.showLoading(false);
      }).catch(function (e) {
        _this.showAlarm({
          type: "error",
          message: "Error, unable to complete action, please try again"
        });
        _this.showLoading(false);
      });

      // return HTTP.post(endpoint, requestParam)
    },
    showConfirm: function showConfirm(status) {
      return confirm("Are you sure turn setting " + status + "?");
    },
    showLoading: function showLoading(value) {
      this.isLoading = value;
    },

    // this should be a global something
    showAlarm: function showAlarm(_ref) {
      var type = _ref.type,
          message = _ref.message;

      console.log(type, message);
      switch (type) {
        case "success":
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].success({
            title: "Success",
            dangerouslyUseHTMLString: true,
            message: message ? message : "Action completed successfully"
          });

        case "warning":
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: message
          });
        default:
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].warning({
            title: "Unknown",
            dangerouslyUseHTMLString: true,
            message: message ? message : "unknown, please verify"
          });
      }
    }
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_radio_vue__ = __webpack_require__(1052);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1e3f42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_radio_vue__ = __webpack_require__(2579);
function injectStyle (ssrContext) {
  __webpack_require__(2578)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da1e3f42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da1e3f42_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ElementControlRadio",
  props: {
    name: "",
    desc: "",
    items: null
  },
  components: {
    "el-form": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Switch"],
    "el-tooltip": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Tooltip"]
  },
  data: function data() {
    return {
      isLoading: false
    };
  },

  watch: {
    defaultValue: {}
  },
  methods: {
    enableSetting: function enableSetting(action) {
      if (!this.showConfirm()) return;
      this.sendRequest(action);
    },
    sendRequest: function sendRequest(action) {
      var _this = this;

      var requestParam = {
        topic: this.$route.params.deviceId,
        payload: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          invConfig: action
        })
      };

      var HTTP = this.$httpUtils.instance;

      this.showLoading(true);
      HTTP.options(this.$utilConstants.IOT_BASE_URL + "/event/publish/", requestParam).then(function (response) {
        _this.$emit("refresh");
        _this.showAlarm({ type: "success", message: "Success, sent!" });
        _this.showLoading(false);
      }).catch(function (e) {
        _this.showAlarm({
          type: "error",
          message: "Error, unable to complete action, please try again"
        });
        _this.showLoading(false);
      });
    },
    showConfirm: function showConfirm() {
      return confirm("Are you sure you want to enable setting?");
    },
    showLoading: function showLoading(value) {
      this.isLoading = value;
    },

    // @todo: this should be a global something
    showAlarm: function showAlarm(_ref) {
      var type = _ref.type,
          message = _ref.message;

      switch (type) {
        case "success":
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].success({
            title: "Success",
            dangerouslyUseHTMLString: true,
            message: message ? message : "Action completed successfully"
          });
        case "warning":
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].error({
            title: "Error",
            dangerouslyUseHTMLString: true,
            message: message
          });
        default:
          return __WEBPACK_IMPORTED_MODULE_1_element_ui__["Notification"].warning({
            title: "Unknown",
            dangerouslyUseHTMLString: true,
            message: message ? message : "unknown, please verify"
          });
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_pending_info_vue__ = __webpack_require__(1054);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468cbe66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_pending_info_vue__ = __webpack_require__(2581);
function injectStyle (ssrContext) {
  __webpack_require__(2580)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-468cbe66"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_pending_info_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_468cbe66_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_pending_info_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { Switch } from "element-ui";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ElementPendingInfo",
  props: {
    pendingChanges: null
  },
  components: {},
  data: function data() {
    return {
      isLoading: false,
      showContent: true
    };
  },

  watch: {
    defaultValue: {}
  },
  methods: {
    showLoading: function showLoading(value) {
      this.isLoading = value;
    },
    renderItem: function renderItem(item) {
      if (item.length > 1) {
        // @todo: should lookup dictionary and do normal
        return "<span>" + item[0] + "</span>: <span>" + item[1] + "</span>";
      }
      return "invalid";
    },
    toggleShowContent: function toggleShowContent() {
      this.showContent = !this.showContent;
    }
  },
  mounted: function mounted() {
    // this.pendingChanges = await this.getPendingChanges();

    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__element_control_new__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__element_control_radio__ = __webpack_require__(1051);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__element_pending_info__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


// import { HTTP as IOTHTTP } from "@/store/actions";









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "currentSettings",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "element-control-new": __WEBPACK_IMPORTED_MODULE_7__element_control_new__["a" /* default */],
    "element-control-radio": __WEBPACK_IMPORTED_MODULE_8__element_control_radio__["a" /* default */],
    "element-pending-info": __WEBPACK_IMPORTED_MODULE_9__element_pending_info__["a" /* default */]
  },
  props: {
    getDeviceCurrentSettings: {
      type: Object,
      default: {}
    }
  },
  computed: {
    // ...mapGetters(["getDeviceCurrentSettings", ""])
  },
  data: function data() {
    return {
      showCanvas: false,
      pendingChanges: null,
      currentSettings: [],
      deviceId: "",
      optionsHolder: {
        OutputMode: ["Single Machine Output", "Parallel Output", "Phase 1 of 3 Phase output", "Phase 2 of 3 Phase Output", "Phase 3 of 3 Phase output"],
        BatteryType: ["AGM", "Flooded battery", "For User Defined"],
        Chargersourcepriority: ["SBL UCD", "SBL UDC", "SLB UCD", "SLB UDC"],
        OutputSourcePriority: ["Utility - Solar - Battery", "Solar - Utility - Battery", "Solar - Battery - Utility"],
        ACInputVoltageLoss: ["Appliance", "UPS"],
        Topology: ["Transformerless", "Transformer"],
        MachineType: ["Grid tie", "Off Grid", "Hybrid"],
        InputVoltage: ["Appliance", "UPS"]
      }
    };
  },
  methods: {
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getDisplayValue: function getDisplayValue(value, key) {
      // let displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });

      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";

      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      // if (dataType == "Boolean") {
      //   try {
      //     let tmpDisplayData = Number(displayedData);
      //     return tmpDisplayData == 0 ? "No" : "Yes";
      //   } catch (error) {}
      // }
      // console.log({ value, key, config, dataType, unit });

      if (dataType == "option") {
        try {
          var tmpDisplayData = Number(value);
          return this.optionsHolder[key][tmpDisplayData] || value;
        } catch (error) {}
      }
      if (value.toString().endsWith(unit) == true) {
        return value;
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          var _tmpDisplayData = Number(value);
          return _tmpDisplayData != NaN ? _tmpDisplayData + unit : value;
        } catch (error) {}
      }

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    transformListData: function transformListData(ListData) {
      var _this = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this.transformListData(x) : _this.transformMapData(x);
      });
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_10__performance_payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    getPendingChanges: function getPendingChanges() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var deviceId, HTTP, endpoint, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deviceId = _this2.$route.params.deviceId;
                HTTP = _this2.$httpUtils.instance;
                endpoint = _this2.$utilConstants.IOT_BASE_URL + "/devicestate/";
                _context.next = 5;
                return HTTP.get("" + endpoint + deviceId);

              case 5:
                res = _context.sent;

                if (!(res && res.data && res.data.state && res.data.state.delta && res.data.state.delta)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", res.data.state.delta);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    refresh: function refresh() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.getPendingChanges();

              case 2:
                _this3.pendingChanges = _context2.sent;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4.deviceId = _this4.$route.params.deviceId;
              console.log({ geyGey: _this4.$route.params.deviceId });

              // this.currentSettings = await transformListData(getDeviceCurrentSettings);
              // this.pendingChanges = await this.getPendingChanges();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_notification__ = __webpack_require__(2587);




var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ElementControlInput",
  props: {
    eventKey: {
      type: String
    },
    topic: {
      type: String
    }
  },
  data: function data() {
    return {
      value: 0,
      requestParam: {
        topic: _this.topic,
        payload: { setExpiry: "2021-11-30T10:03:00" }
      },
      isLoading: false
    };
  },
  methods: {
    showLoading: function showLoading(value) {
      this.isLoading = value;
    },
    submitContractualLoad: function submitContractualLoad() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(parseInt(this.value)) == false) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_notification__["a" /* showAlarm */])({ type: "warning", message: "Valid integer is required." });
        return;
      }
      if (this.value < 1) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_notification__["a" /* showAlarm */])({
          type: "warning",
          message: "Input must be within 0 - 99999999"
        });
        return;
      }
      var HTTP = this.$httpUtils.instance;
      this.requestParam.topic = this.topic;
      this.requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, this.eventKey, this.value));
      this.showLoading(true);
      HTTP.options(this.$utilConstants.IOT_BASE_URL + "/event/publish/", this.requestParam).then(function (response) {
        console.log({ response: response });
        _this2.$emit("refresh");
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_notification__["a" /* showAlarm */])({ type: "success", message: "Success, sent!" });
        _this2.showLoading(false);
        _this2.value = 0;
      }).catch(function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_notification__["a" /* showAlarm */])({
          type: "error",
          message: "Error, unable to complete action, please try again"
        });
        _this2.showLoading(false);
      });
    }
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_dashboard_animated_icons__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_utils_helpers_js__ = __webpack_require__(140);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);




__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["BreadcrumbItem"]);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_25__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: {}
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_12__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_14__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_20_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_22__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_23__widgets_charts__["default"],

    "system-monitor": __WEBPACK_IMPORTED_MODULE_24__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])(["DeviceList"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    return {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      installationData: { name: "Arnergy Solar (Unassigned)" },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningDataLoading: false,
      exportDataLoading: false,
      warningsData: [],
      warningCurrentPage: 1,
      warningsDataTableoptions: [],
      warningsDataValuesFields: ["DeviceTimeStamp", "InverterId", "ACInputFrequencyLoss", "ACInputPhaseDislocation"],
      perPage: 10,
      currentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],

      // [00, 01, 02] (utility first, solar first, solar and utility)
      filterDate: null,
      exportDataTableoptions: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      pickerOptions: {
        shortcuts: [{
          text: "Last week",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last month",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 3 months",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_15_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_15_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartGenOption: {
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      },
      chartConsumpOption: {
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      },
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarGenchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarConsumpchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          //backgroundColor: fillPattern,
          borderWidth: 1
        }]
      },
      timeRightNow: __WEBPACK_IMPORTED_MODULE_15_moment___default()(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      tr: 0,
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        errors: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating",
          Overload: "System Overload"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])(["refreshList"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
        // console.log({powerKey}, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }
      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    warningRows: function warningRows() {
      console.log({ totalRows: this.warningsData.length });
      this.tr = this.warningsData.length * 1;
      return this.warningsData.length * 1;
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.currentTime();

              case 2:
                _this2.timeRightNow = _context.sent;
                container = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.viewDataLoading = false;
                  _this2.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this2.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this2.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = this.installationData.name + "_report.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    exportData: function exportData() {
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                app = _this3;
                inverterId = _this3.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this3.warningDataLoading = false;
                  _this3.warningsOffCanvas = true;

                  var _tmp = resp.data.Items.map(function (x) {
                    if (x.payload.WarningsData) {
                      var in_data = _this3.transformListData(x.payload.WarningsData);
                      in_data.DeviceTimeStamp = x.DeviceTimeStamp;
                      return in_data;
                    }
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    if (v) {
                      return v.map(function (v1) {
                        v1.DeviceTimeStamp = v.DeviceTimeStamp;
                        warningsData.push(v1);
                      });
                    }
                  });
                  console.log({ warningsData: warningsData });
                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.ACInputFrequencyLoss = v.ACInputFrequencyLoss.trim() === "0" ? no : v.ACInputFrequencyLoss.trim() === "1" ? yes : v.ACInputFrequencyLoss.trim();
                    tmp.ACInputPhaseDislocation = v.ACInputPhaseDislocation.trim() === "0" ? no : v.ACInputPhaseDislocation.trim() === "1" ? yes : v.ACInputPhaseDislocation.trim();
                    tmp.ACInputVoltageLoss = v.ACInputVoltageLoss.trim() === "0" ? no : v.ACInputVoltageLoss.trim() === "1" ? yes : v.ACInputVoltageLoss.trim();
                    tmp.ACInputWaveLoss = v.ACInputWaveLoss.trim() === "0" ? no : v.ACInputWaveLoss.trim() === "1" ? yes : v.ACInputWaveLoss.trim();
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm.trim() === "0" ? no : v.BatteryLowAlarm.trim() === "1" ? yes : v.BatteryLowAlarm.trim();
                    tmp.BatteryLowHybridMode = v.BatteryLowHybridMode.trim() === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen.trim() === "0" ? no : v.BatteryOpen.trim() === "1" ? yes : v.BatteryOpen.trim();
                    tmp.BatteryUnderVoltage = v.BatteryUnderVoltage.trim() === "0" ? no : v.BatteryUnderVoltage.trim() === "1" ? yes : v.BatteryUnderVoltage.trim();
                    tmp.EPOactive = v.EPOactive.trim() === "0" ? no : v.EPOactive.trim() === "1" ? yes : v.EPOactive.trim();
                    tmp.GdAV = v.GdAV.trim() === "0" ? no : yes;
                    tmp.GdII = v.GdII.trim() === "0" ? no : tmp.GdII = v.GdII.trim() === "1" ? yes : tmp.GdII = v.GdII.trim();
                    tmp.GridFrequencyHighLoss = v.GridFrequencyHighLoss.trim() === "0" ? no : v.GridFrequencyHighLoss.trim() === "1" ? yes : v.GridFrequencyHighLoss.trim();
                    tmp.GridFrequencyLowLoss = v.GridFrequencyLowLoss.trim() === "0" ? no : v.GridFrequencyLowLoss.trim() === "1" ? yes : v.GridFrequencyLowLoss.trim();
                    tmp.GridVoltageHighLoss = v.GridVoltageHighLoss.trim() === "0" ? no : v.GridVoltageHighLoss.trim() === "1" ? yes : v.GridVoltageHighLoss.trim();
                    tmp.GridVoltageLowLoss = v.GridVoltageLowLoss.trim() === "0" ? no : v.GridVoltageLowLoss.trim() === "1" ? yes : v.GridVoltageLowLoss.trim();

                    tmp.OverTemperature = v.OverTemperature.trim() === "0" ? no : yes;
                    tmp.Overload = v.Overload.trim() === "0" ? no : yes;
                    tmp.PVHgV1 = v.PVHgV1.trim() === "0" ? no : v.PVHgV1.trim() === "1" ? yes : v.PVHgV1.trim();
                    tmp.PVHgV2 = v.PVHgV2.trim() === "0" ? no : v.PVHgV2.trim() === "1" ? yes : v.PVHgV2.trim();
                    tmp.PVLs1 = v.PVLs1.trim() === "0" ? no : v.PVLs1.trim() === "1" ? yes : v.PVLs1.trim();
                    tmp.PVLs2 = v.PVLs2.trim() === "0" ? no : v.PVLs2.trim() === "1" ? yes : v.PVLs2.trim();

                    transformed.push(tmp);
                  });
                  _this3.warningsData = transformed;
                  // console.log(this.warningsData);
                  _this3.tr = _this3.warningsData.length;
                  _this3.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getTrimedValue: function getTrimedValue(p) {
      return p.trim();
    },
    showAlarm: function showAlarm(type) {
      var _this4 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this4.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this4.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_9_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    currentTime: function currentTime() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var me, HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = _this5;
                HTTP = _this5.$httpUtils.instance;
                _context3.next = 4;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 4:
                response = _context3.sent;
                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y" || mode == "05") {
        return true;
      } else {
        return false;
      }
    },
    batteryMode: function batteryMode(mode) {
      console.log({ mode: mode });
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
        case "00":
          resp = "Power On";
          break;
        case "S":
        case "01":
          resp = "On Standby";
          break;
        case "L":
        case "E":
        case "05":
          resp = "On Grid";
          break;
        case "Y":
        case "02":
          resp = "Bypass Mode";
          break;
        case "B":
        case "03":
          resp = "On Battery";
          break;
        case "F":
        case "04":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
        case "06":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_15_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["ACOutputTotalApparentPower"] * 1;
      }, 0);
      return power / 1000 + "kW";
    },
    activePercent: function activePercent(InverterData) {
      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      return this.roundUp(power / InverterData.length);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this6 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this6.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_15_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);
      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this7 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this7.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", this.Device);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (cid) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", true);

              case 2:
                GraphHTTP = _this8.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context4.next = 6;
                return GraphHTTP.post("/graphql", data).then(function (res) {
                  console.log("---> V4 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this8.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  // console.log(res);
                  //  this.transformDashData(_tmpDevice);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this9 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      console.log({ _tmpDevice: _tmpDevice });

      var EnergyData = _tmpDevice.payload.EnergyData;

      EnergyData = undefined === EnergyData ? null === _completePayload ? {} : _completePayload.transformedEnergyData : EnergyData;
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this9.EnergyData[x] = _this9.EnergyData[x] / 1000;
        return _this9.EnergyData[x];
      });
      // console.log({_tmpDevice});
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          PowerData: this.transformListData(_tmpDevice.payload.PowerData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          PowerData: this.transformListData(_tmpDevice.payload.PowerData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      console.log("+++++DEBUG 02 +++>=", tmp_data);
      this.Device = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    initFetch: function initFetch() {
      this.initError = false;
      var inverterId = this.inverterId * 1;
      try {
        var _tmpDevice = this.DeviceList.devices.find(function (x) {
          return x.DeviceID == inverterId;
        });

        if (_tmpDevice) {
          // console.log({_tmpDevice})
          // this.Device = {
          //   Timestamp: _tmpDevice.payload.Timestamp,
          //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
          //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
          // };
          var parsed = this.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // console.log(parsed);
        } else {
          this.initError = true;
          //  console.log(this.initError);
        }
      } catch (error) {
        console.log("iknow", error);
      }

      // this.fetchAllDeviceData();
      var deviceId = this.$route.params.deviceId;

      console.log(deviceId);
      this.graphDetailsCall(parseInt(deviceId));
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_15_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var _ref;

      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      //console.log({ displayData });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [(_ref = {
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946"
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pointRadius", 3), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "backgroundColor", "transparent"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "data", Chartdata["SOC"]), _ref)]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this12 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this12.currentTime();

              case 2:
                _this12.timeRightNow = _context5.sent;
                container = _this12;
                inverterId = _this12.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this12.viewDataLoading = false;
                  _this12.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this12.exportDataToTableValues = exportedData;
                  _this12._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context6.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log(this.exportedData);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this13.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  //console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this13.solarDataChart(DevData, _this13.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this13);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this14 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_15_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this14.transformListData(resp.data.Items);
        // console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var deviceId;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // console.log("----------------------------------------");
              deviceId = _this15.$route.params.deviceId;
              // console.log(deviceId);

              _this15.graphDetailsCall(parseInt(deviceId));
              _this15.getDevice();
              _this15.getDeviceData();
              try {
                _this15.initFetch();
              } catch (err) {}
              // console.log({ err });
              // window.location.reload();

              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this15);
    }))();
  }
});

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_dashboard_animated_icons__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_utils_helpers_js__ = __webpack_require__(140);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);
// var converter = require("json-2-csv");


__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_26__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_24__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_25__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData.SOC);
          var dcop = parseInt(InverterData[0]["DCOutputPower"]);
          console.log({ dcop: dcop });
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      try {
        var power = InverterData.reduce(function (acc, parameter) {
          var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
          // console.log({ powerKey }, Object.keys(parameter));
          return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
        }, 0);
        return power / 1000 + "kW";
      } catch (error) {
        console.log(error);
      }
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType ,key});
      // console.log({singleInverter,key,config});
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }
      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataloading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      try {
        device.payload.InverterData.reduce(function (acc, obj) {
          return acc += Number(obj["OL%"]);
        }, 0);
      } catch (error) {
        console.log("loadSum", error);
      }
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      try {
        var resp = "Battery Mode";
        switch (mode) {
          case "P":
            resp = "Power On";
            break;
          case "S":
            resp = "On Standby";
            break;
          case "L":
            resp = "On Grid";
            break;
          case "B":
            resp = "On Battery";
            break;
          case "F":
            resp = "Fault";
            break;
          case "H":
            resp = "Power saving mode";
            break;
          case "C":
            resp = "Charging";
            break;
          default:
        }

        var outputLoad = this.Device.InverterData.reduce(function (acc, obj) {
          // console.log({ obj });

          return acc += Number(obj["ACOutputApparentPower"]);
        }, 0);
        outputLoad = this.roundUpHandler(outputLoad);
        var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
        resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

        // console.log({ resp, outputLoad, solarPower, mode });

        return resp || "Battery Mode";
      } catch (error) {
        console.log("batteryMode", error);
      }
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InvAggrData) {
      try {
        // console.log({ InvAggrData });
        if (InvAggrData) {
          return InvAggrData.AACOAP * 1 / 1000;
        }
        var InverterData = this.Device.InverterData;

        var power = InverterData.reduce(function (acc, parameter) {
          var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
          return acc + lw * 1;
        }, 0);
        var ac = power / 1000;

        return ac || 0;
      } catch (error) {}
    },
    activePercent: function activePercent(InvAggrData) {
      if (InvAggrData) {
        return InvAggrData["AOL%"];
      }
      var InverterData = this.Device.InverterData;

      console.log({ InverterData: InverterData });

      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      var ap = power / InverterData.length;
      return this.roundUp(ap || 0);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                GraphHTTP = _this6.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context2.next = 6;
                return GraphHTTP.post("/graphql", data).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;
        // console.log({ energyData });

        var edResp = energyData ? energyData.map(function (e) {
          // console.log({ e });
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData[0] ? true : false
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          InvAggrData: _tmpDevice.payload.InvAggrData,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this13.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this13.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = container.installationData.name + "_reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;

                _this14.exportDataloading = true;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this15 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this15.currentTime();

              case 2:
                _this15.timeRightNow = _context6.sent;
                container = _this15;
                inverterId = _this15.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log("+++++=",resp.data.Items[0]);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  _this15.inverter = DevData[0].InverterData;
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  // console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this15);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this16 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this16.transformListData(resp.data.Items);
        console.log({ DevData: DevData });
        // if (DevData[0]) {
        //   app.deviceWarning = DevData[0]["payload"];
        // }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__ = __webpack_require__(97);










var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_25__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData.SOC);
          var dcop = parseInt(InverterData[0]["DCOutputPower"]);
          console.log({ dcop: dcop });
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), (_extends2 = {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        // console.log({ powerKey }, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType ,key});
      // console.log({singleInverter,key,config});
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }
      if (displayedData.endsWith(unit) == true) {
        return displayedData;
      }

      if (dataType == "Integer" || dataType == "Float") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataLoading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      if (__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a") == "Invalid date") {
        return Time;
      } else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(Time).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      device.payload.InverterData.reduce(function (acc, obj) {
        return acc += Number(obj["OL%"]);
      }, 0);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }

      var outputLoad = this.Device.InverterData.reduce(function (acc, obj) {
        // console.log({ obj });

        return acc += Number(obj["ACOutputApparentPower"]);
      }, 0);
      outputLoad = this.roundUpHandler(outputLoad);
      var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
      resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

      // console.log({ resp, outputLoad, solarPower, mode });

      return resp || "Battery Mode";
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      // console.log({ InverterData });
      var InvAggrData = this.Device.InvAggrData;

      if (InvAggrData) {
        return InvAggrData.AACOAP * 1 / 1000;
      }
      var power = InverterData.reduce(function (acc, parameter) {
        var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
        return acc + lw * 1;
      }, 0);
      var ac = power / 1000;

      return ac || 0;
    },
    activePercent: function activePercent(InverterData) {
      var InvAggrData = this.Device.InvAggrData;

      if (InvAggrData) {
        return InvAggrData["AOL%"];
      }
      if (this.inverterId == "417790") {
        // alert("eee");
        var load = parseInt(InverterData[0]["ACOutputApparentPower"]) / 1000 * 100;
        if (load <= 100) {
          return load;
        } else {
          return 100;
        }
      }

      console.log({ InverterData: InverterData });

      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      var ap = power / InverterData.length;
      return this.roundUp(ap || 0);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var GraphHTTP, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                GraphHTTP = _this6.$httpUtils.GraphHTTP;
                data = {
                  query: "{\n        device(id: " + cid + " )\n      }"
                };
                _context2.next = 6;
                return GraphHTTP.post("/graphql", data).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;


        var edResp = energyData ? energyData.map(function (e) {
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11 || MiscData.FV == 1.0 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData[0] ? true : false
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this13.exportDataToTableValues = exportedData;
                  _this13._convertJsonToCsvAndDownload(exportedData);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;
                container = _this14;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    }
  }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "_convertJsonToCsvAndDownload", function _convertJsonToCsvAndDownload(arrJson) {
    var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
    var labelsConf = labels || this.$_createCsvLabelsConf(labels);

    // @note: this.$_xxx is obtained from helpers mixin
    var csvLabels = this.$_createCsvLabels(labelsConf, ",");
    var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
    var content = csvLabels + csvData;

    if (csvLabels == "error" || csvData === "error") {
      console.error("Error: An error occured while parsing the data.");
      return;
    }

    var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
    if (!f) console.error("An error has occured", hasErrorEvent);
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDeviceData", function getDeviceData() {
    var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _this15 = this;

    var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var container, inverterId, headers, data;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this15.currentTime();

            case 2:
              _this15.timeRightNow = _context6.sent;
              container = _this15;
              inverterId = _this15.inverterId;
              headers = {
                "Content-Type": "application/plain"
              };
              data = {
                TableName: "Parameters",
                KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                ExpressionAttributeValues: {
                  ":key": "" + inverterId,
                  ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                  ":down": lowerLimit || new Date().toISOString()
                },
                Limit: limit,
                ScanIndexForward: false
              };
              // console.log(data);

              __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                headers: headers
              }).then(function (resp) {
                //this.exportedData = resp.data.Items;
                // console.log("+++++=",resp.data.Items[0]);
                var DevData = resp.data.Items.map(function (_tmpDevice) {
                  // console.log(_tmpDevice);
                  return {
                    Timestamp: _tmpDevice.DeviceTimeStamp,
                    InverterData: _tmpDevice.payload.InverterData,
                    BatteryData: _tmpDevice.payload.BatteryData,
                    EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                  };
                });
                _this15.inverter = DevData[0].InverterData;
                // let DevData = this.transformListData(tmpData);
                // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                // console.log({ DevData });
                // this.batteryChart(DevData, this.getTimeLabel(DevData));
                _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                // console.log(resp.data.state.reported.userPower);
                // if (resp.data.state.reported.userPower) {
                //   container.powerState = resp.data.state.reported.userPower;
                // }
              }).catch(function (err) {
                //console.log(err)
              });

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this15);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDeviceWarnings", function getDeviceWarnings() {
    var _this16 = this;

    var app = this;
    var inverterId = this.inverterId;
    var headers = {
      "Content-Type": "application/plain"
    };
    var data = {
      TableName: "Warnings",
      KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
      ExpressionAttributeValues: {
        ":key": inverterId * 1,
        ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
      },
      Limit: 1,
      ScanIndexForward: false
    };
    // console.log(data);
    __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
      headers: headers
    }).then(function (resp) {
      var DevData = _this16.transformListData(resp.data.Items);
      console.log({ DevData: DevData });
      // if (DevData[0]) {
      //   app.deviceWarning = DevData[0]["payload"];
      // }
      // console.log(this.getTimeLabel(DevData))
      // this.batteryChart(DevData, this.getTimeLabel(DevData));
      // this.solarDataChart(DevData, this.getTimeLabel(DevData));
      // console.log(resp.data.state.reported.userPower);
      // if (resp.data.state.reported.userPower) {
      //   container.powerState = resp.data.state.reported.userPower;
      // }
    }).catch(function (err) {
      //console.log(err)
    });
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDevice", function getDevice() {
    var inverterId = this.inverterId;
    var context = this;
    var HTTP = this.$httpUtils.instance;
    //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
    HTTP.get(url).then(function (response) {
      if (response.data.length > 0) context.installationData = response.data[0];
      //console.log(response.data);
    }).catch(function (error) {
      return "not assign";
      //console.log("error", error);
    });
  }), _extends2)),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hybridInverterv6.0146cbe.png";

/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_2_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  methods: {
    triggerPaygate: function triggerPaygate() {
      this.$refs.upay_form.click();
    },
    getDate: function getDate(type) {
      return type == 'day' ? __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('Do') : __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("MMM");
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession"]))
});

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__detailsV2_v2_vue__ = __webpack_require__(2604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__detailsV2_v3_vue__ = __webpack_require__(2607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__controls_index_vue__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__detailsV2_v4_vue__ = __webpack_require__(2610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__detailsV2_v5_vue__ = __webpack_require__(2613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__detailsV2_v6_vue__ = __webpack_require__(2616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */















// import flatPickr from "vue-flatpickr-component";

// import "flatpickr/dist/flatpickr.css";

// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
var endies = "https://iot-solarbase.arnergy.com/event/publish";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Collapse"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["CollapseItem"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_9__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_8__kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_17__kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "v2-dash": __WEBPACK_IMPORTED_MODULE_11__detailsV2_v2_vue__["a" /* default */],
    "v3-dash": __WEBPACK_IMPORTED_MODULE_12__detailsV2_v3_vue__["a" /* default */],
    "v4-dash": __WEBPACK_IMPORTED_MODULE_14__detailsV2_v4_vue__["a" /* default */],
    "v5-dash": __WEBPACK_IMPORTED_MODULE_15__detailsV2_v5_vue__["a" /* default */],
    "v6-dash": __WEBPACK_IMPORTED_MODULE_16__detailsV2_v6_vue__["a" /* default */],
    "control-settings": __WEBPACK_IMPORTED_MODULE_13__controls_index_vue__["a" /* default */],

    // powerStat,
    // flatPickr,
    RightBar: __WEBPACK_IMPORTED_MODULE_20__rightBar__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["c" /* mapGetters */])(["DeviceList", "getUserSession"]), {
    // Device: {}
    isShow: {
      get: function get() {
        if (this.$can("am", "sm") || this.$can("manage", "user")) {
          return true;
        } else return false;
      }
    }
  }),
  data: function data() {
    return {
      initError: true,
      installationData: { name: "Arnergy Solar (Unassigned)" },
      deviceWarning: {},
      powerState: {},
      screenView: {
        code: 0,
        codeName: "System Overview"
      },
      chargerPriority: "01",
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_18_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_18_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      timeRightNow: "",
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      Device: {},
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["b" /* mapActions */])(["refreshList"]), {
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    getDevice: function getDevice() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var inverterId, context, HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                inverterId = _this.$route.params.deviceId;
                context = _this;
                HTTP = _this.$httpUtils.instance;
                //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;

                url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
                _context.next = 6;
                return HTTP.get(url).then(function (response) {
                  if (response.data.length > 0) context.installationData = response.data[0];
                  //console.log(response.data);
                }).catch(function (error) {
                  return "not assign";
                  //console.log("error", error);
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    openBlank: function openBlank() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var installationData, uuid, name, CID, URL;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                installationData = _this2.installationData;
                uuid = installationData.user.uuid;
                name = installationData.name, CID = installationData.CID;


                console.log(installationData);

                URL = "https://oss.arnergy.com/d/_fUnhhknk/grid-metrics?orgId=1&var-uuid=" + uuid + "&var-name=" + name + "%20&var-deviceId=" + CID;
                // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&kiosk`;
                // const URL=`https://34.216.73.174/d/0Qwnd6XMz/poc?orgId=1&refresh=1m&var-uuid=${uuid}&from=now-1h&to=now&var-deviceId=${this.$route.params.deviceId}`;

                window.open(URL, "_blank").focus();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    handleSplitValue: function handleSplitValue(param) {
      this.screenView = param;
      // console.log(this.screenView);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    renderChart: function renderChart() {},
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_18_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(parameters) {
      var power = this.roundUp(parameters.ACOutputActivePower * 1 / 1000);
      return power + "kW";
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.$route.params.deviceId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = endies;
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this3.hideControl();
      }).catch(function (e) {
        console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.$route.params.deviceId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_18_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    initFetch: function initFetch() {
      var inverterId = this.$route.params.deviceId;
      // console.log(this.refreshList);
      this.Device = {
        parameters: this.findDeviceData(this.DeviceList.devices, "DeviceID", inverterId)[0],
        mode: this.findDeviceData(this.DeviceList.modes, "DeviceID", inverterId)[0],
        expiry: this.findDeviceData(this.DeviceList.expiries, "DeviceID", inverterId)[0]
      };
      // console.log(this.DeviceList);
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.$route.params.deviceId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    transformData: function transformData(data, keys) {
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["payload"][key] * 1]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_18_moment___default()(c_item["payload"]["TimeStamp"]).add(1, "hour").format("h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "PVChargingPower"]);
      this.solarchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Output Active Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["ACOutputActivePower"]
        }, {
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#ffb946",
          // backgroundColor: "rgba(0,0,0,0.3)",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart: function batteryChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["BatteryCapacity", "OutputLoadPercent"]);
      this.chartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Battery Percent",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["BatteryCapacity"]
        }, {
          pointRadius: 0,
          label: "Load Percent",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["OutputLoadPercent"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

      var container = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Parameters",
        KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": "" + inverterId,
          ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_18_moment___default()("2019/6/20").startOf("day").toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        // console.log(DevData);
        // console.log(this.getTimeLabel(DevData));
        _this4.batteryChart(DevData, _this4.getTimeLabel(DevData));
        _this4.solarDataChart(DevData, _this4.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var app = this;
      var inverterId = this.$route.params.deviceId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_18_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_19__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        return console.log(err);
      });
    }
    // getDevice() {
    //   var inverterId = this.$route.params.deviceId;
    //   const context = this;
    //   const HTTP = this.$httpUtils.instance;
    //   //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    //   const url = `/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][solarKitIds]=${inverterId}`;
    //   HTTP.get(url)
    //     .then((response) => {
    //       if (response.data.length > 0)
    //         context.installationData = response.data[0];
    //     })
    //     .catch((error) => {
    //       return "not assign";
    //       //console.log("error", error);
    //     });
    // },

  }),
  created: function created() {},
  mounted: function mounted() {
    this.initError = false;
    // try {
    //   this.currentTime();
    // this.refreshList();
    //   this.initFetch();
    this.getDevice();
    //   this.getDeviceState();
    //   this.getDeviceData();
    //   this.getDeviceWarnings();
    // } catch (error) {
    //   this.initError = true;
    //   console.log("Init Error", error);
    // }

    // this.fetchAllDeviceData();
    // this.fetchHealth("today");
    // this.statusBorder = "4px solid #000";
    // setInterval(this.fetchAllDeviceData, 60000);
  }
});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_timers__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_pages_dashboard_animated_icons__ = __webpack_require__(97);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";

// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);
// var converter = require("json-2-csv");



__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["BreadcrumbItem"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_5_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui__["Loading"]);

var liveTimeout = null;



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  props: {
    inverterId: {
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_9__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_8__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_16_vue_datetime__["Datetime"],
    "device-control": __WEBPACK_IMPORTED_MODULE_19__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_20__widgets_charts__["default"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_21__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },

    statusBorder: {
      get: function get() {
        return "4px solid #e34a4a;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  beforeDestroy: function beforeDestroy() {
    // console.log("teardown shii", liveTimeout);
    // clearTimeout(liveTimeout);
    this.liveTimeout.destroy();
  },
  data: function data() {
    return {
      activeNames: ["1"],
      loading: true,
      filterDate: null,
      pickerOptions: {
        shortcuts: [{
          text: "Last week",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last month",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 3 months",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      liveTimeout: null,
      initError: false,
      installationData: {
        name: "Loding..."
      },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      perPage: 10,
      currentPage: 1,
      exportDataToTableValues: [],
      exportDataTableoptions: [],
      exportDataToTableValuesFields: ["payload.TimeStamp", "payload.PVInputVoltage", "payload.InverterId", "payload.EnergyData.ConsumedYearOffGrid"],
      // [00, 01, 02] (utility first, solar first, solar and utility)
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_12_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_12_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      timeRightNow: __WEBPACK_IMPORTED_MODULE_12_moment___default()(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])(["refreshList", "performanceGraphCall"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    filterChart: function filterChart() {
      console.log(this.filterDate);
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    showWAlarm: function showWAlarm(type) {
      var _this2 = this;

      var resp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        return _tmp += _this2.deviceWarning[_curr] == 1 ? "<li>" + _this2.flags[type][_curr] + "</li>" : "";
      }, "");
      __WEBPACK_IMPORTED_MODULE_6_element_ui__["Notification"].warning({
        title: "" + type[0].toUpperCase() + type.slice(1),
        dangerouslyUseHTMLString: true,
        message: resp
      });
      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              return "warning";
            } else if (this.flags.faults[property]) {
              return "error";
            }
          }
        }
      }
      return;
    },
    exportData: function exportData() {
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    exportDataToTable: function exportDataToTable() {
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.currentTime();

              case 2:
                _this3.timeRightNow = _context.sent;
                container = _this3;
                inverterId = _this3.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this3.showTableOffCanvas = true;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    console.log(temp);

                    _this3.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }
                  _this3.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.currentTime();

              case 2:
                _this4.timeRightNow = _context2.sent;
                container = _this4;
                inverterId = _this4.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });

                  _this4.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    currentTime: function currentTime() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var me, HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = _this5;
                HTTP = _this5.$httpUtils.instance;
                _context3.next = 4;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 4:
                response = _context3.sent;
                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen() {
      // console.log(this.Device);
      return this.Device.parameters ? new Date(this.Device.parameters.TimeStamp).toDateString() + " " + new Date(this.Device.parameters.TimeStamp).toLocaleTimeString() : "--";
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_12_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    renderChart: function renderChart() {},
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(parameters) {
      var power = this.roundUp(parameters.ACOutputActivePower * 1 / 1000);
      return power + "kW";
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.PVChargingPower * 1 / 1000);
      return power + " kW";
      // var power = this.roundUp(
      //   (parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1)) / 1000
      // );
      // return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    confirmEnergy: function confirmEnergy(data) {
      if (data == undefined) return [];
      return data;
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var FastAPIHTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (cid) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", true);

              case 2:
                FastAPIHTTP = _this6.$httpUtils.FastAPIHTTP;
                _context4.next = 5;
                return FastAPIHTTP.get("/devices/" + cid).then(function (res) {
                  console.log("---> V2 <----");

                  console.log(res);
                  console.log("++++++++>=1", _this6.Device);
                  if (res.data.data.device["Items"]) {
                    _this6.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this6.Device, {
                      parameters: res.data.data.device["Items"][0]["payload"]
                    });
                    console.log("++++++++>=2", _this6.Device);
                  }
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, headers, payLoad, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this7.currentTime();

              case 2:
                _this7.timeRightNow = _context5.sent;
                container = _this7;
                headers = {
                  "Content-Type": "application/plain"
                };
                payLoad = {
                  ":key": Number(_this7.inverterId)
                };
                data = {
                  TableName: "ConnectedDevices",
                  FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
                  ExpressionAttributeValues: payLoad
                  // Limit: limit,
                  // ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
                  headers: headers
                }).then(function (resp) {
                  if (resp.data["Items"]) {
                    _this7.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _this7.Device, {
                      parameters: resp.data["Items"][0]
                    });
                    console.log("++++++++>=", _this7.Device);
                  }
                  // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
                  // console.log("++++++++>=",  resp.data['Items']);
                }).catch(function (err) {
                  //  console.log("=++++++++>", err);
                  // this.liveTimeout = setTimeout(this.fetchAllDeviceData, 60000);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_12_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";
        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    initFetch: function initFetch() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var deviceId, inverterId, data_tmp;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                deviceId = _this8.$route.params.deviceId;
                // let timeRightNow = await this.currentTime();
                // this.performanceGraphCall(timeRightNow);

                inverterId = _this8.inverterId * 1;
                // console.log(
                //   "============================",

                // );

                _this8.graphDetailsCall(parseInt(deviceId));
                data_tmp = _this8.DeviceList.find(function (x) {
                  return x.DeviceID == inverterId;
                });

                console.log("===========", data_tmp.payload);
                _this8.Device = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, data_tmp, {
                  parameters: data_tmp.payload
                  //   mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
                  //   expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
                });
                // console.log(",,,,,", this.Device);
                if (_this8.Device.parameters == null) {
                  _this8.initError = true;
                }

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["payload"][key] * 1]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_12_moment___default()(c_item["payload"]["TimeStamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "PVChargingPower"]);
      this.solarchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Output Active Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["ACOutputActivePower"]
        }, {
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#ffb946",
          // backgroundColor: "rgba(0,0,0,0.3)",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.charttype = "line";
      this.loading = false;
      // this.renderChart();
      this.$refs.solarchartdata.reload(this.solarchartdata, this.charttype);
    },
    batteryChart: function batteryChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["BatteryCapacity", "OutputLoadPercent"]);
      this.chartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "Battery Percent",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["BatteryCapacity"]
        }, {
          pointRadius: 0,
          label: "Load Percent",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.8)",
          data: Chartdata["OutputLoadPercent"]
        }]
      };
      this.charttype = "line";
      // this.renderChart();
      this.$refs.healthchart.reload(this.chartdata, this.charttype);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this9 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

      var container = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Parameters",
        KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
        ExpressionAttributeValues: {
          ":key": "" + inverterId,
          ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_12_moment___default()("2019/6/20").startOf("day").toDate(),
          ":down": lowerLimit || new Date().toISOString()
        },
        Limit: limit,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        //  console.log(DevData);
        // console.log(this.getTimeLabel(DevData));
        _this9.batteryChart(DevData, _this9.getTimeLabel(DevData));
        _this9.solarDataChart(DevData, _this9.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //  console.log(err)
      });
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_12_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = resp.data.Items;
        //  console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {});
    },
    getDevice: function getDevice() {
      //  console.log(err)

      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][or][0][CID]=" + inverterId + "&filter[where][or][1][solarKitIds]=" + inverterId;
      HTTP.get(url).then(function (response) {
        //  console.log({ response });
        if (response.data.length > 0) context.installationData = response.data[0];
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _this10.initError = false;
              try {
                // await this.currentTime();
                _this10.initFetch().then(function (x) {
                  // console.log(this.DeviceList);
                  // this.initFetch();
                  _this10.getDevice();
                  _this10.getDeviceState();
                  _this10.getDeviceWarnings();
                  // this.fetchAllDeviceData();

                  var deviceId = _this10.$route.params.deviceId;

                  console.log(deviceId);
                  _this10.graphDetailsCall(parseInt(deviceId));
                });
              } catch (error) {
                _this10.initError = true;
                //  console.log("Init Error", error);
              }

              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              //

            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this10);
    }))();
  }
});

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__ = __webpack_require__(97);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_25__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData && BatteryData.SOC);
          var dcop = parseInt(InverterData && InverterData.length > 0 && InverterData[0]["DCOutputPower"]);
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        // console.log({ powerKey }, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float" || dataType == "String") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }

      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataLoading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0] || {});
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      device.payload.InverterData.reduce(function (acc, obj) {
        return acc += Number(obj["OL%"]);
      }, 0);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }

      var outputLoad = (this.Device.InverterData || []).reduce(function (acc, obj) {
        // console.log({ obj });

        return acc += Number(obj["ACOutputApparentPower"]);
      }, 0);
      outputLoad = this.roundUpHandler(outputLoad);
      var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
      resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

      // console.log({ resp, outputLoad, solarPower, mode });

      return resp || "Battery Mode";
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      // console.log({ InverterData });
      var InvAggrData = this.Device.InvAggrData;

      try {
        if (InvAggrData) {
          return InvAggrData.AACOAP * 1 / 1000;
        }

        var power = InverterData.reduce(function (acc, parameter) {
          var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
          return acc + lw * 1;
        }, 0);
        var ac = power / 1000;

        return ac || 0;
      } catch (error) {
        return 0;
      }
    },
    activePercent: function activePercent(InverterData) {
      try {
        var InvAggrData = this.Device.InvAggrData;

        if (InvAggrData) {
          return InvAggrData["AOL%"];
        }

        var power = InverterData.reduce(function (acc, parameter) {
          return acc + parameter["OutputLoadPercent"] * 1;
        }, 0);
        console.log({ power: power });
        var ap = power / InverterData.length;
        return this.roundUp(ap || 0);
      } catch (error) {
        console.log();
      }
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var FastAPIHTTP;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                FastAPIHTTP = _this6.$httpUtils.FastAPIHTTP;
                _context2.next = 5;
                return FastAPIHTTP.get("/devices/" + cid).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;
        // console.log({ energyData });

        var edResp = energyData ? energyData.map(function (e) {
          // console.log({ e });
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = ["1.12", "1.11"].includes("" + parseFloat(MiscData.FV)) || parseFloat(MiscData.FV) >= 1.76 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData ? true : false,EnergyData,test:  ['1.12','1.11'].includes(`${parseFloat(MiscData.FV)}`)|| parseFloat(MiscData.FV) >= 1.76
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this13.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this13.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = container.installationData.name + "_reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;
                container = _this14;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this15 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this15.currentTime();

              case 2:
                _this15.timeRightNow = _context6.sent;
                container = _this15;
                inverterId = _this15.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log("+++++=",resp.data.Items[0]);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  _this15.inverter = DevData[0].InverterData;
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  // console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this15);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this16 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this16.transformListData(resp.data.Items);
        console.log({ DevData: DevData });
        // if (DevData[0]) {
        //   app.deviceWarning = DevData[0]["payload"];
        // }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_pages_dashboard_animated_icons__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_utils_helpers_js__ = __webpack_require__(140);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */









// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);




__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_8_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_element_ui__["BreadcrumbItem"]);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_25__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: {}
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_12__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_11__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_14__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_20_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_22__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_23__widgets_charts__["default"],

    "system-monitor": __WEBPACK_IMPORTED_MODULE_24__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])(["DeviceList"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    return {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      installationData: { name: "Arnergy Solar (Unassigned)" },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningDataLoading: false,
      exportDataLoading: false,
      warningsData: [],
      warningCurrentPage: 1,
      warningsDataTableoptions: [],
      warningsDataValuesFields: ["DeviceTimeStamp", "InverterId", "ACInputFrequencyLoss", "ACInputPhaseDislocation"],
      perPage: 10,
      currentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],

      // [00, 01, 02] (utility first, solar first, solar and utility)
      filterDate: null,
      exportDataTableoptions: [{
        value: "Option1",
        label: "Option1"
      }, {
        value: "Option2",
        label: "Option2"
      }, {
        value: "Option3",
        label: "Option3"
      }, {
        value: "Option4",
        label: "Option4"
      }, {
        value: "Option5",
        label: "Option5"
      }],
      pickerOptions: {
        shortcuts: [{
          text: "Last week",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last month",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 3 months",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      chargerPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "Solar and Utility",
        value: "02"
      }],
      outputPriority: "01",
      outputPriorityList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Utility First",
        value: "00"
      }, {
        text: "Solar First",
        value: "01"
      }, {
        text: "SBU First",
        value: "02"
      }],
      deviceMode: "00",
      deviceModeList: [{
        text: "Select Option",
        value: null,
        disabled: true
      }, {
        text: "Inverter Mode",
        value: "00"
      }, {
        text: "UPS Mode",
        value: "01"
      }],
      show: true,
      Device: {},
      // IOTSRC: "https://arnergy-dash-api.herokuapp.com",
      IOTSRC: "http://arnergy-dash-api.herokuapp.com",
      expiryToSend: "",
      THIS_WEEK: __WEBPACK_IMPORTED_MODULE_15_moment___default()().startOf("week").toDate(),
      THIS_MONTH: __WEBPACK_IMPORTED_MODULE_15_moment___default()().startOf("month").toDate(),
      isMale: true,
      statusBorderHandle: "red",
      charttype: "line",
      showWarning: false,
      chartGenOption: {
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      },
      chartConsumpOption: {
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      },
      chartdata: {
        labels: ["Please", "wait", ".", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarGenchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          borderWidth: 1
        }]
      },
      solarConsumpchartdata: {
        labels: ["Please", "wait", ".", ".", "."],
        datasets: [{
          label: "Loading",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 0.3)",
          //backgroundColor: fillPattern,
          borderWidth: 1
        }]
      },
      timeRightNow: __WEBPACK_IMPORTED_MODULE_15_moment___default()(),
      endpointsMap: {
        "on-power": "power",

        "off-power": "power",

        "get-expiry": "requestexpdate",

        "set-expiry": "expirydate",

        "pcp-charger-priority": "charger-priority",

        "pop-output-priority": "output-priority",

        "pgr-device-mode": "device-mode",

        "open-ssh": "ssh",

        "command-shell": "shell",

        "send-command": "command",

        "init-reboot": "reboot",

        "get-settings": "setting",

        "init-reset": "reset",

        "get-batteql": "battequal",

        "on-admin": "admin",

        "off-admin": "admin"
      },
      pickerConfig: {
        enableTime: true,
        dateFormat: "F j, Y",
        // dateFormat: "H-i-S-d-m-Y",
        wrap: true
      },
      commandSending: "",
      ipAddress: "",
      username: "",
      password: "",
      expiryDate_: null,
      currentCommand: "",
      currentParam: "",
      details: "/device/details",
      HealthData: [],
      warnings: [],
      tr: 0,
      battery_meter: {
        background: "green",
        width: "50%"
      },
      flags: {
        errors: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating",
          Overload: "System Overload"
        }
      }
    };
  },
  methods: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])(["refreshList"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
        // console.log({powerKey}, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType });
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float" || dataType == "String") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }
      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    warningRows: function warningRows() {
      console.log({ totalRows: this.warningsData.length });
      this.tr = this.warningsData.length * 1;
      return this.warningsData.length * 1;
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.currentTime();

              case 2:
                _this2.timeRightNow = _context.sent;
                container = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.viewDataLoading = false;
                  _this2.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this2.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this2.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = this.installationData.name + "_report.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    exportData: function exportData() {
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                app = _this3;
                inverterId = _this3.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this3.warningDataLoading = false;
                  _this3.warningsOffCanvas = true;

                  var _tmp = resp.data.Items.map(function (x) {
                    if (x.payload.WarningsData) {
                      var in_data = _this3.transformListData(x.payload.WarningsData);
                      in_data.DeviceTimeStamp = x.DeviceTimeStamp;
                      return in_data;
                    }
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    if (v) {
                      return v.map(function (v1) {
                        v1.DeviceTimeStamp = v.DeviceTimeStamp;
                        warningsData.push(v1);
                      });
                    }
                  });
                  console.log({ warningsData: warningsData });
                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.ACInputFrequencyLoss = v.ACInputFrequencyLoss.trim() === "0" ? no : v.ACInputFrequencyLoss.trim() === "1" ? yes : v.ACInputFrequencyLoss.trim();
                    tmp.ACInputPhaseDislocation = v.ACInputPhaseDislocation.trim() === "0" ? no : v.ACInputPhaseDislocation.trim() === "1" ? yes : v.ACInputPhaseDislocation.trim();
                    tmp.ACInputVoltageLoss = v.ACInputVoltageLoss.trim() === "0" ? no : v.ACInputVoltageLoss.trim() === "1" ? yes : v.ACInputVoltageLoss.trim();
                    tmp.ACInputWaveLoss = v.ACInputWaveLoss.trim() === "0" ? no : v.ACInputWaveLoss.trim() === "1" ? yes : v.ACInputWaveLoss.trim();
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm.trim() === "0" ? no : v.BatteryLowAlarm.trim() === "1" ? yes : v.BatteryLowAlarm.trim();
                    tmp.BatteryLowHybridMode = v.BatteryLowHybridMode.trim() === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen.trim() === "0" ? no : v.BatteryOpen.trim() === "1" ? yes : v.BatteryOpen.trim();
                    tmp.BatteryUnderVoltage = v.BatteryUnderVoltage.trim() === "0" ? no : v.BatteryUnderVoltage.trim() === "1" ? yes : v.BatteryUnderVoltage.trim();
                    tmp.EPOactive = v.EPOactive.trim() === "0" ? no : v.EPOactive.trim() === "1" ? yes : v.EPOactive.trim();
                    tmp.GdAV = v.GdAV.trim() === "0" ? no : yes;
                    tmp.GdII = v.GdII.trim() === "0" ? no : tmp.GdII = v.GdII.trim() === "1" ? yes : tmp.GdII = v.GdII.trim();
                    tmp.GridFrequencyHighLoss = v.GridFrequencyHighLoss.trim() === "0" ? no : v.GridFrequencyHighLoss.trim() === "1" ? yes : v.GridFrequencyHighLoss.trim();
                    tmp.GridFrequencyLowLoss = v.GridFrequencyLowLoss.trim() === "0" ? no : v.GridFrequencyLowLoss.trim() === "1" ? yes : v.GridFrequencyLowLoss.trim();
                    tmp.GridVoltageHighLoss = v.GridVoltageHighLoss.trim() === "0" ? no : v.GridVoltageHighLoss.trim() === "1" ? yes : v.GridVoltageHighLoss.trim();
                    tmp.GridVoltageLowLoss = v.GridVoltageLowLoss.trim() === "0" ? no : v.GridVoltageLowLoss.trim() === "1" ? yes : v.GridVoltageLowLoss.trim();

                    tmp.OverTemperature = v.OverTemperature.trim() === "0" ? no : yes;
                    tmp.Overload = v.Overload.trim() === "0" ? no : yes;
                    tmp.PVHgV1 = v.PVHgV1.trim() === "0" ? no : v.PVHgV1.trim() === "1" ? yes : v.PVHgV1.trim();
                    tmp.PVHgV2 = v.PVHgV2.trim() === "0" ? no : v.PVHgV2.trim() === "1" ? yes : v.PVHgV2.trim();
                    tmp.PVLs1 = v.PVLs1.trim() === "0" ? no : v.PVLs1.trim() === "1" ? yes : v.PVLs1.trim();
                    tmp.PVLs2 = v.PVLs2.trim() === "0" ? no : v.PVLs2.trim() === "1" ? yes : v.PVLs2.trim();

                    transformed.push(tmp);
                  });
                  _this3.warningsData = transformed;
                  // console.log(this.warningsData);
                  _this3.tr = _this3.warningsData.length;
                  _this3.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getTrimedValue: function getTrimedValue(p) {
      return p.trim();
    },
    showAlarm: function showAlarm(type) {
      var _this4 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this4.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this4.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_9_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_9_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    currentTime: function currentTime() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var me, HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                me = _this5;
                HTTP = _this5.$httpUtils.instance;
                _context3.next = 4;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 4:
                response = _context3.sent;
                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5);
      }))();
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_15_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_15_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_15_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_15_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y" || mode == "05") {
        return true;
      } else {
        return false;
      }
    },
    batteryMode: function batteryMode(mode) {
      console.log({ mode: mode });
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
        case "00":
          resp = "Power On";
          break;
        case "S":
        case "01":
          resp = "On Standby";
          break;
        case "L":
        case "E":
        case "05":
          resp = "On Grid";
          break;
        case "Y":
        case "02":
          resp = "Bypass Mode";
          break;
        case "B":
        case "03":
          resp = "On Battery";
          break;
        case "F":
        case "04":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
        case "06":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_15_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["ACOutputTotalApparentPower"] * 1;
      }, 0);
      return power / 1000 + "kW";
    },
    activePercent: function activePercent(InverterData) {
      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      return this.roundUp(power / InverterData.length);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this6 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this6.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_15_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);
      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this7 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this7.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", this.Device);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var FastAPIHTTP;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (cid) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return", true);

              case 2:
                FastAPIHTTP = _this8.$httpUtils.FastAPIHTTP;
                _context4.next = 5;
                return FastAPIHTTP.get("/devices/" + cid).then(function (res) {
                  console.log("---> V4 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this8.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  // console.log(res);
                  //  this.transformDashData(_tmpDevice);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this9 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      console.log({ _tmpDevice: _tmpDevice });

      var EnergyData = _tmpDevice.payload.EnergyData;

      EnergyData = undefined === EnergyData ? null === _completePayload ? {} : _completePayload.transformedEnergyData : EnergyData;
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this9.EnergyData[x] = _this9.EnergyData[x] / 1000;
        return _this9.EnergyData[x];
      });
      // console.log({_tmpDevice});
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          PowerData: this.transformListData(_tmpDevice.payload.PowerData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          PowerData: this.transformListData(_tmpDevice.payload.PowerData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      console.log("+++++DEBUG 02 +++>=", tmp_data);
      this.Device = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    initFetch: function initFetch() {
      this.initError = false;
      var inverterId = this.inverterId * 1;
      try {
        var _tmpDevice = (this.DeviceList && this.DeviceList.devices).find(function (x) {
          return x.DeviceID == inverterId;
        });

        if (_tmpDevice) {
          // console.log({_tmpDevice})
          // this.Device = {
          //   Timestamp: _tmpDevice.payload.Timestamp,
          //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
          //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
          // };
          var parsed = this.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // console.log(parsed);
        } else {
          this.initError = true;
          //  console.log(this.initError);
        }
      } catch (error) {
        console.log("iknow", error);
      }

      // this.fetchAllDeviceData();
      var deviceId = this.$route.params.deviceId;

      console.log(deviceId);
      this.graphDetailsCall(parseInt(deviceId));
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_18__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_15_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var _ref;

      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      //console.log({ displayData });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [(_ref = {
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946"
        }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "pointRadius", 3), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "backgroundColor", "transparent"), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, "data", Chartdata["SOC"]), _ref)]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this12 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this12.currentTime();

              case 2:
                _this12.timeRightNow = _context5.sent;
                container = _this12;
                inverterId = _this12.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this12.viewDataLoading = false;
                  _this12.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this12.exportDataToTableValues = exportedData;
                  _this12._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context6.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log(this.exportedData);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this13.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  //console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this13.solarDataChart(DevData, _this13.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this13);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this14 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_15_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_16__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this14.transformListData(resp.data.Items);
        // console.log(DevData);
        if (DevData[0]) {
          app.deviceWarning = DevData[0]["payload"];
        }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this15 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee7() {
      var deviceId;
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              // console.log("----------------------------------------");
              deviceId = _this15.$route.params.deviceId;
              // console.log(deviceId);

              _this15.graphDetailsCall(parseInt(deviceId));
              _this15.getDevice();
              _this15.getDeviceData();
              try {
                _this15.initFetch();
              } catch (err) {}
              // console.log({ err });
              // window.location.reload();

              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this15);
    }))();
  }
});

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_pages_dashboard_animated_icons__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_utils_helpers_js__ = __webpack_require__(140);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);
// var converter = require("json-2-csv");


__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_26__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_24__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_25__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData && BatteryData.SOC);
          var dcop = parseInt(InverterData && InverterData.length > 0 && InverterData[0]["DCOutputPower"]);
          console.log({ dcop: dcop });
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      try {
        var power = InverterData.reduce(function (acc, parameter) {
          var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
          // console.log({ powerKey }, Object.keys(parameter));
          return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
        }, 0);
        return power / 1000 + "kW";
      } catch (error) {
        console.log(error);
      }
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType ,key});
      // console.log({singleInverter,key,config});
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }

      if (dataType == "Integer" || dataType == "Float" || dataType == "String") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }
      return displayedData;

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataloading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      // console.log(this.Device)
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      try {
        device.payload.InverterData.reduce(function (acc, obj) {
          return acc += Number(obj["OL%"]);
        }, 0);
      } catch (error) {
        console.log("loadSum", error);
      }
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      try {
        var resp = "Battery Mode";
        switch (mode) {
          case "P":
            resp = "Power On";
            break;
          case "S":
            resp = "On Standby";
            break;
          case "L":
            resp = "On Grid";
            break;
          case "B":
            resp = "On Battery";
            break;
          case "F":
            resp = "Fault";
            break;
          case "H":
            resp = "Power saving mode";
            break;
          case "C":
            resp = "Charging";
            break;
          default:
        }

        var outputLoad = this.Device.InverterData.reduce(function (acc, obj) {
          // console.log({ obj });

          return acc += Number(obj["ACOutputApparentPower"]);
        }, 0);
        outputLoad = this.roundUpHandler(outputLoad);
        var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
        resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

        // console.log({ resp, outputLoad, solarPower, mode });

        return resp || "Battery Mode";
      } catch (error) {
        console.log("batteryMode", error);
      }
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InvAggrData) {
      try {
        // console.log({ InvAggrData });
        if (InvAggrData) {
          return InvAggrData.AACOAP * 1 / 1000;
        }
        var InverterData = this.Device.InverterData;

        var power = InverterData.reduce(function (acc, parameter) {
          var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
          return acc + lw * 1;
        }, 0);
        var ac = power / 1000;

        return ac || 0;
      } catch (error) {}
    },
    activePercent: function activePercent(InvAggrData) {
      if (InvAggrData) {
        return InvAggrData["AOL%"];
      }
      var InverterData = this.Device.InverterData;

      console.log({ InverterData: InverterData });

      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      var ap = power / InverterData.length;
      return this.roundUp(ap || 0);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var FastAPIHTTP;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                FastAPIHTTP = _this6.$httpUtils.FastAPIHTTP;
                _context2.next = 5;
                return FastAPIHTTP.get("/devices/" + cid).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;
        // console.log({ energyData });

        var edResp = energyData ? energyData.map(function (e) {
          // console.log({ e });
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData[0] ? true : false
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          InvAggrData: _tmpDevice.payload.InvAggrData,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.showTableOffCanvas = true;

                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  console.log(exportedData);
                  if (exportedData.length > 0) {
                    var temp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                    _this13.exportDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(exportedData[0]);
                  }

                  _this13.exportDataToTableValues = exportedData;
                  var json2csvCallback = function json2csvCallback(err, csv) {
                    if (err) throw err;
                    //return csv;
                    var hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = container.installationData.name + "_reports.csv";
                    hiddenElement.click();
                  };
                  // converter.json2csv(exportedData, json2csvCallback);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;

                _this14.exportDataloading = true;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },
    getDeviceData: function getDeviceData() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this15 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this15.currentTime();

              case 2:
                _this15.timeRightNow = _context6.sent;
                container = _this15;
                inverterId = _this15.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  //this.exportedData = resp.data.Items;
                  // console.log("+++++=",resp.data.Items[0]);
                  var DevData = resp.data.Items.map(function (_tmpDevice) {
                    // console.log(_tmpDevice);
                    return {
                      Timestamp: _tmpDevice.DeviceTimeStamp,
                      InverterData: _tmpDevice.payload.InverterData,
                      BatteryData: _tmpDevice.payload.BatteryData,
                      EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                    };
                  });
                  _this15.inverter = DevData[0].InverterData;
                  // let DevData = this.transformListData(tmpData);
                  // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                  // console.log({ DevData });
                  // this.batteryChart(DevData, this.getTimeLabel(DevData));
                  _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                  // console.log(resp.data.state.reported.userPower);
                  // if (resp.data.state.reported.userPower) {
                  //   container.powerState = resp.data.state.reported.userPower;
                  // }
                }).catch(function (err) {
                  //console.log(err)
                });

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this15);
      }))();
    },
    getDeviceWarnings: function getDeviceWarnings() {
      var _this16 = this;

      var app = this;
      var inverterId = this.inverterId;
      var headers = {
        "Content-Type": "application/plain"
      };
      var data = {
        TableName: "Warnings",
        KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
        ExpressionAttributeValues: {
          ":key": inverterId * 1,
          ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
        },
        Limit: 1,
        ScanIndexForward: false
      };
      // console.log(data);
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
        headers: headers
      }).then(function (resp) {
        var DevData = _this16.transformListData(resp.data.Items);
        console.log({ DevData: DevData });
        // if (DevData[0]) {
        //   app.deviceWarning = DevData[0]["payload"];
        // }
        // console.log(this.getTimeLabel(DevData))
        // this.batteryChart(DevData, this.getTimeLabel(DevData));
        // this.solarDataChart(DevData, this.getTimeLabel(DevData));
        // console.log(resp.data.state.reported.userPower);
        // if (resp.data.state.reported.userPower) {
        //   container.powerState = resp.data.state.reported.userPower;
        // }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    getDevice: function getDevice() {
      var inverterId = this.inverterId;
      var context = this;
      var HTTP = this.$httpUtils.instance;
      //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
      var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
      HTTP.get(url).then(function (response) {
        if (response.data.length > 0) context.installationData = response.data[0];
        //console.log(response.data);
      }).catch(function (error) {
        return "not assign";
        //console.log("error", error);
      });
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__installationStat__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_charts__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__widgets_controls__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__ = __webpack_require__(97);










var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










// import flatPickr from "vue-flatpickr-component";
// import "flatpickr/dist/flatpickr.css";


// const endies =
//   "http://arnergyiot-dev.88se6pd53y.us-west-2.elasticbeanstalk.com/";
// import vueDatetimePicker from 'moment'
// var vueDatetimePicker =
// var timeCalc = require('../../../store/modules/libs/timeago')
// console.log(vueDatetimePicker)




var flatten = __webpack_require__(108);



__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Breadcrumb"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["DatePicker"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["Loading"]);
__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_element_ui__["BreadcrumbItem"]);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "deviceDetails",
  mixins: [__WEBPACK_IMPORTED_MODULE_24__components_utils_helpers_js__["a" /* default */]],
  props: {
    inverterId: {
      type: String,
      default: null
    },
    screenView: {
      type: Object,
      default: "Mad"
    }
  },
  components: {
    InstallationStat: __WEBPACK_IMPORTED_MODULE_13__installationStat__["a" /* default */],
    GreyChart: __WEBPACK_IMPORTED_MODULE_12__components_pages_kitchen_grey_chart__["a" /* default */],
    Battery: __WEBPACK_IMPORTED_MODULE_15__components_pages_kitchen_grey_battery__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_22_vue_datetime__["Datetime"],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_21_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "device-control": __WEBPACK_IMPORTED_MODULE_25__widgets_controls__["a" /* default */],
    "device-charts": __WEBPACK_IMPORTED_MODULE_18__widgets_charts__["default"],
    "system-monitor": __WEBPACK_IMPORTED_MODULE_26__components_pages_dashboard_animated_icons__["a" /* default */]
    // powerStat,
    // flatPickr,
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["DeviceList", "graphDeviceDetails"]), {
    rows: function rows() {
      return this.exportDataToTableValues.length;
    },


    batteryLife: {
      get: function get() {
        try {
          var DOD = 10;
          var totalBatteryCapacity = 5400; //Wh

          var _Device = this.Device,
              BatteryData = _Device.BatteryData,
              InverterData = _Device.InverterData;

          var SOC = parseFloat(BatteryData && BatteryData.SOC);
          var dcop = parseInt(InverterData && InverterData.length > 0 && InverterData[0]["DCOutputPower"]);
          console.log({ dcop: dcop });
          if (dcop) {
            console.log({ SOC: SOC, dcop: dcop });
            // -- Firstly we estimate Battery remaining capacity
            var batteryRemainingCapacity = (SOC - DOD) / 100 * totalBatteryCapacity;
            // console.log({ batteryRemainingCapacity });

            // --- Secondly, we calculate battery hours left
            var batteryHoursLeft = batteryRemainingCapacity / dcop; //w;

            // console.log({ batteryHoursLeft });

            // --- We can then calculate Battery minutes left

            var batteryMinutesLeft = batteryHoursLeft * 60;
            var m = batteryHoursLeft % 1 * 60;

            console.log({
              batteryHoursLeftSplit: batteryHoursLeft % 1,
              batteryHoursLeftFixed: Math.floor(batteryHoursLeft),
              minuites: Math.floor(m)
            });

            // console.log({ batteryMinutesLeft });
            // console.log({ device: this.Device });
            return Math.floor(batteryHoursLeft) + " hours, " + Math.floor(m) + " minutes";
          } else return "";
        } catch (error) {
          console.log("error", error);
        }
      }
    },
    installationType: {
      get: function get() {
        try {
          var _installationData = this.installationData,
              name = _installationData.name,
              deviceType = _installationData.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              return deviceType.name;
            } else {
              return "Arnergy " + (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    installationCapacity: {
      get: function get() {
        try {
          var _installationData2 = this.installationData,
              name = _installationData2.name,
              deviceType = _installationData2.deviceType;

          if (name == "Loading...") {
            return name;
          } else {
            if (name.split("_")[0] == "RNIG") {
              // console.log({ hey: deviceType.name.split(" ")[1].split("-") });
              var configVal = deviceType.name.split(" ")[1].split("-")[0];
              // console.log({ configVal });
              return configVal;
            } else {
              return (this.Device.MiscData ? this.Device.MiscData.InstallSize : "") + " kVA";
            }
          }
        } catch (ExceptionError) {
          console.log({ ExceptionError: ExceptionError });
        }
      }
    },
    warningRows: function warningRows() {
      return this.warningsData.length;
    },

    statusBorder: {
      get: function get() {
        return this.statusCalc(this.Device.Timestamp) == true ? "4px solid #e34a4a;" : "4px solid #1893CA;";
      },
      set: function set(nvalue) {
        this.statusBorderHandle = nvalue;
      }
    }
    // Device: {
    //   get() {
    //     var inverterId = this.inverterId;
    //     return {
    //       parameters: this.DeviceList.devices.find(
    //         x => x.DeviceID == inverterId
    //       ),
    //       mode: this.DeviceList.modes.find(x => x.DeviceID == inverterId),
    //       expiry: this.DeviceList.expiries.find(x => x.DeviceID == inverterId)
    //     };
    //   }
    // }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      activeNames: ["1"],
      loading: true,
      EnergyData: {},
      Device: {
        BatteryData: {}
      },
      singularEnergyData: [],
      MiscData: {},
      inverter: null,
      exportedData: [],
      showOffCanvas: false,
      alarmFlags: {},
      initError: false,
      Dev: null,
      warningDataLoading: false,
      viewDataLoading: false,
      exportDataLoading: false,
      installationData: { name: "Loading..." },
      deviceWarning: {},
      powerState: {},
      chargerPriority: "01",
      showTableOffCanvas: false,
      warningsOffCanvas: false,
      warningsData: [],
      warningsDataValuesFields: [],
      perPage: 10,
      currentPage: 1,
      warningCurrentPage: 1,
      exportDataToTableValues: [],
      exportDataToTableValuesFields: ["payload.InverterDetected", "payload.Version", "payload.DeviceID", "payload.BatteryData.SOC", "payload.Timestamp"],
      warningsDataTableoptions: []
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warningsDataValuesFields", ["DeviceTimeStamp", "InverterId", "InverterOverCurrent", "InverterVoltageTooHigh"]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "exportDataTableoptions", [{
      value: "Option1",
      label: "Option1"
    }, {
      value: "Option2",
      label: "Option2"
    }, {
      value: "Option3",
      label: "Option3"
    }, {
      value: "Option4",
      label: "Option4"
    }, {
      value: "Option5",
      label: "Option5"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "value1", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "filterDate", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last week",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last month",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Last 3 months",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chargerPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "Solar and Utility",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriority", "01"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "outputPriorityList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Utility First",
      value: "00"
    }, {
      text: "Solar First",
      value: "01"
    }, {
      text: "SBU First",
      value: "02"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceMode", "00"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "deviceModeList", [{
      text: "Select Option",
      value: null,
      disabled: true
    }, {
      text: "Inverter Mode",
      value: "00"
    }, {
      text: "UPS Mode",
      value: "01"
    }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "show", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "Device", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "IOTSRC", "http://arnergy-dash-api.herokuapp.com"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryToSend", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_WEEK", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("week").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "THIS_MONTH", __WEBPACK_IMPORTED_MODULE_16_moment___default()().startOf("month").toDate()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "isMale", true), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "statusBorderHandle", "red"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "charttype", "line"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showWarning", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartGenOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "PV Charging Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartConsumpOption", {
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Battery Percentage (%)"
            //labelString: "AC Output Active Power (KW)"
          }
        }]
      }
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "chartdata", {
      labels: ["Please", "wait", ".", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarGenchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "solarConsumpchartdata", {
      labels: ["Please", "wait", ".", ".", "."],
      datasets: [{
        label: "Loading",
        data: [],
        backgroundColor: "rgba(255, 99, 132, 0.3)",
        //backgroundColor: fillPattern,
        borderWidth: 1
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "timeRightNow", __WEBPACK_IMPORTED_MODULE_16_moment___default()()), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "endpointsMap", {
      "on-power": "power",

      "off-power": "power",

      "get-expiry": "requestexpdate",

      "set-expiry": "expirydate",

      "pcp-charger-priority": "charger-priority",

      "pop-output-priority": "output-priority",

      "pgr-device-mode": "device-mode",

      "open-ssh": "ssh",

      "command-shell": "shell",

      "send-command": "command",

      "init-reboot": "reboot",

      "get-settings": "setting",

      "init-reset": "reset",

      "get-batteql": "battequal",

      "on-admin": "admin",

      "off-admin": "admin"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerConfig", {
      enableTime: true,
      dateFormat: "F j, Y",
      // dateFormat: "H-i-S-d-m-Y",
      wrap: true
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "commandSending", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "ipAddress", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "username", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "expiryDate_", null), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentCommand", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "currentParam", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "details", "/device/details"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "HealthData", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "warnings", []), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "battery_meter", {
      background: "green",
      width: "50%"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "flags", {
      errors: {
        InverterFault: "Inverter Fault",
        BusOver: "Bus Overload",
        BusUnder: "Bus Underload",
        BusSoftFail: "Bus Failed",
        InverterVoltageTooLow: "Inverter Voltage Too Low",
        InverterVoltageTooHigh: "Inverter Voltage Too High",
        InverterOverCurrent: "Inverter Overcurrent",
        InverterSoftFail: "Inverter failed (soft)",
        SelfTestFail: "Self test failed",
        OPDCVoltageOpen: "",
        BatteryOpen: "Battery Open",
        CurrentSensorFail: "Current Sensor failed"
      },

      warnings: {
        // LineFail: "Line Failed",
        OPVShort: "Pv Output Short Circuit",
        BatteryUnderShutdown: "Battery Under Shortdown",
        EepromFault: "EEPROM Fault",
        BatteryLowAlarm: "Battery Low",
        PVLoss: "No supply from PV",
        BatteryDerating: "Battery Derating",
        Overload: "System Overload"
      }
    }), _ref;
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["b" /* mapActions */])(["refreshList", "setDeviceCurrentSettings"]), (_extends2 = {
    triggerRemoveDeviceOnPerformanceList: function triggerRemoveDeviceOnPerformanceList() {
      var _this = this;

      var response = confirm("Are you sure you want to continue?");
      if (response) {
        // alert(JSON.stringify("Removing in progress =>") + this.inverterId);

        var headers = {
          "Content-Type": "application/plain"
        };
        var params = {
          TableName: "ConnectedDevices",
          Key: {
            DeviceID: parseInt(this.inverterId)
          }
        };
        __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/delete", params, {
          headers: headers
        }).then(function (resp) {
          alert("Successfully removed");
          _this.$router.go(-1);

          // this.$router.go(-1);
        }).catch(function (err) {
          alert("An error uccured please try agin");
          console.log(err);
        });
      }
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        // console.log({ powerKey }, Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    panelPowerReduceRaw: function panelPowerReduceRaw(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      // console.log({ InverterData });

      var power = InverterData ? InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVChargingPower" + (version == "v4" ? "1" : "");
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0) : "";
      return power;
    },
    getLabel: function getLabel(key) {
      // console.log(key);
      return __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["label"] : key;
    },
    getUnit: function getUnit(displayedData, key) {
      var unit = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      }) ? __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      })["unit"] : key;
      return displayedData.endsWith(unit) == false ? unit : "";
    },
    getDisplayValue: function getDisplayValue(singleInverter, key) {
      var displayedData = singleInverter[key];

      var config = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
        return x.new_key == key || x.old_key == key;
      });
      var unit = config ? config["unit"] : "";
      var dataType = config ? config["datatype"] : "";
      // console.log({ displayedData, dataType ,key});
      // console.log({singleInverter,key,config});
      //  displayedData.endsWith(unit) == false ? unit
      if (dataType == "Boolean") {
        try {
          var tmpDisplayData = Number(displayedData);
          return tmpDisplayData == 0 ? "No" : "Yes";
        } catch (error) {}
      }
      if (dataType == "Switch") {
        try {
          var _tmpDisplayData = Number(displayedData);
          return _tmpDisplayData == 0 ? "Off" : "On";
        } catch (error) {}
      }
      if (displayedData.endsWith(unit) == true) {
        return displayedData;
      }

      if (dataType == "Integer" || dataType == "Float" || dataType == "String") {
        try {
          var _tmpDisplayData2 = Number(displayedData);
          return _tmpDisplayData2 != NaN ? _tmpDisplayData2 + unit : displayedData;
        } catch (error) {}
      }

      // return displayedData.endsWith(unit) == false ? unit : "";
    },
    exportData: function exportData() {
      this.exportDataLoading = true;
      this.filterDate ? this.DataToExport(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExport();
    },
    getDeviceWarningsMapper: function getDeviceWarningsMapper() {
      this.warningDataLoading = true;
      this.filterDate ? this.getDeviceWarningsObject(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceWarningsObject();
    },
    exportDataToTable: function exportDataToTable() {
      this.viewDataLoading = true;
      this.filterDate ? this.DataToExportToTable(this.filterDate[0], this.filterDate[1], 1000) : this.DataToExportToTable();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.getDeviceData(this.filterDate[0], this.filterDate[1], 1000) : this.getDeviceData();
    },
    getDeviceWarningsObject: function getDeviceWarningsObject() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this2 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var app, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                app = _this2;
                inverterId = _this2.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Warnings",
                  KeyConditionExpression: "DeviceID = :key and  DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": inverterId * 1,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this2.warningDataLoading = false;
                  _this2.warningsOffCanvas = true;
                  var _tmp = resp.data.Items.map(function (x) {
                    var data = _this2.transformListData(x.payload.WarningsData);
                    data.DeviceTimeStamp = x.DeviceTimeStamp;
                    return data;
                  });
                  var warningsData = [];
                  _tmp.map(function (v) {
                    return v.map(function (v1) {
                      v1.DeviceTimeStamp = v.DeviceTimeStamp;
                      warningsData.push(v1);
                    });
                  });

                  var transformed = [];
                  var yes = "YES";
                  var no = "NO";
                  warningsData.map(function (v) {
                    var tmp = {};
                    tmp.InverterId = v.InverterId;
                    tmp.DeviceTimeStamp = v.DeviceTimeStamp;
                    tmp.BatteryDerating = v.BatteryDerating === "0" ? no : yes;
                    tmp.BatteryLowAlarm = v.BatteryLowAlarm === "0" ? no : yes;
                    tmp.BatteryOpen = v.BatteryOpen === "0" ? no : yes;
                    tmp.BatteryUnderShutdown = v.BatteryUnderShutdown === "0" ? no : yes;
                    tmp.BatteryVoltageHigh = v.BatteryVoltageHigh === "0" ? no : yes;
                    tmp.BusOver = v.BusOver === "0" ? no : yes;
                    tmp.BusSoftFail = v.BusSoftFail === "0" ? no : yes;
                    tmp.BusUnder = v.BusUnder === "0" ? no : yes;
                    tmp.CurrentSensorFail = v.CurrentSensorFail === "0" ? no : yes;
                    tmp.EepromFault = v.EepromFault === "0" ? no : yes;
                    tmp.FanLocked = v.FanLocked === "0" ? no : yes;
                    tmp.InverterFault = v.InverterFault === "0" ? no : yes;
                    tmp.InverterOverCurrent = v.InverterOverCurrent === "0" ? no : yes;
                    tmp.InverterVoltageTooHigh = v.InverterVoltageTooHigh === "0" ? no : yes;
                    tmp.InverterVoltageTooLow = v.InverterVoltageTooLow === "0" ? no : yes;
                    tmp.IvSfFl = v.IvSfFl === "0" ? no : yes;
                    tmp.LineFail = v.LineFail === "0" ? no : yes;
                    tmp.OPDCVoltageOpen = v.OPDCVoltageOpen === "0" ? no : yes;
                    tmp.OPVShort = v.OPVShort === "0" ? no : yes;
                    tmp.OverTemperature = v.OverTemperature === "0" ? no : yes;
                    tmp.Ovld = v.Ovld === "0" ? no : yes;
                    tmp.Reserved01 = v.Reserved01 === "0" ? no : yes;
                    tmp.Reserved02 = v.Reserved02 === "0" ? no : yes;
                    tmp.Reserved03 = v.Reserved03 === "0" ? no : yes;
                    tmp.Reserved04 = v.Reserved04 === "0" ? no : yes;
                    tmp.SelfTestFail = v.SelfTestFail === "0" ? no : yes;
                    transformed.push(tmp);
                  });
                  _this2.warningsData = transformed;
                  console.log(_this2.warningsData);
                  _this2.warningsDataTableoptions = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(warningsData[0]);
                }).catch(function (err) {
                  console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(err));
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlarm: function showAlarm(type) {
      var _this3 = this;

      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"];
      var resp = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.flags[type]).reduce(function (_tmp, _curr) {
        //console.log(_curr, this.Device.Warnings[_curr]);
        return _tmp += _this3.Device.Warnings[_curr] * 1 > 0 ? "<li>" + _this3.flags[type][_curr] + "</li>" : "";
      }, "");
      if (type == "warnings") {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].warning({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_10_element_ui__["Notification"].error({
          title: "" + type[0].toUpperCase() + type.slice(1),
          dangerouslyUseHTMLString: true,
          message: resp
        });
      }

      // console.log({
      //   deviceWarning: this.deviceWarning,
      //   flags: this.flags.warnings,
      //   resp
      // });
    },
    errorCalc: function errorCalc(Payload) {
      // console.log(Payload);
      // let finReslt = {};
      var excluded = ["id", "deviceID", "InverterId", "Timestamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              //  console.log("Found Warnign", property);
              this.alarmFlags["warning"] = true;
            } else if (this.flags.errors[property]) {
              //  console.log("Found Error", property);
              this.alarmFlags["error"] = true;
            }
          }
        }
      }
      //console.log(this.alarmFlags);
      return;
    },
    datePickerTrigger: function datePickerTrigger() {
      this.show = true;
    },
    formatDate: function formatDate(_date) {
      // return _date;
      return __WEBPACK_IMPORTED_MODULE_16_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    lastSeen: function lastSeen(Time) {
      if (__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.Device.Timestamp).format("MMMM Do YYYY, h:mm:ss a") == "Invalid date") {
        return Time;
      } else return __WEBPACK_IMPORTED_MODULE_16_moment___default()(Time).format("MMMM Do YYYY, h:mm:ss a");
      // return this.Device.parameters.DeviceTimeStamp;
    },
    getError: function getError(key, type) {
      var search = this.flags[type];
      if (this.Device.warnings[key] > 0) {
        return search[key];
      }
    },

    // statusCalc(date) {
    //   return this.statusCalc(this.Device.parameters.DeviceTimeStamp) == true
    //     ? "4px solid #e34a4a;"
    //     : "4px solid #1893CA;";
    // },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()(this.timeRightNow).diff(__WEBPACK_IMPORTED_MODULE_16_moment___default()(date)));
      // console.log(difference / 60000);
      if (difference / 60000 > 90) {
        this.statusBorder = "4px solid #e34a4a";
        return true;
      } else {
        this.statusBorder = "4px solid #1893CA";
        return false;
      }
    },
    statusLabel: function statusLabel(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_16_moment___default()().diff(date));
      if (difference / 60000 > 90) {
        return "Offline";
      } else {
        return "Online";
      }
    },
    batUpdate: function batUpdate(charge) {
      this.battery_meter.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    loadSum: function loadSum() {
      device.payload.InverterData.reduce(function (acc, obj) {
        return acc += Number(obj["OL%"]);
      }, 0);
    },
    countFlags: function countFlags(Warning, type) {
      var excluded = ["id", "deviceID", "InverterId", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      var search = this.flags[type];
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0 && search.hasOwnProperty(property)) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      return totalErr;
    },
    gridCalc: function gridCalc(mode) {
      if (mode == "L" || mode == "E" || mode == "Y") {
        return true;
      } else {
        return false;
      }
    },
    getExtraSourceWhileOnBattery: function getExtraSourceWhileOnBattery(batteryMode, OutputLoadNotPercent, solarPower) {
      // console.log({ batteryMode, OutputLoadNotPercent, solarPower });

      if (batteryMode === "On Battery") {
        if (solarPower > OutputLoadNotPercent) {
          return "On Solar";
        } else if (OutputLoadNotPercent > solarPower && solarPower > 0) {
          return "On Solar & Battery";
        } else return batteryMode;
      } else return batteryMode;
    },
    roundUpHandler: function roundUpHandler(num) {
      return Math.round(num * 100) / 100;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "Battery Mode";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }

      var outputLoad = this.Device.InverterData.reduce(function (acc, obj) {
        // console.log({ obj });

        return acc += Number(obj["ACOutputApparentPower"]);
      }, 0);
      outputLoad = this.roundUpHandler(outputLoad);
      var solarPower = this.panelPowerReduceRaw(this.Device.InverterData);
      resp = this.getExtraSourceWhileOnBattery(resp, outputLoad, solarPower);

      // console.log({ resp, outputLoad, solarPower, mode });

      return resp || "Battery Mode";
    },
    renderChart: function renderChart() {
      this.$refs.solarConsumpchartdata.reload(this.solarConsumpchartdata, this.charttype, this.chartConsumpOption);
      this.$refs.solarGenchartdata.reload(this.solarGenchartdata, this.charttype, this.chartGenOption);
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_16_moment___default()(date).fromNow();
      return difference;
    },
    activePower: function activePower(InverterData) {
      // console.log({ InverterData });
      var InvAggrData = this.Device.InvAggrData;

      if (InvAggrData) {
        return InvAggrData.AACOAP * 1 / 1000;
      }
      var power = InverterData.reduce(function (acc, parameter) {
        var lw = parameter["ACOutputApparentPower"] || parameter["DCOutputPower"];
        return acc + lw * 1;
      }, 0);
      var ac = power / 1000;

      return ac || 0;
    },
    activePercent: function activePercent(InverterData) {
      var InvAggrData = this.Device.InvAggrData;

      if (InvAggrData) {
        return InvAggrData["AOL%"];
      }
      if (this.inverterId == "417790") {
        // alert("eee");
        var load = parseInt(InverterData[0]["ACOutputApparentPower"]) / 1000 * 100;
        if (load <= 100) {
          return load;
        } else {
          return 100;
        }
      }

      console.log({ InverterData: InverterData });

      var power = InverterData.reduce(function (acc, parameter) {
        return acc + parameter["OutputLoadPercent"] * 1;
      }, 0);
      var ap = power / InverterData.length;
      return this.roundUp(ap || 0);
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.PVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(power) {
      return this.roundUp(power) + " kWh";
    },
    showControl: function showControl(type, param) {
      this.currentCommand = type;
      this.currentParam = param;
      this.$refs.controlModal.show();
    },
    hideControl: function hideControl() {
      this.$refs.controlModal.hide();
    },
    control: function control() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      var inverterId = "" + this.inverterId;
      var command = this.currentCommand;
      var param = this.currentParam;
      var key = param + "-" + command;
      // console.log(param+'-'+command+ ' => '+ inverterId )
      var path = this.endpointsMap[key];
      var requestLink = this.$utilConstants.IOT_BASE_URL + "/event/publish/";
      // console.log(endies + path + '/' + inverterId)
      var requestParam = {
        topic: inverterId
      };
      // var requestParam = "";
      switch (path) {
        case "power":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            userPower: param.toUpperCase()
          });
          break;
        case "requestexpdate":
          break;
        case "expirydate":
          // requestParam = this.expiryDate_.replace(/-/gi, "");
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            setExpiry: new Date(this.expiryDate_).toISOString().split(".")[0]
          });
          break;
        case "charger-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.chargerPriority
          });
          break;
        case "output-priority":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.outputPriority
          });
          break;
        case "device-mode":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            command: "" + param.toUpperCase() + this.deviceMode
          });
          break;
        case "ssh":
          requestParam = "ipaddress=" + this.ipAddress + "&username=" + this.username + "&password=" + this.password;
          break;
        case "command":
          requestParam = this.commandSending;
          break;
        case "shell":
          requestParam = this.commandSending;
          break;
        case "reboot":
          break;
        case "setting":
          break;
        case "reset":
          break;
        case "battequal":
          break;
        case "admin":
          requestParam.payload = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({
            adminPower: param.toUpperCase()
          });
          break;
        default:
          break;
      }
      // console.log(JSON.stringify(requestParam));
      var _posts = ["command", "shell", "ssh"];
      // console.log(requestParam);
      HTTP.post(requestLink, requestParam).then(function (response) {
        alert("Sent!!!");
        _this4.hideControl();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    confirmEnergy: function confirmEnergy(data) {
      // console.log(data);
      if (data == undefined) return [];

      return data;
    },
    fetchHealth: function fetchHealth(type) {
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.get(this.IOTSRC + "/health/" + this.inverterId + "/" + type + "?").then(function (response) {
        var respTime = [];
        var Chartdata = response.data;
        var temptime = Chartdata["Time"];
        temptime.forEach(function (element) {
          respTime.push(__WEBPACK_IMPORTED_MODULE_16_moment___default()(element).format("Do MMM hh:mm"));
        });
        container.chartdata = {
          labels: respTime.reverse(),
          datasets: [{
            label: "Battery Voltage",
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            data: Chartdata["BatteryVoltage"].reverse()
          }, {
            label: "PV Charging Power",
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            data: Chartdata["PVChargingPower"].reverse()
          }, {
            label: "Battery Charging Current",
            backgroundColor: "rgba(255, 206, 86, 0.2)",
            data: Chartdata["BatteryChargingCurrent"].reverse()
          }, {
            label: "Battery Capacity",
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            data: Chartdata["BatteryCapacity"].reverse()
          }, {
            label: "Output Load Percent",
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            data: Chartdata["OutputLoadPercent"].reverse()
          }, {
            label: "Grid Voltage",
            backgroundColor: "rgba(255, 153, 0, 0.6)",
            data: Chartdata["GridVoltage"].reverse()
          }, {
            label: "AC Output ActivePower",
            backgroundColor: "rgba(255, 159, 64, 0.2)",
            data: Chartdata["ACOutputActivePower"].reverse()
          }]
        };
        container.charttype = "line";

        container.renderChart();
      }).catch(function (e) {
        //  console.log(e);
      });
    },
    expiryDate: function expiryDate(deviceID) {
      var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

      return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
    },
    findDeviceData: function findDeviceData(dataset, key, value) {
      var res = dataset.filter(function (x) {
        return x[key] == value;
      });
      // console.log(res);
      return res.length > 0 ? res : undefined;
    },
    fetchAllDeviceData: function fetchAllDeviceData() {
      var _this5 = this;

      var container = this;
      var headers = {
        "Content-Type": "application/plain"
      };
      var payLoad = {
        ":key": Number(this.inverterId)
      };
      var data = {
        TableName: "ConnectedDevices",
        FilterExpression: "DeviceID IN (" + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(payLoad).toString() + ")",
        ExpressionAttributeValues: payLoad
        // Limit: limit,
        // ScanIndexForward: false
      };

      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata/scan", data, {
        headers: headers
      }).then(function (resp) {
        if (resp.data["Items"]) {
          var _tmpDevice = resp.data["Items"][0];
          var parsed = _this5.transformDashData(_tmpDevice);
          // this.Device = parsed;
          // this.transformDashData(_tmpDevice);
          //  console.log("++++++++>=", _tmpDevice);
        }
        // setInterval(this.fetchAllDeviceData, 60000);
        // console.log("++++++++>=",  resp.data['Items']);
      }).catch(function (err) {
        //  console.log("=++++++++>", err);
        // setInterval(this.fetchAllDeviceData, 3000);
      });
    },
    graphDetailsCall: function graphDetailsCall(cid) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var FastAPIHTTP;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (cid) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", true);

              case 2:
                FastAPIHTTP = _this6.$httpUtils.FastAPIHTTP;
                _context2.next = 5;
                return FastAPIHTTP.get("/devices/" + cid).then(function (res) {
                  console.log("---> V3 <----");
                  var _tmpDevice = res.data.data.device["Items"][0];
                  var parsed = _this6.transformDashData(_tmpDevice, res.data.data.device);
                  // console.log(res);
                  //  if (res.data.data["Items"]) {
                  //   this.Device = {
                  //     ...this.Device,
                  //     parameters: resp.data["Items"][0]
                  //   };
                  //   console.log("++++++++>=", this.Device);
                  // }
                }).catch(function (err) {
                  console.log(err);
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    groupKwhConversion: function groupKwhConversion(eIn) {
      // console.log({ eIn });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(eIn).map(function (x) {
        if (x != "InverterId") {
          eIn[x] = eIn[x] / 1000;
        }
      });

      return eIn;
      // console.log({ eIn });
    },
    handleSingularEnergyDataTransformation: function handleSingularEnergyDataTransformation(singularEnergyData) {
      var _this7 = this;

      try {
        if (!singularEnergyData) {
          return [];
        }

        var energyData = singularEnergyData.Data;


        var edResp = energyData ? energyData.map(function (e) {
          if (!energyData) return {};
          var et = _this7.transformMapData(e);
          var gkc = _this7.groupKwhConversion(et);

          return gkc;
        }) : [];

        this.singularEnergyData = edResp;
      } catch (error) {}
    },
    transformDashData: function transformDashData(_tmpDevice) {
      var _this8 = this;

      var _completePayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log({ _tmpDevice });
      var payload = _tmpDevice.payload;

      var _ref2 = payload || {},
          MiscData = _ref2.MiscData,
          InverterDetected = _ref2.InverterDetected;

      this.MiscData = MiscData || {};
      // console.log({ MiscData, _completePayload });
      if (InverterDetected && InverterDetected === "NO") {
        this.$router.push({ name: "performance" });
      }
      var EnergyData = _tmpDevice.payload.EnergyData;
      var currentSettings = _completePayload.currentSettings,
          singularEnergyData = _completePayload.EnergyData;

      var currentSettingsAndDeviceId = currentSettings.map(function (x) {
        return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, x, {
          DeviceID: _this8.inverterId
        });
      });
      // console.log({ currentSettingsAndDeviceId });
      this.$store.commit("setDeviceCurrentSettings", this.transformListData(currentSettingsAndDeviceId || []));

      // console.log({
      //   EnergyData:
      //     undefined === EnergyData
      //       ? null === _completePayload
      //         ? {}
      //         : _completePayload.transformedEnergyData
      //       : EnergyData
      // });

      EnergyData = parseFloat(MiscData.FV) >= 1.76 || MiscData.FV == 1.11 || MiscData.FV == 1.0 ? _completePayload.transformedEnergyData : EnergyData;
      // console.log({
      //   testIsEnergyAvaialable: EnergyData[0] ? true : false
      // });

      this.handleSingularEnergyDataTransformation(singularEnergyData);

      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });
      this.EnergyData = this.transformMapData(EnergyData[0] ? EnergyData[0] : EnergyData);
      // console.log({ EnergyData, EnergyMappedData: this.EnergyData });

      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.EnergyData).map(function (x) {
        _this8.EnergyData[x] = _this8.EnergyData[x] / 1000;
        return _this8.EnergyData[x];
      });
      // console.log(_tmpDevice.payload, "PAYLOAD");
      if (_tmpDevice.payload.WarningsData) {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"] || {},
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      } else {
        var tmp_data = {
          InstallType: _tmpDevice.payload.InstallType,
          Timestamp: _tmpDevice.payload.Timestamp,
          Mode: _tmpDevice.payload.ModeData[0]["Mode"],
          InvAggrData: _tmpDevice.payload.InvAggrData,
          InverterData: this.transformListData(_tmpDevice.payload.InverterData),
          ModeData: this.transformListData(_tmpDevice.payload.ModeData),
          // Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
          // WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
          BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
          MiscData: this.transformMapData(_tmpDevice.payload.MiscData),
          EnergyData: this.EnergyData
        };
      }

      // console.log("+++++DEBUG 02 +++>=", tmp_data);
      //this.inverter=_tmpDevice.payload.InverterData;
      this.Device = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, tmp_data);
      this.errorCalc(this.Device.Warnings);
      // console.log("+++++DEBUG +++>=", tmp_data);
      return tmp_data;
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    initFetch: function initFetch() {
      var _this9 = this;

      var deviceId = this.$route.params.deviceId;

      this.graphDetailsCall(parseInt(deviceId));
      this.sleep(60000 * 3).then(function () {
        _this9.initFetch();
      });
      // this.initError = false;
      // var inverterId = this.inverterId * 1;
      // let _tmpDevice = this.DeviceList.devices.find(
      //   x => x.DeviceID == inverterId
      // );

      // if (_tmpDevice) {
      // console.log({_tmpDevice})
      // this.Device = {
      //   Timestamp: _tmpDevice.payload.Timestamp,
      //   Mode: _tmpDevice.payload.ModeData[0]["Mode"],
      //   InverterData: this.transformListData(_tmpDevice.payload.InverterData),
      //   ModeData: this.transformListData(_tmpDevice.payload.ModeData),
      //   Warnings: this.transformListData(_tmpDevice.payload.WarningsData)[0],
      //   WarningsData: this.transformListData(_tmpDevice.payload.WarningsData),
      //   EnergyData: this.transformMapData(_tmpDevice.payload.EnergyData),
      //   BatteryData: this.transformMapData(_tmpDevice.payload.BatteryData),
      //   MiscData: this.transformMapData(_tmpDevice.payload.MiscData)
      // };
      // let parsed = this.transformDashData(_tmpDevice);
      // this.Device = parsed;
      // console.log(parsed);
      // } else {
      // this.initError = true;
      //  console.log(this.initError);
      // }
      // this.fetchAllDeviceData();
    },
    transformMapData: function transformMapData(MapData) {
      // console.log(Object.keys(MapData).reduce((cummData, key) => {
      //   let oldKey = payloadDictionary.find(x => x.new_key == key);
      //   // console.log(oldKey);
      //   if (oldKey) {
      //     cummData[oldKey["old_key"]] = MapData[key];
      //     //   delete cummData[key];
      //   } else {
      //     cummData[key] = MapData[key];
      //   }
      //   // console.log({ cummData, key, oldKey });
      //   return cummData;
      // }, {}));
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(MapData).reduce(function (cummData, key) {
        var oldKey = __WEBPACK_IMPORTED_MODULE_20__payload_dictionary_json___default.a.find(function (x) {
          return x.new_key == key;
        });
        // console.log(oldKey);
        if (oldKey && oldKey["old_key"] != "") {
          cummData[oldKey["old_key"]] = MapData[key];
          //   delete cummData[key];
        } else {
          cummData[key] = MapData[key];
        }
        // console.log({ cummData, key, oldKey });
        return cummData;
      }, {});
    },
    transformListData: function transformListData(ListData) {
      var _this10 = this;

      return ListData.map(function (x) {
        // Object.keys(x).map(key => {
        //   x[payloadDictionary.find(x => x.new_key == key)["old_key"]] = x[key];
        //   delete x[key];
        // });
        return x.length ? _this10.transformListData(x) : _this10.transformMapData(x);
      });
    },
    getDeviceState: function getDeviceState() {
      var container = this;
      var inverterId = this.inverterId;
      // console.log(inverterId)
      // console.log("=========================================")
      __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].get("/devicestate/" + inverterId).then(function (resp) {
        // console.log(resp.data.state.reported.userPower);
        if (resp.data.state.reported.userPower) {
          container.powerState = resp.data.state.reported.userPower;
        }
      }).catch(function (err) {
        //console.log(err)
      });
    },
    transformData: function transformData(data, keys) {
      //console.log("i am devdata",data);
      return data.reduce(function (aggr, c_item) {
        keys.map(function (key) {
          key == "SOC" ? aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["BatteryData"][key]]) : aggr[key] = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr[key]), [c_item["EnergyData"][key] / 1000]);
          //console.log("i am aggr",key,aggr[key]);
        });
        return aggr;
      }, keys.reduce(function (ret, crr) {
        ret[crr] = [];
        return ret;
      }, {}));
    },
    transformChartData: function transformChartData(InverterDataList) {
      var _this11 = this;

      return InverterDataList.reduce(function (aggr, c_item) {
        var tmpCurr = _this11.transformMapData(c_item);
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(tmpCurr).map(function (singleKey) {
          aggr[singleKey] = aggr[singleKey] ? Number(aggr[singleKey]) + Number(tmpCurr[singleKey]) : Number(tmpCurr[singleKey]);
          // aggr[singleKey] =
          //   Number(aggr[singleKey]) + Number(tmpCurr[singleKey]);
        });
        return aggr;
        // console.log(aggr);
      }, {});
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_16_moment___default()(c_item["Timestamp"]).add(1, "hour").format("MMM d YYYY - h:m:s A")]);
        return aggr;
      });
    },
    solarDataChart: function solarDataChart(displayData, labels) {
      var Chartdata = this.transformData(displayData, ["ACOutputActivePower", "SOC", "PVChargingPower"]);
      // console.log({ Chartdata });
      this.solarGenchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          label: "PV Charging Power",
          borderColor: "#109cf1",
          backgroundColor: "rgba(16, 156, 241,0.4)",
          data: Chartdata["PVChargingPower"]
        }]
      };
      this.solarConsumpchartdata = {
        labels: labels,
        datasets: [{
          pointRadius: 0,
          //label: "Output Active Power",
          label: "Battery Percentage",
          borderColor: "#ffb946",
          backgroundColor: "rgba(255, 185, 70,0.3)",
          // backgroundColor: "transparent",
          data: Chartdata["SOC"]
        }]
      };
      this.charttype = "line";
      this.chartGenOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "PV Charging Power (KW)"
            }
          }]
        }
      };
      this.chartConsumpOption = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            scaleLabel: {
              display: true,
              labelString: "Battery Percentage (%)"
              //labelString: "AC Output Active Power (KW)"
            }
          }]
        }
      };
      this.loading = false;
      this.renderChart();
    },
    currentTime: function currentTime() {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this12.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 3:
                response = _context3.sent;

                if (!response) {
                  _context3.next = 11;
                  break;
                }

                if (!response.data.datetime) {
                  _context3.next = 10;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context3.abrupt("return", tmpDate);

              case 10:
                return _context3.abrupt("return", null);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this12);
      }))();
    },
    DataToExportToTable: function DataToExportToTable() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this13 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this13.currentTime();

              case 2:
                _this13.timeRightNow = _context4.sent;
                container = _this13;
                inverterId = _this13.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // return;

                console.log(data);
                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this13.viewDataLoading = false;
                  _this13.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this13.exportDataToTableValues = exportedData;
                  _this13._convertJsonToCsvAndDownload(exportedData);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this13);
      }))();
    },
    _convertJsonToCsvAndDownload: function _convertJsonToCsvAndDownload(arrJson) {
      var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
      var labelsConf = labels || this.$_createCsvLabelsConf(labels);

      // @note: this.$_xxx is obtained from helpers mixin
      var csvLabels = this.$_createCsvLabels(labelsConf, ",");
      var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
      var content = csvLabels + csvData;

      if (csvLabels == "error" || csvData === "error") {
        console.error("Error: An error occured while parsing the data.");
        return;
      }

      var f = this.$_downloadCsv("csv-export", content, "CSV Export Data");
      if (!f) console.error("An error has occured", hasErrorEvent);
    },

    // showModal() {
    //   this.$refs["modal-scrollable"].show();
    // },
    // hideModal() {
    //   this.$refs["modal-scrollable"].hide();
    // },

    // batteryChart(displayData, labels) {
    //   let Chartdata = this.transformData(displayData, [
    //     "BatteryCapacity",
    //     "OutputLoadPercent"
    //   ]);
    //   this.chartdata = {
    //     labels: labels,
    //     datasets: [
    //       {
    //         pointRadius: 0,
    //         label: "Battery Percent",
    //         borderColor: "#109cf1",
    //         backgroundColor: "rgba(16, 156, 241,0.4)",
    //         data: Chartdata["BatteryCapacity"]
    //       },
    //       {
    //         pointRadius: 0,
    //         label: "Load Percent",
    //         borderColor: "#ffb946",
    //         backgroundColor: "rgba(255, 185, 70,0.8)",
    //         data: Chartdata["OutputLoadPercent"]
    //       }
    //     ]
    //   };
    //   this.charttype = "line";
    //   // this.renderChart();
    //   this.$refs.healthchart.reload(this.chartdata, this.charttype);
    // },

    DataToExport: function DataToExport() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this14 = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var container, inverterId, headers, data;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this14.currentTime();

              case 2:
                _this14.timeRightNow = _context5.sent;
                container = _this14;
                inverterId = _this14.inverterId;
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "Parameters",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + inverterId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: limit,
                  ScanIndexForward: false
                };
                // console.log(data);

                __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                }).then(function (resp) {
                  _this14.viewDataLoading = false;
                  _this14.exportDataLoading = false;
                  var exportedData = resp.data.Items.map(function (data) {
                    return flatten(data);
                  });
                  _this14.exportDataToTableValues = exportedData;
                  _this14._convertJsonToCsvAndDownload(exportedData);
                });

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this14);
      }))();
    }
  }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "_convertJsonToCsvAndDownload", function _convertJsonToCsvAndDownload(arrJson) {
    var labels = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_names___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, arrJson[0]));
    var labelsConf = labels || this.$_createCsvLabelsConf(labels);

    // @note: this.$_xxx is obtained from helpers mixin
    var csvLabels = this.$_createCsvLabels(labelsConf, ",");
    var csvData = this.$_createCsvContent(arrJson, labelsConf, ",");
    var content = csvLabels + csvData;

    if (csvLabels == "error" || csvData === "error") {
      console.error("Error: An error occured while parsing the data.");
      return;
    }

    var f = this.$_downloadCsv("csv-export", content, this.installationData.name || "CSV Export Data");
    if (!f) console.error("An error has occured", hasErrorEvent);
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDeviceData", function getDeviceData() {
    var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _this15 = this;

    var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
      var container, inverterId, headers, data;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this15.currentTime();

            case 2:
              _this15.timeRightNow = _context6.sent;
              container = _this15;
              inverterId = _this15.inverterId;
              headers = {
                "Content-Type": "application/plain"
              };
              data = {
                TableName: "Parameters",
                KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                ExpressionAttributeValues: {
                  ":key": "" + inverterId,
                  ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_16_moment___default()("2019/6/20").startOf("day").toDate(),
                  ":down": lowerLimit || new Date().toISOString()
                },
                Limit: limit,
                ScanIndexForward: false
              };
              // console.log(data);

              __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                headers: headers
              }).then(function (resp) {
                //this.exportedData = resp.data.Items;
                // console.log("+++++=",resp.data.Items[0]);
                var DevData = resp.data.Items.map(function (_tmpDevice) {
                  // console.log(_tmpDevice);
                  return {
                    Timestamp: _tmpDevice.DeviceTimeStamp,
                    InverterData: _tmpDevice.payload.InverterData,
                    BatteryData: _tmpDevice.payload.BatteryData,
                    EnergyData: _this15.transformChartData(_tmpDevice.payload.InverterData)
                  };
                });
                _this15.inverter = DevData[0].InverterData;
                // let DevData = this.transformListData(tmpData);
                // console.log(resp.data.Items.map(x => ({ ...x.payload })));
                // console.log({ DevData });
                // this.batteryChart(DevData, this.getTimeLabel(DevData));
                _this15.solarDataChart(DevData, _this15.getTimeLabel(DevData));
                // console.log(resp.data.state.reported.userPower);
                // if (resp.data.state.reported.userPower) {
                //   container.powerState = resp.data.state.reported.userPower;
                // }
              }).catch(function (err) {
                //console.log(err)
              });

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this15);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDeviceWarnings", function getDeviceWarnings() {
    var _this16 = this;

    var app = this;
    var inverterId = this.inverterId;
    var headers = {
      "Content-Type": "application/plain"
    };
    var data = {
      TableName: "Warnings",
      KeyConditionExpression: "DeviceID = :key and  begins_with(DeviceTimeStamp,:sub)",
      ExpressionAttributeValues: {
        ":key": inverterId * 1,
        ":sub": __WEBPACK_IMPORTED_MODULE_16_moment___default()().format("YYYY-MM-DD")
      },
      Limit: 1,
      ScanIndexForward: false
    };
    // console.log(data);
    __WEBPACK_IMPORTED_MODULE_17__store_actions__["a" /* HTTP */].post("/devicedata", data, {
      headers: headers
    }).then(function (resp) {
      var DevData = _this16.transformListData(resp.data.Items);
      console.log({ DevData: DevData });
      // if (DevData[0]) {
      //   app.deviceWarning = DevData[0]["payload"];
      // }
      // console.log(this.getTimeLabel(DevData))
      // this.batteryChart(DevData, this.getTimeLabel(DevData));
      // this.solarDataChart(DevData, this.getTimeLabel(DevData));
      // console.log(resp.data.state.reported.userPower);
      // if (resp.data.state.reported.userPower) {
      //   container.powerState = resp.data.state.reported.userPower;
      // }
    }).catch(function (err) {
      //console.log(err)
    });
  }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_extends2, "getDevice", function getDevice() {
    var inverterId = this.inverterId;
    var context = this;
    var HTTP = this.$httpUtils.instance;
    //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations&filter[where][CID]=" + inverterId;
    HTTP.get(url).then(function (response) {
      if (response.data.length > 0) context.installationData = response.data[0];
      //console.log(response.data);
    }).catch(function (error) {
      return "not assign";
      //console.log("error", error);
    });
  }), _extends2)),
  created: function created() {},
  mounted: function mounted() {
    var _this17 = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              console.log("----------------------------------------");
              _this17.getDevice();
              _this17.getDeviceData();
              try {
                _this17.initFetch();
              } catch (err) {
                console.log({ err: err });
                // window.location.reload();
              }
              // this.initError = false;
              // try {
              // await this.currentTime();
              //   this.refreshList().then(x => {
              //     console.log("=====================");
              //     // console.log(this.DeviceList);
              //     this.initFetch();

              //     this.getDeviceWarnings();
              //   });
              //   //   console.log(data);
              // } catch (error) {
              //   this.initError = true;
              //   console.log("Init Error", error);
              // }
              // this.fetchHealth("today");
              // this.statusBorder = "4px solid #000";
              // setInterval(this.fetchAllDeviceData, 60000);

            case 4:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this17);
    }))();
  }
});

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_geoDistro_vue__ = __webpack_require__(1069);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ceaa7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_geoDistro_vue__ = __webpack_require__(2666);
function injectStyle (ssrContext) {
  __webpack_require__(2620)
  __webpack_require__(2621)
  __webpack_require__(2622)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-192ceaa7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_geoDistro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_192ceaa7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_geoDistro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__ = __webpack_require__(2623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__powerStat__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__darkStyle_json__ = __webpack_require__(2646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__darkStyle_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__darkStyle_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_pages_submodules_performance__ = __webpack_require__(1082);








var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * Returns the Popup class.
 *
 * Unfortunately, the Popup class can only be defined after
 * google.maps.OverlayView is defined, when the Maps API is loaded.
 * This function should be called by initMap.
 */
function createPopupClass() {
  /**
   * A customized popup on the map.
   * @param {!google.maps.LatLng} position
   * @param {!Element} content The bubble div.
   * @constructor
   * @extends {google.maps.OverlayView}
   */
  function Popup(position, content) {
    this.position = position;

    content.classList.add("popup-bubble");

    // This zero-height div is positioned at the bottom of the bubble.
    var bubbleAnchor = document.createElement("div");
    bubbleAnchor.classList.add("popup-bubble-anchor");
    bubbleAnchor.appendChild(content);

    // This zero-height div is positioned at the bottom of the tip.
    this.containerDiv = document.createElement("div");
    this.containerDiv.classList.add("popup-container");
    this.containerDiv.appendChild(bubbleAnchor);

    // Optionally stop clicks, etc., from bubbling up to the map.
    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv);
  }
  // ES5 magic to extend google.maps.OverlayView.
  Popup.prototype = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_create___default()(google.maps.OverlayView.prototype);

  /** Called when the popup is added to the map. */
  Popup.prototype.onAdd = function () {
    this.getPanes().floatPane.appendChild(this.containerDiv);
  };

  /** Called when the popup is removed from the map. */
  Popup.prototype.onRemove = function () {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv);
    }
  };

  /** Called each frame when the popup needs to draw itself. */
  Popup.prototype.draw = function () {
    var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

    // Hide the popup when it is far out of view.
    var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

    if (display === "block") {
      this.containerDiv.style.left = divPosition.x + "px";
      this.containerDiv.style.top = divPosition.y + "px";
    }
    if (this.containerDiv.style.display !== display) {
      this.containerDiv.style.display = display;
    }
  };

  return Popup;
}
/* eslint-disable */
var Weather = __webpack_require__(2626);
Weather.setApiKey("38e055e82a20b42d48ed5131d67eada7");

var ib = null;
var icon = " data:image/png;base64,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";
// "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAtCAYAAABS6WCiAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4wQKCh4fkucy1AAACq5JREFUWMNVmM2PZNdZxn/ve879qOqq7p6Z7ml7xo6HyTh2RGxkhLKwSBasyAbxH4CExJI/gD+AHdlklTUSYsWCBZsgsQCJCESEE8d2bMdjtz2eD09PT3d1V92Pc96XxbldAyUd3epbVec5z/v1PLfFf/xHjii4g2ewDDaCJbBETs4qRR6Mu3ySjngv3+GXdpdf8jrHmznN2SPenj3ihzuf8sPmI96KxxyFc6JkQMAFcDAryzPiP/mRM93PGc5T5OEw57PuGr/pD3l/uMWn4yFf2gEnvmSjLTnUSAjI8ByePsb6joCxrI3X5he8M3/Eu+19/qD5grvhCbtygdhYAMyQj//2z/3Xm0M+WB/wweaAjzc3+Crtc2o79NLgIYIGCIoEBdXyXgWhwy86yFYik3ps6GAcCDZwI3S83p7y/fmXvDv7jHeq+9zWE+TP/uon/g9P36KXOYQIoUJCKJurggqiAiLbv8tyxDb4ZQfmIAFEp5A6DAM+9vjQwdDR0PFyPONPd39F/Prr39KH30V25tNmAUFAKC/LiBlYD7mDPOB7L0NVAyAOuOPi4Lx4iaICzPbwes6YRz4f9/lFd0HcnNyH692U1ISMl5A7JG2QtIa0RnwAMuQBXPD5dbyqEXfcKYfcnhLwgKwfE977KX7tDTj6fXJcQmjJoSWmOz+CdIicfYZcPikJJ5VDYAhe9lOdGDTItL8AiBS2TCnwq6vhZ8e0VeD7736HdZjz82PBRInWXodLJeQ1pMuyuU87+nZnxP0FGZEthkWkrz666hBUaXfnmDofr16hnc+ATCYQ1UsiNFa4hm3RWM5TUdUQKog1UrVQLyE2iAgq4FKKCvFyRgdwvF6Qlm/gEnmwWuArcDdMItFsQNywMMfnL0MzR6oW12qq5hoJFWiEEJAYkBhBCxYi+ES7HH8Cr3ew7/4l7pkgFW6JZIK5EsPn/wK7R9jeq7BUCGEbQXDErbAPimphhziighq4Xk0duYLDp3ceIngEyzhXM0iJEltEAjiIOLgjPiIPfo48v48cvY28/Hslfyro1LcqUg4WBLJumbqDu+NazmKUdiqgjqHo5at/jLR7qBnioIBYj3z4d8h//Rj95teoCkEhTNdYiBPViQpRjJh6oiUiRsAJOKo+RQZUHJ2g40Z2S5e5IZTBLxKQl95BFrfRw++Ug4gQhP/DtGzoKoh1+NP3AS1MCOT2EOISLk9xCZgLQlVaprRhOQVuiCgSWuTtvyg5DIpqEaIQSnhDUDSAmpRJJA7e4+5YTlg2JLZkF+T5h5AdMcPnt7H5gmhcndqRqfFEBdGGUj9ewFUJqmgIhFDCLDEgMuIKxIiZYYCRyNtcgUuRNLWMuxCDOEU8DkWhPCDmE/uMBiHEQBiNIEYIEHZfIsQa1QAhQWzwgzexnLGcyTkhOgMLsPvKNPgHJM5LTkVKgcyqFdiGPI6wWSF9X/JYN2hTEVSIJAKZsLhGlKpEJwhUFRZvkA1yzkV1HHzM+LV76JjwcUTHEfcLogJRhLqNuMzQ1GBVRM5PkHEoTBVCPSeIEcdzgnoJu0N49gFy+gWOkOKS8cZboA2Y45oxM1QNU0fEMZwYFaIa+eQbGC/AS7mLXw2AnjCOBBsJMaChKjouTvCMPvkP5Kt/L79rrhOuvYocHNH3cHE61Yob4iXbDsSgQgyg1QKJc4hX4y8iGkr1xoCGgARFo6BVW1hS2kZUkFDjMVK3wEIwNWYupAwxCcMg+MqxwYiqQhWEsDws81UVVy0uQAQNV22jaFAkTvcQytdKZUsIEANC6YIqCcmdoTdyNtwNCWDZiXUUahdCkKIU6pg4iJX2QREMnXpZPaAuW01VDYTYEJsWbWYMLmgHs6jYpdIPQlpnxmEkDQnTCXSGgG4lu4AqWPErqOs0tXwari909s7bP+DVd+6we/IcZ86/tbtsOkeBRRsIkyM5G4TBHXcnzurATAQDkjsZRRHcJz2X4iBwxa/8kPvkK+DmzX2+1/wPp9/6Aes0Q48jjBRBCLCcB6LWiJf+zRliWyu1Q7Ki+IKTEdyLRBmCSHFBZVROKnIlZ/mcZAOXDmc0GFaiIqXQgkAzjzTaEEhsziFWQanCpJ82aRNGnsyWOrg5qOBeJhXbMBvvP73FJ/InZFPMM0OWLahSGFcqzBcVs2rOqh2JUYUq8EJ8JxCb2JafglsRA3fH3MuoNOd8ENReSJ9MSqRSSrBIINRB2Wkbbu7sEWMQKmUbSjPHpqJxF8xLgaGCCQQRdDJg5oa6lcLyK88mW8OmKkQVYnBiUNoI81lTQKOWWZEdzIQshfeVr7Xpvpsj2dGgVB6JbohZ+d7kB6/cahF7IQYlRqcOTh2hrrkaDo65kMTJk+FSCgO3wj5RpovhiBihEiqgyU6L0SAghgIhZ4IoMVZUw3Nqy9TBqEJDHfcLaFTIYkQpmxf5M1ISxuwkhxEhT8YKMQZTOjc2/UhtA7P+IYs6s1MrdSPE+S5x9yZVekalQh0jbaioKiXGULxOslNk05Mue7qLjs1g9DkWeiBLRQ4Npg0eG6yeQwy4JcYh0fUdFydfcR6cnXnN/qLlmjZUSycEoakqmrqiriuaSoluzjAmVicnnD1/zsVmoB8TY4JkQjYruXYpFS0V/tI7uFZ4zrgZJMOHTGcjqz5zunaejh0H9Lw03+FosWA2b6nnNW2lxOMnFzy7GLl49Ixhs2Z0yCZkdyw72cvagrrhORXAnMCKXLFzhIeKFGb0seEi1Zw8HPi6jRxdJF69PnLnpnBrH+Jvvz5jzEK2GV7VZfOcyWnAJGFeqtrNMHHcDM9FnEkTUxF8cXvqmml+u5PGxHownq2M40fOp18GvnVQEy82HUiE+jomRUuMqT+zY5axPGJ5wPOAp7HYZpsArfyfwsUmOz3Jj7+YXL1l+jFxtk588SQR0zDgmiE4rqGImEbcA65KDjUWZ5jKZKEBrQpjLwqCpRePFS7lqZzpczPwBHkkjWty7omBkSElcnbQiEkgY9vHeZ8ekNwEE8M1TCDlKUwsQU7TQ1RRHzyBZSwNeOpQz4gbuzP43u8cIn//z//pv/jomH/81//Gmx2CRdr9W5wPkYsh0FlNJpaBL8VVuARcAuIZ+nMYBxwrZswzgtMEONyNvHF7h7de2+NnP/snlpzz07/5a+LN6jlv7p3xcrjPs9WAPz7m3t279KacdcJpX7PyPTbxBl19SGquk6sFhKZo6zhC6lEfaFizlBU3wnOO2o47uy139w55ZX7Er+Jjnl52PH78gPjhR7/h4cOHDN2a86cnNOtL7n/6ESEGLGek72nHkZidlppU7ZPmtxj3vk23/yZ68YRr4zF7/g0LzmllIIiRz4XPvlGOP6lYLBY8fXJCX7V8eXxM7LoOd+fNm/schAw3d8k5MwwDXdeRzSFlzAZsPEc2pzSrz5mdv8ftvT9kdfk1++MzlnUkVjVVVVFVLXVd07Yt8/mc5XLJt++9zmxnh73lgnhwcEDTNMzalqObN+m6js1mw3q93q7NZsNms2EYBsZxZBxHzJ2Fr2jvvIY8bzmohZ2dne1aLBYsl8v/txaLBbPZjHjv3j02mw2Xl2vW68stwBVY13X0fb8F7Pue1WrFxWrFg3XHbBnxquXN797lxvXrW3az2Wx7vVpN09I0Nf8L4z4Z/eH0Z84AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDQtMTBUMDk6MzA6MzErMDE6MDA079x1AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTA0LTEwVDA5OjMwOjMxKzAxOjAwRbJkyQAAABp0RVh0ZXhpZjpCaXRzUGVyU2FtcGxlADgsIDgsIDgS7T4nAAAAIXRFWHRleGlmOkRhdGVUaW1lADIwMTk6MDQ6MTAgMDk6Mjk6NTWNkBvnAAAAFXRFWHRleGlmOkltYWdlTGVuZ3RoADExMjXHUk69AAAAE3RFWHRleGlmOkltYWdlV2lkdGgANzM18S/idgAAABl0RVh0ZXhpZjpTb2Z0d2FyZQBHSU1QIDIuMTAuOEmMRE0AAAAASUVORK5CYII=";










// import RichMarker from 'js-rich-marker'


var items = [];
__WEBPACK_IMPORTED_MODULE_7_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_element_ui__["Card"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  searchdata: "",
  components: {
    Performance: __WEBPACK_IMPORTED_MODULE_18__components_pages_submodules_performance__["a" /* default */],
    // Widget,
    powerStat: __WEBPACK_IMPORTED_MODULE_10__powerStat__["a" /* default */],
    // Modal,
    // VuesticSimpleSelect,
    Simplert: __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default.a,
    Battery: __WEBPACK_IMPORTED_MODULE_14__kitchen_grey_battery__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_15_vuex__["c" /* mapGetters */])(["DeviceList", "getUserByDevice", "getUserSession", "getTheme", "getDeviceWarning"])),
  data: function data() {
    return {
      APP_ID: "18bec784",
      APP_KEY: "de70b01f7ec68244432eae21b3696402",
      markerFrequency: {},
      details: "devicePerformance",
      map: null,
      devicesWithWarning: 0,
      devicesWithFault: 0,
      markers: [],
      bounds: [],
      myDevices: [],
      fetchData: [],
      retData: {},
      markerCluster: {},
      mcOptions: {
        styles: [{
          height: 53,
          url: "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m1.png",
          width: 53
        }, {
          height: 56,
          url: "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m2.png",
          width: 56
        }, {
          height: 66,
          url: "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m3.png",
          width: 66
        }, {
          height: 78,
          url: "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m4.png",
          width: 78
        }, {
          height: 90,
          url: "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclusterer/images/m5.png",
          width: 90
        }]
      },
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description: "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: ["Arnergy 300", "Arnergy 1000", "Arnergy 2000", "Arnergy 5000"],
      simpleSelectModel: "",
      timeRightNow: "",
      items: items,
      fields_: [{
        key: "id",
        label: "ID",
        sortable: "true",
        field: "id",
        filterable: true
      }, {
        key: "status",
        label: "STATUS",
        sortable: "true",
        field: "status",
        filterable: true
      }, {
        key: "owner",
        label: "OWN BY",
        sortable: "true",
        field: "owner",
        filterable: true
      }, {
        key: "deviceId",
        label: "DEVICE ID",
        sortable: "true",
        field: "deviceId",
        filterable: true
      }, {
        key: "pvpower",
        label: "PV POWER",
        sortable: "true",
        field: "pvpower",
        filterable: true
      }, {
        key: "devicestatus",
        label: "DEVICE STATUS",
        sortable: "true",
        field: "devicestatus",
        filterable: true
      }, {
        key: "expiry",
        label: "EXPIRY DATE",
        sortable: "true",
        field: "expiry",
        filterable: true
      }, {
        key: "load",
        label: "LORD %",
        sortable: "true",
        field: "load",
        filterable: true
      }, {
        key: "lastseen",
        label: "LAST SEEN",
        sortable: "true",
        field: "lastseen",
        filterable: true
      }],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      flags: {
        faults: {
          InverterFault: "Inverter Fault",
          BusOver: "Bus Overload",
          BusUnder: "Bus Underload",
          BusSoftFail: "Bus Failed",
          InverterVoltageTooLow: "Inverter Voltage Too Low",
          InverterVoltageTooHigh: "Inverter Voltage Too High",
          InverterOverCurrent: "Inverter Overcurrent",
          InverterSoftFail: "Inverter failed (soft)",
          SelfTestFail: "Self test failed",
          OPDCVoltageOpen: "",
          BatteryOpen: "Battery Open",
          CurrentSensorFail: "Current Sensor failed"
        },
        warnings: {
          // LineFail: "Line Failed",
          OPVShort: "Pv Output Short Circuit",
          BatteryUnderShutdown: "Battery Under Shortdown",
          EepromFault: "EEPROM Fault",
          BatteryLowAlarm: "Battery Low",
          PVLoss: "No supply from PV",
          BatteryDerating: "Battery Derating"
        }
      }
    };
  },

  watch: {
    getTheme: function getTheme(newTheme, oldTheme) {
      if (this.map) {
        this.map.setOptions({
          styles: this.getTheme["theme-name"] == "dark-solarbase" ? __WEBPACK_IMPORTED_MODULE_11__darkStyle_json___default.a : {}
        });
      }
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_15_vuex__["b" /* mapActions */])(["fillDeviceList", "refreshList"]), (_extends2 = {
    onClose: function onClose() {},
    errorCalc: function errorCalc(Payload) {
      var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"],
          tempresult = "";
      var totalErr = 0;
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              tempresult = "warning";
            } else if (this.flags.faults[property]) {
              tempresult = "error";
            }
          }
        }
      }
      return tempresult;
    },
    alarms: function alarms(inverterId) {
      var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
      var response = {
        inverter: {
          warning: [],
          faults: []
        },
        pv: {
          warning: [],
          faults: []
        },
        battery: {
          warning: [],
          faults: []
        }
      };
      var Payload = this.getDeviceWarning(inverterId);
      for (var property in Payload) {
        if (Payload.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          // do stuff
          if (Payload[property] > 0) {
            if (this.flags.warnings[property]) {
              if (this.flags.warnings[property].toLowerCase().indexOf("battery") > -1) {
                response.battery.warning = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.battery.warning), [this.flags.warnings[property]]);
              } else if (this.flags.warnings[property].toLowerCase().indexOf("pv") > -1) {
                response.pv.warning = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.pv.warning), [this.flags.warnings[property]]);
              } else {
                response.inverter.warning = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.inverter.warning), [this.flags.warnings[property]]);
              }
            } else if (this.flags.faults[property]) {
              if (this.flags.faults[property].toLowerCase().indexOf("battery") > -1) {
                response.battery.faults = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.battery.faults), [this.flags.faults[property]]);
              } else if (this.flags.faults[property].toLowerCase().indexOf("pv") > -1) {
                response.pv.faults = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.pv.faults), [this.flags.faults[property]]);
              } else {
                response.inverter.faults = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(response.inverter.faults), [this.flags.faults[property]]);
              }
              // return "error";
            }
          }
        }
      }
      // console.log(response);
      return response;
      // this.errorCalc(this.getDeviceWarning(inverterId))
    },
    getFetchData: function getFetchData(inverterId) {
      try {
        return this.fetchData.filter(function (x) {
          return x.solarKitIds == inverterId;
        })[0] || {
          name: "Arnergy Solar",
          userId: "5"
        };
      } catch (error) {
        return {
          name: "Arnergy Solar",
          userId: "5"
        };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt: function filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;else return arr.filter(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).some(function (key) {
          return obj[key].includes(searchKey);
        });
      });
    },
    getPopUp: function getPopUp(deviceData) {
      var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      // console.log(deviceData);
      // console.log(payload);
      var ACOutputApparentPower = payload.ACOutputApparentPower,
          EnergyData = payload.EnergyData;
      var InverterId = deviceData.InverterId,
          TimeStamp = deviceData.TimeStamp,
          OutputLoadPercent = deviceData.OutputLoadPercent,
          id = deviceData.id,
          panelpower = deviceData.panelpower,
          BatteryCapacity = deviceData.BatteryCapacity,
          deviceType = deviceData.deviceType,
          ownerName = deviceData.ownerName,
          ownerId = deviceData.ownerId,
          batteryMode = deviceData.batteryMode,
          expiry = deviceData.expiry,
          lastseen = deviceData.lastseen,
          location = deviceData.location,
          generatedToday = deviceData.generatedToday,
          peakToday = deviceData.peakToday;

      var faultsNwarning = this.alarms(InverterId, "inverter");
      // console.log(location.position.lat,location.position.lng);
      // let url_ = `https://api.weatherunlocked.com/api/current/${location.position.lat},${location.position.lng}?app_id=${this.APP_ID}&app_key=${this.APP_KEY}`;
      var url_ = "https://arnergy.com/weather-api/?loc=" + location.position.lat + "," + location.position.lng;
      // Weather.getCurrent(location.position.lat,location.position.lng, function (current) {
      // console.log(url_);
      // const HTTP = this.$httpUtils.instance;

      return {
        payload: payload,
        deviceData: deviceData,
        faultsNwarning: faultsNwarning,
        weatherData: __WEBPACK_IMPORTED_MODULE_17_axios___default.a.get(url_)
      };
      //   .then(resp => {
      // //   if (resp.data) {
      // //     console.log(resp.data);
      //     return `
      //     <div class="popup-container" href="/device/performance/${InverterId}">
      //      <div class="popup-username">${ownerName}</div>
      //      <div class="popup-body">
      //      <div class="popup-info-section">
      //       <div class="popup-info-section-header">
      //         Inverter
      //       </div>
      //       <div class="popup-info-row">
      //         <strong style="flex: 1">Output:</strong> ${ACOutputApparentPower *
      //           1} kVA
      //       </div>
      //       <div class="popup-info-row">
      //         <strong style="flex: 1">Total Today:</strong> ${
      //           EnergyData
      //             ? Number(EnergyData["ConsumedTodayOffGrid"]) +
      //               Number(EnergyData["ConsumedTodayOnGrid"])
      //             : "-"
      //         } kWh
      //       </div>
      //       <div class="popup-info-row warning-section" style="flex-flow:column">
      //        <h4>Warnings</h4>
      //        <hr>
      //         <strong style="flex: 1; color: #f7cc36;">${
      //           faultsNwarning.inverter.warning &&
      //           faultsNwarning.inverter.warning.length > 0
      //             ? faultsNwarning.inverter.warning.join("<hr>")
      //             : "No warning"
      //         }</strong>
      //       </div>
      //      </div>
      //      <div class="popup-info-section">
      //        <div class="popup-info-section-header">
      //          Battery
      //        </div>
      //         <div class="popup-info-row">
      //            <b style="flex: 1; font-size: 18px;">${BatteryCapacity * 1}%</b>
      //         </div>
      //         <div class="popup-info-row warning-section" style="flex-flow:column">
      //           <h4>Warnings</h4>
      //           <hr>
      //           <strong style="flex: 1; color: #f7cc36;">${
      //             faultsNwarning.battery.warning &&
      //             faultsNwarning.battery.warning.length > 0
      //               ? faultsNwarning.battery.warning.join("<hr>")
      //               : "No warning"
      //           }</strong>
      //         </div>
      //      </div>
      //      <div class="popup-info-section">
      //       <div class="popup-info-section-header">
      //         PV
      //       </div>
      //       <div class="popup-info-row">  <strong style="flex: 1">PV Yield:</strong> ${panelpower} </div>
      //       <div class="popup-info-row">  <strong style="flex: 1">Total Today:</strong> ${
      //         EnergyData ? EnergyData["GeneratedToday"] * 1 : "-"
      //       } kWh </div>
      //       <div class="popup-info-row warning-section" style="flex-flow:column">
      //           <h4>Warnings</h4>
      //           <hr>
      //           <strong style="flex: 1; color: #f7cc36;">${
      //             faultsNwarning.pv.warning &&
      //             faultsNwarning.pv.warning.length > 0
      //               ? faultsNwarning.pv.warning.join("<hr>")
      //               : "No warning"
      //           }</strong>
      //       </div>
      //      </div>
      //     </div>
      //   </div>
      //   `;
      //   });
    },
    getMarker: function getMarker(device) {
      //  console.log(this.errorCalc(this.getDeviceWarning(device)));
      var stat = this.errorCalc(this.getDeviceWarning(device)) ? this.errorCalc(this.getDeviceWarning(device)) : "";
      if (stat == "warning") {
        this.devicesWithWarning++;
        // console.log(device)
      } else if (stat == "error") {
        this.devicesWithFault++;
      }
      // return;
      var tmp_ = document.createElement("div");
      tmp_.setAttribute("class", "custom-marker " + stat);
      tmp_.innerHTML = "  <div class=\"map-device-status " + stat + "\"></div>\n        <img src=\"" + icon + "\" class=\"marker-pin\"/>";
      // `
      // <div class="custom-marker ${stat}">
      //   <div class="map-device-status ${stat}"></div>
      //   <img src="${icon}" class="marker-pin"/>
      // </div>
      // `;
      return tmp_;
    },
    transformDevice: function transformDevice(data) {
      var _this = this;

      var app = this;

      var image = {
        url: icon,
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(0, 32)
      };
      // console.log(this.$route.params);
      // payloadDictionary
      // data = [...data, dummyData];

      var type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(function (x) {
        return x.payload ? true : false;
      }).map(function (val, i) {
        if (val.payload.Version == "v3") {
          var tempData = _this.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
              resp = "Power On";
              break;
            case "S":
              resp = "On Standby";
              break;
            case "L":
              resp = "On Grid";
              break;
            case "B":
              resp = "On Battery";
              break;
            case "F":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
              resp = "Charging";
              break;
            default:
            // code block
          }
          return {
            version: val.payload.Version,
            InverterId: val.payload.BatteryData.BatteryID,
            TimeStamp: val.payload.TimeStamp,
            OutputLoadPercent: _this.roundUp(val.payload.InverterData.reduce(function (acc, obj) {
              return acc += Number(obj["OL%"]);
            }, 0) / val.payload.InverterData.length),
            id: val.payload.DeviceID,
            panelpower: _this.panelPower(0),
            BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
            deviceType: tempData.deviceType ? tempData.deviceType.name : "Arnergy5000",
            ownerName: tempData.name,
            ownerId: tempData.userId,
            address: tempData["locations"],
            batteryMode: resp,
            expiry: val.payload.ExpiryDate,
            lastseen: _this.timeAgo(val.payload.TimeStamp)
          };
        } else {
          var _tempData = _this.getFetchData(val.DeviceID);
          return {
            version: val.payload.version,
            InverterId: val.DeviceID,
            TimeStamp: val.payload.TimeStamp,
            OutputLoadPercent: val.payload.OutputLoadPercent,
            id: _tempData.CID,
            panelpower: _this.panelPower(val.payload.PVChargingPower),
            BatteryCapacity: val.payload.BatteryCapacity,
            deviceType: _tempData.deviceType ? _tempData.deviceType.name : "Arnergy5000",
            ownerName: _tempData.name,
            ownerId: _tempData.userId,
            address: _tempData["locations"],
            batteryMode: _this.batteryMode(val.payload.InverterId),
            expiry: _this.expiryDate(val.payload.InverterId),
            lastseen: _this.timeAgo(val.payload.TimeStamp)
          };
        }
        // }
      }).filter(function (x) {
        return x && type ? _this.statusCalc(x.TimeStamp) == false : true;
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "transformDevice", function transformDevice(data) {
    var _this2 = this;

    // const RichMarker = window.RichMarker;
    var app = this;

    var image = {
      url: icon,
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(0, 32)
    };
    // this.markerCluster = new MarkerClusterer(this.map);
    // this.markerCluster.setOptions(this.mcOptions);
    return data.filter(function (x) {
      return x.payload;
    }).filter(function (val, i) {
      var tempData = _this2.getFetchData(val.DeviceID);
      //  console.log("Transform Val", val);
      var deviceAddress = void 0;
      var deviceAddress_ = tempData;

      var processedData = {};
      // console.log(i,deviceAddress_['locations']);
      if (deviceAddress_["locations"]) {
        deviceAddress = deviceAddress_["locations"];

        if (val.payload.Version == "v3") {
          var _processedData;

          var _tempData2 = _this2.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
              resp = "Power On";
              break;
            case "S":
              resp = "On Standby";
              break;
            case "L":
              resp = "On Grid";
              break;
            case "B":
              resp = "On Battery";
              break;
            case "F":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
              resp = "Charging";
              break;
            default:
            // code block
          }

          processedData = (_processedData = {
            version: val.payload.Version,
            InverterId: val.payload.BatteryData.BatteryID
          }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "InverterId", val.payload.InverterId), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "TimeStamp", val.payload.TimeStamp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "OutputLoadPercent", _this2.roundUp(val.payload.InverterData.reduce(function (acc, obj) {
            return acc += Number(obj["OL%"]);
          }, 0) / val.payload.InverterData.length)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "id", val.payload.DeviceID), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "panelpower", _this2.panelPower(0)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "BatteryCapacity", val.payload.BatteryData.SOC.replace("%", "")), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "deviceType", _tempData2.deviceType ? _tempData2.deviceType.name : "Arnergy5000"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "ownerName", _tempData2.name), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "ownerId", _tempData2.userId), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "address", _tempData2["locations"]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "batteryMode", resp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "expiry", val.payload.ExpiryDate), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "lastseen", _this2.timeAgo(val.payload.TimeStamp)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "location", deviceAddress), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "generatedToday", val.payload["EnergyData"] ? val.payload["EnergyData"]["GeneratedToday"] : "-"), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_processedData, "peakToday", val.payload["EnergyData"] ? val.payload["EnergyData"]["PeakToday"] : "-"), _processedData);
        } else {
          processedData = {
            version: val.payload.version,
            InverterId: val.DeviceID,
            TimeStamp: val.payload.TimeStamp,
            OutputLoadPercent: val.payload.OutputLoadPercent,
            id: tempData.CID,
            panelpower: _this2.panelPower(val.payload.PVChargingPower),
            BatteryCapacity: val.payload.BatteryCapacity,
            deviceType: tempData.deviceType ? tempData.deviceType.name : "Arnergy5000",
            ownerName: tempData.name,
            ownerId: tempData.userId,
            address: tempData["locations"],
            batteryMode: _this2.batteryMode(val.payload.InverterId),
            expiry: _this2.expiryDate(val.payload.InverterId),
            lastseen: _this2.timeAgo(val.payload.TimeStamp),
            location: deviceAddress,
            generatedToday: val.payload["EnergyData"] ? val.payload["EnergyData"]["GeneratedToday"] : "-",
            peakToday: val.payload["EnergyData"] ? val.payload["EnergyData"]["PeakToday"] : "-"
          };
        }

        var locationKey = "" + deviceAddress.position.lat + deviceAddress.position.lng;
        // this.markerFrequency[locationKey] = isNaN(this.markerFrequency[locationKey]) ? [processedData] : [...this.markerFrequency[locationKey],processedData ]
        //  console.log( this.markerFrequency[locationKey]);
        // console.log("+++++++++++++++++++++++++++++=");

        var position = new google.maps.LatLng(deviceAddress.position.lat, deviceAddress.position.lng);

        var marker = new google.maps.Marker({
          position: position,
          icon: image,
          map: _this2.map,
          label: ""
        });
        // console.log({RichMarker})
        // let marker = new RichMarker({
        //   position,
        //   map: this.map,
        //   content: this.getMarker(processedData.InverterId),
        //   anchor: 5
        // });
        // let Popup =   createPopupClass();
        // let marker = new Popup(
        //   position,
        //   this.getMarker(processedData.InverterId)
        // );
        // marker.setMap(this.map);

        // console.log(app.getPopUp(processedData, val.payload));
        google.maps.event.addListener(marker, "click", function (e) {
          var _this3 = this;

          var popUpData = app.getPopUp(processedData, val.payload);

          var _popUpData$payload = popUpData.payload,
              ACOutputApparentPower = _popUpData$payload.ACOutputApparentPower,
              EnergyData = _popUpData$payload.EnergyData;
          var _popUpData$deviceData = popUpData.deviceData,
              InverterId = _popUpData$deviceData.InverterId,
              TimeStamp = _popUpData$deviceData.TimeStamp,
              OutputLoadPercent = _popUpData$deviceData.OutputLoadPercent,
              id = _popUpData$deviceData.id,
              panelpower = _popUpData$deviceData.panelpower,
              BatteryCapacity = _popUpData$deviceData.BatteryCapacity,
              deviceType = _popUpData$deviceData.deviceType,
              ownerName = _popUpData$deviceData.ownerName,
              ownerId = _popUpData$deviceData.ownerId,
              batteryMode = _popUpData$deviceData.batteryMode,
              expiry = _popUpData$deviceData.expiry,
              lastseen = _popUpData$deviceData.lastseen,
              location = _popUpData$deviceData.location,
              generatedToday = _popUpData$deviceData.generatedToday,
              peakToday = _popUpData$deviceData.peakToday;

          var faultsNwarning = popUpData.faultsNwarning;

          popUpData.weatherData.then(function (_resp) {
            var weatherPayload = _resp.data;
            var popUp = "\n                <div class=\"popup-container\">\n                  <div class=\"popup-username\">\n                    " + ownerName + "\n                    <div><a class=\"btn btn-info\" href=\"/device/performance/" + InverterId + "/" + (processedData.version ? processedData.version : "v2") + "\">See Details</a></div>\n\n                  </div>\n                  <main>\n                    <input id=\"inverter_section\" type=\"radio\" name=\"tabs\" checked>\n                    <label for=\"inverter_section\">Inverter</label>\n\n                    <input id=\"battery_section\" type=\"radio\" name=\"tabs\">\n                    <label for=\"battery_section\">Battery</label>\n\n                    <input id=\"pv_section\" type=\"radio\" name=\"tabs\">\n                    <label for=\"pv_section\">PV</label>\n\n                    <section id=\"inverter_content\">\n                      <div class=\"panel text-center\" style: \"color: #AEAEAE;\">\n                        <div class=\"popup-info-section\">\n\n                          <div class=\"popup-info-row\" style=\"color: #AEAEAE;\">\n                            <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Output:</strong> " + Number(ACOutputApparentPower) / 1000 + " kVA\n                          </div>\n                          <div class=\"popup-info-row\" style=\"color: #AEAEAE;\">\n                            <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Total Today:</strong> " + (EnergyData ? Number(EnergyData["ConsumedTodayOffGrid"]) + Number(EnergyData["ConsumedTodayOnGrid"]) : "-") + " kWh\n                          </div>\n                          <div class=\"popup-info-row warning-section\" style=\"color: #AEAEAE;\">\n                            <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Warnings:</strong> " + (faultsNwarning.inverter.warning && faultsNwarning.inverter.warning.length > 0 ? faultsNwarning.inverter.warning : "No warning") + "\n\n                          </div>\n                        </div>\n                      </div>\n                    </section>\n\n                    <section id=\"battery_content\">\n                      <div class=\"panel text-center\">\n                        <div class=\"popup-info-section\">\n\n                          <div class=\"popup-info-row\" style=\"color: #AEAEAE;\">\n                            <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Battery percentage:</strong> " + BatteryCapacity * 1 + "%\n\n                          </div>\n                          <div class=\"popup-info-row warning-section\" style=\"color: #AEAEAE;\">\n                            <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Warnings:</strong> " + (faultsNwarning.inverter.warning && faultsNwarning.inverter.warning.length > 0 ? faultsNwarning.inverter.warning : "No warning") + "\n\n                          </div>\n                        </div>\n                      </div>\n\n                    </section>\n\n                    <section id=\"pv_content\">\n                        <div class=\"panel text-center\">\n                          <div class=\"popup-info-section\">\n\n                            <img width='60' src=\"http://www.weatherunlocked.com/Images/icons/2/" + weatherPayload["wx_icon"].replace(".gif", ".png") + "\">\n                            <h6>" + weatherPayload["wx_desc"] + "</h6>\n                            <div class=\"popup-info-row\" style=\"color: #AEAEAE;\">  <strong style=\"flex: 1; text-align: left;\">PV Yield:</strong> " + panelpower + " </div>\n                            <div class=\"popup-info-row\" style=\"color: #AEAEAE;\">  <strong style=\"flex: 1; text-align: left;\">Total Today:</strong> " + (EnergyData ? EnergyData["GeneratedToday"] * 1 : "-") + " kWh\n                            </div>\n                            <div class=\"popup-info-row warning-section\" style=\"color: #AEAEAE;\">\n                              <strong style=\"flex: 1; text-align: left; color: #AEAEAE;\">Warnings:</strong> " + (faultsNwarning.inverter.warning && faultsNwarning.inverter.warning.length > 0 ? faultsNwarning.inverter.warning : "No warning") + "\n\n                            </div>\n                          </div>\n                        </div>\n                    </section>\n\n                  </main>\n                </div>\n              ";
            // console.log(_resp.data);
            var myOptions = {
              content: popUp,
              maxWidth: 600
            };
            if (ib) {
              ib.close();
            }
            ib = new google.maps.InfoWindow(myOptions);
            ib.open(_this3.map, marker);
          });
          // console.log(popUp);
        });
        _this2.markers.push(marker);
        // this.markerCluster.addMarker(marker);
        _this2.map.fitBounds(_this2.bounds.extend(position));

        return processedData;
      }
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "getDevice", function getDevice() {
    var _this4 = this;

    var context = this;
    var HTTP = this.$httpUtils.instance;
    // &filter[include]=deviceRequest
    //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;
    var url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations";
    HTTP.get(url).then(function (response) {
      // console.log(response);
      context.fetchData = response.data;
      context.myDevices = _this4.transformDevice(context.DeviceList.devices);
      console.log(context.myDevices);
    }).catch(function (error) {
      // return "not assign";
      console.log("error", error);
    });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "onFiltered", function onFiltered(filteredItems) {
    // Trigger pagination to update the number of buttons/pages due to filtering
    this.totalRows = filteredItems.length;
    this.currentPage = 1;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "submitAddForm", function submitAddForm() {
    // console.log(JSON.stringify(this.formDevice));
    var dataParam = this.formDevice;
    if (dataParam.DeviceID === null || dataParam.device_type.name === null || dataParam.location.address === null || dataParam.customer.name === null || dataParam.customer.phone === null || dataParam.DeviceID === "" || dataParam.device_type.name === "" || dataParam.location.address === "" || dataParam.customer.name === "" || dataParam.customer.phone === "") {
      var obj = {
        title: "Please fill all fields!!!",
        message: "",
        type: "error",
        onClose: this.onClose
      };
      this.$refs.simplert.openSimplert(obj);
      // alert('Please fill all fields!!!')
    } else {
      var me = this;
      var _HTTP = this.$httpUtils.instance;
      _HTTP.post("/devices", me.formDevice).then(function (response) {
        me.fetchDevices();
        var obj = {
          title: "Device Created!!!",
          message: "",
          type: "info",
          onClose: me.onClose
        };
        me.$refs.simplert.openSimplert(obj);
      }).catch(function (error) {
        // console.log(error);
        var obj = {
          title: "Error, Try again!!!",
          message: "",
          type: "error",
          onClose: me.onClose
        };
        me.$refs.simplert.openSimplert(obj);
      });
      me.hideControl();
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "showFormPop", function showFormPop() {
    this.$refs.formModal.open();
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "hideControl", function hideControl() {
    this.$refs.formModal.cancel();
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "formatDate", function formatDate(_date) {
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "navTo", function navTo(device) {
    this.$router.push({
      name: "devicePerformance",
      params: {
        deviceId: device
      }
    });
    // console.log(this.details,device)
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "roundUp", function roundUp(num) {
    return Math.round(num * 100) / 100;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "Parse_Json", function Parse_Json(data) {
    return JSON.parse(data);
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "countErrors", function countErrors(Warning) {
    var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
    var totalErr = 0;
    for (var property in Warning) {
      if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
        // do stuff
        if (Warning[property] > 0) {
          totalErr++;
          // console.log(property);
        }
      }
    }
    return totalErr;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "findDeviceData", function findDeviceData(dataset, key, value) {
    var res = dataset.filter(function (x) {
      return x[key] == value;
    });
    return res.length > 0 ? res : undefined;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "batteryMode", function batteryMode(deviceID) {
    // console.log(this.DeviceList.modes);
    // this.DeviceList.modes
    var deviceMode = this.findDeviceData(this.DeviceList.modes, "DeviceID", deviceID);
    // console.log(deviceID);
    // console.log(deviceMode);
    var mode = deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
    var resp = "--";
    switch (mode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "B":
        resp = "On Battery";
        break;
      case "F":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
      // code block
    }
    return resp;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "expiryDate", function expiryDate(deviceID) {
    var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);
    return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "timeAgo", function timeAgo(date) {
    // var difference = date.add(1, "hours").fromNow();
    var difference = Math.abs(this.timeRightNow.diff(date));
    return Object(__WEBPACK_IMPORTED_MODULE_12__main__["timeAgoUtil"])(difference);
    // console.log(moment(date, "Africa/Lagos").fromNow());
    // if (difference / 60000 > 90) {
    //   return true;
    // } else {
    //   return false;
    // }
    // console.log(difference);
    // return moment(date)
    //   .add(1, "hours")
    //   .format()
    //   .toString();
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "statusCalc", function statusCalc(date) {
    var difference = Math.abs(this.timeRightNow.diff(date));
    if (difference / 60000 > 90) {
      return true;
    } else {
      return false;
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "statusLabel", function statusLabel(date) {
    var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_13_moment___default()().diff(date));
    if (difference / 60000 > 90) {
      return "Offline";
    } else {
      return "Online";
    }
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "panelPower", function panelPower(PVChargingPower) {
    // console.log(parameters);
    var power = this.roundUp(PVChargingPower * 1 / 1000);
    return power + " kW";
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "powerToday", function powerToday(power) {
    return this.roundUp(power) + " kWh";
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "fetchDevices", function fetchDevices() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var me;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              me = _this5;

              me.currentTime();
              _context.next = 4;
              return _this5.refreshList();

            case 4:
              _this5.initGeoMap();
              _this5.getDevice();
              // console.log("done");

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "currentTime", function currentTime() {
    // const me = this;
    // const HTTP = this.$httpUtils.instance;
    // HTTP.get(
    //   "https://script.googleusercontent.com/macros/echo?user_content_key=jiQkpjCE87w3Xo4LsqBwRfiPEaPSIXE_pXTgHsLnv1pKswXN8vzhjCDJEuvAakW_3vjYv917_238sPUo9O_CChOMOPPv7GRMm5_BxDlH2jW0nuo2oDemN9CCS2h10ox_1xSncGQajx_ryfhECjZEnJ9GRkcRevgjTvo8Dc32iw_BLJPcPfRdVKhJT5HNzQuXEeN3QFwl2n0M6ZmO-h7C6bwVq0tbM60-xIkq8d3Ts1nwr1bpxPH2HA&lib=MwxUjRcLr2qLlnVOLh12wSNkqcO1Ikdrk",
    //   {
    //     headers: {
    //       crossdomain: true
    //     },
    //     params: {
    //     }
    //   }
    // )
    //   .then(function(response) {
    //     console.log(JSON.stringify(response.data.fulldate));
    //     me.timeRightNow = moment(response.data.fulldate);
    //   })
    //   .catch(function(error) {
    //     console.log(error);
    //   });
    this.timeRightNow = __WEBPACK_IMPORTED_MODULE_13_moment___default()();
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "initGeoMap", function initGeoMap() {
    this.bounds = new google.maps.LatLngBounds();
    var element = document.getElementById("geoDistroMap");
    var mapCentre = {
      latitude: 9.0064697,
      longitude: 4.1765048
    };
    var options = {
      center: new google.maps.LatLng(mapCentre.latitude, mapCentre.longitude),
      zoom: 8,
      scrollwheel: false,
      styles: this.getTheme["theme-name"] == "dark-solarbase" ? __WEBPACK_IMPORTED_MODULE_11__darkStyle_json___default.a : {}
    };
    this.map = new google.maps.Map(element, options);
    // this.markerCoordinates.forEach(coord => {
    //   const position = new google.maps.LatLng(coord.latitude, coord.longitude);
    //   const marker = new google.maps.Marker({
    //     position,
    //     map: this.map
    //   });
    //   this.markers.push(marker);
    //   this.map.fitBounds(this.bounds.extend(position));
    // });
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_extends2, "fetchWeather", function fetchWeather(address) {
    // const HTTP = this.$httpUtils.instance;
    // // lat={lat}&lon={lon}
    // HTTP.get('https://api.openweathermap.org/data/2.5/weather?q=Lagos').then(resp=>{
    //   console.log(resp)
    // });
  }), _extends2)),
  created: function created() {},
  mounted: function mounted() {
    // console.log("Geo Here");
    this.timeRightNow = __WEBPACK_IMPORTED_MODULE_13_moment___default()();
    // this.fetchWeather();
    this.fetchDevices();
    // setInterval(this.fetchDevices, 60000);
    // google.maps.event.addDomListener(window, 'load', this.initGeoMap);
    // setTimeout(() => {
    //   this.initGeoMap();
    // }, 500);
  }
});

/***/ }),
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import ProgressBar from "../../vuestic-components/vuestic-progress-bar/VuesticProgressBar";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "power-stat-widget",
  props: ["Device"],
  data: function data() {
    return {
      battery_meter: {
        background: "green",
        width: "50%"
      }
    };
  },
  components: {
    // ProgressBar
  },
  methods: {
    batUpdate: function batUpdate(charge) {
      // var batt_metter =
      this.$refs.battery_level.style.width = charge + "%";
      var bg;
      if (charge < 20) {
        // Red - Danger!
        // col = ['#750900', '#c6462b', '#b74424', '#df0a00', '#590700']
        bg = "linear-gradient(45deg, rgba(255,0,0,1) 0%, rgba(128,0,0,1) 2%, rgba(252,0,0,1) 98%, rgba(255,0,0,1) 100%)";
      } else if (charge < 40) {
        // Yellow - Might wanna charge soon...
        // col = ['#754f00', '#f2bb00', '#dbb300', '#df8f00', '#593c00']
        bg = "linear-gradient(45deg, #754f00 0%, #f2bb00 2%, #dbb300 98%, #df8f00 100%)";
      } else {
        // Green - All good!
        // col = ['#316d08', '#60b939', '#51aa31', '#64ce11', '#255405']
        bg = "linear-gradient(45deg, #316d08 0%, #60b939 2%, #51aa31 98%, #64ce11 100%)";
      }
      this.battery_meter.background = bg;
      this.$refs.battery_level.style.background = bg;
    },
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    Parse_Json: function Parse_Json(data) {
      return JSON.parse(data);
    },
    countErrors: function countErrors(Warning) {
      var excluded = ["id", "DeviceID", "DeviceTimeStamp", "createdAt", "updatedAt"];
      var totalErr = 0;
      for (var property in Warning) {
        if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
          if (Warning[property] > 0) {
            totalErr++;
          }
        }
      }
      var msg_ = " Error";
      if (totalErr > 1) {
        msg_ = " Errors";
      }
      return totalErr + msg_;
    },
    batteryMode: function batteryMode(mode) {
      var resp = "--";
      switch (mode) {
        case "P":
          resp = "Power On";
          break;
        case "S":
          resp = "On Standby";
          break;
        case "L":
          resp = "On Grid";
          break;
        case "B":
          resp = "On Battery";
          break;
        case "F":
          resp = "Fault";
          break;
        case "H":
          resp = "Power saving mode";
          break;
        case "C":
          resp = "Charging";
          break;
        default:
      }
      return resp;
    },
    timeAgo: function timeAgo(date) {
      var difference = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).fromNow();
      return difference;
    },
    panelPower: function panelPower(parameters) {
      var power = this.roundUp(parameters.pVInputCurrent * 1 * (parameters.pVInputVoltage * 1) / 1000);
      return power + " kW";
    },
    activePower: function activePower(parameters) {
      var power = this.roundUp(parameters.aCOutputActivePower * 1 / 1000);
      return power + " kW";
    },
    powerToday: function powerToday(powr) {
      return this.roundUp(powr) + " kWh";
    }
  },
  mounted: function mounted() {
    // this.batUpdate(this.Device.parameters.batteryCapacity * 1)
    this.batUpdate(this.Device.parameters.batteryCapacity * 1);
  },
  updated: function updated() {
    // console.log('++++++++++++++++++++++++++++++++++++++++++')
    // console.log(this.Device.parameters.batteryCapacity)
    // this.batUpdate(this.Device.parameters.batteryCapacity * 1)
  }
});

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_performance_vue__ = __webpack_require__(1083);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b768d11_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_performance_vue__ = __webpack_require__(2665);
function injectStyle (ssrContext) {
  __webpack_require__(2647)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b768d11"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_performance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b768d11_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_performance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__performance__ = __webpack_require__(2648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__performance_geoDistro__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuikit__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["Tabs"]);
__WEBPACK_IMPORTED_MODULE_6_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui__["TabPane"]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Performance",
  components: {
    IotPerformance: __WEBPACK_IMPORTED_MODULE_1__performance__["a" /* default */],
    GeoDistro: __WEBPACK_IMPORTED_MODULE_2__performance_geoDistro__["a" /* default */],
    "vk-iconnav": __WEBPACK_IMPORTED_MODULE_4_vuikit__["b" /* Iconnav */],
    "vk-iconnav-item": __WEBPACK_IMPORTED_MODULE_4_vuikit__["c" /* IconnavItem */]
  },
  data: function data() {
    return {
      switchOption: true,
      activeTab: "performance",
      value: "Live"
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["DeviceList", "getUserByDevice", "getUserSession"])),
  methods: {},
  mounted: function mounted() {
    // if (!this.$can("read", "installation")) {
    //   this.$router.push({
    //     path: "/",
    //   });
    //   return;
    // }
  }
});

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__powerStat__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__main__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__payload_dictionary_json__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__payload_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__payload_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dummy_json__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__dummy_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__dummy_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__widgets_offlineDevices__ = __webpack_require__(2650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__widgets_alarmDevices__ = __webpack_require__(2655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__widgets_onLineDevices__ = __webpack_require__(2658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__widgets_allDevices__ = __webpack_require__(2661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuikit__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_element_ui__);










var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import Widget from "../../vuestic-components/vuestic-widget/VuesticWidget";
// import Modal from "../../vuestic-components/vuestic-modal/VuesticModal";
// import InstallationStat from "./installationStat";
// import VuesticSimpleSelect from "../../vuestic-components/vuestic-simple-select/VuesticSimpleSelect";

















__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_element_ui__["Badge"]);
var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  searchdata: "",
  components: {
    // Widget,
    powerStat: __WEBPACK_IMPORTED_MODULE_11__powerStat__["a" /* default */],
    OfflineDevices: __WEBPACK_IMPORTED_MODULE_19__widgets_offlineDevices__["a" /* default */],
    AlarmDevices: __WEBPACK_IMPORTED_MODULE_20__widgets_alarmDevices__["a" /* default */],
    OnLineDevices: __WEBPACK_IMPORTED_MODULE_21__widgets_onLineDevices__["a" /* default */],
    AllDevices: __WEBPACK_IMPORTED_MODULE_22__widgets_allDevices__["a" /* default */],
    // Modal,
    // VuesticSimpleSelect,
    Simplert: __WEBPACK_IMPORTED_MODULE_10_vue2_simplert___default.a,
    Battery: __WEBPACK_IMPORTED_MODULE_16__kitchen_grey_battery__["a" /* default */],
    "vk-iconnav": __WEBPACK_IMPORTED_MODULE_23_vuikit__["b" /* Iconnav */],
    "vk-icon": __WEBPACK_IMPORTED_MODULE_23_vuikit__["a" /* Icon */],
    "vk-iconnav-item": __WEBPACK_IMPORTED_MODULE_23_vuikit__["c" /* IconnavItem */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["c" /* mapGetters */])(["DeviceList", "getUserByDevice", "getUserSession", "graphDeviceDetails", "offLineDeviceList", "onLineDevices", "uniqueFV", "uniqueSectors", "uniquePaymentModel", "filteredAllDevices", "getAssignedDevices", "filteredOnlineDevices", "filteredOffLineDevices", "filteredAlarmDevices", "getPerformanceFilter", "getGlobalTableOptions"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    loadingState: {
      get: function get() {
        return this.loadingState;
      }
    },
    criticalSystems: {
      //
      get: function get() {
        var filteredIssues = this.filterIssues();
        console.log("issues", filteredIssues);
        if (filteredIssues) {
          this.setCriticalSystems(filteredIssues);
          // console.log("SHould Log");
          return filteredIssues;
        } else {
          return [];
        }
      }
      // set(newValue, oldValue){

      // }

    }
  }),
  data: function data() {
    return {
      totalDevicesShowing: "",
      paginatedInfo: {},
      showSearch: true,
      value: "live",
      searchTerm: "",
      details: "devicePerformance",
      myDevices: [],
      fetchData: [],
      retData: {},
      showCritical: false,
      loadingState: true,
      showOffOnlinelineDevices: null,
      showAllDevices: false,
      showOnlineOfline: true,
      showOnlineButton: true,
      showFilters: true,
      filterFirmWarVersion: "",
      filterSectorVal: "",
      filterPaymentModel: "",
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description: "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: ["Arnergy 300", "Arnergy 1000", "Arnergy 2000", "Arnergy 5000"],
      simpleSelectModel: "",
      timeRightNow: __WEBPACK_IMPORTED_MODULE_13_moment___default()(),
      items: items,
      criticalColumns: [{
        key: "ownerName",
        label: "OWNED BY",
        sortable: true,
        field: "ownerName",
        filterable: true
      }, {
        key: "deviceType",
        label: "DEVICE TYPE",
        sortable: "true",
        field: "InstallType",
        filterable: true
      }, {
        key: "version",
        label: "VERSION",
        sortable: "true",
        field: "Version",
        filterable: true
      }, {
        key: "InverterId",
        label: "DEVICE ID",
        sortable: "true",
        field: "DeviceID",
        filterable: true
      }, {
        key: "Timestamp",
        label: "LAST SEEN",
        sortable: "true",
        field: "Timestamp",
        filterable: true
      }],
      fields_: [{
        key: "status",
        label: "STATUS",
        field: "status"
      }, {
        key: "ownerName",
        label: "OWNED BY",
        sortable: "true",
        field: "ownerName",
        type: "text",
        filterable: true
      }, {
        key: "InverterId",
        label: "Device ID",
        sortable: "true",
        field: "InverterId",
        type: "text",
        filterable: true
      },
      // {
      //   key: "installedPV",
      //   label: "INSTALLED PV",
      //   sortable: false,
      //   field: "installedPV",
      //   filterable: true,
      //   hidden:
      //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
      // },
      {
        key: "installedCapacity",
        label: "INSTALLED PV / CAPACITY",
        sortable: false,
        field: "installedCapacity",
        filterable: true,
        sortFn: this.numSort,
        firstSortType: "desc"
        // formatFn: this.formatCap,
      },
      // {
      //   key: "FV",
      //   label: "FIRMWARE VERSION",
      //   sortable: "true",
      //   field: "FV",
      //   filterable: true,
      // },
      {
        key: "version",
        label: "VERSION / FIRMWARE VERSION",
        sortable: "true",
        field: "version",
        filterable: true
      },
      // {
      //   key: "InverterId",
      //   label: "DEVICE ID",
      //   sortable: "true",
      //   field: "InverterId",
      //   filterable: true,
      //   // filterOptions: {
      //   //   enabled: true
      //   // }
      // },
      {
        key: "panelpower",
        label: "PV POWER",
        sortable: "true",
        field: "panelpower",
        filterable: true,
        type: "number",
        formatFn: this.formatFnPvP
      }, {
        key: "batteryMode",
        label: "DEVICE STATUS",
        sortable: "true",
        field: "batteryMode",
        filterable: true
      }, {
        key: "BatteryCapacity",
        label: "BATTERY",
        sortable: "true",
        field: "BatteryCapacity",
        filterable: true,
        sortFn: function sortFn(x, y, col, rowX, rowY) {
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // x = Number(x);
          // y = Number(y);
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // return x < y ? -1 : x > y ? 1 : 0;
        }
      },
      // {
      //   key: "expiry",
      //   label: "EXPIRY DATE",
      //   sortable: "true",
      //   field: "expiry",
      //   filterable: true
      // },
      // {
      //   key: "contractualLoad",
      //   field: "contractualLoad",
      //   label: "Contractual Load",
      //   sortable: true,
      //   filterable: true,
      //   hidden:
      //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
      // },
      {
        key: "OutputLoadPercent",
        label: "CONTRACTUAL LOAD / LOAD %",
        sortable: "true",
        field: "OutputLoadPercent",
        filterable: true,
        sortFn: this.numSort
      },
      // {
      //   key: "lastseen",
      //   label: "LAST SEEN",
      //   sortable: false,
      //   field: "lastseen",
      //   filterable: true,
      //   type: "text",
      // },
      {
        key: "Time",
        field: "Time",
        label: "TIME",
        sortable: true,
        type: "date",
        dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss", // expects 2018-03-16
        dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        filterable: true,
        hidden: this.$can("am", "customer") || this.$can("am", "sm") ? true : false
      }],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])(["performanceGraphCall", "handleFilters", "clearFilters", "setPerformanceFilter", "setGlobalTableOptions", "setCriticalSystems"]), (_extends2 = {
    onClose: function onClose() {},

    formatCap: function formatCap(value) {
      return value + "kVA";
    },
    formatFnPvP: function formatFnPvP(v) {
      return v + "kW";
    },
    numSort: function numSort(x, y, col, rowX, rowY) {
      console.log({ x: x, y: y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      x = Number(x);
      y = Number(y);
      console.log({ x: x, y: y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      return x < y ? -1 : x > y ? 1 : 0;
    },
    toggleFilters: function toggleFilters() {
      this.showFilters = !this.showFilters;
      this.filterFirmWarVersion = "";
      this.filterSectorVal = "";
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.clearFilters();
    },
    handleVersionFilterEnabler: function handleVersionFilterEnabler(fv) {
      this.filterFirmWarVersion = fv === "clear" ? "" : fv;
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handleSectorFilterEnabler: function handleSectorFilterEnabler(sector) {
      this.filterSectorVal = sector == "clear" ? "" : sector;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handlePaymentModelFilterEnabler: function handlePaymentModelFilterEnabler(paymentModel) {
      this.filterPaymentModel = paymentModel == "clear" ? "" : paymentModel;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    toggleShowOfflineOnlineDevices: function toggleShowOfflineOnlineDevices(status) {
      // console.log({ status });
      switch (status) {
        case "critical":
          this.toggleCritical();
          this.totalDevicesShowing = this.filterIssues().length;
          break;
        case "Offline":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 2;
          this.totalDevicesShowing = this.filteredOffLineDevices.length;
          this.setPerformanceFilter(2);
          break;
        case "Alarm":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 4;
          this.totalDevicesShowing = this.filteredAlarmDevices.length;
          this.setPerformanceFilter(4);
          break;
        case "Online":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          break;
        case "All":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 3;
          this.totalDevicesShowing = this.filteredAllDevices.length;
          this.setPerformanceFilter(3);
          break;
        default:
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          break;
      }

      var tmpState = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions.performance, {
          currentPage: 1
        })
      });
      this.setGlobalTableOptions(tmpState);
      // if (this.activeTab === true) {
      //   console.log("Online"+this.activeTab );

      // }
      //toggleCritical()
      // this.showOffOnlinelineDevices = !status;
      // if (this.showOfflineDevices) {
      //   this.showCritical = false;
      // }
      // this.showCritical=
    },
    filterIssues: function filterIssues() {
      if (this.DeviceList.length > 0) {
        console.log("clicking again");
        return this.DeviceList.filter(function (x) {
          if ((typeof x === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(x)) === "object") {
            // console.log({ x: typeof x });
            if (x.payload) {
              console.log(__WEBPACK_IMPORTED_MODULE_13_moment___default()(x.payload.TimeStamp).format("DD-MM-yyyy"));
              var dayDiff = __WEBPACK_IMPORTED_MODULE_13_moment___default()().diff(__WEBPACK_IMPORTED_MODULE_13_moment___default()(x.payload.TimeStamp || x.payload.Timestamp), "days");
              console.log(dayDiff);
              return x.payload.InverterDetected == "NO" && dayDiff < 4;
              // console.log({ x: typeof x.payload });
            } else {
                // console.log({ noPayload: x });
              }
          } else {
              // console.log({ xNotObject: x });
            }
        }).reduce(function (acc, cur) {
          // console.log(cur);
          var _tmp = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, cur.payload, {
            ownerName: cur["owner"][0] ? cur["owner"][0]["name"] : "Unassigned"
          });
          return [].concat(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_toConsumableArray___default()(acc), [_tmp]);
        }, []);
      }
    },
    toggleCritical: function toggleCritical() {
      this.showCritical = !this.showCritical;
      // console.log({ Oop: this.DeviceList });
    },
    searchToggle: function searchToggle() {
      this.showSearch = !this.showSearch;
    },
    toggleShowAllDevices: function toggleShowAllDevices(showAllDevices) {
      console.log({ showAllDevices: showAllDevices });
    },
    changeToggle: function changeToggle() {
      //console.log("i am here",this.value);
      if (this.value == "all") {
        this.$router.push({
          path: "/performance/all"
        });
      } else {
        this.$router.push({
          path: "/performance/live"
        });
      }
    },
    tableRowClicked: function tableRowClicked(params) {
      if (params.row.batteryMode !== "inv not detected") {
        this.navTo(params.row);
      }
    },
    getFetchData: function getFetchData(CID) {
      try {
        return this.fetchData.find(function (x) {
          return x.CID == CID || x.solarKitIds == CID;
        }) || {
          name: "Arnergy Solar",
          userId: "5"
        };
      } catch (error) {
        return { name: "Arnergy Solar", userId: "5" };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt: function filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;else return arr.filter(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(obj).some(function (key) {
          return obj[key].includes(searchKey);
        });
      });
    },
    handleFilter: function handleFilter(data) {
      var _this = this;

      var type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(function (x) {
        // console.log(this.statusCalc(x.TimeStamp));

        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? _this.statusCalc(x.TimeStamp) == false : true;
      });
    },
    transformDevice: function transformDevice(data) {
      var _this2 = this;

      // console.log(this.$route.params);
      // payloadDictionary
      // data = [...data, dummyData];
      // graphDeviceDetails
      var d = this.graphDeviceDetails();
      console.log(d);
      console.log(">>data<<");

      var type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(function (x) {
        //  return (
        //   typeof x.payload === "object" &&
        //   x.payload !== "null" &&
        //   x.payload.InverterDetected == "NO"
        // );

        if (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_typeof___default()(x.payload) === "object" && typeof x.payload !== "null" && typeof x.payload !== "undefined" && x.payload.InverterDetected == "NO") {
          var inverterFlag = x.payload && x.payload.InverterDetected && x.payload.InverterDetected == "NO" ? true : false;
          return x.payload && !inverterFlag;
        }
      }).map(function (val, i) {
        if (val.payload.Version == "v4") {
          var tempData = _this2.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
            case "00":
              resp = "Power On";
              break;
            case "S":
            case "01":
              resp = "On Standby";
              break;
            case "L":
            case "E":
            case "05":
              resp = "On Grid";
              break;
            case "Y":
            case "02":
              resp = "Bypass Mode";
              break;
            case "B":
            case "03":
              resp = "On Battery";
              break;
            case "F":
            case "04":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
            case "06":
              resp = "Charging";
              break;
            default:
              resp = val.payload.ModeData[0]["Mode"];
            // code block
          }
          // console.log('=====================V4===========')
          // console.log(val.payload);
          return {
            version: val.payload.Version,
            InverterId: val.payload.BatteryData.BatteryID,
            TimeStamp: val.payload.Timestamp,
            OutputLoadPercent: _this2.roundUp(val.payload.PowerData.reduce(function (acc, obj) {
              return acc += Number(obj["OL%"]);
            }, 0) / val.payload.PowerData.length),
            id: val.payload.DeviceID,
            panelpower: _this2.panelPowerReduce(val.payload.PowerData, "v4"),
            BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
            deviceType: tempData.deviceType ? tempData.deviceType.name : "Arnergy Custom",
            ownerName: tempData.name,
            ownerId: tempData.userId,
            address: tempData["locations"],
            batteryMode: resp,
            expiry: val.payload.ExpiryDate,
            lastseen: _this2.timeAgo(val.payload.Timestamp, tempData.name)
          };
        } else if (val.payload.Version == "v3") {
          // {
          var _tempData = _this2.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
              resp = "Power On";
              break;
            case "S":
              resp = "On Standby";
              break;
            case "L":
              resp = "On Grid";
              break;
            case "E":
              resp = "On Grid";
              break;
            case "Y":
              resp = "Bypass Mode";
              break;
            case "B":
              resp = "On Battery";
              break;
            case "F":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
              resp = "Charging";
              break;
            default:
              resp = val.payload.ModeData[0]["Mode"];
            // code block
          }
          return {
            version: val.payload.Version,
            InverterId: val.payload.BatteryData.BatteryID,
            TimeStamp: val.payload.Timestamp,
            OutputLoadPercent: _this2.roundUp(val.payload.InverterData.reduce(function (acc, obj) {
              return acc += Number(obj["OL%"]);
            }, 0) / val.payload.InverterData.length),
            id: val.payload.DeviceID,
            panelpower: _this2.panelPowerReduce(val.payload.InverterData),
            BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
            deviceType: _tempData.deviceType ? _tempData.deviceType.name : "Arnergy Custom",
            ownerName: _tempData.name,
            ownerId: _tempData.userId,
            address: _tempData["locations"],
            batteryMode: resp,
            expiry: val.payload.ExpiryDate,
            lastseen: _this2.timeAgo(val.payload.Timestamp, _tempData.name)
          };
          // }
        }
        //  else if (val.payload.InstallType == "v4") {
        //   let tempData = this.getFetchData(val.DeviceID);
        //   var resp = "--";
        //   switch (val.payload.ModeData[0]["Mode"]) {
        //     case "P":
        //       resp = "Power On";
        //       break;
        //     case "S":
        //       resp = "On Standby";
        //       break;
        //     case "L":
        //       resp = "On Grid";
        //       break;
        //     case "E":
        //       resp = "On Grid";
        //       break;
        //     case "Y":
        //       resp = "Bypass Mode";
        //       break;
        //     case "B":
        //       resp = "On Battery";
        //       break;
        //     case "F":
        //       resp = "Fault";
        //       break;
        //     case "H":
        //       resp = "Power saving mode";
        //       break;
        //     case "C":
        //       resp = "Charging";
        //       break;
        //     default:
        //       resp = val.payload.ModeData[0]["Mode"];
        //     // code block
        //   }
        //   console.log(val.payload.PowerData)
        //   return {
        //     version: val.payload.Version,
        //     InverterId: val.payload.BatteryData.BatteryID,
        //     TimeStamp: val.payload.Timestamp,
        //     OutputLoadPercent: this.roundUp(
        //       val.payload.InverterData.reduce((acc, obj) => {
        //         return (acc += Number(obj["OL%"]));
        //       }, 0) / val.payload.InverterData.length
        //     ),
        //     id: val.payload.DeviceID,
        //     panelpower: this.panelPowerReduce(val.payload.PowerData),
        //     BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
        //     deviceType: tempData.deviceType
        //       ? tempData.deviceType.name
        //       : "Arnergy Custom",
        //     ownerName: tempData.name,
        //     ownerId: tempData.userId,
        //     address: tempData["locations"],
        //     batteryMode: resp,
        //     expiry: val.payload.ExpiryDate,
        //     lastseen: this.timeAgo(val.payload.Timestamp, tempData.name)
        //   };
        // }
        else {
            var _tempData2 = _this2.getFetchData(val.DeviceID);
            console.log(val);
            console.log(">>>>>>>>>>valvalval<<<<<<<<<<<<<<<<<<<");
            console.log(_tempData2);
            console.log(">>>>>>>>>>tempData<<<<<<<<<<<<<<<<<<<");

            return {
              version: "v2",
              InverterId: val.DeviceID,
              TimeStamp: val.payload.TimeStamp,
              OutputLoadPercent: val.payload.OutputLoadPercent,
              id: _tempData2.CID,
              panelpower: _this2.panelPower(val.payload.PVChargingPower),
              BatteryCapacity: val.payload.BatteryCapacity,
              deviceType: _tempData2.deviceType ? _tempData2.deviceType.name : "Arnergy5000",
              ownerName: _tempData2.name,
              ownerId: _tempData2.userId,
              address: _tempData2["locations"],
              batteryMode: _this2.batteryMode(val.payload.InverterId),
              expiry: _this2.expiryDate(val.payload.InverterId),
              lastseen: _this2.timeAgo(val.payload.TimeStamp)
            };
          }
        // }
      }).filter(function (x) {
        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? _this2.statusCalc(x.TimeStamp) == false : true;
      });
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    getDevice: function getDevice(inverterId) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        var context, HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context = _this3;
                HTTP = _this3.$httpUtils.instance;
                //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;

                url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations";
                _context.next = 5;
                return HTTP.get(url).then(function (response) {
                  context.fetchData = response.data;
                  // console.log(context.fetchData);
                }).catch(function (error) {
                  return "not assign";
                  //console.log("error", error);
                });

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
        // console.log("i am parameter", Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    submitAddForm: function submitAddForm() {
      // console.log(JSON.stringify(this.formDevice));
      var dataParam = this.formDevice;
      if (dataParam.DeviceID === null || dataParam.device_type.name === null || dataParam.location.address === null || dataParam.customer.name === null || dataParam.customer.phone === null || dataParam.DeviceID === "" || dataParam.device_type.name === "" || dataParam.location.address === "" || dataParam.customer.name === "" || dataParam.customer.phone === "") {
        var obj = {
          title: "Please fill all fields!!!",
          message: "",
          type: "error",
          onClose: this.onClose
        };
        this.$refs.simplert.openSimplert(obj);
        // alert('Please fill all fields!!!')
      } else {
        var me = this;
        var HTTP = this.$httpUtils.instance;
        HTTP.post("/devices", me.formDevice).then(function (response) {
          me.fetchDevices();
          var obj = {
            title: "Device Created!!!",
            message: "",
            type: "info",
            onClose: me.onClose
          };
          me.$refs.simplert.openSimplert(obj);
        }).catch(function (error) {
          // console.log(error);
          var obj = {
            title: "Error, Try again!!!",
            message: "",
            type: "error",
            onClose: me.onClose
          };
          me.$refs.simplert.openSimplert(obj);
        });
        me.hideControl();
      }
    },
    showFormPop: function showFormPop() {
      this.$refs.formModal.open();
    },
    hideControl: function hideControl() {
      this.$refs.formModal.cancel();
    },
    formatDate: function formatDate(_date) {
      return __WEBPACK_IMPORTED_MODULE_13_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    navTo: function navTo(device) {
      var id = device.id,
          version = device.version,
          InverterId = device.InverterId;
      // let { DeviceID } = device;
      // console.log( {device});

      this.$router.push({
        name: "devicePerformance",
        params: {
          deviceId: id ? id : InverterId,
          version: version ? version : "v2"
        }
      });
      // console.log(this.details,device)
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "roundUp", function roundUp(num) {
    return Math.round(num * 100) / 100;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "Parse_Json", function Parse_Json(data) {
    return JSON.parse(data);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "countErrors", function countErrors(Warning) {
    var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
    var totalErr = 0;
    for (var property in Warning) {
      if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
        // do stuff
        if (Warning[property] > 0) {
          totalErr++;
          // console.log(property);
        }
      }
    }
    return totalErr;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "errorCalc", function errorCalc(Warning) {
    var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
    var totalErr = 0;
    for (var property in Warning) {
      if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
        // do stuff
        if (Warning[property] > 0) {
          totalErr++;
          // console.log(property);
        }
      }
    }
    // var msg_ = ' Error'
    if (totalErr > 0) {
      return true;
    }
    return false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "findDeviceData", function findDeviceData(dataset, key, value) {
    var res = dataset.filter(function (x) {
      return x[key] == value;
    });
    return res.length > 0 ? res : undefined;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "batteryMode", function batteryMode(deviceID) {
    // console.log(this.DeviceList.modes);
    // this.DeviceList.modes
    var deviceMode = this.findDeviceData(this.DeviceList.modes, "DeviceID", deviceID);
    // console.log(deviceID);
    // console.log(deviceMode);

    var mode = deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
    var resp = "--";
    switch (mode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "B":
        resp = "On Battery";
        break;
      case "F":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
      // code block
    }
    return resp;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "expiryDate", function expiryDate(deviceID) {
    var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

    return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "timeAgo", function timeAgo(date, name) {
    // console.log(name);
    // console.log(this.timeRightNow);
    // console.log(date);

    // var difference = date.add(1, "hours").fromNow();
    // var difference = Math.abs(this.timeRightNow.diff(date));
    // console.log(moment(date).from(this.timeRightNow));
    // console.log("==============================================");
    return __WEBPACK_IMPORTED_MODULE_13_moment___default()(date).from(this.timeRightNow);
    // return timeAgoUtil(difference);
    // console.log(moment(date, "Africa/Lagos").fromNow());
    // if (difference / 60000 > 90) {
    //   return true;
    // } else {
    //   return false;
    // }

    // return moment(date)
    //   .add(1, "hours")
    //   .format()
    //   .toString();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "statusCalc", function statusCalc(date) {
    // console.log( moment(date).diff(this.timeRightNow));
    var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_13_moment___default()(date).diff(this.timeRightNow));
    if (difference / 60000 > 90) {
      return true;
    } else {
      return false;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "statusLabel", function statusLabel(date) {
    var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_13_moment___default()().diff(date));
    if (difference / 60000 > 90) {
      return "Offline";
    } else {
      return "Online";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "panelPower", function panelPower(PVChargingPower) {
    // console.log(parameters);
    var power = this.roundUp(PVChargingPower * 1 / 1000);
    return power + " kW";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "powerToday", function powerToday(power) {
    return this.roundUp(power) + " kWh";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "fetchDevices", function fetchDevices() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "getCurrentCustomerDeviceIds", function getCurrentCustomerDeviceIds() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var httpUtils, userId, url, result, res;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              httpUtils = _this5.$httpUtils;
              userId = _this5.getUserSession.id;
              url = "/installations?filter={\"where\":{\"and\": [{\"userId\":" + userId + "}, {\"or\":[{ \"status\": \"requested\"},{ \"status\": \"commissioned\"},{ \"status\": \"completed\"}]}]}}";
              _context3.next = 5;
              return httpUtils.instance.get(url);

            case 5:
              result = _context3.sent;
              res = result.data.map(function (item) {
                return item.CID;
              });

              _this5.$store.commit("setAssignedDevices", res);
              return _context3.abrupt("return", res);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "currentTime", function currentTime() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var me, HTTP, response, tmpDate;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              me = _this6;
              HTTP = _this6.$httpUtils.instance;
              _context4.next = 4;
              return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

            case 4:
              response = _context4.sent;

              if (!response) {
                _context4.next = 9;
                break;
              }

              if (!response.data.datetime) {
                _context4.next = 9;
                break;
              }

              tmpDate = response.data.datetime.split(".")[0];
              return _context4.abrupt("return", tmpDate);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "get", function get() {
    this.$socket.emit("get", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ action: "sendMessage" }), function (response) {
      console.log(response);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "add", function add() {
    // Emit the server side
    this.$socket.emit("add", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ action: "sendMessage" }));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "sleep", function sleep(ms) {
    // console.log(ms + "here");

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(resolve, ms);
    });
  }), _extends2)),
  created: function created() {},
  mounted: function mounted() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var timeRightNow, deviceIds, assignedDevices, filtrdIssues;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              // this.checkOnboardedCustomer(this.getUserSession.id)
              _this7.toggleFilters();
              _this7.totalDevicesShowing = _this7.filteredAllDevices.length;
              // https://worldtimeapi.org/api/timezone/Africa/Lagos
              // await this.
              _this7.loadingState = true;
              if (_this7.$can("see", "installation")) {
                _this7.showOffOnlinelineDevices = _this7.getPerformanceFilter;
              }
              _context5.next = 6;
              return _this7.currentTime();

            case 6:
              _this7.timeRightNow = _context5.sent;
              timeRightNow = _this7.timeRightNow;
              // console.log({timeRightNow});

              if (!_this7.$can("am", "customer")) {
                _context5.next = 24;
                break;
              }

              if (!(_this7.getAssignedDevices != null)) {
                _context5.next = 13;
                break;
              }

              _context5.t0 = _this7.getAssignedDevices;
              _context5.next = 16;
              break;

            case 13:
              _context5.next = 15;
              return _this7.getCurrentCustomerDeviceIds();

            case 15:
              _context5.t0 = _context5.sent;

            case 16:
              deviceIds = _context5.t0;

              if (!(deviceIds.length < 1)) {
                _context5.next = 20;
                break;
              }

              _this7.showOffOnlinelineDevices = null;
              return _context5.abrupt("return");

            case 20:
              _context5.next = 22;
              return _this7.performanceGraphCall({
                timeRN: _this7.timeRightNow,
                arrayOfIds: deviceIds
              });

            case 22:
              _context5.next = 34;
              break;

            case 24:
              if (!_this7.$can("am", "sm")) {
                _context5.next = 31;
                break;
              }

              // I am a section manager...
              assignedDevices = [];

              try {
                assignedDevices = JSON.parse(_this7.getUserSession.assignedDevices);
              } catch (error) {
                assignedDevices = _this7.getUserSession.assignedDevices.split(",");
              }
              _context5.next = 29;
              return _this7.performanceGraphCall({
                timeRN: _this7.timeRightNow,
                arrayOfIds: assignedDevices
              });

            case 29:
              _context5.next = 34;
              break;

            case 31:
              if (!_this7.$can("manage", "allDevices")) {
                _context5.next = 34;
                break;
              }

              _context5.next = 34;
              return _this7.performanceGraphCall({
                timeRN: _this7.timeRightNow
              });

            case 34:
              filtrdIssues = _this7.filterIssues();

              _this7.setCriticalSystems(filtrdIssues);
              _this7.loadingState = false;

            case 37:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  }
});

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "offlineDevices",
  props: {
    showOfflineDevices: {
      type: Number,
      default: null
    },
    showCritical: { type: Boolean },
    formatDate: { type: Function },
    tableRowClicked: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredOffLineDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_2__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["offLineDeviceList", "getGlobalTableOptions"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        // console.log("Offline"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ offLineDeviceList: this.offLineDeviceList });
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


//
//
//
//
//
//
//
//
//
//


/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "status-indicator",
  props: ["timestamp"],
  data: function data() {
    return {
      boltDisplay: false,
      // batteryLevel: 0,
      battery_meter: {
        background: "green",
        width: this.level + "%" || "100%",
        height: "100%"
      },
      holderStyle: {
        width: this.width || "100px",
        height: this.height || "30px",
        background: "#eee"
      },
      parentStyle: {
        transform: this.direction == "y" ? "rotate(-90deg)" : ""
      },
      boltStyle: {
        display: "none",
        transform: this.direction == "y" ? "rotate(90deg)" : ""
      },
      statusCalc: true
    };
  },
  watch: {
    timestamp: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(newVal, old) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.currentTime();

              case 2:
                this.timeRightNow = _context.sent;

                console.log("Redrawn", this.timeRightNow);
                this.redraw(newVal);
                // this.boltDisplay =

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function timestamp(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return timestamp;
    }()
  },
  components: {},
  methods: {
    currentTime: function currentTime() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var me, HTTP, response, tmpDate;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                me = _this;
                HTTP = _this.$httpUtils.instance;
                _context2.next = 4;
                return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

              case 4:
                response = _context2.sent;

                if (!response) {
                  _context2.next = 9;
                  break;
                }

                if (!response.data.datetime) {
                  _context2.next = 9;
                  break;
                }

                tmpDate = response.data.datetime.split(".")[0];
                return _context2.abrupt("return", tmpDate);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    redraw: function redraw(timeStmp) {
      this.statusCalc = this.statusIndicator(timeStmp);
      // this.$refs.battery_level.style.background = bg;
    },
    statusIndicator: function statusIndicator(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("Redrawn", _this2.timeRightNow);
              // this.timeRightNow = await this.currentTime();
              // this.redraw(this.timeRightNow);

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },
  updated: function updated() {}
});

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Badge"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Button"]);
var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "offlineDevices",
  props: {
    showAlarmDevices: {
      type: Number,
      default: null
    },
    formatDate: { type: Function },
    showCritical: { type: Boolean },
    tableRowClicked: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredAlarmDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_6__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["offLineDeviceList", "getGlobalTableOptions"]), {
    alarmFields: {
      get: function get() {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.fields_), [{
          key: "flags",
          label: "Alarms",
          sortable: "true",
          field: "flags",
          filterable: true
        }]);
      }
    },
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      badgeTypes: {
        "warning": {
          type: "warning",
          label: "Minor"
        },
        "error": {
          type: "danger",
          label: "Major"
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        // console.log("Offline"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ offLineDeviceList: this.offLineDeviceList });
  }
});

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "onlineDevices",
  props: {
    showOnlineDevices: {
      type: Number,
      default: null
    },
    showCritical: { type: Boolean },
    formatDate: { type: Function },
    tableRowClicked: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredOnlineDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_3__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["onLineDevices", "getGlobalTableOptions"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });

      if (this.activeTab === true) {
        // console.log("Online"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ onLineDevices: this.onLineDevices });
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__ = __webpack_require__(141);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AllDevices",
  props: {
    showAllDevices: {
      type: Number,
      default: null
    },

    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    showCritical: { type: Boolean },
    filteredAllDevices: { type: Array, default: [] }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_3__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["graphDeviceDetails", "getGlobalTableOptions"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      allDevices: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        // console.log("All"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // $forceUpdate();
    // window.location.reload();
    // console.log({ filteredAllDevices: this.filteredAllDevices });
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__powerStat__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__widgets_offlineDevices2__ = __webpack_require__(2670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__widgets_alarmDevices2__ = __webpack_require__(2673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__widgets_onLineDevices2__ = __webpack_require__(2676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__widgets_allDevices2__ = __webpack_require__(2679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuikit__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_util__ = __webpack_require__(2682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui__);










var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import Widget from "../../vuestic-components/vuestic-widget/VuesticWidget";
// import Modal from "../../vuestic-components/vuestic-modal/VuesticModal";
// import InstallationStat from "./installationStat";
// import VuesticSimpleSelect from "../../vuestic-components/vuestic-simple-select/VuesticSimpleSelect";














__WEBPACK_IMPORTED_MODULE_9_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_element_ui__["Badge"]);
var items = [];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "dashboard",
  searchdata: "",
  components: {
    // Widget,
    powerStat: __WEBPACK_IMPORTED_MODULE_11__powerStat__["a" /* default */],
    OfflineDevices: __WEBPACK_IMPORTED_MODULE_15__widgets_offlineDevices2__["a" /* default */],
    AlarmDevices: __WEBPACK_IMPORTED_MODULE_16__widgets_alarmDevices2__["a" /* default */],
    OnLineDevices: __WEBPACK_IMPORTED_MODULE_17__widgets_onLineDevices2__["a" /* default */],
    AllDevices: __WEBPACK_IMPORTED_MODULE_18__widgets_allDevices2__["a" /* default */],
    // Modal,
    // VuesticSimpleSelect,
    Simplert: __WEBPACK_IMPORTED_MODULE_10_vue2_simplert___default.a,
    Battery: __WEBPACK_IMPORTED_MODULE_13__kitchen_grey_battery__["a" /* default */],
    "vk-iconnav": __WEBPACK_IMPORTED_MODULE_19_vuikit__["b" /* Iconnav */],
    "vk-icon": __WEBPACK_IMPORTED_MODULE_19_vuikit__["a" /* Icon */],
    "vk-iconnav-item": __WEBPACK_IMPORTED_MODULE_19_vuikit__["c" /* IconnavItem */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["DeviceList", "getUserByDevice", "loadingState", "getUserSession", "graphDeviceDetails", "offLineDeviceList", "onLineDevices", "uniqueFV", "devicePayload", "uniqueSectors", "uniquePaymentModel", "filteredAllDevices", "getAssignedDevices", "filteredOnlineDevices", "filteredOffLineDevices", "filteredAlarmDevices", "getPerformanceFilter", "getGlobalTableOptions"]), {
    getAllFilteredDevice: {
      get: function get() {
        return this.filteredAllDevices;
      }
    },
    getAllFilteredOfflineDevice: {
      get: function get() {
        return this.filteredOffLineDevices;
      }
    },
    getAllFilteredAlarms: {
      get: function get() {
        return this.filteredAlarmDevices;
      }
    },
    getSortOrder: {
      get: function get() {
        return {
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    },
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    getParams: {
      get: function get() {
        return {
          page: this.tableOptions.currentPage,
          limit: this.tableOptions.currentPerPage,
          filter: this.filterMode,
          search: this.searchTerm,
          sortField: this.sortField,
          sortOrder: this.sortOrder
        };
      }
    },
    getLoadingState: {
      get: function get() {
        return this.loadingState;
      }
    },
    pagination: {
      get: function get() {
        return this.devicePayload;
      }
    },
    showNotDetectedInv: {
      get: function get() {
        return this.notDetectedInverter;
      }
    },
    criticalSystems: {
      //
      get: function get() {
        var filteredIssues = this.filterIssues();
        if (filteredIssues) {
          this.setCriticalSystems(filteredIssues);
          // console.log("SHould Log");
          return filteredIssues;
        } else {
          return [];
        }
      }
    }
  }),
  data: function data() {
    return {
      totalDevicesShowing: "",
      paginatedInfo: {},
      showSearch: true,
      value: "live",
      searchTerm: "",
      sortField: "",
      sortOrder: "",
      details: "devicePerformance",
      myDevices: [],
      fetchData: [],
      retData: {},
      notDetectedInverter: "",
      showCritical: false,
      loading: true,
      showOffOnlinelineDevices: null,
      showAllDevices: false,
      showOnlineOfline: true,
      showOnlineButton: true,
      showFilters: true,
      filterFirmWarVersion: "",
      filterSectorVal: "",
      filterPaymentModel: "",
      filterMode: "",
      formDevice: {
        DeviceID: null,
        device_type: {
          name: "Arnergy 5000",
          description: "Bundled with : 3 LED bulbs, FM Radio and 1 x 20Wp High Efficiency Solar Panel.",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        location: {
          address: null,
          latitude: null,
          longitude: null
        },
        customer: {
          name: null,
          phone: null
        },
        subscription_type: {
          name: "Monthly Subscription",
          description: "User Pays Monthly",
          status: 0,
          TimeStamp: new Date(),
          updatedAt: new Date()
        },
        TimeStamp: new Date(),
        updatedAt: new Date(),
        outright_cost: 96796,
        initial_cost: 98533,
        installment_cost: 626882
      },
      deviceOptions: ["Arnergy 300", "Arnergy 1000", "Arnergy 2000", "Arnergy 5000"],
      simpleSelectModel: "",
      timeRightNow: __WEBPACK_IMPORTED_MODULE_12_moment___default()(),
      items: items,
      criticalColumns: [{
        key: "ownerName",
        label: "OWNED BY",
        sortable: true,
        field: "ownerName",
        filterable: true
      }, {
        key: "deviceType",
        label: "DEVICE TYPE",
        sortable: "true",
        field: "InstallType",
        filterable: true
      }, {
        key: "version",
        label: "VERSION",
        sortable: "true",
        field: "Version",
        filterable: true
      }, {
        key: "InverterId",
        label: "DEVICE ID",
        sortable: "true",
        field: "DeviceID",
        filterable: true
      }, {
        key: "Timestamp",
        label: "LAST SEEN",
        sortable: "true",
        field: "Timestamp",
        filterable: true
      }],
      fields_: [{
        key: "status",
        label: "STATUS",
        field: "status"
      }, {
        key: "ownerName",
        label: "OWNED BY",
        sortable: "true",
        field: "ownerName",
        type: "text",
        filterable: true
      }, {
        key: "InverterId",
        label: "Device ID",
        sortable: "true",
        field: "InverterId",
        type: "text",
        filterable: true
      },
      // {
      //   key: "installedPV",
      //   label: "INSTALLED PV",
      //   sortable: false,
      //   field: "installedPV",
      //   filterable: true,
      //   hidden:
      //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
      // },
      {
        key: "installedCapacity",
        label: "INSTALLED PV / CAPACITY",
        sortable: false,
        field: "installedCapacity",
        filterable: true,
        sortFn: this.numSort,
        firstSortType: "desc"
        // formatFn: this.formatCap,
      },
      // {
      //   key: "FV",
      //   label: "FIRMWARE VERSION",
      //   sortable: "true",
      //   field: "FV",
      //   filterable: true,
      // },
      {
        key: "version",
        label: "VERSION / FIRMWARE VERSION",
        sortable: "true",
        field: "version",
        filterable: true
      },
      // {
      //   key: "InverterId",
      //   label: "DEVICE ID",
      //   sortable: "true",
      //   field: "InverterId",
      //   filterable: true,
      //   // filterOptions: {
      //   //   enabled: true
      //   // }
      // },
      {
        key: "panelpower",
        label: "PV POWER",
        sortable: "true",
        field: "panelpower",
        filterable: true,
        type: "number",
        formatFn: this.formatFnPvP
      }, {
        key: "batteryMode",
        label: "DEVICE STATUS",
        sortable: false,
        field: "batteryMode",
        filterable: true
      }, {
        key: "BatteryCapacity",
        label: "BATTERY",
        sortable: "true",
        field: "BatteryCapacity",
        filterable: true,
        sortFn: function sortFn(x, y, col, rowX, rowY) {
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // x = Number(x);
          // y = Number(y);
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // return x < y ? -1 : x > y ? 1 : 0;
        }
      },
      // {
      //   key: "expiry",
      //   label: "EXPIRY DATE",
      //   sortable: "true",
      //   field: "expiry",
      //   filterable: true
      // },
      // {
      //   key: "contractualLoad",
      //   field: "contractualLoad",
      //   label: "Contractual Load",
      //   sortable: true,
      //   filterable: true,
      //   hidden:
      //     this.$can("am", "customer") || this.$can("am", "sm") ? true : false,
      // },
      {
        key: "OutputLoadPercent",
        label: "CONTRACTUAL LOAD / LOAD %",
        sortable: "true",
        field: "OutputLoadPercent",
        filterable: true,
        sortFn: this.numSort
      },
      // {
      //   key: "lastseen",
      //   label: "LAST SEEN",
      //   sortable: false,
      //   field: "lastseen",
      //   filterable: true,
      //   type: "text",
      // },
      {
        key: "Time",
        field: "Time",
        label: "TIME",
        sortable: true,
        type: "date",
        dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss", // expects 2018-03-16
        dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        filterable: true,
        hidden: this.$can("am", "customer") || this.$can("am", "sm") ? true : false
      }],
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])(["performanceGraphCall2", "handleFilters", "clearFilters", "setPerformanceFilter", "setGlobalTableOptions", "setCriticalSystems"]), (_extends2 = {
    onClose: function onClose() {},

    formatCap: function formatCap(value) {
      return value + "kVA";
    },
    formatFnPvP: function formatFnPvP(v) {
      return v + "kW";
    },
    selectedField: function selectedField(field) {
      switch (field) {
        case 'version':
          return 'Version';
        default:
          return field;
      }
    },
    getDevices: function getDevices(payload) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee() {
        var deviceIds, assignedDevices;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.$can("am", "customer")) {
                  _context.next = 16;
                  break;
                }

                if (!(_this.getAssignedDevices != null)) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = _this.getAssignedDevices;
                _context.next = 8;
                break;

              case 5:
                _context.next = 7;
                return _this.getCurrentCustomerDeviceIds();

              case 7:
                _context.t0 = _context.sent;

              case 8:
                deviceIds = _context.t0;

                if (!(deviceIds.length < 1)) {
                  _context.next = 12;
                  break;
                }

                _this.showOffOnlinelineDevices = null;
                return _context.abrupt("return");

              case 12:
                _context.next = 14;
                return _this.performanceGraphCall2(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({
                  timeRN: _this.timeRightNow,
                  arrayOfIds: deviceIds
                }, payload));

              case 14:
                _context.next = 26;
                break;

              case 16:
                if (!_this.$can("am", "sm")) {
                  _context.next = 23;
                  break;
                }

                // I am a section manager...
                assignedDevices = [];

                try {
                  assignedDevices = JSON.parse(_this.getUserSession.assignedDevices);
                } catch (error) {
                  assignedDevices = _this.getUserSession.assignedDevices.split(",");
                }
                _context.next = 21;
                return _this.performanceGraphCall2(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({
                  timeRN: _this.timeRightNow,
                  arrayOfIds: assignedDevices
                }, payload));

              case 21:
                _context.next = 26;
                break;

              case 23:
                if (!_this.$can("manage", "allDevices")) {
                  _context.next = 26;
                  break;
                }

                _context.next = 26;
                return _this.performanceGraphCall2(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({
                  timeRN: _this.timeRightNow
                }, payload));

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    numSort: function numSort(x, y, col, rowX, rowY) {
      x = Number(x);
      y = Number(y);
      return x < y ? -1 : x > y ? 1 : 0;
    },
    toggleFilters: function toggleFilters() {
      this.showFilters = !this.showFilters;
      this.filterFirmWarVersion = "";
      this.filterSectorVal = "";
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.clearFilters();
    },
    handleVersionFilterEnabler: function handleVersionFilterEnabler(fv) {
      this.filterFirmWarVersion = fv === "clear" ? "" : fv;
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handleSectorFilterEnabler: function handleSectorFilterEnabler(sector) {
      this.filterSectorVal = sector == "clear" ? "" : sector;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    handlePaymentModelFilterEnabler: function handlePaymentModelFilterEnabler(paymentModel) {
      this.filterPaymentModel = paymentModel == "clear" ? "" : paymentModel;
      this.$store.commit("filterSectorVal", this.filterSectorVal);
      this.$store.commit("filterFirmWarVersion", this.filterFirmWarVersion);
      this.$store.commit("filterPaymentModel", this.filterPaymentModel);
      this.handleFilters();
    },
    toggleShowOfflineOnlineDevices: function toggleShowOfflineOnlineDevices(status) {
      // console.log({ status });
      switch (status) {
        case "critical":
          this.toggleCritical();
          this.totalDevicesShowing = this.filterIssues().length;
          this.filterMode = "not-detected";
          this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams, { filter: "not-detected", limit: this.devicePayload.deviceAnalytics.notDetectedDevices }));
          this.notDetectedInverter = this.devicePayload.deviceAnalytics.notDetectedDevices;
          break;
        case "Offline":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 2;
          this.totalDevicesShowing = this.filteredOffLineDevices.length;
          this.setPerformanceFilter(2);
          this.filterMode = "offline";
          this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams, { filter: "offline" }));
          this.notDetectedInverter = "";
          break;
        case "Alarm":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 4;
          this.totalDevicesShowing = this.filteredAlarmDevices.length;
          this.setPerformanceFilter(4);
          this.filterMode = "alarm";
          this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams, { filter: "alarm" }));
          this.notDetectedInverter = "";
          break;
        case "Online":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          this.filterMode = "online";
          this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams, { filter: "online" }));
          this.notDetectedInverter = "";
          break;
        case "All":
          this.showCritical = false;
          this.showOffOnlinelineDevices = 3;
          this.totalDevicesShowing = this.filteredAllDevices.length;
          this.setPerformanceFilter(3);
          this.filterMode = "";
          this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams));
          this.notDetectedInverter = "";
          break;
        default:
          this.showCritical = false;
          this.showOffOnlinelineDevices = 1;
          this.totalDevicesShowing = this.filteredOnlineDevices.length;
          this.setPerformanceFilter(1);
          this.notDetectedInverter = "";
          this.filterMode = "";
          break;
      }

      var tmpState = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions.performance, {
          currentPage: 1
        })
      });
      this.setGlobalTableOptions(tmpState);
      // if (this.activeTab === true) {
      //   console.log("Online"+this.activeTab );

      // }
      //toggleCritical()
      // this.showOffOnlinelineDevices = !status;
      // if (this.showOfflineDevices) {
      //   this.showCritical = false;
      // }
      // this.showCritical=
    },
    filterIssues: function filterIssues() {
      if (this.DeviceList.length > 0) {
        return this.DeviceList.filter(function (x) {
          if ((typeof x === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(x)) === "object") {
            // console.log({ x: typeof x });
            if (x.payload) {
              return x.payload.InverterDetected == "NO";
              // console.log({ x: typeof x.payload });
            } else {
                // console.log({ noPayload: x });
              }
          } else {
              // console.log({ xNotObject: x });
            }
        }).reduce(function (acc, cur) {
          // console.log(cur);
          var _tmp = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, cur.payload, {
            ownerName: cur["owner"][0] ? cur["owner"][0]["name"] : "Unassigned"
          });
          return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(acc), [_tmp]);
        }, []);
      }
    },
    toggleCritical: function toggleCritical() {
      this.showCritical = !this.showCritical;
      // console.log({ Oop: this.DeviceList });
    },
    searchToggle: function searchToggle() {
      this.showSearch = !this.showSearch;
    },
    toggleShowAllDevices: function toggleShowAllDevices(showAllDevices) {
      console.log({ showAllDevices: showAllDevices });
    },
    changeToggle: function changeToggle() {
      //console.log("i am here",this.value);
      if (this.value == "all") {
        this.$router.push({
          path: "/performance/all"
        });
      } else {
        this.$router.push({
          path: "/performance/live"
        });
      }
    },
    tableRowClicked: function tableRowClicked(params) {
      if (params.row.batteryMode !== "inv not detected") {
        this.navTo(params.row);
      }
    },
    getFetchData: function getFetchData(CID) {
      try {
        return this.fetchData.find(function (x) {
          return x.CID == CID || x.solarKitIds == CID;
        }) || {
          name: "Arnergy Solar",
          userId: "5"
        };
      } catch (error) {
        return { name: "Arnergy Solar", userId: "5" };
      }
      //.then(res=> {return res[0].name}).catch((err)=> {return''})
      // return null || this.fetchData.filter(x => x.solarKitIds == inverterId)[0].name
    },
    filterIt: function filterIt(arr, searchKey) {
      if (searchKey.length < 3) return arr;else return arr.filter(function (obj) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).some(function (key) {
          return obj[key].includes(searchKey);
        });
      });
    },
    handleFilter: function handleFilter(data) {
      var _this2 = this;

      var type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(function (x) {
        // console.log(this.statusCalc(x.TimeStamp));

        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? _this2.statusCalc(x.TimeStamp) == false : true;
      });
    },
    transformDevice: function transformDevice(data) {
      var _this3 = this;

      // console.log(this.$route.params);
      // payloadDictionary
      // data = [...data, dummyData];
      // graphDeviceDetails
      var d = this.graphDeviceDetails();
      console.log(d);
      console.log(">>data<<");

      var type = this.$route.params["live"] == "live" ? true : false;
      return data.filter(function (x) {
        //  return (
        //   typeof x.payload === "object" &&
        //   x.payload !== "null" &&
        //   x.payload.InverterDetected == "NO"
        // );

        if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_typeof___default()(x.payload) === "object" && typeof x.payload !== "null" && typeof x.payload !== "undefined" && x.payload.InverterDetected == "NO") {
          var inverterFlag = x.payload && x.payload.InverterDetected && x.payload.InverterDetected == "NO" ? true : false;
          return x.payload && !inverterFlag;
        }
      }).map(function (val, i) {
        if (val.payload.Version == "v4") {
          var tempData = _this3.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
            case "00":
              resp = "Power On";
              break;
            case "S":
            case "01":
              resp = "On Standby";
              break;
            case "L":
            case "E":
            case "05":
              resp = "On Grid";
              break;
            case "Y":
            case "02":
              resp = "Bypass Mode";
              break;
            case "B":
            case "03":
              resp = "On Battery";
              break;
            case "F":
            case "04":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
            case "06":
              resp = "Charging";
              break;
            default:
              resp = val.payload.ModeData[0]["Mode"];
            // code block
          }
          // console.log('=====================V4===========')
          // console.log(val.payload);
          return {
            version: val.payload.Version || "N/A",
            InverterId: val.payload.BatteryData.BatteryID,
            TimeStamp: val.payload.Timestamp,
            OutputLoadPercent: _this3.roundUp(val.payload.PowerData.reduce(function (acc, obj) {
              return acc += Number(obj["OL%"]);
            }, 0) / val.payload.PowerData.length),
            id: val.payload.DeviceID,
            panelpower: _this3.panelPowerReduce(val.payload.PowerData, "v4"),
            BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
            deviceType: tempData.deviceType ? tempData.deviceType.name : "Arnergy Custom",
            ownerName: tempData.name,
            ownerId: tempData.userId,
            address: tempData["locations"],
            batteryMode: resp,
            expiry: val.payload.ExpiryDate,
            lastseen: _this3.timeAgo(val.payload.Timestamp, tempData.name)
          };
        } else if (val.payload.Version == "v3") {
          // {
          var _tempData = _this3.getFetchData(val.DeviceID);
          var resp = "--";
          switch (val.payload.ModeData[0]["Mode"]) {
            case "P":
              resp = "Power On";
              break;
            case "S":
              resp = "On Standby";
              break;
            case "L":
              resp = "On Grid";
              break;
            case "E":
              resp = "On Grid";
              break;
            case "Y":
              resp = "Bypass Mode";
              break;
            case "B":
              resp = "On Battery";
              break;
            case "F":
              resp = "Fault";
              break;
            case "H":
              resp = "Power saving mode";
              break;
            case "C":
              resp = "Charging";
              break;
            default:
              resp = val.payload.ModeData[0]["Mode"];
            // code block
          }
          return {
            version: val.payload.Version || "N/A",
            InverterId: val.payload.BatteryData.BatteryID,
            TimeStamp: val.payload.Timestamp,
            OutputLoadPercent: _this3.roundUp(val.payload.InverterData.reduce(function (acc, obj) {
              return acc += Number(obj["OL%"]);
            }, 0) / val.payload.InverterData.length),
            id: val.payload.DeviceID,
            panelpower: _this3.panelPowerReduce(val.payload.InverterData),
            BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
            deviceType: _tempData.deviceType ? _tempData.deviceType.name : "Arnergy Custom",
            ownerName: _tempData.name,
            ownerId: _tempData.userId,
            address: _tempData["locations"],
            batteryMode: resp,
            expiry: val.payload.ExpiryDate,
            lastseen: _this3.timeAgo(val.payload.Timestamp, _tempData.name)
          };
          // }
        }
        //  else if (val.payload.InstallType == "v4") {
        //   let tempData = this.getFetchData(val.DeviceID);
        //   var resp = "--";
        //   switch (val.payload.ModeData[0]["Mode"]) {
        //     case "P":
        //       resp = "Power On";
        //       break;
        //     case "S":
        //       resp = "On Standby";
        //       break;
        //     case "L":
        //       resp = "On Grid";
        //       break;
        //     case "E":
        //       resp = "On Grid";
        //       break;
        //     case "Y":
        //       resp = "Bypass Mode";
        //       break;
        //     case "B":
        //       resp = "On Battery";
        //       break;
        //     case "F":
        //       resp = "Fault";
        //       break;
        //     case "H":
        //       resp = "Power saving mode";
        //       break;
        //     case "C":
        //       resp = "Charging";
        //       break;
        //     default:
        //       resp = val.payload.ModeData[0]["Mode"];
        //     // code block
        //   }
        //   console.log(val.payload.PowerData)
        //   return {
        //     version: val.payload.Version,
        //     InverterId: val.payload.BatteryData.BatteryID,
        //     TimeStamp: val.payload.Timestamp,
        //     OutputLoadPercent: this.roundUp(
        //       val.payload.InverterData.reduce((acc, obj) => {
        //         return (acc += Number(obj["OL%"]));
        //       }, 0) / val.payload.InverterData.length
        //     ),
        //     id: val.payload.DeviceID,
        //     panelpower: this.panelPowerReduce(val.payload.PowerData),
        //     BatteryCapacity: val.payload.BatteryData.SOC.replace("%", ""),
        //     deviceType: tempData.deviceType
        //       ? tempData.deviceType.name
        //       : "Arnergy Custom",
        //     ownerName: tempData.name,
        //     ownerId: tempData.userId,
        //     address: tempData["locations"],
        //     batteryMode: resp,
        //     expiry: val.payload.ExpiryDate,
        //     lastseen: this.timeAgo(val.payload.Timestamp, tempData.name)
        //   };
        // }
        else {
            var _tempData2 = _this3.getFetchData(val.DeviceID);
            console.log(val);
            console.log(">>>>>>>>>>valvalval<<<<<<<<<<<<<<<<<<<");
            console.log(_tempData2);
            console.log(">>>>>>>>>>tempData<<<<<<<<<<<<<<<<<<<");

            return {
              version: "v2",
              InverterId: val.DeviceID,
              TimeStamp: val.payload.TimeStamp,
              OutputLoadPercent: val.payload.OutputLoadPercent,
              id: _tempData2.CID,
              panelpower: _this3.panelPower(val.payload.PVChargingPower),
              BatteryCapacity: val.payload.BatteryCapacity,
              deviceType: _tempData2.deviceType ? _tempData2.deviceType.name : "Arnergy5000",
              ownerName: _tempData2.name,
              ownerId: _tempData2.userId,
              address: _tempData2["locations"],
              batteryMode: _this3.batteryMode(val.payload.InverterId),
              expiry: _this3.expiryDate(val.payload.InverterId),
              lastseen: _this3.timeAgo(val.payload.TimeStamp)
            };
          }
        // }
      }).filter(function (x) {
        // console.log(x && type ? this.statusCalc(x.TimeStamp) == false : true);
        return x && type ? _this3.statusCalc(x.TimeStamp) == false : true;
      });
    },
    roundUp: function roundUp(num) {
      return num.toFixed(2);
    },
    getDevice: function getDevice(inverterId) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var context, HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                context = _this4;
                HTTP = _this4.$httpUtils.instance;
                //const url = `/installations/?filter[where][solarKitIds]=${inverterId}&filter[include]=user&filter[include]=deviceType`;

                url = "/installations/?filter[include]=user&filter[include]=deviceType&filter[include]=locations";
                _context2.next = 5;
                return HTTP.get(url).then(function (response) {
                  context.fetchData = response.data;
                  // console.log(context.fetchData);
                }).catch(function (error) {
                  return "not assign";
                  //console.log("error", error);
                });

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    panelPowerReduce: function panelPowerReduce(InverterData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";

      var power = InverterData.reduce(function (acc, parameter) {
        var powerKey = "PVCgP" + (version == "v4" ? "1" : "");
        // console.log("i am parameter", Object.keys(parameter));
        return parameter[powerKey] ? acc + parameter[powerKey] * 1 : acc + 0;
      }, 0);
      return power / 1000 + "kW";
    },
    submitAddForm: function submitAddForm() {
      // console.log(JSON.stringify(this.formDevice));
      var dataParam = this.formDevice;
      if (dataParam.DeviceID === null || dataParam.device_type.name === null || dataParam.location.address === null || dataParam.customer.name === null || dataParam.customer.phone === null || dataParam.DeviceID === "" || dataParam.device_type.name === "" || dataParam.location.address === "" || dataParam.customer.name === "" || dataParam.customer.phone === "") {
        var obj = {
          title: "Please fill all fields!!!",
          message: "",
          type: "error",
          onClose: this.onClose
        };
        this.$refs.simplert.openSimplert(obj);
        // alert('Please fill all fields!!!')
      } else {
        var me = this;
        var HTTP = this.$httpUtils.instance;
        HTTP.post("/devices", me.formDevice).then(function (response) {
          me.fetchDevices();
          var obj = {
            title: "Device Created!!!",
            message: "",
            type: "info",
            onClose: me.onClose
          };
          me.$refs.simplert.openSimplert(obj);
        }).catch(function (error) {
          // console.log(error);
          var obj = {
            title: "Error, Try again!!!",
            message: "",
            type: "error",
            onClose: me.onClose
          };
          me.$refs.simplert.openSimplert(obj);
        });
        me.hideControl();
      }
    },
    showFormPop: function showFormPop() {
      this.$refs.formModal.open();
    },
    hideControl: function hideControl() {
      this.$refs.formModal.cancel();
    },
    formatDate: function formatDate(_date) {
      return __WEBPACK_IMPORTED_MODULE_12_moment___default()(_date).format("MMMM Do YYYY, h:mm:ss a");
    },
    navTo: function navTo(device) {
      var id = device.id,
          version = device.version,
          InverterId = device.InverterId;
      // let { DeviceID } = device;
      // console.log( {device});

      console.log({ deviceId: id ? id : InverterId,
        version: version ? version : "v2" });
      this.$router.push({
        name: "devicePerformanceV2",
        params: {
          deviceId: id ? id : InverterId,
          version: version ? version : "v2"
        }
      });
      // console.log(this.details,device)
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "roundUp", function roundUp(num) {
    return Math.round(num * 100) / 100;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "Parse_Json", function Parse_Json(data) {
    return JSON.parse(data);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "countErrors", function countErrors(Warning) {
    var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
    var totalErr = 0;
    for (var property in Warning) {
      if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
        // do stuff
        if (Warning[property] > 0) {
          totalErr++;
          // console.log(property);
        }
      }
    }
    return totalErr;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "errorCalc", function errorCalc(Warning) {
    var excluded = ["id", "deviceID", "TimeStamp", "TimeStamp", "updatedAt", "lineFail"];
    var totalErr = 0;
    for (var property in Warning) {
      if (Warning.hasOwnProperty(property) && excluded.indexOf(property) < 0) {
        // do stuff
        if (Warning[property] > 0) {
          totalErr++;
          // console.log(property);
        }
      }
    }
    // var msg_ = ' Error'
    if (totalErr > 0) {
      return true;
    }
    return false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "findDeviceData", function findDeviceData(dataset, key, value) {
    var res = dataset.filter(function (x) {
      return x[key] == value;
    });
    return res.length > 0 ? res : undefined;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "batteryMode", function batteryMode(deviceID) {
    // console.log(this.DeviceList.modes);
    // this.DeviceList.modes
    var deviceMode = this.findDeviceData(this.DeviceList.modes, "DeviceID", deviceID);
    // console.log(deviceID);
    // console.log(deviceMode);

    var mode = deviceMode !== undefined ? deviceMode[0]["payload"]["Mode"] : "";
    var resp = "--";
    switch (mode) {
      case "P":
        resp = "Power On";
        break;
      case "S":
        resp = "On Standby";
        break;
      case "L":
        resp = "On Grid";
        break;
      case "B":
        resp = "On Battery";
        break;
      case "F":
        resp = "Fault";
        break;
      case "H":
        resp = "Power saving mode";
        break;
      case "C":
        resp = "Charging";
        break;
      default:
      // code block
    }
    return resp;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "expiryDate", function expiryDate(deviceID) {
    var deviceExpiry = this.findDeviceData(this.DeviceList.expiries, "DeviceID", deviceID);

    return deviceExpiry !== undefined ? this.formatDate(deviceExpiry[0]["payload"]["expirydate"]) : "--";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "timeAgo", function timeAgo(date, name) {
    // console.log(name);
    // console.log(this.timeRightNow);
    // console.log(date);

    // var difference = date.add(1, "hours").fromNow();
    // var difference = Math.abs(this.timeRightNow.diff(date));
    // console.log(moment(date).from(this.timeRightNow));
    // console.log("==============================================");
    return __WEBPACK_IMPORTED_MODULE_12_moment___default()(date).from(this.timeRightNow);
    // return timeAgoUtil(difference);
    // console.log(moment(date, "Africa/Lagos").fromNow());
    // if (difference / 60000 > 90) {
    //   return true;
    // } else {
    //   return false;
    // }

    // return moment(date)
    //   .add(1, "hours")
    //   .format()
    //   .toString();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "statusCalc", function statusCalc(date) {
    // console.log( moment(date).diff(this.timeRightNow));
    var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()(date).diff(this.timeRightNow));
    if (difference / 60000 > 90) {
      return true;
    } else {
      return false;
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "statusLabel", function statusLabel(date) {
    var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_12_moment___default()().diff(date));
    if (difference / 60000 > 90) {
      return "Offline";
    } else {
      return "Online";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "panelPower", function panelPower(PVChargingPower) {
    // console.log(parameters);
    var power = this.roundUp(PVChargingPower * 1 / 1000);
    return power + " kW";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "powerToday", function powerToday(power) {
    return this.roundUp(power) + " kWh";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "sortDevice", function sortDevice(params) {
    this.sortField = params[0].field;
    this.sortOrder = params[0].type;
    return params;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "fetchDevices", function fetchDevices() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "getCurrentCustomerDeviceIds", function getCurrentCustomerDeviceIds() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var httpUtils, userId, url, result, res;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              httpUtils = _this6.$httpUtils;
              userId = _this6.getUserSession.id;
              url = "/installations?filter={\"where\":{\"and\": [{\"userId\":" + userId + "}, {\"or\":[{ \"status\": \"requested\"},{ \"status\": \"commissioned\"},{ \"status\": \"completed\"}]}]}}";
              _context4.next = 5;
              return httpUtils.instance.get(url);

            case 5:
              result = _context4.sent;

              console.log("******", result);
              res = result.data.map(function (item) {
                return item.CID;
              });

              _this6.$store.commit("setAssignedDevices", res);
              return _context4.abrupt("return", res);

            case 10:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "currentTime", function currentTime() {
    var _this7 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee5() {
      var me, HTTP, response, tmpDate;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              me = _this7;
              HTTP = _this7.$httpUtils.instance;
              _context5.next = 4;
              return HTTP.get("https://arnergy.com/weather-api/time/?" + Date.now());

            case 4:
              response = _context5.sent;

              if (!response) {
                _context5.next = 9;
                break;
              }

              if (!response.data.datetime) {
                _context5.next = 9;
                break;
              }

              tmpDate = response.data.datetime.split(".")[0];
              return _context5.abrupt("return", tmpDate);

            case 9:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "get", function get() {
    this.$socket.emit("get", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ action: "sendMessage" }), function (response) {
      console.log(response);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "add", function add() {
    // Emit the server side
    this.$socket.emit("add", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ action: "sendMessage" }));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, "sleep", function sleep(ms) {
    // console.log(ms + "here");

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
      return setTimeout(resolve, ms);
    });
  }), _extends2)),
  watch: {
    paginatedInfo: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee6(n, o) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(n.first !== o.first)) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams));

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function paginatedInfo(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return paginatedInfo;
    }(),
    getSortOrder: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee7(n, o) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(n.sortField !== o.sortField || n.sortOrder !== o.sortOrder)) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams, { sortField: this.selectedField(n.sortField), sortOrder: n.sortOrder }));

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getSortOrder(_x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return getSortOrder;
    }(),
    tableOptions: function () {
      var _ref3 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee8(n, o) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(n.currentPage !== o.currentPage || n.currentPerPage !== o.currentPerPage)) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams));

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function tableOptions(_x6, _x7) {
        return _ref3.apply(this, arguments);
      }

      return tableOptions;
    }(),
    searchTerm: Object(__WEBPACK_IMPORTED_MODULE_20__utils_util__["a" /* debounce */])(function () {
      var _ref4 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee9(n, o) {
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(n !== o)) {
                  _context9.next = 3;
                  break;
                }

                _context9.next = 3;
                return this.getDevices(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, this.getParams));

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      return function (_x8, _x9) {
        return _ref4.apply(this, arguments);
      };
    }(), 600)
  },
  created: function created() {},
  mounted: function mounted() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.mark(function _callee10() {
      var timeRightNow, deviceIds, assignedDevices, filtrdIssues;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              // this.checkOnboardedCustomer(this.getUserSession.id)
              _this8.toggleFilters();
              _this8.totalDevicesShowing = _this8.filteredAllDevices.length;
              // https://worldtimeapi.org/api/timezone/Africa/Lagos
              // await this.
              if (_this8.$can("see", "installation")) {
                _this8.showOffOnlinelineDevices = _this8.getPerformanceFilter;
              }
              _context10.next = 5;
              return _this8.currentTime();

            case 5:
              _this8.timeRightNow = _context10.sent;
              timeRightNow = _this8.timeRightNow;
              // console.log({timeRightNow});

              if (!_this8.$can("am", "customer")) {
                _context10.next = 23;
                break;
              }

              if (!(_this8.getAssignedDevices != null)) {
                _context10.next = 12;
                break;
              }

              _context10.t0 = _this8.getAssignedDevices;
              _context10.next = 15;
              break;

            case 12:
              _context10.next = 14;
              return _this8.getCurrentCustomerDeviceIds();

            case 14:
              _context10.t0 = _context10.sent;

            case 15:
              deviceIds = _context10.t0;

              if (!(deviceIds.length < 1)) {
                _context10.next = 19;
                break;
              }

              _this8.showOffOnlinelineDevices = null;
              return _context10.abrupt("return");

            case 19:
              _context10.next = 21;
              return _this8.performanceGraphCall2({
                timeRN: _this8.timeRightNow,
                arrayOfIds: deviceIds
              });

            case 21:
              _context10.next = 33;
              break;

            case 23:
              if (!_this8.$can("am", "sm")) {
                _context10.next = 30;
                break;
              }

              // I am a section manager...
              assignedDevices = [];

              try {
                assignedDevices = JSON.parse(_this8.getUserSession.assignedDevices);
              } catch (error) {
                assignedDevices = _this8.getUserSession.assignedDevices.split(",");
              }
              _context10.next = 28;
              return _this8.performanceGraphCall2({
                timeRN: _this8.timeRightNow,
                arrayOfIds: assignedDevices
              });

            case 28:
              _context10.next = 33;
              break;

            case 30:
              if (!_this8.$can("manage", "allDevices")) {
                _context10.next = 33;
                break;
              }

              _context10.next = 33;
              return _this8.performanceGraphCall2({
                timeRN: _this8.timeRightNow
              });

            case 33:
              filtrdIssues = _this8.filterIssues();

              _this8.setCriticalSystems(filtrdIssues);

            case 35:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this8);
    }))();
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "offlineDevices",
  props: {
    showOfflineDevices: {
      type: Number,
      default: null
    },
    showCritical: { type: Boolean },
    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredOffLineDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_2__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["offLineDeviceList", "getGlobalTableOptions", "devicePayload"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    pagination: {
      get: function get() {
        return this.devicePayload;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_3_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onSortChange: function onSortChange(params) {
      this.$emit("sortData", params);
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ offLineDeviceList: this.offLineDeviceList });
  }
});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Badge"]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui__["Button"]);
var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "offlineDevices",
  props: {
    showAlarmDevices: {
      type: Number,
      default: null
    },
    showCritical: { type: Boolean },
    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredAlarmDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_6__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["offLineDeviceList", "getGlobalTableOptions", "devicePayload", "filteredAlarmDevices"]), {
    alarmFields: {
      get: function get() {
        return [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.fields_), [{
          key: "flags",
          label: "Alarms",
          sortable: "true",
          field: "flags",
          filterable: true
        }]);
      }
    },
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    pagination: {
      get: function get() {
        return this.devicePayload;
      }
    },
    getAllAlarms: {
      get: function get() {
        return this.filteredAlarmDevices;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 20,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      badgeTypes: {
        "warning": {
          type: "warning",
          label: "Minor"
        },
        "error": {
          type: "danger",
          label: "Major"
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_5_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    },
    onSortChange: function onSortChange(params) {
      this.$emit("sortData", params);
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ offLineDeviceList: this.offLineDeviceList });
  }
});

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_status_indicator__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__ = __webpack_require__(49);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "onlineDevices",
  props: {
    showOnlineDevices: {
      type: Number,
      default: null
    },
    showCritical: { type: Boolean },
    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    activeTab: { type: Boolean },
    filteredOnlineDevices: { type: Array }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_4__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_3__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["onLineDevices", "getGlobalTableOptions", "devicePayload"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    pagination: {
      get: function get() {
        return this.devicePayload;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      // details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onSortChange: function onSortChange(params) {
      this.$emit("sortData", params);
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });

      if (this.activeTab === true) {
        // console.log("Online"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // vm.$forceUpdate();
    // window.location.reload();
    // console.log({ onLineDevices: this.onLineDevices });
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_grey_battery__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__ = __webpack_require__(141);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AllDevices",
  props: {
    showAllDevices: {
      type: Number,
      default: null
    },
    tableRowClicked: { type: Function },
    formatDate: { type: Function },
    fields_: { type: Array },
    items: { type: Array },
    searchTerm: { type: String },
    total: { type: Number },
    activeTab: { type: Boolean },
    showCritical: { type: Boolean },
    filteredAllDevices: { type: Array, default: [] }
  },
  components: {
    Battery: __WEBPACK_IMPORTED_MODULE_3__kitchen_grey_battery__["a" /* default */],
    Status: __WEBPACK_IMPORTED_MODULE_4__kitchen_status_indicator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["graphDeviceDetails", "getGlobalTableOptions", "devicePayload"]), {
    tableOptions: {
      get: function get() {
        return this.getGlobalTableOptions.performance;
      }
    },
    pagination: {
      get: function get() {
        return this.devicePayload;
      }
    }
  }),
  data: function data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      allDevices: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setGlobalTableOptions"]), {
    showPaginatedInfo: function showPaginatedInfo(paginatedInfoString) {
      this.$emit("paginated-info", paginatedInfoString);
    },
    emitChange: function emitChange() {
      this.$emit("getDevicesData");
    },
    onSortChange: function onSortChange(params) {
      this.$emit("sortData", params);
    },
    statusCalc: function statusCalc(date) {
      var difference = Math.abs(__WEBPACK_IMPORTED_MODULE_2_moment___default()(date).diff(this.timeRightNow));
      if (difference / 60000 > 90) {
        return true;
      } else {
        return false;
      }
    },
    onPageChange: function onPageChange(params) {
      var tmpState = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.getGlobalTableOptions, {
        performance: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params)
      });
      if (this.activeTab === true) {
        // console.log("All"+this.activeTab );
        this.setGlobalTableOptions(tmpState);
      }

      this.emitChange();

      // console.log(params.currentPerPage, "()()")
      // params.currentPage - current page that pagination is at
      // params.prevPage - previous page
      // params.currentPerPage - number of items per page
      // params.total - total number of items in the table
    }
  }),
  mounted: function mounted() {
    // $forceUpdate();
    // window.location.reload();
    // console.log({ filteredAllDevices: this.filteredAllDevices });
  }
});

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__ = __webpack_require__(2686);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: "",

    data: function data() {
        return {
            reports: [],
            fetchData: {
                data: {
                    config: {
                        include: "",
                        parameters: [{
                            key: "",
                            options: "",
                            type: ""
                        }],
                        where: ""
                    },
                    endpoint: "",
                    id: 0,
                    title: ""
                }, // this will be removed...
                includes: [],
                endpoints: "",
                titles: []
            },
            postData: {
                endpoint: "",
                includes: [],
                filter: []
            },
            output: [],
            loading: false,
            tableOptions: [],
            outputList: []
        };
    },


    components: {
        LoadingComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["e" /* LoadingComponent */],
        CheckboxComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["a" /* CheckboxComponent */],
        EmptyViewComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["b" /* EmptyViewComponent */],
        ShowIncludesContent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["g" /* ShowIncludesContent */],
        FilterInputComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["c" /* FilterInputComponent */],
        SelectReportComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["f" /* SelectReportComponent */],
        FilterSelectComponent: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyReportComponents_index__["d" /* FilterSelectComponent */]
    },

    computed: {},

    watch: {},

    methods: {
        getReports: function getReports() {
            var _this = this;

            var HTTP = this.$httpUtils.instance;
            var container = this;
            HTTP.get("/reporting").then(function (reports) {
                container.reportData = reports.data;
                _this.reports = container.reportData;

                // fetch all titles
                _this.fetchAllTitles();
            });
        },
        showAlarm: function showAlarm() {
            __WEBPACK_IMPORTED_MODULE_6_element_ui__["Notification"].error({
                title: 'Error',
                dangerouslyUseHTMLString: true,
                message: 'Kindly select a report to filter.'
            });
        },
        fetchAllTitles: function fetchAllTitles() {
            var _this2 = this;

            this.reports.forEach(function (item) {
                _this2.fetchData.titles.push(item.title);
            });
        },


        /**
         * Emitted methods
         */
        updateSelectedReport: function updateSelectedReport(selectedTitle, selectedEndpoint) {
            var _this3 = this;

            this.output = [];
            this.postData.includes = [];
            this.postData.filter = [];

            this.reports.forEach(function (item) {
                if (item.title == selectedTitle && item.endpoint == selectedEndpoint) {
                    _this3.fetchData.data = item; //update fetch data data
                    _this3.postData.endpoint = selectedEndpoint; // update postData endpoint value
                }
            });
        },
        fetchReport: function fetchReport() {
            var _this4 = this;

            if (this.postData.endpoint == '') {
                // show error notification
                this.showAlarm();
                return;
            }

            this.loading = true; //enable loading

            // prepare request
            var HTTP = this.$httpUtils.instance;
            var endpoint = this.postData.endpoint;
            endpoint += "?";

            // includes
            if (this.postData.includes.length > 0) {
                this.postData.includes.forEach(function (item) {
                    endpoint += "filter[include]=" + item.value + "&";
                });
            }

            // console.log('includes', this.postData.includes)

            // filters
            if (this.postData.filter.length > 0) {
                this.postData.filter.forEach(function (item) {
                    if (item.value != '') {
                        endpoint += "filter[where][" + item.field + "]=" + item.value + "&";
                    }
                });
            }

            // send data
            // console.log(endpoint)
            var container = this;
            HTTP.get(endpoint).then(function (reports) {
                // console.log(reports.data)
                _this4.output = reports.data;
                _this4.loading = false; // disable loading
            });
        },


        /**
         * handle $children events
         */
        _checkboxSelected: function _checkboxSelected(input, status) {
            var includes = this.postData.includes;


            var title = JSON.parse(input);
            if (status) {
                includes.push(title);
            } else {
                includes.forEach(function (item) {
                    if (item.value == title.value) {
                        var value = includes.indexOf(item);
                        includes.splice(value, 1);
                    }
                });
            }
        },
        _updateInputFilter: function _updateInputFilter(val) {
            this.updateFiltersItem(val);
        },
        _setFilterSelect: function _setFilterSelect(val) {
            this.updateFiltersItem(val);
        },


        /**
         * Misc methods
         */
        hasIncludes: function hasIncludes() {
            // is this not too long bayii?
            if (JSON.parse(this.fetchData.data.config.include.length) > 0) {
                return true;
            }
            return false;
        },
        hasFilters: function hasFilters() {
            if (JSON.parse(this.fetchData.data.config.parameters.length) > 1) {
                return true;
            }
            return false;
        },
        returnIncludes: function returnIncludes() {
            return JSON.parse(this.fetchData.data.config.include);
        },
        returnFilters: function returnFilters() {
            return this.fetchData.data.config.parameters;
        },
        removeDollarSign: function removeDollarSign(val) {
            try {
                var firstLetter = val.charAt(0);
                if (firstLetter == "$") {
                    return val.substring(1);
                }
            } catch (error) {
                console.log(error);
            }
            return val;
        },
        updateFiltersItem: function updateFiltersItem(input) {
            var userInput = JSON.parse(input);
            var filter = this.postData.filter;


            filter.forEach(function (item) {
                if (item.field == userInput.field) {
                    var value = filter.indexOf(item);
                    filter.splice(value, 1);
                }
            });
            filter.push(userInput);
        },
        tableColumns: function tableColumns(data) {
            var finalOutput = [];
            // const output = Object.keys(data[0]);
            __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(data[0]).forEach(function (item) {
                finalOutput.push({
                    label: item,
                    field: item
                });
            });
            return finalOutput;
        },


        // tableRows(data){
        //     const finalOutput = [];
        //     data.forEach(item => {
        //         finalOutput.push(Object.values(item))
        //     })
        //     console.log('final output', data)
        //     return finalOutput;
        // },

        isObjectType: function isObjectType(value) {

            var includedValues = this.postData.includes;

            if (includedValues.length > 0) {
                for (var i = 0; i < includedValues.length; i++) {
                    if (includedValues[i].value == value) {
                        // return includedValues[i].value;
                        return true;
                    }
                }
            }

            // includedValues.forEach(item => {
            //     if(item.value == value){
            //         output = true;
            //         // return true;
            //     }
            // })

            return false;
        },
        displayValue: function displayValue(data) {
            var _this5 = this;

            var htmlData = "";
            if ((typeof data === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(data)) == 'object') {
                try {
                    var obj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(data);
                    // const titles = Object.keys(data);
                    // const titles = data;
                    // console.log('the titles: ', titles)
                    obj.forEach(function (item) {
                        if (__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(item[1]) == 'object' && item[1] != null) {
                            htmlData += "\n                                <div class=\"container\">\n                                    <div class=\"row\" style=\"padding:4px\">\n                                        <div class=\"col-xs-12\"><strong>" + item[0] + "</strong></div>\n                                        <div class=\"col-xs-12\">" + _this5.displayObjChild(item[1]) + "</div>\n                                    </div>\n                                </div>\n                            ";
                        } else {
                            htmlData += "\n                                <div class=\"container\">\n                                    <div class=\"row\" style=\"padding:4px\">\n                                        <div class=\"col-xs-3\">" + item[0] + ":</div>\n                                        <div class=\"col-xs-9\">" + item[1] + "</div>\n                                    </div>\n                                </div>\n                            ";
                        }
                    });
                } catch (error) {
                    console.log(error);
                }
            }

            return htmlData;
        },
        displayObjChild: function displayObjChild(val) {
            var htmlData = "";
            var obj = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(val);
            obj.forEach(function (item) {
                htmlData += "\n                    <div class=\"container\">\n                        <div class=\"row\" style=\"padding:4px\">\n                            <div class=\"col-xs-3\">" + item[0] + ":</div>\n                            <div class=\"col-xs-9\">" + item[1] + "</div>\n                        </div>\n                    </div>\n                ";
            });
            return htmlData;
        },
        downloadReport: function downloadReport() {
            // let csv = 'Name,Title\n';
            var csv = this._getFieldTitles(this.output);
            var data = this._getFieldValues(this.output);

            // console.log(csvData);
            // return;

            // const data = [
            //     ['Foo', 'programmer'],
            //     ['Bar', 'bus driver'],
            //     ['Moo', 'Reindeer Hunter']
            // ];

            data.forEach(function (row) {
                csv += row.join(',');
                csv += "\n";
            });

            // console.log(csv);
            var hiddenElement = document.createElement('a');
            hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
            hiddenElement.target = '_blank';
            hiddenElement.download = 'reports.csv';
            hiddenElement.click();
        },
        _getFieldTitles: function _getFieldTitles(array) {
            return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(array[0]).toString() + '\n';
        },
        _getFieldValues: function _getFieldValues(array) {
            var output = [];
            array.forEach(function (item) {
                output.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(item));
            });
            return output;
        }
    },

    mounted: function mounted() {
        var _this6 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this6.getReports();

                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, _this6);
        }))();
    }
});

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "CheckboxComponent",
    props: {
        title: {
            type: String,
            required: true
        }
    },
    data: function data() {
        return {
            checked: false
        };
    },

    methods: {
        checkboxSelect: function checkboxSelect(e) {
            this.checked = !this.checked;
            var output = {
                "value": this.title
            };
            this.$emit('checkboxSelected', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(output), this.checked);
        }
    }
});

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "EmptyViewComponent"
});

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "FilterInputComponent",
    props: {
        placeholder: {}
    },
    data: function data() {
        return {
            name: "",
            input: ""
        };
    },

    methods: {
        inputChanged: function inputChanged() {
            var output = {
                "field": this.placeholder,
                "value": this.input
            };
            this.$emit('updateInputFilter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(output));
        }
    }
});

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "SelectReportComponent",
    props: {
        title: {
            type: String,
            required: true
        },
        reports: {},
        options: {}
    },
    data: function data() {
        return {
            selected: ""
        };
    },

    methods: {
        setDefaultAndUpdateParent: function setDefaultAndUpdateParent() {
            var _this = this;

            this.reports.forEach(function (item) {
                if (item.title == _this.selected) {
                    // send item title and endpoint to parent
                    // best would have been to send `id` instead of these other ones
                    _this.$emit('updateSelectedReport', _this.selected, item.endpoint);
                }
            });
        }
    },
    mounted: function mounted() {
        // this.setDefaultAndUpdateParent();
    }
});

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "FilterSelectComponent",
    props: {
        placeholder: {},
        options: {}
    },
    data: function data() {
        return {
            name: "",
            input: "",
            key: "",
            showTitle: true
        };
    },
    mounted: function mounted() {},

    methods: {
        parseRadioOptions: function parseRadioOptions(val) {
            var newOptions = [];
            var options = JSON.parse(val);
            options.forEach(function (item) {
                return newOptions.push(item.status);
            });
            return newOptions;
        },
        selectOption: function selectOption(event) {
            var output = {
                "field": this.placeholder,
                "value": this.key
            };
            this.$emit('setFilterSelect', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(output));
        }
    }
});

/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LoadingComponent"
});

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_button__ = __webpack_require__(2707);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: "ShowIncludesContent",
    components: {
        "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__["a" /* Offcanvas */],
        "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
        "vk-offcanvas-content": __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__["c" /* OffcanvasContent */],
        "vk-button": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_button__["a" /* Button */]
    },
    props: {
        row: { required: true },
        field: { required: true }
    },
    data: function data() {
        return {
            output: {},
            show: false
        };
    },

    methods: {
        parsePropsValue: function parsePropsValue() {
            this.output = this.row[this.field];
        },
        parseOutputData: function parseOutputData() {
            var htmlData = "<table class=\"vgt-table bordered \"><tbody>";
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(this.output).forEach(function (item) {
                htmlData += "\n                    <tr>\n                        <td class=\"vgt-left-align\"><strong>" + item[0] + ":</strong></td>\n                        <td class=\"vgt-left-align\">" + item[1] + "</td>\n                    </tr>\n                ";
            });
            htmlData += "</tbody></table>";

            return htmlData;
        }
    },
    mounted: function mounted() {
        this.parsePropsValue();
    }
});

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__invoices__ = __webpack_require__(2711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__ = __webpack_require__(23);










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    Invoices: __WEBPACK_IMPORTED_MODULE_10__invoices__["a" /* default */],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_12_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_11_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      errors: [],
      installationOptions: [],
      installationOptionsTest: [],
      showOffCanvas: false,
      isSending: false,
      isDispatching: false,
      contactList: [],
      form: {
        user: null,
        invoiceType: "subscription",
        orderVat: 0,
        contact: null,
        amount: null,
        installation: null,
        comment: null,
        period: null
      }
    };
  },

  computed: {},
  methods: {
    validate: function validate() {
      var err = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "user":
              if (value === "null" || value === "") {
                err[field] = "Select a user.";
              }
              break;
            case "invoiceType":
              if (value === "null" || value === "") {
                err[field] = "Choose invoice type.";
              }
              break;
            case "installation":
              if (value === "null" || value === "") {
                err[field] = "Select an installation.";
              }
              break;
            case "amount":
              if (value === "null" || value === "") {
                err[field] = "Amount cannot be empty.";
              }
              break;
            case "comment":
              if (value === "null" || value === "") {
                err[field] = "Description can not be empty.";
              }
              break;
            case "period":
              if (value === "null" || value === "") {
                err[field] = "Select billing period.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
      //   console.log(this.errors);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      try {
        var HTTP = this.$httpUtils.instance;
        var container = this;
        this.validate();
        var errorLength = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.errors).length;
        //   console.log(errorLength);
        if (errorLength > 0) {
          this.errorMessage = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(this.errors).join("<br>");
          this.displayError = true;
          setTimeout(function () {
            _this.displayError = false;
          }, 3000);
          this.showErrorMsg({
            message: this.errorMessage
          });
        } else {
          // console.log({ reqPayload: this.form.installation });
          // return;
          var reqPayload = {
            payload: this.form,
            userId: this.form.user.id,
            type: this.form.invoiceType,
            paymentMode: this.form.installation.deviceRequest.paymentModel
          };

          // return;
          var url = "/invoices";
          this.isSending = true;
          HTTP.post(url, reqPayload).then(function (response) {
            _this.isSending = false;
            container.showOffCanvas = false;
            container.showSuccessMsg({
              message: "Invoice Sent!"
            });
            setTimeout(function () {
              // window.location.reload();
            }, 1000);
          }).catch(function (error) {
            _this.isSending = false;
            container.showErrorMsg({
              message: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(error.response.data.error.details.messages)
            });
          });
        }
      } catch (error) {
        console.log({ error: error });
      }
    },
    installationSelected: function installationSelected(installation) {
      var modelMap = {
        OS: "OUTRIGHT",
        ES: "ENERGY AS A SERVICE",
        LO: "LEASE TO OWN"
      };
      // console.log({ installation, deviceRequest: installation.deviceRequest });
      // let ctx = this;
      // ctx.form.installation = installation;
      //   console.log(installation.deviceRequest.paymentModel,modelMap[installation.deviceRequest.paymentModel]);
      this.form["comment"] = "" + (modelMap[installation && installation.deviceRequest && installation.deviceRequest.paymentModel] || "OUTRIGHT");
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this2 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this2.createFilter(queryString, contact);
      }) : contacts;
      cb(results);
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(contact) {
      console.log({ contact: contact });
      this.form.user = contact;
      this.form.installation = null;
      console.log({ installation: contact.installations });
      if (contact.installations && contact.installations.length > 0) {
        console.log({ installationIn: contact.installations });
        // this.installationOptions = contact.installations;
        this.installationOptionsTest = contact.installations.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, x, {
            value: x,
            label: (x.CID ? x.CID : x.solarKitIds) + " - " + x.name + " (" + x.deviceType.name + ")"
          });
        });
        console.log({ installationOptions: this.installationOptions });
      }
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var filter = {
        include: { installations: ["deviceRequest", "deviceType"] },
        roleType: "customer"
      };
      var url = "/users?filter=" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(filter);
      HTTP.get(url).then(function (response) {
        container.contactList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    submitInvoice: function submitInvoice() {
      //  let url = `/invoices?filter=${JSON.stringify(filter)}`;
    },
    DispatchInvoice: function DispatchInvoice() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      var data = this.$refs.invoiceComponent.selectedRow;
      var container = this;
      if (!data) return;
      try {
        var reqPayload = {
          invoiceIDs: data
        };
        var url = "invoices/bulk-invoice-reminder";
        this.isDispatching = true;
        HTTP.post(url, reqPayload).then(function (response) {
          _this3.isDispatching = false;
          container.showSuccessMsg({
            message: "Invoice Sent!"
          });
          setTimeout(function () {
            // window.location.reload();
          }, 1000);
        });
      } catch (error) {
        this.isDispatching = false;
        container.showErrorMsg({
          message: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(error.response.data.error.message)
        });
      }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this4.fetchUsers();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }
});

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// eslint-disable-next-line



__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedRow: null,
      searchTerm: "",
      isLoadingVGT: true,
      items: items,
      tableOptions: [{
        field: "name",
        label: "Name",
        sortable: "true"
      }, {
        field: "type",
        label: "Invoice Type",
        sortable: "true"
      }, {
        field: "invoiceNo",
        label: "Invoice Number",
        sortable: "true"
      }, {
        field: "paymentModel",
        label: "Payment Model",
        sortable: "true"
      },
      // {
      //   field: "packageName",
      //   label: "Package Name",
      //   sortable: "true"
      // },
      {
        field: "price",
        label: "Amount",
        sortable: "true"
      }, {
        field: "date",
        label: "Date",
        sortable: "true"
      }, {
        field: "status",
        label: "Status",
        sortable: "true"
      }, {
        field: "action",
        label: "Action",
        sortable: "true"
      }],
      customerTableOptions: [{
        field: "name",
        label: "Name",
        sortable: "true"
      }, {
        field: "type",
        label: "Invoice Type",
        sortable: "true"
      }, {
        field: "invoiceNo",
        label: "Invoice Number",
        sortable: "true"
      },
      // {
      //   field: "packageName",
      //   label: "Package Name",
      //   sortable: "true"
      // },
      {
        field: "paymentModel",
        label: "Payment Model",
        sortable: "true"
      }, {
        field: "price",
        label: "Amount",
        sortable: "true"
      }, {
        field: "date",
        label: "Date",
        sortable: "true"
      }, {
        field: "action",
        label: "Action",
        sortable: "true"
      }],
      invoiceList: "",
      currentPage: 1,
      details: "UserDetails",
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null
    };
  },

  components: {},
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    isACustomer: {
      get: function get() {
        if (this.$can("am", "customer")) {
          return true;
        } else {
          return false;
        }
      }
    }
  }),
  methods: {
    selectionChanged: function selectionChanged(e) {
      if (e.selectedRows.length <= 0) {
        this.selectedRow = null;
        return;
      }
      var obj = e.selectedRows;
      this.selectedRow = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return obj[key].id;
      });
      return;
    },
    viewStatus: function viewStatus(row) {
      // console.log(row);
      this.$router.push({
        //path: `/invoices/:${row.id}`,
        name: "singleinvoice",
        params: {
          single: row.id
        }
      });
    },
    numberWithCommas: function numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    searchTable: function searchTable(invoiceList, tableOptions, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(invoiceList).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("Do MMM YYYY");
    },
    viewMaintenance: function viewMaintenance(maintenance) {
      this.selectedMaintenance = maintenance;
      this.showOffCanvas = true;
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    onFiltered: function onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    init: function init() {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var userId = this.getUserSession.id;
      // console.log('userID', userId);
      var realm = this.getUserSession.realm;
      var filter = void 0;
      filter = {
        order: "id DESC",
        where: {
          or: [{ type: "subscription" }, { type: "autoMonthlySubscription" }]
        },
        limit: 150,
        include: ["user"]
      };
      if (this.$can("am", "customer")) {
        filter = {
          order: "id DESC",
          where: {
            and: [{ userId: userId }, {
              or: [{ type: "subscription" }, { type: "autoMonthlySubscription" }]
            }]
          },
          limit: 150,
          include: ["user"]
        };
      }
      var url = "/invoices?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter);
      //let url = `/maintenance?filter={"where":{"assignedTo":${userId}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // if (this.$can("am", "engineer")) {
      //     url = `/maintenance?filter={"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // } else if (this.$can("manage", "customer")) {
      //     url = `/maintenance?filter={"where":{"realm":{"$regex" :"^${realm}"}},"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // } else if (this.$can("read", "all")) {
      //     url = `/maintenance?filter={"include": [{"installation":"deviceType"},"operationsEngineer",{"comments":"user"}]}`;
      // }
      httpUtils.instance.get(url).then(function (response) {
        console.log("===============================");

        // console.log(response);

        _this.invoiceList = response.data;
        _this.isLoadingVGT = false;
        // this.invoiceList.map(i => {
        //   console.log(i);
        // });
      }).catch(function (error) {
        _this.errors = "Error occured at our end!";
        _this.invoiceList = "";
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.init();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fingerprintjs2__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_EditInvoice__ = __webpack_require__(2717);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "el-card": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Card"],
    Rave: __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment___default.a,
    EditInvoice: __WEBPACK_IMPORTED_MODULE_7__kitchen_EditInvoice__["a" /* default */],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__["b" /* OffcanvasClose */]
  },
  data: function data() {
    return {
      //invoiceId : this.$route,
      downloadLink: window.location.href,
      ispayed: false,
      transDone: false,
      transComplete: false,
      showOffCanvas: false,
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      // raveKey: "FLWPUBK_TEST-89e9c4e181bd9559a5d47e738cb3363a-X",
      invoiceData: {
        payload: {
          user: {
            email: ""
          }
        }
      },
      priceData: [],
      paymentAmount: 0.0,
      paymentData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      payment: [{
        label: "Description",
        key: "description",
        field: "description",
        sortable: "true"
      }, {
        label: "Amount",
        key: "price",
        field: "price",
        sortable: "true"
      }],
      notifications: {
        showSuccessMsg: {
          type: "success",
          title: "Success",
          message: "Success Msg!"
        },
        showInfoMsg: {
          type: "info",
          title: "Information",
          message: "Info. Msg!"
        },
        showWarnMsg: {
          type: "warning",
          title: "Warning",
          message: "Warning Msg!"
        },
        showErrorMsg: {
          type: "error",
          title: "Error",
          message: "Error Msg!"
        }
      }
    };
  },

  methods: {
    getInvoiceData: function getInvoiceData(id) {
      var _this = this;

      var httpUtils = this.$httpUtils;
      var filter = void 0;
      filter = {
        order: "id DESC",

        limit: 1,
        include: ["user"]
      };
      var url = "/invoices/" + id + "?filter=" + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(filter);
      httpUtils.instance.get(url).then(function (response) {
        _this.invoiceData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, response.data, {
          type: "subscription"
        });
        _this.paymentAmount = _this.invoiceData.payload.invoiceTotalAmount || _this.invoiceData.payload.amount || 0.0;
        var ispayed = _this.invoiceData.ispayed;

        console.log({ ispayed: ispayed, invoiceData: _this.invoiceData });
        _this.ispayed = ispayed;

        console.log("invoice_data", _this.invoiceData);
      }).catch(function (error) {
        _this.errors = "Error occured at our end!";
        _this.invoiceData = {};
      });
    },
    numberWithCommas: function numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },

    callback: function callback(response) {
      var trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      if (trRef.data.status === "successful") {
        this.transDone = true;
        this.notifications.showSuccessMsg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.notifications.showSuccessMsg, {
          message: "Transaction Successful"
        });
        this.transComplete = this.concludeTransaction(trRef.data.txRef, this.$route.params.single);
      } else this.notifications.showErrorMsg = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.notifications.showErrorMsg, {
        message: "Transaction fails"
      });
      this.close();
    },
    close: function close() {
      console.log("Payment closed");
      window.location.reload();
    },
    concludeTransaction: function concludeTransaction(txRef, requestId) {
      var _this2 = this;

      var data = true;
      var str = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        txref: txRef,
        requestId: requestId
      });
      var tempReg = JSON.parse(str);
      var HTTP = this.$httpUtils.instance;
      var url = "/payments/initial/request";
      return HTTP.post(url, tempReg).then(function (response) {
        _this2.myResponse = response.data.data[0];
        data = true;
        return true;
      }).catch(function (error) {
        console.log(error);
        var errorMsg = error.response.data.message;
        _this2.showErrorMsg({
          message: errorMsg
        });
        return false;
      });
      return data;
    },
    updatePaymentData: function updatePaymentData() {
      this.paymentData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.paymentData, {
        firstname: this.getUserSession.firstName,
        lastname: this.getUserSession.lastName,
        email: this.getUserSession.email,
        phonenumber: this.getUserSession.phoneNumber,
        name: this.getUserSession.firstName + " " + this.getUserSession.lastName
      });
    },
    triggerPayment: function triggerPayment() {
      document.getElementById("paymentbtn").click();
    },
    convertToPdf: function convertToPdf() {
      // var doc = new jsPDF();
      // doc.text(20, 20, 'Hello world!');
      // doc.text(20, 30, 'This is client-side Javascript to generate a PDF.');
      // // Add new page
      // doc.addPage();
      // doc.text(20, 20, 'Visit CodexWorld.com');
      // // Save the PDF
      // doc.save('document.pdf');
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  mounted: function mounted() {
    this.getInvoiceData(this.$route.params.single);
    var container = this;
    var fp = __WEBPACK_IMPORTED_MODULE_5_fingerprintjs2___default()();
    this.updatePaymentData();
    fp.get(function (result, components) {
      container.paymentData.deviceFingerprint = result; // a hash, representing your device fingerprint
      container.paymentData.device_fingerprint = {
        result: result,
        components: components
      }; // an array of FP components
    });
  }
});

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ArnergyLoader__ = __webpack_require__(414);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "EditInvoice",
  components: {
    "arnergy-loader": __WEBPACK_IMPORTED_MODULE_6__ArnergyLoader__["a" /* default */]
  },
  props: {
    invoiceId: { required: true },
    options: {}
  },
  data: function data() {
    return {
      formParams: {
        paymentType: "",
        paymentRef: ""
      },
      formErrors: {
        paymentType: "",
        paymentRef: ""
      },
      showLoading: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  mounted: function mounted() {},

  methods: {
    selectOption: function selectOption(event) {
      console.log(event);
    },
    doUpdate: function doUpdate(e) {
      var _this = this;

      e.preventDefault();
      this.formErrors = this._doValidate();

      if (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(this.formErrors).length > 0) return;

      var data = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.formParams, {
        paymentType: this.formParams.paymentType,
        paymentRef: this.formParams.paymentRef,
        invoiceID: this.invoiceId
      });

      var HTTP = this.$httpUtils.instance;

      this.showLoading = true;
      HTTP.post("/invoices/status/update", data).then(function (res) {
        _this.showLoading = false;
        _this.showSuccessMsg({ message: "Invoice Successfully updated" });
        //@todo: do something more interesting than reload
        window.location.reload();
      }).catch(function (e) {
        var errorMessage = e.response.data.error.message || "Something went wrong, please try again.";
        _this.showLoading = false;
        _this.showErrorMsg({ message: errorMessage });
      });
    },
    _doValidate: function _doValidate() {
      var formErrors = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.formParams)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "paymentType":
              if (value === "null" || value === "") {
                formErrors[field] = "paymentType cannot be empty.";
              }
              break;
            case "paymentRef":
              if (value === "null" || value === "") {
                formErrors[field] = "paymentRef cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    }
  }
});

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__add__ = __webpack_require__(2723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__edit__ = __webpack_require__(2726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "device-chart",
  props: {},
  components: {
    Add: __WEBPACK_IMPORTED_MODULE_7__add__["a" /* default */],
    Edit: __WEBPACK_IMPORTED_MODULE_8__edit__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    return {
      addOffCanvas: false,
      editOffCanvas: false,
      previewOffCanvas: false,
      loadingSend: false,
      loadingReminder: false,
      selectedRow: null,
      installationList: [],
      form: {
        user: {
          address: ""
        },
        installation: null,
        filterDate: [],
        sendDate: ""
      },
      columns: [{
        label: "ID",
        field: "uid"
      }, {
        label: "First Name",
        field: "firstName"
      }, {
        label: "Last Name",
        field: "lastName"
      }, {
        label: "Email",
        field: "email"
      }, {
        label: "Payment Model",
        field: "paymentModel"
      }, {
        label: "Amount (#)",
        field: "amountString",
        type: "number"
      }, {
        label: "Billing Period",
        field: "billingPeriod",
        type: "string"
      }, {
        label: "is Billing Period updated",
        field: "isBillingUpdated",
        type: "boolean",
        hidden: true
      }], //isBillingUpdated
      subs: []
    };
  },
  methods: {
    selectionChanged: function selectionChanged(e) {
      if (e.selectedRows.length <= 0) return this.selectedRow = null;
      var obj = e.selectedRows;
      var data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).map(function (key) {
        return obj[key].id;
      });
      this.selectedRow = data;
      if (data.length <= 0) return this.selectedRow = null;
      this.selectedRow = data;
      console.log(this.selectedRow);
    },
    rowStyleClassFn: function rowStyleClassFn(row) {
      return row.isBillingUpdated ? "green-border" : "red-border";
    },
    toggleAdd: function toggleAdd() {
      var ctx = this;
      ctx.addOffCanvas = !ctx.addOffCanvas;
    },
    toggleEdit: function toggleEdit() {
      var ctx = this;
      ctx.editOffCanvas = !ctx.editOffCanvas;
    },
    togglePreview: function togglePreview() {
      var ctx = this;
      ctx.previewOffCanvas = !ctx.previewOffCanvas;
    },
    onRowClick: function onRowClick(params) {
      var ctx = this;
      console.log({ row: params.row });
      //  this.removeComma(params.row.amount);
      ctx.form = params.row;
      // ctx.form.amount=this.removeComma(params.row.amount);
      ctx.toggleEdit();
    },
    removeComma: function removeComma(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return parseFloat(val.replace(/,/g, "")).toFixed(2);
      } else {
        return "";
      }
    },
    getContacts: function getContacts() {
      var HTTP = this.$httpUtils.instance;
      var ctx = this;
      var filter = {
        where: {
          and: [{ CID: { neq: null } }, {
            or: [{ status: "requested" }, { status: "scheduled" }, { status: "commissioned" }, { status: "completed" }]
          }]
        },
        include: ["deviceRequest", "locations", "user"]
      };
      var url = "/installations?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter);
      HTTP.get(url).then(function (response) {
        console.log({ response: response.data });

        ctx.installationList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            value: x && x.deviceRequest ? x.name + " (" + (x.CID ? x.CID : x.solarKitIds) + ") " : null
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    sendReminder: function sendReminder() {
      try {
        var ctx = this;
        var HTTP = ctx.$httpUtils.instance;
        ctx.loadingReminder = true;
        var url = "/subscriptionsMgr/autoMonthlySubsReminderRe_sender/" + this.getUserSession.id;
        HTTP.post(url).then(function (response) {
          ctx.loadingReminder = false;
          console.log({ response: response });
          alert("sent");
        }).catch(function (error) {
          var response = error.response;

          ctx.loadingReminder = false;
          console.error({
            error: error.response ? error.response.status == 422 ? error.response.data.error.message : error.response : null
          });
          var errMsg = error.response ? error.response.status == 422 ? error.response.data.error.message : error.response : null;
          console.log({ tttttt: response });
          if (response.status == 422) {} else alert(response.data.error.message);
        });
      } catch (error) {}
      return;
    },
    sendIvoices: function sendIvoices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var ctx, HTTP, url, userId, subs, status;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ctx = _this;
                HTTP = ctx.$httpUtils.instance;
                url = "/subscriptionsMgr/autoMonthlySubsReminder/" + _this.getUserSession.id;
                userId = _this.getUserSession.id;

                console.log({ subs: _this.subs });

                subs = _this.subs;
                _context.next = 8;
                return subs.reduce(function () {
                  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                  var v = arguments[1];

                  if (!v.isBillingUpdated) {
                    status = v.isBillingUpdated;
                  }
                  return status;
                }, true);

              case 8:
                status = _context.sent;

                if (!status) {
                  alert("One or more records billing period are months behind.");
                } else {
                  ctx.loadingSend = true;
                  HTTP.post(url).then(function (response) {
                    ctx.loadingSend = false;
                    console.log({ response: response });
                    alert("sent");
                  }).catch(function (error) {
                    ctx.loadingSend = false;
                    var response = error.response;

                    if (response && response.status == 400) {
                      alert(response.data.error.message);
                    }
                    console.log({ error: error });
                  });
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    numberWithCommas: function numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    getSubs: function getSubs() {
      var _this2 = this;

      var ctx = this;
      var HTTP = ctx.$httpUtils.instance;

      var url = "/subscriptionsMgr";
      HTTP.get(url).then(function (response) {
        ctx.subs = response.data.map(function (x, i) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            uid: ++i,
            installation: x.user.firstName + " " + x.user.lastName + " (" + x.CID + ")",
            firstName: x.user.firstName,
            lastName: x.user.lastName,
            email: x.user.email,
            billingPeriod: __WEBPACK_IMPORTED_MODULE_9_moment___default()(x.filterDate[0]).format("YYYY-MM-DD") + " - " + __WEBPACK_IMPORTED_MODULE_9_moment___default()(x.filterDate[1]).format("YYYY-MM-DD"),
            isBillingUpdated: __WEBPACK_IMPORTED_MODULE_9_moment___default()(x.filterDate[1]) < __WEBPACK_IMPORTED_MODULE_9_moment___default()(new Date()).startOf("month") ? false : true,
            amountString: _this2.numberWithCommas(parseFloat(x.amount).toFixed(2))
          });
        });
        console.log({ subs: ctx.subs });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  created: function created() {
    var ctx = this;
    ctx.getSubs();
    ctx.getContacts();
  }
});

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "add-subs",
  props: {
    toggleAdd: {
      type: Function
    },
    getSubs: {
      type: Function
    },
    addOffCanvas: {
      type: Boolean,
      default: false
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_1_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_2_element_ui__["Autocomplete"]
  },
  computed: {
    getCurrentMonth: function getCurrentMonth() {
      var date = __WEBPACK_IMPORTED_MODULE_3_moment___default()().format("MMMM YYYY");
      return date;
    }
  },
  data: function data() {
    return {
      loading: false,
      form: {
        amount: "",
        title: "",
        description: "",
        orderVat: "7.5",
        installation: null,
        paymentModel: "",
        ccEmails: "",
        user: {
          ccEmails: "",
          address: ""
        },
        filterDate: [],
        location: "",
        sendDate: ""
      }
    };
  },
  methods: {
    logDate: function logDate() {
      console.log({ data: this.form.filterDate });
    },
    add: function add(e) {
      e.preventDefault();
      var ctx = this;
      var HTTP = ctx.$httpUtils.instance;
      console.log({ form: ctx.form });
      if (ctx.form.installation == null || ctx.form.amount < 5 || ctx.form.location == "" || ctx.form.paymentModel == null || ctx.form.user.address == "" || ctx.form.sendDate == "" || ctx.form.filterDate.length < 2) {
        alert("All fields are required");
        return;
      }
      var data = ctx.form;
      delete data.installation;

      ctx.loading = true;
      var url = "/subscriptionsMgr";
      HTTP.post(url, data).then(function (response) {
        console.log({ response: response });
        ctx.getSubs();
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: "",
          sendDate: ""
        };
        ctx.loading = false;
      }).catch(function (error) {
        ctx.loading = false;
        var errorMsg = error.response.data.error.message;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        console.log({ errorMsg: errorMsg });
        alert(errorMsg);
      });
    },
    installationSearch: function installationSearch(queryString, cb) {
      var _this = this;

      var installationList = this.installationList;
      var results = queryString ? installationList.filter(function (installation) {
        return _this.createFilter(queryString, installation);
      }) : installationList;
      cb(results);
    },
    createFilter: function createFilter(queryString, installation) {
      // console.log({ name: installation });
      return (installation.name + " - " + installation.CID).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    noPaymentModelChange: function noPaymentModelChange(paymentModel) {
      var ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    contactSelected: function contactSelected(installation) {
      var ctx = this;
      var form = ctx.form;
      var deviceRequest = installation.deviceRequest,
          user = installation.user,
          locations = installation.locations;

      console.log({ location: deviceRequest });

      var paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location = typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription: function getDescription(paymentModel) {
      var desc = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc = "Subscription for the month of " + this.getCurrentMonth;
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc = "Repayment for the month of " + this.getCurrentMonth;
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle: function getTitle(paymentModel) {
      var title = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          title = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "LEASE TO OWN REPAYMENT";
          break;
        default:
          title = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created: function created() {
    var ctx = this;
  }
});

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__preview__ = __webpack_require__(2728);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "edit-subs",
  props: {
    toggleEdit: {
      type: Function
    },
    editOffCanvas: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object
    },
    getSubs: {
      type: Function
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_2_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Autocomplete"],
    Preview: __WEBPACK_IMPORTED_MODULE_6__preview__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    getCurrentMonth: function getCurrentMonth() {
      var date = __WEBPACK_IMPORTED_MODULE_5_moment___default()().format("MMMM YYYY");
      return date;
    }
  }),
  data: function data() {
    return {
      loading: false,
      loadingDel: false,
      loadingEdit: false,
      previewOffCanvas: false,
      showModal: false,
      previewLoading: false,
      previewData: {}
    };
  },
  methods: {
    togglePreview: function togglePreview() {
      var ctx = this;
      ctx.previewOffCanvas = !ctx.previewOffCanvas;
    },
    setShowModal: function setShowModal(v) {
      this.showModal = v;
    },
    preview: function preview(e) {
      e.preventDefault();
      var ctx = this;
      var HTTP = ctx.$httpUtils.instance;

      var data = ctx.form;
      ctx.previewLoading = true;
      var url = "/subscriptionsMgr/preview/" + this.getUserSession.id + "/" + data.id;
      HTTP.get(url).then(function (response) {
        ctx.previewLoading = false;
        var data = response.data.data;

        console.log({ data: data });
        ctx.previewData = data;
        ctx.showModal = !ctx.showModal;
      }).catch(function (error) {
        ctx.previewLoading = false;
        console.log({ error: error });
      });
      return;
    },
    deleteSub: function deleteSub(e) {
      e.preventDefault();
      var ctx = this;
      ctx.loading = true;
      ctx.loadingDel = true;
      var HTTP = ctx.$httpUtils.instance;
      var data = ctx.form;
      var url = "/subscriptionsMgr/" + data.id;
      HTTP.delete(url).then(function (response) {
        ctx.loading = false;
        ctx.loadingDel = false;
        ctx.getSubs();
        ctx.toggleEdit();
        console.log({ response: response });
      }).catch(function (error) {
        ctx.loading = false;
        ctx.loadingDel = false;

        var errorMsg = error.response.data.error.message;
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        console.log({ errorMsg: errorMsg });
        alert(errorMsg);
      });
      console.log({ HERE: "Dlete" });
    },
    edit: function edit(e) {
      e.preventDefault();
      var ctx = this;
      if (ctx.form.installation == null || ctx.form.amount < 5 || ctx.form.location == undefined || ctx.form.location == "" || ctx.form.paymentModel == null || ctx.form.user.address == undefined || ctx.form.user.address == "" || ctx.form.sendDate == undefined || ctx.form.sendDate == "" || ctx.form.filterDate == undefined || ctx.form.filterDate.length < 2) {
        alert("All fields are required");
        return;
      }
      ctx.loading = true;
      ctx.loadingEdit = true;
      var HTTP = ctx.$httpUtils.instance;
      console.log({ form: ctx.form });

      delete ctx.form.installation;
      var data = ctx.form;
      var url = "/subscriptionsMgr/" + data.id;
      HTTP.put(url, data).then(function (response) {
        ctx.loading = false;
        ctx.loadingEdit = false;
        ctx.getSubs();
        ctx.toggleEdit();
        console.log({ response: response });
      }).catch(function (error) {
        var errorMsg = error.response.data.error.message;
        ctx.loading = false;
        ctx.loadingEdit = false;

        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error));
        console.log({ errorMsg: errorMsg });
        alert(errorMsg);
      });
    },
    installationSearch: function installationSearch(queryString, cb) {
      var _this = this;

      var installationList = this.installationList;
      var results = queryString ? installationList.filter(function (installation) {
        return _this.createFilter(queryString, installation);
      }) : installationList;
      cb(results);
    },
    noPaymentModelChange: function noPaymentModelChange(paymentModel) {
      var ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    createFilter: function createFilter(queryString, installation) {
      return (installation.name + " - " + installation.CID).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(installation) {
      // console.log({ installation });

      var ctx = this;
      var form = ctx.form;
      var deviceRequest = installation.deviceRequest,
          user = installation.user,
          locations = installation.locations;
      // console.log({ location: deviceRequest });

      var paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location = typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: "",
          sendDate: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription: function getDescription(paymentModel) {
      var desc = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc = "Subscription for the month of " + this.getCurrentMonth;
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc = "Repayment for the month of " + this.getCurrentMonth;
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle: function getTitle(paymentModel) {
      var title = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "LEASE TO OWN REPAYMENT";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created: function created() {
    var ctx = this;
  }
});

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "preview-subs",
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    previewData: {
      type: Object,
      default: {}
    }
  },
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_0_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_0_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_1_element_ui__["Autocomplete"]
  },
  data: function data() {
    return {
      loading: false,
      loadingDel: false,
      loadingEdit: false,
      date: __WEBPACK_IMPORTED_MODULE_2_moment___default()().format("YYYY/MM/DD")
    };
  },

  methods: {
    handleModal: function handleModal() {
      this.$emit("showModalUpdate", !this.showModal);
    },
    numberWithCommas: function numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    edit: function edit(e) {},
    installationSearch: function installationSearch(queryString, cb) {
      var _this = this;

      var installationList = this.installationList;
      var results = queryString ? installationList.filter(function (installation) {
        return _this.createFilter(queryString, installation);
      }) : installationList;
      cb(results);
    },
    noPaymentModelChange: function noPaymentModelChange(paymentModel) {
      var ctx = this;

      ctx.form.description = ctx.getDescription(paymentModel);
      ctx.form.title = ctx.getTitle(paymentModel);
    },
    createFilter: function createFilter(queryString, installation) {
      return (installation.name + " - " + installation.CID).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(installation) {
      // console.log({ installation });

      var ctx = this;
      var form = ctx.form;
      var deviceRequest = installation.deviceRequest,
          user = installation.user,
          locations = installation.locations;
      // console.log({ location: deviceRequest });

      var paymentModel = deviceRequest.paymentModel;
      if (paymentModel == "LO" || paymentModel == "ES") {
        form.paymentModel = paymentModel;
        form.description = ctx.getDescription(paymentModel);
        form.title = ctx.getTitle(paymentModel);
        form.userId = user.id;
        form.CID = installation.CID;
        form.installationId = installation.id;
        // User
        form.user.firstName = user.firstName;
        form.user.lastName = user.lastName;
        form.user.email = user.email; //
        form.user.ccEmails = user.ccEmails; //
        form.user.id = user.id; //
        // Location
        form.location = typeof locations == "undefined" ? "" : locations.streetRoute;

        ctx.form = form;
      } else {
        ctx.form = {
          amount: "",
          title: "",
          description: "",
          orderVat: "7.5",
          installation: null,
          paymentModel: "",
          ccEmails: "",
          user: {
            address: ""
          },
          filterDate: [],
          location: ""
        };
        alert("Only ES and LO are Allowed");
      }
    },
    getDescription: function getDescription(paymentModel) {
      var desc = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          desc = "Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          desc = "Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return desc;
    },
    getTitle: function getTitle(paymentModel) {
      var title = "";
      var md = paymentModel != null ? paymentModel.toUpperCase() : "";
      switch (md) {
        case "ES":
          title = "ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION";
          break;
        case "OS":
          desc = "OUTRIGHT SALE";
          break;
        case "LO":
          title = "ARNERGY 5000 - LEASE TO OWN REPAYMENT";
          break;
        default:
          desc = "MONTHLY SUBSCRIPTION";
          break;
      }
      return title;
    }
  },
  created: function created() {
    var ctx = this;
    // alert(ctx.previewOffCanvas)
  }
});

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mockData_sectors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mockData_sectors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__mockData_sectors_json__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "add-subs",
  props: {
    toggleAdd: {
      type: Function
    },
    getSubs: {
      type: Function
    },
    showOffCanvas: {
      type: Boolean,
      default: false
    },
    installationList: {
      type: Array
    }
  },
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_9_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioButton"]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    paymentModel: function paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  }),
  data: function data() {
    var _deviceRequest;

    return {
      loading: false,
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: (_deviceRequest = {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "4279069.77",
            orderVat: 7.5,
            setupFee: "",
            monthlyFee: "",
            cautionFee: "",
            grandTotal: ""
          },
          proposedLocation: "",
          term: "",
          filterDate: [],
          systemCapacity: 5,
          orderVat: 7.5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          title: "Outright sale"
        }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_deviceRequest, "comment", "Design, Installation, Commissioning and Managed Service of a 4.5KW Solar PV System with 10.8kWh Lithium Storage"), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_deviceRequest, "sendMail", true), _deviceRequest)
      },
      discountType: "percent",
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: 7.5
        },
        desc: ""
      }
    };
  },
  methods: {
    calculatePayment: function calculatePayment() {
      var ctx = this;
      var paymentModel = ctx.regDataParams.deviceRequest.paymentModel;

      var _ctx$getComment = ctx.getComment(paymentModel),
          comment = _ctx$getComment.comment,
          title = _ctx$getComment.title;

      ctx.regDataParams.deviceRequest.comment = comment;
      ctx.regDataParams.deviceRequest.title = title;
      switch (paymentModel) {
        case "OS":
          ctx.regDataParams.deviceRequest.priceModel.amount = 4279069.77;
          ctx.regDataParams.deviceRequest.priceModel.amountVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.amount, ctx.regDataParams.deviceRequest.priceModel.orderVat);
          ctx.regDataParams.deviceRequest.priceModel.grandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.amount) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.amountVAT);

          ctx.regDataParams.deviceRequest.priceModel.amountPaymentB4Delivery = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.grandTotal, 90);
          ctx.regDataParams.deviceRequest.priceModel.amountBalanceAfterInstalation = ctx.getVatValue(parseFloat(ctx.regDataParams.deviceRequest.priceModel.grandTotal), 10);
          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });

          break;
        case "ES":
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 366279.07;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 75069.77;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 225209.3;

          ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.setupFee, ctx.regDataParams.deviceRequest.priceModel.orderVat);
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.monthlyFee, ctx.regDataParams.deviceRequest.priceModel.orderVat);
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.cautionFee, ctx.regDataParams.deviceRequest.priceModel.orderVat);

          ctx.regDataParams.deviceRequest.priceModel.setupFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT);

          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFee) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT);

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFee) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT);

          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });

          break;
        case "LO":
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 366279.07;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 154697.67;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 154697.67;

          // Discoount
          console.error({
            orderDicount: ctx.regDataParams.deviceRequest.orderDiscount
          });

          ctx.regDataParams.deviceRequest.priceModel.setupFeeDiscount = ctx.regDataParams.deviceRequest.priceModel.setupFee;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeDiscount = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.monthlyFee, ctx.regDataParams.deviceRequest.orderDiscount);
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeDiscount = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.cautionFee, ctx.regDataParams.deviceRequest.orderDiscount);

          // VAT
          ctx.regDataParams.deviceRequest.priceModel.setupFeeVAT = 0.0;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.monthlyFee, ctx.regDataParams.deviceRequest.priceModel.orderVat);
          ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.cautionFee, ctx.regDataParams.deviceRequest.priceModel.orderVat);
          // Grand total
          ctx.regDataParams.deviceRequest.priceModel.setupFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee) - parseFloat(ctx.regDataParams.deviceRequest.priceModel.setupFee);

          ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFee) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFeeVAT);

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFee) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFeeVAT);

          ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotalPlusMonthlyFeeGrandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.cautionFeeGrandTotal) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.monthlyFeeGrandTotal);
          console.error({ price: ctx.regDataParams.deviceRequest.priceModel });
          break;

        default:
          ctx.regDataParams.deviceRequest.priceModel.amount = 0;
          ctx.regDataParams.deviceRequest.priceModel.setupFee = 0;
          ctx.regDataParams.deviceRequest.priceModel.monthlyFee = 0;
          ctx.regDataParams.deviceRequest.priceModel.cautionFee = 0;
          break;
      }
    },
    getComment: function getComment(paymentModel) {
      var response = {};
      switch (paymentModel) {
        case "ES":
          response.title = "Energy as a Service Purchase Setup";
          response.comment = "Design, Installation, Commissioning and Managed Service of an 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "LO":
          response.title = "LEASE TO OWN SERVICE";
          response.comment = "Design, Installation, Commissioning and Managed Service of an 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage";
          break;
        case "OS":
          response.title = "Outright sale";
          response.comment = "Design, Installation, Commissioning and Managed Service of a 4.5KW Solar PV System with 10.8kWh Lithium Storage";
          break;

        default:
          response.title = "";
          response.comment = "";
          break;
      }
      return response;
    },
    getVatValue: function getVatValue(val) {
      var percent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7.5;

      if (val != "" && val != null && typeof val != "undefined") {
        return (parseFloat(val) * percent / 100).toFixed(2);
      } else {
        return "";
      }
    },
    numberWithCommas: function numberWithCommas(val) {
      if (val != "" && val != null && typeof val != "undefined") {
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "";
      }
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var regDataParams, HTTP, resp, _error$response$data$, details, message, error_incomming, tempMsg;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.form.package == null)) {
                  _context.next = 4;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select a device type"
                });
                _context.next = 47;
                break;

              case 4:
                if (!(_this.form.sector == null)) {
                  _context.next = 8;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select an sector"
                });
                _context.next = 47;
                break;

              case 8:
                _this.regDataParams.deviceRequest.deviceTypeId = _this.form.package;
                // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
                // this.regDataParams.deviceRequest.orderVat = this.orderVat;
                regDataParams = _this.regDataParams;
                // let orderDiscount = this.orderDiscount;
                // let orderVat = this.orderVat;
                //console.log(this.contactList);
                //console.log(this.form);

                console.error({ regDataParams: regDataParams });
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(regDataParams.deviceRequest.priceModel).forEach(function (key, i) {
                  return regDataParams.deviceRequest.priceModel[key] = _this.numberWithCommas(parseFloat(regDataParams.deviceRequest.priceModel[key]).toFixed(2));
                });
                // console.error({ regDataParams });

                // return;
                HTTP = _this.$httpUtils.instance;

                console.log(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(regDataParams));
                _this.loading = true;
                _context.prev = 15;

                if (!(_this.form.invoiceType == "initial")) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return HTTP.post("/users", regDataParams);

              case 19:
                _context.t0 = _context.sent;
                _context.next = 25;
                break;

              case 22:
                _context.next = 24;
                return HTTP.post("/device_requests", __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, regDataParams.deviceRequest, {
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: _this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: _this.form.userId
                }));

              case 24:
                _context.t0 = _context.sent;

              case 25:
                resp = _context.t0;

                _this.loading = false;
                _this.showSuccessMsg({ message: "Request Submitted" });
                //   // this.activeTab="manage_requests";
                //   // this.renderManageComponent= true;
                _this.showOffCanvas = false;
                _this.toggleAdd();
                // this.$router.push({
                //   name: "devices",
                //   params: {
                //     activetab: "manage_requests"
                //   }
                // });
                //   this.$router.go();
                _context.next = 47;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context["catch"](15);

                _this.loading = false;

                if (!_context.t1.response) {
                  _context.next = 46;
                  break;
                }

                if (!_context.t1.response.data) {
                  _context.next = 46;
                  break;
                }

                // console.log(error.response.data);
                _error$response$data$ = _context.t1.response.data.error, details = _error$response$data$.details, message = _error$response$data$.message;

                console.log({ message: message, details: details });

                error_incomming = undefined !== message ? message : details.messages;
                // typeof error.response.data.error === undefined
                //   ? error.response.data.error.messages
                //   : error.response.data.error.details.messages;
                // error_incomming;

                console.log(error_incomming);

                if (!(typeof error_incomming === "string")) {
                  _context.next = 44;
                  break;
                }

                _this.showErrorMsg({
                  message: error_incomming
                });
                return _context.abrupt("return");

              case 44:
                tempMsg = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(error_incomming).map(function (x) {
                  return x + ": " + error_incomming[x].join(",");
                });

                _this.showErrorMsg({
                  message: tempMsg.join("<br>")
                });

              case 46:
                console.log({
                  error: _context.t1
                });

              case 47:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[15, 32]]);
      }))();
    },
    logDate: function logDate() {
      console.log({ data: this.form.filterDate });
    },
    changeContact: function changeContact() {
      // console.log({ customerList: this.customerList });

      this.form.invoiceType == "initial" ? this.contactList = this.ZcontactList : this.contactList = this.customerList;
    },
    calcSetup: function calcSetup(price) {
      var setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      var temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub: function calcSub(price) {
      var subscriptionPercent = Number(this.selectedPaymentModel["Subscription"]) / 100;
      var temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution: function calcCaution(price) {
      var cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      var temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this2 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this2.createFilter(queryString, contact);
      }) : contacts;
      // console.log({ results });
      cb(results);
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
      this.regDataParams.deviceRequest.installationName = contact["First_Name"] + " " + contact["Last_Name"];
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    createSectorFilter: function createSectorFilter(queryString, sector) {
      console.log({ sector: sector });
      return ("" + sector.value.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    sectorSearch: function sectorSearch(queryString, cb) {
      var _this3 = this;

      //  sectorList;
      // console.log({sectorList});
      var results = queryString ? __WEBPACK_IMPORTED_MODULE_10__mockData_sectors_json___default.a.filter(function (sect) {
        return _this3.createSectorFilter(queryString.trim(), sect);
      }) : __WEBPACK_IMPORTED_MODULE_10__mockData_sectors_json___default.a;
      // console.log({ results });
      cb(results);
    },
    sectorSelected: function sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = "" + sector.value;
    },
    packageSelected: function packageSelected() {
      var _this4 = this;

      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(function (x) {
        return x.id == _this4.form.package;
      })["price"];
      // this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      // this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(
      //   this.form.price
      // );
      // this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(
      //   this.form.price
      // );
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context2.sent;

                _this5.zohoToken = newToken.data.token;
                _this5.showErrorMsg({
                  message: "Token refreshed, Please reload page"
                });
                // this.loadAll();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    loadAll: function loadAll() {
      var _this7 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        // console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this7.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      //  filter={"include": ["installations"]} customer
      var url = "/users?filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.customerList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this8.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  created: function created() {
    var ctx = this;
    ctx.regDataParams.deviceRequest.priceModel.amount = 4279069.77;
    ctx.regDataParams.deviceRequest.priceModel.amountVAT = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.amount);
    ctx.regDataParams.deviceRequest.priceModel.grandTotal = parseFloat(ctx.regDataParams.deviceRequest.priceModel.amount) + parseFloat(ctx.regDataParams.deviceRequest.priceModel.amountVAT);

    ctx.regDataParams.deviceRequest.priceModel.amountPaymentB4Delivery = ctx.getVatValue(ctx.regDataParams.deviceRequest.priceModel.grandTotal, 90);
    ctx.regDataParams.deviceRequest.priceModel.amountBalanceAfterInstalation = ctx.getVatValue(parseFloat(ctx.regDataParams.deviceRequest.priceModel.grandTotal), 10);
    console.error({ price: ctx.regDataParams.deviceRequest.priceModel });
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this9.fetchPackageConfig();

            case 2:
              tmpPackageConfig = _context4.sent;

              _this9.packageConfigs = tmpPackageConfig["data"];
              _this9.regDataParams.deviceRequest = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, _this9.regDataParams.deviceRequest, {
                salesManager: _this9.getUserSession.firstName + " " + _this9.getUserSession.lastName,
                salesManagerContact: "" + _this9.getUserSession.phoneNumber
              });
              _this9.loadAll();
              _this9.fetchUsers();
              _this9.fetchSysTypes();

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this9);
    }))();
  }
});

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_customBox__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_customGridBox__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_customGeoBox__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_customChart__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_customDatePicker__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_customPieChart__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */















__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Card"]);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Select"]);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Option"]);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["OptionGroup"]);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["Input"]);
__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_element_ui__["InputNumber"]);

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inverterId: null,
      batteryData: {},
      inverterData: {},
      energyData: {},
      pieChart: {},
      loadingChartData: false,
      batteryDataLabel: [{
        type: "value",
        name: " %",
        min: 0,
        max: 100,
        interval: 20,
        axisLabel: {
          formatter: "{value}",
          color: "#959490"
        },
        splitLine: {
          lineStyle: {
            color: "transparent"
          }
        }
      }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  components: {
    // GreyPagination
    "custom-box": __WEBPACK_IMPORTED_MODULE_5__components_customBox__["a" /* default */],
    "custom-grid-box": __WEBPACK_IMPORTED_MODULE_6__components_customGridBox__["a" /* default */],
    "custom-geo-box": __WEBPACK_IMPORTED_MODULE_7__components_customGeoBox__["a" /* default */],
    "custom-chart": __WEBPACK_IMPORTED_MODULE_8__components_customChart__["a" /* default */],
    "custom-pie-chart": __WEBPACK_IMPORTED_MODULE_10__components_customPieChart__["a" /* default */],
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_12_element_ui__["DatePicker"],
    "custom-date-picker": __WEBPACK_IMPORTED_MODULE_9__components_customDatePicker__["a" /* default */]
  },
  methods: {
    handleOnChartReady: function handleOnChartReady() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, headers, data, resp, DevData;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this;
                _context.prev = 1;

                container.loadingChartData = true;
                // var inverterId = "411241";
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "HourlyChart",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + _this.$route.params.deviceId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_14_moment___default()(new Date().toISOString()).startOf("day").toDate(),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: 1440,
                  ScanIndexForward: true
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_13__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                });

              case 7:
                resp = _context.sent;
                DevData = resp.data.Items.map(function (v) {
                  return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, v, {
                    EnergyData: v.FV >= 1.76 || v.FV == 1.11 ? v.EnergyData.Data[0] : v.EnergyData
                  });
                });
                // let { FV } = DevData;
                // console.log({ DevData });

                _this.batteryData = {
                  title: "Battery Level/Load (%)",
                  timeStamps: _this.getTimeLabel(DevData),
                  seriesData: _this.batteryDataChart(DevData),
                  yAxisLabel: _this.batteryDataLabel
                };
                _this.inverterData = {
                  title: "PV Yield/System Output",
                  timeStamps: _this.getTimeLabel(DevData),
                  seriesData: _this.inverterDataChart(DevData),
                  yAxisLabel: [{
                    type: "value",
                    name: "kW",
                    min: 0,
                    // max: 100,
                    // interval: 10,
                    splitNumber: 3,
                    axisLabel: {
                      formatter: "{value}",
                      color: "#959490"
                    },
                    splitLine: {
                      lineStyle: {
                        // color: "#eee"
                      }
                    }
                  }]
                };
                _this.energyData = {
                  title: "Energy Data",
                  timeStamps: _this.getTimeLabel(DevData),
                  seriesData: _this.energyDataChart(DevData)
                };
                _this.pieChart = {
                  title: "Energy Source(kW)",
                  data: _this.pieChartData(DevData)
                };
                container.loadingChartData = false;
                _context.next = 22;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);

                console.log("********************************************************");
                console.log(_context.t0);
                container.loadingChartData = false;
                console.log("********************************************************");

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 16]]);
      }))();
    },
    batteryDataChart: function batteryDataChart(displayData) {
      // console.log({ displayData });
      var seriesData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrBatteryData({
        data: displayData,
        color: "green",
        type: "line"
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrDecoration({
        data: this.computeLoadPercent(displayData, "max"),
        color: "red",
        title: "Output Load"
      })), [{
        name: "Output Load (avg)",
        legend: "Output Load",
        type: "bar",
        smooth: false,
        symbol: "none",
        // stack: "ol",
        barGap: 0,
        // areaStyle: {},
        itemStyle: {
          color: "rgba(16, 156, 241,0.4)" // blue
        },
        // yAxisIndex: 1,
        data: this.computeLoadPercent(displayData, "avg")
      }]);

      return seriesData;
    },
    inverterDataChart: function inverterDataChart(displayData) {
      var seriesData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrPvChargingPower({
        data: displayData,
        color: "blue",
        type: "bar"
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrDecoration({
        data: this.computeACOAP(displayData, "max"),
        color: "green",
        title: "Output Power"
      })));

      return seriesData;
    },
    energyDataChart: function energyDataChart(displayData) {
      console.log({ displayData: displayData });
      var seriesData = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrGeneratednX({
        data: displayData,
        color: "blue",
        type: "bar"
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrConOnGrd({
        data: displayData,
        color: "yellow",
        type: "bar"
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.arrConOffGrd(displayData, "red")));

      return seriesData;
    },
    pieChartData: function pieChartData(displayData) {
      var result = [{
        value: this.computePieChartData(displayData, "pvSource"),
        name: "PV",
        itemStyle: {
          color: "rgba(16, 156, 241,0.4)" // blue
        }
      }, {
        value: this.computePieChartData(displayData, "gridSource"),
        name: "Grid",
        itemStyle: {
          color: "rgba(255, 185, 70,0.47)" // yellow
        }
      }, {
        value: this.computePieChartData(displayData, "batterySource"),
        name: "Battery",
        itemStyle: {
          color: "rgba(250, 113, 111, 0.46)" // red
        }
      }];
      return result;
    },
    computePieChartData: function computePieChartData(arrData, key) {
      var result = arrData.filter(function (item) {
        if (!item["loadEnergySource"] || !item["loadEnergySource"][key]) return;
        return item["loadEnergySource"][key];
      });

      if (result.length < 1) return;

      return Math.round(result.reduce(function (total, item) {
        return total + item["loadEnergySource"][key];
      }, 0) / result.length / 1000);
    },


    // computePieChartData(arrData, key) {
    //   const objData = arrData[arrData.length - 1];
    //   console.log(objData["loadEnergySource"][key]);
    //   if(!objData["loadEnergySource"] || !objData["loadEnergySource"][key]) return
    //   return objData["loadEnergySource"][key];
    // },

    // @todo: this should be extracted to a global util class
    computeBatteryData: function computeBatteryData(arrData, str) {
      return arrData.map(function (item) {
        if (item["Battery"] && item["Battery"]["SOC"]) {
          switch (str) {
            case "max":
              return item["Battery"]["SOC"]["max"];
            case "min":
              return item["Battery"]["SOC"]["min"];
            case "avg":
              return item["Battery"]["SOC"]["avg"];
            default:
              return item["Battery"]["SOC"]["max"];
          }
        } else {
          return 0;
        }
      });
    },


    // @todo: this should be extracted to a global util class
    computePVChargingPower: function computePVChargingPower(arrData) {
      var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "v3";
      var str = arguments[2];

      return arrData.map(function (item) {
        // const powerKey = `PVCgP${version == "v4" ? "1" : ""}`;
        var chgPwr = item.InverterData["PVCgP"] || item.InverterData["PVCgP1"];
        if (chgPwr) {
          switch (str) {
            case "max":
              return chgPwr["max"] / 1000;
            case "min":
              return chgPwr["min"] / 1000;
            case "avg":
              return chgPwr["avg"] / 1000;
            default:
              return chgPwr["max"] / 1000;
          }
        } else {
          return 0;
        }
      });
    },
    computeLoadPercent: function computeLoadPercent(arrData, str) {
      return arrData.map(function (item) {
        if (item["InverterData"]["OL%"]) {
          switch (str) {
            case "max":
              return item["InverterData"]["OL%"]["max"];
            case "min":
              return item["InverterData"]["OL%"]["min"];
            case "avg":
              return item["InverterData"]["OL%"]["avg"];
            default:
              return item["InverterData"]["OL%"]["max"];
          }
        } else {
          return 0;
        }
      });
    },
    computeEnergyData: function computeEnergyData(arrData, key) {
      return arrData.map(function (item) {
        if (!item["EnergyData"] || !item["EnergyData"][key]) return;
        return item["EnergyData"][key] / 1000;
      });
    },
    arrDecoration: function arrDecoration(_ref) {
      var data = _ref.data,
          color = _ref.color,
          title = _ref.title;

      return [
      // {
      //   name: title,
      //   // legend: title,
      //   type: "pictorialBar",
      //   symbol: "rect",
      //   itemStyle: {
      //     color: this.getColor(color, "0.1")
      //   },
      //   symbolRepeat: true,
      //   symbolSize: [12, 4],
      //   symbolMargin: 1,
      //   data: data
      // },
      {
        name: title,
        legend: title,
        type: "line",
        smooth: true,
        symbol: "emptyCircle",
        showAllSymbol: true,
        symbolSize: 10,
        barGap: 0,
        stack: "ol",
        itemStyle: {
          color: this.getColor(color, "0.5")
        },
        data: data
      }];
    },
    arrBatteryData: function arrBatteryData(_ref2) {
      var data = _ref2.data,
          color = _ref2.color,
          type = _ref2.type;

      return [{
        name: "Battery Level",
        legend: "Battery Level",
        type: type,
        smooth: true,
        // symbol: "none",
        stack: "battery",
        itemStyle: {
          color: this.getColor(color, "0.4")
        },
        data: this.computeBatteryData(data, "max")
      }, {
        name: "Battery Level (avg)",
        // legend: "Battery Level",
        type: type,
        smooth: true,
        // symbol: "none",
        // areaStyle: {},
        stack: "battery",
        areaStyle: {
          color: this.getColor(color, "0.2")
        },
        itemStyle: {
          color: this.getColor(color, "0.8")
        },
        data: this.computeBatteryData(data, "avg")
      }];
    },
    arrPvChargingPower: function arrPvChargingPower(_ref3) {
      var data = _ref3.data,
          color = _ref3.color,
          type = _ref3.type;

      return [{
        name: "PV Yield",
        legend: "PV Yield",
        type: type,
        barGap: 0,
        smooth: true,
        symbol: "none",
        // stack: "pvcp",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.5")
        },
        lineStyle: {
          width: 1
        },
        data: this.computePVChargingPower(data, this.$route.params.version, "max")
      }, {
        name: "PV Yield (avg)",
        // legend: "PV Charging Power",
        // legend: "PV Yield (AVG)",
        type: type,
        smooth: true,
        symbol: "none",
        // stack: "pvcp",
        areaStyle: {},
        itemStyle: {
          color: this.getColor("red", "0.5")
        },
        lineStyle: {
          width: 1
        },
        data: this.computePVChargingPower(data, this.$route.params.version, "avg")
      }, {
        name: "PV Yield (min)",
        // legend: "PV Charging Power",
        type: type,
        smooth: true,
        symbol: "none",
        // stack: "pvcp",
        areaStyle: {},
        itemStyle: {
          color: this.getColor("yellow", "0.5")
        },
        lineStyle: {
          width: 1
        },
        data: this.computePVChargingPower(data, this.$route.params.version, "min")
      }];
    },
    arrACOutputCurrent: function arrACOutputCurrent(_ref4) {
      var data = _ref4.data,
          color = _ref4.color,
          type = _ref4.type;

      return [{
        name: "Output Power (line)",
        legend: "Output Power (line)",
        type: type,
        smooth: true,
        symbol: "none",
        stack: "acaot",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.67")
        },
        lineStyle: {
          width: 1
        },
        data: this.computeACOAP(data, "max")
      }, {
        name: "AC Output Current (avg)",
        legend: "AC Output Current",
        type: type,
        smooth: true,
        symbol: "none",
        stack: "acaot",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.47")
        },
        lineStyle: {
          width: 1
        },
        data: this.computeACOAP(data, "avg")
      }, {
        name: "AC Output Current (min)",
        legend: "AC Output Current",
        type: type,
        smooth: true,
        symbol: "none",
        stack: "acaot",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.27")
        },
        lineStyle: {
          width: 1
        },
        data: this.computeACOAP(data, "min")
      }];
    },
    arrConOnGrd: function arrConOnGrd(_ref5) {
      var data = _ref5.data,
          color = _ref5.color,
          type = _ref5.type;

      return [{
        name: "Consumed On Grid (Year)",
        legend: "Consumed",
        type: type,
        symbol: "rect",
        barWidth: 15,
        itemStyle: {
          color: this.getColor(color, "0.5")
        },
        symbolRepeat: true,
        stack: "ConOGd",
        areaStyle: {
          color: this.getColor(color, "0.2")
        },
        // smooth: true,
        // symbol: "emptyCircle",
        // showAllSymbol: true,
        // symbolSize: 15,
        // barGap: 0,
        // itemStyle: {
        //   // color: "rgba(250, 113, 111, 0.7)" // red
        //   color: "rgba(16, 156, 241,0.5)" // blue
        // },
        data: this.computeEnergyData(data, "ConYOGd")
      }, {
        name: "Consumed On Grid (Month)",
        // legend: "Consumed",
        type: type,
        stack: "ConOGd",
        symbol: "rect",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.4")
        },
        // smooth: true,
        // symbol: "emptyCircle",
        // showAllSymbol: true,
        // symbolSize: 15,
        // barGap: 0,
        // itemStyle: {
        //   // color: "rgba(250, 113, 111, 0.6)" // red
        // },
        data: this.computeEnergyData(data, "ConMOGd")
      }, {
        name: "Consumed On Grid (Week)",
        // legend: "Consumed",
        type: type,
        // smooth: false,
        // symbol: "none",
        stack: "ConOGd",
        symbol: "rect",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.3")
        },
        data: this.computeEnergyData(data, "ConWOGd")
      }, {
        name: "Consumed On Grid (Today)",
        // legend: "ConTOGd",
        type: type,
        stack: "ConOGd",
        symbol: "rect",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.2")
        },
        data: this.computeEnergyData(data, "ConTOGd")
      }];
    },
    arrConOffGrd: function arrConOffGrd(displayData, color) {
      return [{
        name: "Consumed Off Grid (Year)",
        legend: "Consumed Off Grid (Year)",
        type: "bar",
        smooth: true,
        symbol: "emptyCircle",
        showAllSymbol: true,
        symbolSize: 15,
        stack: "confgd",
        barGap: 0,
        barWidth: 12,
        itemStyle: {
          color: this.getColor(color, "0.5") // red
        },
        data: this.computeEnergyData(displayData, "ConYfGd")
      }, {
        name: "Consumed Off Grid (Month)",
        legend: "ConMOGd",
        type: "bar",
        stack: "confgd",
        // smooth: true,
        // symbol: "emptyCircle",
        // showAllSymbol: true,
        // symbolSize: 15,
        itemStyle: {
          color: this.getColor(color, "0.4")
        },
        data: this.computeEnergyData(displayData, "ConMfGd")
      }, {
        name: "Consumed Off Grid (Week)",
        legend: "ConWOGd",
        stack: "confgd",
        type: "bar",
        // smooth: false,
        // symbol: "none",
        // stack: "ol",
        // barGap: 0,
        // areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.3")
        },
        // yAxisIndex: 1,
        data: this.computeEnergyData(displayData, "ConWfGd")
      }, {
        name: "Consumed Off Grid (Today)",
        legend: "ConTOGd",
        type: "bar",
        stack: "confgd",
        // barGap: 0,
        // smooth: false,
        // symbol: "none",
        itemStyle: {
          color: this.getColor(color, "0.2")
        },
        data: this.computeEnergyData(displayData, "ConTfGd")
      }];
    },
    arrGeneratednX: function arrGeneratednX(_ref6) {
      var data = _ref6.data,
          color = _ref6.color,
          type = _ref6.type;

      return [{
        name: "Generated (Year)",
        legend: "Generated (Year)",
        type: type,
        smooth: true,
        stack: "gnx",
        areaStyle: {
          color: this.getColor(color, "0.5")
        },
        itemStyle: {
          color: this.getColor(color, "0.4")
        },
        barWidth: 18,
        lineStyle: {
          width: 1
        },
        data: this.computeEnergyData(data, "GnY")
      }, {
        name: "Generated (Month)",
        // legend: "ConMOGd",
        type: type,
        smooth: true,
        // symbol: "none",
        stack: "gnx",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.3")
        },
        lineStyle: {
          width: 1
        },
        data: this.computeEnergyData(data, "GnM")
      }, {
        name: "Generated (Week)",
        // legend: "ConWOGd",
        type: type,
        smooth: true,
        symbol: "none",
        stack: "gnx",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.2")
        },
        lineStyle: {
          width: 1
        },
        data: this.computeEnergyData(data, "GnW")
      }, {
        name: "Generated (Today)",
        // legend: "ConTOGd",
        type: type,
        smooth: true,
        symbol: "none",
        stack: "gnx",
        areaStyle: {},
        itemStyle: {
          color: this.getColor(color, "0.1")
        },
        // lineStyle: {
        //   width: 1
        // },
        data: this.computeEnergyData(data, "GnT")
      }];
    },
    computeACOAP: function computeACOAP(arrData, str) {
      return arrData.map(function (item) {
        var ACOAP = item.InverterData["ACOAP"] || item.InverterData["ACOAPt"];
        if (ACOAP) {
          if (str) {
            return ACOAP[str] / 1000;
          }
          return ACOAP["max"] / 1000;
        } else {
          return 0;
        }
      });
    },
    roundUp: function roundUp(num) {
      return Math.round(num * 100) / 100;
    },
    getColor: function getColor(color, opacity) {
      switch (color) {
        case "blue":
          return "rgba(16, 156, 241, " + opacity + ")"; // blue
        case "red":
          return "rgba(250, 113, 111, " + opacity + ")"; // red
        case "green":
          return "rgba(114, 184, 76, " + opacity + ")"; // green
        case "yellow":
          return "rgba(255, 185, 70, " + opacity + ")"; // yellow
        default:
          return "rgba(${color} ${opacity})";
      }
    },
    getTimeLabel: function getTimeLabel(data) {
      return data.reduce(function (aggr, c_item) {
        aggr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(aggr), [__WEBPACK_IMPORTED_MODULE_14_moment___default()(c_item["DeviceTimeStamp"])
        // .add(1, "hour")
        // .format("h:m:s A")
        .format("D MMM YYYY HH:mm")]);
        return aggr;
      });
    }
  },
  mounted: function mounted() {
    this.inverterId = this.$route.params.deviceId;
  }
});

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-box",
  props: ["title", "value", "color", "voltage", "current", "icon", "iconLabel"],
  data: function data() {
    return {};
  },

  computed: {},
  components: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-grid-box",
  props: ["title", "value", "voltage", "leftText", "rightText"],
  data: function data() {
    return {};
  },

  computed: {},
  components: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-geo-box",
  props: ["title", "value", "color", "voltage", "current", "icon"],
  data: function data() {
    return {};
  },

  computed: {},
  components: {},
  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);


//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-chart",
  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full_js__["a" /* default */]
  },
  props: ["data", "loading"],
  watch: {
    // watch it
    data: function data(newVal, oldVal) {
      this.line.series = newVal.seriesData;
      this.line.xAxis[0].data = newVal.timeStamps;
      this.line.yAxis = newVal.yAxisLabel, this.line.title.text = newVal.title ? newVal.title : "no title";
      this.line.legend.data = this.computeLegendValues(newVal.seriesData);
    }
  },
  data: function data() {
    return {
      // initOpts: {
      //   renderer: 'svg'
      // },
      line: {
        title: {
          text: ""
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          // trigger: "axis",
          // axisPointer: {
          //   // type: "cross",
          //   label: {}
          // },
          backgroundColor: "#6a7985",
          textStyle: {
            fontSize: 12
          }
        },
        legend: {
          type: "scroll",
          right: 0,
          data: [],
          textStyle: {
            color: "#7f8b94"
          }
        },
        toolbox: {
          top: 18,
          feature: {
            // dataZoom: {
            //   yAxisIndex: "none"
            // },
            // restore: {},
            // mark: {
            //   show: true
            // },
            // dataView: {
            //   show: true,
            //   readOnly: false
            // },
            magicType: {
              title: {
                line: "Line charts",
                bar: "Bar charts",
                stack: "Stacked charts",
                tiled: "Tiled charts"
              },
              show: true,
              type: ["line", "bar"]
            },
            restore: {
              title: "Refresh",
              show: true
            },
            saveAsImage: {
              title: "Save as image",
              show: true
            }
          }
        },
        // grid: {
        //   left: "3%",
        //   right: "4%",
        //   bottom: "3%",
        //   containLabel: true
        // },
        grid: {
          top: "20%",
          left: "1%",
          right: 0,
          bottom: "8%",
          containLabel: true
          // show: true,
          // backgroundColor: "#f5f4f0"
        },
        xAxis: [{
          // name: "x",
          minorTick: {
            show: true
          },
          axisLabel: {
            color: "#959490"
          },
          splitLine: {
            lineStyle: {
              color: "#000"
            }
          },
          minorSplitLine: {
            show: true,
            lineStyle: {
              color: "#000"
            }
          },
          // type: "category",
          // boundaryGap: false,
          // splitLine: {
          //   lineStyle: {
          //     color: "#999"
          //   }
          // },
          data: []
        }],
        yAxis: [{
          type: "value",
          name: "kWh",
          min: 0,
          // max: 100,
          // interval: 10,
          splitNumber: 3,
          axisLabel: {
            formatter: "{value}",
            color: "#959490"
          },
          splitLine: {
            lineStyle: {
              color: "transparent"
            }
          }
        }],
        dataZoom: [{
          // type: "slide",
          show: true,
          start: 30,
          end: 100
        }, {
          type: "slider",
          show: true,
          start: 30,
          end: 100
        }],
        series: []
        /*
        line: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "shadow",
              label: {
                show: true
              }
            }
          },
          toolbox: {
            show: true,
            feature: {
              mark: {
                show: true
              },
              dataView: {
                show: true,
                readOnly: false
              },
              magicType: {
                show: true,
                type: ["line", "bar"]
              },
              restore: {
                show: true
              },
              saveAsImage: {
                show: true
              }
            }
          },
          calculable: true,
          legend: {
            data: ["Growth", "Budget 2011", "Budget 2012"],
            itemGap: 5
          },
          grid: {
            top: "12%",
            left: "1%",
            right: "10%",
            containLabel: true
          },
          xAxis: [
            {
              type: "category"
              // data: [],
            }
          ],
          yAxis: [
            {
              type: "value",
              name: "Consumption",
              axisLabel: {
                // formatter: function(a) {
                //   a = +a;
                // return "hello";
                // return isFinite(a) ?
                //   echarts.format.addCommas(+a / 1000) :
                //   '';
                // }
              }
            }
          ],
          dataZoom: [
            {
              show: true,
              start: 94,
              end: 100
            },
            {
              type: "inside",
              start: 94,
              end: 100
            },
            {
              show: true,
              yAxisIndex: 0,
              filterMode: "empty",
              width: 30,
              height: "80%",
              showDataShadow: false,
              left: "93%"
            }
          ],
          series: [
            {
              name: "Consumption",
              type: "bar",
              itemStyle: {
                color: "#1a93ca"
              },
              data: []
            },
            {
              name: "Solar",
              type: "bar",
              itemStyle: {
                color: "#ffe9c9"
              },
              data: []
            }
          ]
        }
        */
      } };
  },
  methods: {
    onClick: function onClick(event, instance, ECharts) {
      console.log(arguments);
    },
    onReady: function onReady(instance, ECharts) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$emit("onReady");

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    computeLegendValues: function computeLegendValues(arr) {
      console.log({ "ARRAY": arr });
      if (!Array.isArray(arr)) return [];
      return arr.map(function (item) {
        return item.legend;
      });
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "custom-date-picker",
  props: ["callbackFunc"],
  data: function data() {
    return {
      show: false,
      currentDateFilter: {},
      // custom component
      quickRanges: [{ label: "Last 2 days", number: "2", value: "day" }, { label: "Yesterday", number: "1", value: "day" }, { label: "Today", number: "0", value: "day" }, { label: "Last hour", number: "1", value: "hour" }, { label: "Last 7 days", number: "7", value: "day" }, { label: "Day before", number: "1", value: "day" }, { label: "This week", number: "0", value: "week" }, { label: "Last 3 hours", number: "3", value: "hour" }, { label: "Last 30 days", number: "30", value: "day" }, { label: "This day last week", number: "7", value: "day" }, { label: "This month", number: "0", value: "month" }, { label: "Last 6 hours", number: "6", value: "hour" }, { label: "Last 90 days", number: "90", value: "day" }, { label: "Previous week", number: "1", value: "week" }, { label: "This year", number: "0", value: "year" }, { label: "Last 2 hours", number: "2", value: "hour" }, { label: "Last 6 months", number: "6", value: "month" }, { label: "Previous month", number: "1", value: "month" }, { label: "Last year", number: "1", value: "year" }, { label: "Last 2 hours", number: "2", value: "hour" }],

      // plugin
      filterDate: [__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("day"), __WEBPACK_IMPORTED_MODULE_1_moment___default()()],
      viewDataLoading: false,
      pickerOptions: {
        shortcuts: [{
          text: "Today",
          onClick: function onClick(picker) {
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("day");
            var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "This week",
          onClick: function onClick(picker) {
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("week");
            var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "This month",
          onClick: function onClick(picker) {
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("month");
            var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "This year",
          onClick: function onClick(picker) {
            var start = __WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf("year");
            var end = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 7 days",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 30 days",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "Last 3 months",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      }
    };
  },

  computed: {},
  components: {
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_0_element_ui__["DatePicker"]
  },
  methods: {
    toggleCalender: function toggleCalender() {
      this.show = !this.show;
    },
    openCalender: function openCalender() {
      this.show = true;
    },
    closeCalender: function closeCalender() {
      this.show = false;
    },
    filterChanged: function filterChanged() {
      this.viewDataLoading = true;
      this.filterChart();
    },
    filterChart: function filterChart() {
      this.loading = true;
      this.filterDate ? this.callbackFunc(this.filterDate[0], this.filterDate[1], 1000) : this.callbackFunc();
    },
    gotoNext: function gotoNext() {
      var nextIndex = this.quickRanges.indexOf(this.currentDateFilter) + 1;
      this.onClickQuickRange(this.quickRanges[nextIndex]);
    },
    gotoPrev: function gotoPrev() {
      var prevIndex = this.quickRanges.indexOf(this.currentDateFilter) - 1;
      this.onClickQuickRange(this.quickRanges[prevIndex]);
    },
    isFirstItem: function isFirstItem() {
      var currentIndex = this.quickRanges.indexOf(this.currentDateFilter);
      return currentIndex === 0 ? true : false;
    },
    isLastItem: function isLastItem() {
      var currentIndex = this.quickRanges.indexOf(this.currentDateFilter);
      return currentIndex === this.quickRanges.length - 1 ? true : false;
    },
    onClickQuickRange: function onClickQuickRange(item) {
      var durationOne = void 0;
      var durationMany = void 0;
      switch (item.value) {
        case "hour":
          durationOne = "hour";
          durationMany = "hours";
          break;
        case "day":
          durationOne = "day";
          durationMany = "days";
          break;
        case "week":
          durationOne = "week";
          durationMany = "weeks";
          break;
        case "month":
          durationOne = "month";
          durationMany = "months";
          break;
        case "year":
          durationOne = "year";
          durationMany = "years";
          break;

        default:
          durationOne = "day";
          durationMany = "days";
          break;
      }
      if (item.number === "0") {
        this.callbackFunc(__WEBPACK_IMPORTED_MODULE_1_moment___default()().startOf(durationOne));
      } else {
        this.callbackFunc(__WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(item.number, durationMany));
      }
      this.currentDateFilter = item;
      this.closeCalender();
    }
  },
  mounted: function mounted() {
    this.onClickQuickRange(this.quickRanges[0]);
  }
});

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_customPieChart__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */










/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loadingChartData: false,
      powerAvailability: {},
      networkAvailability: {},
      energySource: {}
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices", "getUserSession"])),
  components: {
    "custom-pie-chart": __WEBPACK_IMPORTED_MODULE_4__components_customPieChart__["a" /* default */]
  },
  methods: {
    handleOnChartReady: function handleOnChartReady() {
      var upperLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this = this;

      var lowerLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var container, headers, data, resp, DevData, lastItemData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this;
                _context.prev = 1;

                container.loadingChartData = true;
                // var inverterId = "411241";
                headers = {
                  "Content-Type": "application/plain"
                };
                data = {
                  TableName: "HourlyChart",
                  KeyConditionExpression: "DeviceID = :key and DeviceTimeStamp BETWEEN :up AND :down",
                  ExpressionAttributeValues: {
                    ":key": "" + _this.$route.params.deviceId,
                    ":up": upperLimit || __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract("7", "days"),
                    ":down": lowerLimit || new Date().toISOString()
                  },
                  Limit: 1440, //1440
                  ScanIndexForward: true
                };
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__store_actions__["a" /* HTTP */].post("/devicedata", data, {
                  headers: headers
                });

              case 7:
                resp = _context.sent;
                DevData = resp.data.Items;
                lastItemData = DevData[DevData.length - 1];


                _this.powerAvailability = {
                  title: "Last 24 hours",
                  data: [{
                    value: _this.computeData(lastItemData, 'pvSource'),
                    name: "PV Source",
                    itemStyle: {
                      color: "rgba(16, 156, 241,0.4)" // blue
                    }
                  }, {
                    value: _this.computeData(lastItemData, 'gridSource'),
                    name: "Grid Source",
                    itemStyle: {
                      color: "rgba(255, 185, 70,0.47)" // yellow
                    }
                  }, {
                    value: _this.computeData(lastItemData, 'batterySource'),
                    name: "Battery Source",
                    itemStyle: {
                      color: "rgba(250, 113, 111, 0.46)" // red
                    }
                  }]
                };
                container.loadingChartData = false;
                _context.next = 20;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);

                console.log("********************************************************");
                console.log(_context.t0);
                container.loadingChartData = false;
                console.log("********************************************************");

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 14]]);
      }))();
    },


    // computeData(arrData, key) {
    //   return arrData.map(item => {
    //     if(!item["loadEnergySource"] || !item["EnergyData"][key]) return
    //     return item["loadEnergySource"][key] / 1000 + 'kVA';
    //   });
    // },

    computeData: function computeData(objData, key) {
      console.log(objData["loadEnergySource"][key]);
      // if(!objData["loadEnergySource"] || !objData["loadEnergySource"][key]) return
      return objData["loadEnergySource"][key];
    }
  },
  mounted: function mounted() {
    this.inverterId = this.$route.params.deviceId;
  }
});

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_customBox__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_customGridBox__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_customGeoBox__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_customChart__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_customDatePicker__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_customPieChart__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable ok */














/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inverterId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["c" /* mapGetters */])(["filteredAllDevices", "filteredOnlineDevices", "filteredOffLineDevices", "filteredAlarmDevices", "criticalSystems"])),
  components: {
    // GreyPagination
    "custom-box": __WEBPACK_IMPORTED_MODULE_1__components_customBox__["a" /* default */],
    "custom-grid-box": __WEBPACK_IMPORTED_MODULE_2__components_customGridBox__["a" /* default */],
    "custom-geo-box": __WEBPACK_IMPORTED_MODULE_3__components_customGeoBox__["a" /* default */],
    "custom-chart": __WEBPACK_IMPORTED_MODULE_4__components_customChart__["a" /* default */],
    "custom-pie-chart": __WEBPACK_IMPORTED_MODULE_6__components_customPieChart__["a" /* default */],
    "custom-date-picker": __WEBPACK_IMPORTED_MODULE_5__components_customDatePicker__["a" /* default */]
  },
  methods: {},
  mounted: function mounted() {
    this.inverterId = this.$route.params.deviceId;
  }
});

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_dashboard_components_customBox_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_dashboard_components_customGridBox_vue__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_dashboard_components_customGeoBox_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_dashboard_components_customChart_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_dashboard_components_customDatePicker_vue__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_dashboard_components_customPieChart_vue__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash__ = __webpack_require__(2757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store_actions__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LineChart_vue__ = __webpack_require__(1121);






var _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable ok */













var icon = "data:image/png;base64,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";




/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
  components: {
    "line-chart": __WEBPACK_IMPORTED_MODULE_17__LineChart_vue__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()({
      deviceExpiry: null,
      daysToExpire: 100,
      inverterId: null,
      markers: [],
      place: null,
      map: null,
      center: { lat: 9.082, lng: 8.6753 },
      url: icon,
      devices: null,
      activeDevice: null,
      chartType: "temperature",
      loadingChartData: true,
      emptyChart: false,
      alarmTableFields: [{
        field: "datetime",
        label: "Date/Time",
        sortable: "true"
      }, {
        field: "device_id",
        label: "Device ID",
        sortable: "true"
      }, {
        field: "alarmType",
        label: "Alarm Type",
        sortable: "true"
      }, {
        field: "alarmValue",
        label: "Alarm Value",
        sortable: "true"
      }, {
        field: "threshValue",
        label: "Threshold Value",
        sortable: "true"
      }, {
        field: "thresh",
        label: "Threshold",
        sortable: "true"
      }, {
        field: "comment",
        label: "Comment",
        sortable: "true"
      }],
      chartData: null,
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: false
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
          // position: 'bottom'
        },
        responsive: true,
        maintainAspectRatio: false
      },
      deviceCount: 0,
      invoiceCount: 0,
      criticalWarningCount: 0,
      warningCount: 0,
      zoom: 6
    }, "devices", []);
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])(["getUserSession", "getAssignedDevices"]))
}, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "components", {
  // GreyPagination
  "custom-box": __WEBPACK_IMPORTED_MODULE_5__components_pages_dashboard_components_customBox_vue__["a" /* default */],
  "custom-grid-box": __WEBPACK_IMPORTED_MODULE_6__components_pages_dashboard_components_customGridBox_vue__["a" /* default */],
  "custom-geo-box": __WEBPACK_IMPORTED_MODULE_7__components_pages_dashboard_components_customGeoBox_vue__["a" /* default */],
  "custom-chart": __WEBPACK_IMPORTED_MODULE_8__components_pages_dashboard_components_customChart_vue__["a" /* default */],
  "custom-pie-chart": __WEBPACK_IMPORTED_MODULE_10__components_pages_dashboard_components_customPieChart_vue__["a" /* default */],
  "custom-date-picker": __WEBPACK_IMPORTED_MODULE_9__components_pages_dashboard_components_customDatePicker_vue__["a" /* default */]
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "methods", {
  getClass: function getClass(chartType) {
    return { active: this.chartType === chartType };
  },
  getSMFilter: function getSMFilter(assignedDevices) {
    var filter = {
      where: {
        or: []
      }
    };
    assignedDevices.map(function (v) {
      filter.where.or.push({ CID: v });
    });
    return filter;
  },
  log: function log(msg) {
    console.log(msg);
  },
  invoice: function invoice() {
    var _this = this;

    var filter = "";
    var userId = this.getUserSession.id;
    var httpUtils = this.$httpUtils;
    if (this.$can("am", "customer")) {
      filter = {
        order: "id DESC",
        where: {
          and: [{ userId: userId }, {
            or: [{ type: "subscription" }, { type: "autoMonthlySubscription" }]
          }]
        },
        limit: 150,
        include: ["user"]
      };
    }
    var url = "/invoices?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter);

    httpUtils.instance.get(url).then(function (response) {
      _this.invoiceCount = response.data.length;
    }).catch(function (error) {
      _this.errors = "Error occured at our end!";
    });
  },
  deviceLocation: function deviceLocation() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var HTTP, userId, LOCATIONURL, assignedDevices, filter, _filter, resp, data;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              HTTP = _this2.$httpUtils.instance;
              userId = _this2.getUserSession.id;

              console.log(userId);
              LOCATIONURL = "";

              if (_this2.$can("am", "sm")) {
                assignedDevices = JSON.parse(_this2.getUserSession.assignedDevices);

                _this2.deviceCount = assignedDevices.length;
                if (_this2.deviceCount > 0) {
                  filter = _this2.getSMFilter(assignedDevices);

                  LOCATIONURL = "/installations?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(filter);
                }
              } else {
                _filter = {
                  where: {
                    and: [{ userId: "" + userId }, {
                      or: [{ status: "requested" }, { status: "commissioned" }, { status: "completed" }]
                    }]
                  },
                  include: ["locations"]
                };

                LOCATIONURL = "/installations?filter=" + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_filter);
              }

              _context.next = 8;
              return HTTP.get(LOCATIONURL).then(function (res) {
                return res;
              }).catch(function (httpError) {
                console.log({ httpError: httpError });
              });

            case 8:
              resp = _context.sent;
              data = resp.data;

              if (data.length > 0) {
                _this2.deviceCount = data.length;
                data.map(function (m) {
                  var locations = m.locations,
                      name = m.name,
                      CID = m.CID;

                  if (locations) {
                    var position = locations.position,
                        streetRoute = locations.streetRoute;

                    var latLng = position;
                    _this2.markers.push({
                      latLng: latLng,
                      name: streetRoute + " - " + CID,
                      CID: CID
                    });
                  }
                });
              }
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](0);

              console.log(_context.t0);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2, [[0, 13]]);
    }))();
  },
  init: function init() {
    var lowerLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var _this3 = this;

    var upperLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var inverterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var httpUtils, assignedDevices, smQuery, GraphHTTP, res, surveillanceByDateAndIDs, yo, goodWarning, openWarning;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              httpUtils = _this3.$httpUtils;


              _this3.isLoading = true;
              assignedDevices = [];

              if (_this3.$can("am", "sm")) {
                assignedDevices = _this3.getUserSession.assignedDevices;
              } else {
                assignedDevices = _this3.getAssignedDevices; // ==> ['416931', '416850'];
              }
              // console.log({ assignedDevices, sm: this.$can("am", "sm") });

              smQuery = "{\n          surveillanceByDateAndIDs(DateRange:[\"" + (lowerLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()().subtract(7, "days").toISOString()) + "\",\"" + (upperLimit || __WEBPACK_IMPORTED_MODULE_15_moment___default()().toISOString()) + "\"],IDs:" + (assignedDevices || []) + "){\n                name\n                deviceId\n                fault\n                severity\n                status\n                id\n                startTime\n                endTime\n              }\n            }";
              GraphHTTP = _this3.$httpUtils.GraphHTTP;
              res = GraphHTTP.post("/graphql", { query: smQuery });
              surveillanceByDateAndIDs = res.data.data.surveillanceByDateAndIDs;
              yo = surveillanceByDateAndIDs || [];
              goodWarning = yo.filter(function (v) {
                return v.severity == "Critical" && v.status != "RESOLVED";
              });

              _this3.criticalWarningCount = goodWarning.length;
              _this3.isLoading = false;
              openWarning = yo.filter(function (v) {
                return v.status == "OPEN";
              });

              _this3.warningCount = openWarning.length;
              return _context2.abrupt("return", goodWarning);

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2["catch"](0);

              console.log("init ==>", _context2.t0);
              _this3.isLoading = false;
              return _context2.abrupt("return", []);

            case 23:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[0, 18]]);
    }))();
  },
  getWeatherData: function getWeatherData(id) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var query, GraphHTTP, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              query = _this4.geoDataQuery(id);
              GraphHTTP = _this4.$httpUtils.GraphHTTP;
              _context3.next = 4;
              return GraphHTTP.post("/graphql", {
                query: query
              });

            case 4:
              res = _context3.sent;

              _this4.stripForChart(res.data.data.geoData);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  },
  geoDataQuery: function geoDataQuery(id) {
    return "\n        {geoData(ID:\"" + id + "\"){\n          id\n          createdAt\n          deviceId\n          weather{\n            icon\n            description\n            main\n            id\n          }\n          coord{\n            lon\n            lat\n          }\n          main{\n            temp\n            temp_min\n            weather\n            humidity\n            temp_max\n            pressure\n            sea_level\n            feels_like\n          }\n        }}";
  },
  stripForChart: function stripForChart(geoData) {
    var deviceLabels = [];
    var deviceTempData = [];
    var deviceHumidData = [];
    geoData.map(function (device) {
      deviceLabels[deviceLabels.length] = new Date(device.createdAt).toLocaleTimeString([], {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit"
      }).toUpperCase();
      deviceTempData[deviceTempData.length] = device.main.temp;
      deviceHumidData[deviceHumidData.length] = device.main.humidity;
    });
    var lineColor = this.genRandomHexCode();
    this.loadingChartData = false;
    if (deviceLabels.length > 0) {
      this.emptyChart = false;
      var allTempData = {
        label: "Device " + geoData[0].deviceId,
        data: this.chartType === "temperature" ? deviceTempData : deviceHumidData,
        fill: false,
        borderColor: lineColor,
        backgroundColor: lineColor,
        borderWidth: 1,
        tension: 0 // increase to make the line curvy
      };
      this.fillChart(deviceLabels, allTempData);
    } else this.emptyChart = true;
  },
  genRandomHexCode: function genRandomHexCode() {
    return "#" + Math.floor(Math.random() * 16777215).toString(16);
  },
  fillChart: function fillChart(labels, data) {
    this.chartData = { labels: labels, datasets: [data] };
  },
  changeActiveDevice: function changeActiveDevice(id, type) {
    this.loadingChartData = true;
    if (this.chartData) this.chartData = null;
    if (this.chartType === type) this.deviceExpiry = null;
    if (this.activeDevice !== id) this.chartType = "temperature";
    if (!this.activeDevice) this.activeDevice = id;
    this.chartType = type;
    this.getWeatherData(id);
    this.getPendingChanges(id);
  },
  getPendingChanges: function getPendingChanges(deviceId) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var options, HTTP, res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              options = {
                weekday: "short",
                year: "numeric",
                month: "long",
                day: "numeric"
              };
              HTTP = _this5.$httpUtils.NotificationHTTP;
              // const endpoint = "https://iot-solarbase.arnergy.com/devicestate/";

              _context4.next = 4;
              return HTTP.get("configuration/" + deviceId);

            case 4:
              res = _context4.sent;


              _this5.deviceExpiry = new Date(res.data.response.expiryDate).toLocaleDateString(undefined, options);
              _this5.daysToExpire = res.data.response.daysToExpire;
              _this5.$store.commit("setActiveDeviceDaysToExpire", _this5.daysToExpire);
              // window.location.reload()

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  }
}), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "mounted", function mounted() {
  var _this6 = this;

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _this6.inverterId = _this6.$route.params.deviceId;
            _this6.init();
            _this6.deviceLocation();
            _this6.invoice();
            if (_this6.$can("am", "sm")) {
              _this6.devices = JSON.parse(_this6.getUserSession.assignedDevices);
            } else {
              _this6.devices = _this6.getAssignedDevices;
            }

            _this6.changeActiveDevice(_this6.devices[0], "temperature");

          case 6:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, _this6);
  }))();
}), _components$data$comp);

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(1122);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(2758)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(2759);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'line-chart',
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Line */],
  props: ['chartdata', 'options'],
  mounted: function mounted() {
    this.renderChart(this.chartdata, this.options);
  }
});

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "notifications",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession", "getUserNotifications"])),
  data: function data() {
    return {
      notificationList: [{
        id: 0,
        read: false,
        deleted: false,
        type: "warning",
        alertLevel: "high",
        date: "November 5, 2021",
        message: "You have 7 days left to renew your subscription for Device 416814 before it is shut down",
        action: ""
      }]
    };
  },

  methods: {
    readMessage: function readMessage(id) {
      var _this = this;

      var item = this.notificationList.find(function (x) {
        return x.id == id;
      });
      item.read = true;
      var HTTP = this.$httpUtils.NotificationHTTP;
      HTTP.patch("notification/" + id).then(function (res) {
        _this.$store.commit("saveUserNotifications", _this.notificationList);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    getNotificationsCount: function getNotificationsCount() {
      return this.notificationList.filter(function (item) {
        return item.read != true;
      }).length;
    },

    // deleteNotification(index) {
    //   let newList = [];
    //   newList = this.notificationList.filter(
    //     item => this.notificationList.indexOf(item) !== index
    //   );
    //   this.notificationList = newList;
    // },
    deleteNotification: function deleteNotification(id) {
      var _this2 = this;

      var res = confirm("Are you sure you want to delete this notification?");
      if (!res) return;

      this.notificationList = this.notificationList.filter(function (x) {
        return x.id != id;
      });

      var HTTP = this.$httpUtils.NotificationHTTP;
      HTTP.delete("notification/" + id).then(function (res) {
        // remove deleted item from list
        _this2.$store.commit("saveUserNotifications", _this2.notificationList);
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fecthData: function fecthData() {
      this.notificationList = this.getUserNotifications.map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, {
          id: item.id,
          read: false,
          deleted: false,
          type: item.type,
          alertLevel: item.alertLevel,
          date: __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.createdAt).fromNow(),
          message: item.longMessage,
          action: ""
        });
      });
    }
  },
  mounted: function mounted() {
    // fetch data
    this.fecthData();
  }
});

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__warnings__ = __webpack_require__(2769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__ = __webpack_require__(23);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    Warnings: __WEBPACK_IMPORTED_MODULE_8__warnings__["a" /* default */],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_10_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_9_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_9_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_9_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      errors: [],
      installationOptions: [],
      showOffCanvas: false,
      warningItem: null
    };
  },

  computed: {},
  methods: {
    openWarningInfo: function openWarningInfo(row) {
      this.warningItem = row;
      console.log(row);
    },
    showOffCanvasFunc: function showOffCanvasFunc() {
      this.showOffCanvas = true;
    },
    hideOffCanvasFunc: function hideOffCanvasFunc() {
      this.showOffCanvas = false;
    },
    validate: function validate() {
      var err = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          // console.log(`${field}: ${value}`);
          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }
          switch (field) {
            case "user":
              if (value === "null" || value === "") {
                err[field] = "Select a user.";
              }
              break;
            case "invoiceType":
              if (value === "null" || value === "") {
                err[field] = "Choose invoice type.";
              }
              break;
            case "installation":
              if (value === "null" || value === "") {
                err[field] = "Select an installation.";
              }
              break;
            case "amount":
              if (value === "null" || value === "") {
                err[field] = "Amount cannot be empty.";
              }
              break;
            case "comment":
              if (value === "null" || value === "") {
                err[field] = "Description can not be empty.";
              }
              break;
            case "period":
              if (value === "null" || value === "") {
                err[field] = "Select billing period.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.errors = err;
    },
    installationSelected: function installationSelected(installation) {
      var modelMap = {
        OS: "OUTRIGHT",
        ES: "ENERGY AS A SERVICE",
        LO: "LEASE TO OWN"
      };
      this.form["comment"] = "" + modelMap[installation.deviceRequest.paymentModel];
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this.createFilter(queryString, contact);
      }) : contacts;
      cb(results);
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSelected: function contactSelected(contact) {
      //   console.log({ contact });
      this.form.user = contact;
      this.form.installation = null;
      if (contact.installations && contact.installations.length > 0) {
        this.installationOptions = contact.installations;
      }
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      var filter = {
        include: { installations: ["deviceRequest", "deviceType"] },
        roleType: "customer"
      };
      var url = "/users?filter=" + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(filter) + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.contactList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.fetchUsers();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_date_fns_format__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// eslint-disable-next-line







__WEBPACK_IMPORTED_MODULE_10_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchDeviceId: null,
      searchTerm: "",
      items: items,
      warningTimerId: null,
      tableOptions: [{
        field: "name",
        label: "Name",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Name", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [],
          filterFn: function filterFn(data, filterString) {
            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter"
          // sortFn: function(x, y, col, rowX, rowY) {
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // x = Number(x);
          // y = Number(y);
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // return x < y ? -1 : x > y ? 1 : 0;
          // }
        } }, {
        field: "deviceId",
        label: "DeviceID",
        sortable: true,
        type: "number",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Device Id", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            // console.log({ data, filterString });

            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "fault",
        label: "Fault",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Fault", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            // console.log({ data, filterString });

            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "startTime",
        label: "Start Time",
        sortable: true,
        type: "date",
        dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", // expects 2018-03-16
        dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        filterable: true,
        width: "17%"
      }, {
        field: "severity",
        label: "Severity",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Severity", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ["Major", "Minor", "Critical", "Major & Critical"], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            if (filterString == "Major & Critical") {
              if (data.toLowerCase().includes("Major".toLowerCase()) || data.toLowerCase().includes("Critical".toLowerCase())) {
                return data;
              }
            } else if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "status",
        label: "Status",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Status", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ["Open", "Resolved"], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "endTime",
        label: "End Time",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%"
      }, {
        field: "action",
        label: "",
        hidden: true
      }],
      list: "",
      currentPage: 1,
      perPage: 10,
      isLoading: false,
      filterDate: null
    };
  },

  components: {
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_9_element_ui__["DatePicker"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"])),
  methods: {
    infiniteHandler: function infiniteHandler($state) {
      // axios
      //   .get(api, {
      //     params: {
      //       page: this.page,
      //     },
      //   })
      //   .then(({ data }) => {
      //     if (data.hits.length) {
      //       this.page += 1;
      //       this.list.push(...data.hits);
      //       $state.loaded();
      //     } else {
      //       $state.complete();
      //     }
      //   });
    },
    numSort: function numSort(x, y, col, rowX, rowY) {
      console.log({ x: x, y: y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      x = Number(x);
      y = Number(y);
      //  console.log({ x, y,dir: x < y ? "up" : x > y ? "down" : "stay" });
      return x < y ? -1 : x > y ? 1 : 0;
    },
    viewStatus: function viewStatus(row) {
      this.$emit("onRowClick", row);
      this.$emit("showOffCanvas");
    },
    searchWarnings: function searchWarnings() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var lowerLimit, upperLimit;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lowerLimit = _this.filterDate == null ? __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(3, "days").toISOString() : _this.filterDate[0].toISOString();
                upperLimit = _this.filterDate != null ? _this.filterDate[1].toISOString() : __WEBPACK_IMPORTED_MODULE_10_moment___default()().toISOString();
                // const inverterId = this.searchDeviceId;

                _context.next = 4;
                return _this.init(lowerLimit, upperLimit, null);

              case 4:
                _this.list = _context.sent;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    searchTable: function searchTable(list, tableOptions, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(list).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    sleep: function sleep(ms) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this2.warningTimerId = setTimeout(resolve, ms);
        return _this2.warningTimerId;
      });
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_10_moment___default()(date).format("Do MMM YYYY");
    },
    init: function init() {
      var lowerLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this3 = this;

      var upperLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var inverterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var defaultDiff, httpUtils, smQuery, assignedDevices, query, filterQuery, GraphHTTP, res, _res$data$data, surveillance, surveillanceByDate, surveillanceByDateAndIDs, yo, goodWarning;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defaultDiff = 3;
                _context2.prev = 1;
                httpUtils = _this3.$httpUtils;
                smQuery = "";

                if (_this3.$can("am", "sm")) {
                  assignedDevices = _this3.getUserSession.assignedDevices;

                  smQuery = "\n            {\n              surveillanceByDateAndIDs(DateRange:[\"" + (lowerLimit || __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(defaultDiff, "days").toISOString()) + "\",\"" + (upperLimit || __WEBPACK_IMPORTED_MODULE_10_moment___default()().toISOString()) + "\"],IDs:" + (assignedDevices || []) + "){\n                deviceId\n                fault\n                severity\n                status\n                id\n                startTime\n                endTime\n              }\n            }\n          ";
                }

                query = "\n          {\n            surveillance{\n              deviceId\n              fault\n              startTime\n              endTime\n              id\n              name\n              severity\n              status\n            }\n          }\n        ";
                filterQuery = "{\n          surveillanceByDate(DateRange:[\"" + (lowerLimit || __WEBPACK_IMPORTED_MODULE_10_moment___default()().subtract(defaultDiff, "days").toISOString()) + "\",\"" + (upperLimit || __WEBPACK_IMPORTED_MODULE_10_moment___default()().toISOString()) + "\"]){\n            deviceId\n            fault\n            name\n            startTime\n            status\n            id\n            severity\n            endTime\n          }\n        }";
                GraphHTTP = _this3.$httpUtils.GraphHTTP;
                // console.log({rrr:this.$can("am", "sm")==true?smQuery: filterQuery});
                // console.log({rrr:null == lowerLimit || null == upperLimit ? this.$can("am", "sm")?smQuery:query: filterQuery});
                // let url = `/warning_reports?filter=${JSON.stringify(filter)}`;

                _context2.next = 10;
                return GraphHTTP.post("/graphql", {
                  query: _this3.$can("am", "sm") == true ? smQuery : filterQuery
                });

              case 10:
                res = _context2.sent;

                // const res = await GraphHTTP.post("/graphql", {
                //   query: this.$can("am", "sm") == true ? smQuery : filterQuery
                // });
                // var format = require("date-fns/format");
                // console.log({ warning: res.data });
                _res$data$data = res.data.data, surveillance = _res$data$data.surveillance, surveillanceByDate = _res$data$data.surveillanceByDate, surveillanceByDateAndIDs = _res$data$data.surveillanceByDateAndIDs;

                // console.log({surveillance,surveillanceByDate, surveillanceByDateAndIDs});

                yo = surveillance || surveillanceByDate || surveillanceByDateAndIDs || [];
                goodWarning = yo.map(function (v) {
                  return {
                    deviceId: v.deviceId,
                    fault: v.fault,
                    severity: v.severity,
                    status: v.status,
                    startTime: Object(__WEBPACK_IMPORTED_MODULE_8_date_fns_format__["a" /* default */])(new Date(v.startTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"), //`${moment(v.startTime).format("YYYY-MM-DD HH:mm:ss")}`,
                    endTime: v.endTime ? "" + Object(__WEBPACK_IMPORTED_MODULE_8_date_fns_format__["a" /* default */])(new Date(v.endTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : v.endTime,
                    name: v.name
                  };
                });


                _this3.list = goodWarning;
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](1);

                console.log("init ==>", _context2.t0);

              case 20:
                _context2.prev = 20;

                _this3.isLoading = false;
                //This bit reruns the function so as to update the data at intervals. Helps to achieve realtime reporting
                // setTimeout(this.init(), 300000)
                _this3.sleep(300000).then(function () {
                  // console.log("running cron!!!", new Date());
                  _this3.init();
                });
                return _context2.finish(20);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 17, 20, 24]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.warningTimerId) return;
    clearTimeout(this.warningTimerId);
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isLoading = true;
              _context3.next = 3;
              return _this4.init();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Warnings2__ = __webpack_require__(2775);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Index2",
  components: {
    Warnings2: __WEBPACK_IMPORTED_MODULE_0__Warnings2__["a" /* default */]
  },
  computed: {}
});

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





__WEBPACK_IMPORTED_MODULE_8_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Warnings2",
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      searchDeviceId: null,
      searchTerm: "",
      showDropDownData: false,
      selectedSeverity: "",
      selectedStatus: "",
      paginationInfo: {},
      items: items,
      resolutionTime: "",
      warningTimerId: null,
      tableOptions: [{
        field: "name",
        label: "CUSTOMER NAME",
        sortable: true,
        type: "text",
        filterable: true,
        width: "15%"
      }, {
        field: "deviceId",
        label: "DEVICE ID",
        sortable: true,
        type: "number",
        filterable: true,
        width: "10%"
      }, {
        field: "fault",
        label: "FAULT",
        sortable: true,
        type: "text",
        filterable: true,
        width: "15%"
      }, {
        field: "severity",
        label: "SEVERITY",
        sortable: true,
        type: "text",
        filterable: true,
        width: "15%"
      }, {
        field: "status",
        label: "STATUS",
        sortable: true,
        type: "text",
        filterable: true,
        width: "15%"
      }, {
        field: "startTime && endTime",
        label: "START TIME / END TIME",
        sortable: true,
        type: "date",
        dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", // expects 2018-03-16
        dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        filterable: true,
        width: "18%"
      }, {
        field: "resolutionTime",
        label: "RESOLUTION TIME",
        sortable: true,
        type: "text",
        filterable: true,
        width: "12%"
      }],
      list: [],
      currentPage: 1,
      // perPage: 50,
      isLoading: false,
      filterDate: null
    };
  },

  watch: {
    searchTerm: function searchTerm(newTerm) {
      this.filterData(newTerm);
    }
  },
  components: {
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"])),
  methods: {
    dateFormatter: function dateFormatter(date1, date2) {
      var endTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date1, "Do MMM, YYYY h:mm:ssA");
      var startTime = __WEBPACK_IMPORTED_MODULE_8_moment___default()(date2, "Do MMM, YYYY h:mm:ssA");
      if (endTime._i != "") {
        var duration = __WEBPACK_IMPORTED_MODULE_8_moment___default.a.duration(endTime.diff(startTime));
        return duration.humanize();
      } else {
        return "---";
      }
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropDownData = true;
    },
    toggleDropdownOff: function toggleDropdownOff() {
      this.showDropDownData = false;
      this.selectedStatus = "";
      this.selectedSeverity = "";
    },
    filterDataByFilt: function filterDataByFilt() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var foundObjects, _foundObjects, _foundObjects2;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.selectedStatus.length > 0) {
                  foundObjects = _this.list.filter(function (obj) {
                    var values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(obj);
                    return values.some(function (value) {
                      return value.toLowerCase().includes(_this.selectedStatus);
                    });
                  });

                  _this.list = foundObjects;
                  _this.selectedStatus = "";
                  _this.showDropDownData = false;
                }
                if (_this.selectedSeverity.length > 0) {
                  _foundObjects = _this.list.filter(function (obj) {
                    var values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(obj);
                    return values.some(function (value) {
                      return value.toLowerCase().includes(_this.selectedSeverity);
                    });
                  });

                  _this.list = _foundObjects;
                  _this.selectedSeverity = "";
                  _this.showDropDownData = false;
                } else if (_this.selectedStatus.length > 0 && _this.selectedSeverity.length > 0) {
                  _foundObjects2 = _this.list.filter(function (obj) {
                    var values = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(obj);
                    return values.some(function (value) {
                      return value.toLowerCase().includes(_this.selectedStatus) && value.toLowerCase().includes(_this.selectedSeverity);
                    });
                  });

                  _this.list = _foundObjects2;
                  _this.selectedStatus = "";
                  _this.selectedSeverity = "";
                  _this.showDropDownData = false;
                } else {
                  _this.showDropDownData = false;
                  _this.init();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    resolveFunction: function resolveFunction(deviceId, alarmsStatus) {
      var _this2 = this;

      var ALARMhttp = this.$httpUtils.AlarmHTTP;
      var systemStatus = alarmsStatus;

      if (systemStatus !== "RESOLVED") {
        var systemDeviceId = {
          DeviceID: deviceId
        };
        var url = "/api/v1/clear-faults";
        ALARMhttp.put(url, systemDeviceId).then(function (res) {
          _this2.showSuccessMsg({
            message: "System alarms resolution successful"
          });
          _this2.init();
          _this2.hide();
        }).catch(function (error) {
          _this2.showErrorMsg({ message: error.response.data.error.message });
        });
      } else {
        this.showInfoMsg({ message: "Device's Alarms already RESOLVED" });
      }
    },
    searchTable: function searchTable(list, tableOptions, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(list).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    sleep: function sleep(ms) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this3.warningTimerId = setTimeout(resolve, ms);
        return _this3.warningTimerId;
      });
    },
    init: function init() {
      var lowerLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var upperLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var inverterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var defaultDiff, httpUtils, smQuery, assignedDevices, ALARMhttp, url, res, _res$data$data, surveillance, surveillanceByDate, surveillanceByDateAndIDs, yo, goodWarning;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defaultDiff = 3;
                _context2.prev = 1;
                httpUtils = _this4.$httpUtils;
                smQuery = "";

                if (_this4.$can("am", "sm")) {
                  assignedDevices = _this4.getUserSession.assignedDevices;

                  smQuery = "\n              {\n                surveillanceByDateAndIDs(DateRange:[\"" + (lowerLimit || __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(defaultDiff, "days").toISOString()) + "\",\"" + (upperLimit || __WEBPACK_IMPORTED_MODULE_8_moment___default()().toISOString()) + "\"],IDs:" + (assignedDevices || []) + "){\n                  deviceId\n                  fault\n                  severity\n                  status\n                  id\n                  startTime\n                  endTime\n                }\n              }\n            ";
                }

                ALARMhttp = _this4.$httpUtils.AlarmHTTP;
                url = "/api/v1/get-faults";
                _context2.next = 9;
                return ALARMhttp.get(url);

              case 9:
                res = _context2.sent;
                _res$data$data = res.data.data, surveillance = _res$data$data.surveillance, surveillanceByDate = _res$data$data.surveillanceByDate, surveillanceByDateAndIDs = _res$data$data.surveillanceByDateAndIDs;
                yo = surveillance || surveillanceByDate || surveillanceByDateAndIDs || [];
                goodWarning = yo.map(function (v) {
                  return {
                    deviceId: v.deviceId,
                    fault: v.fault,
                    severity: v.severity,
                    status: v.status,
                    startTime: __WEBPACK_IMPORTED_MODULE_8_moment___default()(v.startTime).format("Do MMM, YYYY HH:mm:ssA"),
                    endTime: v.endTime ? "" + __WEBPACK_IMPORTED_MODULE_8_moment___default()(v.endTime).format("Do MMM, YYYY HH:mm:ssA") : v.endTime,
                    name: v.name
                  };
                });


                _this4.list = goodWarning;
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](1);

                console.log("init ==>", _context2.t0);

              case 19:
                _context2.prev = 19;

                _this4.isLoading = false;
                _this4.sleep(300000).then(function () {
                  _this4.init();
                });
                return _context2.finish(19);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 16, 19, 23]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this5.isLoading = true;
              _context3.next = 3;
              return _this5.init();

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__warnings__ = __webpack_require__(2781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__ = __webpack_require__(23);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    Warnings: __WEBPACK_IMPORTED_MODULE_2__warnings__["a" /* default */],
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_3_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_3_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_3_element_ui__["RadioButton"]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      errors: [],
      installationOptions: [],
      showOffCanvas: false,
      warningItem: null
    };
  },

  computed: {},
  methods: {
    openWarningInfo: function openWarningInfo(row) {
      this.warningItem = row;
      console.log(row);
    },
    showOffCanvasFunc: function showOffCanvasFunc() {
      this.showOffCanvas = true;
    },
    hideOffCanvasFunc: function hideOffCanvasFunc() {
      this.showOffCanvas = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_date_fns_format__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// eslint-disable-next-line




__WEBPACK_IMPORTED_MODULE_8_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      searchDeviceId: null,
      searchTerm: "",
      items: items,

      tableOptions: [{
        field: "name",
        label: "Name",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Name", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [],
          filterFn: function filterFn(data, filterString) {
            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter"
          // sortFn: function(x, y, col, rowX, rowY) {
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // x = Number(x);
          // y = Number(y);
          // console.log({ x, y, dir: x < y ? "up" : x > y ? "down" : "stay" });
          // return x < y ? -1 : x > y ? 1 : 0;
          // }
        } }, {
        field: "deviceId",
        label: "DeviceID",
        sortable: true,
        type: "number",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Device Id", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            // console.log({ data, filterString });

            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "fault",
        label: "Fault",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Fault", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            // console.log({ data, filterString });

            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "startTime",
        label: "Start Time",
        sortable: true,
        type: "date",
        dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx", // expects 2018-03-16
        dateOutputFormat: "MMM do yyyy", // outputs Mar 16th 2018
        filterable: true,
        width: "17%"
      }, {
        field: "severity",
        label: "Severity",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Severity", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ["Major", "Minor", "Critical", "Major & Critical"], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            if (filterString == "Major & Critical") {
              if (data.toLowerCase().includes("Major".toLowerCase()) || data.toLowerCase().includes("Critical".toLowerCase())) {
                return data;
              }
            } else if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "status",
        label: "Status",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%",
        filterOptions: {
          styleClass: "", // class to be added to the parent th element
          enabled: true, // enable filter for this column
          placeholder: "Filter by Status", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: ["Open", "Resolved"], // dropdown (with selected values) instead of text input
          filterFn: function filterFn(data, filterString) {
            if (data.toLowerCase().includes(filterString.toLowerCase())) {
              return data;
            }
          },
          trigger: "enter" //only trigger on enter not on keyup
        }
      }, {
        field: "endTime",
        label: "End Time",
        sortable: true,
        type: "text",
        filterable: true,
        width: "17%"
      }, {
        field: "action",
        label: "",
        hidden: true
      }],
      list: "",
      currentPage: 1,
      perPage: 10,
      isLoading: false,
      filterDate: null
    };
  },

  components: {
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_7_element_ui__["DatePicker"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"])),
  methods: {
    infiniteHandler: function infiniteHandler($state) {
      // axios
      //   .get(api, {
      //     params: {
      //       page: this.page,
      //     },
      //   })
      //   .then(({ data }) => {
      //     if (data.hits.length) {
      //       this.page += 1;
      //       this.list.push(...data.hits);
      //       $state.loaded();
      //     } else {
      //       $state.complete();
      //     }
      //   });
    },
    fetchDevices: function fetchDevices() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getCurrentCustomerDeviceIds: function getCurrentCustomerDeviceIds() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var httpUtils, userId, url, result;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                httpUtils = _this2.$httpUtils;
                userId = _this2.getUserSession.id;
                url = "/installations?filter={\"where\":{\"and\": [{\"userId\":" + userId + "}, {\"or\":[{ \"status\": \"requested\"},{ \"status\": \"commissioned\"},{ \"status\": \"completed\"}]}]}}";
                _context2.next = 5;
                return httpUtils.instance.get(url);

              case 5:
                result = _context2.sent;
                return _context2.abrupt("return", result.data.map(function (item) {
                  return item.CID;
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    numSort: function numSort(x, y, col, rowX, rowY) {
      console.log({ x: x, y: y, dir: x < y ? "up" : x > y ? "down" : "stay" });
      x = Number(x);
      y = Number(y);
      //  console.log({ x, y,dir: x < y ? "up" : x > y ? "down" : "stay" });
      return x < y ? -1 : x > y ? 1 : 0;
    },
    viewStatus: function viewStatus(row) {
      this.$emit("onRowClick", row);
      this.$emit("showOffCanvas");
    },
    searchWarnings: function searchWarnings() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var lowerLimit, upperLimit;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                lowerLimit = _this3.filterDate == null ? __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(3, "days").toISOString() : _this3.filterDate[0].toISOString();
                upperLimit = _this3.filterDate != null ? _this3.filterDate[1].toISOString() : __WEBPACK_IMPORTED_MODULE_8_moment___default()().toISOString();
                // const inverterId = this.searchDeviceId;

                _context3.next = 4;
                return _this3.init(lowerLimit, upperLimit, null);

              case 4:
                _this3.list = _context3.sent;

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    searchTable: function searchTable(list, tableOptions, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(list).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_8_moment___default()(date).format("Do MMM YYYY");
    },
    init: function init() {
      var lowerLimit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this4 = this;

      var upperLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var inverterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var defaultDiff, httpUtils, assignedDevices, smQuery, GraphHTTP, res, surveillanceByDateAndIDs, yo, goodWarning;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                defaultDiff = 3;
                _context4.prev = 1;
                httpUtils = _this4.$httpUtils;


                _this4.isLoading = true;
                assignedDevices = [];

                if (!_this4.$can("am", "sm")) {
                  _context4.next = 9;
                  break;
                }

                assignedDevices = _this4.getUserSession.assignedDevices;
                _context4.next = 14;
                break;

              case 9:
                _context4.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a;
                _context4.next = 12;
                return _this4.getCurrentCustomerDeviceIds();

              case 12:
                _context4.t1 = _context4.sent;
                assignedDevices = (0, _context4.t0)(_context4.t1);

              case 14:
                console.log({ assignedDevices: assignedDevices, sm: _this4.$can("am", "sm") });

                smQuery = "\n  {\nsurveillanceByDateAndIDs(DateRange:[\"" + (lowerLimit || __WEBPACK_IMPORTED_MODULE_8_moment___default()().subtract(defaultDiff, "days").toISOString()) + "\",\"" + (upperLimit || __WEBPACK_IMPORTED_MODULE_8_moment___default()().toISOString()) + "\"],IDs:" + (assignedDevices || []) + "){\n  name\n  deviceId\n  fault\n  severity\n  status\n  id\n  startTime\n  endTime\n}\n}\n";
                GraphHTTP = _this4.$httpUtils.GraphHTTP;
                // console.log({rrr:this.$can("am", "sm")==true?smQuery: filterQuery});
                // console.log({rrr:null == lowerLimit || null == upperLimit ? this.$can("am", "sm")?smQuery:query: filterQuery});
                // let url = `/warning_reports?filter=${JSON.stringify(filter)}`;

                _context4.next = 19;
                return GraphHTTP.post("/graphql", {
                  query: smQuery
                });

              case 19:
                res = _context4.sent;

                // var format = require("date-fns/format");
                // console.log({ warning: res.data });
                surveillanceByDateAndIDs = res.data.data.surveillanceByDateAndIDs;

                // console.log({surveillance,surveillanceByDate, surveillanceByDateAndIDs});

                yo = surveillanceByDateAndIDs || [];
                goodWarning = yo.map(function (v) {
                  return {
                    deviceId: v.deviceId,
                    fault: v.fault,
                    severity: v.severity,
                    status: v.status,
                    startTime: Object(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__["a" /* default */])(new Date(v.startTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx"), //`${moment(v.startTime).format("YYYY-MM-DD HH:mm:ss")}`,
                    endTime: v.endTime ? "" + Object(__WEBPACK_IMPORTED_MODULE_6_date_fns_format__["a" /* default */])(new Date(v.endTime), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx") : v.endTime,
                    name: v.name
                  };
                });
                // console.log({ goodWarning });

                _this4.isLoading = false;

                return _context4.abrupt("return", goodWarning);

              case 27:
                _context4.prev = 27;
                _context4.t2 = _context4["catch"](1);

                console.log("init ==>", _context4.t2);
                _this4.isLoading = false;

                return _context4.abrupt("return", []);

              case 32:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[1, 27]]);
      }))();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this5.init();

            case 2:
              _this5.list = _context5.sent;

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this5);
    }))();
  }
});

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kitchen_ButtonOnboardingPackage__ = __webpack_require__(2787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__kitchen_OnboardingSelectButton__ = __webpack_require__(2809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kitchen_Onboarding_SideIndicator_vue__ = __webpack_require__(2815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_Onboarding_ModalCalculate__ = __webpack_require__(2818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_money_format__ = __webpack_require__(2824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OnboardingTopBar_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OnboardingButton_vue__ = __webpack_require__(468);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */











/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Onboarding",
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["getUserSession"])),
  components: {
    ButtonOnboardingPackage: __WEBPACK_IMPORTED_MODULE_4__kitchen_ButtonOnboardingPackage__["a" /* default */],
    OnboardingSelectButton: __WEBPACK_IMPORTED_MODULE_5__kitchen_OnboardingSelectButton__["a" /* default */],
    SideIndicator: __WEBPACK_IMPORTED_MODULE_6__kitchen_Onboarding_SideIndicator_vue__["a" /* default */],
    ModalCalculate: __WEBPACK_IMPORTED_MODULE_7__kitchen_Onboarding_ModalCalculate__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__["a" /* default */],
    MoneyFormat: __WEBPACK_IMPORTED_MODULE_9_vue_money_format__["a" /* default */],
    OnboardingTopBar: __WEBPACK_IMPORTED_MODULE_10__OnboardingTopBar_vue__["a" /* default */],
    OnboardingButton: __WEBPACK_IMPORTED_MODULE_11__OnboardingButton_vue__["a" /* default */]
  },
  data: function data() {
    return {
      activeIndex: 0,
      showLoading: false,
      activePackageType: {},
      activePaymentType: {},
      packages: [{
        id: 1,
        name: "Arnergy IPP",
        productDescription: "A customized solution for residents in estates with centralized power generation",
        amountOS: 120,
        monthlyAmountLO: 10,
        tenure: 12
      }],
      tempPackages: [{
        id: 1,
        name: "Arnergy IPP",
        productDescription: "A customized solution for residents in estates with centralized power generation",
        amountOS: 120,
        monthlyAmountLO: 10,
        tenure: 12
      }],
      paymentTypes: [{
        id: 0,
        key: "LO",
        title: "Lease to Own (LO)",
        description: "This allows you to pay monthly over a specified lease tenor and own the system afterward"
        // {
        //   id: 1,
        //   key: "OS",
        //   title: "Outright Sale (OS)",
        //   description:
        //     "This allows you to pay once and the package becomes yours forever"
        // }
      }]
    };
  },

  methods: {
    fetchProducts: function fetchProducts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this.$httpUtils.FASTHTTP;
                _context.next = 3;
                return HTTP.get("/product/products");

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res.data.map(function (item) {
                  return {
                    id: item.id,
                    name: item.producttype,
                    productDescription: item.productdescription,
                    amountOS: item.amountos,
                    monthlyAmountLO: item.monthlyamountlo,
                    tenure: item.tenurelo
                  };
                }).sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getOnboardingState: function getOnboardingState(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.get("/onboardingstate/state").then(function (response) {
        _this2.$store.commit("saveOnboardingCustomerState", response.data);
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    updateOnboardingState: function updateOnboardingState() {
      var _this3 = this;

      var HTTP = this.$httpUtils.FASTHTTP;

      console.log("tenure", this.activePackageType);

      var payloadData = {
        stateid: 0,
        packageType: this.$store.state.onboardingCustomerState.packageType,
        productType: this.activePackageType.name
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        _this3.$store.commit("saveOnboardingCustomerState", res.data);
        console.log("rfsf", _this3.$store.state.onboardingCustomerState);
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    updateActivePaymentType: function updateActivePaymentType(item) {
      this.activePaymentType = item;
      if (this.activePaymentType.key === "OS") {
        this.packages = this.tempPackages.filter(function (x) {
          return x.name !== "Arnergy 10000";
        });
      } else this.packages = this.tempPackages;
    },
    updateActivePackageType: function updateActivePackageType(item) {
      this.activePackageType = item;
      localStorage.productId = this.activePackageType.id;
    },
    handleContinue: function handleContinue() {
      if (!this.activePaymentType.key || !this.activePackageType.id) {
        alert("Please select Payment type and Package Type");
        return;
      }
      // save onboarding package type
      this.$store.commit("saveOnboardingPackageType", this.activePackageType);
      this.updateOnboardingRoute();
    },
    updateOnboardingRoute: function updateOnboardingRoute() {
      var _this4 = this;

      var HTTP = this.$httpUtils.FASTHTTP;
      this.showLoading = true;

      var payloadData = {
        stateid: 0,
        packageType: this.activePaymentType.key,
        productType: this.activePackageType.name
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        _this4.showLoading = false;

        if (_this4.activePaymentType.key == "LO") {
          _this4.$router.push({ path: "/onboarding/lo/summary" });
        } else if (_this4.activePaymentType.key == "OS") {
          _this4.$router.push({ path: "/onboarding/os/agreement" });
        }
      }).catch(function (error) {
        _this4.showLoading = false;
        _this4.showErrorMsg({ message: error.response.data.error.message });
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // this.packages = await this.fetchProducts();
              // this.tempPackages = this.packages;
              _this5.updateOnboardingState();
              _this5.getOnboardingState(_this5.getUserSession.id);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }
});

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Onboarding_ModalComponent__ = __webpack_require__(2789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Onboarding_TestModal2__ = __webpack_require__(2798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Onboarding_Agreement__ = __webpack_require__(127);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ButtonOnboardingPackage",
  components: {
    ModalComponent: __WEBPACK_IMPORTED_MODULE_2__Onboarding_ModalComponent__["a" /* default */],
    TestModal: __WEBPACK_IMPORTED_MODULE_3__Onboarding_TestModal2__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Onboarding_Agreement__["a" /* default */]
  },
  props: {
    title: null,
    ID: null,
    productDescription: null,
    packages: null,
    amount: null,
    monthlyAmount: null,
    tenure: null,
    isActive: false
  },
  computed: {},
  data: function data() {
    return {
      modalActive: false,
      showDropdown: false,
      showModal: false,
      showTerms: false,
      productInfos: {},
      products: [{
        ID: null,
        name: null,
        productDescription: null,
        amountOS: null,
        monthlyAmountLO: null,
        tenure: null
      }],
      productsDetails: []
    };
  },

  methods: {
    setActive: function setActive() {
      this.modalActive = true;
    },
    modalActiveClose: function modalActiveClose() {
      this.modalActive = false;
      console.log(this.modalActive);
      console.log("close it wiht right button");
    },
    close: function close() {
      this.showModal = false;
      this.showTerms = false;
    },
    proceedToTerms: function proceedToTerms() {
      this.showTerms = true;
    },
    showModalFunc: function showModalFunc() {
      this.showModal = true;
    },
    closeTerms: function closeTerms() {
      this.showTerms = false;
      this.showModal = false;
      this.$emit("nextPage");
    },
    goToKyc: function goToKyc() {
      this.$emit("nextPageKyc");
    },
    fetchBanks: function fetchBanks() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this.$httpUtils.instance;
                _context.next = 3;
                return HTTP.get("/arnergyProducts");

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res.data.map(function (item) {
                  console.log(res.data);
                  return {
                    id: item.id,
                    name: item.productType,
                    productDescription: item.productDescription,
                    amountOS: item.amountOS,
                    monthlyAmountLO: item.monthlyAmountLO,
                    tenure: item.tenureLO
                  };
                }).sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetchProductById: function fetchProductById(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.updateStateFunc();

              case 2:
                localStorage.productName = _this2.title;
                data = {
                  productId: id.toString()
                };
                HTTP = _this2.$httpUtils.instance;
                _context2.next = 7;
                return HTTP.post("/arnergyProductDetails/getProductById", data);

              case 7:
                res = _context2.sent;


                if (res.data) {
                  _this2.showModal = true;

                  // parse for "arnergy-select" use
                  _this2.productsDetails = res.data.map(function (item) {
                    console.log(res.data);
                    return {
                      id: item.id,
                      productId: item.productid,
                      contractTenure: item.contracttenure,
                      cautionFee: item.cautionfee,
                      monthlyPayment: item.monthlypayment
                    };
                  }).sort(function (a, b) {
                    return a.id > b.id ? 1 : -1;
                  });
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    updateStateFunc: function updateStateFunc() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      HTTP.patch("/onboardingStates", {
        customerid: localStorage.customerId,
        stateid: 0,
        packageType: "LO",
        id: localStorage.customerState
      }).then(function (res) {
        _this3.$store.commit("saveOnboanrdingState", 0);

        if (res.data) null;
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var obj, productInfos;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              obj = _this4.packages.find(function (x) {
                return x.id == _this4.ID;
              });
              productInfos = {
                name: obj.name,
                id: obj.id
              };

              _this4.productInfos = productInfos;

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: ['modalState'],
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__ArnergySelect_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]

  },
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      activeIndex: 0,
      employmentStatus: [{ id: 'Employed', name: 'Employed' }, { id: 'Self Employed', name: 'Self Employed' }],
      businessType: [{ id: 'Oil & Gas', name: 'Oil & Gas' }, { id: 'Painter', name: 'Painter' }, { id: 'Trader', name: 'Trader' }],
      tenures: [{ id: '6 Months tenure', name: '6 Months tenure' }, { id: '8 Months tenure', name: '8 Months tenure' }, { id: '12 Months tenure', name: '12 Months tenure' }, { id: '9 Months tenure', name: '9 Months tenure' }],
      form: {
        tenure: '',
        income: '',
        employment: ''
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    continuePage: function continuePage() {
      this.$emit('closeToPopTerms');
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergySelect",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    autocomplete: '',
    type: null,
    error: null
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergyInput",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null,
    value: {}
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: ["modalTitle"],
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_5__ArnergySelect_vue__["a" /* default */],
    "el-checkbox": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Checkbox"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserById", "getUserAmounty", "getDeviceById", "getUsers", "getTest", "getUserAmount", "getGroups", "getSubgroups", "getGroupItems", "getDummy", "getDevices"])),
  data: function data() {
    return {
      costShow: false,
      activeIndex: 0,
      employmentStatus: [{ id: "Employed", name: "Employed" }],
      businessType: [{ id: "Oil & Gas", name: "Oil & Gas" }, { id: "Painter", name: "Painter" }, { id: "Trader", name: "Trader" }],
      tenures: [{ id: "6 Months tenure", name: "6 Months tenure" }, { id: "8 Months tenure", name: "8 Months tenure" }, { id: "12 Months tenure", name: "12 Months tenure" }, { id: "9 Months tenure", name: "9 Months tenure" }],
      form: {
        tenure: "",
        income: "",
        employment: "",
        accept: false
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    continuePage: function continuePage() {
      this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Calculator__ = __webpack_require__(2802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: {
    productDetails: []
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_5__AnergySelectDynamic_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_6__Agreement__["a" /* default */],
    Calculator: __WEBPACK_IMPORTED_MODULE_7__Calculator__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getCustomerProductOptions"])),
  data: function data() {
    return {
      productDetails: null,
      titleProduct: null,
      amt: null,
      desc: null,
      costShow: false,
      ctn: false,
      product: {},
      message: "",
      price: __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get("amtPay") ? __WEBPACK_IMPORTED_MODULE_8_js_cookie___default.a.get("amtPay") : "",
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: "Oil & Gas", name: "Oil & Gas" }, { id: "Farmer", name: "Farmer" }, { id: "Driver", name: "Driver" }, { id: "Painter", name: "Painter" }],
      cacAmt: "",
      employmentStatus: [{ id: "Employed", name: "Employed" }],
      incomes: [{ id: "1", name: " Below N500,000" }, { id: "2", name: "Between N500,000 and N750,000" }, {
        id: "3",
        name: "Between N750,000 and N1,000,000"
      }, { id: "4", name: "Above N1,000,000" }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      errMsg: false,
      form: {
        tenure: "",
        income: "",
        employment: "",
        business: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    fetchAll: function fetchAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // parse for "arnergy-select" use
                _this.products = _this.productDetails;

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAmtofTenure: function getAmtofTenure(id) {
      var obj = this.tenures.find(function (x) {
        return x.id == id;
      });
      this.amountToPay = obj;
      console.log(obj);
      localStorage.productID = obj.productID;
    },
    finalReq: function finalReq() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      // const data = {
      //   customerId: localStorage.customerId,
      //   productid: 1,
      //   tenure: localStorage.proTenure,
      //   firstPaymentAmt: localStorage.amtPay,
      //   recurrentMonthlyAmt: localStorage.amtRepay,
      //   employmentStatus: this.form.employment,
      //   monthlyIncomeRange: this.form.income,
      //   typeOfBusiness: this.form.business,
      // }
      var incomeRange = void 0;
      this.incomes.map(function (income) {
        if (income.id === _this2.form.income) {
          incomeRange = income.id;
        }
      });
      var data = {
        customerId: localStorage.customerId,
        productid: localStorage.productId,
        tenure: localStorage.proTenure,
        firstPaymentAmt: localStorage.amtPay,
        recurrentMonthlyAmt: localStorage.amtRepay,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: incomeRange,
        typeOfBusiness: this.form.business,
        totalPayment: localStorage.totalPayment,
        cautionFee: localStorage.cautionFee,
        setupFee: localStorage.setupFee,
        upfrontPayment: localStorage.upfrontPayment
      };
      // console.log(data)

      if (data.employmentStatus && data.monthlyIncomeRange) {
        this.loader = true;
        HTTP.post("/CustomerProductOptions/saveCustomerOption", data).then(function (res) {
          // console.log(res.data);
          if (res.data.status) {
            localStorage.optionID = res.data.optionId;
            localStorage.amtPayID = res.data.optionId;

            _this2.loader = false;
            _this2.message = res.data.message;
            _this2.errorMessage = false;
            _this2.sucessMsg = true;
            _this2.ctn = true;

            localStorage.removeItem("amtPay");
            localStorage.removeItem("amtRepay");
            localStorage.removeItem("proTenure");
            localStorage.removeItem("cautionFee");
            localStorage.removeItem("setupFee");
            localStorage.removeItem("upfrontPayment");
            localStorage.removeItem("totalPayment");
            localStorage.removeItem("productId");
          } else {
            _this2.message = res.data.message;
            _this2.errorMessage = true;
            _this2.loader = false;
            _this2.sucessMsg = false;
            // setTimeout(() => {
            // window.location.href = '/onboarding'
            // },2000)
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errMsg = true;
        setTimeout(function () {
          return _this2.errMsg = false;
        }, 1500);
      }
    },
    nextFunc: function nextFunc() {
      this.activeIndex++;
    },
    AmtSwicth: function AmtSwicth() {
      switch (this.titleProduct) {
        case "Arnergy 5000":
          this.cacAmt = "";
          return;
        case "Arnergy 5000X":
          this.cacAmt = "4500000";
          return;
        case "Arnergy 10000":
          this.cacAmt = "7500000";
          return;
        default:
          return null;
      }
    },
    setComponentParams: function setComponentParams() {
      var _product = this.$store.state.onboardingPackageType;
      this.titleProduct = _product.name;
      this.amt = _product.amountOS;
      this.desc = _product.productDescription;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // console.log(this.getCustomerProductOptions);
              _this3.fetchAll();
              _this3.AmtSwicth();

              // get active product == productType from store
              _this3.setComponentParams();

              _this3.tenures = _this3.productDetails.map(function (item) {
                return {
                  id: item.id,
                  name: item.contractTenure,
                  caution: item.cautionFee,
                  monthly: item.monthlyPayment,
                  productID: item.productId
                };
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergyInput",
  props: {
    tenureDatas: null,
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null,
    value: ""
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit('change', event.target.value);
      this.$emit("input", event.target.value);
      this.$emit("subgroup", event.target.value);
    }
  }
});

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_intl_numberformat__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chenfengyuan_vue_number_input__ = __webpack_require__(2804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chenfengyuan_vue_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__chenfengyuan_vue_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__configCal_js__ = __webpack_require__(2805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: {
    typeProduct: 10,
    productName: "product"
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_3__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_4__ArnergySelect_vue__["a" /* default */],
    VueIntlNumberformat: __WEBPACK_IMPORTED_MODULE_8_vue_intl_numberformat__["a" /* default */],
    VueNumberInput: __WEBPACK_IMPORTED_MODULE_9__chenfengyuan_vue_number_input___default.a,
    "el-checkbox": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Checkbox"],
    Agreement: __WEBPACK_IMPORTED_MODULE_7__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      range: [0, 500],
      numberPay: 500,
      monthlyPaymentValue: "",
      ten: 6,
      value: 0,
      costShow: false,
      answer: "",
      showAgreement: false,
      depositCondition: false,
      finalFP: "",
      recurringPaymentSetups: "",
      activeIndex: 0,
      numberTenure: "",
      deposits: [{ id: "2900000", name: "Arnergy 5000" }, { id: "4500000", name: "Arnergy 5000X" }, { id: "7500000", name: "Arnergy 10000" }],

      tenures: [{ id: "12 Months tenure ", name: "12 Months tenure" }, { id: "24 Months tenure", name: "24 Months tenure" }, { id: "36 Months tenure", name: "36 Months tenure" }],
      form: {
        product: "2900000",
        income: "",
        employment: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
      // firstPaymentAmt
      // recurrentMonthlyAmt
      // totalPayment
      // cautionFee
      // setupFee
      // upfrontPayment
    };
  },


  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapActions */])(["setUserAmounty", "setTest"]), {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    resetUpfront: function resetUpfront() {
      if (!this.depositCondition) {
        this.value = 0;
        this.PMT(0.015, this.ten, this.typeProduct - this.value, 0, 0);
      }
      // console.log("Resetting...", this.depositCondition);
    },
    PMT: function PMT() {
      var rate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.015;
      var nperiod = arguments[1];
      var pv = arguments[2];
      var fv = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = rate / (pvif - 1) * -((pv - 0.05 * pv) * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }
      this.monthlyPaymentValue = Math.abs(pmt) === "Infinity" ? 0.0 : Math.abs(pmt).toFixed(2);
    },
    passReqFunc: function passReqFunc() {
      var data = {
        monthlyPayment: this.monthlyPaymentValue,
        tenure: this.ten + "",
        upfrontPayment: this.value + "",
        cautionFee: this.monthlyPaymentValue,
        setupFee: this.productName == "Arnergy 5000X" ? "60000" : "0",
        totalFirstPayment: this.ten == 0 && this.value == 0 ? Number(this.monthlyPaymentValue) * 2 + 0.05 * this.typeProduct + "" : Number(this.monthlyPaymentValue) * 2 + this.value + 0.05 * this.typeProduct + "",
        totalPayment: this.ten == 0 && this.value == 0 ? this.typeProduct + 0.05 * this.typeProduct + "" : (this.ten * this.monthlyPaymentValue + 0.05 * this.typeProduct + this.value).toFixed(2) + ""
      };

      localStorage.amtPay = data.totalFirstPayment;
      localStorage.amtRepay = data.monthlyPayment;
      localStorage.proTenure = data.tenure;
      localStorage.cautionFee = data.cautionFee;
      localStorage.setupFee = data.setupFee;
      localStorage.upfrontPayment = data.upfrontPayment;
      localStorage.totalPayment = data.totalPayment;
      this.$store.commit("setUserAmount", data.totalFirstPayment);

      // console.log(data);
      if (data.monthlyPayment == 0) {
        this.$emit("toKyc");
      } else {
        this.$emit("nextFunc");
      }

      // this.$emit('nextFunc',data);
    }
  }),
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.PMT(0.015, _this.ten.length > 6 ? _this.ten : 6, _this.typeProduct, 0, 0);

              // this.setComponentParams();
              // console.log("type product", this.typeProduct);
              // console.log("product name", this.productName);

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1139 */,
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OnboardingSelectButton",
  components: {},
  props: ["title", "ID", "description", "isActive"],

  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    setActive: function setActive() {
      this.$emit("setActive");
    },
    url: function url() {}
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SideIndicator",
  props: {
    items: null,
    activeIndex: {
      default: 0
    }
  },
  components: {},
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    gotoSection: function gotoSection(sectionIndex) {
      this.$emit('gotoSection', sectionIndex);
    },
    isDisabled: function isDisabled(key) {
      return key > this.activeIndex ? true : false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_numeric_input__ = __webpack_require__(2820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_numeric_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_numeric_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_intl_numberformat__ = __webpack_require__(1139);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: ["modalState"],
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    VueNumericInput: __WEBPACK_IMPORTED_MODULE_5_vue_numeric_input___default.a,
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__ArnergySelect_vue__["a" /* default */],
    VueIntlNumberformat: __WEBPACK_IMPORTED_MODULE_6_vue_intl_numberformat__["a" /* default */],

    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      range: [0, 500],
      numberPay: 500,
      ten: 6,
      value: 100000,
      costShow: false,
      showAgreement: false,
      activeIndex: 0,
      numberTenure: "",
      deposits: [{ id: "2900000", name: "Arnergy 5000" }, { id: "4500000", name: "Arnergy 5000X" }, { id: "7500000", name: "Arnergy 10000" }],

      tenures: [{ id: "12 Months tenure ", name: "12 Months tenure" }, { id: "24 Months tenure", name: "24 Months tenure" }, { id: "36 Months tenure", name: "36 Months tenure" }],
      form: {
        product: "2900000",
        income: "",
        employment: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: '',
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: 'Oil & Gas', name: 'Oil & Gas' }, { id: 'Farmer', name: 'Farmer' }, { id: 'Driver', name: 'Driver' }, { id: 'Painter', name: 'Painter' }],
      employmentStatus: [{ id: 'Employed', name: 'Employed' }, { id: 'Self Employed', name: 'Self Employed' }],
      incomes: [{ id: '< N500,000', name: ' < N500,000' }, { id: '>N500,000 and < N750,000', name: '>N500,000 and < N750,000' }, {
        id: '> N750,000 and < N1,000,000',
        name: '> N750,000 and < N1,000,000'
      }, { id: '> N1,000,000', name: '> N1,000,000' }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: '',
        income: '',
        employment: '',
        business: ''
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
      message: 'Success Msg!'
    },
    showInfoMsg: {
      type: 'info',
      title: 'Information',
      message: 'Info. Msg!'
    },
    showWarnMsg: {
      type: 'warning',
      title: 'Warning',
      message: 'Warning Msg!'
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
      message: 'Error Msg!'
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(122);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OnboardingTopBar",
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    return {
      showDropdown: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["setUserSession"]), {
    logout: function logout() {
      this.setUserSession(null);
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push("/auth/login");
      }, 100);
    }
  })
});

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "OnboardingButton",
    props: ['type', 'text', 'margin'],
    data: function data() {
        return {};
    },

    methods: {
        onButtonClick: function onButtonClick() {
            this.$emit("onButtonClick");
        }
    },
    mounted: function mounted() {}
});

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/man-woman.433a499.png";

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shs_ravepay__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shs_Wallet__ = __webpack_require__(69);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    FundWallet: __WEBPACK_IMPORTED_MODULE_2__shs_ravepay__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_3__rightBar__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_4__shs_Wallet__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: "fundwallet",
      txId: "",
      mrchId: "09554",
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "Transaction Amount",
        field: "actualAmount",
        filterable: true
      }, {
        label: "Status",
        field: "status",
        filterable: true
      }, {
        label: "Transaction Type",
        field: "transactionType",
        filterable: true
      }, {
        label: "Date",
        field: "createdAt",
        filterable: true
      }],
      rows: [
        // { user: "300283377", ref: "2012020321", date: "12/12/2015" },
        // { user: "305383177", ref: "2012020321", date: "12/01/1991" }
      ]
    };
  },

  methods: {
    triggerPaygate: function triggerPaygate() {
      this.$refs.upay_form.click();
    },

    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.paymentModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.paymentModal.hide();
    },
    hashCode: function hashCode(str) {
      str = str + "";
      return str;
      // .split("")
      // .reduce(
      //   (prevHash, currVal) =>
      //     ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0,
      //   0
      // );
    },
    generateTx: function generateTx() {
      // console.log(this.getUserSession);
      return this.hashCode(Date.now() * this.getUserSession.id + "");
    },
    getHistory: function getHistory() {
      var HTTP = this.$httpUtils.instance;
      var url = "/transactionHistories?filter[where][userId]=" + this.getUserSession.id;
      if (this.$can("read", "all")) {
        url = "/transactionHistories";
      }

      var container = this;
      HTTP.get(url).then(function (response) {
        // container.$router.push({path: `/device/${response.data.data.inverter_number}`});
        container.rows = response.data;
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession"])),
  mounted: function mounted() {
    if (!this.$can("read", "wallet")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    this.generateTx();
    this.getHistory();
    // console.log(this.getUserSession.id);
  }
});

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequests__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__instalation_instalationList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__instalation_inventoryRequest__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__instalation_ongoingInstalation__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mockData_sectors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mockData_sectors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__mockData_sectors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__ = __webpack_require__(23);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import { ZOHOTHTTP } from "../../../store/actions";





var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.chmanage;
      this._keyStr.chmanage;
    }
    return t;
  },
  decode: function decode(e) {
    manage;
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  },
  _utf8_decode: function _utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  props: ["_activeTab"],
  data: function data() {
    return {
      discountType: "percent",
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      // paymentModel: `OS`,
      // setupFee: "",
      // monthlyFee: "",
      // cautionFee: "",
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "",
            setupFee: "",
            monthlyFee: "",
            cautionFee: ""
          },
          systemCapacity: 5,
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          sendMail: true
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: ""
        },
        desc: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$route.params.activetab,
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_15_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_15_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_15_element_ui__["RadioButton"],
    DeviceRequest: __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__["a" /* default */],
    ManageRequests: __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequests__["a" /* default */],
    ApprovedInstallations: __WEBPACK_IMPORTED_MODULE_9__instalation_instalationList__["a" /* default */],
    OngoingInstallations: __WEBPACK_IMPORTED_MODULE_11__instalation_ongoingInstalation__["a" /* default */],
    inventoryRequest: __WEBPACK_IMPORTED_MODULE_10__instalation_inventoryRequest__["a" /* default */],
    MyDeviceList: __WEBPACK_IMPORTED_MODULE_8__devices_List__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_12__rightBar__["a" /* default */]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_13_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    paymentModel: function paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  }),
  watch: {
    paymentModel: function paymentModel(newVal, oldVal) {
      this.selectedPaymentModel = this.packageConfigs.find(function (x) {
        return x.Package == newVal;
      });
      this.regDataParams.deviceRequest.paymentModel = newVal;
      // console.log(newVal.price);
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      if (this.selectedPaymentModel) {
        this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
        this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
        this.regDataParams.deviceRequest.priceModel.cautionFee = this.calcCaution(this.form.price);
      }
    }
  },
  methods: {
    changeContact: function changeContact() {
      this.form.invoiceType == "initial" ? this.contactList = this.ZcontactList : this.contactList = this.customerList;
      //console.log(this.customerList)
    },
    calcSetup: function calcSetup(price) {
      var setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      var temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub: function calcSub(price) {
      var subscriptionPercent = Number(this.selectedPaymentModel["Subscription"]) / 100;
      var temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution: function calcCaution(price) {
      var cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      var temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var regDataParams, HTTP, resp, error_incomming, tempMsg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.form.package == null)) {
                  _context.next = 4;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select a device type"
                });
                _context.next = 32;
                break;

              case 4:
                if (!(_this.form.sector == null)) {
                  _context.next = 8;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select an sector"
                });
                _context.next = 32;
                break;

              case 8:
                _this.regDataParams.deviceRequest.deviceTypeId = _this.form.package;
                // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
                // this.regDataParams.deviceRequest.orderVat = this.orderVat;
                regDataParams = _this.regDataParams;
                // let orderDiscount = this.orderDiscount;
                // let orderVat = this.orderVat;
                //console.log(this.contactList);
                //console.log(this.form);

                HTTP = _this.$httpUtils.instance;

                console.log(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(regDataParams));
                _context.prev = 12;

                if (!(_this.form.invoiceType == "initial")) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return HTTP.post("/users", regDataParams);

              case 16:
                _context.t0 = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return HTTP.post("/device_requests", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, regDataParams.deviceRequest, {
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: _this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: _this.form.userId
                }));

              case 21:
                _context.t0 = _context.sent;

              case 22:
                resp = _context.t0;

                _this.showSuccessMsg({ message: "Request Submitted" });
                //   // this.activeTab="manage_requests";
                //   // this.renderManageComponent= true;
                _this.showOffCanvas = false;
                _this.$router.push({
                  name: "devices",
                  params: {
                    activetab: "manage_requests"
                  }
                });
                //   this.$router.go();
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](12);

                if (_context.t1.response) {
                  if (_context.t1.response.data) {
                    // console.log(error.response.data);
                    error_incomming = _context.t1.response.data.error.details.messages;
                    // console.log(error_incomming);

                    tempMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(error_incomming).map(function (x) {
                      return x + ": " + error_incomming[x].join(",");
                    });

                    _this.showErrorMsg({
                      message: tempMsg.join("<br>")
                    });
                  }
                }
                console.log({
                  error: _context.t1
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 28]]);
      }))();
    },
    packageSelected: function packageSelected() {
      var _this2 = this;

      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(function (x) {
        return x.id == _this2.form.package;
      })["price"];
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
      this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
      this.regDataParams.deviceRequest.installationName = contact["First_Name"] + " " + contact["Last_Name"];
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    sectorSelected: function sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = "" + sector["name"];
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },
    loadAll: function loadAll() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        // console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this3.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[where][roleType]=customer" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.customerList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    loadModules: function loadModules() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      ZOHOTHTTP.get("/settings/all", {
        headers: {
          Authorization: "Zoho-oauthtoken " + this.zohoToken["accessToken"],
          "Content-Type": " application/json;charset=UTF-8"
        }
      }).then(function (response) {
        container.zohoModules = response.data["data"];
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this4 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this4.createFilter(queryString, contact);
      }) : contacts;
      // console.log({ results });
      cb(results);
    },
    createSectorFilter: function createSectorFilter(queryString, sector) {
      console.log({ sector: sector });
      return ("" + sector.value.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    sectorSearch: function sectorSearch(queryString, cb) {
      var _this5 = this;

      //  sectorList;
      // console.log({sectorList});
      var results = queryString ? __WEBPACK_IMPORTED_MODULE_16__mockData_sectors_json___default.a.filter(function (sect) {
        return _this5.createSectorFilter(queryString.trim(), sect);
      }) : __WEBPACK_IMPORTED_MODULE_16__mockData_sectors_json___default.a;
      // console.log({ results });
      cb(results);
    },

    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this7.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context3.sent;

                _this7.zohoToken = newToken.data.token;
                _this7.showErrorMsg({
                  message: "Token refreshed, Please reload page"
                });
                // this.loadAll();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this8.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this9._activeTab) {
                _this9.activeTab = _this9._activeTab;
              }
              // let _tmpdata = await this.fetchZohoToken();
              _context4.next = 3;
              return _this9.fetchPackageConfig();

            case 3:
              tmpPackageConfig = _context4.sent;

              _this9.packageConfigs = tmpPackageConfig["data"];
              _this9.regDataParams.deviceRequest = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this9.regDataParams.deviceRequest, {
                salesManager: _this9.getUserSession.firstName + " " + _this9.getUserSession.lastName,
                salesManagerContact: "" + _this9.getUserSession.phoneNumber
              });
              // console.log(this.zohoToken.data.token);
              // this.zohoToken = _tmpdata.data.token;
              // this.loadAll();
              _this9.fetchUsers();
              _this9.fetchSysTypes();
              // console.log(this._activeTab);

              // axios.interceptors.response.use(
              //   function(response) {
              //     return response;
              //   },
              //   function(error) {
              //     console.log(error);
              //     // handle error
              //     if (error.response) {
              //       alert(error.response.data.message);
              //     }
              //   }
              // );
              // const HTTP = this.$httpUtils.instance;

              // this.loadModules();

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this9);
    }))();
  }
});

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fingerprintjs2__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_fingerprintjs2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_fingerprintjs2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_modal__ = __webpack_require__(84);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-requests",
  components: {
    Rave: __WEBPACK_IMPORTED_MODULE_6_vue_ravepayment___default.a,
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_modal__["b" /* ModalClose */]
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data: function data() {
    return {
      selectedPayments: {
        setup: true
      },
      checked1: false,
      feePayable: {},
      dialogVisible: false,
      packageConfig: [],
      // TODO: Move ravekey to build env
      // raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      raveKey: "FLWPUBK_TEST-89e9c4e181bd9559a5d47e738cb3363a-X",
      raveBtnText: "Make Payment",
      packageData: null,
      selectedRow: {},
      formData: {
        expirymonth: "00",
        expiryyear: "00",
        email: "",
        name: null,
        firstname: "John",
        lastname: "Doe",
        phonenumber: null,
        amount: 10000,
        deviceFingerprint: "00000",
        //   country: "NG",
        //   currency: "NGN",
        device_fingerprint: {
          components: null,
          result: null
        }
      },
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      responseData: "",
      statusMap: ["Pending Authorization", "Installation Scheduled", "Installation Completed"],
      errors: "",
      componentName: "",
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "Payment Model",
        field: "deviceType.paymentModel",
        filterable: true
      },
      // {
      //   label: "Payment Amount (₦)",
      //   field: "order.paymentAmount",
      //   filterable: true
      // },
      {
        label: "Actions",
        field: "actions"
      }],
      deviceRequests: [],
      rows: []
    };
  },

  methods: {
    getBreakDown: function getBreakDown(base, order) {
      var hasDiscount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (hasDiscount) {
        return {
          base: Math.round(base),
          discount: Math.round(order["discountType"] == "percent" ? base * Number(order["orderDiscount"]) / 100 : order["amountDiscount"]),
          vat: Math.round((base - (order["discountType"] == "percent" ? base * Number(order["orderDiscount"]) / 100 : order["amountDiscount"])) * (Number(order["orderVat"]) / 100)),
          total: Math.round(base - (order["discountType"] == "percent" ? base * Number(order["orderDiscount"]) / 100 : order["amountDiscount"]) + (base - (order["discountType"] == "percent" ? base * Number(order["orderDiscount"]) / 100 : order["amountDiscount"])) * (Number(order["orderVat"]) / 100))
        };
      } else {
        return {
          base: Math.round(base),
          discount: 0,
          vat: Math.round(base * (Number(order["orderVat"]) / 100)),
          total: Math.round(base + base * (Number(order["orderVat"]) / 100))
        };
      }
      // return {
      //   base: base,
      //   vat: base * (Number(vat) / 100),
      //   discount: base * (Number(discount) / 100),
      //   total:
      //     base + base * (Number(vat) / 100) - base * (Number(discount) / 100)
      // };
    },
    getBreakDown_: function getBreakDown_(base, vat, discount) {
      return {
        base: base,
        vat: base * (Number(vat) / 100),
        discount: base * (Number(discount) / 100),
        total: base + base * (Number(vat) / 100) - base * (Number(discount) / 100)
      };
    },
    paymentOptions: function paymentOptions(rowData) {
      this.selectedRow = rowData;
      this.dialogVisible = true;
      var priceModel = JSON.parse(rowData.priceModel);
      if (rowData["paymentModel"] != "OS") {
        var setup = this.getBreakDown(Number(priceModel["setupFee"]), rowData, true);
        var caution = this.getBreakDown(Number(priceModel["cautionFee"]), rowData, false);
        var monthly = this.getBreakDown(Number(priceModel["monthlyFee"]), rowData, false);
        this.feePayable = {
          setup: setup,
          caution: caution,
          monthly: monthly
        };
      } else {
        var outright = this.getBreakDown(Number(priceModel["amount"]), rowData, false);
        this.feePayable = {
          outright: outright
        };
      }
    },
    triggerPayment: function triggerPayment(rowData) {
      // this.selectedRow = rowData;
      // console.log(
      if (this.calculatedAmount < 1) {
        this.showErrorMsg({
          message: "You have not selected any payment"
        });
      } else {
        document.getElementById("paymentBtn_").click();
      }
      // );
    },
    getPrice: function getPrice(order, packageConfig) {
      console.log({ order: order, packageConfig: packageConfig });
      var packageType = order.deviceType;
      var cautionFee = Number(Number(Number(packageType["price"]) * (Number(packageConfig["Subscription"]) / 100)) * Number(packageConfig["Caution"])).toFixed(2);
      var subFee = Number(Number(packageType["price"]) * (Number(packageConfig["Subscription"]) / 100)).toFixed(2);
      var setupFee = Number(Number(packageType["price"]) * (Number(packageConfig["Setup"]) / 100)).toFixed(2);
      var basePrice = order.deviceType.price;
      var orderVat = order.orderVat / 100;
      var orderDiscount = order.orderDiscount / 100;
      if (order["paymentModel"] == "OS") {
        return basePrice + basePrice * orderVat - basePrice * orderDiscount;
      } else {
        return Number(Number(Number(setupFee) + Number(cautionFee) + Number(subFee) + Number(Number(packageType["price"]) * (Number(order["orderVat"]) / 100))) - Number(Number(packageType["price"]) * (Number(order["orderDiscount"]) / 100))).toFixed(2);
      }
    },

    // TODO:: Very important
    calculatePaymentAmount: function calculatePaymentAmount(rowData) {
      var HTTP = this.$httpUtils.instance;
      var packagData, LO_Data, ES_Data;
      // HTTP.get("/package-configs").then(packag => {
      //   packagData = packag.data;
      // });
      // for (i of packagData) {
      //   i.Package == "LO" ? (LO_Data = { ...i }) : (ES_Data = { ...i });
      // }

      ES_Data = this.packageConfig.data.find(function (x) {
        return x.Package == "ES";
      });
      LO_Data = this.packageConfig.data.find(function (x) {
        return x.Package == "LO";
      });

      // console.log({
      //     ES_Data,
      //     LO_Data
      // });

      var finalPrice = 0;
      var basePrice = rowData.deviceType.price;
      var orderVat = rowData.orderVat / 100;
      var orderDiscount = rowData.orderDiscount / 100;

      switch (rowData.paymentModel) {
        case "ES":
          //let price_to_pay = ((ES_Data.Setup / 100) * basePrice) + ((ES_Data.Subscription / 100) * basePrice) + (ES_Data.Subscription * ES_Data.Caution)
          finalPrice = this.getPrice(rowData, ES_Data);
          // finalPrice =
          //     (ES_Data.Setup / 100) * basePrice +
          //     (ES_Data.Subscription / 100) * basePrice +
          //     ES_Data.Subscription * ES_Data.Caution;
          break;
        case "LO":
          finalPrice = this.getPrice(rowData, LO_Data);
          //     finalPrice =
          //       (ES_Data.Setup / 100) * basePrice +
          //       (ES_Data.Subscription / 100) * basePrice +
          //       ES_Data.Subscription * ES_Data.Caution;

          break;
        default:
          finalPrice = this.getPrice(rowData, {});
          break;
      }
      return finalPrice;
      // return {
      //   basePrice,
      //   orderVat,
      //   orderDiscount
      // };
    },

    callback: function () {
      var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee(response) {
        var trRef;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                trRef = response.data;

                trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
                // console.log(trRef.data);
                if (trRef.data.status === "successful") {
                  this.transDone = true;
                } else {
                  this.showErrorMsg({
                    message: "Transaction fails"
                  });
                }
                // this.transComplete = await this.concludeTransaction(
                //   trRef.data.txRef,
                //   this.selectedRow.id
                // );
                this.close;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function callback(_x2) {
        return _ref.apply(this, arguments);
      }

      return callback;
    }(),
    close: function close() {
      console.log("Payment closed");
    },
    concludeTransaction: function concludeTransaction(txRef, requestId) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var data, str, tempReg, HTTP, url;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = true;
                str = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                  txref: txRef,
                  requestId: requestId
                });
                tempReg = JSON.parse(str);
                HTTP = _this.$httpUtils.instance;
                url = "/payments/initial/request";
                return _context2.abrupt("return", HTTP.post(url, tempReg).then(function (response) {
                  _this.myResponse = response.data.data[0];
                  // console.log(response.data.data[0]);
                  data = true;
                  return true;
                }).catch(function (error) {
                  console.log(error);
                  var errorMsg = error.response.data.message;
                  _this.showErrorMsg({
                    message: errorMsg
                  });
                  return false;
                }));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }))();
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },
    getRegLink: function getRegLink(link) {
      return link + this.getUserSession.loggegInUser.token;
    },

    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo: function navTo(id) {
      this.$router.push({
        name: "deviceRequestStatus",
        params: {
          id: id
        }
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDummy", "getUserSession"]), {
    paymentMeta: function paymentMeta() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.selectedRow, {
        selectedPayments: this.selectedPayments,
        type: "initial"
      });
    },
    reference: function reference() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    },
    calculatedAmount: function calculatedAmount() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.selectedPayments).reduce(function (x, ind_) {
        return x += _this2.selectedPayments[ind_] == true && _this2.feePayable[ind_] ? _this2.feePayable[ind_]["total"] : 0;
      }, 0);
    }
    // productReg: {
    //   get(){
    //     return this._productReg+ this.getUserSession.loggedInUser.token;
    //   },
    //   set(val){
    //     // this.productReg = this.productReg+ this.getUserSession.loggedInUser.token;
    //   }
    // }

  }),
  watch: {
    // selectedPayments:function(val){
    //   console.log(val);
    // Object.keys(selectedPayments).reduce((sum,index)=>{
    //         sum+=feePayable[x]['total'];
    //         return sum;
    //       },0)
    // }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var HTTP, container, userId, realm, fp;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              HTTP = _this3.$httpUtils.instance;
              container = _this3;
              userId = _this3.getUserSession.id;
              realm = _this3.getUserSession.realm;
              fp = __WEBPACK_IMPORTED_MODULE_7_fingerprintjs2___default()();

              _this3.formData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.formData, {
                firstname: _this3.getUserSession.firstName,
                lastname: _this3.getUserSession.lastName,
                email: _this3.getUserSession.email,
                phonenumber: _this3.getUserSession.phoneNumber,
                name: _this3.getUserSession.firstName + " " + _this3.getUserSession.lastName
              });
              fp.get(function (result, components) {
                container.formData.deviceFingerprint = result; // a hash, representing your device fingerprint
                container.formData.device_fingerprint = {
                  result: result,
                  components: components
                }; // an array of FP components
              });
              // console.log({ formData: this.formData });

              _context3.next = 9;
              return HTTP.get("/package-configs");

            case 9:
              _this3.packageConfig = _context3.sent;

              //  .then(packag => {
              //     packagData = packag.data;
              //   });
              HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"transactionHistories\",{\"deviceType\": { \"packageComponents\": \"componentType\" }}], \"where\": {\"and\":[{\"userId\":" + userId + "}, {\"or\":[{\"status\": 0},{\"status\": 1},{\"status\": 2},{\"status\": 3},{\"status\": 4}]}]}}", {}).then(function (response) {
                // console.log(response)
                // console.log(JSON.stringify(rolesdata.data))
                container.deviceRequests = response.data.filter(function (x) {
                  return x.user;
                });
              });

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  }
});

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enquiries_index__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { ZOHOTHTTP } from "../../../store/actions";






var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
    }
    return t;
  },
  decode: function decode(e) {
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  },
  _utf8_decode: function _utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  data: function data() {
    return {
      assignedTo: null,
      installationContact: null,
      selectedPaymentModel: [],
      packageConfigs: [],
      paymentModel: "OS",
      orderVat: 5,
      orderDiscount: 0,
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          paymentModel: "OS",
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: "No comment here	Roof is ready for installation"
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      assignList: [],
      form: {
        assignedTo: "",
        issue: "",
        start: "",
        end: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$can("manage", "mine") ? "device_request" : "manage_requests",
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_6_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_6_element_ui__["RadioButton"],
    "el-date-picker": __WEBPACK_IMPORTED_MODULE_6_element_ui__["DatePicker"],
    // DeviceRequest,
    Enquiries: __WEBPACK_IMPORTED_MODULE_3__enquiries_index__["a" /* default */]
    // HotelDatePicker
    // ManageRequests,
    // ScheduleInstallation,
    // ApprovedInstallations,
    // MyDeviceList,
    // RightBar
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserSession", "getUsers"])),

  // watch: {
  //   paymentModel: function(newVal, oldVal) {
  //     this.selectedPaymentModel = this.packageConfigs.find(
  //       x => x.Package == newVal
  //     );
  //     this.regDataParams.deviceRequest.paymentModel = newVal;
  //   }
  // },
  methods: {
    // calcSetup(paymentModel) {
    //   let setupPercent = Number(this.selectedPaymentModel["Setup"]);
    //   // console.log({ setupPercent });
    //   return setupPercent * this.form.price;
    // },
    // calcSub(paymentModel) {
    //   let subscriptionPercent = Number(
    //     this.selectedPaymentModel["Subscription"]
    //   );
    //   // console.log({ subscriptionPercent });
    //   return subscriptionPercent * this.form.price;
    // },
    value: function value() {
      // this.form.timeline =
      this.form.start = this.form.timeline[0];
      this.form.end = this.form.timeline[1];
      delete this.form.timeline;

      // console.log({
      //   form: JSON.stringify(this.form)
      // })
    },
    onSubmit: function onSubmit() {
      var _this = this;

      // console.log(this.form);
      var container = this;
      var HTTP = this.$httpUtils.instance;
      HTTP.post("/maintenance", this.form).then(function (response) {
        // console.log(response);
        container.showInfoMsg({
          message: "Complaint Added"
        });
        container.showOffCanvas = false;
        window.location.reload();
        //container.init();
      }).catch(function (error) {
        console.log("error", error);
        _this.showErrorMsg({
          message: error
        });
      });
    },

    // async onSubmit() {
    //   this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
    //   this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
    //   this.regDataParams.deviceRequest.orderVat = this.orderVat;
    //   let regDataParams = this.regDataParams;
    //   // let orderDiscount = this.orderDiscount;
    //   // let orderVat = this.orderVat;
    //   // console.log({ regDataParams });
    //   const HTTP = this.$httpUtils.instance;
    //   try {
    //     let resp = await HTTP.post("/users", regDataParams);
    //   } catch (error) {
    //     if (error.response) {
    //       if (error.response.data) {
    //         // console.log(error.response.data);
    //         let error_incomming = error.response.data.error.details.messages;
    //         // console.log(error_incomming);
    //         let tempMsg = Object.keys(error_incomming).map(
    //           x => `${x}: ${error_incomming[x].join(",")}`
    //         );
    //         this.showErrorMsg({
    //           message: tempMsg.join("<br>")
    //         });
    //       }
    //     }
    //     console.log({
    //       error
    //     });
    //   }
    //   // .then(resp => {
    //   //   console.log(resp);
    //   // })
    //   // .catch(function(error_incomming) {
    //   //   console.log(error_incomming);
    //   // let tempMsg = Object.keys(error_incomming["messages"]).map(
    //   //   x => `${x}: ${error_incomming[x].join(",")}`
    //   // );
    //   // this.showWarnMsg({
    //   //   message: tempMsg.join("<br>")
    //   // });
    //   // });
    // },
    // packageSelected() {
    //   this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
    //   this.form.price = this.systemTypes.find(x => x.id == this.form.package)[
    //     "price"
    //   ];
    //   // console.log({
    //   //   form: this.form
    //   // });
    // },
    contactSelected: function contactSelected(contact) {
      this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.form, {
        installationId: contact["id"]
      });
    },
    userSelected: function userSelected(user) {
      this.form = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.form, {
        assignedTo: user["id"]
      });
      console.log({
        form: this.form
      });
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },

    // loadAll() {
    //   console.log("++++++++++++++++++++++++++");
    //   // console.log(this.zohoToken);
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   let container = this;
    //   ZOHOTHTTP.get(`fetchAll`, {
    //     params: {
    //       collection: "Leads?fields=Email,First_Name,Last_Name,Phone"
    //     }
    //   })
    //     .then(response => response.data["result"]["data"])
    //     .then(tempList => {
    //       // console.log(tempList);

    //       container.contactList = tempList.map(x => ({
    //         ...x,
    //         value: `${x.First_Name} ${x.Last_Name}`
    //       }));
    //     })
    //     .catch(e => {
    //       console.log("========Err=========");
    //       console.log(e);
    //       // this.refreshZohoToken();
    //     });
    // },
    // loadModules() {
    //   console.log("++++++++++++++++++++++++++");
    //   // console.log(this.zohoToken);
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   let container = this;
    //   ZOHOTHTTP.get(`/settings/all`, {
    //     headers: {
    //       Authorization: `Zoho-oauthtoken ${this.zohoToken["accessToken"]}`,
    //       "Content-Type": " application/json;charset=UTF-8"
    //     }
    //   })
    //     .then(response => {
    //       container.zohoModules = response.data["data"];
    //     })
    //     .catch(e => {
    //       console.log("========Err=========");
    //       console.log(e);
    //       // this.refreshZohoToken();
    //     });
    // },
    // createFilter(queryString, contact) {
    //   return (
    //     `${contact.First_Name} ${contact.Last_Name}`
    //       .toLowerCase()
    //       .indexOf(queryString.toLowerCase()) > -1
    //   );
    // },
    createContactFilter: function createContactFilter(queryString, user) {
      //   console.log(user.name)
      return ("" + user.name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    createUserFilter: function createUserFilter(queryString, user) {
      return (user.firstName + " " + user.lastName).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this2 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this2.createContactFilter(queryString, contact);
      }) : contacts;
      cb(results);
    },
    userSearch: function userSearch(queryString, cb) {
      var _this3 = this;

      var users = this.assignList;
      var results = queryString ? users.filter(function (user) {
        return _this3.createUserFilter(queryString, user);
      }) : users;
      cb(results);
    },

    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this4.$httpUtils.instance;
                _context.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },

    // async refreshZohoToken() {
    //   const HTTP = this.$httpUtils.instance;
    //   let newToken = await HTTP.post("/zohos/refresh-zoho-token");
    //   this.zohoToken = newToken.data.token;
    //   this.loadAll();e
    // },
    fetchSysTypes: function fetchSysTypes() {
      var _this5 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this5.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchAssignList: function fetchAssignList() {
      var _this6 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType]=customer operations engineer" + "&filter[order]=id DESC";
      HTTP.get(url)
      // .then(response => {
      //   const usersList = response.data;
      //   console.log(usersList)
      //   this.$store.commit("saveUsers", usersList);
      //   // console.log(this.getUserById(1))
      // })
      .then(function (response) {
        return response.data;
      }).then(function (tempList) {
        // console.log(tempList);

        _this6.assignList = tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, x, {
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchContactList: function fetchContactList() {
      var _this7 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/installations?filter={\"include\":[\"deviceType\",\"user\"]}";
      //  url = `/users?filter[include][installations]=deviceType&filter[where][roleType]=customer`;
      HTTP.get(url)
      // .then(response => {
      //   const usersList = response.data;
      //   console.log(usersList)
      //   this.$store.commit("saveUsers", usersList);
      //   // console.log(this.getUserById(1))
      // })
      .then(function (response) {
        return response.data;
      }).then(function (tempList) {
        // console.log(tempList);
        //  this.contactList = tempList.filter(x =>  {
        //             if(x.name.trim() !== '- -'){
        //                console.log(x.name);
        //             }
        //           });
        _this7.contactList = tempList.filter(function (x) {
          return x.name.trim() !== "- -";
        }).map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, x, {
            value: x.name + " " + (" " + x.deviceType.name + ",  ") + (" " + x.solarKitIds)
          });
        });

        // x.name.trim() !== '- -' ? ({
        //   ...x,
        //   value: `${x.name} ` + ` ${x.deviceType.name},  `     + ` ${x.solarKitIds}`
        // }): false);
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this8.fetchPackageConfig();

            case 2:
              tmpPackageConfig = _context2.sent;

              _this8.packageConfigs = tmpPackageConfig["data"];
              // console.log(this.zohoToken.data.token);
              // this.zohoToken = _tmpdata.data.token;
              // this.loadAll();
              _this8.fetchSysTypes();
              _this8.assignList = _this8.fetchAssignList();
              _this8.contactList = _this8.fetchContactList();

              // axios.interceptors.response.use(
              //   function(response) {
              //     return response;
              //   },
              //   function(error) {
              //     console.log(error);
              //     // handle error
              //     if (error.response) {
              //       alert(error.response.data.message);
              //     }
              //   }
              // );
              // const HTTP = this.$httpUtils.instance;

              // this.loadModules();

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this8);
    }))();
  }
});

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__report_config__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__ = __webpack_require__(23);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { ZOHOTHTTP } from "../../../store/actions";





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  data: function data() {
    return {
      selectedPaymentModel: [],
      packageConfigs: [],
      paymentModel: "OS",
      orderVat: 5,
      orderDiscount: 0,

      form: {
        endpoint: "",
        field: "",
        operation: "",
        inputValue: "",
        dynamicTags: [],
        inputVisible: false
      },
      formResults: [],
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: "report_config",
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_6_element_ui__["FormItem"],
    "el-tag": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Tag"],
    ReportConfig: __WEBPACK_IMPORTED_MODULE_3__report_config__["a" /* default */]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserSession"])),
  // watch: {
  //   paymentModel: function(newVal, oldVal) {
  //     this.selectedPaymentModel = this.packageConfigs.find(
  //       x => x.Package == newVal
  //     );
  //     this.regDataParams.deviceRequest.paymentModel = newVal;
  //   }
  // },
  methods: {
    handleClose: function handleClose(tag) {
      this.form.dynamicTags.splice(this.form.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.form.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.form.inputValue;
      if (inputValue) {
        this.form.dynamicTags.push(inputValue);
      }
      this.form.inputVisible = false;
      this.form.inputValue = "";
    },
    onSubmit: function onSubmit() {
      var inputResults = this.form;
      if (inputResults) {
        this.formResults.push(inputResults);
      }

      console.log(this.formResults);

      // this.form.endpoint = ""
      // this.form.inputValue = ""
      // this.form.dynamicTags = []
      // this.form.operation = ""
      // this.form.field = ""
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__inventory_index__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__inventory_components__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__ = __webpack_require__(84);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-modal-title": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["c" /* ModalTitle */],
    "vk-modal": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["a" /* Modal */],
    "vk-modal-close": __WEBPACK_IMPORTED_MODULE_7_vuikit_lib_modal__["b" /* ModalClose */],
    "el-form": __WEBPACK_IMPORTED_MODULE_3_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_3_element_ui__["FormItem"],
    Inventory: __WEBPACK_IMPORTED_MODULE_4__inventory_index__["a" /* default */],
    InventoryComponent: __WEBPACK_IMPORTED_MODULE_5__inventory_components__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: "inventory_component",
      showOffCanvas: false,
      showAddInventoryModal: false,
      multiple: true,
      componentForm: {
        componentId: null,
        componentTypeId: null,
        serialNumber: null,
        type: "component",
        userId: 0
      },
      serialForm: {
        min: null,
        max: null
      },
      getComponentName: function getComponentName(param) {
        try {
          return this.componentOptions.filter(function (x) {
            return x.value == param;
          })[0].name;
        } catch (error) {
          return "";
        }
      },

      componentOptions: [{
        value: null,
        disabled: true,
        text: "Select component"
      }],
      componentTypeOptions: [{
        value: null,
        disabled: true,
        text: "Select component type"
      }]
    };
  },

  computed: {},
  methods: {
    showModal: function showModal() {
      this.$refs.myModalRef.show();
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    fetchComponentTypes: function fetchComponentTypes(selectedCompId) {
      console.log(selectedCompId);
      if (selectedCompId !== null) {
        var context = this;
        var HTTP = this.$httpUtils.instance;
        var url = "/components/" + selectedCompId + "/componentTypes";
        HTTP.get(url).then(function (response) {
          var componentList = response.data;
          componentList.filter(function (x) {
            x.value = x.id;
            x.text = x.name;
          });
          context.componentTypeOptions = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(context.componentTypeOptions), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(componentList));
        });
      }
    },
    addInventory: function addInventory() {
      var url = "/inventories";
      if (this.multiple) {
        this.componentForm.serialNumber = this.serialForm.min + "->" + this.serialForm.max;
        url = "/inventories/multiple";
      }
      if (this.validateRequestForm() === true) {
        this.componentForm.userId = this.getUserSession.id;
        var container = this;
        var HTTP = this.$httpUtils.instance;
        HTTP.post(url, this.componentForm).then(function (response) {
          container.showSuccessMsg({
            message: response.data + "\nComponent(s) Added"
          });
          container.hideModal();
          container.getComponents();
        }).catch(function (error) {
          var errorMsg = error.response.data.error.details.messages;
          var errTemp = [];
          var keyHooks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(errorMsg);
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(errorMsg).map(function (x, index) {
            errTemp[index] = keyHooks[index] + " " + x[0];
          });
          errTemp = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(errTemp).join("<br>");
          container.showErrorMsg({
            message: errTemp
          });
        });
      } else {
        this.showErrorMsg({
          message: this.validateRequestForm()
        });
      }
    }
  }
});

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_4_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_4_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_4_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_0__users_index__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_1__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_2__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_3__users_allow__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list"
    };
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_customers__ = __webpack_require__(2856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__users_invoices__ = __webpack_require__(2862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rightBar__ = __webpack_require__(115);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    Customers: __WEBPACK_IMPORTED_MODULE_0__users_customers__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_2__devices_List__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_5__rightBar__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_3__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_4__users_allow__["a" /* default */],
    Invoices: __WEBPACK_IMPORTED_MODULE_1__users_invoices__["a" /* default */]
  },
  data: function data() {
    return {
      activeTab: "customer_list"
    };
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util__ = __webpack_require__(2858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_util__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */



// import { ZOHOTHTTP } from "../../../store/actions";
// https://www.zohoapis.com/crm/v2


__WEBPACK_IMPORTED_MODULE_6_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "customers",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_8_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_7_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_7_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_7_element_ui__["FormItem"]
  },
  data: function data() {
    return {
      zohoToken: {},
      contactList: [],
      usersList: [],
      form: {
        // links: [],
        contact: "",
        invoiceType: "",
        price: "",
        desc: ""
      },

      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceRequest&filter[include][installations]=deviceType&filter[where][roleType]=customer" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        _this.usersList = response.data;
      }).catch(function (error) {
        console.log("error", error);
      });
    },

    // querySearch(queryString, cb) {
    //   var links = this.form.links;
    //   var results = queryString
    //     ? links.filter(this.createFilter(queryString))
    //     : links;
    //   // call callback function to return suggestions
    //   cb(results);
    // },
    // createFilter(queryString) {
    //   return link => {
    //     return (
    //       link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    //     );
    //   };
    // },
    loadAll: function loadAll() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: "Contacts?fields=Email,Full_Name,Phone"
        }
      }).then(function (response) {
        return response.data["result"]["data"];
      }).then(function (tempList) {
        container.contactList = tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, x, {
            value: x.Full_Name
          });
        });
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },

    // querySearchAsync(queryString, cb) {
    //   var links = this.links;
    //   var results = queryString
    //     ? links.filter(this.createFilter(queryString))
    //     : links;
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     cb(results);
    //   }, 3000 * Math.random());
    // },
    createFilter: function createFilter(queryString, contact) {
      return contact.Full_Name.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this2 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this2.createFilter(queryString, contact);
      }) : contacts;
      cb(results);
    },
    onSubmit: function onSubmit() {
      console.log(this.form.links);
    },
    fetchZohoToken: function fetchZohoToken() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this3.$httpUtils.instance;
                _context.next = 3;
                return HTTP.get("/zohos/get-zoho-token");

              case 3:
                return _context.abrupt("return", _context.sent);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this4.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context2.sent;

                _this4.zohoToken = newToken.data.token;
                _this4.loadAll();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this5.fetchUsers();
              _this5.loadAll();
              // console.log(this.zohoToken);

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_4_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "invoices",
  components: {
    // "vk-offcanvas": Offcanvas,
    // "vk-offcanvas-close": OffcanvasClose
  },
  data: function data() {
    return {
      links: [],
      state: "",
      timeout: null,
      showOffCanvas: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getDummy", "getDevices"]), {
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    searchTable: function searchTable(row, col, cellValue, searchTerm) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(row).join("<%>").toLowerCase().indexOf(searchTerm.toLowerCase()) > -1;
    },
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_4_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType]=CUSTOMER" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit("saveUsers", usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
    // this.links = this.loadAll();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_Notification__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__instalation_inventoryRequest__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__instalation_ongoingInstalation__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mockData_sectors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__mockData_sectors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__mockData_sectors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuikit_lib_offcanvas__ = __webpack_require__(23);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












// import { ZOHOTHTTP } from "../../../store/actions";





var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.chmanage;
      this._keyStr.chmanage;
    }
    return t;
  },
  decode: function decode(e) {
    manage;
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  },
  _utf8_decode: function _utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  props: ["_activeTab"],
  data: function data() {
    return {
      discountType: "percent",
      usertype: localStorage.roleType,
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      // paymentModel: `OS`,
      // setupFee: "",
      // monthlyFee: "",
      // cautionFee: "",
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        def: true,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "",
            setupFee: "",
            monthlyFee: "",
            cautionFee: ""
          },
          systemCapacity: 5,
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          sendMail: true
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: ""
        },
        desc: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$route.params.activetab,
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_20_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_20_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_18_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioButton"],
    DeviceRequest: __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__["a" /* default */],
    ManageRequestsuser: __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__["a" /* default */],
    ApprovedInstallations: __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__["a" /* default */],
    OngoingInstallations: __WEBPACK_IMPORTED_MODULE_14__instalation_ongoingInstalation__["a" /* default */],
    inventoryRequest: __WEBPACK_IMPORTED_MODULE_13__instalation_inventoryRequest__["a" /* default */],
    MyDeviceList: __WEBPACK_IMPORTED_MODULE_11__devices_List__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_15__rightBar__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_8__devices_Notification__["a" /* default */],
    Users: __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__["a" /* default */],
    CustomerGroup: __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__["a" /* default */]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    paymentModel: function paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  }),
  watch: {
    paymentModel: function paymentModel(newVal, oldVal) {
      this.selectedPaymentModel = this.packageConfigs.find(function (x) {
        return x.Package == newVal;
      });
      this.regDataParams.deviceRequest.paymentModel = newVal;
      // console.log(newVal.price);
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      if (this.selectedPaymentModel) {
        this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
        this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
        this.regDataParams.deviceRequest.priceModel.cautionFee = this.calcCaution(this.form.price);
      }
    }
  },
  methods: {
    changeContact: function changeContact() {
      this.form.invoiceType == "initial" ? this.contactList = this.ZcontactList : this.contactList = this.customerList;
      //console.log(this.customerList)
    },
    calcSetup: function calcSetup(price) {
      var setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      var temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub: function calcSub(price) {
      var subscriptionPercent = Number(this.selectedPaymentModel["Subscription"]) / 100;
      var temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution: function calcCaution(price) {
      var cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      var temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var regDataParams, HTTP, resp, error_incomming, tempMsg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.form.package == null)) {
                  _context.next = 4;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select a device type"
                });
                _context.next = 32;
                break;

              case 4:
                if (!(_this.form.sector == null)) {
                  _context.next = 8;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select an sector"
                });
                _context.next = 32;
                break;

              case 8:
                _this.regDataParams.deviceRequest.deviceTypeId = _this.form.package;
                // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
                // this.regDataParams.deviceRequest.orderVat = this.orderVat;
                regDataParams = _this.regDataParams;
                // let orderDiscount = this.orderDiscount;
                // let orderVat = this.orderVat;
                //console.log(this.contactList);
                //console.log(this.form);

                HTTP = _this.$httpUtils.instance;

                console.log(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(regDataParams));
                _context.prev = 12;

                if (!(_this.form.invoiceType == "initial")) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return HTTP.post("/users", regDataParams);

              case 16:
                _context.t0 = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return HTTP.post("/device_requests", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, regDataParams.deviceRequest, {
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: _this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: _this.form.userId
                }));

              case 21:
                _context.t0 = _context.sent;

              case 22:
                resp = _context.t0;

                _this.showSuccessMsg({ message: "Request Submitted" });
                //   // this.activeTab="manage_requests";
                //   // this.renderManageComponent= true;
                _this.showOffCanvas = false;
                _this.$router.push({
                  name: "devices",
                  params: {
                    activetab: "manage_requests"
                  }
                });
                //   this.$router.go();
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](12);

                if (_context.t1.response) {
                  if (_context.t1.response.data) {
                    // console.log(error.response.data);
                    error_incomming = _context.t1.response.data.error.details.messages;
                    // console.log(error_incomming);

                    tempMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(error_incomming).map(function (x) {
                      return x + ": " + error_incomming[x].join(",");
                    });

                    _this.showErrorMsg({
                      message: tempMsg.join("<br>")
                    });
                  }
                }
                console.log({
                  error: _context.t1
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 28]]);
      }))();
    },
    packageSelected: function packageSelected() {
      var _this2 = this;

      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(function (x) {
        return x.id == _this2.form.package;
      })["price"];
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
      this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
      this.regDataParams.deviceRequest.installationName = contact["First_Name"] + " " + contact["Last_Name"];
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    sectorSelected: function sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = "" + sector["name"];
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },
    loadAll: function loadAll() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        // console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this3.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      //  filter={"include": ["installations"]}
      // &filter[order]=id DESC
      var url = "/users?filter[where][roleType]=customer" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.customerList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    loadModules: function loadModules() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      ZOHOTHTTP.get("/settings/all", {
        headers: {
          Authorization: "Zoho-oauthtoken " + this.zohoToken["accessToken"],
          "Content-Type": " application/json;charset=UTF-8"
        }
      }).then(function (response) {
        container.zohoModules = response.data["data"];
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this4 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this4.createFilter(queryString, contact);
      }) : contacts;
      // console.log({ results });
      cb(results);
    },
    createSectorFilter: function createSectorFilter(queryString, sector) {
      console.log({ sector: sector });
      return ("" + sector.value.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    sectorSearch: function sectorSearch(queryString, cb) {
      var _this5 = this;

      //  sectorList;
      // console.log({sectorList});
      var results = queryString ? __WEBPACK_IMPORTED_MODULE_19__mockData_sectors_json___default.a.filter(function (sect) {
        return _this5.createSectorFilter(queryString.trim(), sect);
      }) : __WEBPACK_IMPORTED_MODULE_19__mockData_sectors_json___default.a;
      // console.log({ results });
      cb(results);
    },

    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this7.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context3.sent;

                _this7.zohoToken = newToken.data.token;
                _this7.showErrorMsg({
                  message: "Token refreshed, Please reload page"
                });
                // this.loadAll();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this8.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this9._activeTab) {
                _this9.activeTab = _this9._activeTab;
              }
              // let _tmpdata = await this.fetchZohoToken();
              _context4.next = 3;
              return _this9.fetchPackageConfig();

            case 3:
              tmpPackageConfig = _context4.sent;

              _this9.packageConfigs = tmpPackageConfig["data"];
              _this9.regDataParams.deviceRequest = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this9.regDataParams.deviceRequest, {
                salesManager: _this9.getUserSession.firstName + " " + _this9.getUserSession.lastName,
                salesManagerContact: "" + _this9.getUserSession.phoneNumber
              });
              // console.log(this.zohoToken.data.token);
              // this.zohoToken = _tmpdata.data.token;
              // this.loadAll();
              _this9.fetchUsers();
              _this9.fetchSysTypes();
              // console.log(this._activeTab);

              // axios.interceptors.response.use(
              //   function(response) {
              //     return response;
              //   },
              //   function(error) {
              //     console.log(error);
              //     // handle error
              //     if (error.response) {
              //       alert(error.response.data.message);
              //     }
              //   }
              // );
              // const HTTP = this.$httpUtils.instance;

              // this.loadModules();

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this9);
    }))();
  }
});

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fs_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raw_loader_templates_invoice_ejs__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_mgt_Subgroup_vue__ = __webpack_require__(2872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_mgt_Group_vue__ = __webpack_require__(2879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_mgt_GroupItem_vue__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_mgt_Customers_vue__ = __webpack_require__(2890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import ejs from "ejs";











var dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [{
      quantity: 1,
      createdAt: "2019-07-02T12:28:34.267Z",
      updatedAt: "2019-07-02T12:28:34.267Z",
      id: 12,
      deviceTypeId: 3,
      componentId: 2,
      componentTypeId: null,
      componentType: {
        name: "inverter",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 2
      }
    }, {
      quantity: 2,
      createdAt: "2019-07-02T12:28:47.102Z",
      updatedAt: "2019-07-02T12:28:47.102Z",
      id: 13,
      deviceTypeId: 3,
      componentId: 1,
      componentTypeId: null,
      componentType: {
        name: "battery",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 1
      }
    }, {
      quantity: 15,
      createdAt: "2019-07-02T14:16:33.398Z",
      updatedAt: "2019-07-02T14:16:33.398Z",
      id: 16,
      deviceTypeId: 3,
      componentId: 3,
      componentTypeId: null,
      componentType: {
        name: "solar panels",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 3
      }
    }]
  },
  selectedRequest: null
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-requests",
  data: function data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
      centerDialogVisible2: false,
      defPage: true,
      usertype: localStorage.roleType,
      secPage: false,
      showModal: false,
      activeTab: "manage_requestsdd",
      starting: true,
      form: {
        name: '',
        desc: ''
      },
      formErrors: {
        name: '',
        description: ''
      },
      notificationShow: false,
      emailShow: false,
      smsShow: false,
      subgropShow: false,
      lastPage: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "System Capacity",
        field: "system.capacity",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }],
      deviceRequests: [],
      rows: []
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_12_element_ui__["Dialog"],
    ModalMain: __WEBPACK_IMPORTED_MODULE_10__kitchen_Onboarding_ModalMain_vue__["a" /* default */],
    Customers: __WEBPACK_IMPORTED_MODULE_9__user_mgt_Customers_vue__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_11__kitchen_ArnergyInput_vue__["a" /* default */],
    Group: __WEBPACK_IMPORTED_MODULE_7__user_mgt_Group_vue__["a" /* default */],
    GroupItem: __WEBPACK_IMPORTED_MODULE_8__user_mgt_GroupItem_vue__["a" /* default */],
    Subgroup: __WEBPACK_IMPORTED_MODULE_6__user_mgt_Subgroup_vue__["a" /* default */]
  },
  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.invoiceModal.hide();
    },
    sub: function sub() {
      console.log('tutu');
    },
    navTo: function navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    fetchInvoice: function fetchInvoice(rowData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, user, packageConfig, packageType, html, el, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log({ rowData, templateLocation });
                _this.showInvoice = true;
                order = dataParam.order, user = dataParam.user, packageConfig = dataParam.packageConfig, packageType = dataParam.packageType;
                // readString(templateLocation).then(console.log);

                html = ejs.render(__WEBPACK_IMPORTED_MODULE_4_raw_loader_templates_invoice_ejs__["a" /* default */], {
                  order: order,
                  user: user,
                  packageConfig: packageConfig,
                  packageType: packageType,
                  setupURL: false
                });
                el = _this.$refs.invoiceSection;
                options = {
                  type: "dataURL"
                };

                _this.receiptData = html;
                // this.finalData = await this.$html2canvas(el, options);
                // console.log({ finalData });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showFirst: function showFirst() {
      this.defPage = false;
      this.lastPage = true;
      this.secPage = true;
    },
    addModal: function addModal() {
      this.showModal = true;
    },
    deleteRequest: function deleteRequest(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete("/device_requests/" + id).then(function (response) {
        _this2.centerDialogVisible = false;
        window.location.reload(true);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    var HTTP = this.$httpUtils.instance;
    var container = this;

    // {"status": 1}
    HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"transactionHistories\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}], \n      \"where\": {\n        \"or\":[\n          {\"status\": 0},\n          {\"status\": 1}\n        ]\n        } }", {}).then(function (response) {
      // console.log(JSON.stringify(rolesdata.data))
      console.log({ response: response });

      container.deviceRequests = response.data.filter(function (x) {
        return x.user;
      });
    });
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_mgt_SubgroupInfo__ = __webpack_require__(2874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__ = __webpack_require__(23);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_18_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioButton"],
    SubgroupInfo: __WEBPACK_IMPORTED_MODULE_7__user_mgt_SubgroupInfo__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_8__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_9__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_10__users_allow__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_12__kitchen_ArnergyInput_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_13__kitchen_ArnergySelect_vue__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_14_vue_sweetalert2__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  }, computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_16_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getGroups', 'getDummy', 'getDevices'])),
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      loader: false,
      form: {
        subname: null,
        groupID: null,
        description: null,
        status: false
      },
      errorGroup: false,
      groups: [{ id: null, name: null }],
      loading: false,
      formErrors: {
        name: "",
        description: ""
      }
    };
  },

  methods: {
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "subname":
              if (value === "null" || value === "") {
                formErrors[field] = "Group Name cannot be empty.";
              }
              break;
            case "description":
              if (value === "null" || value === "") {
                formErrors[field] = "Group Description cannot be empty.";
              }
              break;

            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    createSub: function createSub(e) {
      var _this = this;

      e.preventDefault();
      var data = {
        groupid: this.form.groupID,
        subgroupname: this.form.subname,
        subgroupdesc: this.form.description,
        status: this.form.status
      };
      console.log(data);
      var HTTP = this.$httpUtils.instance;
      if (data.groupid && data.subgroupname && data.subgroupdesc) {
        this.loader = true;
        HTTP.post("/customerSubGroups", data).then(function (res) {
          if (res.data) {
            _this.showModal = false;
            _this.showAlert();
            _this.loader = false;
            _this.groupID = null;
            _this.form.subname = null;
            _this.form.description = null;
            _this.form.status = false;
            _this.fetchSubgroups();
          }
        }).catch(function (err) {
          console.log(err);
        });
        return;
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this.errorGroup = false;
        }, 1500);

        return;
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.groupID = "";
      this.form.subname = "";
      this.form.description = "";
      this.form.status = false;
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({ title: 'Success', imageWidth: '40px', text: 'SubGroup Created Successfully', icon: 'success', width: '550px' });
    },
    triggerSubgroup: function triggerSubgroup() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log({ getGroups: _this2.getGroups });
                res = _this2.getGroups.map(function (v) {
                  return {
                    id: v.id,
                    name: v.groupname
                  };
                });

                if (res) {

                  _this2.showModal = true;
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchGroups: function fetchGroups(e) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (e) {
                  e.preventDefault();
                }

                HTTP = _this3.$httpUtils.instance;
                _context2.next = 4;
                return HTTP.get("/customerGroups");

              case 4:
                res = _context2.sent;
                return _context2.abrupt("return", res.data.map(function (item) {
                  return {
                    id: item.id,
                    name: item.groupname
                  };
                }).sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    fetchSubgroups: function fetchSubgroups() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/customerSubGroups/getCustomerSubgroups\n";
      HTTP.post(url).then(function (response) {
        var usersList = response.data;
        _this4.$store.commit("saveSubgroups", usersList.map(function (data) {
          return {
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            subgroupdesc: data.subgroupdesc,
            status: data.status == 0 ? "Disabled" : "Enabled",
            id: data.id
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this5.fetchGroups();

            case 2:
              _this5.groups = _context3.sent;

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this5);
    }))();
  }
});

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */




__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'el-dialog': __WEBPACK_IMPORTED_MODULE_4_element_ui__["Dialog"],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergySelect_vue__["a" /* default */]

  },
  data: function data() {
    return {
      searchTerm: '',
      value: "",
      selectOption: {
        enabled: true
      },
      editModal: false,
      items: items,
      updateID: "",
      groups: [{ id: null, name: null }],
      loader: false,
      form: {
        groupID: null,
        subgroup_desc: null,
        subgroupname: null,
        status: false
      },
      fields: [{
        field: 'groupname',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'subgroupname',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'subgroupdesc',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'status',
        label: 'Status',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      cxTeamFields: [{
        field: 'groupname',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'fu',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'Subgroup Description',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'Status',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phoneNumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedAt',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      modalInfo: {
        title: '',
        content: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getGroups', 'getSubgroups', 'getDummy', 'getDevices']), {
    isACxTeam: {
      get: function get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('Do MMM YYYY');
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    editmodal: function editmodal(row) {
      var _this = this;

      var id = row.id;

      this.loading = true;
      console.log({ row: row, g: this.getGroups });
      this.updateID = id;
      var HTTP = this.$httpUtils.instance;
      var url = '/customerSubGroups/' + id;
      HTTP.get(url).then(function (res) {
        try {
          _this.editModal = true;
          _this.form.groupID = res.data.groupid;
          _this.form.subgroup_desc = res.data.subgroupdesc;
          _this.form.subgroupname = res.data.subgroupname;
          _this.form.status = res.data.status;
          var f = _this.getGroups.find(function (v) {
            return v.id == _this.form.groupID;
          });
          _this.value = f;
          _this.loading = false;
        } catch (error) {
          _this.loading = false;
        }
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    updateGroup: function updateGroup(e) {
      var _this2 = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var data = {
        groupid: this.form.groupID,
        subgroupname: this.form.subgroupname,
        subgroupdesc: this.form.subgroup_desc,
        status: this.form.status ? 1 : 0,
        id: this.updateID
      };
      this.loader = true;
      console.log(data);
      HTTP.put('/customerSubGroups/' + this.updateID, data).then(function (res) {
        if (res.data) {
          _this2.editModal = false;
          _this2.showAlert();
          _this2.loader = false;
          _this2.fetchUsers();
          _this2.form.subgroup_desc = '';
          _this2.form.groupID = "";
          _this2.form.subgroupname = '';
          _this2.form.status = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Subgroup Updated Successfully',
        icon: 'success',
        width: '550px'
      });
    },
    fetchUsers: function fetchUsers() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/customerSubGroups/getCustomerSubgroups\n';
      HTTP.post(url).then(function (response) {
        var usersList = response.data;
        _this3.$store.commit('saveSubgroups', usersList.map(function (data) {
          return {
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            subgroupdesc: data.subgroupdesc,
            status: data.status == 0 ? 'Disabled' : 'Enabled',
            id: data.id
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
    this.groups = this.getGroups.map(function (item) {
      return {
        id: item.id,
        name: item.groupname
      };
    }).sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mgt_GroupInfo__ = __webpack_require__(2881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuikit_lib_offcanvas__ = __webpack_require__(23);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_14_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_14_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_13_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_13_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_13_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_13_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_13_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_13_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_4__user_mgt_GroupInfo__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_5__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_7__users_allow__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal2: false,
      loader: false,
      errorGroup: false,
      form: {
        groupname: null,
        group_desc: null,
        status: false
      },
      formErrors: {
        groupname: "",
        group_desc: ""
      }
    };
  },

  computed: {},
  methods: {
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "groupname":
              if (value === "null" || value === "") {
                formErrors[field] = "Group Name cannot be empty.";
              }
              break;
            case "group_desc":
              if (value === "null" || value === "") {
                formErrors[field] = "Group Description cannot be empty.";
              }
              break;

            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({ title: 'Success', imageWidth: '40px', text: 'Group Created Successfully', icon: 'success', width: '550px' });
    },
    createGroup: function createGroup(e) {
      var _this = this;

      e.preventDefault();
      var data = {
        groupname: this.form.groupname,
        groupdesc: this.form.group_desc,
        status: this.form.status ? 1 : 0
      };
      console.log(data);
      var HTTP = this.$httpUtils.instance;
      if (data.groupname && data.groupdesc) {
        this.loader = true;
        HTTP.post("/customerGroups", data).then(function (res) {
          if (res.data) {
            _this.showModal2 = false;
            _this.showAlert();
            _this.loader = false;
            _this.fetchUsers();
            _this.form.groupname = null;
            _this.form.group_desc = null;
            _this.form.status = false;
          }
        }).catch(function (err) {
          console.log(err);
        });
        return;
      }
      if (data.groupname == null && data.groupdesc == null) {
        this.errorGroup = true;
        setTimeout(function () {
          return _this.errorGroup = false;
        }, 1500);

        return;
      }
    },
    closeModal: function closeModal() {
      this.form.groupname = "";
      this.form.group_desc = "";
      this.form.status = false;
      this.showModal2 = false;
    },
    fetchUsers: function fetchUsers() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/customerGroups\n";
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this2.$store.commit("saveGroups", usersList.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            groupdesc: data.groupdesc,
            status: data.status == 0 ? "Disabled" : "Enabled"
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    //  console.log(this.getUserSession);
    var httpUtils = this.__proto__.__proto__.$httpUtils;
    // this.access = 'CUSTOMER'
    // console.log(this.$ability);
  }
});

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'el-dialog': __WEBPACK_IMPORTED_MODULE_8_element_ui__["Dialog"],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergyInput_vue__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_4_vue_sweetalert2__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true
      },
      editModal: false,
      loader: false,
      form: {
        groupnamee: '',
        group_desc: '',
        status: false
      },
      updateID: '',
      items: items,
      fields: [{
        field: 'id',
        label: 'ID',
        sortable: 'true'
      }, {
        field: 'groupname',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'groupdesc',
        label: 'Group Description',
        sortable: 'true'
      }, {
        field: 'status',
        label: 'Status',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],

      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      modalInfo: {
        title: '',
        content: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getGroups', 'getDummy', 'getDevices']), {
    isACxTeam: {
      get: function get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format('Do MMM YYYY');
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    updateGroup: function updateGroup(e) {
      var _this = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var data = {
        groupname: this.form.groupnamee,
        groupdesc: this.form.group_desc,
        status: this.form.status ? 1 : 0,
        id: this.updateID
      };

      this.loader = true;
      console.log(data);
      HTTP.put('/customerGroups', data).then(function (res) {
        if (res.data) {
          _this.editModal = false;
          _this.showAlert();
          _this.loader = false;
          _this.fetchUsers();
          _this.form.groupnamee = '';
          _this.form.group_desc = '';
          _this.form.status = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Group Updated Successfully',
        icon: 'success',
        width: '550px'
      });
    },
    fetchUsers: function fetchUsers() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/customerGroups\n';
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this2.$store.commit('saveGroups', usersList.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            groupdesc: data.groupdesc,
            status: data.status == 0 ? 'Disabled' : 'Enabled'
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editmodal: function editmodal(id) {
      var _this3 = this;

      this.updateID = id;
      this.loading = true;
      var HTTP = this.$httpUtils.instance;
      var url = '/customerGroups/' + id;
      HTTP.get(url).then(function (res) {
        _this3.editModal = true;
        _this3.form.groupnamee = res.data.groupname;
        _this3.form.group_desc = res.data.groupdesc;
        _this3.form.status = res.data.status;
        _this3.loading = false;
      }).catch(function (error) {
        console.log('error', error);
        _this3.loading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupItem_vue__ = __webpack_require__(1166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e389b2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupItem_vue__ = __webpack_require__(2889);
function injectStyle (ssrContext) {
  __webpack_require__(2885)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e389b2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e389b2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_mgt_GroupIteminfo__ = __webpack_require__(2886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_multiselect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuikit_lib_offcanvas__ = __webpack_require__(23);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_24_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_24_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_23_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_23_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_23_element_ui__["RadioButton"],
    GroupIteminfo: __WEBPACK_IMPORTED_MODULE_9__user_mgt_GroupIteminfo__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_10__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_11__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_12__users_allow__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_14__kitchen_ArnergyInput_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_15__kitchen_ArnergySelect_vue__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_17_vue_multiselect___default.a,
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_20_vue_sweetalert2__["a" /* default */],
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_16__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_13__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_defineProperty___default()({
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      errorInfo: "",
      loader: false,
      errorGroup: false,
      form: {
        groupID: null,
        subgroup: null,
        status: false
      },
      devices: [{ id: null }],
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      value: [],

      formErrors: {
        name: "",
        description: ""
      }

    }, "value", "");
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getGroups", "getSubgroups", "getGroupItems", "getDummy", "getDevices"])),
  methods: {
    capitalizeFirstLetter: function capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    submityy: function submityy(e) {
      var _this = this;

      e.preventDefault();
      console.log("gggg");
      var HTTP = this.$httpUtils.instance;
      // this.formErrors = this.validateInputs();
      console.log({ form: this.form });
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        deviceid: this.value
      };
      console.log(data);
      if (data.groupid && data.subgroupid && data.deviceid) {
        HTTP.post("/groupItems/addGroupItems", data).then(function (res) {
          if (res.data) {
            _this.showModal = false;
            _this.showAlert();
            _this.loader = false;
            _this.fetchGroupitems();
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this.errorGroup = false;
        }, 1500);
      }
    },
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var field = _ref3[0];
          var value = _ref3[1];

          value = value + "";
          if (value != null && value !== "" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          } else {
            formErrors[field] = this.capitalizeFirstLetter(field) + " are required.";
          }

          // switch (field) {
          //   case 'bank':
          //     if (value === 'null' || value === '') {
          //       formErrors[field] = ``;
          //     }
          //     break
          //   case 'accountNo':
          //     if (value === 'null' || value === '') {
          //       formErrors[field] = 'Account Number cannot be empty.'
          //     }
          //     break
          //   case 'dateRange':
          //     if (value === 'null' || value === '') {
          //       formErrors[field] = 'Date range cannot be empty.'
          //     }
          //     break
          //   default:
          //     break
          // }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    sub: function sub(e) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        deviceid: this.value
      };
      var HTTP = this.$httpUtils.instance;
      if (data.groupid && data.deviceid) {
        this.loader = true;
        HTTP.post("/groupItems/addGroupItems", data).then(function (res) {
          if (res.data) {
            _this2.showModal = false;
            _this2.showAlert();
            _this2.loader = false;
            _this2.fetchGroupitems();
            _this2.showModal = false;
            _this2.value = "";
            _this2.form.groupID = null;
            _this2.form.subgroup = null;
            _this2.loader = false;
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this2.errorGroup = false;
        }, 1500);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.value = "";
      this.form.groupID = false;
      this.form.status = false;
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Group Items Created Successfully",
        icon: "success",
        width: "550px"
      });
    },
    fetchGroupitems: function fetchGroupitems() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/groupItems/getGroupItems\n";
      HTTP.post(url).then(function (response) {
        var list = response.data;
        _this3.$store.commit("saveGroupItems", list);

        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log({ id: id });
                HTTP = _this4.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context.next = 6;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  _this4.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 6:
                res = _context.sent;

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetchDevices: function fetchDevices() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, filter, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                filter = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                  where: {
                    and: [{ CID: { neq: null } }, {
                      or: [{ status: "commissioned" }, { status: "completed" }, { status: "scheduled" }, { status: "requested" }]
                    }]
                  }
                });
                _context2.next = 4;
                return HTTP.get("/installations?filter=" + filter);

              case 4:
                res = _context2.sent;
                return _context2.abrupt("return", res.data.map(function (item) {
                  return {
                    id: item.CID || item.solarKitIds
                  };
                }).sort(function (a, b) {
                  return a.cid > b.cid ? 1 : -1;
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.fetchDevices();

            case 2:
              _this6.devices = _context3.sent;


              _this6.groups = _this6.getGroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.groupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_multiselect_dist_vue_multiselect_min_css__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_6_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'el-dialog': __WEBPACK_IMPORTED_MODULE_5_element_ui__["Dialog"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_7_vue_multiselect___default.a,
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_9__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true
      },
      editModal: false,
      loader: false,
      form: {
        groupID: '',
        subgroup: '',
        device: '',
        status: false
      },
      updateID: '',
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      value: [],
      items: items,
      fields: [{
        field: 'groupname',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'subgroupname',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'deviceid',
        label: 'Device ID',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      cxTeamFields: [{
        field: 'id',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'fu',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'Device',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'Status',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phoneNumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedAt',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      loading: false,
      modalInfo: {
        title: '',
        content: ''
      },
      devices: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getGroups', 'getSubgroups', 'getGroupItems', 'getDummy', 'getDevices']), {
    isACxTeam: {
      get: function get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('Do MMM YYYY');
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchGroupItems: function fetchGroupItems() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/groupItems/getGroupItems';
      HTTP.post(url).then(function (response) {
        var list = response.data;
        _this.$store.commit('saveGroupItems', list);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    editmodal: function editmodal(id) {
      var _this2 = this;

      this.loading = true;
      this.updateID = id;
      var HTTP = this.$httpUtils.instance;
      var url = '/groupItems/' + id;
      HTTP.get(url).then(function (res) {
        _this2.form.subgroup = res.data.subgroupid;
        _this2.form.groupID = res.data.groupid;
        _this2.form.status = res.data.subgroupid ? true : false;

        _this2.form.device = _this2.devices.find(function (did) {
          return did.id == res.data.deviceid;
        });
        console.log({ did: _this2.form.device, fdid: res.data.deviceid });
        _this2.getSubgroupss(res.data.groupid);

        _this2.editModal = true;
        _this2.loading = false;
      }).catch(function (error) {
        console.log('error', error);
        _this2.loading = false;
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this3.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context.next = 5;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  if (res.data) {
                    _this3.subgroups = res.data.map(function (item) {
                      return {
                        id: item.id,
                        name: item.subgroupname
                      };
                    }).sort(function (a, b) {
                      return a.name > b.name ? 1 : -1;
                    });
                  }
                  console.log(_this3.subgroupsData);
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    updateGroup: function updateGroup(e) {
      var _this4 = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var form = this.form,
          updateID = this.updateID;

      var data = {
        groupid: form.groupID,
        subgroupid: form.subgroup,
        deviceid: form.device.id,
        id: updateID
      };
      this.loader = true;
      console.log(data);
      HTTP.put('/groupItems', data).then(function (res) {
        if (res.data) {
          _this4.editModal = false;
          _this4.showAlert();
          _this4.loader = false;
          _this4.fetchGroupItems();
          _this4.form.subgroup = '';
          _this4.form.groupname = '';
          _this4.form.deviceid = "";
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'GroupItem Updated Successfully',
        icon: 'success',
        width: '550px'
      });
    },
    fetchDevices: function fetchDevices() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, filter, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                filter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ where: { and: [{ "CID": { "neq": null } }, { or: [{ "status": "commissioned" }, { "status": "completed" }, { "status": "scheduled" }, { "status": "requested" }] }] } });
                _context2.next = 4;
                return HTTP.get('/installations?filter=' + filter);

              case 4:
                res = _context2.sent;
                return _context2.abrupt('return', res.data.map(function (item) {
                  return {
                    id: item.CID || item.solarKitIds
                  };
                }).sort(function (a, b) {
                  return a.cid > b.cid ? 1 : -1;
                }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.fetchDevices();

            case 2:
              _this6.devices = _context3.sent;

              // this.fetchGroupItems()


              _this6.groups = _this6.getGroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.groupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mgt_CustomersInfo_vue__ = __webpack_require__(2892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__ = __webpack_require__(23);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_19_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_18_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_18_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_18_element_ui__["RadioButton"],
    CustomersInfo: __WEBPACK_IMPORTED_MODULE_4__user_mgt_CustomersInfo_vue__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_5__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_7__users_allow__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_12_vue_multiselect___default.a,
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_15_vue_sweetalert2__["a" /* default */],
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_11__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      errorGroup: false,
      errorInfo: "",
      loader: false
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "errorGroup", false), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "form", {
      groupID: null,
      subgroup: null,
      status: false
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "devices", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "groups", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "subgroups", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "value", []), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "formErrors", {
      name: "",
      description: ""
    }), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, "value", ""), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getGroups", "getSubgroups", "getGroupItems", "getDummy", "getDevices"])),
  methods: {
    triggerModal: function triggerModal() {
      this.showModal = true;
      this.subgroups = this.getSubgroups.map(function (v) {
        return {
          id: v.id,
          name: v.groupname
        };
      });
      console.log({ getSubgroups: this.getSubgroups });
    },
    submityy: function submityy(e) {
      var _this = this;

      e.preventDefault();
      console.log("gggg");
      var HTTP = this.$httpUtils.instance;
      this.formErrors = this.validateInputs();
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subname,
        deviceid: this.value
      };
      console.log(data);
      HTTP.post("/addGroupItems", data).then(function (res) {
        if (res.data) {
          _this.showModal = false;
          _this.showAlert();
          _this.loader = false;
          _this.fetchGroupitems();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    customerSubmit: function customerSubmit(e) {
      var _this2 = this;

      e.preventDefault();
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        userid: this.value
      };
      var HTTP = this.$httpUtils.instance;
      if (data.groupid && data.userid) {
        this.loader = true;
        HTTP.post("/groupUsers/addGroupUsers", data).then(function (res) {
          if (res.data) {
            _this2.showModal = false;
            _this2.showAlert();
            _this2.loader = false;
            _this2.fetchGroupitems();
            _this2.showModal = false;
            _this2.value = "";
            _this2.form.groupID = null;
            _this2.form.subgroup = null;
            _this2.loader = false;
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this2.errorGroup = false;
        }, 1500);
      }
    },
    closeModal: function closeModal() {
      this.showModal = false;
      this.value = "";
      this.form.groupID = false;
      this.form.status = false;
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Customer Created Successfully",
        icon: "success",
        width: "550px"
      });
    },
    fetchGroupitems: function fetchGroupitems() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/groupUsers/getGroupUsers";
      HTTP.post(url).then(function (response) {
        var list = response.data;
        _this3.$store.commit("saveGroupUsers", list);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this4.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context.next = 5;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  _this4.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    fetchDevices: function fetchDevices() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.get("/users");

              case 3:
                res = _context2.sent;
                return _context2.abrupt("return", res.data.map(function (item) {
                  return {
                    id: item.id,
                    name: item.email
                  };
                }).sort(function (a, b) {
                  return a.nme > b.name ? 1 : -1;
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this6.fetchDevices();

            case 2:
              _this6.devices = _context3.sent;


              console.log(_this6.devices);
              _this6.groups = _this6.getGroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.groupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }
});

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect_dist_vue_multiselect_min_css__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_7_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "el-dialog": __WEBPACK_IMPORTED_MODULE_6_element_ui__["Dialog"],
    Multiselect: __WEBPACK_IMPORTED_MODULE_8_vue_multiselect___default.a,
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_10__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergySelect_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      searchTerm: "",
      users: [],
      value: {},
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },

      editModal: false,
      loader: false,
      form: {
        groupID: "",
        subgroup: "",
        usersID: "",
        status: false
      },
      updateID: "",
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }]
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "value", []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "items", items), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "fields", [{
      field: "groupname",
      label: "Group Name",
      sortable: "true"
    }, {
      field: "subgroupname",
      label: "Subgroup Name",
      sortable: "true"
    }, {
      field: "email",
      label: "Email",
      sortable: "true"
    }, {
      field: "actions",
      label: "Actions",
      hidden: false

      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "cxTeamFields", [{
      field: "id",
      label: "Group Name",
      sortable: "true"
    }, {
      field: "fu",
      label: "Subgroup Name",
      sortable: "true"
    }, {
      field: "Device",
      label: "User Type",
      sortable: "true"
    }, {
      field: "Status",
      label: "E-mail",
      sortable: "true"
    },
    // { key: 'dob', label: 'Date of birth', sortable: 'true'},
    {
      field: "gender",
      label: "Gender",
      sortable: "true"
    },
    // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
    // { key: 'is_active', label: 'Status', sortable: 'true'},
    // { key: 'last_login', label: 'Last Login', sortable: 'true'},
    {
      field: "phoneNumber",
      label: "Phone Number",
      sortable: "true"
    },
    // { key: 'address', label: 'Address', sortable: 'true'},
    {
      field: "updatedAt",
      label: "Last Seen",
      sortable: "true"
    }, {
      field: "actions",
      label: "Actions",
      hidden: true
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "currentPage", 1), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "details", ["UserDetails", "allowUser"]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "perPage", 10), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "totalRows", items.length), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "pageOptions", [5, 10, 15]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "sortBy", null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "sortDesc", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "filter", null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "loading", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "modalInfo", {
      title: "",
      content: ""
    }), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getGroupUsers", "getGroups", "getSubgroups", "getGroupItems", "getDummy", "getDevices"]), {
    isACxTeam: {
      get: function get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_7_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    deleteCustomer: function deleteCustomer(id) {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      var c = confirm("Are you sure?");
      if (c) {
        var url = "/groupUsers/" + id;
        HTTP.delete(url).then(function (response) {
          _this.showSuccessAlert("Deleted.");
          _this.fetchGroupItems();
        });
      }
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchGroupItems: function fetchGroupItems() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/groupUsers/getGroupUsers";
      HTTP.post(url).then(function (response) {
        var list = response.data;
        console.log({ list: list });
        _this2.$store.commit("saveGroupUsers", list);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    editmodal: function editmodal(row) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var id, HTTP, filter, url;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                id = row.id;

                _this3.updateID = id; //groupUsers/getGroupUsers
                HTTP = _this3.$httpUtils.instance;
                filter = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({
                  where: { id: "" + id },
                  include: ["user"]
                });
                url = "/groupUsers?filter=" + filter;

                HTTP.get(url).then(function () {
                  var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(res) {
                    var data, user;
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            data = res.data;

                            if (!(data.length > 0)) {
                              _context.next = 11;
                              break;
                            }

                            user = data[0].user;

                            _this3.form.subgroup = data[0].subgroupid;
                            _this3.form.status = data[0].subgroupid ? true : false;
                            _this3.form.groupID = data[0].groupid; //groups.find(v=>v.id==data[0].groupid);
                            _this3.value = _this3.users.find(function (v) {
                              return v.id == data[0].userid;
                            });
                            _context.next = 9;
                            return _this3.getSubgroupss(_this3.form.groupID);

                          case 9:
                            _this3.editModal = true;
                            _this3.loading = false;

                          case 11:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this3);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()).catch(function (error) {
                  console.log("error", error);
                  _this3.loading = false;
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    showSuccessAlert: function showSuccessAlert(msg) {
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: msg,
        icon: "success",
        width: "550px"
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this4.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context3.next = 5;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  if (res.data) {
                    _this4.subgroups = res.data.map(function (item) {
                      return {
                        id: item.id,
                        name: item.subgroupname
                      };
                    }).sort(function (a, b) {
                      return a.name > b.name ? 1 : -1;
                    });
                  }
                  console.log(_this4.subgroupsData);
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context3.sent;

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    updateGroup: function updateGroup(e) {
      var _this5 = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var _form = this.form,
          groupID = _form.groupID,
          subgroup = _form.subgroup;
      var userid = this.value.id;

      var data = {
        groupid: groupID,
        subgroupid: subgroup,
        userid: userid,
        id: this.updateID
      };
      this.loader = true;
      console.log(data);
      HTTP.put("/groupUsers", data).then(function (res) {
        if (res.data) {
          _this5.editModal = false;
          _this5.showAlert();
          _this5.loader = false;
          _this5.fetchGroupItems();
          _this5.form.subgroup = "";
          _this5.form.groupname = "";
          _this5.form.deviceid = "";
        }
      }).catch(function (err) {
        console.log(err);
        _this5.loading = false;
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "GroupItem Updated Successfully",
        icon: "success",
        width: "550px"
      });
    },
    fetchUsers: function fetchUsers() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context4.next = 3;
                return HTTP.get("/users");

              case 3:
                res = _context4.sent;


                // parse for "arnergy-select" use
                _this6.users = res.data.map(function (item) {
                  return {
                    id: item.id,
                    name: item.email
                  };
                }).sort(function (a, b) {
                  return a.nme > b.name ? 1 : -1;
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    fetchDevices: function fetchDevices() {
      var _this7 = this;

      var HTTP = this.$httpUtils.instance;
      HTTP.post("/groupUsers/getGroupUsers").then(function (res) {
        if (res.data) {
          _this7.devices = res.data.map(function (item) {
            return {
              id: item.CID && item.CID
            };
          }).sort(function (a, b) {
            return a.id > b.id ? 1 : -1;
          });
        }
      });

      // parse for "arnergy-select" use
    }
  },
  mounted: function mounted() {
    console.log(this.getGroups);
    this.devices = this.fetchDevices();
    this.fetchGroupItems();
    this.fetchUsers();

    this.groups = this.getGroups.map(function (item) {
      return {
        id: item.id,
        name: item.groupname
      };
    }).sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
  }
});

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fs_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raw_loader_templates_invoice_ejs__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user_mgt_Sms_vue__ = __webpack_require__(2898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_mgt_Email_vue__ = __webpack_require__(2904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__user_mgt_GroupItem_vue__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import ejs from "ejs";










var dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [{
      quantity: 1,
      createdAt: "2019-07-02T12:28:34.267Z",
      updatedAt: "2019-07-02T12:28:34.267Z",
      id: 12,
      deviceTypeId: 3,
      componentId: 2,
      componentTypeId: null,
      componentType: {
        name: "inverter",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 2
      }
    }, {
      quantity: 2,
      createdAt: "2019-07-02T12:28:47.102Z",
      updatedAt: "2019-07-02T12:28:47.102Z",
      id: 13,
      deviceTypeId: 3,
      componentId: 1,
      componentTypeId: null,
      componentType: {
        name: "battery",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 1
      }
    }, {
      quantity: 15,
      createdAt: "2019-07-02T14:16:33.398Z",
      updatedAt: "2019-07-02T14:16:33.398Z",
      id: 16,
      deviceTypeId: 3,
      componentId: 3,
      componentTypeId: null,
      componentType: {
        name: "solar panels",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 3
      }
    }]
  },
  selectedRequest: null
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-requests",
  data: function data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
      centerDialogVisible2: false,
      defPage: true,
      usertype: localStorage.roleType,
      secPage: false,
      showModal: false,
      activeTab: "manage_requestsdd",
      form: {
        name: '',
        desc: ''
      },
      formErrors: {
        name: '',
        description: ''
      },
      notificationShow: false,
      emailShow: false,
      smsShow: false,
      subgropShow: false,
      lastPage: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "System Capacity",
        field: "system.capacity",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }],
      deviceRequests: [],
      rows: []
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_11_element_ui__["Dialog"],
    ModalMain: __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_ModalMain_vue__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergyInput_vue__["a" /* default */],
    GroupItem: __WEBPACK_IMPORTED_MODULE_8__user_mgt_GroupItem_vue__["a" /* default */],
    Group: __WEBPACK_IMPORTED_MODULE_7__user_mgt_Email_vue__["a" /* default */],
    Subgroup: __WEBPACK_IMPORTED_MODULE_6__user_mgt_Sms_vue__["a" /* default */]
  },
  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo: function navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    fetchInvoice: function fetchInvoice(rowData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, user, packageConfig, packageType, html, el, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log({ rowData, templateLocation });
                _this.showInvoice = true;
                order = dataParam.order, user = dataParam.user, packageConfig = dataParam.packageConfig, packageType = dataParam.packageType;
                // readString(templateLocation).then(console.log);

                html = ejs.render(__WEBPACK_IMPORTED_MODULE_4_raw_loader_templates_invoice_ejs__["a" /* default */], {
                  order: order,
                  user: user,
                  packageConfig: packageConfig,
                  packageType: packageType,
                  setupURL: false
                });
                el = _this.$refs.invoiceSection;
                options = {
                  type: "dataURL"
                };

                _this.receiptData = html;
                // this.finalData = await this.$html2canvas(el, options);
                // console.log({ finalData });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    showFirst: function showFirst() {
      this.defPage = false;
      this.lastPage = true;
      this.secPage = true;
    },
    addModal: function addModal() {
      this.showModal = true;
    },
    deleteRequest: function deleteRequest(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete("/device_requests/" + id).then(function (response) {
        _this2.centerDialogVisible = false;
        window.location.reload(true);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    var HTTP = this.$httpUtils.instance;
    var container = this;

    // {"status": 1}
    HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"transactionHistories\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}], \n      \"where\": {\n        \"or\":[\n          {\"status\": 0},\n          {\"status\": 1}\n        ]\n        } }", {}).then(function (response) {
      // console.log(JSON.stringify(rolesdata.data))
      console.log({ response: response });

      container.deviceRequests = response.data.filter(function (x) {
        return x.user;
      });
    });
  }
});

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__user_mgt_SmsInfo__ = __webpack_require__(2900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__ = __webpack_require__(23);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    'vk-offcanvas': __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    'vk-offcanvas-close': __WEBPACK_IMPORTED_MODULE_17_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    'el-autocomplete': __WEBPACK_IMPORTED_MODULE_16_element_ui__["Autocomplete"],
    'el-form': __WEBPACK_IMPORTED_MODULE_16_element_ui__["Form"],
    'el-form-item': __WEBPACK_IMPORTED_MODULE_16_element_ui__["FormItem"],
    'el-radio': __WEBPACK_IMPORTED_MODULE_16_element_ui__["Radio"],
    'el-radio-group': __WEBPACK_IMPORTED_MODULE_16_element_ui__["RadioGroup"],
    'el-radio-button': __WEBPACK_IMPORTED_MODULE_16_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_4__user_mgt_SmsInfo__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_5__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_7__users_allow__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_12_vue_sweetalert2__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__["a" /* default */],
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_13__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      showOffCanvas: false,
      activeTab: 'user_list',
      showModal: false,
      phoneNumbers: [],
      loader: false,
      phone: '',
      errorGroup: false,
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      form: {
        groupID: '',
        subgroup: ''
      }
    }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'groups', [{ id: 'group1', name: 'group1' }, { id: 'group2', name: 'group2' }]), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_ref, 'formErrors', {
      name: '',
      description: ''
    }), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_11_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getEmails', 'getGroups', 'getSubgroups', 'getDummy', 'getDevices'])),
  methods: {
    smsFunc: function smsFunc(e) {
      var _this = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        phonenumber: this.phoneNumbers
      };

      console.log(data);
      if (data.groupid && data.phonenumber) {
        this.loader = true;
        HTTP.post('/smsSetups/addPhoneNumber', data).then(function (res) {
          if (res.data) {
            _this.showModal = false;
            _this.showAlert();
            _this.loader = false;
            _this.fetchSms();
            _this.phoneNumbers = [];
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this.errorGroup = false;
        }, 1500);
      }
    },
    addField: function addField(e) {
      e.preventDefault();
      if (this.phone) {
        this.phoneNumbers.push({ phone: this.phone });
        this.phone = '';
      }
      console.log(this.phoneNumbers);
    },
    removeField: function removeField(phone) {
      if (phone) {
        this.phoneNumbers.splice(this.phoneNumbers.findIndex(function (e) {
          return e.phone === phone;
        }), 1);
      }
      console.log(this.phoneNumbers);
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Sms Set Up Successfully',
        icon: 'success',
        width: '550px'
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this2.$httpUtils.instance;
                formData = new FormData();

                formData.append('groupid', id);
                _context.next = 5;
                return HTTP.post('/customerSubGroups/getCustomerSubGroupByGroupId', formData).then(function (res) {
                  _this2.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    fetchSms: function fetchSms() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/smsSetups\n';
      HTTP.post(url).then(function (response) {
        var list = response.data;
        _this3.$store.commit('saveSms', list.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            phonenumber: data.phonenumber,

            status: data.status === 0 ? 'Disabled' : 'Enabled'
          };
        }));

        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(_this4.phoneNumbers);
              _this4.groups = _this4.getGroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.groupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_11_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    "el-dialog": __WEBPACK_IMPORTED_MODULE_10_element_ui__["Dialog"],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__["a" /* default */],
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_7__kitchen_AnergySelectDynamic_vue__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      updateID: "",
      editModal: false
    }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "updateID", ""), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "groups", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "subgroups", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "phoneNumbers", []), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "phone", ""), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "loader", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "form", {
      groupID: null,
      subgroup: null,
      status: false,
      phone: ""
    }), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "items", items), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "fields", [{
      field: "groupname",
      label: "Group Name",
      sortable: "true"
    }, {
      field: "subgroupname",
      label: "Subgroup Name",
      sortable: "true"
    }, {
      field: "phonenumber",
      label: "Phone Number",
      sortable: "true"
    }, {
      field: "status",
      label: "Status",
      sortable: "true"
    }, {
      field: "actions",
      label: "Actions"
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "cxTeamFields", [{
      field: "id",
      label: "Group Name",
      sortable: "true"
    }, {
      field: "fu",
      label: "Subgroup Name",
      sortable: "true"
    }, {
      field: "Subgroup Description",
      label: "User Type",
      sortable: "true"
    }, {
      field: "Status",
      label: "E-mail",
      sortable: "true"
    },
    // { key: 'dob', label: 'Date of birth', sortable: 'true'},
    {
      field: "gender",
      label: "Gender",
      sortable: "true"
    },
    // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
    // { key: 'is_active', label: 'Status', sortable: 'true'},
    // { key: 'last_login', label: 'Last Login', sortable: 'true'},
    {
      field: "phoneNumber",
      label: "Phone Number",
      sortable: "true"
    },
    // { key: 'address', label: 'Address', sortable: 'true'},
    {
      field: "updatedAt",
      label: "Last Seen",
      sortable: "true"
    }, {
      field: "actions",
      label: "Actions"
    }]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "currentPage", 1), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "details", ["UserDetails", "allowUser"]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "perPage", 10), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "totalRows", items.length), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "pageOptions", [5, 10, 15]), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "sortBy", null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "sortDesc", false), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "filter", null), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_defineProperty___default()(_ref, "modalInfo", {
      title: "",
      content: ""
    }), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getGroups", "getSms", "getDummy", "getDevices"]), {
    isACxTeam: {
      get: function get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_11_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/smsSetups/getSmsSetupDetail";
      HTTP.post(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit("saveSms", usersList.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            phonenumber: data.phonenumber,

            status: data.status === 0 ? "Disabled" : "Enabled"
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this2.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context.next = 5;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  _this2.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    addField: function addField(e) {
      e.preventDefault();
      if (this.phone) {
        this.phoneNumbers.push({ phone: this.phone });
        this.phone = "";
      }
      console.log(this.phoneNumbers);
    },
    removeField: function removeField(phone) {
      if (phone) {
        this.phoneNumbers.splice(this.phoneNumbers.findIndex(function (e) {
          return e.phone === phone;
        }), 1);
      }
      console.log(this.phoneNumbers);
    },
    updateGroup: function updateGroup(e) {
      var _this3 = this;

      e.preventDefault();
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        phonenumber: this.form.phone,
        status: this.form.status,
        id: 0
      };
      var HTTP = this.$httpUtils.instance;
      console.log('press');
      this.loader = true;
      HTTP.put("/smsSetups/" + this.updateID, data).then(function (res) {
        if (res.data) {
          _this3.editModal = false;
          _this3.showAlert();
          _this3.loader = false;
          _this3.fetchUsers();
          _this3.form.subgroup_desc = "";
          _this3.form.groupID = "";
          _this3.form.subgroupname = "";
          _this3.form.status = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    editmodal: function editmodal(id) {
      var _this4 = this;

      this.updateID = id;
      var HTTP = this.$httpUtils.instance;
      var url = "/smsSetups/" + id;
      HTTP.get(url).then(function (res) {
        if (res.data) {
          _this4.editModal = true;
          _this4.form.groupID = res.data.groupid;
          _this4.form.subgroup_desc = res.data.subgroupid;
          _this4.form.phone = res.data.phonenumber;
          _this4.form.status = res.data.status;
        }
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Subgroup Updated Successfully",
        icon: "success",
        width: "550px"
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
    this.groups = this.getGroups.map(function (item) {
      return {
        id: item.id,
        name: item.groupname
      };
    }).sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__user_mgt_EmailInfo__ = __webpack_require__(2906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_multiselect_dist_vue_multiselect_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_sweetalert2_dist_sweetalert2_min_css__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_15_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_14_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_14_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_14_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_14_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_14_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_14_element_ui__["RadioButton"],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_14_element_ui__["Dialog"],
    Users: __WEBPACK_IMPORTED_MODULE_3__user_mgt_EmailInfo__["a" /* default */],
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_13__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    Multiselect: __WEBPACK_IMPORTED_MODULE_11_vue_multiselect___default.a,
    Devices: __WEBPACK_IMPORTED_MODULE_4__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_5__shs_Wallet__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_16_vue_sweetalert2__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_6__users_allow__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_9__kitchen_ArnergyInput_vue__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_10__kitchen_ArnergySelect_vue__["a" /* default */],
    ModalMain: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalMain_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      showModal: false,
      emailAddress: [],
      emailAddressCC: [],
      emailAddressBCC: [],
      errorGroup: false,
      loader: false,
      email: "",
      emailCC: "",
      emailBCC: "",
      form: {
        name: "",
        groupID: "",
        description: "",
        status: false
      },
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      formErrors: {
        name: "",
        description: ""
      },
      value: [],
      options: [{ name: "Vue.js", language: "JavaScript" }, { name: "Adonis", language: "JavaScript" }, { name: "Rails", language: "Ruby" }, { name: "Sinatra", language: "Ruby" }, { name: "Laravel", language: "PHP" }, { name: "Phoenix", language: "Elixir" }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getEmails", "getGroups", "getSubgroups", "getDummy", "getDevices"])),
  methods: {
    handleClose: function handleClose() {
      this.showModal = false;
    },
    addField: function addField(e) {
      e.preventDefault();
      if (this.email) {
        this.emailAddress.push({ email: this.email });
        this.email = "";
      }
      console.log(this.emailAddress);
    },
    addFieldCC: function addFieldCC(e) {
      e.preventDefault();
      if (this.emailCC) {
        this.emailAddressCC.push({ email: this.emailCC });
        this.emailCC = "";
      }
      console.log(this.emailAddress);
    },
    addFieldBCC: function addFieldBCC(e) {
      e.preventDefault();
      if (this.emailBCC) {
        this.emailAddressBCC.push({ email: this.emailBCC });
        this.emailBCC = "";
      }
      console.log(this.emailAddress);
    },
    emailFunc: function emailFunc(e) {
      var _this = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var data = {
        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        emailAddress: {
          emailTo: this.emailAddress,
          emailCc: this.emailAddressCC,
          emailBcc: this.emailAddressBCC
        }
      };
      console.log(data);
      if (data.groupid && data.emailAddress) {
        this.loader = true;
        HTTP.post("/emailsetups/addEmail", data).then(function (res) {
          if (res.data) {
            _this.showModal = false;
            _this.showAlert();
            _this.loader = false;
            _this.fetchEmails();
            _this.form.groupID = "";
            _this.form.subgroup = "";
            _this.emailAddress.emailTo = "";
            _this.emailAddress.EmailCC = "";
            THIS.emailAddress.emailBCC = "";
          }
        }).catch(function (err) {
          console.log(err);
        });
      } else {
        this.errorGroup = true;
        setTimeout(function () {
          return _this.errorGroup = false;
        }, 1500);
      }
    },
    removeField: function removeField(email) {
      if (email) {
        this.emailAddress.splice(this.emailAddress.findIndex(function (e) {
          return e.email === email;
        }), 1);
      }
      console.log(this.phoneNumbers);
    },
    removeFieldCC: function removeFieldCC(email) {
      if (email) {
        this.emailAddressCC.splice(this.emailAddressCC.findIndex(function (e) {
          return e.email === email;
        }), 1);
      }
      console.log(this.phoneNumbers);
    },
    removeFieldBCC: function removeFieldBCC(email) {
      if (email) {
        this.emailAddressBCC.splice(this.emailAddressBCC.findIndex(function (e) {
          return e.email === email;
        }), 1);
      }
      console.log(this.phoneNumbers);
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this2.$httpUtils.instance;
                formData = new FormData();

                formData.append("groupid", id);
                _context.next = 5;
                return HTTP.post("/customerSubGroups/getCustomerSubGroupByGroupId", formData).then(function (res) {
                  _this2.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "Email Set up Successfully",
        icon: "success",
        width: "550px"
      });
    },
    fetchEmails: function fetchEmails() {
      var _this3 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/emailsetups/getEmailSetupDetail\n";
      HTTP.post(url).then(function (response) {
        var list = response.data;
        _this3.$store.commit("saveEmails", list.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            emailaddress: data.emailaddress,
            sendtype: data.sendtype,

            status: data.status === 0 ? "Disabled" : "Enabled"
          };
        }));

        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this4.groups = _this4.getGroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.groupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

              _this4.subgroups = _this4.getSubgroups.map(function (item) {
                return {
                  id: item.id,
                  name: item.subgroupname
                };
              }).sort(function (a, b) {
                return a.name > b.name ? 1 : -1;
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__kitchen_AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_ui__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ArnergyDynamic: __WEBPACK_IMPORTED_MODULE_6__kitchen_AnergySelectDynamic_vue__["a" /* default */],
    'el-dialog': __WEBPACK_IMPORTED_MODULE_8_element_ui__["Dialog"],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergySelect_vue__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      selectOption: {
        enabled: true
      },
      editModal: false,
      loader: false,
      form: {
        groupID: '',
        subgroup: '',
        status: false,
        emailaddress: '',
        sendtype: '',
        status2: false
      },
      updateID: '',
      items: items,
      groups: [{ id: null, name: null }],
      subgroups: [{ id: null, name: null }],
      sendtypes: [{ id: 1, name: 'CC' }, { id: 2, name: 'BCC' }],

      fields: [{
        field: 'groupname',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'subgroupname',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'emailaddress',
        label: 'Email Address',
        sortable: 'true'
      }, {
        field: 'sendtype',
        label: 'Send Type',
        sortable: 'true'
      }, {
        field: 'status',
        label: 'Status',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      cxTeamFields: [{
        field: 'id',
        label: 'Group Name',
        sortable: 'true'
      }, {
        field: 'fu',
        label: 'Subgroup Name',
        sortable: 'true'
      }, {
        field: 'Subgroup Description',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'Status',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phoneNumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedAt',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getEmails', 'getGroups', 'getDummy', 'getDevices']), {
    isACxTeam: {
      get: function get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('Do MMM YYYY');
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: 'Success',
        imageWidth: '40px',
        text: 'Group Updated Successfully',
        icon: 'success',
        width: '550px'
      });
    },
    updateGroup: function updateGroup(e) {
      var _this = this;

      e.preventDefault();
      var HTTP = this.$httpUtils.instance;
      var data = {

        groupid: this.form.groupID,
        subgroupid: this.form.subgroup,
        emailAddress: this.form.emailaddress,
        sendType: this.form.sendtype === "2" ? "BCC" : "CC",
        status: this.form.status2,
        id: 0
      };

      this.loader = true;
      console.log(data);
      HTTP.put('emailsetups/' + this.updateID, data).then(function (res) {
        if (res.data) {
          _this.editModal = false;
          _this.showAlert();
          _this.loader = false;
          _this.fetchUsers();
          _this.form.groupID = '';
          _this.form.subgroup = "";
          _this.form.status2 = false;
          _this.form.status = false;
          _this.form.emailaddress = "";
          _this.form.status = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    editmodal: function editmodal(id) {
      var _this2 = this;

      this.updateID = id;
      var HTTP = this.$httpUtils.instance;
      var url = '/emailsetups/' + id;
      HTTP.get(url).then(function (res) {
        _this2.editModal = true;
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    getSubgroupss: function getSubgroupss(id) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this3.$httpUtils.instance;
                formData = new FormData();

                formData.append('groupid', id);
                _context.next = 5;
                return HTTP.post('/customerSubGroups/getCustomerSubGroupByGroupId', formData).then(function (res) {
                  _this3.subgroups = res.data.map(function (item) {
                    return {
                      id: item.id,
                      name: item.subgroupname
                    };
                  }).sort(function (a, b) {
                    return a.name > b.name ? 1 : -1;
                  });
                }).catch(function (e) {
                  //
                });

              case 5:
                res = _context.sent;

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    fetchUsers: function fetchUsers() {
      var _this4 = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/emailsetups/getEmailSetupDetail';
      HTTP.post(url).then(function (response) {
        var usersList = response.data;
        _this4.$store.commit('saveEmails', usersList.map(function (data) {
          return {
            id: data.id,
            groupname: data.groupname,
            subgroupname: data.subgroupname,
            emailaddress: data.emailaddress,
            sendtype: data.sendtype,

            status: data.status === 0 ? 'Disabled' : 'Enabled'
          };
        }));
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsers();
    this.groups = this.getGroups.map(function (item) {
      return {
        id: item.id,
        name: item.groupname
      };
    }).sort(function (a, b) {
      return a.name > b.name ? 1 : -1;
    });
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__users_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__ = __webpack_require__(23);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_5_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_4_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_4_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_4_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_4_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_0__users_index__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_1__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_2__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_3__users_allow__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: "user_list",
      usertype: localStorage.roleType
    };
  },

  computed: {},
  methods: {}
});

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fs_web___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fs_web__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import ejs from "ejs";


// import templateLocation from "raw-loader!./templates/invoice.ejs";


var dataParam = {
  packageConfig: null,
  order: {
    paymentModel: "OS",
    orderVat: 5,
    orderDiscount: 0,
    typeOfBuilding: "Normal",
    roofType: "Aluminium",
    roofCondition: "Very Good",
    roofReadiness: "Very Ready",
    roofAge: 4,
    roofComment: "No comment here\tRoof is ready for installation",
    deviceTypeId: 3,
    comment: "No comment here\tRoof is ready for installation"
  },
  user: {
    firstName: "Test",
    email: "seun.omotunde@arnergy.com",
    roleType: "customer",
    lastName: "Testerson",
    dateOfBirth: "2019-07-10T17:22:47.521Z",
    phoneNumber: "234671993331",
    gender: 0,
    wallet: 0,
    createdAt: "2019-07-10T17:55:56.668Z",
    updatedAt: "2019-07-10T17:55:56.668Z",
    realm: "",
    username: "seun.omotunde@arnergy.com",
    emailVerified: null,
    id: 615,
    street_route: null,
    cpassword: "<%DUMMY%>",
    stateId: null,
    countryId: 1,
    lgaId: null,
    deviceRequest: {
      paymentModel: "OS",
      orderVat: 7.5,
      orderDiscount: 0,
      typeOfBuilding: "Normal",
      roofType: "Aluminium",
      roofCondition: "Very Good",
      roofReadiness: "Very Ready",
      roofAge: 4,
      roofComment: "No comment here\tRoof is ready for installation",
      deviceTypeId: 3,
      comment: "No comment here\tRoof is ready for installation"
    }
  },
  packageType: {
    name: "ARNERGY5000",
    description: "Arnergy5000 are the pet version for SME",
    price: 4004485,
    OTAEnabled: true,
    chainable: true,
    createdAt: "2018-06-21T20:20:25.000Z",
    updatedAt: "2018-06-21T20:20:25.000Z",
    id: 3,
    packageComponents: [{
      quantity: 1,
      createdAt: "2019-07-02T12:28:34.267Z",
      updatedAt: "2019-07-02T12:28:34.267Z",
      id: 12,
      deviceTypeId: 3,
      componentId: 2,
      componentTypeId: null,
      componentType: {
        name: "inverter",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 2
      }
    }, {
      quantity: 2,
      createdAt: "2019-07-02T12:28:47.102Z",
      updatedAt: "2019-07-02T12:28:47.102Z",
      id: 13,
      deviceTypeId: 3,
      componentId: 1,
      componentTypeId: null,
      componentType: {
        name: "battery",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 1
      }
    }, {
      quantity: 15,
      createdAt: "2019-07-02T14:16:33.398Z",
      updatedAt: "2019-07-02T14:16:33.398Z",
      id: 16,
      deviceTypeId: 3,
      componentId: 3,
      componentTypeId: null,
      componentType: {
        name: "solar panels",
        description: null,
        createdAt: "2018-06-21T20:20:25.000Z",
        updatedAt: "2018-06-21T20:20:25.000Z",
        id: 3
      }
    }]
  },
  selectedRequest: null
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "manage-requests",
  data: function data() {
    return {
      receiptData: "Loading...",
      centerDialogVisible: false,
      showInvoice: false,
      searchTerm: "",
      selectOption: {
        enabled: true
      },
      responseData: "",
      errors: "",
      componentName: "",
      columns: [{
        label: "Customer Name",
        field: "full_name"
      }, {
        label: "Installation Name",
        field: "installation_name",
        filterable: true
      }, {
        label: "Phone Number",
        field: "user.phone",
        filterable: true
      },
      // {
      //   label: 'Installation Address',
      //   field: 'address',
      //   filterable: true,
      // },
      {
        label: "Desired Bundle",
        field: "deviceType.name",
        filterable: true
      }, {
        label: "System Capacity",
        field: "system.capacity",
        filterable: true
      }, {
        label: "Actions",
        field: "actions"
      }],
      deviceRequests: [],
      rows: []
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_4_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_5_element_ui__["Dialog"]
  },
  methods: {
    random_num: function random_num(dumm) {
      return Math.floor(Math.random(9999) * 9999);
    },
    showModal: function showModal() {
      this.$refs.invoiceModal.show();
    },
    hideModal: function hideModal() {
      this.$refs.invoiceModal.hide();
    },
    navTo: function navTo(id) {
      this.$router.push({
        name: "addInstalation",
        params: {
          id: id
        }
      });
    },
    fetchInvoice: function fetchInvoice(rowData) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var order, user, packageConfig, packageType, html, el, options;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log({ rowData, templateLocation });
                _this.showInvoice = true;
                order = dataParam.order, user = dataParam.user, packageConfig = dataParam.packageConfig, packageType = dataParam.packageType;
                // readString(templateLocation).then(console.log);

                html = ejs.render(templateLocation, {
                  order: order,
                  user: user,
                  packageConfig: packageConfig,
                  packageType: packageType,
                  setupURL: false
                });
                el = _this.$refs.invoiceSection;
                options = {
                  type: "dataURL"
                };

                _this.receiptData = html;
                // this.finalData = await this.$html2canvas(el, options);
                // console.log({ finalData });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    deleteRequest: function deleteRequest(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      // console.log(id);
      HTTP.delete("/device_requests/" + id).then(function (response) {
        _this2.centerDialogVisible = false;
        window.location.reload(true);
      }).catch(function (e) {
        console.log(e);
      });
    }
  },
  computed: {},
  mounted: function mounted() {
    if (!this.$can("create", "installation")) {
      this.$router.push({
        path: "/"
      });
      return;
    }
    var HTTP = this.$httpUtils.instance;
    var container = this;

    // {"status": 1}
    HTTP.get("/device_requests/?filter={\"include\": [\"user\",\"transactionHistories\", {\"deviceType\": { \"packageComponents\": \"componentType\" }}], \n      \"where\": {\n        \"or\":[\n          {\"status\": 0},\n          {\"status\": 1}\n        ]\n        } }", {}).then(function (response) {
      // console.log(JSON.stringify(rolesdata.data))
      console.log({ response: response });

      container.deviceRequests = response.data.filter(function (x) {
        return x.user;
      });
    });
  }
});

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_Notification__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__customer_admin_Customer__ = __webpack_require__(2918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__customer_admin_Kyc__ = __webpack_require__(2923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__customer_admin_PaymentSchedule__ = __webpack_require__(2926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__customer_admin_Repayment__ = __webpack_require__(2929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__customer_admin_Transactions__ = __webpack_require__(2932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__instalation_inventoryRequest__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__instalation_ongoingInstalation__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mockData_sectors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__mockData_sectors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__mockData_sectors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuikit_lib_offcanvas__ = __webpack_require__(23);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













// import TransHistory from "../customer-admin/TranHistory";






// import { ZOHOTHTTP } from "../../../store/actions";





var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.chmanage;
      this._keyStr.chmanage;
    }
    return t;
  },
  decode: function decode(e) {
    manage;
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  },
  _utf8_decode: function _utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  props: ["_activeTab"],
  data: function data() {
    return {
      discountType: "percent",
      usertype: localStorage.roleType,
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      // paymentModel: `OS`,
      // setupFee: "",
      // monthlyFee: "",
      // cautionFee: "",
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        def: true,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "",
            setupFee: "",
            monthlyFee: "",
            cautionFee: ""
          },
          systemCapacity: 5,
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          sendMail: true
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: ""
        },
        desc: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$route.params.activetab,
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_25_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_25_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_23_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_23_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_23_element_ui__["RadioButton"],
    DeviceRequest: __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__["a" /* default */],
    ManageRequestsuser: __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__["a" /* default */],
    ApprovedInstallations: __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__["a" /* default */],
    OngoingInstallations: __WEBPACK_IMPORTED_MODULE_19__instalation_ongoingInstalation__["a" /* default */],
    inventoryRequest: __WEBPACK_IMPORTED_MODULE_18__instalation_inventoryRequest__["a" /* default */],
    MyDeviceList: __WEBPACK_IMPORTED_MODULE_11__devices_List__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_20__rightBar__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_8__devices_Notification__["a" /* default */],
    Users: __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__["a" /* default */],
    CustomerGroup: __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__["a" /* default */],
    Kyc: __WEBPACK_IMPORTED_MODULE_14__customer_admin_Kyc__["a" /* default */],
    Customer: __WEBPACK_IMPORTED_MODULE_13__customer_admin_Customer__["a" /* default */],
    PaymentSchedule: __WEBPACK_IMPORTED_MODULE_15__customer_admin_PaymentSchedule__["a" /* default */],
    Repayment: __WEBPACK_IMPORTED_MODULE_16__customer_admin_Repayment__["a" /* default */],
    Transactions: __WEBPACK_IMPORTED_MODULE_17__customer_admin_Transactions__["a" /* default */]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_21_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    paymentModel: function paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  }),
  watch: {
    paymentModel: function paymentModel(newVal, oldVal) {
      this.selectedPaymentModel = this.packageConfigs.find(function (x) {
        return x.Package == newVal;
      });
      this.regDataParams.deviceRequest.paymentModel = newVal;
      // console.log(newVal.price);
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      if (this.selectedPaymentModel) {
        this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
        this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
        this.regDataParams.deviceRequest.priceModel.cautionFee = this.calcCaution(this.form.price);
      }
    }
  },
  methods: {
    changeContact: function changeContact() {
      this.form.invoiceType == "initial" ? this.contactList = this.ZcontactList : this.contactList = this.customerList;
      //console.log(this.customerList)
    },
    calcSetup: function calcSetup(price) {
      var setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      var temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub: function calcSub(price) {
      var subscriptionPercent = Number(this.selectedPaymentModel["Subscription"]) / 100;
      var temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution: function calcCaution(price) {
      var cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      var temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var regDataParams, HTTP, resp, error_incomming, tempMsg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.form.package == null)) {
                  _context.next = 4;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select a device type"
                });
                _context.next = 32;
                break;

              case 4:
                if (!(_this.form.sector == null)) {
                  _context.next = 8;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select an sector"
                });
                _context.next = 32;
                break;

              case 8:
                _this.regDataParams.deviceRequest.deviceTypeId = _this.form.package;
                // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
                // this.regDataParams.deviceRequest.orderVat = this.orderVat;
                regDataParams = _this.regDataParams;
                // let orderDiscount = this.orderDiscount;
                // let orderVat = this.orderVat;
                //console.log(this.contactList);
                //console.log(this.form);

                HTTP = _this.$httpUtils.instance;

                console.log(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(regDataParams));
                _context.prev = 12;

                if (!(_this.form.invoiceType == "initial")) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return HTTP.post("/users", regDataParams);

              case 16:
                _context.t0 = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return HTTP.post("/device_requests", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, regDataParams.deviceRequest, {
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: _this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: _this.form.userId
                }));

              case 21:
                _context.t0 = _context.sent;

              case 22:
                resp = _context.t0;

                _this.showSuccessMsg({ message: "Request Submitted" });
                //   // this.activeTab="manage_requests";
                //   // this.renderManageComponent= true;
                _this.showOffCanvas = false;
                _this.$router.push({
                  name: "devices",
                  params: {
                    activetab: "manage_requests"
                  }
                });
                //   this.$router.go();
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](12);

                if (_context.t1.response) {
                  if (_context.t1.response.data) {
                    // console.log(error.response.data);
                    error_incomming = _context.t1.response.data.error.details.messages;
                    // console.log(error_incomming);

                    tempMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(error_incomming).map(function (x) {
                      return x + ": " + error_incomming[x].join(",");
                    });

                    _this.showErrorMsg({
                      message: tempMsg.join("<br>")
                    });
                  }
                }
                console.log({
                  error: _context.t1
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 28]]);
      }))();
    },
    packageSelected: function packageSelected() {
      var _this2 = this;

      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(function (x) {
        return x.id == _this2.form.package;
      })["price"];
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
      this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
      this.regDataParams.deviceRequest.installationName = contact["First_Name"] + " " + contact["Last_Name"];
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    sectorSelected: function sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = "" + sector["name"];
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },
    loadAll: function loadAll() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        // console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this3.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[where][roleType]=customer" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.customerList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    loadModules: function loadModules() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      ZOHOTHTTP.get("/settings/all", {
        headers: {
          Authorization: "Zoho-oauthtoken " + this.zohoToken["accessToken"],
          "Content-Type": " application/json;charset=UTF-8"
        }
      }).then(function (response) {
        container.zohoModules = response.data["data"];
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this4 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this4.createFilter(queryString, contact);
      }) : contacts;
      // console.log({ results });
      cb(results);
    },
    createSectorFilter: function createSectorFilter(queryString, sector) {
      console.log({ sector: sector });
      return ("" + sector.value.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    sectorSearch: function sectorSearch(queryString, cb) {
      var _this5 = this;

      //  sectorList;
      // console.log({sectorList});
      var results = queryString ? __WEBPACK_IMPORTED_MODULE_24__mockData_sectors_json___default.a.filter(function (sect) {
        return _this5.createSectorFilter(queryString.trim(), sect);
      }) : __WEBPACK_IMPORTED_MODULE_24__mockData_sectors_json___default.a;
      // console.log({ results });
      cb(results);
    },

    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this7.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context3.sent;

                _this7.zohoToken = newToken.data.token;
                _this7.showErrorMsg({
                  message: "Token refreshed, Please reload page"
                });
                // this.loadAll();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this8.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this9._activeTab) {
                _this9.activeTab = _this9._activeTab;
              }
              // let _tmpdata = await this.fetchZohoToken();
              _context4.next = 3;
              return _this9.fetchPackageConfig();

            case 3:
              tmpPackageConfig = _context4.sent;

              _this9.packageConfigs = tmpPackageConfig["data"];
              _this9.regDataParams.deviceRequest = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this9.regDataParams.deviceRequest, {
                salesManager: _this9.getUserSession.firstName + " " + _this9.getUserSession.lastName,
                salesManagerContact: "" + _this9.getUserSession.phoneNumber
              });
              // console.log(this.zohoToken.data.token);
              // this.zohoToken = _tmpdata.data.token;
              // this.loadAll();
              _this9.fetchUsers();
              _this9.fetchSysTypes();
              // console.log(this._activeTab);

              // axios.interceptors.response.use(
              //   function(response) {
              //     return response;
              //   },
              //   function(error) {
              //     console.log(error);
              //     // handle error
              //     if (error.response) {
              //       alert(error.response.data.message);
              //     }
              //   }
              // );
              // const HTTP = this.$httpUtils.instance;

              // this.loadModules();

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this9);
    }))();
  }
});

/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(312);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {
    ModalMain: __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      default: false,
      showModal: true,
      showEdit: false,
      form: {
        bvn: ""
      },
      datas: [],
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    getCustomers: function getCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/customerAccountDetails").then(function (res) {
        _this.datas = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    edit: function edit() {
      this.showEdit = true;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.getCustomers();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null
  },
  components: {},
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: '',
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: 'Oil & Gas', name: 'Oil & Gas' }, { id: 'Farmer', name: 'Farmer' }, { id: 'Driver', name: 'Driver' }, { id: 'Painter', name: 'Painter' }],
      employmentStatus: [{ id: 'Employed', name: 'Employed' }],
      incomes: [{ id: '< N500,000', name: ' < N500,000' }, { id: '>N500,000 and < N750,000', name: '>N500,000 and < N750,000' }, {
        id: '> N750,000 and < N1,000,000',
        name: '> N750,000 and < N1,000,000'
      }, { id: '> N1,000,000', name: '> N1,000,000' }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: '',
        income: '',
        employment: '',
        business: ''
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
      message: 'Success Msg!'
    },
    showInfoMsg: {
      type: 'info',
      title: 'Information',
      message: 'Info. Msg!'
    },
    showWarnMsg: {
      type: 'warning',
      title: 'Warning',
      message: 'Warning Msg!'
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
      message: 'Error Msg!'
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {},
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(312);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {
    ModalMain: __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      showEdit: false,
      formErrors: {},
      datas: [],
      datar: [],
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst: function showFirst() {
      this.show1 = true;
      this.show2 = false;
    },
    showSecond: function showSecond() {
      this.show1 = false, this.show2 = true;
    },
    getCustomers: function getCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories").then(function (res) {
        _this.datas = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    edit: function edit() {
      console.log('edit');
      this.showEdit = true;
    },
    getThis: function getThis() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups").then(function (res) {
        _this2.datar = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.getCustomers();
              _this3.getThis();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(312);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {
    ModalMain: __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      datas: [],
      datar: [],
      showEdit: false,
      showModal: true,
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst: function showFirst() {
      this.show1 = true;
      this.show2 = false;
    },
    edit: function edit() {
      this.showEdit = true;
    },
    showSecond: function showSecond() {
      this.show1 = false, this.show2 = true;
    },
    getCustomers: function getCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories").then(function (res) {
        _this.datas = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getThis: function getThis() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups").then(function (res) {
        _this2.datar = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.getCustomers();
              _this3.getThis();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Modal__ = __webpack_require__(312);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FinishTab",
  props: {
    getUserSession: null
  },
  components: {
    ModalMain: __WEBPACK_IMPORTED_MODULE_3__Modal__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      datas: [],
      datar: [],
      showModal: true,
      show1: true,
      show2: false,
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    showFirst: function showFirst() {
      this.show1 = true;
      this.show2 = false;
    },
    showSecond: function showSecond() {
      this.show1 = false, this.show2 = true;
    },
    getCustomers: function getCustomers() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/transactionHistories").then(function (res) {
        _this.datas = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getThis: function getThis() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/recurringPaymentSetups").then(function (res) {
        _this2.datar = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this3.getCustomers();
              _this3.getThis();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  }
});

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__devices_Notification__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__instalation_inventoryRequest__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__instalation_ongoingInstalation__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rightBar__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__payment_due_payments__ = __webpack_require__(2938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__payment_payment_schedule__ = __webpack_require__(2941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__payment_transaction_history__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mockData_sectors_json__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__mockData_sectors_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__mockData_sectors_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuikit_lib_offcanvas__ = __webpack_require__(23);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















// import { ZOHOTHTTP } from "../../../store/actions";





var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode: function encode(e) {
    var t = "";
    var n, r, i, s, o, u, a;
    var f = 0;
    e = Base64._utf8_encode(e);
    while (f < e.length) {
      n = e.charCodeAt(f++);
      r = e.charCodeAt(f++);
      i = e.charCodeAt(f++);
      s = n >> 2;
      o = (n & 3) << 4 | r >> 4;
      u = (r & 15) << 2 | i >> 6;
      a = i & 63;
      if (isNaN(r)) {
        u = a = 64;
      } else if (isNaN(i)) {
        a = 64;
      }
      t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.chmanage;
      this._keyStr.chmanage;
    }
    return t;
  },
  decode: function decode(e) {
    manage;
    var t = "";
    var n, r, i;
    var s, o, u, a;
    var f = 0;
    e = e.replace(/[^A-Za-z0-9+/=]/g, "");
    while (f < e.length) {
      s = this._keyStr.indexOf(e.charAt(f++));
      o = this._keyStr.indexOf(e.charAt(f++));
      u = this._keyStr.indexOf(e.charAt(f++));
      a = this._keyStr.indexOf(e.charAt(f++));
      n = s << 2 | o >> 4;
      r = (o & 15) << 4 | u >> 2;
      i = (u & 3) << 6 | a;
      t = t + String.fromCharCode(n);
      if (u != 64) {
        t = t + String.fromCharCode(r);
      }
      if (a != 64) {
        t = t + String.fromCharCode(i);
      }
    }
    t = Base64._utf8_decode(t);
    return t;
  },
  _utf8_encode: function _utf8_encode(e) {
    e = e.replace(/rn/g, "n");
    var t = "";
    for (var n = 0; n < e.length; n++) {
      var r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
      } else if (r > 127 && r < 2048) {
        t += String.fromCharCode(r >> 6 | 192);
        t += String.fromCharCode(r & 63 | 128);
      } else {
        t += String.fromCharCode(r >> 12 | 224);
        t += String.fromCharCode(r >> 6 & 63 | 128);
        t += String.fromCharCode(r & 63 | 128);
      }
    }
    return t;
  },
  _utf8_decode: function _utf8_decode(e) {
    var t = "";
    var n = 0;
    var r = c1 = c2 = 0;
    while (n < e.length) {
      r = e.charCodeAt(n);
      if (r < 128) {
        t += String.fromCharCode(r);
        n++;
      } else if (r > 191 && r < 224) {
        c2 = e.charCodeAt(n + 1);
        t += String.fromCharCode((r & 31) << 6 | c2 & 63);
        n += 2;
      } else {
        c2 = e.charCodeAt(n + 1);
        c3 = e.charCodeAt(n + 2);
        t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        n += 3;
      }
    }
    return t;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  props: ["_activeTab"],
  data: function data() {
    return {
      discountType: "percent",
      usertype: localStorage.roleType,
      ZcontactList: [],
      selectedPaymentModel: [],
      packageConfigs: [],
      // paymentModel: `OS`,
      // setupFee: "",
      // monthlyFee: "",
      // cautionFee: "",
      regDataParams: {
        firstName: null,
        roleType: "customer",
        lastName: null,
        dateOfBirth: new Date(),
        gender: 0,
        phoneNumber: null,
        realm: "",
        username: "",
        email: null,
        def: true,
        street_route: null,
        password: "<%DUMMY%>",
        cpassword: "<%DUMMY%>",
        stateId: null,
        countryId: 1,
        lgaId: null,
        deviceRequest: {
          sector: "",
          installationName: "",
          paymentModel: "OS",
          priceModel: {
            amount: "",
            setupFee: "",
            monthlyFee: "",
            cautionFee: ""
          },
          systemCapacity: 5,
          orderVat: 5,
          orderDiscount: 0,
          typeOfBuilding: "Normal",
          roofType: "Aluminium",
          roofCondition: "Very Good",
          roofReadiness: "Very Ready",
          roofAge: 4,
          roofComment: "No comment here	Roof is ready for installation",
          deviceTypeId: null,
          comment: null,
          sendMail: true
        }
      },
      zohoToken: {},
      zohoModules: [],
      systemTypes: [],
      contactList: [],
      form: {
        userId: null,
        package: null,
        sector: "",
        contact: "",
        invoiceType: "initial",
        paymentModel: {
          name: "",
          setupFee: "",
          monthlyFee: "",
          cautionFee: "",
          orderDiscount: "",
          orderVat: ""
        },
        desc: ""
      },
      productReg: "https://arnergy.surge.sh/products.html?q=",
      activeTab: this.$route.params.activetab,
      showOffCanvas: false
    };
  },

  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_23_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_23_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_21_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_21_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_21_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_21_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_21_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_21_element_ui__["RadioButton"],
    DeviceRequest: __WEBPACK_IMPORTED_MODULE_6__devices_MyRequests__["a" /* default */],
    ManageRequestsuser: __WEBPACK_IMPORTED_MODULE_7__devices_ManageRequestsuser__["a" /* default */],
    Payment: __WEBPACK_IMPORTED_MODULE_16__payment_due_payments__["a" /* default */],
    ApprovedInstallations: __WEBPACK_IMPORTED_MODULE_12__instalation_instalationList__["a" /* default */],
    OngoingInstallations: __WEBPACK_IMPORTED_MODULE_14__instalation_ongoingInstalation__["a" /* default */],
    PaymentShedule: __WEBPACK_IMPORTED_MODULE_17__payment_payment_schedule__["a" /* default */],
    Transaction: __WEBPACK_IMPORTED_MODULE_18__payment_transaction_history__["a" /* default */],
    inventoryRequest: __WEBPACK_IMPORTED_MODULE_13__instalation_inventoryRequest__["a" /* default */],
    MyDeviceList: __WEBPACK_IMPORTED_MODULE_11__devices_List__["a" /* default */],
    RightBar: __WEBPACK_IMPORTED_MODULE_15__rightBar__["a" /* default */],
    Notification: __WEBPACK_IMPORTED_MODULE_8__devices_Notification__["a" /* default */],
    Users: __WEBPACK_IMPORTED_MODULE_9__user_mgt_Users__["a" /* default */],
    CustomerGroup: __WEBPACK_IMPORTED_MODULE_10__user_mgt_CustomerGroup__["a" /* default */]
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_19_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    paymentModel: function paymentModel() {
      return this.regDataParams.deviceRequest.paymentModel;
    }
  }),
  watch: {
    paymentModel: function paymentModel(newVal, oldVal) {
      this.selectedPaymentModel = this.packageConfigs.find(function (x) {
        return x.Package == newVal;
      });
      this.regDataParams.deviceRequest.paymentModel = newVal;
      // console.log(newVal.price);
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      if (this.selectedPaymentModel) {
        this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
        this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
        this.regDataParams.deviceRequest.priceModel.cautionFee = this.calcCaution(this.form.price);
      }
    }
  },
  methods: {
    changeContact: function changeContact() {
      this.form.invoiceType == "initial" ? this.contactList = this.ZcontactList : this.contactList = this.customerList;
      //console.log(this.customerList)
    },
    calcSetup: function calcSetup(price) {
      var setupPercent = Number(this.selectedPaymentModel["Setup"]) / 100;
      // console.log( this.form.price);
      var temp_price = Number(setupPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcSub: function calcSub(price) {
      var subscriptionPercent = Number(this.selectedPaymentModel["Subscription"]) / 100;
      var temp_price = Number(subscriptionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    calcCaution: function calcCaution(price) {
      var cautionPercent = Number(this.selectedPaymentModel["Caution"]) / 100;
      var temp_price = Number(cautionPercent * price).toFixed(2) * 1;
      // let vat = temp_price * 0.05;
      return Number(temp_price).toFixed(2);
    },
    onSubmit: function onSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var regDataParams, HTTP, resp, error_incomming, tempMsg;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.form.package == null)) {
                  _context.next = 4;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select a device type"
                });
                _context.next = 32;
                break;

              case 4:
                if (!(_this.form.sector == null)) {
                  _context.next = 8;
                  break;
                }

                _this.showErrorMsg({
                  message: "Please select an sector"
                });
                _context.next = 32;
                break;

              case 8:
                _this.regDataParams.deviceRequest.deviceTypeId = _this.form.package;
                // this.regDataParams.deviceRequest.orderDiscount = this.orderDiscount;
                // this.regDataParams.deviceRequest.orderVat = this.orderVat;
                regDataParams = _this.regDataParams;
                // let orderDiscount = this.orderDiscount;
                // let orderVat = this.orderVat;
                //console.log(this.contactList);
                //console.log(this.form);

                HTTP = _this.$httpUtils.instance;

                console.log(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(regDataParams));
                _context.prev = 12;

                if (!(_this.form.invoiceType == "initial")) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return HTTP.post("/users", regDataParams);

              case 16:
                _context.t0 = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return HTTP.post("/device_requests", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, regDataParams.deviceRequest, {
                  // status: 1,
                  priceModel: regDataParams.deviceRequest.priceModel,
                  status: _this.regDataParams.deviceRequest.sendMail ? 0 : 1,
                  userId: _this.form.userId
                }));

              case 21:
                _context.t0 = _context.sent;

              case 22:
                resp = _context.t0;

                _this.showSuccessMsg({ message: "Request Submitted" });
                //   // this.activeTab="manage_requests";
                //   // this.renderManageComponent= true;
                _this.showOffCanvas = false;
                _this.$router.push({
                  name: "devices",
                  params: {
                    activetab: "manage_requests"
                  }
                });
                //   this.$router.go();
                _context.next = 32;
                break;

              case 28:
                _context.prev = 28;
                _context.t1 = _context["catch"](12);

                if (_context.t1.response) {
                  if (_context.t1.response.data) {
                    // console.log(error.response.data);
                    error_incomming = _context.t1.response.data.error.details.messages;
                    // console.log(error_incomming);

                    tempMsg = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(error_incomming).map(function (x) {
                      return x + ": " + error_incomming[x].join(",");
                    });

                    _this.showErrorMsg({
                      message: tempMsg.join("<br>")
                    });
                  }
                }
                console.log({
                  error: _context.t1
                });

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[12, 28]]);
      }))();
    },
    packageSelected: function packageSelected() {
      var _this2 = this;

      this.regDataParams.deviceRequest.deviceTypeId = this.form.package;
      this.form.price = this.systemTypes.find(function (x) {
        return x.id == _this2.form.package;
      })["price"];
      this.regDataParams.deviceRequest.priceModel.amount = this.form.price;
      this.regDataParams.deviceRequest.priceModel.setupFee = this.calcSetup(this.form.price);
      this.regDataParams.deviceRequest.priceModel.monthlyFee = this.calcSub(this.form.price);
      // console.log({
      //   form: this.calcSetup(this.form.price)
      // });
    },
    contactSelected: function contactSelected(contact) {
      this.regDataParams = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, this.regDataParams, {
        firstName: contact["First_Name"],
        lastName: contact["Last_Name"],
        phoneNumber: contact["Phone"],
        username: contact["Email"],
        email: contact["Email"]
      });
      this.regDataParams.deviceRequest.installationName = contact["First_Name"] + " " + contact["Last_Name"];
      if (this.form.invoiceType == "existing") {
        this.form.userId = contact["id"];
      }
    },
    sectorSelected: function sectorSelected(sector) {
      this.regDataParams.deviceRequest.sector = "" + sector["name"];
    },
    getRegUri: function getRegUri(data) {
      return Base64.encode("\uFFFD6" + data);
    },
    loadAll: function loadAll() {
      var _this3 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      // console.log("++++++++++++++++++++++++++");
      // console.log(page);
      //  console.log(this.form)
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      var collection = "Contacts?fields=Email,First_Name,Last_Name,Phone";
      if (page > 1) {
        collection = "Contacts?fields=Email,First_Name,Last_Name,Phone&page=" + page;
      }
      ZOHOTHTTP.get("fetchAll", {
        params: {
          collection: collection
        }
      }).then(function (response) {
        return response.data["result"];
      }).then(function (resultData) {
        var tempList = resultData["data"];
        // console.log(tempList);
        container.ZcontactList = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(container.ZcontactList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(tempList.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            value: x.First_Name ? x.First_Name + " " + x.Last_Name : x.Last_Name
          });
        })));
        container.contactList = container.ZcontactList;
        // console.log(container.ZcontactList);
        if (resultData["info"]["more_records"] == true) {
          _this3.loadAll(resultData["info"]["page"] + 1);
        }
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    fetchUsers: function fetchUsers() {
      var HTTP = this.$httpUtils.instance;
      var container = this;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[where][roleType]=customer" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        container.customerList = response.data.map(function (x) {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, x, {
            First_Name: x.firstName,
            Last_Name: x.lastName,
            value: x.firstName + " " + x.lastName
          });
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    loadModules: function loadModules() {
      console.log("++++++++++++++++++++++++++");
      // console.log(this.zohoToken);
      var ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
      var container = this;
      ZOHOTHTTP.get("/settings/all", {
        headers: {
          Authorization: "Zoho-oauthtoken " + this.zohoToken["accessToken"],
          "Content-Type": " application/json;charset=UTF-8"
        }
      }).then(function (response) {
        container.zohoModules = response.data["data"];
      }).catch(function (e) {
        console.log("========Err=========");
        console.log(e);
        // this.refreshZohoToken();
      });
    },
    createFilter: function createFilter(queryString, contact) {
      return (contact.First_Name + " " + contact.Last_Name).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    contactSearch: function contactSearch(queryString, cb) {
      var _this4 = this;

      var contacts = this.contactList;
      var results = queryString ? contacts.filter(function (contact) {
        return _this4.createFilter(queryString, contact);
      }) : contacts;
      // console.log({ results });
      cb(results);
    },
    createSectorFilter: function createSectorFilter(queryString, sector) {
      console.log({ sector: sector });
      return ("" + sector.value.trim()).toLowerCase().indexOf(queryString.toLowerCase()) > -1;
    },
    sectorSearch: function sectorSearch(queryString, cb) {
      var _this5 = this;

      //  sectorList;
      // console.log({sectorList});
      var results = queryString ? __WEBPACK_IMPORTED_MODULE_22__mockData_sectors_json___default.a.filter(function (sect) {
        return _this5.createSectorFilter(queryString.trim(), sect);
      }) : __WEBPACK_IMPORTED_MODULE_22__mockData_sectors_json___default.a;
      // console.log({ results });
      cb(results);
    },

    // async fetchZohoToken() {
    //   const ZOHOTHTTP = this.$httpUtils.ZOHOTHTTP;
    //   return await ZOHOTHTTP.get("get-zoho-token");
    // },
    fetchPackageConfig: function fetchPackageConfig() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;
                _context2.next = 3;
                return HTTP.get("/package-configs");

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    refreshZohoToken: function refreshZohoToken() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var HTTP, newToken;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                HTTP = _this7.$httpUtils.instance;
                _context3.next = 3;
                return HTTP.post("/zohos/refresh-zoho-token");

              case 3:
                newToken = _context3.sent;

                _this7.zohoToken = newToken.data.token;
                _this7.showErrorMsg({
                  message: "Token refreshed, Please reload page"
                });
                // this.loadAll();

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    fetchSysTypes: function fetchSysTypes() {
      var _this8 = this;

      var HTTP = this.$httpUtils.instance;
      var url = "/device_types?filter[include][packageComponents]=componentType";
      return HTTP.get(url).then(function (response) {
        _this8.systemTypes = response.data;
        // console.log({ systemTypes });
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    var _this9 = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
      var tmpPackageConfig;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (_this9._activeTab) {
                _this9.activeTab = _this9._activeTab;
              }
              // let _tmpdata = await this.fetchZohoToken();
              _context4.next = 3;
              return _this9.fetchPackageConfig();

            case 3:
              tmpPackageConfig = _context4.sent;

              _this9.packageConfigs = tmpPackageConfig["data"];
              _this9.regDataParams.deviceRequest = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, _this9.regDataParams.deviceRequest, {
                salesManager: _this9.getUserSession.firstName + " " + _this9.getUserSession.lastName,
                salesManagerContact: "" + _this9.getUserSession.phoneNumber
              });
              // console.log(this.zohoToken.data.token);
              // this.zohoToken = _tmpdata.data.token;
              // this.loadAll();
              _this9.fetchUsers();
              _this9.fetchSysTypes();
              // console.log(this._activeTab);

              // axios.interceptors.response.use(
              //   function(response) {
              //     return response;
              //   },
              //   function(error) {
              //     console.log(error);
              //     // handle error
              //     if (error.response) {
              //       alert(error.response.data.message);
              //     }
              //   }
              // );
              // const HTTP = this.$httpUtils.instance;

              // this.loadModules();

            case 8:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this9);
    }))();
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */





__WEBPACK_IMPORTED_MODULE_5_moment___default.a.updateLocale('en', {
  monthsShort: 'jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec'.split('_')
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    'el-dialog': __WEBPACK_IMPORTED_MODULE_4_element_ui__["Dialog"],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_3__kitchen_ArnergyInput__["a" /* default */]
  },
  data: function data() {
    return {
      searchTerm: '',
      usertype: localStorage.roleType,
      showModal: false,
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{
        field: 'id',
        label: 'ID',
        sortable: 'true'
      }, {
        field: 'full_name',
        label: 'Full Name',
        sortable: 'true'
      }, {
        field: 'roleType',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'email',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phoneNumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedAt',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      cxTeamFields: [{
        field: 'id',
        label: 'ID',
        sortable: 'true'
      }, {
        field: 'full_name',
        label: 'Full Name',
        sortable: 'true'
      }, {
        field: 'roletype',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'email',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phonenumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedat',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      cxTeamFieldsAdmin: [{
        field: 'id',
        label: 'ID',
        sortable: 'true'
      }, {
        field: 'full_name',
        label: 'Full Name',
        sortable: 'true'
      }, {
        field: 'roleType',
        label: 'User Type',
        sortable: 'true'
      }, {
        field: 'email',
        label: 'E-mail',
        sortable: 'true'
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: 'gender',
        label: 'Gender',
        sortable: 'true'
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: 'phoneNumber',
        label: 'Phone Number',
        sortable: 'true'
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: 'updatedAt',
        label: 'Last Seen',
        sortable: 'true'
      }, {
        field: 'actions',
        label: 'Actions'
      }],
      currentPage: 1,
      details: ['UserDetails', 'allowUser'],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: '',
        content: ''
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getUserById', 'getDeviceById', 'getUsers', 'getUsersAdmin', 'getDummy', 'getDevices']), {
    isACxTeam: {
      get: function get() {
        if (this.$can('am', 'cxTeam') || this.$can('edit', 'user')) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_5_moment___default()(date).format('Do MMM YYYY');
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = 'Row index: ' + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    pressFunc: function pressFunc() {
      console.log('i was presseed');
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = '/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER' + '&filter[order]=id DESC';
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit('saveUsers', usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    },
    fetchUsersAdmin: function fetchUsersAdmin() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var data = new FormData();
      var id = localStorage.customerId;
      data.append('customerAdminUserId', id);
      //  filter={"include": ["installations"]}
      var url = '/groupUsers/getUsersByCustomerAdmin';
      HTTP.post(url, data).then(function (response) {
        var usersList = response.data;
        _this2.$store.commit('saveUsersAdmin', usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log('error', error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsersAdmin();
    this.fetchUsers();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */


__WEBPACK_IMPORTED_MODULE_3_moment___default.a.updateLocale("en", {
  monthsShort: "jan_feb_mar_apr_may_june_july_aug_sept_oct_nov_dec".split("_")
});

var items = [];
/* harmony default export */ __webpack_exports__["a"] = ({
  // components: {
  //   Inventory
  // },
  data: function data() {
    return {
      searchTerm: "",
      usertype: localStorage.roleType,
      selectOption: {
        enabled: true
      },
      items: items,
      fields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      cxTeamFields: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roletype",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phonenumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedat",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      cxTeamFieldsAdmin: [{
        field: "id",
        label: "ID",
        sortable: "true"
      }, {
        field: "full_name",
        label: "Full Name",
        sortable: "true"
      }, {
        field: "roleType",
        label: "User Type",
        sortable: "true"
      }, {
        field: "email",
        label: "E-mail",
        sortable: "true"
      },
      // { key: 'dob', label: 'Date of birth', sortable: 'true'},
      {
        field: "gender",
        label: "Gender",
        sortable: "true"
      },
      // { key: 'wallet_balance', label: 'Wallet Balance', sortable: 'true'},
      // { key: 'is_active', label: 'Status', sortable: 'true'},
      // { key: 'last_login', label: 'Last Login', sortable: 'true'},
      {
        field: "phoneNumber",
        label: "Phone Number",
        sortable: "true"
      },
      // { key: 'address', label: 'Address', sortable: 'true'},
      {
        field: "updatedAt",
        label: "Last Seen",
        sortable: "true"
      }, {
        field: "actions",
        label: "Actions"
      }],
      currentPage: 1,
      details: ["UserDetails", "allowUser"],
      perPage: 10,
      totalRows: items.length,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: {
        title: "",
        content: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserById", "getDeviceById", "getUsers", "getUsersAdmin", "getDummy", "getDevices"]), {
    isACxTeam: {
      get: function get() {
        if (this.$can("am", "cxTeam") || this.$can("edit", "user")) {
          return true;
        } else {
          return true;
        }
      }
    },
    sortOptions: function sortOptions() {
      // Create an options list from our fields
      return this.fields.filter(function (f) {
        return f.sortable;
      }).map(function (f) {
        return {
          text: f.label,
          value: f.key
        };
      });
    }
  }),
  methods: {
    formatDate: function formatDate(date) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format("Do MMM YYYY");
    },
    navTo: function navTo(url, user) {
      this.$router.push({
        name: url,
        params: {
          userId: user
        }
      });
    },
    info: function info(item, index, button) {
      this.modalInfo.title = "Row index: " + index;
      this.modalInfo.content = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 2);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    resetModal: function resetModal() {
      this.modalInfo.title = "";
      this.modalInfo.content = "";
    },
    onFiltered: function onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    pressFunc: function pressFunc() {
      console.log('i was presseed');
    },
    fetchUsers: function fetchUsers() {
      var _this = this;

      var HTTP = this.$httpUtils.instance;
      //  filter={"include": ["installations"]}
      var url = "/users?filter[include][installations]=deviceType&filter[where][roleType][neq]=CUSTOMER" + "&filter[order]=id DESC";
      HTTP.get(url).then(function (response) {
        var usersList = response.data;
        _this.$store.commit("saveUsers", usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchUsersAdmin: function fetchUsersAdmin() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      var data = new FormData();
      var id = localStorage.customerId;
      data.append("customerAdminUserId", id);
      //  filter={"include": ["installations"]}
      var url = "/groupUsers/getUsersByCustomerAdmin";
      HTTP.post(url, data).then(function (response) {
        var usersList = response.data;
        _this2.$store.commit("saveUsersAdmin", usersList);
        // console.log(this.getUserById(1))
      }).catch(function (error) {
        console.log("error", error);
      });
    }
  },
  mounted: function mounted() {
    this.fetchUsersAdmin();
    this.fetchUsers();
    // console.log(this.getDummy)
  }
});

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_modal_verify_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuex__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "",
  components: {
    "vk-offcanvas": __WEBPACK_IMPORTED_MODULE_16_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    "vk-offcanvas-close": __WEBPACK_IMPORTED_MODULE_16_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    "el-autocomplete": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Autocomplete"],
    "el-form": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Form"],
    "el-form-item": __WEBPACK_IMPORTED_MODULE_15_element_ui__["FormItem"],
    "el-radio": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Radio"],
    "el-radio-group": __WEBPACK_IMPORTED_MODULE_15_element_ui__["RadioGroup"],
    "el-radio-button": __WEBPACK_IMPORTED_MODULE_15_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_3__users_index__["a" /* default */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_15_element_ui__["Dialog"],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_8__kitchen_ArnergySelect_vue__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_5__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_6__shs_Wallet__["a" /* default */],
    Rave: __WEBPACK_IMPORTED_MODULE_4_vue_ravepayment___default.a,
    ModalSuccess: __WEBPACK_IMPORTED_MODULE_14__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */],
    ModalVerify: __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_modal_verify_vue__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_10__users_allow__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      passwordMatch: false,
      errorStatus: false,
      connectionStatus: false,
      activeTab: "user_list",
      CT: [{ id: "Individual", name: "Customer Individial" }, { id: "Corporate", name: "Customer Corporate" }],
      usertype: localStorage.roleType,
      firstName: "",
      lastName: "",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      email: "",
      phone_number: "",
      showModal: false,
      productAmt: "",
      customerType: "",
      password: "",
      required: false,
      redirectUrl: "https://solarbase.arnergy.com/auth/paymentFeedback",
      cpassword: "",
      modalSucess: false,
      meta: [{
        metaname: "school",
        metavalue: "high school"
      }],
      ModalVerify: false
    };
  },

  computed: {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_17_vuex__["b" /* mapActions */])(["saveOsCustomer"]), {
    flutterwavePay: function flutterwavePay() {
      var _this = this;

      var data = {
        firstName: this.firstName,
        email: this.email,
        roleType: this.customerType,
        ccEmails: this.email,
        assignedDevices: "null",
        lastName: this.lastName,
        dateOfBirth: new Date(),
        phoneNumber: this.phone_number,
        gender: 0,
        street_route: "string",
        wallet: 0,
        createdAt: "2021-07-09T11:17:55.049Z",
        updatedAt: "2021-07-09T11:17:55.049Z",
        realm: "string",
        username: this.email,
        emailVerified: true,
        password: this.password
      };

      if (this.firstName && this.lastName && this.email && this.phone_number && this.password && this.cpassword) {
        var HTTP = this.$httpUtils.instance;
        if (this.cpassword && this.password) {
          HTTP.post("/users", data).then(function (res) {
            if (res.data.id) {
              _this.showModal = true;
              console.log(res.data);
              _this.saveOsCustomer(res.data);
              localStorage.firstName = res.data.firstName;
              localStorage.lastName = res.data.lastName;
              localStorage.customerId = res.data.id;
              localStorage.phoneNumber = res.data.phoneNumber;

              _this.showLoading = false;

              HTTP.patch("/onboardingStates", {
                customerid: res.data.id,
                packageType: "OS",
                stateid: 1
              }).then(function (x) {
                localStorage.customerState = x.data.id;
                localStorage.packageType = x.data.packageType;
                _this.$store.commit("saveOnboanrdingState", 1);
              });

              HTTP.post("/onboardingNotifications/sendAccountRegistrationEmail", {
                firstName: res.data.firstName,
                lastName: res.data.lastName,
                email: res.data.email
              });
            } else {
              _this.errorStatus = true;
              setTimeout(function () {
                _this.errorStatus = false;
              }, 2000);
            }
          }).catch(function (Err) {
            _this.errorStatus = true;
            setTimeout(function () {
              _this.errorStatus = false;
            }, 2000);
          });
        } else {
          this.passwordMatch = true;
          setTimeout(function () {
            _this.passwordMatch = false;
          }, 2000);
        }
      } else {
        this.required = true;
        setTimeout(function () {
          _this.required = false;
        }, 2000);
      }
    },

    callback: function callback(response) {
      var trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      this.close();
      // @todo: validate request... this is wrong
      if (trRef.data.status === "successful") {
        this.showSuccessMsg = { message: "Transaction Successful" };
        // console.log('yeeeeeeeeeeeeeeeeeeeeeeeee')
        // this.gotoSection(1)
      } else {
        this.showErrorMsg({ message: "Transaction fails" });
      }
    },
    triggerPayment: function triggerPayment() {
      document.getElementById("paymentbtn").click();
    },
    close: function close() {
      console.log("Payment closed");
    },
    gotoFeedback: function gotoFeedback() {
      var customer = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone_number: this.phone_number,
        productAmt: this.productAmt,
        customerType: this.customerType,
        usertype: localStorage.roleType
      };
      this.saveOsCustomer(customer);
      __WEBPACK_IMPORTED_MODULE_13__router__["a" /* default */].push("/auth/paymentFeedback");
    },
    flutterwavePaygate: function flutterwavePaygate() {
      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: this.productAmt,
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "https://solarbase.arnergy.com/auth/paymentFeedback",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.email,
          phone_number: this.phone_number,
          name: this.firstName + " " + this.lastName
        },
        callback: function callback(data) {
          console.log(data);
        },
        onclose: function onclose() {
          // close modal
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
        }
      });
    },
    getParamValuesByName: function getParamValuesByName(querystring) {
      var qstring = window.location.href.slice(window.location.href.indexOf("?") + 1).split("&");
      for (var i = 0; i < qstring.length; i++) {
        var urlparam = qstring[i].split("=");
        if (urlparam[0] == querystring) {
          return urlparam[1];
        }
      }
    },
    fetchProductById: function fetchProductById(id) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this2.$httpUtils.instance;
                _context.next = 3;
                return HTTP.get("/arnergyProducts/" + id);

              case 3:
                res = _context.sent;


                if (res.data) {
                  _this2.productAmt = res.data.amountOS;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var uid;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              uid = _this3.getParamValuesByName("id");

              _this3.fetchProductById(uid);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ModalVerify",
  components: {},
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ModalError",
  props: ["message"],
  components: {},
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__users_index__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__devices_List__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shs_Wallet__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__users_allow__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_modal_verify_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_offcanvas__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuex__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    'vk-offcanvas': __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_offcanvas__["a" /* Offcanvas */],
    'vk-offcanvas-close': __WEBPACK_IMPORTED_MODULE_13_vuikit_lib_offcanvas__["b" /* OffcanvasClose */],
    'el-autocomplete': __WEBPACK_IMPORTED_MODULE_11_element_ui__["Autocomplete"],
    'el-form': __WEBPACK_IMPORTED_MODULE_11_element_ui__["Form"],
    'el-form-item': __WEBPACK_IMPORTED_MODULE_11_element_ui__["FormItem"],
    'el-dialog': __WEBPACK_IMPORTED_MODULE_11_element_ui__["Dialog"],
    'el-radio': __WEBPACK_IMPORTED_MODULE_11_element_ui__["Radio"],
    ModalVerify: __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_modal_verify_vue__["a" /* default */],
    ModalSuccess: __WEBPACK_IMPORTED_MODULE_10__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */],
    'el-radio-group': __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioGroup"],
    'el-radio-button': __WEBPACK_IMPORTED_MODULE_11_element_ui__["RadioButton"],
    Users: __WEBPACK_IMPORTED_MODULE_3__users_index__["a" /* default */],
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_7__kitchen_ArnergyInput__["a" /* default */],
    Devices: __WEBPACK_IMPORTED_MODULE_4__devices_List__["a" /* default */],
    transactionHistories: __WEBPACK_IMPORTED_MODULE_5__shs_Wallet__["a" /* default */],
    userRole: __WEBPACK_IMPORTED_MODULE_8__users_allow__["a" /* default */]
  },
  data: function data() {
    return {
      showOffCanvas: false,
      activeTab: 'user_list',
      usertype: localStorage.roleType,
      showModal: true,
      firstName: 'Victor',
      lastName: 'Abimbola',
      email: 'abimbolavitor3@gmail.com',
      modalVerify: false,
      modalSucess: false,
      messageSuccess: "",
      productAmt: "",
      phone_number: ""
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["c" /* mapGetters */])(['getOsCustomer']), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_14_vuex__["b" /* mapActions */])(['saveOsCustomer']), {
    flutterwavePay: function flutterwavePay() {
      FlutterwaveCheckout({
        // public_key: 'FLWPUBK_TEST-SANDBOXDEMOKEY-X',
        public_key: 'FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X',
        tx_ref: this.genRandomNumber,
        amount: this.productAmt,
        currency: 'NGN',
        country: 'NG',
        paymentType: 'account',
        // paymentOptions: 'ussd',

        // specified redirect URL
        // redirect_url: 'https://solarbase.arnergy.com/auth/paymentFeedback',
        redirect_url: 'https://solarbase.arnergy.com/auth/login',
        meta: {
          consumer_id: 23,
          consumer_mac: '92a3-912ba-1192a'
        },
        customer: {
          email: this.email,
          phone_number: this.phone_number,
          name: this.firstName + ' ' + this.lastName
        },
        callback: function callback(data) {
          console.log(data);
        },
        onclose: function onclose() {
          // close modal
        },
        customizations: {
          title: 'Arnergy Solar',
          description: 'Payment',
          logo: 'https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg'
        }
      });
    },
    verify: function verify(tx_ref) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  txref: tx_ref,
                  lastName: localStorage.lastName,
                  firstName: localStorage.firstName,
                  customerId: parseInt(localStorage.customerId)
                };

                if (!data.txref) {
                  _context.next = 26;
                  break;
                }

                console.log(data);
                _this.$emit("showLoading", true);
                HTTP = _this.$httpUtils.instance;
                _context.prev = 5;
                _context.next = 8;
                return HTTP.post("/payments/verifyPayment", data);

              case 8:
                res = _context.sent;

                _this.$emit("showLoading", false);

                if (!res.data.customerid) {
                  _context.next = 14;
                  break;
                }

                _this.modalSucess = true;
                _this.messageSuccess = res.data.message;
                return _context.abrupt('return');

              case 14:
                if (!(res.data == null || res.status == 204)) {
                  _context.next = 17;
                  break;
                }

                _this.modalVerify = true;
                return _context.abrupt('return');

              case 17:
                _context.next = 26;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](5);

                _this.modalVerify = true;

                console.log("working 50  modal suppose show");
                console.log(_context.t0);
                _this.$emit("showLoading", false);
                _this.showErrorMsg({
                  message: "Unable to complete action, please try again."
                });

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[5, 19]]);
      }))();
    }
  }),
  created: function created() {
    var customer = this.getOsCustomer || localStorage.getItem('osCustomer');
    if (!this.getOsCustomer) this.saveOsCustomer(localStorage.getItem('osCustomer'));
    this.firstName = customer.firstName;
    this.lastName = customer.lastName;
    this.email = customer.email;
    this.productAmt = customer.productAmt;
    this.phone_number = customer.phone_number;
  }
});

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OnboardingProgressTracker_vue__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OnboardingTopBar_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnboardingButton_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OS",
  components: {
    OnboardingTopBar: __WEBPACK_IMPORTED_MODULE_2__OnboardingTopBar_vue__["a" /* default */],
    OnboardingButton: __WEBPACK_IMPORTED_MODULE_3__OnboardingButton_vue__["a" /* default */],
    OnboardingProgressTracker: __WEBPACK_IMPORTED_MODULE_1__OnboardingProgressTracker_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  data: function data() {
    return {
      packageType: {
        name: '',
        productDescription: '',
        amountOS: 0
      },
      showTracker: false,
      agreementStatus: false,
      osSection: "",
      osRoutes: ["/onboarding/os/agreement", "/onboarding/os/summary", "/onboarding/os/finish"],
      tabItems: [{
        title: "Start"
      }, {
        title: "Agreement",
        percent: "32.5",
        path: "/onboarding/os/agreement"
      }, {
        title: "Payment Summary",
        percent: "66.2",
        path: "/onboarding/os/summary"
      }, {
        title: "Finish",
        percent: "100",
        path: "/onboarding/os/finish"
      }]
    };
  },

  methods: {
    buttonFunction: function buttonFunction(btnType) {
      if (btnType === "prev") return this.handlePrev();else if (btnType === "next") {
        switch (this.osSection) {
          case "/onboarding/os/summary":
            this.flutterwavePaygate();
            break;
          case "/onboarding/os/agreement":
            if (this.agreementStatus) this.handleNext();else alert('Please accept the terms and conditions to continue');
            break;
          default:
            this.handleNext();
        }
        // if (this.osSection !== "/onboarding/os/summary") {
        //   if (this.osSection === "/onboarding/os/agreement" && !this.agreementStatus) alert('Please accept the terms and conditions to continue');
        //   else return this.handleNext();
        // }
        // else this.flutterwavePaygate();
      }
    },
    handleNext: function handleNext() {
      var pageRouteIndex = this.osRoutes.indexOf(this.$route.path);
      if (pageRouteIndex < this.osRoutes.length) {
        this.$router.push(this.osRoutes[pageRouteIndex + 1]);
        this.osSection = this.osRoutes[pageRouteIndex + 1];
        this.$refs.progressTracker.setActivePoints();
      }
    },
    handlePrev: function handlePrev() {
      var pageRouteIndex = this.osRoutes.indexOf(this.$route.path);
      if (pageRouteIndex > 0) {
        this.$router.push(this.osRoutes[pageRouteIndex - 1]);
        this.osSection = this.osRoutes[pageRouteIndex - 1];
        this.$refs.progressTracker.setActivePoints();
      } else if (pageRouteIndex === 0) this.$router.push("/onboarding");
    },
    flutterwavePaygate: function flutterwavePaygate() {
      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        amount: this.packageType.amountOS,
        //amount: "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/onboarding/os/finish",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phoneNumber,
          name: this.getUserSession.firstName + " " + this.getUserSession.lastName
        },
        callback: function callback(data) {
          console.log(data);
        },
        onclose: function onclose() {
          // close modal
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
        }
      });
    },
    updateStatus: function updateStatus(stateid) {
      var _this = this;

      var HTTP = this.$httpUtils.instance;

      HTTP.patch("/onboardingStates", {
        customerid: this.getUserSession.id,
        stateid: stateid,
        packageType: 'OS',
        id: this.$store.state.onboardingCustomerState.id
      }).then(function (res) {
        return _this.$store.commit("saveOnboardingCustomerState", res.data);
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    getOnboardingState: function getOnboardingState(id) {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;
      HTTP.get("/onboardingStates/findOne?filter={\"where\":{\"customerid\":" + id + "}}").then(function (response) {
        if (_this2.$route.path !== _this2.osRoutes[response.data.stateid - 1]) {
          _this2.$router.push(_this2.osRoutes[response.data.stateid - 1]);
        }
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    updateTracker: function updateTracker(bool) {
      this.showTracker = bool;
    },
    updateAgreementStatus: function updateAgreementStatus(bool) {
      this.agreementStatus = bool;
    }
  },
  mounted: function mounted() {
    this.getOnboardingState(this.getUserSession.id);
    this.osSection = this.$route.path;
    this.packageType = this.$store.state.onboardingPackageType;
  }
});

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingProgressTracker_vue__ = __webpack_require__(1193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffbf068_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingProgressTracker_vue__ = __webpack_require__(2958);
function injectStyle (ssrContext) {
  __webpack_require__(2957)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ffbf068"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingProgressTracker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ffbf068_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingProgressTracker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "OnboardingProgressTracker",
    props: ["tabItems"],
    computed: {
        getProgressPercent: function getProgressPercent() {
            var _this = this;

            var percent = void 0;
            this.tabItems.map(function (item) {
                if (item.path == _this.$route.path) percent = item.percent;
            });
            return percent;
        }
    },
    data: function data() {
        return {
            setActivePoints: function setActivePoints() {
                var _this2 = this;

                var activeStatus = true;
                var itemsArray = this.tabItems;
                itemsArray.map(function (item) {
                    item.active = activeStatus;
                    if (item.path == _this2.$route.path) activeStatus = false;
                });
                this.tabItems = itemsArray;
            }
        };
    },
    beforeMount: function beforeMount() {
        this.setActivePoints();
    }
});

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OSAgreement",
  props: ["updateStatus", "updateAgreementStatus", "updateTracker"],
  data: function data() {
    return {
      checkAgreement: false,
      agreementCount: 1
    };
  },

  methods: {
    toggleAgreementCheck: function toggleAgreementCheck() {
      this.checkAgreement = !this.checkAgreement;
      this.updateAgreementStatus(this.checkAgreement);
    },
    handleAgreementNavigation: function handleAgreementNavigation(direction) {
      if (this.agreementCount >= 0) {
        if (direction === "plus") this.agreementCount = this.agreementCount + 1;
        if (direction === "minus") this.agreementCount = this.agreementCount - 1;
      }
    }
  },
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(1);
  }
});

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(7);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OSSummary",
  props: ["updateStatus", "updateTracker"],
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    return {
      packageType: {
        name: '',
        productDescription: '',
        amountOS: 0,
        id: 0
      }
    };
  },

  methods: {
    saveCustomerProduct: function saveCustomerProduct() {
      var HTTP = this.$httpUtils.instance;

      var data = {
        customerId: this.getUserSession.id,
        productid: this.packageType.id,
        tenure: '6',
        firstPaymentAmt: '1181000',
        monthlyIncomeRange: '>1000000',
        employmentStatus: 'employed',
        totalPayment: '3065000',
        cautionFee: '0',
        setupFee: '0'
      };

      HTTP.post("/CustomerProductOptions", data).catch(function (err) {
        return console.log(err);
      });
    },
    getCustomerProduct: function getCustomerProduct() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, customerProductId, res, productPackage, customerProduct;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this.$httpUtils.instance;
                _context.next = 3;
                return HTTP.get("/CustomerProductOptions?filter={\"where\":{\"customerId\":" + _this.getUserSession.id + "},\"order\":\"id DESC\",\"limit\":\"1\"}");

              case 3:
                customerProductId = _context.sent;
                _context.next = 6;
                return HTTP.get("/arnergyProducts");

              case 6:
                res = _context.sent;
                productPackage = res.data.filter(function (item) {
                  return item.id === customerProductId.data[0].productid;
                });
                customerProduct = {
                  id: productPackage[0].id,
                  name: productPackage[0].productType,
                  amountOS: productPackage[0].amountOS,
                  productDescription: productPackage[0].productDescription
                };


                _this.$store.commit("saveOnboardingPackageType", customerProduct);
                return _context.abrupt("return", customerProduct);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this2.updateTracker(true);
              _this2.packageType = _this2.$store.state.onboardingPackageType;

              if (!_this2.packageType.name) {
                _context2.next = 6;
                break;
              }

              _this2.saveCustomerProduct();
              _context2.next = 9;
              break;

            case 6:
              _context2.next = 8;
              return _this2.getCustomerProduct();

            case 8:
              _this2.packageType = _context2.sent;

            case 9:
              _this2.updateStatus(2);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  }
});

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OSFinish",
  props: ["updateStatus", "updateTracker"],
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
  }
});

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OnboardingProgressTracker_vue__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OnboardingTopBar_vue__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OnboardingButton_vue__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LO",
  components: {
    OnboardingTopBar: __WEBPACK_IMPORTED_MODULE_2__OnboardingTopBar_vue__["a" /* default */],
    OnboardingButton: __WEBPACK_IMPORTED_MODULE_3__OnboardingButton_vue__["a" /* default */],
    OnboardingProgressTracker: __WEBPACK_IMPORTED_MODULE_1__OnboardingProgressTracker_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  data: function data() {
    return {
      packageType: {
        name: "",
        productDescription: "",
        amountOS: 0
      },
      productPackage: {},
      employmentPackage: {},
      showTracker: false,
      agreementStatus: false,
      bankStatementPassed: false,
      creditCheckPassed: false,
      kycPassed: false,
      payDepositPassed: false,
      errorMessage: false,
      loSection: "",
      loRoutes: ["/onboarding/lo/summary",
      // "/onboarding/lo/job-info",
      "/onboarding/lo/agreement",
      // "/onboarding/lo/bank-statement",
      "/onboarding/lo/credit-check", "/onboarding/lo/kyc", "/onboarding/lo/deposit", "/onboarding/lo/finish"],
      tabItems: [{
        title: "Start"
      }, {
        title: "Payment Summary",
        percent: "16.67",
        path: "/onboarding/lo/summary"
      },
      // {
      //   title: "Job Information",
      //   percent: "27.48",
      //   path: "/onboarding/lo/job-info"
      // },
      {
        title: "Agreement",
        percent: "33.34",
        path: "/onboarding/lo/agreement"
      },
      // {
      //   title: "Bank Statement",
      //   percent: "53",
      //   path: "/onboarding/lo/bank-statement"
      // },
      {
        title: "Credit Check",
        percent: "50.01",
        path: "/onboarding/lo/credit-check"
      }, {
        title: "KYC",
        percent: "66.68",
        path: "/onboarding/lo/kyc"
      }, {
        title: "Pay Deposit",
        percent: "83.35",
        path: "/onboarding/lo/deposit"
      }, {
        title: "Finish",
        percent: "100",
        path: "/onboarding/lo/finish"
      }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    buttonFunction: function buttonFunction(btnType) {
      if (btnType === "prev") {
        switch (this.loSection) {
          case "/onboarding/lo/finish":
            this.showErrorMsg({
              message: "You have successfully completed the onboarding process!"
            });
            break;
          default:
            this.handlePrev();
        }
      } else if (btnType === "next") {
        switch (this.loSection) {
          case "/onboarding/lo/summary":
            this.processCustomerProduct();
            break;
          case "/onboarding/lo/job-info":
            this.processCustomerProduct();
            break;
          case "/onboarding/lo/agreement":
            if (this.agreementStatus) this.handleNext();else this.showErrorMsg({
              message: "Please accept the terms and conditions to continue"
            });
            break;
          // case "/onboarding/lo/bank-statement":
          //   return this.handleNext();
          //   if (this.bankStatementPassed) this.handleNext();
          //   else
          //     this.showErrorMsg({
          //       message: "You have not passed the bank statement check!"
          //     });
          //   break;
          case "/onboarding/lo/credit-check":
            // this.handleNext();
            // return;
            if (this.creditCheckPassed) this.handleNext();else this.showErrorMsg({
              message: "You need to pass the credit check!"
            });
            break;
          case "/onboarding/lo/kyc":
            if (this.kycPassed) this.handleNext();else this.showErrorMsg({
              message: "Kindly upload all required details!"
            });
            break;
          case "/onboarding/lo/deposit":
            if (this.payDepositPassed) this.handleNext();else this.showErrorMsg({
              message: "You need to pay the initial deposit and setup recurring payment!"
            });
            break;
          case "/onboarding/lo/finish":
            this.showSuccessMsg({
              message: "We would call you soon to finalize the documentation and installation process."
            });
            break;
          default:
            this.handleNext();
        }
      }
    },
    handleNext: function handleNext() {
      var pageRouteIndex = this.loRoutes.indexOf(this.$route.path);
      if (pageRouteIndex < this.loRoutes.length) {
        this.$router.push(this.loRoutes[pageRouteIndex + 1]);
        this.loSection = this.loRoutes[pageRouteIndex + 1];
        this.$refs.progressTracker.setActivePoints();
      }
    },
    handlePrev: function handlePrev() {
      var pageRouteIndex = this.loRoutes.indexOf(this.$route.path);
      if (pageRouteIndex > 0) {
        this.$router.push(this.loRoutes[pageRouteIndex - 1]);
        this.loSection = this.loRoutes[pageRouteIndex - 1];
        this.$refs.progressTracker.setActivePoints();
      } else if (pageRouteIndex === 0) this.$router.push("/onboarding");
    },
    getCustomerProductDetails: function getCustomerProductDetails(product) {
      this.productPackage = product;
    },
    getCustomerEmploymentDetails: function getCustomerEmploymentDetails(details) {
      this.employmentPackage = details;
    },
    processCustomerProduct: function processCustomerProduct() {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.productPackage, {
        monthlyIncomeRange: "4",
        employmentStatus: "0"
      }, this.employmentPackage);

      if (this.loSection === "/onboarding/lo/job-info") {
        if (this.employmentPackage.monthlyIncomeRange && this.employmentPackage.employmentStatus) {
          this.saveCustomerProduct(data);
        } else this.showErrorMsg({ message: "Please fill all fields!" });
      } else this.saveCustomerProduct(data);
    },
    saveCustomerProduct: function saveCustomerProduct(data) {
      var _this = this;

      var HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get("/productoption/productoption").then(function (res) {
        if (res.data === null) {
          HTTP.post("/productoption/productoption", data).then(function (response) {
            console.log("This is a console logggggg", response.data);
            if (response.status) _this.handleNext();else _this.showErrorMsg({ message: response.data.message });
          }).catch(function (error) {
            return _this.showErrorMsg({
              message: error.response.data.detail
            });
          });
        } else if (!res.data.isPurchased) {
          HTTP.patch("/productoption/nextproductionoption", data).then(function (result) {
            if (result.status) _this.handleNext();else _this.showErrorMsg({ message: result.data.message });
          }).catch(function (err) {
            return _this.showErrorMsg({ message: err.response.data.detail });
          });
        }
      }).catch(function (err) {
        return console.log(err);
      });
    },
    updateStatus: function updateStatus(stateid) {
      var _this2 = this;

      var HTTP = this.$httpUtils.FASTHTTP;
      var payloadData = {
        stateid: stateid,
        packageType: "LO"
      };

      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        return _this2.$store.commit("saveOnboardingCustomerState", res.data);
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    getOnboardingState: function getOnboardingState(id) {
      var _this3 = this;

      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.get("/onboardingstate/state").then(function (response) {
        if (_this3.$route.path !== _this3.loRoutes[response.data.stateid - 1]) {
          _this3.loSection = _this3.loRoutes[response.data.stateid - 1];
          _this3.$router.push(_this3.loRoutes[response.data.stateid - 1]);
        }
      }).catch(function (error) {
        return console.log({ error: error });
      });
    },
    updateTracker: function updateTracker(bool) {
      this.showTracker = bool;
    },
    markAsCompleted: function markAsCompleted(bool) {
      switch (this.loSection) {
        case "/onboarding/lo/agreement":
          this.agreementStatus = bool;
          break;
        case "/onboarding/lo/bank-statement":
          this.bankStatementPassed = bool;
          break;
        case "/onboarding/lo/credit-check":
          this.creditCheckPassed = bool;
          break;
        case "/onboarding/lo/kyc":
          this.kycPassed = bool;
          break;
        case "/onboarding/lo/deposit":
          this.payDepositPassed = bool;
          break;
      }
    }
  },
  mounted: function mounted() {
    this.getOnboardingState(this.getUserSession.id);
    // this.loSection = this.$route.path;
    this.packageType = this.$store.state.onboardingPackageType;
  }
});

/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LOSummary",
  props: ["updateStatus", "updateTracker", "getCustomerProductDetails"],
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getUserSession"]), {
    getProgressPercent: function getProgressPercent() {
      var _this = this;

      var percent = void 0;
      this.tenureItems.map(function (item) {
        if (item.point == _this.activeTenure) percent = item.percent;
      });
      return percent;
    }
  }),
  watch: {
    quantity: function quantity(newValues, oldValues) {
      if (!newValues) return;
      this.activePackage = {
        firstPaymentAmt: 299700 * newValues,
        cautionFee: 99900 * newValues,
        monthlyPaymentValue: 99900 * newValues
      };
      this.setActivePoints(this.activeTenure);
    }
  },
  data: function data() {
    return {
      activeTenure: 6,
      quantity: 1,
      tenureItems: [{
        point: 6,
        percent: 17.5
      }, {
        point: 12,
        percent: 33.5
      }, {
        point: 18,
        percent: 50
      }, {
        point: 24,
        percent: 66
      }, {
        point: 30,
        percent: 82.5
      }, {
        point: 36,
        percent: 100,
        active: true
      }],
      typeProduct: 0,
      productName: "",
      monthlyPaymentValue: "",
      activePackage: {
        firstPaymentAmt: 299700,
        cautionFee: 99900,
        monthlyPaymentValue: 99900
      },
      setActivePoints: function setActivePoints(point) {
        var _this2 = this;

        var activeStatus = true;
        this.unmarkPoints();
        this.tenureItems.map(function (item) {
          item.active = activeStatus;
          if (item.point == point) {
            _this2.activeTenure = point;
            item.marked = true;
            activeStatus = false;
          }
        });

        this.$store.state.onboardingCustomerState.tenure = this.activeTenure;
        this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);

        this.getCustomerProductDetails({
          customerid: this.getUserSession.id,
          productid: this.productPackage.id,
          tenure: this.activeTenure,
          firstpaymentamt: this.activePackage.firstPaymentAmt,
          recurrentmonthlyamt: parseFloat(this.monthlyPaymentValue),
          monthlyincomerange: "",
          employmentstatus: "",
          totalpayment: this.activeTenure * this.monthlyPaymentValue + 0.05 * this.typeProduct,
          cautionfee: parseFloat(this.monthlyPaymentValue),
          setupfee: "0",
          typeofbusiness: "Micheal, please remove this and upfrontPayment",
          upfrontpayment: 0
        });

        console.log("Please find meeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", this.getCustomerProductDetails);
      }
    };
  },

  methods: {
    unmarkPoints: function unmarkPoints() {
      this.tenureItems.map(function (item) {
        return delete item.marked;
      });
    },
    PMT: function PMT() {
      var rate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.015;
      var nperiod = arguments[1];
      var pv = arguments[2];
      var fv = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      if (rate == 0) return -(pv + fv) / nperiod;

      var pvif = Math.pow(1 + rate, nperiod);
      var pmt = rate / (pvif - 1) * -((pv - 0.05 * pv) * pvif + fv);

      if (type == 1) {
        pmt /= 1 + rate;
      }
      this.monthlyPaymentValue = Math.abs(pmt) === "Infinity" ? 0.0 : Math.abs(pmt).toFixed(2);
    },
    getProductPackage: function getProductPackage() {
      this.productPackage = this.$store.state.onboardingPackageType;
      this.typeProduct = this.productPackage.amountOS;
      this.productName = this.productPackage.name;
    }
  },
  mounted: function mounted() {
    console.log("rfsf", this.$store.state.onboardingCustomerState);
    this.updateTracker(true);
    this.updateStatus(1);
    this.PMT(0.015, this.activeTenure, this.typeProduct, 0, 0);
  },
  beforeMount: function beforeMount() {
    this.getProductPackage();
    this.setActivePoints(this.activeTenure);
  }
});

/***/ }),
/* 1199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_InputSelect_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "JobInformation",
  props: ["updateStatus", "updateTracker", "getCustomerEmploymentDetails"],
  components: {
    InputSelect: __WEBPACK_IMPORTED_MODULE_1__components_InputSelect_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    return {
      form: {
        employmentStatus: "",
        incomeRange: ""
      },
      formErrors: {},
      employmentOptions: [{ id: "Employed", name: "Employed" }, { id: "Self Employed", name: "Self Employed" }],
      incomeOptions: [{ id: "1", name: "Below NGN500,000" }, { id: "2", name: "Between NGN500,000 and NGN750,000" }, { id: "3", name: "Between NGN750,000 and NGN1,000,000" }, { id: "4", name: "Above NGN1,000,000" }]
    };
  },

  methods: {
    getCustProductDetails: function getCustProductDetails() {
      this.getCustomerEmploymentDetails({
        monthlyIncomeRange: this.form.incomeRange,
        employmentStatus: this.form.employmentStatus
      });
    },
    getProductPackage: function getProductPackage() {
      this.productPackage = this.$store.state.onboardingPackageType;
      this.typeProduct = this.productPackage.amountOS;
      this.productName = this.productPackage.name;
    }
  },
  mounted: function mounted() {
    // console.log("rfsf" , this.$store.state.onboardingCustomerState)
    this.updateTracker(true);
    this.updateStatus(2);
    this.getProductPackage();
    this.getCustProductDetails();
  }
});

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputSelect_vue__ = __webpack_require__(1201);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7b7232_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputSelect_vue__ = __webpack_require__(2979);
function injectStyle (ssrContext) {
  __webpack_require__(2978)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c7b7232"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7b7232_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InputSelect",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null,
    value: {},
    command: null
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
      this.command();
    }
  }
});

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/male-tablet.ef6690c.gif";

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LOAgreement",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  data: function data() {
    return {
      checkAgreement: false,
      agreementCount: 1
    };
  },

  methods: {
    toggleAgreementCheck: function toggleAgreementCheck() {
      this.checkAgreement = !this.checkAgreement;
      this.markAsCompleted(this.checkAgreement);
    },
    handleAgreementNavigation: function handleAgreementNavigation(direction) {
      if (this.agreementCount >= 0) {
        if (direction === "plus") this.agreementCount = this.agreementCount + 1;
        if (direction === "minus") this.agreementCount = this.agreementCount - 1;
      }
    }
  },
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
  }
});

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InputBank_vue__ = __webpack_require__(2986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_InputField_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_LoMiniTracker_vue__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_ArnergySelect_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__kitchen_Onboarding_ModalNotify_vue__ = __webpack_require__(2993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__kitchen_Onboarding_modal_vue__ = __webpack_require__(2996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__kitchen_Onboarding_modal_error_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__kitchen_AnergyBank_vue__ = __webpack_require__(3001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__store_state__ = __webpack_require__(813);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















__WEBPACK_IMPORTED_MODULE_21_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_sweetalert2__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BankStatement",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputBank: __WEBPACK_IMPORTED_MODULE_10__components_InputBank_vue__["a" /* default */],
    InputField: __WEBPACK_IMPORTED_MODULE_11__components_InputField_vue__["a" /* default */],
    LoMiniTracker: __WEBPACK_IMPORTED_MODULE_12__components_LoMiniTracker_vue__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_20_vue_sweetalert2__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_13__kitchen_ArnergySelect_vue__["a" /* default */],
    ModalNotify: __WEBPACK_IMPORTED_MODULE_15__kitchen_Onboarding_ModalNotify_vue__["a" /* default */],
    ModalError: __WEBPACK_IMPORTED_MODULE_18__kitchen_Onboarding_modal_error_vue__["a" /* default */],
    Modal: __WEBPACK_IMPORTED_MODULE_17__kitchen_Onboarding_modal_vue__["a" /* default */],
    ModalSucess: __WEBPACK_IMPORTED_MODULE_14__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */],
    "el-dialog": __WEBPACK_IMPORTED_MODULE_23_element_ui__["Dialog"]
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    var _ref;

    return _ref = {
      loader: false,
      loader1: false,
      showModal: false,
      showNotify: false,
      bankChoosen: "",
      stage: "",
      loaderConfirm: false,
      messageSuccess: "You have passed the bank statement stage!",
      showModalError: false,
      messageModal: ""
    }, __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "stage", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "confirmStatus", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "notifyMsg", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "modalSucess", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "getLinkData", ""), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "confirmBank", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "GTpdf", {
      color: "#0892d0"
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "form", {
      bank: "",
      accountNo: "",
      phoneNumber: "",
      date: "",
      // startDate: "",
      // endDate: "",
      dateRange: "",
      ticketId: "",
      password: ""
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "message", "Please enter the code you received on your mobile phone"), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "formErrors", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "amtData", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "showRetry", false), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "activeIndex", 0), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "summary", {}), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "banks", [{ id: null, name: null }]), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "pickerOptions", {
      shortcuts: [{
        text: "Last 6 months",
        onClick: function onClick(picker) {
          var end = new Date("2021-09-16");
          var start = new Date("2022-03-16");
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
          picker.$emit("pick", [start, end]);
        }
      }]
    }), __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_defineProperty___default()(_ref, "tabItems", [{
      title: "Make Request",
      percent: "0"
    }, {
      title: "Confirm Action",
      percent: "53"
    }, {
      title: "Summary",
      percent: "100"
    }]), _ref;
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["saveCustomerProductOptions"]), {
    gotoCreditCheck: function gotoCreditCheck() {
      this.updateStateFunc();
    },
    updateStateFunc: function updateStateFunc() {
      var _this = this;

      // console.log("presssed");
      var HTTP = this.$httpUtils.instance;
      HTTP.patch("/onboardingStates", {
        customerid: localStorage.customerId,
        stateid: 2,
        id: localStorage.customerState
      }).then(function (res) {
        _this.$store.commit("saveOnboanrdingState", 2);

        if (res.data) {
          _this.modalSucess = true;
          setTimeout(function () {
            _this.$emit("updateStatus");
          }, 2000);
        }
      });
    },
    getLink: function getLink(id) {
      // console.log("calling my function");
      // console.log(this.banks)
      var obj = this.banks.find(function (x) {
        return x.id == id;
      });
      // console.log(obj.bankLinkStatus)
      this.getLinkData = obj.bankLinkStatus;
      this.form.phoneNumber = localStorage.phoneNumber;
    },
    bankRequestPassed: function bankRequestPassed() {
      var pass = this.summary.statementOk ? true : false;
      this.markAsCompleted(pass);
      return pass;
    },
    gotoSection: function gotoSection(value) {
      this.activeIndex = value;
    },
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref2 = _step.value;

          var _ref3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref2, 2);

          var field = _ref3[0];
          var value = _ref3[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "bank":
              if (value === "null" || value === "") {
                formErrors[field] = "Bank cannot be empty.";
              }
              break;
            case "accountNo":
              if (value === "null" || value === "") {
                formErrors[field] = "Account Number cannot be empty.";
              } else if (value.length < 10 || value.length > 11) {
                formErrors[field] = "Account Number should be 10 characters";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    validateInputs2: function validateInputs2() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.form)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref4 = _step2.value;

          var _ref5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref4, 2);

          var field = _ref5[0];
          var value = _ref5[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "password":
              if (value === "null" || value === "") {
                formErrors[field] = "Password cannot be empty.";
              }
              break;
            case "ticketId":
              if (value === "null" || value === "") {
                formErrors[field] = "Ticket ID cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return formErrors;
    },
    retryRequest: function retryRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  ticketid: localStorage.ticketId
                };

                // console.log(data);

                _this2.loader1 = true;
                _this2.$emit("showLoading", true);
                HTTP = _this2.$httpUtils.instance;
                _context.prev = 4;
                _context.next = 7;
                return HTTP.post("/RequestStatementData/getFeedback", data);

              case 7:
                res = _context.sent;


                // console.log(res.data);

                _this2.$emit("showLoading", false);
                _this2.loader1 = false;
                // this.gotoSection(this.activeIndex + 1);
                // return;

                if (res.data.data.result.status == "Invalid") {
                  _this2.showModalError = true;
                  _this2.showErrorMsg({ message: res.data.data.result.feedback });
                  //  + '. invalid - Please wait for 50 - 10 minutes to receive the code'

                  _this2.showRetry = false;
                  _this2.gotoSection(0);
                } else if (res.data.data.result.status == "Pending") {
                  _this2.message = res.data.data.result.feedback;
                  //  + '. pending - Please wait for 5 - 10 minutes to receive the code'
                } else {
                  _this2.message = res.data.data.result.feedback;
                  _this2.gotoSection(_this2.activeIndex + 1);
                }

                // this.showNotify = true;
                // this.notifyMsg = res.data.message;
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);

                console.log(_context.t0);
                _this2.$emit("showLoading", false);
                // this.showModalError = true;
                _this2.showErrorMsg({
                  messsage: "Unable to complete action, please try again"
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 13]]);
      }))();
    },
    getCurrentStyle: function getCurrentStyle(current, today) {
      var style = {};
      if (current.date() === 1) {
        style.border = "1px solid #1890ff";
        style.background = "#fff";
        style.borderRadius = "50%";
      }
      return style;
    },
    okayConfirm: function okayConfirm() {
      this.confirmStatus = false;
      this.showRetry = false;
      this.activeIndex = 0;
    },
    makeRequest: function makeRequest() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, obj, data, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.gotoSection(_this3.activeIndex + 1);
                return _context2.abrupt("return");

              case 10:

                // console.log(data)
                _this3.loader = true;
                _this3.$emit("showLoading", true);
                _context2.prev = 12;
                _context2.next = 15;
                return HTTP.post("/RequestStatementData/RequestStatement", data);

              case 15:
                res = _context2.sent;

                localStorage.ticketId = res.data.ticketid;

                _this3.$emit("showLoading", false);
                _this3.loader = false;

                if (!(res.data.data.result.status == "Pending")) {
                  _context2.next = 23;
                  break;
                }

                _this3.message = res.data.data.result.feedback;
                //  + '. make request pending - Please wait for 50 - 10 minutes to receive the code'
                _this3.showRetry = true;
                return _context2.abrupt("return");

              case 23:
                if (!(res.data.data.status == "00")) {
                  _context2.next = 27;
                  break;
                }

                _this3.message = res.data.data.result.feedback;
                //  + '. Please wait for 5 - 100 minutes to receive the code'

                _this3.gotoSection(_this3.activeIndex + 1);
                return _context2.abrupt("return");

              case 27:
                _context2.next = 33;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2["catch"](12);

                console.log(_context2.t0);
                _this3.$emit("showLoading", false);

                // this.showNotify =  true;
                // this.notifyMsg = res.data.message

              case 33:
                _context2.next = 36;
                break;

              case 35:
                if (_this3.form.bank) {
                  //console.log("it would call");
                  _this3.loader = true;
                  HTTP.post("/RequestStatementData/RequestStatement", data).then(function (res) {
                    if (!res.data) {
                      _this3.loader = false;
                      _this3.confirmBank = true;
                      _this3.gotoSection(_this3.activeIndex + 1);
                    }
                  });
                }

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[12, 29]]);
      }))();
    },
    confirmBankFunc: function confirmBankFunc(e) {
      this.confirmBank = false;
      this.gotoSection(this.activeIndex + 1);
    },
    confirmRequest: function confirmRequest() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var productType, HTTP, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.gotoSection(_this4.activeIndex + 1);
                setTimeout(function () {
                  _this4.confirmStatus = true;
                }, 400);
                return _context3.abrupt("return");

              case 5:
                productType = _context3.sent;

                //console.log("product type", productType);
                _this4.saveCustomerProductOptions(productType);

                HTTP = _this4.$httpUtils.instance;

                _this4.formErrors = _this4.validateInputs2();

                if (!(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this4.formErrors).length > 0)) {
                  _context3.next = 11;
                  break;
                }

                return _context3.abrupt("return");

              case 11:
                data = {
                  ticketNo: _this4.form.ticketId,
                  password: _this4.form.password,
                  customerId: _this4.getUserSession.id,
                  productType: productType.id,
                  tenure: productType.tenure,
                  id: 0
                };


                _this4.$emit("showLoading", true);
                _this4.loaderConfirm = true;
                try {
                  HTTP.post("/confirmStatementRequests/confirmStatement", data).then(function (res) {
                    console.log("res.dataaa", res.data);
                    _this4.loaderConfirm = false;
                    _this4.loader = false;

                    if (res.data == null) {
                      // console.log("204 no response");
                      _this4.loaderConfirm = false;
                      _this4.showModal = true;
                    } else if (res.status === 200 && res.data.statementOk == true) {
                      _this4.loaderConfirm = false;
                      _this4.showModal = false;
                      _this4.summary = res.data;
                      _this4.gotoSection(_this4.activeIndex + 1);
                    } else if (res.data.status == 99) {
                      _this4.loaderConfirm = false, _this4.showModal = false;
                      _this4.showErrorMsg({ message: res.data.message });
                    } else if (res.status == 200 && res.data.statementOk == false) {
                      // this.confirmStatus =  true;
                      _this4.summary = res.data;
                      _this4.loader = false;
                      _this4.gotoSection(_this4.activeIndex + 1);
                      setTimeout(function () {
                        _this4.confirmStatus = true;
                      }, 400);
                    } else {
                      _this4.showModal = false;
                      _this4.loaderConfirm = false;
                    }
                    // console.log('response error')
                  });
                } catch (error) {
                  _this4.loader = false;
                  _this4.$emit("showLoading", false);
                  _this4.loaderConfirm = false;

                  _this4.showErrorMsg({
                    message: "Unable to complete action, please try again."
                  });
                  _this4.activeIndex = 0;
                }

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    getProductType: function getProductType(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var HTTP;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                HTTP = _this5.$httpUtils.instance;
                _context4.next = 3;
                return HTTP.get("/CustomerProductOptions?filter={\"where\":{\"customerId\":" + id + "},\"order\":\"id DESC\",\"limit\":\"1\"}").then(function (res) {
                  return _this5.amtData = res.data[0];
                }).catch(function (err) {
                  return console.log(err);
                });

              case 3:
                return _context4.abrupt("return", _this5.amtData);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    confirmRequestModal: function confirmRequestModal() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var HTTP, productType;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                HTTP = _this6.$httpUtils.instance;

                _this6.loader = true;
                _context5.next = 4;
                return _this6.getProductType(_this6.getUserSession.id);

              case 4:
                productType = _context5.sent;

                _this6.saveCustomerProductOptions(productType);

                setTimeout(function () {
                  _this6.formErrors = _this6.validateInputs2();
                  if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(_this6.formErrors).length > 0) return;
                  var data = {
                    ticketNo: _this6.form.ticketId,
                    password: _this6.form.password,
                    customerId: _this6.getUserSession.id,
                    productType: productType.id,
                    tenure: productType.tenure,
                    id: 0
                  };
                  // console.log(data);
                  _this6.$emit("showLoading", true);
                  try {
                    HTTP.post("/confirmStatementRequests/confirmStatement", data).then(function (res) {
                      // console.log(res.data);
                      _this6.loader = false;
                      if (res.data.statementOk) {
                        _this6.loader = false;
                        _this6.showModal = false;
                        _this6.summary = res.data;
                        _this6.gotoSection(_this6.activeIndex + 1);
                      } else if (res.status == 200 && res.data.statementOk == false) {
                        // this.confirmStatus =  true;
                        _this6.summary = res.data;
                        _this6.loader = false;
                        _this6.gotoSection(_this6.activeIndex + 1);
                        setTimeout(function () {
                          _this6.confirmStatus = true;
                        }, 400);
                        _this6.showModal = false;
                      } else {
                        _this6.showModalError = true;
                        _this6.loader = false;
                        _this6.showModal = false;
                        _this6.showErrorMsg({
                          message: "Unable to complete action, please try again."
                        });
                      }
                    });
                  } catch (error) {
                    _this6.loader = false;

                    _this6.$emit("showLoading", false);
                    _this6.showErrorMsg({
                      message: "Unable to complete action, please try again."
                    });
                    _this6.activeIndex = 0;
                  }
                }, 3000);

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    },
    fetchBanks: function fetchBanks() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                HTTP = _this7.$httpUtils.instance;
                _context6.next = 3;
                return HTTP.get("/customerBanks");

              case 3:
                res = _context6.sent;
                return _context6.abrupt("return", res.data.map(function (item) {
                  return {
                    id: item.bankId,
                    name: item.bankName,
                    bankLinkStatus: item.bankId == 13 || item.bankId == 17 ? "N" : "Y"
                    // bankLinkStatus: item.bankLinkStatus,
                  };
                }).sort(function (a, b) {
                  return a.name > b.name ? 1 : -1;
                }));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    }
  }),
  mounted: function mounted() {
    var _this8 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.fetchBanks();

            case 2:
              _this8.banks = _context7.sent;

              _this8.updateTracker(true);
              _this8.updateStatus(4);

            case 5:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this8);
    }))();
  }
});

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InputBank",
  props: {
    model: null,
    placeholder: null,
    disabled: false,
    type: "text",
    items: null,
    error: null
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
      this.$emit("getLinked", event.target.value);
    }
  }
});

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InputField",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    autocomplete: '',
    type: null,
    error: null
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoMiniTracker_vue__ = __webpack_require__(1208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd93261_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoMiniTracker_vue__ = __webpack_require__(2992);
function injectStyle (ssrContext) {
  __webpack_require__(2991)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bd93261"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoMiniTracker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd93261_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoMiniTracker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LoMiniTracker",
    props: ["tabItems", "activeIndex"],
    computed: {
        getProgressPercent: function getProgressPercent() {
            var percent = void 0;
            console.log("activeee", this.activeIndex);
            if (this.activeIndex == 0) {
                percent = 0;
            } else if (this.activeIndex == 1) {
                percent = 53;
            } else {
                percent = 100;
            }
            console.log("percent", percent);
            return percent;
        }
    },
    data: function data() {
        return {
            setActivePoints: function setActivePoints() {
                var _this = this;

                var activeStatus = true;
                var itemsArray = this.tabItems;
                itemsArray.map(function (item) {
                    item.active = activeStatus;
                    if (item.path == _this.$route.path) activeStatus = false;
                });
                this.tabItems = itemsArray;
            }
        };
    },
    beforeMount: function beforeMount() {
        this.setActivePoints();
    }
});

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Modal',
  props: {
    productDetails: null,
    titleProduct: null,
    notifyMsg: null,
    amt: null,
    desc: null,
    tableDatas: null
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: '',
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: 'Oil & Gas', name: 'Oil & Gas' }, { id: 'Farmer', name: 'Farmer' }, { id: 'Driver', name: 'Driver' }, { id: 'Painter', name: 'Painter' }],
      employmentStatus: [{ id: 'Employed', name: 'Employed' }, { id: 'Self Employed', name: 'Self Employed' }],
      incomes: [{ id: '< N500,000', name: ' < N500,000' }, { id: '>N500,000 and < N750,000', name: '>N500,000 and < N750,000' }, {
        id: '> N750,000 and < N1,000,000',
        name: '> N750,000 and < N1,000,000'
      }, { id: '> N1,000,000', name: '> N1,000,000' }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: '',
        income: '',
        employment: '',
        business: ''
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: 'success',
      title: 'Success',
      message: 'Success Msg!'
    },
    showInfoMsg: {
      type: 'info',
      title: 'Information',
      message: 'Info. Msg!'
    },
    showWarnMsg: {
      type: 'warning',
      title: 'Warning',
      message: 'Warning Msg!'
    },
    showErrorMsg: {
      type: 'error',
      title: 'Error',
      message: 'Error Msg!'
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    fetchAll: function fetchAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.productDetails);
                // parse for "arnergy-select" use
                _this.products = _this.productDetails;

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAmtofTenure: function getAmtofTenure(id) {
      console.log('pussy is sweet');
      var obj = this.tenures.find(function (x) {
        return x.id == id;
      });
      this.amountToPay = obj;
    },
    finalReq: function finalReq() {
      var _this2 = this;

      localStorage.amtPay = this.amountToPay.caution;
      localStorage.amtRepay = this.amountToPay.monthly;

      console.log('set the new amt is ' + this.amountPay.caution);

      var data = {
        customerId: localStorage.customerId,
        productid: this.amountToPay.productID,
        tenure: this.amountToPay.name,
        firstPaymentAmt: this.amountToPay.monthly,
        recurrentMonthlyAmt: this.amountToPay.caution,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: this.form.income,
        typeOfBusiness: this.form.business
      };
      this.loader = true;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post('https://solarbase-test-env-dev.us-west-2.elasticbeanstalk.com/api/v1/CustomerProductOptions/saveCustomerOption', data).then(function (res) {
        if (res.data.status) {
          _this2.loader = false;
          _this2.message = res.data.message;
          _this2.errorMessage = false;
          _this2.sucessMsg = true;
          _this2.ctn = true;
        } else {
          _this2.message = res.data.message;
          _this2.errorMessage = true;
          _this2.loader = false;
          _this2.sucessMsg = false;
          setTimeout(function () {
            window.location.href = '/onboarding';
          }, 2000);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(_this3.tableDatas);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: ['modalstate'],
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */]

  },
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ModalError",
  props: ['modalstateError'],
  components: {},
  computed: {},
  data: function data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },


  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  mounted: function mounted() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
// import { mapGetters, mapActions } from "vuex";

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ArnergyInput",
  props: {
    model: null,
    placeholder: null,
    label: null,
    disabled: false,
    type: "text",
    items: null,
    error: null
  },
  computed: {},
  data: function data() {
    return {};
  },

  methods: {
    handleInput: function handleInput(event) {
      this.$emit("input", event.target.value);
      this.$emit("getLinked", event.target.value);
    }
  }
});

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_InputField_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_modal_error_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_sweetalert2_dist_sweetalert2_min_css__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */







__WEBPACK_IMPORTED_MODULE_11_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CreditCheck",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField: __WEBPACK_IMPORTED_MODULE_7__components_InputField_vue__["a" /* default */],
    ModalError: __WEBPACK_IMPORTED_MODULE_9__kitchen_Onboarding_modal_error_vue__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_10_vue_sweetalert2__["a" /* default */],
    ModalSucess: __WEBPACK_IMPORTED_MODULE_8__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      loader: false,
      message: "",
      showModalError: false,
      messageSuccess: "You have passed the credit check stage",
      modalSucess: false,
      stage: "",
      messageModal: "",
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoCreditCheck: function gotoCreditCheck() {
      this.$emit("updateStatus");
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      // this.$swal.fire({title: 'Success', imageWidth: '40px', text: 'You have passed the Credit Check stage', icon:'success', width: '550px'});
    },
    bankRequestPassed: function bankRequestPassed() {
      // return true;
      return this.summary.statementpassed ? true : false;
    },
    gotoNextState: function gotoNextState() {
      this.$emit("updateStatus");
    },
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "bvn":
              if (value === "null" || value === "") {
                formErrors[field] = "Bank cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    makeRequest: function makeRequest() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.formErrors = _this.validateInputs();

                if (!(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this.formErrors).length > 0)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                data = {
                  bvn: _this.form.bvn,
                  customerid: localStorage.customerId
                };


                _this.loader = true;
                _this.$emit("showLoading", true);
                HTTP = _this.$httpUtils.FASTHTTP;
                _context.prev = 7;
                _context.next = 10;
                return HTTP.post("/creditcheck/check-credit-rating", data);

              case 10:
                res = _context.sent;

                _this.$emit("showLoading", false);
                _this.loader = false;

                if (!(res.data.isPerforming === true)) {
                  _context.next = 21;
                  break;
                }

                _this.showSuccessMsg({ message: "Credit Check Passed!" });
                _this.markAsCompleted(true);
                setTimeout(function () {
                  _this.gotoNextState();
                }, 2000);
                _this.updateStateFunc();
                return _context.abrupt("return");

              case 21:
                _this.showErrorMsg({ message: res.data.message });

              case 22:
                _context.next = 30;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](7);

                console.log(_context.t0);
                _this.loader = false;
                _this.$emit("showLoading", false);
                _this.showErrorMsg({
                  message: "Unable to complete action, please try again"
                });

              case 30:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[7, 24]]);
      }))();
    },
    updateStateFunc: function updateStateFunc() {
      var _this2 = this;

      var payloadData = {
        stateid: 3
      };
      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        _this2.$store.commit("saveOnboanrdingState", 3);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    }
  },
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
  }
});

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_InputField_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_InputSelect_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_modal_error_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue2_datepicker__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_datepicker_index_css__ = __webpack_require__(3010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_sweetalert2_dist_sweetalert2_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js_cookie__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_base64_file_upload__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_base64_file_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_base64_file_upload__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "KYC",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField: __WEBPACK_IMPORTED_MODULE_8__components_InputField_vue__["a" /* default */],
    InputSelect: __WEBPACK_IMPORTED_MODULE_9__components_InputSelect_vue__["a" /* default */],

    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_13_vue_sweetalert2__["a" /* default */],
    DatePicker: __WEBPACK_IMPORTED_MODULE_14_vue2_datepicker__["a" /* default */],
    VueBase64FileUpload: __WEBPACK_IMPORTED_MODULE_19_vue_base64_file_upload___default.a,
    ModalError: __WEBPACK_IMPORTED_MODULE_11__kitchen_Onboarding_modal_error_vue__["a" /* default */],
    ModalSucess: __WEBPACK_IMPORTED_MODULE_12__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapGetters */])(["getUserSession"])),
  data: function data() {
    return {
      time1: null,
      value1: new Date(),
      msg: "",

      customImageMaxSize: 3,
      loader: false,

      form: {
        moi_Exp_Date: "",
        moi: "",
        utility: ""
      },
      image: "",
      image2: "",
      showModalError: false,
      modalSucess: false,
      stage: "",
      moi_file: "",
      utility_file: "",
      formErrors: {},
      message: "You passed the KYC documents stage",

      // activeIndex: 0,
      summary: {},
      mois: [{ id: "Driving License", name: "Driving License" }, { id: "International Passport", name: "International Passport" }],
      utilities: [{ id: "Waste Bill", name: "Waste Bill" }, { id: "Nepa Bill", name: "Electricity Bill" }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    handleFileUpload: function handleFileUpload(e) {
      var selected = e.target.files[0];
      this.image = selected;
      console.log("image 1", this.image);
    },
    disabledBeforeTodayAndAfterAWeek: function disabledBeforeTodayAndAfterAWeek(date) {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    onFile: function onFile(file) {
      console.log(file); // file object
    },
    onLoad: function onLoad(dataUri) {
      console.log(dataUri); // data-uri string
    },
    onSizeExceeded: function onSizeExceeded(size) {
      alert("Image " + size + "Mb size exceeds limits of " + this.customImageMaxSize + "Mb!");
    },
    handleFileUpload2: function handleFileUpload2(e) {
      var selected = e.target.files[0];
      this.image2 = selected;
      console.log("image 2", this.image2);
    },
    createBase64: function createBase64(file) {
      var reader = new FileReader();
      reader.onload = function (e) {
        console.log(e.target.result);
      };
      reader.readAsBinaryString(file);
      console.log(reader);
    },
    createBase642: function createBase642(file) {
      var _this = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        _this.image2 = e.target.result;
        console.log(e.target.result);
      };
      reader.readAsBinaryString(file);
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Success",
        imageWidth: "40px",
        text: "You have passed the Kyc Uploads Stage",
        icon: "success",
        width: "550px"
      });
    },
    showAlertErr: function showAlertErr() {
      // Use sweetalert2
      this.$swal({
        title: "error",
        imageWidth: "40px",
        text: "All fields are required",
        icon: "error",
        width: "550px"
      });
    },
    gotoNextState: function gotoNextState() {
      this.$emit("updateStatus");
    },
    validateInputs: function validateInputs() {
      var formErrors = [];

      //
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.form)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "bvn":
              if (value === "null" || value === "") {
                formErrors[field] = "Bank cannot be empty.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },
    makeRequest: function makeRequest() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, formData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                HTTP = _this2.$httpUtils.FASTHTTP;
                formData = new FormData();


                formData.append("utility_file", _this2.image2);
                formData.append("moi", _this2.form.moi);
                formData.append("utility_doc", _this2.form.utility);
                // formData.append("customer", localStorage.customerId);
                formData.append("moi_exp_date", _this2.value1);
                formData.append("moi_file", _this2.image);

                // const data = {
                //   moi: this.form.moi,
                //   utility_file: this.image2,
                //   moi_file: this.image,
                //   utility_doc: this.form.utility,
                //   moi_exp_date: this.value1
                // };

                if (_this2.form.moi && _this2.value1 && _this2.form.utility && _this2.image && _this2.image2) {
                  // console.log(data);

                  _this2.loader = true;
                  HTTP.post("/kycfiles/filesapi-file", formData, {
                    header: {
                      "Content-Type": "multipart/form-data"
                    }
                  }).then(function (res) {
                    if (res.data) {
                      _this2.updateStateFunc();
                      _this2.loader = false;
                      _this2.value1 = "";
                      _this2.showSuccessMsg({ message: "Details Succesfully Uploaded!" });
                      _this2.markAsCompleted(true);
                      _this2.showModalError = false;
                      setTimeout(function () {
                        _this2.gotoNextState();
                      }, 2000);
                    }
                  }).catch(function (err) {
                    _this2.loader = false;
                  });
                } else {
                  _this2.showModalError = true;
                  _this2.message = "All fields are required";
                  setTimeout(function () {
                    _this2.showModalError = false;
                  }, 2000);
                }

                //

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    updateStateFunc: function updateStateFunc() {
      var _this3 = this;

      // console.log("presssed");
      var payloadData = {
        "stateid": 4
      };
      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        _this3.$store.commit("saveOnboanrdingState", 4);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    }
  },
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(4);
  }
});

/***/ }),
/* 1215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_InputField_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_LoMiniTracker_vue__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__kitchen_Onboarding_ModalSuccess_vue__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__kitchen_Onboarding_modal_verify_vue__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_sweetalert2__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_js_cookie__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_ravepayment__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_ravepayment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_ravepayment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__kitchen_Onboarding_Consent_vue__ = __webpack_require__(3015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__kitchen_Onboarding_TableModal_vue__ = __webpack_require__(3018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_min_css__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_sweetalert2_dist_sweetalert2_min_css__);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_20_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_sweetalert2__["a" /* default */]);
// Vue.forceUpdate();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PayDeposit",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField: __WEBPACK_IMPORTED_MODULE_10__components_InputField_vue__["a" /* default */],
    VueSweetalert2: __WEBPACK_IMPORTED_MODULE_15_vue_sweetalert2__["a" /* default */],
    TableModal: __WEBPACK_IMPORTED_MODULE_19__kitchen_Onboarding_TableModal_vue__["a" /* default */],
    ModalVerify: __WEBPACK_IMPORTED_MODULE_13__kitchen_Onboarding_modal_verify_vue__["a" /* default */],
    ModalSucess: __WEBPACK_IMPORTED_MODULE_12__kitchen_Onboarding_ModalSuccess_vue__["a" /* default */],
    Consent: __WEBPACK_IMPORTED_MODULE_18__kitchen_Onboarding_Consent_vue__["a" /* default */],
    Rave: __WEBPACK_IMPORTED_MODULE_17_vue_ravepayment___default.a,
    LoMiniTracker: __WEBPACK_IMPORTED_MODULE_11__components_LoMiniTracker_vue__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["c" /* mapGetters */])(["getUserAmount", "getCustomerProductOptions", "getUserSession"]), {
    genRandomNumber: function genRandomNumber() {
      var text = "";
      var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  }),
  data: function data() {
    return {
      showModalValidated: false,
      newCardFormVisible: true,
      loader: false,
      showWarnMsg: "",
      info: {},
      card: {
        number: "",
        expiry: "",
        cvv: "",
        pin: ""
      },
      debitCards: [],
      months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      processCard: false,
      defaultCardSet: false,
      defaultCardID: "",
      formErrors: {},
      // fieldTypes: {
      //   password: 'text'
      // },
      loader1: false,
      custProdOptions: {},
      firstpaymentamt: "",
      meta: [{
        metaname: "school",
        metavalue: "high school"
      }],
      tableDatas: null,
      paymentSucess: false,
      exactName: localStorage.exactName,
      showChoice: false,
      showTable: false,
      messageSuccess: "Your payment was successful!",
      modalSucess: false,
      activeIndex: 0,
      exact: this.getUserAmount,
      exactRepay: __WEBPACK_IMPORTED_MODULE_16_js_cookie___default.a.get("amtRepay") ? __WEBPACK_IMPORTED_MODULE_16_js_cookie___default.a.get("amtRepay") : "",
      exactTenure: localStorage.tenure,
      active: "Arnergy 5000",
      raveKey: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
      redirectUrl: "/onboarding",
      formData: {
        paymentDay: "",
        startingDate: "01/02/2020",
        amountPay: ""
      },
      packages: [{ id: 1, name: "Arnergy 5000", amount: 500 }, { id: 2, name: "Arnergy 5000X", amount: 2500 }, { id: 3, name: "Arnergy 10000", amount: 5000 }],
      counter: 0,
      tabItems: [{
        title: "Pay Deposit",
        percent: "0"
      }, {
        title: "Set Re-occuring Billing",
        percent: "100"
      }]
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["b" /* mapActions */])(["setUserSession"]), {
    toggleNewCardForm: function toggleNewCardForm() {
      this.newCardFormVisible = !this.newCardFormVisible;
    },
    addDebitCard: function addDebitCard() {
      this.formErrors = this.validateInputs();
      console.log(this.formErrors);
      console.log("card", this.card);
      if (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(this.formErrors).length > 0) return;

      var hello = this.card;
      console.log(hello);
    },
    endCardProcessing: function endCardProcessing() {
      this.processCard = false;
      this.defaultCardSet = false;
      this.modalSucess = false;
    },
    updateExpiryInput: function updateExpiryInput(expiry) {
      if (expiry.length === 2) this.card.expiry = expiry + " / ";else if (expiry.length > 2) {
        var x = expiry.replace(" / ", "");
        if (x.length === 3) this.card.expiry = "" + x[0] + x[1] + " / " + x[2];
        this.card.expiry = "" + x[0] + x[1] + " / " + x[2] + x[3];
        console.log(this.card.expiry);
      }
    },
    gotoSection: function gotoSection(value) {
      this.activeIndex = value;
    },
    getAmount: function getAmount() {
      var _this = this;

      var active = this.packages.find(function (item) {
        return item.name == _this.active;
      });
      return active.amount;
    },
    close: function close() {
      console.log("Payment closed");
    },
    triggerPayment: function triggerPayment() {
      document.getElementById("paymentbtn").click();
    },
    validateInputs: function validateInputs() {
      var formErrors = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_entries___default()(this.card)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref = _step.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var field = _ref2[0];
          var value = _ref2[1];

          value = value + "";
          if (value !== "null" && value !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_is_integer___default()(value)) {
            value = value.trim();
          }

          switch (field) {
            case "number":
              console.log(Number(value));
              console.log(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(Number(value)));
              if (value === "null" || value === "") {
                formErrors[field] = "Number cannot be empty.";
              } else if (value.length < 16 || value.length > 18) {
                formErrors[field] = "Card number length is incorrect";
              } else if (isNaN(value)) {
                formErrors[field] = "Please enter a valid card number.";
              }
              break;
            case "expiry":
              console.log(value.replace(" / ", ""));
              if (value === "null" || value === "") {
                formErrors[field] = "Expiry cannot be empty.";
              } else if (value.replace(" / ", "").length < 4 || value.replace(" / ", "").length > 4) {
                formErrors[field] = "Invalid date entered";
              } else if (isNaN(value.replace(" / ", ""))) {
                formErrors[field] = "Please enter a valid expiry date.";
              }
              break;
            case "cvv":
              if (value === "null" || value === "") {
                formErrors[field] = "CVV cannot be empty.";
              } else if (value.length < 3 || value.length > 3) {
                formErrors[field] = "CVV should be 3 characters";
              } else if (isNaN(value.replace(" / ", ""))) {
                formErrors[field] = "Please enter a valid CVV.";
              }
              break;
            default:
              break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return formErrors;
    },

    callback: function callback(response) {
      var trRef = response.data;
      trRef.data = trRef.tx == undefined ? trRef.data : trRef.tx;
      this.close();
      if (trRef.data.status === "successful") {
        this.showSuccessMsg = { message: "Transaction Successful!" };
      } else {
        this.showErrorMsg({ message: "Transaction fails" });
      }
    },
    setCurrentAfterPayment: function setCurrentAfterPayment() {
      var _this2 = this;

      this.$emit("showLoading", true);
      var urlSearchParams = new URLSearchParams(window.location.search);
      var params = Object.fromEntries(urlSearchParams.entries());
      var txref = params["tx_ref"];

      if (!txref) {
        this.$emit("showLoading", false);
        return;
      }
      var data = {
        txref: txref
      };

      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.post("/payment/verify-payment", data).then(function (res) {
        console.log("testing", res.data);
        _this2.activeIndex = 1;
        if (res.data) {
          window.history.replaceState(null, "Arnergy :: IOT", "/onboarding/lo");
          localStorage.recurID = res.data.id;

          _this2.modalSucess = true;
          _this2.updateStateFunc();
          _this2.fetchDebitCards(_this2.getUserSession.id);
          _this2.activeIndex = 1;
          _this2.$emit("showLoading", false);
        } else {
          console.log("Nothing to show here");
        }
      }).catch(function (error) {
        console.log("testing error", error);
        console.log(error);
        _this2.$emit("showLoading", false);
      });
    },
    updateStateFunc: function updateStateFunc() {
      var _this3 = this;

      console.log("presssed");
      var payloadData = {
        stateid: v
      };
      var HTTP = this.$httpUtils.FASTHTTP;
      HTTP.patch("/onboardingstate/nextstate", payloadData).then(function (res) {
        _this3.$store.commit("saveOnboanrdingState", v);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    },
    showAlert: function showAlert() {
      // Use sweetalert2
      this.$swal.fire({
        title: "Success",
        imageWidth: "40px",
        text: "Your payment was successful",
        icon: "success",
        width: "550px"
      });
    },
    verify: function verify() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var data, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  txref: localStorage.txf_ref
                };
                HTTP = _this4.$httpUtils.FASTHTTP;
                _context.prev = 2;
                _context.next = 5;
                return HTTP.post("/payment/verify-payment", data);

              case 5:
                res = _context.sent;

                if (!(res.data.customerid && res.status == 200)) {
                  _context.next = 12;
                  break;
                }

                localStorage.recurID = res.data.id;
                _this4.activeIndex == 1;
                _this4.modalSucess = true;
                console.log("activeee", _this4.activeIndex);
                return _context.abrupt("return");

              case 12:

                if (res.data == null || res.status == 204) {
                  _this4.showModalValidated = true;
                }
                _context.next = 21;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](2);

                _this4.showModalValidated = true;
                setTimeout(function () {
                  window.location.href = "/onboarding/lo";
                }, 3900);

                console.log({ error: _context.t0.response.data.detail });
                _this4.showErrorMsg({
                  message: _context.t0.response.data.detail
                });

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[2, 15]]);
      }))();
    },
    closeTable: function closeTable() {
      window.location.href = "/onboarding/lo";
    },
    showChoiceFunc: function showChoiceFunc() {
      this.showChoice = true;
    },
    flutterwavePaygate: function flutterwavePaygate(amount) {
      if (amount === "10") this.processCard = true;
      var finalAmount = this.processCard ? amount : this.firstpaymentamt ? this.firstpaymentamt : this.getCustomerProductOptions.firstpaymentamt;

      FlutterwaveCheckout({
        public_key: "FLWPUBK-fc3e5bbcb014dba6aea1724614daa1d5-X",
        tx_ref: this.genRandomNumber,
        // amount: finalAmount,
        amount: "10",
        currency: "NGN",
        country: "NG",
        paymentType: "account",

        // specified redirect URL
        redirect_url: "/onboarding/lo/deposit",
        meta: {
          consumer_id: 23,
          consumer_mac: "92a3-912ba-1192a"
        },
        customer: {
          email: this.getUserSession.email,
          phone_number: this.getUserSession.phonenumber,
          name: this.getUserSession.firstname + " " + this.getUserSession.lastname
        },
        callback: function callback(data) {
          console.log("flutterwaveCheckout", data);
        },
        onclose: function onclose(data) {
          // close modal
          console.log("on close", data);
        },
        customizations: {
          title: "Arnergy Solar",
          description: "Payment",
          logo: "https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg"
        }
      });
    },
    consent: function consent(answer) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var onboardingData, HTTP, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.debitCards.map(function (card) {
                  if (card.isDefaultCard) _this5.defaultCardID = card.id;
                });

                onboardingData = {
                  customerid: _this5.getUserSession.id,
                  productid: _this5.custProdOptions.productid,
                  customerconcent: answer,
                  id: _this5.defaultCardID
                };

                if (!(answer === "Y")) {
                  _context2.next = 26;
                  break;
                }

                _this5.loader = true;

                HTTP = _this5.$httpUtils.FASTHTTP;

                _this5.showChoice = false;

                _context2.prev = 6;

                _this5.$emit("showLoading", true);
                _context2.next = 10;
                return HTTP.post("/payment/update-recurring", onboardingData);

              case 10:
                res = _context2.sent;

                if (!res.data) {
                  _context2.next = 16;
                  break;
                }

                _this5.loader = false;

                _this5.$emit("showLoading", false);
                _this5.$emit("updateStatus");
                return _context2.abrupt("return");

              case 16:
                _context2.next = 24;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](6);

                _this5.$emit("showLoading", false);
                _this5.loader = false;
                console.log({ error: _context2.t0.response.data.error.message });
                _this5.showErrorMsg({
                  message: _context2.t0.response.data.detail
                });

              case 24:
                _context2.next = 27;
                break;

              case 26:
                _this5.showChoice = false;

              case 27:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[6, 18]]);
      }))();
    },
    fetchAmt: function fetchAmt(id) {
      var _this6 = this;

      var HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get("/productoption/productoption").then(function (res) {
        console.log("This is the dataaa", res.data);
        _this6.custProdOptions = res.data;
        _this6.firstpaymentamt = res.data.firstpaymentamt; //change this...
      }).catch(function (err) {
        return console.log(err);
      });

      this.$forceUpdate();
    },
    fetchDebitCards: function fetchDebitCards(id) {
      var _this7 = this;

      this.counter = this.counter + 1;
      console.log("counter: ", this.counter);
      var HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get("/payment/get-cards").then(function (res) {
        console.log("fetchDebit", res.data);
        _this7.debitCards = res.data;
        if (_this7.debitCards.length > 0) {
          _this7.activeIndex = 1;
          _this7.markAsCompleted(true);
        }
        if (_this7.debitCards.length === 1 && !_this7.debitCards[0].isDefaultCard) {
          var card = _this7.debitCards[0];
          // this.setDefaultCard(card.id, card.customerid);
          // this.fetchDebitCards(this.getUserSession.id);
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setDefaultCard: function setDefaultCard(cardid, custid) {
      var _this8 = this;

      var HTTP = this.$httpUtils.FASTHTTP;
      var data = { id: cardid, customerid: custid };
      console.log("setDefa", data);

      HTTP.post("/payment/set-default-cards", data).then(function (res) {
        _this8.processCard = true;
        _this8.defaultCardSet = true;
        _this8.showSuccessMsg({ message: "Default card set successfully!" });
        _this8.fetchDebitCards(_this8.getUserSession.id);
        _this8.defaultCardID = cardid;
      }).catch(function (error) {
        _this8.loader = false;
        console.log({ error: error.response.data.detail });
        _this8.showErrorMsg({
          message: error.response.data.detail
        });
      });
      console.log("debitt", this.debitCards);
    },
    setActiveIndex: function setActiveIndex(id) {
      var _this9 = this;

      var HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get("/onboardingstate/state").then(function (response) {
        console.log("setActive", response.data);
        if (response.data.stateid == 8) {
          _this9.activeIndex = 1;
          return;
        }
      }).catch(function (error) {
        console.log({ error: error });
      });
    }
  }),
  mounted: function mounted() {
    var _this10 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("mounted");
              _context3.next = 3;
              return _this10.fetchAmt(_this10.getUserSession.id);

            case 3:

              _this10.fetchDebitCards(_this10.getUserSession.id);

              _this10.setActiveIndex(_this10.getUserSession.id);

              _this10.setCurrentAfterPayment();
              _this10.updateTracker(true);
              _this10.updateStatus(7);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this10);
    }))();
  }
});

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: "",
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: "Oil & Gas", name: "Oil & Gas" }, { id: "Farmer", name: "Farmer" }, { id: "Driver", name: "Driver" }, { id: "Painter", name: "Painter" }],
      employmentStatus: [{ id: "Employed", name: "Employed" }, { id: "Self Employed", name: "Self Employed" }],
      incomes: [{ id: "< N500,000", name: "Below N500,000" }, {
        id: ">N500,000 and < N750,000",
        name: "Between N500,000 and N750,000"
      }, {
        id: "> N750,000 and < N1,000,000",
        name: "Between N750,000 and N1,000,000"
      }, { id: "> N1,000,000", name: "Above N1,000,000" }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: "",
        income: "",
        employment: "",
        business: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    fetchAll: function fetchAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.productDetails);
                // parse for "arnergy-select" use
                _this.products = _this.productDetails;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAmtofTenure: function getAmtofTenure(id) {
      console.log("pussy is sweet");
      var obj = this.tenures.find(function (x) {
        return x.id == id;
      });
      this.amountToPay = obj;
    },
    finalReq: function finalReq() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;

      localStorage.amtPay = this.amountToPay.caution;
      localStorage.amtRepay = this.amountToPay.monthly;

      var data = {
        customerId: localStorage.customerId,
        productid: this.amountToPay.productID,
        tenure: this.amountToPay.name,
        firstPaymentAmt: this.amountToPay.monthly,
        recurrentMonthlyAmt: this.amountToPay.caution,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: this.form.income,
        typeOfBusiness: this.form.business
      };
      this.loader = true;
      HTTP.post("/CustomerProductOptions/saveCustomerOption", data).then(function (res) {
        if (res.data.status) {
          _this2.loader = false;
          _this2.message = res.data.message;
          _this2.errorMessage = false;
          _this2.sucessMsg = true;
          _this2.ctn = true;
        } else {
          _this2.message = res.data.message;
          _this2.errorMessage = true;
          _this2.loader = false;
          _this2.sucessMsg = false;
          setTimeout(function () {
            window.location.href = "/onboarding";
          }, 2000);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    // console.log("it is " + this.productDetails);
    // this.fetchAll();
    // console.log(this.products);
    // this.tenures = this.productDetails.map((item) => {
    //   return {
    //     id: item.id,
    //     name: item.contractTenure,
    //     caution: item.cautionFee,
    //     monthly: item.monthlyPayment,
    //     productID: item.productId,
    //   };
    // });

    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Agreement__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Modal",
  props: {
    productDetails: null,
    titleProduct: null,
    amt: null,
    desc: null,
    tableDatas: null
  },
  components: {
    ArnergyInput: __WEBPACK_IMPORTED_MODULE_2__ArnergyInput__["a" /* default */],
    ArnergySelect: __WEBPACK_IMPORTED_MODULE_3__AnergySelectDynamic_vue__["a" /* default */],
    Agreement: __WEBPACK_IMPORTED_MODULE_4__Agreement__["a" /* default */]
  },
  computed: {},
  data: function data() {
    return {
      costShow: false,
      showAgreement: false,
      ctn: false,
      message: "",
      activeIndex: 0,
      sucessMsg: false,
      errorMessage: false,
      BT: [{ id: "Oil & Gas", name: "Oil & Gas" }, { id: "Farmer", name: "Farmer" }, { id: "Driver", name: "Driver" }, { id: "Painter", name: "Painter" }],
      employmentStatus: [{ id: "Employed", name: "Employed" }, { id: "Self Employed", name: "Self Employed" }],
      incomes: [{ id: "< N500,000", name: " < N500,000" }, { id: ">N500,000 and < N750,000", name: ">N500,000 and < N750,000" }, {
        id: "> N750,000 and < N1,000,000",
        name: "> N750,000 and < N1,000,000"
      }, { id: "> N1,000,000", name: "> N1,000,000" }],
      tenures: [{ id: null, name: null }],
      amountToPay: {},
      products: [],
      loader: false,
      form: {
        tenure: "",
        income: "",
        employment: "",
        business: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {},
      dateOptions: {
        weekday: "short",
        year: "numeric",
        month: "long",
        day: "numeric"
      }
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },

  methods: {
    gotoNextState: function gotoNextState() {
      // this.$emit("updateStatus");
    },
    fetchAll: function fetchAll() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(_this.productDetails);
                // parse for "arnergy-select" use
                _this.products = _this.productDetails;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getAmtofTenure: function getAmtofTenure(id) {
      var obj = this.tenures.find(function (x) {
        return x.id == id;
      });
      this.amountToPay = obj;
    },
    finalReq: function finalReq() {
      var _this2 = this;

      var HTTP = this.$httpUtils.instance;

      localStorage.amtPay = this.amountToPay.caution;
      localStorage.amtRepay = this.amountToPay.monthly;

      console.log("set the new amt is " + this.amountPay.caution);

      var data = {
        customerId: localStorage.customerId,
        productid: this.amountToPay.productID,
        tenure: this.amountToPay.name,
        firstPaymentAmt: this.amountToPay.monthly,
        recurrentMonthlyAmt: this.amountToPay.caution,
        employmentStatus: this.form.employment,
        monthlyIncomeRange: this.form.income,
        typeOfBusiness: this.form.business
      };
      this.loader = true;
      HTTP.post("/CustomerProductOptions/saveCustomerOption", data).then(function (res) {
        if (res.data.status) {
          _this2.loader = false;
          _this2.message = res.data.message;
          _this2.errorMessage = false;
          _this2.sucessMsg = true;
          _this2.ctn = true;
        } else {
          _this2.message = res.data.message;
          _this2.errorMessage = true;
          _this2.loader = false;
          _this2.sucessMsg = false;
          setTimeout(function () {
            window.location.href = "/onboarding";
          }, 2000);
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              console.log(_this3.tableDatas);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }))();
  }
});

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LOFinish",
  props: ["updateStatus", "updateTracker"],
  data: function data() {
    return {};
  },

  methods: {},
  mounted: function mounted() {
    this.updateTracker(true);
    this.updateStatus(8);
  }
});

/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(122);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "verify-email",
  data: function data() {
    return {
      OTP: {},
      data: {},
      loader: false,
      isDisabled: false
    };
  },

  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    handleOnComplete: function handleOnComplete(value) {
      console.log("OTP completed: ", value);
      this.OTP = value;
      if (value.length > 5) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    handleOnChange: function handleOnChange(value) {
      this.OTP = value;

      console.log("OTP changed: ", this.OTP.length);
      if (value.length > 5) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
    },
    submitOTP: function submitOTP(e) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var HTTP, dataDend, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                console.log("lengf", _this.OTP);
                HTTP = _this.$httpUtils.FASTHTTP;
                dataDend = {
                  verificationtoken: _this.OTP,
                  email: _this.data.email
                };
                _context.prev = 4;

                _this.loader = true;
                _context.next = 8;
                return HTTP.post("/auth/verifyemail-otp", dataDend).then(function (res) {
                  if (res.status == 204) {
                    _this.showSuccessMsg({
                      message: "Email has been verified!"
                    });
                    _this.loader = false;

                    // HTTP.post(
                    //   "/onboardingNotifications/sendAccountRegistrationEmail",
                    //   {
                    //     firstName: this.data.firstName,
                    //     lastName: this.data.lastName,
                    //     email: this.data.email,
                    //     customerId: this.data.id
                    //   }
                    // );
                    setTimeout(function () {
                      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push("/auth/login");
                    }, 2000);
                  }
                }).catch(function (error) {
                  console.log("error in", error);
                  var message = error.response.data.detail;
                  _this.showErrorMsg({ message: message });
                  _this.loader = false;
                });

              case 8:
                res = _context.sent;
                _context.next = 17;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);

                console.log("error out", _context.t0);
                _this.errorMessage = "Something went wrong, please try again.";
                _this.showErrorMsg({ message: _this.errorMessage });
                _this.loader = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 11]]);
      }))();
    },
    resendOTP: function resendOTP(e) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var HTTP, idata, res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                HTTP = _this2.$httpUtils.FASTHTTP;
                _context2.prev = 2;

                _this2.loader = true;

                idata = {
                  email: _this2.data.email
                };

                console.log(idata);

                _context2.next = 8;
                return HTTP.post("/auth/resend-token", idata).then(function (res) {
                  if (res.status == 204) {
                    _this2.showSuccessMsg({
                      message: "OTP has been resent!"
                    });
                    _this2.loader = false;
                  }
                }).catch(function (error) {
                  console.log("error in", error);
                  var response = error.response;
                  var message = response.data.error.message;

                  _this2.showErrorMsg({ message: message.split(";")[0] });
                  _this2.loader = false;
                  console.log("first", _this2.showErrorMsg);
                });

              case 8:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);

                console.log("error out", _context2.t0);
                _this2.errorMessage = "Something went wrong, please try again.";
                _this2.showErrorMsg({ message: _this2.errorMessage });
                _this2.loader = false;
                console.log("second", _this2.showErrorMsg);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 11]]);
      }))();
    }
  },
  mounted: function mounted() {
    this.data = this.$route.params;
  }
});

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-footer'
});

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "notification-box",
    props: ['action', 'message'],
    data: function data() {
        return {
            notifyBox: false,
            closeButton: true
        };
    },

    methods: {
        showCloseButton: function showCloseButton() {
            this.closeButton = true;
        },
        hideCloseButton: function hideCloseButton() {
            this.closeButton = false;
        },
        closeNotification: function closeNotification() {
            this.notifyBox = false;
        }
    }
});

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getAssignedDevices", "getActiveDeviceDaysToExpire"])),
  data: function data() {
    return {
      show: false,
      daysLeft: 1000
    };
  },

  methods: {
    showNotification: function showNotification(num) {
      if (!num) return false;
      var res = Math.round(num);
      if (res <= 0) {
        this.daysLeft = 0;
        return true;
      }
      if (res < 6 && res > 0) {
        this.daysLeft = res;
        return true;
      }
      return false;
    }
  },
  mounted: function mounted() {
    // this.showNotification();
  }
});

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(7);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "UsersWithoutDevice",
  components: {},

  data: function data() {
    return {
      userIsActive: false
    };
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["getloggedinUserRole", "getloggedinUserInstallationCount"])),

  methods: {
    userWithoutDevice: function userWithoutDevice() {
      var hasNoInstallation = this.getloggedinUserInstallationCount === 0;
      var isCustomer = this.getloggedinUserRole.toLowerCase() === "customer";
      this.userIsActive = hasNoInstallation && isCustomer;
    }
  },

  watch: {
    getloggedinUserInstallationCount: "userWithoutDevice",
    getloggedinUserRole: "userWithoutDevice"
  },

  mounted: function mounted() {
    this.userWithoutDevice();
  }
});

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
var tableExport = __webpack_require__(3052);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "grey-table-header",
  props: ["title", "id"],
  data: function data() {
    return {
      battery_meter: {
        background: "green",
        width: "50%"
      }
    };
  },
  components: {},
  methods: {
    exportDeviceList: function exportDeviceList(type) {
      tableExport("device_list", this.title, type);
    }
  },
  mounted: function mounted() {},
  updated: function updated() {}
});

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Center"
});

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "arnergy-table",
  props: {
    columns: {
      type: Array
      //   default: () => []
      //   required: true
    },
    rows: {
      type: Array
      //   default: () => []
      //   required: true
    },
    searchOption: {
      type: Object,
      default: function _default() {
        enabled: true;
      }
      //   required: true
    },
    selectOption: {
      type: Object,
      default: function _default() {
        enabled: true;
      }
      //   required: true
    },
    pageChanged: {
      type: Function,
      default: function _default() {
        return Function;
      }
    },
    selectAll: {
      type: Function,
      default: function _default() {
        return Function;
      }
    },
    toggleSelectRow: {
      type: Function,
      default: function _default() {
        return Function;
      }
    },
    perPageChanged: {
      type: Function,
      default: function _default() {
        return Function;
      }
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clonedeep__ = __webpack_require__(3062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clonedeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_clonedeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var DEFAULT_ROWS_PER_PAGE_DROPDOWN = [20, 50, 60, 70, 80, 100, 200];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "GreyPagination",
  props: {
    styleClass: { default: "table table-bordered" },
    total: { default: null },
    perPage: {},
    rtl: { default: false },
    customRowsPerPageDropdown: {
      default: function _default() {
        return [];
      }
    },

    paginateDropdownAllowAll: { default: true },
    mode: { default: "records" },
    // text options
    nextText: { default: "Next" },
    prevText: { default: "Prev" },
    rowsPerPageText: { default: "Rows per page:" },
    ofText: { default: "of" },
    pageText: { default: "page" },
    allText: { default: "All" },
    currentPage: { default: 1 },
    pageChanged: {
      type: Function
    },
    perPageChanged: {
      type: Function
    }
  },

  data: function data() {
    return {
      prevPage: 0,
      currentPerPage: 200,
      rowsPerPageOptions: []
    };
  },

  watch: {
    perPage: {
      handler: function handler(newValue, oldValue) {
        // console.log({
        //   newValue,
        //   oldValue
        // })
        this.handlePerPage();
        this.customPerPageChanged();
      },

      immediate: true
    },

    customRowsPerPageDropdown: function customRowsPerPageDropdown() {
      this.handlePerPage();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(["isSidebarCollapsed"]), {
    // Number of pages
    pagesCount: function pagesCount() {
      var quotient = Math.floor(this.total / this.currentPerPage);
      var remainder = this.total % this.currentPerPage;

      return remainder === 0 ? quotient : quotient + 1;
    },


    // Current displayed items
    paginatedInfo: function paginatedInfo() {
      var first = (this.currentPage - 1) * this.currentPerPage + 1;
      var last = Math.min(this.total, this.currentPage * this.currentPerPage);

      if (last === 0) {
        first = 0;
      }

      // let paginatedInfoString = `${first} - ${last} ${this.ofText} ${this.total}`;
      this.$emit("paginated-info", {
        first: first,
        last: last,
        ofText: this.ofText,
        total: this.total
      });
      return first + " - " + last + " " + this.ofText + " " + this.total;
    },


    // Get last page
    // lastPage(){

    // },

    // Can go to next page
    nextIsPossible: function nextIsPossible() {
      return this.currentPage < this.pagesCount;
    },


    // Can go to previous page
    prevIsPossible: function prevIsPossible() {
      return this.currentPage > 1;
    }
  }),

  methods: {
    // Change current page
    changePage: function changePage(pageNumber) {
      var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (pageNumber > 0 && this.total > this.currentPerPage * (pageNumber - 1)) {
        this.prevPage = this.currentPage;
        this.currentPage = pageNumber;
        if (emit) this.customPageChanged();
      }
    },


    // Go to next page
    nextPage: function nextPage() {
      if (this.nextIsPossible) {
        this.prevPage = this.currentPage;
        ++this.currentPage;
        this.customPageChanged();
      }
    },
    jumpToFirst: function jumpToFirst() {
      if (this.prevIsPossible) {
        this.prevPage = this.currentPage;

        this.currentPage = 1;
        this.customPageChanged();
      }
    },
    jumpToLast: function jumpToLast() {
      if (this.nextIsPossible) {
        this.prevPage = this.currentPage;

        this.currentPage = this.pagesCount;
        this.customPageChanged();
      }
    },


    // Go to previous page
    previousPage: function previousPage() {
      if (this.prevIsPossible) {
        this.prevPage = this.currentPage;
        --this.currentPage;
        this.customPageChanged();
      }
    },


    // customPerPageChange(customPerPage) {
    //   this.customPerPageChanged({currentPerPage: customPerPage});
    // }
    // Indicate page changing
    customPageChanged: function customPageChanged() {
      this.pageChanged({ currentPage: this.currentPage });
      // this.$emit('page-changed', {
      //   currentPage: this.currentPage,
      //   prevPage: this.prevPage,
      // });
    },


    // Indicate per page changing
    customPerPageChanged: function customPerPageChanged() {
      // go back to first page
      this.perPageChanged({ currentPerPage: this.currentPerPage });
      // this.$emit('per-page-changed', { currentPerPage: this.currentPerPage });
      // this.changePage(1, false);
    },


    // Handle per page changing
    handlePerPage: function handlePerPage() {
      //* if there's a custom dropdown then we use that
      if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0) {
        this.rowsPerPageOptions = this.customRowsPerPageDropdown;
      } else {
        //* otherwise we use the default rows per page dropdown
        this.rowsPerPageOptions = __WEBPACK_IMPORTED_MODULE_1_lodash_clonedeep___default()(DEFAULT_ROWS_PER_PAGE_DROPDOWN);
      }

      if (this.perPage) {
        this.currentPerPage = this.perPage;
        // if perPage doesn't already exist, we add it
        var found = false;
        for (var i = 0; i < this.rowsPerPageOptions.length; i++) {
          if (this.rowsPerPageOptions[i] === this.perPage) {
            found = true;
          }
        }
        if (!found && this.perPage !== -1) {
          this.rowsPerPageOptions.unshift(this.perPage);
        }
      } else {
        // reset to default
        this.currentPerPage = 50;
      }
    }
  },

  mounted: function mounted() {
    if (this.pagesCount >= this.currentPage) {
      this.changePage(this.currentPage);
    }
  },


  components: {
    // 'pagination-page-info': VgtPaginationPageInfo,
  }
});

/***/ }),
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */,
/* 1331 */,
/* 1332 */,
/* 1333 */,
/* 1334 */,
/* 1335 */,
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */,
/* 1340 */,
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 540,
	"./af.js": 540,
	"./ar": 541,
	"./ar-dz": 542,
	"./ar-dz.js": 542,
	"./ar-kw": 543,
	"./ar-kw.js": 543,
	"./ar-ly": 544,
	"./ar-ly.js": 544,
	"./ar-ma": 545,
	"./ar-ma.js": 545,
	"./ar-sa": 546,
	"./ar-sa.js": 546,
	"./ar-tn": 547,
	"./ar-tn.js": 547,
	"./ar.js": 541,
	"./az": 548,
	"./az.js": 548,
	"./be": 549,
	"./be.js": 549,
	"./bg": 550,
	"./bg.js": 550,
	"./bm": 551,
	"./bm.js": 551,
	"./bn": 552,
	"./bn-bd": 553,
	"./bn-bd.js": 553,
	"./bn.js": 552,
	"./bo": 554,
	"./bo.js": 554,
	"./br": 555,
	"./br.js": 555,
	"./bs": 556,
	"./bs.js": 556,
	"./ca": 557,
	"./ca.js": 557,
	"./cs": 558,
	"./cs.js": 558,
	"./cv": 559,
	"./cv.js": 559,
	"./cy": 560,
	"./cy.js": 560,
	"./da": 561,
	"./da.js": 561,
	"./de": 562,
	"./de-at": 563,
	"./de-at.js": 563,
	"./de-ch": 564,
	"./de-ch.js": 564,
	"./de.js": 562,
	"./dv": 565,
	"./dv.js": 565,
	"./el": 566,
	"./el.js": 566,
	"./en-au": 567,
	"./en-au.js": 567,
	"./en-ca": 568,
	"./en-ca.js": 568,
	"./en-gb": 569,
	"./en-gb.js": 569,
	"./en-ie": 570,
	"./en-ie.js": 570,
	"./en-il": 571,
	"./en-il.js": 571,
	"./en-in": 572,
	"./en-in.js": 572,
	"./en-nz": 573,
	"./en-nz.js": 573,
	"./en-sg": 574,
	"./en-sg.js": 574,
	"./eo": 575,
	"./eo.js": 575,
	"./es": 576,
	"./es-do": 577,
	"./es-do.js": 577,
	"./es-mx": 578,
	"./es-mx.js": 578,
	"./es-us": 579,
	"./es-us.js": 579,
	"./es.js": 576,
	"./et": 580,
	"./et.js": 580,
	"./eu": 581,
	"./eu.js": 581,
	"./fa": 582,
	"./fa.js": 582,
	"./fi": 583,
	"./fi.js": 583,
	"./fil": 584,
	"./fil.js": 584,
	"./fo": 585,
	"./fo.js": 585,
	"./fr": 586,
	"./fr-ca": 587,
	"./fr-ca.js": 587,
	"./fr-ch": 588,
	"./fr-ch.js": 588,
	"./fr.js": 586,
	"./fy": 589,
	"./fy.js": 589,
	"./ga": 590,
	"./ga.js": 590,
	"./gd": 591,
	"./gd.js": 591,
	"./gl": 592,
	"./gl.js": 592,
	"./gom-deva": 593,
	"./gom-deva.js": 593,
	"./gom-latn": 594,
	"./gom-latn.js": 594,
	"./gu": 595,
	"./gu.js": 595,
	"./he": 596,
	"./he.js": 596,
	"./hi": 597,
	"./hi.js": 597,
	"./hr": 598,
	"./hr.js": 598,
	"./hu": 599,
	"./hu.js": 599,
	"./hy-am": 600,
	"./hy-am.js": 600,
	"./id": 601,
	"./id.js": 601,
	"./is": 602,
	"./is.js": 602,
	"./it": 603,
	"./it-ch": 604,
	"./it-ch.js": 604,
	"./it.js": 603,
	"./ja": 605,
	"./ja.js": 605,
	"./jv": 606,
	"./jv.js": 606,
	"./ka": 607,
	"./ka.js": 607,
	"./kk": 608,
	"./kk.js": 608,
	"./km": 609,
	"./km.js": 609,
	"./kn": 610,
	"./kn.js": 610,
	"./ko": 611,
	"./ko.js": 611,
	"./ku": 612,
	"./ku.js": 612,
	"./ky": 613,
	"./ky.js": 613,
	"./lb": 614,
	"./lb.js": 614,
	"./lo": 615,
	"./lo.js": 615,
	"./lt": 616,
	"./lt.js": 616,
	"./lv": 617,
	"./lv.js": 617,
	"./me": 618,
	"./me.js": 618,
	"./mi": 619,
	"./mi.js": 619,
	"./mk": 620,
	"./mk.js": 620,
	"./ml": 621,
	"./ml.js": 621,
	"./mn": 622,
	"./mn.js": 622,
	"./mr": 623,
	"./mr.js": 623,
	"./ms": 624,
	"./ms-my": 625,
	"./ms-my.js": 625,
	"./ms.js": 624,
	"./mt": 626,
	"./mt.js": 626,
	"./my": 627,
	"./my.js": 627,
	"./nb": 628,
	"./nb.js": 628,
	"./ne": 629,
	"./ne.js": 629,
	"./nl": 630,
	"./nl-be": 631,
	"./nl-be.js": 631,
	"./nl.js": 630,
	"./nn": 632,
	"./nn.js": 632,
	"./oc-lnc": 633,
	"./oc-lnc.js": 633,
	"./pa-in": 634,
	"./pa-in.js": 634,
	"./pl": 635,
	"./pl.js": 635,
	"./pt": 636,
	"./pt-br": 637,
	"./pt-br.js": 637,
	"./pt.js": 636,
	"./ro": 638,
	"./ro.js": 638,
	"./ru": 639,
	"./ru.js": 639,
	"./sd": 640,
	"./sd.js": 640,
	"./se": 641,
	"./se.js": 641,
	"./si": 642,
	"./si.js": 642,
	"./sk": 643,
	"./sk.js": 643,
	"./sl": 644,
	"./sl.js": 644,
	"./sq": 645,
	"./sq.js": 645,
	"./sr": 646,
	"./sr-cyrl": 647,
	"./sr-cyrl.js": 647,
	"./sr.js": 646,
	"./ss": 648,
	"./ss.js": 648,
	"./sv": 649,
	"./sv.js": 649,
	"./sw": 650,
	"./sw.js": 650,
	"./ta": 651,
	"./ta.js": 651,
	"./te": 652,
	"./te.js": 652,
	"./tet": 653,
	"./tet.js": 653,
	"./tg": 654,
	"./tg.js": 654,
	"./th": 655,
	"./th.js": 655,
	"./tk": 656,
	"./tk.js": 656,
	"./tl-ph": 657,
	"./tl-ph.js": 657,
	"./tlh": 658,
	"./tlh.js": 658,
	"./tr": 659,
	"./tr.js": 659,
	"./tzl": 660,
	"./tzl.js": 660,
	"./tzm": 661,
	"./tzm-latn": 662,
	"./tzm-latn.js": 662,
	"./tzm.js": 661,
	"./ug-cn": 663,
	"./ug-cn.js": 663,
	"./uk": 664,
	"./uk.js": 664,
	"./ur": 665,
	"./ur.js": 665,
	"./uz": 666,
	"./uz-latn": 667,
	"./uz-latn.js": 667,
	"./uz.js": 666,
	"./vi": 668,
	"./vi.js": 668,
	"./x-pseudo": 669,
	"./x-pseudo.js": 669,
	"./yo": 670,
	"./yo.js": 670,
	"./zh-cn": 671,
	"./zh-cn.js": 671,
	"./zh-hk": 672,
	"./zh-hk.js": 672,
	"./zh-mo": 673,
	"./zh-mo.js": 673,
	"./zh-tw": 674,
	"./zh-tw.js": 674
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1405;

/***/ }),
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */,
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */
/***/ (function(module, exports) {

module.exports = {"_from":"ant-design-vue@1.7.8","_id":"ant-design-vue@1.7.8","_inBundle":false,"_integrity":"sha512-F1hmiS9vwbyfuFvlamdW5l9bHKqRlj9wHaGDIE41NZMWXyWy8qL0UFa/+I0Wl8gQWZCqODW5pN6Yfoyn85At3A==","_location":"/ant-design-vue","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"ant-design-vue@1.7.8","name":"ant-design-vue","escapedName":"ant-design-vue","rawSpec":"1.7.8","saveSpec":null,"fetchSpec":"1.7.8"},"_requiredBy":["#USER","/"],"_resolved":"https://registry.npmjs.org/ant-design-vue/-/ant-design-vue-1.7.8.tgz","_shasum":"1abbf86b68a4f5b1000bea0487b8031dc0001661","_spec":"ant-design-vue@1.7.8","_where":"C:\\Users\\tolulope.dosu-idowu\\Desktop\\arnergy_repo\\arnergy-core-vue","bugs":{"url":"https://github.com/vueComponent/ant-design-vue/issues"},"bundleDependencies":false,"dependencies":{"@ant-design/icons":"^2.1.1","@ant-design/icons-vue":"^2.0.0","@simonwep/pickr":"~1.7.0","add-dom-event-listener":"^1.0.2","array-tree-filter":"^2.1.0","async-validator":"^3.0.3","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-runtime":"6.x","classnames":"^2.2.5","component-classes":"^1.2.6","dom-align":"^1.10.4","dom-closest":"^0.2.0","dom-scroll-into-view":"^2.0.0","enquire.js":"^2.1.6","intersperse":"^1.0.0","is-mobile":"^2.2.1","is-negative-zero":"^2.0.0","ismobilejs":"^1.0.0","json2mq":"^0.2.0","lodash":"^4.17.5","moment":"^2.21.0","mutationobserver-shim":"^0.3.2","node-emoji":"^1.10.0","omit.js":"^1.0.0","raf":"^3.4.0","resize-observer-polyfill":"^1.5.1","shallow-equal":"^1.0.0","shallowequal":"^1.0.2","vue-ref":"^2.0.0","warning":"^4.0.0"},"deprecated":false,"description":"An enterprise-class UI design language and Vue-based implementation","devDependencies":{"@commitlint/cli":"^8.0.0","@commitlint/config-conventional":"^8.0.0","@octokit/rest":"^16.0.0","@vue/cli-plugin-eslint":"^4.0.0","@vue/server-test-utils":"1.0.0-beta.16","@vue/test-utils":"1.0.0-beta.16","acorn":"^7.0.0","autoprefixer":"^9.6.0","axios":"^0.19.0","babel-cli":"^6.26.0","babel-core":"^6.26.0","babel-eslint":"^10.0.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-jest":"^23.6.0","babel-loader":"^7.1.2","babel-plugin-import":"^1.1.1","babel-plugin-inline-import-data-uri":"^1.0.1","babel-plugin-istanbul":"^6.0.0","babel-plugin-syntax-dynamic-import":"^6.18.0","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-class-properties":"^6.24.1","babel-plugin-transform-decorators":"^6.24.1","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-plugin-transform-es3-member-expression-literals":"^6.22.0","babel-plugin-transform-es3-property-literals":"^6.22.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-object-rest-spread":"^6.26.0","babel-plugin-transform-runtime":"~6.23.0","babel-plugin-transform-vue-jsx":"^3.7.0","babel-polyfill":"^6.26.0","babel-preset-env":"^1.6.1","case-sensitive-paths-webpack-plugin":"^2.1.2","chalk":"^3.0.0","cheerio":"^1.0.0-rc.2","codecov":"^3.0.0","colorful":"^2.1.0","commander":"^4.0.0","compare-versions":"^3.3.0","cross-env":"^7.0.0","css-loader":"^3.0.0","deep-assign":"^2.0.0","enquire-js":"^0.2.1","eslint":"^6.8.0","eslint-config-prettier":"^6.10.1","eslint-plugin-html":"^6.0.0","eslint-plugin-markdown":"^2.0.0-alpha.0","eslint-plugin-vue":"^6.2.2","fetch-jsonp":"^1.1.3","fs-extra":"^8.0.0","glob":"^7.1.2","gulp":"^4.0.1","gulp-babel":"^7.0.0","gulp-strip-code":"^0.1.4","html-webpack-plugin":"^3.2.0","husky":"^4.0.0","istanbul-instrumenter-loader":"^3.0.0","jest":"^24.0.0","jest-serializer-vue":"^2.0.0","jest-transform-stub":"^2.0.0","js-base64":"^3.0.0","json-templater":"^1.2.0","jsonp":"^0.2.1","less":"^3.9.0","less-loader":"^6.0.0","less-plugin-npm-import":"^2.1.0","lint-staged":"^10.0.0","marked":"0.3.18","merge2":"^1.2.1","mini-css-extract-plugin":"^0.10.0","minimist":"^1.2.0","mkdirp":"^0.5.1","mockdate":"^2.0.2","nprogress":"^0.2.0","optimize-css-assets-webpack-plugin":"^5.0.1","postcss":"^7.0.6","postcss-loader":"^3.0.0","prettier":"^1.18.2","pretty-quick":"^2.0.0","querystring":"^0.2.0","raw-loader":"^4.0.0","reqwest":"^2.0.5","rimraf":"^3.0.0","rucksack-css":"^1.0.2","selenium-server":"^3.0.1","semver":"^7.0.0","style-loader":"^1.0.0","stylelint":"^13.0.0","stylelint-config-prettier":"^8.0.0","stylelint-config-standard":"^19.0.0","terser-webpack-plugin":"^3.0.3","through2":"^3.0.0","url-loader":"^3.0.0","vue":"^2.6.11","vue-antd-md-loader":"^1.1.0","vue-clipboard2":"0.3.1","vue-draggable-resizable":"^2.1.0","vue-eslint-parser":"^7.0.0","vue-i18n":"^8.3.2","vue-infinite-scroll":"^2.0.2","vue-jest":"^2.5.0","vue-loader":"^15.6.2","vue-router":"^3.0.1","vue-server-renderer":"^2.6.11","vue-template-compiler":"^2.6.11","vue-virtual-scroller":"^1.0.0","vuex":"^3.1.0","webpack":"^4.28.4","webpack-cli":"^3.2.1","webpack-dev-server":"^3.1.14","webpack-merge":"^4.1.1","webpackbar":"^4.0.0","xhr-mock":"^2.5.1"},"files":["dist","lib","es","types","scripts"],"homepage":"https://www.antdv.com/","keywords":["ant","design","antd","vue","vueComponent","component","components","ui","framework","frontend"],"license":"MIT","main":"lib/index.js","module":"es/index.js","name":"ant-design-vue","peerDependencies":{"vue":"^2.6.0","vue-template-compiler":"^2.6.0"},"repository":{"type":"git","url":"git+https://github.com/vueComponent/ant-design-vue.git"},"scripts":{"codecov":"codecov","compile":"node antd-tools/cli/run.js compile","dev":"webpack-dev-server","dist":"node antd-tools/cli/run.js dist","lint":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./components","lint:docs":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue,.md ./antdv-demo/docs/**/demo/**","lint:site":"eslint -c ./.eslintrc --fix --ext .jsx,.js,.vue ./antdv-demo","lint:style":"stylelint \"{site,components}/**/*.less\" --syntax less","postinstall":"node scripts/postinstall || echo \"ignore\"","pre-publish":"node ./scripts/prepub","prepublish":"node antd-tools/cli/run.js guard","prettier":"prettier -c --write '**/*'","pretty-quick":"pretty-quick","pub":"node antd-tools/cli/run.js pub","pub-with-ci":"node antd-tools/cli/run.js pub-with-ci","start":"cross-env NODE_ENV=development webpack-dev-server --config webpack.config.js","test":"cross-env NODE_ENV=test jest --config .jest.js"},"sideEffects":["site/*","components/style.js","components/**/style/*","*.vue","*.md","dist/*","es/**/style/*","lib/**/style/*","*.less"],"title":"Ant Design Vue","typings":"types/index.d.ts","version":"1.7.8"}

/***/ }),
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(799);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(1781)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(800);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(1788)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(803);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(1805)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1805 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(808);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(1827)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1827 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(810);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(1832)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__casl_ability__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_http_common__ = __webpack_require__(400);
/* eslint-disable */





var userTypes = {
  admin: ["admin", "executive", "finance", "customer operations manager", "customer operations engineer", "Supply Chain".toLowerCase(), "technical team", "customer projects", "customer service", "sales executive"],
  agent: ["agent", "lifestyle", "groove"],
  customer: ["customer", "alc customer", "groove customer", "iot customer"],
  sm: ["section manager"]
};

function setAccessLocal(userSession) {
  __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit("setUser", userSession);
  //ability.update(userSession.roleType);
}

function init(acl, can) {
  // console.log({ acl });

  if (acl.map(function (item) {
    return userTypes.admin.includes(item.principalType.toLowerCase());
  }).includes(true)) {
    can("read", "all");
    can("see", "installation");
    can("manage", "installation");
    can("manage", "allDevices");
    can("manage", "onboardingTracker");
    can("manage", "bills");
    // can("see", "maintenance");
    // can("manage", "subsmanager");
    can("am", "manager"); //subsmanager
    //can('create', ['invoice'])
    if (acl.find(function (x) {
      return x.principalType === userTypes.admin[0];
    }) !== undefined) {
      can(["update", "create"], "installation");
      can("see", "proforma");
      can("see", "warnings");
      can(["create", "manage"], ["token", "wallet", "user", "invoice", "report", "inventory"]);
    }
    if (acl.find(function (x) {
      return x.principalType === userTypes.admin[1];
    }) !== undefined) {
      can("create", ["token", "wallet", "inventory", "invoice"]);
      can(["update", "create"], "installation");
    }
    if (acl.find(function (x) {
      return x.principalType === userTypes.admin[2];
    }) !== undefined) {
      // console.log(userTypes.admin[2])
      can("am", "finance");
      can(["update", "create"], "installation");
      can("create", ["token", "wallet", "inventory", "invoice"]);
      can(["create", "manage"], ["token", "wallet", "user", "invoice", "report", "subsmanager"]);
      //console.log(acl.find(x => x.principalType === userTypes.admin[3]));
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[3];
    }) !== undefined) {
      can("am", "manager");
      can("see", "maintenance");
      can(["update", "create"], "installation");
      can("see", "warnings");
      //console.log(acl,'Manager');
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[4];
    }) !== undefined) {
      can("see", "maintenance");
      can("am", "engineer");
      can("see", "warnings");
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[5];
    }) !== undefined) {
      can("create", "inventory");
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[6];
    }) !== undefined) {
      can("manage", "alarmConfig");
      can("see", "warnings");
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[7];
    }) !== undefined) {
      can("commission", "installation");
      can("edit", "installation");
      can("create", "customer");
      can("see", "proforma");
      can("see", "warnings");
    }
    if (acl.find(function (x) {
      return x.principalType == userTypes.admin[8];
    }) !== undefined) {
      can("am", "cxTeam");
      can(["create", "manage", "edit"], ["user", "customer"]);
    }
  }

  if (acl.map(function (item) {
    return userTypes.agent.includes(item.principalType);
  }).includes(true)) {
    // can('create', ['device', 'token'])
    // console.log("agent");
    can("see", "installation");
    can("manage", ["device", "customer"]);
    can("read", ["device", "token", "wallet", "user", "performance", "notification", "dashboard"]);
    can("create", ["device", "token", "wallet"]);
    if (acl.find(function (x) {
      return x.principalType === userTypes.agent[0];
    }) !== undefined) {}
    if (acl.find(function (x) {
      return x.principalType === userTypes.agent[1];
    }) !== undefined) {}
    if (acl.find(function (x) {
      return x.principalType === userTypes.agent[2];
    }) !== undefined) {}
  }
  if (acl.map(function (item) {
    return userTypes.sm.includes(item.principalType);
  }).includes(true)) {
    can("see", "installation");
    // console.log({ sm: "item.principalType" });
    // can("create", ["token", "device", "wallet"]);
    can("manage", ["device", "mine", "my-request"]);
    can("read", ["device", "token", "wallet", "notification", "dashboard", "installation"]);
    can("am", "sm");
    can("query", "history");
    can("am", "manager");
    can("see", "customerWarning");
    can("see", "billing");
  }
  if (acl.map(function (item) {
    return userTypes.customer.includes(item.principalType);
  }).includes(true)) {
    can("see", "installation");
    // console.log("customer");customer
    can("create", ["token", "device", "wallet"]);
    can("manage", ["device", "mine", "my-request", "invoice"]);
    can("read", ["device", "token", "wallet", "notification", "dashboard", "installation"]);
    can("am", "customer");
    can("see", "customerWarning");
    can("see", "billing");
    if (acl.find(function (x) {
      return x.principalType === userTypes.customer[0];
    }) !== undefined) {}
    if (acl.find(function (x) {
      return x.principalType === userTypes.customer[1];
    }) !== undefined) {}
    if (acl.find(function (x) {
      return x.principalType === userTypes.customer[2];
    }) !== undefined) {}
    if (acl.find(function (x) {
      return x.principalType === userTypes.customer[3];
    }) !== undefined) {
      can("read", "performance");
    }
  }
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__casl_ability__["b" /* AbilityBuilder */].define(function (can) {
  var userSession = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getUserSession;

  if (userSession) {
    var acl = userSession.role_mappings;

    if (!acl) {
      // Switch to use http1 first, but handle 401 errors gracefully.
      var HTTP1 = __WEBPACK_IMPORTED_MODULE_2__utils_http_common__["a" /* default */].instance;
      HTTP1.get("/users/" + userSession.id + "?filter[include][role_mappings]/?" + Date.now()).then(function (userResponse) {
        if (userResponse.status === 200) {
          // Success!
          var saveRole = [{ subject: userResponse.data.roleType, actions: "all" }];
          userResponse.data.token = token;
          userResponse.data.roleType = saveRole;
          setAccessLocal(userResponse.data);
          init(userResponse.data.role_mappings, can);
        } else if (userResponse.status === 401) {
          // Fall back to HTTP, but don't initialize abilities until we have a successful response.
          var HTTP = __WEBPACK_IMPORTED_MODULE_2__utils_http_common__["a" /* default */].FASTHTTP;

          HTTP.get("/auth/user", {}).then(function (fallbackUserResponse) {
            if (fallbackUserResponse.status === 200) {
              var _saveRole = [{
                subject: fallbackUserResponse.data.roletype,
                actions: "all"
              }];
              fallbackUserResponse.data.token = token;
              fallbackUserResponse.data.roleType = _saveRole;
              setAccessLocal(fallbackUserResponse.data);
              init(fallbackUserResponse.data.role_mappings, can);
            } else {
              // Handle the fallback user response error.
              console.error("Fallback user response error: ", fallbackUserResponse);
            }
          });
        } else {
          // Handle the initial user response error.
          console.error("Initial user response error: ", userResponse);
        }
      }).catch(function (error) {
        // Handle any unexpected errors during the HTTP1 request.
        console.error("Unexpected error during HTTP1 request: ", error);
      });
    } else {
      // We already have ACL data, so initialize abilities now.
      init(acl, can);
    }
  } else {
    // User is not logged in, so initialize abilities with anonymous permissions.
    can("all", "anon");
  }
}));

/**
 * Defines how to detect object's type: https://stalniy.github.io/casl/abilities/2017/07/20/define-abilities.html
 */
function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }
  return item.__type;
}

// can('create', 'invoice')

// can('read', 'token')

// can('manage', 'inventory')

// can('manage', 'component')

// can('update', 'inventory')

// can('delete', 'inventory')

/***/ }),
/* 1854 */,
/* 1855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var getLuxOnboardingStates = function getLuxOnboardingStates(state) {
  return state.luxOnboardingStatus;
};
var getLuxPaymentStates = function getLuxPaymentStates(state) {
  return state.luxPaymentStatus;
};
var getUsers = function getUsers(state) {
  return state.userList;
};
var getUsersAdmin = function getUsersAdmin(state) {
  return state.userListAdmin;
};
var getGroups = function getGroups(state) {
  return state.groupList;
};
var getSubgroups = function getSubgroups(state) {
  return state.subgroupList;
};
var getGroupItems = function getGroupItems(state) {
  return state.groupitemList;
};
var getGroupUsers = function getGroupUsers(state) {
  return state.groupUsers;
};
var getInstalls = function getInstalls(state) {
  return state.installs;
};
var getInstallss = function getInstallss(state) {
  return state.installss;
};
var getEmails = function getEmails(state) {
  return state.emailList;
};
var getSms = function getSms(state) {
  return state.smsList;
};
var isHome = function isHome(state) {
  return state.isHome;
};
var getAccess = function getAccess(state) {
  return state.userAccess;
};
var getUserSession = function getUserSession(state) {
  return state.loggedInUser;
};
var getUserAmount = function getUserAmount(state) {
  return state.userAmount;
};
var getDummy = function getDummy(state) {
  return state.dummy;
};
var getDevices = function getDevices(state) {
  return state.deviceList;
};
var getUserById = function getUserById(state) {
  return function (id) {
    return state.userList.find(function (user) {
      return user.id === id;
    });
  };
};
var getUserByEmail = function getUserByEmail(state) {
  return function (email) {
    return state.userList.find(function (user) {
      return user.email === email;
    });
  };
};
var getDeviceById = function getDeviceById(state) {
  return function (id) {
    return state.deviceList.find(function (device) {
      return device.id === id;
    });
  };
};
var getDeviceByUserId = function getDeviceByUserId(state) {
  return function (id) {
    return state.deviceList.filter(function (device) {
      return device.user.data.id === id;
    });
  };
};
var getUserByDevice = function getUserByDevice(state) {
  return function (id) {
    return state.deviceList.filter(function (device) {
      return device.user.data.solarKitIds === id;
    });
  };
};
var getDrawerMode = function getDrawerMode(state) {
  return state.drawerMode;
};
var getRole = function getRole(state) {
  return state.roles;
};
var getRoleAdmin = function getRoleAdmin(state) {
  return state.rolesAdmin;
};
var getTheme = function getTheme(state) {
  return state.activeTheme;
};
var themeList = function themeList(state) {
  return {
    light: state.defaultTheme,
    dark: state.darkTheme
  };
};
var getDeviceWarning = function getDeviceWarning(state) {
  return function (device) {
    return state.devicesWarning[device] ? state.devicesWarning[device] : null;
  };
};
var getGlobalTableOptions = function getGlobalTableOptions(state) {
  return state.globalTableOptions;
};
var filterSectorVal = function filterSectorVal(state) {
  return state.filterSectorVal;
};
var DeviceList = function DeviceList(state) {
  return state.allDevices;
};
var isSidebarCollapsed = function isSidebarCollapsed(state) {
  return state.isSidebarCollapsed;
};
var OffDeviceList = function OffDeviceList(state) {
  return state.allOffDevices;
};
var graphDeviceDetails = function graphDeviceDetails(state) {
  return state.allGraphDevices;
};
var devicePayload = function devicePayload(state) {
  return state.devicePayload;
}; //
var loadingState = function loadingState(state) {
  return state.loadingState;
}; //
var offLineDeviceList = function offLineDeviceList(state) {
  return state.offLineDevices;
}; //
var alarmDevices = function alarmDevices(state) {
  return state.alarmDevices;
}; //
var onLineDevices = function onLineDevices(state) {
  return state.onLineDevices;
}; //
var uniqueFV = function uniqueFV(state) {
  return state.uniqueFV;
}; //
var filteredAllDevices = function filteredAllDevices(state) {
  return state.filteredAllDevices;
};
var filteredOnlineDevices = function filteredOnlineDevices(state) {
  return state.filteredOnlineDevices;
};
var filteredOffLineDevices = function filteredOffLineDevices(state) {
  return state.filteredOffLineDevices;
};
var filteredAlarmDevices = function filteredAlarmDevices(state) {
  return state.filteredAlarmDevices;
};
var filterFirmWarVersion = function filterFirmWarVersion(state) {
  return state.filterFirmWarVersion;
}; //
var filterPaymentModel = function filterPaymentModel(state) {
  return state.filterPaymentModel;
}; //
var criticalSystems = function criticalSystems(state) {
  return state.criticalSystems;
}; //
var uniqueSectors = function uniqueSectors(state) {
  return state.uniqueSectors;
}; //
var uniquePaymentModel = function uniquePaymentModel(state) {
  return state.uniquePaymentModel;
}; //
var getPerformanceFilter = function getPerformanceFilter(state) {
  return state.performanceFilter;
}; //
var getDeviceCurrentSettings = function getDeviceCurrentSettings(state) {
  return state.deviceCurrentSettings[0] || [];
}; //
//
var getloggedinUserRole = function getloggedinUserRole(state) {
  return state.loggedinUserRole;
};
var getloggedinUserInstallationCount = function getloggedinUserInstallationCount(state) {
  return state.loggedinUserInstallationCount;
};
var combinedDevices = function combinedDevices(state) {
  return state.allOffDevices.concat(state.allDevices);
};

var getOsCustomer = function getOsCustomer(state) {
  return state.osCustomer;
};
var getCustomerProductOptions = function getCustomerProductOptions(state) {
  return state.customerProductOptions;
};
var getUserNotifications = function getUserNotifications(state) {
  return state.userNotifications;
}; //
var getAssignedDevices = function getAssignedDevices(state) {
  return state.assignedDevices;
};
var getActiveDeviceDaysToExpire = function getActiveDeviceDaysToExpire(state) {
  return state.activeDeviceDaysToExpire;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  getLuxOnboardingStates: getLuxOnboardingStates,
  getLuxPaymentStates: getLuxPaymentStates,
  isSidebarCollapsed: isSidebarCollapsed,
  getTheme: getTheme,
  getUserById: getUserById,
  loadingState: loadingState,
  getUserByDevice: getUserByDevice,
  getUserByEmail: getUserByEmail,
  getDeviceById: getDeviceById,
  getUsers: getUsers,
  getUsersAdmin: getUsersAdmin,
  getInstalls: getInstalls,
  getInstallss: getInstallss,
  getGroups: getGroups,
  getSubgroups: getSubgroups,
  getGroupItems: getGroupItems,
  getGroupUsers: getGroupUsers,
  getEmails: getEmails,
  getSms: getSms,
  getDeviceWarning: getDeviceWarning,
  getDummy: getDummy,
  devicePayload: devicePayload,
  getDevices: getDevices,
  getDeviceByUserId: getDeviceByUserId,
  getUserSession: getUserSession,
  getUserAmount: getUserAmount,
  getAccess: getAccess,
  isHome: isHome,
  getDrawerMode: getDrawerMode,
  DeviceList: DeviceList,
  OffDeviceList: OffDeviceList,
  combinedDevices: combinedDevices,
  getRole: getRole,
  getRoleAdmin: getRoleAdmin,
  themeList: themeList,
  graphDeviceDetails: graphDeviceDetails,
  offLineDeviceList: offLineDeviceList,
  alarmDevices: alarmDevices,
  onLineDevices: onLineDevices,
  uniqueFV: uniqueFV,
  filteredAllDevices: filteredAllDevices,
  filteredOnlineDevices: filteredOnlineDevices,
  filteredAlarmDevices: filteredAlarmDevices,
  filteredOffLineDevices: filteredOffLineDevices,
  filterFirmWarVersion: filterFirmWarVersion,
  filterPaymentModel: filterPaymentModel,
  uniqueSectors: uniqueSectors,
  filterSectorVal: filterSectorVal,
  uniquePaymentModel: uniquePaymentModel,
  getGlobalTableOptions: getGlobalTableOptions,
  getPerformanceFilter: getPerformanceFilter,
  criticalSystems: criticalSystems,
  getDeviceCurrentSettings: getDeviceCurrentSettings,
  getOsCustomer: getOsCustomer,
  getCustomerProductOptions: getCustomerProductOptions,
  getUserNotifications: getUserNotifications,
  getAssignedDevices: getAssignedDevices,
  getActiveDeviceDaysToExpire: getActiveDeviceDaysToExpire,
  getloggedinUserInstallationCount: getloggedinUserInstallationCount,
  getloggedinUserRole: getloggedinUserRole
});

/***/ }),
/* 1856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);



var _toggleSidebar$device;

/* eslint-disable */
var saveUsers = function saveUsers(state, data) {
  // state.userList = data;
  console.error("@refactor: not saving user list to state", data);
};
var saveUsersAdmin = function saveUsersAdmin(state, data) {
  // state.userListAdmin = data;
  console.error("@refactor: not saving user list admin to state", data);
};
var saveGroups = function saveGroups(state, data) {
  state.groupList = data;
};
var saveSubgroups = function saveSubgroups(state, data) {
  state.subgroupList = data;
};
var saveGroupItems = function saveGroupItems(state, data) {
  state.groupitemList = data;
};
var saveGroupUsers = function saveGroupUsers(state, data) {
  state.groupUsers = data;
};
var saveEmails = function saveEmails(state, data) {
  state.emailList = data;
};
var saveInstall = function saveInstall(state, data) {
  state.installs = data;
};
var saveInstalls = function saveInstalls(state, data) {
  state.installss = data;
};
var saveSms = function saveSms(state, data) {
  state.smsList = data;
};
var setGlobalTableOptions = function setGlobalTableOptions(state, data) {
  state.globalTableOptions = data;
};
var setAccess = function setAccess(state, data) {
  state.userAccess = data;
};
var saveDevices = function saveDevices(state, data) {
  state.deviceList = data;
};
var setUser = function setUser(state, data) {
  state.loggedInUser = data;
};
var setUserAmount = function setUserAmount(state, data) {
  state.userAmount = data;
};
var setHome = function setHome(state, data) {
  state.isHome = data;
};
var setDrawerMode = function setDrawerMode(state, data) {
  state.drawerMode = data;
};
var setRole = function setRole(state, data) {
  state.roles = data;
};
var setRoleAdmin = function setRoleAdmin(state, data) {
  state.rolesAdmin = data;
};
var toggleSidebar = function toggleSidebar(state, data) {
  state.isSidebarCollapsed = data;
  console.log("SIDEBAR", state.isSidebarCollapsed);
};
var setTheme = function setTheme(state, data) {
  if (data) {
    state.activeTheme = data;
    // console.log(state.activeTheme);
  } else {
    state.activeTheme = state.defaultTheme;
  }
};

var fillDeviceList = function fillDeviceList(state, list) {
  state.allDevices = list;
};

var devicePayload = function devicePayload(state, list) {
  state.devicePayload = list;
};

var loadingState = function loadingState(state, list) {
  state.loadingState = list;
};

var graphDeviceDetails = function graphDeviceDetails(state, list) {
  // console.log(list.data);

  state.allGraphDevices = list;
};
//uniqueFV
// filteredAllDevices
// filteredOnlineDevices
// uniqueSectors
var uniqueSectors = function uniqueSectors(state, list) {
  state.uniqueSectors = list;
};

var filteredAllDevices = function filteredAllDevices(state, list) {
  state.filteredAllDevices = list;
};

var filteredOnlineDevices = function filteredOnlineDevices(state, list) {
  state.filteredOnlineDevices = list;
};
var filteredOffLineDevices = function filteredOffLineDevices(state, list) {
  state.filteredOffLineDevices = list;
};

var filteredAlarmDevices = function filteredAlarmDevices(state, list) {
  state.filteredAlarmDevices = list;
};
var setCriticalSystems = function setCriticalSystems(state, list) {
  state.criticalSystems = list;
};

var uniqueFV = function uniqueFV(state, list) {
  state.uniqueFV = list;
};
var uniquePaymentModel = function uniquePaymentModel(state, list) {
  state.uniquePaymentModel = list;
};
var onLineDevices = function onLineDevices(state, list) {
  state.onLineDevices = list;
};
var filterFirmWarVersion = function filterFirmWarVersion(state, list) {
  state.filterFirmWarVersion = list;
};
var filterPaymentModel = function filterPaymentModel(state, list) {
  state.filterPaymentModel = list;
};
var filterSectorVal = function filterSectorVal(state, list) {
  state.filterSectorVal = list;
};
var offLineDevices = function offLineDevices(state, list) {
  // state.offLineDevices = list;
  console.log("@refactor: not saving offline devices to state", list);
};
var alarmDevices = function alarmDevices(state, list) {
  // state.alarmDevices = list;
  console.log("@refactor: not saving alarm devices to state", list);
};
var updateWarning = function updateWarning(state, deviceWarning) {
  state.devicesWarning = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.devicesWarning, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, deviceWarning["DeviceID"], deviceWarning["payload"]));
};

var fillOffDeviceList = function fillOffDeviceList(state, list) {
  state.allOffDevices = list;
};
var setPerformanceFilter = function setPerformanceFilter(state, performanceFilter) {
  state.performanceFilter = performanceFilter;
};

var setDeviceCurrentSettings = function setDeviceCurrentSettings(state, currentSettings) {
  state.deviceCurrentSettings = currentSettings;
};

var saveOsCustomer = function saveOsCustomer(state, customer) {
  localStorage.setItem("osCustomer", customer);
  state.osCustomer = customer;
};

var saveCustomerProductOptions = function saveCustomerProductOptions(state, options) {
  state.customerProductOptions = options;
};
var saveOnboanrdingState = function saveOnboanrdingState(state, options) {
  console.log({ options: options });
  state.onboanrdingState = options;
};

var saveOnboardingPackageType = function saveOnboardingPackageType(state, options) {
  state.onboardingPackageType = options;
};

var saveOnboardingCustomerState = function saveOnboardingCustomerState(state, value) {
  state.onboardingCustomerState = value;
};

var saveUserNotifications = function saveUserNotifications(state, data) {
  state.userNotifications = data;
};

var setAssignedDevices = function setAssignedDevices(state, data) {
  state.assignedDevices = data;
};

var setActiveDeviceDaysToExpire = function setActiveDeviceDaysToExpire(state, data) {
  state.activeDeviceDaysToExpire = data;
};

/* harmony default export */ __webpack_exports__["a"] = (_toggleSidebar$device = {
  toggleSidebar: toggleSidebar,
  devicePayload: devicePayload,
  saveUsers: saveUsers,
  loadingState: loadingState,
  saveUsersAdmin: saveUsersAdmin,
  saveGroups: saveGroups,
  saveSubgroups: saveSubgroups,
  saveGroupItems: saveGroupItems,
  saveGroupUsers: saveGroupUsers,
  saveEmails: saveEmails,
  saveSms: saveSms,
  saveDevices: saveDevices,
  saveInstall: saveInstall,
  saveInstalls: saveInstalls
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveDevices", saveDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setUser", setUser), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setUserAmount", setUserAmount), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setAccess", setAccess), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setHome", setHome), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setDrawerMode", setDrawerMode), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "fillDeviceList", fillDeviceList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "fillOffDeviceList", fillOffDeviceList), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "updateWarning", updateWarning), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setRole", setRole), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setRoleAdmin", setRoleAdmin), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setTheme", setTheme), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "graphDeviceDetails", graphDeviceDetails), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "offLineDevices", offLineDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "alarmDevices", alarmDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "onLineDevices", onLineDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "uniqueFV", uniqueFV), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filteredAllDevices", filteredAllDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filteredOnlineDevices", filteredOnlineDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filteredOffLineDevices", filteredOffLineDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filteredAlarmDevices", filteredAlarmDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filterFirmWarVersion", filterFirmWarVersion), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filterSectorVal", filterSectorVal), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "uniqueSectors", uniqueSectors), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "uniquePaymentModel", uniquePaymentModel), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "filterPaymentModel", filterPaymentModel), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setGlobalTableOptions", setGlobalTableOptions), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setPerformanceFilter", setPerformanceFilter), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setCriticalSystems", setCriticalSystems), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setDeviceCurrentSettings", setDeviceCurrentSettings), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveOsCustomer", saveOsCustomer), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveCustomerProductOptions", saveCustomerProductOptions), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveUserNotifications", saveUserNotifications), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setAssignedDevices", setAssignedDevices), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "setActiveDeviceDaysToExpire", setActiveDeviceDaysToExpire), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveOnboanrdingState", saveOnboanrdingState), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveOnboardingPackageType", saveOnboardingPackageType), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_toggleSidebar$device, "saveOnboardingCustomerState", saveOnboardingCustomerState), _toggleSidebar$device);

/***/ }),
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(830);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(1919);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1918 */,
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(831);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(1923);
function injectStyle (ssrContext) {
  __webpack_require__(1921)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1921 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1922 */,
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(833);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(1927);
function injectStyle (ssrContext) {
  __webpack_require__(1925)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1925 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1926 */,
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(1929);
var normalizeComponent = __webpack_require__(2)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(836);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(1932);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1931 */,
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4697ca05_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(3042);
function injectStyle (ssrContext) {
  __webpack_require__(1944)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4697ca05_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1944 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3a92d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1997);
function injectStyle (ssrContext) {
  __webpack_require__(1950)
  __webpack_require__(1951)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c3a92d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c3a92d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1950 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1951 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'menu-background': !_vm.isSidebarCollapsed,
    'menu-bg-short': _vm.isSidebarCollapsed,
    animated: _vm.animated,
    slideIn: _vm.slideIn
  },attrs:{"collapse":_vm.isSidebarCollapsed,"background-color":_vm.getTheme['$background-color'],"text-color":_vm.getTheme['$text-color'],"active-text-color":_vm.getTheme['$active-text-color']}},[_c('div',{class:{ 'center-align': _vm.isSidebarCollapsed }},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],staticStyle:{"max-width":"160px"},attrs:{"src":__webpack_require__(1998),"alt":""}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSidebarCollapsed),expression:"isSidebarCollapsed"}],staticStyle:{"margin":"0 auto"},attrs:{"src":__webpack_require__(1999),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"profile-box",attrs:{"index":"0"}},[_c('router-link',{attrs:{"to":("/profile/edit/" + (this.getUserSession.id))}},[_c('div',{staticClass:"profile-content"},[_c('div',{staticClass:"profile-picture"},[_c('img',{staticClass:"user-avatar",attrs:{"src":__webpack_require__(2000),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],staticClass:"user-details",attrs:{"slot":"title"},slot:"title"},[_vm._v("\n          "+_vm._s(this.getUserSession !== null
              ? this.getUserSession.firstName +
                " " +
                this.getUserSession.lastName
              : "")+"\n          "),_c('div',{staticClass:"user-email"},[_vm._v("\n            "+_vm._s(this.getUserSession !== null ? this.getUserSession.email : "")+"\n          ")])])])])],1),_vm._v(" "),_c('p',{staticClass:"menu-title"},[_vm._v("Menu")]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"demo"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"20"},on:{"click":function($event){return _vm.navTo('dashboardSummary')}}},[_c('i',{staticClass:"fa fa-home icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        Dashboard Summary (Demo)\n      ")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"mine"}},[_c('div',{staticClass:"menu-item",on:{"click":function($event){return _vm.navTo('customerDashboard')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(2001)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Dashboard")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"mine"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"1"},on:{"click":function($event){_vm.isOnboardingLoacation ? null : _vm.navTo('Home')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(849)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Performance")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"1"},on:{"click":function($event){_vm.isOnboardingLoacation ? null : _vm.navTo('Home')}}},[_c('i',{staticClass:"fa fa-home icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Dashboard")])])]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"packages"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"2"},on:{"click":function($event){return _vm.navTo('packages')}}},[_c('i',{staticClass:"fa fa-list icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Product Packages")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"allDevices"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"4"},on:{"click":function($event){return _vm.navTo('devices')}}},[_c('i',{staticClass:"fa fa-desktop icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Installation Management")])])]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"performance"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"3"},on:{"click":function($event){return _vm.navToPath('/performance/live')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(849)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Performance")])])]),_vm._v(" "),_c('can',{attrs:{"I":"see","a":"warnings"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"16"},on:{"click":function($event){return _vm.navTo('warnings')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(850)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Alarm")])])]),_vm._v(" "),_c('can',{attrs:{"I":"see","a":"customerWarning"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"18"},on:{"click":function($event){return _vm.navTo('customerWarnings')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(850)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Alarm")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"user"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"5"},on:{"click":function($event){return _vm.navToPath('/user_management/users')}}},[_c('i',{staticClass:"fa fa-user-plus icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Users Management")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"bills"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"25"},on:{"click":function($event){return _vm.navToPath('/admin-billing')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(851)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Billing")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"bills"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"26"},on:{"click":function($event){return _vm.navToPath('/admin-transaction-history')}}},[_c('i',{staticClass:"fa fa-history icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Transaction History")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"onbbb"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"16"},on:{"click":function($event){return _vm.navToPath('/customer_admin/customers')}}},[_c('i',{staticClass:"fa fa-list-alt icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("\n        Customer Admin Onboarding\n      ")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"payment"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"16"},on:{"click":function($event){return _vm.navToPath('/customer_payment/payment_schedule')}}},[_c('i',{staticClass:"fa fa-list-alt icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Payment")])])]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"inventorygg"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"6"},on:{"click":function($event){return _vm.navTo('inventory')}}},[_c('i',{staticClass:"fa fa-list-alt icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Inventory")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"customer"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"7"},on:{"click":function($event){return _vm.navTo('customers')}}},[_c('i',{staticClass:"fa fa-users icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Customers")])])]),_vm._v(" "),_c('can',{attrs:{"I":"see","a":"maintenance"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"8"},on:{"click":function($event){return _vm.navTo('support')}}},[_c('i',{staticClass:"fa fa-wrench icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Maintenance")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"report"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"9"},on:{"click":function($event){return _vm.navTo('reports')}}},[_c('i',{staticClass:"fa fa-file icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Reports")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"allDevices"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"10"},on:{"click":function($event){return _vm.navTo('invoices')}}},[_c('i',{staticClass:"fa fa-receipt icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Invoices")])])]),_vm._v(" "),_c('can',{attrs:{"I":"see","a":"proforma"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"15"},on:{"click":function($event){return _vm.navTo('proforma')}}},[_c('i',{staticClass:"fa fa-desktop icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Proforma")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"allDevices"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"19"},on:{"click":function($event){return _vm.navTo('devices-status')}}},[_c('i',{staticClass:"fa fa-exclamation-triangle icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Device Expiry Report")])])]),_vm._v(" "),_c('can',{attrs:{"I":"see","a":"billing"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"23"},on:{"click":function($event){return _vm.navTo('billing')}}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(851)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Billing")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"onboardingTracker"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"21"},on:{"click":function($event){return _vm.navTo('onboarding-tracker')}}},[_c('i',{staticClass:"fa fa-desktop icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Onboarding Tracker")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"onboardingTracker"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"7"},on:{"click":function($event){return _vm.navTo('lux-onboarding')}}},[_c('i',{staticClass:"fa fa-desktop icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Lux Onboarding")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"subsmanager"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"11"},on:{"click":function($event){return _vm.navTo('subsmanager')}}},[_c('i',{staticClass:"fa fa-exclamation-circle icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Recurring Invoice Mgmt.")])])]),_vm._v(" "),_c('can',{attrs:{"I":"am","a":"sudo"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"17"},on:{"click":function($event){return _vm.navTo('reportConfig')}}},[_c('i',{staticClass:"fa fa-cog icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Report Config")])])]),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"alarmConfig"}},[_c('div',{staticClass:"menu-item",attrs:{"index":"13"},on:{"click":function($event){return _vm.navTo('alarmConfig')}}},[_c('i',{staticClass:"fa fa-bell-o icon-side"}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Alarm Config")])])]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('div',{staticClass:"menu-item",attrs:{"index":"14"},on:{"click":_vm.logout}},[_c('img',{class:{ 'smaller-img': _vm.isSidebarCollapsed },attrs:{"src":__webpack_require__(2002)}}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSidebarCollapsed),expression:"!isSidebarCollapsed"}],attrs:{"slot":"title"},slot:"title"},[_vm._v("Logout")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/white-logo.0632dbf.svg";

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/white-logo-strip.80f22c9.svg";

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2001 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAzCAYAAADCQcvdAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAG3SURBVHgB7ZqNTcMwEIWvqAN0hDABHaEjlAnoBnSDdoOwAWxQmIARgAnSDWCDx51ioQoSX35s4ov8Sae2in25Z/nnJSpRJpMRANxzfLo40JxgQSX+UpJ1WMSK4xHtnKQNWcSJe4OOtCnIElIwR4XuVGZEDhBnRyQXuIZf3NGFT+SaUoQL26A+AtrYXbTde9pJji2lBBd0pxS8aeizhX9A9pQCXMjBU2QFz5SDPqWnNQQdxBUdcmib0jQi0exOeom7yKWJ/D/XA92dyMHd2504kT5jEN/1QHcnT2OKcPlPyuAVFAPo0+iBAiG5PPepgovsIO5IgYFuCAoKATq4E4oEYrse9HAnsUAs14MB7iQWCO16MMKdxAL1UvGJ7GYIFHHCK02E3Fup7aAlKKGTskChbOqouRNLAoUf17N0X6ToNB80hyE7q5zdt0v348XFb27c9ZR55vhoubYhHzwCOwNTdOfrc0UzJwu0ThZonSzQOrMXuKRAIPzz4ftisfiikQQRiPr9SGiHU3CMFpjXoHXyJtODMyVIEIG8253545oSJK9B6+RNpoEVDP1xZ4hAeftWkRHyGrTONwzF+C+cZpx3AAAAAElFTkSuQmCC"

/***/ }),
/* 2002 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA0CAYAAADfRPtlAAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAL2SURBVHgB7ZrxddowEMYPXv4vG8QblExQukE6QekEoROEDcgGTidgBJMJSCcwmYBs8PXuSXGII1myLYHs19979+AhbOuT7s7S2UT/GTYTCgyAjD/mbPI5Y7s+aX5he2V7FptMJq+UOixoxrZgy9mOaEepj7ul1JCZYtt0EOUSm9El0cJyxCW/iFC+6B3CzZiLkm1JPfFKMno0c7YF+XEglUgkibyc/C4JJyOVhGZ+p6JHtt/REhKUS5YeI16wrdi8Oq7Pu9TH+cxmRqHhk87R7JLStvYV1XAdEft4VpEe4goEHlUttIguEs1uKaJXFBHtFUFETiwXKEklgzoHth8c8M8UGfEg/rizNP/lPjxQxxNvQoxckmjXHKc4Afa4S2+t2Baoe5KJNY0By+yVlBDoer+F2u6YWFJCcH+26HKLgnl3kNTsCXhfBNy3PbBMffYEfFzlyPfM56C5xT3dB58ZfF7Gla5+Tsm8BZJ6yYHSJ2PbN8WlCPxm+P2JhoNk1o0tLqdk3njuaHisTXF5ReZFde/ds75nbSksc0f7gk1Efq9CzJJgrqknsK9rz0G1pbuicfIWl1+mNF4kzJ6mFCDeEkQ25DcchztxURFYz6Q39LHc1wU57y8Ki9wKMsd//rCtqjIj1AK2TtSaS1fgLjF+6rfMoGmmvtKwkNmSWtGu3iAxaCogDWkHX8WbsRX2+9WCEsPgolIsdm+C+U97g8BuZbmI1AT65wmYC61H9CzJh0YLPLb2LqintCbWlBBQNduMugBzCj5iDPVQAfbCU0FjAfZHWO2KPKmiY9H2yOwnjQGop7QYu8iHBpFncVe5DlTVzGT9Blq76r5BZI5I2RXup7xhyiBaZNlwIWlbUkD0rDU9NpdBD7f40KPZNJOV0K4X1gN5D/f7NwVirKx0B1xvQEB3cKvFzh3nlGr6Cu9LLxfx18VofjHARqlFiO3h977NKdFfeKiL9HHZUBS41DIRyg1LxKFAKntR7sgtzDWdtrzF74IC8w+xUmcjK+DODAAAAABJRU5ErkJggg=="

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__ = __webpack_require__(852);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f19104_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__ = __webpack_require__(3029);
function injectStyle (ssrContext) {
  __webpack_require__(2004)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01f19104"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01f19104_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2004 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2005 */,
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(853);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b78f9b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(2018);
function injectStyle (ssrContext) {
  __webpack_require__(2007)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b78f9b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b78f9b4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2007 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('div',{staticClass:"half-circle-spinner"},[_c('div',{staticClass:"circle circle-1"}),_vm._v(" "),_c('div',{staticClass:"circle circle-2"})]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Loading, please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"material-input__component",class:_vm.computedClasses},[(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"email","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),(_vm.type === 'url')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"url","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"number","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"max":_vm.max,"min":_vm.min,"step":_vm.step,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"password","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"max":_vm.max,"min":_vm.min,"step":_vm.step,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"tel","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),(_vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.valueCopy),expression:"valueCopy"}],staticClass:"material-input",attrs:{"type":"text","name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"autocomplete":_vm.autocomplete,"minlength":_vm.minlength,"maxlength":_vm.maxlength,"required":_vm.required},domProps:{"value":(_vm.valueCopy)},on:{"focus":function($event){return _vm.handleFocus(true)},"blur":function($event){return _vm.handleFocus(false)},"input":[function($event){if($event.target.composing){ return; }_vm.valueCopy=$event.target.value},_vm.handleModelInput]}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"material-input-bar"}),_vm._v(" "),_c('label',{staticClass:"material-label"},[_vm._t("default")],2),_vm._v(" "),(_vm.errorMessages)?_c('div',{staticClass:"material-errors"},_vm._l((_vm.computedErrors),function(error,key){return _c('div',{key:key,staticClass:"material-error"},[_vm._v("\n      "+_vm._s(error)+"\n    ")])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_c('img',{staticClass:"logo-cover",staticStyle:{"width":"150px"},attrs:{"src":__webpack_require__(214)}}),_vm._v(" "),(_vm.slider == 'slider1')?_c('div',{staticClass:"slider slider1"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider2')?_c('div',{staticClass:"slider slider2"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider3')?_c('div',{staticClass:"slider slider3"},[_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-side"},[_c('p',{staticClass:"alt-text"},[_vm._v("\n      Have an account?\n      "),_c('router-link',{staticClass:"signup-link",attrs:{"to":"/auth/login"}},[_vm._v("Sign In")])],1),_vm._v(" "),_c('div',{staticClass:"register-form"},[_c('div',{staticClass:"form-box"},[_c('div',{staticClass:"main-form-box"},[_c('div',{staticClass:"styled-header"}),_vm._v(" "),_c('form',{staticClass:"form-container",on:{"submit":_vm.submitForm}},[_c('h3',[_vm._v("Create Account")]),_vm._v(" "),_c('p',[_vm._v("Let’s get you started! This will only take a few minutes")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.firstname),expression:"regParams.firstname"}],class:['input', _vm.formErrors.firstname ? 'error' : ''],attrs:{"type":"text","placeholder":"First name","required":""},domProps:{"value":(_vm.regParams.firstname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "firstname", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.firstname)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.firstname)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.lastname),expression:"regParams.lastname"}],class:['input', _vm.formErrors.lastname ? 'error' : ''],attrs:{"type":"text","placeholder":"Last name","required":""},domProps:{"value":(_vm.regParams.lastname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "lastname", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.lastname)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.lastname)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.phonenumber),expression:"regParams.phonenumber"}],class:[
                  'input',
                  _vm.formErrors.phonenumber ? 'error' : ''
                ],attrs:{"type":"text","placeholder":"Phone Number","required":""},domProps:{"value":(_vm.regParams.phonenumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "phonenumber", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.phonenumber)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.phonenumber)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.email),expression:"regParams.email"}],class:['input', _vm.formErrors.email ? 'error' : ''],attrs:{"type":"email","placeholder":"Email Address","required":""},domProps:{"value":(_vm.regParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "email", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.email)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.email)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.password),expression:"regParams.password"}],class:['input', _vm.formErrors.password ? 'error' : ''],attrs:{"type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.regParams.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "password", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.password)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.password)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.cpassword),expression:"regParams.cpassword"}],class:['input', _vm.formErrors.cpassword ? 'error' : ''],attrs:{"type":"password","placeholder":"Confirm Password","required":""},domProps:{"value":(_vm.regParams.cpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "cpassword", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.cpassword)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.formErrors.cpassword)+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.loader)?_c('button',{staticClass:"form-button"},[_vm._m(3)]):_c('button',{staticClass:"form-button",on:{"click":_vm.submitForm}},[_vm._v("\n              Sign up\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li',{staticClass:"active"}),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li',{staticClass:"active"}),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li',{staticClass:"active"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(858);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a713ac0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(2021);
function injectStyle (ssrContext) {
  __webpack_require__(2020)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a713ac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a713ac0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_c('img',{staticClass:"logo-cover",staticStyle:{"width":"150px"},attrs:{"src":__webpack_require__(214)}}),_vm._v(" "),(_vm.slider == 'slider1')?_c('div',{staticClass:"slider slider1"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider2')?_c('div',{staticClass:"slider slider2"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider3')?_c('div',{staticClass:"slider slider3"},[_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-side"},[_c('p',{staticClass:"alt-text"},[_vm._v("\n      Don't have an account?\n      "),_c('router-link',{staticClass:"signup-link",attrs:{"to":"/auth/register"}},[_vm._v("Sign Up")])],1),_vm._v(" "),_c('div',{staticClass:"register-form"},[_c('div',{staticClass:"form-box"},[_c('div',{staticClass:"main-form-box"},[_c('div',{staticClass:"styled-header"}),_vm._v(" "),_c('form',{staticClass:"form-container",attrs:{"action":"#"}},[_c('h3',[_vm._v("Enter your details")]),_vm._v(" "),_c('p',[_vm._v("Kindly enter your details below!")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginParams.email),expression:"loginParams.email"}],class:['input', _vm.loginErrors.email ? 'error' : ''],attrs:{"type":"email","placeholder":"Email Address","required":""},domProps:{"value":(_vm.loginParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginParams, "email", $event.target.value)}}}),_vm._v(" "),(_vm.loginErrors.email)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.loginErrors.email)+"\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.loginParams.password),expression:"loginParams.password"}],class:['input', _vm.loginErrors.password ? 'error' : ''],attrs:{"type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.loginParams.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.loginParams, "password", $event.target.value)}}}),_vm._v(" "),(_vm.loginErrors.password)?_c('small',{staticClass:"error"},[_vm._v("\n                "+_vm._s(_vm.loginErrors.password)+"\n              ")]):_vm._e()]),_vm._v(" "),(_vm.loader)?_c('button',{staticClass:"form-button"},[_vm._m(3)]):_c('button',{staticClass:"form-button",on:{"click":_vm.submitLogin}},[_vm._v("\n              Login\n            ")]),_vm._v(" "),_c('router-link',{staticClass:"signup-link",attrs:{"to":"/auth/forgot-password"}},[_vm._v("Forgot Password?\n            ")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li',{staticClass:"active"}),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li',{staticClass:"active"}),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li',{staticClass:"active"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(859);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02011f4f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(2024);
function injectStyle (ssrContext) {
  __webpack_require__(2023)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02011f4f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02011f4f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[_c('h1',[_vm._v("Error")]),_vm._v(" "),_c('div',[_c('br'),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$can('anon')),expression:"!$can('anon')"}],attrs:{"size":"md","variant":"danger"},on:{"click":_vm.logout}},[_vm._v("\n        Logout\n      ")]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.$can('anon')),expression:"$can('anon')"}],attrs:{"size":"md","variant":"primary"},on:{"click":_vm.login}},[_vm._v("\n        Login\n      ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPassword_vue__ = __webpack_require__(860);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb55cce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPassword_vue__ = __webpack_require__(2029);
function injectStyle (ssrContext) {
  __webpack_require__(2026)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1eb55cce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb55cce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2027 */,
/* 2028 */,
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[_c('div',{staticClass:"p-signup",staticStyle:{"vertical-align":"middle"}},[(!_vm.regSuccess)?_c('form',{staticClass:"p-signup__form",attrs:{"action":"#"},on:{"submit":function($event){$event.preventDefault();return _vm.submitRequest.apply(null, arguments)}}},[_c('img',{staticClass:"p-signin-a__form-heading",attrs:{"src":"https://arnergy.com/logo.png","alt":"","height":"50px;"}}),_vm._v(" "),_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Reset Password")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-set-password"}},[_vm._v("Set Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.newPassword),expression:"regParams.newPassword"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","id":"p-signup-set-password","placeholder":"Password "},domProps:{"value":(_vm.regParams.newPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "newPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-repeat-password"}},[_vm._v("Repeat Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpassword),expression:"cpassword"}],staticClass:"form-control form-control-lg",attrs:{"type":"password","id":"p-signup-repeat-password","placeholder":"Repeat Password "},domProps:{"value":(_vm.cpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpassword=$event.target.value}}})])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"type":"submit"},on:{"click":_vm.submitRequest}},[_vm._v("CONTINUE")])])],1)]):_vm._e(),_vm._v(" "),(_vm.regSuccess)?_c('div',{staticClass:"p-signup__form",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"fa fa-key fa-fw",staticStyle:{"font-size":"12em","color":"#192a3e","margin-top":"20px"}}),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content",staticStyle:{"font-size":"14px","color":"#192a3e","text-align":"center"}},[_c('h4',[_vm._v("Your password has been reset!")]),_vm._v(" "),_c('router-link',{staticClass:"link-info",attrs:{"to":"/auth/login"}},[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit"},[_vm._v("LOGIN")])])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(861);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2e9ed7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(2032);
function injectStyle (ssrContext) {
  __webpack_require__(2031)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c2e9ed7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2e9ed7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register-container"},[_c('img',{staticClass:"logo-cover",staticStyle:{"width":"150px"},attrs:{"src":__webpack_require__(214)}}),_vm._v(" "),(_vm.slider == 'slider1')?_c('div',{staticClass:"slider slider1"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider2')?_c('div',{staticClass:"slider slider2"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.slider == 'slider3')?_c('div',{staticClass:"slider slider3"},[_vm._m(2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-side"},[_c('p',{staticClass:"alt-text"},[_vm._v("\n      Remember now? \n      "),_c('router-link',{staticClass:"signup-link",attrs:{"to":"/auth/login"}},[_vm._v("Login")])],1),_vm._v(" "),_c('div',{staticClass:"register-form"},[_c('div',{staticClass:"form-box"},[_c('div',{staticClass:"main-form-box"},[_c('form',{staticClass:"form-container",attrs:{"action":"#"}},[(_vm.regSuccess)?_c('div',{staticClass:"reset-form"},[_c('h3',{staticClass:"big-text success"},[_vm._v("Success!")]),_vm._v(" "),_c('p',{staticClass:"small-text success"},[_vm._v("A password recovery email has been sent to your inbox")]),_vm._v(" "),_c('button',{staticClass:"form-button",attrs:{"type":"button"},on:{"click":_vm.goToLogin}},[_vm._v("\n                Login\n              ")])]):_c('div',{staticClass:"reset-form"},[_c('h3',{staticClass:"big-text"},[_vm._v("Forgot password")]),_vm._v(" "),_c('p',{staticClass:"small-text"},[_vm._v("Kindly enter your email below!")]),_vm._v(" "),_c('div',{staticClass:"input-box"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.email),expression:"regParams.email"}],staticClass:"input",attrs:{"type":"email","placeholder":"Email Address","required":""},domProps:{"value":(_vm.regParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "email", $event.target.value)}}})]),_vm._v(" "),(_vm.loader)?_c('button',{staticClass:"form-button"},[_vm._m(3)]):_c('button',{staticClass:"form-button",on:{"click":_vm.submitRequest}},[_vm._v("Reset Password")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li',{staticClass:"active"}),_vm._v(" "),_c('li'),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li',{staticClass:"active"}),_vm._v(" "),_c('li')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-base"},[_c('div',{staticClass:"slider-text"},[_c('h3',[_vm._v("Have amazing access to Electricity")]),_vm._v(" "),_c('p',[_vm._v("\n          Arnergy is for anyone who longs for easier and convienient ways to\n          get energy supply\n        ")])]),_vm._v(" "),_c('ul',{staticClass:"slider-state"},[_c('li'),_vm._v(" "),_c('li'),_vm._v(" "),_c('li',{staticClass:"active"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailConfirmed_vue__ = __webpack_require__(862);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715773dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailConfirmed_vue__ = __webpack_require__(2035);
function injectStyle (ssrContext) {
  __webpack_require__(2034)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-715773dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailConfirmed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_715773dc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailConfirmed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[_c('div',{staticClass:"p-signup",staticStyle:{"vertical-align":"middle"}},[(_vm.shouldNotBeHere)?_c('div',[_c('Center',[_c('h1',[_vm._v("You probably shouldn't be here")])])],1):_vm._e(),_vm._v(" "),(!_vm.regSuccess)?_c('form',{staticClass:"p-signup__form"},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Verify Email")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))])],1)]):_vm._e(),_vm._v(" "),(_vm.regSuccess)?_c('div',{staticClass:"p-signup__form",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"fa fa-thumbs-up fa-fw",staticStyle:{"font-size":"12em","color":"#0b75c1"}}),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content",staticStyle:{"font-size":"14px","text-align":"center"}},[_vm._v("\n        Email verified successfully\n        "),_c('router-link',{staticClass:"link-info btn btn-info",attrs:{"to":("/auth/new-password/" + (_vm.regParams.userId) + "/" + (_vm.regParams.accessToken))}},[_vm._v("Continue")])],1)]):_vm._e(),_vm._v(" "),(!_vm.regSuccess)?_c('div',{staticClass:"p-signup__form",staticStyle:{"text-align":"center"}},[_c('span',{staticClass:"fa fa-exclamation-triangle fa-fw",staticStyle:{"font-size":"12em","color":"#0b75c1"}}),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content",staticStyle:{"font-size":"14px","text-align":"center"}},[_vm._v("\n        Email verification not successful, back to\n        "),_c('router-link',{staticClass:"link-info",attrs:{"to":"/auth/login"}},[_vm._v("Sign In")])],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateToken_vue__ = __webpack_require__(863);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8b244b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateToken_vue__ = __webpack_require__(2041);
function injectStyle (ssrContext) {
  __webpack_require__(2037)
  __webpack_require__(2038)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GenerateToken_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8b244b6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GenerateToken_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b',{staticClass:"hide"},[_vm._v("#"+_vm._s(_vm.item.id))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.item.name)+": "+_vm._s(_vm.item.deviceType.name))]),_vm._v(" "),_c('abbr',[_vm._v(_vm._s(_vm.item.solarKitIds))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2040 */,
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"content-heading"},[_vm._v("Recharge Device")]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('form-wizard',{attrs:{"color":"#269af1","step-size":"sm"},on:{"on-complete":_vm.finishGeneration}},[_c('h2',{attrs:{"slot":"title"},slot:"title"}),_vm._v(" "),_c('tab-content',{attrs:{"title":"Device ID","icon":"fa fa-building-o","before-change":_vm.checkValidation}},[_c('b-modal',{ref:"myModalRef",attrs:{"centered":"","hide-footer":"","title":"PIN Number"}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v(_vm._s(_vm.myResponse))])]),_vm._v(" "),_c('b-btn',{staticClass:"mt-3 ok",attrs:{"variant":"outline-danger","block":""},on:{"click":_vm.hideModal}},[_vm._v("Close Me")])],1),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{attrs:{"for":"inverter-number"}},[_vm._v("Inverter Number")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.items,"placeholder":"Please Enter Inverter Number","required":"","get-label":_vm.getLabel,"component-item":_vm.template},on:{"update-items":_vm.updateItems},model:{value:(_vm.formData.item),callback:function ($$v) {_vm.$set(_vm.formData, "item", $$v)},expression:"formData.item"}})],1)])])],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Duration Info","icon":"iconfont iconfont-clock","before-change":_vm.concludeTransaction}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.carddetail==false),expression:"carddetail==false"}],staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"heading",staticStyle:{"text-align":"center"}},[_c('h5',[_vm._v("Note that the token will be send to the details below:\n                 "),_vm._v(" "),_c('br'),(_vm.formData.item !==null)?_c('b',[_vm._v("Name: "+_vm._s(_vm.formData.item.name))]):_vm._e(),_vm._v(" "),_c('br'),(_vm.formData.item !==null)?_c('b',[_vm._v("Email: "+_vm._s(_vm.formData.item.user.email))]):_vm._e(),_vm._v(" "),_c('br'),(_vm.formData.item !==null)?_c('b',[_vm._v("Phone Number: "+_vm._s(_vm.formData.item.user.phoneNumber))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"duration"}},[_vm._v("Duration")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3 form-control form-control-lg",attrs:{"options":_vm.options},model:{value:(_vm.formData.duration),callback:function ($$v) {_vm.$set(_vm.formData, "duration", $$v)},expression:"formData.duration"}})],1)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:((_vm.formData.duration*_vm.initAmt>_vm.getUserSession.wallet)),expression:"(formData.duration*initAmt>getUserSession.wallet)"}],attrs:{"title":"Payment","icon":"iconfont iconfont-widget-money"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"background":"#ffffff"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"wallet"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.carddetail==false),expression:"carddetail==false"}],staticClass:"payment"},[_c('div',{staticClass:"heading"},[_c('h1',[_vm._v("Make Payment")]),_vm._v(" "),_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v("To complete this transaction additional payment of \n                 "+_vm._s((_vm.initAmt * _vm.formData.duration) - _vm.getUserSession.wallet)+"\n                 has to be made or fund you wallet direct here\n                 "),_c('b-btn',{attrs:{"variant":"info","size":"sm","to":"/shs/pay?type=wallet"},on:{"click":function($event){_vm.paymentFormSelected = "wallet funding"}}},[_vm._v("\n             Fund Wallet\n           ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-group cardno",attrs:{"id":"cardno-field"}},[_c('label',{attrs:{"for":"cardNumber"}},[_vm._v("Card Number")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"XXXX XXXX XXXX XXXX","id":"ccnum"},on:{"input":_vm.cardValidate},model:{value:(_vm.formData.cardno),callback:function ($$v) {_vm.$set(_vm.formData, "cardno", $$v)},expression:"formData.cardno"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group owner"},[_c('label',{attrs:{"for":"owner"}},[_vm._v("Card Name")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"John Doe"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group CVV"},[_c('label',{attrs:{"for":"cvv"}},[_vm._v("CVV")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"123","id":"cvc"},model:{value:(_vm.formData.cvv),callback:function ($$v) {_vm.$set(_vm.formData, "cvv", $$v)},expression:"formData.cvv"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group CVV"},[_c('label',{attrs:{"for":"pin"}},[_vm._v("PIN")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"XXXX","id":"pin"},model:{value:(_vm.formData.pin),callback:function ($$v) {_vm.$set(_vm.formData, "pin", $$v)},expression:"formData.pin"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group expiration-date"},[_c('label',{attrs:{"for":"expiry"}},[_vm._v("Expire Date")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"12 / 21","id":"expiry"},model:{value:(_vm.formData.expiry),callback:function ($$v) {_vm.$set(_vm.formData, "expiry", $$v)},expression:"formData.expiry"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group owner",attrs:{"id":"owner"}},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"email","placeholder":"mymail@mail.com","id":"email"},model:{value:(_vm.formData.email),callback:function ($$v) {_vm.$set(_vm.formData, "email", $$v)},expression:"formData.email"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group cardno"},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Phone No")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg cc-number",attrs:{"type":"tel","placeholder":"08011111111","id":"mobile"},model:{value:(_vm.formData.phonenumber),callback:function ($$v) {_vm.$set(_vm.formData, "phonenumber", $$v)},expression:"formData.phonenumber"}})],1),_vm._v(" "),_c('div',{staticStyle:{"clear":"both"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":_vm.confirmPayment}},[_vm._v("Confirm")])]),_vm._v(" "),_c('div',{staticClass:"form-group cardtype"},[_c('img',{staticClass:"transparent",attrs:{"src":__webpack_require__(2042),"id":"visa"}}),_vm._v(" "),_c('img',{staticClass:"transparent",attrs:{"src":__webpack_require__(2043),"id":"mastercard"}}),_vm._v(" "),_c('img',{staticClass:"transparent",attrs:{"src":__webpack_require__(2044),"id":"amex"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.carddetail==true),expression:"carddetail==true"}],staticClass:"payment2"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Your Transaction Reference is \n                       "),_c('b',[_vm._v(_vm._s(_vm.transactionReference))]),_vm._v(" \n                       please supply the otp sent to your mobile to complete the Transaction")])]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"please supply otp","id":"otp"},model:{value:(_vm.otp),callback:function ($$v) {_vm.otp=$$v},expression:"otp"}})],1)])])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Transaction Status","icon":"fa fa-ticket"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tokenGenerated === true),expression:"tokenGenerated === true"}],staticClass:"widget_box"},[_c('figcaption',[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "),_c('h2',[_vm._v("Successful")]),_vm._v(" "),(_vm.transactionReference !==null )?_c('b',[_vm._v(" Wallet transaction Reference is: "+_vm._s(_vm.transactionReference))]):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("solar Kit Id: "),_c('b',[_vm._v(_vm._s((_vm.myResponse !== null) ? _vm.myResponse.solarKitId:'-'))])]),_vm._v(" "),_c('h3',[_vm._v("No of Days: "),_c('b',[_vm._v(_vm._s((_vm.myResponse !== null) ?_vm.formData.duration:'-'))])]),_vm._v(" "),(_vm.myResponse.token !== null)?_c('h3',[_vm._v("Token Generated: "+_vm._s((_vm.myResponse !== null) ? _vm.numberWithSpaces(_vm.myResponse.token) : '-'))]):_vm._e(),_vm._v(" "),(_vm.myResponse.token === null)?_c('h3',[_vm._v("Expiry Date: "+_vm._s((_vm.myResponse !== null)? _vm.myResponse.expiry : '-'))]):_vm._e()])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tokenGenerated === false),expression:"tokenGenerated === false"}],staticClass:"widget_box"},[_c('figcaption',[_vm._v("\n                       Transaction in Progress ... \n                     ")]),_vm._v(" "),_c('h6',[_vm._v("Note: If your wallet balance is lesser than your transaction, Please make payment before you proceed\n                       "),_c('b-btn',{attrs:{"variant":"info","size":"sm","to":"/shs/pay?type=wallet"},on:{"click":function($event){_vm.paymentFormSelected = "wallet funding"}}},[_vm._v("\n             Fund Wallet\n           ")])],1)])])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2042 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2043 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2044 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenHistory_vue__ = __webpack_require__(868);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca81421_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenHistory_vue__ = __webpack_require__(2047);
function injectStyle (ssrContext) {
  __webpack_require__(2046)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TokenHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca81421_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TokenHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('h2',{staticClass:"content-heading"},[_vm._v("Token History")]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"paginate":true,"globalSearch":true,"lineNumbers":true,"styleClass":"table table-striped col-md-12"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('td',{staticClass:"fancy",attrs:{"data-label":"User"}},[_vm._v(_vm._s(props.row.user))]),_vm._v(" "),_c('td',{staticClass:"fancy",attrs:{"data-label":"Token"}},[_vm._v(_vm._s(props.row.token))]),_vm._v(" "),_c('td',{staticClass:"fancy",attrs:{"data-label":"Date"}},[_vm._v(_vm._s(props.row.date))])]}}])})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"400px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.usersLists,"select-options":_vm.selectOption,"search-options":{enabled: true, 
      searchFn: _vm.searchTable,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstName)+" "+_vm._s(props.row.lastName))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionResponse_vue__ = __webpack_require__(870);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c6dbd2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionResponse_vue__ = __webpack_require__(2052);
function injectStyle (ssrContext) {
  __webpack_require__(2051)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionResponse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42c6dbd2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionResponse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"containerm container-fh",attrs:{"id":"transc_success"}},[_c('div',{staticClass:"main-container container-fh__content p-trial-period-expired",staticStyle:{"padding":"0px"}},[(_vm.TranscResp.status !== 'successful')?_c('img',{staticClass:"p-trial-period-expired__image",attrs:{"src":"/static/img/modal/3.svg","alt":"","width":"200px"}}):_vm._e(),_vm._v(" "),(_vm.TranscResp.status === 'successful')?_c('img',{staticClass:"p-trial-period-expired__image",attrs:{"src":"/static/img/modal/2.svg","alt":"","width":"200px"}}):_vm._e(),_vm._v(" "),_c('div',[_c('h2',{staticClass:"p-trial-period-expired__heading"},[_vm._v("Transaction "+_vm._s(_vm.TranscResp.status)+"!")]),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v(_vm._s(_vm.getUserSession.firstName + ' '+ _vm.getUserSession.lastName))]),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v(_vm._s(_vm.getUserSession.phoneNumber))]),_vm._v(" "),_vm._l((_vm.TranscResp.data),function(single,index){return (index !== 'UserID')?_c('div',{key:index,staticClass:"p-trial-period-expired__desc"},[_vm._v(_vm._s((index + ": " + single)))]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v("Date: ")]),_vm._v(" "),_vm._m(0)],2)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-trial-period-expired__upgrade"},[_c('a',{staticClass:"btn btn-info",attrs:{"href":"/"}},[_vm._v("Go back home")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transDone === false),expression:"transDone === false"}],staticClass:"row"},[_c('div',{staticClass:"col-12 creditCardForm"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"payment"},[_c('div',{staticClass:"form-group owner",attrs:{"id":"owner"}},[_c('label',{attrs:{"for":"owner"}},[_vm._v("Owner")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"John Doe"},model:{value:(_vm.formData.name),callback:function ($$v) {_vm.$set(_vm.formData, "name", $$v)},expression:"formData.name"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group expiration-date",attrs:{"id":"phone"}},[_c('label',{attrs:{"for":"mobile"}},[_vm._v("Phone No")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg cc-number",attrs:{"type":"tel","placeholder":"08011111111","id":"mobile"},model:{value:(_vm.formData.phonenumber),callback:function ($$v) {_vm.$set(_vm.formData, "phonenumber", $$v)},expression:"formData.phonenumber"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group cardno",attrs:{"id":"email"}},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"type":"email","placeholder":"mymail@mail.com","id":"email"},model:{value:(_vm.formData.email),callback:function ($$v) {_vm.$set(_vm.formData, "email", $$v)},expression:"formData.email"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group expiration-date",attrs:{"id":"amount"}},[_c('label',{attrs:{"for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('b-form-input',{staticClass:"form-control form-control-lg",attrs:{"placeholder":"20000.00","type":"currency"},model:{value:(_vm.formData.amount),callback:function ($$v) {_vm.$set(_vm.formData, "amount", $$v)},expression:"formData.amount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"width":"100%","text-align":"center"}},[_c('div',{staticClass:"App",staticStyle:{"display":"none"}},[_c('p',{staticClass:"App-intro"},[_c('Rave',{attrs:{"is-production":true,"text":_vm.raveBtnText,"style-class":"paymentbtn","id":"paymentbtn","email":_vm.formData.email,"amount":_vm.formData.amount,"reference":_vm.reference,"rave-key":_vm.raveKey,"callback":_vm.callback,"close":_vm.close,"currency":"NGN","customer_firstname":_vm.formData.firstname,"customer_lastname":_vm.formData.lastname,"customer_phone":_vm.formData.phonenumber}})],1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",staticStyle:{"width":"40%","background-color":"#ffb946"},attrs:{"type":"button"},on:{"click":_vm.confirmPayment}},[_vm._v("Proceed")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transDone === true),expression:"transDone === true"}],staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transComplete === true),expression:"transComplete === true"}],staticClass:"widget_box"},[_c('figcaption',[_c('p',[_vm._v("\n          Transaction Completed with Reference ID:\n          "),(_vm.myResponse)?_c('b',[_vm._v(_vm._s(_vm.myResponse.detail.flwref))]):_vm._e()]),_vm._v(" "),_c('div',[_vm._v("\n          Comfirm your transaction details below:\n          "),(_vm.myResponse)?_c('p',[_c('b',[_vm._v("Full Name")]),_vm._v("\n            "+_vm._s(_vm.myResponse.detail.custname)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.myResponse)?_c('p',[_c('b',[_vm._v("Transaction Medium")]),_vm._v("\n            "+_vm._s(_vm.myResponse.detail.paymenttype)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.myResponse)?_c('p',[_c('b',[_vm._v("Amount")]),_vm._v("\n            "+_vm._s(_vm.myResponse.detail.amount)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.myResponse)?_c('p',[_c('b',[_vm._v("Charged Amount")]),_vm._v("\n            "+_vm._s(_vm.myResponse.detail.chargedamount)+"\n          ")]):_vm._e()]),_vm._v(" "),_c('b-btn',{attrs:{"to":"/home","variant":"info"}},[_c('span',{staticClass:"sidebar-collapse-text"},[_vm._v("Done")])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.transComplete === false),expression:"transComplete === false"}],staticClass:"widget_box"},[_c('figcaption',[_vm._v("Transaction in Progress ...")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h3',[_vm._v("Fund Wallet")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__ = __webpack_require__(873);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_711d7bdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__ = __webpack_require__(2058);
function injectStyle (ssrContext) {
  __webpack_require__(2056)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_New_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_711d7bdb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_New_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2056 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'open':_vm.openSuggestion},staticStyle:{"position":"relative"}},[_c('input',{staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.updateValue($event.target.value)},"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.enter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.down.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.up.apply(null, arguments)}]}}),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",staticStyle:{"width":"100%","max-height":"200px","overflow-y":"auto"}},_vm._l((_vm.matches),function(suggestion,index){return _c('li',{key:index,class:{'active': _vm.isActive(index)},on:{"click":function($event){return _vm.suggestionClick(index)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.displayText(suggestion)))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('form-wizard',{attrs:{"title":"Add New Device","subtitle":"","color":"#269af1"},on:{"on-complete":_vm.onSubmit}},[_c('tab-content',{attrs:{"title":"Customer details","icon":"fa fa-user","before-change":_vm.beforeDeviceDetails}},[_c('b-card',{staticClass:"section-container"},[_c('b-form-group',{attrs:{"id":"CustomerDetails","label":"Customer Details:","label-for":"CustomerDetails"}},[_c('autocomplete',{attrs:{"suggestions":_vm.getUsers,"placeholder":"Search...","keys":_vm.searchKey,"display":_vm.displayKey,"onSelected":_vm.onSelected,"value":_vm.selectedName},model:{value:(_vm.selection),callback:function ($$v) {_vm.selection=$$v},expression:"selection"}})],1),_vm._v(" "),_c('b-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentUser !== null),expression:"currentUser !== null"}],staticStyle:{"width":"100%","border-radius":"12px","text-align":"center"},attrs:{"title":(_vm.currentUser !== null) ? _vm.currentUser.first_name + ' ' + _vm.currentUser.last_name: '',"tag":"article","id":"profile_id"}},[_c('div',{staticClass:"card-text profile"},[_c('p',[_vm._v(_vm._s((_vm.currentUser !== null) ? _vm.currentUser.phone : ''))]),_vm._v(" "),_c('p',[_vm._v(_vm._s((_vm.currentUser !== null) ? _vm.currentUser.email : ''))])])])],1)],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"Device Details","icon":"fa fa-server"}},[_c('b-card',{staticClass:"section-container"},[_c('b-form-group',{attrs:{"id":"DeviceIDGroup","label":"Device ID:","label-for":"DeviceID"}},[_c('b-form-input',{attrs:{"id":"DeviceID","type":"text","required":"","placeholder":"Enter Device ID"},model:{value:(_vm.deviceParam.inverter_number),callback:function ($$v) {_vm.$set(_vm.deviceParam, "inverter_number", $$v)},expression:"deviceParam.inverter_number"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"col-form-label pt0"},[_vm._v("State")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.stateOptions},on:{"change":_vm.fetchLgas},model:{value:(_vm.deviceParam.state_id),callback:function ($$v) {_vm.$set(_vm.deviceParam, "state_id", $$v)},expression:"deviceParam.state_id"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{staticClass:"col-form-label pt0"},[_vm._v("Local Govt. Area")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.lgaOptions},model:{value:(_vm.deviceParam.lga_id),callback:function ($$v) {_vm.$set(_vm.deviceParam, "lga_id", $$v)},expression:"deviceParam.lga_id"}})],1)]),_vm._v(" "),_c('b-form-group',{attrs:{"id":"DeviceCapacityGroup","label":"Device Capacity (Watts):","label-for":"deviceCapacity"}},[_c('b-form-input',{attrs:{"id":"deviceCapacity","type":"text","required":"","placeholder":"Enter Device Capacity"},model:{value:(_vm.deviceParam.inverter_capacity),callback:function ($$v) {_vm.$set(_vm.deviceParam, "inverter_capacity", $$v)},expression:"deviceParam.inverter_capacity"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"NumberOfPanel","label":"Number Of Panel:","label-for":"NumberOfPanel"}},[_c('b-form-input',{attrs:{"id":"NumberOfPanel","type":"text","required":"","placeholder":"Number Of Panel"},model:{value:(_vm.deviceParam.number_of_panels),callback:function ($$v) {_vm.$set(_vm.deviceParam, "number_of_panels", $$v)},expression:"deviceParam.number_of_panels"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"PanelRating","label":"Panel Rating:","label-for":"PanelRating"}},[_c('b-form-input',{attrs:{"id":"PanelRating","type":"text","required":"","placeholder":"Panel Rating"},model:{value:(_vm.deviceParam.panel_rating),callback:function ($$v) {_vm.$set(_vm.deviceParam, "panel_rating", $$v)},expression:"deviceParam.panel_rating"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"NumberOfBatteries","label":"Number Of Batteries:","label-for":"NumberOfBatteries"}},[_c('b-form-input',{attrs:{"id":"NumberOfBatteries","type":"text","required":"","placeholder":"Number Of Batteries"},model:{value:(_vm.deviceParam.number_of_batteries),callback:function ($$v) {_vm.$set(_vm.deviceParam, "number_of_batteries", $$v)},expression:"deviceParam.number_of_batteries"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"BatteryRating","label":"Battery Rating:","label-for":"BatteryRating"}},[_c('b-form-input',{attrs:{"id":"BatteryRating","type":"text","required":"","placeholder":"Battery Rating"},model:{value:(_vm.deviceParam.battery_rating),callback:function ($$v) {_vm.$set(_vm.deviceParam, "battery_rating", $$v)},expression:"deviceParam.battery_rating"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"DeviceTypeGroup","label":"Device Type:","label-for":"deviceType"}},[_c('b-form-select',{attrs:{"id":"deviceType","options":_vm.systemTypeOptions,"required":""},model:{value:(_vm.deviceParam.system_type_id),callback:function ($$v) {_vm.$set(_vm.deviceParam, "system_type_id", $$v)},expression:"deviceParam.system_type_id"}})],1)],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2060 */,
/* 2061 */,
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container all-devices-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getUsers,"isLoading":_vm.isLoadingVGT,"select-options":_vm.selectOption,"search-options":{
        enabled: true,
        searchFn: _vm.searchTable,
        externalQuery: _vm.searchTerm
      },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.name))]):_vm._e(),_vm._v(" "),(props.column.field == 'cid')?_c('span',[_vm._v(_vm._s(props.row.CID ? props.row.CID : ""))]):_vm._e(),_vm._v(" "),(props.column.field == 'devicetype')?_c('span',[_vm._v(_vm._s(props.row.deviceType.name))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user.email))]):_vm._e(),_vm._v(" "),(props.column.field == 'phoneNumber')?_c('span',[_vm._v(_vm._s(props.row.user.phoneNumber))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s(props.row.gender + "" === "0" ? "Female" : "Male"))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.navTo(props.row.id)}}},[_vm._v("Details")]),_vm._v(" "),(props.row.CID)?_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditCanvas(props.row)}}},[_vm._v("Edit")]):_vm._e(),_vm._v(" "),(props.row.CID)?_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleUpdateCanvas(props.row)}}},[_vm._v("Complete")]):_vm._e()],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.openCompletionCanvas},on:{"update:show":function($event){_vm.openCompletionCanvas=$event}}},[_c('div',{},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.openCompletionCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Update Completion Details")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Purchase Price"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"purchase-price"},model:{value:(_vm.regDataParams.purchase_price),callback:function ($$v) {_vm.$set(_vm.regDataParams, "purchase_price", $$v)},expression:"regDataParams.purchase_price"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Completion Date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.regDataParams.completion_date),callback:function ($$v) {_vm.$set(_vm.regDataParams, "completion_date", $$v)},expression:"regDataParams.completion_date"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"disabled":_vm.isLoading,"type":"prim​​ary"},on:{"click":function($event){return _vm.onUpdateCompletion()}}},[_vm._v(_vm._s(_vm.isLoading ? "Loading..." : "Update"))])],1)],1)],1)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.editOffCanvas},on:{"update:show":function($event){_vm.editOffCanvas=$event}}},[_c('div',{},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.editOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Edit")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.name),callback:function ($$v) {_vm.$set(_vm.regDataParams, "name", $$v)},expression:"regDataParams.name"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"User"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"user-role","filterable":"","remote":"","remote-method":_vm.fetchUser,"placeholder":"Assign Device"},model:{value:(_vm.regDataParams.userId),callback:function ($$v) {_vm.$set(_vm.regDataParams, "userId", $$v)},expression:"regDataParams.userId"}},_vm._l((_vm.users),function(user){return _c('el-option',{key:("" + (user.id)),attrs:{"label":((user.firstName) + " " + (user.lastName) + " - (" + (user.id) + ")"),"value":("" + (user.id))}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Device Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"device-type","filterable":"","remote":"","remote-method":_vm.fetchSysTypes,"placeholder":"Choose Device Type"},model:{value:(_vm.regDataParams.deviceTypeId),callback:function ($$v) {_vm.$set(_vm.regDataParams, "deviceTypeId", $$v)},expression:"regDataParams.deviceTypeId"}},_vm._l((_vm.systemTypeOptions),function(device,key){return _c('el-option',{key:key,attrs:{"label":("" + (device.name)),"value":device.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Plan"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"device-type","placeholder":"Choose Device Plan"},model:{value:(_vm.regDataParams.plans),callback:function ($$v) {_vm.$set(_vm.regDataParams, "plans", $$v)},expression:"regDataParams.plans"}},_vm._l((_vm.plans),function(device,key){return _c('el-option',{key:key,attrs:{"label":(device + " Device Plan"),"value":device}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Date"}},[_c('el-date-picker',{attrs:{"type":"daterange","range-separator":"To","start-placeholder":"Start date","end-placeholder":"End date"},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(_vm._s(_vm.isLoading ? "Loading..." : "Update"))])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__(881);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028fd4c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__(2065);
function injectStyle (ssrContext) {
  __webpack_require__(2064)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-028fd4c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_028fd4c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-container device-expiry-table-height"},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getDevices,"select-options":_vm.selectOption,"search-options":{
          enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm
        },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'remoteExpiryDate')?_c('span',[(props.row.remoteExpiryDate)?_c('span',[_vm._v("\n            "+_vm._s(_vm._f("formatDate")(props.row.remoteExpiryDate))+"\n            ")]):_c('span',[_vm._v("--")])]):_vm._e(),_vm._v(" "),(props.column.field == 'expiryDate')?_c('span',[(props.row.expiryDate)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("formatDate")(props.row.expiryDate))+"\n            ")]):_c('span',[_vm._v("--")])]):_vm._e(),_vm._v(" "),(props.column.field == 'lastSyncTime')?_c('span',[(props.row.lastSyncTime)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("formatDateTime")(props.row.lastSyncTime))+"\n            ")]):_c('span',[_vm._v("--")])]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v(_vm._s(props.row.deviceId ? props.row.deviceId : "-"))]):_vm._e(),_vm._v(" "),(props.column.field == 'customerName')?_c('span',[_vm._v(_vm._s(props.row.customerName ? props.row.customerName : "-"))]):_vm._e(),_vm._v(" "),(props.column.field == 'isShutdown')?_c('span',[_c('i',{staticClass:"fas fa-lightbulb fa-2x",style:(props.row.isShutdown ? 'color: red' : 'color: green'),attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(props.column.field == 'syncStatus')?_c('span',[_c('i',{staticClass:"fas fa-sync fa-2x",style:((
                (props.row.remoteExpiryDate && props.row.remoteExpiryDate.substring(0,10)) === 
                (props.row.expiryDate && props.row.expiryDate.substring(0,10)))
                  ? 'color: green' : 'color: red')})]):_vm._e(),_vm._v(" "),(props.column.field == 'adminPower')?_c('span',[_vm._v(_vm._s(// props.row.adminPower ? props.row.adminPower : "-"
            // adminPowerCast(props.row.adminPower) ? props.row.adminPower : "-"
            _vm.adminPowerCast(props.row.adminPower)))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button',{attrs:{"variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleEditCanvas( props.row)}}},[_vm._v("Extend Expiry Date")])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.editOffCanvas},on:{"update:show":function($event){_vm.editOffCanvas=$event}}},[_c('div',{},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.editOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Extend Device Admin Shutdown")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Invoice Number"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.invoiceNumber),callback:function ($$v) {_vm.$set(_vm.regDataParams, "invoiceNumber", $$v)},expression:"regDataParams.invoiceNumber"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",staticStyle:{"text-align":"center"},attrs:{"label":"Payment From"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":"","type":"date"},model:{value:(_vm.regDataParams.oldExpiryDate),callback:function ($$v) {_vm.$set(_vm.regDataParams, "oldExpiryDate", $$v)},expression:"regDataParams.oldExpiryDate"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",staticStyle:{"text-align":"center"},attrs:{"label":"Expiry Date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date"},model:{value:(_vm.regDataParams.newExpiryDate),callback:function ($$v) {_vm.$set(_vm.regDataParams, "newExpiryDate", $$v)},expression:"regDataParams.newExpiryDate"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(_vm._s(_vm.isLoading ? "Loading..." : "Submit"))])],1)],1)],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Device Expiry Report")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__ = __webpack_require__(882);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79eb041b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__ = __webpack_require__(2068);
function injectStyle (ssrContext) {
  __webpack_require__(2067)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Request_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79eb041b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Request_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"main-container container-fh__content p-trial-period-expired",staticStyle:{"padding":"0px"}},[_c('img',{staticClass:"p-trial-period-expired__image",attrs:{"src":"/static/img/modal/1.svg","alt":"","width":"100px"}}),_vm._v(" "),(_vm.reqSuccess == true)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v("Your request has been submitted!")]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"text-align":"center !important"}},[_vm._v("\n              You will recieve a notification when granted\n              Thanks.\n            ")])]):_vm._e(),_vm._v(" "),(_vm.reqSuccess == false)?_c('div',{staticClass:"col-md-8"},[_c('h2',{staticClass:"p-trial-period-expired__heading"},[_vm._v("Device Registration")]),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v("Please kindly fill the form below for request")]),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__upgrade",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.customerregtype),expression:"requestForm.customerregtype"}],staticClass:"form-control select2-hidden-accessible",attrs:{"name":"regtype"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.requestForm, "customerregtype", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null","selected":"","disabled":""}},[_vm._v("Registration Type")]),_vm._v(" "),_c('option',{attrs:{"value":"individual"}},[_vm._v("Individual")]),_vm._v(" "),_c('option',{attrs:{"value":"business"}},[_vm._v("Business")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.typeOfBuilding),expression:"requestForm.typeOfBuilding"}],staticClass:"form-control select2-hidden-accessible",attrs:{"name":"buildingtype"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.requestForm, "typeOfBuilding", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null","selected":"","disabled":""}},[_vm._v("Type of building")]),_vm._v(" "),_c('option',{attrs:{"value":"bungalow"}},[_vm._v("Bungalow")]),_vm._v(" "),_c('option',{attrs:{"value":"duplex"}},[_vm._v("Duplex")]),_vm._v(" "),_c('option',{attrs:{"value":"one storey"}},[_vm._v("One Storey")]),_vm._v(" "),_c('option',{attrs:{"value":"two storey"}},[_vm._v("Two Storey")]),_vm._v(" "),_c('option',{attrs:{"value":"others"}},[_vm._v("Others(Charges Apply)")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.roofType),expression:"requestForm.roofType"}],staticClass:"form-control select2-hidden-accessible",attrs:{"name":"rooftype"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.requestForm, "roofType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"null","selected":"","disabled":""}},[_vm._v("Roof Type")]),_vm._v(" "),_c('option',{attrs:{"value":"Aluminium"}},[_vm._v("Aluminium")]),_vm._v(" "),_c('option',{attrs:{"value":"slate"}},[_vm._v("Slate")])])]),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Is roof condition good?"}},[_c('b-form-radio-group',{attrs:{"options":_vm.binaryOptions,"name":"roofCondition"},model:{value:(_vm.requestForm.roofCondition),callback:function ($$v) {_vm.$set(_vm.requestForm, "roofCondition", $$v)},expression:"requestForm.roofCondition"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Is the house ready for installation?"}},[_c('b-form-radio-group',{attrs:{"options":_vm.binaryOptions,"name":"houseInstalation"},model:{value:(_vm.requestForm.roofReadiness),callback:function ($$v) {_vm.$set(_vm.requestForm, "roofReadiness", $$v)},expression:"requestForm.roofReadiness"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.roofAge),expression:"requestForm.roofAge"}],staticClass:"form-control form-control-md",attrs:{"type":"text","placeholder":"Age of roof"},domProps:{"value":(_vm.requestForm.roofAge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.requestForm, "roofAge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.roofComment),expression:"requestForm.roofComment"}],staticClass:"form-control form-control-md",attrs:{"placeholder":"Condition of roof? (Please note that charges apply if roof is discovered to be bad on delivery of system)","cols":"30","rows":"2"},domProps:{"value":(_vm.requestForm.roofComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.requestForm, "roofComment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.systemTypeOptions},model:{value:(_vm.requestForm.deviceTypeId),callback:function ($$v) {_vm.$set(_vm.requestForm, "deviceTypeId", $$v)},expression:"requestForm.deviceTypeId"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.requestForm.comment),expression:"requestForm.comment"}],staticClass:"form-control form-control-md",attrs:{"placeholder":"Comment","cols":"30","rows":"2"},domProps:{"value":(_vm.requestForm.comment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.requestForm, "comment", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._v("\n              Select 'I agree' to comply with T & C. "),_c('a',{staticClass:"btn-primary btn-xs",staticStyle:{"padding":"2px"},attrs:{"target":"_blank","href":"http://arnergy.com/files/ARNERGY-Terms-and-Conditions-090118.pdf"}},[_vm._v("Read/Download T & C here")]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"tnc","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.requestForm.customertnc),callback:function ($$v) {_vm.$set(_vm.requestForm, "customertnc", $$v)},expression:"requestForm.customertnc"}},[_vm._v("\n                I agree\n              ")])],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"device"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info btn-lg btn-block btn-rounded",attrs:{"type":"button"},on:{"click":_vm.submitRequest}},[_vm._v("Submit Request")])])])],1)]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2070 */,
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Are you sure","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("Do you want to delete this request?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("No")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.deleteRequest(_vm.selectedRequest.id)}}},[_vm._v("Yes")])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"overlay":"","flipped":"","stuck":"","show":_vm.showInvoice},on:{"update:show":function($event){_vm.showInvoice=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showInvoice = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('svg',{staticClass:"wow-star",attrs:{"version":"1.1","viewBox":"0 0 300 300","preserveAspectRatio":"xMinYMin meet"}},[_c('foreignobject',{staticClass:"wow-star__text",attrs:{"width":"100%","height":"100%"},domProps:{"innerHTML":_vm._s(_vm.receiptData)}})])],1)]),_vm._v(" "),_c('div',{staticClass:"main-container request-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['firstName']) + " " + (props.row.user['lastName'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'installation_name')?_c('span',[_vm._v(_vm._s(props.row['installationName'] ? ((props.row['installationName']) + " ") : ((props.row.user['firstName']) + " " + (props.row.user['lastName']))))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['email']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['phoneNumber']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceType? ((props.row.deviceType['name']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'system.capacity')?_c('span',[_vm._v(_vm._s(props.row.systemCapacity? ((props.row.systemCapacity) + "kVA") :'--'))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('router-link',{attrs:{"to":("/device-request/" + (props.row['id']))}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 0),expression:"props.row.status == 0"}],attrs:{"variant":"primary"}},[_vm._v("\n                    View Status  \n                    "),_c('span',{staticClass:"fa fa-check"})])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"installation"}},[_c('router-link',{attrs:{"to":("/device-request/" + (props.row['id']))}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 1),expression:"props.row.status == 1"}],attrs:{"size":"md","variant":"info"}},[_vm._v("\n                    Approve Installation  \n                    "),_c('span',{staticClass:"fa fa-calendar"})])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"invoice"}}),_vm._v(" \n              "),_c('can',{attrs:{"I":"delete","a":"installation"}},[_c('b-button',{staticClass:"delete-btn",attrs:{"variant":"danger","size":"md"},on:{"click":function($event){_vm.selectedRequest = props.row; _vm.centerDialogVisible = true}}},[_vm._v("\n                  Delete Request  \n                  "),_c('span',{staticClass:"fa fa-trash"})]),_vm._v(" \n              ")],1)],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deviceRequestStatus_vue__ = __webpack_require__(887);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6bd19e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deviceRequestStatus_vue__ = __webpack_require__(2074);
function injectStyle (ssrContext) {
  __webpack_require__(2073)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_deviceRequestStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6bd19e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_deviceRequestStatus_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fh__content p-trial-period-expired",staticStyle:{"padding":"0px"}},[_c('img',{staticClass:"p-trial-period-expired__image",staticStyle:{"margin-top":"50px"},attrs:{"src":"/static/img/modal/1.svg","alt":"","width":"100px"}}),_vm._v(" "),(_vm.installationData)?_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth"},[_c('div',[_c('div',{staticClass:"widget-alpha__amount"},[_vm._v(_vm._s(_vm.installationData.user? ((_vm.installationData.user.firstName) + " " + (_vm.installationData.user.lastName)): "-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description"},[_vm._v(_vm._s(_vm.installationData.user?((_vm.installationData.user.email) + " ") : "-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description"},[_vm._v(_vm._s(_vm.installationData.user ? (" " + (_vm.installationData.deviceType.name) + ": " + (_vm.installationData.systemCapacity) + "kVA"):"-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s((" " + (_vm.installationData.paymentModel))))])]),_vm._v(" "),_c('span',{staticClass:"widget-alpha__icon fa fa-info"})]),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"installation"}},[_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"widget_header",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"widget_header__title"},[_vm._v("Installation Component Configuration")])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.instalationPackageConfig,"styleClass":"table table-striped col-md-12"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'quantity')?_c('span',[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.instalationPackageConfig[props.row.originalIndex]['quantity']),callback:function ($$v) {_vm.$set(_vm.instalationPackageConfig[props.row.originalIndex], 'quantity', $$v)},expression:"instalationPackageConfig[props.row.originalIndex]['quantity']"}})],1):_vm._e(),_vm._v(" "),(props.column.field == 'componentType.name')?_c('span',{staticStyle:{"text-transform":"capitalize","font-weight":"bold"}},[_vm._v(_vm._s(props.row.componentType.name))]):_vm._e()]}}],null,false,3121654233)})],1),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__upgrade",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info btn-lg btn-block btn-rounded",attrs:{"type":"button"},on:{"click":_vm.submitRequest}},[_vm._v("Approve Installation")])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('el-timeline',{attrs:{"reverse":false}},[_c('el-timeline-item',{attrs:{"type":"primary","timestamp":new Date(_vm.installationData.createdAt).toString(),"placement":"top"}},[_c('el-card',[_c('h4',[_vm._v("Request submitted")])])],1),_vm._v(" "),(_vm.installationData.status > 0)?_c('div',[(_vm.installationData.transactionHistories)?_c('el-timeline-item',{attrs:{"type":"success","timestamp":new Date(_vm.installationData.transactionHistories.createdAt).toString(),"placement":"top"}},[_c('el-card',[_c('h4',[_vm._v("Payment successful")]),_vm._v(" "),_c('p',[_vm._v("₦"+_vm._s(_vm.installationData.transactionHistories.paymentAmount))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(new Date(_vm.installationData.transactionHistories.updatedAt).toString()))])])],1):_vm._e(),_vm._v(" "),(_vm.installationData.status >= 2)?_c('el-timeline-item',{attrs:{"type":"success","timestamp":new Date(_vm.installationData.installations.createdAt).toString(),"placement":"top"}},[_c('el-card',[_c('h4',[_vm._v("Installation request approved")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("CustomerID:")]),_vm._v("\n                "+_vm._s(_vm.installationData.CID)+"\n              ")])])],1):_vm._e(),_vm._v(" "),(_vm.installationData.status >= 3)?_c('el-timeline-item',{attrs:{"type":"success","timestamp":new Date(_vm.installationData.installations.updatedAt).toString(),"placement":"top"}},[_c('el-card',[_c('h4',[_vm._v("Installation schedulled")]),_vm._v(" "),_c('p',{staticClass:"badge badge-info",staticStyle:{"font-size":"1rem"}},[_vm._v(_vm._s(new Date(_vm.installationData.installations.from).toString())+" - "+_vm._s(new Date(_vm.installationData.installations.to).toString()))])])],1):_vm._e(),_vm._v(" "),(_vm.installationData.status >= 3)?_c('el-timeline-item',{attrs:{"type":"primary","timestamp":new Date(_vm.installationData.installations.updatedAt).toString(),"placement":"top"}},[_c('el-card',[_c('h4',[_vm._v("Installation Commissioned")]),_vm._v(" "),_c('a',{staticClass:"badge badge-success",staticStyle:{"font-size":"1rem"},attrs:{"href":("/device/" + (_vm.installationData.installations.id))}},[_vm._v("View device")])])],1):_vm._e()],1):_vm._e()],1)],1)]):_c('div',{staticClass:"col-md-8"},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-body",staticStyle:{"text-align":"center !important"}},[_c('span',{staticClass:"fa fa-spinner fa-4x animated rotateIn infinite loadingState",staticStyle:{"color":"#1a93ca"}}),_vm._v(" "),_c('h3',[_vm._v("Fetching details...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__ = __webpack_require__(888);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d891db4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__ = __webpack_require__(2083);
function injectStyle (ssrContext) {
  __webpack_require__(2076)
  __webpack_require__(2077)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d891db4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_View_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d891db4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_View_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2078 */,
/* 2079 */,
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(891);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53422fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__ = __webpack_require__(2081);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_53422fc4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_VueGoogleAutocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autocompleteText),expression:"autocompleteText"}],ref:"autocomplete",class:_vm.classname,attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"disabled":_vm.disabled},domProps:{"value":(_vm.autocompleteText)},on:{"focus":function($event){return _vm.onFocus()},"blur":function($event){return _vm.onBlur()},"change":_vm.onChange,"keypress":_vm.onKeyPress,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.autocompleteText=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-google-autocomplete',{ref:"address",attrs:{"id":"map","classname":"form-control","placeholder":"Please type your address"},on:{"placechanged":_vm.changeHandler}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Update Location","visible":_vm.dialogVisible,"width":"300px"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('address-input',{attrs:{"changeHandler":_vm.getAddressData}}),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submitAddressUpdate}},[_vm._v("Update")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._v("\n        "+_vm._s(_vm.inst)+"\n\n        "),_c('div',{staticClass:"col-sm-1 col-md-1"}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-10 col-md-10 boxDetailStyling"},[_c('div',[_c('figcaption',{staticClass:"detailStyling"},[_c('p',{staticStyle:{"font-size":"39px","font-weight":"700","margin":"0"}},[_c('i',{staticClass:"fa fa-user fa-lg"}),_vm._v("\n                "+_vm._s(_vm.device_prop("inst.name"))+"\n              ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currentDevice.inst.CID))])])]),_vm._v(" "),_c('div',[_c('figcaption',{staticClass:"detailStylingA",staticStyle:{"cursor":"pointer","margin-left":"70px"},on:{"click":_vm.triggerEditLocation}},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.device_prop("inst.locations.streetNumber"))+",\n                "+_vm._s(_vm.device_prop("inst.locations.streetRoute"))+"\n              ")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"32px 0"}}),_vm._v(" "),_c('div',{staticClass:"French"},[_c('p',[_c('i',{staticClass:"fa fa-barcode fa-lg"}),_vm._v(" "),_c('span',[_vm._v("Device type: ")]),_c('span',[_vm._v(_vm._s(_vm.device_prop("inst.deviceType.name")))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Rating: ")]),_c('span',[_vm._v(_vm._s(_vm.device_prop("rating"))+" kW")]),_c('br')]),_vm._v(" "),_c('p',[_c('span',[_vm._v("Solar Kit Id: ")]),_vm._v(" "),_vm._l((_vm.deviceParse(
                  _vm.device_prop('inst.solarKitIds')
                )),function(item,index){return _c('span',{key:index},[_vm._v("\n                "+_vm._s(item)+"\n              ")])})],2)]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"32px 0"}}),_vm._v(" "),_c('div',{staticClass:"detailStyle001"},[_c('div',{staticClass:"detailStylingA"},[_vm._m(1),_vm._v(" "),_c('p',{staticStyle:{"background-color":"#E5E7E8","padding-left":"5px","margin-right":"80%","border-radius":"5px"}},[_vm._v("\n                "+_vm._s(_vm.device_prop("inst.user.id"))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"detailStylingA"},[_vm._m(2),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.device_prop("inst.user.phoneNumber")))])]),_vm._v(" "),_c('div',{staticClass:"detailStylingA"},[_vm._m(3),_vm._v(" "),_c('p',{staticStyle:{"background-color":"#E5E7E8","padding-left":"5px","margin-right":"70%","border-radius":"5px"}},[_vm._v("\n                "+_vm._s(_vm.device_prop("inst.user.email"))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"detailStylingA"},[_vm._m(4),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.device_prop("inst.deviceRequest.paymentModel"))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"detailStylingA"},[_vm._m(5),_vm._v(" "),_c('p',[_vm._v("\n                "+_vm._s(_vm.device_prop("inst.status"))+"\n              ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('el-card',{staticClass:"box-card"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":"Maintenance","name":"maintenance"}},[_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.maintenanceColumns,"rows":_vm.currentDevice.inst.maintenanceHistory,"paginate":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'operator')?_c('td',[_vm._v("\n                          "+_vm._s(props.row.operationsEngineer.firstName)+"\n                          "+_vm._s(props.row.operationsEngineer.lastName)+"\n                        ")]):(props.column.field == 'issue')?_c('td',[_vm._v("\n                          "+_vm._s(props.row.issue)+"\n                        ")]):_c('td',[_vm._v(_vm._s(props.row))])]}}])})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Components","name":"component"}},[_c('div',[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.columns,"rows":_vm.currentDevice.inst.deviceRequest
                            .installationComponents,"paginate":true,"line-numbers":true}})],1)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Alarms","name":"alarm"}},[_c('div',[_c('div',{staticClass:"col-md-12 col-xs-12"},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.alarmColumns,"rows":_vm.alarmRows,"paginate":true,"line-numbers":true}})],1)])])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"})])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('i',{staticClass:"fa fa-map-marker fa-lg"}),_vm._v("Location")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#667474"}},[_c('i',{staticClass:"fa fa-id-card fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" User ID\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#667474"}},[_c('i',{staticClass:"fa fa-phone fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" Tel\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#667474"}},[_c('i',{staticClass:"fa fa-envelope fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v(" E-mail\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#667474"}},[_c('i',{staticClass:"fa fa-credit-card fa-lg",attrs:{"aria-hidden":"true"}}),_vm._v("\n                Payment Model\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"#667474"}},[_c('i',{staticClass:"fa fa-building fa-lg"}),_vm._v(" Device Status\n              ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(892);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eec89a60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2085);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eec89a60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas-content',[_c('vk-button',{on:{"click":function($event){_vm.show = true}}},[_vm._v("Open")]),_vm._v(" "),_c('div',[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.show = false}}}),_vm._v(" "),_c('h3',[_vm._v("Title")]),_vm._v(" "),_c('p',[_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"page-content__header-description col-md-12"},[_vm._v("Modal")]),_vm._v(" "),_c('b-button',{on:{"click":_vm.showModal}},[_vm._v("Open Modal")]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",staticClass:"modal-dialog modal-content",attrs:{"centered":"","hide-footer":"","role":"document"}},[_c('div',{staticStyle:{"text-align":"center !important"},attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('b-btn',{staticClass:"close custom-modal__close",staticStyle:{"justify-content":"center !important","font-size":".89em"},on:{"click":_vm.hideModal}},[_c('span',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/modal/4.png","alt":""}}),_vm._v(" "),_c('h2',{staticClass:"page-content__header-description"},[_vm._v("My Modal Component")])],1),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('h3',[_vm._v("Hello From My Modal!")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"page-content__header-description col-md-12"},[_vm._v("Grid Overview Display")]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 text-center"},[_c('div',{staticClass:"widget_box"},[_c('figcaption',[_c('h3',[_vm._v("Panels (80watts)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.random_num('inverter_number')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 text-center"},[_c('div',{staticClass:"widget_box"},[_c('figcaption',[_c('h3',[_vm._v("Inverter (3000watts)")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.random_num('inverter_number')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 text-center"},[_c('div',{staticClass:"widget_box"},[_c('figcaption',[_c('h3',[_vm._v("Pole")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.random_num('inverter_number')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-3 text-center"},[_c('div',{staticClass:"widget_box"},[_c('figcaption',[_c('h3',[_vm._v("Table")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.random_num('inverter_number')))])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"Activity name"}},[_c('el-input',{model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Activity zone"}},[_c('el-select',{attrs:{"placeholder":"please select your zone"},model:{value:(_vm.form.region),callback:function ($$v) {_vm.$set(_vm.form, "region", $$v)},expression:"form.region"}},[_c('el-option',{attrs:{"label":"Zone one","value":"shanghai"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Zone two","value":"beijing"}})],1)],1),_vm._v(" "),_c('el-form-item',[_vm._l((_vm.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.handleClose(tag)}}},[_vm._v("\n              "+_vm._s(tag)+"\n              ")])}),_vm._v(" "),(_vm.inputVisible)?_c('el-input',{ref:"saveTagInput",staticClass:"input-new-tag",attrs:{"size":"mini"},on:{"blur":_vm.handleInputConfirm},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm.apply(null, arguments)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):_c('el-button',{staticClass:"button-new-tag",attrs:{"size":"small"},on:{"click":_vm.showInput}},[_vm._v("+ New Tag")])],2),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onSubmit}},[_vm._v("Create")]),_vm._v(" "),_c('el-button',[_vm._v("Cancel")])],1)],1)],1)],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"page-content__header-description col-md-12"},[_vm._v("Info Banner")]),_vm._v(" "),_c('div',{staticClass:"modal-dialog",attrs:{"role":"document"}},[_c('button',{staticClass:"close custom-modal__close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{staticClass:"ua-icon-modal-close",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header custom-modal__image"},[_c('img',{attrs:{"src":"/static/img/modal/2.png","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"modal-body custom-modal__body"},[_c('h4',{staticClass:"custom-modal__body-heading"},[_vm._v("Setup Fee Payment")]),_vm._v(" "),_c('div',{staticClass:"custom-modal__body-desc"},[_vm._v("Just a step to go. Click the button below to make payment")])]),_vm._v("\n                .sh {\n                // display: table-cell;\n                }\n                "),_c('div',{staticClass:"modal-footer",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"custom-modal__buttons"},[_c('button',{staticClass:"btn btn-info iconfont icon-left custom-modal__icon-btn",attrs:{"type":"button"}},[_vm._v("\n                      Proceed\n                      "),_c('span',{staticClass:"btn-icon fa fa-mouse-pointer"})])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container user-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.isACxTeam ? _vm.cxTeamFields : _vm.fields,"rows":_vm.users,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstName)+" "+_vm._s(props.row.lastName))]):_vm._e(),_vm._v(" "),(props.column.field === 'gender')?_c('span',[_vm._v("\n\n          "+_vm._s(("" + (props.row.gender)) === '0' ? "Female" : "Male")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('router-link',{attrs:{"to":("/users/priviledges/" + (props.row.id))}},[_c('b-button',{attrs:{"size":"md","variant":"info"}},[_vm._v("\n              Priviledges  \n              "),_c('span',{staticClass:"fa fa-wrench"})])],1),_vm._v(" "),_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":function($event){$event.stopPropagation();return _vm.navTo(("/users/edit/" + (props.row.id)), props.row)}}},[_vm._v("\n            Edit  \n            "),_c('span',{staticClass:"fa fa-pencil-square-o"})])],1):_vm._e(),_vm._v(" "),(props.column.field === 'updatedAt')?_c('span',[_vm._v("\n          "+_vm._s(props.row.updatedAt)+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field === 'id')?_c('span',[_vm._v("\n          "+_vm._s(props.row.id)+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field === 'roleType')?_c('span',[_vm._v("\n          "+_vm._s(props.row.roleType)+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field === 'email')?_c('span',[_vm._v("\n          "+_vm._s(props.row.email)+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field === 'phoneNumber')?_c('span',[_vm._v("\n          "+_vm._s(props.row.phoneNumber)+"\n        ")]):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_user_vue__ = __webpack_require__(894);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cd1c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_user_vue__ = __webpack_require__(2090);
function injectStyle (ssrContext) {
  __webpack_require__(2089)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f4cd1c58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f4cd1c58_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2089 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.regSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"POST"},on:{"submit":_vm.submitReg}},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Create new user")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("User Role")]),_vm._v(" "),_c('el-autocomplete',{staticStyle:{"width":"100%"},attrs:{"id":"user-role","fetch-suggestions":_vm.searchRole,"value-key":"name","placeholder":"Select Role","prefix-icon":"el-icon-search"},on:{"select":_vm.checkSelRole},model:{value:(_vm.regParams.roleType),callback:function ($$v) {_vm.$set(_vm.regParams, "roleType", $$v)},expression:"regParams.roleType"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSectionManager),expression:"isSectionManager"}],staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Assign Device(s)")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"user-role","filterable":"","placeholder":"Assign Device(s)","multiple":""},on:{"change":function($event){return _vm.logTHis()}},model:{value:(_vm.regParams.assignedDevices),callback:function ($$v) {_vm.$set(_vm.regParams, "assignedDevices", $$v)},expression:"regParams.assignedDevices"}},_vm._l((_vm.installations),function(installation,key){return _c('el-option',{key:("installation_" + key),attrs:{"label":((installation.name) + " - " + (installation.CID)),"value":("" + (installation.CID))}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.email),expression:"regParams.email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"p-signup-email","placeholder":"you@yourcompany.com"},domProps:{"value":(_vm.regParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-first-name"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.firstName),expression:"regParams.firstName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-first-name","placeholder":"First Name"},domProps:{"value":(_vm.regParams.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-last-name"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.lastName),expression:"regParams.lastName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-last-name","placeholder":"Last Name"},domProps:{"value":(_vm.regParams.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.phoneNumber),expression:"regParams.phoneNumber"}],staticClass:"form-control form-control-lg",attrs:{"type":"phone-number","id":"p-signup-phone","placeholder":"Phone Number"},domProps:{"value":(_vm.regParams.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"p-signup-gender","placeholder":"Choose Gender"},model:{value:(_vm.regParams.gender),callback:function ($$v) {_vm.$set(_vm.regParams, "gender", $$v)},expression:"regParams.gender"}},_vm._l((_vm.genderData),function(single_gender){return _c('el-option',{key:single_gender.id,attrs:{"label":single_gender.name,"value":single_gender.id}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-street_route"}},[_vm._v("Home Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.street_route),expression:"regParams.street_route"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-street_route","placeholder":"Home Address"},domProps:{"value":(_vm.regParams.street_route)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "street_route", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send E-mail")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"inactive-text":"Send Email","active-text":"Don't send Email"},model:{value:(_vm.regParams.noMail),callback:function ($$v) {_vm.$set(_vm.regParams, "noMail", $$v)},expression:"regParams.noMail"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"type":"submit"},on:{"click":_vm.submitReg}},[_vm._v("\n            Create User\n          ")])])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_billing_vue__ = __webpack_require__(895);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78339510_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_billing_vue__ = __webpack_require__(2097);
function injectStyle (ssrContext) {
  __webpack_require__(2092)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78339510"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78339510_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2093 */,
/* 2094 */,
/* 2095 */,
/* 2096 */,
/* 2097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.billingSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"POST"},on:{"submit":_vm.createBilling}},[_c('h5',{staticClass:"p-signup__form-heading"},[_vm._v("Setup Billing")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"installationId"}},[_vm._v("Installation")]),_vm._v(" "),_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.installationSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.regParams.installation),callback:function ($$v) {_vm.$set(_vm.regParams, "installation", $$v)},expression:"regParams.installation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"price"}},[_vm._v("Amount(NGN)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.price),expression:"regParams.price"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"price","placeholder":"Amount"},domProps:{"value":(_vm.regParams.price)},on:{"change":_vm.updateMonthlyCharge,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"numberOfTimesPaymentIsMade"}},[_vm._v("Number of payments made")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.numberOfTimesPaymentIsMade),expression:"regParams.numberOfTimesPaymentIsMade"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"numberOfTimesPaymentIsMade","placeholder":"number of payment times"},domProps:{"value":(_vm.regParams.numberOfTimesPaymentIsMade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "numberOfTimesPaymentIsMade", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"monthlyRecurringChargeDate"}},[_vm._v("Charge date")]),_vm._v(" "),_c('DatePicker',{staticClass:"date-upload",attrs:{"id":"monthlyRecurringChargeDate","placeholder":"yyyy-mm-dd","default-value":new Date(),"disabled-date":_vm.disabledBeforeTodayAndAfterAWeek},model:{value:(_vm.regParams.monthlyRecurringChargeDate),callback:function ($$v) {_vm.$set(_vm.regParams, "monthlyRecurringChargeDate", $$v)},expression:"regParams.monthlyRecurringChargeDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"duration"}},[_vm._v("Payment Duration (in Months)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.duration),expression:"regParams.duration"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"duration","placeholder":"Monthly Duration"},domProps:{"value":(_vm.regParams.duration)},on:{"change":_vm.updateMonthlyCharge,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "duration", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"monthlyCharge"}},[_vm._v("Monthly Charge(NGN)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.monthlyCharge),expression:"regParams.monthlyCharge"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"monthlyCharge","disabled":""},domProps:{"value":(_vm.regParams.monthlyCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "monthlyCharge", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"type":"submit"},on:{"click":_vm.createBilling}},[_vm._v("\n            Create Billing\n          ")])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BillingUpdate_vue__ = __webpack_require__(897);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449256db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BillingUpdate_vue__ = __webpack_require__(2100);
function injectStyle (ssrContext) {
  __webpack_require__(2099)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-449256db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BillingUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_449256db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BillingUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.billingSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"PATCH"},on:{"submit":_vm.submitReg}},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("\n        Billing Update\n      ")]),_vm._v(" "),_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("\n        Proceed to update the device with the id\n        "+_vm._s(_vm.parameters.installationId)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"numberOfTimesPaymentIsMade"}},[_vm._v("Number of payments made")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.numberOfTimesPaymentIsMade),expression:"regParams.numberOfTimesPaymentIsMade"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"numberOfTimesPaymentIsMade","placeholder":_vm.parameters.numbOfPayments},domProps:{"value":(_vm.regParams.numberOfTimesPaymentIsMade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "numberOfTimesPaymentIsMade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"monthlyRecurringChargeDate"}},[_vm._v("Charge date")]),_vm._v(" "),_c('date-picker',{staticClass:"date-upload",attrs:{"id":"monthlyRecurringChargeDate","placeholder":_vm.parameters.chargingDate,"default-value":new Date(),"disabled-date":_vm.disabledBeforeTodayAndAfterAWeek},model:{value:(_vm.regParams.monthlyRecurringChargeDate),callback:function ($$v) {_vm.$set(_vm.regParams, "monthlyRecurringChargeDate", $$v)},expression:"regParams.monthlyRecurringChargeDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"monthlyCharge"}},[_vm._v("Monthly charge(NGN)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.monthlyCharge),expression:"regParams.monthlyCharge"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"monthlyCharge","placeholder":_vm.parameters.monthCharges,"disabled":""},domProps:{"value":(_vm.regParams.monthlyCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "monthlyCharge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"duration"}},[_vm._v("Payment Duration (in Months)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.duration),expression:"regParams.duration"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","id":"duration","placeholder":_vm.parameters.durationss},domProps:{"value":(_vm.regParams.duration)},on:{"change":_vm.updateMonthlyCharge,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "duration", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"type":"submit"},on:{"click":_vm.submitReg}},[_vm._v("\n            Update\n          ")])])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_customer_vue__ = __webpack_require__(898);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f4cb34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_customer_vue__ = __webpack_require__(2103);
function injectStyle (ssrContext) {
  __webpack_require__(2102)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03f4cb34"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03f4cb34_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.regSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('el-form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"POST"},on:{"submit":_vm.submitReg}},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Create new customer")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Contact"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.formContact),callback:function ($$v) {_vm.formContact=$$v},expression:"formContact"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"type":"submit"},on:{"click":_vm.submitReg}},[_vm._v("\n            Convert contact\n          ")])])],1)])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid",staticStyle:{"min-height":"80vh","margin-top":"2rem"}},[_c('div',{staticClass:"main-container"},[_c('b-card',{staticClass:"col-md-12",attrs:{"bg-variant":"light","text-variant":"dark"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"widget widget-controls widget-table widget-notifications"},[_c('div',{staticClass:"widget-controls__header widget-controls__header--bordered"},[_c('div',[_vm._v("\n                    User Details\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"widget-controls__content js-scrollable",staticStyle:{"justify-content":"center","color":"rgba(0,0,0,0.28)","align-items":"center"},attrs:{"data-simplebar":"init"}},[_c('span',{staticClass:"fa fa-user",staticStyle:{"font-size":"8em","color":"rgba(0,0,0,0.28)"}}),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedUser !== null),expression:"selectedUser !== null"}],staticStyle:{"font-weight":"700"}},[_vm._v("\n                    "+_vm._s(_vm.selectedUser !== null ? _vm.selectedUser.firstName : "")+"\n                    "+_vm._s(_vm.selectedUser !== null ? _vm.selectedUser.lastName : "")+"\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-text profile text-center"},[_c('h3',[_vm._v("\n                      "+_vm._s(_vm.selectedUser !== null ? _vm.selectedUser.email : "")+"\n                    ")]),_vm._v(" "),_c('h3',[_vm._v("\n                      "+_vm._s(_vm.selectedUser !== null ? _vm.selectedUser.phoneNumber : "")+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"widget widget-controls widget-table widget-notifications"},[_c('div',{staticClass:"widget-controls__header widget-controls__header--bordered"},[_c('div',[_vm._v("\n                    Privileges\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"widget-controls__content js-scrollable",attrs:{"data-simplebar":"init"}},[_c('div',{staticClass:"simplebar-track vertical",staticStyle:{"visibility":"visible"}},[_c('div',{staticClass:"simplebar-scrollbar",staticStyle:{"top":"2px","height":"100px"}})]),_vm._v(" "),_c('div',{staticClass:"simplebar-track horizontal",staticStyle:{"visibility":"hidden"}},[_c('div',{staticClass:"simplebar-scrollbar"})]),_vm._v(" "),_c('div',{staticClass:"simplebar-scroll-content",staticStyle:{"padding-right":"14px","margin-bottom":"-28px"}},[_c('div',{staticClass:"simplebar-content",staticStyle:{"padding-bottom":"14px","margin-right":"-14px","overflow-x":"auto"}},[_c('div',{staticClass:"widget-notifications__items"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-sm color-icon-label-table"},[_c('tbody',_vm._l((_vm.roles),function(singleItem,index_){return _c('tr',{key:index_},[_c('td',[_vm._v(_vm._s(singleItem.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(singleItem.description))]),_vm._v(" "),_c('td',[(
                                      (_vm.val = _vm.userRole.find(function (data) { return data.role.id === singleItem.id
                                          ? true
                                          : false; }
                                      ))
                                    )?_c('div',[_c('a',{staticClass:"btn btn-sm btn-success",attrs:{"href":"#"},on:{"click":function($event){return _vm.alterMap(
                                          false,
                                          singleItem.id,
                                          singleItem.name,
                                          _vm.userId
                                        )}}},[_vm._v("Disable")])]):_c('div',[_c('a',{staticClass:"btn btn-sm btn-primary",attrs:{"href":"#"},on:{"click":function($event){return _vm.alterMap(
                                          true,
                                          singleItem.id,
                                          singleItem.name,
                                          _vm.userId
                                        )}}},[_vm._v("Enable")])])])])}),0)])])])])])])])])])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_user_vue__ = __webpack_require__(900);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1b55fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_user_vue__ = __webpack_require__(2108);
function injectStyle (ssrContext) {
  __webpack_require__(2107)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e1b55fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e1b55fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.regSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"POST"},on:{"submit":_vm.submitReg}},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Edit user")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSectionManager),expression:"isSectionManager"}],staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Assign Device(s)")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"user-role","filterable":"","placeholder":"Assign Device(s)","multiple":""},on:{"change":function($event){return _vm.logTHis()}},model:{value:(_vm.regParams.assignedDevices),callback:function ($$v) {_vm.$set(_vm.regParams, "assignedDevices", $$v)},expression:"regParams.assignedDevices"}},_vm._l((_vm.installations),function(installation,key){return _c('el-option',{key:("installation_" + key),attrs:{"label":((installation.name) + " - " + (installation.CID)),"value":("" + (installation.CID))}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.email),expression:"regParams.email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"p-signup-email","placeholder":"you@yourcompany.com"},domProps:{"value":(_vm.regParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-first-name"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.firstName),expression:"regParams.firstName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-first-name","placeholder":"First Name"},domProps:{"value":(_vm.regParams.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-last-name"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.lastName),expression:"regParams.lastName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-last-name","placeholder":"Last Name"},domProps:{"value":(_vm.regParams.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.phoneNumber),expression:"regParams.phoneNumber"}],staticClass:"form-control form-control-lg",attrs:{"type":"phone-number","id":"p-signup-phone","placeholder":"Phone Number"},domProps:{"value":(_vm.regParams.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"p-signup-gender","placeholder":"Choose Gender"},model:{value:(_vm.regParams.gender),callback:function ($$v) {_vm.$set(_vm.regParams, "gender", $$v)},expression:"regParams.gender"}},_vm._l((_vm.genderData),function(single_gender){return _c('el-option',{key:single_gender.id,attrs:{"label":single_gender.name,"value":single_gender.id}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-street_route"}},[_vm._v("Home Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.street_route),expression:"regParams.street_route"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-street_route","placeholder":"Home Address"},domProps:{"value":(_vm.regParams.street_route)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "street_route", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-street_route"}},[_vm._v("CC Emails")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.ccEmails),expression:"regParams.ccEmails"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-street_route","placeholder":"CC Email"},domProps:{"value":(_vm.regParams.ccEmails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "ccEmails", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send E-mail")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"inactive-text":"Send Email","active-text":"Don't send Email"},model:{value:(_vm.regParams.noMail),callback:function ($$v) {_vm.$set(_vm.regParams, "noMail", $$v)},expression:"regParams.noMail"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":_vm.submitReg}},[_vm._v("\n            "+_vm._s(_vm.isLoading ? "Loading..." : "Update User")+"\n          ")])])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_profile_vue__ = __webpack_require__(901);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cdb50af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_profile_vue__ = __webpack_require__(2111);
function injectStyle (ssrContext) {
  __webpack_require__(2110)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cdb50af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cdb50af_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2110 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-front__content"},[(_vm.regSuccess == false)?_c('div',{staticClass:"p-signup",staticStyle:{"margin":"80px 0px"}},[_c('form',{staticClass:"p-signup__form",staticStyle:{"width":"80%"},attrs:{"method":"POST"},on:{"submit":_vm.submitReg}},[_c('h4',{staticClass:"p-signup__form-heading"},[_vm._v("Edit Profile")]),_vm._v(" "),_c('div',{staticClass:"p-signup__form-content"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v(_vm._s(_vm.errorMessage))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSectionManager),expression:"isSectionManager"}],staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Assign Device(s)")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"user-role","filterable":"","placeholder":"Assign Device(s)","multiple":""},on:{"change":function($event){return _vm.logTHis()}},model:{value:(_vm.regParams.assignedDevices),callback:function ($$v) {_vm.$set(_vm.regParams, "assignedDevices", $$v)},expression:"regParams.assignedDevices"}},_vm._l((_vm.installations),function(installation,key){return _c('el-option',{key:("installation_" + key),attrs:{"label":((installation.name) + " - " + (installation.CID)),"value":("" + (installation.CID))}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.email),expression:"regParams.email"}],staticClass:"form-control form-control-lg",attrs:{"type":"email","id":"p-signup-email","placeholder":"you@yourcompany.com"},domProps:{"value":(_vm.regParams.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-first-name"}},[_vm._v("First Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.firstName),expression:"regParams.firstName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-first-name","placeholder":"First Name"},domProps:{"value":(_vm.regParams.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "firstName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-last-name"}},[_vm._v("Last Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.lastName),expression:"regParams.lastName"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","id":"p-signup-last-name","placeholder":"Last Name"},domProps:{"value":(_vm.regParams.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "lastName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-phone"}},[_vm._v("Phone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.phoneNumber),expression:"regParams.phoneNumber"}],staticClass:"form-control form-control-lg",attrs:{"type":"phone-number","id":"p-signup-phone","placeholder":"Phone Number"},domProps:{"value":(_vm.regParams.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-gender"}},[_vm._v("Gender")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"p-signup-gender","placeholder":"Choose Gender"},model:{value:(_vm.regParams.gender),callback:function ($$v) {_vm.$set(_vm.regParams, "gender", $$v)},expression:"regParams.gender"}},_vm._l((_vm.genderData),function(single_gender){return _c('el-option',{key:single_gender.id,attrs:{"label":single_gender.name,"value":single_gender.id}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-street_route"}},[_vm._v("Home Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.street_route),expression:"regParams.street_route"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-street_route","placeholder":"Home Address"},domProps:{"value":(_vm.regParams.street_route)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "street_route", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',{attrs:{"for":"p-signup-dateOfBirth"}},[_vm._v("Date of Birth")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.dateOfBirth.split('T')[0]),expression:"regParams.dateOfBirth.split('T')[0]"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-dateOfBirth","placeholder":"Date of Birth"},domProps:{"value":(_vm.regParams.dateOfBirth.split('T')[0])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams.dateOfBirth.split('T'), 0, $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-street_route"}},[_vm._v("CC Emails")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regParams.ccEmails),expression:"regParams.ccEmails"}],staticClass:"form-control form-control-lg",attrs:{"type":"address","id":"p-signup-street_route","placeholder":"CC Email"},domProps:{"value":(_vm.regParams.ccEmails)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regParams, "ccEmails", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send E-mail")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"inactive-text":"Send Email","active-text":"Don't send Email"},model:{value:(_vm.regParams.noMail),callback:function ($$v) {_vm.$set(_vm.regParams, "noMail", $$v)},expression:"regParams.noMail"}})],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"btn btn-info btn-block btn-lg p-signup__form-submit",attrs:{"disabled":_vm.isLoading,"type":"submit"},on:{"click":_vm.submitReg}},[_vm._v("\n            "+_vm._s(_vm.isLoading ? "Loading..." : "Update Profile")+"\n          ")])])],1)])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__(902);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddcb9b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__(2114);
function injectStyle (ssrContext) {
  __webpack_require__(2113)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ddcb9b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ddcb9b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"text-center profile-header mt-5"},[_c('b-col',{attrs:{"md":"4"}},[_c('b-row',{staticClass:"widget_box pink widget widget-alpha widget-alpha--color-amaranth"},[_c('div',{staticClass:"user-caption"},[_c('h2',[_vm._v("\n              "+_vm._s(_vm.currentUser.firstName)+"\n              "),_c('span',[_vm._v(_vm._s(_vm.currentUser.lastName))])]),_vm._v(" "),_c('div',{staticClass:"caption user-details"},[_c('h6',[_c('span',{staticClass:"fa fa-envelope-o"}),_vm._v("\n                "+_vm._s(_vm.currentUser.email)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"caption user-details"},[_c('h6',[_c('span',{staticClass:"fa fa-phone"}),_vm._v("\n                "+_vm._s(_vm.currentUser.phoneNumber)+"\n              ")])])])])],1),_vm._v(" "),_c('b-col',{attrs:{"md":"8"}},[_c('div',{staticClass:"mt-5",staticStyle:{"background":"none"}},[_c('div',{staticClass:"content"},[_c('b-row',[(_vm.currentUser.installations&&_vm.currentUser.installations.length>0)?_c('b-col',{staticClass:"mt-5"},[_c('div',{staticClass:"pink widget widget-alpha widget-alpha--color-amaranth single_device"},[_c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v("Installations")]),_vm._v(" "),_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"scope":"col"}},[_vm._v("Instalation Name")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("CID")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("System Capacity")]),_vm._v(" "),_c('th',{attrs:{"scope":"col"}},[_vm._v("System Type")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.currentUser.installations),function(device){return _c('tr',{key:device.id,on:{"click":function($event){return _vm.navTo(device.id)}}},[_c('td',[_vm._v(_vm._s(device.name?device.name:"Unassigned"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(("" + (device.CID?device.CID:device.solarKitIds))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(device.deviceRequest.systemCapacity?((device.deviceRequest.systemCapacity) + " kVA"):"--"))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(device.deviceType.name))])])}),0)])])])]):_vm._e(),_vm._v(" "),_c('b-col',[_c('div',{staticClass:"widget_box pink widget widget-alpha widget-alpha--color-amaranth"},[_c('div',{staticClass:"col-md-12"},[_c('h2',[_vm._v("Recent Payments")]),_vm._v(" "),_c('ul',{staticClass:"device_list"},[_c('can',{attrs:{"I":"read","a":"token"}},[_c('transaction-histories')],1)],1)])])])],1)],1)])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishTab_vue__ = __webpack_require__(903);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93f9cbea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishTab_vue__ = __webpack_require__(2117);
function injectStyle (ssrContext) {
  __webpack_require__(2116)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-93f9cbea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FinishTab_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_93f9cbea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FinishTab_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2116 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('div',{staticClass:"heading"},[_c('img',{attrs:{"width":"200","src":__webpack_require__(2118)}}),_vm._v(" "),_c('h2',{staticClass:"login-title"},[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      You are on your way to enjoying stable power supply! We are now\n      processing your unit for installation and will call you soon to finalize\n      the documentation and installation process.\n    ")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("\n      An email with your purchase details has been sent to you. Thank you for\n      choosing Arnergy.\n    ")])]),_vm._v(" "),_c('div',{staticClass:"footer"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2118 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Billing_vue__ = __webpack_require__(904);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6209e597_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Billing_vue__ = __webpack_require__(2140);
function injectStyle (ssrContext) {
  __webpack_require__(2120)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6209e597"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Billing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6209e597_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Billing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2121 */,
/* 2122 */,
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */,
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoader_vue__ = __webpack_require__(906);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f995cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerLoader_vue__ = __webpack_require__(2139);
function injectStyle (ssrContext) {
  __webpack_require__(2138)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27f995cb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SpinnerLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27f995cb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SpinnerLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"lds-spinner"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]),_vm._v(" "),_c('h3',[_vm._v("Processing ...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"switch-row"},[_c('div',{staticClass:"select-device"},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"active-device","placeholder":"Choose Device"},on:{"change":function($event){return _vm.changeActiveDevice(_vm.activeDevice)}},model:{value:(_vm.activeDevice),callback:function ($$v) {_vm.activeDevice=$$v},expression:"activeDevice"}},_vm._l((_vm.devices),function(device,key){return _c('el-option',{key:key,attrs:{"label":("Device " + device),"value":device}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"button-text",on:{"click":function($event){return _vm.flutterwavePaygate('10')}}},[_vm._v("\n        + Add New Card\n      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"each-rowsa"},[_vm._l((_vm.debitCards),function(card,index){return _c('div',{key:index},[(card.isDefaultCard)?_c('div',{staticClass:"default-card"},[_c('div',{staticClass:"single-card"},[_c('img',{staticClass:"arnergy-logo",attrs:{"src":__webpack_require__(421),"alt":"arnergy-logo"}}),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('h2',[_vm._v(_vm._s("**** **** **** " + card.last4digits))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.lastName)+" "+_vm._s(card.firstName))])]),_vm._v(" "),_c('div',{staticClass:"card-base"},[(card.cardtype == 'MASTERCARD')?_c('img',{staticClass:"card-logo",attrs:{"src":__webpack_require__(907),"alt":"card-logo"}}):_c('img',{staticClass:"card-logo",attrs:{"src":__webpack_require__(908),"alt":"card-logo"}})])]),_vm._v(" "),_c('div',{staticClass:"payment-details"},[_c('div',{staticClass:"left"},[_c('p',[_vm._v("Next Due Payment ("+_vm._s(_vm.formatDate(_vm.dueDate))+")")]),_vm._v(" "),_c('h3',[_vm._v("\n                NGN\n                "+_vm._s(_vm.amountDue
                    ? _vm.amountDue.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
                    : "0.00")+"\n              ")])]),_vm._v(" "),_c('button',{style:(_vm.notDue
                  ? ''
                  : _vm.isDue
                  ? 'border: 1px solid red; color: red; '
                  : ''),on:{"click":function($event){return _vm.makePayment(_vm.currentID)}}},[_vm._v("\n              Pay Now\n            ")])])]):_vm._e()])}),_vm._v(" "),_vm._l((_vm.debitCards),function(card,index2){return _c('div',{key:index2,staticClass:"list"},[(!card.isDefaultCard)?_c('div',{staticClass:"other-card"},[_c('div',{staticClass:"single-card"},[_c('img',{staticClass:"arnergy-logo",attrs:{"src":__webpack_require__(421),"alt":"arnergy-logo"}}),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('h2',[_vm._v(_vm._s("**** **** **** " + card.last4digits))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(card.lastName)+" "+_vm._s(card.firstName))])]),_vm._v(" "),_c('div',{staticClass:"card-base"},[(card.cardtype == 'MASTERCARD')?_c('img',{staticClass:"card-logo",attrs:{"src":__webpack_require__(907),"alt":"card-logo"}}):_c('img',{staticClass:"card-logo",attrs:{"src":__webpack_require__(908),"alt":"card-logo"}})])]),_vm._v(" "),_c('div',{staticClass:"other-details"},[_c('button',{on:{"click":function($event){return _vm.setDefaultCard(card.id, card.customerid)}}},[_vm._v("Set as Default Card")])])]):_vm._e()])})],2)]),_vm._v(" "),_c('div',[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 transaction-table"},[_c('vue-good-table',{staticClass:"table",attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.transactionHistory,"totalRows":_vm.total,"pagination-options":{
          enabled: true,
        }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'transactionReference')?_c('span',[_vm._v("\n            "+_vm._s(props.row.transactionReference
                ? props.row.transactionReference
                : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'fullName')?_c('span',[_vm._v("\n            "+_vm._s(props.row.user
                ? ((props.row.user.firstName) + " " + (props.row.user.lastName))
                : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amountPaid')?_c('span',[_vm._v("\n            "+_vm._s(props.row.actualAmount
                ? ("NGN " + (props.row.actualAmount
                    .toFixed(2)
                    .toString()
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")))
                : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentStatus')?_c('span',{staticClass:"center-svg"},[(props.row.status)?_c('span',[_vm._v("\n              "+_vm._s(props.row.status == "success"
                  ? ("Success - **** **** **** " + (props.row.detail.card.last_4digits) + " (" + (props.row.detail.card.type
                        .toString()
                        .charAt(0)
                        .toUpperCase() +
                      props.row.detail.card.type
                        .toString()
                        .substr(1)
                        .toLowerCase()) + ")")
                  : "Failed transaction")+"\n            ")]):_c('span',[_vm._v(" - - - - ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentTime')?_c('span',[(props.row.createdAt)?_c('span',[_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.createdAt))+"\n              "+_vm._s(_vm.formatTime(props.row.createdAt))+"\n            ")]):_c('span',[_vm._v(" - - - - ")])]):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px","margin-left":"10px"}},[_c('h2',{staticClass:"page-title",staticStyle:{"flex":"1"}},[_vm._v("Billing")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionHistory_vue__ = __webpack_require__(909);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5295f3fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionHistory_vue__ = __webpack_require__(2143);
function injectStyle (ssrContext) {
  __webpack_require__(2142)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5295f3fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TransactionHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5295f3fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TransactionHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.transactionHistory,"totalRows":_vm.total,"pagination-options":{ 
					enabled: true
				}},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPerPageChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'transactionReference')?_c('span',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.transactionReference ? props.row.transactionReference : "----")+"\n\t\t\t\t\t")]):_vm._e(),_vm._v(" "),(props.column.field == 'fullName')?_c('span',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.user ? ((props.row.user.firstName) + " " + (props.row.user.lastName)) : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amountPaid')?_c('span',[_vm._v("\n\t\t\t\t\t\t"+_vm._s(props.row.actualAmount ? ("NGN " + ((props.row.actualAmount).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))) : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentStatus')?_c('span',{staticClass:"center-svg"},[(props.row.status)?_c('span',[_vm._v("\n              "+_vm._s(props.row.status == "success" ? ("Success - **** **** **** " + (props.row.detail.card.last_4digits) + " (" + ((props.row.detail.card.type).toString().charAt(0).toUpperCase() +	(props.row.detail.card.type).toString().substr(1).toLowerCase()) + ")") : "Failed transaction")+"\n            ")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t- - - - \n\t\t\t\t\t\t")])]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentTime')?_c('span',[(props.row.createdAt)?_c('span',[_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.createdAt))+" "+_vm._s(_vm.formatTime(props.row.createdAt))+"\n            ")]):_c('span',[_vm._v("\n\t\t\t\t\t\t\t- - - - \n\t\t\t\t\t\t")])]):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Transaction History")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingTracker_vue__ = __webpack_require__(910);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c26adca0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingTracker_vue__ = __webpack_require__(2146);
function injectStyle (ssrContext) {
  __webpack_require__(2145)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c26adca0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingTracker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c26adca0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingTracker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"main-container onboarding-tracker-table-height"},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getUsers,"isLoading":_vm.isLoadingVGT,"select-options":_vm.selectOption,"search-options":{
          enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm
        },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'fullName')?_c('span',[_vm._v("\n            "+_vm._s(props.row.fullName ? props.row.fullName : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'completionDate')?_c('span',[(props.row.completionDate)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("formatDate")(props.row.completionDate))+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'startDate')?_c('span',[(props.row.startDate)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("formatDate")(props.row.startDate))+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentType')?_c('span',[(props.row.paymentType)?_c('span',{staticClass:"center-svg"},[_vm._v("\n              "+_vm._s(props.row.paymentType)+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'productType')?_c('span',[(props.row.productType)?_c('span',[_vm._v("\n              "+_vm._s(props.row.productType)+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'signedAgreement')?_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross(props.row.signedAgreement ? 'Y' : 'N')}})]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentTenure')?_c('span',[(props.row.paymentTenure)?_c('span',{staticClass:"center-svg"},[_vm._v("\n              "+_vm._s(props.row.paymentTenure)+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e(),_vm._v(" "),(props.column.field == 'statementPassed')?_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross(props.row.statementPassed ? 'Y' : 'N')}})]):_vm._e(),_vm._v(" "),(props.column.field == 'kycUploadComplete')?_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross(props.row.kycUploadComplete ? 'Y' : 'N')}})]):_vm._e(),_vm._v(" "),(props.column.field == 'depositSuccessful')?_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross(props.row.depositSuccessful ? 'Y' : 'N')}})]):_vm._e(),_vm._v(" "),(props.column.field == 'installationStatus')?_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross(props.row.installationStatus ? 'Y' : 'N')}})]):_vm._e(),_vm._v(" "),(props.column.field == 'installationDate')?_c('span',[(props.row.installationDate)?_c('span',[_vm._v("\n              "+_vm._s(_vm._f("formatDate")(props.row.installationDate))+"\n            ")]):_c('span',[_c('img',{staticClass:"center-svg",attrs:{"src":_vm.tickOrCross('N')}})])]):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.editOffCanvas},on:{"update:show":function($event){_vm.editOffCanvas=$event}}},[_c('div',{},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.editOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Edit")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.name),callback:function ($$v) {_vm.$set(_vm.regDataParams, "name", $$v)},expression:"regDataParams.name"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(_vm._s(_vm.isLoading ? "Loading..." : "Edit"))])],1)],1)],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Customer Onboarding Tracker")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBilling_vue__ = __webpack_require__(913);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7aaa16c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBilling_vue__ = __webpack_require__(2152);
function injectStyle (ssrContext) {
  __webpack_require__(2148)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7aaa16c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminBilling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7aaa16c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminBilling_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BillingListing_vue__ = __webpack_require__(914);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_936e1144_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BillingListing_vue__ = __webpack_require__(2151);
function injectStyle (ssrContext) {
  __webpack_require__(2150)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-936e1144"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BillingListing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_936e1144_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BillingListing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container billing-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type Customers ID","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getUsers,"isLoading":_vm.isLoadingVGT,"search-options":{
        enabled: true,
        searchFn: _vm.searchTable,
        externalQuery: _vm.searchTerm
      },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'firstName')?_c('span',[_vm._v("\n          "+_vm._s(props.row.user ? props.row.user.firstName : "----")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'lastName')?_c('span',[_vm._v("\n          "+_vm._s(props.row.user ? props.row.user.lastName : "----")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v("\n          "+_vm._s(props.row.installation ? props.row.installation.CID : "----")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'totalPrice')?_c('span',[_vm._v("\n          "+_vm._s((props.row.totalPrice ? props.row.totalPrice : "----").replace(
              /\B(?=(\d{3})+(?!\d))/g,
              ","
            ))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'monthlyCharge')?_c('span',[_vm._v("\n          "+_vm._s((props.row.monthlyCharge
              ? props.row.monthlyCharge
              : "----"
            ).replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amountPaid')?_c('span',[_vm._v("\n          "+_vm._s((props.row.totalAmountPaid
              ? props.row.totalAmountPaid
              : "----"
            ).replace(/\B(?=(\d{3})+(?!\d))/g, ","))+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'numberOfTimesPaymentIsMade')?_c('span',[_vm._v("\n          "+_vm._s(props.row.numberOfTimesPaymentIsMade
              ? props.row.numberOfTimesPaymentIsMade
              : "----")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'remainingPayment')?_c('span',[_vm._v(_vm._s((props.row.totalPrice - props.row.totalAmountPaid).toLocaleString(
            "en-US"
          )))]):_vm._e(),_vm._v(" "),(props.column.field == 'remainingDuration')?_c('span',[_vm._v("\n          "+_vm._s(props.row.duration - props.row.numberOfTimesPaymentIsMade))]):_vm._e(),_vm._v(" "),(props.column.field == 'monthlyRecurringChargeDate')?_c('span',[_vm._v("\n          "+_vm._s(_vm.formatDate(props.row.monthlyRecurringChargeDate)
              ? _vm.formatDate(props.row.monthlyRecurringChargeDate)
              : "----")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('router-link',{attrs:{"to":{
              name: 'BillingUpdate',
              params: {
                id: props.row.id,
                installationCID: props.row.installation
                  ? props.row.installation.CID
                  : 0,
                monthlyCharge: props.row.monthlyCharge,
                numbOfpayment: props.row.numberOfTimesPaymentIsMade,
                chargeDate: _vm.formatDate(props.row.monthlyRecurringChargeDate),
                pDuration: props.row.duration ? props.row.duration : 0,
                amounts: props.row.totalPrice
              }
            }}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("  \n          ")]),_vm._v(" "),_c('button',{staticClass:"red-border",on:{"click":function($event){return _vm.deleteModal(
                props.row.installation ? props.row.installation.CID : 0,
                props.row.id
              )}}},[_c('i',{staticClass:"fa fa-trash"})])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])}),_vm._v(" "),_c('modal',{attrs:{"name":"my-first-modal"}},[_c('div',{staticClass:"form",staticStyle:{"width":"80%"}},[_c('form',{attrs:{"name":"myForm","method":""},on:{"submit":_vm.deletionDetails}},[_c('h4',[_vm._v("\n            Are you sure you want to delete device\n            "+_vm._s(_vm.idSelected)+"?\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.deleteReason),expression:"deleteReason"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"fname","id":"modalText","required":true,"placeholder":"State your reason for deleting the user"},domProps:{"value":(_vm.deleteReason)},on:{"input":function($event){if($event.target.composing){ return; }_vm.deleteReason=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"button-delete",attrs:{"type":"submit"},on:{"click":function($event){$event.preventDefault();return _vm.deletionDetails(_vm.deleteDevice)}}},[_vm._v("\n              Delete\n            ")]),_vm._v(" "),_c('button',{staticClass:"button-cancel",attrs:{"type":"submit"},on:{"click":_vm.cancel}},[_vm._v("\n              Cancel\n            ")])])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}}),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Customer Billing")]),_vm._v(" "),(_vm.usertype != 'customer admin')?_c('div',{staticStyle:{"display":"flex","margin-right":"20px"}},[_c('span',{staticStyle:{"flex":"1","align-items":"center","margin-right":"10px"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/user/billing"}},[_vm._v("Setup Billing")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('BillingListing')],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxOnboarding_vue__ = __webpack_require__(915);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1e2bb9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxOnboarding_vue__ = __webpack_require__(2164);
function injectStyle (ssrContext) {
  __webpack_require__(2154)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2e1e2bb9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxOnboarding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e1e2bb9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxOnboarding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceSerial_vue__ = __webpack_require__(916);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1b1055c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceSerial_vue__ = __webpack_require__(2157);
function injectStyle (ssrContext) {
  __webpack_require__(2156)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b1b1055c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceSerial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b1b1055c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceSerial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"container-fluid"},[_c('div',{staticClass:"device_serial"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"deviceId"}},[_vm._v("Choose a Device ID\n        ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.deviceId),expression:"regparams.deviceId"}],staticClass:"form-control",attrs:{"name":"deviceId","id":"deviceId","placeholder":"Select a DeviceId","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.regparams, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":"","hidden":""}},[_vm._v("Select a DeviceId")]),_vm._v(" "),_c('option',{attrs:{"value":"41148428"}},[_vm._v("41148428")]),_vm._v(" "),_c('option',{attrs:{"value":"41148430"}},[_vm._v("41148430")]),_vm._v(" "),_c('option',{attrs:{"value":"416811"}},[_vm._v("416811")])])])]),_vm._v(" "),_c('div',{staticClass:"row mul_select"},[_c('div',{staticClass:"col-12 multiple_option"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"lux_serial_number"}},[_vm._v("Pick one or more Lux Serial Number")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.serialNumbers),expression:"regparams.serialNumbers"}],staticClass:"form-control",attrs:{"name":"lux_serial_number","id":"lux_serial_number","multiple":"","size":"2"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.regparams, "serialNumbers", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2480530042"}},[_vm._v("2480530042")]),_vm._v(" "),_c('option',{attrs:{"value":"2480530073"}},[_vm._v("2480530073")]),_vm._v(" "),_c('option',{attrs:{"value":"2480530057"}},[_vm._v("2480530057")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416774"}},[_vm._v("ARN-416774")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416775"}},[_vm._v("ARN-416775")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416776"}},[_vm._v("ARN-416776")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416777"}},[_vm._v("ARN-416777")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416778"}},[_vm._v("ARN-416778")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416779"}},[_vm._v("ARN-416779")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416770"}},[_vm._v("ARN-416770")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-4167712"}},[_vm._v("ARN-4167712")])])])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"button_style"},[_c('button',{staticClass:"btn btn-outline-primary btn-lg",attrs:{"type":"submit"},on:{"click":_vm.back}},[_vm._v("\n          Back\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("\n          Next\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxPayment_vue__ = __webpack_require__(917);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b665013_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxPayment_vue__ = __webpack_require__(2160);
function injectStyle (ssrContext) {
  __webpack_require__(2159)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b665013"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxPayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b665013_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxPayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"container-fluid"},[_c('div',{staticClass:"lux_payment"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"payment_type"}},[_vm._v("Select Payment Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.paymentType),expression:"luxPayment.paymentType"}],staticClass:"form-control form-control-lg",attrs:{"name":"payment_type","id":"payment_type","placeholder":"Select a Payment Type"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.luxPayment, "paymentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":"","hidden":""}},[_vm._v("Select a Payment Type")]),_vm._v(" "),_c('option',{attrs:{"value":"OS"}},[_vm._v("Outright Sale (OS)")]),_vm._v(" "),_c('option',{attrs:{"value":"LO"}},[_vm._v("Lease to Own (LO)")]),_vm._v(" "),_c('option',{attrs:{"value":"ES"}},[_vm._v("ENERGY AS A SERVICE (ES)")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"CLoad"}},[_vm._v("Enter CLoad Value")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.cLoadValue),expression:"luxPayment.cLoadValue"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"Cload","id":"Cload","placeholder":"Contractual Load"},domProps:{"value":(_vm.luxPayment.cLoadValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.luxPayment, "cLoadValue", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"device_version"}},[_vm._v("Select Device Version")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.deviceVersion),expression:"luxPayment.deviceVersion"}],staticClass:"form-control form-control-lg",attrs:{"name":"device_version","id":"device_version"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.luxPayment, "deviceVersion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":"","hidden":""}},[_vm._v("Select a Device version")]),_vm._v(" "),_c('option',{attrs:{"value":"v3"}},[_vm._v("System Version 3")]),_vm._v(" "),_c('option',{attrs:{"value":"v5"}},[_vm._v("System Version 5")]),_vm._v(" "),_c('option',{attrs:{"value":"v6"}},[_vm._v("System Version 6")]),_vm._v(" "),_c('option',{attrs:{"value":"v7"}},[_vm._v("System Version 7")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"CID"}},[_vm._v("Device CID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.CID),expression:"luxPayment.CID"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"CID","id":"CID","placeholder":"CID"},domProps:{"value":(_vm.luxPayment.CID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.luxPayment, "CID", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"charge_cycle"}},[_vm._v("Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.Charge),expression:"luxPayment.Charge"}],staticClass:"form-control",attrs:{"type":"number","name":"Charge Cycle","id":"charge_cycle","placeholder":"Charge Cycle"},domProps:{"value":(_vm.luxPayment.Charge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.luxPayment, "Charge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"E_charge_cycle"}},[_vm._v("Exptd. Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.luxPayment.ExptdCharge),expression:"luxPayment.ExptdCharge"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"E_charge_cycle","id":"E_charge_cycle","placeholder":"Expected Charge Cycle"},domProps:{"value":(_vm.luxPayment.ExptdCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.luxPayment, "ExptdCharge", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"button_style"},[_c('button',{staticClass:"btn btn-outline-primary btn-lg",attrs:{"type":"submit"},on:{"click":_vm.back}},[_vm._v("\n          Back\n        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("\n          Onboard\n        ")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxMisc_vue__ = __webpack_require__(918);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dd2813_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxMisc_vue__ = __webpack_require__(2163);
function injectStyle (ssrContext) {
  __webpack_require__(2162)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-29dd2813"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxMisc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29dd2813_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxMisc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"container-fluid"},[_c('div',{staticClass:"luxMisc"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"CID"}},[_vm._v("Device CID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.CID),expression:"regparams.CID"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"CID","id":"CID","placeholder":"CID"},domProps:{"value":(_vm.regparams.CID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "CID", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"charge_cycle"}},[_vm._v("Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.Charge),expression:"regparams.Charge"}],staticClass:"form-control",attrs:{"type":"number","name":"Charge Cycle","id":"charge_cycle","placeholder":"Charge Cycle"},domProps:{"value":(_vm.regparams.Charge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "Charge", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"E_charge_cycle"}},[_vm._v("Exptd. Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.ExptdCharge),expression:"regparams.ExptdCharge"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"E_charge_cycle","id":"E_charge_cycle","placeholder":"Expected Charge Cycle"},domProps:{"value":(_vm.regparams.ExptdCharge)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "ExptdCharge", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"LAC"}},[_vm._v("LAC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.LAC),expression:"regparams.LAC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"LAC","id":"LAC","placeholder":"LAC"},domProps:{"value":(_vm.regparams.LAC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "LAC", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"MCC"}},[_vm._v("MCC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MCC),expression:"regparams.MCC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"MCC","id":"MCC","placeholder":"MCC"},domProps:{"value":(_vm.regparams.MCC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "MCC", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"MNC"}},[_vm._v("MNC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MNC),expression:"regparams.MNC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"MNC","id":"MNC","placeholder":"MNC"},domProps:{"value":(_vm.regparams.MNC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "MNC", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PAP"}},[_vm._v("PAP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.PAP),expression:"regparams.PAP"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PAP","id":"PAP","placeholder":"PAP"},domProps:{"value":(_vm.regparams.PAP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "PAP", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PAT"}},[_vm._v("PAT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.PAT),expression:"regparams.PAT"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PAT","id":"PAT","placeholder":"PAT"},domProps:{"value":(_vm.regparams.PAT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "PAT", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PSC"}},[_vm._v("PSC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.PSC),expression:"regparams.PSC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PSC","id":"PSC","placeholder":"PSC"},domProps:{"value":(_vm.regparams.PSC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "PSC", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"Radio"}},[_vm._v("Radio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.Radio),expression:"regparams.Radio"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"Radio","id":"Radio","placeholder":"Radio"},domProps:{"value":(_vm.regparams.Radio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "Radio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"SIM"}},[_vm._v("SIM")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.SIM),expression:"regparams.SIM"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"SIM","id":"SIM","placeholder":"SIM"},domProps:{"value":(_vm.regparams.SIM)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "SIM", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"button_style"},[_c('button',{staticClass:"btn btn-outline-primary btn-lg",attrs:{"type":"submit"},on:{"click":_vm.back}},[_vm._v("\n            Back\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("\n            Next\n          ")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"container-fluid body"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header_placement"},[_c('h2',{staticStyle:{"color":"#0892D0"}},[_vm._v("Arnergy Lux Devices")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(this.$store.state.luxCount)+" of 2")])]),_vm._v(" "),(this.$store.state.luxCount == 1)?_c('div',[_c('DeviceSerial')],1):(this.$store.state.luxCount == 2)?_c('div',[_c('LuxPayment')],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxDeviceUpdate_vue__ = __webpack_require__(919);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a6a5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxDeviceUpdate_vue__ = __webpack_require__(2167);
function injectStyle (ssrContext) {
  __webpack_require__(2166)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d6a6a5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LuxDeviceUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6a6a5d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LuxDeviceUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"container-fluid body"},[_c('div',{staticClass:"container arnergy_lux"},[_c('div',{staticClass:"cotainer"},[_c('h2',{staticStyle:{"color":"#0892D0"}},[_vm._v("\n        Update Arnergy Lux Device - "+_vm._s(this.$route.params.exportDeviceid)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"container device_serial"},[_c('div',{staticClass:"row mul_select"},[_c('div',{staticClass:"col-12 multiple_option"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"lux_serial_number"}},[_vm._v("Pick one or more Lux Serial Number")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.serialNumbers),expression:"regparams.serialNumbers"}],staticClass:"form-control",attrs:{"name":"lux_serial_number","id":"lux_serial_number","multiple":"","size":"2"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.regparams, "serialNumbers", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"2480530042"}},[_vm._v("2480530042")]),_vm._v(" "),_c('option',{attrs:{"value":"2480530073"}},[_vm._v("2480530073")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416773"}},[_vm._v("ARN-416773")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416774"}},[_vm._v("ARN-416774")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416775"}},[_vm._v("ARN-416775")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416776"}},[_vm._v("ARN-416776")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416777"}},[_vm._v("ARN-416777")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416778"}},[_vm._v("ARN-416778")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416779"}},[_vm._v("ARN-416779")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-416770"}},[_vm._v("ARN-416770")]),_vm._v(" "),_c('option',{attrs:{"value":"ARN-4167712"}},[_vm._v("ARN-4167712")])])])])]),_vm._v(" "),_c('div',{staticClass:"container lux_payment"},[_c('div',{staticClass:"row lux_payment_row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"payment_type"}},[_vm._v("Select Payment Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.paymentType),expression:"regparams.paymentType"}],staticClass:"form-control form-control-lg",attrs:{"name":"payment_type","id":"payment_type","placeholder":"Select a payment type","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.regparams, "paymentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":"","hidden":""}},[_vm._v("Select Payment Type")]),_vm._v(" "),_c('option',{attrs:{"value":"OS"}},[_vm._v("Outright Sale (OS)")]),_vm._v(" "),_c('option',{attrs:{"value":"LO"}},[_vm._v("Lease to Own (LO)")]),_vm._v(" "),_c('option',{attrs:{"value":"ES"}},[_vm._v("ENERGY AS A SERVICE (ES)")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"CLoad"}},[_vm._v("Enter CLoad Value")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.CLoad),expression:"regparams.CLoad"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"Cload","id":"Cload","placeholder":"Input Cload"},domProps:{"value":(_vm.regparams.CLoad)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams, "CLoad", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"device_version"}},[_vm._v("Select Device Version")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.Version),expression:"regparams.Version"}],staticClass:"form-control form-control-lg",attrs:{"name":"device_version","id":"device_version","placeholder":"Version _","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.regparams, "Version", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","disabled":"","selected":"","hidden":""}},[_vm._v("Select Device Version")]),_vm._v(" "),_c('option',{attrs:{"value":"v3"}},[_vm._v("System Version 3")]),_vm._v(" "),_c('option',{attrs:{"value":"v5"}},[_vm._v("System Version 5")]),_vm._v(" "),_c('option',{attrs:{"value":"v6"}},[_vm._v("System Version 6")]),_vm._v(" "),_c('option',{attrs:{"value":"v7"}},[_vm._v("System Version 7")])])])])]),_vm._v(" "),_c('div',{staticClass:"container luxMisc"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"CID"}},[_vm._v("Device CID")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.CID),expression:"regparams.MiscData.CID"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"CID","id":"CID","placeholder":"CID number"},domProps:{"value":(_vm.regparams.MiscData.CID)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "CID", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"charge_cycle"}},[_vm._v("Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.ChgCycle),expression:"regparams.MiscData.ChgCycle"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"Charge Cycle","id":"charge_cycle","placeholder":"Charge Cycle"},domProps:{"value":(_vm.regparams.MiscData.ChgCycle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "ChgCycle", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"E_charge_cycle"}},[_vm._v("Exptd. Charge Cycle")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.ExptdChgCyl),expression:"regparams.MiscData.ExptdChgCyl"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"E_charge_cycle","id":"E_charge_cycle","placeholder":"Expected Charge"},domProps:{"value":(_vm.regparams.MiscData.ExptdChgCyl)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "ExptdChgCyl", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"LAC"}},[_vm._v("LAC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.LAC),expression:"regparams.MiscData.LAC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"LAC","id":"LAC","placeholder":"LAC"},domProps:{"value":(_vm.regparams.MiscData.LAC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "LAC", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"MCC"}},[_vm._v("MCC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.MCC),expression:"regparams.MiscData.MCC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"MCC","id":"MCC","placeholder":"MCC"},domProps:{"value":(_vm.regparams.MiscData.MCC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "MCC", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"MNC"}},[_vm._v("MNC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.MNC),expression:"regparams.MiscData.MNC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"MNC","id":"MNC","placeholder":"MNC"},domProps:{"value":(_vm.regparams.MiscData.MNC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "MNC", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PAP"}},[_vm._v("PAP")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.PAP),expression:"regparams.MiscData.PAP"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PAP","id":"PAP","placeholder":"PAP"},domProps:{"value":(_vm.regparams.MiscData.PAP)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "PAP", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PAT"}},[_vm._v("PAT")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.PAT),expression:"regparams.MiscData.PAT"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PAT","id":"PAT","placeholder":"PAT"},domProps:{"value":(_vm.regparams.MiscData.PAT)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "PAT", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"PSC"}},[_vm._v("PSC")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.PSC),expression:"regparams.MiscData.PSC"}],staticClass:"form-control form-control-lg",attrs:{"type":"number","name":"PSC","id":"PSC","placeholder":"PSC"},domProps:{"value":(_vm.regparams.MiscData.PSC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "PSC", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"Radio"}},[_vm._v("Radio")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.Radio),expression:"regparams.MiscData.Radio"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"Radio","id":"Radio","placeholder":"Radio"},domProps:{"value":(_vm.regparams.MiscData.Radio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "Radio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticStyle:{"color":"#0892D0"},attrs:{"for":"SIM"}},[_vm._v("SIM")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.regparams.MiscData.SIM),expression:"regparams.MiscData.SIM"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","name":"SIM","id":"SIM","placeholder":"SIM"},domProps:{"value":(_vm.regparams.MiscData.SIM)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.regparams.MiscData, "SIM", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"container button_style"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"}),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("\n              Enter\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLuxUsers_vue__ = __webpack_require__(920);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6479c620_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLuxUsers_vue__ = __webpack_require__(2170);
function injectStyle (ssrContext) {
  __webpack_require__(2169)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6479c620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListLuxUsers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6479c620_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListLuxUsers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","width":"89%","margin-left":"auto","margin-right":"auto"}},[_c('h2',{staticStyle:{"flex":"1","align-items":"center"}},[_vm._v("LUX Onboarding")]),_vm._v(" "),(_vm.usertype != 'customer')?_c('div',{staticStyle:{"display":"flex","margin-top":"16px"}},[_c('span',{staticStyle:{"flex":"1"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/lux-onboarding/create"}},[_vm._v("Create User")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"width":"89%","margin-left":"auto","margin-right":"auto"}},[_c('p',{staticStyle:{"text-align":"right","color":"orange"}},[_vm._v("\n      Total energy generated: "+_vm._s(_vm.luxTotalEnergy)+"kWh\n    ")])]),_vm._v(" "),_c('div',{staticClass:"main-container",staticStyle:{"width":"90%","margin":"auto"}},[_c('div',[_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getUsers,"search-options":{
          enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm
        },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'firstName')?_c('span',[_vm._v("\n            "+_vm._s(props.row.user ? props.row.user.firstName : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'lastName')?_c('span',[_vm._v("\n            "+_vm._s(props.row.user ? props.row.user.lastName : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v("\n            "+_vm._s(props.row.deviceId ? props.row.deviceId : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'serialNumbers')?_c('span',[_vm._v("\n            "+_vm._s(props.row.serialNumbers ? props.row.serialNumbers : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'Version')?_c('span',[_vm._v("\n            "+_vm._s(props.row.Version ? props.row.Version : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentType')?_c('span',[_vm._v("\n            "+_vm._s(props.row.paymentType ? props.row.paymentType : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('router-link',{attrs:{"to":{
                name: 'LuxDeviceUpdate',
                params: {
                  exportDeviceid: props.row.deviceId ? props.row.deviceId : 0
                }
              }}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v("  \n            ")]),_vm._v(" "),_c('button',{staticClass:"red-border",on:{"click":function($event){return _vm.deleteModal(props.row.deviceId ? props.row.deviceId : '----')}}},[_c('i',{staticClass:"fa fa-trash"})])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])}),_vm._v(" "),_c('modal',{attrs:{"name":"my-first-modal"}},[_c('div',{staticClass:"form",staticStyle:{"width":"80%"}},[_c('h4',[_vm._v("\n            Are you sure you want to delete User with the deviceID -\n            "+_vm._s(_vm.DeviceID)+"?\n          ")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('button',{staticClass:"button-delete",attrs:{"type":"submit"},on:{"click":_vm.deleteDevice}},[_vm._v("\n              Delete\n            ")]),_vm._v(" "),_c('button',{staticClass:"button-cancel",attrs:{"type":"submit"},on:{"click":_vm.cancel}},[_vm._v("\n              Cancel\n            ")])])])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTransactionHistory_vue__ = __webpack_require__(921);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_350e4150_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTransactionHistory_vue__ = __webpack_require__(2175);
function injectStyle (ssrContext) {
  __webpack_require__(2172)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-350e4150"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AdminTransactionHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_350e4150_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AdminTransactionHistory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.cxTeamFields,"rows":_vm.getUsersAdmin,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v("\n            "+_vm._s(props.row.gender + "" === "0" ? "Female" : "Male")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('router-link',{attrs:{"to":("priviledges/" + (props.row.id))},on:{"click":_vm.pressFunc}},[_c('button',{staticClass:"btn btn-md btn-success"},[_vm._v("\n                Pay Now  \n                "),_c('span',{staticClass:"fa fa-wrench"})])])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Transaction History ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Customer Name","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"500px"},attrs:{"type":"daterange","range-separator":"To","start-placeholder":"Start date","end-placeholder":"End date"},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1),_vm._v(" "),_c('div',{staticClass:"main-container transaction-table-height"},[_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.transactionHistories,"search-options":{
          enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm
        },"pagination-options":{ 
                    enabled: true
                }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'transactionReference')?_c('span',[_vm._v("\n                        "+_vm._s(props.row.transactionReference ? props.row.transactionReference : "----")+"\n                    ")]):_vm._e(),_vm._v(" "),(props.column.field == 'fullName')?_c('span',[_vm._v("\n                        "+_vm._s(props.row.detail&&props.row.detail.customer&&props.row.detail.customer.name ? props.row.detail.customer.name : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'amountPaid')?_c('span',[_vm._v("\n                        "+_vm._s(props.row.actualAmount ? ("NGN " + ((props.row.actualAmount).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))) : "----")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentStatus')?_c('span',{staticClass:"center-svg"},[(props.row.status)?_c('span',[_vm._v("\n              "+_vm._s(props.row.status == "success" ? ("Success - **** **** **** " + (props.row.detail&&props.row.detail.card.last_4digits) + " (" + ((props.row.detail&&props.row.detail.card.type).toString().charAt(0).toUpperCase() +	(props.row.detail&&props.row.detail.card.type).toString().substr(1).toLowerCase()) + ")") : "Failed transaction")+"\n            ")]):_c('span',[_vm._v("\n                            - - - - \n                        ")])]):_vm._e(),_vm._v(" "),(props.column.field == 'transactionType')?_c('span',[_vm._v("\n                        "+_vm._s(props.row.transactionType ? props.row.transactionType : "----")+"\n                    ")]):_vm._e(),_vm._v(" "),(props.column.field == 'paymentTime')?_c('span',[(props.row.createdAt)?_c('span',[_vm._v("\n              "+_vm._s(_vm.formatDate(props.row.createdAt))+" "+_vm._s(_vm.formatTime(props.row.createdAt))+"\n            ")]):_c('span',[_vm._v("\n                            - - - - \n                        ")])]):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Transaction History")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(924);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cef3ca16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2178);
function injectStyle (ssrContext) {
  __webpack_require__(2177)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cef3ca16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cef3ca16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 2177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid",staticStyle:{"min-height":"80vh"}},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("\n      Welcome to Arnergy\n      Solarbase™\n    ")]),_vm._v(" "),_c('div',[_c('div',{staticClass:"row"},[_c('can',{attrs:{"I":"create","a":"device"}},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box"},[_c('div',{staticClass:"top-widget-box__header"},[_c('span',{staticClass:"title"},[_vm._v("Expiry")]),_vm._v(" "),_c('i',{staticClass:"fa fa-calendar fa-2x icon"})]),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('h1',[_vm._v("Feb 19th")]),_vm._v(" "),_c('p',[_vm._v("2019")])])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"wallet"}},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box"},[_c('div',{staticClass:"top-widget-box__header"},[_c('span',{staticClass:"title"},[_vm._v("Wallet Balance")]),_vm._v(" "),_c('i',{staticClass:"fa fa-credit-card fa-2x icon"})]),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('h1',[_vm._v("₦"+_vm._s(_vm.getUserSession.wallet))]),_vm._v(" "),_c('p',[_c('b-button',{attrs:{"variant":"warning","size":"sm","to":"/shs/pay?type=wallet"}},[_vm._v("Fund Wallet")])],1)])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"device"}},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box"},[_c('div',{staticClass:"top-widget-box__header"},[_c('span',{staticClass:"title"},[_vm._v("Devices Capacity")]),_vm._v(" "),_c('i',{staticClass:"fa fa-hdd-o fa-2x icon"})]),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('h1',[_vm._v("\n                    12\n                    "),_c('span',{staticClass:"title"},[_vm._v("kWAh")])])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-xl-5 col-lg-5 col-md-12 sh"},[_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"widget_header",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"widget_header__title"},[_vm._v("Device Stat")]),_vm._v(" "),_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-12 sh"},[_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"widget_header",staticStyle:{"justify-content":"space-between"},attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"widget_header__title"},[_vm._v("Performance")]),_vm._v(" "),_c('el-select',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Filter"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('Center',{staticStyle:{"height":"200px"}},[_c('i',{staticClass:"fa fa-hourglass fa-4x"}),_vm._v("\n              Under Construction\n            ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-12 sh"},[_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"widget_header",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"widget_header__title"},[_vm._v("Device Stat")])]),_vm._v(" "),_c('Center',{staticStyle:{"height":"200px"}},[_c('i',{staticClass:"fa fa-hourglass fa-4x"}),_vm._v("\n              Under Construction\n            ")])],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main-container"},[_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.componentData,"search-options":{enabled: true,
          externalQuery: _vm.searchTerm},"pagination-options":{enabled: true},"lineNumbers":true,"styleClass":"table table-striped col-md-12"},on:{"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('div',{staticClass:"page-content__header-description col-md-12",staticStyle:{"line-height":"35px","padding-bottom":"14px","border-bottom":"1px solid rgba(200, 200, 200, 0.3)"}},[_vm._v("\n            Inventory Overview\n            "),_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showModal}},[_vm._v("\n              Add Inventory\n            ")])],1)]),_vm._v(" "),_vm._l((_vm.rows),function(row,index){return _c('div',{key:index,staticClass:"col-xl-3 col-lg-3 col-md-3 text-center"},[_c('div',{staticClass:"widget_box"},[_c('figcaption',[_c('h3',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.componentName[row.id])+" "+_vm._s(row.name))]),_vm._v(" "),_c('h5',{staticStyle:{"font-size":"2em"}},[_vm._v(_vm._s((_vm.inventoryCount[row.id]) || 0))])])])])})],2)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packages_vue__ = __webpack_require__(927);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2619368d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packages_vue__ = __webpack_require__(2183);
function injectStyle (ssrContext) {
  __webpack_require__(2182)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2619368d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_packages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2619368d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_packages_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.packageForm,"label-width":"120px"}},[_c('vk-modal',{attrs:{"show":_vm.showAddModal},on:{"update:show":function($event){_vm.showAddModal=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.showAddModal = false}}}),_vm._v(" "),_c('vk-modal-title',[_vm._v("Add Component")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Component"}},[_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(_vm.componentId),callback:function ($$v) {_vm.componentId=$$v},expression:"componentId"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Quantity"}},[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.packageForm.quantity),callback:function ($$v) {_vm.$set(_vm.packageForm, "quantity", $$v)},expression:"packageForm.quantity"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.selectedPackage?_vm.selectedPackage.name:'-'))]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.selectedPackage)?_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Components")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"text"},on:{"click":function($event){_vm.showAddModal = true}}},[_vm._v("Add")])],1),_vm._v(" "),((_vm.selectedPackage['packageComponents'].length < 1))?_c('Center',[_c('span',{staticClass:"fa fa-ban fa-4x"}),_vm._v("\n          No Component\n        ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.selectedPackage['packageComponents']),function(_package,index){return _c('div',{key:index,staticClass:"p__component_list"},[_c('div',{staticClass:"component_list_left"},[_c('h2',[_vm._v(_vm._s(_package['componentType']['name']))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_package['quantity']))])]),_vm._v(" "),_c('i',{staticClass:"fa fa-times-circle fa-2x",on:{"click":function($event){return _vm.deleteComponentConfig(_package['id'])}}})])})],2):_vm._e(),_vm._v(" "),(_vm.selectedPackage)?_c('el-card',{staticClass:"box-card",staticStyle:{"margin-top":"12px"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Package Price")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"text"},on:{"click":function($event){_vm.priceChangeDisabled = false}}},[_vm._v("Edit")])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('el-input-number',{staticStyle:{"flex":"1"},attrs:{"disabled":_vm.priceChangeDisabled,"controls-position":"right","min":1},model:{value:(_vm.packageDefaultPrice),callback:function ($$v) {_vm.packageDefaultPrice=$$v},expression:"packageDefaultPrice"}}),_vm._v(" "),(_vm.selectedPackage.price != _vm.packageDefaultPrice)?_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updatePackagePrice}},[_vm._v("Update")]):_vm._e()],1)]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"table-header-custom"},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_vm._v(" "),_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.systemTypes,"line-numbers":true,"search-options":{enabled: true,  externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},on:{"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"pagination-deviceTypeIdbottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pagdeviceTypeIdeChanged,"perPageChanged":props.deviceTypeIdperPageChanged}}),_vm._v("deviceTypeId\n                ")]}}])},[_vm._v("deviceTypeId\n              ")])],1)])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Products Packages")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2185 */,
/* 2186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditReorderLevelComponent__ = __webpack_require__(2187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReorderLevelAlert__ = __webpack_require__(2190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__ReorderLevelAlert__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EditReorderLevelComponent__["a"]; });





/***/ }),
/* 2187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReorderLevelComponent_vue__ = __webpack_require__(930);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2869726b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReorderLevelComponent_vue__ = __webpack_require__(2189);
function injectStyle (ssrContext) {
  __webpack_require__(2188)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2869726b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditReorderLevelComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2869726b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditReorderLevelComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vk-modal',{attrs:{"show":_vm.showReorderEditModal},on:{"update:show":function($event){_vm.showReorderEditModal=$event}}},[_c('vk-modal-close',{on:{"click":_vm.closeModal}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('vk-modal-title',[_vm._v("Edit Reorder Level")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('el-form-item',{staticClass:"form-item"},[_c('el-input',{attrs:{"placeholder":"Reorder Level","type":"number"},on:{"input":_vm.updateInput,"change":_vm.updateInput},model:{value:(_vm.modalValue),callback:function ($$v) {_vm.modalValue=$$v},expression:"modalValue"}})],1),_vm._v(" "),_c('el-button',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"12px"},attrs:{"size":""},on:{"click":_vm.updateReorderLevel}},[_vm._v("Save Changes")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReorderLevelAlert_vue__ = __webpack_require__(931);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bacdf40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReorderLevelAlert_vue__ = __webpack_require__(2192);
function injectStyle (ssrContext) {
  __webpack_require__(2191)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bacdf40"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReorderLevelAlert_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bacdf40_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReorderLevelAlert_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"item-container"},[(_vm.hover)?_c('div',{staticClass:"my-tooltip"},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v("Available items is less than the set Reoder level, please order/upload new inventory items ")]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',[_vm._v("Reorder Level")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.reorderLevel))])]),_vm._v(" "),_c('div',{staticClass:"item"},[_c('span',[_vm._v("Available Items")]),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.availableInventories))])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"buttonStyle",on:{"mouseleave":function($event){_vm.hover = false},"mouseenter":function($event){_vm.hover = true}}},[_c('i',{staticClass:"fa fa-warning"})])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('strong',[_vm._v("Warning")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('h3',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.selectedPackage?_vm.selectedPackage.name.toUpperCase():'-'))]),_vm._v(" "),_c('span',[((_vm.offCanvasType == 'component_type'))?_c('el-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.showAddModal = true}}},[_vm._v("\n            Add component type \n            "),_c('span',{staticClass:"fa fa-plus"})]):_c('el-button',{attrs:{"size":"md","variant":"primary"},on:{"click":function($event){_vm.showAddInventoryModal = true}}},[_vm._v("\n            Add inventory \n            "),_c('span',{staticClass:"fa fa-plus"})])],1)]),_vm._v(" "),_c('hr',{staticStyle:{"margin":"0px !important"}}),_vm._v(" "),((_vm.itemData.length < 1 && _vm.gettingPackage == false))?_c('Center',[_c('span',{staticClass:"fa fa-ban fa-4x"}),_vm._v("\n        "+_vm._s(_vm.offCanvasType=="inventory_data"? "No inventory item":"No Component Type")+"\n      ")]):_vm._e(),_vm._v(" "),((_vm.itemData.length < 1 && _vm.gettingPackage == true))?_c('Center',[_c('span',{staticClass:"fa fa-hourglass fa-4x animated infinite rotateIn"}),_vm._v("\n        "+_vm._s(_vm.offCanvasType=="inventory_data"? "Fetching inventory items":"Fetching Component Types")+"\n      ")]):_vm._e(),_vm._v(" "),((_vm.offCanvasType == 'component_type'))?[((_vm.itemData.length >= 1))?_c('div',{staticStyle:{"width":"100%","margin-top":"20px"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.componentFields,"rows":_vm.itemData,"search-options":{enabled: true,
              externalQuery: _vm.search},"pagination-options":{enabled: true},"lineNumbers":true,"styleClass":"table table-striped col-md-8"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'name')?_c('span',{staticClass:"nameStyle"},[_vm._v("\n                "+_vm._s(props.row.name? props.row['name']:'--')+"\n                "),_c('ReorderLevelAlert',{attrs:{"itemRow":props.row,"inventories":_vm.currentInventories}})],1):_vm._e(),_vm._v(" "),(props.column.field == 'description')?_c('span',[_vm._v(_vm._s(props.row.description? props.row['description']:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'reorderLevel')?_c('span',[_vm._v("\n                "+_vm._s(props.row.reorderLevel? props.row['reorderLevel'] : 0)+"\n                "),_c('button',{staticClass:"reorderLevelStyle",attrs:{"type":"button"},on:{"click":function($event){return _vm.editReorderButton(props.row)}}},[_c('i',{staticClass:"fa fa-pencil"})])]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('el-button',{attrs:{"size":"mini","type":"danger","plain":""},on:{"click":function($event){return _vm.handleComponentTypeDelete(props.$index,props.row)}}},[_vm._v("Delete")])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}],null,false,452565266)})],1):_vm._e()]:[((_vm.itemData.length >= 1))?_c('div',{staticStyle:{"width":"100%","margin-top":"20px"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.inventoryFields,"rows":_vm.itemData,"search-options":{enabled: true,
              externalQuery: _vm.search},"pagination-options":{enabled: true},"lineNumbers":true,"styleClass":"table table-striped col-md-8"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'name')?_c('span',[_vm._v(_vm._s(props.row.componentType.name? props.row.componentType.name:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'serialNumber')?_c('span',[_vm._v(_vm._s(props.row.serialNumber? props.row['serialNumber']:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'batchNumber')?_c('span',[_vm._v(_vm._s(props.row.batchNumber? props.row['batchNumber']:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('el-button',{attrs:{"size":"mini","type":"danger","plain":""},on:{"click":function($event){return _vm.handleInventoryDelete(props.$index,props.row)}}},[_vm._v("Delete")])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}],null,false,2827334640)})],1):_vm._e()]],2)]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.inventoryForm}},[_c('vk-modal',{attrs:{"show":_vm.showAddInventoryModal},on:{"update:show":function($event){_vm.showAddInventoryModal=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.showAddInventoryModal = false}}}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('vk-modal-title',[_vm._v("Add "+_vm._s(_vm.selectedPackage?_vm.selectedPackage.name:''))]),_vm._v(" "),_c('span',[_c('el-button',{attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){_vm.multiple=!_vm.multiple}}},[_vm._v("\n            Add "+_vm._s(_vm.multiple?"Single":"Multiple")+"\n             \n            "),_c('span',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('el-form-item',{staticClass:"form-item"},[_c('el-select',{staticStyle:{"flex":"1","width":"100%"},attrs:{"placeholder":"Select Component Type"},model:{value:(_vm.inventoryForm.componentTypeId),callback:function ($$v) {_vm.$set(_vm.inventoryForm, "componentTypeId", $$v)},expression:"inventoryForm.componentTypeId"}},_vm._l((_vm.componentTypeOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.name,"value":item.value}})}),1)],1),_vm._v(" "),(!_vm.multiple)?_c('el-form-item',{staticClass:"form-item"},[_c('el-input',{attrs:{"placeholder":"Batch Number","type":"text"},model:{value:(_vm.inventoryForm.batchNumber),callback:function ($$v) {_vm.$set(_vm.inventoryForm, "batchNumber", $$v)},expression:"inventoryForm.batchNumber"}})],1):_vm._e(),_vm._v(" "),(_vm.multiple)?_c('el-form-item',{staticClass:"form-item"},[_c('input',{ref:"input",staticStyle:{"background":"#fff"},attrs:{"type":"file"},on:{"change":_vm.readFile}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('progress',{staticStyle:{"width":"100%"},attrs:{"max":"100"},domProps:{"value":_vm.uploadPercentage}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.uploadStatus))])]):_c('el-form-item',{staticClass:"form-item"},[_c('el-input',{attrs:{"placeholder":"Serial Number","id":"inventoryForm_batch","type":"text"},model:{value:(_vm.inventoryForm.serialNumber),callback:function ($$v) {_vm.$set(_vm.inventoryForm, "serialNumber", $$v)},expression:"inventoryForm.serialNumber"}})],1),_vm._v(" "),_c('el-button',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"12px"},attrs:{"size":""},on:{"click":_vm.addInventory}},[_vm._v("\n          Add  \n          "),_c('span',{staticClass:"fa fa-plus"})])],1)],1),_vm._v(" "),_c('EditReorderLevelComponent',{attrs:{"showReorderEditModal":_vm.showReorderEditModal,"reorderItemRow":_vm.reorderItemRow,"defaultValue":_vm.reorderItemRow && _vm.reorderItemRow.reorderLevel ? _vm.reorderItemRow.reorderLevel : 0},on:{"closeModal":_vm.closeEditReorderLevelModal,"updateCallback":_vm.reorderLevelUpdateResponse}})],1),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.componentForm,"label-width":"120px"}},[_c('vk-modal',{attrs:{"show":_vm.showAddModal},on:{"update:show":function($event){_vm.showAddModal=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.showAddModal = false}}}),_vm._v(" "),_c('vk-modal-title',[_vm._v("Add Component Type")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Name"}},[_c('el-input',{attrs:{"placeholder":"Name","type":"text"},model:{value:(_vm.componentForm.name),callback:function ($$v) {_vm.$set(_vm.componentForm, "name", $$v)},expression:"componentForm.name"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"placeholder":"Description","type":"text"},model:{value:(_vm.componentForm.description),callback:function ($$v) {_vm.$set(_vm.componentForm, "description", $$v)},expression:"componentForm.description"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Unit"}},[_c('el-input',{attrs:{"placeholder":"Unit","type":"text"},model:{value:(_vm.componentForm.unit),callback:function ($$v) {_vm.$set(_vm.componentForm, "unit", $$v)},expression:"componentForm.unit"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Rating"}},[_c('el-input',{attrs:{"placeholder":"Rating","type":"text"},model:{value:(_vm.componentForm.rating),callback:function ($$v) {_vm.$set(_vm.componentForm, "rating", $$v)},expression:"componentForm.rating"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.submitComponentForm()}}},[_vm._v("Create")])],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.tableFields,"rows":_vm.componentData,"search-options":{enabled: true,
        externalQuery: _vm.searchTerm},"pagination-options":{enabled: true},"lineNumbers":true,"styleClass":"table table-striped col-md-12"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'name')?_c('span',{staticClass:"nameStyle"},[_vm._v("\n          "+_vm._s(props.row.name? props.row.name :'--')+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'number')?_c('span',[_vm._v(_vm._s(props.row.inventories? props.row['inventories'].length:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('el-button',{attrs:{"size":"mini","type":"primary"},on:{"click":function($event){return _vm.viewComponentType(props.row)}}},[_vm._v("Component Type")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"success"},on:{"click":function($event){return _vm.viewInventory(props.row)}}},[_vm._v("Inventory")]),_vm._v(" "),_c('el-button',{attrs:{"size":"mini","type":"warning"},on:{"click":function($event){return _vm.addBtnInventory(props.row)}}},[_vm._v("Add Inventory")])],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(932);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8c2ec66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2197);
function injectStyle (ssrContext) {
  __webpack_require__(2195)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8c2ec66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2196 */,
/* 2197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"page-content__header-description col-md-12",staticStyle:{"line-height":"35px","padding-bottom":"14px","border-bottom":"1px solid #c8c8c8"}},[_vm._v("Role List\n            "),_c('b-button',{staticClass:"pull-right",attrs:{"variant":"primary"},on:{"click":_vm.showModal}},[_vm._v("\n              Add Role\n            ")])],1),_vm._v(" "),_c('b-modal',{ref:"myModalRef",staticClass:"modal-dialog modal-content",attrs:{"centered":"","hide-footer":"","role":"document"}},[_c('div',{staticStyle:{"text-align":"center !important"},attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('b-btn',{staticClass:"close custom-modal__close",staticStyle:{"justify-content":"center !important","font-size":".89em"},on:{"click":_vm.hideModal}},[_c('span',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('img',{attrs:{"src":"/static/img/modal/4.png","alt":""}}),_vm._v(" "),_c('h2',{staticClass:"page-content__header-description"},[_vm._v("Add Role")])],1),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.displayError}},[_vm._v("\n            "+_vm._s(_vm.errorMessage)+"\n        ")]),_vm._v(" "),_c('form',{staticClass:"p-userRole",attrs:{"action":"#"}},[_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.name),expression:"data.name"}],staticClass:"form-control form-control-lg",attrs:{"type":"text","placeholder":"Role Name"},domProps:{"value":(_vm.data.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "name", $event.target.value)}}})]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.description),expression:"data.description"}],staticClass:"form-control form-control-lg",attrs:{"placeholder":"Role Description"},domProps:{"value":(_vm.data.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data, "description", $event.target.value)}}}),_vm._v(" "),_c('b-button',{staticStyle:{"margin-top":"12px"},attrs:{"size":"md","variant":"primary"},on:{"click":_vm.addRole}},[_vm._v("\n                Add   "),_c('span',{staticClass:"fa fa-plus"})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"paginate":true,"globalSearch":true,"styleClass":"table table-striped col-md-12"}})],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('vk-modal',{attrs:{"show":_vm.confirmDeleteModal},on:{"update:show":function($event){_vm.confirmDeleteModal=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.confirmDeleteModal = false}}}),_vm._v(" "),_c('div',{staticStyle:{"font-size":"17px"}},[_vm._v("Are you sure you want to delete report?")]),_vm._v(" "),_c('div',{staticClass:"uk-text-right",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button-group',[_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){return _vm.confirmDeleteReport()}}},[_vm._v("Delete")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.confirmDeleteModal = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New Report Configuration")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form}},[_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Endpoint"},model:{value:(_vm.form.endpoint),callback:function ($$v) {_vm.$set(_vm.form, "endpoint", $$v)},expression:"form.endpoint"}},_vm._l((_vm.pathList),function(item,idx){return _c('el-option',{key:(idx + "_endpoint_option" + (item.path)),attrs:{"label":item.path,"value":item.path}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Include Filter"},model:{value:(_vm.form.config.include),callback:function ($$v) {_vm.$set(_vm.form.config, "include", $$v)},expression:"form.config.include"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"Where Filter"},model:{value:(_vm.formWhere),callback:function ($$v) {_vm.formWhere=$$v},expression:"formWhere"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.parameterConfig),function(varParam){return _c('el-form-item',{key:("dynamic_" + (varParam['key'])),staticStyle:{"display":"flex"}},[_c('el-input',{staticStyle:{"width":"150px"},attrs:{"disabled":true},model:{value:(varParam['key']),callback:function ($$v) {_vm.$set(varParam, 'key', $$v)},expression:"varParam['key']"}}),_vm._v(" "),_c('el-select',{staticStyle:{"width":"150px"},attrs:{"placeholder":"Type"},model:{value:(varParam['type']),callback:function ($$v) {_vm.$set(varParam, 'type', $$v)},expression:"varParam['type']"}},[_c('el-option',{attrs:{"label":"freetext","value":"text"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"single option","value":"radio"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"multi option","value":"checkbox"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"range","value":"range"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"date","value":"date"}})],1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(varParam['options']),expression:"varParam['options']"}],staticClass:"el-input__inner",staticStyle:{"width":"150px"},attrs:{"placeholder":"Options"},domProps:{"value":(varParam['options'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(varParam, 'options', $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(varParam['name']),expression:"varParam['name']"}],staticClass:"el-input__inner",staticStyle:{"width":"150px"},attrs:{"placeholder":"Name"},domProps:{"value":(varParam['name'])},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(varParam, 'name', $event.target.value)}}})],1)}),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],2)],1)]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"custom-table-row",staticStyle:{"display":"flex","flex-flow":"row","justify-content":"space-between"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("New Report")])])])],1),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.columns,"rows":_vm.reportData,"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'title')?_c('span',[_vm._v(_vm._s(props.row.title? props.row['title']:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'endpoint')?_c('span',[_vm._v(_vm._s(props.row.endpoint? props.row['endpoint']:'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('el-button',{attrs:{"size":"mini","type":"danger","plain":""},on:{"click":function($event){return _vm.deleteReport(props.row)}}},[_vm._v("Delete")])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmConfig_vue__ = __webpack_require__(935);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aca424e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmConfig_vue__ = __webpack_require__(2200);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmConfig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1aca424e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmConfig_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Alarm Config","name":"alarm_config"}},[_c('div',{staticClass:"main-container"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New Alarm Configuration")]),_vm._v(" "),_c('hr')],1),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Label"}},[_c('el-input',{model:{value:(_vm.form.label),callback:function ($$v) {_vm.$set(_vm.form, "label", $$v)},expression:"form.label"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Field Name"}},[_c('el-input',{model:{value:(_vm.form.fieldName),callback:function ($$v) {_vm.$set(_vm.form, "fieldName", $$v)},expression:"form.fieldName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Field Property"}},[_c('el-input',{model:{value:(_vm.form.fieldProperty),callback:function ($$v) {_vm.$set(_vm.form, "fieldProperty", $$v)},expression:"form.fieldProperty"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Condition"}},[_c('el-switch',{attrs:{"active-text":"Greater than","inactive-text":"Less than","active-value":"Greater than","inactive-value":"Less than"},model:{value:(_vm.form.condition),callback:function ($$v) {_vm.$set(_vm.form, "condition", $$v)},expression:"form.condition"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Value"}},[_c('el-input',{model:{value:(_vm.form.value),callback:function ($$v) {_vm.$set(_vm.form, "value", $$v)},expression:"form.value"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"filterable":"","placeholder":"Installation"},model:{value:(_vm.form.installationId),callback:function ($$v) {_vm.$set(_vm.form, "installationId", $$v)},expression:"form.installationId"}},_vm._l((_vm.installationList),function(item,idx){return _c('el-option',{key:(idx + "_installation_option" + (item.name)),attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"45%"},attrs:{"type":"primary"},on:{"click":_vm.createAlarm}},[_vm._v("Create")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"custom-table-row",staticStyle:{"display":"flex","flex-flow":"row","justify-content":"space-between"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("New Alarm")])])])],1),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.fields,"rows":_vm.getUsers,"select-options":_vm.selectOption,"search-options":{enabled: true,
                        searchFn: _vm.searchTable,
                                externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.name))]):_vm._e(),_vm._v(" "),(props.column.field == 'cid')?_c('span',[_vm._v(_vm._s(props.row.CID?props.row.CID:''))]):_vm._e(),_vm._v(" "),(props.column.field == 'devicetype')?_c('span',[_vm._v(_vm._s(props.row.deviceType.name))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user.email))]):_vm._e(),_vm._v(" "),(props.column.field == 'phoneNumber')?_c('span',[_vm._v(_vm._s(props.row.user.phoneNumber))]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.navTo(props.row.id)}}},[_vm._v("View Alarm Config")])],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)])],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Alarms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2203 */,
/* 2204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){return _vm.reloadPage()}}}),_vm._v(" "),_c('h3',[_vm._v("\n        Maintenance Details\n        "),_c('el-button',{staticStyle:{"float":"right"},attrs:{"size":"sm","type":"primary"},on:{"click":function($event){_vm.showStatusModal = true}}},[_vm._v("\n          Change Status\n          ")])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"slot":"header"},slot:"header"},[(_vm.selectedMaintenance['installation'])?_c('div',{staticStyle:{"display":"flex","flex-flow":"column"}},[_c('h4',{staticStyle:{"margin":"0px"}},[_vm._v(_vm._s(_vm.selectedMaintenance['installation']['name']))]),_vm._v(" "),_c('small',{staticClass:"maintenance-details"},[_vm._v(_vm._s(_vm.selectedMaintenance['installation']["deviceType"]["name"]))]),_vm._v(" "),_c('small',{staticClass:"maintenance-details"},[_vm._v(_vm._s(_vm.selectedMaintenance['installation']["solarKitIds"]))])]):_vm._e(),_vm._v(" "),(_vm.selectedMaintenance['installation'])?_c('div',{staticStyle:{"display":"flex","flex-flow":"column"}},[_c('h4',{staticStyle:{"margin":"0px"}},[_vm._v(_vm._s(_vm.selectedMaintenance['operationsEngineer']['firstName'])+" "+_vm._s(_vm.selectedMaintenance['operationsEngineer']['lastName']))]),_vm._v(" "),_c('small',{staticClass:"maintenance-details"},[_vm._v(_vm._s(_vm.selectedMaintenance['operationsEngineer']["email"]))]),_vm._v(" "),_c('small',{staticClass:"maintenance-details"},[_vm._v(_vm._s(_vm.selectedMaintenance['operationsEngineer']["phoneNumber"]))])]):_vm._e()]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('b-badge',{staticStyle:{"font-size":"10px"},attrs:{"pill":"","variant":"primary"}},[_vm._v(_vm._s(new Date(_vm.selectedMaintenance['start']).toDateString()))]),_vm._v(" "),_c('hr',{staticStyle:{"width":"100%","margin":"0px"}}),_vm._v(" "),_c('b-badge',{staticStyle:{"font-size":"10px"},attrs:{"pill":"","variant":"secondary"}},[_vm._v(_vm._s(new Date(_vm.selectedMaintenance['end']).toDateString()))])],1),_vm._v(" "),_c('div',{staticClass:"description",staticStyle:{"margin-top":"10px"}},[_vm._v(_vm._s(_vm.selectedMaintenance['issue']))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('ckeditor',{attrs:{"editor":_vm.editor}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-direction":"row","justify-content":"space-between","align-items":"center"}},[_c('h2',[_vm._v("Pictures")]),_vm._v(" "),_c('el-button',[_vm._v("Upload Picture")])],1),_vm._v(" "),_c('el-carousel',{attrs:{"height":"150px"}},_vm._l((4),function(item){return _c('el-carousel-item',{key:item},[_c('h3',{staticClass:"small"},[_vm._v(_vm._s(item))])])}),1),_vm._v(" "),_c('Center',{staticStyle:{"margin-top":"10px"}},[_c('el-button',{attrs:{"size":"sm","type":"primary"}},[_vm._v("Save")])],1)],1)]),_vm._v(" "),_c('vk-modal',{attrs:{"show":_vm.showStatusModal},on:{"update:show":function($event){_vm.showStatusModal=$event}}},[_c('div',{staticClass:"d-block text-center"},[_c('vk-modal-close',{on:{"click":function($event){_vm.showStatusModal = false}}}),_vm._v(" "),_c('h3',[_vm._v("Status")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Status"}},[_c('el-select',{attrs:{"placeholder":"Change Status"},model:{value:(_vm.statusValue),callback:function ($$v) {_vm.statusValue=$$v},expression:"statusValue"}},_vm._l((_vm.statusOption),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.name,"value":item.name}})}),1)],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"sm","type":"primary"},on:{"click":function($event){return _vm.submitStatus()}}},[_vm._v("Change Status")])],1)]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.commentForm,"label-width":"120px"}},[_c('vk-modal',{attrs:{"show":_vm.showCommentModal},on:{"update:show":function($event){_vm.showCommentModal=$event}}},[_c('div',{staticClass:"d-block text-center"},[_c('vk-modal-close',{on:{"click":function($event){_vm.showCommentModal = false}}}),_vm._v(" "),_c('h3',[_vm._v("Comment")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Comment"}},[_c('el-input',{attrs:{"placeholder":"Type Comment","type":"textarea"},model:{value:(_vm.commentForm.content),callback:function ($$v) {_vm.$set(_vm.commentForm, "content", $$v)},expression:"commentForm.content"}})],1),_vm._v(" "),_c('el-button',{staticStyle:{"margin-top":"10px"},attrs:{"size":"sm","type":"primary"},on:{"click":function($event){return _vm.submitComment()}}},[_vm._v("\n          Post Comment\n          ")])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.maintenanceList,"search-options":{enabled: true,
      searchFn: _vm.searchTable,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'installation.name')?_c('span',[_vm._v(_vm._s(props.row['installation']['name']+ " ("+ props.row['installation']['deviceType']['name']+")"))]):(props.column.field == 'operationsEngineer.name')?_c('span',[_vm._v(_vm._s(props.row['operationsEngineer']['firstName']+ " "+ props.row['operationsEngineer']['lastName']))]):(props.column.field == 'start')?_c('span',[_vm._v(_vm._s(new Date(props.row['start']).toDateString()))]):(props.column.field == 'end')?_c('span',[_vm._v(_vm._s(new Date(props.row['end']).toDateString()))]):(props.column.field == 'status')?_c('span',[_c('b-badge',{attrs:{"variant":props.row['status'] == 'close'?"danger": "info"}},[_vm._v(_vm._s(props.row['status'] ?props.row['status']: 'open'))])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.viewMaintenance(props.row)}}},[_vm._v("View")])],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_view_vue__ = __webpack_require__(938);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea80b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_view_vue__ = __webpack_require__(2207);
function injectStyle (ssrContext) {
  __webpack_require__(2206)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_view_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eea80b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_view_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2206 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('figure',{staticClass:"enquiry_holder"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":"/static/img/enq_dp.jpg","alt":"Enquiry"}})]),_vm._v(" "),_c('figcaption',[_c('div',{staticClass:"date"},[_c('span',{staticClass:"day"},[_vm._v("28")]),_c('span',{staticClass:"month"},[_vm._v("Oct, 2016")])]),_vm._v(" "),_c('div',{staticClass:"enq_info"},[_c('h3',[_vm._v("John Doe")]),_vm._v(" "),_c('h5',[_vm._v("Ikeja, Lagos")]),_vm._v(" "),_c('h4',[_vm._v("08072128239")])]),_vm._v(" "),_c('p',[_vm._v("\n                I don't need to compromise my principles, they don't have the slightest bearing on what happens to me anyway.\n              ")])]),_vm._v(" "),_c('footer',[_c('div',{staticClass:"views"},[_c('i',{staticClass:"fa fa-info"}),_vm._v("Resolved")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addInstalation_vue__ = __webpack_require__(939);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b94a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addInstalation_vue__ = __webpack_require__(2210);
function injectStyle (ssrContext) {
  __webpack_require__(2209)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addInstalation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46b94a2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addInstalation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 2209 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container container-fh__content p-trial-period-expired",staticStyle:{"padding":"0px"}},[_c('img',{staticClass:"p-trial-period-expired__image",staticStyle:{"margin-top":"50px"},attrs:{"src":"/static/img/modal/1.svg","alt":"","width":"100px"}}),_vm._v(" "),(_vm.reqSuccess == true)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"p-trial-period-expired__desc"},[_vm._v("Your installation schedule has been submitted!")]),_vm._v(" "),_c('div',{staticClass:"panel-body",staticStyle:{"text-align":"center !important"}},[_vm._v("\n      You will recieve a notification when granted\n      Thanks.\n    ")])]):_vm._e(),_vm._v(" "),(_vm.reqSuccess == false)?_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth"},[_c('div',[_c('div',{staticClass:"widget-alpha__amount"},[_vm._v(_vm._s(_vm.installationData.user? ((_vm.installationData.user.firstName) + " " + (_vm.installationData.user.lastName)): "-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description"},[_vm._v(_vm._s(_vm.installationData.user?((_vm.installationData.user.email) + " ") : "-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description"},[_vm._v(_vm._s(_vm.installationData.user ? (" " + (_vm.installationData.deviceType.name)):"-"))]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s((" " + (_vm.installationData.paymentModel))))])]),_vm._v(" "),_c('span',{staticClass:"widget-alpha__icon fa fa-info"})]),_vm._v(" "),_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"widget_header",attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"widget_header__title"},[_vm._v("Installation Component Configuration")])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.instalationPackageConfig,"styleClass":"table table-striped col-md-12"},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'quantity')?_c('span',[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.instalationPackageConfig[props.row.originalIndex]['quantity']),callback:function ($$v) {_vm.$set(_vm.instalationPackageConfig[props.row.originalIndex], 'quantity', $$v)},expression:"instalationPackageConfig[props.row.originalIndex]['quantity']"}})],1):_vm._e(),_vm._v(" "),(props.column.field == 'componentType.name')?_c('span',{staticStyle:{"text-transform":"capitalize","font-weight":"bold"}},[_vm._v(_vm._s(props.row.componentType.name))]):_vm._e()]}}],null,false,3121654233)})],1),_vm._v(" "),_c('div',{staticClass:"p-trial-period-expired__upgrade",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-info btn-lg btn-block btn-rounded",attrs:{"type":"button"},on:{"click":_vm.submitRequest}},[_vm._v("Submit Installation schedule")])])])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container instalation-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{enabled: true,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true},"lineNumbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['firstName']) + " " + (props.row.user['lastName'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'installation_name')?_c('span',[_vm._v(_vm._s(props.row['installationName'] ? ((props.row['installationName']) + " ") : ((props.row.user['firstName']) + " " + (props.row.user['lastName']))))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['email']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['phoneNumber']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceType? ((props.row.deviceType['name']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s((props.row.gender+"" === "0")?'Female':'Male'))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 2),expression:"props.row.status == 2"}],attrs:{"to":("/instalation/schedule/" + (props.row.id))}},[_c('b-button',{staticStyle:{"margin-top":"12px"},attrs:{"size":"md","variant":"info"}},[_vm._v("\n                Inventory Request & Installation Schedule \n                "),_c('span',{staticClass:"fa fa-calendar"})])],1)],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instalationSchedule_vue__ = __webpack_require__(941);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29bfa8b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instalationSchedule_vue__ = __webpack_require__(2215);
function injectStyle (ssrContext) {
  __webpack_require__(2214)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_instalationSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29bfa8b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_instalationSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4"},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("\n          Customer Information\n        ")]),_vm._v(" "),_c('div',{staticClass:"row list-group"},[_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Customer ID")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s(("" + (_vm.InstallationData.CID))))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Full Name")]),_vm._v(" "),_c('dd',{},[_vm._v("\n              "+_vm._s(((_vm.InstallationData.user.firstName) + " " + (_vm.InstallationData.user.lastName)))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Email Address")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s(((_vm.InstallationData.user.email) + " ")))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Product Name")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s((" " + (_vm.InstallationData.deviceType.name))))])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("\n          Schedule Installation\n        ")]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('form',{attrs:{"id":"inventoryTransfer"},on:{"submit":function($event){$event.preventDefault();return _vm.submitRequest.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12",attrs:{"role":"tablist"}},[_c('div',[_c('div',{staticClass:"card mb-1 statistic-widget statistic-widget-f"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"collapse show",attrs:{"id":"accordion_comp0","collapse":"","show":"","order-collapse-inner":"","role":"tabpanel"}},[_c('div',{staticClass:"card-body"},[_c('HotelDatePicker',{attrs:{"format":"DD-MM-YYYYTHH:MM:SS","i18n":_vm.customFormat},on:{"check-in-changed":_vm.setCheckin,"check-out-changed":_vm.setCheckOut}})],1)])])])]),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.packageForm,"label-width":"120px"}},[_c('vk-modal',{attrs:{"show":_vm.showAddModal},on:{"update:show":function($event){_vm.showAddModal=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.showAddModal = false}}}),_vm._v(" "),_c('vk-modal-title',[_vm._v("Add Component")]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Component"}},[_c('el-autocomplete',{staticClass:"inline-input",attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"Please Input"},on:{"select":_vm.handleSelect},model:{value:(_vm.componentId),callback:function ($$v) {_vm.componentId=$$v},expression:"componentId"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"Description"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Quantity"}},[_c('el-input-number',{attrs:{"min":1},model:{value:(_vm.packageForm.quantity),callback:function ($$v) {_vm.$set(_vm.packageForm, "quantity", $$v)},expression:"packageForm.quantity"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Add new item")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Bill Of Quantity")]),_vm._v(" "),_c('el-button',{staticStyle:{"float":"right","padding":"3px 0"},attrs:{"type":"text"},on:{"click":function($event){_vm.showAddModal = true}}},[_vm._v("Add Component")])],1),_vm._v(" "),_vm._l((_vm.packageData),function(data,index){return _c('div',{key:index,staticClass:"text item",staticStyle:{"display":"flex","justify-content":"space-between"}},[_c('span',[_c('h5',[_vm._v(_vm._s(data.componentItems.name))])]),_vm._v(" "),_c('span',[_c('el-input-number',{attrs:{"id":"packageQty","min":1},model:{value:(data.quantity),callback:function ($$v) {_vm.$set(data, "quantity", $$v)},expression:"data.quantity"}})],1)])})],2)],1),_vm._v(" "),_vm._m(1)],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"card-header p-1",attrs:{"role":"tab"}},[_c('a',{staticClass:"order-collapse__header",attrs:{"href":"#","aria-controls":"accordion_comp0","aria-expanded":"true","role":"button"}},[_c('h5',{staticStyle:{"text-transform":"capitalize"}},[_vm._v("\n                          Select Installation Date\n                        ")]),_vm._v(" "),_c('span',{staticClass:"badge badge-info",staticStyle:{"font-size":"1.2rem","color":"rgb(255, 255, 255)"}},[_vm._v("Installation Date Beginning From")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-trial-period-expired__upgrade col-md-12"},[_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-secondary btn-lg",attrs:{"type":"submit"}},[_vm._v("\n                    Submit installation schedule\n                  ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2216 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container ongoing-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm
      },"pagination-options":{enabled: true},"lineNumbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ((props.row.deviceRequest.user['firstName']) + " " + (props.row.deviceRequest.user['lastName'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ((props.row.deviceRequest.user['email']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ((props.row.deviceRequest.user['phoneNumber']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'cid')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.CID? ((props.row.deviceRequest.CID) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.deviceType? ((props.row.deviceRequest.deviceType['name']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s((props.row.deviceRequest.gender+"" === "0")?'Female':'Male'))]):_c('span',[_vm._v(_vm._s(props.row.deviceRequest[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('router-link',{attrs:{"to":("/installation/commission/" + (props.row.id))}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.deviceRequest.status == 4),expression:"props.row.deviceRequest.status == 4"}],staticStyle:{"margin-top":"12px"},attrs:{"size":"md","variant":"warning"}},[_vm._v("\n                Commission Installation  \n                ")])],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container inventory-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('vk-modal',{attrs:{"show":_vm.showInventoryApprove},on:{"update:show":function($event){_vm.showInventoryApprove=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.showInventoryApprove = false}}}),_vm._v(" "),_c('vk-modal-title',[_vm._v(_vm._s(_vm.currentDeviceRequest?("" + (_vm.currentDeviceRequest.name)):"-"))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.currentDeviceRequest["deviceRequest"]? ((_vm.currentDeviceRequest["deviceRequest"]['deviceType']['name']) + " (" + (_vm.currentDeviceRequest["deviceRequest"]['paymentModel']) + ")"):'-'))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l(((_vm.BOQ)),function(componentInfo,index){return _c('div',{key:("componentInfo_" + index),staticClass:"componentInfo"},[_c('b',[_vm._v("\n            "+_vm._s(componentInfo['componentItems']['name'])+"\n            (Available: "+_vm._s(_vm._printTotalAvailableComponents(componentInfo, _vm.inventoryCount))+")\n          ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(componentInfo['quantity']))])])}),0),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('can',{attrs:{"I":"am","a":"finance"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm._shouldDisableApproveButton(_vm.currentDeviceRequest.deviceRequest, _vm.inventoryCount)},on:{"click":_vm.submitRequest}},[_vm._v("Approve inventory request")])])],1)],1),_vm._v(" "),_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{enabled: true,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true},"lineNumbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ("" + (props.row['name'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'installation_name')?_c('span',[_vm._v(_vm._s(props.row['installationName'] ? ((props.row['installationName']) + " ") : props.row.deviceRequest.user?((props.row.deviceRequest.user['firstName']) + " " + (props.row.deviceRequest.user['lastName'])):'--'))]):(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ((props.row.deviceRequest.user['email']) + " ") :'--'))]):(props.column.field == 'CID')?_c('span',[_vm._v(_vm._s(props.row? ((props.row['CID']) + " ") :'--'))]):(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.user? ((props.row.deviceRequest.user['phoneNumber']) + " ") :'--'))]):(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceRequest.deviceType? ((props.row.deviceRequest.deviceType['name']) + " ") :'--'))]):(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s((props.row.deviceRequest.gender+"" === "0")?'Female':'Male'))]):_c('span',[_vm._v(_vm._s(props.row.deviceRequest[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',{staticClass:"fancy"},[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('b-button',{staticStyle:{"margin-top":"12px"},attrs:{"size":"md","variant":"info"},on:{"click":function($event){return _vm.showApprovalModal(props.row)}}},[_vm._v("\n              View  \n              ")])],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_installationCommission_vue__ = __webpack_require__(945);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdaae28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_installationCommission_vue__ = __webpack_require__(2223);
function injectStyle (ssrContext) {
  __webpack_require__(2221)
  __webpack_require__(2222)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bdaae28"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_installationCommission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bdaae28_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_installationCommission_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","padding":"10px 0 !important","flex-flow":"column","margin-bottom":"30px"}},[_c('el-breadcrumb',{staticClass:"col-sm-6",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Dashboard")]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/devices/all_devices' }}},[_vm._v("Installation Management")])],1),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("Commission Installation")])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('form',{attrs:{"id":"inventoryCommission"},on:{"submit":function($event){$event.preventDefault();return _vm.submitRequest.apply(null, arguments)}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('el-card',{staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Customer")]),_vm._v(" "),_c('div',{staticClass:"row list-group"},[_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("CID")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s(("" + (_vm.InstallationData.deviceRequest && _vm.InstallationData.deviceRequest.CID ? _vm.InstallationData.deviceRequest.CID : 'nill'))))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Full Name")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s(((_vm.InstallationData.deviceRequest.user.firstName) + " " + (_vm.InstallationData.deviceRequest.user.lastName))))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Email Address")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s(((_vm.InstallationData.deviceRequest.user.email) + " ")))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Product Name")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s((" " + (_vm.InstallationData.deviceRequest.deviceType.name))))])]),_vm._v(" "),_c('div',{staticClass:"list-group-item"},[_c('dt',{},[_vm._v("Payment Model")]),_vm._v(" "),_c('dd',{},[_vm._v(_vm._s((" " + (_vm.InstallationData.deviceRequest.paymentModel))))])])])]),_vm._v(" "),_c('el-card',{staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Installation Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-transform":"capitalize"},attrs:{"for":"location"}},[_vm._v("Address")]),_vm._v(" "),_c('address-input',{attrs:{"changeHandler":_vm.getAddressData,"placeholder":"Type Address"},model:{value:(_vm.formData.address),callback:function ($$v) {_vm.$set(_vm.formData, "address", $$v)},expression:"formData.address"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-transform":"capitalize"},attrs:{"for":"expiryDate"}},[_vm._v("Warranty Expiry Date")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"date","placeholder":"Pick an Expiry date"},model:{value:(_vm.formData.warranty),callback:function ($$v) {_vm.$set(_vm.formData, "warranty", $$v)},expression:"formData.warranty"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-transform":"capitalize"},attrs:{"for":"maintenanceType"}},[_vm._v("Maintenance Type")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Pick a Maintenance Type"},model:{value:(_vm.formData.maintenance),callback:function ($$v) {_vm.$set(_vm.formData, "maintenance", $$v)},expression:"formData.maintenance"}},_vm._l((_vm.maintenanceOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('el-card',{staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Assign Operation Engineer")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Assigned To"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.userSearch,"placeholder":"Search User","prefix-icon":"el-icon-search"},on:{"select":_vm.userSelected},model:{value:(_vm.assignedTo),callback:function ($$v) {_vm.assignedTo=$$v},expression:"assignedTo"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('el-card',[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Components")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-md-12",attrs:{"role":"tablist"}},_vm._l((_vm.InstallationData.deviceRequest.installationComponents),function(compSelect,index){return _c('div',{key:index},[_c('b-card',{staticClass:"mb-1 statistic-widget statistic-widget-f",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",attrs:{"header-tag":"header","role":"tab"}},[_c('a',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('accordion_comp'+index),expression:"'accordion_comp'+index"}],staticClass:"order-collapse__header",attrs:{"href":"#"}},[_c('h5',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(compSelect.componentItems.name))]),_vm._v(" "),_c('b-badge',{staticStyle:{"font-size":"1.5rem","color":"#fff"},attrs:{"variant":"info"}},[_vm._v("\n                        Quantity: "+_vm._s(compSelect.quantity)+"\n                        "),(_vm.filterList(_vm.availableComponentsList,compSelect).length<=compSelect.quantity)?_c('b-badge',{staticClass:"inset"},[_vm._v("less than "+_vm._s(compSelect.quantity)+" item in stock")]):_vm._e()],1)],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'accordion_comp'+index,"collapse":"","show":"","order-collapse-inner":"","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[(_vm.data = _vm.isSolarPanels(compSelect.componentItems.name, _vm.availableComponentsList))?_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.showSolarInputs(_vm.data, compSelect.quantity))}})]):_c('div',_vm._l((compSelect.quantity),function(i){return _c('b-form-select',{key:compSelect.componentTypeId+'__'+i,staticClass:"mb-3 componentType",staticStyle:{"text-transform":"capitalize !important"},attrs:{"name":compSelect.componentTypeId+'__'+i,"options":_vm.filterList(_vm.availableComponentsList,compSelect)},model:{value:(_vm.rows['__'+compSelect.componentItems.name+'__'+i]),callback:function ($$v) {_vm.$set(_vm.rows, '__'+compSelect.componentItems.name+'__'+i, $$v)},expression:"rows['__'+compSelect.componentItems.name+'__'+i]"}})}),1)])],1)],1)],1)}),0),_vm._v(" "),_c('div',{staticClass:"col-md-12",staticStyle:{"margin":"30px","text-align":"center"}},[_c('button',{staticClass:"btn btn-secondary btn-lg",attrs:{"type":"submit"}},[_vm._v("Commission Installation")])])])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__ = __webpack_require__(946);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6bdb166_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__ = __webpack_require__(2601);
function injectStyle (ssrContext) {
  __webpack_require__(2225)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e6bdb166"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6bdb166_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2227 */,
/* 2228 */,
/* 2229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey-chat-widget",class:{'short-chart': _vm.short}},[_c('canvas',{attrs:{"id":("myChart" + _vm.id),"width":"400","height":"400"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row dashboard-info-widgets"},[_c('div',{staticClass:"col-md-6 col-xl-6"},[_c('vuestic-widget',{staticClass:"info-widget"},[_c('div',{staticClass:"info-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number",staticStyle:{"padding-left":"12px"}},[_c('i',{staticClass:"ion ion-power text-primary stats-icon"}),_vm._v("\n            59\n          ")]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("Total Installations")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-6"},[_c('vuestic-widget',{staticClass:"info-widget"},[_c('div',{staticClass:"info-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number",staticStyle:{"padding-left":"12px"}},[_c('i',{staticClass:"fa fa-superpowers text-danger stats-icon"}),_vm._v("\n            12\n          ")]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("Total Power Installed")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v2_vue__ = __webpack_require__(950);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a38f3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v2_vue__ = __webpack_require__(2569);
function injectStyle (ssrContext) {
  __webpack_require__(2233)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84a38f3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84a38f3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey-battery-widget",style:([_vm.holderStyle, _vm.parentStyle])},[_c('div',{staticClass:"battery",class:{mini:_vm.mini},style:([_vm.holderStyle])},[_c('span',{ref:"bolt_display",staticClass:"fa fa-exclamation warning-bolt",staticStyle:{"color":"#df0a00"},style:([_vm.boltStyle])}),_vm._v(" "),_c('div',{ref:"battery_level",staticClass:"level",style:(_vm.battery_meter)})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2236 */,
/* 2237 */
/***/ (function(module, exports) {

module.exports = {"_from":"weekstart@^1.0.0","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"weekstart@^1.0.0","name":"weekstart","escapedName":"weekstart","rawSpec":"^1.0.0","saveSpec":null,"fetchSpec":"^1.0.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_shasum":"af642eb10dc24b1af9d4dcc0415056edc087b897","_spec":"weekstart@^1.0.0","_where":"C:\\Users\\tolulope.dosu-idowu\\Desktop\\arnergy_repo\\arnergy-core-vue","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"bundleDependencies":false,"deprecated":false,"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),
/* 2238 */,
/* 2239 */,
/* 2240 */,
/* 2241 */,
/* 2242 */,
/* 2243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('el-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.subExpiry),expression:"subExpiry"}],attrs:{"show-icon":"","title":"Subscription expiry date","type":"success","closable":false}},[_c('h3',[_vm._v("\n      "+_vm._s(_vm.subExpiry)+"\n      "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"float":"right"},on:{"click":_vm.getDeviceState}},[_vm._v("\n        Refresh\n      ")])])]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","flex-flow":"row","display":"flex"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__body"},[(_vm.powerState == "OFF")?_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('power', '11')}}},[_c('i',{staticClass:"fa fa-power-off fa-2x",staticStyle:{"color":"#2980b9"}}),_vm._v("\n            Power On\n          ")])]):_vm._e(),_vm._v(" "),(_vm.powerState == "ON")?_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('power', '00')}}},[_c('i',{staticClass:"fa fa-power-off fa-2x",staticStyle:{"color":"#e74c3c"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Power Off")])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('div',{staticClass:"col-md-3 col-sm-6 d-none"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('expiry', 'set')}}},[_c('i',{staticClass:"fa fa-calendar fa-2x",staticStyle:{"color":"#2c3e50"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Set Expiry Date")])])]),_vm._v(" "),(_vm.adminPower == "OFF")?_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth d-none",on:{"click":function($event){return _vm.showControl('admin', '11')}}},[_c('i',{staticClass:"fa fa-check-square-o fa-2x",staticStyle:{"color":"#16a085"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Admin Enable Device")])])]):_vm._e(),_vm._v(" "),(_vm.adminPower == "ON")?_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth d-none",on:{"click":function($event){return _vm.showControl('admin', '00')}}},[_c('i',{staticClass:"fa fa-ban fa-2x",staticStyle:{"color":"#95a5a6"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Admin Disable Device")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 display-none"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('charger-priority', 'pcp')}}},[_c('i',{staticClass:"fa fa-plug fa-2x",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Set Charger Priority")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 display-none"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('output-priority', 'pop')}}},[_c('i',{staticClass:"fa fa-cogs fa-2x",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Set Output Priority")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6 display-none"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",on:{"click":function($event){return _vm.showControl('device-mode', 'pgr')}}},[_c('i',{staticClass:"fa fa-server fa-2x",staticStyle:{"color":"rgb(232, 15, 90)"}}),_vm._v(" "),_c('span',{staticClass:"sm-font-size"},[_vm._v("Set Device Mode")])])])])],1)])]),_vm._v(" "),(_vm.deviceShadow && _vm.deviceShadow.delta)?_c('div',{staticStyle:{"width":"100%","flex-flow":"column","display":"flex"}},[_c('h3',[_vm._v("Pending Changes")]),_vm._v(" "),_c('ul',_vm._l((Object.keys(_vm.deviceShadow.delta)),function(singleKey){return _c('li',{key:("desired_" + singleKey)},[_c('b',[_vm._v(_vm._s(singleKey)+" : ")]),_vm._v(" "+_vm._s(_vm.deviceShadow.delta[singleKey])+"\n      ")])}),0)]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"css":"false"}},[_c('el-dialog',{attrs:{"title":"Device Control","visible":_vm.controlModal,"close-on-click-modal":false,"width":"30%"},on:{"update:visible":function($event){_vm.controlModal=$event}}},[_c('div',[(_vm.currentCommand === 'power')?_c('div',[_vm._v("\n          Are you sure you want to switch Device power\n          "+_vm._s(_vm.currentParam == "11" ? "On" : "Off")+"?\n        ")]):(_vm.currentCommand === 'expiry')?_c('div',[(_vm.currentParam === 'get')?_c('div',[_vm._v("Get Expiry Date?")]):(_vm.currentParam === 'set')?_c('div',[_c('datetime',{staticClass:"form-control form-control-lg",attrs:{"placeholder":"Pick a date","type":"datetime","input-class":"form-control form-control-lg"},model:{value:(_vm.expiryDate_),callback:function ($$v) {_vm.expiryDate_=$$v},expression:"expiryDate_"}})],1):_vm._e()]):(_vm.currentCommand === 'charger-priority')?_c('div',[_c('div',[_c('div',{staticStyle:{"text-align":"centea"}},[_vm._v("Set Chargerr Priority")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.chargerPriorityList},model:{value:(_vm.chargerPriority),callback:function ($$v) {_vm.chargerPriority=$$v},expression:"chargerPriority"}})],1)]):(_vm.currentCommand === 'output-priority')?_c('div',[_c('div',[_c('div',{staticStyle:{"text-align":"centea"}},[_vm._v("Set Output Priority")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.outputPriorityList},model:{value:(_vm.outputPriority),callback:function ($$v) {_vm.outputPriority=$$v},expression:"outputPriority"}})],1)]):(_vm.currentCommand === 'device-mode')?_c('div',[_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v("Set Device Mode")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.deviceModeList},model:{value:(_vm.deviceMode),callback:function ($$v) {_vm.deviceMode=$$v},expression:"deviceMode"}})],1)]):(_vm.currentCommand === 'command')?_c('div',[_c('div',[_vm._v("\n            Send Command:\n            "),_c('hr'),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commandSending),expression:"commandSending"}],attrs:{"id":"simple-input","required":""},domProps:{"value":(_vm.commandSending)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commandSending=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-input"}},[_vm._v("Command to send")]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])]):(_vm.currentCommand === 'shell')?_c('div',[_c('div',[_vm._v("\n            Send Command:\n            "),_c('hr'),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.commandSending),expression:"commandSending"}],attrs:{"id":"simple-input","required":""},domProps:{"value":(_vm.commandSending)},on:{"input":function($event){if($event.target.composing){ return; }_vm.commandSending=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-input"}},[_vm._v("Command to send")]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])])]):(_vm.currentCommand === 'reboot')?_c('div',[_c('div',[_vm._v("Reboot Inverter?")])]):(_vm.currentCommand === 'settings')?_c('div',[_c('div',[_vm._v("Request Inverter Settings?")])]):(_vm.currentCommand === 'reset')?_c('div',[_c('div',[_vm._v("Reset Board?")])]):(_vm.currentCommand === 'batteql')?_c('div',[_c('div',[_vm._v("Request Battery Equalization?")])]):(_vm.currentCommand === 'admin')?_c('div',[(_vm.currentParam === '11')?_c('div',[_vm._v("\n            Sure you want to activate device?\n          ")]):(_vm.currentParam === '00')?_c('div',[_vm._v("\n            Sure you want to disable device?\n          ")]):_vm._e()]):(_vm.currentCommand === 'ssh')?_c('div',[_vm._v("\n          Open SSH Access:\n          "),_c('hr',{}),_vm._v(" "),_c('fieldset',[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ipAddress),expression:"ipAddress"}],attrs:{"id":"simple-input","required":""},domProps:{"value":(_vm.ipAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.ipAddress=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-input"}},[_vm._v("IP Address")]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],attrs:{"id":"simple-input","required":""},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-input"}},[_vm._v("Username")]),_vm._v(" "),_c('i',{staticClass:"bar"})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],attrs:{"id":"simple-input","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}}),_vm._v(" "),_c('label',{staticClass:"control-label",attrs:{"for":"simple-input"}},[_vm._v("Password")]),_vm._v(" "),_c('i',{staticClass:"bar"})])])])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-with-icon rounded-icon btn-micro",staticStyle:{"margin-right":"12px"},on:{"click":function($event){return _vm.control()}}},[_c('i',{staticClass:"fa-check fa"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-with-icon rounded-icon btn-micro",staticStyle:{"margin-right":"12px"},on:{"click":function($event){return _vm.hideControl()}}},[_c('i',{staticClass:"fa-close fa"})])])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('vk-offcanvas',{attrs:{"flipped":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"overflow":"auto"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h2',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('div',{staticClass:"d-flex justify-content-reverse",staticStyle:{"display":"flex","flex-flow":"column"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"25%","margin-left":"75%"},on:{"click":_vm.exportWarnings}},[_vm._v("\n            Export\n          ")])])],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":"","striped":"","hover":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1),_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],1)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(223),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n                    "+_vm._s(inverterKey)+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(inverterKey != "InverterId"
                      ? singleInverter[inverterKey]
                      : "--"))])])}),0)])])}),1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('span',{staticClass:"fa fa-bolt"}),_vm._v(" "),_c('battery',{attrs:{"width":"300px","height":"180px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(dataKey)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Device.BatteryData[dataKey] == 1
                ? "Yes"
                : _vm.Device.BatteryData[dataKey] == 0
                ? "No"
                : _vm.Device.BatteryData[dataKey]))])])}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',[_vm._v("Misc Data")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(dataKey)+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Device.MiscData[dataKey]))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"block",staticStyle:{"margin-bottom":"30px"}},[_c('span',{staticClass:"demonstration"},[_vm._v("Filter")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"datetimerange","picker-options":_vm.pickerOptions,"range-separator":"-","start-placeholder":"Start date","end-placeholder":"End date","align":"center"},on:{"change":_vm.filterChanged},model:{value:(_vm.filterDate),callback:function ($$v) {_vm.filterDate=$$v},expression:"filterDate"}}),_vm._v(" "),_c('can',{attrs:{"I":"am","a":"manager"}},[_c('el-select',{staticStyle:{"width":"120px"},attrs:{"placeholder":"Select"},model:{value:(_vm.datasetInterval),callback:function ($$v) {_vm.datasetInterval=$$v},expression:"datasetInterval"}},[_c('el-option',{attrs:{"label":"Minutes","value":"minutes"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Hours","value":"hours"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Weeks","value":"weeks"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Months","value":"weeks"}})],1),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.LastEvaluatedKey),expression:"LastEvaluatedKey"}],attrs:{"type":"primary","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.LoadMore}},[_vm._v(_vm._s(_vm.LoadMoreLoading ? "Loading..." : "Load More"))]),_vm._v(" "),_c('el-button',{attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Loading..." : "Export Data"))]),_vm._v(" "),_c('el-button',{attrs:{"type":"warning","plain":"","disabled":_vm.viewDataLoading},on:{"click":_vm.exportDataToTable}},[_vm._v(_vm._s(_vm.exportDataToTableLoading ? "Loading..." : "View Data History"))]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","plain":"","disabled":_vm.viewDataLoading},on:{"click":_vm.getDeviceWarningsMapper}},[_vm._v(_vm._s(_vm.warningDataLoading ? "Loading..." : "Warning/Alarm History"))])],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"col-md-6 col-sm-6 col-xs-12"},[_c('grey-chart',{ref:"healthchart",attrs:{"type":_vm.charttype,"data":_vm.chartdata,"id":"healthchart"}})],1),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"col-md-6 col-sm-6 col-xs-12"},[_c('grey-chart',{ref:"solarchartdata",attrs:{"type":_vm.charttype,"data":_vm.solarchartdata,"id":"solarchartdata"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2247 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customAnimatedIcon_vue__ = __webpack_require__(955);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcc245b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customAnimatedIcon_vue__ = __webpack_require__(2253);
function injectStyle (ssrContext) {
  __webpack_require__(2252)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0bcc245b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customAnimatedIcon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0bcc245b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customAnimatedIcon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_vm._l((_vm.lines),function(line,index){return _c('div',{key:("multi_line_" + index)},[(line)?_c('div',{class:'line ' + line +'-line',style:({'background': _vm.color,})},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(line==='bottom-left'),expression:"line==='bottom-left'"}],staticClass:"data-value",style:({ color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.dataValue)}}),_vm._v(" "),_c('div',{staticClass:"inner",style:({'background': _vm.color,})},_vm._l((4),function(i){return _c('div',{key:(line + "_" + i),staticClass:"inner-arrow",class:line.split('-')[1],style:({'border-color': _vm.color})})}),0),_vm._v(" "),_vm._l((4),function(i){return _c('div',{key:("multi_" + line + "_" + i),staticClass:"inner-circle",style:({'background-color': _vm.color,'box-shadow': ("0 0 2px 2px " + _vm.color)})})})],2):_vm._e()])}),_vm._v(" "),(_vm.line)?_c('div',{class:'line ' + _vm.line + '-line',style:({ background: _vm.color })},[_c('p',{staticClass:"data-value",style:({ color: _vm.color }),domProps:{"innerHTML":_vm._s(_vm.dataValue)}}),_vm._v(" "),_c('div',{staticClass:"inner",style:({ background: _vm.color })},_vm._l((4),function(i){return _c('div',{key:(_vm.line + "_" + i),staticClass:"inner-arrow",class:_vm.line.split('-')[1],style:({ 'border-color': _vm.color })})}),0),_vm._v(" "),_vm._l((4),function(i){return _c('div',{key:("single_" + _vm.line + "_" + i),staticClass:"inner-circle",style:({
        'background-color': _vm.color,
        'box-shadow': ("0 0 2px 2px " + _vm.color)
      })})})],2):_vm._e(),_vm._v(" "),_c('div',{class:'circle ' + _vm.line,style:({
      'border-color': _vm.value == 0 ? 'rgba(0,0,0,0)' : _vm.color,
      'box-shadow': ("0 0 6px 4px " + (_vm.value == 0 ? 'rgba(0,0,0,0)' : _vm.color))
    })},[(_vm.title)?_c('p',{staticClass:"the_title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"img-div"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image,"alt":_vm.title}}):_c('img',{attrs:{"src":__webpack_require__(956),"alt":_vm.title}})]),_vm._v(" "),_c('p',{staticClass:"the_value"},[_vm._v("\n      "+_vm._s(_vm.value !== null || _vm.value !== undefined
      ? ("" + (_vm.value==0.001?0:_vm.value) + (_vm.unit || "kW"))
      : "no_value")+"\n    ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2254 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */,
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */,
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */,
/* 2273 */,
/* 2274 */,
/* 2275 */,
/* 2276 */,
/* 2277 */,
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */,
/* 2289 */,
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */,
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */,
/* 2372 */,
/* 2373 */,
/* 2374 */,
/* 2375 */,
/* 2376 */,
/* 2377 */,
/* 2378 */,
/* 2379 */,
/* 2380 */,
/* 2381 */,
/* 2382 */,
/* 2383 */,
/* 2384 */,
/* 2385 */,
/* 2386 */,
/* 2387 */,
/* 2388 */,
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */,
/* 2408 */,
/* 2409 */,
/* 2410 */,
/* 2411 */,
/* 2412 */,
/* 2413 */,
/* 2414 */,
/* 2415 */,
/* 2416 */,
/* 2417 */,
/* 2418 */,
/* 2419 */,
/* 2420 */,
/* 2421 */,
/* 2422 */,
/* 2423 */,
/* 2424 */,
/* 2425 */,
/* 2426 */,
/* 2427 */,
/* 2428 */,
/* 2429 */,
/* 2430 */,
/* 2431 */,
/* 2432 */,
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */,
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */,
/* 2536 */,
/* 2537 */,
/* 2538 */,
/* 2539 */,
/* 2540 */,
/* 2541 */,
/* 2542 */,
/* 2543 */,
/* 2544 */,
/* 2545 */,
/* 2546 */,
/* 2547 */,
/* 2548 */,
/* 2549 */,
/* 2550 */,
/* 2551 */,
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"option":_vm.chartOptions,"loading":_vm.loading},on:{"ready":_vm.onReady,"click":_vm.onClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12 col-lg-8"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"margin-bottom":"10px","height":"100%"}},[_c('div',{staticClass:"animated-area"},[_c('div',{staticClass:"flex justify-between"},[_c('custom-animated-icon',{attrs:{"title":"Solar","value":_vm.pvp / 1000 != 0
                ? _vm.pvp / 1000
                : _vm.getValue(_vm.loadEnergySource['pvSource'] || 0),"data-value":"","color":"rgba(16, 156, 241, 0.9)","line":_vm.pvp / 1000 == 0 && _vm.pvp == 0 ? null : 'top-left',"image":__webpack_require__(956)}}),_vm._v(" "),_c('custom-animated-icon',{attrs:{"title":"Battery","value":_vm.getValue(_vm.loadEnergySource['batterySource'] || 0) == 0
                ? _vm.device['BatteryData'] && _vm.device['BatteryData']['SOC']
                : _vm.getValue(_vm.loadEnergySource['batterySource'] || 0),"line":_vm.getValue(_vm.loadEnergySource['batterySource'] || 0) == 0
                ? null
                : 'top-right',"unit":_vm.getValue(_vm.loadEnergySource['batterySource'] || 0) == 0
                ? '%'
                : 'kW',"data-value":_vm.getBatteryWattage() + 'kW',"color":"rgba(250, 113, 111, 0.46)","image":__webpack_require__(2565)}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('custom-animated-icon',{attrs:{"title":_vm.isSmartController ? 'Smart Controller' : 'Inverter',"value":_vm.getValue(_vm.acoap) == 0 ? _vm.pvp / 1000 : _vm.getValue(_vm.acoap),"data-value":_vm.getBatteryWattage() + 'kW',"color":"rgba(114, 184, 76, 0.9)","isCenterItem":true,"lines":[
              _vm.getValue(_vm.acoap) == 0 ? null : 'top-left',
              (_vm.device['BatteryData'] && _vm.device['BatteryData']['CurrentState']) == _vm.chargeState
                ? 'bottom-left'
                : null
            ],"image":__webpack_require__(2566)}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('custom-animated-icon',{attrs:{"title":"Grid","value":_vm.getValue(_vm.loadEnergySource['gridSource'] || _vm.getGridStatus),"data-value":"","line":_vm.getValue(_vm.loadEnergySource['gridSource'] || 0) == 0
                ? null
                : 'bottom-left',"color":"rgba(255, 185, 70, 0.9)","image":__webpack_require__(2567)}}),_vm._v(" "),_c('custom-animated-icon',{attrs:{"title":"Load","value":_vm.getValue(_vm.acoap),"data-value":"","color":"#8f82b0","image":__webpack_require__(2568)}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-4"},[_c('div',{staticStyle:{"margin-bottom":"0px","height":"100%","justify-content":"center","display":"flex"}},[_c('div',{staticClass:"chart-section"},[(_vm.loadEnergySource)?_c('custom-pie-chart',{attrs:{"orient":"horizontal","loading":_vm.loadingChartData,"data":_vm.pieChart},on:{"onReady":_vm.handleOnChartReady}}):_vm._e()],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2565 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgNTEyIDUxMiIgaGVpZ2h0PSI1MTIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnPjxwYXRoIGQ9Im0zNTQgNTEyaC0xOTZjLTI1LjM2NCAwLTQ2LTIwLjYzNi00Ni00NnYtMzU2YzAtMjUuMzY0IDIwLjYzNi00NiA0Ni00NmgxOTZjMjUuMzY0IDAgNDYgMjAuNjM2IDQ2IDQ2djM1NmMwIDI1LjM2NC0yMC42MzYgNDYtNDYgNDZ6bS0xOTYtNDE2Yy03LjcyIDAtMTQgNi4yOC0xNCAxNHYzNTZjMCA3LjcyIDYuMjggMTQgMTQgMTRoMTk2YzcuNzIgMCAxNC02LjI4IDE0LTE0di0zNTZjMC03LjcyLTYuMjgtMTQtMTQtMTR6Ii8+PHBhdGggZD0ibTMyMCA5NmgtMTI4Yy04LjgzNyAwLTE2LTcuMTY0LTE2LTE2di00NGMwLTE5Ljg1MSAxNi4xNDktMzYgMzYtMzZoODhjMTkuODUxIDAgMzYgMTYuMTQ5IDM2IDM2djQ0YzAgOC44MzYtNy4xNjMgMTYtMTYgMTZ6bS0xMTItMzJoOTZ2LTI4YzAtMi4yMDYtMS43OTQtNC00LTRoLTg4Yy0yLjIwNiAwLTQgMS43OTQtNCA0eiIvPjxwYXRoIGQ9Im0zMjAgNDU2aC0xMjhjLTguODM3IDAtMTYtNy4xNjQtMTYtMTZzNy4xNjMtMTYgMTYtMTZoMTI4YzguODM3IDAgMTYgNy4xNjQgMTYgMTZzLTcuMTYzIDE2LTE2IDE2eiIvPjxwYXRoIGQ9Im0zMjAgMzkyaC0xMjhjLTguODM3IDAtMTYtNy4xNjQtMTYtMTZzNy4xNjMtMTYgMTYtMTZoMTI4YzguODM3IDAgMTYgNy4xNjQgMTYgMTZzLTcuMTYzIDE2LTE2IDE2eiIvPjxwYXRoIGQ9Im0zMjAgMzI4aC0xMjhjLTguODM3IDAtMTYtNy4xNjQtMTYtMTZzNy4xNjMtMTYgMTYtMTZoMTI4YzguODM3IDAgMTYgNy4xNjQgMTYgMTZzLTcuMTYzIDE2LTE2IDE2eiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 2566 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iQ2FwYV8xIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MTIgNTEyIiBoZWlnaHQ9IjUxMiIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGc+PHBhdGggZD0ibTQzNiAwaC0zNjBjLTI0LjgxMyAwLTQ1IDIwLjE4Ny00NSA0NXY3NWgtMTZjLTguMjg0IDAtMTUgNi43MTYtMTUgMTVzNi43MTYgMTUgMTUgMTVoMTZ2MTY1YzAgOC4yODQgNi43MTYgMTUgMTUgMTVoMTV2MTM3YzAgMjQuODEzIDIwLjE4NyA0NSA0NSA0NWgzMDBjMjQuODEzIDAgNDUtMjAuMTg3IDQ1LTQ1di0xMzdoMTVjOC4yODQgMCAxNS02LjcxNiAxNS0xNXYtMTY1aDE2YzguMjg0IDAgMTUtNi43MTYgMTUtMTVzLTYuNzE2LTE1LTE1LTE1aC0xNnYtNzVjMC0yNC44MTMtMjAuMTg3LTQ1LTQ1LTQ1em0tMTUgNDY3YzAgOC4yNzEtNi43MjkgMTUtMTUgMTVoLTMwMGMtOC4yNzEgMC0xNS02LjcyOS0xNS0xNXYtMTM3aDMwdjEwN2MwIDguMjg0IDYuNzE2IDE1IDE1IDE1aDI0MGM4LjI4NCAwIDE1LTYuNzE2IDE1LTE1di0xMDdoMzB6bS0yNDAtMTM3djQ1YzAgOC4yODQgNi43MTYgMTUgMTUgMTVzMTUtNi43MTYgMTUtMTV2LTQ1aDMwdjQ1YzAgOC4yODQgNi43MTYgMTUgMTUgMTVzMTUtNi43MTYgMTUtMTV2LTQ1aDMwdjQ1YzAgOC4yODQgNi43MTYgMTUgMTUgMTVzMTUtNi43MTYgMTUtMTV2LTQ1aDMwdjkyaC0yMTB2LTkyem0yNzAtMzBoLTM5MHYtMjU1YzAtOC4yNzEgNi43MjktMTUgMTUtMTVoMzYwYzguMjcxIDAgMTUgNi43MjkgMTUgMTV6Ii8+PGNpcmNsZSBjeD0iMTk2IiBjeT0iMjI1IiByPSIxNSIvPjxjaXJjbGUgY3g9IjI1NiIgY3k9IjIyNSIgcj0iMTUiLz48Y2lyY2xlIGN4PSIzMTYiIGN5PSIyMjUiIHI9IjE1Ii8+PGNpcmNsZSBjeD0iMzc2IiBjeT0iMjI1IiByPSIxNSIvPjxjaXJjbGUgY3g9IjEzNiIgY3k9IjIyNSIgcj0iMTUiLz48cGF0aCBkPSJtMzYxIDEwNWMwLTguMjg0LTYuNzE2LTE1LTE1LTE1aC0yNDBjLTguMjg0IDAtMTUgNi43MTYtMTUgMTV2NjBjMCA4LjI4NCA2LjcxNiAxNSAxNSAxNWgyNDBjOC4yODQgMCAxNS02LjcxNiAxNS0xNXptLTEyMCAxNWgzMHYzMGgtMzB6bS0zMCAzMGgtMzB2LTMwaDMwem0tOTAtMzBoMzB2MzBoLTMwem0yMTAgMzBoLTMwdi0zMGgzMHoiLz48cGF0aCBkPSJtNDA2IDkwYy04LjI4NCAwLTE1IDYuNzE2LTE1IDE1djYwYzAgOC4yODQgNi43MTYgMTUgMTUgMTVzMTUtNi43MTYgMTUtMTV2LTYwYzAtOC4yODQtNi43MTYtMTUtMTUtMTV6Ii8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 2567 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2568 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticClass:"stats_header__title"},[_vm._v("\n          Device\n          "+_vm._s(_vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp)
              ? "Offline"
              : "Online")+"\n        ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"21px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen()))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n          "+_vm._s(_vm.installationData.name || "-")+"\n        ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"flex-end"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[(
              _vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp)
            )?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.triggerRemoveDeviceOnPerformanceList()}}},[_vm._v("\n            Remove\n          ")]):_vm._e(),_vm._v("\n           \n        ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[(_vm.errorCalc(_vm.deviceWarning) == 'warning')?_c('button',{staticClass:"btn btn-outline-warning",on:{"click":function($event){return _vm.showWAlarm('warnings')}}},[_vm._v("\n            Warning\n          ")]):_vm._e(),_vm._v(" "),(_vm.errorCalc(_vm.deviceWarning) == 'error')?_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){return _vm.showWAlarm('error')}}},[_vm._v("\n            Fault\n          ")]):_vm._e()])],1)]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errorCalc(_vm.deviceWarning) == 'error')?_c('div',{staticClass:"col-md-12"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-exclamation-triangle icon-right input-icon error-icon"}),_vm._v(" "),_c('ul',_vm._l((_vm.flags.faults),function(key,index_error){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceWarning[index_error] == 1),expression:"deviceWarning[index_error] == 1"}],key:(index_error + "_error")},[_vm._v("\n                "+_vm._s(key)+"\n              ")])}),0)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{},[_c('el-collapse',{staticClass:"page-content",on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Device Status")]),_vm._v(" "),_c('h1',[_vm._v("\n                      "+_vm._s(_vm.Device.parameters &&
                        _vm.statusCalc(_vm.Device.parameters.TimeStamp)
                          ? "Offline"
                          : "Online")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen()))]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load active power")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.parameters)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                      "+_vm._s(Number(_vm.Device.parameters.OutputLoadPercent))+"% Load\n                    ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.parameters.BatteryCapacity}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery status")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.Device.parameters.BatteryCapacity * 1)+"%")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.mode)))]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      PV Power:\n                      "+_vm._s(_vm.Device.parameters
                          ? _vm.panelPower(_vm.Device.parameters)
                          : "-")+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                  'background-color':
                    _vm.Device.mode == 'L'
                      ? '#2ED47A !important'
                      : '#e74c3c !important',
                  height: '100%'
                })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                      "+_vm._s(_vm.Device.mode == "L" ? "ON" : "OFF")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedToday || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedWeek || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedMonth || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedYear || 0 * 1)+"kWh\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedTodayOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedWeekOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedMonthOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedTodayOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedWeekOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedMonthOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedYearOnGrid || 0 * 1)+"kWh\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakToday ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakWeek ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakMonth ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakYear ||
                        0 * 1)+"kWp\n                  ")])])])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v3_vue__ = __webpack_require__(1046);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52686aca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v3_vue__ = __webpack_require__(2574);
function injectStyle (ssrContext) {
  __webpack_require__(2571)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-52686aca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52686aca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2572 */,
/* 2573 */,
/* 2574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(223),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(
                  ['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV)))) ||
                    parseFloat(_vm.MiscData.FV) >= 1.76
                )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                  )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.Device.BatteryData[dataKey])+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InverterData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InverterData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) >= 1.76 ||
              ['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) < 1.76 &&
              !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
              parseFloat(_vm.MiscData.FV) < 1.76 &&
                !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
            )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                  )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId,"identifier":_vm.Device.MiscData.systemIdentificator,"inverterNum":_vm.Device.InverterData[0].InverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_vm._v("loading")]),_vm._v(" "),_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw",staticStyle:{"font-size":"18px"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item"},[_c('div',[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.desc))])]),_vm._v(" "),_c('div',{staticClass:"button-div"},[_c('button',{staticClass:"item-button item-button--enable",attrs:{"type":"button"},on:{"click":_vm.enableSetting}},[_vm._v("\n        Enable\n      ")]),_vm._v(" "),_c('button',{staticClass:"item-button item-button--disable",attrs:{"type":"button"},on:{"click":_vm.disableSetting}},[_vm._v("\n        Disable\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover"},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_vm._v("loading")]),_vm._v(" "),_c('i',{staticClass:"fa fa-circle-o-notch fa-spin fa-3x fa-fw",staticStyle:{"font-size":"18px"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"title-info"}),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('div',{staticClass:"grid"},_vm._l((_vm.items),function(item){return _c('div',{key:item.name,staticClass:"item",on:{"click":function($event){return _vm.enableSetting(item.action)}}},[(item.desc)?_c('el-tooltip',{attrs:{"effect":"dark","content":item.desc || '',"placement":"bottom"}},[_c('div',[_vm._v(_vm._s(item.name))])]):_vm._e(),_vm._v(" "),(!item.desc)?_c('span',[_vm._v(_vm._s(item.name))]):_vm._e()],1)}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.pendingChanges)?_c('div'):_c('div',{staticClass:"box"},[_c('div',{staticClass:"top",on:{"click":_vm.toggleShowContent}},[_c('h3',{staticClass:"title"},[_vm._v("Pending Changes")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.showContent)?_c('ul',{staticClass:"list"},_vm._l((Object.entries(_vm.pendingChanges)),function(item,index){return _c('li',{key:index,staticClass:"item",domProps:{"innerHTML":_vm._s(_vm.renderItem(item))}})}),0):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-caret-down"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_current_settings_vue__ = __webpack_require__(1055);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c397c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_current_settings_vue__ = __webpack_require__(2584);
function injectStyle (ssrContext) {
  __webpack_require__(2583)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c397c6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_current_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c397c6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_current_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(("" + (_vm.getDeviceCurrentSettings.DeviceID)) !== ("" + _vm.deviceId))?_c('div',[_vm._v("\n    No Current settings.\n  ")]):_vm._e(),_vm._v(" "),(("" + (_vm.getDeviceCurrentSettings.DeviceID)) === ("" + _vm.deviceId))?_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(_vm.getDeviceCurrentSettings)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.getDeviceCurrentSettings[dataKey], dataKey)))])])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_input_vue__ = __webpack_require__(1056);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695a54ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_input_vue__ = __webpack_require__(2588);
function injectStyle (ssrContext) {
  __webpack_require__(2586)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_element_control_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_695a54ec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_element_control_input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = showAlarm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui__);

function showAlarm(_ref) {
  var type = _ref.type,
      message = _ref.message;

  console.log(type, message);
  switch (type) {
    case "success":
      return __WEBPACK_IMPORTED_MODULE_0_element_ui__["Notification"].success({
        title: "Success",
        dangerouslyUseHTMLString: true,
        message: message ? message : "Action completed successfully"
      });

    case "warning":
      return __WEBPACK_IMPORTED_MODULE_0_element_ui__["Notification"].error({
        title: "Error",
        dangerouslyUseHTMLString: true,
        message: message
      });
    default:
      return __WEBPACK_IMPORTED_MODULE_0_element_ui__["Notification"].warning({
        title: "Unknown",
        dangerouslyUseHTMLString: true,
        message: message ? message : "unknown, please verify"
      });
  }
}

/***/ }),
/* 2588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"row col-sm-12"},[_c('div',{staticClass:"form-group col-sm-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.value),expression:"value"}],staticClass:"form-control",attrs:{"type":"number","placeholder":"0 - 99999999","step":"10","min":"0","max":"99999999"},domProps:{"value":(_vm.value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.value=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.isLoading,"value":_vm.isLoading ? "Loading..." : "Submit"},on:{"click":_vm.submitContractualLoad}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showCanvas},on:{"update:show":function($event){_vm.showCanvas=$event}}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Settings/Current Settings")]),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Settings"}},[_c('element-pending-info',{attrs:{"pending-changes":_vm.pendingChanges}}),_vm._v(" "),_c('div',[_c('el-collapse',[_c('el-collapse-item',{attrs:{"title":"Parameter Command Settings","name":"1"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-new',{attrs:{"enable-action":"PEa","disable-action":"PDa","name":"Silence Buzzer","desc":"Enable/Disable Silence Buzzer"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEb","disable-action":"PDb","name":"Bypass Function","desc":"Enable/Disable Bypass Function"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEj","disable-action":"PDj","name":"Power Saving","desc":"Enable/Disable Power Saving"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEk","disable-action":"PDk","name":"LCD Display Escape","desc":"Enable/Disable LCD Display Escape after 1min timeout"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEu","disable-action":"PDu","name":"Overload Restart","desc":"Enable/Disable Overload Restart"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEv","disable-action":"PDv","name":"Temperature Restart","desc":"Enable/Disable Temperature Restart"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEx","disable-action":"PDx","name":"Backlight ON","desc":"Enable/Disable Backlight ON"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEy","disable-action":"PDy","name":"Alarm ON","desc":"Enable/Disable Alarm ON when primary source interrupt"},on:{"refresh":_vm.refresh}}),_vm._v(" "),_c('element-control-new',{attrs:{"enable-action":"PEz","disable-action":"PDz","name":"Faut Code Record","desc":"Enable/Disable Faut Code Record"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Setting utility max charging current","name":"2"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-radio',{attrs:{"items":[
                      { name: '2A', action: 'MUCHGC002' },
                      { name: '10A', action: 'MUCHGC010' },
                      { name: '30A', action: 'MUCHGC030' },
                      { name: '50A', action: 'MUCHGC050' },
                      { name: '60A', action: 'MUCHGC060' }
                    ],"name":"Utility max charging current","desc":"Select max charging current option"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Setting Inverter output source priority","name":"3"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-radio',{attrs:{"items":[
                      { name: 'Utility-Solar-Battery', action: 'POP00' },
                      { name: 'Solar-Utility-Battery', action: 'POP01' },
                      { name: 'Solar-Battery-Utility', action: 'POP02' }
                    ],"name":"Inverter output source priority","desc":"Select Inverter output source priority"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Set battery re-charge voltage","name":"4"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-radio',{attrs:{"items":[
                      { name: '44V', action: 'PBCV44.0' },
                      { name: '45V', action: 'PBCV45.0' },
                      { name: '46V', action: 'PBCV46.0' },
                      { name: '47V', action: 'PBCV47.0' },
                      { name: '48V', action: 'PBCV48.0' },
                      { name: '49V', action: 'PBCV49.0' },
                      { name: '50V', action: 'PBCV50.0' },
                      { name: '51V', action: 'PBCV51.0' }
                    ],"name":"Set battery re-charge voltage","desc":"Select Set battery re-charge voltage"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Set battery re-discharge voltage","name":"5"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-radio',{attrs:{"items":[
                      { name: '0V', action: 'PBDV00.0' },
                      { name: '48V', action: 'PBDV48.0' },
                      { name: '49V', action: 'PBDV49.0' },
                      { name: '50V', action: 'PBDV50.0' },
                      { name: '51V', action: 'PBDV51.0' },
                      { name: '52V', action: 'PBDV52.0' },
                      { name: '53V', action: 'PBDV53.0' },
                      { name: '54V', action: 'PBDV54.0' },
                      { name: '55V', action: 'PBDV55.0' },
                      { name: '56V', action: 'PBDV56.0' },
                      { name: '57V', action: 'PBDV57.0' },
                      { name: '58V', action: 'PBDV58.0' }
                    ],"name":"Set battery re-discharge voltage","desc":"Select Set battery re-discharge voltage"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Setting Inverter charger priority","name":"6"}},[_c('div',{staticClass:"inside"},[_c('div',{},[_c('element-control-radio',{attrs:{"items":[
                      {
                        name: 'SBL UCD',
                        action: 'PCP00',
                        desc:
                          'Allow AC charge battery, and solar charge battery first and then power load'
                      },
                      {
                        name: 'SBL UDC',
                        action: 'PCP01',
                        desc:
                          'Disallow AC charge battery, and solar charge battery first and then power load'
                      },
                      {
                        name: 'SLB UCD',
                        action: 'PCP02',
                        desc:
                          'Allow AC charge battery, and solar power load first and then charge battery'
                      },
                      {
                        name: 'SLB UDC',
                        action: 'PCP03',
                        desc:
                          'Disallow AC charge battery, and solar power load first and then charge battery'
                      }
                    ],"name":"Setting Inverter charger priority","desc":"Select Setting Inverter charger priority"},on:{"refresh":_vm.refresh}})],1)])]),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Installed solar PV capacity","name":"7"}},[_c('element-current-input',{attrs:{"eventKey":"InstalledPV","topic":_vm.$route.params.deviceId},on:{"refresh":_vm.refresh}})],1),_vm._v(" "),_c('el-collapse-item',{attrs:{"title":"Contractual load for system","name":"8"}},[_c('element-current-input',{attrs:{"eventKey":"CLoad","topic":_vm.$route.params.deviceId},on:{"refresh":_vm.refresh}})],1)],1)],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Current Settings"}},[_c('element-current-settings',{attrs:{"getDeviceCurrentSettings":_vm.currentSettings}})],1)],1)],1),_vm._v(" "),_c('button',{staticClass:"control-button",attrs:{"type":"button"},on:{"click":function($event){_vm.showCanvas = true}}},[_c('i',{staticClass:"fa fa-cog",staticStyle:{"font-size":"16px"},attrs:{"aria-hidden":"true"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v4_vue__ = __webpack_require__(1057);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7844ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v4_vue__ = __webpack_require__(2592);
function injectStyle (ssrContext) {
  __webpack_require__(2591)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7844ce8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7844ce8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.tr,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',{staticStyle:{"z-index":"9999999"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index_d){return _c('el-card',{key:("inverterDetails_" + index_d),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(223),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},[_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n                    "+_vm._s(_vm.getLabel(inverterKey))+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(inverterKey != "InverterId"
                      ? _vm.getDisplayValue(singleInverter, inverterKey)
                      : "--"))])])}),_vm._v(" "),_vm._l((Object.keys(
                    _vm.Device.PowerData[index_d]
                  )),function(inverterKey,index_dp){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_p" + index_dp),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n                    "+_vm._s(_vm.getLabel(inverterKey))+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(inverterKey != "InverterId"
                      ? _vm.getDisplayValue(
                          _vm.Device.PowerData[index_d],
                          inverterKey
                        )
                      : "--"))])])})],2)])])}),1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('span',{staticClass:"fa fa-bolt"}),_vm._v(" "),_c('battery',{attrs:{"width":"300px","height":"180px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(_vm.getLabel(dataKey))+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Device.BatteryData[dataKey] == 1
                ? "Yes"
                : _vm.Device.BatteryData[dataKey] == 0
                ? "No"
                : _vm.Device.BatteryData[dataKey]))])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(_vm.getLabel(dataKeyMisc))+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[(_vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.triggerRemoveDeviceOnPerformanceList()}}},[_vm._v("\n        Remove\n      ")]):_vm._e(),_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"flex-end","top":"0px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n          Warning\n        ")]):_vm._e(),_vm._v("\n         \n        "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n          Fault\n        ")]):_vm._e(),_vm._v("\n         \n        "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n          System Details\n        ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticClass:"stats_header__title"},[_vm._v("\n              Device "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n            ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"21px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n              Installation Capacity:\n              "+_vm._s(_vm.Device.MiscData ? _vm.Device.MiscData.InstallSize : "")+"KVA\n              (Arnergy "),_c('span',[_vm._v(_vm._s(_vm.Device.InstallType))]),_vm._v(")\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n              "+_vm._s(_vm.installationData.name || "-")+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}})])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{},[_c('el-collapse',{staticClass:"page-content",on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Device\n                      "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online"))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load active power")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.PowerData)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      "+_vm._s(_vm.activePercent(_vm.Device.PowerData))+"% Load\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                      "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                      "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                      "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      PV Power:\n                      "+_vm._s(_vm.Device.PowerData
                          ? _vm.panelPowerReduce(_vm.Device.PowerData, "v4")
                          : "-")+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                  'background-color': _vm.gridCalc(_vm.Device.Mode)
                    ? '#2ED47A !important'
                    : '#e74c3c !important',
                  height: '100%'
                })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                      "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                      This Month\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid ||
                          0 * 1)+"kWh\n                    ")])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid ||
                            0 * 1)+"kWh\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                    ")])])])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e()],1),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v5_vue__ = __webpack_require__(1058);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e00aaef0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v5_vue__ = __webpack_require__(2595);
function injectStyle (ssrContext) {
  __webpack_require__(2594)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e00aaef0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e00aaef0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":'https://res.cloudinary.com/mentor-africa-project/image/upload/v1634545558/Charge_Controller.jpg',"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76 || _vm.MiscData.FV == 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.Device.BatteryData[dataKey])+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InvAggrData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InvAggrData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76 || _vm.MiscData.FV == 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v6_vue__ = __webpack_require__(1059);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75e2ef6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v6_vue__ = __webpack_require__(2598);
function injectStyle (ssrContext) {
  __webpack_require__(2597)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a75e2ef6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a75e2ef6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(1060),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) >= 1.76 ||
                    _vm.MiscData.FV == 1.11 ||
                    _vm.MiscData.FV == 1.0
                )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      _vm.MiscData.FV != 1.11 &&
                      _vm.MiscData.FV != 1.0
                  )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(
                          parseFloat(_vm.MiscData.FV) < 1.76 &&
                            parseFloat(_vm.MiscData.FV) != 1.0
                        )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.Device.BatteryData[dataKey])+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InverterData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InverterData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) >= 1.76 ||
              _vm.MiscData.FV == 1.11 ||
              _vm.MiscData.FV == 1.0
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    parseFloat(_vm.MiscData.FV) != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) < 1.76 &&
              _vm.MiscData.FV != 1.11 &&
              _vm.MiscData.FV != 1.0
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
              parseFloat(_vm.MiscData.FV) < 1.76 &&
                _vm.MiscData.FV != 1.11 &&
                _vm.MiscData.FV != 1.0
            )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      _vm.MiscData.FV != 1.11 &&
                      _vm.MiscData.FV != 1.0
                  )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"widget-alpha__description widget-alpha__amount",staticStyle:{"float":"right","margin":"10px","clear":"both","color":"#ff8625"}},[_vm._v("\n      Wallet balance:\n      "),_c('span',{staticClass:"widget-alpha__amount"},[_vm._v("\n        ₦"+_vm._s(_vm.getUserSession.wallet)+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"widget-alpha__description",staticStyle:{"float":"right","margin":"10px","clear":"both"}},[_c('b-button',{attrs:{"variant":"info","size":"sm","to":"/shs/pay?type=wallet"},on:{"click":function($event){_vm.paymentFormSelected = "wallet funding"}}},[_vm._v("\n        Fund Wallet\n      ")])],1)]),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"background":"#fff","padding":"0px"}},[_c('figure',{staticClass:"snip1208"},[_c('img',{attrs:{"src":"/static/img/Picture.png","alt":"Solar Services"}}),_vm._v(" "),_c('div',{staticClass:"date"},[_c('span',{staticClass:"day"},[_vm._v(_vm._s(_vm.getDate('day')))]),_c('span',{staticClass:"month"},[_vm._v(_vm._s(_vm.getDate('month')))])]),_vm._v(" "),_c('i',{staticClass:"fa fa-newspaper-o"}),_vm._v(" "),_vm._m(0),_c('a',{attrs:{"href":"#"}})])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figcaption',[_c('h3',[_vm._v("Arnergy Solar Services")]),_vm._v(" "),_c('p',[_vm._v("\n                The Arnergy IOT dashboard allows customers to monitor their usage. Our dashboard informs users of their battery levels, daily energy consumption, and faults occuring on their devices. Our users can access their dashboards with any device, whether a laptop, tablet or mobile phone.\n            ")]),_vm._v(" "),_c('button',[_vm._v("Read More")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"column"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","cursor":"pointer"}},[_c('el-breadcrumb',{staticClass:"col-sm-6",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Dashboard")]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/performance/live' }}},[_vm._v("Performance")])],1),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.params.deviceId))])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right",staticStyle:{"display":"flex","flex-flow":"row no-wrap"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.openBlank}},[_vm._v("Chart")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"dropdown-1","text":"View Options"}},[_c('b-dropdown-item',{attrs:{"active":""},on:{"click":function($event){return _vm.handleSplitValue({ code: 0, name: 'System Overview' })}}},[_vm._v("System Overview")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.handleSplitValue({ code: 2, name: 'Device Controls' })}}},[_vm._v("Device Controls")])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('div',{staticStyle:{"margin-left":"10px"}},[_c('control-settings')],1)])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.$route.params.version == 'v2')?_c('v2-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v3')?_c('v3-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v4')?_c('v4-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v5')?_c('v5-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v6')?_c('v6-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detailsV2_vue__ = __webpack_require__(1062);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad022e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detailsV2_vue__ = __webpack_require__(2619);
function injectStyle (ssrContext) {
  __webpack_require__(2603)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad022e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_detailsV2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad022e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_detailsV2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v2_vue__ = __webpack_require__(1063);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7061f20c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v2_vue__ = __webpack_require__(2606);
function injectStyle (ssrContext) {
  __webpack_require__(2605)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7061f20c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7061f20c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticClass:"stats_header__title"},[_vm._v("\n          Device\n          "+_vm._s(_vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp)
              ? "Offline"
              : "Online")+"\n        ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"21px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen()))]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n          "+_vm._s(_vm.installationData.name || "-")+"\n        ")])]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"flex-end"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[(
              _vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp)
            )?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.triggerRemoveDeviceOnPerformanceList()}}},[_vm._v("\n            Remove\n          ")]):_vm._e(),_vm._v("\n           \n        ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[(_vm.errorCalc(_vm.deviceWarning) == 'warning')?_c('button',{staticClass:"btn btn-outline-warning",on:{"click":function($event){return _vm.showWAlarm('warnings')}}},[_vm._v("\n            Warning\n          ")]):_vm._e(),_vm._v(" "),(_vm.errorCalc(_vm.deviceWarning) == 'error')?_c('button',{staticClass:"btn btn-outline-danger",on:{"click":function($event){return _vm.showWAlarm('error')}}},[_vm._v("\n            Fault\n          ")]):_vm._e()])],1)]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.errorCalc(_vm.deviceWarning) == 'error')?_c('div',{staticClass:"col-md-12"},[_c('b-alert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"fa fa-exclamation-triangle icon-right input-icon error-icon"}),_vm._v(" "),_c('ul',_vm._l((_vm.flags.faults),function(key,index_error){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceWarning[index_error] == 1),expression:"deviceWarning[index_error] == 1"}],key:(index_error + "_error")},[_vm._v("\n                "+_vm._s(key)+"\n              ")])}),0)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{},[_c('el-collapse',{staticClass:"page-content",on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Device Status")]),_vm._v(" "),_c('h1',[_vm._v("\n                      "+_vm._s(_vm.Device.parameters &&
                        _vm.statusCalc(_vm.Device.parameters.TimeStamp)
                          ? "Offline"
                          : "Online")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen()))]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load active power")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.parameters)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                      "+_vm._s(Number(_vm.Device.parameters.OutputLoadPercent))+"% Load\n                    ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.parameters.BatteryCapacity}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery status")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.Device.parameters.BatteryCapacity * 1)+"%")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.mode)))]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      PV Power:\n                      "+_vm._s(_vm.Device.parameters
                          ? _vm.panelPower(_vm.Device.parameters)
                          : "-")+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                  'background-color':
                    _vm.Device.mode == 'L'
                      ? '#2ED47A !important'
                      : '#e74c3c !important',
                  height: '100%'
                })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                      "+_vm._s(_vm.Device.mode == "L" ? "ON" : "OFF")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedToday || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedWeek || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedMonth || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .GeneratedYear || 0 * 1)+"kWh\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedTodayOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedWeekOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedMonthOffGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                        .ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedTodayOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedWeekOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedMonthOnGrid || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData)
                          .ConsumedYearOnGrid || 0 * 1)+"kWh\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakToday ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakWeek ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakMonth ||
                        0 * 1)+"kWp\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.Device.parameters.EnergyData).PeakYear ||
                        0 * 1)+"kWp\n                  ")])])])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v3_vue__ = __webpack_require__(1064);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7d3071_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v3_vue__ = __webpack_require__(2609);
function injectStyle (ssrContext) {
  __webpack_require__(2608)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d7d3071"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d7d3071_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(223),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(
                  ['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV)))) ||
                    parseFloat(_vm.MiscData.FV) >= 1.76
                )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                  )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData && _vm.Device.BatteryData.SOC || 0}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp( (_vm.Device.BatteryData && _vm.Device.BatteryData.SOC || 0) * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.TotalBatCur || 0)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData && _vm.Device.MiscData.ChgCycle || 0)+"/"+_vm._s(_vm.Device.MiscData && _vm.Device.MiscData.ExptdChgCyl || 0)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData || {})),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.getDisplayValue(_vm.Device.BatteryData, dataKey))+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData || {})),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InverterData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InverterData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData && _vm.Device.BatteryData.SOC || 0}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.CurrentState || 0))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s((_vm.Device.BatteryData && _vm.Device.BatteryData.SOC || 0) * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.TotalBatCur || 0)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.CurrentState || 0)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) >= 1.76 ||
              ['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) < 1.76 &&
              !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
              parseFloat(_vm.MiscData.FV) < 1.76 &&
                !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
            )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                  )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    !['1.12', '1.11'].includes(("" + (parseFloat(_vm.MiscData.FV))))
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v4_vue__ = __webpack_require__(1065);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b03cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v4_vue__ = __webpack_require__(2612);
function injectStyle (ssrContext) {
  __webpack_require__(2611)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-77b03cef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v4_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77b03cef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v4_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.tr,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item){return _c('el-option',{key:item,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',{staticStyle:{"z-index":"9999999"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index_d){return _c('el-card',{key:("inverterDetails_" + index_d),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(223),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},[_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n                    "+_vm._s(_vm.getLabel(inverterKey))+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(inverterKey != "InverterId"
                      ? _vm.getDisplayValue(singleInverter, inverterKey)
                      : "--"))])])}),_vm._v(" "),_vm._l((Object.keys(
                    _vm.Device.PowerData[index_d]
                  )),function(inverterKey,index_dp){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_p" + index_dp),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n                    "+_vm._s(_vm.getLabel(inverterKey))+"\n                  ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(inverterKey != "InverterId"
                      ? _vm.getDisplayValue(
                          _vm.Device.PowerData[index_d],
                          inverterKey
                        )
                      : "--"))])])})],2)])])}),1),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('span',{staticClass:"fa fa-bolt"}),_vm._v(" "),_c('battery',{attrs:{"width":"300px","height":"180px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(_vm.getLabel(dataKey))+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.Device.BatteryData[dataKey] == 1
                ? "Yes"
                : _vm.Device.BatteryData[dataKey] == 0
                ? "No"
                : _vm.getDisplayValue(_vm.Device.BatteryData, dataKey)))])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v("\n              "+_vm._s(_vm.getLabel(dataKeyMisc))+"\n            ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[(_vm.Device.parameters && _vm.statusCalc(_vm.Device.parameters.TimeStamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.triggerRemoveDeviceOnPerformanceList()}}},[_vm._v("\n        Remove\n      ")]):_vm._e(),_vm._v("\n       \n    ")]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"flex-end","top":"0px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n          Warning\n        ")]):_vm._e(),_vm._v("\n         \n        "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n          Fault\n        ")]):_vm._e(),_vm._v("\n         \n        "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n          System Details\n        ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticClass:"stats_header__title"},[_vm._v("\n              Device "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n            ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"21px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n              Installation Capacity:\n              "+_vm._s(_vm.Device.MiscData ? _vm.Device.MiscData.InstallSize : "")+"KVA\n              (Arnergy "),_c('span',[_vm._v(_vm._s(_vm.Device.InstallType))]),_vm._v(")\n            ")]),_vm._v(" "),_c('p',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n              "+_vm._s(_vm.installationData.name || "-")+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}})])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{},[_c('el-collapse',{staticClass:"page-content",on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Device\n                      "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online"))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load active power")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.PowerData)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      "+_vm._s(_vm.activePercent(_vm.Device.PowerData))+"% Load\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                      "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                      "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                      "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                      PV Power:\n                      "+_vm._s(_vm.Device.PowerData
                          ? _vm.panelPowerReduce(_vm.Device.PowerData, "v4")
                          : "-")+"\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                  'background-color': _vm.gridCalc(_vm.Device.Mode)
                    ? '#2ED47A !important'
                    : '#e74c3c !important',
                  height: '100%'
                })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                      "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                    ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                      This Month\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid ||
                          0 * 1)+"kWh\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid ||
                          0 * 1)+"kWh\n                    ")])])])])]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid ||
                            0 * 1)+"kWh\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Week:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Month:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                    ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                      This Year:\n                    ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                      "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                    ")])])])])])],1)])]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e()],1),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v5_vue__ = __webpack_require__(1066);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad088d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v5_vue__ = __webpack_require__(2615);
function injectStyle (ssrContext) {
  __webpack_require__(2614)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ad088d0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v5_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ad088d0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v5_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":'https://res.cloudinary.com/mentor-africa-project/image/upload/v1634545558/Charge_Controller.jpg',"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76 || _vm.MiscData.FV == 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData && _vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(((_vm.Device.BatteryData && _vm.Device.BatteryData.SOC) || 0) * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData &&  _vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData && _vm.Device.MiscData.ExptdChgCyl)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.getDisplayValue(_vm.Device.BatteryData, dataKey))+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InvAggrData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InvAggrData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData && _vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.SOC * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData && _vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData &&  _vm.Device.BatteryData.CurrentState)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76 || _vm.MiscData.FV == 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76 && _vm.MiscData.FV != 1.11)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v6_vue__ = __webpack_require__(1067);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ab36bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v6_vue__ = __webpack_require__(2618);
function injectStyle (ssrContext) {
  __webpack_require__(2617)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20ab36bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_v6_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ab36bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_v6_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content_"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.warningsOffCanvas},on:{"update:show":function($event){_vm.warningsOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.warningsOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Warning Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.warningsDataValuesFields),callback:function ($$v) {_vm.warningsDataValuesFields=$$v},expression:"warningsDataValuesFields"}},_vm._l((_vm.warningsDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.warningsData,"fields":_vm.warningsDataValuesFields,"per-page":_vm.perPage,"current-page":_vm.warningCurrentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.warningRows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.warningCurrentPage),callback:function ($$v) {_vm.warningCurrentPage=$$v},expression:"warningCurrentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.warningCurrentPage))])],1)])],2)]),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showTableOffCanvas},on:{"update:show":function($event){_vm.showTableOffCanvas=$event}}},[_c('div',{staticStyle:{"width":"auto !important","overflow":"scroll"}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showTableOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report")]),_vm._v(" "),_c('hr'),_vm._v(" "),[_c('el-select',{attrs:{"multiple":"","placeholder":"Select"},model:{value:(_vm.exportDataToTableValuesFields),callback:function ($$v) {_vm.exportDataToTableValuesFields=$$v},expression:"exportDataToTableValuesFields"}},_vm._l((_vm.exportDataTableoptions),function(item,key){return _c('el-option',{key:key,attrs:{"label":item,"value":item}})}),1)],_vm._v(" "),_c('div',[_c('div',{staticClass:"overflow-auto"},[_c('b-table',{attrs:{"responsive":"","items":_vm.exportDataToTableValues,"fields":_vm.exportDataToTableValuesFields,"per-page":_vm.perPage,"current-page":_vm.currentPage,"small":""}}),_vm._v(" "),_c('b-pagination',{attrs:{"total-rows":_vm.rows,"per-page":_vm.perPage,"aria-controls":"my-table"},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}}),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Current Page: "+_vm._s(_vm.currentPage))])],1)])],2)]),_vm._v(" "),(_vm.initError == false)?_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('el-tabs',{staticStyle:{"height":"100%"},attrs:{"tab-position":"top"}},[_c('el-tab-pane',{attrs:{"label":"Inverters"}},_vm._l((_vm.Device.InverterData),function(singleInverter,index){return _c('el-card',{key:("inverterDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"inverter-details-box"},[_c('div',{staticStyle:{"width":"150px","border-right":"1px solid #eee","padding":"5px","margin-right":"2px","text-align":"center"}},[_c('img',{staticStyle:{"width":"50%","height":"auto"},attrs:{"src":__webpack_require__(1060),"alt":"inv"}}),_vm._v(" "),_c('b',[_vm._v(_vm._s(singleInverter["InverterId"]))])]),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex","align-items":"center","flex-flow":"column","justify-content":"center","padding":"10px"}},_vm._l((Object.keys(singleInverter)),function(inverterKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(inverterKey != 'InverterId'),expression:"inverterKey != 'InverterId'"}],key:("inverterKey_" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(inverterKey)))]),_vm._v(" "),_c('span',[_vm._v("\n                    "+_vm._s(inverterKey != "InverterId"
                        ? _vm.getDisplayValue(singleInverter, inverterKey)
                        : "--")+"\n                  ")])])}),0)])])}),1),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('el-tab-pane',{attrs:{"label":"Energy"}},_vm._l((_vm.singularEnergyData),function(singleEnergy,index){return _c('el-card',{key:("energyDetails_" + index),staticStyle:{"margin-bottom":"20px"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"inverterId"},[_c('b',[_vm._v("Inverter ID:")]),_vm._v("\n                "+_vm._s(" ")+"\n                "+_vm._s(singleEnergy.InverterId)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-left",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Week\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Month\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        This Year\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).GeneratedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) >= 1.76 ||
                    _vm.MiscData.FV == 1.11 ||
                    _vm.MiscData.FV == 1.0
                )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedToday || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeek || 0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonth || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYear || 0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedAllTime ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(parseFloat(_vm.MiscData.FV) < 1.76)?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                            0 * 1)+"kWh\n                      ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      _vm.MiscData.FV != 1.11 &&
                      _vm.MiscData.FV != 1.0
                  )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          Today:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedTodayOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(
                          parseFloat(_vm.MiscData.FV) < 1.76 &&
                            parseFloat(_vm.MiscData.FV) != 1.0
                        )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Week:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedWeekOnGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Month:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedMonthOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                          This Year:\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOnGrid ||
                              0 * 1)+"kWh\n                        ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                          All Time\n                        ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                          "+_vm._s(_vm.confirmEnergy(singleEnergy).ConsumedYearOffGrid ||
                              0 * 1)+"kWh\n                        ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"col-sm-12 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("\n                    Peak Power Generated\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-12 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakToday || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(
                        parseFloat(_vm.MiscData.FV) < 1.76 &&
                          parseFloat(_vm.MiscData.FV) != 1.0
                      )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Week:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakWeek || 0 * 1)+"kWp\n                      ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Month:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakMonth || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("\n                        This Year:\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("\n                        All Time\n                      ")]),_vm._v(" "),_c('div',{},[_vm._v("\n                        "+_vm._s(_vm.confirmEnergy(singleEnergy).PeakYear || 0 * 1)+"kWp\n                      ")])]):_vm._e()])])])],1)])}),1):_vm._e(),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Battery"}},[_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('battery',{attrs:{"width":"300px","height":"150px","direction":"x","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('Center',{staticClass:"row",staticStyle:{"padding":"8px"}},[_c('h1',[_vm._v("\n              "+_vm._s(_vm.roundUp(_vm.Device.BatteryData.SOC * 1))+"% ‐\n              "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('small',[_vm._v("\n              Charge cycles: "+_vm._s(_vm.Device.MiscData.ChgCycle)+"/"+_vm._s(_vm.Device.MiscData.ExptdChgCyl)+"\n            ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('Can',{attrs:{"I":"manage","a":"installation"}},[_c('span',[_vm._v(_vm._s(_vm.batteryLife))])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.BatteryData)),function(dataKey,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKey != 'InverterId'),expression:"dataKey != 'InverterId'"}],key:("BatteryData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKey)))]),_vm._v(" "),_c('span',[_vm._v("\n              "+_vm._s(_vm.Device.BatteryData[dataKey] == 1
                  ? "Yes"
                  : _vm.Device.BatteryData[dataKey] == 0
                  ? "No"
                  : _vm.getDisplayValue(_vm.Device.BatteryData, dataKey))+"\n            ")])])})],2),_vm._v(" "),_c('el-tab-pane',{staticStyle:{"padding-top":"20px","padding-bottom":"20px"},attrs:{"label":"Misc Data"}},[_c('h3',[_vm._v("System Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((Object.keys(_vm.Device.MiscData)),function(dataKeyMisc,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(dataKeyMisc != 'InverterId'),expression:"dataKeyMisc != 'InverterId'"}],key:("MiscData" + index),staticClass:"inverterInfo"},[_c('b',[_vm._v(_vm._s(_vm.getLabel(dataKeyMisc)))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getDisplayValue(_vm.Device.MiscData, dataKeyMisc)))])])})],2)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.initError)?_c('div',{staticClass:"sadFaceIOT"},[_c('i',{staticClass:"fa fa-meh-o fa-3x",staticStyle:{"font-size":"20rem"}}),_vm._v(" "),_c('h1',[_vm._v("Device not smart yet!!!")]),_vm._v(" "),_c('h3',[_vm._v("check back later...")])]):_c('div',{staticClass:"col-md-12",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"row","justify-content":"center","top":"0px"}},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"row","display":"flex","flex":"1"}},[_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('h1',{staticStyle:{"margin-top":"20px"}},[_c('img',{staticClass:"_user-avatar",attrs:{"src":"https://all4ed.org/wp-content/themes/all4ed/assets/images/avatar-placeholder-generic.png","alt":""}}),_vm._v("\n            "+_vm._s(_vm.installationData.name || "-")+"\n          ")]),_vm._v(" "),_c('b',{staticStyle:{"font-size":"17px"}},[_vm._v("Last Seen: "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp)))]),_vm._v(" "),_c('p',[_vm._v("\n            Installed Capacity:\n            "+_vm._s(_vm.installationCapacity)+" ( "),_c('span',[_vm._v(_vm._s(_vm.installationType))]),_vm._v(")\n          ")])]),_vm._v(" "),_c('div',{staticClass:"stats",staticStyle:{"align-items":"left","padding":"10px"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","justify-content":"space-between"}},[_c('can',{attrs:{"I":"manage","a":"installation"}},[(_vm.statusCalc(_vm.Device.Timestamp))?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.triggerRemoveDeviceOnPerformanceList}},[_vm._v("\n                Remove\n              ")]):_vm._e(),_vm._v("\n               \n            ")]),_vm._v(" "),(_vm.alarmFlags.warning == true)?_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.showAlarm('warnings')}}},[_vm._v("\n              Warning\n            ")]):_vm._e(),_vm._v("\n             \n            "),(_vm.alarmFlags.error == true)?_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.showAlarm('errors')}}},[_vm._v("\n              Fault\n            ")]):_vm._e(),_vm._v("\n             \n            "),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n              System Details\n            ")]),_vm._v(" "),_c('el-button',{staticStyle:{"margin-left":"10px"},attrs:{"type":"success","disabled":_vm.viewDataLoading,"plain":""},on:{"click":_vm.exportData}},[_vm._v(_vm._s(_vm.exportDataLoading ? "Downloading..." : "Download Report"))])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.batteryLife))])])])]),_vm._v(" "),(_vm.screenView.code === 0)?_c('div',[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('el-collapse',{model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"title":"Monitor","name":"1"}},[_c('system-monitor',{attrs:{"device":_vm.Device}})],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("\n                    Device\n                    "+_vm._s(_vm.statusCalc(_vm.Device.Timestamp) ? "Offline" : "Online")+"\n                  ")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.batteryMode(_vm.Device.Mode)))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.lastSeen(_vm.Device.Timestamp))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Load Wattage")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.activePower(_vm.Device.InverterData))+" kW")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    "+_vm._s(_vm.activePercent(_vm.Device.InverterData))+"% Load\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_c('div',{staticClass:"top-widget-box__header"},[_c('battery',{attrs:{"width":"60px","height":"40px","direction":"y","level":_vm.Device.BatteryData.SOC}})],1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Battery "+_vm._s(_vm.Device.BatteryData.CurrentState))]),_vm._v(" "),_c('h1',[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.SOC * 1)+"% ‐\n                    "),_c('small',[_vm._v(_vm._s(_vm.Device.BatteryData.TotalBatCur)+"A")])]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("\n                    "+_vm._s(_vm.Device.BatteryData.CurrentState)+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v("\n                    PV Power:\n                    "+_vm._s(_vm.Device.InverterData
                        ? _vm.panelPowerReduce(_vm.Device.InverterData)
                        : "-")+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",style:({
                'background-color': _vm.gridCalc(_vm.Device.Mode)
                  ? '#2ED47A !important'
                  : '#e74c3c !important',
                height: '100%'
              })},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title",staticStyle:{"color":"#fff"}},[_vm._v("Grid Status")]),_vm._v(" "),_c('h1',{staticStyle:{"color":"#fff"}},[_vm._v("\n                    "+_vm._s(_vm.gridCalc(_vm.Device.Mode) ? "ON" : "OFF")+"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"stats_header__title"},[_vm._v(" ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("Today")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Week")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Month")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("This Year")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).GeneratedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) >= 1.76 ||
              _vm.MiscData.FV == 1.11 ||
              _vm.MiscData.FV == 1.0
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedToday || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    parseFloat(_vm.MiscData.FV) != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeek || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonth || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYear || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedAllTime || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),(
            parseFloat(_vm.MiscData.FV) < 1.76 &&
              _vm.MiscData.FV != 1.11 &&
              _vm.MiscData.FV != 1.0
          )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                ")])]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[(
              parseFloat(_vm.MiscData.FV) < 1.76 &&
                _vm.MiscData.FV != 1.11 &&
                _vm.MiscData.FV != 1.0
            )?_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed On Grid")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedTodayOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(
                    parseFloat(_vm.MiscData.FV) < 1.76 &&
                      _vm.MiscData.FV != 1.11 &&
                      _vm.MiscData.FV != 1.0
                  )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedWeekOnGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedMonthOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOnGrid || 0 * 1)+"kWh\n                  ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                    "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).ConsumedYearOffGrid || 0 * 1)+"kWh\n                  ")])]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"flex-flow":"column"}},[_c('div',{staticClass:"row stat_data_row"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-sm-8 power_stat_row_",staticStyle:{"font-size":"12px"}},[_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("Today:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakToday || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(
                  parseFloat(_vm.MiscData.FV) < 1.76 &&
                    _vm.MiscData.FV != 1.11 &&
                    _vm.MiscData.FV != 1.0
                )?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Week:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakWeek || 0 * 1)+"kWp\n                ")])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Month:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakMonth || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"text-left stats_header__title"},[_vm._v("This Year:")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]),_vm._v(" "),(parseFloat(_vm.MiscData.FV) >= 1.76)?_c('div',{staticStyle:{"margin":"5px"}},[_c('div',{staticClass:"stats_header__title text-left"},[_vm._v("All Time")]),_vm._v(" "),_c('div',{},[_vm._v("\n                  "+_vm._s(_vm.confirmEnergy(_vm.EnergyData).PeakYear || 0 * 1)+"kWp\n                ")])]):_vm._e()])])])],1)]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 1)?_c('el-card',{staticClass:"box-card widget"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5"})]):_vm._e(),_vm._v(" "),(_vm.screenView.code === 2)?_c('div',{staticClass:"box-card widget control-power-stats col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('device-control',{attrs:{"inverterId":_vm.inverterId}})],1):_vm._e()],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-calendar fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-bolt fa-4x icon"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-lightbulb-o fa-4x icon",staticStyle:{"color":"#fff"},attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(61, 177, 53)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Generated Energy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Energy Consumed")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(232, 150, 0)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title"},[_vm._v("Consumed Off Grid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-4 power_stat_"},[_c('div',{staticClass:"fa fa-bolt fa-4x text-center",staticStyle:{"color":"rgb(235, 59, 124)","transform":"rotate(20%)"}}),_vm._v(" "),_c('h3',{staticClass:"stats-title text-center"},[_vm._v("Peak Power Generated")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","padding":"10px !important","flex-flow":"column"}},[_c('div',{staticStyle:{"display":"flex","align-items":"center","cursor":"pointer"}},[_c('el-breadcrumb',{staticClass:"col-sm-6",attrs:{"separator":"/"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("Dashboard")]),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"all"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/performance/live' }}},[_vm._v("Performance")])],1),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.params.deviceId))])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"pull-right",staticStyle:{"display":"flex","flex-flow":"row no-wrap"}},[_c('b-button',{attrs:{"variant":"success"},on:{"click":_vm.openBlank}},[_vm._v("Chart")]),_vm._v(" "),_c('div',{staticStyle:{"margin-left":"10px"}},[_c('b-dropdown',{staticClass:"m-md-2",attrs:{"id":"dropdown-1","text":"View Options"}},[_c('b-dropdown-item',{attrs:{"active":""},on:{"click":function($event){return _vm.handleSplitValue({ code: 0, name: 'System Overview' })}}},[_vm._v("System Overview")]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){return _vm.handleSplitValue({ code: 2, name: 'Device Controls' })}}},[_vm._v("Device Controls")])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('div',{staticStyle:{"margin-left":"10px"}},[_c('control-settings')],1)])],1)])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.$route.params.version == 'v2')?_c('v2-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v3')?_c('v3-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v4')?_c('v4-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v5')?_c('v5-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e(),_vm._v(" "),(_vm.$route.params.version == 'v6')?_c('v6-dash',{attrs:{"inverterId":_vm.$route.params.deviceId,"screenView":_vm.screenView}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2623 */,
/* 2624 */,
/* 2625 */,
/* 2626 */,
/* 2627 */,
/* 2628 */,
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */,
/* 2633 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2634 */,
/* 2635 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 2636 */,
/* 2637 */,
/* 2638 */,
/* 2639 */,
/* 2640 */,
/* 2641 */,
/* 2642 */,
/* 2643 */,
/* 2644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row dashboard-warning-widgets"},[_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('vuestic-widget',{staticClass:"warning-widget"},[_c('div',{staticClass:"warning-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number"},[_c('i',{staticClass:"icon glyphicon glyphicon-building-o text-primary stats-icon"}),_vm._v("\n            "+_vm._s(_vm.activePower(_vm.Device.parameters))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("Load Active Power")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('vuestic-widget',{staticClass:"warning-widget"},[_c('div',{staticClass:"warning-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number"},[_vm._v("\n            "+_vm._s((_vm.Device.parameters.outputLoadPercent))+"%\n          ")]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("Load Percentage")])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('vuestic-widget',{staticClass:"warning-widget"},[_c('div',{staticClass:"warning-widget-inner"},[_c('div',{staticClass:"warning-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number"},[_c('div',{staticClass:"battery",staticStyle:{"clear":"both"}},[_c('div',{ref:"battery_level",staticClass:"level",style:(_vm.battery_meter)})])]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("\n              "+_vm._s(_vm.batteryMode(_vm.Device.modeinquiries.mode))+"\n              "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"font-size":"1.4rem"}},[_vm._v(_vm._s(_vm.Device.parameters.batteryCapacity)+"%")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticStyle:{"font-size":"1.4rem"}},[_vm._v(_vm._s(_vm.Device.parameters.batteryVoltage)+"volt")])])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-xl-3"},[_c('vuestic-widget',{staticClass:"warning-widget"},[_c('div',{staticClass:"warning-widget-inner"},[_c('div',{staticClass:"stats"},[_c('div',{staticClass:"stats-number"},[_vm._v("\n            "+_vm._s(_vm.powerToday(_vm.Device.generated.consumed))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"stats-title"},[_vm._v("Energy Consumed Today")])])])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2646 */
/***/ (function(module, exports) {

module.exports = [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.business","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text","stylers":[{"visibility":"off"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}]

/***/ }),
/* 2647 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1084);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e43fa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2664);
function injectStyle (ssrContext) {
  __webpack_require__(2649)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a8e43fa2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offlineDevices_vue__ = __webpack_require__(1085);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d93489_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offlineDevices_vue__ = __webpack_require__(2654);
function injectStyle (ssrContext) {
  __webpack_require__(2651)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-27d93489"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offlineDevices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27d93489_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offlineDevices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table_status",class:{
                'badge-danger': _vm.statusCalc==true,
                'badge-success': _vm.statusCalc == false
              }},[_vm._v(_vm._s(_vm.timestamp))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOfflineDevices === 2 && !_vm.showCritical),expression:"showOfflineDevices === 2 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredOffLineDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredOffLineDevices,"line-numbers":true,"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm
      },"sort-options":{
        enabled: true,
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
              'badge-danger': _vm.statusCalc(props.row.TimeStamp),
              'badge-success': !_vm.statusCalc(props.row.TimeStamp)
            }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n        ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,343963945)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmDevices_vue__ = __webpack_require__(1087);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa208a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmDevices_vue__ = __webpack_require__(2657);
function injectStyle (ssrContext) {
  __webpack_require__(2656)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6fa208a5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmDevices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa208a5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmDevices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAlarmDevices===2 && !_vm.showCritical),expression:"showAlarmDevices===2 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredAlarmDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.alarmFields,"rows":_vm.filteredAlarmDevices,"line-numbers":true,"search-options":{
          enabled: true,
          externalQuery: _vm.searchTerm
        },"sort-options":{
        enabled: true,
        // initialSortBy: {field: 'lastseen', type: 'desc'}
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
                'badge-danger': _vm.statusCalc(props.row.TimeStamp),
                'badge-success': !_vm.statusCalc(props.row.TimeStamp)
              }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'flags')?_c('span',_vm._l((Object.keys(props.row.flags)),function(x,index){return _c('el-badge',{key:("alarm_badge_" + index),staticClass:"item",attrs:{"value":props.row.flags[x],"type":_vm.badgeTypes[x].type}},[_c('el-button',{attrs:{"type":_vm.badgeTypes[x].type,"size":"mini","plain":""}},[_vm._v(_vm._s(_vm.badgeTypes[x].label))])],1)}),1):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n        ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,2386858942)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onLineDevices_vue__ = __webpack_require__(1088);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d7a572_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onLineDevices_vue__ = __webpack_require__(2660);
function injectStyle (ssrContext) {
  __webpack_require__(2659)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2d7a572"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onLineDevices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2d7a572_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onLineDevices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOnlineDevices === 1 && !_vm.showCritical),expression:"showOnlineDevices === 1 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredOnlineDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredOnlineDevices,"line-numbers":true,"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'Time', type: 'desc' }
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
              'badge-danger': _vm.statusCalc(props.row.TimeStamp),
              'badge-success': !_vm.statusCalc(props.row.TimeStamp)
            }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n        ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":200},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,913428057)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allDevices_vue__ = __webpack_require__(1089);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c94e2536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allDevices_vue__ = __webpack_require__(2663);
function injectStyle (ssrContext) {
  __webpack_require__(2662)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c94e2536"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allDevices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c94e2536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allDevices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2662 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllDevices === 3 && !_vm.showCritical),expression:"showAllDevices === 3 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredAllDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredAllDevices,"line-numbers":true,"search-options":{
        enabled: true,
        externalQuery: _vm.searchTerm,
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'ownerName', type: 'asc' },
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
              'badge-danger': _vm.statusCalc(props.row.TimeStamp),
              'badge-success': !_vm.statusCalc(props.row.TimeStamp),
            }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n        ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'batteryMode')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,698846951)})],1):(!_vm.filteredAllDevices && !_vm.showCritical)?_c('div',{staticStyle:{"display":"flex","flex-flow":"column","min-height":"500px","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"fa fa-spinner fa-4x animated rotateIn infinite loadingState",staticStyle:{"color":"#1a93ca"}}),_vm._v(" "),_c('h3',[_vm._v("Wait a second..")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard page-content__header-description"},[_c('h1',{staticClass:"page-title",staticStyle:{"flex":"1"}},[_vm._v("Performance")]),_vm._v(" "),(_vm.showOffOnlinelineDevices != null)?_c('div',{staticStyle:{"flex-flow":"row","display":"flex","flex":"1","margin-bottom":"8px"}},[_c('span',{staticClass:"label-container",staticStyle:{"float":"right","display":"flex"}},[_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-blue-filter':
              _vm.showOffOnlinelineDevices === 3 && !_vm.showCritical
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('All')}}},[_c('p',{staticClass:"blue-label"},[_vm._v("All")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.filteredAllDevices.length))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-green-filter':
              _vm.showOffOnlinelineDevices === 1 && !_vm.showCritical
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Online')}}},[_c('p',{staticClass:"green-label"},[_vm._v("Online")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.filteredOnlineDevices.length))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-yellow-filter':
              _vm.showOffOnlinelineDevices === 2 && !_vm.showCritical
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Offline')}}},[_c('p',{staticClass:"yellow-label"},[_vm._v("Offline")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.filteredOffLineDevices.length))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-red-filter':
              _vm.showOffOnlinelineDevices === 4 && !_vm.showCritical
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Alarm')}}},[_c('p',{staticClass:"red-label"},[_vm._v("Alarms")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.filteredAlarmDevices.length))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{ 'active-orange-filter': _vm.showCritical },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('critical')}}},[_c('p',{staticClass:"orange-label"},[_vm._v("Inverter Not Detected")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.criticalSystems.length))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterFirmWarVersion ? this.filterFirmWarVersion : "Version")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniqueFV),function(fv){return _c('el-dropdown-item',{key:fv.id},[_c('span',{on:{"click":function($event){return _vm.handleVersionFilterEnabler(fv.FV)}}},[_vm._v("\n              "+_vm._s(fv.FV)+"\n            ")])])}),1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom border",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterSectorVal ? this.filterSectorVal : "Sector")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniqueSectors),function(item){return _c('el-dropdown-item',{key:item.id},[_c('span',{on:{"click":function($event){return _vm.handleSectorFilterEnabler(item.sector)}}},[_vm._v("\n              "+_vm._s(item.sector)+"\n            ")])])}),1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom border",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterPaymentModel
              ? this.filterPaymentModel
              : "Payment Model")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniquePaymentModel),function(item){return _c('el-dropdown-item',{key:item.id},[_c('span',{on:{"click":function($event){return _vm.handlePaymentModelFilterEnabler(item.paymentModel)}}},[_vm._v(_vm._s(item.paymentModel))])])}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"display-search-bar"},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.paginatedInfo.ofText),expression:"paginatedInfo.ofText"}]},[_vm._v("\n      Showing\n      "+_vm._s(_vm.paginatedInfo.total > 0
          ? ((_vm.paginatedInfo.first) + " - " + (_vm.paginatedInfo.last) + "\n      " + (_vm.paginatedInfo.ofText) + " " + (_vm.paginatedInfo.total) + " " + (_vm.paginatedInfo.total > 1 ? "Devices" : "Device"))
          : "no device")+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch && !_vm.showCritical),expression:"showSearch && !showCritical"}],staticClass:"t"},[_c('el-input',{staticStyle:{"width":"50%"},attrs:{"placeholder":"Search All Devices","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"main-container"},[(_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical)?_c('div',[_c('OfflineDevices',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical),expression:"showOffOnlinelineDevices === 2 && !showCritical"}],attrs:{"showCritical":_vm.showCritical,"activeTab":_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical,"showOfflineDevices":_vm.showOffOnlinelineDevices,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredOffLineDevices":_vm.filteredOffLineDevices,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event}}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical)?_c('div',[_c('AlarmDevices',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical),expression:"showOffOnlinelineDevices === 4 && !showCritical"}],attrs:{"showCritical":_vm.showCritical,"activeTab":_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical,"showAlarmDevices":_vm.showOffOnlinelineDevices,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredAlarmDevices":_vm.filteredAlarmDevices,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event}}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical)?_c('div',[_c('OnLineDevices',{attrs:{"v-show":_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical,"showOnlineDevices":_vm.showOffOnlinelineDevices,"activeTab":_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical,"showCritical":_vm.showCritical,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredOnlineDevices":_vm.filteredOnlineDevices,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event}}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical)?_c('div',[_c('AllDevices',{attrs:{"v-show":_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical,"showAllDevices":_vm.showOffOnlinelineDevices,"activeTab":_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical,"showCritical":_vm.showCritical,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredAllDevices":_vm.filteredAllDevices,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event}}})],1):_vm._e(),_vm._v(" "),(
        _vm.showOffOnlinelineDevices === null && !_vm.showCritical && !_vm.loadingState
      )?_c('div',[_vm._v("\n      no data\n    ")]):_vm._e(),_vm._v(" "),(_vm.loadingState)?_c('div',{staticClass:"loadingState"},[_vm._v("\n      Loading, please wait.....\n    ")]):_vm._e(),_vm._v(" "),(_vm.showCritical)?_c('div',{staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Inverter not detected")]),_vm._v(" "),_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.criticalColumns,"rows":_vm.criticalSystems,"line-numbers":true}})],1):_vm._e()]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('iot-performance')],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content",staticStyle:{"padding":"0px !important"}},[_c('can',{attrs:{"I":"manage","a":"mine"}},[_c('Performance')],1),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('div',{staticClass:"container-fluid",staticStyle:{"padding":"0px !important"}},[_c('div',{staticClass:"google-map",attrs:{"id":"geoDistroMap"}}),_vm._v(" "),_c('div',{staticClass:"legend_accordion",attrs:{"role":"tablist"}},[_c('b-card',{staticClass:"mb-1 legend_box",attrs:{"no-body":""}},[_c('b-card-header',{staticClass:"p-1",staticStyle:{"padding":"0px"},attrs:{"header-tag":"header","role":"tab"}},[_c('b-button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.accordion-1",modifiers:{"accordion-1":true}}],attrs:{"block":"","href":"#","variant":"info"}},[_vm._v("Geographical Distribution")])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"accordion-1","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('b-card-body',[_c('h6',{staticClass:"box-card-subtitle",staticStyle:{"padding":"5px"}},[_vm._v("Device Status")]),_vm._v(" "),_c('div',{staticClass:"legend-keys text-center",staticStyle:{"padding":"5px 5px"}},[_c('div',{staticClass:"keys"},[_c('span',{staticClass:"text-center"},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(911),"alt":"checked-icon"}})]),_vm._v("\n                  Device Ok\n                ")]),_vm._v(" "),_c('div',{staticClass:"keys"},[_c('span',[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(2667),"alt":"warning-icon"}})]),_vm._v("\n                  Device Warning\n                ")]),_vm._v(" "),_c('div',{staticClass:"keys"},[_c('span',[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__(912),"alt":"error-icon"}})]),_vm._v("\n                  Device Error\n                ")])]),_vm._v(" "),_c('b-list-group',{attrs:{"horizontal":"md"}},[_c('b-list-group-item',[_vm._v("\n                  All Devices\n                  "),_c('strong',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.markers.length))])]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\n                  Devices with warning\n                  "),_c('strong',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.devicesWithWarning))])]),_vm._v(" "),_c('b-list-group-item',[_vm._v("\n                  Devices with fault\n                  "),_c('strong',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.devicesWithFault))])])],1)],1)],1)],1)],1)])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2667 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAkFBMVEUAAAD/uUb/uEf/uUb/uUb/uUb/uUb/ukX/tkn/vUL/uUb/uUb/uUb/uUf/tUr/ukX/uUb/uUb/uUb/uEf/v0D/uUb/uEf/uUb/uUb/uUb/ukX/uUb/uUb/uUb/uEf/uUb/uUb/uUb/uUb/uUb/uUb/uUb/ukX/uUb/tUr/uUb/uEf/uUb/uUb/uUb/uUYAAABJnfz1AAAALnRSTlMAHWy31/S2axwbmfv9qh9O8k1tdxTxGZz8arTa2PPZ1jdp+JpmmBrwGHhLTJG1r6xrDQAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAHdElNRQfjBxARDQAWd/8JAAAAuUlEQVQoz3WS6wKBQBCFR0pthe6I1UVEmPd/PFF7iXF+zZ5vr2cWYNDMmJuWZS5sB3Qx18NR/nKl/HWAmoJQ+JGPE/nGOF/4cSzIZw2T+ySJqNKsBxv8Bej299xSwGMQIQVwBwsa5LCnwQE4DTgENEjhSIPi/+G2GpSlqitwZOBY1/oD4SRHTSPLc5/VhQixvb7jDWXsNxF7NzTE+G6ULVp4T3W/7VTTk4e8m+dm039SPQvOi7xio/EC69tKJzGfLDIAAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMDctMTZUMTU6MTM6MDArMDI6MDBKi8rOAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTA3LTE2VDE1OjEzOjAwKzAyOjAwO9ZycgAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAAASUVORK5CYII="

/***/ }),
/* 2668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index3_vue__ = __webpack_require__(1090);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3febb21e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index3_vue__ = __webpack_require__(2683);
function injectStyle (ssrContext) {
  __webpack_require__(2669)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3febb21e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2669 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offlineDevices2_vue__ = __webpack_require__(1091);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b64f94c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offlineDevices2_vue__ = __webpack_require__(2672);
function injectStyle (ssrContext) {
  __webpack_require__(2671)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b64f94c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offlineDevices2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b64f94c4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offlineDevices2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOfflineDevices === 2 && !_vm.showCritical),expression:"showOfflineDevices === 2 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredOffLineDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredOffLineDevices,"line-numbers":true,"mode":"remote","sort-options":{
        enabled: true,
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked,"on-sort-change":_vm.onSortChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
            'badge-danger': _vm.statusCalc(props.row.TimeStamp),
            'badge-success': !_vm.statusCalc(props.row.TimeStamp)
          }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n      ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":_vm.pagination.totalRecords,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":_vm.pagination.limit},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,2342970112)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmDevices2_vue__ = __webpack_require__(1092);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d90a766c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmDevices2_vue__ = __webpack_require__(2675);
function injectStyle (ssrContext) {
  __webpack_require__(2674)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d90a766c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_alarmDevices2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d90a766c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_alarmDevices2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAlarmDevices===2 && !_vm.showCritical),expression:"showAlarmDevices===2 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.getAllAlarms)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.alarmFields,"rows":_vm.getAllAlarms,"line-numbers":true,"mode":"remote","sort-options":{
        enabled: true,
      },"pagination-options":{ enabled: true, perPage: _vm.getAllAlarms.length }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked,"on-sort-change":_vm.onSortChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
              'badge-danger': _vm.statusCalc(props.row.TimeStamp),
              'badge-success': !_vm.statusCalc(props.row.TimeStamp)
            }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'flags')?_c('span',_vm._l((Object.keys(props.row.flags)),function(x,index){return _c('el-badge',{key:("alarm_badge_" + index),staticClass:"item",attrs:{"value":props.row.flags[x],"type":_vm.badgeTypes[x].type}},[_c('el-button',{attrs:{"type":_vm.badgeTypes[x].type,"size":"mini","plain":""}},[_vm._v(_vm._s(_vm.badgeTypes[x].label))])],1)}),1):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n      ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":_vm.pagination.totalRecords,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":_vm.pagination.limit},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,1752973399)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onLineDevices2_vue__ = __webpack_require__(1093);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ccc6e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onLineDevices2_vue__ = __webpack_require__(2678);
function injectStyle (ssrContext) {
  __webpack_require__(2677)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60ccc6e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_onLineDevices2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60ccc6e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_onLineDevices2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOnlineDevices === 1 && !_vm.showCritical),expression:"showOnlineDevices === 1 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredOnlineDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredOnlineDevices,"line-numbers":true,"mode":"remote","sort-options":{
        enabled: true,
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked,"on-sort-change":_vm.onSortChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
            'badge-danger': _vm.statusCalc(props.row.TimeStamp),
            'badge-success': !_vm.statusCalc(props.row.TimeStamp)
          }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'InverterId')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.InverterId))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%\n      ")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'devicestatus')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":_vm.pagination.totalRecords,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":_vm.pagination.limit},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,2342970112)})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allDevices2_vue__ = __webpack_require__(1094);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d78ca974_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allDevices2_vue__ = __webpack_require__(2681);
function injectStyle (ssrContext) {
  __webpack_require__(2680)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d78ca974"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_allDevices2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d78ca974_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_allDevices2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAllDevices === 3 && !_vm.showCritical),expression:"showAllDevices === 3 && !showCritical"}],staticStyle:{"width":"100%"}},[(_vm.filteredAllDevices)?_c('div',{staticStyle:{"width":"100%"}},[_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.fields_,"rows":_vm.filteredAllDevices,"line-numbers":true,"mode":"remote","sort-options":{
        enabled: true,
      },"pagination-options":{ enabled: true }},on:{"on-page-change":_vm.onPageChange,"on-per-page-change":_vm.onPageChange,"on-row-click":_vm.tableRowClicked,"on-sort-change":_vm.onSortChange},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'status')?_c('span',[_c('div',{key:((props.row.TimeStamp) + "_" + (props.row.InverterId)),staticClass:"table_status",class:{
              'badge-danger': _vm.statusCalc(props.row.TimeStamp),
              'badge-success': !_vm.statusCalc(props.row.TimeStamp),
            }})]):(props.column.field == 'ownerName')?_c('span',[_c('p',[_vm._v(_vm._s(props.row.ownerName))])]):(props.column.field == 'deviceType')?_c('span',[_vm._v(_vm._s(props.row.deviceType))]):(props.column.field == 'version')?_c('span',[_vm._v(_vm._s(((props.row.version) + " / " + (props.row.FV))))]):(props.column.field == 'panelpower')?_c('span',[_vm._v(_vm._s(props.row.panelpower))]):(props.column.field == 'OutputLoadPercent')?_c('span',[_vm._v(_vm._s(((props.row.contractualLoad) + " / " + (props.row.OutputLoadPercent)))+"%")]):(props.column.field == 'installedCapacity')?_c('span',[_vm._v(_vm._s(((props.row.installedPV) + " / " + (props.row.installedCapacity))))]):(props.column.field == 'batteryMode')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_vm._v(_vm._s(props.row.batteryMode))]):(props.column.field == 'BatteryCapacity')?_c('span',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('battery',{staticStyle:{"margin-top":"5px"},attrs:{"mini":true,"width":"18px","height":"10px","direction":"y","level":props.row.BatteryCapacity}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(((props.row.BatteryCapacity * 1) + "%")))])],1):(props.column.field == 'Time')?_c('span',[_vm._v(_vm._s(("" + (_vm.formatDate(props.row.Time)))))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"currentPage":_vm.tableOptions.currentPage,"total":_vm.pagination.totalRecords,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":_vm.pagination.limit},on:{"paginated-info":function($event){return _vm.showPaginatedInfo($event)}}})]}}],null,false,1882565279)})],1):(!_vm.filteredAllDevices && !_vm.showCritical)?_c('div',{staticStyle:{"display":"flex","flex-flow":"column","min-height":"500px","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"fa fa-spinner fa-4x animated rotateIn infinite loadingState",staticStyle:{"color":"#1a93ca"}}),_vm._v(" "),_c('h3',[_vm._v("Wait a second..")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn, wait) {
   var timer = void 0;
   return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
         args[_key] = arguments[_key];
      }

      if (timer) {
         clearTimeout(timer); // clear any pre-existing timer
      }
      var context = this; // get the current context
      timer = setTimeout(function () {
         fn.apply(context, args); // call the function if time expires
      }, wait);
   };
}

/***/ }),
/* 2683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard page-content__header-description"},[_c('h1',{staticClass:"page-title",staticStyle:{"flex":"1"}},[_vm._v("Performance")]),_vm._v(" "),(_vm.showOffOnlinelineDevices != null)?_c('div',{staticStyle:{"flex-flow":"row","display":"flex","flex":"1","margin-bottom":"8px"}},[_c('span',{staticClass:"label-container",staticStyle:{"float":"right","display":"flex"}},[_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-blue-filter':
              _vm.showOffOnlinelineDevices === 3 && !_vm.showCritical,
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('All')}}},[_c('p',{staticClass:"blue-label"},[_vm._v("All")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.pagination.deviceAnalytics.totalDetectableDevices))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-green-filter':
              _vm.showOffOnlinelineDevices === 1 && !_vm.showCritical,
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Online')}}},[_c('p',{staticClass:"green-label"},[_vm._v("Online")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.pagination.deviceAnalytics.onLines))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-yellow-filter':
              _vm.showOffOnlinelineDevices === 2 && !_vm.showCritical,
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Offline')}}},[_c('p',{staticClass:"yellow-label"},[_vm._v("Offline")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.pagination.deviceAnalytics.offLines))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{
            'active-red-filter':
              _vm.showOffOnlinelineDevices === 4 && !_vm.showCritical,
          },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('Alarm')}}},[_c('p',{staticClass:"red-label"},[_vm._v("Alarms")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.pagination.deviceAnalytics.alarms))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"default-label",class:{ 'active-orange-filter': _vm.showCritical },on:{"click":function($event){return _vm.toggleShowOfflineOnlineDevices('critical')}}},[_c('p',{staticClass:"orange-label"},[_vm._v("Inverter Not Detected")]),_vm._v(" "),_c('p',{staticClass:"device-amount"},[_vm._v(_vm._s(_vm.pagination.deviceAnalytics.notDetectedDevices))])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterFirmWarVersion ? this.filterFirmWarVersion : "Version")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniqueFV),function(fv){return _c('el-dropdown-item',{key:fv.id},[_c('span',{on:{"click":function($event){return _vm.handleVersionFilterEnabler(fv.FV)}}},[_vm._v("\n              "+_vm._s(fv.FV)+"\n            ")])])}),1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom border",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterSectorVal ? this.filterSectorVal : "Sector")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniqueSectors),function(item){return _c('el-dropdown-item',{key:item.id},[_c('span',{on:{"click":function($event){return _vm.handleSectorFilterEnabler(item.sector)}}},[_vm._v("\n              "+_vm._s(item.sector)+"\n            ")])])}),1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFilters),expression:"showFilters"}],staticClass:"table-header-custom border",staticStyle:{"margin-bottom":"12px","margin-right":"5pt"}},[_c('el-dropdown',[_c('el-button',{staticClass:"el-dropdown-link",attrs:{"size":"small","round":""}},[_vm._v("\n          "+_vm._s(this.filterPaymentModel
              ? this.filterPaymentModel
              : "Payment Model")+"\n          "),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},_vm._l((_vm.uniquePaymentModel),function(item){return _c('el-dropdown-item',{key:item.id},[_c('span',{on:{"click":function($event){return _vm.handlePaymentModelFilterEnabler(item.paymentModel)}}},[_vm._v(_vm._s(item.paymentModel))])])}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"display-search-bar"},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.paginatedInfo.ofText && !_vm.getLoadingState),expression:"paginatedInfo.ofText && !getLoadingState"}]},[_vm._v("\n      Showing\n      "+_vm._s(_vm.paginatedInfo.total > 0
          ? ((_vm.paginatedInfo.first) + " - " + (_vm.showNotDetectedInv || _vm.paginatedInfo.last) + " \n      " + (_vm.paginatedInfo.ofText) + " " + (_vm.showNotDetectedInv || _vm.paginatedInfo.total) + " " + (_vm.paginatedInfo.total > 1 ? "Devices" : "Device"))
          : "no device")+"\n    ")]),_vm._v(" "),_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.getLoadingState),expression:"getLoadingState"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch && !_vm.showCritical),expression:"showSearch && !showCritical"}],staticClass:"t"},[_c('el-input',{staticClass:"el-input el-input--prefix",staticStyle:{"width":"50%"},attrs:{"placeholder":"Search All Devices","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"main-container"},[(_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical && !_vm.getLoadingState)?_c('div',[_c('OfflineDevices',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical),expression:"showOffOnlinelineDevices === 2 && !showCritical"}],attrs:{"showCritical":_vm.showCritical,"activeTab":_vm.showOffOnlinelineDevices === 2 && !_vm.showCritical,"showOfflineDevices":_vm.showOffOnlinelineDevices,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredOffLineDevices":_vm.getAllFilteredOfflineDevice,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event},"sortData":_vm.sortDevice}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical && !_vm.getLoadingState)?_c('div',[_c('AlarmDevices',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical),expression:"showOffOnlinelineDevices === 4 && !showCritical"}],attrs:{"showCritical":_vm.showCritical,"activeTab":_vm.showOffOnlinelineDevices === 4 && !_vm.showCritical,"showAlarmDevices":_vm.showOffOnlinelineDevices,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredAlarmDevices":_vm.getAllFilteredAlarms,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event},"sortData":_vm.sortDevice}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical && !_vm.getLoadingState)?_c('div',[_c('OnLineDevices',{attrs:{"v-show":_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical,"showOnlineDevices":_vm.showOffOnlinelineDevices,"activeTab":_vm.showOffOnlinelineDevices === 1 && !_vm.showCritical,"showCritical":_vm.showCritical,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"searchTerm":_vm.searchTerm,"filteredOnlineDevices":_vm.filteredOnlineDevices,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event},"sortData":_vm.sortDevice}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical && !_vm.getLoadingState)?_c('div',[_c('AllDevices',{attrs:{"v-show":_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical,"showAllDevices":_vm.showOffOnlinelineDevices,"activeTab":_vm.showOffOnlinelineDevices === 3 && !_vm.showCritical,"showCritical":_vm.showCritical,"tableRowClicked":_vm.tableRowClicked,"fields_":_vm.fields_,"items":_vm.items,"total":_vm.pagination.deviceAnalytics.totalDetectableDevices,"searchTerm":_vm.searchTerm,"filteredAllDevices":_vm.getAllFilteredDevice,"formatDate":_vm.formatDate},on:{"paginated-info":function($event){_vm.paginatedInfo = $event},"sortData":_vm.sortDevice}})],1):_vm._e(),_vm._v(" "),(_vm.showOffOnlinelineDevices === null && !_vm.showCritical && !_vm.getLoadingState)?_c('div',[_vm._v("\n      no data\n    ")]):_vm._e(),_vm._v(" "),(_vm.getLoadingState)?_c('div',{staticStyle:{"height":"300px","display":"flex","alignItems":"center","justifyContent":"center"}},[_vm._v("\n      Loading, please wait...\n    ")]):_vm._e(),_vm._v(" "),(_vm.showCritical && !_vm.getLoadingState)?_c('div',{staticStyle:{"width":"100%"}},[_c('h2',[_vm._v("Inverter not detected")]),_vm._v(" "),_c('vue-good-table',{staticClass:"table",attrs:{"columns":_vm.criticalColumns,"rows":_vm.criticalSystems,"line-numbers":true}})],1):_vm._e()]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1095);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4da186c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2709);
function injectStyle (ssrContext) {
  __webpack_require__(2685)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e4da186c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4da186c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CheckboxComponent__ = __webpack_require__(2687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyViewComponent__ = __webpack_require__(2690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FilterInputComponent__ = __webpack_require__(2694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SelectReportComponent__ = __webpack_require__(2697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FilterSelectComponent__ = __webpack_require__(2700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoadingComponent__ = __webpack_require__(2703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ShowIncludesContent__ = __webpack_require__(2705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__LoadingComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CheckboxComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__EmptyViewComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__ShowIncludesContent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__FilterInputComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__FilterSelectComponent__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__SelectReportComponent__["a"]; });










/***/ }),
/* 2687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxComponent_vue__ = __webpack_require__(1096);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc9594e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxComponent_vue__ = __webpack_require__(2689);
function injectStyle (ssrContext) {
  __webpack_require__(2688)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5cc9594e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CheckboxComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5cc9594e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckboxComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"this-checkbox-item",on:{"click":_vm.checkboxSelect}},[_c('span',{staticClass:"this-checkbox"},[(!_vm.checked)?_c('i',{staticClass:"fa fa-square-o"}):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-check-square-o"})]),_vm._v(" "),_c('span',{staticClass:"this-text"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyViewComponent_vue__ = __webpack_require__(1097);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b23506a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyViewComponent_vue__ = __webpack_require__(2692);
function injectStyle (ssrContext) {
  __webpack_require__(2691)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b23506a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyViewComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b23506a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyViewComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty-state"},[_c('div',[_c('img',{staticClass:"empty-image",attrs:{"src":__webpack_require__(2693),"alt":""}}),_vm._v(" "),_c('h3',{staticClass:"empty-title"},[_vm._v("Nothing to show")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2693 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 2694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterInputComponent_vue__ = __webpack_require__(1098);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd5afd1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterInputComponent_vue__ = __webpack_require__(2696);
function injectStyle (ssrContext) {
  __webpack_require__(2695)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6cd5afd1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterInputComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6cd5afd1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterInputComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.input),expression:"input"}],staticClass:"input-field",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.input)},on:{"change":_vm.inputChanged,"input":function($event){if($event.target.composing){ return; }_vm.input=$event.target.value}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReportComponent_vue__ = __webpack_require__(1099);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dadbcb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReportComponent_vue__ = __webpack_require__(2699);
function injectStyle (ssrContext) {
  __webpack_require__(2698)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6dadbcb6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SelectReportComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dadbcb6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SelectReportComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(this.title))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"input-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.setDefaultAndUpdateParent($event)}]}},_vm._l((_vm.options),function(option){return _c('option',{key:option.id},[_vm._v("\n        "+_vm._s(option)+"\n        ")])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelectComponent_vue__ = __webpack_require__(1100);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761c0938_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelectComponent_vue__ = __webpack_require__(2702);
function injectStyle (ssrContext) {
  __webpack_require__(2701)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-761c0938"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterSelectComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_761c0938_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterSelectComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",on:{"click":function($event){_vm.showTitle = false}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTitle),expression:"showTitle"}],staticClass:"titleClass"},[_vm._v("\n        "+_vm._s(_vm.placeholder)+"\n    ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.key),expression:"key"}],staticClass:"input-select",attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.placeholder},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.key=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selectOption($event)}]}},_vm._l((_vm.parseRadioOptions(_vm.options)),function(optionVal,index){return _c('option',{key:index,attrs:{"label":optionVal},domProps:{"value":optionVal}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingComponent_vue__ = __webpack_require__(1101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7912216e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingComponent_vue__ = __webpack_require__(2704);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7912216e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","flex-flow":"column","min-height":"500px","justify-content":"center","align-items":"center"}},[_c('span',{staticClass:"fa fa-spinner fa-4x animated rotateIn infinite loadingState",staticStyle:{"color":"#1a93ca"}}),_vm._v(" "),_c('h3',[_vm._v("Wait a second..")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowIncludesContent_vue__ = __webpack_require__(1102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69160750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowIncludesContent_vue__ = __webpack_require__(2708);
function injectStyle (ssrContext) {
  __webpack_require__(2706)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69160750"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowIncludesContent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69160750_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowIncludesContent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2707 */,
/* 2708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vk-offcanvas-content',[_c('vk-offcanvas',{attrs:{"show":_vm.show},on:{"update:show":function($event){_vm.show=$event}}},[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.show = false}}}),_vm._v(" "),_c('h3',[_vm._v("Report Details")]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.parseOutputData())}})],1)],1),_vm._v(" "),_c('div',[_c('b-button',{staticStyle:{"background-color":"#1a93ca","color":"white","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){_vm.show = !_vm.show}}},[_vm._v("View")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12 container"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2 this-sidebar"},[_c('SelectReportComponent',{attrs:{"title":"Select Report","reports":_vm.reports,"options":_vm.fetchData.titles},on:{"updateSelectedReport":_vm.updateSelectedReport}}),_vm._v(" "),(_vm.hasIncludes())?_c('span',[_c('p',{staticClass:"title",staticStyle:{"margin":"10px 0"}},[_vm._v("Includes")]),_vm._v(" "),_vm._l((_vm.returnIncludes()),function(item){return _c('CheckboxComponent',{key:item.id,attrs:{"title":item},on:{"checkboxSelected":_vm._checkboxSelected}})})],2):_vm._e(),_vm._v(" "),(_vm.hasFilters())?_c('div',[_c('p',{staticClass:"title",staticStyle:{"margin":"10px 0"}},[_vm._v("Filters")]),_vm._v(" "),_vm._l((_vm.returnFilters()),function(item){return _c('div',{key:item.id,staticClass:"filter-field"},[(item.type == 'text' || item.type == 'freetext')?_c('FilterInputComponent',{attrs:{"placeholder":_vm.removeDollarSign(item.key)},on:{"updateInputFilter":_vm._updateInputFilter}}):_vm._e(),_vm._v(" "),(item.type == 'radio')?_c('FilterSelectComponent',{attrs:{"placeholder":_vm.removeDollarSign(item.key),"options":item.options},on:{"setFilterSelect":_vm._setFilterSelect}}):_vm._e()],1)})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttonSection"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.fetchReport}},[_vm._v("Fetch Report")])])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[(_vm.loading)?_c('LoadingComponent'):_vm._e(),_vm._v(" "),(_vm.output.length < 1 && !_vm.loading)?_c('EmptyViewComponent'):_vm._e(),_vm._v(" "),(_vm.output.length > 0 && !_vm.loading)?_c('div',[_c('div',{staticClass:"header-bar"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.fetchData.data.title)+" Reports")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary yellow-btn",on:{"click":_vm.downloadReport}},[_vm._v("Download CSV")])]),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.tableColumns(_vm.output),"rows":_vm.output,"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return (_vm.isObjectType(props.column.field))?[_c('ShowIncludesContent',{attrs:{"row":props.row,"field":props.column.field}})]:undefined}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}],null,true)})],1):_vm._e()],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xl-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Reports")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a079393_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2714);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a079393_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__ = __webpack_require__(1104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db0afd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__ = __webpack_require__(2713);
function injectStyle (ssrContext) {
  __webpack_require__(2712)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7db0afd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7db0afd2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container invoices-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Search Invoices","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.isACustomer ? _vm.customerTableOptions : _vm.tableOptions,"rows":_vm.invoiceList,"isLoading":_vm.isLoadingVGT,"search-options":{
        enabled: true,
        searchFn: _vm.searchTable,
        externalQuery: _vm.searchTerm
      },"pagination-options":{ enabled: true },"select-options":{
        enabled: true,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }},on:{"on-selected-rows-change":_vm.selectionChanged},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('div',[(props.column.field == 'name')?_c('span',[_vm._v("\n            "+_vm._s(props.row["payload"]["user"]["firstName"] &&
              props.row["payload"]["user"]["lastName"]
                ? ((props.row["payload"]["user"]["firstName"]) + " " + (props.row["payload"]["user"]["lastName"]))
                : ((props.row["user"]["firstName"]) + " " + (props.row["user"]["lastName"])))+"\n          ")]):_vm._e(),_vm._v(" "),(
              props.column.field == 'type' ||
                props.column.field == 'invoiceType'
            )?_c('span',[_vm._v("\n            "+_vm._s(props.row["type"] ||
              props.row["type"] == "autoMonthlySubscription"
                ? "subscription"
                : props.row["payload"]["invoiceType"])+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'invoiceNo')?_c('span',[_vm._v("\n            "+_vm._s(props.row["invoiceNo"])+"\n          ")]):(props.column.field == 'paymentModel')?_c('span',[_vm._v("\n            "+_vm._s(props.row["paymentMode"])+"\n          ")]):(props.column.field == 'price')?_c('span',[_vm._v("\n            "+_vm._s("₦")+_vm._s(_vm.numberWithCommas(
                props.row["payload"]["packageType"]
                  ? props.row["payload"]["packageType"]["price"]
                  : props.row["payload"]["invoiceTotalAmount"]
                  ? props.row["payload"]["invoiceTotalAmount"]
                  : props.row["payload"]["amount"] || "0.0"
              ))+"\n          ")]):(props.column.field == 'date')?_c('span',[_vm._v("\n            "+_vm._s(new Date(props.row["createdAt"]).toDateString())+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',{class:props.row['ispayed']
                ? 'badge badge-success'
                : 'badge badge-danger'},[_vm._v(_vm._s(props.row["ispayed"] ? "Paid" : "Not Paid"))]):_vm._e(),_vm._v(" "),(props.column.field == 'action')?_c('span',[_c('b-button',{staticStyle:{"background-color":"#1a93ca","color":"white","border":"none"},attrs:{"type":"primary"},on:{"click":function($event){return _vm.viewStatus(props.row)}}},[_vm._v("View")])],1):_vm._e()])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Send Invoice")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Contact"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select installation"},on:{"change":_vm.installationSelected},model:{value:(_vm.form.installation),callback:function ($$v) {_vm.$set(_vm.form, "installation", $$v)},expression:"form.installation"}},_vm._l((_vm.installationOptionsTest),function(item){return _c('el-option',{key:((item.CID ? item.CID : item.solarKitIds) + "_item_list"),attrs:{"label":("" + (item.label)),"value":item}})}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Billing Period"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"daterange","range-separator":"To","start-placeholder":"Start date","end-placeholder":"End date"},model:{value:(_vm.form.period),callback:function ($$v) {_vm.$set(_vm.form, "period", $$v)},expression:"form.period"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Amount (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":" VAT (%)"}},[_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},model:{value:(_vm.form.orderVat),callback:function ($$v) {_vm.$set(_vm.form, "orderVat", $$v)},expression:"form.orderVat"}},[_c('el-option',{key:"0_item_vat_list",attrs:{"label":"0%","value":0.0}}),_vm._v(" "),_c('el-option',{key:"7_5_item_vat_list",attrs:{"label":"7.5%","value":7.5}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary","disabled":_vm.isSending},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v(_vm._s(_vm.isSending ? "Sending..." : "Send Invoice"))])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Invoices")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("\n            New Invoice\n          ")])])]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center","margin":"10px"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"disabled":_vm.isDispatching},on:{"click":_vm.DispatchInvoice}},[_vm._v("\n            "+_vm._s(_vm.isDispatching ? "Sending..." : "Send Reminder")+"\n          ")])])])],1),_vm._v(" "),_c('div',[_c('Invoices',{ref:"invoiceComponent"})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_single_vue__ = __webpack_require__(1105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe66170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_vue__ = __webpack_require__(2720);
function injectStyle (ssrContext) {
  __webpack_require__(2716)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fe66170"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_single_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fe66170_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_single_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditInvoice_vue__ = __webpack_require__(1106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59a85d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditInvoice_vue__ = __webpack_require__(2719);
function injectStyle (ssrContext) {
  __webpack_require__(2718)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a59a85d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a59a85d2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[(_vm.showLoading)?_c('arnergy-loader'):_vm._e(),_vm._v(" "),_c('h3',[_vm._v("Update Invoice")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{staticClass:"label"},[_vm._v("Payment Reference")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.formParams.paymentRef),expression:"formParams.paymentRef"}],staticClass:"input",attrs:{"required":""},domProps:{"value":(_vm.formParams.paymentRef)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.formParams, "paymentRef", $event.target.value)}}}),_vm._v(" "),(_vm.formErrors.paymentRef)?_c('small',{staticClass:"error"},[_vm._v("\n      "+_vm._s(_vm.formErrors.paymentRef)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{staticClass:"label"},[_vm._v("Payment Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.formParams.paymentType),expression:"formParams.paymentType"}],staticClass:"input-select",attrs:{"value":"paymentType"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.formParams, "paymentType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((['Cash', 'Bank Transfer']),function(optionVal,index){return _c('option',{key:index,attrs:{"label":optionVal},domProps:{"value":optionVal}})}),0),(_vm.formErrors.paymentType)?_c('small',{staticClass:"error"},[_vm._v("\n      "+_vm._s(_vm.formErrors.paymentType)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.doUpdate}},[_vm._v("Update")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('EditInvoice',{attrs:{"invoiceId":_vm.invoiceData.id}})],1)]),_vm._v(" "),_c('div',{staticClass:"invoice-container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10 col-md-offset-1"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":__webpack_require__(214)}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 text-right"},[_c('div',{staticClass:"invoice-status text-right"},[(_vm.ispayed)?_c('span',{staticClass:"payment-status paid"},[_vm._v("PAID")]):_c('div',{staticClass:"unpaid-div"},[_c('span',{staticClass:"payment-status unpaid"},[_vm._v("UNPAID")]),_vm._v(" "),_c('can',{attrs:{"I":"am","a":"finance"}},[_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("Update")])],1)],1)]),_vm._v(" "),_c('can',{attrs:{"I":"am","a":"customer"}},[_c('Rave',{staticStyle:{"display":"none"},attrs:{"is-production":true,"text":"Pay Now","style-class":"btn btn-primary","id":"paymentbtn","email":_vm.paymentData.email,"amount":_vm.paymentAmount,"reference":_vm.genRandomNumber,"rave-key":_vm.raveKey,"callback":_vm.callback,"metadata":[
                  {
                    metaname: 'requestInfo',
                    metavalue: JSON.stringify(_vm.invoiceData)
                  }
                ],"paymentOptions":"card,barter,account,ussd","payment_plan":parseInt(0),"close":_vm.close,"currency":"NGN","country":"NG","customerFirstname":_vm.paymentData.firstname,"customerLastname":_vm.paymentData.lastname,"customerPhone":_vm.paymentData.phonenumber}}),_vm._v(" "),(!_vm.ispayed)?_c('el-button',{attrs:{"type":"btn btn-primary"},on:{"click":_vm.triggerPayment}},[_vm._v("Pay Now")]):_vm._e()],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("\n              Invoice No:\n              "+_vm._s(_vm.invoiceData.invoiceNo ? _vm.invoiceData.invoiceNo : "--")+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('h5',[_vm._v("Invoiced To:")]),_vm._v(" "),_c('address',[_vm._v("\n              "+_vm._s(_vm.invoiceData.payload.user.firstName &&
                _vm.invoiceData.payload.user.lastName
                  ? ((_vm.invoiceData.payload.user.firstName) + " " + (_vm.invoiceData.payload.user.lastName))
                  : "--")+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(_vm.invoiceData.payload.user.phoneNumber
                  ? _vm.invoiceData.payload.user.phoneNumber
                  : _vm.invoiceData.user.phoneNumber || "")+"\n              "),_c('br'),_vm._v("\n              "+_vm._s(_vm.invoiceData.payload.user.email
                  ? _vm.invoiceData.payload.user.email
                  : "--")+"\n              ")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-6"},[_c('h5',[_vm._v("Invoice Date:")]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(_vm.invoiceData.createdAt
                  ? new Date(_vm.invoiceData.createdAt).toDateString()
                  : "--")+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"text-align":"left"}},[_c('table',{staticClass:"table"},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("\n                  "+_vm._s(_vm.invoiceData.payload.comment
                      ? _vm.invoiceData.payload.comment
                      : _vm.invoiceData.payload["title"] || "No Comment")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s("₦")+_vm._s(_vm.numberWithCommas(
                      _vm.invoiceData.payload.amount
                        ? _vm.invoiceData.payload.amount
                        : "0.0"
                    ))+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v(_vm._s("VAT"))]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("\n                  "+_vm._s("₦")+_vm._s(_vm.numberWithCommas(
                      _vm.invoiceData.payload.invoiceVatAmount
                        ? _vm.invoiceData.payload.invoiceVatAmount
                        : "0.0"
                    ))+"\n                ")])]),_vm._v(" "),_c('tr',[_vm._m(2),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('h4',[_vm._v("\n                    "+_vm._s("₦")+_vm._s(_vm.numberWithCommas(
                        _vm.invoiceData.payload.invoiceTotalAmount
                          ? parseFloat(
                              _vm.invoiceData.payload.invoiceTotalAmount
                            ).toFixed(2)
                          : _vm.invoiceData.payload.amount || "0.0"
                      ))+"\n                  ")])])])])])])])])]),_vm._v(" "),_c('p',{staticClass:"text-center hidden-print"},[_c('router-link',{staticClass:"btn btn-link",attrs:{"to":"/invoices"}},[_vm._v("« Back to Invoices")]),_vm._v(" "),_vm._m(3)],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-3 col-sm-6"},[_c('h5',[_vm._v("Pay To:")]),_vm._v(" "),_c('address',[_vm._v("\n              22A, Adeleke Adedoyin Street,\n              "),_c('br'),_vm._v("Off Kofo Abayomi, Street, V.I. Lagos\n              "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Tel: +234 802 288 8840, "),_c('br'),_vm._v("+234 802 288 8841\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('td',[_vm._v("Cost Breakdown")]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_vm._v("Amount")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('h4',[_vm._v("Total")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-link",attrs:{"href":"javascript:window.print()"}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" Print\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a42157f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2732);
function injectStyle (ssrContext) {
  __webpack_require__(2722)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a42157f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2722 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_vue__ = __webpack_require__(1108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1d13ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__ = __webpack_require__(2725);
function injectStyle (ssrContext) {
  __webpack_require__(2724)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e1d13ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_add_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e1d13ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_add_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.addOffCanvas},on:{"update:show":function($event){_vm.addOffCanvas=$event}}},[_c('div',{staticStyle:{"height":"100%","text-align":"left"}},[_c('vk-offcanvas-close',{on:{"click":_vm.toggleAdd}}),_vm._v(" "),_c('h3',[_vm._v("Add")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('form',[_c('div',{staticClass:"form-group",staticStyle:{"padding":"0"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"deviceID"}},[_vm._v("Installation")]),_vm._v(" "),_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.installationSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.installation),callback:function ($$v) {_vm.$set(_vm.form, "installation", $$v)},expression:"form.installation"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"column","padding":"0"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"filterDate"}},[_vm._v("Contract Period")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"-","start-placeholder":"Start date","end-placeholder":"End date","align":"center"},model:{value:(_vm.form.filterDate),callback:function ($$v) {_vm.$set(_vm.form, "filterDate", $$v)},expression:"form.filterDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"orderVat"}},[_vm._v("VAT (%)")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select"},model:{value:(_vm.form.orderVat),callback:function ($$v) {_vm.$set(_vm.form, "orderVat", $$v)},expression:"form.orderVat"}},[_c('el-option',{key:"7_5_item_vat_list",attrs:{"label":"7.5%","value":7.5}}),_vm._v(" "),_c('el-option',{key:"0_0_item_vat_list",attrs:{"label":"0.0%","value":0.0}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"orderVat"}},[_vm._v("Payment Model")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select Payment Model"},on:{"change":function($event){return _vm.noPaymentModelChange(_vm.form.paymentModel)}},model:{value:(_vm.form.paymentModel),callback:function ($$v) {_vm.$set(_vm.form, "paymentModel", $$v)},expression:"form.paymentModel"}},[_c('el-option',{key:"5_item_paymentModel_list",attrs:{"label":"LO","value":"LO"}}),_vm._v(" "),_c('el-option',{key:"7_item_paymentModel_list",attrs:{"label":"ES","value":"ES"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"orderVat"}},[_vm._v("Send Date")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","align":"center"},model:{value:(_vm.form.sendDate),callback:function ($$v) {_vm.$set(_vm.form, "sendDate", $$v)},expression:"form.sendDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"amount"}},[_vm._v("Amount")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"amount"}},[_vm._v("Installation Location")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Location"},model:{value:(_vm.form.location),callback:function ($$v) {_vm.$set(_vm.form, "location", $$v)},expression:"form.location"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION","id":"title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage","id":"description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("Contact Address")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"No 5, Apabio Str, Lagos, Nigeria","id":"address"},model:{value:(_vm.form.user.address),callback:function ($$v) {_vm.$set(_vm.form.user, "address", $$v)},expression:"form.user.address"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("CC Emails")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"me@arnergy.com, you@arnergy.com","id":"ccEmails"},model:{value:(_vm.form.user.ccEmails),callback:function ($$v) {_vm.$set(_vm.form.user, "ccEmails", $$v)},expression:"form.user.ccEmails"}})],1)]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",attrs:{"type":"submit"},on:{"click":_vm.add}},[_vm._v("\n            "+_vm._s(_vm.loading ? "Loading..." : "Add")+"\n          ")])])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__ = __webpack_require__(1109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0e057e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__ = __webpack_require__(2731);
function injectStyle (ssrContext) {
  __webpack_require__(2727)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c0e057e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_edit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2727 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__ = __webpack_require__(1110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df2d134_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__ = __webpack_require__(2730);
function injectStyle (ssrContext) {
  __webpack_require__(2729)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7df2d134"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7df2d134_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showModal)?_c('div',[_c('transition',{attrs:{"name":"modal"}},[_c('div',{},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button"},on:{"click":_vm.handleModal}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('table',[_c('tr',[_c('td',{staticClass:"arnergyLogo"},[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":"https://arnergy.com/wp-content/uploads/2020/07/Arnergy.svg","alt":"Arnergy Logo","srcset":""}})]),_vm._v(" "),_c('td',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('div',{staticClass:"invoceMeta",staticStyle:{}},[_c('div',{staticClass:"invoiceMetaData"},[_c('b',[_vm._v("Invoiced No:")]),_vm._v(" "+_vm._s(((_vm.previewData.CID) + "-xx-xx"))+"\n                          "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"invoiceMetaData"},[_c('b',[_vm._v("Invoiced To: ")]),_vm._v("\n                          "+_vm._s(((_vm.previewData.user.firstName) + " " + (_vm.previewData.user.lastName)))),_c('br')]),_vm._v(" "),_c('div',{staticClass:"invoiceMetaData"},[_c('b',[_vm._v(" Date: ")]),_vm._v(" "+_vm._s(_vm.date)+"\n                        ")])])])]),_vm._v(" "),_c('tr',[_c('td',[_c('p',{staticClass:"office-address",staticStyle:{"font-size":"12px"}},[_c('b',{staticStyle:{"margin-bottom":"20px","color":"#1a93ca"}},[_vm._v("\n                          Arnergy Solar")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n                          22A, Adeleke Adedoyin Str."),_c('br'),_vm._v("\n                          Victoria Island, Lagos.\n                        ")])]),_vm._v(" "),_c('p',{staticClass:"office-address",staticStyle:{"font-size":"12px"}},[_c('b',{staticStyle:{"margin-bottom":"20px","color":"#1a93ca"}},[_vm._v("Customer Details")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","border-bottom":"1px solid #eee","width":"100%"}},[_c('b',[_vm._v("Name : ")]),_vm._v("\n                          "+_vm._s(((_vm.previewData.user.firstName) + " " + (_vm.previewData.user.lastName)))+"\n                        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","border-bottom":"1px solid #eee","width":"100%"}},[_c('b',[_vm._v("Customer ID : ")]),_vm._v(" "+_vm._s(("" + (_vm.previewData.CID)))+"\n                        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"10px","border-bottom":"1px solid #eee","width":"100%"}},[_c('b',[_vm._v("Address : ")]),_vm._v(" "+_vm._s(("" + (_vm.previewData.user.address)))+"\n                        ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('td',{staticStyle:{"display":"flex","justify-content":"flex-end"}},[_c('div',{staticClass:"invoceMeta",staticStyle:{"width":"100%","text-align":"right","height":"100pt"}},[_c('span',{},[_vm._v("\n                          Billing Period:\n\n                          "+_vm._s(((_vm.previewData.period[0]) + " - " + (_vm.previewData.period[1])))+" ")]),_c('br')])])])]),_vm._v(" "),_c('table',{attrs:{"id":"invoiceMainTable"}},[_c('tr',{attrs:{"id":"invoiceMainTable"}},[_c('th',{staticClass:"sn"},[_vm._v("SN")]),_vm._v(" "),_c('th',{staticClass:"description"},[_vm._v("Description")]),_vm._v(" "),_c('th',{staticClass:"amount"},[_vm._v("Amount")])]),_vm._v(" "),_c('tr',{staticClass:"tr1"},[_c('td',{staticStyle:{"text-align":"right","border-right":"1px solid #000","border-left":"1px solid #000","margin-bottom":"40px"}},[_vm._v("\n                      1.1\n                    ")]),_vm._v(" "),_c('td',{staticClass:"tdDescription"},[_c('b',[_vm._v(_vm._s(("" + (_vm.previewData.title))))]),_c('br'),_vm._v("\n                      "+_vm._s(("" + (_vm.previewData.description)))+"\n                    ")]),_vm._v(" "),_c('td',{staticStyle:{"border-left":"1pt solid black !important"}},[_vm._v("\n                      "+_vm._s(("" + (this.numberWithCommas(
                          parseFloat(_vm.previewData.amount).toFixed(2)
                        ))))+"\n                    ")])]),_vm._v(" "),_c('tr',{staticClass:"tr100px"},[_c('td',{staticClass:"trTerms",attrs:{"rowspan":"4"}}),_vm._v(" "),_c('td',{staticStyle:{"border-left":"1pt solid black !important"},attrs:{"rowspan":"1"}},[_vm._v("\n                      "+_vm._s(((parseFloat(_vm.previewData.orderVat).toFixed(1)) + "% VAT"))+"\n                    ")]),_vm._v(" "),_c('td',{staticClass:"tdGrandVatVal"},[_vm._v("\n                      "+_vm._s(("" + (this.numberWithCommas(
                          parseFloat(_vm.previewData.fees.amountVat).toFixed(2)
                        ))))+"\n                    ")])]),_vm._v(" "),_c('tr',{staticClass:"tr100px"},[_c('td',{staticClass:"tdGrandTotal",staticStyle:{"border-left":"1pt solid black !important"}},[_vm._v("\n                      Grand Total\n                    ")]),_vm._v(" "),_c('td',{staticClass:"tdGrandTotalVal"},[_vm._v("\n                      "+_vm._s(("" + (this.numberWithCommas(
                          parseFloat(_vm.previewData.fees.amountGT).toFixed(2)
                        ))))+"\n                    ")])]),_vm._v(" "),_c('tr',{staticClass:"trNoData"},[_c('td',{staticStyle:{"border-left":"1pt solid black !important"}})]),_vm._v(" "),_c('tr',{staticClass:"trTerms"},[_c('td',{staticClass:"td1Terms"},[_vm._v("\n                      Terms and Conditions: "),_c('br'),_c('br'),_vm._v("\n                      Monthly Subscription: "),_c('br'),_vm._v(" "),_c('div',[_c('b',[_vm._v("Account Details:")]),_vm._v(" "),_c('b',[_vm._v("ARNERGY SOLAR LIMITED 2.0")]),_vm._v(" "),_c('br'),_vm._v("\n                        STANBIC IBTC BANK 0031527436\n                      ")])]),_vm._v(" "),_c('td',{staticClass:"td1Terms"},[_vm._v("\n                      TIN: 17571205-0001 Payable to Federal Inland Revenue\n                      Service\n                    ")])])])])])])])])])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showModal)?_c('div',[_c('Preview',{attrs:{"showModal":_vm.showModal,"previewData":_vm.previewData},on:{"showModalUpdate":function($event){return _vm.setShowModal($event)}}})],1):_vm._e(),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.editOffCanvas},on:{"update:show":function($event){_vm.editOffCanvas=$event}}},[_c('div',{staticStyle:{"height":"100%"}},[_c('vk-offcanvas-close',{on:{"click":_vm.toggleEdit}}),_vm._v(" "),_c('h3',[_vm._v("Edit")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('form',[_c('div',{staticClass:"form-group",staticStyle:{"padding":"0"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"deviceID"}},[_vm._v("Installation")]),_vm._v(" "),_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.installationSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.installation),callback:function ($$v) {_vm.$set(_vm.form, "installation", $$v)},expression:"form.installation"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"column","padding":"0"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"filterDate"}},[_vm._v("Contract Period")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"-","start-placeholder":"Start date","end-placeholder":"End date","align":"center"},model:{value:(_vm.form.filterDate),callback:function ($$v) {_vm.$set(_vm.form, "filterDate", $$v)},expression:"form.filterDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"orderVat"}},[_vm._v("VAT (%)")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select"},model:{value:(_vm.form.orderVat),callback:function ($$v) {_vm.$set(_vm.form, "orderVat", $$v)},expression:"form.orderVat"}},[_c('el-option',{key:"7_5_item_vat_list",attrs:{"label":"7.5%","value":7.5}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"orderVat"}},[_vm._v("Payment Model")]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Select Payment Model"},on:{"change":function($event){return _vm.noPaymentModelChange(_vm.form.paymentModel)}},model:{value:(_vm.form.paymentModel),callback:function ($$v) {_vm.$set(_vm.form, "paymentModel", $$v)},expression:"form.paymentModel"}},[_c('el-option',{key:"5_item_paymentModel_list",attrs:{"label":"LO","value":"LO"}}),_vm._v(" "),_c('el-option',{key:"7_item_paymentModel_list",attrs:{"label":"ES","value":"ES"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"sendDate"}},[_vm._v("Send Date")]),_vm._v(" "),_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetime","align":"center"},model:{value:(_vm.form.sendDate),callback:function ($$v) {_vm.$set(_vm.form, "sendDate", $$v)},expression:"form.sendDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"amount"}},[_vm._v("Amount\n              ")]),_vm._v(" "),_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.form.amount),callback:function ($$v) {_vm.$set(_vm.form, "amount", $$v)},expression:"form.amount"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"amount"}},[_vm._v("Installation Location")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"Location"},model:{value:(_vm.form.location),callback:function ($$v) {_vm.$set(_vm.form, "location", $$v)},expression:"form.location"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"title"}},[_vm._v("Title")]),_vm._v(" "),_c('el-input',{attrs:{"placeholder":"ARNERGY 5000 - ENERGY AS A SERVICE SUBSCRIPTION","id":"title"},model:{value:(_vm.form.title),callback:function ($$v) {_vm.$set(_vm.form, "title", $$v)},expression:"form.title"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("Description")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"Design, Installation, Commissioning and Managed Service of a 4.5kWp Solar PV System with 10.8kWh Lithium-ion battery Storage","id":"description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex","flex-flow":"row"}},[_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-right":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("Contact Address")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"No 5, Apabio Str, Lagos, Nigeria","id":"address"},model:{value:(_vm.form.user.address),callback:function ($$v) {_vm.$set(_vm.form.user, "address", $$v)},expression:"form.user.address"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"display":"flex: flex-flow: column","width":"45%","margin-left":"5%"}},[_c('label',{staticStyle:{"text-align":"left","padding":"0"},attrs:{"for":"description"}},[_vm._v("CC Emails")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","rows":2,"placeholder":"me@arnergy.com, you@arnergy.com","id":"ccEmails"},model:{value:(_vm.form.user.ccEmails),callback:function ($$v) {_vm.$set(_vm.form.user, "ccEmails", $$v)},expression:"form.user.ccEmails"}})],1)]),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"btn btn-primary mb-2",attrs:{"disabled":_vm.loading,"type":"submit"},on:{"click":_vm.edit}},[_vm._v("\n              "+_vm._s(_vm.loadingEdit ? "Loading..." : "Edit")+"\n            ")]),_vm._v("\n               \n            "),_vm._v(" "),_c('button',{staticClass:"btn btn-primary mb-2",attrs:{"type":"submit"},on:{"click":_vm.preview}},[_vm._v("\n              "+_vm._s(_vm.previewLoading ? "Loading..." : "Preview")+"\n            ")]),_vm._v("\n               \n            "),_c('button',{staticClass:"btn btn-danger mb-2",attrs:{"disabled":_vm.loading,"type":"submit"},on:{"click":_vm.deleteSub}},[_vm._v("\n              "+_vm._s(_vm.loadingDel ? "Loading..." : "Delete")+"\n            ")])])])])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('Add',{attrs:{"toggleAdd":_vm.toggleAdd,"installationList":_vm.installationList,"addOffCanvas":_vm.addOffCanvas,"getSubs":_vm.getSubs}}),_vm._v(" "),_c('Edit',{attrs:{"toggleEdit":_vm.toggleEdit,"installationList":_vm.installationList,"editOffCanvas":_vm.editOffCanvas,"getSubs":_vm.getSubs,"form":_vm.form}}),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"create","a":"subsmanager"}},[_c('div',{staticClass:"flex",staticStyle:{"display":"flex","flex-flow":"row-reverse"}},[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":_vm.toggleAdd}},[_vm._v("Add")]),_vm._v(" \n              ")],1)]),_vm._v(" "),_c('div',[_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.subs,"row-style-class":_vm.rowStyleClassFn,"select-options":{
                  enabled: true,
                  selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                  selectionInfoClass: 'custom-class',
                  selectionText: 'rows selected',
                  clearSelectionText: 'clear',
                  disableSelectInfo: true, // disable the select info panel on top
                  selectAllByGroup: true // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
                }},on:{"on-selected-rows-change":_vm.selectionChanged,"on-row-click":_vm.onRowClick}})],1)])],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Subscription Management")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d676ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2735);
function injectStyle (ssrContext) {
  __webpack_require__(2734)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04d676ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d676ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2734 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticStyle:{"display":"flex","align-content":"center","text-align":"left","margin-left":"auto","border":"1pt black dotted","margin-right":"auto","width":"80%","background":"#fff","padding-left":"5%","padding-right":"5%"}},[_c('div',{staticClass:"col-sm-12"},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.form.invoiceType == "initial" ? "Send Invoice" : "Create Request")+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"customer-invoice","placeholder":"--Customer Type--"},on:{"change":_vm.changeContact},model:{value:(_vm.form.invoiceType),callback:function ($$v) {_vm.$set(_vm.form, "invoiceType", $$v)},expression:"form.invoiceType"}},[_c('el-option',{attrs:{"label":"New","value":"initial"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Existing","value":"existing"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Owner"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Industry sector"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"sector-select","fetch-suggestions":_vm.sectorSearch,"placeholder":"Select sector","prefix-icon":"el-icon-suitcase"},on:{"select":_vm.sectorSelected},model:{value:(_vm.form.sector),callback:function ($$v) {_vm.$set(_vm.form, "sector", $$v)},expression:"form.sector"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.deviceRequest.installationName),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "installationName", $$v)},expression:"regDataParams.deviceRequest.installationName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Date"}},[_c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"type":"datetimerange","range-separator":"-","start-placeholder":"Start date","end-placeholder":"End date","align":"center"},model:{value:(_vm.regDataParams.deviceRequest.filterDate),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "filterDate", $$v)},expression:"regDataParams.deviceRequest.filterDate"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Address"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.address),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "address", $$v)},expression:"regDataParams.deviceRequest.address"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Proposed Location"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.proposedLocation),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "proposedLocation", $$v)},expression:"regDataParams.deviceRequest.proposedLocation"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Package"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Package"},on:{"change":_vm.packageSelected},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}},_vm._l((_vm.systemTypes),function(item,index){return _c('el-option',{key:((item.id) + "_package_" + index),staticStyle:{"height":"55px"},attrs:{"label":item.name,"value":item.id}},[_c('h4',{staticStyle:{"float":"left","margin":"0px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#8492a6","font-size":"13px","line-height":"20px"}},[_vm._v(_vm._s(item.description))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"System Capacity(KW)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","min":5,"max":1000},model:{value:(_vm.regDataParams.deviceRequest.systemCapacity),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "systemCapacity", $$v)},expression:"regDataParams.deviceRequest.systemCapacity"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Payment Model"}},[_c('el-radio-group',{on:{"change":_vm.calculatePayment},model:{value:(_vm.regDataParams.deviceRequest.paymentModel),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "paymentModel", $$v)},expression:"regDataParams.deviceRequest.paymentModel"}},[_c('el-radio',{attrs:{"label":"OS"}},[_vm._v("OS")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"LO"}},[_vm._v("LO")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"ES"}},[_vm._v("ES")])],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":""}},[(_vm.regDataParams.deviceRequest.paymentModel == "OS")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Base price(₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.amount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "amount", $$v)},expression:"regDataParams.deviceRequest.priceModel.amount"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "ES")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e()]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"VAT"}},[_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},on:{"change":_vm.calculatePayment},model:{value:(_vm.regDataParams.deviceRequest.priceModel.orderVat),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "orderVat", $$v)},expression:"regDataParams.deviceRequest.priceModel.orderVat"}},[_c('el-option',{key:"7_5_item_vat_list",attrs:{"label":"7.5%","value":7.5}}),_vm._v(" "),_c('el-option',{key:"0_0_item_vat_list",attrs:{"label":"0.0%","value":0.0}})],1)],1),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Discount"}},[(_vm.discountType == "percent")?_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},on:{"change":_vm.calculatePayment},model:{value:(_vm.regDataParams.deviceRequest.orderDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "orderDiscount", $$v)},expression:"regDataParams.deviceRequest.orderDiscount"}},_vm._l((101),function(item){return _c('el-option',{key:("discoutnt_" + item + "_item_list"),attrs:{"label":item - 1 + '%',"value":item - 1}})}),1):_c('el-input-number',{staticStyle:{"width":"180px"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.amountDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "amountDiscount", $$v)},expression:"regDataParams.deviceRequest.amountDiscount"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Title"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.title),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "title", $$v)},expression:"regDataParams.deviceRequest.title"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.comment),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "comment", $$v)},expression:"regDataParams.deviceRequest.comment"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Terms"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.term),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "term", $$v)},expression:"regDataParams.deviceRequest.term"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send Invoice")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"active-text":"Send Invoice","inactive-text":"Don't send Invoice"},model:{value:(_vm.regDataParams.deviceRequest.sendMail),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "sendMail", $$v)},expression:"regDataParams.deviceRequest.sendMail"}})],1),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","width":"100%"}},[_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary","disabled":_vm.loading},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__ = __webpack_require__(1112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d869eb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__ = __webpack_require__(2748);
function injectStyle (ssrContext) {
  __webpack_require__(2737)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d869eb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d869eb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2737 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('header',{staticClass:"header"},[_c('div',[(_vm.icon)?_c('span',{staticClass:"icon"},[_c('i',{class:'fa ' + _vm.icon,staticStyle:{"font-size":"16px"}})]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.iconLabel))])]),_vm._v(" "),(_vm.voltage)?_c('div',{style:('color:' + _vm.color)},[_vm._v(_vm._s(_vm.voltage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"body",style:('color:' + _vm.color)},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('footer',{staticClass:"footer"},[_vm._v("\r\n    "+_vm._s(_vm.current)+"\r\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2740 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"body"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.leftText))]),_vm._v(" "),_c('span',{staticClass:"text-center"},[_vm._v("0")]),_vm._v(" "),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.rightText))]),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header"},[_c('div',[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-train",staticStyle:{"font-size":"16px"}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"left-bar"},[_c('div',{staticClass:"child",staticStyle:{"width":"30%"}})]),_vm._v(" "),_c('div',{staticClass:"right-bar"},[_c('div',{staticClass:"child"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('header',{staticClass:"header"},[_c('i',{staticClass:"fa fa-globe",staticStyle:{"font-size":"16px"}})]),_vm._v(" "),_c('div',{staticClass:"main"},[_c('div',{staticClass:"flex"},[_c('i',{staticClass:"fa fa-globe",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('p',{staticClass:"flex-grow ml-2"},[_vm._v("Installed Capacity")]),_vm._v(" "),_c('p',[_vm._v("0.76")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('i',{staticClass:"fa fa-globe",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('p',{staticClass:"flex-grow ml-2"},[_vm._v("MWH of Energy generated:")]),_vm._v(" "),_c('p',[_vm._v("\n        49\n      ")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('i',{staticClass:"fa fa-globe",staticStyle:{"font-size":"16px"}}),_vm._v(" "),_c('p',{staticClass:"flex-grow ml-2"},[_vm._v("MWH of Energy consumed:")]),_vm._v(" "),_c('p',[_vm._v("0.76")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"echarts"},[_c('IEcharts',{attrs:{"option":_vm.line,"loading":_vm.loading},on:{"ready":_vm.onReady,"click":_vm.onClick}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('el-date-picker',{attrs:{"type":"datetimerange","picker-options":_vm.pickerOptions,"range-separator":"-","start-placeholder":"Start date","end-placeholder":"End date","align":"center"},on:{"change":_vm.filterChanged},model:{value:(_vm.filterDate),callback:function ($$v) {_vm.filterDate=$$v},expression:"filterDate"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"content no-top-padding header-area"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("Device Charts")]),_vm._v(" "),_c('custom-date-picker',{attrs:{"callback-func":_vm.handleOnChartReady}})],1),_vm._v(" "),_c('div',{staticClass:"chart-section"},[_c('custom-pie-chart',{attrs:{"loading":_vm.loadingChartData,"data":_vm.pieChart},on:{"onReady":_vm.handleOnChartReady}})],1),_vm._v(" "),_c('custom-chart',{attrs:{"loading":_vm.loadingChartData,"data":_vm.batteryData},on:{"onReady":_vm.handleOnChartReady}})],1),_vm._v(" "),_c('div',{staticClass:"footer-area"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"chart-section"},[_c('custom-chart',{attrs:{"loading":_vm.loadingChartData,"data":_vm.inverterData},on:{"onReady":_vm.handleOnChartReady}})],1),_vm._v(" "),_c('div',{staticClass:"chart-section"},[_c('custom-chart',{attrs:{"loading":_vm.loadingChartData,"data":_vm.energyData},on:{"onReady":_vm.handleOnChartReady}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pie_vue__ = __webpack_require__(1118);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f08e719_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pie_vue__ = __webpack_require__(2751);
function injectStyle (ssrContext) {
  __webpack_require__(2750)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f08e719"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pie_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f08e719_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pie_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"footer-area"},[_c('div',{staticClass:"content pie-charts"},[_c('div',[_c('custom-pie-chart',{attrs:{"loading":_vm.loadingChartData,"data":_vm.powerAvailability},on:{"onReady":_vm.handleOnChartReady}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content no-top-padding header-area"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v("Device Doughnot Charts")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_summary_vue__ = __webpack_require__(1119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f66f2d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_summary_vue__ = __webpack_require__(2754);
function injectStyle (ssrContext) {
  __webpack_require__(2753)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21f66f2d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_summary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21f66f2d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_summary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"no-top-padding header-area"},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"top-widget-box performance",staticStyle:{"display":"flex","flex-flow":"row wrap","justify-content":"space-between","align-items":"center","padding":"16px 17px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"top-widget-box__header",staticStyle:{"display":"flex","flex-flow":"column wrap"}},[_c('span',{staticClass:"stats_header_ _title"},[_vm._v("Total Devices")]),_vm._v(" "),_c('h1',{staticStyle:{"margin":"2px"}},[_vm._v(_vm._s(_vm.filteredAllDevices.length))])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-sm-12 col-xs-12 mb-5",staticStyle:{"margin-bottom":"12px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Online Devices")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.filteredOnlineDevices.length))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("Connected to the internet")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth",staticStyle:{"height":"90%"}},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Offline Devices")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.filteredOffLineDevices.length))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("Not connected to the internet")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth"},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Devices with alarm")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.filteredAlarmDevices.length))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("With alarm notifications")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-xl-3 col-lg-3 col-md-6 col-sm-12 col-xs-12"},[_c('div',{staticClass:"widget widget-alpha widget-alpha--color-amaranth"},[_c('div',{staticClass:"top-widget-box performance"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"top-widget-box__body"},[_c('span',{staticClass:"stats_header__title"},[_vm._v("Critical Systems")]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.criticalSystems.length))]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v(" ")]),_vm._v(" "),_c('p',{staticClass:"top-subtitle"},[_vm._v("With Inverter not detected error")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"footer-area col-md-12 col-sm-12 col-xs-12 mb-5"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"grid grid-1"},[_c('custom-box',{attrs:{"value":"35W","title":"Devices","icon":"fa-calendar-plus-o ","iconLabel":"25C","color":"#4790d0"}}),_vm._v(" "),_c('custom-box',{attrs:{"value":"0W","title":"Unavailable","icon":"fa-hourglass-end","color":"#f7ab3e"}}),_vm._v(" "),_c('custom-box',{attrs:{"value":"0W","title":"Available","icon":"fa-hourglass-end","color":"#72b84ce6"}})],1),_vm._v(" "),_c('div',{staticClass:"grid grid-2"},[_c('custom-box',{attrs:{"value":"100.0%","title":"Error","icon":"fa-battery-quarter ","iconLabel":"Idle","voltage":"53.99V","color":"#fa716f","current":"1.40A"}}),_vm._v(" "),_c('custom-geo-box',{attrs:{"value":"100.0%","title":"Energy Generated"}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__body"},[_c('h1',[_vm._v("Dashboard Summary")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-wifi fa-4x icon",staticStyle:{"color":"#2ED47A"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-ban fa-4x icon",staticStyle:{"color":"#e74c3c"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-exclamation fa-4x icon",attrs:{"aria-hidden":"true"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-widget-box__header"},[_c('i',{staticClass:"fa fa-exclamation-circle fa-4x icon",staticStyle:{"color":"#e74c3c"},attrs:{"aria-hidden":"true"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1d45898_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2762);
function injectStyle (ssrContext) {
  __webpack_require__(2756)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f1d45898"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1d45898_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2756 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2757 */,
/* 2758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2759 */,
/* 2760 */,
/* 2761 */,
/* 2762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"summaries"},[_c('div',{staticClass:"summary green-icon"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-box"},[_c('p',{staticClass:"data-title"},[_vm._v("\n          "+_vm._s(_vm.deviceCount > 1 ? "Devices" : "Device")+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"data-num"},[_vm._v("\n          "+_vm._s(_vm.deviceCount)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"summary yellow-icon"},[_c('router-link',{attrs:{"to":("/users/edit/" + (this.getUserSession.id))}},[_c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons"},[_vm._v("layers")])])]),_vm._v(" "),_c('div',{staticClass:"text-box"},[_c('p',{staticClass:"data-title"},[_vm._v("Invoices")]),_vm._v(" "),_c('p',{staticClass:"data-num"},[_vm._v(_vm._s(_vm.invoiceCount))])])],1),_vm._v(" "),_c('div',{staticClass:"summary blue-icon"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"text-box"},[_c('p',{staticClass:"data-title"},[_vm._v("Warning")]),_vm._v(" "),_c('p',{staticClass:"data-num"},[_vm._v(_vm._s(_vm.warningCount))])])]),_vm._v(" "),_c('div',{staticClass:"summary red-box"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"text-box"},[_c('p',{staticClass:"data-title"},[_vm._v("Critical Devices")]),_vm._v(" "),_c('p',{staticClass:"data-num"},[_vm._v(_vm._s(_vm.criticalWarningCount))])])])]),_vm._v(" "),_c('div',{staticClass:"chart-map"},[_c('div',{staticClass:"geo-chart"},[_c('div',{staticClass:"select-device"},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"active-device","placeholder":"Choose Device"},on:{"change":function($event){return _vm.changeActiveDevice(_vm.activeDevice)}},model:{value:(_vm.activeDevice),callback:function ($$v) {_vm.activeDevice=$$v},expression:"activeDevice"}},_vm._l((_vm.devices),function(device,key){return _c('el-option',{key:key,attrs:{"label":("Device " + device),"value":device}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"device-expiry"},[_c('div',{staticClass:"device-details"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"expiry-details"},[_c('p',[_vm._v("Expiry Date")]),_vm._v(" "),_c('p',{staticClass:"expiry"},[_vm._v(_vm._s(_vm.deviceExpiry ? _vm.deviceExpiry : "---"))])])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"chart-control"},[(_vm.chartData)?_c('div',{staticClass:"shuffle-type"},[_c('p',{class:_vm.getClass('temperature'),on:{"click":function($event){return _vm.changeActiveDevice(_vm.activeDevice, 'temperature')}}},[_vm._v("\n            Temperature\n          ")]),_vm._v(" "),_c('p',{class:_vm.getClass('humidity'),on:{"click":function($event){return _vm.changeActiveDevice(_vm.activeDevice, 'humidity')}}},[_vm._v("\n            Humidity\n          ")])]):_vm._e(),_vm._v(" "),(_vm.chartData)?_c('line-chart',{attrs:{"chartdata":_vm.chartData,"options":_vm.options}}):_vm._e(),_vm._v(" "),_c('div',[_c('div',[(_vm.loadingChartData)?_c('p',{staticClass:"process"},[_c('a-spin',{attrs:{"size":"large","tip":"Loading..."}})],1):_vm._e()]),_vm._v(" "),(_vm.emptyChart && !_vm.loadingChartData)?_c('p',{staticClass:"loading-chart"},[_vm._v("\n            Data unavailable for this device. Please try again or choose\n            another device\n          ")]):_vm._e()])],1)]),_vm._v(" "),_c('GmapMap',{ref:"map",staticClass:"map-box",attrs:{"zoom":_vm.zoom,"center":_vm.center,"map-type-id":"terrain"}},_vm._l((_vm.markers),function(marker,index){return _c('GmapMarker',{key:index,attrs:{"position":marker.latLng,"title":marker.name,"clickable":true},on:{"click":_vm.log}})}),1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons material-icons-outlined"},[_vm._v("devices")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons material-icons-outlined"},[_vm._v("error_outline")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons material-icons-outlined"},[_vm._v("error_outline")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons"},[_vm._v("event")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-image"},[_c('img',{attrs:{"src":__webpack_require__(2763),"alt":"Blue box"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Arnergy-5000.5f3b926.jpeg";

/***/ }),
/* 2764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1123);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f526dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2766);
function injectStyle (ssrContext) {
  __webpack_require__(2765)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31f526dd"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31f526dd_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2765 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('p',{staticClass:"page-headliner"},[_vm._v("\n    Showing "+_vm._s(_vm.notificationList.length)+" notifications |\n    "+_vm._s(_vm.getNotificationsCount())+" unread\n  ")]),_vm._v(" "),_c('div',{staticClass:"notifications"},[(_vm.notificationList.length == 0)?_c('div',[_vm._v("You have 0 Notifications")]):_vm._e(),_vm._v(" "),_vm._l((_vm.notificationList),function(notify,index){return _c('div',{key:index,staticClass:"notification"},[_c('div',{staticClass:"content-type",on:{"click":function($event){return _vm.readMessage(notify.id)}}},[_c('p',{staticClass:"read-status",class:{ unread: notify.read === false }}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"content-details",on:{"click":function($event){return _vm.readMessage(notify.id)}}},[_c('p',{staticClass:"date"},[_vm._v(_vm._s(notify.date))]),_vm._v(" "),_c('p',{staticClass:"message"},[_vm._v(_vm._s(notify.message))]),_vm._v(" "),_c('p',{staticClass:"action"},[_vm._v(_vm._s(notify.action))])]),_vm._v(" "),_c('span',{staticClass:"material-icons close-button",on:{"click":function($event){return _vm.deleteNotification(notify.id)}}},[_vm._v("\n        close\n      ")])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons"},[_vm._v(" event ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1124);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2611ca93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2772);
function injectStyle (ssrContext) {
  __webpack_require__(2768)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2611ca93"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2611ca93_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2768 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__ = __webpack_require__(1125);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5056f536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__ = __webpack_require__(2771);
function injectStyle (ssrContext) {
  __webpack_require__(2770)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5056f536"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5056f536_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container alarm-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_vm._v("loading, please wait...")]):_c('vue-good-table',{attrs:{"columns":_vm.tableOptions,"search-options":{
        enabled: false,
        externalQuery: _vm.searchTerm
      },"sort-options":{
        enabled: true,
        initialSortBy: { field: 'startTime', type: 'desc' }
      },"rows":_vm.list,"pagination-options":{ enabled: false },"line-numbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('div',[(props.column.field == 'name')?_c('span',[_vm._v(_vm._s(props.row["name"] ? props.row["name"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v(_vm._s(props.row["deviceId"] ? props.row["deviceId"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'fault')?_c('span',[_vm._v(_vm._s(props.row["fault"] ? props.row["fault"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'severity')?_c('span',{class:props.row['severity'] == 'Minor'
                ? 'badge badge-dark'
                : props.row['severity'] == 'Major'
                ? 'badge badge-warning'
                : 'badge badge-warning'},[_vm._v(_vm._s(props.row["severity"] ? props.row["severity"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',{class:props.row['status'] == 'RESOLVED'
                ? 'statusLabel badge badge-success'
                : 'statusLabel badge badge-danger'},[_vm._v(_vm._s(props.row["status"] ? props.row["status"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'startTime')?_c('span',[_vm._v(_vm._s(props.row["startTime"] ? props.row["startTime"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'endTime')?_c('span',[_vm._v(_vm._s(props.row["endTime"] ? props.row["endTime"] : "--"))]):_vm._e()])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":100}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":_vm.hideOffCanvasFunc}}),_vm._v(" "),_c('h3',[_vm._v("Warning Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.warningItem != null),expression:"warningItem != null"}]},[_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" DeviceID ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.DeviceID))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Name ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.installation.name))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" StartTime ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.StartTime))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" EndTime ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.EndTime))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Fault ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Fault))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Severity ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Severity))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Status ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Status))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',[_c('Warnings',{on:{"showOffCanvas":_vm.showOffCanvasFunc,"onRowClick":_vm.openWarningInfo}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Alarms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index2_vue__ = __webpack_require__(1126);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b4fc17_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index2_vue__ = __webpack_require__(2778);
function injectStyle (ssrContext) {
  __webpack_require__(2774)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57b4fc17"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57b4fc17_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warnings2_vue__ = __webpack_require__(1127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0baad16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warnings2_vue__ = __webpack_require__(2777);
function injectStyle (ssrContext) {
  __webpack_require__(2776)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b0baad16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Warnings2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0baad16_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Warnings2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container alarm-table-height"},[_c('div',{staticStyle:{"width":"100%"}},[(_vm.isLoading)?_c('div',{staticClass:"loading"},[_vm._v("loading, please wait...")]):_c('div',[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"filter_search"},[_c('h3',{staticClass:"pagin_style"},[_vm._v("\n            Showing\n            "+_vm._s(_vm.paginationInfo.total > 0
                ? ((_vm.paginationInfo.first) + " - " + (_vm.paginationInfo.last) + "\n                  " + (_vm.paginationInfo.ofText) + " " + (_vm.paginationInfo.total) + " " + (_vm.paginationInfo.total > 1 ? "Devices" : "Device"))
                : "no device")+"\n          ")]),_vm._v(" "),_c('el-input',{staticClass:"el-input el-input--prefix",staticStyle:{"width":"30%"},attrs:{"placeholder":"Enter Name or Device ID","prefix-icon":"el-icon-search","clearable":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_vm._v(" "),_c('div',{staticClass:"filter_button"},[_c('p',{staticClass:"dropbtn",staticStyle:{"position":"relative"},on:{"click":_vm.toggleDropdown}},[_vm._m(0),_vm._v("\n            Filter\n            "),_vm._m(1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDropDownData),expression:"showDropDownData"}],staticClass:"dropContent"},[_c('p',{staticStyle:{"font-weight":"600","font-size":"14px","color":"orange","margin-bottom":"0px !important"}},[_vm._v("\n              SEVERITY\n            ")]),_vm._v(" "),_c('p',{staticClass:"radios"},[_c('label',{attrs:{"for":"Minor"}},[_vm._v("Minor")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeverity),expression:"selectedSeverity"}],attrs:{"type":"radio","id":"Minor","name":"Severity","value":"minor"},domProps:{"checked":_vm._q(_vm.selectedSeverity,"minor")},on:{"change":function($event){_vm.selectedSeverity="minor"}}})]),_vm._v(" "),_c('p',{staticClass:"radios"},[_c('label',{attrs:{"for":"Major"}},[_vm._v("Major")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeverity),expression:"selectedSeverity"}],attrs:{"type":"radio","id":"Major","name":"Severity","value":"major"},domProps:{"checked":_vm._q(_vm.selectedSeverity,"major")},on:{"change":function($event){_vm.selectedSeverity="major"}}})]),_vm._v(" "),_c('p',{staticClass:"radios"},[_c('label',{attrs:{"for":"Critical"}},[_vm._v("Critical")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSeverity),expression:"selectedSeverity"}],attrs:{"type":"radio","id":"Critical","name":"Severity","value":"critical"},domProps:{"checked":_vm._q(_vm.selectedSeverity,"critical")},on:{"change":function($event){_vm.selectedSeverity="critical"}}})]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"600","font-size":"14px","color":"orange","margin-bottom":"0px !important"}},[_vm._v("\n              STATUS\n            ")]),_vm._v(" "),_c('p',{staticClass:"radios"},[_c('label',{attrs:{"for":"Open"}},[_vm._v("Open")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatus),expression:"selectedStatus"}],attrs:{"type":"radio","id":"Open","name":"Status","value":"open"},domProps:{"checked":_vm._q(_vm.selectedStatus,"open")},on:{"change":function($event){_vm.selectedStatus="open"}}})]),_vm._v(" "),_c('p',{staticClass:"radios"},[_c('label',{attrs:{"for":"Resolved"}},[_vm._v("Resolved")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatus),expression:"selectedStatus"}],attrs:{"type":"radio","id":"Resolved","name":"Status","value":"resolved"},domProps:{"checked":_vm._q(_vm.selectedStatus,"resolved")},on:{"change":function($event){_vm.selectedStatus="resolved"}}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.toggleDropdownOff}},[_vm._v("\n                  Cancel\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.filterDataByFilt}},[_vm._v("\n                  Apply\n                ")])])])])])]),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.tableOptions,"rows":_vm.list,"search-options":{
          skipDiacritics: true,
          enabled: true,
          searchFn: _vm.searchTable,
          externalQuery: _vm.searchTerm
        },"pagination-options":{
          enabled: true,
          perPage: 50
        },"sort-options":{
          enabled: true,
          initialSortBy: { field: 'name', type: 'asc' }
        }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('div',[(props.column.field == 'name')?_c('span',[_vm._v(_vm._s(props.row["name"] ? props.row["name"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v(_vm._s(props.row["deviceId"] ? props.row["deviceId"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'fault')?_c('span',[_vm._v(_vm._s(props.row["fault"] ? props.row["fault"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'severity')?_c('span',{class:props.row['severity'] == 'Minor'
                  ? 'badge badge-dark'
                  : props.row['severity'] == 'Major'
                  ? 'badge badge-warning'
                  : 'badge badge-warning'},[_vm._v(_vm._s(props.row["severity"] ? props.row["severity"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',{class:props.row['status'] == 'RESOLVED'
                  ? 'statusLabel badge badge-success'
                  : 'statusLabel badge badge-danger',on:{"click":function($event){return _vm.resolveFunction(props.row['deviceId'], props.row['status'])}}},[_vm._v(_vm._s(props.row["status"] ? props.row["status"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'startTime && endTime')?_c('span',[_vm._v(_vm._s(props.row["startTime"]
                  ? props.row["startTime"].replace(/(?:^|\s)\S/g, function(
                      a
                    ) {
                      return a.toUpperCase();
                    })
                  : "--")),_c('br'),_vm._v("\n              "+_vm._s(props.row["endTime"]
                  ? props.row["endTime"].replace(/(?:^|\s)\S/g, function(a) {
                      return a.toUpperCase();
                    })
                  : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'resolutionTime')?_c('span',[_vm._v(_vm._s(_vm.dateFormatter(props.row.endTime, props.row.startTime)))]):_vm._e()])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged},on:{"paginated-info":function($event){_vm.paginationInfo = $event}}})]}}])})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fas fa-filter",staticStyle:{"font-size":"20px","margin-left":"10px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"position":"absolute","right":"18px"}},[_c('i',{staticClass:"fa fa-caret-down"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',[_c('Warnings2')],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Alarms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9d1468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2784);
function injectStyle (ssrContext) {
  __webpack_require__(2780)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2f9d1468"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2f9d1468_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2780 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__ = __webpack_require__(1129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75748d26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__ = __webpack_require__(2783);
function injectStyle (ssrContext) {
  __webpack_require__(2782)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75748d26"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_warnings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75748d26_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_warnings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_vm._v("\n=======\n      ")]),_vm._v("\n>>>>>>> 30b8af42757d5bdcc94ece35320f6e4c3c8bc6dc\n\n      "),(_vm.isLoading)?_c('p',{staticClass:"process"},[_c('a-spin',{attrs:{"size":"large","tip":"Loading..."}})],1):_c('vue-good-table',{attrs:{"columns":_vm.tableOptions,"search-options":{
          enabled: false,
          externalQuery: _vm.searchTerm
        },"sort-options":{
          enabled: true,
          initialSortBy: { field: 'startTime', type: 'desc' }
        },"rows":_vm.list,"pagination-options":{ enabled: false },"line-numbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('div',[(props.column.field == 'name')?_c('span',[_vm._v(_vm._s(props.row["name"] ? props.row["name"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v(_vm._s(props.row["deviceId"] ? props.row["deviceId"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'fault')?_c('span',[_vm._v(_vm._s(props.row["fault"] ? props.row["fault"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'severity')?_c('span',{class:props.row['severity'] == 'Minor'
                  ? 'badge badge-dark'
                  : props.row['severity'] == 'Major'
                  ? 'badge badge-warning'
                  : 'badge badge-warning'},[_vm._v(_vm._s(props.row["severity"] ? props.row["severity"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',{class:props.row['status'] == 'RESOLVED'
                  ? 'statusLabel badge badge-success'
                  : 'statusLabel badge badge-danger'},[_vm._v(_vm._s(props.row["status"] ? props.row["status"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'startTime')?_c('span',[_vm._v(_vm._s(props.row["startTime"] ? props.row["startTime"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'endTime')?_c('span',[_vm._v(_vm._s(props.row["endTime"] ? props.row["endTime"] : "--"))]):_vm._e()])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged,"perPage":100}})]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":_vm.hideOffCanvasFunc}}),_vm._v(" "),_c('h3',[_vm._v("Warning Info")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.warningItem != null),expression:"warningItem != null"}]},[_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" DeviceID ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.DeviceID))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Name ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.installation.name))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" StartTime ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.StartTime))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" EndTime ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.EndTime))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Fault ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Fault))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Severity ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Severity))])]),_vm._v(" "),_c('div',{staticClass:"inverterInfo"},[_c('b',[_vm._v(" Status ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.warningItem && _vm.warningItem.Status))])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',[_c('Warnings',{on:{"showOffCanvas":_vm.showOffCanvasFunc,"onRowClick":_vm.openWarningInfo}})],1)])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Alarms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8dec2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2830);
function injectStyle (ssrContext) {
  __webpack_require__(2786)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b8dec2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8dec2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonOnboardingPackage_vue__ = __webpack_require__(1131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6780e661_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonOnboardingPackage_vue__ = __webpack_require__(2808);
function injectStyle (ssrContext) {
  __webpack_require__(2788)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6780e661"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ButtonOnboardingPackage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6780e661_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ButtonOnboardingPackage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComponent_vue__ = __webpack_require__(1132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08926016_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComponent_vue__ = __webpack_require__(2797);
function injectStyle (ssrContext) {
  __webpack_require__(2790)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08926016"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08926016_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),_c('input',{staticClass:"input",attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"required":"","disabled":_vm.disabled,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.model},on:{"input":_vm.handleInput}}),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('select',{staticClass:"select-input",attrs:{"name":"selectInput"},domProps:{"value":_vm.value},on:{"change":_vm.handleInput}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.items),function(item,key){return _c('option',{key:key,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2):_c('p',[_vm._v("No items found")]),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{},[_c('div',{},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-headerxx"}),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('h2',{staticClass:"text-center"},[_vm._v("\n                  ARNERGY GENERAL TERMS AND CONDITIONS FOR LEASE TO OWN SOLAR POWER SYSTEM SERVICES\n                ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                  In these terms and conditions (the “Terms”), “Arnergy” means Arnergy Solar Limited and the “Consumer”\nmeans you the Consumer. Arnergy and the Consumer are also individually referred to as a Party and\ncollectively referred to as the Parties. Please read the following terms before proceeding with your payment.\nBy clicking register, the Consumer agrees to be bound by these Terms and the Terms contained herein and any\nterms made available via a hyperlink shall constitute a lease to own agreement between Arnergy and the\nConsumer. By choosing to purchase an Arnergy solar power system under the lease-to-own model, the\nConsumer agrees to provide the required documentation for Arnergy’s customer onboarding requirements\nand credit check process and the Consumer agrees to be bound by these Terms.\n                ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                  Be rest assured that all information provided is treated as confidential. See clause 11 (Confidentiality).\nArnergy reserves the right to modify these Terms at any time. Arnergy shall provide the Consumer with notice\nof the modifications via email communication at least five (5) days before the date they become effective.\n                ")]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                    1. DEFINITIONS AND INTERPRETATION\n                  ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      1.1 In these Terms, unless the context otherwise admits or requires, the following expressions\n                      shall have the meanings set against them:\n                      ")]),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Terms means this Solar System Lease Terms and Conditions;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Applicable Law means all laws in force and effect as of the date hereof and which may be\nenacted or brought into force and effect hereinafter in Nigeria, including statutes, rules,\nregulations, directions, bye-laws, notifications, ordinances and judgments having force of law,\nor any final interpretation by a court of law having jurisdiction over the matter in question as\nmay be in force and effect during the subsistence of these Terms;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Business Day means a day other than a Saturday or Sunday on which banks are ordinarily\nopen for the transaction of normal banking business in the Federal Republic of Nigeria;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Confidential Information means information of commercial value, in whatever form or\nmedium, which has been kept confidential by the Party from whom the information\noriginates and which has not come into the public domain during the term of these Terms in\nbreach of any obligation of confidence, including information relating to the applications,\nsoftware, or any of its constituent parts, the source codes, commercial or technical\nknow-how, technology, information pertaining to business operations and strategies, and\ninformation pertaining to customers and pricing;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Effective Date means the date the System is switched on and installed at the Consumer’s\nLocation;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("IP Rights means patents, rights to inventions, copyright and related rights, trademarks and\nservice marks, trade and business names, rights in goodwill or to sue for passing off or unfair\ncompetition, rights in designs, patents and any other intellectual property rights, in each case\nwhether registered or unregistered and including all applications for, and renewals or\nextensions of, such rights and all similar or equivalent rights or forms of protection in any\npart of the world;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Lease Period means the agreed duration of the lease which commences from the Effective\nDate;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Location means the agreed address of the Consumer where the System is installed;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Purchase Option means the right of the Consumer to purchase the System at the end of the\nLease Period;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Rental Payments means the sum payable by the Consumer to Arnergy on a monthly basis\nduring the course of the Lease Period;")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("Services means the design, installation, commissioning and maintenance of the System at\nthe Location, and the provision of the solar power system services in accordance with these\nTerms; and")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("System means the solar power system, including the solar modules/panels (if applicable),\ninverter system, battery storage, remote monitoring technology and other accessories\nthereto.")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      1.2 Arnergy holds title to and ownership of the System for\n                      the duration of the lease period to be agreed between\n                      Arnergy and the Client.The headings and titles to the clause and paragraphs in these Terms, are inserted for\nconvenience only and shall not control or affect the construction, meaning or interpretation\nof any provision of these Terms.\n                    ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("2. COMMENCEMENT AND DURATION")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      The Lease Period shall commence on the Effective Date for the duration of the Lease Period unless\nand until terminated in accordance with clause 15.\n                    ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("3. NATURE OF THESE TERMS")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      Arnergy shall let the System, and the Consumer agrees to take it on a lease for use at the Location,\nsubject to these Terms.\n                    ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                    4. OWNERSHIP, DELIVERY AND RISK OF THE ARNERGY SYSTEM\n                  ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      4.1 Arnergy holds title to, and ownership of the System and all additional assets and equipment\ninstalled as part of the System in connection with the Services for the duration of the Lease\nPeriod.\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      4.2 Arnergy shall deliver the System to the Location. Upon the completion of the delivery and\ninstallation of the System, the Consumer shall provide Arnergy with an executed copy of the\ncertificate of acceptance and by doing so, the Consumer will be deemed to have\nacknowledged delivery of and accepted the System.\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      4.3 The Consumer shall ensure the reasonable safety of the physical security of the System from\nthe Effective Date. The Consumer shall exercise reasonable care in the use of the System in\nthe manner recommended by Arnergy.\n                    ")])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("5. CONSIDERATION & PAYMENTS")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.1 Prior to the installation date, the Consumer shall pay to Arnergy, an initial deposit and a\ncaution fee. The caution fee shall be applied to the last month of the Lease Period provided\nthat there are no sums owed to Arnergy prior to the last month of the Lease Period.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.2 The Consumer shall pay to Arnergy, in respect of the Lease Period, the Rental Payments. The\nConsumer will not claim capital allowances on the System during the Lease Period.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.3 The Services are provided on a pre-paid basis. Arnergy shall invoice the Consumer for the\nRental Payment in advance for the Services to be provided in the following month.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.4 The Services shall be activated by Arnergy where the Consumer has made the requisite\nmonthly pre- payment for a relevant month.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.5 We may review the monthly payments subject to prevailing market conditions. Arnergy shall\npromptly notify the Consumer in such instances and appropriate changes shall be made\nimmediately and become binding on the Consumer.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.6 The Rental Payments shall be non-refundable and payable in advance for each month that\nthe System is at the Location, regardless of whether the solar power was consumed or not\nconsumed in any given month.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        5.7 The Consumer acknowledges that where payments fall due on a day which is not a business\nday, such payments are to be made on the preceding business day.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      6. PURCHASE OPTION\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        The Parties agree that the Consumer shall have the automatic right to exercise the Purchase Option\nupon the expiration of the Lease Period PROVIDED THAT all outstanding payments and obligations\ndue to Arnergy from the Consumer under this lease have been discharged. The Consumer shall upon\nthe exercise of the Purchase Option have ownership of the System transferred from Arnergy to the\nConsumer. When the exercise of the Purchase Option has been completed in accordance with the\nterms of this clause 6, ownership and title to the System shall automatically pass to the Consumer\nwithout any further act or deed and in the condition and at the Location.\n                      ")])])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                    7. SCOPE OF WORK FOR THE INSTALLATION SERVICE\n                  ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      7.1 Arnergy’s installation scope of work includes the following:\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                      7.1.1 Installation of the solar panels on the roof or a location provided by the\nConsumer (where applicable);\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                      7.1.2 Installation of the bluebox at the Consumer’s preferred location which must be\nwell ventilated, covered from rainfall or water; and\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                      7.2 It is agreed and acknowledged that, Arnergy’s scope of work for the installation does not\ninclude the following:\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                      7.2.1 Rewiring of the Consumer's facility where the wiring architecture of the\nbuilding is a surface wiring; and\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                      7.2.2 Interconnection of multiple buildings where the buildings electrical wiring are\nnot interconnected.\n                    ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                      For the out of scope work set out above, the Consumer shall be responsible for the associated\nwork required for the successful completion of the installation and the fees.\n                    ")])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("8. MONITORING OF THE SYSTEM, POWER OVERLOAD AND SYSTEM REPAIRS")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.1 Arnergy and the Consumer shall have access to round the clock technology to monitor the\nSystem. This shall be at no additional cost to the Consumer.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.2 Arnergy shall conduct routine maintenance of the System quarterly and corrective\nmaintenance where required.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.3 The Consumer shall have no justification to withhold, omit, halt or delay making the required\nRental Payments where the Consumer failed or omitted to immediately notify Arnergy of the\nneed for a corrective maintenance or repair. The full monthly Rental Payment shall remain\ndue and payable by the Consumer in such instance.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.4 The Consumer authorises Arnergy and its designated personnel to have access to inspect the\nSystem where Arnergy has provided the 12 hours prior notice to the Consumer by SMS or\nemail ahead of maintenance inspections (between the hours of 9.00am-5.00pm).\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.5 Where the actual load on the System, as used by the Consumer, is in excess of the System’s\nspecified load capacity already agreed between the Consumer and Arnergy, this causes\ndisruptions to the System and affects the reliability. Where the Consumer intends to effect an\nincrease in its load requirement and System usage, it is the Consumer’s responsibility to\nnotify Arnergy promptly to avoid disruptions due to excess load. Arnergy will advise on any\nupgrades to the System that is required to give effect to the changes.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.6 Arnergy shall maintain and repair the System at no additional cost to the Consumer, unless\nthe damage to the System was caused by negligence or willful misconduct of the Consumer\nand/or its affiliates, in which case, the Consumer shall bear the cost for repair and replacing\nall worn and damaged parts of the System.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.7 Only authorised personnel of Arnergy are permitted to repair the System.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.8 Arnergy is committed to its environmental and sustainability objectives. Therefore, Arnergy\nmust be carried along on any disposal of any part of the System for proper disposal in\naccordance with generally accepted health and safety standards.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        8.9 Where any payment is required from the Consumer under clause 8.5 and 8.6, such cost shall\nform part of the Rental Payments and shall be prorated for the remainder of the Lease\nPeriod.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      9. OBLIGATIONS OF THE CONSUMER\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        9.1 The Consumer shall act reasonably and cooperate with Arnergy to enable Arnergy deliver\nand install the System in line with these Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        9.2 The Consumer shall provide a suitable space on the roof or cleared level land areas, free of\nany debris or other encumbrances for the System at the Location and ensure that the System\nbenefits from valid rights of use of all land and other easements necessary to install and\noperate the System at the Location during the Lease Period.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        9.3 The Consumer agrees that it shall not during the Lease Period modify, move, relocate,\nsub-lease, charge, mortgage, encumber by any means or tamper with or otherwise handle\nthe System without the express prior written consent of Arnergy.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        9.4 The Consumer shall take all reasonable measures necessary to prevent any damage to the\nSystem. This includes without limitation ensuring that the System is located in a vandalism-\nproof perimeter at the Location.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        9.5 Notwithstanding any other provision of these Terms, the Consumer shall be responsible for\nany damage, destruction or loss of the System attributable to the negligence, or willful\nmisconduct of the Consumer and the Consumer shall accordingly cause the System or\ndamaged part of the System to be rebuilt or replaced at its cost. While the System is being\nrebuilt or replaced, the Consumer’s obligation to make the Rental Payments shall continue in\nforce and effect.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("10. WARRANTIES")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        10.1 If the System is materially damaged or destroyed, or suffers any other material loss, or the\nuse thereof is otherwise diminished to render impracticable or unreasonable the continued\nproduction of energy, Arnergy shall repair or replace the System in the earliest practical date\nin accordance with these Terms. Provided that where the same is caused by negligence or\ndamage by the Consumer or any of its agents, such repair will be at the cost of the Consumer.\nWhere the Consumer’s operations are or are reasonably expected to be hindered by any such\ndamage or where there are any delays expected in repairing or replacing the System\ndepending on the extent of the damage, Arnergy shall promptly notify the Consumer and\nArnergy shall put a stop gap measure in place for provision of power until the repair or\nreplacement is concluded.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        10.2 Any stop gap used pending the replacement or repair of the System shall adequately serve\nthe same function of the System as provided herein.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        10.3 Arnergy warrants that the System is free from defects in materials and workmanship for a\nperiod of five (5) years from the Effective Date. This warranty shall not apply to an abuse,\ndamage, alteration or misuse of the System by the gross negligence or willful misconduct of\nthe Consumer.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      11. CONFIDENTIAL INFORMATION & PUBLICITY\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        11.1 Each Party shall safeguard, treat as confidential and not use for the purposes of its own\nbusiness any Confidential Information which relates to the business and affairs of either\nParty.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        11.2 Notwithstanding Clause 11.1, each Party may at any time disclose any Confidential\nInformation, following reasonable consultation with the other Party, if the disclosure is made\nin good faith in the circumstances set out below and, in each case, only to the extent\nreasonably necessary:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        11.2.1 if it is required by law, the terms of a grant, a court of competent jurisdiction or any\ngovernment or regulatory authority; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        11.2.2 to its own employees, directors or consultants where such disclosure is required for\nthe exercise of the relevant Party’s obligations under these Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        11.3 In the case of a company, the Consumer hereby grants Arnergy the right to use the name and\nservice marks of the Consumer in its marketing materials or other oral, electronic, or written\npromotions, which shall include naming the Consumer as a client of Arnergy and a brief\nscope of services provided. Either Party may elect to issue a press or social media\npromotional release related to this Agreement. In doing so, any release shall be approved by\nthe other Party and such approval shall not be unreasonably withheld.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      12. INDEMNIFICATION AND LIMITATION OF LIABILITY\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        12.1 Either Party (the \"Indemnifying Party\") shall indemnify and hold the other Party (the\n\"Indemnified Party\") harmless from and against any loss, damage, expense or liability\nincurred by the Indemnified Party as a consequence of a breach of the Indemnifying Party or\nits agents, employees, directors, officers, managers, members, of its obligations under these\nTerms. In the event that there are any third-party claims, losses, liabilities and costs caused\nby the Indemnifying Party’s breach/negligence, the Indemnifying Party shall be solely liable.\nIn the event that there is contributory liability on the part of the Indemnified Party and/or\nthe Indemnified Party is equally responsible for the liability, the consequence of the liability\nshall be shared equally in proportion to each Party’s relative degree of fault.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        12.2 Arnergy shall not be liable to the Consumer, whether in contract, tort (including negligence),\nbreach of statutory duty, or otherwise, for any loss of profit, or for any indirect or\nconsequential loss arising under or in connection with these Terms or the Consumer’s use of\nthe System.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        12.3 Under no circumstances will the aggregate liability of Arnergy or its affiliates arising out of\nor related to this Agreement, (including but not limited to warranty claims), regardless of the\nforum and regardless of whether any action or claim is based on contract, tort (including\nnegligence), strict liability, or any other legal or equitable theory, exceed the 3 months’ value\nof the Rental Payment. The foregoing limitations will not in any way limit the Consumer’s\npayment obligations under clause 5 above.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      13. DEFAULT\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.1 Should the Consumer fail to effect prompt payment of the Rental Payments and such other\namounts payable under these Terms, or where there is negligent or willful damage to the\nSystem by the Consumer, Arnergy may (without prejudice to other rights and remedies of\nArnergy) suspend part or all of the Services until payment has been made in full.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.2 Unauthorized tampering/hacking of the System by the Consumer is a breach of Arnergy’s\nlegal ownership of the System and any IP Rights of Arnergy. Arnergy reserves the right to\nimmediately decommission the System (and decommissioning fees shall be payable by the\nConsumer) and/or take legal action in such instances.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.3 Where an invoice remains unpaid for a period of thirty (30) days from the date of receipt of\nan invoice for payment, Arnergy reserves the right to report the default to the national credit\nbureau and Arnergy can also provide information required to the credit bureau with regards\nto these Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.4 Arnergy shall have the right to decommission the System from the Location in the below\ninstances:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        13.4.1 Willful or negligent damage to the System by the Consumer/and or its affiliates\nand the Consumer is reluctant to bear responsibility for repairs; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        13.4.2 Non-payment for a period of thirty (30) days from the date of receipt of an\ninvoice for payment; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        13.4.3 Unauthorized tampering/hacking of the System by the Consumer.; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        13.4.4 Complete abandonment of the System.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.5 The Consumer hereby authorises Arnergy and its designated personnel to have access and\nenter the Location to decommission the System in accordance with these Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.6 Where Arnergy is unable to take possession of the System in accordance with the provisions\nof clauses 13.4 and 13.5, the Consumer shall be liable to pay to Arnergy N500,000.00 as\ndefault rate or liquidated damages for each day which the Consumer remains in possession\nof the System. Until the System has been returned or repossessed, the Consumer shall be\nsolely responsible for its safe keeping.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.7 For the avoidance of doubt, any outstanding payments due to Arnergy shall continue to\naccrue during the default and remedy events set out in this clause 13 until the outstanding\npayment is paid to Arnergy.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        13.8 Where the Consumer has interest in continued use of the Services, accrued interest shall be\npayable by the Consumer for re-activation of the System.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      14. SWITCH TO ALTERNATIVE BUSINESS MODEL AND SYSTEM UPGRADE\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        14.1 The Consumer may opt to switch to an alternative business model of Arnergy. In the event\nthe Consumer would like to switch to the outright sale model, the System will be purchased\nby the Consumer at the outright sales price communicated by Arnergy to the Consumer.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        14.2 The Consumer may also opt to upgrade to a higher System, and Arnergy will review such\nrequests provided that the Consumer has consistently paid the Rental Payments in previous\nmonths and is not in breach of any provision of these Terms.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      15. TERMINATION\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        15.1 The provision of these Terms shall terminate in any of the following instances:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.1.1 where the Purchase Option is exercised at the end of the Lease Period;\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.1.2 where there is a default by the Consumer in the circumstances stated in clause\n13 above; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.1.3 the other Party commits a material breach of any of these Terms and such\nbreach is irremediable or (if such breach is remediable) fails to remedy that\nbreach within a period of thirty (30) days after being notified in writing to do\nso; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.1.4 the Consumer or any guarantor of the Consumer’s obligations is unable or\nadmits in writing its inability to pay its debts as they fall due.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.1.5 In the case of a company, where any of the following occurs in relation to the\nConsumer:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-3"},[_vm._v("\n                        15.1.5.1 the suspension of payments, a moratorium of any indebtedness,\nwinding up, dissolution, or reorganisation (by way of voluntary\narrangement, scheme of arrangement or otherwise) other than a\nsolvent liquidation or reorganisation;\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-3"},[_vm._v("\n                        15.1.5.2 a composition, compromise, assignment or arrangement with any\ncreditor; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-3"},[_vm._v("\n                        15.1.5.3 the appointment of a liquidator (other than in respect of a solvent\nliquidation), receiver, manager or other similar officer in respect of the\nConsumer or any of its assets, except that no breach of this Agreement\nwill occur under this clause in the case of an application for winding-up\npresented by a creditor which is contested in good faith and with due\nprocess and diligence and is discharged, stayed, dismissed or struck out\nwithin forty-five (45) days of commencement.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-3"},[_vm._v("\n                        15.1.5.4 where creditors’ process any expropriation, attachment, sequestration,\ndistress or execution or analogous event that affects the System.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-3"},[_vm._v("\n                        15.1.5.5 the authority or ability of the Consumer to conduct all of its business is\nlimited or wholly or substantially curtailed by any seizure,\nexpropriation, nationalisation, compulsory acquisition, intervention,\nrestriction or other action by or on behalf of any authority in relation to\nany of its assets or the shares in the Consumer.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        15.2 Arnergy shall retrieve the System from the Location (at the cost of the Party responsible for\nthe termination) following the termination of the provision of these Terms under sub clauses\n14.1.2-14.1.5. \n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        15.3 Notwithstanding termination of the provisions of these Terms, in accordance with this clause\n14, the following clauses shall continue to have effect:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.3.1 Definitions and Interpretation (Clause 1);\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.3.2 Confidentiality & Publicity (Clause 11);\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.3.3 Notices (clause 16);\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.3.4 No Implied Waiver, Entire Terms, Counterparts, Severability (Clauses 17.1,\n17.2, 17.5 and 17.6); and\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        15.3.5 Governing Law and Dispute Resolution (Clause 18).\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        15.4 A termination of these Terms shall be without prejudice to the rights of either Party that had\naccrued prior to the date of termination.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        15.5 For the avoidance of doubt, the Consumer shall not be entitled to a refund of any Rental\nPayments upon termination.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      16. NOTICES\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        16.1 Any notices, request or other communication to be given or made under the provision of\nthese Terms shall be in writing and be delivered by hand, airmail or e-mail to, (i) Arnergy’s\ndetails specified below, (ii) the Consumer’s contact details and address as notified to Arnergy\nas part of this onboarding process; and (iii) at such other address as such Party notifies in\nwriting to the other Party from time to time:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        To: Arnergy\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Name: Arnergy Solar Limited\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Address: 1, Industrial Avenue, Ilupeju, Lagos\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Email: customer.service@arnergy.com\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        16.2 A notice is deemed to have been received:\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        16.2.1 If delivered personally, at the time of delivery; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        16.2.2 If sent via a courier or other recorded delivery service, five (5) days from the\ndate of posting; or\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        16.2.3 If sent by electronic mail, upon electronic confirmation of transmission.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        16.2.4 If deemed receipt under the above paragraphs of this Clause 16.2, is not within\nbusiness hours (meaning between 9:00am and 5:30pm West Africa Standard\nTime on a Business Day), when business next starts in the place of the deemed\nreceipt.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      17. GENERAL\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        No Implied Waiver \n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.1 The failure of either Party to insist on strict performance of any covenant or obligation under\nthese Terms, regardless of the length of time for which such failure continues, shall not be\ndeemed a waiver of such Party's right to demand strict compliance in the future. No consent\nor waiver, express or implied, to or of any breach or default in the performance of any\nobligation under these Terms shall constitute a consent or waiver to or of any other breach\nor default in the performance of the same or any other obligation.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Entire Terms\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.2 These Terms constitute the entire Terms between the Parties and supersedes and\nextinguishes all previous Terms, promises, assurances, warranties, representations and\nunderstandings between them, whether written or oral, relating to its subject matter. Each\nParty agrees that it shall have no remedies in respect of any statement, representation,\nassurance or warranty (whether made innocently or negligently) that is not set out or\nreferenced in these Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        No Variation \n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.3 No variation of these Terms shall be effective unless it is in writing and signed by the parties\nor their authorized representatives.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Assignment\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.4 The rights of the Consumer under these Terms and any document entered into in connection\nwith or pursuant to the provision of these Terms shall not be assignable. Arnergy may from\ntime to time assign or transfer all or any of its interest in these Terms and any document\nentered in connection with or pursuant to these Terms or sell, charge or otherwise dispose of\nits rights in and to the System. Arnergy shall notify the Consumer via email communication\nin such circumstances.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Severability \n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.5 In the event any provision of these Terms is determined to be invalid or unenforceable by\nruling of an arbitrator or court of competent jurisdiction, the remainder of these Terms (and\neach of the remaining terms and conditions contained herein) shall remain in full force and\neffect.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Counterparts\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.6 These Terms may be executed in any number of counterparts and the counterparts taken\ntogether shall be deemed to constitute one and the same Terms.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark pl-4"},[_vm._v("\n                        Force majeure \n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.7 If any of the Parties hereto is prevented from fulfilling its obligations under these Terms by\nreason of any supervening event beyond its control (including but not limited to an Act of\nGod, Natural Disaster, Government Order, Riot, Pandemic or Epidemic or Civil Disorder)\n(Force Majeure) the Party unable to fulfil its obligations shall immediately give notice in\nwriting of this to the other Party and shall do everything in its power, including but not\nlimited to accepting assistance from third parties or the other Party, to resume full\nperformance.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        17.8 If the period of incapacity exceeds one (1) month, then these Terms shall automatically\nterminate unless Parties expressly agree otherwise in writing. The Parties shall be relieved\nfrom liability under these Terms, except in relation to obligations to make payments which\nfall due under these Terms.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      18. GOVERNING LAW AND DISPUTE RESOLUTION\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        18.1 The provisions of these Terms shall be governed by and construed in accordance with the\nlaws of the Federal Republic of Nigeria.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        18.2 In the event of any dispute or claim arising out of or in connection with the interpretation or\nimplementation of these Terms, the Parties shall endeavour in good faith to resolve any such\ndispute through amicable discussion but within a period of thirty (30) days commencing on\nthe date either Party serves written notice upon the other outlining the nature and substance\nof such dispute.\n                      ")]),_vm._v(" "),_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        18.3 Where the Parties are unable to amicably settle the dispute within the thirty (30) day period,\nsuch dispute shall be submitted by either or both Parties to arbitration at the Lagos\nMulti-Door Courthouse. Both Parties accept that any ruling from such arbitration relating to\nthe subject matter disputed between the Parties shall be binding and final in all respects\nbetween the Parties.\n                      ")])])]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"text-left text-dark"},[_vm._v("\n                      19. AUTHORITY\n                    ")]),_vm._v(" "),_c('div',{attrs:{"className":"child-agree ml-5 pl-5"}},[_c('p',{staticClass:"text-justify text-dark"},[_vm._v("\n                        In the case of a company as the Purchaser, The individual that has agreed electronically with these\nTerms for their respective company warrants that they are fully authorized to do so and that they\n(and their respective company) are thereby legally bound by all of the terms and conditions hereof.\n                      ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('p',{staticClass:"text-left text-dark text-ark"},[_vm._v("\n                      Apply to terms & Conditions\n                    ")]),_vm._v(" "),_c('el-checkbox',{model:{value:(_vm.form.accept),callback:function ($$v) {_vm.$set(_vm.form, "accept", $$v)},expression:"form.accept"}},[_vm._v("Click to Accept Terms & Regulations")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.accept),expression:"form.accept"}]},[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.continuePage}},[_vm._v("\n                        Agree and continue\n                      ")])])],1)])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[(_vm.showAgreement)?_c('agreement',{on:{"close":function($event){_vm.showAgreement = false}}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('h1',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('div',{staticClass:"heading"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}],staticClass:"login-title"},[_vm._v("Product Information")]),_vm._v(" "),_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}],staticClass:"login-title"},[_vm._v("Job/ Business Information")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}],staticClass:"main-body"},[_c('h2',[_vm._v("Arnergy 5000")]),_vm._v(" "),_c('p',[_vm._v("2 Battery + 12 panels on 1 Arnergy 5000 cabinet")]),_vm._v(" "),_c('div',[_c('h1',{staticClass:"amt"},[_vm._v("Amount : #56,000 ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Select Tenure","items":_vm.tenures},model:{value:(_vm.form.tenure),callback:function ($$v) {_vm.$set(_vm.form, "tenure", $$v)},expression:"form.tenure"}}),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.form.tenure)?_c('div',{staticClass:"info-footer"},[_c('p',[_vm._v("Next Repayment Cost : #76,000 ")]),_vm._v(" "),_c('p',[_vm._v("Next Repayment Cost : #76,000 ")])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}],staticClass:"main-body"},[_c('div',[_c('arnergy-select',{attrs:{"label":"","items":_vm.employmentStatus},model:{value:(_vm.form.employment),callback:function ($$v) {_vm.$set(_vm.form, "employment", $$v)},expression:"form.employment"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.income,"label":"What's your monthly income ?"},model:{value:(_vm.form.income),callback:function ($$v) {_vm.$set(_vm.form, "income", $$v)},expression:"form.income"}}),_vm._v(" "),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.employment == 'Self Employed'),expression:"form.employment == 'Self Employed'"}]},[_c('arnergy-select',{attrs:{"label":"What's your business type ?","items":_vm.businessType},model:{value:(_vm.form.business),callback:function ($$v) {_vm.$set(_vm.form, "business", $$v)},expression:"form.business"}})],1)])],1)])]),_vm._v(" "),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}]},[(_vm.form.tenure)?_c('div',[(_vm.modalstate)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":function($event){_vm.activeIndex= 1}}},[_vm._v("\n                    Next →\n                  ")])])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}]},[(_vm.form.tenure)?_c('div',[(_vm.modalstate)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('closeToPopTerms')}}},[_vm._v("\n                      Continue →\n                    ")])])]):_vm._e()])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestModal2_vue__ = __webpack_require__(1136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f980624c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestModal2_vue__ = __webpack_require__(2807);
function injectStyle (ssrContext) {
  __webpack_require__(2799)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f980624c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestModal2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f980624c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestModal2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2800 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('select',{staticClass:"select-input",attrs:{"name":"selectInput"},domProps:{"value":_vm.value},on:{"change":_vm.handleInput}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.items),function(item,key){return _c('option',{key:key,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2):_c('p',[_vm._v("No items found")]),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__ = __webpack_require__(1138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcc197f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__ = __webpack_require__(2806);
function injectStyle (ssrContext) {
  __webpack_require__(2803)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dcc197f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Calculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dcc197f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Calculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2803 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2804 */,
/* 2805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = ({
    cal: 18 / 1000
});

/***/ }),
/* 2806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('div',{},[_c('div',[_c('div',{},[_c('div',[_c('br'),_vm._v(" "),_c('div',{staticClass:"text-left pb-2"},[_vm._v("Tenure (Months)")]),_vm._v(" "),_c('div',[_c('p',{staticStyle:{"width":"100%"}},[_c('vue-number-input',{attrs:{"step":6,"min":6,"max":36,"size":"large","inputtable":false,"center":"","controls":""},on:{"click":function($event){return _vm.PMT(0.015, _vm.ten, _vm.typeProduct - _vm.value, 0, 0)}},model:{value:(_vm.ten),callback:function ($$v) {_vm.ten=$$v},expression:"ten"}})],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.product),expression:"form.product"}]},[_c('div',{staticClass:"results"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',{staticClass:"bold-text"},[_vm._v("Total Payment")]),_vm._v(" "),(_vm.ten == 0 && _vm.value == 0)?_c('div',{staticClass:"bold-text"},[_vm._v("\n                  NGN "+_vm._s(Intl.NumberFormat("en-US").format(_vm.typeProduct))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.ten != 0)?_c('div',{staticClass:"bold-text"},[_vm._v("\n                  NGN "+_vm._s(Intl.NumberFormat("en-US").format(
                          _vm.ten * _vm.monthlyPaymentValue + (0.05 * _vm.typeProduct) + _vm.value
                        ))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_vm._m(0),_vm._v(" "),(_vm.ten == 0 && _vm.value == 0)?_c('div',[_vm._v("\n                  NGN "+_vm._s(Intl.NumberFormat("en-US").format(_vm.typeProduct + (0.05 * _vm.typeProduct)))+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.ten != 0)?_c('div',[_vm._v("\n                  NGN "+_vm._s(Intl.NumberFormat("en-US").format(
                          2 * _vm.monthlyPaymentValue + (0.05 * _vm.typeProduct) + _vm.value
                        ))+"\n                ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('ul',[_c('li',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Monthly Payment")]),_vm._v(" "),_c('div',[_c('div',[_vm._v("\n                        NGN "+_vm._s(_vm.monthlyPaymentValue == "Infinity"
                            ? "0.00"
                            : Intl.NumberFormat("en-US").format(
                                _vm.monthlyPaymentValue
                              ))+"\n                      ")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Caution Fee (Refundable)")]),_vm._v(" "),_c('div',[_vm._v("\n                      NGN "+_vm._s(_vm.monthlyPaymentValue == "Infinity"
                          ? "0.00"
                          : Intl.NumberFormat("en-US").format(_vm.monthlyPaymentValue))+"\n                    ")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Upfront Deposit")]),_vm._v(" "),_c('div',[_vm._v("\n                      NGN "+_vm._s(Intl.NumberFormat("en-US").format(0.05 *  _vm.typeProduct))+"\n                    ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Subsequent Payments")]),_vm._v(" "),_c('div',[_vm._v("\n                  NGN "+_vm._s(_vm.monthlyPaymentValue == "Infinity"
                      ? "0.00"
                      : Intl.NumberFormat("en-US").format(_vm.monthlyPaymentValue))+"\n                ")])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('div',[_c('div',[_c('div',[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.passReqFunc}},[_vm._v("\n            Next →\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("Total 1st Month Payment \n                  "),_c('br'),_vm._v(" "),_c('i',[_vm._v("(Payable now)")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{},[_c('div',{},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body"},[_c('div',[_c('div',{staticClass:"headingg"},[_c('h2',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}],staticClass:"login-title"},[_vm._v("\n                  Product Information\n                ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1 && !_vm.sucessMsg),expression:"activeIndex == 1 && !sucessMsg"}]},[_c('h2',{staticClass:"login-title"},[_vm._v("\n                    Job/Business Information\n                  ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}],staticClass:"main-body"},[_c('h2',[_vm._v(_vm._s(_vm.titleProduct))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.desc))]),_vm._v(" "),_c('div',[(_vm.amt)?_c('calculator',{attrs:{"productName":_vm.titleProduct,"typeProduct":_vm.amt},on:{"nextFunc":_vm.nextFunc,"toKyc":function($event){return _vm.$emit('goToKyc')}}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.form.tenure)?_c('div',{staticClass:"info-footer",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"info-below"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("\n                          First Payment Before Installation\n                        ")]),_vm._v(" "),_c('div',{staticClass:"amt"},[_vm._v("\n                          N"+_vm._s((_vm.amountToPay.caution + "").replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            ))+"\n                          "),_c('br')])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"info-below"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("\n                          Recurring Monthly Payment\n                        ")]),_vm._v(" "),_c('div',{staticClass:"amt"},[_vm._v("\n                          N"+_vm._s((_vm.amountToPay.monthly + "").replace(
                              /(\d)(?=(\d{3})+(?!\d))/g,
                              "$1,"
                            ))+"\n                          "),_c('br')])])]):_vm._e()],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}],staticClass:"main-body"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.sucessMsg),expression:"sucessMsg"}],staticClass:"font-weight-bold text-success success-message"},[_vm._v("\n                    "+_vm._s(_vm.message)+"\n                  ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errMsg),expression:"errMsg"}],staticClass:"font-weight-bold text-danger"},[_vm._v("\n                    All fields are required!\n                  ")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorMessage),expression:"errorMessage"}],staticClass:"font-weight-bold text-danger"},[_vm._v("\n                    "+_vm._s(_vm.message)+"\n                  ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.sucessMsg),expression:"!sucessMsg"}]},[_c('arnergy-select',{attrs:{"label":"What's your employment status ?","items":_vm.employmentStatus},model:{value:(_vm.form.employment),callback:function ($$v) {_vm.$set(_vm.form, "employment", $$v)},expression:"form.employment"}}),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"What's your monthly income ?","items":_vm.incomes},model:{value:(_vm.form.income),callback:function ($$v) {_vm.$set(_vm.form, "income", $$v)},expression:"form.income"}}),_vm._v(" "),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.employment == 'Self Employed'),expression:"form.employment == 'Self Employed'"}]},[_c('arnergy-select',{attrs:{"label":"What's your business type ?","items":_vm.BT},model:{value:(_vm.form.business),callback:function ($$v) {_vm.$set(_vm.form, "business", $$v)},expression:"form.business"}})],1)])],1)])]),_vm._v(" "),_c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}]},[_c('div',[_c('div',[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.ctn == false),expression:"ctn == false"}],staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.finalReq}},[_vm._v("\n                          Continue →\n                        ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.ctn),expression:"ctn"}],staticClass:"submit-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('proceed')}}},[_vm._v("\n                          Continue →\n                        ")])])])])])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.fetchProductById(_vm.ID)}}},[_vm._v("\n    Continue\n  ")]),_vm._v(" "),(_vm.showModal)?_c('TestModal',{attrs:{"titleProduct":_vm.title,"desc":_vm.productDescription,"amt":_vm.amount,"productDetails":_vm.productsDetails},on:{"close":_vm.close,"proceed":_vm.proceedToTerms,"goToKyc":_vm.goToKyc}}):_vm._e(),_vm._v(" "),(_vm.showTerms)?_c('Agreement',{on:{"close":_vm.closeTerms}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingSelectButton_vue__ = __webpack_require__(1140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554f9005_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingSelectButton_vue__ = __webpack_require__(2811);
function injectStyle (ssrContext) {
  __webpack_require__(2810)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-554f9005"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OnboardingSelectButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_554f9005_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OnboardingSelectButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2810 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cover",style:({ 'border-color': _vm.isActive ? '#1a93ca' : '#ebebeb' }),on:{"click":_vm.setActive}},[_c('div',{staticClass:"product-tile"},[(_vm.title === 'Lease to Own (LO)' || _vm.title === 'Outright Sale (OS)')?_c('div',[(!_vm.isActive)?_c('img',{attrs:{"src":__webpack_require__(2812),"alt":"x"}}):_vm._e(),_vm._v(" "),(_vm.isActive)?_c('img',{attrs:{"src":__webpack_require__(2813),"alt":"x"}}):_vm._e()]):_vm._e(),_vm._v(" "),(
        _vm.title === 'Arnergy 10000' ||
          _vm.title === 'Arnergy IPP' ||
          _vm.title === 'Arnergy 5000' ||
          _vm.title === 'Arnergy 5000X'
      )?_c('div',[(_vm.title === 'Arnergy 10000')?_c('img',{staticClass:"prod-img-x",style:({ filter: _vm.isActive ? 'none' : 'grayscale(100%)' }),attrs:{"src":__webpack_require__(2814),"alt":"x"}}):_vm._e(),_vm._v(" "),(_vm.title === 'Arnergy 5000')?_c('img',{staticClass:"prod-img-x",style:({ filter: _vm.isActive ? 'none' : 'grayscale(100%)' }),attrs:{"src":__webpack_require__(466),"alt":"x"}}):_vm._e(),_vm._v(" "),(_vm.title === 'Arnergy IPP')?_c('img',{staticClass:"prod-img-x",style:({ filter: _vm.isActive ? 'none' : 'grayscale(100%)' }),attrs:{"src":__webpack_require__(466),"alt":"x"}}):_vm._e(),_vm._v(" "),(_vm.title === 'Arnergy 5000X')?_c('img',{staticClass:"prod-img-x",style:({ filter: _vm.isActive ? 'none' : 'grayscale(100%)' }),attrs:{"src":__webpack_require__(466),"alt":"x"}}):_vm._e()]):_vm._e(),_vm._v(" "),_c('h3',{staticClass:"title",style:({ color: _vm.isActive ? '#0892D0' : '#C4C4C4' })},[_vm._v("\n      "+_vm._s(_vm.title ? _vm.title : "no_title")+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2812 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTUiIGhlaWdodD0iNTUiIHZpZXdCb3g9IjAgMCA1NSA1NSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0zMi45OTEgMTcuNDE3MkwzMS4yOTU2IDE1LjcyMTdINDUuMjcyNVYxNC4wMjkySDMxLjI5NTZMMzIuOTkxIDEyLjMzMzlMMzEuNzk0MiAxMS4xMzcyTDI4LjA1NTggMTQuODc1NUwzMS43OTQyIDE4LjYxNEwzMi45OTEgMTcuNDE3MloiIGZpbGw9IiNDNEM0QzQiLz4NCjxwYXRoIGQ9Ik0wIDAuMDc0NzA3TDAuMDcxODY1MSA1NC45MjU0SDU1VjAuMDc0NzA3SDBaTTUzLjMwNzQgNTMuMjMzSDEuNzYyMTVMMS42OTQ3OSAxLjc2NzI0SDUzLjMwNzZWNTMuMjMzSDUzLjMwNzRaIiBmaWxsPSIjQzRDNEM0Ii8+DQo8cGF0aCBkPSJNNi4wNTY1NSAxOC44NjE5SDIyLjM5NTdWNTIuMzYxOUgyNC4wODgyVjE3LjE2OTRINC4zNjQwMVY1Mi4zNjE5SDYuMDU2NTVWMTguODYxOVoiIGZpbGw9IiNDNEM0QzQiLz4NCjxwYXRoIGQ9Ik0xOS43OTUzIDMzLjQ3MTlIMTguMTAyOFYzOC42MjM5SDE5Ljc5NTNWMzMuNDcxOVoiIGZpbGw9IiNDNEM0QzQiLz4NCjwvc3ZnPg0K"

/***/ }),
/* 2813 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/arnergy-10000x.f8f212b.png";

/***/ }),
/* 2815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideIndicator_vue__ = __webpack_require__(1141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494c44e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideIndicator_vue__ = __webpack_require__(2817);
function injectStyle (ssrContext) {
  __webpack_require__(2816)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-494c44e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494c44e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2816 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items && _vm.items.length > 0)?_c('div',{staticClass:"page-sidebar"},_vm._l((_vm.items),function(item,key){return _c('button',{key:key,staticClass:"page-sidebar-button",attrs:{"disabled":_vm.isDisabled(key),"type":"button"},on:{"click":function($event){_vm.isDisabled(key) ? null : _vm.gotoSection(key)}}},[_c('span',{staticClass:"sign"}),_vm._v(_vm._s(item.name)+"\n  ")])}),0):_c('p',[_vm._v("no side indicator items found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCalculate_vue__ = __webpack_require__(1142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8446932e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCalculate_vue__ = __webpack_require__(2821);
function injectStyle (ssrContext) {
  __webpack_require__(2819)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8446932e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalCalculate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8446932e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalCalculate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2819 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2820 */,
/* 2821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body"},[_c('div',[_c('div',{staticClass:"heading"},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}],staticClass:"login-title",staticStyle:{"color":"#FFB946"}},[_vm._v("\n                  Arnergy Calculator\n                ")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',[_c('arnergy-select',{attrs:{"label":"Product Type","items":_vm.deposits},model:{value:(_vm.form.product),callback:function ($$v) {_vm.$set(_vm.form, "product", $$v)},expression:"form.product"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-left pb-2"},[_vm._v("First Intial Deposit")]),_vm._v(" "),_c('div',[_c('vue-numeric-input',{attrs:{"align":"center","size":'100%',"s":"","step":50000,"min":100000},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"text-left pb-2"},[_vm._v("Tenure (Months)")]),_vm._v(" "),_c('div',[_c('vue-numeric-input',{attrs:{"align":"center","size":'100%',"step":6,"min":6},model:{value:(_vm.ten),callback:function ($$v) {_vm.ten=$$v},expression:"ten"}})],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.product),expression:"form.product"}]},[_c('div',{staticClass:"results"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Total 1st Month Payment")]),_vm._v(" "),_c('div',[_vm._v("\n                          NGN\n                          "+_vm._s((
                              ((_vm.form.product - _vm.value) / _vm.ten) * 2 +
                              _vm.value
                            ).toFixed(2))+"\n                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Subsequent Payments")]),_vm._v(" "),_c('div',[_vm._v("\n                          NGN "+_vm._s(((_vm.form.product - _vm.value) / _vm.ten).toFixed(2))+"\n                        ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Monthly Payment")]),_vm._v(" "),_c('div',[_vm._v("\n                          NGN "+_vm._s(((_vm.form.product - _vm.value) / _vm.ten).toFixed(2))+"\n                        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Set-Up fee (One-off)")]),_vm._v(" "),_c('div',[_vm._v("NGN 0")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('div',[_vm._v("Caution Fee")]),_vm._v(" "),_c('div',[_vm._v("\n                          NGN "+_vm._s(((_vm.form.product - _vm.value) / _vm.ten).toFixed(2))+"\n                        ")])])])])],1)])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._t("body")],2)])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2824 */,
/* 2825 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topbar-container"},[_c('div',{staticClass:"logo-box"},[_c('img',{attrs:{"src":__webpack_require__(421),"alt":"Arnergy Logo"}})]),_vm._v(" "),_c('div',{staticClass:"right-box"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"v-divider"}),_vm._v(" "),_c('div',{staticClass:"user-details"},[_c('p',{staticClass:"name bolden"},[_vm._v("\n        "+_vm._s(this.getUserSession !== null
            ? this.getUserSession.firstname +
              " " +
              this.getUserSession.lastname.toUpperCase()
            : "")+"\n      ")]),_vm._v(" "),_c('p',{staticClass:"email sub-text"},[_vm._v("\n        "+_vm._s(this.getUserSession !== null ? this.getUserSession.email : "")+"\n      ")])]),_vm._v(" "),_c('img',{style:({ cursor: 'pointer' }),attrs:{"src":__webpack_require__(2827),"alt":"Logout button"},on:{"click":_vm.logout}}),_vm._v(" "),_c('a',{staticClass:"faq",attrs:{"href":"https://onboarding-faq.netlify.app/homepage/","target":"_blank"}},[_vm._v("Need Help?")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"help-text"},[_vm._v("\n      For help please call us on "),_c('span',{staticClass:"bolden"},[_vm._v("07002288888")]),_vm._v("/"),_c('span',{staticClass:"bolden"},[_vm._v("08002288888")]),_vm._v("\n      or email us at "),_c('span',{staticClass:"bolden"},[_vm._v("support@arnergy.com")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2827 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 2828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button-container",on:{"click":_vm.onButtonClick}},[(_vm.type == 'next')?_c('div',{staticClass:"button next-btn",class:{ 'mr-2': _vm.margin && _vm.margin === 'right', 'ml-2': _vm.margin && _vm.margin === 'left', }},[_c('span',[_vm._v(_vm._s(_vm.text)+" >")])]):_vm._e(),_vm._v(" "),(_vm.type == 'download')?_c('div',{staticClass:"button download-btn",class:{ 'mr-2': _vm.margin && _vm.margin === 'right', 'ml-2': _vm.margin && _vm.margin === 'left', }},[_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e(),_vm._v(" "),(_vm.type == 'prev')?_c('div',{staticClass:"button prev-btn",class:{ 'mr-2': _vm.margin && _vm.margin === 'right', 'ml-2': _vm.margin && _vm.margin === 'left', }},[_c('svg',{attrs:{"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z","fill":"#0892D0"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ background: '#FFFFFF', height: '100vh' })},[_c('onboarding-top-bar'),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"choose-package"},[_c('div',{staticClass:"welcome"},[_vm._v("Start your Arnergy Journey!")]),_vm._v(" "),_c('div',{staticClass:"subtext"},[_vm._v("\n        Join the thousands of Arnergy users all over Africa who are enjoying\n        unlimited answers with our solar solution today.\n      ")]),_vm._v(" "),_c('div',{staticClass:"choice-type"},[_vm._v("Choose a payment type")]),_vm._v(" "),_c('div',{staticClass:"boxes"},_vm._l((_vm.paymentTypes),function(item){return _c('div',{key:item.id},[_c('onboarding-select-button',{attrs:{"title":item.title,"description":item.description,"isActive":_vm.activePaymentType && _vm.activePaymentType.id == item.id},on:{"setActive":function($event){return _vm.updateActivePaymentType(item)}}})],1)}),0),_vm._v(" "),_c('div',{staticClass:"subtext"},[_vm._v("\n        "+_vm._s(this.activePaymentType.key === "OS"
            ? this.paymentTypes[1].description
            : this.paymentTypes[0].description)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"package"},_vm._l((_vm.packages),function(item){return _c('div',{key:item.id},[_c('onboarding-select-button',{attrs:{"ID":item.id,"title":item.name,"description":item.productDescription,"isActive":_vm.activePackageType && _vm.activePackageType.id == item.id},on:{"setActive":function($event){return _vm.updateActivePackageType(item)}}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"right-image"},[_c('div',{staticClass:"description"},[_vm._v("\n        "+_vm._s(this.activePackageType.productDescription
            ? this.activePackageType.productDescription
            : "Welcome!")+"\n      ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142)}}),_vm._v(" "),_c('img',{staticClass:"man-woman",attrs:{"src":__webpack_require__(1146)}}),_vm._v(" "),_c('onboarding-button',{staticClass:"continue",attrs:{"type":"next","text":"Continue"},on:{"onButtonClick":_vm.handleContinue}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payments_vue__ = __webpack_require__(1147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf7cacc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payments_vue__ = __webpack_require__(2833);
function injectStyle (ssrContext) {
  __webpack_require__(2832)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cf7cacc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('form',{attrs:{"method":"post","id":"upay_form","name":"upay_form","action":"https://fidelitypaygate.fidelitybank.ng/cipg/MerchantServices/MakePayment.aspx","target":"_top"}},[_c('input',{attrs:{"type":"hidden","name":"mercId"},domProps:{"value":_vm.mrchId}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"currCode","value":"566"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"amt","value":"1.00"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"orderId"},domProps:{"value":_vm.generateTx()}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"prod"},domProps:{"value":_vm.paymentFormSelected}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"email"},domProps:{"value":_vm.getUserSession.email}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"phone"},domProps:{"value":_vm.getUserSession.phoneNumber}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"hash"},domProps:{"value":_vm.generateTx()}}),_vm._v(" "),_c('input',{ref:"upay_form",staticStyle:{"display":"none"},attrs:{"name":"submit","type":"submit"}})]),_vm._v(" "),_c('b-modal',{ref:"paymentModal",attrs:{"centered":"","id":"paymentModal","hide-footer":""}},[_c('div',{staticStyle:{"text-align":"center !important"},attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('b-btn',{staticClass:"close custom-modal__close",staticStyle:{"justify-content":"center","font-size":".89em"},on:{"click":_vm.hideModal}},[_c('span',{staticClass:"fa fa-close",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('h1',{staticClass:"page-content__header-description"},[_vm._v("Payment Method")])],1),_vm._v(" "),_c('div',{staticClass:"d-block text-center"},[_c('b-button',{staticClass:"payment_options",attrs:{"variant":"link","block":"","to":"/shs/pay"}},[_c('img',{attrs:{"src":"/static/img/rave.jpg","alt":""}})]),_vm._v(" "),_c('b-button',{staticClass:"payment_options",attrs:{"variant":"link"},on:{"click":_vm.triggerPaygate}},[_c('img',{attrs:{"src":"/static/img/paygate.png","height":"80","alt":""}})])],1)]),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"wallet"}},[_c('el-tab-pane',{attrs:{"label":"Fund Wallet","name":"fundwallet"}},[_c('FundWallet')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"token"}},[_c('el-tab-pane',{attrs:{"label":"Renew Subscription Plan","name":"renewsub"}},[_c('div',{staticClass:"widget widget-alpha"},[_vm._v("\n                Renew your devices or for someone else's device's subscription plan.\n                "),_c('router-link',{staticClass:"btn",attrs:{"to":{name:'GenerateToken'}}})],1)])],1),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"token"}},[_c('can',{attrs:{"I":"read","a":"wallet"}},[_c('el-tab-pane',{attrs:{"label":"Transaction History","name":"transactions"}},[_c('transaction-histories')],1)],1)],1)],1)],1)])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","padding":"20px !important"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Payments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_devices_vue__ = __webpack_require__(1148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0767ad3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_devices_vue__ = __webpack_require__(2838);
function injectStyle (ssrContext) {
  __webpack_require__(2835)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0767ad3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0767ad3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2836 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container requests-table-height"},[_c('vk-modal',{attrs:{"show":_vm.dialogVisible},on:{"update:show":function($event){_vm.dialogVisible=$event}}},[_c('vk-modal-close',{on:{"click":function($event){_vm.dialogVisible = false}}}),_vm._v(" "),_c('vk-modal-title',[_vm._v("Payment Options")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"flex":"1","display":"flex-flow: column","justify-content":"center","padding":"10px"}},[_vm._l((Object.keys(_vm.feePayable)),function(feePay,index_){return _c('div',{key:("" + index_)},[_c('label',{staticStyle:{"text-transform":"capitalize"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayments[feePay]),expression:"selectedPayments[feePay]"}],staticClass:"uk-checkbox",attrs:{"type":"checkbox","disabled":feePay == 'setup',"checked":""},domProps:{"checked":Array.isArray(_vm.selectedPayments[feePay])?_vm._i(_vm.selectedPayments[feePay],null)>-1:(_vm.selectedPayments[feePay])},on:{"change":function($event){var $$a=_vm.selectedPayments[feePay],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.selectedPayments, feePay, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.selectedPayments, feePay, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.selectedPayments, feePay, $$c)}}}}),_vm._v(" "),_vm._v("\n          "+_vm._s(feePay)+" "+_vm._s(feePay != "monthly"?"Fee":"Subscription")+" - ₦"+_vm._s(_vm.feePayable[feePay]['total'])+"   "+_vm._s(_vm.feePayable[feePay]['discount'] > 0? ("(Discount: ₦" + (_vm.feePayable[feePay]['discount']) + ") "):'')+"\n        ")])])}),_vm._v(" "),_c('h2',{staticClass:"text-center"},[_vm._v("Total: ₦"+_vm._s(_vm.calculatedAmount))])],2),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('el-button',{on:{"click":function($event){_vm.dialogVisible = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('Rave',{staticStyle:{"display":"none"},attrs:{"id":"paymentBtn_","is-production":false,"text":_vm.raveBtnText,"style-class":"btn btn-primary","email":_vm.formData.email,"amount":_vm.calculatedAmount,"reference":_vm.reference,"rave-key":_vm.raveKey,"callback":_vm.callback,"metadata":[{metaname: 'requestInfo', metavalue:JSON.stringify(_vm.paymentMeta)}],"paymentOptions":"card,barter,account,ussd","close":_vm.close,"currency":"NGN","customerFirstname":_vm.formData.firstname,"customerLastname":_vm.formData.lastname,"customerPhone":_vm.formData.phonenumber}}),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.triggerPayment}},[_vm._v("Continue")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{enabled: true,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['firstName']) + " " + (props.row.user['lastName'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['email']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['phoneNumber']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceType? ((props.row.deviceType['name']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.paymentModel')?_c('span',[_vm._v("\n          "+_vm._s(props.row.paymentModel)+"\n        ")]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 0),expression:"props.row.status == 0"}],attrs:{"variant":"primary"},on:{"click":function($event){return _vm.navTo(props.row.id)}}},[_vm._v("\n                Approve Request  \n                "),_c('span',{staticClass:"fa fa-check"})])],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"installation"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 1),expression:"props.row.status == 1"}],attrs:{"size":"md","variant":"info"},on:{"click":function($event){return _vm.navTo(props.row.id)}}},[_vm._v("\n                Approve Installation  \n                "),_c('span',{staticClass:"fa fa-calendar"})])],1),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"mine"}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 0),expression:"props.row.status == 0"}],attrs:{"variant":"primary"},on:{"click":function($event){return _vm.paymentOptions(props.row)}}},[_vm._v("\n                Make Payment  \n                "),_c('span',{staticClass:"fa fa-payment"})]),_vm._v(" "),_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status != 0),expression:"props.row.status != 0"}],attrs:{"variant":"info"},on:{"click":function($event){return _vm.navTo(props.row.id)}}},[_vm._v("\n                Check Status  \n                "),_c('span',{staticClass:"fa fa-check"})])],1)],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("\n        "+_vm._s(_vm.form.invoiceType == "initial" ? "Send Invoice" : "Create Request")+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"customer-invoice","placeholder":"--Customer Type--"},on:{"change":_vm.changeContact},model:{value:(_vm.form.invoiceType),callback:function ($$v) {_vm.$set(_vm.form, "invoiceType", $$v)},expression:"form.invoiceType"}},[_c('el-option',{attrs:{"label":"New","value":"initial"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Existing","value":"existing"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Owner"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Industry sector"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"sector-select","fetch-suggestions":_vm.sectorSearch,"placeholder":"Select sector","prefix-icon":"el-icon-suitcase"},on:{"select":_vm.sectorSelected},model:{value:(_vm.form.sector),callback:function ($$v) {_vm.$set(_vm.form, "sector", $$v)},expression:"form.sector"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.deviceRequest.installationName),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "installationName", $$v)},expression:"regDataParams.deviceRequest.installationName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Address"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.address),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "address", $$v)},expression:"regDataParams.deviceRequest.address"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Package"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Package"},on:{"change":_vm.packageSelected},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}},_vm._l((_vm.systemTypes),function(item,index){return _c('el-option',{key:((item.id) + "_package_" + index),staticStyle:{"height":"55px"},attrs:{"label":item.name,"value":item.id}},[_c('h4',{staticStyle:{"float":"left","margin":"0px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#8492a6","font-size":"13px","line-height":"20px"}},[_vm._v(_vm._s(item.description))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"System Capacity(KW)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","min":5,"max":1000},model:{value:(_vm.regDataParams.deviceRequest.systemCapacity),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "systemCapacity", $$v)},expression:"regDataParams.deviceRequest.systemCapacity"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Payment Model"}},[_c('el-radio-group',{model:{value:(_vm.regDataParams.deviceRequest.paymentModel),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "paymentModel", $$v)},expression:"regDataParams.deviceRequest.paymentModel"}},[_c('el-radio',{attrs:{"label":"OS"}},[_vm._v("OS")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"LO"}},[_vm._v("LO")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"ES"}},[_vm._v("ES")])],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":""}},[(_vm.regDataParams.deviceRequest.paymentModel == "OS")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Base price(₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.amount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "amount", $$v)},expression:"regDataParams.deviceRequest.priceModel.amount"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "ES")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e()]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Discount"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"placeholder":"Discount type"},model:{value:(_vm.discountType),callback:function ($$v) {_vm.discountType=$$v},expression:"discountType"}},[_c('el-option',{key:"discount_item_list_percent",attrs:{"label":"Percent (%)","value":"percent"}}),_vm._v(" "),_c('el-option',{key:"discount_item_list_cash",attrs:{"label":"Amount (₦)","value":"amount"}})],1),_vm._v(" "),(_vm.discountType == "percent")?_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},model:{value:(_vm.regDataParams.deviceRequest.orderDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "orderDiscount", $$v)},expression:"regDataParams.deviceRequest.orderDiscount"}},_vm._l((101),function(item){return _c('el-option',{key:(item + "_item_list"),attrs:{"label":item - 1,"value":item - 1}})}),1):_c('el-input-number',{staticStyle:{"width":"180px"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.amountDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "amountDiscount", $$v)},expression:"regDataParams.deviceRequest.amountDiscount"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.comment),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "comment", $$v)},expression:"regDataParams.deviceRequest.comment"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Terms"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.term),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "term", $$v)},expression:"regDataParams.deviceRequest.term"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send Invoice")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"active-text":"Send Invoice","inactive-text":"Don't send Invoice"},model:{value:(_vm.regDataParams.deviceRequest.sendMail),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "sendMail", $$v)},expression:"regDataParams.deviceRequest.sendMail"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("\n        "+_vm._s(_vm.$can("create", "installation")
            ? "Installation Management"
            : "Devices")+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Manage Requests","name":"manage_requests"}},[_c('ManageRequests')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"manage","a":"mine"}},[_c('el-tab-pane',{attrs:{"label":"My Requests","name":"device_request"}},[_c('DeviceRequest')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Approved Installations","name":"approved_installations"}},[_c('ApprovedInstallations')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('el-tab-pane',{attrs:{"label":"Inventory request","name":"inventory_request"}},[_c('inventoryRequest')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Ongoing Installations","name":"ongoing_installations"}},[_c('OngoingInstallations')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"device"}},[_c('el-tab-pane',{attrs:{"label":"All Devices","name":"all_devices"}},[_c('MyDeviceList')],1)],1)],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_support_vue__ = __webpack_require__(1150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2293e909_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__ = __webpack_require__(2841);
function injectStyle (ssrContext) {
  __webpack_require__(2840)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2293e909"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_support_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2293e909_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_support_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Create Issue")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"},nativeOn:{"submit":function($event){$event.preventDefault();}}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Customer"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.installationContact),callback:function ($$v) {_vm.installationContact=$$v},expression:"installationContact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Assigned To"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.userSearch,"placeholder":"Search User","prefix-icon":"el-icon-search"},on:{"select":_vm.userSelected},model:{value:(_vm.assignedTo),callback:function ($$v) {_vm.assignedTo=$$v},expression:"assignedTo"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Issue Description"}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"id":"customer-description"},model:{value:(_vm.form.issue),callback:function ($$v) {_vm.$set(_vm.form, "issue", $$v)},expression:"form.issue"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Timeline"}},[_c('el-date-picker',{attrs:{"type":"daterange","align":"right","start-placeholder":"Start Date","end-placeholder":"End Date","format":"yyyy/MM/dd","value-format":"yyyy-MM-dd"},on:{"change":_vm.value},model:{value:(_vm.form.timeline),callback:function ($$v) {_vm.$set(_vm.form, "timeline", $$v)},expression:"form.timeline"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Maintenance")]),_vm._v(" "),_c('can',{attrs:{"I":"am","a":"manager"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){_vm.showOffCanvas = true}}},[_vm._v("New Maintenance")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('Enquiries')],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__ = __webpack_require__(1151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e9b975_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__ = __webpack_require__(2844);
function injectStyle (ssrContext) {
  __webpack_require__(2843)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-08e9b975"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08e9b975_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Report Config","name":"report_config"}},[_c('ReportConfig')],1)],1)],1)],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Reports")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feedback_vue__ = __webpack_require__(1152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666e5734_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feedback_vue__ = __webpack_require__(2847);
function injectStyle (ssrContext) {
  __webpack_require__(2846)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-666e5734"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666e5734_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Feedback")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"widget widget-alpha dash-widget"},[_c('div',{staticClass:"dash-widget-body"},[_c('div',{staticClass:"widget-icon"},[_c('i',{staticClass:"fa fa-envelope-o fa-3x widget-alpha__icon"})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inventory_vue__ = __webpack_require__(1153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48bd2628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inventory_vue__ = __webpack_require__(2850);
function injectStyle (ssrContext) {
  __webpack_require__(2849)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48bd2628"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inventory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48bd2628_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_inventory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Inventory Management")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}})],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('el-tab-pane',{attrs:{"label":"Components","name":"inventory_component"}},[_c('InventoryComponent')],1)],1)],1)],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__ = __webpack_require__(1154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718a60f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__ = __webpack_require__(2853);
function injectStyle (ssrContext) {
  __webpack_require__(2852)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-718a60f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_718a60f2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("User Management")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"}},[_vm._v("New Users")])],1)])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('Users')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customers_vue__ = __webpack_require__(1155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c2dfb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customers_vue__ = __webpack_require__(2865);
function injectStyle (ssrContext) {
  __webpack_require__(2855)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67c2dfb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67c2dfb4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customers_vue__ = __webpack_require__(1156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3505915c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customers_vue__ = __webpack_require__(2861);
function injectStyle (ssrContext) {
  __webpack_require__(2857)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3505915c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3505915c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2858 */,
/* 2859 */,
/* 2860 */,
/* 2861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"table-header-custom"},[_c('el-input',{staticStyle:{"max-width":"400px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"customer"}},[_c('router-link',{attrs:{"to":"/customer/new"}},[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("New Customer")])],1)],1)],1),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.usersList,"search-options":{
        enabled: true,
        searchFn: _vm.searchTable,
        externalQuery: _vm.searchTerm
      },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstName)+" "+_vm._s(props.row.lastName))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s(props.row.gender + "" === "0" ? "Female" : "Male"))]):(props.column.field == 'actions')?_c('span',[_c('el-button',{attrs:{"size":"md","type":"primary","plain":""},on:{"click":function($event){$event.stopPropagation();return _vm.navTo(_vm.details[0], props.row.id)}}},[_vm._v("Details")])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__ = __webpack_require__(1157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e71f33b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__ = __webpack_require__(2864);
function injectStyle (ssrContext) {
  __webpack_require__(2863)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1e71f33b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e71f33b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"table-header-custom"},[_c('el-input',{staticStyle:{"max-width":"400px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}})],1),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getUsers,"search-options":{enabled: true, 
      searchFn: _vm.searchTable,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstName)+" "+_vm._s(props.row.lastName))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v(_vm._s((props.row.gender+"" === "0")?'Female':'Male'))]):(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":function($event){$event.stopPropagation();return _vm.navTo(_vm.details[0],props.row.id)}}},[_vm._v("Details")])],1)],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('el-tab-pane',{attrs:{"label":"Customers","name":"customer_list"}},[_c('Customers')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"invoice"}},[_c('el-tab-pane',{attrs:{"label":"Invoices","name":"invoices"}},[_c('Invoices')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"wallet"}},[_c('el-tab-pane',{attrs:{"label":"Transaction History","name":"transaction_history"}},[_c('transaction-histories')],1)],1)],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Customer Management")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditTrail_vue__ = __webpack_require__(1158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b1c4b2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditTrail_vue__ = __webpack_require__(2868);
function injectStyle (ssrContext) {
  __webpack_require__(2867)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9b1c4b2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_auditTrail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b1c4b2c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_auditTrail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"page-content__header-description"},[_vm._v("Audit Trail")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-4 col-lg-4 col-md-4"},[_c('div',{staticClass:"widget widget-alpha dash-widget"},[_c('div',{staticClass:"dash-widget-body"},[_c('div',{staticClass:"widget-icon"},[_c('i',{staticClass:"fa fa-list fa-3x widget-alpha__icon"})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_mgt_vue__ = __webpack_require__(1159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e214c5b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_mgt_vue__ = __webpack_require__(2915);
function injectStyle (ssrContext) {
  __webpack_require__(2870)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e214c5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_user_mgt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e214c5b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_user_mgt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subgroup_vue__ = __webpack_require__(1161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff81f966_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subgroup_vue__ = __webpack_require__(2878);
function injectStyle (ssrContext) {
  __webpack_require__(2873)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ff81f966"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Subgroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff81f966_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Subgroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubgroupInfo_vue__ = __webpack_require__(1162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da65af88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubgroupInfo_vue__ = __webpack_require__(2876);
function injectStyle (ssrContext) {
  __webpack_require__(2875)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da65af88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubgroupInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da65af88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubgroupInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container subgroup-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit Subgroup","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('arnergy-select',{attrs:{"label":"Select Group","items":_vm.groups},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Subgroup Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.subgroupname),expression:"form.subgroupname"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.subgroupname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "subgroupname", $event.target.value)}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Subgroup Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.subgroup_desc),expression:"form.subgroup_desc"}],staticClass:"form-control",attrs:{"id":"exampleFormControlTextarea1","rows":"3"},domProps:{"value":(_vm.form.subgroup_desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "subgroup_desc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mt-5 form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n          "+_vm._s(_vm.form.status ? 'Disable Group' : 'Enable Group')+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n            Edit Subgroup\n          ")])])])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search","a":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getSubgroups,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('b-button',{attrs:{"disabled":_vm.loading,"size":"md","variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row)}}},[_vm._v("\n            "+_vm._s(_vm.loading?"Loading...":"Edit Subgroup")+"  \n            "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2877 */,
/* 2878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Subgroup","visible":_vm.showModal,"width":"50%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-danger text-center font-weight-bold"},[_vm._v("Group Name, Subgroup Name, and Subgroup Description are required!")]),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Select Group","items":_vm.groups},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Subgroup Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.subname),expression:"form.subname"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.subname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "subname", $event.target.value)}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Subgroup Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.description),expression:"form.description"}],staticClass:"form-control",attrs:{"id":"exampleFormControlTextarea1","rows":"3"},domProps:{"value":(_vm.form.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-check ml-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            "+_vm._s(_vm.form.status ? "Disable" : "Enable")+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.createSub}},[_vm._v("Create Group")])])])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("SubGroup")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.triggerSubgroup()}}},[_vm._v("\n            New Subgroup\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('SubgroupInfo')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__ = __webpack_require__(1163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b041f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__ = __webpack_require__(2884);
function injectStyle (ssrContext) {
  __webpack_require__(2880)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-38b041f8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38b041f8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupInfo_vue__ = __webpack_require__(1164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a9b000_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupInfo_vue__ = __webpack_require__(2883);
function injectStyle (ssrContext) {
  __webpack_require__(2882)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-73a9b000"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73a9b000_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container group-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit Group","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Group Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.groupnamee),expression:"form.groupnamee"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.groupnamee)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "groupnamee", $event.target.value)}}})]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Group Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.group_desc),expression:"form.group_desc"}],staticClass:"form-control",attrs:{"id":"exampleFormControlTextarea1","rows":"3"},domProps:{"value":(_vm.form.group_desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "group_desc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mt-5 form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n           "+_vm._s(_vm.form.status ? 'Disable Group' : 'Enable Group')+"\n         ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n             Edit Group\n           ")])])])])])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getGroups,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('b-button',{attrs:{"disabled":_vm.loading,"size":"md","variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row.id)}}},[_vm._v("\n             "+_vm._s(_vm.loading?"Loading...":"Edit Group")+"  \n             "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Group","visible":_vm.showModal,"width":"40%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-danger text-center font-weight-bold"},[_vm._v("Group Name and Group Description are required!")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Group Name")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.groupname),expression:"form.groupname"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.groupname)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "groupname", $event.target.value)}}})]),_c('br'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Group Description")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.group_desc),expression:"form.group_desc"}],staticClass:"form-control",attrs:{"id":"exampleFormControlTextarea1","rows":"3"},domProps:{"value":(_vm.form.group_desc)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "group_desc", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mt-5 form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n           "+_vm._s(_vm.form.status ? 'Disable Group' : 'Enable Group')+"\n         ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.createGroup}},[_vm._v("\n             Create Group\n           ")])])])])])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Group")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"},on:{"click":function($event){_vm.showModal2 = true}}},[_vm._v("\n             New Group\n           ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('Users')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupIteminfo_vue__ = __webpack_require__(1167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb76dbf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupIteminfo_vue__ = __webpack_require__(2888);
function injectStyle (ssrContext) {
  __webpack_require__(2887)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cb76dbf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GroupIteminfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb76dbf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GroupIteminfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container groupitem-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit GroupItems","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            Do you want to add device to Subgroup?\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleFormControlTextarea1"}},[_vm._v("Device ID")]),_vm._v(" "),_c('multiselect',{attrs:{"options":_vm.devices,"multiple":false,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Select Devices You want","label":"id","track-by":"id","preselect-first":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var search = ref.search;
var isOpen = ref.isOpen;
return [(values.length && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._v(_vm._s(values.length)+" options selected")]):_vm._e()]}}]),model:{value:(_vm.form.device),callback:function ($$v) {_vm.$set(_vm.form, "device", $$v)},expression:"form.device"}})],1),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n            Edit GroupItems\n          ")])])])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search","a":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getGroupItems,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions' && _vm.usertype != 'customer admin')?_c('span',[_c('b-button',{attrs:{"disabled":_vm.loading,"size":"md","variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row.id)}}},[_vm._v("\n            "+_vm._s(_vm.loading?"Loading...":"Edit GroupItems")+"  \n            "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Group Item","visible":_vm.showModal,"width":"40%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-danger text-center font-weight-bold"},[_vm._v("\n          Group Name, and Devices ID are required!\n        ")]),_vm._v(" "),_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            Do you want to add device to Subgroup?\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('multiselect',{attrs:{"options":_vm.devices,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Select Devices You want","label":"id","track-by":"id","preselect-first":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var isOpen = ref.isOpen;
return [(values.length && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._v(_vm._s(values.length)+" options selected")]):_vm._e()]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.submityy}},[_vm._v("\n              Create GroupItems\n            ")])])])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Group Devices")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n            Add Device\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('GroupIteminfo')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__(1168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3222fd2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__(2895);
function injectStyle (ssrContext) {
  __webpack_require__(2891)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3222fd2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3222fd2a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersInfo_vue__ = __webpack_require__(1169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_616b6a2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersInfo_vue__ = __webpack_require__(2894);
function injectStyle (ssrContext) {
  __webpack_require__(2893)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-616b6a2e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomersInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_616b6a2e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomersInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container customer-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit GroupItems","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            Do you want to add device to Subgroup?\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('div',[_c('multiselect',{attrs:{"options":_vm.users,"multiple":false,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Select Users You want","label":"name","track-by":"id","preselect-first":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var isOpen = ref.isOpen;
return [(values.length && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._v(_vm._s(values.length)+" options selected")]):_vm._e()]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n              Edit GroupItems\n            ")])])])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search","a":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getGroupUsers,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(
            props.column.field == 'actions' && _vm.usertype != 'customer admin'
          )?_c('span',[_c('b-button',{attrs:{"size":"md","disabled":_vm.loading,"variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row)}}},[_vm._v("\n            "+_vm._s(_vm.loading ? "Loading..." : "Edit")+"\n            "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Assign Customer","visible":_vm.showModal,"width":"40%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-center text-danger"},[_vm._v("\n          Group Name, and Emails are required!\n        ")]),_vm._v(" "),_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            Do you want to add device to Subgroup?\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('multiselect',{attrs:{"options":_vm.devices,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":"Select Users You want","label":"name","track-by":"id","preselect-first":false},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var values = ref.values;
var isOpen = ref.isOpen;
return [(values.length && !isOpen)?_c('span',{staticClass:"multiselect__single"},[_vm._v(_vm._s(values.length)+" options selected")]):_vm._e()]}}]),model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.customerSubmit}},[_vm._v("\n              Submit\n            ")])])])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Customers")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"},on:{"click":function($event){return _vm.triggerModal()}}},[_vm._v("\n            Assign Customer\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('CustomersInfo')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Email Details","visible":_vm.emailShow,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.emailShow=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Email Address"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email To"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email CC"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email Bcc"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Submit")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add SMS Details","visible":_vm.smsShow,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.smsShow=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Phone Number"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Submit")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Group","visible":_vm.centerDialogVisible2,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible2=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Group Name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Group Description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notificationShow),expression:"notificationShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.notificationShow)?_vm._i(_vm.notificationShow,null)>-1:(_vm.notificationShow)},on:{"change":function($event){var $$a=_vm.notificationShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.notificationShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.notificationShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.notificationShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Allow Notification "+_vm._s(_vm.emailShow)+" ")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subgropShow),expression:"subgropShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.subgropShow)?_vm._i(_vm.subgropShow,null)>-1:(_vm.subgropShow)},on:{"change":function($event){var $$a=_vm.subgropShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.subgropShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.subgropShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.subgropShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable Subgroup")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailShow),expression:"emailShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.emailShow)?_vm._i(_vm.emailShow,null)>-1:(_vm.emailShow)},on:{"change":function($event){var $$a=_vm.emailShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.emailShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.emailShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.emailShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable Email")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsShow),expression:"smsShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.smsShow)?_vm._i(_vm.smsShow,null)>-1:(_vm.smsShow)},on:{"change":function($event){var $$a=_vm.smsShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.smsShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.smsShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.smsShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable SMS")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Create Group")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Are you sure","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("Do you want to delete this request?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("No")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.deleteRequest(_vm.selectedRequest.id)}}},[_vm._v("Yes")])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"overlay":"","flipped":"","stuck":"","show":_vm.showInvoice},on:{"update:show":function($event){_vm.showInvoice=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showInvoice = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('svg',{staticClass:"wow-star",attrs:{"version":"1.1","viewBox":"0 0 300 300","preserveAspectRatio":"xMinYMin meet"}},[_c('foreignobject',{staticClass:"wow-star__text",attrs:{"width":"100%","height":"100%"},domProps:{"innerHTML":_vm._s(_vm.receiptData)}})])],1)]),_vm._v(" "),(_vm.usertype == 'customer super admin' || _vm.usertype == 'customer admin')?_c('div',{staticClass:"mt-5"},[_c('div',{},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Customers","name":"customers"}},[_c('div',{},[_c('Customers')],1)])],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Devices","name":"groupitems"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('GroupItem')],1)])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.usertype != 'customer super admin' && _vm.usertype !='customer admin')?_c('div',{staticClass:"mt-5"},[_c('div',{},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Group","name":"manage_requestsdd"}},[_c('Group')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Subgroup","name":"subgroup"}},[_c('div',{},[_c('Subgroup')],1)])],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Customers","name":"customers"}},[_c('div',{},[_c('Customers')],1)])],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Devices","name":"groupitems"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('GroupItem')],1)])],1)],1)],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sms_vue__ = __webpack_require__(1171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f01254_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sms_vue__ = __webpack_require__(2903);
function injectStyle (ssrContext) {
  __webpack_require__(2899)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f01254"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sms_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f01254_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sms_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsInfo_vue__ = __webpack_require__(1172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04246a92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsInfo_vue__ = __webpack_require__(2902);
function injectStyle (ssrContext) {
  __webpack_require__(2901)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04246a92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04246a92_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container sms-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit Sms","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Select Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Phone Number")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.phone),expression:"form.phone"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "phone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mt-5 form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n           "+_vm._s(_vm.form.status ? "Disable Group" : "Enable Group")+"\n         ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n             Edit Sms\n           ")])])])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search","a":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getSms,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row.id)}}},[_vm._v("\n             Edit Sms  \n             "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Sms","visible":_vm.showModal,"width":"40%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-danger text-center font-weight-bold"},[_vm._v("Group Name and Phone Numbers are required!")]),_vm._v(" "),_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],staticStyle:{"width":"100%","height":"4rem"},attrs:{"type":"number"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"height":"4rem"},on:{"click":_vm.addField}},[_vm._v("\n            Add\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',[_vm._v("Phone Numbers Selected")]),_vm._v(" "),_c('div',{},_vm._l((_vm.phoneNumbers),function(item){return _c('div',{key:item.phone},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"pb-3"},[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('div',{staticClass:"text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.removeField(item.phone)}}},[_vm._v("\n                  Remove\n                ")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.smsFunc}},[_vm._v("Submit")])])])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("SMS")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n            New SMS\n          ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('Users')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__ = __webpack_require__(1173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cebb1b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__ = __webpack_require__(2909);
function injectStyle (ssrContext) {
  __webpack_require__(2905)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3cebb1b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cebb1b6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Email_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2905 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailInfo_vue__ = __webpack_require__(1174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f441a84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailInfo_vue__ = __webpack_require__(2908);
function injectStyle (ssrContext) {
  __webpack_require__(2907)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f441a84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f441a84_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container email-table-height"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Edit Email","visible":_vm.editModal,"width":"40%"},on:{"update:visible":function($event){_vm.editModal=$event}}},[_c('form',[_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n          Do you want to edit Subgroup to Email ?\n        ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Email Address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.emailaddress),expression:"form.emailaddress"}],staticClass:"form-control",staticStyle:{"height":"5rem"},attrs:{"type":"text"},domProps:{"value":(_vm.form.emailaddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "emailaddress", $event.target.value)}}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Send Type","items":_vm.sendtypes},model:{value:(_vm.form.sendtype),callback:function ($$v) {_vm.$set(_vm.form, "sendtype", $$v)},expression:"form.sendtype"}}),_vm._v(" "),_c('div',{staticClass:"mt-5 form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status2),expression:"form.status2"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status2)?_vm._i(_vm.form.status2,"")>-1:(_vm.form.status2)},on:{"change":function($event){var $$a=_vm.form.status2,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status2", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status2", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status2", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n          "+_vm._s(_vm.form.status2 ? 'Disable Group' : 'Enable Group')+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.updateGroup}},[_vm._v("\n            Edit Email\n          ")])])])],1)])],1),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search","a":""},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"columns":_vm.fields,"rows":_vm.getEmails,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'actions')?_c('span',[_c('b-button',{attrs:{"size":"md","variant":"success"},on:{"click":function($event){return _vm.editmodal(props.row.id)}}},[_vm._v("\n            Edit Email  \n            "),_c('span',{staticClass:"fa fa-wrench"})])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Email","visible":_vm.showModal,"width":"40%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('form',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.errorGroup),expression:"errorGroup"}],staticClass:"text-danger text-center font-weight-bold"},[_vm._v("Group Name and Email Addresses are required!")]),_vm._v(" "),_c('arnergy-dynamic',{attrs:{"label":"Select Group","items":_vm.groups},on:{"subgroup":_vm.getSubgroupss},model:{value:(_vm.form.groupID),callback:function ($$v) {_vm.$set(_vm.form, "groupID", $$v)},expression:"form.groupID"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.groupID),expression:"form.groupID"}],staticClass:"form-check ml-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.status),expression:"form.status"}],staticClass:"form-check-input",attrs:{"type":"checkbox","value":"","id":"defaultCheck1"},domProps:{"checked":Array.isArray(_vm.form.status)?_vm._i(_vm.form.status,"")>-1:(_vm.form.status)},on:{"change":function($event){var $$a=_vm.form.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.form, "status", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.form, "status", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.form, "status", $$c)}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"defaultCheck1"}},[_vm._v("\n            Do you want to add Subgroup to Email ?\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.status),expression:"form.status"}]},[_c('arnergy-select',{attrs:{"label":"Subgroup","items":_vm.subgroups},model:{value:(_vm.form.subgroup),callback:function ($$v) {_vm.$set(_vm.form, "subgroup", $$v)},expression:"form.subgroup"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticStyle:{"width":"100%","height":"4rem"},attrs:{"type":"email"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"height":"4rem"},on:{"click":_vm.addField}},[_vm._v("\n            Add Email\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailAddress),expression:"emailAddress"}]},[_vm._v("Email Address Selected")]),_vm._v(" "),_c('div',{},_vm._l((_vm.emailAddress),function(item){return _c('div',{key:item.email},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"pb-3"},[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('div',{staticClass:"text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.removeField(item.email)}}},[_vm._v("Remove")])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailCC),expression:"emailCC"}],staticStyle:{"width":"100%","height":"4rem"},attrs:{"type":"email"},domProps:{"value":(_vm.emailCC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailCC=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"height":"4rem"},on:{"click":_vm.addFieldCC}},[_vm._v("\n            Add EmailCC\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailAddressCC),expression:"emailAddressCC"}]},[_vm._v("EmailCC Address Selected")]),_vm._v(" "),_c('div',{},_vm._l((_vm.emailAddressCC),function(item){return _c('div',{key:item.emailCC},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"pb-3"},[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('div',{staticClass:"text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.removeFieldCC(item.email)}}},[_vm._v("Remove")])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content align-items-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailBCC),expression:"emailBCC"}],staticStyle:{"width":"100%","height":"4rem"},attrs:{"type":"email"},domProps:{"value":(_vm.emailBCC)},on:{"input":function($event){if($event.target.composing){ return; }_vm.emailBCC=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"height":"4rem"},on:{"click":_vm.addFieldBCC}},[_vm._v("\n            Add Email BCC\n          ")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailAddressBCC),expression:"emailAddressBCC"}]},[_vm._v("EmailBCC Address Selected")]),_vm._v(" "),_c('div',{},_vm._l((_vm.emailAddressBCC),function(item){return _c('div',{key:item.emailBCC},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"pb-3"},[_vm._v(_vm._s(item.email))]),_vm._v(" "),_c('div',{staticClass:"text-danger",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.removeFieldBCC(item.email)}}},[_vm._v("Remove")])])])}),0)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.emailFunc}},[_vm._v("Submit")])])])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("New User")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Email")]),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"user"}},[_c('span',{staticStyle:{"display":"flex","align-items":"center"}},[_c('button',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n              New Email\n            ")])])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('Users')],1),_vm._v(" "),_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}})],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Email Details","visible":_vm.emailShow,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.emailShow=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Email Address"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email To"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email CC"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Email Bcc"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Submit")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add SMS Details","visible":_vm.smsShow,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.smsShow=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Phone Number"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Submit")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Add Group","visible":_vm.centerDialogVisible2,"width":"40%","top":"20vh","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible2=$event}}},[_c('div',[_c('form',[_c('arnergy-input',{attrs:{"error":_vm.formErrors.name,"label":"Group Name"},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"error":_vm.formErrors.description,"label":"Group Description"},model:{value:(_vm.form.description),callback:function ($$v) {_vm.$set(_vm.form, "description", $$v)},expression:"form.description"}}),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notificationShow),expression:"notificationShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.notificationShow)?_vm._i(_vm.notificationShow,null)>-1:(_vm.notificationShow)},on:{"change":function($event){var $$a=_vm.notificationShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.notificationShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.notificationShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.notificationShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Allow Notification "+_vm._s(_vm.emailShow)+" ")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.subgropShow),expression:"subgropShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.subgropShow)?_vm._i(_vm.subgropShow,null)>-1:(_vm.subgropShow)},on:{"change":function($event){var $$a=_vm.subgropShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.subgropShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.subgropShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.subgropShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable Subgroup")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.emailShow),expression:"emailShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.emailShow)?_vm._i(_vm.emailShow,null)>-1:(_vm.emailShow)},on:{"change":function($event){var $$a=_vm.emailShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.emailShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.emailShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.emailShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable Email")])]),_vm._v(" "),_c('div',{staticClass:"form-group form-check ml-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.smsShow),expression:"smsShow"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"exampleCheck1"},domProps:{"checked":Array.isArray(_vm.smsShow)?_vm._i(_vm.smsShow,null)>-1:(_vm.smsShow)},on:{"change":function($event){var $$a=_vm.smsShow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.smsShow=$$a.concat([$$v]))}else{$$i>-1&&(_vm.smsShow=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.smsShow=$$c}}}}),_vm._v(" "),_c('label',{staticClass:"form-check-label",attrs:{"for":"exampleCheck1"}},[_vm._v("Enable SMS")])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-primary"},[_vm._v("Create Group")])])],1)])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Are you sure","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("Do you want to delete this request?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("No")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.deleteRequest(_vm.selectedRequest.id)}}},[_vm._v("Yes")])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"overlay":"","flipped":"","stuck":"","show":_vm.showInvoice},on:{"update:show":function($event){_vm.showInvoice=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showInvoice = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('svg',{staticClass:"wow-star",attrs:{"version":"1.1","viewBox":"0 0 300 300","preserveAspectRatio":"xMinYMin meet"}},[_c('foreignobject',{staticClass:"wow-star__text",attrs:{"width":"100%","height":"100%"},domProps:{"innerHTML":_vm._s(_vm.receiptData)}})])],1)]),_vm._v(" "),(_vm.usertype != 'customer super admin' && _vm.usertype !='customer admin')?_c('div',{staticClass:"mt-5"},[_c('div',{},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Email","name":"manage_requestsdd"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('Group')],1)])],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"SMS","name":"manage_requests"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('Subgroup')],1)])],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.usertype == 'customer super admin' || _vm.usertype =='customer admin')?_c('div',{staticClass:"mt-5"},[_c('div',{},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Email","name":"manage_requestsdd"}},[_c('div',{staticClass:"d-flex justify-content-end"},[_c('Group')],1)])],1)],1)],1)]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}}),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("User ")]),_vm._v(" "),(_vm.usertype != 'customer admin')?_c('div',{staticStyle:{"display":"flex","margin-right":"20px"}},[_c('span',{staticStyle:{"flex":"1","align-items":"center"}},[_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":"/user/new"}},[_vm._v("New User")])],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('can',{attrs:{"I":"read","a":"user"}},[_c('Users')],1)],1)])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2913 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"Are you sure","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("Do you want to delete this request?")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("No")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.deleteRequest(_vm.selectedRequest.id)}}},[_vm._v("Yes")])],1)])],1),_vm._v(" "),_c('vk-offcanvas',{attrs:{"overlay":"","flipped":"","stuck":"","show":_vm.showInvoice},on:{"update:show":function($event){_vm.showInvoice=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showInvoice = false}}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('svg',{staticClass:"wow-star",attrs:{"version":"1.1","viewBox":"0 0 300 300","preserveAspectRatio":"xMinYMin meet"}},[_c('foreignobject',{staticClass:"wow-star__text",attrs:{"width":"100%","height":"100%"},domProps:{"innerHTML":_vm._s(_vm.receiptData)}})])],1)]),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('vue-good-table',{attrs:{"lineNumbers":true,"columns":_vm.columns,"rows":_vm.deviceRequests,"search-options":{enabled: true,
              externalQuery: _vm.searchTerm},"pagination-options":{enabled: true}},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['firstName']) + " " + (props.row.user['lastName'])):'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'installation_name')?_c('span',[_vm._v(_vm._s(props.row['installationName'] ? ((props.row['installationName']) + " ") : ((props.row.user['firstName']) + " " + (props.row.user['lastName']))))]):_vm._e(),_vm._v(" "),(props.column.field == 'email')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['email']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'user.phone')?_c('span',[_vm._v(_vm._s(props.row.user? ((props.row.user['phoneNumber']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceType.name')?_c('span',[_vm._v(_vm._s(props.row.deviceType? ((props.row.deviceType['name']) + " ") :'--'))]):_vm._e(),_vm._v(" "),(props.column.field == 'system.capacity')?_c('span',[_vm._v(_vm._s(props.row.systemCapacity? ((props.row.systemCapacity) + "kVA") :'--'))]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))]),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('b-button-group',[_c('can',{attrs:{"I":"manage","a":"installation"}},[_c('router-link',{attrs:{"to":("/device-request/" + (props.row['id']))}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 0),expression:"props.row.status == 0"}],attrs:{"variant":"primary"}},[_vm._v("\n                    View Status  \n                    "),_c('span',{staticClass:"fa fa-check"})])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"installation"}},[_c('router-link',{attrs:{"to":("/device-request/" + (props.row['id']))}},[_c('b-button',{directives:[{name:"show",rawName:"v-show",value:(props.row.status == 1),expression:"props.row.status == 1"}],attrs:{"size":"md","variant":"info"}},[_vm._v("\n                    Approve Installation  \n                    "),_c('span',{staticClass:"fa fa-calendar"})])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"invoice"}}),_vm._v(" \n              "),_c('can',{attrs:{"I":"delete","a":"installation"}},[_c('b-button',{staticClass:"delete-btn",attrs:{"variant":"danger","size":"md"},on:{"click":function($event){_vm.selectedRequest = props.row; _vm.centerDialogVisible = true}}},[_vm._v("\n                  Delete Request  \n                  "),_c('span',{staticClass:"fa fa-trash"})]),_vm._v(" \n              ")],1)],1)],1):_vm._e()]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("\n        "+_vm._s(_vm.form.invoiceType == "initial" ? "Send Invoice" : "Create Request")+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"customer-invoice","placeholder":"--Customer Type--"},on:{"change":_vm.changeContact},model:{value:(_vm.form.invoiceType),callback:function ($$v) {_vm.$set(_vm.form, "invoiceType", $$v)},expression:"form.invoiceType"}},[_c('el-option',{attrs:{"label":"New","value":"initial"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Existing","value":"existing"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Owner"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Industry sector"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"sector-select","fetch-suggestions":_vm.sectorSearch,"placeholder":"Select sector","prefix-icon":"el-icon-suitcase"},on:{"select":_vm.sectorSelected},model:{value:(_vm.form.sector),callback:function ($$v) {_vm.$set(_vm.form, "sector", $$v)},expression:"form.sector"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.deviceRequest.installationName),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "installationName", $$v)},expression:"regDataParams.deviceRequest.installationName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Address"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.address),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "address", $$v)},expression:"regDataParams.deviceRequest.address"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Package"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Package"},on:{"change":_vm.packageSelected},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}},_vm._l((_vm.systemTypes),function(item,index){return _c('el-option',{key:((item.id) + "_package_" + index),staticStyle:{"height":"55px"},attrs:{"label":item.name,"value":item.id}},[_c('h4',{staticStyle:{"float":"left","margin":"0px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#8492a6","font-size":"13px","line-height":"20px"}},[_vm._v(_vm._s(item.description))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"System Capacity(KW)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","min":5,"max":1000},model:{value:(_vm.regDataParams.deviceRequest.systemCapacity),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "systemCapacity", $$v)},expression:"regDataParams.deviceRequest.systemCapacity"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Payment Model"}},[_c('el-radio-group',{model:{value:(_vm.regDataParams.deviceRequest.paymentModel),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "paymentModel", $$v)},expression:"regDataParams.deviceRequest.paymentModel"}},[_c('el-radio',{attrs:{"label":"OS"}},[_vm._v("OS")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"LO"}},[_vm._v("LO")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"ES"}},[_vm._v("ES")])],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":""}},[(_vm.regDataParams.deviceRequest.paymentModel == "OS")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Base price(₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.amount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "amount", $$v)},expression:"regDataParams.deviceRequest.priceModel.amount"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "ES")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e()]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Discount"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"placeholder":"Discount type"},model:{value:(_vm.discountType),callback:function ($$v) {_vm.discountType=$$v},expression:"discountType"}},[_c('el-option',{key:"discount_item_list_percent",attrs:{"label":"Percent (%)","value":"percent"}}),_vm._v(" "),_c('el-option',{key:"discount_item_list_cash",attrs:{"label":"Amount (₦)","value":"amount"}})],1),_vm._v(" "),(_vm.discountType == "percent")?_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},model:{value:(_vm.regDataParams.deviceRequest.orderDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "orderDiscount", $$v)},expression:"regDataParams.deviceRequest.orderDiscount"}},_vm._l((101),function(item){return _c('el-option',{key:(item + "_item_list"),attrs:{"label":item - 1,"value":item - 1}})}),1):_c('el-input-number',{staticStyle:{"width":"180px"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.amountDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "amountDiscount", $$v)},expression:"regDataParams.deviceRequest.amountDiscount"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.comment),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "comment", $$v)},expression:"regDataParams.deviceRequest.comment"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Terms"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.term),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "term", $$v)},expression:"regDataParams.deviceRequest.term"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send Invoice")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"active-text":"Send Invoice","inactive-text":"Don't send Invoice"},model:{value:(_vm.regDataParams.deviceRequest.sendMail),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "sendMail", $$v)},expression:"regDataParams.deviceRequest.sendMail"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("\n        \n        "+_vm._s(_vm.$can("manage", "user")
            ? "Users Management"
            : "Devices")+"\n      ")])]),_vm._v(" "),(_vm.usertype != 'customer super admin' && _vm.usertype !='customer admin')?_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[_c('el-tab-pane',{attrs:{"label":"Users","name":"users"}},[_c('Users')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Customer Group","name":"customer_group"}},[_c('ManageRequestsuser')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Notification","name":"notification"}},[_c('Notification')],1)],1)],1)],1)]):_vm._e(),_vm._v(" "),(_vm.usertype == 'customer super admin' || _vm.usertype ==  'customer admin')?_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"manage","a":"user"}},[_c('el-tab-pane',{attrs:{"label":"Users","name":"users"}},[_c('Users')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Customer Group","name":"customer_group"}},[_c('ManageRequestsuser')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Notification","name":"notification"}},[_c('Notification')],1)],1)],1)],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_admin_vue__ = __webpack_require__(1177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad428124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_admin_vue__ = __webpack_require__(2935);
function injectStyle (ssrContext) {
  __webpack_require__(2917)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad428124"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customer_admin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad428124_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customer_admin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__(1178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b39423_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__(2922);
function injectStyle (ssrContext) {
  __webpack_require__(2919)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-18b39423"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b39423_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2920 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('h1',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"heading"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"container",staticStyle:{"width":"100%"}},[_vm._t("body")],2)])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[(_vm.showModal)?_c('modal-main',{on:{"close":function($event){_vm.showModal = false}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Search Customers\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('form',[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Select")]),_vm._v(" "),_c('option',[_vm._v("Account")]),_vm._v(" "),_c('option',[_vm._v("Transaction Ref")]),_vm._v(" "),_c('option',[_vm._v("Al Customers")]),_vm._v(" "),_c('option',[_vm._v("Successful Onboarded")])])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])]),_vm._v(" "),_c('div',[_c('table',{staticClass:"table table-bordered"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.datas),function(item){return _c('tr',{key:item.id},[_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n            "+_vm._s(item.name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n            "+_vm._s(item.nuban)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n            "+_vm._s(item.accountCategory)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n            "+_vm._s(item.accountType.slice(0, 11))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v("\n            "+_vm._s(item.ticketNo)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v("\n            "+_vm._s(item.availableBal)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v("\n            "+_vm._s(item.tenor)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v("\n            "+_vm._s(item.status)+"\n          ")])])})],2)])]),_vm._v(" "),_c('div',{staticClass:"footer"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('h2',{staticClass:"page-header"},[_vm._v("Customer Onboarding")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Name")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-right text-left pr-5"},[_vm._v("\n            Nuban\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty",staticStyle:{"margin-right":"60px"}},[_vm._v("\n            Account Category\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("\n            Account Type\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("\n            Ticket Number\n          ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Available Balance")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Tenor")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Customer Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kyc_vue__ = __webpack_require__(1180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ccf9284_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kyc_vue__ = __webpack_require__(2925);
function injectStyle (ssrContext) {
  __webpack_require__(2924)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ccf9284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Kyc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ccf9284_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Kyc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2924 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"page-header"},[_vm._v("KYC Documents")]),_vm._v(" "),_c('div'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 card"},[_c('h3',[_vm._v("KYYC DOCUMENTS TYPES")]),_vm._v(" "),_c('p',[_vm._v("Means of Identification")]),_vm._v(" "),_c('ul',[_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('A',{attrs:{"href":"#"}},[_c('li',{staticClass:"text-primary"},[_vm._v("Driving License")])]),_vm._v(" "),_c('br')],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Utility Bills")]),_vm._v(" "),_c('ul',[_vm._m(1),_vm._v(" "),_c('br'),_vm._v(" "),_c('A',{attrs:{"href":"#"}},[_c('li',{staticClass:"text-primary"},[_vm._v("Nepa Bill")])]),_vm._v(" "),_c('br')],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"}),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"footer"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('li',{staticClass:"text-primary"},[_vm._v("International Passports")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('li',{staticClass:"text-primary"},[_vm._v("Waste Bill")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-8 card"},[_c('h3',{staticClass:"page-header"},[_vm._v("KYC INFORMATIONS ")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("Image: ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v("Expiry Date: ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSchedule_vue__ = __webpack_require__(1181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5921137d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSchedule_vue__ = __webpack_require__(2928);
function injectStyle (ssrContext) {
  __webpack_require__(2927)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5921137d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PaymentSchedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5921137d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PaymentSchedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2927 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[(_vm.showEdit)?_c('modal-main',{on:{"close":function($event){_vm.showEdit = false}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Edit Payment Schedule\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('form',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputEmail1"}},[_vm._v("Customer ID")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"exampleInputEmail1","aria-describedby":"emailHelp"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputPassword1"}},[_vm._v("New Amount")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","id":"exampleInputPassword1"}})])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n          Submit\n        ")])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.datas),function(item){return _c('tr',{key:item.id},[_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n        "+_vm._s(item.transactionType)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n        "+_vm._s(item.transactionReference)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v(_vm._s(item.paymentAmount))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v(_vm._s(item.actualAmount))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v(_vm._s(item.status))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"btn text-success",on:{"click":_vm.edit}},[_vm._v("Edit Payment Schedule")])])])})],2),_vm._v(" "),_c('div',{staticClass:"footer"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"page-header"},[_vm._v("Payment Schedule")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Transaction Type")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-right text-left pr-5"},[_vm._v("\n        Transaction Reference\n      ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("Payment Amount")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Actual Amount")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Transaction Status")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Actions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repayment_vue__ = __webpack_require__(1182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc6ef9e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repayment_vue__ = __webpack_require__(2931);
function injectStyle (ssrContext) {
  __webpack_require__(2930)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7fc6ef9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Repayment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7fc6ef9e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Repayment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2930 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[(_vm.showModal)?_c('modal-main',{on:{"close":function($event){_vm.showModal = false}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Search Repayment Setup\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('form',[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Select")]),_vm._v(" "),_c('option',[_vm._v("Account")]),_vm._v(" "),_c('option',[_vm._v("Transaction Ref")]),_vm._v(" "),_c('option',[_vm._v("Al Customers")]),_vm._v(" "),_c('option',[_vm._v("Successful Onboarded")])])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])])])]):_vm._e(),_vm._v(" "),(_vm.showEdit)?_c('modal-main',{on:{"close":function($event){_vm.showEdit = false}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Edit Repayment Setup\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('form',{staticStyle:{"width":"100%"}},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputEmail1"}},[_vm._v("Customer ID")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"email","id":"exampleInputEmail1","aria-describedby":"emailHelp"}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"exampleInputPassword1"}},[_vm._v("New Amount")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"password","id":"exampleInputPassword1"}})])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n          Submit\n        ")])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.datar),function(item){return _c('tr',{key:item.id},[_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.product)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.tenure)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          N"+_vm._s(item.monthlyCharge)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          N"+_vm._s(item.totalPayableAmount)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"ml-5 mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.firstName)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.lastName)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v(_vm._s(item.cardBIN + '****' + item.last4digits))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v(_vm._s(item.expirymonth + ' / ' + item.expiryyear))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap",on:{"click":_vm.edit}},[_c('span',{staticClass:"text-success"},[_vm._v("Edit Repayment")])])])})],2),_vm._v(" "),_c('div',{staticClass:"footer"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"page-header"},[_vm._v("Repayment Set Up History")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Product")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Tenure")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Monthly Charge")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Total Amount")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("First Name")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-right text-left pr-5"},[_vm._v("\n          Last Name\n        ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Card")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Expiry M/Y")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Actions")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__ = __webpack_require__(1183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c234fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__ = __webpack_require__(2934);
function injectStyle (ssrContext) {
  __webpack_require__(2933)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a3c234fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a3c234fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2933 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[(_vm.showModal)?_c('modal-main',{on:{"close":function($event){_vm.showModal = false}}},[_c('h4',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n      Search Transaction History\n    ")]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%"},attrs:{"slot":"body"},slot:"body"},[_c('form',[_c('select',{staticClass:"form-control"},[_c('option',[_vm._v("Select")]),_vm._v(" "),_c('option',[_vm._v("Account")]),_vm._v(" "),_c('option',[_vm._v("Transaction Ref")]),_vm._v(" "),_c('option',[_vm._v("Al Customers")]),_vm._v(" "),_c('option',[_vm._v("Successful Onboarded")])])]),_vm._v(" "),_c('div',{staticClass:"pt-4 text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"type":"button"},on:{"click":function($event){_vm.showModal = true}}},[_vm._v("Search")])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('br'),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.datas),function(item){return _c('tr',{key:item.id},[_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.transactionType)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n          "+_vm._s(item.transactionReference)+"\n        ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v(_vm._s(item.paymentAmount))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v(_vm._s(item.createdAt && item.createdAt.slice(0,10)))]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v(_vm._s(item.status))])])})],2),_vm._v(" "),_c('div',{staticClass:"footer"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h2',{staticClass:"page-header"},[_vm._v("Customer Transaction History")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Transaction Type")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-right text-left pr-5"},[_vm._v("\n          Transaction Reference\n        ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("Payment Amount")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("Transaction Date")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Transaction Status")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("\n        "+_vm._s(_vm.form.invoiceType == "initial" ? "Send Invoice" : "Create Request")+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"customer-invoice","placeholder":"--Customer Type--"},on:{"change":_vm.changeContact},model:{value:(_vm.form.invoiceType),callback:function ($$v) {_vm.$set(_vm.form, "invoiceType", $$v)},expression:"form.invoiceType"}},[_c('el-option',{attrs:{"label":"New","value":"initial"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Existing","value":"existing"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Owner"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Industry sector"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"sector-select","fetch-suggestions":_vm.sectorSearch,"placeholder":"Select sector","prefix-icon":"el-icon-suitcase"},on:{"select":_vm.sectorSelected},model:{value:(_vm.form.sector),callback:function ($$v) {_vm.$set(_vm.form, "sector", $$v)},expression:"form.sector"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.deviceRequest.installationName),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "installationName", $$v)},expression:"regDataParams.deviceRequest.installationName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Address"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.address),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "address", $$v)},expression:"regDataParams.deviceRequest.address"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Package"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Package"},on:{"change":_vm.packageSelected},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}},_vm._l((_vm.systemTypes),function(item,index){return _c('el-option',{key:((item.id) + "_package_" + index),staticStyle:{"height":"55px"},attrs:{"label":item.name,"value":item.id}},[_c('h4',{staticStyle:{"float":"left","margin":"0px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#8492a6","font-size":"13px","line-height":"20px"}},[_vm._v(_vm._s(item.description))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"System Capacity(KW)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","min":5,"max":1000},model:{value:(_vm.regDataParams.deviceRequest.systemCapacity),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "systemCapacity", $$v)},expression:"regDataParams.deviceRequest.systemCapacity"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Payment Model"}},[_c('el-radio-group',{model:{value:(_vm.regDataParams.deviceRequest.paymentModel),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "paymentModel", $$v)},expression:"regDataParams.deviceRequest.paymentModel"}},[_c('el-radio',{attrs:{"label":"OS"}},[_vm._v("OS")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"LO"}},[_vm._v("LO")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"ES"}},[_vm._v("ES")])],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":""}},[(_vm.regDataParams.deviceRequest.paymentModel == "OS")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Base price(₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.amount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "amount", $$v)},expression:"regDataParams.deviceRequest.priceModel.amount"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "ES")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e()]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Discount"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"placeholder":"Discount type"},model:{value:(_vm.discountType),callback:function ($$v) {_vm.discountType=$$v},expression:"discountType"}},[_c('el-option',{key:"discount_item_list_percent",attrs:{"label":"Percent (%)","value":"percent"}}),_vm._v(" "),_c('el-option',{key:"discount_item_list_cash",attrs:{"label":"Amount (₦)","value":"amount"}})],1),_vm._v(" "),(_vm.discountType == "percent")?_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},model:{value:(_vm.regDataParams.deviceRequest.orderDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "orderDiscount", $$v)},expression:"regDataParams.deviceRequest.orderDiscount"}},_vm._l((101),function(item){return _c('el-option',{key:(item + "_item_list"),attrs:{"label":item - 1,"value":item - 1}})}),1):_c('el-input-number',{staticStyle:{"width":"180px"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.amountDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "amountDiscount", $$v)},expression:"regDataParams.deviceRequest.amountDiscount"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.comment),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "comment", $$v)},expression:"regDataParams.deviceRequest.comment"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Terms"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.term),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "term", $$v)},expression:"regDataParams.deviceRequest.term"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send Invoice")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"active-text":"Send Invoice","inactive-text":"Don't send Invoice"},model:{value:(_vm.regDataParams.deviceRequest.sendMail),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "sendMail", $$v)},expression:"regDataParams.deviceRequest.sendMail"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_vm._m(0),_vm._v(" "),(_vm.usertype != 'customer super admin' && _vm.usertype !='customer admin')?_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('el-tab-pane',{attrs:{"label":"Customers","name":"customers"}},[_c('Customer')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"KYC Doucments","name":"kyc_document"}},[_c('Kyc')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Payment Schedule","name":"payment_schedule"}},[_c('PaymentSchedule')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Repayment","name":"repayment"}},[_c('Repayment')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Transactions","name":"transactions"}},[_c('Transactions')],1)],1)],1)],1)]):_vm._e()])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("\n        Customer Admin\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__ = __webpack_require__(1184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cb1b20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__ = __webpack_require__(2944);
function injectStyle (ssrContext) {
  __webpack_require__(2937)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21cb1b20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21cb1b20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2937 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_due_payments_vue__ = __webpack_require__(1185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786f16ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_due_payments_vue__ = __webpack_require__(2940);
function injectStyle (ssrContext) {
  __webpack_require__(2939)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-786f16ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_due_payments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_786f16ec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_due_payments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"","visible":_vm.showModal},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("Make Your Payment")])]),_vm._v(" "),_c('form',[_c('arnergy-input',{attrs:{"label":"First name","model":_vm.firstName,"disabled":""}}),_vm._v(" "),_c('arnergy-input',{attrs:{"model":_vm.lastName,"label":"Last name","disabled":""}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Email","model":_vm.email,"disabled":""}}),_vm._v(" "),_c('label',{staticClass:"text-dark"},[_vm._v("Amount")])],1),_vm._v(" "),_c('div',{staticClass:"paying-now"},[_c('span',[_vm._v("Paying now")]),_vm._v(" "),_c('span',[_vm._v("\n              NGN"+_vm._s((500000 + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))+"\n            ")])]),_vm._v(" "),_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.flutterwavePay}},[_vm._v("\n            Make Payment\n          ")]),_vm._v(" "),_c('div',{staticClass:"footer-lock"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "),_c('small',{staticClass:"small"},[_vm._v("\n              Payment are encrypted using 256-bit SSL\n            ")])]),_vm._v(" "),_c('p',{staticClass:"space small"},[_vm._v("\n            By clicking\n            "),_c('span',[_vm._v("\"Make Payment\"")]),_vm._v("\n            you acknowledge that you have read and agree to our\n            "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Terms of Use")]),_vm._v("\n            and\n            "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Privacy Policy")]),_vm._v("\n            ; you will e charged the same price every 12months untill you\n            cancel your membership or complete payment. You may cancel\n            subscription by accessing Account settings section on your\n            dashboard.\n          ")])])])])])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.cxTeamFields,"rows":_vm.getUsersAdmin,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v("\n            "+_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname)+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v("\n            "+_vm._s(props.row.gender + '' === '0' ? 'Female' : 'Male')+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('button',{staticClass:"btn btn-md btn-success",on:{"click":function($event){_vm.showModal = true}}},[_vm._v("\n              Pay Now  \n              "),_c('span',{staticClass:"fa fa-wrench"})])]):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Due Payments")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_schedule_vue__ = __webpack_require__(1186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a69ffc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_schedule_vue__ = __webpack_require__(2943);
function injectStyle (ssrContext) {
  __webpack_require__(2942)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87a69ffc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_schedule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a69ffc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payment_schedule_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticStyle:{"width":"100%"}},[_c('el-input',{staticStyle:{"max-width":"200px"},attrs:{"placeholder":"Type something","prefix-icon":"el-icon-search"},model:{value:(_vm.searchTerm),callback:function ($$v) {_vm.searchTerm=$$v},expression:"searchTerm"}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',[_c('vue-good-table',{attrs:{"columns":_vm.cxTeamFields,"rows":_vm.getUsersAdmin,"search-options":{ enabled: true, externalQuery: _vm.searchTerm },"pagination-options":{ enabled: true }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field == 'full_name')?_c('span',[_vm._v(_vm._s(props.row.firstname)+" "+_vm._s(props.row.lastname))]):_vm._e(),_vm._v(" "),(props.column.field == 'gender')?_c('span',[_vm._v("\n            "+_vm._s(props.row.gender + "" === "0" ? "Female" : "Male")+"\n          ")]):_vm._e(),_vm._v(" "),(props.column.field == 'actions')?_c('span',[_c('router-link',{attrs:{"to":("priviledges/" + (props.row.id))},on:{"click":_vm.pressFunc}},[_c('button',{staticClass:"btn btn-md btn-success"},[_vm._v("\n                Pay Now  \n                "),_c('span',{staticClass:"fa fa-wrench"})])])],1):_c('span',[_vm._v(_vm._s(props.row[props.column.field]))])]}},{key:"pagination-bottom",fn:function(props){return [_c('grey-pagination',{attrs:{"total":props.total,"pageChanged":props.pageChanged,"perPageChanged":props.perPageChanged}})]}}])})],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Payment Shedule ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("\n        "+_vm._s(_vm.form.invoiceType == "initial" ? "Send Invoice" : "Create Request")+"\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"form",attrs:{"model":_vm.form,"label-width":"150px","label-position":"left"}},[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Type"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"id":"customer-invoice","placeholder":"--Customer Type--"},on:{"change":_vm.changeContact},model:{value:(_vm.form.invoiceType),callback:function ($$v) {_vm.$set(_vm.form, "invoiceType", $$v)},expression:"form.invoiceType"}},[_c('el-option',{attrs:{"label":"New","value":"initial"}}),_vm._v(" "),_c('el-option',{attrs:{"label":"Existing","value":"existing"}})],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Owner"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"customer-contact","fetch-suggestions":_vm.contactSearch,"placeholder":"Search contact","prefix-icon":"el-icon-search"},on:{"select":_vm.contactSelected},model:{value:(_vm.form.contact),callback:function ($$v) {_vm.$set(_vm.form, "contact", $$v)},expression:"form.contact"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Industry sector"}},[_c('el-autocomplete',{staticClass:"inline-input",staticStyle:{"width":"100%"},attrs:{"id":"sector-select","fetch-suggestions":_vm.sectorSearch,"placeholder":"Select sector","prefix-icon":"el-icon-suitcase"},on:{"select":_vm.sectorSelected},model:{value:(_vm.form.sector),callback:function ($$v) {_vm.$set(_vm.form, "sector", $$v)},expression:"form.sector"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Installation Name"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-name","min":1},model:{value:(_vm.regDataParams.deviceRequest.installationName),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "installationName", $$v)},expression:"regDataParams.deviceRequest.installationName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Address"}},[_c('el-input',{staticStyle:{"width":"100%"},attrs:{"id":"customer-address","min":1},model:{value:(_vm.regDataParams.deviceRequest.address),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "address", $$v)},expression:"regDataParams.deviceRequest.address"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Package"}},[_c('el-select',{staticStyle:{"width":"100%"},attrs:{"placeholder":"Package"},on:{"change":_vm.packageSelected},model:{value:(_vm.form.package),callback:function ($$v) {_vm.$set(_vm.form, "package", $$v)},expression:"form.package"}},_vm._l((_vm.systemTypes),function(item,index){return _c('el-option',{key:((item.id) + "_package_" + index),staticStyle:{"height":"55px"},attrs:{"label":item.name,"value":item.id}},[_c('h4',{staticStyle:{"float":"left","margin":"0px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"left","color":"#8492a6","font-size":"13px","line-height":"20px"}},[_vm._v(_vm._s(item.description))])])}),1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"System Capacity(KW)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"controls-position":"right","min":5,"max":1000},model:{value:(_vm.regDataParams.deviceRequest.systemCapacity),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "systemCapacity", $$v)},expression:"regDataParams.deviceRequest.systemCapacity"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Payment Model"}},[_c('el-radio-group',{model:{value:(_vm.regDataParams.deviceRequest.paymentModel),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "paymentModel", $$v)},expression:"regDataParams.deviceRequest.paymentModel"}},[_c('el-radio',{attrs:{"label":"OS"}},[_vm._v("OS")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"LO"}},[_vm._v("LO")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"ES"}},[_vm._v("ES")])],1)],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":""}},[(_vm.regDataParams.deviceRequest.paymentModel == "OS")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Base price(₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.amount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "amount", $$v)},expression:"regDataParams.deviceRequest.priceModel.amount"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "LO")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.regDataParams.deviceRequest.paymentModel == "ES")?_c('div',[_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Setup Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.setupFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "setupFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.setupFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Monthly Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.monthlyFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "monthlyFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.monthlyFee"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Caution Fee (₦)"}},[_c('el-input-number',{staticStyle:{"width":"100%"},attrs:{"disabled":false,"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.priceModel.cautionFee),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest.priceModel, "cautionFee", $$v)},expression:"regDataParams.deviceRequest.priceModel.cautionFee"}})],1)],1):_vm._e()]),_vm._v(" "),_c('el-form-item',{staticClass:"form-item",attrs:{"label":"Discount"}},[_c('el-select',{staticStyle:{"width":"140px"},attrs:{"placeholder":"Discount type"},model:{value:(_vm.discountType),callback:function ($$v) {_vm.discountType=$$v},expression:"discountType"}},[_c('el-option',{key:"discount_item_list_percent",attrs:{"label":"Percent (%)","value":"percent"}}),_vm._v(" "),_c('el-option',{key:"discount_item_list_cash",attrs:{"label":"Amount (₦)","value":"amount"}})],1),_vm._v(" "),(_vm.discountType == "percent")?_c('el-select',{staticStyle:{"width":"100px"},attrs:{"placeholder":"Select"},model:{value:(_vm.regDataParams.deviceRequest.orderDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "orderDiscount", $$v)},expression:"regDataParams.deviceRequest.orderDiscount"}},_vm._l((101),function(item){return _c('el-option',{key:(item + "_item_list"),attrs:{"label":item - 1,"value":item - 1}})}),1):_c('el-input-number',{staticStyle:{"width":"180px"},attrs:{"id":"customer-price","min":1},model:{value:(_vm.regDataParams.deviceRequest.amountDiscount),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "amountDiscount", $$v)},expression:"regDataParams.deviceRequest.amountDiscount"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Description"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.comment),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "comment", $$v)},expression:"regDataParams.deviceRequest.comment"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"fo​​rm-item",attrs:{"label":"Terms"}},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8, maxRows: 12 },"placeholder":"Please input"},model:{value:(_vm.regDataParams.deviceRequest.term),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "term", $$v)},expression:"regDataParams.deviceRequest.term"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',{attrs:{"for":"p-signup-email"}},[_vm._v("Send Invoice")]),_vm._v(" "),_c('el-switch',{staticStyle:{"width":"100%"},attrs:{"active-text":"Send Invoice","inactive-text":"Don't send Invoice"},model:{value:(_vm.regDataParams.deviceRequest.sendMail),callback:function ($$v) {_vm.$set(_vm.regDataParams.deviceRequest, "sendMail", $$v)},expression:"regDataParams.deviceRequest.sendMail"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{staticClass:"customer-btn",attrs:{"type":"prim​​ary"},on:{"click":function($event){return _vm.onSubmit()}}},[_vm._v("Create")])],1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("\n        "+_vm._s(_vm.$can("create", "installation")
            ? "Customer Payment"
            : "Devices")+"\n      ")])]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('el-tab-pane',{attrs:{"label":"Payment Schedule","name":"payment_schedule"}},[_c('PaymentShedule')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"installation"}},[_c('el-tab-pane',{attrs:{"label":"Due Payment","name":"due_payment"}},[_c('Payment')],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"inventory"}},[_c('el-tab-pane',{attrs:{"label":"Transaction History","name":"transaction"}},[_c('Transaction')],1)],1)],1)],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentProcess_vue__ = __webpack_require__(1187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0cbc21c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentProcess_vue__ = __webpack_require__(2951);
function injectStyle (ssrContext) {
  __webpack_require__(2946)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f0cbc21c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentProcess_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0cbc21c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentProcess_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2946 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2947 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"text-right text-danger point",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h1',{staticClass:"text-center font-weight-bold text-danger"},[_vm._v("Transaction Already Verified")]),_vm._v(" "),_c('p',{staticClass:"text-center"}),_vm._v(" "),_c('div',[_c('div')])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2949 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"text-right text-danger point",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("\n              Close\n            ")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-check-circle-o font-weight-bold fa-4x text-success"}),_vm._v(" "),_c('p',{staticClass:"text-success font-weight-bold"},[_vm._v("Success!, "+_vm._s(_vm.message))])])]),_vm._v(" "),_c('div',[_c('div')])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"","visible":_vm.showModal,"before-close":_vm.gotoFeedback,"width":"30%"},on:{"update:visible":function($event){_vm.showModal=$event}}},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("Process Payment")])]),_vm._v(" "),_c('form',[_c('arnergy-input',{attrs:{"label":"First name","model":_vm.firstName}}),_vm._v(" "),_c('arnergy-input',{attrs:{"model":_vm.lastName,"label":"Last name"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Email","model":_vm.email}}),_vm._v(" "),_c('label',{staticClass:"text-dark"},[_vm._v("Amount")])],1),_vm._v(" "),_c('div',{staticClass:"paying-now"},[_c('span',[_vm._v("Paying now")]),_vm._v(" "),_c('span',[_vm._v("\n          NGN"+_vm._s((_vm.productAmt + "").replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))+"\n        ")])]),_vm._v(" "),_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.flutterwavePaygate}},[_vm._v("\n        Make Payment\n      ")]),_vm._v(" "),_c('div',{staticClass:"footer-lock"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "),_c('small',{staticClass:"small"},[_vm._v("\n          Payment are encrypted using 256-bit SSL\n        ")])]),_vm._v(" "),_c('p',{staticClass:"space small"},[_vm._v("\n        By clicking\n        "),_c('span',[_vm._v("\"Make Payment\"")]),_vm._v("\n        you acknowledge that you have read and agree to our\n        "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Terms of Use")]),_vm._v("\n        and\n        "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Privacy Policy")]),_vm._v("\n        ; you will e charged the same price every 12months untill you cancel\n        your membership or complete payment. You may cancel subscription by\n        accessing Account settings section on your dashboard.\n      ")])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"","visible":_vm.errorStatus,"width":"30%"},on:{"update:visible":function($event){_vm.errorStatus=$event}}},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title text-danger"},[_vm._v("Error")])]),_vm._v(" "),_c('p',{staticClass:"text-danger text-center"},[_vm._v("Email or username already exists")])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"","visible":_vm.required,"width":"30%"},on:{"update:visible":function($event){_vm.required=$event}}},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title text-danger"},[_vm._v("Error")])]),_vm._v(" "),_c('p',{staticClass:"text-danger text-center"},[_vm._v("All fields are required!")])])],1),_vm._v(" "),_c('transition',{attrs:{"css":false}},[_c('el-dialog',{attrs:{"title":"","visible":_vm.passwordMatch,"width":"30%"},on:{"update:visible":function($event){_vm.passwordMatch=$event}}},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title text-danger"},[_vm._v("Error")])]),_vm._v(" "),_c('p',{staticClass:"text-danger text-center"},[_vm._v("Passwords do not match!")])])],1),_vm._v(" "),_c('Rave',{staticStyle:{"display":"none"},attrs:{"is-production":true,"text":"Pay Now","style-class":"btn btn-primary","id":"paymentbtn","email":_vm.email,"amount":500,"reference":_vm.genRandomNumber,"rave-key":_vm.raveKey,"callback":_vm.callback,"redirectUrl":_vm.redirectUrl,"metadata":_vm.meta,"paymentOptions":"card,barter,account,ussd","payment_plan":parseInt(0),"close":_vm.close,"currency":"NGN","customerFirstname":_vm.firstName,"customerLastname":_vm.lastName,"customerPhone":_vm.phone_number}}),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Payment")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-5 col-md-5 offset-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"heading mb-5"},[_c('h2',{staticClass:"login-title"},[_vm._v("Create an account to complete payment")]),_vm._v(" "),_c('p',[_vm._v("\n              Monitor your device. Save mother Earth. Build an eco-friendly\n              environment. Do it all with Arnergy Solar. Already have an\n              account?\n              "),_c('span',[_c('router-link',{staticClass:"link",attrs:{"to":"/auth/login"}},[_vm._v("Log in")])],1)])]),_vm._v(" "),_c('form',[(_vm.passwordMatch)?_c('p',{staticClass:"text-danger text-center"},[_vm._v("\n              Password and confirm password do not match\n            ")]):_vm._e(),_vm._v(" "),(_vm.required)?_c('p',{staticClass:"text-danger text-center"},[_vm._v("\n              All fields are required!\n            ")]):_vm._e(),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"First name"},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Last name"},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Phone Number"},model:{value:(_vm.phone_number),callback:function ($$v) {_vm.phone_number=$$v},expression:"phone_number"}}),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{staticClass:"label"},[_vm._v("Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],staticClass:"input",attrs:{"type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-item"},[_c('label',{staticClass:"label"},[_vm._v("Confirm Password")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cpassword),expression:"cpassword"}],staticClass:"input",attrs:{"type":"password","placeholder":"Confirm Password","required":""},domProps:{"value":(_vm.cpassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cpassword=$event.target.value}}})]),_vm._v(" "),_c('arnergy-select',{attrs:{"label":"Customer Type","items":_vm.CT},model:{value:(_vm.customerType),callback:function ($$v) {_vm.customerType=$$v},expression:"customerType"}})],1),_vm._v(" "),_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.flutterwavePay}},[_vm._v("\n            Submit\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__ = __webpack_require__(1190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3932a04a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__ = __webpack_require__(2954);
function injectStyle (ssrContext) {
  __webpack_require__(2953)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3932a04a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Feedback_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3932a04a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Feedback_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-dialog',{attrs:{"title":"","visible":_vm.modalSucess,"width":"40%"},on:{"update:visible":function($event){_vm.modalSucess=$event}}},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title text-success"},[_vm._v("Payment Successful")])]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('p',[_vm._v("\n      Your payment was made successfully, In due time , one of our agents would contact with you shortly for the intallation, distribution and guide process.\n    ")]),_vm._v(" "),_c('a',{staticClass:"text-center",attrs:{"href":"https://arnergy.com/"}},[_c('button',{staticClass:"btn btn-md btn-info",attrs:{"size":"md"}},[_vm._v("\n                Okay\n              ")])])])]),_vm._v(" "),(_vm.modalVerify)?_c('modal-verify',{on:{"close":function($event){_vm.showModalValidated = false}}}):_vm._e(),_vm._v(" "),(_vm.modalSucess)?_c('modal-sucess',{attrs:{"message":_vm.messageSuccess},on:{"close":function($event){_vm.modalSucess = false}}}):_vm._e(),_vm._v(" "),_c('vk-offcanvas',{attrs:{"flipped":"","overlay":"","stuck":"","show":_vm.showOffCanvas},on:{"update:show":function($event){_vm.showOffCanvas=$event}}},[_c('div',[_c('vk-offcanvas-close',{on:{"click":function($event){_vm.showOffCanvas = false}}}),_vm._v(" "),_c('h3',[_vm._v("Payment")]),_vm._v(" "),_c('hr')],1)]),_vm._v(" "),_c('div',{staticClass:"col-xl-12 col-lg-5 col-md-5 offset-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xl-12 col-lg-12 col-md-12"},[_c('div',{staticClass:"container-fluid"},[_vm._m(1),_vm._v(" "),_c('form',[_c('arnergy-input',{attrs:{"label":"First name","model":_vm.firstName,"disabled":""}}),_vm._v(" "),_c('arnergy-input',{attrs:{"model":_vm.lastName,"label":"Last name","disabled":""}}),_vm._v(" "),_c('arnergy-input',{attrs:{"label":"Email","model":_vm.email,"disabled":""}}),_vm._v(" "),_c('label',{staticClass:"text-dark"},[_vm._v("Amount")])],1),_vm._v(" "),_c('div',{staticClass:"paying-now"},[_c('span',[_vm._v("Paying now")]),_vm._v(" "),_c('span',[_vm._v("\n              NGN"+_vm._s((_vm.productAmt + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,'))+"\n            ")])]),_vm._v(" "),_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.flutterwavePay}},[_vm._v("\n            Make Payment\n          ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content__header-description",staticStyle:{"display":"flex","margin-bottom":"20px"}},[_c('h2',{staticStyle:{"flex":"1"}},[_vm._v("Payment Process")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("Payment Feeback Page")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-lock"},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" "),_c('small',{staticClass:"small"},[_vm._v("\n              Payment are encrypted using 256-bit SSL\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"space small"},[_vm._v("\n            By clicking\n            "),_c('span',[_vm._v("\"Make Payment\"")]),_vm._v("\n            you acknowledge that you have read and agree to our\n            "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Terms of Use")]),_vm._v("\n            and\n            "),_c('a',{staticClass:"link",attrs:{"href":"#"}},[_vm._v("Privacy Policy")]),_vm._v("\n            ; you will e charged the same price every 12months untill you\n            cancel your membership or complete payment. You may cancel\n            subscription by accessing Account settings section on your\n            dashboard.\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f60aff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2959);
function injectStyle (ssrContext) {
  __webpack_require__(2956)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f60aff0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f60aff0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2956 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracker-container"},[_c('div',{staticClass:"tracker"},[_c('div',{staticClass:"texts"},_vm._l((_vm.tabItems),function(item){return _c('div',{key:item.title,staticClass:"section"},[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{class:item.active ? 'default-status active' : 'default-status'})])}),0),_vm._v(" "),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({height: 'inherit', background: '#4AEB76', borderRadius: '9px', width: (_vm.getProgressPercent + "%")})})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"os-layout"},[_c('onboarding-top-bar'),_vm._v(" "),_c('div',{staticClass:"onboarding-content"},[(_vm.showTracker)?_c('onboarding-progress-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems}}):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"updateStatus":_vm.updateStatus,"updateTracker":_vm.updateTracker,"updateAgreementStatus":_vm.updateAgreementStatus}})],1),_vm._v(" "),(_vm.osSection !== '/onboarding/os/finish')?_c('div',{staticClass:"buttons"},[_c('onboarding-button',{attrs:{"type":"prev","text":"Back"},on:{"onButtonClick":function($event){return _vm.buttonFunction('prev')}}}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[(_vm.osSection == '/onboarding/os/agreement')?_c('a',{staticClass:"download-button",attrs:{"href":"https://arnergy-website.s3.us-west-2.amazonaws.com/Arnergy+-+Outright+Sales+Agreement.pdf ","target":"_blank","download":""}},[_vm._v("\n        Download Agreement\n      ")]):_vm._e(),_vm._v(" "),_c('onboarding-button',{attrs:{"type":"next","text":"Continue"},on:{"onButtonClick":function($event){return _vm.buttonFunction('next')}}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSAgreement_vue__ = __webpack_require__(1194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4901c7ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSAgreement_vue__ = __webpack_require__(2962);
function injectStyle (ssrContext) {
  __webpack_require__(2961)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4901c7ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSAgreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4901c7ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSAgreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2961 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement-container"},[_c('h2',[_vm._v("Arnergy General Terms and Conditions with Outright Sales Customers")]),_vm._v(" "),(_vm.agreementCount)?_c('div',{staticClass:"terms-and-condition"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"below-agreement"},[_c('div',{staticClass:"accept-terms",on:{"click":_vm.toggleAgreementCheck}},[_c('span',{staticClass:"green-box"},[(_vm.checkAgreement)?_c('svg',{attrs:{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.7586 2.00489C13.0804 2.34979 13.0804 2.89737 12.7586 3.24227L5.52359 10.9952C5.33629 11.196 5.07182 11.2919 4.80879 11.2611C4.56725 11.2703 4.33131 11.1737 4.16035 10.9905L0.241389 6.79096C-0.0804629 6.44606 -0.0804629 5.89847 0.241389 5.55358C0.579197 5.19159 1.14011 5.19159 1.47791 5.55357L4.8441 9.16052L11.5221 2.00489C11.8599 1.6429 12.4208 1.6429 12.7586 2.00489Z","fill":"white"}})]):_vm._e()]),_vm._v(" "),_c('small',[_vm._v("Click to Accept Terms and Regulations")])]),_vm._v(" "),_c('div',{staticClass:"terms-pagination"},[_c('div',{staticClass:"button left-btn",on:{"click":function($event){return _vm.handleAgreementNavigation('minus')}}},[_c('svg',{attrs:{"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z","fill":"#0892D0"}})])]),_vm._v(" "),_c('div',{staticClass:"button right-btn",on:{"click":function($event){return _vm.handleAgreementNavigation('plus')}}},[_c('svg',{attrs:{"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.448125 7.872L4.03212 4.256L0.448125 0.655999H3.02413L6.60813 4.256L3.02413 7.872H0.448125Z","fill":"#0892D0"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column1"},[_c('p',{staticClass:"top-level"},[_vm._v("\n        In these terms and conditions (the “Terms”), “Arnergy” means Arnergy\n        Solar Limited and the “Purchaser” means you the Purchaser. Arnergy and\n        the Purchaser are also individually referred to as a Party and\n        collectively referred to as the Parties. Please read the following\n        terms before proceeding with your payment. By clicking register, the\n        Purchaser agrees to be bound by these Terms and the Terms contained\n        herein and any terms made available via a hyperlink shall constitute\n        an outright sales agreement between Arnergy and the Purchaser. By\n        choosing to purchase an Arnergy solar power system (the System) under\n        the outright-sales model, the Purchaser agrees to provide the required\n        documentation for Arnergy’s customer onboarding requirements and the\n        Purchaser agrees to be bound by these Terms.\n      ")]),_vm._v(" "),_c('p',{staticClass:"top-level"},[_vm._v("\n        Be rest assured that all information provided is treated as\n        confidential. See clause 9 (Confidentiality). Arnergy reserves the\n        right to modify these Terms at any time. Arnergy shall provide the\n        Purchaser with notice of the modifications via email communication at\n        least five (5) days before the date they become effective.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("1. Nature of the Terms")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        The Parties agree that Arnergy shall sell the System to the Purchaser\n        in consideration of the payment of the Purchase Price.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("2. Delivery and Installation")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. Upon completion of the delivery and installation of the System at\n        the agreed location (the Site) by Arnergy (the Delivery Date), the\n        Purchaser shall deliver to Arnergy the certificate of acceptance.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. Arnergy’s scope of work for the installation includes the\n        following:\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Installation of the solar panels on the roof or a location provided by\n        the Purchaser (where applicable);\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Installation of the bluebox at the Purchaser’s preferred location\n        which must be well ventilated, covered from rainfall or water; and\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Connection of the agreed loads and segregation at the distribution\n        box.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        c. It is agreed and acknowledged that, Arnergy’s scope of work for the\n        installation does not include the following:\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Rewiring of the Purchaser's facility where the wiring architecture of\n        the building is a surface wiring; and\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Interconnection of multiple buildings where the buildings electrical\n        wiring are not interconnected.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        For the out of scope work set out above, the Purchaser shall be\n        responsible for the associated work required for the successful\n        completion of the installation and the fees.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("3. Title to the System and Risk")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        Title to the System shall not pass to the Purchaser until the date\n        that the full Purchase Price has been paid to Arnergy (the Payment\n        Date). Until the Payment Date, ownership shall not pass to the\n        Purchaser and the Purchaser shall not be entitled to sell, transfer,\n        lease, charge, assign by way of security or otherwise deal in or\n        encumber the System and the relationship between Arnergy and the\n        Purchaser in respect of the System including any proceeds of sale or\n        other consideration therefore shall be a fiduciary one. The Purchaser\n        shall be responsible for physical security of the System from the\n        Delivery Date. Risk in the System shall pass to the Purchaser from the\n        Delivery Date.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("4. Purchase Price")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. The Purchase Price is payable in accordance with the following\n        milestones:\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        90% of the Purchase Price is payable upfront prior to installation of\n        the System; and\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        10% of the Purchase Price is due and payable within fourteen (14) days\n        of completion of the installation of the System.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. The Purchaser may also opt to make 100% full payment of the\n        Purchase Price prior to installation of the System.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        c. The Purchase Price is inclusive of the following: (i) the cost of\n        delivery of the System to the Site; (ii)Design, Project Management and\n        Labour Cost; and (iii) One Year Free Maintenance from the Delivery\n        Date.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("5. Warranty")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. Arnergy warrants that (i) the System is free from defects in\n        materials and workmanship for a period of five (5) years from the date\n        of installation; and (ii) it will perform the services with reasonable\n        care and skill. The Purchaser shall give notice to Arnergy as soon as\n        it is reasonably able upon becoming aware of a breach of warranty.\n        Arnergy shall as soon as it is reasonably able investigate any alleged\n        breach of warranty and in the case of a breach of warranty falling\n        within this paragraph shall remedy the same free of charge by: (i)\n        carrying out such repairs, modifications or alterations to the System;\n        and/or (ii) replacing the System or such component parts as it shall\n        in its absolute discretion think fit. The obligations of Arnergy above\n        shall be discharged between the hours of 9 am to 5.30 pm Monday to\n        Friday (bank and other public holidays excepted). Any System or\n        component parts of the System retrieved by Arnergy pursuant to this\n        paragraph (the “Retrieved System”) shall upon its replacement with a\n        substituted system or component part become the property of Arnergy\n        and the Purchaser warrants that its title to such Retrieved System\n        shall be free and unencumbered or that it shall have all necessary\n        consents and authorities to part with possession of the Retrieved\n        System. For the avoidance of doubt it is hereby stated that the term\n        \"Retrieved System\" refers to a defective removed, recovered and\n        retrieved System/component parts and not to a new System/component\n        parts installed or fitted under this warranty clause.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. Subject to clause (a) above and with the exception of the condition\n        and warranties implied by law, all other conditions, warranties, terms\n        and undertakings, express or implied, statutory or otherwise in\n        respect of the System and the provision of the services are hereby\n        excluded.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("6. Access to the Site")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        The Purchaser shall allow Arnergy and its designated personnel such\n        reasonable access to the Site as it shall from time to time require to\n        perform its obligations under these Terms.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("7. Default")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. Where the Purchaser fails to pay any sum due to Arnergy by the\n        stipulated payment dates (Payment Default), Arnergy may suspend part\n        or all of the services until the Purchaser makes payment of the\n        outstanding payment due to Arnergy.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. Where the outstanding balance payment remains unpaid for a period\n        of thirty (30) days after the stipulated payment date, Arnergy\n        reserves the right to report the default to the national credit bureau\n        and Arnergy can also provide information required to the credit bureau\n        with regards to these Terms.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("8. Termination")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        These Terms may be terminated by Arnergy in the following instances:\n        (i) where there is an unauthorized tampering or hacking of the System\n        by the Purchaser after a service suspension/System switch-off by\n        Arnergy; or (ii) where a Payment Default subsists for a period of\n        thirty (30) days after the installation date.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        The Purchaser hereby irrevocably authorises Arnergy and its designated\n        personnel to access the Site to decommission the System. The\n        decommissioning costs shall be payable by the Purchaser and 80% of the\n        Purchase Price shall be non-refundable.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("9. Confidentiality")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. Each Party shall safeguard, treat as confidential and not use for\n        the purposes of its own business any Confidential Information\n        (information of commercial value of a Party) which relates to the\n        business and affairs of either Party. Notwithstanding the above , each\n        Party may at any time disclose any Confidential Information, following\n        reasonable consultation with the other Party, if the disclosure is\n        made in good faith in the circumstances set out below and, in each\n        case, only to the extent reasonably necessary: (i) if if it is\n        required by law, the terms of a grant, a court of competent\n        jurisdiction or any government or regulatory authority; or (ii) to its\n        own employees, directors or consultants where such disclosure is\n        required for the exercise of the relevant Party’s obligations under\n        these Terms.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. In the case of a company, the Purchaser hereby grants Arnergy the\n        right to use the name and service marks of the Purchaser in its\n        marketing materials or other oral, electronic, or written promotions,\n        which shall include naming the Purchaser as a client of Arnergy and a\n        brief scope of services provided. Either Party may elect to issue a\n        press or social media promotional release related to these Terms. In\n        doing so, any release shall be approved by the other Party and such\n        approval shall not be unreasonably withheld.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("10. Miscellaneous")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        a. Variation- No variation of these Terms shall be effective unless it\n        is in writing and signed by the Parties or their authorized\n        representatives.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-title"},[_vm._v("\n        b. Severability- In the event any provision of these Terms is\n        determined to be invalid or unenforceable by ruling of an arbitrator\n        or court of competent jurisdiction, the remainder of these Terms (and\n        each of the remaining terms and conditions contained herein) shall\n        remain in full force and effect.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        No Assignment- Neither these Terms nor any of the rights of a Party\n        herein may be assigned, pledged, transferred or hypothecated without\n        the prior written consent of the other Party.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Force Majeure- If a Party is prevented from fulfilling its obligations\n        under these Terms by reason of any supervening event beyond its\n        control (including but not limited to an Act of God, Natural Disaster,\n        Pandemic or Epidemic or Civil Disorder), the Party unable to fulfil\n        its obligations shall immediately give notice in writing of this to\n        the other Party and shall do everything in its power, including but\n        not limited to accepting assistance from third parties or the other\n        Party, to resume full performance. If the period of incapacity exceeds\n        thirty (30) days , then these Terms shall also automatically terminate\n        unless Parties expressly agree otherwise in writing. The Parties shall\n        be relieved from liability under these Terms, except in relation to\n        obligations to make payments which fall due under these Terms.\n      ")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        Entire Agreement- these Terms shall constitute the entire agreement of\n        the Parties with respect to the subject matter herein, and shall\n        supersede all other prior agreements, understandings, and\n        negotiations, both written and oral, between the Parties hereto.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("11. Governing Law and Dispute Resolution")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        These Terms shall be governed by and construed in accordance with the\n        laws of the Federal Republic of Nigeria. The Parties shall endeavour\n        in good faith to resolve any such dispute through amicable discussion\n        within a period of thirty (30) days commencing on the date either\n        Party serves written notice upon the other outlining the nature and\n        substance of such dispute. Where the Parties are unable to amicably\n        settle the dispute within the thirty (30) day period, such dispute\n        shall be submitted by either or both Parties to arbitration at the\n        Lagos Multi-Door Courthouse.\n      ")]),_vm._v(" "),_c('p',{staticClass:"main-title"},[_vm._v("12. Authority")]),_vm._v(" "),_c('p',{staticClass:"sub-sub-title"},[_vm._v("\n        In the case of a company as the Purchaser, the individual that has\n        agreed electronically with these Terms for their respective company\n        warrants that they are fully authorized to do so and that they (and\n        their respective company) are thereby legally bound by all of the\n        terms and conditions hereof.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSSummary_vue__ = __webpack_require__(1195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47af28e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSSummary_vue__ = __webpack_require__(2965);
function injectStyle (ssrContext) {
  __webpack_require__(2964)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b47af28e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b47af28e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2964 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"summary"},[_c('h2',[_vm._v("Payment Summary")]),_vm._v(" "),_c('div',{staticClass:"summary-table"},[_c('div',[_c('p',[_vm._v("Product Name")]),_vm._v(" "),_c('p',{on:{"click":_vm.saveCustomerProduct}},[_vm._v(_vm._s(_vm.packageType.name))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("Product Description")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.packageType.productDescription))])]),_vm._v(" "),_c('div',{staticClass:"table-base"},[_c('p',[_vm._v("Product Amount")]),_vm._v(" "),_c('p',[_vm._v("NGN "+_vm._s(_vm.packageType.amountOS ? _vm.packageType.amountOS.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0))])])])]),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      Review the package choice and click continue to make payment!\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(313),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSFinish_vue__ = __webpack_require__(1196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7501ea3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSFinish_vue__ = __webpack_require__(2968);
function injectStyle (ssrContext) {
  __webpack_require__(2967)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7501ea3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OSFinish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7501ea3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OSFinish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish-container"},[_c('h2',[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',[_vm._v("You have successfully completed your onboarding process. \n      You are on your way to enjoying stable power supply! \n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      We are now processing your unit for installation and will call you soon to finalize the documentation and installation process. \n      An email with your purchase details has been sent to you.\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" \n      Thank you for choosing Arnergy!\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(1197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382f2a88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(2971);
function injectStyle (ssrContext) {
  __webpack_require__(2970)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-382f2a88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_382f2a88_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"os-layout"},[_c('onboarding-top-bar'),_vm._v(" "),_c('div',{staticClass:"onboarding-content"},[(_vm.showTracker)?_c('onboarding-progress-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems}}):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"updateStatus":_vm.updateStatus,"updateTracker":_vm.updateTracker,"markAsCompleted":_vm.markAsCompleted,"getCustomerProductDetails":_vm.getCustomerProductDetails,"getCustomerEmploymentDetails":_vm.getCustomerEmploymentDetails}})],1),_vm._v(" "),(_vm.loSection !== '/onboarding/lo/finish')?_c('div',{staticClass:"buttons"},[_c('onboarding-button',{attrs:{"type":"prev","text":"Back"},on:{"onButtonClick":function($event){return _vm.buttonFunction('prev')}}}),_vm._v(" "),_c('div',{staticClass:"right-buttons"},[(_vm.loSection == '/onboarding/lo/agreement')?_c('a',{staticClass:"download-button",attrs:{"href":"https://arnergy-website.s3.us-west-2.amazonaws.com/Arnergy+-+Lease+to+Own+Agreement.pdf","target":"_blank","download":""}},[_vm._v("\n        Download Agreement\n      ")]):_vm._e(),_vm._v(" "),_c('onboarding-button',{attrs:{"type":"next","text":"Continue"},on:{"onButtonClick":function($event){return _vm.buttonFunction('next')}}})],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOSummary_vue__ = __webpack_require__(1198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d57ba0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOSummary_vue__ = __webpack_require__(2974);
function injectStyle (ssrContext) {
  __webpack_require__(2973)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-87d57ba0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87d57ba0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2973 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"summary"},[_c('h2',[_vm._v("Payment Summary")]),_vm._v(" "),_c('div',{staticClass:"quantity"},[_c('label',{attrs:{"for":"quantity"}},[_vm._v("Quantity of Inverter: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantity),expression:"quantity"}],attrs:{"type":"number","name":"quantity","id":"quantity","min":"1","max":"500","width":"25%"},domProps:{"value":(_vm.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.quantity=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"summary-table"},[_c('div',[_c('p',[_vm._v("Total 1st Month Payment (payable now)")]),_vm._v(" "),_c('p',[_vm._v("\n          NGN\n          "+_vm._s(Intl.NumberFormat("en-US").format(_vm.activePackage.firstPaymentAmt))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"tabbed"},[_c('p',[_vm._v("2 Months Upfront Payment")]),_vm._v(" "),_c('p',[_vm._v("\n          NGN\n          "+_vm._s(Intl.NumberFormat("en-US").format(
              2 * +_vm.activePackage.monthlyPaymentValue
            ))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"tabbed"},[_c('p',[_vm._v("Caution fee (Refundable)")]),_vm._v(" "),_c('p',[_vm._v("\n          NGN\n          "+_vm._s(Intl.NumberFormat("en-US").format(_vm.activePackage.cautionFee))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"tabbed"},[_c('p',[_vm._v("Subsequent Monthly Payment")]),_vm._v(" "),_c('p',[_vm._v("\n          NGN\n          "+_vm._s(Intl.NumberFormat("en-US").format(
              _vm.activePackage.monthlyPaymentValue
            ))+"\n        ")]),_vm._v(" "),_c('img',{staticClass:"arrows",attrs:{"src":__webpack_require__(2975)}})])])]),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      System ownership is transferred upon meeting all lease obligations\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(313),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2975 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMTQ3IiB2aWV3Qm94PSIwIDAgMjYgMTQ3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPg0KPGxpbmUgeDE9IjAuNSIgeTE9IjIuMTg1NTdlLTA4IiB4Mj0iMC40OTk5OTQiIHkyPSIxNDMiIHN0cm9rZT0iI0ZFN0ExMSIvPg0KPHBhdGggZD0iTTI1LjM1MzYgMTQzLjM1NEMyNS41NDg4IDE0My4xNTggMjUuNTQ4OCAxNDIuODQyIDI1LjM1MzYgMTQyLjY0NkwyMi4xNzE2IDEzOS40NjRDMjEuOTc2MyAxMzkuMjY5IDIxLjY1OTcgMTM5LjI2OSAyMS40NjQ1IDEzOS40NjRDMjEuMjY5MiAxMzkuNjYgMjEuMjY5MiAxMzkuOTc2IDIxLjQ2NDUgMTQwLjE3MkwyNC4yOTI5IDE0M0wyMS40NjQ1IDE0NS44MjhDMjEuMjY5MiAxNDYuMDI0IDIxLjI2OTIgMTQ2LjM0IDIxLjQ2NDUgMTQ2LjUzNkMyMS42NTk3IDE0Ni43MzEgMjEuOTc2MyAxNDYuNzMxIDIyLjE3MTYgMTQ2LjUzNkwyNS4zNTM2IDE0My4zNTRaTTAgMTQzLjVIMjVWMTQyLjVIMFYxNDMuNVoiIGZpbGw9IiNGRTdBMTEiLz4NCjxwYXRoIGQ9Ik0yNS4zNTM2IDg4LjM1MzZDMjUuNTQ4OCA4OC4xNTgzIDI1LjU0ODggODcuODQxNyAyNS4zNTM2IDg3LjY0NjRMMjIuMTcxNiA4NC40NjQ1QzIxLjk3NjMgODQuMjY5MiAyMS42NTk3IDg0LjI2OTIgMjEuNDY0NSA4NC40NjQ1QzIxLjI2OTIgODQuNjU5NyAyMS4yNjkyIDg0Ljk3NjMgMjEuNDY0NSA4NS4xNzE2TDI0LjI5MjkgODhMMjEuNDY0NSA5MC44Mjg0QzIxLjI2OTIgOTEuMDIzNyAyMS4yNjkyIDkxLjM0MDMgMjEuNDY0NSA5MS41MzU1QzIxLjY1OTcgOTEuNzMwOCAyMS45NzYzIDkxLjczMDggMjIuMTcxNiA5MS41MzU1TDI1LjM1MzYgODguMzUzNlpNMCA4OC41SDI1Vjg3LjVIMFY4OC41WiIgZmlsbD0iI0ZFN0ExMSIvPg0KPHBhdGggZD0iTTI1LjM1MzYgMzMuMzUzNkMyNS41NDg4IDMzLjE1ODMgMjUuNTQ4OCAzMi44NDE3IDI1LjM1MzYgMzIuNjQ2NEwyMi4xNzE2IDI5LjQ2NDVDMjEuOTc2MyAyOS4yNjkyIDIxLjY1OTcgMjkuMjY5MiAyMS40NjQ1IDI5LjQ2NDVDMjEuMjY5MiAyOS42NTk3IDIxLjI2OTIgMjkuOTc2MyAyMS40NjQ1IDMwLjE3MTZMMjQuMjkyOSAzM0wyMS40NjQ1IDM1LjgyODRDMjEuMjY5MiAzNi4wMjM3IDIxLjI2OTIgMzYuMzQwMyAyMS40NjQ1IDM2LjUzNTVDMjEuNjU5NyAzNi43MzA4IDIxLjk3NjMgMzYuNzMwOCAyMi4xNzE2IDM2LjUzNTVMMjUuMzUzNiAzMy4zNTM2Wk0wIDMzLjVIMjVWMzIuNUgwVjMzLjVaIiBmaWxsPSIjRkU3QTExIi8+DQo8L3N2Zz4NCg=="

/***/ }),
/* 2976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobInformation_vue__ = __webpack_require__(1199);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e19cba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobInformation_vue__ = __webpack_require__(2980);
function injectStyle (ssrContext) {
  __webpack_require__(2977)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-66e19cba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_JobInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66e19cba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_JobInformation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 2977 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2978 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('select',{staticClass:"select-input",attrs:{"name":"selectInput"},domProps:{"value":_vm.value},on:{"change":_vm.handleInput}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.items),function(item,key){return _c('option',{key:key,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2):_c('p',[_vm._v("No items found")]),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"info-container"},[_c('div',{staticClass:"info-form"},[_c('h2',[_vm._v("Job/Business Information")]),_vm._v(" "),_c('form',{staticClass:"employment"},[_c('h4',[_vm._v("What’s your employment status?")]),_vm._v(" "),_c('input-select',{attrs:{"items":_vm.employmentOptions,"command":_vm.getCustProductDetails},model:{value:(_vm.form.employmentStatus),callback:function ($$v) {_vm.$set(_vm.form, "employmentStatus", $$v)},expression:"form.employmentStatus"}}),_vm._v(" "),_c('h4',[_vm._v("What’s your monthly income?")]),_vm._v(" "),_c('input-select',{attrs:{"items":_vm.incomeOptions,"command":_vm.getCustProductDetails},model:{value:(_vm.form.incomeRange),callback:function ($$v) {_vm.$set(_vm.form, "incomeRange", $$v)},expression:"form.incomeRange"}})],1)]),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      Kindly provide your employment status and monthly income range\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(1202),"alt":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOAgreement_vue__ = __webpack_require__(1203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5258d2fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOAgreement_vue__ = __webpack_require__(2983);
function injectStyle (ssrContext) {
  __webpack_require__(2982)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5258d2fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOAgreement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5258d2fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOAgreement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2982 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement-container"},[_c('h2',[_vm._v("STANDARD TERMS AND CONDITIONS FOR SOLAR POWER SYSTEM SERVICES")]),_vm._v(" "),(_vm.agreementCount)?_c('div',{staticClass:"terms-and-condition"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"below-agreement"},[_c('div',{staticClass:"accept-terms",on:{"click":_vm.toggleAgreementCheck}},[_c('span',{staticClass:"green-box"},[(_vm.checkAgreement)?_c('svg',{attrs:{"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M12.7586 2.00489C13.0804 2.34979 13.0804 2.89737 12.7586 3.24227L5.52359 10.9952C5.33629 11.196 5.07182 11.2919 4.80879 11.2611C4.56725 11.2703 4.33131 11.1737 4.16035 10.9905L0.241389 6.79096C-0.0804629 6.44606 -0.0804629 5.89847 0.241389 5.55358C0.579197 5.19159 1.14011 5.19159 1.47791 5.55357L4.8441 9.16052L11.5221 2.00489C11.8599 1.6429 12.4208 1.6429 12.7586 2.00489Z","fill":"white"}})]):_vm._e()]),_vm._v(" "),_c('small',[_vm._v("Click to Accept Terms and Regulations")])]),_vm._v(" "),_c('div',{staticClass:"terms-pagination"},[_c('div',{staticClass:"button left-btn",on:{"click":function($event){return _vm.handleAgreementNavigation('minus')}}},[_c('svg',{attrs:{"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z","fill":"#0892D0"}})])]),_vm._v(" "),_c('div',{staticClass:"button right-btn",on:{"click":function($event){return _vm.handleAgreementNavigation('plus')}}},[_c('svg',{attrs:{"width":"7","height":"8","viewBox":"0 0 7 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.448125 7.872L4.03212 4.256L0.448125 0.655999H3.02413L6.60813 4.256L3.02413 7.872H0.448125Z","fill":"#0892D0"}})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("\n        These standard terms and conditions apply to services rendered by\n        Arnergy Solar Limited (“Arnergy”) to a customer (the “Customer”)\n        pursuant to a contractual agreement recording the terms of the\n        engagement (the “Contract”) incorporating these standard terms and\n        conditions by reference.\n        "),_c('br')]),_c('h2',[_vm._v("1. DEFINITIONS")]),_vm._v(" "),_c('br'),_vm._v("\n        1.1. Business Day means means a day (other than a Saturday, Sunday or\n        public holiday) when banks in Lagos, Nigeria are open for general\n        business;\n        "),_c('br'),_vm._v("\n        1.2. Delivery Date means the date of installation of the System by\n        Arnergy at the Location;\n        "),_c('br'),_vm._v("\n        1.3. Location means the agreed site of the Customer where a System is\n        installed;\n        "),_c('br'),_vm._v("\n        1.4. Services means the provision of the solar power system services\n        to the Customer; and\n        "),_c('br'),_vm._v("\n        1.5. System means the solar power systems, including the solar\n        modules/panels, inverter system, battery storage, remote monitoring\n        technology and other accessories deployed by Arnergy.\n        "),_c('br'),_vm._v("\n        1.6 If there is conflict between this Standard Terms and Conditions\n        and the Contract, the Standard Terms and Conditions, will prevail.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("2. OWNERSHIP OF THE SYSTEM")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        The customer acknowledges that the System provided and installed at\n        the Location will remain the personal property of Arnergy and will\n        continue in the ownership of Arnergy for the duration of the Contract.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("3. RISK, DELIVERY AND INSTALLATION OF THE SYSTEM")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        3.1. Arnergy shall be responsible for the delivery of the System to\n        the Location and the installation, commissioning and testing of the\n        System.\n        "),_c('br'),_vm._v("\n        3.2. The customer acknowledges that the risk of loss, theft, damage,\n        or destruction to the System shall pass to the Customer upon delivery\n        and installation of the System at the Location.\n        "),_c('br'),_vm._v("\n        3.3. The delivery of the System, and acceptance by the Customer, is\n        deemed to take place on the Delivery Date. Upon the completion of the\n        delivery and installation of the System, the Customer shall present\n        Arnergy with an executed copy of the Certificate of Acceptance and by\n        doing so, the Customer will be deemed to have acknowledged delivery\n        of, and unconditionally accepted the System.\n        "),_c('br'),_vm._v("\n        3.4. Arnergy shall offer appropriate training to onboard the Customer\n        on the use of the System after the completion of delivery and\n        installation of the System.\n        "),_c('br'),_vm._v("\n        3.5. On completion of the installation of the System, Arnergy shall\n        remove any unused materials and debris generated during installation\n        from the deployment address at its own cost within two (2) days from\n        the date of completion of installation failing which the Customer may\n        proceed with the removal of such debris and Arnergy shall make a full\n        refund of the cost expended in effecting the removal.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("4. PAYMENTS")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        4.1. Arnergy’s fees shall be as agreed in the Contract.\n        "),_c('br'),_vm._v("\n        4.2. We shall invoice the Customer for payments at the beginning of\n        each month for the Services to be provided during that month. 4.3. We\n        may review the monthly payments subject to prevailing market\n        conditions. Arnergy shall promptly notify the Customer in such\n        instances.\n        "),_c('br'),_vm._v("\n        4.4. Arnergy’s monthly payments shall be payable by the Customer,\n        regardless of whether the solar power was used or unused. 4.5. The\n        Customer acknowledges that where payments fall due on a day which is\n        not a Business Day, such payments are to be made on the preceding\n        Business Day.\n        "),_c('br'),_vm._v("\n        4.6. Payments made by the Customer to Arnergy must be without any set\n        off or counterclaim and free and clear of all deductions or\n        withholdings whatsoever save only as may be required by law, in which\n        event the Customer shall pay to Arnergy such additional amount as may\n        be necessary in order that the net amount received by Arnergy after\n        deductions and withholdings will not be less than the amount Arnergy\n        would have been entitled to receive in the absence of any requirement\n        to make any deduction or withholding.\n        "),_c('br'),_vm._v("\n        4.7. In the event of non- payment by a Customer where the requisite\n        time frame for payment (five (5) days from the date of receipt of the\n        relevant invoice by the Customer) has lapsed, the Customer\n        acknowledges that Arnergy may charge interest which shall accrue each\n        day at the rate of [20%] per annum above the 30-day NIBOR (published\n        by FMDQ OTC on the due date) from the due date until the outstanding\n        payments are processed by the Customer.\n        "),_c('br'),_vm._v("\n        4.8. Should the Customer fail to effect timeous payment of the amount\n        payable, Arnergy may (without prejudice to other rights and remedies\n        of Arnergy) suspend part or all of the Services until payment has been\n        made in full.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("5. MONITORING OF THE SYSTEM, ELECTRICITY OVERLOAD AND SYSTEM REPAIRS")]),_vm._v(" "),_c('br'),_vm._v("\n        5.1. Arnergy and the Customer shall have access to round the clock\n        technology to monitor the System. This shall be at no additional cost\n        to the Customer.\n        "),_c('br'),_vm._v("\n        5.2. Arnergy shall conduct routine maintenance of the System regularly\n        and corrective maintenance where required. 5.3. The Customer\n        authorises Arnergy and its designated personnel to have access to\n        inspect the System where Arnergy has provided 12 hours prior notice to\n        the Customer by SMS or email ahead of routine maintenance inspections\n        (between the hours of 9.00am-5.00pm).\n        "),_c('br'),_vm._v("\n        5.4. Where the Customer effects an increase on the amount of\n        electricity required at the Location contrary to the agreed actual\n        load without prior notice to Arnergy, such an increase/extra load\n        shall be prorated based on the monthly charges payable by the\n        Customer.\n        "),_c('br'),_vm._v("\n        5.5. Arnergy shall maintain and repair the System at no additional\n        cost to the Customer, unless the damage to the System was caused by\n        negligence or willful misconduct of the Customer and/or its\n        affiliates, in which case, the Customer shall bear the cost for repair\n        and replacing all worn and damaged parts of the System.\n        "),_c('br'),_vm._v("\n        5.6. Only authorised personnel of Arnergy are permitted to repair the\n        System.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("6. MAINTENANCE AND WARRANTY COVER")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        6.1 Where any corrective maintenance is required within working hours,\n        it shall be done within twenty-four (24) hours of Arnergy’s awareness\n        of such corrective maintenance or repair. Provided that, where\n        corrective maintenance is reported after 5pm on a business day, it\n        shall be done within twenty-four (24) hours from start of business on\n        the next business day.\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        6.2 Arnergy warrants that the System, described in schedule 1 of the\n        Contract is free from defects in materials and workmanship for a\n        period of Seven (7) years from the Effective Date. This warranty shall\n        not apply to an abuse, damage, alteration or misuse of the System by\n        the gross negligence or willful misconduct of the Customer. Arnergy\n        shall not be liable to the Customer, whether in contract, tort\n        (including negligence), breach of statutory duty, or otherwise, for\n        any loss of profit, or for any indirect or consequential loss arising\n        under or in connection with the Contract or the Customer’s use of the\n        System.\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("7. DEFAULT AND ACCESS TO DECOMMISSION THE SYSTEM")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        7.1. In the event of any willful or negligent damage to the System, or\n        consistent two (2) months failure to make payments due to Arnergy, the\n        Customer acknowledges that the caution fee shall be applied for the\n        month of default for a maximum period of two (2) months.\n        "),_c('br'),_vm._v("\n        7.2. The Customer acknowledges that Arnergy shall be entitled to\n        decommission the System from the Location in the below instances:\n        "),_c('br'),_vm._v("\n        7.2.1. Willful or negligent damage to the System by the Customer/and\n        or its affiliates and the Customer is reluctant to bear responsibility\n        for repairs;\n        "),_c('br'),_vm._v("\n        7.2.2. Default in monthly payments for three (3) months; or\n        "),_c('br'),_vm._v("\n        7.2.3. Complete abandonment of the System.\n        "),_c('br'),_vm._v("\n        7.3. The Customer authorises Arnergy and its designated personnel to\n        have access to decommission the System where Arnergy has provided 12\n        hours prior notice to the Customer by SMS or email ahead of routine\n        maintenance inspections (between the hours of 9.00am-5.00pm).\n        "),_c('br'),_vm._v("\n        7.4. Where Arnergy is unable to take possession of the System, the\n        Customers shall be liable to pay to Arnergy N500,000.00 as default\n        rate for each day which the Customer remains in possession of the\n        System. Until the System has been returned or repossessed, the\n        Customer shall be solely responsible for its safe keeping.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("8. SWITCH TO ALTERNATIVE BUSINESS MODEL AND SYSTEM UPGRADE")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        8.1. Subject to Arnergy’s consent, the Customer may opt to switch to\n        an alternative business model of Arnergy. In such cases, any necessary\n        amendments to the engagement with the Customer shall be forward\n        looking and shall have no bearing on payments already made by the\n        Customer for services rendered in previous months.\n        "),_c('br'),_vm._v("\n        8.2. Subject to Arnergy’s consent, the Customer may also opt to\n        upgrade to a higher System, and Arnergy will review such request\n        provided the Customer has consistently paid the monthly charges for a\n        period of not less than twelve (12) months prior to the date of the\n        Customer’s request for an upgrade. The Customer may be required to pay\n        the difference in the set up fee earlier made and the current set up\n        fee for the upgraded System. The Customer may also opt to downgrade\n        the System and Arnergy will review such request provided the Customer\n        has consistently paid the monthly charges for a period of not less\n        than six (6) months prior to the date of the Customer’s request for a\n        downgrade.\n        "),_c('br'),_vm._v(" "),_c('h2',[_vm._v("9. DISPOSAL OF SYSTEM")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        9.1. Where the Customer has possession of a System under an agreement\n        with Arnergy, and wishes to dispose of the System having purchased the\n        System, the Customer is required to comply with Arnergy's recommended\n        disposal procedure, and failure to comply with the recommended\n        disposal procedure, shall not make Arnergy liable.\n        "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n        9.2. The System is considered an electronic device for disposal in\n        accordance with Nigerian laws and may not be disposed of as domestic\n        waste. Therefore:\n        "),_c('br'),_vm._v("\n        ● Customer shall use only designated channels for disposing the\n        devices;\n        "),_c('br'),_vm._v("\n        ● Customer shall comply with all local and currently applicable laws\n        and regulations.\n        "),_c('br'),_vm._v(" "),_c('p')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankStatement_vue__ = __webpack_require__(1204);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a22b41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankStatement_vue__ = __webpack_require__(3004);
function injectStyle (ssrContext) {
  __webpack_require__(2985)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69a22b41"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BankStatement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69a22b41_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BankStatement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 2985 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputBank_vue__ = __webpack_require__(1205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122b0bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputBank_vue__ = __webpack_require__(2988);
function injectStyle (ssrContext) {
  __webpack_require__(2987)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0122b0bb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InputBank_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0122b0bb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InputBank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.items && _vm.items.length > 0)?_c('select',{staticClass:"select-input",attrs:{"name":"selectInput"},on:{"change":_vm.handleInput}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Select Option")]),_vm._v(" "),_vm._l((_vm.items),function(item,key){return _c('option',{key:key,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2):_c('p',[_vm._v("No items found")]),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[_c('input',{staticClass:"input",attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"required":"","disabled":_vm.disabled,"autocomplete":_vm.autocomplete},domProps:{"value":_vm.model},on:{"input":_vm.handleInput}}),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2991 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracker-container"},[_c('div',{staticClass:"tracker"},[_c('div',{staticClass:"texts"},_vm._l((_vm.tabItems),function(item){return _c('div',{key:item.title,staticClass:"section"},[_c('p',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('div',{class:item.active ? 'default-status active' : 'default-status'})])}),0),_vm._v(" "),_c('div',{staticClass:"progress-container"},[_c('div',{staticClass:"progress-bar",style:({height: 'inherit', background: '#FE7A11', borderRadius: '9px', width: (_vm.getProgressPercent + "%")})})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNotify_vue__ = __webpack_require__(1209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69e881e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNotify_vue__ = __webpack_require__(2995);
function injectStyle (ssrContext) {
  __webpack_require__(2994)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a69e881e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModalNotify_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a69e881e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModalNotify_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2994 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('h1',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_c('img',{attrs:{"src":"http://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Error.svg/497px-Error.svg.png","alt":" ","width":"50"}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('p',{attrs:{"className":"text-success"}},[_vm._v(_vm._s(_vm.notifyMsg ? _vm.notifyMsg : "Error in connection!")+" ")])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(1210);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f710f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__ = __webpack_require__(2998);
function injectStyle (ssrContext) {
  __webpack_require__(2997)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30f710f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30f710f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 2997 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-body"},[_c('div',[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("Confirm Request")]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_vm._v("\n          Please note, You would be charged from your bank account to get your bank statement, click the button below to continue\n        ")])]),_vm._v(" "),_c('div',[(_vm.modalstate)?_c('div',{attrs:{"className":"text-center"}},[_c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])]):_c('div',[_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('confirmRequest')}}},[_vm._v("\n          Continue to get bank statement\n        ")])])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 2999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"text-right"},[_c('p',{staticClass:"text-right text-danger point",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"d-flex justify-content-center align-items-center"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-times font-weight-bold fa-4x text-danger"}),_vm._v(" "),_c('p',{staticClass:"text-danger font-weight-bold"},[_vm._v("Error!, "+_vm._s(_vm.modalstateError))])])]),_vm._v(" "),_c('div',[_c('div')])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnergyBank_vue__ = __webpack_require__(1212);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3fcde22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnergyBank_vue__ = __webpack_require__(3003);
function injectStyle (ssrContext) {
  __webpack_require__(3002)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f3fcde22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnergyBank_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3fcde22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnergyBank_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 3002 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-item"},[(_vm.label)?_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('select',{staticClass:"select-input",attrs:{"name":"selectInput"},on:{"change":_vm.handleInput}},[_c('option',{attrs:{"disabled":"","selected":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_vm._l((_vm.items),function(item,key){return _c('option',{key:key,domProps:{"value":item.id}},[_vm._v(_vm._s(item.name))])})],2):_c('p',[_vm._v("No items found")]),_vm._v(" "),(_vm.error)?_c('small',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"summary"},[_c('h2',[_vm._v("Request for Bank Statement")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}]},[(_vm.showRetry)?_c('div',[_c('h4',[_vm._v("Make Request")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('p',[_vm._v("\n          Your request is being treated, please wait for 5 - 10mins to receive\n          your ticket number and password.\n        ")]),_vm._v(" "),_c('div',{staticClass:"footer"},[(_vm.loader1)?_c('div',{attrs:{"className":"text-center"}},[_vm._m(0)]):_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":_vm.retryRequest}},[_vm._v("\n              Input\n            ")])])])],1):_c('div',[_c('h4',[_vm._v("Make Request")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h3',[_vm._v("\n          For GT and Zenith bank customers, click\n          "),_c('a',{style:(_vm.GTpdf),attrs:{"href":"https://res.cloudinary.com/mentor-africa-project/image/upload/v1647451517/GTZenithworkaround.pdf","target":"_blank"}},[_vm._v("\n            here\n          ")]),_vm._v("\n          for the steps to submit bank statement.\n        ")]),_vm._v(" "),_c('form',[_c('h4',[_vm._v("Bank")]),_vm._v(" "),_c('input-bank',{attrs:{"items":_vm.banks,"error":_vm.formErrors.bank},on:{"getLinked":_vm.getLink},model:{value:(_vm.form.bank),callback:function ($$v) {_vm.$set(_vm.form, "bank", $$v)},expression:"form.bank"}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getLinkData),expression:"getLinkData"}]},[_c('h4',[_vm._v("\n              Phone Number (Please ensure it is registered with your account\n              number)\n            ")]),_vm._v(" "),_c('input-field',{attrs:{"model":_vm.form.phoneNumber},model:{value:(_vm.form.phoneNumber),callback:function ($$v) {_vm.$set(_vm.form, "phoneNumber", $$v)},expression:"form.phoneNumber"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getLinkData == 'Y'),expression:"getLinkData == 'Y'"}]},[_c('h4',[_vm._v("Account Number")]),_vm._v(" "),_c('input-field',{attrs:{"error":_vm.formErrors.accountNo},model:{value:(_vm.form.accountNo),callback:function ($$v) {_vm.$set(_vm.form, "accountNo", $$v)},expression:"form.accountNo"}})],1)],1),_vm._v(" "),(_vm.loader)?_c('div',{staticClass:"download-button"},[_vm._m(2)]):_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":_vm.makeRequest}},[_vm._v("\n            Make Request\n          ")])])],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}]},[_c('h4',[_vm._v("Confirm Action")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('p',{staticStyle:{"max-width":"740px","text-align":"center"}},[_vm._v("\n        "+_vm._s(_vm.message)+". For GT & Zenith customers, kindly input the details\n        shown on your banking platform.\n      ")]),_vm._v(" "),_c('form',[_c('h4',[_vm._v("Ticket ID")]),_vm._v(" "),_c('input-field',{attrs:{"error":_vm.formErrors.ticketId,"label":"Ticket ID","type":"text","autocomplete":"nopenklnglnmgdlmlmdlmlmlfml","name":"ticket123","id":"ticket123"},model:{value:(_vm.form.ticketId),callback:function ($$v) {_vm.$set(_vm.form, "ticketId", $$v)},expression:"form.ticketId"}}),_vm._v(" "),_c('h4',[_vm._v("Password")]),_vm._v(" "),_c('input-field',{attrs:{"error":_vm.formErrors.password,"label":"Password","type":"password","name":"pass123","id":"pass123","autocomplete":"new-password"},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1),_vm._v(" "),(_vm.loaderConfirm)?_c('div',{attrs:{"className":"text-center"}},[_vm._m(3)]):_c('div',[_c('button',{staticClass:"download-button-wide",attrs:{"type":"button"},on:{"click":_vm.confirmRequest}},[_vm._v("\n          Process Request\n        ")])])],1),_vm._v(" "),(_vm.showModal)?_c('modal',{attrs:{"modalstate":_vm.loader},on:{"confirmRequest":_vm.confirmRequestModal,"close":function($event){_vm.showModal = false}}}):_vm._e(),_vm._v(" "),(_vm.showModalError)?_c('modal-error',{attrs:{"modalstateError":_vm.messageModal},on:{"close":function($event){_vm.showModalError = false}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 2),expression:"activeIndex == 2"}]},[_c('h4',[_vm._v("Summary")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary-table"},[_c('div',[_c('p',[_vm._v("Name")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.summary.name))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("Nuban")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.summary.nuban))])]),_vm._v(" "),_c('div',[_c('p',[_vm._v("Available Balance")]),_vm._v(" "),_c('p',[_vm._v("\n              NGN\n              "+_vm._s(new Intl.NumberFormat("en-US").format(_vm.summary.availableBal))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"table-base"},[_c('p',{staticStyle:{"color":"black"}},[_vm._v("Statement Passed")]),_vm._v(" "),(_vm.summary.statementOk)?_c('p',{staticStyle:{"font-weight":"bold","color":"green"}},[_vm._v("\n              true\n            ")]):_c('p',{staticStyle:{"font-weight":"bold","color":"red"}},[_vm._v("false")])])])]),_vm._v(" "),(!_vm.bankRequestPassed())?_c('p',{staticStyle:{"color":"red","text-align":"center","margin":"10px auto"}},[_vm._v("\n        Unfortunately, you can't proceed with your request! Please try another\n        account.\n      ")]):_c('p',{staticStyle:{"color":"green","text-align":"center","margin":"10px auto"}},[_vm._v("\n        You have passed the bank statement check! Kindly click continue to\n        proceed.\n      ")]),_vm._v(" "),(!_vm.bankRequestPassed())?_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":function($event){(_vm.activeIndex = 0), (_vm.showRetry = false)}}},[_vm._v("\n        Retry\n      ")]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"illustration"},[_vm._m(4),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(313),"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem","max-width":"17vw"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Processing...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n          Please fill the form to submit bank statement. This will help us\n          determine if you’ll be accepted or not.\n          "),_c('br'),_vm._v(" "),_c('i',{staticStyle:{"fontSize":"12px","marginLeft":"25%"}},[_vm._v("NB: Six (6) months bank statement would be shared with Arnergy")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",staticStyle:{"margin":"auto"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-button"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"description"},[_vm._v("\n      Kindly fill in your bank details. "),_c('br'),_vm._v("\n      Your details are encrypted and safe with us.\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheck_vue__ = __webpack_require__(1213);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fd3604_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheck_vue__ = __webpack_require__(3007);
function injectStyle (ssrContext) {
  __webpack_require__(3006)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35fd3604"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35fd3604_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheck_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3006 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"agreement-container"},[_c('h2',[_vm._v("Credit Check")]),_vm._v(" "),_c('p',[_vm._v("\n      Please enter your BVN to check if you are eligible for this service.\n    ")]),_vm._v(" "),(_vm.modalSucess)?_c('modal-sucess',{attrs:{"message":_vm.messageSuccess},on:{"close":function($event){_vm.modalSucess = false}}}):_vm._e(),_vm._v(" "),(_vm.showModalError)?_c('modal-error',{attrs:{"modalstateError":_vm.messageModal},on:{"close":function($event){_vm.showModalError = false}}}):_vm._e(),_vm._v(" "),_c('form',[_c('h4',[_vm._v("Bank Verification Number (BVN)")]),_vm._v(" "),_c('input-field',{attrs:{"error":_vm.formErrors.bvn},model:{value:(_vm.form.bvn),callback:function ($$v) {_vm.$set(_vm.form, "bvn", $$v)},expression:"form.bvn"}})],1),_vm._v(" "),(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_vm._m(0)]):_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":_vm.makeRequest}},[_vm._v("\n        Make Request\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      Kindly input your BVN to enable us run a credit check\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(1202),"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-button"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KYC_vue__ = __webpack_require__(1214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fce7460_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KYC_vue__ = __webpack_require__(3012);
function injectStyle (ssrContext) {
  __webpack_require__(3009)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1fce7460"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KYC_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1fce7460_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KYC_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3009 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3011 */,
/* 3012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"agreement-container"},[_c('h2',[_vm._v("KYC Upload")]),_vm._v(" "),_c('p',[_vm._v("Please upload all the required documents.")]),_vm._v(" "),(_vm.modalSucess)?_c('modal-sucess',{attrs:{"message":_vm.messageSuccess},on:{"close":function($event){_vm.modalSucess = false}}}):_vm._e(),_vm._v(" "),(_vm.showModalError)?_c('modal-error',{attrs:{"modalstateError":_vm.messageModal},on:{"close":function($event){_vm.showModalError = false}}}):_vm._e(),_vm._v(" "),_c('form',[_c('div',{staticClass:"kyc-row"},[_c('div',{staticClass:"first"},[_c('h4',[_vm._v("Means of Identification")]),_vm._v(" "),_c('input-select',{attrs:{"items":_vm.mois},model:{value:(_vm.form.moi),callback:function ($$v) {_vm.$set(_vm.form, "moi", $$v)},expression:"form.moi"}})],1),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Choose Image")]),_vm._v(" "),_c('div',{staticClass:"image-upload"},[_c('p',{staticClass:"image-name"},[_vm._v(_vm._s(this.image.name))]),_vm._v(" "),_c('input',{ref:"moi_file",staticClass:"image-upload-button",attrs:{"type":"file","id":"file","accept":"image/*"},on:{"change":_vm.handleFileUpload}}),_vm._v(" "),_c('label',{attrs:{"for":"file"}},[_vm._v("Choose Image")])])])]),_vm._v(" "),_c('h4',[_vm._v("Select Expiry Date")]),_vm._v(" "),_c('date-picker',{staticClass:"date-upload",attrs:{"default-value":new Date(),"disabled-date":_vm.disabledBeforeTodayAndAfterAWeek},model:{value:(_vm.value1),callback:function ($$v) {_vm.value1=$$v},expression:"value1"}}),_vm._v(" "),_c('div',{staticClass:"kyc-row"},[_c('div',{staticClass:"first"},[_c('h4',[_vm._v("Utility Bill")]),_vm._v(" "),_c('input-select',{attrs:{"items":_vm.utilities},model:{value:(_vm.form.utility),callback:function ($$v) {_vm.$set(_vm.form, "utility", $$v)},expression:"form.utility"}})],1),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Choose Image")]),_vm._v(" "),_c('div',{staticClass:"image-upload"},[_c('p',{staticClass:"image-name"},[_vm._v(_vm._s(this.image2.name))]),_vm._v(" "),_c('input',{ref:"utility_file",staticClass:"image-upload-button",attrs:{"type":"file","id":"file2","accept":"image/*"},on:{"change":_vm.handleFileUpload2}}),_vm._v(" "),_c('label',{attrs:{"for":"file2"}},[_vm._v("Choose Image")])])])])],1),_vm._v(" "),(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_vm._m(0)]):_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":_vm.makeRequest}},[_vm._v("\n        Submit\n      ")])])],1),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      Kindly upload a means of identification and your utility bill.\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(313),"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-button"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayDeposit_vue__ = __webpack_require__(1215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_812d00d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayDeposit_vue__ = __webpack_require__(3021);
function injectStyle (ssrContext) {
  __webpack_require__(3014)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-812d00d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayDeposit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_812d00d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayDeposit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3014 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Consent_vue__ = __webpack_require__(1216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3772f04d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Consent_vue__ = __webpack_require__(3017);
function injectStyle (ssrContext) {
  __webpack_require__(3016)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3772f04d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Consent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3772f04d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Consent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("\n                Do you want to set up recurring repayment ?\n              ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"d-flex justify-content-between align-items-center"},[_c('button',{staticClass:"submit-button mr-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('consent', 'N')}}},[_vm._v("\n                  NO\n                ")]),_vm._v(" "),_c('button',{staticClass:"submit-button ml-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('consent', 'Y')}}},[_vm._v("\n                  YES\n                ")])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableModal_vue__ = __webpack_require__(1217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249fe88c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableModal_vue__ = __webpack_require__(3020);
function injectStyle (ssrContext) {
  __webpack_require__(3019)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-249fe88c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249fe88c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3019 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent-box"},[_c('transition',{attrs:{"name":"modal"}},[_c('div',{},[_c('div',{staticClass:"modal-wrapper"},[_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_c('h1',{staticClass:"close-btn",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"heading"},[_c('h2',{staticClass:"login-title"},[_vm._v("RePayment Information")])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('tr',[_c('th',{staticClass:"text-nowrap mr-5"},[_vm._v("Monthly Charge")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-right text-left pr-5"},[_vm._v("\n                  Repayment Date\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty",staticStyle:{"margin-right":"60px"}},[_vm._v("\n                  Outstanding Balance\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap mr-5 go-righty text-left"},[_vm._v("\n                  Outstanding Tenure\n                ")]),_vm._v(" "),_c('th',{staticClass:"text-nowrap"},[_vm._v("Payment status")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n                  NGN"+_vm._s(Intl.NumberFormat("en-US").format(
                      Number(_vm.tableDatas.monthlyCharge)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n                  "+_vm._s(_vm.tableDatas.startingDate
                      ? new Date(_vm.tableDatas.startingDate).toLocaleDateString(
                          undefined,
                          _vm.dateOptions
                        )
                      : "")+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n                  NGN"+_vm._s(Intl.NumberFormat("en-US").format(
                      _vm.tableDatas.totalPayableAmount -
                        Number(_vm.tableDatas.initialPaymentAmount)
                    ))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap text-center"},[_vm._v("\n                  "+_vm._s(Number(_vm.tableDatas.tenure) - 1)+" Months\n                ")]),_vm._v(" "),_c('td',{staticClass:"mr-5 text-nowrap"},[_vm._v("\n                  "+_vm._s(_vm.tableDatas.initialPaymentMade ? "Paid" : "Not Paid")+"\n                ")])])])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"summary-container"},[_c('div',{staticClass:"summary"},[_c('h2',[_vm._v("Pay Deposit")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 0),expression:"activeIndex == 0"}]},[_c('div',[_c('h4',[_vm._v("Pay Initial Deposit")]),_vm._v(" "),_c('i',{staticStyle:{"fontSize":"14px","font-weight":"bold","color":"red"}},[_vm._v("NB: Card used for payment would be set as default for recurring\n          payments!")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":_vm.activeIndex}}),_vm._v(" "),_c('form',[_c('div',{staticClass:"kyc-row"},[_c('div',{staticClass:"first"},[_c('h4',[_vm._v("First Name")]),_vm._v(" "),_c('input-field',{attrs:{"model":_vm.getUserSession.firstname,"disabled":""}})],1),_vm._v(" "),_c('div',{staticClass:"first"},[_c('h4',[_vm._v("Last Name")]),_vm._v(" "),_c('input-field',{attrs:{"model":_vm.getUserSession.lastname,"disabled":""}})],1)]),_vm._v(" "),_c('h4',[_vm._v("Email Address")]),_vm._v(" "),_c('input-field',{attrs:{"model":_vm.getUserSession.email,"disabled":""}}),_vm._v(" "),_c('p',{staticStyle:{"margin-bottom":"20px"}},[_vm._v("\n            Paying Now\n            "),_c('span',{staticClass:"amount"},[_vm._v("\n              NGN\n              "+_vm._s(_vm.firstpaymentamt)+"\n            ")])])],1),_vm._v(" "),(_vm.loader)?_c('div',{attrs:{"className":"text-center"}},[_vm._m(0)]):_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":_vm.flutterwavePaygate}},[_vm._v("\n            Make Payment\n          ")])])],1)]),_vm._v(" "),(_vm.showModalValidated)?_c('modal-verify',{on:{"close":function($event){_vm.showModalValidated = false}}}):_vm._e(),_vm._v(" "),(_vm.showChoice)?_c('consent',{on:{"consent":_vm.consent,"close":function($event){_vm.showChoice = false}}}):_vm._e(),_vm._v(" "),(_vm.showTable)?_c('table-modal',{attrs:{"tableDatas":_vm.tableDatas},on:{"close":_vm.closeTable,"closeCon":function($event){_vm.showChoice = false}}}):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeIndex == 1),expression:"activeIndex == 1"}]},[_c('h4',[_vm._v("Set Re-occuring Billing")]),_vm._v(" "),_c('i',{staticStyle:{"fontSize":"12px","marginLeft":"25%"}},[_vm._v("NB: Default card would be colored blue!")]),_vm._v(" "),_c('lo-mini-tracker',{ref:"progressTracker",attrs:{"tabItems":_vm.tabItems,"activeIndex":2}}),_vm._v(" "),_c('h4',{staticStyle:{"marginTop":"50px","marginBottom":"0px"}},[_vm._v("Select Default Card")]),_vm._v(" "),_c('div',[(_vm.paymentSucess)?[_c('el-alert',{attrs:{"title":"Successful Payment","center":"true","type":"success","description":"Your payment was successful!","show-icon":""}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"card-section"},_vm._l((_vm.debitCards),function(card,index){return _c('div',{key:index,staticClass:"single-card"},[_c('div',{class:card.isDefaultCard ? 'debit-cards' : 'debit-cards-inactive',on:{"click":function($event){return _vm.setDefaultCard(card.id, card.customerid)}}},[_c('p',[_vm._v(_vm._s(card.firstname)+" "+_vm._s(card.lastname))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s("**** **** **** " + card.last4digits))]),_vm._v(" "),_c('p',[_vm._v("\n              "+_vm._s(card.cardtype.charAt(0).toUpperCase() +
                  card.cardtype.substr(1).toLowerCase())+"\n              "+_vm._s(card.expirymonth + "/" + card.expiryyear)+"\n            ")])])])}),0),_vm._v(" "),_c('div',[_c('button',{staticClass:"download-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.flutterwavePaygate('10')}}},[_vm._v("\n          Add a Debit Card\n        ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"illustration"},[_c('div',{staticClass:"description"},[_vm._v("\n      We value the security of your card. Please note that your details will\n      be tokenized, encrypted, and processed following the PCI Data Security\n      Standards\n    ")]),_vm._v(" "),_c('img',{staticClass:"polygon",attrs:{"src":__webpack_require__(142),"alt":"Comment Bubble"}}),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(1146),"alt":""}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"3rem","height":"3rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOFinish_vue__ = __webpack_require__(1218);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5578a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOFinish_vue__ = __webpack_require__(3024);
function injectStyle (ssrContext) {
  __webpack_require__(3023)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-58f5578a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LOFinish_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58f5578a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LOFinish_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"finish-container"},[_c('h2',[_vm._v("Congratulations!")]),_vm._v(" "),_c('p',[_vm._v("You have successfully completed your onboarding process. \n      You are on your way to enjoying stable power supply! \n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n      We are now processing your unit for installation and will call you soon to finalize the documentation and installation process. \n      An email with your purchase details has been sent to you.\n      "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" \n      Thank you for choosing Arnergy!\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailVerified_vue__ = __webpack_require__(1219);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ca2be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailVerified_vue__ = __webpack_require__(3027);
function injectStyle (ssrContext) {
  __webpack_require__(3026)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmailVerified_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_91ca2be4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmailVerified_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3026 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__(214)}}),_vm._v(" "),_c('img',{staticClass:"image",attrs:{"src":__webpack_require__(3028)}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v("Email verification!")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v("\n    Kindly input the 6 digits OTP that was sent to your email.\n  ")]),_vm._v(" "),_c('v-otp-input',{ref:"otpInput",staticStyle:{"margin-top":"20px"},attrs:{"input-classes":"otp-input","separator":"-","num-inputs":6,"should-auto-focus":true,"is-input-num":true},on:{"on-change":_vm.handleOnChange,"on-complete":_vm.handleOnComplete}}),_vm._v(" "),_c('div',{staticClass:"submit"},[(_vm.isDisabled)?_c('div',[(_vm.loader)?_c('button',{staticClass:"submit-button"},[_vm._m(0)]):_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.submitOTP}},[_vm._v("\n        Submit OTP\n      ")])]):_vm._e(),_vm._v(" "),(_vm.loader)?_c('button',{staticClass:"submit-button"},[_vm._m(1)]):_c('button',{staticClass:"submit-button",attrs:{"type":"button"},on:{"click":_vm.resendOTP}},[_vm._v("\n      Resend OTP\n    ")])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submit-gif"},[_c('div',{staticClass:"spinner-border",staticStyle:{"width":"2rem","height":"2rem"},attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/verify-envelope.53f9afe.svg";

/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main_bar_holder"}},[_c('el-menu',{staticClass:"el-menu-horizontal-dash",attrs:{"default-active":_vm.activeIndex,"mode":"horizontal","background-color":_vm.getTheme['$background-color'],"text-color":_vm.getTheme['$text-color'],"active-text-color":_vm.getTheme['$active-text-color']}},[_c('div',{staticClass:"menu_pin_holder",attrs:{"index":"1"}},[_c('div',{staticClass:"left_header_components"},[_vm._t("menupin"),_vm._v(" "),_c('el-switch',{staticStyle:{"display":"block","margin-left":"100px"},attrs:{"active-text":"Dark","inactive-text":"Light"},on:{"change":_vm.toggleTheme},model:{value:(_vm.activeModel),callback:function ($$v) {_vm.activeModel=$$v},expression:"activeModel"}})],2),_vm._v(" "),_c('div',{staticClass:"notifications_right",on:{"click":_vm.navigateToNotifications}},[(_vm.notifications)?_c('p',[_vm._v(_vm._s(_vm.getNotificationsCount()))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"icon-box"},[_c('span',{staticClass:"material-icons"},[_vm._v("\n            notifications\n          ")])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__ = __webpack_require__(1220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500e5ddc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__ = __webpack_require__(3032);
function injectStyle (ssrContext) {
  __webpack_require__(3031)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_500e5ddc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3031 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"p-front__footer"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("2013 - "+_vm._s(new Date().getFullYear())+" © Arnergy")])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"https://arnergy.surge.sh/contact.html"}},[_vm._v("Contact")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://arnergy.surge.sh/FAQ.html"}},[_vm._v("FAQ")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://arnergy.surge.sh/about.html"}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"https://arnergy.surge.sh/products.html"}},[_vm._v("Products and Services")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotifyBox_vue__ = __webpack_require__(1221);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a64cd53_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotifyBox_vue__ = __webpack_require__(3035);
function injectStyle (ssrContext) {
  __webpack_require__(3034)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a64cd53"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotifyBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a64cd53_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotifyBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3034 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notifyBox),expression:"notifyBox"}],staticClass:"notify-box",on:{"mouseover":_vm.showCloseButton,"mouseout":_vm.hideCloseButton}},[_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.closeButton),expression:"closeButton"}],staticClass:"close-icon",on:{"click":_vm.closeNotification}},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"content-box"},[_c('p',{staticClass:"notify-message"},[_vm._v(_vm._s(_vm.message))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaysLeft_vue__ = __webpack_require__(1222);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5cdcdf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaysLeft_vue__ = __webpack_require__(3038);
function injectStyle (ssrContext) {
  __webpack_require__(3037)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d5cdcdf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DaysLeft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d5cdcdf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DaysLeft_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showNotification(_vm.getActiveDeviceDaysToExpire)),expression:"showNotification(getActiveDeviceDaysToExpire)"}],staticClass:"content-container"},[_c('div',{staticClass:"message"},[_c('span',{staticClass:"days"},[_vm._v(_vm._s(_vm.daysLeft))]),_vm._v(" "),_c('span',[_vm._v("days left for uninterrupted electricty")]),_vm._v(" "),_c('span',{staticClass:"dot dot--left"}),_vm._v(" "),_c('span',{staticClass:"dot dot--right"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersWithoutDevice_vue__ = __webpack_require__(1223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b59b4aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersWithoutDevice_vue__ = __webpack_require__(3041);
function injectStyle (ssrContext) {
  __webpack_require__(3040)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersWithoutDevice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b59b4aca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersWithoutDevice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3040 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userIsActive)?_c('p',{staticClass:"note"},[_vm._v("\n  Your account is inactive, kindly activate and enjoy full benefits\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getTheme['theme-name'],attrs:{"id":"app"}},[_c('can',{attrs:{"I":"am","a":"customer"}},[_c('days-left')],1),_vm._v(" "),_c('main',{attrs:{"id":"panel"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$can('all', 'anon') && _vm.isDefaultLayout),expression:"!$can('all', 'anon') && isDefaultLayout"}]},[_c('sidebar')],1),_vm._v(" "),_c('div',{staticClass:"content-area"},[_c('main-header',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$can('all', 'anon') && _vm.isDefaultLayout),expression:"!$can('all', 'anon') && isDefaultLayout"}]},[_c('template',{slot:"menupin"},[_c('div',{staticStyle:{"padding":"15px"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$can('all', 'anon')),expression:"!$can('all', 'anon')"}],staticClass:"fa fa-bars toggle-button",attrs:{"id":"hamburger"},on:{"click":function($event){return _vm.toggleSidebar(!_vm.isSidebarCollapsed)}}})])])],2),_vm._v(" "),_c('UsersWithoutDevice'),_vm._v(" "),_c('div',{class:("" + (_vm.isDefaultLayout ? 'page-content__header-description' : '')),style:(("" + (_vm.isDefaultLayout
                ? 'margin-bottom: 0px; padding-left: 24px; margin-top: 0px;'
                : '')))},[(
              _vm.$routerHistory.hasPrevious() &&
                !_vm.$can('all', 'anon') &&
                _vm.isDefaultLayout
            )?_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.goback),expression:"goback"}],staticClass:"back-nav-pin",attrs:{"to":{ path: _vm.$routerHistory.previous().path }}},[_c('span',{staticClass:"fa fa-arrow-left"})]):_vm._e()],1),_vm._v(" "),_c('router-view',{staticStyle:{"flex":"1"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var IOT_BASE_URL = "https://y68elgfgvk.execute-api.eu-west-2.amazonaws.com/staging"; //==> staging "https://iot-solarbase.arnergy.com";
// "https://hvh99xaxi0.execute-api.us-west-2.amazonaws.com/prod"; //"https://iot-solarbase.arnergy.com";

/* harmony default export */ __webpack_exports__["a"] = ({ IOT_BASE_URL: IOT_BASE_URL });

/***/ }),
/* 3044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* eslint-disable */
/* harmony default export */ __webpack_exports__["a"] = ({
  save: function save(key, jsonData, expirationMin) {
    var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'fixed';

    if (typeof Storage === 'undefined') {
      return false;
    }
    var expirationMS = expirationMin * 60 * 1000;
    var currentTime = new Date().getTime();
    var record = {
      value: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(jsonData),
      ttl: currentTime + expirationMS,
      type: type,
      expirationMin: expirationMin
    };
    localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(record));
    return jsonData;
  },
  load: function load(key) {
    if (typeof Storage === 'undefined') {
      return false;
    }
    var record = JSON.parse(localStorage.getItem(key));
    var currentTime = new Date().getTime();
    if (!record) {
      return false;
    }
    if (currentTime > record.ttl) {
      localStorage.removeItem(key);
      return false;
    }
    if (currentTime < record.ttl && record.type === 'variable') {
      var recordCopy = JSON.parse(localStorage.getItem(key));
      localStorage.removeItem(key);
      var expirationMS = recordCopy.expirationMin * 60 * 1000;
      recordCopy.ttl = new Date().getTime() + expirationMS;
      localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(recordCopy));
      return recordCopy;
    }
    return currentTime < record.ttl && JSON.parse(record.value);
  }
});

/***/ }),
/* 3045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3046 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3047 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3048 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_table_header_vue__ = __webpack_require__(1224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59cb667e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_table_header_vue__ = __webpack_require__(3053);
function injectStyle (ssrContext) {
  __webpack_require__(3051)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59cb667e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_table_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59cb667e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_table_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3051 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3052 */,
/* 3053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart_control row col-md-12"},[_c('div',{staticClass:"col"},[_c('div',{staticClass:"h4 page-heading"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col text-right"},[_c('vk-button',{staticClass:"chart_button",staticStyle:{"text-transform":"capitalize"}},[_vm._v("Export")]),_vm._v(" "),_c('vk-dropdown',{staticStyle:{"min-width":"120px !important","text-align":"left","cursor":"pointer"}},[_c('vk-nav-dropdown',[_c('div',[_c('i',{staticClass:"fa fa-file-image-o fa-2x",on:{"click":function($event){return _vm.exportDeviceList('image')}}}),_vm._v(" Image")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fa fa-file-pdf-o fa-2x",staticStyle:{"color":"#f53"},on:{"click":function($event){return _vm.exportDeviceList('pdf')}}}),_vm._v(" PDF")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fa fa-file-excel-o fa-2x",staticStyle:{"color":"#483"},on:{"click":function($event){return _vm.exportDeviceList('csv')}}}),_vm._v(" CSV")]),_vm._v(" "),_c('div',[_c('i',{staticClass:"fa fa-file-word-o fa-2x",staticStyle:{"color":"#39f"},on:{"click":function($event){return _vm.exportDeviceList('doc')}}}),_vm._v(" DOC")])])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_center_vue__ = __webpack_require__(1225);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab5c876_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_center_vue__ = __webpack_require__(3056);
function injectStyle (ssrContext) {
  __webpack_require__(3055)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_center_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ab5c876_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_center_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-center"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arnergy_table_vue__ = __webpack_require__(1226);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8c04aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arnergy_table_vue__ = __webpack_require__(3059);
function injectStyle (ssrContext) {
  __webpack_require__(3058)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_arnergy_table_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8c04aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_arnergy_table_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"arnergy-table"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"select-options":_vm.selectOption,"search-options":_vm.searchOption},on:{"on-select-all":_vm.selectAll,"on-row-click":_vm.toggleSelectRow},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [_c('div',[(props.column.field == 'name')?_c('span',[_vm._v("\n          "+_vm._s(props.row["installation"]["name"]
              ? props.row["installation"]["name"]
              : "---")+"\n        ")]):_vm._e(),_vm._v(" "),(props.column.field == 'deviceId')?_c('span',[_vm._v(_vm._s(props.row["DeviceID"] ? props.row["DeviceID"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'fault')?_c('span',[_vm._v(_vm._s(props.row["Fault"] ? props.row["Fault"] : "---"))]):_vm._e(),_vm._v(" "),(props.column.field == 'severity')?_c('span',{class:props.row['Severity'] == 'minor'
              ? 'badge badge-info'
              : 'badge badge-warning'},[_vm._v(_vm._s(props.row["Severity"] ? props.row["Severity"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'status')?_c('span',{class:props.row['Status'] == 'resolved'
              ? 'statusLabel badge badge-success'
              : 'statusLabel badge badge-danger'},[_vm._v(_vm._s(props.row["Status"] ? props.row["Status"] : "--"))]):_vm._e(),_vm._v(" "),(props.column.field == 'date')?_c('span',[_vm._v(_vm._s(props.row["StartTime"] ? props.row["StartTime"] : "--"))]):_vm._e()])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 3060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_pagination_vue__ = __webpack_require__(1227);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3763bc42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_pagination_vue__ = __webpack_require__(3063);
function injectStyle (ssrContext) {
  __webpack_require__(3061)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grey_pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3763bc42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grey_pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 3061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3062 */,
/* 3063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagination-strip"},[_c('div',{staticClass:"grey-custom-pagination__wrapper pagination-wrapper"},[_c('div',{staticClass:"col rows-per-page"},[_c('span',{staticClass:"footer__row-count__label"},[_vm._v(_vm._s(_vm.rowsPerPageText))]),_vm._v(" "),_c('el-select',{staticStyle:{"width":"80px"},attrs:{"name":"perPageSelect","placeholder":"Per page"},on:{"change":_vm.customPerPageChanged},model:{value:(_vm.currentPerPage),callback:function ($$v) {_vm.currentPerPage=$$v},expression:"currentPerPage"}},[_vm._l((_vm.rowsPerPageOptions),function(option,idx){return _c('el-option',{key:'rows-dropdown-option-' + idx,staticClass:"pagination-option",attrs:{"value":option,"label":option}})}),_vm._v(" "),(_vm.paginateDropdownAllowAll)?_c('el-option',{attrs:{"value":_vm.total}},[_vm._v(_vm._s(_vm.allText))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"grey-custom-pagination__info"},[_vm._v("\n        Showing "+_vm._s(_vm.paginatedInfo)+"\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"grey-custom-pagination vgt-pull-right"},[_c('div',{staticClass:"grey-custom-pagination__wrapper"},[_c('div',{staticClass:"pagination_item",class:{ disabled: !_vm.prevIsPossible },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.jumpToFirst.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-angle-double-left"})]),_vm._v(" "),_c('div',{staticClass:"pagination_item",class:{ disabled: !_vm.prevIsPossible },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.previousPage.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-angle-left"})]),_vm._v(" "),_c('div',{staticClass:"pagination_item active"},[_c('span',[_vm._v(_vm._s(_vm.currentPage))])]),_vm._v(" "),(_vm.nextIsPossible)?_c('div',{staticClass:"pagination_item",class:{ disabled: !_vm.nextIsPossible },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.nextPage.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.currentPage + 1))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pagination_item",class:{ disabled: !_vm.nextIsPossible },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.nextPage.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-angle-right"})]),_vm._v(" "),_c('div',{staticClass:"pagination_item",class:{ disabled: !_vm.nextIsPossible },on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.jumpToLast.apply(null, arguments)}}},[_c('span',{staticClass:"fa fa-angle-double-right"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[315]);


// WEBPACK FOOTER //
// static/js/app.9c764270c08e12dca461.js